webpackJsonp([11],Array(22).concat([
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SOUND_STATE = exports.SOUNDS_PLAY = undefined;
exports.playHoverSound = playHoverSound;
exports.playCancelClickSound = playCancelClickSound;
exports.playClickSound = playClickSound;
exports.playButtonClickSound = playButtonClickSound;
exports.playBuildingClickSound = playBuildingClickSound;
exports.playSelectClickSound = playSelectClickSound;
exports.playTabClickSound = playTabClickSound;
exports.playSelectBattleClickSound = playSelectBattleClickSound;
exports.playCarouselClickSound = playCarouselClickSound;
exports.playCarouselHoverSound = playCarouselHoverSound;
exports.playOneReserveProduceSuccessSound = playOneReserveProduceSuccessSound;
exports.playEnterMainCardSound = playEnterMainCardSound;
exports.playExitMainCardSound = playExitMainCardSound;
exports.playEnterAnnouncementSound = playEnterAnnouncementSound;
exports.playExitAnnouncementSound = playExitAnnouncementSound;
exports.playEnterStrongholdSound = playEnterStrongholdSound;
exports.playExitStrongholdSound = playExitStrongholdSound;
exports.playEnterGlobalMapSound = playEnterGlobalMapSound;
exports.playExitGlobalMapSound = playExitGlobalMapSound;
exports.playEnterClansWinnerRewardSound = playEnterClansWinnerRewardSound;
exports.playExitClansWinnerRewardSound = playExitClansWinnerRewardSound;
exports.playEnterClansBattlesGlobalMapSound = playEnterClansBattlesGlobalMapSound;
exports.playExitClansBattlesGlobalMapSound = playExitClansBattlesGlobalMapSound;
exports.playClansWinnerRewardMakeBet = playClansWinnerRewardMakeBet;
exports.playCongratulationClanJoiningSound = playCongratulationClanJoiningSound;
exports.sendEnterLandingSoundState = sendEnterLandingSoundState;
exports.sendEnterMainCardSoundState = sendEnterMainCardSoundState;
exports.sendEnterStrongholdSoundState = sendEnterStrongholdSoundState;
exports.sendEnterGlobalMapSoundState = sendEnterGlobalMapSoundState;
exports.sendEnterAnnouncementsSoundState = sendEnterAnnouncementsSoundState;

var _sounds = __webpack_require__(66);

var _sounds2 = _interopRequireDefault(_sounds);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SOUNDS_PLAY = exports.SOUNDS_PLAY = 'sounds/PLAY_SOUND';
var SOUND_STATE = exports.SOUND_STATE = 'sounds/SOUND_STATE';

function playSound(soundId) {
    var webToClient = {
        handler: 'playSound',
        params: { soundId: soundId }
    };

    return {
        type: SOUNDS_PLAY,
        payload: {},
        meta: { webToClient: webToClient }
    };
}

function sendSoundState(stateName, stateValue) {
    var webToClient = {
        handler: 'sendSoundState',
        params: { stateName: stateName, stateValue: stateValue }
    };
    return {
        type: SOUND_STATE,
        payload: {},
        meta: { webToClient: webToClient }
    };
}

// Sound events
function playHoverSound() {
    return playSound(_sounds2.default.HOVER);
}

function playCancelClickSound() {
    return playSound(_sounds2.default.CANCEL_CLICK);
}

function playClickSound() {
    return playSound(_sounds2.default.CLICK);
}

function playButtonClickSound() {
    return playSound(_sounds2.default.BUTTON_CLICK);
}

function playBuildingClickSound() {
    return playSound(_sounds2.default.BUILDING_CLICK);
}

function playSelectClickSound() {
    return playSound(_sounds2.default.SELECT_CLICK);
}

function playTabClickSound() {
    return playSound(_sounds2.default.TAB_CLICK);
}

function playSelectBattleClickSound() {
    return playSound(_sounds2.default.SELECT_BATTLE_CLICK);
}

function playCarouselClickSound() {
    return playSound(_sounds2.default.CAROUSEL_CLICK);
}

function playCarouselHoverSound() {
    return playSound(_sounds2.default.CAROUSEL_HOVER);
}

function playOneReserveProduceSuccessSound() {
    return playSound(_sounds2.default.RESERVE_PRODUCE_SUCCESS);
}

function playEnterMainCardSound() {
    return playSound(_sounds2.default.MAIN_CARD_ENTER);
}

function playExitMainCardSound() {
    return playSound(_sounds2.default.MAIN_CARD_EXIT);
}

function playEnterAnnouncementSound() {
    return playSound(_sounds2.default.ANNOUNCEMENT_ENTER);
}

function playExitAnnouncementSound() {
    return playSound(_sounds2.default.ANNOUNCEMENT_EXIT);
}

function playEnterStrongholdSound() {
    return playSound(_sounds2.default.STRONGHOLD_ENTER);
}

function playExitStrongholdSound() {
    return playSound(_sounds2.default.STRONGHOLD_EXIT);
}

function playEnterGlobalMapSound() {
    return playSound(_sounds2.default.GLOBAL_MAP_ENTER);
}

function playExitGlobalMapSound() {
    return playSound(_sounds2.default.GLOBAL_MAP_EXIT);
}

function playEnterClansWinnerRewardSound() {
    return playSound(_sounds2.default.CLANS_WINNER_REWARD_ENTER);
}

function playExitClansWinnerRewardSound() {
    return playSound(_sounds2.default.CLANS_WINNER_REWARD_EXIT);
}

function playEnterClansBattlesGlobalMapSound() {
    return playSound(_sounds2.default.CLANS_BATTLES_GLOBAL_MAP_ENTER);
}

function playExitClansBattlesGlobalMapSound() {
    return playSound(_sounds2.default.CLANS_BATTLES_GLOBAL_MAP_EXIT);
}

function playClansWinnerRewardMakeBet() {
    return playSound(_sounds2.default.CLANS_WINNER_REWARD_MAKE_BET);
}

function playCongratulationClanJoiningSound() {
    return playSound(_sounds2.default.CONGRATULATION_CLAN_JOINING);
}

// Sound states
function sendEnterLandingSoundState() {
    return sendSoundState(_sounds2.default.LANDING_STATE.name, _sounds2.default.LANDING_STATE.enterLanding);
}

function sendEnterMainCardSoundState() {
    return sendSoundState(_sounds2.default.LANDING_STATE.name, _sounds2.default.LANDING_STATE.enterMainCard);
}

function sendEnterStrongholdSoundState() {
    return sendSoundState(_sounds2.default.LANDING_STATE.name, _sounds2.default.LANDING_STATE.enterStronghold);
}

function sendEnterGlobalMapSoundState() {
    return sendSoundState(_sounds2.default.LANDING_STATE.name, _sounds2.default.LANDING_STATE.enterGlobalMap);
}

function sendEnterAnnouncementsSoundState() {
    return sendSoundState(_sounds2.default.LANDING_STATE.name, _sounds2.default.LANDING_STATE.enterAnnouncements);
}

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DefaultTooltip = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactWotBootstrap = __webpack_require__(5);

var _DefaultTooltip = __webpack_require__(405);

var _DefaultTooltip2 = _interopRequireDefault(_DefaultTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DefaultTooltip = exports.DefaultTooltip = function (_React$Component) {
    _inherits(DefaultTooltip, _React$Component);

    function DefaultTooltip() {
        _classCallCheck(this, DefaultTooltip);

        return _possibleConstructorReturn(this, (DefaultTooltip.__proto__ || Object.getPrototypeOf(DefaultTooltip)).apply(this, arguments));
    }

    _createClass(DefaultTooltip, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _reactWotBootstrap.Tooltip,
                { id: this.props.id },
                _react2.default.createElement(
                    'div',
                    { className: _DefaultTooltip2.default.content },
                    this.props.title && _react2.default.createElement(
                        'p',
                        { className: _DefaultTooltip2.default.subtitle },
                        this.props.title
                    ),
                    this.props.message && _react2.default.createElement(
                        'p',
                        { className: _DefaultTooltip2.default.message },
                        this.props.message
                    )
                )
            );
        }
    }]);

    return DefaultTooltip;
}(_react2.default.Component);

DefaultTooltip.propTypes = {
    id: _propTypes2.default.string.isRequired,
    title: _propTypes2.default.node,
    message: _propTypes2.default.node
};
exports.default = DefaultTooltip;

/***/ }),
/* 31 */,
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.VehiclePropTypes = exports.UnitDataPropTypes = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UnitDataPropTypes = exports.UnitDataPropTypes = _propTypes2.default.shape({
    clan: _propTypes2.default.object.isRequired,
    commander_nickname: _propTypes2.default.string.isRequired,
    created_at: _propTypes2.default.number.isRequired,
    fort_battle_in_progress: _propTypes2.default.bool.isRequired,
    in_battle: _propTypes2.default.bool.isRequired,
    is_destroyed: _propTypes2.default.bool,
    players_matching_started_at: _propTypes2.default.number,
    legionaries_number: _propTypes2.default.number.isRequired,
    max_legionaries_number: _propTypes2.default.number.isRequired,
    max_members_number: _propTypes2.default.number.isRequired,
    locked_slots_number: _propTypes2.default.number.isRequired,
    max_vehicle_level: _propTypes2.default.number.isRequired,
    members_number: _propTypes2.default.number.isRequired,
    periphery: _propTypes2.default.shape({ id: _propTypes2.default.number.isRequired }).isRequired,
    type: _propTypes2.default.oneOf(Object.keys(_constants.UNIT_TYPES)).isRequired
});

var VehiclePropTypes = exports.VehiclePropTypes = _propTypes2.default.shape({
    dailyXPFactor: _propTypes2.default.number,
    iconUrl: _propTypes2.default.string.isRequired,
    id: _propTypes2.default.number.isRequired,
    isPremium: _propTypes2.default.bool,
    isTopConfiguration: _propTypes2.default.bool,
    level: _propTypes2.default.number,
    name: _propTypes2.default.string.isRequired,
    nation: _propTypes2.default.string.isRequired,
    shortName: _propTypes2.default.string.isRequired,
    type: _propTypes2.default.string.isRequired
});

/***/ }),
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactIntl = __webpack_require__(3);

var _IndustrialResource = __webpack_require__(203);

var _IndustrialResource2 = _interopRequireDefault(_IndustrialResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IndustrialResource = function IndustrialResource(props) {
    var className = (0, _classnames2.default)(props.className, _IndustrialResource2.default.base, props.notEnough && _IndustrialResource2.default.base__notEnough, props.small && _IndustrialResource2.default.base__small, props.large && _IndustrialResource2.default.base__large, props.custom && _IndustrialResource2.default.base__custom, props.iconAtLeft && _IndustrialResource2.default.base__iconAtLeft);

    var tooltipProps = props.popoverId ? {
        'data-tip': true,
        'data-for': props.popoverId
    } : null;

    return _react2.default.createElement(
        'span',
        _extends({ className: className }, tooltipProps),
        props.iconAtLeft && _react2.default.createElement('span', { className: _IndustrialResource2.default.base_icon }),
        _react2.default.createElement(_reactIntl.FormattedNumber, { value: props.value }),
        !props.iconAtLeft && _react2.default.createElement('span', { className: _IndustrialResource2.default.base_icon })
    );
};
IndustrialResource.propTypes = {
    className: _propTypes2.default.string,
    value: _propTypes2.default.number.isRequired,
    notEnough: _propTypes2.default.bool,
    small: _propTypes2.default.bool,
    large: _propTypes2.default.bool,
    custom: _propTypes2.default.bool,
    popoverId: _propTypes2.default.string,
    iconAtLeft: _propTypes2.default.bool
};

exports.default = IndustrialResource;

/***/ }),
/* 36 */,
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getPeripheryById = getPeripheryById;
exports.getAvailablePeripheries = getAvailablePeripheries;
exports.isSortiesAvailable = isSortiesAvailable;
exports.checkBattleModeAvailableAtPeriphery = checkBattleModeAvailableAtPeriphery;
exports.isFortBattlesAvailable = isFortBattlesAvailable;
exports.getClosestMatchmakerTick = getClosestMatchmakerTick;
exports.getSortiesPeripheriesByClosestPrimetime = getSortiesPeripheriesByClosestPrimetime;
exports.getBattlesPeripheriesByClosestPrimetime = getBattlesPeripheriesByClosestPrimetime;
exports.getPeripheriesList = getPeripheriesList;

var _constants = __webpack_require__(4);

function getPeripheryById(peripheries, peripheryId) {
    return peripheries.find(function (item) {
        return item.periphery_id === peripheryId;
    });
}

/**
 * Returns list of peripheries which are available at this moment (using "interim" setting if suitable)
 * @param {object[]} peripheries -- list of peripheries like in available_units.meta.sorties.peripheries
 * @param {string} unitType -- currently FORT_BATTLE or SORTIES
 * @param {number} interimMs -- interim (in milliseconds) before prime time start when we need to
 * show it like it started.
 *
 * peripheries example:
 * {
 *   battle_modes: ["CHAMPION", "ABSOLUTE"],
 *   name: "WOT RU6",
 *   periphery_id: 106,
 *   primetime_end: 1530226800000,
 *   primetime_start: 1530198000000
 * }
 * */
function getAvailablePeripheries(peripheries, unitType) {
    var interimMs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.SORTIES_START_INTERIM;

    return peripheries.filter(function (periphery) {
        if (unitType === _constants.UNIT_TYPES.SORTIE) return isSortiesAvailable(periphery, interimMs);

        return isFortBattlesAvailable(periphery);
    });
}

function isSortiesAvailable(periphery) {
    var interimMs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.SORTIES_START_INTERIM;

    if (!periphery) return false;

    var nowTimestamp = Date.now();
    return periphery.primetime_start - interimMs < nowTimestamp && periphery.primetime_end > nowTimestamp;
}

function checkBattleModeAvailableAtPeriphery(periphery, battleMode) {
    if (!periphery) return false;
    return periphery.battle_modes.includes(battleMode);
}

function isFortBattlesAvailable(periphery) {
    if (!periphery) return false;

    var nowTimestamp = Date.now();
    var futureTick = getClosestMatchmakerTick(periphery);

    if (futureTick === undefined) return false;

    return futureTick - _constants.FORT_BATTLES_START_INTERIM < nowTimestamp;
}

function getClosestMatchmakerTick(periphery) {
    var nowTimestamp = Date.now();
    return periphery.matchmaker_ticks.find(function (tick) {
        return tick > nowTimestamp;
    });
}

function getSortiesPeripheriesByClosestPrimetime(peripheries) {
    var nowTimestamp = Date.now();
    return peripheries.filter(function (periphery) {
        return periphery.primetime_start > nowTimestamp;
    }).sort(function (a, b) {
        return a.primetime_start - b.primetime_start;
    }).filter(function (periphery, idx, list) {
        return list[0].primetime_start === periphery.primetime_start;
    });
}

function getBattlesPeripheriesByClosestPrimetime(peripheries) {
    return peripheries.filter(function (periphery) {
        return getClosestMatchmakerTick(periphery);
    }).sort(function (a, b) {
        return getClosestMatchmakerTick(a) - getClosestMatchmakerTick(b);
    }).filter(function (periphery, idx, list) {
        return getClosestMatchmakerTick(list[0]) === getClosestMatchmakerTick(periphery);
    });
}

function getPeripheriesList(availablePeripheries) {
    return availablePeripheries.map(function (item) {
        return item.name;
    }).join(', ');
}

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PLAYERS_COLUMN_DESCRIPTION = exports.STATUS_BATTLE_SCHEDULE_MESSAGE = exports.STATUS_MATCHING_LEGIONARIES = exports.STATUS_IN_BATTLE_MESSAGE = exports.STATUS_BATTLE_READY_MESSAGE = exports.BATTLE_ROOMS_COLUMNS = exports.BATTLE_MODE_DISABLED_ON_PERIPHERY = exports.BATTLE_ROOMS_UNIT_DISABLED = exports.BATTLE_ROOMS_UNITS_LIST_BUTTON = exports.BATTLE_ROOMS_UNITS_LIST = exports.REFRESH_UNITS_LIST_TOOLTIP_BODY = exports.REFRESH_UNITS_LIST_TOOLTIP_TITLE = exports.BATTLE_ROOMS_TITLE = exports.BATTLE_ROOMS_FIELDS = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BATTLE_ROOMS_FIELDS = exports.BATTLE_ROOMS_FIELDS = {
    CLAN: 'clan',
    PLACES: 'places',
    RATING: 'rating',
    SERVER: 'server',
    SQUAD: 'squad'
};

var BATTLE_ROOMS_TITLE = exports.BATTLE_ROOMS_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_rooms.new.title',
    defaultMessage: '\u0421\u0440\u0430\u0436\u0435\u043D\u0438\u044F \u043A\u043B\u0430\u043D\u043E\u0432'
});

var REFRESH_UNITS_LIST_TOOLTIP_TITLE = exports.REFRESH_UNITS_LIST_TOOLTIP_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_rooms.refresh_units_list_tooltip_title',
    defaultMessage: '\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0441\u043F\u0438\u0441\u043E\u043A'
});

var REFRESH_UNITS_LIST_TOOLTIP_BODY = exports.REFRESH_UNITS_LIST_TOOLTIP_BODY = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_rooms.refresh_units_list_tooltip_body',
    defaultMessage: '\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0441\u043F\u0438\u0441\u043E\u043A \u043E\u0442\u0440\u044F\u0434\u043E\u0432.'
});

var BATTLE_ROOMS_UNITS_LIST = exports.BATTLE_ROOMS_UNITS_LIST = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_rooms.units_list',
    defaultMessage: '\u0421\u043F\u0438\u0441\u043E\u043A \u043E\u0442\u0440\u044F\u0434\u043E\u0432'
});

var BATTLE_ROOMS_UNITS_LIST_BUTTON = exports.BATTLE_ROOMS_UNITS_LIST_BUTTON = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_rooms.units_list_button',
    defaultMessage: '\u041A \u0441\u043F\u0438\u0441\u043A\u0443 \u043E\u0442\u0440\u044F\u0434\u043E\u0432'
});

var BATTLE_ROOMS_UNIT_DISABLED = exports.BATTLE_ROOMS_UNIT_DISABLED = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_rooms.unit_disabled',
    defaultMessage: '\u041D\u0430\u0431\u043E\u0440 \u0432 \u0441\u043E\u0441\u0442\u0430\u0432 \u043E\u0442\u0440\u044F\u0434\u0430 \u0437\u0430\u043A\u0440\u044B\u0442'
});

var BATTLE_MODE_DISABLED_ON_PERIPHERY = exports.BATTLE_MODE_DISABLED_ON_PERIPHERY = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_rooms.battle_mode_disabled_on_periphery',
    defaultMessage: '\u0412\u0440\u0435\u043C\u044F \u043D\u0430\u0447\u0430\u043B\u0430 \u0441\u0442\u0430\u043D\u0435\u0442 \u0438\u0437\u0432\u0435\u0441\u0442\u043D\u043E \u043F\u043E\u0437\u0436\u0435'
});

var BATTLE_ROOMS_COLUMNS = exports.BATTLE_ROOMS_COLUMNS = {
    clan: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battle_rooms.columns.clan',
        defaultMessage: '\u041F\u043E\u0434\u0445\u043E\u0434\u044F\u0449\u0438\u0435 \u043E\u0442\u0440\u044F\u0434\u044B'
    }),
    rating: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battle_rooms.columns.rating',
        defaultMessage: '\u0420\u0435\u0439\u0442\u0438\u043D\u0433'
    }),
    server: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battle_rooms.columns.server',
        defaultMessage: '\u0421\u0435\u0440\u0432\u0435\u0440'
    }),
    squad: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battle_rooms.columns.squad',
        defaultMessage: '\u0421\u043E\u0441\u0442\u0430\u0432'
    }),
    legionaries: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battle_rooms.columns.legionaries',
        defaultMessage: '\u041B\u0435\u0433\u0438\u043E\u043D\u0435\u0440\u044B'
    }),
    places: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battle_rooms.columns.places',
        defaultMessage: '\u041C\u0435\u0441\u0442\u0430'
    }),
    vehicles: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battle_rooms.columns.vehicles',
        defaultMessage: '\u0422\u0435\u0445\u043D\u0438\u043A\u0430'
    })
};

var STATUS_BATTLE_READY_MESSAGE = exports.STATUS_BATTLE_READY_MESSAGE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_rooms.squad.status_battle_ready_message',
    defaultMessage: '\u0411\u043E\u0439 \u043D\u0430\u0447\u043D\u0451\u0442\u0441\u044F \u043F\u043E \u0433\u043E\u0442\u043E\u0432\u043D\u043E\u0441\u0442\u0438'
});

var STATUS_IN_BATTLE_MESSAGE = exports.STATUS_IN_BATTLE_MESSAGE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_rooms.squad.status_in_battle_message',
    defaultMessage: '\u041E\u0442\u0440\u044F\u0434 \u0432 \u0431\u043E\u044E'
});

var STATUS_MATCHING_LEGIONARIES = exports.STATUS_MATCHING_LEGIONARIES = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_rooms.squad.status_matching_legionaries',
    defaultMessage: '\u0410\u0432\u0442\u043E\u043D\u0430\u0431\u043E\u0440 \u043B\u0435\u0433\u0438\u043E\u043D\u0435\u0440\u043E\u0432...'
});

var STATUS_BATTLE_SCHEDULE_MESSAGE = exports.STATUS_BATTLE_SCHEDULE_MESSAGE = function STATUS_BATTLE_SCHEDULE_MESSAGE(time) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battle_rooms.squad.status_battle_shedule_today_message',
        defaultMessage: '\u041D\u0430\u0447\u0430\u043B\u043E {time}',
        values: { time: time }
    });
};

var PLAYERS_COLUMN_DESCRIPTION = exports.PLAYERS_COLUMN_DESCRIPTION = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_rooms.squad.tooltips.players.message',
    defaultMessage: '\u0422\u0435\u043A\u0443\u0449\u0435\u0435 \u0438 \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0435 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0438\u0433\u0440\u043E\u043A\u043E\u0432 \u0432 \u0441\u043E\u0441\u0442\u0430\u0432\u0435 \u043E\u0442\u0440\u044F\u0434\u0430.'
});

/***/ }),
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TOOLTIP_FOOTER_REBUILD = exports.TOOLTIP_BACK_FOOTER = exports.TOOLTIP_FOOTER = exports.STATIC_TOOLTIPS_MESSAGES = exports.STATIC_TOOLTIPS_ID = exports.BATTLE_WIZARD_REWARD_TOOLTIP_X2 = exports.BATTLE_WIZARD_REWARD_TOOLTIP = exports.BATTLE_TITLE_TOOLTIPS_ID = exports.SORTIES_END_INTERIM = undefined;

var _BATTLE_TITLE_TOOLTIP;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint-disable max-len */

var SORTIES_END_INTERIM = exports.SORTIES_END_INTERIM = 5 * 60 * 1000; // 5 minutues

var BATTLE_TITLE_TOOLTIPS_ID = exports.BATTLE_TITLE_TOOLTIPS_ID = (_BATTLE_TITLE_TOOLTIP = {}, _defineProperty(_BATTLE_TITLE_TOOLTIP, _constants.UNIT_TYPES.SORTIE, 'sortie_title_tooltip'), _defineProperty(_BATTLE_TITLE_TOOLTIP, _constants.UNIT_TYPES.FORT_BATTLE, 'fort_battle_title_tooltip'), _BATTLE_TITLE_TOOLTIP);

var BATTLE_WIZARD_REWARD_TOOLTIP = exports.BATTLE_WIZARD_REWARD_TOOLTIP = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_wizard.reward.tooltip',
    defaultMessage: '\u041D\u0430\u0433\u0440\u0430\u0434\u0430 \u0437\u0430 \u0437\u0430\u0445\u0432\u0430\u0442 \u0426\u0438\u0442\u0430\u0434\u0435\u043B\u0438 \u043F\u0440\u043E\u0442\u0438\u0432\u043D\u0438\u043A\u0430.'
});

var BATTLE_WIZARD_REWARD_TOOLTIP_X2 = exports.BATTLE_WIZARD_REWARD_TOOLTIP_X2 = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_wizard.reward.tooltip_x2',
    defaultMessage: '\u041D\u0430\u0433\u0440\u0430\u0434\u0430 \u0437\u0430 \u0437\u0430\u0445\u0432\u0430\u0442 \u0426\u0438\u0442\u0430\u0434\u0435\u043B\u0438 \u043F\u0440\u043E\u0442\u0438\u0432\u043D\u0438\u043A\u0430 (\u0441 \u0443\u0447\u0451\u0442\u043E\u043C \u04452 \u0437\u0430 \u043F\u0435\u0440\u0432\u0443\u044E \u043F\u043E\u0431\u0435\u0434\u0443).'
});

var STATIC_TOOLTIPS_ID = exports.STATIC_TOOLTIPS_ID = {
    sortie_reward: 'battle-wizard-sortie-reward-tooltip',
    per_battle: 'battle-wizard-per-battle-reward-tooltip',
    vehicle_levels: 'battle-wizard-vehicle-levels-tooltip',
    players_count: 'battle-wizard-players-count-tooltip',
    legionaries_count: 'battle-wizard-legionaries-count-tooltip',
    fort_battle_duration: 'battle-wizard-fort-battle-duration-tooltip',
    sortie_duration: 'battle-wizard-sortie-duration-tooltip'
};

var STATIC_TOOLTIPS_MESSAGES = exports.STATIC_TOOLTIPS_MESSAGES = {
    sortie_reward: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battle_wizard.sortie_reward_tooltip',
        defaultMessage: '\u041D\u0430\u0433\u0440\u0430\u0434\u0430, \u043A\u043E\u0442\u043E\u0440\u0430\u044F \u0434\u0435\u043B\u0438\u0442\u0441\u044F \u043C\u0435\u0436\u0434\u0443 \u043A\u043B\u0430\u043D\u0430\u043C\u0438 \u0432 \u0432\u044B\u043B\u0430\u0437\u043A\u0435. \u041F\u043E\u0431\u0435\u0434\u0438\u0442\u0435\u043B\u044C \u043F\u043E\u043B\u0443\u0447\u0430\u0435\u0442 \u043E\u0441\u043D\u043E\u0432\u043D\u0443\u044E \u0434\u043E\u043B\u044E \u043D\u0430\u0433\u0440\u0430\u0434\u044B.'
    }),
    per_battle: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battle_wizard.per_battle_reward_tooltip',
        defaultMessage: '\u041D\u0430\u0433\u0440\u0430\u0434\u0430 \u0432 \u043A\u0430\u0436\u0434\u043E\u043C \u0431\u043E\u044E, \u043A\u043E\u0442\u043E\u0440\u0430\u044F \u0434\u0435\u043B\u0438\u0442\u0441\u044F \u043C\u0435\u0436\u0434\u0443 \u043A\u043B\u0430\u043D\u0430\u043C\u0438.'
    }),
    vehicle_levels: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battle_wizard.vehicle_levels_tooltip',
        defaultMessage: '\u0423\u0440\u043E\u0432\u043D\u0438 \u0442\u0435\u0445\u043D\u0438\u043A\u0438 \u0432 \u0431\u043E\u044E'
    }),
    players_count: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battle_wizard.players_count_tooltip',
        defaultMessage: '\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0438\u0433\u0440\u043E\u043A\u043E\u0432 \u0432 \u043E\u0442\u0440\u044F\u0434\u0435, \u0432\u043A\u043B\u044E\u0447\u0430\u044F \u043B\u0435\u0433\u0438\u043E\u043D\u0435\u0440\u043E\u0432'
    }),
    legionaries_count: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battle_wizard.legionaries_count_tooltip',
        defaultMessage: '\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0435 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043B\u0435\u0433\u0438\u043E\u043D\u0435\u0440\u043E\u0432 \u0432 \u043E\u0442\u0440\u044F\u0434\u0435'
    }),
    fort_battle_duration: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battle_wizard.fort_battle_duration_tooltip',
        defaultMessage: '\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u0434\u043B\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C \u043E\u0434\u043D\u043E\u0433\u043E \u0431\u043E\u044F \u0438 \u0432\u0441\u0435\u0433\u043E \u041D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u044F'
    }),
    sortie_duration: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battle_wizard.sortie_duration_tooltip',
        defaultMessage: '\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u0434\u043B\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C \u0431\u043E\u044F'
    })
};

var TOOLTIP_FOOTER = exports.TOOLTIP_FOOTER = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_tooltip.click',
    defaultMessage: '\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u0441\u043E\u0437\u0434\u0430\u0442\u044C \u043E\u0442\u0440\u044F\u0434'
});

var TOOLTIP_BACK_FOOTER = exports.TOOLTIP_BACK_FOOTER = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_tooltip.back',
    defaultMessage: '\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u0432\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u043A \u043E\u0442\u0440\u044F\u0434\u0443.'
});

var TOOLTIP_FOOTER_REBUILD = exports.TOOLTIP_FOOTER_REBUILD = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_tooltip.rebuild',
    defaultMessage: '\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u0441\u043C\u0435\u043D\u0438\u0442\u044C \u0440\u0435\u0436\u0438\u043C.'
});

/***/ }),
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

var _datetime = __webpack_require__(13);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Timer = function (_React$Component) {
    _inherits(Timer, _React$Component);

    function Timer() {
        _classCallCheck(this, Timer);

        return _possibleConstructorReturn(this, (Timer.__proto__ || Object.getPrototypeOf(Timer)).apply(this, arguments));
    }

    _createClass(Timer, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.update();
        }
    }, {
        key: 'update',
        value: function update() {
            this.clearTimeouts();
            if (!this.props.endTime && !this.props.startTime) return;

            var milliseconds = void 0;
            if (this.props.endTime) {
                milliseconds = Math.max(this.props.endTime.diff((0, _moment2.default)()), 0);

                if (this.props.onExpire && milliseconds === 0) {
                    if (this.props.onExpireDelay) {
                        this.onExpireTimeoutId = setTimeout(this.props.onExpire, Math.min(this.props.onExpireDelay, _constants.MAX_SET_TIMEOUT_VALUE));
                    } else {
                        this.props.onExpire();
                    }
                }
            } else {
                milliseconds = (0, _moment2.default)().diff(this.props.startTime);
            }

            this.timeoutId = setTimeout(this.update.bind(this), 1000);

            this.setState({
                milliseconds: milliseconds
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.clearTimeouts();
        }
    }, {
        key: 'clearTimeouts',
        value: function clearTimeouts() {
            if (this.timeoutId) clearTimeout(this.timeoutId);
            if (this.onExpireTimeoutId) clearTimeout(this.onExpireTimeoutId);
        }
    }, {
        key: 'getTimeLeftLabel',
        value: function getTimeLeftLabel(milliseconds) {
            if (this.props.shortFormat) return (0, _moment2.default)(milliseconds).format('mm:ss');
            return this.props.hideSeconds ? (0, _datetime.getHoursMinutes)(milliseconds) : (0, _datetime.getFormattedTime)(milliseconds, true);
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.props.endTime && !this.props.startTime) return null;

            var formattedTime = this.getTimeLeftLabel(this.state.milliseconds);
            return _react2.default.createElement(
                'span',
                null,
                formattedTime
            );
        }
    }]);

    return Timer;
}(_react2.default.Component);

Timer.propTypes = {
    startTime: _propTypes2.default.instanceOf(_moment2.default),
    endTime: _propTypes2.default.instanceOf(_moment2.default),
    onExpire: _propTypes2.default.func,
    onExpireDelay: _propTypes2.default.number,
    shortFormat: _propTypes2.default.bool,
    hideSeconds: _propTypes2.default.bool
};
exports.default = Timer;

/***/ }),
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NavigationArrow = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactWotBootstrap = __webpack_require__(5);

var _constants = __webpack_require__(131);

var _NavigationArrow = __webpack_require__(202);

var _NavigationArrow2 = _interopRequireDefault(_NavigationArrow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var NavigationArrow = exports.NavigationArrow = function NavigationArrow(props) {
    var _classNames;

    var className = (0, _classnames2.default)(_NavigationArrow2.default.base, _NavigationArrow2.default['base__' + props.size], _NavigationArrow2.default['base__' + props.type], (_classNames = {}, _defineProperty(_classNames, _NavigationArrow2.default.base__disabled, props.disabled), _defineProperty(_classNames, _NavigationArrow2.default.noBorder, props.hideBorder), _classNames));

    return _react2.default.createElement(
        'button',
        {
            className: className,
            onClick: props.disabled ? null : props.handleClick,
            onMouseDown: props.disabled ? null : _reactWotBootstrap.sendClickSoundCommand,
            onMouseEnter: props.disabled ? null : _reactWotBootstrap.sendHoverSoundCommand
        },
        _react2.default.createElement('span', { className: _NavigationArrow2.default.arrow })
    );
};

NavigationArrow.propTypes = {
    size: _propTypes2.default.oneOf(Object.values(_constants.ARROW_SIZES)).isRequired,
    type: _propTypes2.default.oneOf(Object.values(_constants.ARROW_TYPES)).isRequired,
    disabled: _propTypes2.default.bool,
    handleClick: _propTypes2.default.func,
    hideBorder: _propTypes2.default.bool
};

NavigationArrow.SIZES = _constants.ARROW_SIZES;
NavigationArrow.TYPES = _constants.ARROW_TYPES;

NavigationArrow.defaultProps = {
    size: _constants.ARROW_SIZES.big
};

exports.default = NavigationArrow;

/***/ }),
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getReactiveUpdateUrl = getReactiveUpdateUrl;
function getReactiveUpdateUrl(host, channelsUrl) {
    if (!host || !channelsUrl) return null;

    return "wss://" + host + "/ws/" + channelsUrl;
}

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(4);

var _VehicleType = __webpack_require__(408);

var _VehicleType2 = _interopRequireDefault(_VehicleType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var VehicleType = function VehicleType(props) {
    var _classNames;

    var className = (0, _classnames2.default)(_VehicleType2.default.base, _VehicleType2.default['base__' + props.type], (_classNames = {}, _defineProperty(_classNames, _VehicleType2.default.base__premium, props.premium), _defineProperty(_classNames, _VehicleType2.default.base__mini, props.mini), _classNames));
    return _react2.default.createElement('span', { className: className });
};

VehicleType.propTypes = {
    type: _propTypes2.default.oneOf(_constants.VEHICLE_TYPES).isRequired,
    premium: _propTypes2.default.bool,
    mini: _propTypes2.default.bool
};

exports.default = VehicleType;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WizardDefaultTooltip = exports.WizardButton = exports.UnavailableBattle = exports.Status = exports.SortieTooltip = exports.Schedule = exports.Reward = exports.Options = exports.Option = exports.Level = exports.FortBattleTooltip = exports.Direction = exports.BattleTitleTooltip = exports.BattleTitle = exports.Battle = exports.Arenas = undefined;

var _Arenas2 = __webpack_require__(480);

var _Arenas3 = _interopRequireDefault(_Arenas2);

var _Battle2 = __webpack_require__(482);

var _Battle3 = _interopRequireDefault(_Battle2);

var _BattleTitle2 = __webpack_require__(485);

var _BattleTitle3 = _interopRequireDefault(_BattleTitle2);

var _BattleTitleTooltip2 = __webpack_require__(487);

var _BattleTitleTooltip3 = _interopRequireDefault(_BattleTitleTooltip2);

var _Direction2 = __webpack_require__(490);

var _Direction3 = _interopRequireDefault(_Direction2);

var _FortBattleTooltip2 = __webpack_require__(493);

var _FortBattleTooltip3 = _interopRequireDefault(_FortBattleTooltip2);

var _Level2 = __webpack_require__(496);

var _Level3 = _interopRequireDefault(_Level2);

var _Option2 = __webpack_require__(498);

var _Option3 = _interopRequireDefault(_Option2);

var _Options2 = __webpack_require__(501);

var _Options3 = _interopRequireDefault(_Options2);

var _Reward2 = __webpack_require__(503);

var _Reward3 = _interopRequireDefault(_Reward2);

var _Schedule2 = __webpack_require__(506);

var _Schedule3 = _interopRequireDefault(_Schedule2);

var _SortieTooltip2 = __webpack_require__(509);

var _SortieTooltip3 = _interopRequireDefault(_SortieTooltip2);

var _Status2 = __webpack_require__(512);

var _Status3 = _interopRequireDefault(_Status2);

var _UnavailableBattle2 = __webpack_require__(515);

var _UnavailableBattle3 = _interopRequireDefault(_UnavailableBattle2);

var _WizardButton2 = __webpack_require__(518);

var _WizardButton3 = _interopRequireDefault(_WizardButton2);

var _WizardDefaultTooltip2 = __webpack_require__(520);

var _WizardDefaultTooltip3 = _interopRequireDefault(_WizardDefaultTooltip2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Arenas = _Arenas3.default;
exports.Battle = _Battle3.default;
exports.BattleTitle = _BattleTitle3.default;
exports.BattleTitleTooltip = _BattleTitleTooltip3.default;
exports.Direction = _Direction3.default;
exports.FortBattleTooltip = _FortBattleTooltip3.default;
exports.Level = _Level3.default;
exports.Option = _Option3.default;
exports.Options = _Options3.default;
exports.Reward = _Reward3.default;
exports.Schedule = _Schedule3.default;
exports.SortieTooltip = _SortieTooltip3.default;
exports.Status = _Status3.default;
exports.UnavailableBattle = _UnavailableBattle3.default;
exports.WizardButton = _WizardButton3.default;
exports.WizardDefaultTooltip = _WizardDefaultTooltip3.default;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Back = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = __webpack_require__(7);

var _constants = __webpack_require__(241);

var _reactWotBootstrap = __webpack_require__(5);

var _sounds = __webpack_require__(22);

var _Back = __webpack_require__(2085);

var _Back2 = _interopRequireDefault(_Back);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Back = exports.Back = function Back(props) {
    var handleMouseDown = function handleMouseDown() {
        return props.playClickSound();
    };
    var handleHover = function handleHover() {
        return props.playHoverSound();
    };

    var sideClass = props.caption ? _Back2.default['base__' + props.side] : null;

    var className = (0, _classnames2.default)(_Back2.default.base, _Back2.default['base__' + props.type], sideClass, _defineProperty({}, _Back2.default.base__cn, _reactWotBootstrap.helpers.isChineseLanguage()));

    return _react2.default.createElement(
        'button',
        {
            className: className,
            onClick: props.handleClick,
            onMouseDown: handleMouseDown,
            onMouseEnter: handleHover
        },
        _react2.default.createElement('span', { className: _Back2.default.icon }),
        props.caption && _react2.default.createElement(
            'span',
            { className: _Back2.default.caption },
            props.caption
        ),
        props.children
    );
};

Back.propTypes = {
    caption: _propTypes2.default.node,
    handleClick: _propTypes2.default.func.isRequired,
    playHoverSound: _propTypes2.default.func.isRequired,
    playClickSound: _propTypes2.default.func.isRequired,
    type: _propTypes2.default.oneOf(Object.values(_constants.BACK_TYPES)).isRequired,
    side: _propTypes2.default.oneOf(Object.values(_constants.BACK_SIDES)).isRequired
};

Back.defaultProps = {
    caption: _constants.BACK_CAPTIONS.back,
    type: 'back',
    side: 'left'
};

Back.CAPTIONS = _constants.BACK_CAPTIONS;
Back.TYPES = _constants.BACK_TYPES;
Back.SIDES = _constants.BACK_SIDES;

var mapDispatchToProps = { playHoverSound: _sounds.playHoverSound, playClickSound: _sounds.playClickSound };

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(Back);

/***/ }),
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ALL_BATTLES_NEXT_PRIMETIME = exports.BATTLES_UNAVAILABLE = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BATTLES_UNAVAILABLE = exports.BATTLES_UNAVAILABLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'schedule.battles_unavailable',
    defaultMessage: '\u0421\u0440\u0430\u0436\u0435\u043D\u0438\u044F \u043D\u0435 \u043F\u0440\u043E\u0432\u043E\u0434\u044F\u0442\u0441\u044F'
});

var ALL_BATTLES_NEXT_PRIMETIME = exports.ALL_BATTLES_NEXT_PRIMETIME = function ALL_BATTLES_NEXT_PRIMETIME(time) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battle_rooms.empty_list.all_battles_schedule_item',
        defaultMessage: '\u0411\u043B\u0438\u0436\u0430\u0439\u0448\u0438\u0435 \u0441\u0440\u0430\u0436\u0435\u043D\u0438\u044F: {time}',
        values: { time: time }
    });
};

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CLAN_SUPPLY_ARC_PROGRESSBAR_STATISTICS = exports.CLAN_SUPPLY_PROGRESSION_TANK_RECEIVED = exports.CLAN_SUPPLY_PROGRESSION_EXPLORE_WITH_NEW_TANK = exports.CLAN_SUPPLY_PROGRESSION_CAN_OPEN_NEW_REGION = exports.CLAN_SUPPLY_PROGRESSION_EXPLORE_NEW_REGIONS = exports.CLAN_SUPPLY_PROGRESSION_ALL_REGIONS_EXPLORED = exports.CLAN_SUPPLY_SLASH = exports.CLAN_SUPPLY_PROGRESSION_REGIONS_EXPLORED = exports.CLAN_SUPPLY_PROGRESSION_DISABLED_TEXT = exports.CLAN_SUPPLY_PROGRESSION_PROGRESS_TOOLTIP = exports.CLAN_SUPPLY_PROGRESSION_TITLE = exports.CLAN_SUPPLY_QUESTS_TAKE_REWARD = exports.CLAN_SUPPLY_QUESTS_TIME_BEFORE_END = exports.CLAN_SUPPLY_IN_PROGRESS = exports.CLAN_SUPPLY_QUESTS_ALL_DONE = exports.CLAN_SUPPLY_QUESTS_PLAY_WITH_TEAMMATES = exports.CLAN_SUPPLY_QUESTS_DISABLED_TEXT = exports.CLAN_SUPPLY_QUESTS_TITLE = exports.MANEUVERS_DESCRIPTION = exports.MANEUVERS_TITLE = exports.STRONGHOLD_UPDATED = exports.TODAY_TIME = exports.CUSTOM_DATE_TIME = exports.TOMMOROW_TIME = exports.PLUS = exports.TOMMOROW_IN = exports.BATTLES_NOW = exports.GLOBAL_MAP_NEAREST_BATTLE_TIME = exports.CLAN_QUESTS_TUTORIAL_ARROW_TEXT = exports.CLAN_QUESTS_RELOAD_BUTTON_TITLE = exports.CLAN_QUESTS_NOT_AVAILABLE_MESSAGE = exports.CLAN_QUESTS_DISABLED_MESSAGE = exports.CLAN_QUESTS_DISABLED_TITLE = exports.CLAN_QUESTS_RELOAD_BUTTON_TOOLTIP = exports.CLAN_QUESTS_CLAN_TIMER_TITLE = exports.CLAN_QUESTS_ALL_FINISHED_TITLE = exports.CLAN_QUESTS_CLAN_FINISHED_TITLE = exports.CLAN_QUESTS_CLAN_TIMER_TOOLTIP = exports.CLAN_QUESTS_CLAN_POINTS_TOOLTIP_MESSAGE = exports.CLAN_QUESTS_CLAN_POINTS_TOOLTIP_TITLE = exports.CLAN_QUESTS_PERSONAL_POINTS_TOOLTIP_MESSAGE = exports.CLAN_QUESTS_PERSONAL_POINTS_TOOLTIP_TITLE = exports.CLAN_QUESTS_PERSONAL_TIMER_TOOLTIP = exports.CLAN_QUESTS_ALL_CLAN_REWARDS_RECEIVED = exports.CLAN_QUESTS_ALL_PERSONAL_REWARDS_RECEIVED = exports.CLAN_QUESTS_NEXT_CLAN_REWARD_TITLE = exports.CLAN_QUESTS_NEXT_ACCOUNT_REWARD_TITLE = exports.CLAN_QUESTS_CLAN_TITLE = exports.CLAN_QUESTS_PERSONAL_TITLE = exports.PERSONAL_FAME_POINTS_EARN = exports.PERSONAL_FAME_POINTS_BALANCE = exports.PERSONAL_FAME_POINTS = exports.CLAN_TREASURY = exports.ENTRYPOINT_SEARCH = exports.ENTRYPOINT_CLAN = exports.EVENT_ON_GLOBAL_MAP = exports.GLOBAL_MAP_DISABLED = exports.GLOBAL_MAP = exports.CHALLENGES = exports.CHALLENGES_TIMER = exports.CHALLENGES_OFF = exports.CLAN_LANDING_ROLE_DESCRIPTION = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _cards = __webpack_require__(94);

var _cards2 = _interopRequireDefault(_cards);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLAN_LANDING_ROLE_DESCRIPTION = exports.CLAN_LANDING_ROLE_DESCRIPTION = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.role',
    defaultMessage: '\u0412\u0430\u0448\u0430 \u0434\u043E\u043B\u0436\u043D\u043E\u0441\u0442\u044C \u0432 \u043A\u043B\u0430\u043D\u0435:'
}); /* eslint-disable react/no-multi-comp */
var CHALLENGES_OFF = exports.CHALLENGES_OFF = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.challenge.off',
    defaultMessage: '\u0412\u043E\u0435\u043D\u043D\u044B\u0435 \u0438\u0433\u0440\u044B \u043E\u0442\u043A\u043B\u044E\u0447\u0435\u043D\u044B'
});

var CHALLENGES_TIMER = exports.CHALLENGES_TIMER = function CHALLENGES_TIMER(timer) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'clan_landing.challenges_timer',
        defaultMessage: '\u043E\u0441\u0442\u0430\u043B\u043E\u0441\u044C {timer}',
        values: { timer: timer }
    });
};

var CHALLENGES = exports.CHALLENGES = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.challenges',
    defaultMessage: '\u0412\u043E\u0435\u043D\u043D\u044B\u0435 \u0438\u0433\u0440\u044B:'
});

var GLOBAL_MAP = exports.GLOBAL_MAP = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.global_map',
    defaultMessage: '\u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u0430\u044F \u043A\u0430\u0440\u0442\u0430'
});

var GLOBAL_MAP_DISABLED = exports.GLOBAL_MAP_DISABLED = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.global_map_disabled',
    defaultMessage: '\u0411\u043E\u0438 \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435 \u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E \u043F\u0440\u0438\u043E\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u044B.'
});

var EVENT_ON_GLOBAL_MAP = exports.EVENT_ON_GLOBAL_MAP = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.event_on_global_map',
    defaultMessage: '\u0421\u043E\u0431\u044B\u0442\u0438\u0435 \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435'
});

var ENTRYPOINT_CLAN = exports.ENTRYPOINT_CLAN = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'stronghold.entrypoint.clan',
    defaultMessage: '\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043A \u043F\u0440\u043E\u0444\u0438\u043B\u044E \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043B\u0430\u043D\u0430'
});

var ENTRYPOINT_SEARCH = exports.ENTRYPOINT_SEARCH = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'stronghold.entrypoint.search',
    defaultMessage: '\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043A \u043F\u043E\u0438\u0441\u043A\u0443 \u043A\u043B\u0430\u043D\u0430'
});

var CLAN_TREASURY = exports.CLAN_TREASURY = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'stronghold.entrypoint.clan_treasury',
    defaultMessage: '\u041A\u0430\u0437\u043D\u0430 \u043A\u043B\u0430\u043D\u0430'
});

var PERSONAL_FAME_POINTS = exports.PERSONAL_FAME_POINTS = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.personal_fame_points',
    defaultMessage: '\u041B\u0438\u0447\u043D\u044B\u0435 \u043E\u0447\u043A\u0438 \u0441\u043B\u0430\u0432\u044B'
});

var PERSONAL_FAME_POINTS_BALANCE = exports.PERSONAL_FAME_POINTS_BALANCE = function PERSONAL_FAME_POINTS_BALANCE(pfp) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'clan_landing.personal_fame_points_balance',
        defaultMessage: '\u0421\u0435\u0439\u0447\u0430\u0441: {pfp}',
        values: { pfp: pfp }
    });
};

var PERSONAL_FAME_POINTS_EARN = exports.PERSONAL_FAME_POINTS_EARN = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.personal_fame_points_earn',
    defaultMessage: '\u0417\u0430\u0440\u0430\u0431\u043E\u0442\u0430\u0442\u044C \u043B\u0438\u0447\u043D\u044B\u0435 \u043E\u0447\u043A\u0438 \u0441\u043B\u0430\u0432\u044B \u043C\u043E\u0436\u043D\u043E \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435.'
});

var CLAN_QUESTS_PERSONAL_TITLE = exports.CLAN_QUESTS_PERSONAL_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.clan_quests.personal_title',
    defaultMessage: '\u041F\u043E\u0440\u0443\u0447\u0435\u043D\u0438\u044F'
});

var CLAN_QUESTS_CLAN_TITLE = exports.CLAN_QUESTS_CLAN_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.clan_quests.clan_title',
    defaultMessage: '\u0426\u0435\u043B\u0438 \u043F\u043E\u0445\u043E\u0434\u0430'
});

var CLAN_QUESTS_NEXT_ACCOUNT_REWARD_TITLE = exports.CLAN_QUESTS_NEXT_ACCOUNT_REWARD_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.clan_quests.next_account_reward_title',
    defaultMessage: '\u0414\u043E \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u043D\u0430\u0433\u0440\u0430\u0434\u044B:'
});

var CLAN_QUESTS_NEXT_CLAN_REWARD_TITLE = exports.CLAN_QUESTS_NEXT_CLAN_REWARD_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.clan_quests.next_clan_reward_title',
    defaultMessage: '\u0414\u043E \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u0442\u0440\u043E\u0444\u0435\u044F:'
});

var CLAN_QUESTS_ALL_PERSONAL_REWARDS_RECEIVED = exports.CLAN_QUESTS_ALL_PERSONAL_REWARDS_RECEIVED = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.clan_quests.all_personal_rewards_received',
    defaultMessage: '\u0412\u0441\u0435 \u043D\u0430\u0433\u0440\u0430\u0434\u044B \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u044B'
});

var CLAN_QUESTS_ALL_CLAN_REWARDS_RECEIVED = exports.CLAN_QUESTS_ALL_CLAN_REWARDS_RECEIVED = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.clan_quests.all_clan_rewards_received',
    defaultMessage: '\u0412\u0441\u0435 \u0442\u0440\u043E\u0444\u0435\u0438 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u044B'
});

var CLAN_QUESTS_PERSONAL_TIMER_TOOLTIP = exports.CLAN_QUESTS_PERSONAL_TIMER_TOOLTIP = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.clan_quests.personal_timer_tooltip',
    defaultMessage: '\u0412\u0440\u0435\u043C\u044F \u0434\u043E \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F \u043F\u043E\u0440\u0443\u0447\u0435\u043D\u0438\u0439.'
});

var CLAN_QUESTS_PERSONAL_POINTS_TOOLTIP_TITLE = exports.CLAN_QUESTS_PERSONAL_POINTS_TOOLTIP_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.clan_quests.personal_points_tooltip_title',
    defaultMessage: '\u041E\u0447\u043A\u0438 \u043B\u0438\u0447\u043D\u043E\u0433\u043E \u0432\u043A\u043B\u0430\u0434\u0430'
});

var CLAN_QUESTS_PERSONAL_POINTS_TOOLTIP_MESSAGE = exports.CLAN_QUESTS_PERSONAL_POINTS_TOOLTIP_MESSAGE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.clan_quests.personal_points_tooltip_message',
    defaultMessage: '\u041E\u0447\u043A\u0438 \u043B\u0438\u0447\u043D\u043E\u0433\u043E \u0432\u043A\u043B\u0430\u0434\u0430 \u043C\u043E\u0436\u043D\u043E \u0437\u0430\u0440\u0430\u0431\u043E\u0442\u0430\u0442\u044C \u0437\u0430 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435 \u043F\u043E\u0440\u0443\u0447\u0435\u043D\u0438\u0439.'
});

var CLAN_QUESTS_CLAN_POINTS_TOOLTIP_TITLE = exports.CLAN_QUESTS_CLAN_POINTS_TOOLTIP_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.clan_quests.clan_points_tooltip_title',
    defaultMessage: '\u041E\u0447\u043A\u0438 \u043F\u043E\u0445\u043E\u0434\u0430'
});

var CLAN_QUESTS_CLAN_POINTS_TOOLTIP_MESSAGE = exports.CLAN_QUESTS_CLAN_POINTS_TOOLTIP_MESSAGE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.clan_quests.clan_points_tooltip_message',
    defaultMessage: '\u041E\u0447\u043A\u0438 \u043F\u043E\u0445\u043E\u0434\u0430 \u0437\u0430\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u044E\u0442 \u0432\u0441\u0435 \u0438\u0433\u0440\u043E\u043A\u0438 \u043A\u043B\u0430\u043D\u0430 \u0437\u0430 \u0434\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u0435 \u0446\u0435\u043B\u0435\u0439 \u043F\u043E\u0445\u043E\u0434\u0430 \u0438 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435 \u043F\u043E\u0440\u0443\u0447\u0435\u043D\u0438\u0439.'
});

var CLAN_QUESTS_CLAN_TIMER_TOOLTIP = exports.CLAN_QUESTS_CLAN_TIMER_TOOLTIP = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.clan_quests.clan_timer_tooltip',
    defaultMessage: '\u0412\u0440\u0435\u043C\u044F \u0434\u043E \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F \u0446\u0435\u043B\u0435\u0439 \u043F\u043E\u0445\u043E\u0434\u0430.'
});

var CLAN_QUESTS_CLAN_FINISHED_TITLE = exports.CLAN_QUESTS_CLAN_FINISHED_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.clan_quests.clan_finished_title',
    defaultMessage: '\u0412\u0441\u0435 \u0446\u0435\u043B\u0438 \u043F\u043E\u0445\u043E\u0434\u0430 \u0434\u043E\u0441\u0442\u0438\u0433\u043D\u0443\u0442\u044B!'
});

var CLAN_QUESTS_ALL_FINISHED_TITLE = exports.CLAN_QUESTS_ALL_FINISHED_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.clan_quests.all_finished_title',
    defaultMessage: '\u0411\u043E\u0435\u0432\u043E\u0439 \u043F\u043E\u0445\u043E\u0434 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0437\u0430\u0432\u0435\u0440\u0448\u0451\u043D!'
});

var CLAN_QUESTS_CLAN_TIMER_TITLE = exports.CLAN_QUESTS_CLAN_TIMER_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.clan_quests.clan_timer_title',
    defaultMessage: '\u0414\u043E \u043D\u043E\u0432\u043E\u0433\u043E \u0411\u043E\u0435\u0432\u043E\u0433\u043E \u043F\u043E\u0445\u043E\u0434\u0430:'
});

var CLAN_QUESTS_RELOAD_BUTTON_TOOLTIP = exports.CLAN_QUESTS_RELOAD_BUTTON_TOOLTIP = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.clan_quests.reload_button_tooltip',
    defaultMessage: '\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u043E \u0411\u043E\u0435\u0432\u044B\u0445 \u043F\u043E\u0445\u043E\u0434\u0430\u0445.'
});

var CLAN_QUESTS_DISABLED_TITLE = exports.CLAN_QUESTS_DISABLED_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.clan_quests.disabled_title',
    defaultMessage: '\u0411\u043E\u0435\u0432\u043E\u0439 \u043F\u043E\u0445\u043E\u0434'
});

var CLAN_QUESTS_DISABLED_MESSAGE = exports.CLAN_QUESTS_DISABLED_MESSAGE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.clan_quests.disabled_message',
    defaultMessage: '\u0411\u043E\u0435\u0432\u044B\u0435 \u043F\u043E\u0445\u043E\u0434\u044B \u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E \u043F\u0440\u0438\u043E\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044B.'
});

var CLAN_QUESTS_NOT_AVAILABLE_MESSAGE = exports.CLAN_QUESTS_NOT_AVAILABLE_MESSAGE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.clan_quests.not_available_message',
    defaultMessage: '\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u043E \u0431\u043E\u0435\u0432\u044B\u0445 \u043F\u043E\u0445\u043E\u0434\u0430\u0445 \u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430.'
});

var CLAN_QUESTS_RELOAD_BUTTON_TITLE = exports.CLAN_QUESTS_RELOAD_BUTTON_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.clan_quests.reload_button_title',
    defaultMessage: '\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C'
});

var CLAN_QUESTS_TUTORIAL_ARROW_TEXT = exports.CLAN_QUESTS_TUTORIAL_ARROW_TEXT = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.clan_quests.tutorial_arrow_text',
    defaultMessage: '\u041F\u0415\u0420\u0415\u0419\u0422\u0418{brTag}\u041A \u041F\u041E\u0425\u041E\u0414\u0423',
    values: {
        brTag: _react2.default.createElement('br', null)
    }
});

var GLOBAL_MAP_NEAREST_BATTLE_TIME = exports.GLOBAL_MAP_NEAREST_BATTLE_TIME = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.global_map.nearest_battle_time',
    defaultMessage: '\u0412\u0440\u0435\u043C\u044F \u0431\u043B\u0438\u0436\u0430\u0439\u0448\u0435\u0433\u043E \u0431\u043E\u044F \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435'
});

var BATTLES_NOW = exports.BATTLES_NOW = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.battles_now',
    defaultMessage: '\u0418\u0434\u0443\u0442 \u0431\u043E\u0438'
});

var TOMMOROW_IN = exports.TOMMOROW_IN = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.tommorow_in',
    defaultMessage: '\u0417\u0430\u0432\u0442\u0440\u0430 \u0432'
});

var PLUS = exports.PLUS = function PLUS(isPlanned) {
    return isPlanned ? _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'clan_landing.plus',
        defaultMessage: '+'
    }) : null;
};

var TOMMOROW_TIME = exports.TOMMOROW_TIME = function TOMMOROW_TIME(date, isPlanned) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'clan_landing.tomorrow_date',
        defaultMessage: '{text}{space}{time}{plus}',
        values: {
            text: _react2.default.createElement(
                'span',
                { className: _cards2.default.battleText },
                TOMMOROW_IN
            ),
            time: date.format('LT'),
            plus: PLUS(isPlanned),
            space: '\u2007'
        }
    });
};

var CUSTOM_DATE_TIME = exports.CUSTOM_DATE_TIME = function CUSTOM_DATE_TIME(date, isPlanned) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'clan_landing.custom_date',
        defaultMessage: '{time}{plus}{space}{date}',
        values: {
            date: _react2.default.createElement(
                'span',
                { className: _cards2.default.battleText },
                date.format('L')
            ),
            time: date.format('LT'),
            plus: PLUS(isPlanned),
            space: '\u2007'
        }
    });
};

var TODAY_TIME = exports.TODAY_TIME = function TODAY_TIME(date, isPlanned) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'clan_landing.today_date',
        defaultMessage: '{time}{plus}',
        values: {
            time: date.format('LT'),
            plus: PLUS(isPlanned)
        }
    });
};

var STRONGHOLD_UPDATED = exports.STRONGHOLD_UPDATED = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.stronghold_updated',
    defaultMessage: '\u041E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u0423\u043A\u0440\u0435\u043F\u0440\u0430\u0439\u043E\u043D\u0430'
});

var MANEUVERS_TITLE = exports.MANEUVERS_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.maneuvers_title',
    defaultMessage: '\u041C\u0430\u043D\u0451\u0432\u0440\u044B'
});

var MANEUVERS_DESCRIPTION = exports.MANEUVERS_DESCRIPTION = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.maneuvers_description',
    defaultMessage: '\u041A\u043B\u0430\u043D\u043E\u0432\u044B\u0435 \u0441\u0440\u0430\u0436\u0435\u043D\u0438\u044F \u0437\u0430 \u043B\u0438\u0434\u0435\u0440\u0441\u0442\u0432\u043E \u0438 \u0446\u0435\u043D\u043D\u044B\u0435 \u043D\u0430\u0433\u0440\u0430\u0434\u044B'
});

var CLAN_SUPPLY_QUESTS_TITLE = exports.CLAN_SUPPLY_QUESTS_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.clan_supply_quests_title',
    defaultMessage: '\u0417\u0430\u0434\u0430\u0447\u0438 \u043F\u043E\u0445\u043E\u0434\u0430'
});
var CLAN_SUPPLY_QUESTS_DISABLED_TEXT = exports.CLAN_SUPPLY_QUESTS_DISABLED_TEXT = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.clan_supply_quests_disabled_text',
    defaultMessage: '\u0412\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435 \u0437\u0430\u0434\u0430\u0447 \u043F\u043E\u0445\u043E\u0434\u0430 \u043F\u0440\u0438\u043E\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043E'
});

var CLAN_SUPPLY_QUESTS_PLAY_WITH_TEAMMATES = exports.CLAN_SUPPLY_QUESTS_PLAY_WITH_TEAMMATES = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.clan_supply_quests_play_with_teammates',
    defaultMessage: '\u0417\u0430\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0439\u0442\u0435 \u043E\u0447\u043A\u0438 \u043F\u043E\u0445\u043E\u0434\u0430 \u0438 \u043F\u0440\u043E\u043C\u0440\u0435\u0441\u0443\u0440\u0441'
});

var CLAN_SUPPLY_QUESTS_ALL_DONE = exports.CLAN_SUPPLY_QUESTS_ALL_DONE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.clan_supply_all_done',
    defaultMessage: '\u0412\u0441\u0435 \u0437\u0430\u0434\u0430\u0447\u0438 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u044B'
});

var CLAN_SUPPLY_IN_PROGRESS = exports.CLAN_SUPPLY_IN_PROGRESS = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.clan_supply_in_progress',
    defaultMessage: '\u041D\u0430\u0433\u0440\u0430\u0434\u0430 \u0431\u0443\u0434\u0435\u0442 \u043D\u0430\u0447\u0438\u0441\u043B\u0435\u043D\u0430 \u0432 \u0431\u043B\u0438\u0436\u0430\u0439\u0448\u0435\u0435 \u0432\u0440\u0435\u043C\u044F'
});

var CLAN_SUPPLY_QUESTS_TIME_BEFORE_END = exports.CLAN_SUPPLY_QUESTS_TIME_BEFORE_END = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.clan_supply_quests_time_before_end',
    defaultMessage: '\u0412\u0440\u0435\u043C\u044F \u0434\u043E \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u044F \u0442\u0435\u043A\u0443\u0449\u0435\u0433\u043E \u043F\u0435\u0440\u0438\u043E\u0434\u0430'
});

var CLAN_SUPPLY_QUESTS_TAKE_REWARD = exports.CLAN_SUPPLY_QUESTS_TAKE_REWARD = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.clan_supply_quests_take_reward',
    defaultMessage: '\u0417\u0430\u0431\u0440\u0430\u0442\u044C \u043D\u0430\u0433\u0440\u0430\u0434\u0443'
});

var CLAN_SUPPLY_PROGRESSION_TITLE = exports.CLAN_SUPPLY_PROGRESSION_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.clan_supply_progression_campaign_title',
    defaultMessage: '\u0411\u043E\u0435\u0432\u043E\u0439 \u043F\u043E\u0445\u043E\u0434'
});

var CLAN_SUPPLY_PROGRESSION_PROGRESS_TOOLTIP = exports.CLAN_SUPPLY_PROGRESSION_PROGRESS_TOOLTIP = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.clan_supply_progression_campaign_progress_tooltip',
    defaultMessage: '\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043E\u0442\u043A\u0440\u044B\u0442\u044B\u0445 \u0440\u0435\u0433\u0438\u043E\u043D\u043E\u0432'
});

var CLAN_SUPPLY_PROGRESSION_DISABLED_TEXT = exports.CLAN_SUPPLY_PROGRESSION_DISABLED_TEXT = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.clan_supply_progression_disabled_text',
    defaultMessage: '\u041F\u0440\u043E\u0433\u0440\u0435\u0441\u0441 \u0431\u043E\u0435\u0432\u043E\u0433\u043E \u043F\u043E\u0445\u043E\u0434\u0430 \u043F\u0440\u0438\u043E\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D'
});

var CLAN_SUPPLY_PROGRESSION_REGIONS_EXPLORED = exports.CLAN_SUPPLY_PROGRESSION_REGIONS_EXPLORED = function CLAN_SUPPLY_PROGRESSION_REGIONS_EXPLORED(explored, count, divider) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'clan_landing.clan_supply_progression_regions_explored',
        defaultMessage: '\u041E\u0422\u041A\u0420\u042B\u0422\u041E \u0420\u0415\u0413\u0418\u041E\u041D\u041E\u0412:{explored}{divider}{count}',
        values: { explored: explored, count: count, divider: divider }
    });
};

var CLAN_SUPPLY_SLASH = exports.CLAN_SUPPLY_SLASH = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.clan_supply_slash',
    defaultMessage: '/'
});

var CLAN_SUPPLY_PROGRESSION_ALL_REGIONS_EXPLORED = exports.CLAN_SUPPLY_PROGRESSION_ALL_REGIONS_EXPLORED = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.clan_supply_progression_all_regions_explored',
    defaultMessage: '\u0411\u041E\u0415\u0412\u041E\u0419 \u041F\u041E\u0425\u041E\u0414 \u0417\u0410\u0412\u0415\u0420\u0428\u0401\u041D'
});

var CLAN_SUPPLY_PROGRESSION_EXPLORE_NEW_REGIONS = exports.CLAN_SUPPLY_PROGRESSION_EXPLORE_NEW_REGIONS = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.clan_supply_progression_explore_new_regions',
    defaultMessage: '\u041E\u0442\u043A\u0440\u044B\u0432\u0430\u0439\u0442\u0435 \u0440\u0435\u0433\u0438\u043E\u043D\u044B \u0438 \u043F\u043E\u043B\u0443\u0447\u0430\u0439\u0442\u0435 \u043D\u0430\u0433\u0440\u0430\u0434\u044B'
});

var CLAN_SUPPLY_PROGRESSION_CAN_OPEN_NEW_REGION = exports.CLAN_SUPPLY_PROGRESSION_CAN_OPEN_NEW_REGION = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.clan_supply_progression_can_open_new_region',
    defaultMessage: '\u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u043E\u0442\u043A\u0440\u044B\u0442\u044C \u043D\u043E\u0432\u044B\u0439 \u0440\u0435\u0433\u0438\u043E\u043D'
});

var CLAN_SUPPLY_PROGRESSION_EXPLORE_WITH_NEW_TANK = exports.CLAN_SUPPLY_PROGRESSION_EXPLORE_WITH_NEW_TANK = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.clan_supply_progression_explore_with_new_tank',
    defaultMessage: '\u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u043E\u0442\u043A\u0440\u044B\u0442\u044C \u0440\u0435\u0433\u0438\u043E\u043D \u0441 \u0442\u0435\u0445\u043D\u0438\u043A\u043E\u0439'
});

var CLAN_SUPPLY_PROGRESSION_TANK_RECEIVED = exports.CLAN_SUPPLY_PROGRESSION_TANK_RECEIVED = function CLAN_SUPPLY_PROGRESSION_TANK_RECEIVED(tier, type, name) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'clan_landing.clan_supply_progression_tank_received',
        defaultMessage: '{tier}{type}{name} \u043F\u043E\u043B\u0443\u0447\u0435\u043D',
        values: { tier: tier, type: type, name: name }
    });
};

var CLAN_SUPPLY_ARC_PROGRESSBAR_STATISTICS = exports.CLAN_SUPPLY_ARC_PROGRESSBAR_STATISTICS = function CLAN_SUPPLY_ARC_PROGRESSBAR_STATISTICS(current, required) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'clan_landing.arc_progressbar.statistics',
        defaultMessage: '{current}/{required}',
        values: { current: current, required: required }
    });
};

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BalancePropTypes = exports.RewardsMetaPropTypes = exports.RewardPropTypes = exports.TankPropTypes = exports.ProductPropTypes = exports.ProductItemPropTypes = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _constants = __webpack_require__(92);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProductItemPropTypes = exports.ProductItemPropTypes = _propTypes2.default.shape({
    id: _propTypes2.default.number.isRequired,
    value: _propTypes2.default.number.isRequired,
    price: _propTypes2.default.number,
    is_bought: _propTypes2.default.bool.isRequired
});

var ProductPropTypes = exports.ProductPropTypes = _propTypes2.default.shape({
    is_available_to_buy: _propTypes2.default.bool.isRequired,
    groups: _propTypes2.default.objectOf(_propTypes2.default.arrayOf(ProductItemPropTypes).isRequired)
});

var TankPropTypes = exports.TankPropTypes = _propTypes2.default.shape({
    type: _propTypes2.default.oneOf(['heavyTank', 'mediumTank', 'lightTank', 'SPG', 'AT-SPG']).isRequired,
    nation: _propTypes2.default.oneOf(['ussr', 'germany', 'usa', 'china', 'france', 'uk', 'japan', 'czech', 'sweden', 'poland', 'italy']).isRequired,
    userName: _propTypes2.default.string.isRequired,
    typeUserName: _propTypes2.default.string.isRequired,
    level: _propTypes2.default.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10]).isRequired,
    vehicleId: _propTypes2.default.number.isRequired,
    isPremium: _propTypes2.default.bool.isRequired,
    inHangar: _propTypes2.default.bool,

    clipFireRate: _propTypes2.default.array,
    turretArmor: _propTypes2.default.array.isRequired,
    reloadTime: _propTypes2.default.number,
    health: _propTypes2.default.number.isRequired,
    avgDamage: _propTypes2.default.array.isRequired,
    piercingPower: _propTypes2.default.array.isRequired,
    hullArmor: _propTypes2.default.array.isRequired
});

var RewardPropTypes = exports.RewardPropTypes = _propTypes2.default.shape({
    id: _propTypes2.default.number.isRequired,
    token: _propTypes2.default.number.isRequired,
    type: _propTypes2.default.oneOf(Object.values(_constants.REWARDS_TYPES)).isRequired,
    infoUrl: _propTypes2.default.string,
    isSelected: _propTypes2.default.bool.isRequired,
    price: _propTypes2.default.number,
    secondCurrency: _propTypes2.default.string.isRequired,
    secondPrice: _propTypes2.default.number.isRequired,
    vehicleParams: TankPropTypes
});

var RewardsMetaPropTypes = exports.RewardsMetaPropTypes = _propTypes2.default.shape({
    purchaseDatetimeEnd: _propTypes2.default.string.isRequired,
    minBet: _propTypes2.default.number,
    currentBet: _propTypes2.default.number,
    places: _propTypes2.default.number.isRequired,
    famePoints: _propTypes2.default.number,
    hasAuctionTicket: _propTypes2.default.bool
});

var BalancePropTypes = exports.BalancePropTypes = _propTypes2.default.shape({
    gold: _propTypes2.default.number.isRequired,
    credits: _propTypes2.default.number.isRequired,
    crystal: _propTypes2.default.number.isRequired,
    walletStatus: _propTypes2.default.shape({
        gold: _propTypes2.default.string.isRequired,
        credits: _propTypes2.default.string.isRequired,
        crystal: _propTypes2.default.string.isRequired
    }),
    isWGMoneyAvailable: _propTypes2.default.bool.isRequired
});

/***/ }),
/* 80 */,
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _Clan = __webpack_require__(404);

var _Clan2 = _interopRequireDefault(_Clan);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Clan = function Clan(_ref) {
    var tag = _ref.tag,
        name = _ref.name,
        color = _ref.color,
        emblem = _ref.emblem,
        battle = _ref.battle,
        nameColor = _ref.nameColor,
        tooltipId = _ref.tooltipId,
        tooltipData = _ref.tooltipData,
        className = _ref.className;

    var dataAttrs = tooltipId ? {
        'data-tip': tooltipData || true,
        'data-for': tooltipId
    } : {};

    return _react2.default.createElement(
        'div',
        _extends({
            className: (0, _classnames2.default)(_Clan2.default.base, _defineProperty({}, _Clan2.default.base__battle, battle), className)
        }, dataAttrs),
        _react2.default.createElement(
            'div',
            { className: _Clan2.default.emblem },
            _react2.default.createElement('img', { className: _Clan2.default.logo, src: emblem })
        ),
        _react2.default.createElement(
            'p',
            { className: _Clan2.default.name, style: { color: nameColor } },
            _react2.default.createElement(
                'span',
                { style: { color: color || '' } },
                '[' + tag + ']'
            ),
            ' ',
            name
        ),
        _react2.default.createElement(
            'p',
            { className: _Clan2.default.battle },
            battle
        )
    );
};

Clan.propTypes = {
    tag: _propTypes2.default.string.isRequired,
    name: _propTypes2.default.string.isRequired,
    color: _propTypes2.default.string,
    emblem: _propTypes2.default.string.isRequired,
    battle: _propTypes2.default.node,
    nameColor: _propTypes2.default.string,
    tooltipId: _propTypes2.default.string,
    tooltipData: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    className: _propTypes2.default.string
};

exports.default = Clan;

/***/ }),
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58), __webpack_require__(122)(module)))

/***/ }),
/* 94 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tooltip-root":"cards_tooltip-root--1bG8H","tooltipRoot":"cards_tooltip-root--1bG8H","tooltip-root__show":"cards_tooltip-root__show--rn2gb","tooltipRootShow":"cards_tooltip-root__show--rn2gb","tooltip-body":"cards_tooltip-body--3MmDd","tooltipBody":"cards_tooltip-body--3MmDd","tooltip-wrapper":"cards_tooltip-wrapper--5iMVy","tooltipWrapper":"cards_tooltip-wrapper--5iMVy","tooltip-content":"cards_tooltip-content--1EPBT","tooltipContent":"cards_tooltip-content--1EPBT","tooltip-title":"cards_tooltip-title--2qb7V","tooltipTitle":"cards_tooltip-title--2qb7V","tooltip-subtitle":"cards_tooltip-subtitle--29-Vr","tooltipSubtitle":"cards_tooltip-subtitle--29-Vr","tooltip-message":"cards_tooltip-message--54Coz","tooltipMessage":"cards_tooltip-message--54Coz","tooltip-warning":"cards_tooltip-warning--3J8tw","tooltipWarning":"cards_tooltip-warning--3J8tw","tooltip-divider":"cards_tooltip-divider--1TBYt","tooltipDivider":"cards_tooltip-divider--1TBYt","tooltip-highlight":"cards_tooltip-highlight--3eGih","tooltipHighlight":"cards_tooltip-highlight--3eGih","tooltip-ribbon":"cards_tooltip-ribbon--10VhS","tooltipRibbon":"cards_tooltip-ribbon--10VhS","tooltip-statusMessage":"cards_tooltip-statusMessage--3mPlm","tooltipStatusMessage":"cards_tooltip-statusMessage--3mPlm","tooltip-statusMessage__positive":"cards_tooltip-statusMessage__positive--3b0kr","tooltipStatusMessagePositive":"cards_tooltip-statusMessage__positive--3b0kr","tooltip-status":"cards_tooltip-status--3rE6L","tooltipStatus":"cards_tooltip-status--3rE6L","tooltip-statusMessage__negative":"cards_tooltip-statusMessage__negative--2Y5iF","tooltipStatusMessageNegative":"cards_tooltip-statusMessage__negative--2Y5iF","tooltip-statusMessage__noPermission":"cards_tooltip-statusMessage__noPermission--1OPoL","tooltipStatusMessageNoPermission":"cards_tooltip-statusMessage__noPermission--1OPoL","tooltip-status__positive":"cards_tooltip-status__positive--3-wqR","tooltipStatusPositive":"cards_tooltip-status__positive--3-wqR","tooltip-status__negative":"cards_tooltip-status__negative--1IBGQ","tooltipStatusNegative":"cards_tooltip-status__negative--1IBGQ","tooltip-statusText":"cards_tooltip-statusText--1KKtF","tooltipStatusText":"cards_tooltip-statusText--1KKtF","card":"cards_card--3IlIt","maneuvers":"cards_maneuvers--1_AAG","maneuvers__with_news":"cards_maneuvers__with_news--3eDG2","maneuversWithNews":"cards_maneuvers__with_news--3eDG2","maneuvers__with_quests":"cards_maneuvers__with_quests--1lELy","maneuversWithQuests":"cards_maneuvers__with_quests--1lELy","maneuvers__with_news_with_quests":"cards_maneuvers__with_news_with_quests--2xDRk","maneuversWithNewsWithQuests":"cards_maneuvers__with_news_with_quests--2xDRk","stronghold":"cards_stronghold--1dyEG","stronghold__with_news":"cards_stronghold__with_news--3l4lR","strongholdWithNews":"cards_stronghold__with_news--3l4lR","stronghold__with_quests":"cards_stronghold__with_quests--3fFt-","strongholdWithQuests":"cards_stronghold__with_quests--3fFt-","stronghold__with_news_with_quests":"cards_stronghold__with_news_with_quests--3bhQ5","strongholdWithNewsWithQuests":"cards_stronghold__with_news_with_quests--3bhQ5","stronghold_level":"cards_stronghold_level--3_dNU","strongholdLevel":"cards_stronghold_level--3_dNU","challenges":"cards_challenges--24Y04","stronghold__vertical":"cards_stronghold__vertical--1L2cP","strongholdVertical":"cards_stronghold__vertical--1L2cP","timer":"cards_timer--1wsSd","balance":"cards_balance--Dh1Xs","balance_notEnough":"cards_balance_notEnough--322DP","balanceNotEnough":"cards_balance_notEnough--322DP","main":"cards_main--10kqm","members_online":"cards_members_online--1Zc6A","membersOnline":"cards_members_online--1Zc6A","count_online":"cards_count_online--dj0jD","countOnline":"cards_count_online--dj0jD","count_delimiter":"cards_count_delimiter--3OAi3","countDelimiter":"cards_count_delimiter--3OAi3","treasury":"cards_treasury--30aee","currency":"cards_currency--1s-m0","main__with_quests":"cards_main__with_quests--3IuXf","mainWithQuests":"cards_main__with_quests--3IuXf","crystal":"cards_crystal--3HSvg","gold":"cards_gold--sg3KQ","crystal__empty":"cards_crystal__empty--2pzCl","crystalEmpty":"cards_crystal__empty--2pzCl","gold__empty":"cards_gold__empty--1_n7S","goldEmpty":"cards_gold__empty--1_n7S","buttons_wrapper":"cards_buttons_wrapper--340KA","buttonsWrapper":"cards_buttons_wrapper--340KA","icon_search":"cards_icon_search--2zmqe","iconSearch":"cards_icon_search--2zmqe","icon_clan":"cards_icon_clan--2kq6X","iconClan":"cards_icon_clan--2kq6X","main__cn":"cards_main__cn--SjjB0","mainCn":"cards_main__cn--SjjB0","main__with_quests_cn":"cards_main__with_quests_cn--ssaPO","mainWithQuestsCn":"cards_main__with_quests_cn--ssaPO","global_map":"cards_global_map--2TR-F","globalMap":"cards_global_map--2TR-F","global_map__cn":"cards_global_map__cn--2er9S","globalMapCn":"cards_global_map__cn--2er9S","global_map__with_news":"cards_global_map__with_news--1wOzB","globalMapWithNews":"cards_global_map__with_news--1wOzB","global_map__with_news_cn":"cards_global_map__with_news_cn--1gKtl","globalMapWithNewsCn":"cards_global_map__with_news_cn--1gKtl","global_map__with_quests":"cards_global_map__with_quests--Tuckn","globalMapWithQuests":"cards_global_map__with_quests--Tuckn","global_map__with_quests_cn":"cards_global_map__with_quests_cn--1rSgz","globalMapWithQuestsCn":"cards_global_map__with_quests_cn--1rSgz","global_map__with_news_with_quests":"cards_global_map__with_news_with_quests--1zASs","globalMapWithNewsWithQuests":"cards_global_map__with_news_with_quests--1zASs","global_map__with_news_with_quests_cn":"cards_global_map__with_news_with_quests_cn--1bzOH","globalMapWithNewsWithQuestsCn":"cards_global_map__with_news_with_quests_cn--1bzOH","famePoints":"cards_famePoints--3ki31","externalUrl":"cards_externalUrl--4U7Y6","global_map__locked":"cards_global_map__locked--3F_ko","globalMapLocked":"cards_global_map__locked--3F_ko","locked_description":"cards_locked_description--2HN12","lockedDescription":"cards_locked_description--2HN12","pfp":"cards_pfp--18oYN","battleHolder":"cards_battleHolder--31MUg","battleBox":"cards_battleBox--3OQG5","battleDate":"cards_battleDate--qedHh","battleText":"cards_battleText--eRFCd","multiplier":"cards_multiplier--3AfON","industrialResourceBuyin":"cards_industrialResourceBuyin--1M4ow","clan_quests":"cards_clan_quests--3mkN2","clanQuests":"cards_clan_quests--3mkN2","clan_quests__new":"cards_clan_quests__new--24JTF","clanQuestsNew":"cards_clan_quests__new--24JTF","clan_quests__hasError":"cards_clan_quests__hasError--2NJ9P","clanQuestsHasError":"cards_clan_quests__hasError--2NJ9P","clan_quests__disabled":"cards_clan_quests__disabled--2BIBZ","clanQuestsDisabled":"cards_clan_quests__disabled--2BIBZ","centeredBlock":"cards_centeredBlock--1f1Mu","finishedBlockTitle":"cards_finishedBlockTitle--1S6iK","finishedtimerBlock":"cards_finishedtimerBlock--278kB","disabledTitle":"cards_disabledTitle--3L7bX","disabledMessage":"cards_disabledMessage--2BHEj","errorLogo":"cards_errorLogo--34fIJ","errorTitle":"cards_errorTitle--2sxxU","errorMessage":"cards_errorMessage--hDrMd","errorReload":"cards_errorReload--c1Z5G","errorLogMessage":"cards_errorLogMessage--1LFp_","content":"cards_content--3OVem","column":"cards_column--Gp7Zj","divider":"cards_divider--3hqyz","header":"cards_header--3Dbc_","title":"cards_title--2lYIh","progressBlock":"cards_progressBlock--ZFQAu","progressPersonalItem":"cards_progressPersonalItem--IYU4N","progressClanItem":"cards_progressClanItem--378C2","bottomBlock":"cards_bottomBlock--3ep8r","rewardsBlock":"cards_rewardsBlock--Oow-G","tillReward":"cards_tillReward--1u8f_","points":"cards_points--2JJzR","pointsBlock":"cards_pointsBlock--2Cut9","accountPoints":"cards_accountPoints--iSB0Z","clanPoints":"cards_clanPoints--3GKTj","plus":"cards_plus--2OX0r","finishedTitle":"cards_finishedTitle--11DWb","reload":"cards_reload--29_Mk","timerBlock":"cards_timerBlock--37x0r","tutorialArrow":"cards_tutorialArrow--22jmT","clanSupplyCard":"cards_clanSupplyCard--36PO3","clanSupplyCard__quests":"cards_clanSupplyCard__quests--2Uvhr","clanSupplyCardQuests":"cards_clanSupplyCard__quests--2Uvhr","clanSupplyCard__progression":"cards_clanSupplyCard__progression--2OTLF","clanSupplyCardProgression":"cards_clanSupplyCard__progression--2OTLF","clanSupplyQuestsCard":"cards_clanSupplyQuestsCard--1NmgS","quests":"cards_quests--1-JZn","quest":"cards_quest--6poN1","rewards":"cards_rewards--3dBIx","currencies":"cards_currencies--1BvBh","currencies__tourCoin":"cards_currencies__tourCoin--1Cu2U","currenciesTourCoin":"cards_currencies__tourCoin--1Cu2U","currencies__industrialResource":"cards_currencies__industrialResource--3JShW","currenciesIndustrialResource":"cards_currencies__industrialResource--3JShW","status":"cards_status--3c17W","icon-status":"cards_icon-status--397KK","iconStatus":"cards_icon-status--397KK","icon-status__reward-available":"cards_icon-status__reward-available--2ko_4","iconStatusRewardAvailable":"cards_icon-status__reward-available--2ko_4","icon-status__complete":"cards_icon-status__complete--2cweY","iconStatusComplete":"cards_icon-status__complete--2cweY","icon-status__pending":"cards_icon-status__pending--3Z526","iconStatusPending":"cards_icon-status__pending--3Z526","progress":"cards_progress--2at8N","current":"cards_current--2dKk1","current__started":"cards_current__started--2T-gz","currentStarted":"cards_current__started--2T-gz","required":"cards_required--2yI6e","clanSupplyProgressionCard":"cards_clanSupplyProgressionCard--3iHpS","tankImage":"cards_tankImage--2bf8m","explored":"cards_explored--3YNNw","exploredText":"cards_exploredText--1zCI0","exploredCurrent":"cards_exploredCurrent--1Mpk5","exploredCount":"cards_exploredCount--2vkKA","exploredDivider":"cards_exploredDivider--3Lsh6","effect":"cards_effect--tBhTv","effect__rotated":"cards_effect__rotated--zDox1","effectRotated":"cards_effect__rotated--zDox1","line":"cards_line--3l8JW"};

/***/ }),
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TYPES = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _Warning = __webpack_require__(382);

var _Warning2 = _interopRequireDefault(_Warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TYPES = exports.TYPES = {
    warning: 'warning',
    alert: 'alert',
    message: 'message'
};

var Warning = function Warning(props) {
    var className = (0, _classnames2.default)(_Warning2.default.base, _Warning2.default['base__' + TYPES[props.type]]);
    return _react2.default.createElement(
        'p',
        { className: className },
        props.children
    );
};

Warning.propTypes = {
    type: _propTypes2.default.oneOf(Object.keys(TYPES)).isRequired
};

Warning.defaultProps = {
    type: TYPES.warning
};

exports.default = Warning;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SCHEDULE_TYPES = exports.HAS_OFFSET = undefined;

var _locale = __webpack_require__(21);

var LANGUAGES_WITH_DATETIME_EXTRA_SYMBOLS = ['zh-CN', 'zh-SG', 'zh-TW', 'ko', 'ja'];

var HAS_OFFSET = exports.HAS_OFFSET = LANGUAGES_WITH_DATETIME_EXTRA_SYMBOLS.includes((0, _locale.getCurrentLanguage)());

var SCHEDULE_TYPES = exports.SCHEDULE_TYPES = {
    ALL_BATTLES: 'allBattleModes',
    ONE_BATTLE: 'oneBattleMode',
    MAIN_SCHEDULE: 'mainSchedule'
};

/***/ }),
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var ARROW_SIZES = exports.ARROW_SIZES = {
    big: 'big',
    small: 'small',
    tiny: 'tiny'
};

var ARROW_TYPES = exports.ARROW_TYPES = {
    left: 'left',
    right: 'right'
};

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.checkIndustrialResource = checkIndustrialResource;
exports.checkUpgradeVisibility = checkUpgradeVisibility;
exports.getNecessaryBuildingsLevel = getNecessaryBuildingsLevel;
exports.getBuildingsLevelSumm = getBuildingsLevelSumm;
exports.checkBuildingsLevelSumm = checkBuildingsLevelSumm;
exports.upgradeAvailability = upgradeAvailability;

var _constants = __webpack_require__(4);

var _accounts = __webpack_require__(33);

function checkIndustrialResource(state) {
    var upgradeCost = state.settings.command_center.costs[state.stronghold.level];
    var industrialResourceBalance = state.clan.industrial_resource;
    return industrialResourceBalance >= upgradeCost;
}

function checkUpgradeVisibility(state) {
    var hasPermission = (0, _accounts.canManageBuilding)(state.account);
    var maxLevelReached = state.stronghold.level === _constants.MAX_BUILDING_LEVEL;
    return hasPermission && !maxLevelReached;
}

function getNecessaryBuildingsLevel(_ref) {
    var settings = _ref.settings,
        stronghold = _ref.stronghold;

    return settings.command_center.required_total_stronghold_level_to_upgrade[stronghold.level - 1];
}

function getBuildingsLevelSumm(_ref2) {
    var stronghold = _ref2.stronghold,
        buildings = _ref2.buildings;

    var levelsSumm = stronghold.level;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = Object.keys(buildings)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var buildingId = _step.value;

            levelsSumm += buildings[buildingId].level;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return levelsSumm;
}

function checkBuildingsLevelSumm(state) {
    var necessaryBuildingsLevel = getNecessaryBuildingsLevel(state);
    var buildingsLevelSumm = getBuildingsLevelSumm(state);

    return buildingsLevelSumm >= necessaryBuildingsLevel;
}

function upgradeAvailability(state) {
    var hasEnougthIndustrialResource = checkIndustrialResource(state);
    var showUpgrade = checkUpgradeVisibility(state);
    var hasEnoughBuildingLevelSumm = checkBuildingsLevelSumm(state);

    return hasEnoughBuildingLevelSumm && hasEnougthIndustrialResource && showUpgrade;
}

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CreateUnitButton = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(7);

var _window_titles = __webpack_require__(80);

var _window_titles2 = _interopRequireDefault(_window_titles);

var _peripheries = __webpack_require__(37);

var _locale = __webpack_require__(21);

var _unit_create = __webpack_require__(129);

var _reactWotBootstrap = __webpack_require__(5);

var _CreateUnitButtonTooltip = __webpack_require__(399);

var _CreateUnitButtonTooltip2 = _interopRequireDefault(_CreateUnitButtonTooltip);

var _constants = __webpack_require__(402);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var COOLDOWN = 3000;

var CreateUnitButton = exports.CreateUnitButton = function (_React$Component) {
    _inherits(CreateUnitButton, _React$Component);

    function CreateUnitButton() {
        _classCallCheck(this, CreateUnitButton);

        var _this = _possibleConstructorReturn(this, (CreateUnitButton.__proto__ || Object.getPrototypeOf(CreateUnitButton)).call(this));

        _this.state = { cooldown: false };

        _this.openBattleWizard = _this.openBattleWizard.bind(_this);
        return _this;
    }

    _createClass(CreateUnitButton, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.state.cooldown) clearTimeout(this.cooldownTimer);
        }
    }, {
        key: 'resetCooldown',
        value: function resetCooldown() {
            this.setState({ cooldown: false });
        }
    }, {
        key: 'openBattleWizard',
        value: function openBattleWizard() {
            var _this2 = this;

            this.props.openBattleWizard();
            this.setState({ cooldown: true });
            this.cooldownTimer = setTimeout(function () {
                return _this2.resetCooldown();
            }, COOLDOWN);
        }
    }, {
        key: 'render',
        value: function render() {
            var sortiesPeriphery = (0, _peripheries.getPeripheryById)(this.props.meta.sorties.peripheries, this.props.peripheryId);
            var fortBattlesPeriphery = (0, _peripheries.getPeripheryById)(this.props.meta.fort_battles.peripheries, this.props.peripheryId);

            var isBattlesAvailable = (0, _peripheries.isSortiesAvailable)(sortiesPeriphery) || (0, _peripheries.isFortBattlesAvailable)(fortBattlesPeriphery);

            var button = _react2.default.createElement(
                _reactWotBootstrap.ButtonSmall,
                {
                    onClick: this.openBattleWizard,
                    isDisabled: !isBattlesAvailable || this.state.cooldown,
                    tooltipId: isBattlesAvailable ? null : _CreateUnitButtonTooltip2.default.id
                },
                _constants.BATTLE_ROOMS_CREATE_UNIT_BUTTON_CAPTION
            );

            return _react2.default.createElement(
                'div',
                null,
                button,
                _react2.default.createElement(_CreateUnitButtonTooltip2.default, {
                    meta: this.props.meta,
                    peripheryName: this.props.peripheryName
                })
            );
        }
    }]);

    return CreateUnitButton;
}(_react2.default.Component);

CreateUnitButton.propTypes = {
    openBattleWizard: _propTypes2.default.func.isRequired,
    meta: _propTypes2.default.object.isRequired,
    peripheryId: _propTypes2.default.number.isRequired,
    peripheryName: _propTypes2.default.string.isRequired
};


var mapStateToProps = function mapStateToProps(state) {
    return {
        meta: state.availableUnits.meta,
        peripheryId: state.account.periphery_id,
        peripheryName: state.account.periphery_name
    };
};

var mapDispatchToProps = {
    openBattleWizard: function openBattleWizard() {
        return (0, _unit_create.openBattleWizard)((0, _locale.formatMessage)(_window_titles2.default.wizard_create));
    }
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CreateUnitButton);

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = exports.Title = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactWotBootstrap = __webpack_require__(5);

var _reactRedux = __webpack_require__(7);

var _shared_translations = __webpack_require__(162);

var _schedule = __webpack_require__(27);

var _schedule2 = __webpack_require__(103);

var _Title = __webpack_require__(403);

var _Title2 = _interopRequireDefault(_Title);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Title = exports.Title = function Title(props) {
    var scheduleTooltipId = 'scheduleTooltip';
    var onScheduleButtonClick = function onScheduleButtonClick() {
        return _schedule.scheduleOpenThrottler.throttle(props.openSchedule);
    };

    return _react2.default.createElement(
        'h1',
        { className: _Title2.default.heading },
        props.children,
        _react2.default.createElement(
            'span',
            { className: _Title2.default.scheduleButton },
            _react2.default.createElement(
                _reactWotBootstrap.ButtonSmall,
                {
                    type: 'mini',
                    onClick: onScheduleButtonClick,
                    tooltipId: scheduleTooltipId
                },
                _react2.default.createElement('div', { className: _Title2.default.scheduleIcon })
            ),
            props.showScheduleBubble && _react2.default.createElement(
                'div',
                { className: _Title2.default.scheduleButton__bubble },
                '!'
            ),
            _react2.default.createElement(
                _reactWotBootstrap.Tooltip,
                { id: scheduleTooltipId },
                _react2.default.createElement(
                    'div',
                    { className: _Title2.default.tooltipContent },
                    _react2.default.createElement(
                        'p',
                        { className: _Title2.default.tooltipSubtitle },
                        _shared_translations.SCHEDULE_TITLE
                    ),
                    props.showScheduleBubble && _react2.default.createElement(
                        'p',
                        { className: _Title2.default.tooltipMessage },
                        _shared_translations.SCHEDULE_HAS_CHANGES
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: _Title2.default.tooltipMessage },
                        _shared_translations.SCHEDULE_TOOLTIP
                    )
                )
            )
        )
    );
};

Title.propTypes = {
    children: _propTypes2.default.node.isRequired,
    openSchedule: _propTypes2.default.func.isRequired,
    showScheduleBubble: _propTypes2.default.bool.isRequired
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
    return {
        showScheduleBubble: !state.userFlags.schedule_visited
    };
};

var mapDispatchToProps = exports.mapDispatchToProps = {
    openSchedule: _schedule2.openSchedule
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Title);

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Squad = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = __webpack_require__(7);

var _helpers = __webpack_require__(11);

var _datetime = __webpack_require__(13);

var _peripheries = __webpack_require__(37);

var _join_unit = __webpack_require__(201);

var _unit_participants = __webpack_require__(379);

var _reactWotBootstrap = __webpack_require__(5);

var _Clan = __webpack_require__(81);

var _Clan2 = _interopRequireDefault(_Clan);

var _DefaultTooltip = __webpack_require__(30);

var _DefaultTooltip2 = _interopRequireDefault(_DefaultTooltip);

var _slots = __webpack_require__(406);

var _constants = __webpack_require__(4);

var _constants2 = __webpack_require__(38);

var _constants3 = __webpack_require__(136);

var _propTypes3 = __webpack_require__(32);

var _Squad = __webpack_require__(208);

var _Squad2 = _interopRequireDefault(_Squad);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Squad = exports.Squad = function (_React$Component) {
    _inherits(Squad, _React$Component);

    function Squad() {
        _classCallCheck(this, Squad);

        return _possibleConstructorReturn(this, (Squad.__proto__ || Object.getPrototypeOf(Squad)).apply(this, arguments));
    }

    _createClass(Squad, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.props.requestUnitParticipants();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (this.props.unitData.id !== prevProps.unitData.id) {
                this.props.requestUnitParticipants();
            }
        }

        // TODO: merge logic with UnitTooltip.prototype.getFooterMessage

    }, {
        key: 'getFooterMessage',
        value: function getFooterMessage() {
            var periphery = void 0;
            var isAvailable = void 0;
            var primetimeStart = void 0;
            if (this.props.unitData.type === _constants.UNIT_TYPES.SORTIE) {
                periphery = (0, _peripheries.getPeripheryById)(this.props.meta.sorties.peripheries, this.props.unitData.periphery.id);
                isAvailable = (0, _peripheries.isSortiesAvailable)(periphery);
                primetimeStart = periphery ? periphery.primetime_start : null;
            } else {
                periphery = (0, _peripheries.getPeripheryById)(this.props.meta.fort_battles.peripheries, this.props.unitData.periphery.id);
                isAvailable = (0, _peripheries.isFortBattlesAvailable)(periphery) || this.props.unitData.fort_battle_in_progress;
                primetimeStart = periphery ? (0, _peripheries.getClosestMatchmakerTick)(periphery) : null;
            }

            var highlightedClassName = (0, _classnames2.default)(_Squad2.default.message, _Squad2.default.message__highlighted);
            if (this.props.unitData.in_battle) {
                return _react2.default.createElement(
                    'p',
                    { className: (0, _classnames2.default)(_Squad2.default.message, _Squad2.default.message__inBattle) },
                    _constants2.STATUS_IN_BATTLE_MESSAGE
                );
            } else if (this.props.unitData.players_matching_started_at !== null) {
                return _react2.default.createElement(
                    'p',
                    { className: highlightedClassName },
                    _constants2.STATUS_MATCHING_LEGIONARIES
                );
            } else if (isAvailable) {
                return _react2.default.createElement(
                    'p',
                    { className: _Squad2.default.message },
                    _constants2.STATUS_BATTLE_READY_MESSAGE
                );
            } else if (primetimeStart === null) {
                return this.props.unitData.fort_battle_in_progress ? null : _react2.default.createElement(
                    'p',
                    { className: highlightedClassName },
                    _constants2.BATTLE_MODE_DISABLED_ON_PERIPHERY
                );
            } else {
                var availableTime = (0, _datetime.getEndDateMessage)((0, _moment2.default)(primetimeStart));
                var timeNode = _react2.default.createElement(
                    'span',
                    { className: _Squad2.default.scheduleTime },
                    availableTime
                );
                return _react2.default.createElement(
                    'p',
                    { className: highlightedClassName },
                    (0, _constants2.STATUS_BATTLE_SCHEDULE_MESSAGE)(timeNode)
                );
            }
        }
    }, {
        key: 'renderTableHead',
        value: function renderTableHead() {
            var theadTRCLassName = (0, _classnames2.default)(_Squad2.default.tr, _Squad2.default.tr__thead);
            var vehicleTHClassName = (0, _classnames2.default)(_Squad2.default.th, _Squad2.default.th__vehicle);
            var nicknameTHClassName = (0, _classnames2.default)(_Squad2.default.th, _Squad2.default.th__nickname);
            var ratingTHClassName = (0, _classnames2.default)(_Squad2.default.th, _Squad2.default.th__rating);

            var playersColumnTH = this.props.forPreview ? _react2.default.createElement(
                'div',
                { className: nicknameTHClassName, 'data-tip': true, 'data-for': _constants3.TOOLTIPS.PLAYERS.id },
                _constants2.BATTLE_ROOMS_COLUMNS.squad,
                ': ',
                _react2.default.createElement(
                    'span',
                    { className: _Squad2.default.count },
                    this.props.unitData.members_number
                ),
                ' / ' + this.props.unitData.max_members_number,
                _react2.default.createElement(_DefaultTooltip2.default, _constants3.TOOLTIPS.PLAYERS)
            ) : _react2.default.createElement(
                'div',
                { className: nicknameTHClassName, 'data-tip': true, 'data-for': _constants3.TOOLTIPS.LEGIONARIES.id },
                _constants2.BATTLE_ROOMS_COLUMNS.legionaries,
                ': ',
                _react2.default.createElement(
                    'span',
                    { className: _Squad2.default.count },
                    this.props.unitData.legionaries_number
                ),
                ' / ' + this.props.unitData.max_legionaries_number,
                _react2.default.createElement(_DefaultTooltip2.default, _constants3.TOOLTIPS.LEGIONARIES)
            );

            return _react2.default.createElement(
                'div',
                { className: theadTRCLassName },
                playersColumnTH,
                _react2.default.createElement(
                    'div',
                    { className: ratingTHClassName, 'data-tip': true, 'data-for': _constants3.TOOLTIPS.RATING.id },
                    _react2.default.createElement('div', { className: _Squad2.default.ratingIcon }),
                    _react2.default.createElement(_DefaultTooltip2.default, _constants3.TOOLTIPS.RATING)
                ),
                _react2.default.createElement(
                    'div',
                    { className: vehicleTHClassName, 'data-tip': true, 'data-for': _constants3.TOOLTIPS.VEHICLE.id },
                    _constants2.BATTLE_ROOMS_COLUMNS.vehicles,
                    ': ',
                    _react2.default.createElement(
                        'span',
                        { className: _Squad2.default.level },
                        (0, _helpers.toRoman)(this.props.unitData.max_vehicle_level)
                    ),
                    _react2.default.createElement(_DefaultTooltip2.default, _constants3.TOOLTIPS.VEHICLE)
                )
            );
        }
    }, {
        key: 'renderSlots',
        value: function renderSlots() {
            var _this2 = this;

            var _props$unitData = this.props.unitData,
                max_members_number = _props$unitData.max_members_number,
                locked_slots_number = _props$unitData.locked_slots_number;


            var memberSlots = this.props.participants.map(function (member, index) {
                return _react2.default.createElement(_slots.MemberSlot, {
                    index: index + 1,
                    member: member,
                    key: 'member_slot_' + index,
                    realm: _this2.props.realm,
                    isLegionary: member.clan_tag !== _this2.props.unitData.clan.tag
                });
            });

            var lockedSlots = Array.from({ length: locked_slots_number }, function (_, index) {
                return _react2.default.createElement(_slots.LegionarySlot, { key: 'locked-slot-' + index });
            });

            var freeSlotsCount = max_members_number - this.props.participants.length - locked_slots_number;
            var freeSlotsNumerationStart = this.props.participants.length + locked_slots_number;

            var freeSlots = Array.from({ length: freeSlotsCount }, function (_, index) {
                var slotIndex = freeSlotsNumerationStart + index + 1;
                return _react2.default.createElement(_slots.FreeSlot, { index: slotIndex, key: 'free-slot-' + index });
            });

            var disabledSlotsCount = _constants.MAX_UNIT_PARTICIPANTS - max_members_number;
            var disabledSlots = Array.from({ length: disabledSlotsCount }, function (_, index) {
                return _react2.default.createElement(_slots.DisabledSlot, { index: index, key: 'disabled-slot-' + index });
            });

            return [].concat(_toConsumableArray(memberSlots), _toConsumableArray(lockedSlots), _toConsumableArray(freeSlots), _toConsumableArray(disabledSlots));
        }
    }, {
        key: 'render',
        value: function render() {
            var clan = void 0;
            if (!this.props.forPreview) {
                clan = _react2.default.createElement(
                    'header',
                    { 'data-tip': true, 'data-for': _constants3.TOOLTIPS.CLAN.id, className: _Squad2.default.header },
                    _react2.default.createElement(_Clan2.default, this.props.unitData.clan),
                    _react2.default.createElement(
                        _reactWotBootstrap.Tooltip,
                        { id: _constants3.TOOLTIPS.CLAN.id },
                        _react2.default.createElement(_Clan2.default, this.props.unitData.clan)
                    )
                );
            }

            var squadClasses = (0, _classnames2.default)(_Squad2.default.base, _defineProperty({}, _Squad2.default.unitPreview, this.props.forPreview));
            return _react2.default.createElement(
                'div',
                { className: squadClasses },
                clan,
                _react2.default.createElement(
                    'main',
                    { className: _Squad2.default.table },
                    _react2.default.createElement(
                        'div',
                        { className: _Squad2.default.thead },
                        this.renderTableHead()
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _Squad2.default.tbody },
                        this.renderSlots(),
                        _react2.default.createElement(_DefaultTooltip2.default, _constants3.TOOLTIPS.NO_VEHICLE),
                        _react2.default.createElement(_DefaultTooltip2.default, _constants3.TOOLTIPS.LEGIONARY)
                    )
                ),
                _react2.default.createElement(
                    'footer',
                    { className: _Squad2.default.footer },
                    _react2.default.createElement(
                        'div',
                        { className: _Squad2.default.button },
                        _react2.default.createElement(
                            _reactWotBootstrap.Button,
                            {
                                onClick: this.props.joinToUnit,
                                tooltipId: _constants3.TOOLTIPS.JOIN_BUTTON.id
                            },
                            _constants3.JOIN_BUTTON_CAPTION,
                            _react2.default.createElement(_DefaultTooltip2.default, _constants3.TOOLTIPS.JOIN_BUTTON)
                        )
                    ),
                    this.getFooterMessage()
                )
            );
        }
    }]);

    return Squad;
}(_react2.default.Component);

Squad.propTypes = {
    forPreview: _propTypes2.default.bool.isRequired,
    unitData: _propTypes3.UnitDataPropTypes.isRequired,

    joinToUnit: _propTypes2.default.func.isRequired,
    requestUnitParticipants: _propTypes2.default.func.isRequired,
    meta: _propTypes2.default.shape({
        sorties: _propTypes2.default.object.isRequired,
        fort_battles: _propTypes2.default.object.isRequired
    }),
    participants: _propTypes2.default.array.isRequired,
    realm: _propTypes2.default.string.isRequired
};


var mapStateToProps = function mapStateToProps(_ref) {
    var settings = _ref.settings,
        unitParticipants = _ref.unitParticipants,
        availableUnits = _ref.availableUnits;

    return {
        meta: availableUnits.meta,
        participants: unitParticipants.participants,
        realm: settings.realm
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
    var unit = ownProps.unitData;
    return {
        joinToUnit: function joinToUnit() {
            return dispatch((0, _join_unit.joinToUnit)(unit.server_id, unit.periphery.id));
        },
        requestUnitParticipants: function requestUnitParticipants() {
            return dispatch((0, _unit_participants.requestUnitParticipants)(unit.server_id, unit.periphery.id));
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Squad);

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TOOLTIPS = exports.JOIN_BUTTON_CAPTION = exports.LOCKED_SLOT_CAPTION = exports.FREE_SLOT_CAPTION = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _i18n = __webpack_require__(10);

var _constants = __webpack_require__(38);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FREE_SLOT_CAPTION = exports.FREE_SLOT_CAPTION = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_rooms.squad.free_slot_caption',
    defaultMessage: '\u0421\u0432\u043E\u0431\u043E\u0434\u043D\u043E'
});

var LOCKED_SLOT_CAPTION = exports.LOCKED_SLOT_CAPTION = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_rooms.squad.locked_slot_caption',
    defaultMessage: '\u0410\u0432\u0442\u043E\u043D\u0430\u0431\u043E\u0440 \u043B\u0435\u0433\u0438\u043E\u043D\u0435\u0440\u0430'
});

var JOIN_BUTTON_CAPTION = exports.JOIN_BUTTON_CAPTION = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_rooms.squad.join_button_caption',
    defaultMessage: '\u0412\u0441\u0442\u0443\u043F\u0438\u0442\u044C \u0432 \u043E\u0442\u0440\u044F\u0434'
});

var TOOLTIPS = exports.TOOLTIPS = {
    CLAN: {
        id: 'battle_rooms.squad.tooltips.clan'
    },
    COMMANDER: {
        id: 'battle_rooms.squad.tooltips.commander',
        message: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'battle_rooms.squad.tooltips.commander.message',
            defaultMessage: '\u041A\u043E\u043C\u0430\u043D\u0434\u0438\u0440 \u043E\u0442\u0440\u044F\u0434\u0430'
        })
    },
    LEGIONARIES: {
        id: 'battle_rooms.squad.tooltips.legionaries',
        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'battle_rooms.squad.tooltips.legionaries.title',
            defaultMessage: '\u041B\u0435\u0433\u0438\u043E\u043D\u0435\u0440\u044B'
        }),
        message: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'battle_rooms.squad.tooltips.legionaries.message',
            defaultMessage: '\u0422\u0435\u043A\u0443\u0449\u0435\u0435 \u0438 \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0435 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043B\u0435\u0433\u0438\u043E\u043D\u0435\u0440\u043E\u0432 \u0432 \u0441\u043E\u0441\u0442\u0430\u0432\u0435 \u043E\u0442\u0440\u044F\u0434\u0430.'
        })
    },
    PARTICIPANT: {
        id: 'battle_rooms.squad.tooltips.participant'
    },
    PLAYERS: {
        id: 'battle_rooms.squad.tooltips.players',
        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'battle_rooms.squad.tooltips.players.title',
            defaultMessage: '\u0421\u043E\u0441\u0442\u0430\u0432 \u043E\u0442\u0440\u044F\u0434\u0430'
        }),
        message: _constants.PLAYERS_COLUMN_DESCRIPTION
    },
    RATING: {
        id: 'battle_rooms.squad.tooltips.rating',
        title: _i18n.RATING_TEXT,
        message: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'battle_rooms.squad.tooltips.rating.message',
            defaultMessage: '\u041B\u0438\u0447\u043D\u044B\u0439 \u0440\u0435\u0439\u0442\u0438\u043D\u0433 \u0438\u0433\u0440\u043E\u043A\u0430.'
        })
    },
    VEHICLE: {
        id: 'battle_rooms.squad.tooltips.vehicle',
        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'battle_rooms.squad.tooltips.vehicle.title',
            defaultMessage: '\u0422\u0435\u0445\u043D\u0438\u043A\u0430'
        }),
        message: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'battle_rooms.squad.tooltips.vehicle.message',
            defaultMessage: '\u041C\u0430\u0448\u0438\u043D\u0430, \u043A\u043E\u0442\u043E\u0440\u0443\u044E \u0432\u044B\u0431\u0440\u0430\u043B \u0438\u0433\u0440\u043E\u043A.'
        })
    },
    NO_VEHICLE: {
        id: 'battle_rooms.squad.tooltips.no_vehicle',
        message: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'battle_rooms.squad.tooltips.no_vehicle.message',
            defaultMessage: '\u041C\u0430\u0448\u0438\u043D\u0430 \u043D\u0435 \u0432\u044B\u0431\u0440\u0430\u043D\u0430'
        })
    },
    JOIN_BUTTON: {
        id: 'battle_rooms.squad.tooltips.join',
        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'battle_rooms.squad.tooltips.join.title',
            defaultMessage: '\u0412\u0441\u0442\u0443\u043F\u0438\u0442\u044C \u0432 \u043E\u0442\u0440\u044F\u0434'
        }),
        message: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'battle_rooms.squad.tooltips.join.message',
            defaultMessage: '\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u0441\u0442\u0430\u0442\u044C \u0434\u043E\u0431\u0440\u043E\u0432\u043E\u043B\u044C\u0446\u0435\u043C \u0438 \u043F\u0435\u0440\u0435\u0439\u0442\u0438 \u043A \u043E\u0442\u0440\u044F\u0434\u0443.'
        })
    },
    LEGIONARY: {
        id: 'battle_rooms.squad.tooltips.legionary_slot',
        message: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'battle_rooms.squad.tooltips.legionary_slot.message',
            defaultMessage: '\u041B\u0435\u0433\u0438\u043E\u043D\u0435\u0440'
        })
    }
};

/***/ }),
/* 137 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tooltip-body":"UnitsList_tooltip-body--2I1bb","tooltipBody":"UnitsList_tooltip-body--2I1bb","tooltip-wrapper":"UnitsList_tooltip-wrapper--3T2_m","tooltipWrapper":"UnitsList_tooltip-wrapper--3T2_m","tooltip-content":"UnitsList_tooltip-content--1Wtxh","tooltipContent":"UnitsList_tooltip-content--1Wtxh","tooltip-base":"UnitsList_tooltip-base--3_6y3","tooltipBase":"UnitsList_tooltip-base--3_6y3","isVisible":"UnitsList_isVisible--Xz9PI","isWide":"UnitsList_isWide--2r1CR","th":"UnitsList_th--3pk5K","th__sortable":"UnitsList_th__sortable--3HoH-","thSortable":"UnitsList_th__sortable--3HoH-","thTitle":"UnitsList_thTitle--3oLjX","th__desc":"UnitsList_th__desc--OLODL","thDesc":"UnitsList_th__desc--OLODL","th__asc":"UnitsList_th__asc--1O-te","thAsc":"UnitsList_th__asc--1O-te","base__cn":"UnitsList_base__cn--3tKmE","baseCn":"UnitsList_base__cn--3tKmE","thCondition":"UnitsList_thCondition--38STL","thCondition__hover":"UnitsList_thCondition__hover--2tovv","thConditionHover":"UnitsList_thCondition__hover--2tovv","thCondition__active":"UnitsList_thCondition__active--2b-XV","thConditionActive":"UnitsList_thCondition__active--2b-XV","base":"UnitsList_base--1IZf1","tableHeader":"UnitsList_tableHeader--31t2S","thead":"UnitsList_thead--1av95","tbody":"UnitsList_tbody--2jF1c","tr":"UnitsList_tr--tPCWx","tr__thead":"UnitsList_tr__thead--3Orh3","trThead":"UnitsList_tr__thead--3Orh3","tr__subtitle":"UnitsList_tr__subtitle--36uoJ","trSubtitle":"UnitsList_tr__subtitle--36uoJ","tr__selected":"UnitsList_tr__selected--1yCJK","trSelected":"UnitsList_tr__selected--1yCJK","td":"UnitsList_td--QkXrt","th__basis":"UnitsList_th__basis--1fMBM","thBasis":"UnitsList_th__basis--1fMBM","td__basis":"UnitsList_td__basis--1RcdT","tdBasis":"UnitsList_td__basis--1RcdT","th__left":"UnitsList_th__left--vAAzq","thLeft":"UnitsList_th__left--vAAzq","td__left":"UnitsList_td__left--1x9vu","tdLeft":"UnitsList_td__left--1x9vu","th__center":"UnitsList_th__center--2S1Yu","thCenter":"UnitsList_th__center--2S1Yu","td__center":"UnitsList_td__center--24--t","tdCenter":"UnitsList_td__center--24--t","unitsList":"UnitsList_unitsList--1j0Oj","ratingIcon":"UnitsList_ratingIcon--CAvQG","rating":"UnitsList_rating--unCbS","modeIcon":"UnitsList_modeIcon--z2tYl","modeIcon__sortie-10":"UnitsList_modeIcon__sortie-10--3IjZr","modeIconSortie10":"UnitsList_modeIcon__sortie-10--3IjZr","modeIcon__sortie-8":"UnitsList_modeIcon__sortie-8--1l32O","modeIconSortie8":"UnitsList_modeIcon__sortie-8--1l32O","modeIcon__sortie-6":"UnitsList_modeIcon__sortie-6--2GRnC","modeIconSortie6":"UnitsList_modeIcon__sortie-6--2GRnC","modeIcon__fort-battle-10":"UnitsList_modeIcon__fort-battle-10--M7B7z","modeIconFortBattle10":"UnitsList_modeIcon__fort-battle-10--M7B7z","totalCount":"UnitsList_totalCount--2-2yG","inBattleIcon":"UnitsList_inBattleIcon--1d9uQ"};

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BattleModeFilter = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactWotBootstrap = __webpack_require__(5);

var _helpers = __webpack_require__(11);

var _i18n = __webpack_require__(10);

var _LevelFilterTooltip = __webpack_require__(211);

var _LevelFilterTooltip2 = _interopRequireDefault(_LevelFilterTooltip);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BattleModeFilter = exports.BattleModeFilter = function (_React$Component) {
    _inherits(BattleModeFilter, _React$Component);

    function BattleModeFilter() {
        _classCallCheck(this, BattleModeFilter);

        var _this = _possibleConstructorReturn(this, (BattleModeFilter.__proto__ || Object.getPrototypeOf(BattleModeFilter)).call(this));

        _this.generateTabsItems = _this.generateTabsItems.bind(_this);
        _this.getCheckedItem = _this.getCheckedItem.bind(_this);
        _this.onTabChange = _this.onTabChange.bind(_this);
        return _this;
    }

    _createClass(BattleModeFilter, [{
        key: 'generateTabsItems',
        value: function generateTabsItems() {
            return this.props.battleModesSettings.map(function (setting) {
                if (setting.unit_type === _constants.UNIT_TYPES.SORTIE) {
                    return {
                        value: getTabValue(setting.unit_type, setting.max_vehicle_level),
                        caption: (0, _i18n.SORTIES_WITH_LEVEL)((0, _helpers.toRoman)(setting.max_vehicle_level)),
                        tooltipId: getTooltipId(setting)
                    };
                }

                return {
                    value: getTabValue(setting.unit_type, setting.max_vehicle_level),
                    caption: _i18n.FORT_BATTLES,
                    tooltipId: getTooltipId(setting)
                };
            });
        }
    }, {
        key: 'getCheckedItem',
        value: function getCheckedItem() {
            return getTabValue(this.props.selectedUnitType, this.props.selectedVehicleLevel);
        }
    }, {
        key: 'onTabChange',
        value: function onTabChange(value) {
            var selectedSetting = this.props.battleModesSettings.find(function (setting) {
                return getTabValue(setting.unit_type, setting.max_vehicle_level) === value;
            });

            this.props.onChange(selectedSetting.unit_type, selectedSetting.max_vehicle_level);
        }
    }, {
        key: 'renderTooltips',
        value: function renderTooltips() {
            var _this2 = this;

            return this.props.battleModesSettings.map(function (setting) {
                return _react2.default.createElement(_LevelFilterTooltip2.default, {
                    id: getTooltipId(setting),
                    key: setting.unit_type + setting.max_vehicle_level,
                    battleRegulations: setting,
                    tab: _this2.props.tab
                });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var TAB_COUNT = this.props.battleModesSettings.length;
            var MIN_TABS_WIDTH = 350; // react-wot-boostrap style
            // 1/4 of UnitsView div.main width(560px) if you have less than 5 tabs
            var TAB_WIDTH = TAB_COUNT < 5 ? 140 : 560 / TAB_COUNT;
            var width = Math.max(TAB_WIDTH * TAB_COUNT, MIN_TABS_WIDTH);

            return _react2.default.createElement(
                'div',
                { style: { width: width + 'px' } },
                _react2.default.createElement(_reactWotBootstrap.Tabs, {
                    items: this.generateTabsItems(),
                    checkedItem: this.getCheckedItem(),
                    onItemChange: this.onTabChange
                }),
                this.renderTooltips()
            );
        }
    }]);

    return BattleModeFilter;
}(_react2.default.Component);

BattleModeFilter.propTypes = {
    tab: _propTypes2.default.oneOf(Object.values(_constants.BATTLE_ROOMS_TAB_STATES)).isRequired,
    selectedUnitType: _propTypes2.default.string,
    selectedVehicleLevel: _propTypes2.default.number,

    battleModesSettings: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        unit_type: _propTypes2.default.oneOf(Object.keys(_constants.UNIT_TYPES)),
        min_players_number: _propTypes2.default.number,
        max_players_number: _propTypes2.default.number,
        max_vehicle_level: _propTypes2.default.number,
        max_legionaries_number: _propTypes2.default.number,
        battle_duration: _propTypes2.default.number
    })),

    /**
     * method that is called when tab is changed
     * @param {UNIT_TYPES} unitType of selected tab
     * @param {(int|undefined)} vehicleLevel of selected tab. undefined for fort battles
     */
    onChange: _propTypes2.default.func.isRequired
};


function getTabValue(unit_type, vehicle_level) {
    return unit_type + '_' + vehicle_level;
}

function getTooltipId(_ref) {
    var unit_type = _ref.unit_type,
        max_vehicle_level = _ref.max_vehicle_level;

    return 'battleModeFilterTooltip_' + unit_type + '_' + max_vehicle_level;
}

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var isUnitDisabled = exports.isUnitDisabled = function isUnitDisabled(unit, accountClanId) {
    return !unit.is_open && unit.clan && unit.clan.id !== accountClanId || unit.is_destroyed;
};

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapStateToProps = exports.BattleRoomsSchedule = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(7);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(4);

var _ScheduleTable = __webpack_require__(216);

var _ScheduleTable2 = _interopRequireDefault(_ScheduleTable);

var _schedule = __webpack_require__(27);

var _helpers = __webpack_require__(435);

var _BattlesNotHeldMessage = __webpack_require__(436);

var _BattlesNotHeldMessage2 = _interopRequireDefault(_BattlesNotHeldMessage);

var _BattleRoomsSchedule = __webpack_require__(440);

var _BattleRoomsSchedule2 = _interopRequireDefault(_BattleRoomsSchedule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BattleRoomsSchedule = exports.BattleRoomsSchedule = function (_React$Component) {
    _inherits(BattleRoomsSchedule, _React$Component);

    function BattleRoomsSchedule() {
        _classCallCheck(this, BattleRoomsSchedule);

        return _possibleConstructorReturn(this, (BattleRoomsSchedule.__proto__ || Object.getPrototypeOf(BattleRoomsSchedule)).apply(this, arguments));
    }

    _createClass(BattleRoomsSchedule, [{
        key: 'render',
        value: function render() {
            if (!this.props.playdays) return null;
            var playday = (0, _helpers.getCurrentPlayday)(this.props.playdays, this.props.vehicleLevel, this.props.unitType);
            if (playday) playday.schedule_items = (0, _schedule.clearScheduleItemsOfChallenges)(playday.schedule_items);

            var baseClassNames = (0, _classnames2.default)(_BattleRoomsSchedule2.default.base, _defineProperty({}, _BattleRoomsSchedule2.default.isAllModes, this.props.type === 'allBattleModes'));

            return _react2.default.createElement(
                'div',
                { className: baseClassNames },
                _react2.default.createElement(
                    'h3',
                    { className: _BattleRoomsSchedule2.default.title },
                    _react2.default.createElement(_BattlesNotHeldMessage2.default, {
                        playdayEnd: this.props.playdayEnd,
                        playdays: this.props.playdays,
                        playdayStart: this.props.playdayStart,
                        unitType: this.props.unitType,
                        vehicleLevel: this.props.vehicleLevel
                    })
                ),
                _react2.default.createElement(
                    'section',
                    { className: _BattleRoomsSchedule2.default.scheduleWrapper },
                    playday && _react2.default.createElement(_ScheduleTable2.default, {
                        playday: playday,
                        type: this.props.type,
                        unitType: this.props.unitType,
                        vehicleLevel: this.props.vehicleLevel
                    })
                )
            );
        }
    }]);

    return BattleRoomsSchedule;
}(_react2.default.Component);

BattleRoomsSchedule.propTypes = {
    unitType: _propTypes2.default.oneOf(Object.values(_constants.UNIT_TYPES)),
    vehicleLevel: _propTypes2.default.number,
    type: _propTypes2.default.oneOf(['allBattleModes', 'oneBattleMode']),

    playdayStart: _propTypes2.default.number,
    playdayEnd: _propTypes2.default.number,
    playdays: _propTypes2.default.array
};
BattleRoomsSchedule.defaultProps = {
    type: 'oneBattleMode'
};
var mapStateToProps = exports.mapStateToProps = function mapStateToProps(_ref) {
    var schedule = _ref.schedule;

    return {
        playdayStart: schedule.playday_start,
        playdayEnd: schedule.playday_end,
        playdays: schedule.playdays
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(BattleRoomsSchedule);

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactWotBootstrap = __webpack_require__(5);

var _Nation = __webpack_require__(447);

var _Nation2 = _interopRequireDefault(_Nation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Nation = function Nation(props) {
    var className = (0, _classnames2.default)(_Nation2.default.base, _Nation2.default['base__' + props.nation], _defineProperty({}, _Nation2.default.base__cn, props.realm && _reactWotBootstrap.helpers.isChineseRealm(props.realm)));
    return _react2.default.createElement('span', { className: className });
};

Nation.TYPES = ['all_nations', 'ussr', 'germany', 'usa', 'france', 'uk', 'czech', 'china', 'japan', 'sweden', 'poland', 'italy'];

Nation.propTypes = {
    nation: _propTypes2.default.oneOf(Nation.TYPES).isRequired,
    realm: _propTypes2.default.string
};

Nation.defaultProps = {
    nation: Nation.TYPES[0]
};

exports.default = Nation;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var POSTBATTLE_TABS_LIST = exports.POSTBATTLE_TABS_LIST = ['result', 'details'];

var POSTBATTLE_MAX_ROWS = exports.POSTBATTLE_MAX_ROWS = 4;
var POSTBATTLE_ROW_HEIGHT = exports.POSTBATTLE_ROW_HEIGHT = 59;
var POSTBATTLE_HEADER_HEIGHT = exports.POSTBATTLE_HEADER_HEIGHT = 318;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _format_number = __webpack_require__(109);

var _FamePoints = __webpack_require__(2314);

var _FamePoints2 = _interopRequireDefault(_FamePoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FamePoints = function FamePoints(_ref) {
    var value = _ref.value,
        notAvailable = _ref.notAvailable,
        inactive = _ref.inactive,
        iconPosition = _ref.iconPosition,
        size = _ref.size,
        mixClassName = _ref.mixClassName;

    var className = (0, _classnames2.default)(_FamePoints2.default.base, _FamePoints2.default['base__' + size], _FamePoints2.default['base__' + iconPosition], notAvailable && _FamePoints2.default['base__not-available'], inactive && _FamePoints2.default.base__inactive, mixClassName);
    return _react2.default.createElement(
        'span',
        { className: className },
        (0, _format_number.thousands)(value)
    );
};

FamePoints.propTypes = {
    value: _propTypes2.default.number.isRequired,
    notAvailable: _propTypes2.default.bool,
    inactive: _propTypes2.default.bool,
    iconPosition: _propTypes2.default.oneOf(['before', 'after']).isRequired,
    size: _propTypes2.default.oneOf(['small', 'medium', 'regular', 'large']).isRequired,
    mixClassName: _propTypes2.default.string
};

FamePoints.defaultProps = {
    notAvailable: false,
    inactive: false,
    iconPosition: 'after',
    size: 'regular'
};

exports.default = FamePoints;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LeavingClanTooltip = exports.BattlesInClanTooltipContent = exports.RoleTooltipContent = exports.NameTooltipContent = exports.NotLoggedInEverTooltip = exports.NotPlayedInClanModesTooltip = exports.PlayerStatusColumnTooltipContent = exports.ResourceColumnTooltipContent = exports.FortBattlesColumnTooltipContent = exports.Attack11ColumnTooltipContent = exports.Attack10ColumnTooltipContent = exports.Attack8ColumnTooltipContent = exports.Attack6ColumnTooltipContent = exports.AttackColumnTooltipContent = exports.PlayerColumnTooltipContent = exports.RoleColumnTooltipContent = exports.ClearSelectedMembersTooltip = exports.SelectedMembersTooltip = exports.AboutIndicatorsStatisticsTooltip = exports.AboutIndicatorsClanModesTooltip = exports.StatisticsRandomEpicBattleTypeTooltip = exports.StatisticsRandomDefaultBattleTypeTooltip = exports.StatisticsDisabledPeriodTooltip = exports.Statistics1DayTooltip = exports.Statistics7DaysTooltip = exports.Statistics28DaysTooltip = exports.StatisticsOverallTooltip = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _reactWotBootstrap = __webpack_require__(5);

var _helpers = __webpack_require__(11);

var _i18n = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-multi-comp, max-len*/
var StatisticsOverallTooltip = exports.StatisticsOverallTooltip = function StatisticsOverallTooltip() {
    return _react2.default.createElement(
        _reactWotBootstrap.Tooltip,
        { id: StatisticsOverallTooltip.id },
        _react2.default.createElement(
            _reactWotBootstrap.TooltipBody,
            null,
            _react2.default.createElement(
                _reactWotBootstrap.TooltipSubtitle,
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'clanmanagement.tooltips.statistics_overall_header',
                    defaultMessage: '\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430 \u0437\u0430 \u0432\u0441\u0451 \u0432\u0440\u0435\u043C\u044F'
                })
            ),
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'clanmanagement.tooltips.statistics_overall_body',
                defaultMessage: '\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0441\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0443 \u0437\u0430 \u0432\u0441\u0451 \u0432\u0440\u0435\u043C\u044F.'
            })
        )
    );
};
StatisticsOverallTooltip.id = 'statistics-overall-tooltip';

var Statistics28DaysTooltip = exports.Statistics28DaysTooltip = function Statistics28DaysTooltip() {
    return _react2.default.createElement(
        _reactWotBootstrap.Tooltip,
        { id: Statistics28DaysTooltip.id },
        _react2.default.createElement(
            _reactWotBootstrap.TooltipBody,
            null,
            _react2.default.createElement(
                _reactWotBootstrap.TooltipSubtitle,
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'clanmanagement.tooltips.statistics_28_days_header',
                    defaultMessage: '\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430 \u0437\u0430 28 \u0434\u043D\u0435\u0439'
                })
            ),
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'clanmanagement.tooltips.statistics_28_days_body',
                defaultMessage: '\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0441\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0443 \u0437\u0430 \u043F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0438\u0435 28 \u0434\u043D\u0435\u0439'
            })
        )
    );
};
Statistics28DaysTooltip.id = 'statistics-28-days-tooltip';

var Statistics7DaysTooltip = exports.Statistics7DaysTooltip = function Statistics7DaysTooltip() {
    return _react2.default.createElement(
        _reactWotBootstrap.Tooltip,
        { id: Statistics7DaysTooltip.id },
        _react2.default.createElement(
            _reactWotBootstrap.TooltipBody,
            null,
            _react2.default.createElement(
                _reactWotBootstrap.TooltipSubtitle,
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'clanmanagement.tooltips.statistics_7_days_header',
                    defaultMessage: '\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430 \u0437\u0430 7 \u0434\u043D\u0435\u0439'
                })
            ),
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'clanmanagement.tooltips.statistics_7_days_body',
                defaultMessage: '\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0441\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0443 \u0437\u0430 \u043F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0438\u0435 7 \u0434\u043D\u0435\u0439'
            })
        )
    );
};
Statistics7DaysTooltip.id = 'statistics-7-days-tooltip';

var Statistics1DayTooltip = exports.Statistics1DayTooltip = function Statistics1DayTooltip() {
    return _react2.default.createElement(
        _reactWotBootstrap.Tooltip,
        { id: Statistics1DayTooltip.id },
        _react2.default.createElement(
            _reactWotBootstrap.TooltipBody,
            null,
            _react2.default.createElement(
                _reactWotBootstrap.TooltipSubtitle,
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'clanmanagement.tooltips.statistics_1_day_header',
                    defaultMessage: '\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430 \u0437\u0430 \u0441\u0443\u0442\u043A\u0438'
                })
            ),
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'clanmanagement.tooltips.statistics_1_day_body',
                defaultMessage: '\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0441\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0443 \u0437\u0430 \u043F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0438\u0435 \u0441\u0443\u0442\u043A\u0438'
            })
        )
    );
};
Statistics1DayTooltip.id = 'statistics-1-days-tooltip';

var StatisticsDisabledPeriodTooltip = exports.StatisticsDisabledPeriodTooltip = function StatisticsDisabledPeriodTooltip() {
    return _react2.default.createElement(
        _reactWotBootstrap.Tooltip,
        { id: StatisticsDisabledPeriodTooltip.id },
        _react2.default.createElement(
            _reactWotBootstrap.TooltipBody,
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'clanmanagement.tooltips.statistics_disabled_period_tooltip_1',
                defaultMessage: '\u041D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u0432\u044B\u0431\u0440\u0430\u0442\u044C \u043F\u0435\u0440\u0438\u043E\u0434 \u0434\u043B\u044F \u0434\u0430\u043D\u043D\u043E\u0433\u043E \u0440\u0435\u0436\u0438\u043C\u0430 \u0431\u043E\u044F.'
            }),
            _react2.default.createElement('br', null),
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'clanmanagement.tooltips.statistics_disabled_period_tooltip_2',
                defaultMessage: '\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430 \u0434\u043B\u044F \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u0433\u043E \u0440\u0435\u0436\u0438\u043C\u0430 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430 \u0442\u043E\u043B\u044C\u043A\u043E \u0437\u0430 \u0432\u0441\u0451 \u0432\u0440\u0435\u043C\u044F.'
            })
        )
    );
};
StatisticsDisabledPeriodTooltip.id = 'statistics-disabled-period-tooltip';

var StatisticsRandomDefaultBattleTypeTooltip = exports.StatisticsRandomDefaultBattleTypeTooltip = function StatisticsRandomDefaultBattleTypeTooltip() {
    return _react2.default.createElement(
        _reactWotBootstrap.Tooltip,
        { id: StatisticsRandomDefaultBattleTypeTooltip.id },
        _react2.default.createElement(
            _reactWotBootstrap.TooltipBody,
            null,
            _react2.default.createElement(
                _reactWotBootstrap.TooltipSubtitle,
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'clanmanagement.tooltips.statistics_random_default_battle_type_tooltip_header',
                    defaultMessage: '\u0421\u043B\u0443\u0447\u0430\u0439\u043D\u044B\u0439 \u0431\u043E\u0439 15\xD715'
                })
            ),
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'clanmanagement.tooltips.statistics_random_default_battle_type_tooltip',
                defaultMessage: '\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0441\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0443 \u0438\u0433\u0440\u043E\u043A\u043E\u0432 \u0432 \u0421\u043B\u0443\u0447\u0430\u0439\u043D\u044B\u0445 \u0431\u043E\u044F\u0445 15 \u043D\u0430 15, \u0432\u043A\u043B\u044E\u0447\u0430\u044F \u0421\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u044B\u0439 \u0431\u043E\u0439, \u0428\u0442\u0443\u0440\u043C \u0438 \u0412\u0441\u0442\u0440\u0435\u0447\u043D\u044B\u0439 \u0431\u043E\u0439.'
            })
        )
    );
};
StatisticsRandomDefaultBattleTypeTooltip.id = 'statistics-random-default-battle-type-tooltip';

var StatisticsRandomEpicBattleTypeTooltip = exports.StatisticsRandomEpicBattleTypeTooltip = function StatisticsRandomEpicBattleTypeTooltip() {
    return _react2.default.createElement(
        _reactWotBootstrap.Tooltip,
        { id: StatisticsRandomEpicBattleTypeTooltip.id },
        _react2.default.createElement(
            _reactWotBootstrap.TooltipBody,
            null,
            _react2.default.createElement(
                _reactWotBootstrap.TooltipSubtitle,
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'clanmanagement.tooltips.statistics_random_epic_battle_type_tooltip_header',
                    defaultMessage: '\u0421\u043B\u0443\u0447\u0430\u0439\u043D\u044B\u0439 \u0431\u043E\u0439 30\xD730'
                })
            ),
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'clanmanagement.tooltips.statistics_random_epic_battle_type_tooltip',
                defaultMessage: '\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0441\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0443 \u0438\u0433\u0440\u043E\u043A\u043E\u0432 \u0432 \u0413\u0435\u043D\u0435\u0440\u0430\u043B\u044C\u043D\u044B\u0445 \u0441\u0440\u0430\u0436\u0435\u043D\u0438\u044F\u0445.'
            })
        )
    );
};
StatisticsRandomEpicBattleTypeTooltip.id = 'statistics-random-epic-battle-type-tooltip';

var AboutIndicatorsClanModesTooltip = exports.AboutIndicatorsClanModesTooltip = function AboutIndicatorsClanModesTooltip() {
    return _react2.default.createElement(
        _reactWotBootstrap.Tooltip,
        { id: AboutIndicatorsClanModesTooltip.id },
        _react2.default.createElement(
            _reactWotBootstrap.TooltipHeader,
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'clanmanagement.tooltips.about_indicators_clan_modes_header',
                defaultMessage: '\u041E \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u0435\u043B\u044F\u0445'
            })
        ),
        _react2.default.createElement(
            _reactWotBootstrap.TooltipBody,
            null,
            _react2.default.createElement(
                _reactWotBootstrap.TooltipSubtitle,
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'clanmanagement.tooltips.about_indicators_clan_modes_subheader1',
                    defaultMessage: '\u0411\u043E\u0438'
                })
            ),
            _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'clanmanagement.tooltips.about_indicators_clan_modes_text1',
                    defaultMessage: '\u0423\u0447\u0438\u0442\u044B\u0432\u0430\u044E\u0442\u0441\u044F \u0442\u043E\u043B\u044C\u043A\u043E \u0431\u043E\u0438 \u0432 \u043E\u0442\u0440\u044F\u0434\u0430\u0445 \u044D\u0442\u043E\u0433\u043E \u043A\u043B\u0430\u043D\u0430 \u043F\u043E\u0441\u043B\u0435 \u0432\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u044F \u0432 \u043D\u0435\u0433\u043E.'
                })
            ),
            _react2.default.createElement(
                _reactWotBootstrap.TooltipSubtitle,
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'clanmanagement.tooltips.about_indicators_clan_modes_subheader2',
                    defaultMessage: '\u041F\u0440\u043E\u043C\u0440\u0435\u0441\u0443\u0440\u0441'
                })
            ),
            _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'clanmanagement.tooltips.about_indicators_clan_modes_text2',
                    defaultMessage: '\u0423\u0447\u0438\u0442\u044B\u0432\u0430\u0435\u0442\u0441\u044F \u043F\u0440\u043E\u043C\u0440\u0435\u0441\u0443\u0440\u0441, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u0438\u0433\u0440\u043E\u043A \u0437\u0430\u0440\u0430\u0431\u043E\u0442\u0430\u043B \u043F\u043E\u0441\u043B\u0435 \u0432\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u044F \u0432 \u043A\u043B\u0430\u043D \u043A\u0430\u043A \u0432 \u0435\u0433\u043E \u043E\u0442\u0440\u044F\u0434\u0430\u0445, \u0442\u0430\u043A \u0438 \u043B\u0435\u0433\u0438\u043E\u043D\u0435\u0440\u043E\u043C.'
                })
            )
        ),
        _react2.default.createElement(
            _reactWotBootstrap.TooltipFooter,
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'clanmanagement.tooltips.about_indicators_clan_modes_text3',
                defaultMessage: '\u041F\u0440\u0438 \u043F\u043E\u0432\u0442\u043E\u0440\u043D\u043E\u043C \u0432\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u0438 \u0432 \u043A\u043B\u0430\u043D \u0443\u0447\u0438\u0442\u044B\u0432\u0430\u0435\u0442\u0441\u044F \u0441\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430 \u0432 \u0442\u043E\u043C \u0447\u0438\u0441\u043B\u0435 \u0438 \u0434\u043E \u0432\u044B\u0445\u043E\u0434\u0430 \u0438\u0437 \u043D\u0435\u0433\u043E.'
            })
        )
    );
};
AboutIndicatorsClanModesTooltip.id = 'about-indicators-tooltip';

var AboutIndicatorsStatisticsTooltip = exports.AboutIndicatorsStatisticsTooltip = function AboutIndicatorsStatisticsTooltip() {
    return _react2.default.createElement(
        _reactWotBootstrap.Tooltip,
        { id: AboutIndicatorsStatisticsTooltip.id },
        _react2.default.createElement(
            _reactWotBootstrap.TooltipBody,
            null,
            _react2.default.createElement(
                _reactWotBootstrap.TooltipSubtitle,
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'clanmanagement.tooltips.about_indicators_statistics_header',
                    defaultMessage: '\u041E \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u0435\u043B\u044F\u0445'
                })
            ),
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'clanmanagement.tooltips.about_indicators_statistics_body',
                defaultMessage: '\u0423\u0447\u0438\u0442\u044B\u0432\u0430\u044E\u0442\u0441\u044F \u0432\u0441\u0435 \u0431\u043E\u0438, \u043F\u0440\u043E\u0432\u0435\u0434\u0451\u043D\u043D\u044B\u0435 \u0438\u0433\u0440\u043E\u043A\u043E\u043C, \u0432\u043D\u0435 \u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0441\u0442\u0438 \u043E\u0442 \u043D\u0430\u0445\u043E\u0436\u0434\u0435\u043D\u0438\u044F \u0432 \u043A\u043B\u0430\u043D\u0435.'
            })
        )
    );
};
AboutIndicatorsStatisticsTooltip.id = AboutIndicatorsClanModesTooltip.id;

var SelectedMembersTooltip = exports.SelectedMembersTooltip = function SelectedMembersTooltip(_ref) {
    var count = _ref.count,
        total = _ref.total;
    return _react2.default.createElement(
        _reactWotBootstrap.Tooltip,
        { id: SelectedMembersTooltip.id },
        _react2.default.createElement(
            _reactWotBootstrap.TooltipBody,
            null,
            _react2.default.createElement(
                _reactWotBootstrap.TooltipSubtitle,
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'clanmanagement.tooltips.selected_members_header',
                    defaultMessage: '\u0412\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0435 \u0438\u0433\u0440\u043E\u043A\u0438'
                })
            ),
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'clanmanagement.tooltips.selected_members_body',
                defaultMessage: '\u0412\u044B\u0431\u0440\u0430\u043D\u043E \u0438\u0433\u0440\u043E\u043A\u043E\u0432: {count} \u0438\u0437 {total}',
                values: { count: count, total: total }
            })
        )
    );
};
SelectedMembersTooltip.id = 'selected-members-tooltip';
SelectedMembersTooltip.propTypes = {
    count: _propTypes2.default.number.isRequired,
    total: _propTypes2.default.number.isRequired
};

var ClearSelectedMembersTooltip = exports.ClearSelectedMembersTooltip = function ClearSelectedMembersTooltip() {
    return _react2.default.createElement(
        _reactWotBootstrap.Tooltip,
        { id: ClearSelectedMembersTooltip.id },
        _react2.default.createElement(
            _reactWotBootstrap.TooltipBody,
            null,
            _react2.default.createElement(
                _reactWotBootstrap.TooltipSubtitle,
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'clanmanagement.tooltips.clear_selected_members_header',
                    defaultMessage: '\u041E\u0442\u043C\u0435\u043D\u0430 \u0432\u044B\u0431\u043E\u0440\u0430'
                })
            ),
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'clanmanagement.tooltips.clear_selected_members_body',
                defaultMessage: '\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043E\u0442\u043C\u0435\u043D\u0438\u0442\u044C \u0432\u044B\u0431\u043E\u0440 \u0438\u0433\u0440\u043E\u043A\u043E\u0432.'
            })
        )
    );
};
ClearSelectedMembersTooltip.id = 'clear-selected-members-tooltip';

var RoleColumnTooltipContent = exports.RoleColumnTooltipContent = function RoleColumnTooltipContent() {
    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            _reactWotBootstrap.TooltipBody,
            null,
            _react2.default.createElement(
                _reactWotBootstrap.TooltipSubtitle,
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'clanmanagement.tooltips.role_column_header',
                    defaultMessage: '\u0414\u043E\u043B\u0436\u043D\u043E\u0441\u0442\u044C'
                })
            ),
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'clanmanagement.tooltips.role_column_body',
                defaultMessage: '\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043E\u0442\u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0438\u0433\u0440\u043E\u043A\u043E\u0432 \u043F\u043E \u0434\u043E\u043B\u0436\u043D\u043E\u0441\u0442\u0438 \u0432 \u043A\u043B\u0430\u043D\u0435.'
            })
        )
    );
};
RoleColumnTooltipContent.tip = 'role-column-tooltip-tip';

var PlayerColumnTooltipContent = exports.PlayerColumnTooltipContent = function PlayerColumnTooltipContent() {
    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            _reactWotBootstrap.TooltipBody,
            null,
            _react2.default.createElement(
                _reactWotBootstrap.TooltipSubtitle,
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'clanmanagement.tooltips.player_column_header',
                    defaultMessage: '\u0418\u0433\u0440\u043E\u043A'
                })
            ),
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'clanmanagement.tooltips.player_column_body',
                defaultMessage: '\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043E\u0442\u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0438\u0433\u0440\u043E\u043A\u043E\u0432 \u043F\u043E \u0438\u043C\u0435\u043D\u0438.'
            })
        )
    );
};
PlayerColumnTooltipContent.tip = 'player-column-tooltip-tip';

var AttackColumnTooltipContent = exports.AttackColumnTooltipContent = function AttackColumnTooltipContent(level) {
    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            _reactWotBootstrap.TooltipBody,
            null,
            _react2.default.createElement(
                _reactWotBootstrap.TooltipSubtitle,
                null,
                (0, _i18n.SORTIES_WITH_LEVEL)(level)
            ),
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'clanmanagement.tooltips.attacks_column_body',
                defaultMessage: '\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043E\u0442\u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0438\u0433\u0440\u043E\u043A\u043E\u0432 \u043F\u043E \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u0443 \u0431\u043E\u0451\u0432 \u0432 \u0412\u044B\u043B\u0430\u0437\u043A\u0430\u0445 \u0432 {level} \u0434\u0438\u0432\u0438\u0437\u0438\u043E\u043D\u0435.',
                values: { level: level }
            })
        )
    );
};

var Attack6ColumnTooltipContent = exports.Attack6ColumnTooltipContent = function Attack6ColumnTooltipContent() {
    return AttackColumnTooltipContent((0, _helpers.toRoman)(6));
};
Attack6ColumnTooltipContent.tip = 'attack-6-column-tooltip-tip';
var Attack8ColumnTooltipContent = exports.Attack8ColumnTooltipContent = function Attack8ColumnTooltipContent() {
    return AttackColumnTooltipContent((0, _helpers.toRoman)(8));
};
Attack8ColumnTooltipContent.tip = 'attack-8-column-tooltip-tip';
var Attack10ColumnTooltipContent = exports.Attack10ColumnTooltipContent = function Attack10ColumnTooltipContent() {
    return AttackColumnTooltipContent((0, _helpers.toRoman)(10));
};
Attack10ColumnTooltipContent.tip = 'attack-10-column-tooltip-tip';
var Attack11ColumnTooltipContent = exports.Attack11ColumnTooltipContent = function Attack11ColumnTooltipContent() {
    return AttackColumnTooltipContent((0, _helpers.toRoman)(11));
};
Attack11ColumnTooltipContent.tip = 'attack-11-column-tooltip-tip';

var FortBattlesColumnTooltipContent = exports.FortBattlesColumnTooltipContent = function FortBattlesColumnTooltipContent() {
    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            _reactWotBootstrap.TooltipBody,
            null,
            _react2.default.createElement(
                _reactWotBootstrap.TooltipSubtitle,
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'clanmanagement.tooltips.fort_battles_column_header',
                    defaultMessage: '\u0411\u043E\u0438 \u0432 \u041D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u044F\u0445'
                })
            ),
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'clanmanagement.tooltips.fort_battles_column_body',
                defaultMessage: '\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043E\u0442\u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0438\u0433\u0440\u043E\u043A\u043E\u0432 \u043F\u043E \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u0443 \u0431\u043E\u0451\u0432 \u0432 \u041D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u044F\u0445.'
            })
        )
    );
};
FortBattlesColumnTooltipContent.tip = 'fort-battles-column-tooltip-tip';

var ResourceColumnTooltipContent = exports.ResourceColumnTooltipContent = function ResourceColumnTooltipContent() {
    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            _reactWotBootstrap.TooltipBody,
            null,
            _react2.default.createElement(
                _reactWotBootstrap.TooltipSubtitle,
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'clanmanagement.tooltips.resource_column_header',
                    defaultMessage: '\u041F\u0440\u043E\u043C\u0440\u0435\u0441\u0443\u0440\u0441'
                })
            ),
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'clanmanagement.tooltips.resource_column_body',
                defaultMessage: '\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043E\u0442\u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0438\u0433\u0440\u043E\u043A\u043E\u0432 \u043F\u043E \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u0443 \u043F\u0440\u043E\u043C\u0440\u0435\u0441\u0443\u0440\u0441\u0430, \u0437\u0430\u0440\u0430\u0431\u043E\u0442\u0430\u043D\u043D\u043E\u0433\u043E \u0437\u0430 \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0439 \u043F\u0435\u0440\u0438\u043E\u0434.'
            })
        )
    );
};
ResourceColumnTooltipContent.tip = 'resource-column-tooltip-tip';

var PlayerStatusColumnTooltipContent = exports.PlayerStatusColumnTooltipContent = function PlayerStatusColumnTooltipContent() {
    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            _reactWotBootstrap.TooltipBody,
            null,
            _react2.default.createElement(
                _reactWotBootstrap.TooltipSubtitle,
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'clanmanagement.tooltips.player_status_column_header',
                    defaultMessage: '\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u0435\u0435 \u0432\u0440\u0435\u043C\u044F \u0438\u0433\u0440\u044B'
                })
            ),
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'clanmanagement.tooltips.player_status_column_body',
                defaultMessage: '\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043E\u0442\u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0438\u0433\u0440\u043E\u043A\u043E\u0432 \u043F\u043E \u0432\u0440\u0435\u043C\u0435\u043D\u0438, \u043A\u043E\u0442\u043E\u0440\u043E\u0435 \u043F\u0440\u043E\u0448\u043B\u043E \u0441 \u043C\u043E\u043C\u0435\u043D\u0442\u0430 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0435\u0433\u043E \u0432\u044B\u0445\u043E\u0434\u0430 \u0438\u0437 \u0438\u0433\u0440\u044B.'
            })
        )
    );
};
PlayerStatusColumnTooltipContent.tip = 'player-status-column-tooltip-tip';

var NotPlayedInClanModesTooltip = exports.NotPlayedInClanModesTooltip = function NotPlayedInClanModesTooltip() {
    return _react2.default.createElement(
        _reactWotBootstrap.Tooltip,
        { id: NotPlayedInClanModesTooltip.id },
        _react2.default.createElement(
            _reactWotBootstrap.TooltipBody,
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'clanmanagement.tooltip.not_played_in_clan_modes.body',
                defaultMessage: '\u0418\u0433\u0440\u043E\u043A \u043D\u0435 \u0443\u0447\u0430\u0441\u0442\u0432\u043E\u0432\u0430\u043B \u0432 \u0431\u043E\u044F\u0445 \u0432 \u0441\u043E\u0441\u0442\u0430\u0432\u0435 \u043A\u043B\u0430\u043D\u0430'
            })
        )
    );
};
NotPlayedInClanModesTooltip.id = 'clanmanagement.tooltip.not_played_in_clan_modes';

var NotLoggedInEverTooltip = exports.NotLoggedInEverTooltip = function NotLoggedInEverTooltip() {
    return _react2.default.createElement(
        _reactWotBootstrap.Tooltip,
        { id: NotLoggedInEverTooltip.id },
        _react2.default.createElement(
            _reactWotBootstrap.TooltipBody,
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'clanmanagement.tooltips.not_logged_ever_body',
                defaultMessage: '\u0415\u0449\u0451 \u043D\u0435 \u0437\u0430\u0445\u043E\u0434\u0438\u043B \u0432 \u0438\u0433\u0440\u0443'
            })
        )
    );
};
NotLoggedInEverTooltip.id = 'clanmanagement.tooltip.not_logged_ever_body';

var NameTooltipContent = exports.NameTooltipContent = function NameTooltipContent(_ref2) {
    var name = _ref2.name;
    return _react2.default.createElement(
        _reactWotBootstrap.TooltipBody,
        null,
        name
    );
};
NameTooltipContent.propTypes = {
    name: _propTypes2.default.string.isRequired
};

var RoleTooltipContent = exports.RoleTooltipContent = function RoleTooltipContent(_ref3) {
    var role = _ref3.role;
    return _react2.default.createElement(
        _reactWotBootstrap.TooltipBody,
        null,
        _i18n.USER_ROLES[role]
    );
};
RoleTooltipContent.propTypes = {
    role: _propTypes2.default.string.isRequired
};

var BattlesInClanTooltipContent = exports.BattlesInClanTooltipContent = function BattlesInClanTooltipContent(_ref4) {
    var battles = _ref4.battles,
        winrate = _ref4.winrate;
    return _react2.default.createElement(
        _reactWotBootstrap.TooltipBody,
        null,
        _react2.default.createElement(
            _reactWotBootstrap.TooltipSubtitle,
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'clanmanagement.tooltips.battles_in_clan_header',
                defaultMessage: '\u0411\u043E\u0438 \u0432 \u0441\u043E\u0441\u0442\u0430\u0432\u0435 \u043A\u043B\u0430\u043D\u0430'
            })
        ),
        _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'clanmanagement.tooltips.battles_in_clan_body1',
                defaultMessage: '\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0431\u043E\u0451\u0432: {battles}',
                values: { battles: _react2.default.createElement(
                        'span',
                        { className: 'tooltip-important-lbl' },
                        battles
                    ) }
            })
        ),
        _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'clanmanagement.tooltips.battles_in_clan_body2',
                defaultMessage: '\u041F\u043E\u0431\u0435\u0434\u044B: {winrate}',
                values: { winrate: _react2.default.createElement(
                        'span',
                        { className: 'tooltip-important-lbl' },
                        winrate
                    ) }
            })
        )
    );
};

var LeavingClanTooltip = exports.LeavingClanTooltip = function LeavingClanTooltip() {
    return _react2.default.createElement(
        _reactWotBootstrap.Tooltip,
        { id: LeavingClanTooltip.id },
        _react2.default.createElement(
            _reactWotBootstrap.TooltipBody,
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'clanmanagement.tooltips.leaving_the_clan_tooltip\'',
                defaultMessage: '\u041F\u043E\u043A\u0438\u043D\u0443\u0442\u044C \u043A\u043B\u0430\u043D'
            })
        )
    );
};
LeavingClanTooltip.id = 'leaving-the-clan-tooltip';

BattlesInClanTooltipContent.propTypes = {
    battles: _propTypes2.default.string.isRequired,
    winrate: _propTypes2.default.string.isRequired
};

/***/ }),
/* 145 */,
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _constants = __webpack_require__(229);

var _i18n = __webpack_require__(10);

var _reactWotBootstrap = __webpack_require__(5);

var _ArenaTooltip = __webpack_require__(230);

var _ArenaTooltip2 = _interopRequireDefault(_ArenaTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArenaTooltip = function ArenaTooltip(props) {

    var title = null;
    if (props.direction) {
        title = _react2.default.createElement(
            'h3',
            { className: _ArenaTooltip2.default.title },
            _constants.ARENA_TOOLTIP_TITLE[props.point]
        );
    } else if (props.withTitle) {
        title = _react2.default.createElement(
            'h3',
            { className: _ArenaTooltip2.default.title },
            props.arena.name
        );
    }

    var description = null;
    if (props.direction) {
        description = _react2.default.createElement(
            'p',
            { className: _ArenaTooltip2.default.details },
            _react2.default.createElement(
                'span',
                { className: _ArenaTooltip2.default.caption },
                (0, _constants.ARENA_TOOLTIP_DIRECTION)(_i18n.NAME_BY_DIRECTION[props.direction])
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement(
                'span',
                { className: _ArenaTooltip2.default.caption },
                (0, _constants.ARENA_TOOLTIP_BATTLE_MAP)(props.arena.name)
            )
        );
    } else if (props.children) {
        description = _react2.default.createElement(
            'div',
            { className: _ArenaTooltip2.default.content },
            props.children
        );
    }

    var content = void 0;
    if (props.arena.available_in_game) {
        var arenaImage = { backgroundImage: 'url(\'' + props.arena.image_url + '\')' };

        var emblems = void 0;
        if (props.emblems && props.arena.bases) {
            if (props.emblems.length !== props.arena.bases.length || !props.arena.bases) {
                // eslint-disable-next-line no-console
                console.error('<ArenaTooltip> validation error: emblems number does not match bases coordinates,' + 'emblems will not be rendered');
            } else {
                emblems = props.emblems.map(function (emblem, index) {
                    var emblemPosition = props.arena.bases[index];
                    if (!emblemPosition) return;

                    var emblemStyle = {
                        left: emblemPosition[0] + '%',
                        top: emblemPosition[1] + '%'
                    };

                    return _react2.default.createElement(
                        'div',
                        { key: index, className: _ArenaTooltip2.default.minimapEmblem, style: emblemStyle },
                        emblem
                    );
                });
            }
        }
        content = _react2.default.createElement(
            'div',
            { className: _ArenaTooltip2.default.minimap, style: arenaImage },
            emblems
        );
    } else {
        if (title) {
            content = _react2.default.createElement(
                _reactWotBootstrap.TooltipFooter,
                null,
                _constants.ARENA_EXCLUDED
            );
        } else {
            content = _constants.ARENA_EXCLUDED;
        }
    }

    return _react2.default.createElement(
        _reactWotBootstrap.Tooltip,
        { id: props.tooltipId },
        title,
        description,
        content
    );
};

ArenaTooltip.propTypes = {
    tooltipId: _propTypes2.default.string.isRequired,
    point: _propTypes2.default.number,
    direction: _propTypes2.default.string,
    withTitle: _propTypes2.default.bool,
    arena: _propTypes2.default.shape({
        id: _propTypes2.default.string.isRequired,
        name: _propTypes2.default.string.isRequired,
        available_in_game: _propTypes2.default.bool,
        bases: _propTypes2.default.arrayOf(_propTypes2.default.arrayOf(_propTypes2.default.number)),
        image_url: _propTypes2.default.string
    }).isRequired,

    emblems: _propTypes2.default.arrayOf(_propTypes2.default.element)
};

exports.default = ArenaTooltip;

/***/ }),
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.checkIndustrialResource = checkIndustrialResource;
exports.checkUpgradeVisibility = checkUpgradeVisibility;
exports.upgradeAvailability = upgradeAvailability;

var _constants = __webpack_require__(4);

var _accounts = __webpack_require__(33);

function checkIndustrialResource(state, _ref) {
    var type = _ref.type,
        level = _ref.level;

    var upgradeCost = state.settings.buildings[type].costs[level];
    var industrialResourceBalance = state.clan.industrial_resource;
    return industrialResourceBalance >= upgradeCost;
}

function checkUpgradeVisibility(state, _ref2) {
    var level = _ref2.level;

    var hasPermission = (0, _accounts.canManageBuilding)(state.account);
    var maxLevelReached = level === _constants.MAX_BUILDING_LEVEL;
    return hasPermission && !maxLevelReached;
}

function upgradeAvailability(state, _ref3) {
    var type = _ref3.type,
        level = _ref3.level;

    var nextLevelIsValid = level + 1 <= state.stronghold.level;
    var hasEnougthIndustrialResource = checkIndustrialResource(state, { type: type, level: level });
    var showUpgrade = checkUpgradeVisibility(state, { level: level });
    return nextLevelIsValid && hasEnougthIndustrialResource && showUpgrade;
}

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SCHEDULE_HAS_CHANGES = exports.SCHEDULE_TOOLTIP = exports.SCHEDULE_TITLE = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SCHEDULE_TITLE = exports.SCHEDULE_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'schedule.title',
    defaultMessage: '\u0420\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u0441\u0440\u0430\u0436\u043D\u0435\u043D\u0438\u0439'
});

var SCHEDULE_TOOLTIP = exports.SCHEDULE_TOOLTIP = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'schedule.tooltip',
    defaultMessage: '\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043F\u0435\u0440\u0435\u0439\u0442\u0438 \u043A \u0440\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u044E \u0441\u0440\u0430\u0436\u0435\u043D\u0438\u0439 \u0432 \u0423\u043A\u0440\u0435\u043F\u0440\u0430\u0439\u043E\u043D\u0435.'
});

var SCHEDULE_HAS_CHANGES = exports.SCHEDULE_HAS_CHANGES = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'schedule.has_changes',
    defaultMessage: '\u0415\u0441\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u0432 \u0440\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u0438.'
});

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.IndustrialResourceCoefTooltip = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _DefaultTooltip = __webpack_require__(30);

var _DefaultTooltip2 = _interopRequireDefault(_DefaultTooltip);

var _constants = __webpack_require__(293);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IndustrialResourceCoefTooltip = exports.IndustrialResourceCoefTooltip = function IndustrialResourceCoefTooltip(_ref) {
    var multiplier = _ref.multiplier;

    return _react2.default.createElement(_DefaultTooltip2.default, {
        id: IndustrialResourceCoefTooltip.id,
        message: (0, _constants.INDUSTRIAL_RESOURCE_MULTIPLIER_TOOLTIP_TEXT)(multiplier)
    });
};

IndustrialResourceCoefTooltip.id = 'industrial_resource_multiplier_tooltip';

IndustrialResourceCoefTooltip.propTypes = {
    multiplier: _propTypes2.default.number.isRequired
};

exports.default = IndustrialResourceCoefTooltip;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useFlowLogTimeSpent = exports.useFlowLogOnce = exports.useFlowLog = exports.useMetricsLogTimeSpent = exports.useMetricsLogOnce = exports.useMetricsLog = exports.useTooltipLogger = exports.FLOW_GROUP = exports.METRICS_GROUP = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(0);

var _helpers = __webpack_require__(1354);

var _constants = __webpack_require__(2244);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var PROPERTIES_LIMIT = 200;
var MILLISECONDS = 1000;

var METRICS_GROUP = exports.METRICS_GROUP = 'metrics';
var FLOW_GROUP = exports.FLOW_GROUP = 'flow';

var getDate = function getDate() {
    return Date.now();
};

var addTimeSpent = function addTimeSpent(params, timeSpent) {
    if (params === undefined) {
        params = {};
    }
    params['timeSpent'] = timeSpent;
    return params;
};

var convertMetricsParams = function convertMetricsParams(_ref) {
    var partnerID = _ref.partnerID,
        item = _ref.item,
        parentScreen = _ref.parentScreen,
        itemState = _ref.itemState,
        info = _ref.info;

    return {
        item: item,
        partnerID: partnerID ? partnerID : null,
        parent_screen: parentScreen ? parentScreen : null,
        item_state: itemState ? itemState : null,
        additional_info: info ? info : null
    };
};

var convertFlowParams = function convertFlowParams(_ref2) {
    var sourceItem = _ref2.sourceItem,
        destinationItem = _ref2.destinationItem,
        transitionMethod = _ref2.transitionMethod,
        partnerID = _ref2.partnerID;

    return {
        partnerID: partnerID ? partnerID : null,
        source_item: sourceItem ? sourceItem : null,
        destination_item: destinationItem ? destinationItem : null,
        transition_method: transitionMethod ? transitionMethod : null
    };
};

/*
    NOTE!
    DO NOT USE base hooks directly (_useLog, ...).
    Use Metrics or Flow hooks instead.
*/
var _useLog = function _useLog(feature, group) {
    var log = (0, _react.useCallback)(function (action) {
        var logLevel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.LogLevel.Info;
        var params = arguments[2];

        if (!params) {
            params = {};
        }
        if (Object.keys(params).length >= PROPERTIES_LIMIT) {
            return;
        }

        (0, _helpers.sendLogs)(feature, group, action, logLevel, params);
    }, [feature, group]);

    return function (action, logLevel, params) {
        return log(action, logLevel, params);
    };
};

var _useLogOnce = function _useLogOnce(feature, group) {
    var logger = _useLog(feature, group);
    var actions = (0, _react.useRef)([]);

    var logOnce = (0, _react.useCallback)(function (action, logLevel, params) {
        if (!action || actions.current.includes(action)) {
            return;
        } else {
            actions.current.push(action);
        }

        logger(action, logLevel, params);
    }, [actions, logger]);

    var reset = function reset() {
        actions.current = [];
    };

    return [function (action, logLevel, params) {
        return logOnce(action, logLevel, params);
    }, function () {
        return reset();
    }];
};

var _useLogTimeSpent = function _useLogTimeSpent(feature, group) {
    var logger = _useLog(feature, group);
    var actions = (0, _react.useRef)(new Map());
    var suspendedActions = (0, _react.useRef)(new Map());

    var start = (0, _react.useCallback)(function (action) {
        if (!action) {
            return;
        }
        var key = actions.current.get(action);
        if (key !== undefined && key > 0) {
            return;
        } else {
            actions.current.set(action, getDate());
        }
    }, [actions]);

    var reset = (0, _react.useCallback)(function () {
        actions.current.clear();
        suspendedActions.current.clear();
    }, [actions, suspendedActions]);

    var suspend = (0, _react.useCallback)(function (action) {
        if (!action) {
            return;
        }
        if (actions.current.get(action) === undefined || suspendedActions.current.get(action) !== undefined) {
            return;
        }

        suspendedActions.current.set(action, getDate());
    }, [actions, suspendedActions]);

    var resume = (0, _react.useCallback)(function (action) {
        if (!action) {
            return;
        }
        var prevActionTime = actions.current.get(action);
        if (prevActionTime === undefined) {
            return;
        }

        var prevSusTime = suspendedActions.current.get(action);
        if (prevSusTime === undefined) {
            return;
        }

        suspendedActions.current.delete(action);

        var suspensionTime = getDate() - prevSusTime;
        actions.current.set(action, prevActionTime + suspensionTime);
    }, [actions, suspendedActions]);

    var stop = (0, _react.useCallback)(function (action) {
        var timeLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var logLevel = arguments[2];
        var params = arguments[3];

        var prevDate = actions.current.get(action);
        if (prevDate === undefined) {
            return;
        }

        var prevSusTime = suspendedActions.current.get(action);
        if (prevSusTime !== undefined) {
            resume(action);
        }

        actions.current.delete(action);

        var timeSpent = (getDate() - prevDate) / MILLISECONDS;
        if (timeSpent <= timeLimit) {
            return;
        }
        params = addTimeSpent(params, timeSpent);

        logger(action, logLevel, params);
    }, [actions, suspendedActions, logger, resume]);

    return [function (action) {
        return start(action);
    }, function (action, timeLimit, logLevel, params) {
        return stop(action, timeLimit, logLevel, params);
    }, function () {
        return reset();
    }, function (action) {
        return suspend(action);
    }, function (action) {
        return resume(action);
    }];
};

/*
    Use Metrics logger to log some user action(button click, etc).
    More info about log args: https://confluence.wargaming.net/x/dPWyZw

    const log = useMetricsLog(feature);
*/
var useMetricsLog = function useMetricsLog(feature) {
    var logger = _useLog(feature, METRICS_GROUP);

    var log = (0, _react.useCallback)(function (params) {
        logger(params.action, params.logLevel, convertMetricsParams(params));
    }, [logger]);
    return function (params) {
        return log(params);
    };
};

/*
    const [log, reset] = useMetricsLogOnce(feature);
*/
var useMetricsLogOnce = function useMetricsLogOnce(feature) {
    var _useLogOnce2 = _useLogOnce(feature, METRICS_GROUP),
        _useLogOnce3 = _slicedToArray(_useLogOnce2, 2),
        logOnce = _useLogOnce3[0],
        reset = _useLogOnce3[1];

    var logMetricsOnce = (0, _react.useCallback)(function (params) {
        var action = params.action,
            logLevel = params.logLevel;

        logOnce(action, logLevel, convertMetricsParams(params));
    }, [logOnce]);

    return [function (params) {
        return logMetricsOnce(params);
    }, function () {
        return reset();
    }];
};

/*
    const [start, stop, reset, suspend, resume] = useMetricsLogTimeSpent(feature);
*/
var useMetricsLogTimeSpent = function useMetricsLogTimeSpent(feature) {
    var _useLogTimeSpent2 = _useLogTimeSpent(feature, METRICS_GROUP),
        _useLogTimeSpent3 = _slicedToArray(_useLogTimeSpent2, 5),
        start = _useLogTimeSpent3[0],
        stop = _useLogTimeSpent3[1],
        reset = _useLogTimeSpent3[2],
        suspend = _useLogTimeSpent3[3],
        resume = _useLogTimeSpent3[4];

    var metricsStop = (0, _react.useCallback)(function (params) {
        var action = params.action,
            timeLimit = params.timeLimit,
            logLevel = params.logLevel;

        stop(action, timeLimit, logLevel, convertMetricsParams(params));
    }, [stop]);

    return [function (action) {
        return start(action);
    }, function (params) {
        return metricsStop(params);
    }, function () {
        return reset();
    }, function (action) {
        return suspend(action);
    }, function (action) {
        return resume(action);
    }];
};

/*
    Use Flow logger to log transactions between views.
    More info about log args: https://confluence.wargaming.net/x/dPWyZw

    const log = useFlowLog(feature);
*/
var useFlowLog = function useFlowLog(feature) {
    var logger = _useLog(feature, FLOW_GROUP);

    var log = (0, _react.useCallback)(function (params) {
        logger(params.action, params.logLevel, convertFlowParams(params));
    }, [logger]);

    return function (params) {
        return log(params);
    };
};

/*
    const [log, reset] = useFlowLogOnce(feature);
*/
var useFlowLogOnce = function useFlowLogOnce(feature) {
    var _useLogOnce4 = _useLogOnce(feature, FLOW_GROUP),
        _useLogOnce5 = _slicedToArray(_useLogOnce4, 2),
        logOnce = _useLogOnce5[0],
        reset = _useLogOnce5[1];

    var logMetricsOnce = (0, _react.useCallback)(function (params) {
        var action = params.action,
            logLevel = params.logLevel;

        logOnce(action, logLevel, convertFlowParams(params));
    }, [logOnce]);

    return [function (params) {
        return logMetricsOnce(params);
    }, function () {
        return reset();
    }];
};

/*
    const [start, stop, reset, suspend, resume] = useFlowLogTimeSpent(feature);
*/
var useFlowLogTimeSpent = function useFlowLogTimeSpent(feature) {
    var _useLogTimeSpent4 = _useLogTimeSpent(feature, FLOW_GROUP),
        _useLogTimeSpent5 = _slicedToArray(_useLogTimeSpent4, 5),
        start = _useLogTimeSpent5[0],
        stop = _useLogTimeSpent5[1],
        reset = _useLogTimeSpent5[2],
        suspend = _useLogTimeSpent5[3],
        resume = _useLogTimeSpent5[4];

    var flowStop = (0, _react.useCallback)(function (params) {
        var action = params.action,
            timeLimit = params.timeLimit,
            logLevel = params.logLevel;

        stop(action, timeLimit, logLevel, convertFlowParams(params));
    }, [stop]);

    return [function (action) {
        return start(action);
    }, function (params) {
        return flowStop(params);
    }, function () {
        return reset();
    }, function (action) {
        return suspend(action);
    }, function (action) {
        return resume(action);
    }];
};

/*
    Used to log 'tooltip watched' action
        const checkBoxTooltipLogger = useTooltipLogger(FEATURE, {
            item: Items.AbilitiesCheckboxTooltip,
            parentScreen: ParentScreen.SetupView,
        });
        ...
        <SimpleTooltip
            {...checkBoxTooltipLogger}
        >
*/
var useTooltipLogger = function useTooltipLogger(feature, params) {
    var _useMetricsLogTimeSpe = useMetricsLogTimeSpent(feature),
        _useMetricsLogTimeSpe2 = _slicedToArray(_useMetricsLogTimeSpe, 2),
        start = _useMetricsLogTimeSpe2[0],
        stop = _useMetricsLogTimeSpe2[1];

    var action = params.action,
        timeLimit = params.timeLimit,
        tooltipParams = _objectWithoutProperties(params, ['action', 'timeLimit']);

    return (0, _react.useMemo)(function () {
        return {
            onShow: function onShow() {
                return start(action ? action : _constants.TOOLTIP_ACTION);
            },
            onHide: function onHide() {
                return stop(_extends({
                    action: action ? action : _constants.TOOLTIP_ACTION,
                    timeLimit: timeLimit ? timeLimit : _constants.TOOLTIP_TIME_LIMIT
                }, tooltipParams));
            }
        };
    }, [action, timeLimit, tooltipParams, start, stop]);
};

exports.useTooltipLogger = useTooltipLogger;
exports.useMetricsLog = useMetricsLog;
exports.useMetricsLogOnce = useMetricsLogOnce;
exports.useMetricsLogTimeSpent = useMetricsLogTimeSpent;
exports.useFlowLog = useFlowLog;
exports.useFlowLogOnce = useFlowLogOnce;
exports.useFlowLogTimeSpent = useFlowLogTimeSpent;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var FEATURE = exports.FEATURE = 'clan_landing';

var Actions = exports.Actions = {
    Open: 'open',
    Close: 'close',
    Click: 'click',
    Preview: 'preview',
    Hover: 'hover',
    TooltipWatched: 'tooltip_watched'
};

var Items = exports.Items = {
    Hangar: 'hangar',
    LandingPromo: 'landing_promo_window',
    LandingBonus: 'landing_bonus_window',
    LandingToursOfDuty: 'landing_tours_of_duty_window',
    LandingStronghold: 'landing_stronghold_window',
    LandingGlobalMap: 'landing_globalmap_window',
    LandingClans: 'landing_clans_window',
    LandingPromoStyleTooltip: 'landing_promo_style_tooltip',
    GlobalMapEventButton: 'global_map_event_button',
    LegionnaireBattleButton: 'legionnaire_battle_button',
    ClanInvitationsButton: 'clan_invitations_button',
    CreateClanButton: 'create_clan_button',
    FocusSearchTextField: 'focus_search_text_field',
    ClearSearchTextField: 'clear_search_text_field',
    SubmitSearchTextField: 'submit_search_text_field',
    FiltersSettingsWindow: 'filters_settings_window',
    ClanInfoCard: 'clan_info_card',
    PaginationLeftButton: 'pagination_left_button',
    PaginationRightButton: 'pagination_right_button',
    JoinClanButton: 'join_clan_button',
    SaveButton: 'save_button'
};

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ANNOUNCEMENT_CONFIRMATION_BUTTON_CANCEL = exports.ANNOUNCEMENT_CONFIRMATION_BUTTON_APPLY_DELETE = exports.ANNOUNCEMENT_CONFIRMATION_BUTTON_APPLY_ARCHIVE = exports.ANNOUNCEMENT_CONFIRMATION_DESCRIPTION_DELETE = exports.ANNOUNCEMENT_CONFIRMATION_TITLE_DELETE = exports.ANNOUNCEMENT_CONFIRMATION_DESCRIPTION_ARCHIVE = exports.ANNOUNCEMENT_CONFIRMATION_TITLE_ARCHIVE = exports.ANNOUNCEMENT_EDIT_PRIVACY_LINK = exports.ANNOUNCEMENT_EDIT_PRIVACY_CAPTION = exports.ANNOUNCEMENT_EDIT_INFO_TOOLTIP = exports.ANNOUNCEMENT_EDIT_INFO = exports.ANNOUNCEMENT_EDIT_GROUP_TYPE_ITEMS_TOOLTIP = exports.ANNOUNCEMENT_EDIT_GROUP_TYPE_ITEMS = exports.ANNOUNCEMENT_EDIT_GROUP_TYPE_TOOLTIP = exports.ANNOUNCEMENT_EDIT_GROUP_TYPE_CAPTION = exports.ANNOUNCEMENT_EDIT_TEXTAREA_HINT_BOLD_EXAMPLE = exports.ANNOUNCEMENT_EDIT_TEXTAREA_HINT_BOLD_BODY_TOOLTIP = exports.ANNOUNCEMENT_EDIT_TEXTAREA_HINT_BOLD_TITLE_TOOLTIP = exports.ANNOUNCEMENT_EDIT_TEXTAREA_HINT_BOLD = exports.ANNOUNCEMENT_EDIT_TEXTAREA_HINT_CHARS = exports.ANNOUNCEMENT_EDIT_BUTTON_CANCEL = exports.ANNOUNCEMENT_EDIT_BUTTON_SAVE_TOOLTIP_FORBIDDEN = exports.ANNOUNCEMENT_EDIT_BUTTON_SAVE_TOOLTIP_LIMIT = exports.ANNOUNCEMENT_EDIT_BUTTON_SAVE = exports.ANNOUNCEMENT_CREATE_BUTTON_SAVE = exports.ANNOUNCEMENT_VIEW_BUTTON_CREATE_DISABLED_TOOLTIP = exports.ANNOUNCEMENT_VIEW_BUTTON_CREATE_TOOLTIP = exports.ANNOUNCEMENT_VIEW_BUTTON_CREATE = exports.ANNOUNCEMENT_VIEW_BUTTON_DELETE_TOOLTIP = exports.ANNOUNCEMENT_VIEW_BUTTON_DELETE = exports.ANNOUNCEMENT_VIEW_BUTTON_ARCHIVE_TOOLTIP = exports.ANNOUNCEMENT_VIEW_BUTTON_ARCHIVE = exports.ANNOUNCEMENT_VIEW_BUTTON_EDIT_TOOLTIP = exports.ANNOUNCEMENT_VIEW_BUTTON_EDIT = exports.ANNOUNCEMENT_EDIT_TITLE = exports.ANNOUNCEMENT_CREATE_TITLE = exports.ANNOUNCEMENT_VIEW_TITLE = exports.OUT_OF_CLAN = exports.LOCKED_ANNOUNCEMENT_TOOLTIP = exports.EXTERNAL_URL_ICON_TOOLTIP = exports.CREATE_NEW_ANNOUNCEMENT_ICON_TOOLTIP = exports.CREATE_NEW_ANNOUNCEMENT_BUTTON_TOOLTIP = exports.CREATE_NEW_ANNOUNCEMENT_BUTTON = exports.CREATE_NEW_ANNOUNCEMENT_TEXT = undefined;

var _ANNOUNCEMENT_EDIT_GR, _ANNOUNCEMENT_EDIT_GR2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _constants = __webpack_require__(43);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint-disable react/no-multi-comp */
/* eslint-disable max-len */


var CREATE_NEW_ANNOUNCEMENT_TEXT = exports.CREATE_NEW_ANNOUNCEMENT_TEXT = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'announcements.card.new.text',
    defaultMessage: '\u0412\u044B \u0438 \u0434\u0440\u0443\u0433\u0438\u0435 \u0443\u043F\u043E\u043B\u043D\u043E\u043C\u043E\u0447\u0435\u043D\u043D\u044B\u0435 \u0441\u043E\u043A\u043B\u0430\u043D\u043E\u0432\u0446\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0440\u0430\u0437\u043C\u0435\u0441\u0442\u0438\u0442\u044C \u0437\u0434\u0435\u0441\u044C \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044F \u0434\u043B\u044F \u0432\u0441\u0435\u0433\u043E \u043A\u043B\u0430\u043D\u0430.'
});

var CREATE_NEW_ANNOUNCEMENT_BUTTON = exports.CREATE_NEW_ANNOUNCEMENT_BUTTON = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'announcements.card.new.button',
    defaultMessage: '\u0420\u0430\u0437\u043C\u0435\u0441\u0442\u0438\u0442\u044C \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0435'
});

var CREATE_NEW_ANNOUNCEMENT_BUTTON_TOOLTIP = exports.CREATE_NEW_ANNOUNCEMENT_BUTTON_TOOLTIP = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'announcements.card.new.button.tooltip',
    defaultMessage: '\u0420\u0430\u0437\u043C\u0435\u0441\u0442\u0438\u0442\u044C \u043D\u043E\u0432\u043E\u0435 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0435'
});

var CREATE_NEW_ANNOUNCEMENT_ICON_TOOLTIP = exports.CREATE_NEW_ANNOUNCEMENT_ICON_TOOLTIP = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'announcements.card.new.icon_tooltip',
    defaultMessage: '\u0420\u0430\u0437\u043C\u0435\u0441\u0442\u0438\u0442\u044C \u043D\u043E\u0432\u043E\u0435 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0435'
});

var EXTERNAL_URL_ICON_TOOLTIP = exports.EXTERNAL_URL_ICON_TOOLTIP = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'announcements.card.news.icon_tooltip',
    defaultMessage: '\u0421\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u043D\u043E\u0432\u043E\u0441\u0442\u044C \u043D\u0430 \u0442\u0430\u043D\u043A\u043E\u0432\u043E\u043C \u043F\u043E\u0440\u0442\u0430\u043B\u0435.'
});

var LOCKED_ANNOUNCEMENT_TOOLTIP = exports.LOCKED_ANNOUNCEMENT_TOOLTIP = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'announcements.copyright.lock_icon_tooltip',
    defaultMessage: '\u041E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0435 \u0432\u0438\u0434\u044F\u0442 \u041A\u043E\u043C\u0430\u043D\u0434\u0443\u044E\u0449\u0438\u0439, \u0417\u0430\u043C\u0435\u0441\u0442\u0438\u0442\u0435\u043B\u044C \u043A\u043E\u043C\u0430\u043D\u0434\u0443\u044E\u0449\u0435\u0433\u043E, \u041E\u0444\u0438\u0446\u0435\u0440 \u0448\u0442\u0430\u0431\u0430 \u0438 \u041A\u043E\u043C\u0430\u043D\u0434\u0438\u0440 \u043F\u043E\u0434\u0440\u0430\u0437\u0434\u0435\u043B\u0435\u043D\u0438\u044F.'
});

var OUT_OF_CLAN = exports.OUT_OF_CLAN = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'announcements.copyright.out_of_clan',
    defaultMessage: '\u0418\u0433\u0440\u043E\u043A \u043F\u043E\u043A\u0438\u043D\u0443\u043B \u043A\u043B\u0430\u043D'
});

var ANNOUNCEMENT_VIEW_TITLE = exports.ANNOUNCEMENT_VIEW_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'announcements.view.title',
    defaultMessage: '\u041E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0435 \u043A\u043E\u043C\u0430\u043D\u0434\u043E\u0432\u0430\u043D\u0438\u044F'
});

var ANNOUNCEMENT_CREATE_TITLE = exports.ANNOUNCEMENT_CREATE_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'announcements.view.title.create',
    defaultMessage: '\u041D\u043E\u0432\u043E\u0435 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0435'
});

var ANNOUNCEMENT_EDIT_TITLE = exports.ANNOUNCEMENT_EDIT_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'announcements.view.title.edit',
    defaultMessage: '\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044F'
});

var ANNOUNCEMENT_VIEW_BUTTON_EDIT = exports.ANNOUNCEMENT_VIEW_BUTTON_EDIT = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'announcements.view.button.edit',
    defaultMessage: '\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C'
});

var ANNOUNCEMENT_VIEW_BUTTON_EDIT_TOOLTIP = exports.ANNOUNCEMENT_VIEW_BUTTON_EDIT_TOOLTIP = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'announcements.view.button.edit.tooltip',
    defaultMessage: '\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043A \u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044E \u044D\u0442\u043E\u0433\u043E \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044F.'
});

var ANNOUNCEMENT_VIEW_BUTTON_ARCHIVE = exports.ANNOUNCEMENT_VIEW_BUTTON_ARCHIVE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'announcements.view.button.archive',
    defaultMessage: '\u041F\u0435\u0440\u0435\u043C\u0435\u0441\u0442\u0438\u0442\u044C \u0432 \u0430\u0440\u0445\u0438\u0432'
});

var ANNOUNCEMENT_VIEW_BUTTON_ARCHIVE_TOOLTIP = exports.ANNOUNCEMENT_VIEW_BUTTON_ARCHIVE_TOOLTIP = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'announcements.view.button.archive.tooltip',
    defaultMessage: '\u041F\u043E\u0441\u043B\u0435 \u043F\u0435\u0440\u0435\u043C\u0435\u0449\u0435\u043D\u0438\u044F \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044F \u0432 \u0430\u0440\u0445\u0438\u0432, \u0432\u044B \u0441\u043C\u043E\u0436\u0435\u0442\u0435 \u0432\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u0435\u0433\u043E \u043D\u0430 \u043A\u043B\u0430\u043D\u043E\u0432\u043E\u043C \u043F\u043E\u0440\u0442\u0430\u043B\u0435.'
});

var ANNOUNCEMENT_VIEW_BUTTON_DELETE = exports.ANNOUNCEMENT_VIEW_BUTTON_DELETE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'announcements.view.button.delete',
    defaultMessage: '\u0423\u0434\u0430\u043B\u0438\u0442\u044C'
});

var ANNOUNCEMENT_VIEW_BUTTON_DELETE_TOOLTIP = exports.ANNOUNCEMENT_VIEW_BUTTON_DELETE_TOOLTIP = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'announcements.view.button.delete.tooltip',
    defaultMessage: '\u041F\u043E\u0441\u043B\u0435 \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u044F \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044F \u0432\u044B \u043D\u0435 \u0441\u043C\u043E\u0436\u0435\u0442\u0435 \u0435\u0433\u043E \u0432\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C.'
});

var ANNOUNCEMENT_VIEW_BUTTON_CREATE = exports.ANNOUNCEMENT_VIEW_BUTTON_CREATE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'announcements.view.button.create',
    defaultMessage: '\u0420\u0430\u0437\u043C\u0435\u0441\u0442\u0438\u0442\u044C \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0435'
});

var ANNOUNCEMENT_VIEW_BUTTON_CREATE_TOOLTIP = exports.ANNOUNCEMENT_VIEW_BUTTON_CREATE_TOOLTIP = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'announcements.view.button.create.tooltip',
    defaultMessage: '\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u0440\u0430\u0437\u043C\u0435\u0441\u0442\u0438\u0442\u044C \u043D\u043E\u0432\u043E\u0435 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0435.'
});

var ANNOUNCEMENT_VIEW_BUTTON_CREATE_DISABLED_TOOLTIP = exports.ANNOUNCEMENT_VIEW_BUTTON_CREATE_DISABLED_TOOLTIP = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'announcements.view.button.create.disabled_tooltip',
    defaultMessage: '\u0412 \u043A\u043B\u0430\u043D\u0435 \u0443\u0436\u0435 \u0440\u0430\u0437\u043C\u0435\u0449\u0435\u043D\u043E \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0435 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0439.'
});

var ANNOUNCEMENT_CREATE_BUTTON_SAVE = exports.ANNOUNCEMENT_CREATE_BUTTON_SAVE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'announcements.create.button.save',
    defaultMessage: '\u0420\u0430\u0437\u043C\u0435\u0441\u0442\u0438\u0442\u044C'
});

var ANNOUNCEMENT_EDIT_BUTTON_SAVE = exports.ANNOUNCEMENT_EDIT_BUTTON_SAVE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'announcements.edit.button.save',
    defaultMessage: '\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C'
});

var ANNOUNCEMENT_EDIT_BUTTON_SAVE_TOOLTIP_LIMIT = exports.ANNOUNCEMENT_EDIT_BUTTON_SAVE_TOOLTIP_LIMIT = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'announcements.edit.button.save.tooltip.limit',
    defaultMessage: '\u041F\u0440\u0435\u0432\u044B\u0448\u0435\u043D\u043E \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0435 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432.'
});

var ANNOUNCEMENT_EDIT_BUTTON_SAVE_TOOLTIP_FORBIDDEN = exports.ANNOUNCEMENT_EDIT_BUTTON_SAVE_TOOLTIP_FORBIDDEN = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'announcements.edit.button.save.tooltip.forbidden',
    defaultMessage: '\u041E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0435 \u0441\u043E\u0434\u0435\u0440\u0436\u0438\u0442 \u0432\u044B\u0440\u0430\u0436\u0435\u043D\u0438\u044F, \u043D\u0430\u0440\u0443\u0448\u0430\u044E\u0449\u0438\u0435 \u041F\u0440\u0430\u0432\u0438\u043B\u0430 \u043A\u043B\u0430\u043D\u043E\u0432.'
});

var ANNOUNCEMENT_EDIT_BUTTON_CANCEL = exports.ANNOUNCEMENT_EDIT_BUTTON_CANCEL = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'announcements.edit.button.cancel',
    defaultMessage: '\u041E\u0442\u043C\u0435\u043D\u0430'
});

var ANNOUNCEMENT_EDIT_TEXTAREA_HINT_CHARS = exports.ANNOUNCEMENT_EDIT_TEXTAREA_HINT_CHARS = function ANNOUNCEMENT_EDIT_TEXTAREA_HINT_CHARS(charLength, maxLength) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'announcements.edit.textarea_hint.chars',
        defaultMessage: '\u0421\u0438\u043C\u0432\u043E\u043B\u044B: {charLength} / {maxLength}',
        values: { charLength: charLength, maxLength: maxLength }
    });
};

var ANNOUNCEMENT_EDIT_TEXTAREA_HINT_BOLD = exports.ANNOUNCEMENT_EDIT_TEXTAREA_HINT_BOLD = function ANNOUNCEMENT_EDIT_TEXTAREA_HINT_BOLD(example) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'announcements.edit.textarea_hint.bold',
        defaultMessage: '\u0412\u044B\u0434\u0435\u043B\u0435\u043D\u0438\u0435 \u0436\u0438\u0440\u043D\u044B\u043C: {example}',
        values: { example: example }
    });
};

var ANNOUNCEMENT_EDIT_TEXTAREA_HINT_BOLD_TITLE_TOOLTIP = exports.ANNOUNCEMENT_EDIT_TEXTAREA_HINT_BOLD_TITLE_TOOLTIP = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'announcements.edit.textarea_hint.bold.title.tooltip',
    defaultMessage: '\u041E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u0435 \u0442\u0435\u043A\u0441\u0442\u0430'
});

var ANNOUNCEMENT_EDIT_TEXTAREA_HINT_BOLD_BODY_TOOLTIP = exports.ANNOUNCEMENT_EDIT_TEXTAREA_HINT_BOLD_BODY_TOOLTIP = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'announcements.edit.textarea_hint.bold.body.tooltip',
    defaultMessage: '\u0427\u0442\u043E\u0431\u044B \u0441\u0434\u0435\u043B\u0430\u0442\u044C \u0442\u0435\u043A\u0441\u0442 \u0436\u0438\u0440\u043D\u044B\u043C, \u0432\u044B\u0434\u0435\u043B\u0438\u0442\u0435 \u0435\u0433\u043E \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u043C \xAB*\xBB \u0441 \u0434\u0432\u0443\u0445 \u0441\u0442\u043E\u0440\u043E\u043D. \u041F\u0440\u0438 \u044D\u0442\u043E\u043C \u0441\u0438\u043C\u0432\u043E\u043B \xAB*\xBB \u043D\u0435 \u0431\u0443\u0434\u0435\u0442 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0442\u044C\u0441\u044F \u0432 \u0440\u0430\u0437\u043C\u0435\u0449\u0451\u043D\u043D\u043E\u043C \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0438. \u0427\u0442\u043E\u0431\u044B \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432 \xAB*\xBB \u0438\u043B\u0438 \xAB_\xBB \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u043B\u0438\u0441\u044C \u0432 \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0438, \u043F\u043E\u0441\u0442\u0430\u0432\u044C\u0442\u0435 \u043F\u0435\u0440\u0435\u0434 \u043D\u0438\u043C\u0438 \u0441\u0438\u043C\u0432\u043E\u043B \xAB{backslash}\xBB. \u041F\u0440\u0438 \u044D\u0442\u043E\u043C \u0441\u0438\u043C\u0432\u043E\u043B \xAB{backslash}\xBB \u043D\u0435 \u0431\u0443\u0434\u0435\u0442 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0442\u044C\u0441\u044F \u0432 \u0440\u0430\u0437\u043C\u0435\u0449\u0451\u043D\u043D\u043E\u043C \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0438.',
    values: { backslash: '\\' }
});

var ANNOUNCEMENT_EDIT_TEXTAREA_HINT_BOLD_EXAMPLE = exports.ANNOUNCEMENT_EDIT_TEXTAREA_HINT_BOLD_EXAMPLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'announcements.edit.textarea_hint.bold.example',
    defaultMessage: '*\u0442\u0435\u043A\u0441\u0442*'
});

var ANNOUNCEMENT_EDIT_GROUP_TYPE_CAPTION = exports.ANNOUNCEMENT_EDIT_GROUP_TYPE_CAPTION = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'announcements.edit.group_type.caption',
    defaultMessage: '\u0423\u0440\u043E\u0432\u0435\u043D\u044C \u0434\u043E\u0441\u0442\u0443\u043F\u0430'
});

var ANNOUNCEMENT_EDIT_GROUP_TYPE_TOOLTIP = exports.ANNOUNCEMENT_EDIT_GROUP_TYPE_TOOLTIP = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'announcements.edit.group_type.tooltip',
    defaultMessage: '\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435, \u043A\u0442\u043E \u0441\u043C\u043E\u0436\u0435\u0442 \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u044D\u0442\u043E \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0435.'
});

var ANNOUNCEMENT_EDIT_GROUP_TYPE_ITEMS = exports.ANNOUNCEMENT_EDIT_GROUP_TYPE_ITEMS = (_ANNOUNCEMENT_EDIT_GR = {}, _defineProperty(_ANNOUNCEMENT_EDIT_GR, _constants.GROUP_LIST.ALL_MEMBERS, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'announcements.edit.group_type.all_members',
    defaultMessage: '\u0412\u0441\u0435 \u0438\u0433\u0440\u043E\u043A\u0438 \u043A\u043B\u0430\u043D\u0430'
})), _defineProperty(_ANNOUNCEMENT_EDIT_GR, _constants.GROUP_LIST.COMMAND_STAFF, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'announcements.edit.group_type.command_staff',
    defaultMessage: '\u041A\u043E\u043C\u0430\u043D\u0434\u043D\u044B\u0439 \u0441\u043E\u0441\u0442\u0430\u0432'
})), _ANNOUNCEMENT_EDIT_GR);

var ANNOUNCEMENT_EDIT_GROUP_TYPE_ITEMS_TOOLTIP = exports.ANNOUNCEMENT_EDIT_GROUP_TYPE_ITEMS_TOOLTIP = (_ANNOUNCEMENT_EDIT_GR2 = {}, _defineProperty(_ANNOUNCEMENT_EDIT_GR2, _constants.GROUP_LIST.ALL_MEMBERS, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'announcements.edit.group_type.all_members.tooltip',
    defaultMessage: '\u041E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0435 \u0441\u043C\u043E\u0433\u0443\u0442 \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0432\u0441\u0435 \u0438\u0433\u0440\u043E\u043A\u0438 \u043A\u043B\u0430\u043D\u0430.'
})), _defineProperty(_ANNOUNCEMENT_EDIT_GR2, _constants.GROUP_LIST.COMMAND_STAFF, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'announcements.edit.group_type.command_staff.tooltip',
    defaultMessage: '\u041E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0435 \u0441\u043C\u043E\u0433\u0443\u0442 \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0442\u043E\u043B\u044C\u043A\u043E \u041A\u043E\u043C\u0430\u043D\u0434\u0443\u044E\u0449\u0438\u0439, \u0417\u0430\u043C\u0435\u0441\u0442\u0438\u0442\u0435\u043B\u044C \u043A\u043E\u043C\u0430\u043D\u0434\u0443\u044E\u0449\u0435\u0433\u043E, \u041E\u0444\u0438\u0446\u0435\u0440 \u0448\u0442\u0430\u0431\u0430 \u0438 \u041A\u043E\u043C\u0430\u043D\u0434\u0438\u0440 \u043F\u043E\u0434\u0440\u0430\u0437\u0434\u0435\u043B\u0435\u043D\u0438\u044F.'
})), _ANNOUNCEMENT_EDIT_GR2);

var ANNOUNCEMENT_EDIT_INFO = exports.ANNOUNCEMENT_EDIT_INFO = function ANNOUNCEMENT_EDIT_INFO(date) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'announcements.edit.info',
        defaultMessage: '\u041E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0435 \u0431\u0443\u0434\u0435\u0442 \u043F\u0435\u0440\u0435\u043C\u0435\u0449\u0435\u043D\u043E \u0432 \u0430\u0440\u0445\u0438\u0432 {date}',
        values: { date: date }
    });
};

var ANNOUNCEMENT_EDIT_INFO_TOOLTIP = exports.ANNOUNCEMENT_EDIT_INFO_TOOLTIP = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'announcements.edit.info.tooltip',
    defaultMessage: '\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u044D\u0442\u0443 \u0434\u0430\u0442\u0443 \u0438 \u0432\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044F \u0438\u0437 \u0430\u0440\u0445\u0438\u0432\u0430 \u043C\u043E\u0436\u043D\u043E \u043D\u0430 \u043A\u043B\u0430\u043D\u043E\u0432\u043E\u043C \u043F\u043E\u0440\u0442\u0430\u043B\u0435.'
});

var ANNOUNCEMENT_EDIT_PRIVACY_CAPTION = exports.ANNOUNCEMENT_EDIT_PRIVACY_CAPTION = function ANNOUNCEMENT_EDIT_PRIVACY_CAPTION(link) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'announcements.edit.privacy.caption',
        defaultMessage: '\u0412 \u0446\u0435\u043B\u044F\u0445 \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438 \u043D\u0435 \u0443\u043A\u0430\u0437\u044B\u0432\u0430\u0439\u0442\u0435 \u0437\u0434\u0435\u0441\u044C \u043B\u0438\u0447\u043D\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u043E \u0441\u0435\u0431\u0435 \u0438\u043B\u0438 \u043E \u043A\u043E\u043C-\u043B\u0438\u0431\u043E, \u0442\u0430\u043A \u043A\u0430\u043A \u043C\u044B \u043D\u0435 \u0441\u043C\u043E\u0436\u0435\u043C \u0437\u0430\u0449\u0438\u0442\u0438\u0442\u044C \u0435\u0451 \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 {link}',
        values: { link: link }
    });
};

var ANNOUNCEMENT_EDIT_PRIVACY_LINK = exports.ANNOUNCEMENT_EDIT_PRIVACY_LINK = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'announcements.edit.privacy.link',
    defaultMessage: '\u041F\u043E\u043B\u0438\u0442\u0438\u043A\u043E\u0439 \u043A\u043E\u043D\u0444\u0438\u0434\u0435\u043D\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438 Wargaming'
});

var ANNOUNCEMENT_CONFIRMATION_TITLE_ARCHIVE = exports.ANNOUNCEMENT_CONFIRMATION_TITLE_ARCHIVE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'announcements.confirmation.title.archive',
    defaultMessage: '\u041F\u0435\u0440\u0435\u043C\u0435\u0441\u0442\u0438\u0442\u044C \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0435 \u0432 \u0430\u0440\u0445\u0438\u0432?'
});

var ANNOUNCEMENT_CONFIRMATION_DESCRIPTION_ARCHIVE = exports.ANNOUNCEMENT_CONFIRMATION_DESCRIPTION_ARCHIVE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'announcements.confirmation.description.archive',
    defaultMessage: '\u0412\u044B \u0441\u043C\u043E\u0436\u0435\u0442\u0435 \u0432\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u044D\u0442\u043E \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0435 \u0438\u0437 \u0430\u0440\u0445\u0438\u0432\u0430 \u043D\u0430 \u043A\u043B\u0430\u043D\u043E\u0432\u043E\u043C \u043F\u043E\u0440\u0442\u0430\u043B\u0435.'
});

var ANNOUNCEMENT_CONFIRMATION_TITLE_DELETE = exports.ANNOUNCEMENT_CONFIRMATION_TITLE_DELETE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'announcements.confirmation.title.delete',
    defaultMessage: '\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u0435?'
});

var ANNOUNCEMENT_CONFIRMATION_DESCRIPTION_DELETE = exports.ANNOUNCEMENT_CONFIRMATION_DESCRIPTION_DELETE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'announcements.confirmation.description.delete',
    defaultMessage: '\u041F\u043E\u0441\u043B\u0435 \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u044F \u043E\u0431\u044A\u044F\u0432\u043B\u0435\u043D\u0438\u044F \u0432\u044B \u043D\u0435 \u0441\u043C\u043E\u0436\u0435\u0442\u0435 \u0435\u0433\u043E \u0432\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C.'
});

var ANNOUNCEMENT_CONFIRMATION_BUTTON_APPLY_ARCHIVE = exports.ANNOUNCEMENT_CONFIRMATION_BUTTON_APPLY_ARCHIVE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'announcements.confirmation.button.apply.archive',
    defaultMessage: '\u041F\u0435\u0440\u0435\u043C\u0435\u0441\u0442\u0438\u0442\u044C'
});

var ANNOUNCEMENT_CONFIRMATION_BUTTON_APPLY_DELETE = exports.ANNOUNCEMENT_CONFIRMATION_BUTTON_APPLY_DELETE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'announcements.confirmation.button.apply.delete',
    defaultMessage: '\u0423\u0434\u0430\u043B\u0438\u0442\u044C'
});

var ANNOUNCEMENT_CONFIRMATION_BUTTON_CANCEL = exports.ANNOUNCEMENT_CONFIRMATION_BUTTON_CANCEL = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'announcements.confirmation.button.cancel',
    defaultMessage: '\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C'
});

/***/ }),
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = exports.AuthWrapper = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(7);

var _clan = __webpack_require__(191);

var _clan2 = _interopRequireDefault(_clan);

var _LoadingScreen = __webpack_require__(29);

var _LoadingScreen2 = _interopRequireDefault(_LoadingScreen);

var _account = __webpack_require__(42);

var _account2 = _interopRequireDefault(_account);

var _reactivity = __webpack_require__(67);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AuthWrapper = exports.AuthWrapper = function (_React$Component) {
    _inherits(AuthWrapper, _React$Component);

    function AuthWrapper() {
        _classCallCheck(this, AuthWrapper);

        return _possibleConstructorReturn(this, (AuthWrapper.__proto__ || Object.getPrototypeOf(AuthWrapper)).apply(this, arguments));
    }

    _createClass(AuthWrapper, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.props.requestAccountInfo();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.closeReactiveConnection();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            // PushStream disabled - just do nothing
            if (!nextProps.reactiveUrl) return this.closeReactiveConnection();

            // If reactiveChannel changed, we should reconnect to new WebSocket
            if (nextProps.reactiveUrl && this.props.reactiveUrl !== nextProps.reactiveUrl) {
                return this.updateReactiveConnection(nextProps);
            }
        }
    }, {
        key: 'updateReactiveConnection',
        value: function updateReactiveConnection(props) {
            this.closeReactiveConnection();

            if (props === null) props = this.props;

            var _props = props,
                reactiveUrl = _props.reactiveUrl;

            if (reactiveUrl === null) {
                return;
            }

            this.channel = new _clan2.default(reactiveUrl);
        }
    }, {
        key: 'closeReactiveConnection',
        value: function closeReactiveConnection() {
            if (this.channel !== undefined) {
                this.channel.disconnect();
                this.channel = undefined;
            }
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.props.showLoading) {
                return _react2.default.createElement(_LoadingScreen2.default, { type: 'fullscreen' });
            }
            return this.props.children;
        }
    }]);

    return AuthWrapper;
}(_react2.default.Component);

AuthWrapper.propTypes = {
    showLoading: _propTypes2.default.bool.isRequired,
    requestAccountInfo: _propTypes2.default.func.isRequired,
    reactiveUrl: _propTypes2.default.string
};
var mapStateToProps = exports.mapStateToProps = function mapStateToProps(_ref) {
    var account = _ref.account,
        clan = _ref.clan,
        settings = _ref.settings;

    var showLoading = account.loaded !== account.loading && account.loading || !account.loaded;

    var reactive_channel = clan.reactive_channel;
    var pushStreamHost = settings.pushStreamHost;


    var reactiveUrl = (0, _reactivity.getReactiveUpdateUrl)(pushStreamHost, reactive_channel);

    return {
        showLoading: showLoading,
        reactiveUrl: reactiveUrl
    };
};

var mapDispatchToProps = exports.mapDispatchToProps = {
    requestAccountInfo: _account2.default
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AuthWrapper);

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _account = __webpack_require__(42);

var _account2 = _interopRequireDefault(_account);

var _store = __webpack_require__(56);

var _store2 = _interopRequireDefault(_store);

var _actions = __webpack_require__(88);

var _actions2 = _interopRequireDefault(_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CHANNEL_DELETED_MESSAGE = 'Channel deleted';

var ClanRoomChannel = function () {
    function ClanRoomChannel(url) {
        _classCallCheck(this, ClanRoomChannel);

        this.ws = new WebSocket(url);
        this.ws.onmessage = this.onMessage.bind(this);
    }

    _createClass(ClanRoomChannel, [{
        key: 'disconnect',
        value: function disconnect() {
            if (this.ws !== undefined) {
                this.ws.close();
                this.ws = undefined;
            }
        }
    }, {
        key: 'onMessage',
        value: function onMessage(_ref) {
            var data = _ref.data;

            if (data === CHANNEL_DELETED_MESSAGE) {
                this.disconnect();
                _store2.default.dispatch((0, _account2.default)());
                return;
            }

            var _JSON$parse = JSON.parse(data),
                payload = _JSON$parse.payload,
                type = _JSON$parse.type;

            if (!payload || !type) {
                console.error('Invalid action from clan channel', data); // eslint-disable-line no-console
                return;
            }

            var actionCreator = (0, _actions2.default)(type);
            if (!actionCreator) return;

            _store2.default.dispatch(actionCreator(payload));
        }
    }]);

    return ClanRoomChannel;
}();

exports.default = ClanRoomChannel;

/***/ }),
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"NavigationArrow_base--laStI","noBorder":"NavigationArrow_noBorder--3Ygep","base__disabled":"NavigationArrow_base__disabled--1SbWz","baseDisabled":"NavigationArrow_base__disabled--1SbWz","base__big":"NavigationArrow_base__big--18b_e","baseBig":"NavigationArrow_base__big--18b_e","base__left":"NavigationArrow_base__left--SqTh9","baseLeft":"NavigationArrow_base__left--SqTh9","base__right":"NavigationArrow_base__right--3oyWC","baseRight":"NavigationArrow_base__right--3oyWC","base__small":"NavigationArrow_base__small--1bHUc","baseSmall":"NavigationArrow_base__small--1bHUc","base__tiny":"NavigationArrow_base__tiny--2kSWM","baseTiny":"NavigationArrow_base__tiny--2kSWM"};

/***/ }),
/* 203 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"IndustrialResource_base--2E6J8","base__notEnough":"IndustrialResource_base__notEnough--2VJq9","baseNotEnough":"IndustrialResource_base__notEnough--2VJq9","base__small":"IndustrialResource_base__small--2EK4m","baseSmall":"IndustrialResource_base__small--2EK4m","base__large":"IndustrialResource_base__large--1BVnB","baseLarge":"IndustrialResource_base__large--1BVnB","base__custom":"IndustrialResource_base__custom--R6mS2","baseCustom":"IndustrialResource_base__custom--R6mS2","base__iconAtLeft":"IndustrialResource_base__iconAtLeft--1S7P8","baseIconAtLeft":"IndustrialResource_base__iconAtLeft--1S7P8","base_icon":"IndustrialResource_base_icon--3DJRc","baseIcon":"IndustrialResource_base_icon--3DJRc"};

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _SingleValueBonusDescription = __webpack_require__(385);

var _BonusParametersDescription = __webpack_require__(387);

var _reserves = __webpack_require__(28);

var _ReserveBonus = __webpack_require__(390);

var _ReserveBonus2 = _interopRequireDefault(_ReserveBonus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReserveBonus = function ReserveBonus(_ref) {
    var reserveInfo = _ref.reserveInfo,
        level = _ref.level,
        nextLevel = _ref.nextLevel,
        _ref$isNextLevelHighl = _ref.isNextLevelHighlighted,
        isNextLevelHighlighted = _ref$isNextLevelHighl === undefined ? false : _ref$isNextLevelHighl,
        _ref$layoutType = _ref.layoutType,
        layoutType = _ref$layoutType === undefined ? 'default' : _ref$layoutType,
        _ref$isClientParamete = _ref.isClientParametersVisible,
        isClientParametersVisible = _ref$isClientParamete === undefined ? true : _ref$isClientParamete;
    var reserveType = reserveInfo.type,
        bonus = reserveInfo.bonus;


    var currentBonus = bonus.values[level - 1];
    var nextBonus = bonus.values[nextLevel - 1];

    var sortedBattleTypes = Object.keys(currentBonus.battle_types).sort(_reserves.sortReserveBattleTypes);

    var reserveParameters = function () {
        return sortedBattleTypes.map(function (battleType) {
            var parameters = {};

            var currentValue = (0, _reserves.getReserveParameterByKey)(currentBonus, battleType);
            var nextValue = (0, _reserves.getReserveParameterByKey)(nextBonus, battleType);

            var bonusValue = isNextLevelHighlighted ? nextValue : currentValue;
            parameters.bonus = {
                value: bonusValue.replace('%', ''),
                isHighlightEnabled: isNextLevelHighlighted && nextValue !== currentValue
            };

            if (currentBonus.duration) {
                var durationValue = isNextLevelHighlighted ? nextBonus.duration : currentBonus.duration;
                parameters.duration = {
                    value: durationValue / 3600,
                    isHighlightEnabled: isNextLevelHighlighted && nextBonus.duration !== currentBonus.duration
                };
            }

            return parameters;
        });
    }();

    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_ReserveBonus2.default.base, _ReserveBonus2.default['base__' + layoutType + 'Layout']) },
        isClientParametersVisible && currentBonus.parameters ? _react2.default.createElement(_BonusParametersDescription.BonusParametersDescription, {
            reserveType: reserveType,
            layoutType: layoutType,
            isNextLevelHighlighted: isNextLevelHighlighted,
            currentBonus: currentBonus,
            nextBonus: nextBonus,
            battleTypes: sortedBattleTypes
        }) : sortedBattleTypes.map(function (battleType, index) {
            return _react2.default.createElement(_SingleValueBonusDescription.SingleValueBonusDescription, {
                key: battleType,
                layoutType: layoutType,
                battleType: battleType,
                reserveType: reserveType,
                bonusType: bonus.type,
                reserveParameters: reserveParameters[index]
            });
        })
    );
};

ReserveBonus.propTypes = {
    reserveInfo: _propTypes2.default.object.isRequired,
    level: _propTypes2.default.number.isRequired,
    nextLevel: _propTypes2.default.number.isRequired,
    isNextLevelHighlighted: _propTypes2.default.bool,
    isClientParametersVisible: _propTypes2.default.bool,
    layoutType: _propTypes2.default.oneOf(['default', 'tooltip', 'toolbar'])
};

exports.default = ReserveBonus;

/***/ }),
/* 205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"SingleValueBonusDescription_base--3pgrF","base__tooltipLayout":"SingleValueBonusDescription_base__tooltipLayout--3r-8k","baseTooltipLayout":"SingleValueBonusDescription_base__tooltipLayout--3r-8k","base__toolbarLayout":"SingleValueBonusDescription_base__toolbarLayout--2HpEy","baseToolbarLayout":"SingleValueBonusDescription_base__toolbarLayout--2HpEy","value":"SingleValueBonusDescription_value--LOm69","base__defaultLayout":"SingleValueBonusDescription_base__defaultLayout--ASSeh","baseDefaultLayout":"SingleValueBonusDescription_base__defaultLayout--ASSeh","value__glow":"SingleValueBonusDescription_value__glow--202_R","valueGlow":"SingleValueBonusDescription_value__glow--202_R","sign":"SingleValueBonusDescription_sign--sBy6a","percent":"SingleValueBonusDescription_percent--2Oztl","number":"SingleValueBonusDescription_number--1HeY9","target":"SingleValueBonusDescription_target--3reGt","target__glow":"SingleValueBonusDescription_target__glow--qrCDm","targetGlow":"SingleValueBonusDescription_target__glow--qrCDm","description":"SingleValueBonusDescription_description--nmJDg","duration__glow":"SingleValueBonusDescription_duration__glow--37I11","durationGlow":"SingleValueBonusDescription_duration__glow--37I11","resultType__glow":"SingleValueBonusDescription_resultType__glow--2TR8y","resultTypeGlow":"SingleValueBonusDescription_resultType__glow--2TR8y"};

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ReserveTooltipBody = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _ReserveBonus = __webpack_require__(204);

var _ReserveBonus2 = _interopRequireDefault(_ReserveBonus);

var _i18n = __webpack_require__(10);

var _ReserveTooltipBody = __webpack_require__(392);

var _ReserveTooltipBody2 = _interopRequireDefault(_ReserveTooltipBody);

var _constants = __webpack_require__(393);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReserveTooltipBody = exports.ReserveTooltipBody = function ReserveTooltipBody(_ref) {
    var reserveType = _ref.reserveType,
        level = _ref.level,
        reserveInfo = _ref.reserveInfo,
        _ref$isClientParamete = _ref.isClientParametersVisible,
        isClientParametersVisible = _ref$isClientParamete === undefined ? true : _ref$isClientParamete;

    var bonusValuesArray = Object.values(reserveInfo.bonus.values[level - 1].battle_types);

    var mainEffectDescription = _i18n.EFFECT_ON_USE_DESCRIPTION[reserveType];
    var additionalEffectDescription = _i18n.ADDITIONAL_EFFECT_ON_USE_DESCRIPTION[reserveType];

    return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
            'div',
            { className: _ReserveTooltipBody2.default.ribbon },
            _react2.default.createElement(
                'div',
                { className: _ReserveTooltipBody2.default.bonuses },
                (0, _constants.LEVEL_BONUSES)(level)
            ),
            isClientParametersVisible && mainEffectDescription && _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)(_ReserveTooltipBody2.default.sectionTitle, _ReserveTooltipBody2.default.sectionTitle__effect) },
                    _i18n.EFFECT_ON_USE_TITLE
                ),
                _react2.default.createElement(
                    'div',
                    { className: _ReserveTooltipBody2.default.effectDescription },
                    mainEffectDescription
                )
            ),
            _react2.default.createElement(_ReserveBonus2.default, {
                reserveInfo: reserveInfo,
                level: level,
                nextLevel: level,
                layoutType: 'tooltip',
                isClientParametersVisible: isClientParametersVisible
            })
        ),
        isClientParametersVisible && additionalEffectDescription && _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)(_ReserveTooltipBody2.default.sectionTitle, _ReserveTooltipBody2.default.sectionTitle__additionalEffect) },
                _i18n.ADDITIONAL_EFFECT_ON_USE_TITLE
            ),
            bonusValuesArray.map(function (value, index) {
                return _react2.default.createElement(
                    'div',
                    { className: _ReserveTooltipBody2.default.parameter, key: index },
                    _react2.default.createElement(
                        'div',
                        { className: _ReserveTooltipBody2.default.parameterValue },
                        '+' + value
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _ReserveTooltipBody2.default.parameterDescription },
                        additionalEffectDescription
                    )
                );
            })
        )
    );
};

ReserveTooltipBody.propTypes = {
    reserveType: _propTypes2.default.string.isRequired,
    level: _propTypes2.default.number.isRequired,
    reserveInfo: _propTypes2.default.object.isRequired,
    isClientParametersVisible: _propTypes2.default.bool
};

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _store = __webpack_require__(56);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ClanUnitsChannel = function () {
    function ClanUnitsChannel(url) {
        _classCallCheck(this, ClanUnitsChannel);

        this.ws = new WebSocket(url);
        this.ws.onmessage = this.onMessage.bind(this);
    }

    _createClass(ClanUnitsChannel, [{
        key: 'disconnect',
        value: function disconnect() {
            this.ws.close();
        }
    }, {
        key: 'onMessage',
        value: function onMessage(_ref) {
            var data = _ref.data;

            var _JSON$parse = JSON.parse(data),
                payload = _JSON$parse.payload,
                type = _JSON$parse.type;

            if (!payload || !type) {
                // eslint-disable-next-line no-console
                console.error('Invalid action from clan units channel', data);
                return;
            }

            _store2.default.dispatch({
                type: type,
                payload: payload
            });
        }
    }]);

    return ClanUnitsChannel;
}();

exports.default = ClanUnitsChannel;

/***/ }),
/* 208 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tooltip-root":"Squad_tooltip-root--13hPU","tooltipRoot":"Squad_tooltip-root--13hPU","tooltip-root__show":"Squad_tooltip-root__show--310yN","tooltipRootShow":"Squad_tooltip-root__show--310yN","tooltip-body":"Squad_tooltip-body--1neBz","tooltipBody":"Squad_tooltip-body--1neBz","tooltip-wrapper":"Squad_tooltip-wrapper--3sBH0","tooltipWrapper":"Squad_tooltip-wrapper--3sBH0","tooltip-content":"Squad_tooltip-content--UIJc1","tooltipContent":"Squad_tooltip-content--UIJc1","tooltip-title":"Squad_tooltip-title--2N2b3","tooltipTitle":"Squad_tooltip-title--2N2b3","tooltip-subtitle":"Squad_tooltip-subtitle--3_XcY","tooltipSubtitle":"Squad_tooltip-subtitle--3_XcY","tooltip-message":"Squad_tooltip-message--3FQtk","tooltipMessage":"Squad_tooltip-message--3FQtk","tooltip-warning":"Squad_tooltip-warning--1SfqK","tooltipWarning":"Squad_tooltip-warning--1SfqK","tooltip-divider":"Squad_tooltip-divider--pkZ6C","tooltipDivider":"Squad_tooltip-divider--pkZ6C","tooltip-highlight":"Squad_tooltip-highlight--EkCI3","tooltipHighlight":"Squad_tooltip-highlight--EkCI3","tooltip-ribbon":"Squad_tooltip-ribbon--1U8Lc","tooltipRibbon":"Squad_tooltip-ribbon--1U8Lc","tooltip-statusMessage":"Squad_tooltip-statusMessage--1kp0X","tooltipStatusMessage":"Squad_tooltip-statusMessage--1kp0X","tooltip-statusMessage__positive":"Squad_tooltip-statusMessage__positive--38QZe","tooltipStatusMessagePositive":"Squad_tooltip-statusMessage__positive--38QZe","tooltip-status":"Squad_tooltip-status--2jbjM","tooltipStatus":"Squad_tooltip-status--2jbjM","tooltip-statusMessage__negative":"Squad_tooltip-statusMessage__negative--NKO3j","tooltipStatusMessageNegative":"Squad_tooltip-statusMessage__negative--NKO3j","tooltip-statusMessage__noPermission":"Squad_tooltip-statusMessage__noPermission--1HmXa","tooltipStatusMessageNoPermission":"Squad_tooltip-statusMessage__noPermission--1HmXa","tooltip-status__positive":"Squad_tooltip-status__positive--1gOum","tooltipStatusPositive":"Squad_tooltip-status__positive--1gOum","tooltip-status__negative":"Squad_tooltip-status__negative--1TQsU","tooltipStatusNegative":"Squad_tooltip-status__negative--1TQsU","tooltip-statusText":"Squad_tooltip-statusText--h8mLV","tooltipStatusText":"Squad_tooltip-statusText--h8mLV","base":"Squad_base--1EbQ5","unitPreview":"Squad_unitPreview--29OZ_","header":"Squad_header--1joGL","list":"Squad_list--2eeLq","table":"Squad_table--11xPk","thead":"Squad_thead--2gfGN","tbody":"Squad_tbody--2Ud2_","tr":"Squad_tr--2Qemm","tr__thead":"Squad_tr__thead--34c4H","trThead":"Squad_tr__thead--34c4H","tr__disabled":"Squad_tr__disabled--6DL1a","trDisabled":"Squad_tr__disabled--6DL1a","th":"Squad_th--3xBpr","td":"Squad_td--1WgAW","th__nickname":"Squad_th__nickname--1tD_v","thNickname":"Squad_th__nickname--1tD_v","td__nickname":"Squad_td__nickname--2fTe7","tdNickname":"Squad_td__nickname--2fTe7","th__rating":"Squad_th__rating--14gky","thRating":"Squad_th__rating--14gky","td__rating":"Squad_td__rating--2F6z5","tdRating":"Squad_td__rating--2F6z5","th__vehicle":"Squad_th__vehicle--2Ow7t","thVehicle":"Squad_th__vehicle--2Ow7t","td__vehicle":"Squad_td__vehicle--11o88","tdVehicle":"Squad_td__vehicle--11o88","ratingIcon":"Squad_ratingIcon--3aeKM","rating":"Squad_rating--21N5T","count":"Squad_count--1KTYP","level":"Squad_level--QS5x3","footer":"Squad_footer--2vO0C","button":"Squad_button--2NxHN","message":"Squad_message--2HOdP","message__highlighted":"Squad_message__highlighted--3X93p","messageHighlighted":"Squad_message__highlighted--3X93p","message__inBattle":"Squad_message__inBattle--6IoD6","messageInBattle":"Squad_message__inBattle--6IoD6","name":"Squad_name--Vgbo-","tr__free":"Squad_tr__free--2ubn2","trFree":"Squad_tr__free--2ubn2","tr__lockedSlot":"Squad_tr__lockedSlot--2El_a","trLockedSlot":"Squad_tr__lockedSlot--2El_a","commanderIcon":"Squad_commanderIcon--1uXm-","lockedSlotIcon":"Squad_lockedSlotIcon--18qOQ","numeration":"Squad_numeration--AsBho"};

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UnitCheckboxFilter = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(7);

var _reactWotBootstrap = __webpack_require__(5);

var _DefaultTooltip = __webpack_require__(30);

var _DefaultTooltip2 = _interopRequireDefault(_DefaultTooltip);

var _constants = __webpack_require__(417);

var _available_units = __webpack_require__(50);

var _UnitCheckboxFilter = __webpack_require__(418);

var _UnitCheckboxFilter2 = _interopRequireDefault(_UnitCheckboxFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UnitCheckboxFilter = exports.UnitCheckboxFilter = function (_React$Component) {
    _inherits(UnitCheckboxFilter, _React$Component);

    function UnitCheckboxFilter() {
        _classCallCheck(this, UnitCheckboxFilter);

        return _possibleConstructorReturn(this, (UnitCheckboxFilter.__proto__ || Object.getPrototypeOf(UnitCheckboxFilter)).apply(this, arguments));
    }

    _createClass(UnitCheckboxFilter, [{
        key: 'render',
        value: function render() {
            var props = this.props;
            return _react2.default.createElement(
                'div',
                { className: _UnitCheckboxFilter2.default.base },
                _react2.default.createElement(
                    'div',
                    { className: _UnitCheckboxFilter2.default.filterItem },
                    _react2.default.createElement(_reactWotBootstrap.Checkbox, {
                        caption: _constants.BATTLE_ROOMS_FILTER.notInBattle,
                        onChange: props.waitingForPlayersClickHandler,
                        isChecked: props.filter.waitingForPlayers,
                        tooltipId: _constants.WAITING_FOR_PLAYERS_TOOLTIP.id
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: _UnitCheckboxFilter2.default.filterItem },
                    _react2.default.createElement(_reactWotBootstrap.Checkbox, {
                        caption: _constants.BATTLE_ROOMS_FILTER.places,
                        onChange: props.hasFreeSlotsClickHandler,
                        isChecked: props.filter.hasFreeSlots,
                        tooltipId: _constants.HAS_FREE_SLOTS_TOOLTIP.id
                    })
                ),
                _react2.default.createElement(_DefaultTooltip2.default, _constants.WAITING_FOR_PLAYERS_TOOLTIP),
                _react2.default.createElement(_DefaultTooltip2.default, _constants.HAS_FREE_SLOTS_TOOLTIP)
            );
        }
    }]);

    return UnitCheckboxFilter;
}(_react2.default.Component);

UnitCheckboxFilter.propTypes = {
    filter: _propTypes2.default.object.isRequired,
    hasFreeSlotsClickHandler: _propTypes2.default.func.isRequired,
    waitingForPlayersClickHandler: _propTypes2.default.func.isRequired
};


var mapStateToProps = function mapStateToProps(state) {
    return {
        filter: state.availableUnits.filter
    };
};

var mapDispatchToProps = {
    hasFreeSlotsClickHandler: _available_units.filterByHasFreeSlots,
    waitingForPlayersClickHandler: _available_units.filterByWaitingForPlayers
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UnitCheckboxFilter);

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UnitsList = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _constants = __webpack_require__(4);

var _UnitsList = __webpack_require__(137);

var _UnitsList2 = _interopRequireDefault(_UnitsList);

var _TableHeader = __webpack_require__(419);

var _TableHeader2 = _interopRequireDefault(_TableHeader);

var _TableBody = __webpack_require__(421);

var _TableBody2 = _interopRequireDefault(_TableBody);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UnitsList = exports.UnitsList = function (_React$Component) {
    _inherits(UnitsList, _React$Component);

    function UnitsList() {
        _classCallCheck(this, UnitsList);

        return _possibleConstructorReturn(this, (UnitsList.__proto__ || Object.getPrototypeOf(UnitsList)).apply(this, arguments));
    }

    _createClass(UnitsList, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: _UnitsList2.default.base },
                _react2.default.createElement(
                    'div',
                    { className: _UnitsList2.default.tableHeader },
                    _react2.default.createElement(_TableHeader2.default, null)
                ),
                _react2.default.createElement(
                    'div',
                    { className: _UnitsList2.default.unitsList },
                    _react2.default.createElement(_TableBody2.default, {
                        filter: this.props.filter,
                        updateListHandler: this.props.updateListHandler,
                        updateCooldown: this.props.updateCooldown
                    })
                )
            );
        }
    }]);

    return UnitsList;
}(_react2.default.Component);

UnitsList.propTypes = {
    filter: _propTypes2.default.shape({
        levels: _propTypes2.default.arrayOf(_propTypes2.default.number),
        unitType: _propTypes2.default.oneOf(Object.values(_constants.UNIT_TYPES))
    }).isRequired,
    updateCooldown: _propTypes2.default.bool.isRequired,

    updateListHandler: _propTypes2.default.func.isRequired
};
exports.default = UnitsList;

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LevelFilterTooltip = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactWotBootstrap = __webpack_require__(5);

var _helpers = __webpack_require__(11);

var _datetime = __webpack_require__(13);

var _constants = __webpack_require__(4);

var _constants2 = __webpack_require__(423);

var _i18n = __webpack_require__(10);

var _LevelFilterTooltip = __webpack_require__(424);

var _LevelFilterTooltip2 = _interopRequireDefault(_LevelFilterTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LevelFilterTooltip = exports.LevelFilterTooltip = function (_React$Component) {
    _inherits(LevelFilterTooltip, _React$Component);

    function LevelFilterTooltip() {
        _classCallCheck(this, LevelFilterTooltip);

        return _possibleConstructorReturn(this, (LevelFilterTooltip.__proto__ || Object.getPrototypeOf(LevelFilterTooltip)).apply(this, arguments));
    }

    _createClass(LevelFilterTooltip, [{
        key: 'getVehicleLevels',
        value: function getVehicleLevels(_ref) {
            var min_vehicle_level = _ref.min_vehicle_level,
                max_vehicle_level = _ref.max_vehicle_level;

            return min_vehicle_level === max_vehicle_level ? (0, _helpers.toRoman)(max_vehicle_level) : (0, _helpers.toRoman)(min_vehicle_level) + '-' + (0, _helpers.toRoman)(max_vehicle_level);
        }
    }, {
        key: 'getPlayersNumber',
        value: function getPlayersNumber(_ref2) {
            var min_players_number = _ref2.min_players_number,
                max_players_number = _ref2.max_players_number;

            return min_players_number === max_players_number ? max_players_number : min_players_number + '-' + max_players_number;
        }
    }, {
        key: 'render',
        value: function render() {
            var battleRegulationsFormatted = {
                vehicleLevels: this.getVehicleLevels(this.props.battleRegulations),
                playersNumber: this.getPlayersNumber(this.props.battleRegulations),
                legionariesNumber: this.props.battleRegulations.max_legionaries_number,
                battleDuration: (0, _datetime.getMinutesFormat)(this.props.battleRegulations.battle_duration / 60)
            };

            var battleRegulations = Object.keys(battleRegulationsFormatted).map(function (key, index) {
                return _react2.default.createElement(
                    'div',
                    { key: index, className: _LevelFilterTooltip2.default.detailsItem },
                    _react2.default.createElement(
                        'span',
                        { className: _LevelFilterTooltip2.default.value },
                        battleRegulationsFormatted[key]
                    ),
                    _react2.default.createElement(
                        'span',
                        { className: _LevelFilterTooltip2.default.description },
                        _constants2.LEVEL_FILTER_TOOLTIP_DESCRIPTION[key]
                    )
                );
            });

            var title = this.props.battleRegulations.unit_type === _constants.UNIT_TYPES.FORT_BATTLE ? _i18n.FORT_BATTLES : (0, _constants2.LEVEL_FILTER_TOOLTIP_TITLE)((0, _helpers.toRoman)(this.props.battleRegulations.max_vehicle_level));

            var content = _react2.default.createElement(
                'div',
                { className: _LevelFilterTooltip2.default.base },
                _react2.default.createElement(
                    'p',
                    { className: _LevelFilterTooltip2.default.title },
                    title
                ),
                _react2.default.createElement(
                    'div',
                    { className: _LevelFilterTooltip2.default.details },
                    battleRegulations
                ),
                _react2.default.createElement('div', { className: _LevelFilterTooltip2.default.divider }),
                _react2.default.createElement(
                    'p',
                    { className: _LevelFilterTooltip2.default.message },
                    _constants2.LEVEL_FILTER_TOOLTIP_FILTER_ACTIONS[this.props.tab]
                )
            );

            return _react2.default.createElement(
                _reactWotBootstrap.Tooltip,
                { id: this.props.id, isWide: true },
                _react2.default.createElement(
                    'div',
                    { className: _LevelFilterTooltip2.default.content },
                    content
                )
            );
        }
    }]);

    return LevelFilterTooltip;
}(_react2.default.Component);

LevelFilterTooltip.propTypes = {
    id: _propTypes2.default.string.isRequired,
    battleRegulations: _propTypes2.default.shape({
        unit_type: _propTypes2.default.oneOf([_constants.UNIT_TYPES.SORTIE, _constants.UNIT_TYPES.FORT_BATTLE]),
        min_players_number: _propTypes2.default.number,
        max_players_number: _propTypes2.default.number,
        min_vehicle_level: _propTypes2.default.number,
        max_vehicle_level: _propTypes2.default.number,
        max_legionaries_number: _propTypes2.default.number,
        battle_duration: _propTypes2.default.number
    }).isRequired,
    tab: _propTypes2.default.oneOf(Object.values(_constants.BATTLE_ROOMS_TAB_STATES)).isRequired
};
exports.default = LevelFilterTooltip;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactWotBootstrap = __webpack_require__(5);

var _constants = __webpack_require__(425);

var _EmptyList = __webpack_require__(426);

var _EmptyList2 = _interopRequireDefault(_EmptyList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmptyList = function EmptyList(props) {
    return _react2.default.createElement(
        'div',
        { className: _EmptyList2.default.base },
        _react2.default.createElement(
            'div',
            { className: _EmptyList2.default.holder },
            _react2.default.createElement(
                'h3',
                { className: _EmptyList2.default.title },
                _constants.EMPTY_LIST_TITLE
            ),
            _react2.default.createElement(
                'div',
                { className: _EmptyList2.default.button },
                _react2.default.createElement(
                    _reactWotBootstrap.ButtonSmall,
                    {
                        onClick: props.handleListUpdate,
                        type: 'secondary',
                        isDisabled: props.updateCooldown
                    },
                    _constants.UPDATE_BUTTON_CAPTION
                )
            )
        )
    );
};

EmptyList.propTypes = {
    updateCooldown: _propTypes2.default.bool,
    handleListUpdate: _propTypes2.default.func.isRequired
};

exports.default = EmptyList;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapStateToProps = exports.Tabs = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = __webpack_require__(7);

var _reactWotBootstrap = __webpack_require__(5);

var _constants = __webpack_require__(4);

var _constants2 = __webpack_require__(427);

var _players_matching = __webpack_require__(36);

var _playersMatching = __webpack_require__(57);

var _Tabs = __webpack_require__(428);

var _Tabs2 = _interopRequireDefault(_Tabs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Tabs = exports.Tabs = function (_React$Component) {
    _inherits(Tabs, _React$Component);

    function Tabs() {
        _classCallCheck(this, Tabs);

        return _possibleConstructorReturn(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).apply(this, arguments));
    }

    _createClass(Tabs, [{
        key: 'handleTabClick',
        value: function handleTabClick(tabId) {
            (0, _reactWotBootstrap.sendTabClickSoundCommand)();
            if (tabId === _constants2.BATTLE_ROOMS_TABS[0].id) {
                this.props.openPlayerMatchingTab();
                (0, _playersMatching.saveToStorage)(_constants.LOCAL_STORAGE_KEYS.BATTLE_ROOMS_TAB, _constants.BATTLE_ROOMS_TAB_STATES.MATCHING);
            } else if (tabId === _constants2.BATTLE_ROOMS_TABS[1].id) {
                this.props.openUnitListTab();
                (0, _playersMatching.saveToStorage)(_constants.LOCAL_STORAGE_KEYS.BATTLE_ROOMS_TAB, _constants.BATTLE_ROOMS_TAB_STATES.UNITS);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var tabsComponent = _constants2.BATTLE_ROOMS_TABS.map(function (tab) {
                var handleClick = function handleClick() {
                    return _this2.handleTabClick(tab.id);
                };

                var itemClassName = (0, _classnames2.default)(_Tabs2.default.item, _defineProperty({}, _Tabs2.default.item__selected, tab.id === _this2.props.selectedTabId));

                return _react2.default.createElement(
                    'div',
                    {
                        className: itemClassName,
                        key: tab.id,
                        onClick: handleClick,
                        onMouseEnter: _reactWotBootstrap.sendHoverSoundCommand
                    },
                    _react2.default.createElement(
                        'div',
                        { className: _Tabs2.default.tab },
                        _react2.default.createElement('span', { className: _Tabs2.default.overlay }),
                        _react2.default.createElement('span', { className: _Tabs2.default.borders }),
                        _react2.default.createElement(
                            'span',
                            { className: _Tabs2.default.caption },
                            tab.title
                        )
                    )
                );
            });

            var className = (0, _classnames2.default)(_Tabs2.default.base, _defineProperty({}, _Tabs2.default.base__cn, _reactWotBootstrap.helpers.isChineseLanguage()));

            return _react2.default.createElement(
                'div',
                { className: className },
                _react2.default.createElement(
                    'div',
                    { className: _Tabs2.default.holder },
                    tabsComponent
                )
            );
        }
    }]);

    return Tabs;
}(_react2.default.Component);

Tabs.propTypes = {
    openPlayerMatchingTab: _propTypes2.default.func.isRequired,
    openUnitListTab: _propTypes2.default.func.isRequired,
    selectedTabId: _propTypes2.default.string.isRequired
};
var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
    var isUnitsTabStored = (0, _playersMatching.getParsedStorageItem)(_constants.LOCAL_STORAGE_KEYS.BATTLE_ROOMS_TAB) === _constants.BATTLE_ROOMS_TAB_STATES.UNITS;
    var isUnitsTabSelected = !state.players_matching.active || isUnitsTabStored;

    var selectedTabId = isUnitsTabSelected ? _constants2.BATTLE_ROOMS_TABS[1].id : _constants2.BATTLE_ROOMS_TABS[0].id;

    return { selectedTabId: selectedTabId };
};

var mapDispatchToProps = {
    openPlayerMatchingTab: _players_matching.enablePlayerMatching,
    openUnitListTab: _players_matching.disablePlayerMatching
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Tabs);

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapStateToProps = exports.UnitTooltip = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(7);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _helpers = __webpack_require__(11);

var _datetime = __webpack_require__(13);

var _peripheries = __webpack_require__(37);

var _helpers2 = __webpack_require__(139);

var _reactWotBootstrap = __webpack_require__(5);

var _Timer = __webpack_require__(51);

var _Timer2 = _interopRequireDefault(_Timer);

var _Clan = __webpack_require__(81);

var _Clan2 = _interopRequireDefault(_Clan);

var _constants = __webpack_require__(4);

var _constants2 = __webpack_require__(38);

var _constants3 = __webpack_require__(429);

var _UnitTooltip = __webpack_require__(430);

var _UnitTooltip2 = _interopRequireDefault(_UnitTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UnitTooltip = exports.UnitTooltip = function (_React$Component) {
    _inherits(UnitTooltip, _React$Component);

    function UnitTooltip() {
        _classCallCheck(this, UnitTooltip);

        return _possibleConstructorReturn(this, (UnitTooltip.__proto__ || Object.getPrototypeOf(UnitTooltip)).apply(this, arguments));
    }

    _createClass(UnitTooltip, [{
        key: 'getFooterMessage',
        value: function getFooterMessage() {
            var periphery = void 0;
            var isAvailable = void 0;
            var primetimeStart = null;
            if (this.props.battleType === _constants.UNIT_TYPES.SORTIE) {
                periphery = (0, _peripheries.getPeripheryById)(this.props.meta.sorties.peripheries, this.props.peripheryId);
                isAvailable = (0, _peripheries.isSortiesAvailable)(periphery);
                if (periphery) primetimeStart = periphery.primetime_start;
            } else {
                periphery = (0, _peripheries.getPeripheryById)(this.props.meta.fort_battles.peripheries, this.props.peripheryId);
                isAvailable = (0, _peripheries.isFortBattlesAvailable)(periphery);
                if (periphery) primetimeStart = (0, _peripheries.getClosestMatchmakerTick)(periphery);
            }

            var positiveStatusClassName = (0, _classnames2.default)(_UnitTooltip2.default.status, _UnitTooltip2.default.status__positive);
            var negativeStatusClassName = (0, _classnames2.default)(_UnitTooltip2.default.status, _UnitTooltip2.default.status__negative);
            var highlightStatusClassName = (0, _classnames2.default)(_UnitTooltip2.default.status, _UnitTooltip2.default.status__highlighted);

            if (this.props.inBattle) {
                return _react2.default.createElement(
                    'p',
                    { className: (0, _classnames2.default)(_UnitTooltip2.default.status, _UnitTooltip2.default.status__inBattle) },
                    _constants2.STATUS_IN_BATTLE_MESSAGE
                );
            } else if (this.props.inPlayersMatching) {
                return _react2.default.createElement(
                    'p',
                    { className: highlightStatusClassName },
                    _constants2.STATUS_MATCHING_LEGIONARIES
                );
            } else if (isAvailable) {
                return _react2.default.createElement(
                    'p',
                    { className: positiveStatusClassName },
                    _constants2.STATUS_BATTLE_READY_MESSAGE
                );
            } else if (primetimeStart === null) {
                return _react2.default.createElement(
                    'p',
                    { className: negativeStatusClassName },
                    _constants2.BATTLE_MODE_DISABLED_ON_PERIPHERY
                );
            } else {
                var availableTime = (0, _datetime.getEndDateMessage)((0, _moment2.default)(primetimeStart));
                return _react2.default.createElement(
                    'p',
                    { className: negativeStatusClassName },
                    (0, _constants2.STATUS_BATTLE_SCHEDULE_MESSAGE)(availableTime)
                );
            }
        }
    }, {
        key: 'getCreationTime',
        value: function getCreationTime() {
            var timeNode = _react2.default.createElement(
                'span',
                { className: _UnitTooltip2.default.highlight },
                _react2.default.createElement(_Timer2.default, { startTime: (0, _moment2.default)(this.props.createdAt) })
            );
            return (0, _constants3.UNIT_TOOLTIP_CREATION_TIME)(timeNode);
        }
    }, {
        key: 'getBattleMode',
        value: function getBattleMode() {
            return _constants3.UNIT_TOOLTIP_BATTLE_MODE[this.props.battleType]((0, _helpers.toRoman)(this.props.battleLevel));
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.props.isUnitDisabled) return _react2.default.createElement(
                _reactWotBootstrap.Tooltip,
                { id: _constants3.BATTLE_ROOMS_UNIT_TOOLTIP_ID },
                _react2.default.createElement(
                    'div',
                    { className: _UnitTooltip2.default.base },
                    _constants3.UNIT_TOOLTIP_DISABLED_TEXT
                )
            );
            return _react2.default.createElement(
                _reactWotBootstrap.Tooltip,
                { id: _constants3.BATTLE_ROOMS_UNIT_TOOLTIP_ID },
                _react2.default.createElement(
                    'div',
                    { className: _UnitTooltip2.default.base },
                    _react2.default.createElement(_Clan2.default, _extends({}, this.props.clan, { battle: this.getBattleMode() })),
                    _react2.default.createElement(
                        'div',
                        { className: _UnitTooltip2.default.ribbon },
                        this.getCreationTime()
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: _UnitTooltip2.default.message },
                        _react2.default.createElement(
                            'span',
                            { className: _UnitTooltip2.default.commander },
                            _constants3.UNIT_TOOLTIP_DATA_LABELS.commander,
                            ': ',
                            _react2.default.createElement(_reactWotBootstrap.Role, { role: this.props.commanderRole }),
                            '\u2009',
                            _react2.default.createElement(
                                'span',
                                { className: _UnitTooltip2.default.highlight },
                                this.props.commanderNickname
                            )
                        )
                    ),
                    _react2.default.createElement('span', { className: _UnitTooltip2.default.divider }),
                    this.getFooterMessage()
                )
            );
        }
    }]);

    return UnitTooltip;
}(_react2.default.Component);

UnitTooltip.propTypes = {
    unitId: _propTypes2.default.number.isRequired,
    clan: _propTypes2.default.object.isRequired,
    inBattle: _propTypes2.default.bool.isRequired,
    inPlayersMatching: _propTypes2.default.bool,
    battleType: _propTypes2.default.oneOf(Object.values(_constants.UNIT_TYPES)).isRequired,
    battleLevel: _propTypes2.default.number.isRequired,
    createdAt: _propTypes2.default.number.isRequired,
    peripheryId: _propTypes2.default.number.isRequired,
    commanderNickname: _propTypes2.default.string.isRequired,
    commanderRole: _propTypes2.default.oneOf(Object.values(_constants.USER_ROLES)).isRequired,
    meta: _propTypes2.default.shape({
        sorties: _propTypes2.default.object.isRequired,
        fort_battles: _propTypes2.default.object.isRequired
    }),
    isUnitDisabled: _propTypes2.default.bool.isRequired
};
UnitTooltip.id = _constants3.BATTLE_ROOMS_UNIT_TOOLTIP_ID;
var mapStateToProps = exports.mapStateToProps = function mapStateToProps(_ref, _ref2) {
    var availableUnits = _ref.availableUnits,
        clan = _ref.clan,
        clanUnits = _ref.clanUnits;
    var unitId = _ref2.unitId;
    var meta = availableUnits.meta;


    var unit = availableUnits.units.find(function (unit) {
        return unit.id === unitId;
    });
    if (!unit) unit = clanUnits.units.find(function (unit) {
        return unit.id === unitId;
    });

    var _unit = unit,
        type = _unit.type,
        inBattle = _unit.in_battle,
        players_matching_started_at = _unit.players_matching_started_at,
        battleLevel = _unit.max_vehicle_level,
        createdAt = _unit.created_at,
        commanderRole = _unit.commander_role,
        commanderNickname = _unit.commander_nickname,
        periphery = _unit.periphery;


    var peripheryId = periphery.id;

    return {
        clan: unit.clan,
        inBattle: inBattle,
        inPlayersMatching: players_matching_started_at !== null,
        battleType: type,
        battleLevel: battleLevel,
        peripheryId: peripheryId,
        meta: meta,
        createdAt: createdAt,
        commanderNickname: commanderNickname,
        commanderRole: commanderRole,
        isUnitDisabled: (0, _helpers2.isUnitDisabled)(unit, clan.id)
    };
};

UnitTooltip.id = _constants3.BATTLE_ROOMS_UNIT_TOOLTIP_ID;

exports.default = (0, _reactRedux.connect)(mapStateToProps)(UnitTooltip);

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BattleRoomsWrapper = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(7);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactWotBootstrap = __webpack_require__(5);

var _i18n = __webpack_require__(10);

var _web_to_client = __webpack_require__(12);

var _playersMatching = __webpack_require__(57);

var _constants = __webpack_require__(4);

var _IndustrialResourceCoefTooltip = __webpack_require__(163);

var _IndustrialResourceCoefTooltip2 = _interopRequireDefault(_IndustrialResourceCoefTooltip);

var _CreateUnitButton = __webpack_require__(133);

var _CreateUnitButton2 = _interopRequireDefault(_CreateUnitButton);

var _Tabs = __webpack_require__(213);

var _Tabs2 = _interopRequireDefault(_Tabs);

var _Title = __webpack_require__(134);

var _Title2 = _interopRequireDefault(_Title);

var _constants2 = __webpack_require__(38);

var _BattleRoomsWrapper = __webpack_require__(433);

var _BattleRoomsWrapper2 = _interopRequireDefault(_BattleRoomsWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BattleRoomsWrapper = exports.BattleRoomsWrapper = function (_React$Component) {
    _inherits(BattleRoomsWrapper, _React$Component);

    function BattleRoomsWrapper() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, BattleRoomsWrapper);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BattleRoomsWrapper.__proto__ || Object.getPrototypeOf(BattleRoomsWrapper)).call.apply(_ref, [this].concat(args))), _this), _this.onKeyDown = function (event) {
            if (event.keyCode === _constants.KEY_CODES.ESCAPE && !_this.props.isVehiclesFilterOpen) {
                (0, _web_to_client.closeBattleRoomsList)();
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(BattleRoomsWrapper, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            window.addEventListener('keydown', this.onKeyDown);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('keydown', this.onKeyDown);
        }
    }, {
        key: 'render',
        value: function render() {
            var className = (0, _classnames2.default)(_BattleRoomsWrapper2.default.base, _defineProperty({}, _BattleRoomsWrapper2.default.base__cn, _reactWotBootstrap.helpers.isChineseRealm(this.props.realm)));

            return _react2.default.createElement(
                'div',
                { className: className },
                _react2.default.createElement(
                    'header',
                    { className: _BattleRoomsWrapper2.default.header },
                    _react2.default.createElement(
                        _Title2.default,
                        null,
                        _constants2.BATTLE_ROOMS_TITLE,
                        this.props.industrialResourceMultiplier > 1 && _react2.default.createElement(
                            'div',
                            { className: _BattleRoomsWrapper2.default.multiplier, 'data-tip': true, 'data-for': _IndustrialResourceCoefTooltip2.default.id },
                            (0, _i18n.INDUSTRIAL_RESOURCE_MULTIPLIER_TEXT)(_react2.default.createElement(
                                'span',
                                { className: _BattleRoomsWrapper2.default.multiplierValue },
                                (0, _i18n.INDUSTRIAL_RESOURCE_MULTIPLIER)(this.props.industrialResourceMultiplier)
                            ))
                        )
                    ),
                    this.props.clanId && _react2.default.createElement(
                        'div',
                        { className: _BattleRoomsWrapper2.default.createUnit },
                        _react2.default.createElement(_CreateUnitButton2.default, null)
                    ),
                    this.props.industrialResourceMultiplier > 1 && _react2.default.createElement(_IndustrialResourceCoefTooltip2.default, { multiplier: this.props.industrialResourceMultiplier })
                ),
                _react2.default.createElement(
                    'main',
                    { className: _BattleRoomsWrapper2.default.holder },
                    this.props.playersMatchingAvailable && _react2.default.createElement(
                        'div',
                        { className: _BattleRoomsWrapper2.default.tabs },
                        _react2.default.createElement(_Tabs2.default, null)
                    ),
                    this.props.children
                )
            );
        }
    }]);

    return BattleRoomsWrapper;
}(_react2.default.Component);

BattleRoomsWrapper.propTypes = {
    clanId: _propTypes2.default.number,
    isVehiclesFilterOpen: _propTypes2.default.bool.isRequired,
    playersMatchingAvailable: _propTypes2.default.bool,
    realm: _propTypes2.default.string.isRequired,
    industrialResourceMultiplier: _propTypes2.default.number.isRequired
};


var mapStateToProps = function mapStateToProps(_ref2) {
    var account = _ref2.account,
        players_matching = _ref2.players_matching,
        clan = _ref2.clan,
        settings = _ref2.settings;

    var playersMatchingAvailable = (0, _playersMatching.isPlayersMatchingAvailable)(account, players_matching);

    return {
        clanId: clan.id,
        isVehiclesFilterOpen: players_matching.isVehiclesFilterOpen,
        playersMatchingAvailable: playersMatchingAvailable,
        realm: settings.realm,
        industrialResourceMultiplier: settings.industrialResourceMultiplier
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(BattleRoomsWrapper);

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapStateToProps = exports.ScheduleTable = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(7);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactWotBootstrap = __webpack_require__(5);

var _helpers = __webpack_require__(11);

var _i18n = __webpack_require__(10);

var _datetime = __webpack_require__(13);

var _schedule = __webpack_require__(27);

var _constants = __webpack_require__(4);

var _constants2 = __webpack_require__(108);

var _NoBattlesMessage = __webpack_require__(217);

var _NoBattlesMessage2 = _interopRequireDefault(_NoBattlesMessage);

var _BattleModeAtPeripheryOverriddenTooltip = __webpack_require__(219);

var _BattleModeAtPeripheryOverriddenTooltip2 = _interopRequireDefault(_BattleModeAtPeripheryOverriddenTooltip);

var _TimeLine = __webpack_require__(221);

var _TimeLine2 = _interopRequireDefault(_TimeLine);

var _ScheduleTable = __webpack_require__(223);

var _ScheduleTable2 = _interopRequireDefault(_ScheduleTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ScheduleTable = exports.ScheduleTable = function (_React$Component) {
    _inherits(ScheduleTable, _React$Component);

    function ScheduleTable() {
        _classCallCheck(this, ScheduleTable);

        var _this = _possibleConstructorReturn(this, (ScheduleTable.__proto__ || Object.getPrototypeOf(ScheduleTable)).call(this));

        _this.state = {
            time: (0, _moment2.default)()
        };

        _this.tick = function () {
            _this.setState({ time: (0, _moment2.default)() });
        };

        _this.getPlaydayLength = function () {
            var end = _this.props.playdayEnd;
            if (end < _this.props.playdayStart) end += 24;
            return end - _this.props.playdayStart;
        };

        _this.getPlayingHours = function () {
            var firstPlayingHour = _this.props.playdayStart - 1;
            if (firstPlayingHour === -1) firstPlayingHour = 23;
            return Array.from({ length: _this.getPlaydayLength() + 3 }, function (_, index) {
                return (firstPlayingHour + index) % 24;
            });
        };

        _this.getTableCell = function (schedule_type, vehicle_level, schedules, hour, peripheriesOrder, index) {

            var getBarsForCell = function getBarsForCell(schedule, barIndex) {
                var _classNames;

                var period = schedule.periods.find(function (period) {
                    return utcHourToLocal(period[0]) === hour;
                });
                if (!period) return null;

                var _period = _slicedToArray(period, 2),
                    start = _period[0],
                    end = _period[1];

                if (end < start) end += 24;

                var peripheryPosition = peripheriesOrder.indexOf(schedule.periphery);
                var top = (peripheryPosition + 1) / (peripheriesOrder.length + 1) * 100 + '%';
                var width = (end - start) * 100 + '%'; // width is set in cell sizes

                var style = {
                    width: 'calc(' + width + ' - 4px)',
                    top: top,
                    left: '1px'
                };

                var isFirstPeriod = (0, _schedule.checkIsFirstPeriod)(period, schedule.periods, _this.props.playdayStart, _this.props.playdayEnd);

                var tooltipId = _this.getPeripheryTooltipId(schedule_type, vehicle_level, schedule.periphery);
                var caption = void 0;
                if (schedule.periphery && isFirstPeriod) {
                    // draw caption only for first bar per periphery
                    caption = _react2.default.createElement(
                        'div',
                        { className: _ScheduleTable2.default.barName },
                        _react2.default.createElement('div', { className: _ScheduleTable2.default.warningIcon, 'data-tip': true, 'data-for': tooltipId }),
                        schedule.periphery
                    );
                } else if (schedule_type === 'CHALLENGE' && isFirstPeriod) {
                    caption = _react2.default.createElement('div', { className: (0, _classnames2.default)(_ScheduleTable2.default.barName, _ScheduleTable2.default.barName__challenge) });
                }
                var className = (0, _classnames2.default)(_ScheduleTable2.default.bar, (_classNames = {}, _defineProperty(_classNames, _ScheduleTable2.default['bar__' + schedule_type.toLowerCase()], schedule.enabled !== false), _defineProperty(_classNames, _ScheduleTable2.default.bar__disabled, schedule.enabled === false), _defineProperty(_classNames, _ScheduleTable2.default.bar__overridden, schedule.overridden === true), _classNames));

                return _react2.default.createElement(
                    'div',
                    {
                        className: className,
                        style: style,
                        key: barIndex
                    },
                    caption
                );
            };

            var bars = schedules.map(getBarsForCell);
            return _react2.default.createElement(
                'div',
                { className: _ScheduleTable2.default.td, key: hour + '_' + index },
                _react2.default.createElement('div', { className: (0, _classnames2.default)(_ScheduleTable2.default.td_inner) }),
                bars
            );
        };

        _this.getPeripheryTooltipId = function (type, vehicle_level, periphery) {
            return 'calendar.selected_day.' + type + vehicle_level + '.' + periphery + '.tooltip';
        };

        _this.getTableRow = function (scheduleItem, index) {
            var time = _this.state.time;

            var name = void 0;
            switch (scheduleItem.type) {
                case 'SORTIE':
                    name = (0, _i18n.SORTIES_WITH_LEVEL)((0, _helpers.toRoman)(scheduleItem.vehicle_level));
                    break;
                case 'FORT_BATTLE':
                    name = _i18n.FORT_BATTLES;
                    break;
                case 'CHALLENGE':
                    name = _i18n.CHALLENGES;
                    break;
            }

            var schedules = scheduleItem.schedules || [];

            var peripheriesOrder = schedules.filter(function (schedule) {
                return schedule.periods.length > 0;
            }).sort(sortSchedulesByPrimetimeStart).map(function (schedule) {
                return schedule.periphery;
            });

            var cellsCount = _this.getPlaydayLength() + 2; // 2 cells of padding: left and right
            var cells = Array.from({ length: cellsCount }, function (_, index) {
                var hoursSinceTableStart = _this.props.playdayStart + index - 1;
                var localHour = (0, _moment2.default)(time).utc().hour(hoursSinceTableStart).local().hour();

                return _this.getTableCell(scheduleItem.type, scheduleItem.vehicle_level, schedules, localHour, peripheriesOrder, index);
            });

            var peripheryOverriddenTooltips = schedules.filter(_schedule.isScheduleDisabledOrOverridden).map(function (schedule) {
                return _react2.default.createElement(_BattleModeAtPeripheryOverriddenTooltip2.default, {
                    id: _this.getPeripheryTooltipId(scheduleItem.type, scheduleItem.vehicle_level, schedule.periphery),
                    isDisabled: !schedule.enabled,
                    peripheryName: schedule.periphery,
                    vehicleLevel: scheduleItem.vehicle_level,
                    battleMode: scheduleItem.type,
                    key: schedule.periphery
                });
            });

            return _react2.default.createElement(
                'div',
                { className: _ScheduleTable2.default.tr, key: index },
                _react2.default.createElement(
                    'div',
                    { className: _ScheduleTable2.default.td_name },
                    name
                ),
                _react2.default.createElement(
                    'div',
                    { className: _ScheduleTable2.default.td_wrapper },
                    cells
                ),
                peripheryOverriddenTooltips
            );
        };

        var formats = _reactWotBootstrap.FormatsManager.getFormats();
        _this.dateFormat = formats.shortDate;

        _this.tableHeadTimeFormat = _moment2.default.localeData()._longDateFormat.LT;
        if (_this.tableHeadTimeFormat.endsWith('A')) {
            // https://jira.wargaming.net/browse/WGSH-3397
            _this.tableHeadTimeFormat = _this.tableHeadTimeFormat.replace(':mm', '');
        }

        _this.getTableHeadTimeCell = _this.getTableHeadTimeCell.bind(_this);
        return _this;
    }

    _createClass(ScheduleTable, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.interval = setInterval(this.tick, 1000);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            clearInterval(this.interval);
        }

        /**
         * we need to have padding of 1 hour before and after the schedule
         * @example
         * this.props.playdayStart = 10
         * this.props.playdayEnd = 11
         * this.getPlayingHours() === [9, 10, 11, 12]
         * @example
         * this.props.playdayStart = 23
         * this.props.playdayEnd = 1
         * this.getPlayingHours() === [22, 23, 0, 1, 2]
         * @returns {int[]} array of hours to render over the schedule grid
         */

    }, {
        key: 'getTableHead',
        value: function getTableHead() {
            var playdayDate = (0, _moment2.default)().add(this.props.selectedPlaydayId, 'day').format(this.dateFormat);
            return _react2.default.createElement(
                'div',
                { className: _ScheduleTable2.default.tableHead },
                _react2.default.createElement(
                    'div',
                    { className: _ScheduleTable2.default.td_name },
                    playdayDate
                ),
                _react2.default.createElement(
                    'div',
                    { className: _ScheduleTable2.default.td_wrapper },
                    this.getPlayingHours().map(this.getTableHeadTimeCell)
                )
            );
        }
    }, {
        key: 'getTableHeadTimeCell',
        value: function getTableHeadTimeCell(utcHour, index) {
            return _react2.default.createElement(
                'div',
                { className: _ScheduleTable2.default.td_time, key: 'td_time_' + utcHour + '_' + index },
                getLocalTimeFromUTCHour(utcHour).format(this.tableHeadTimeFormat)
            );
        }

        /**
         * @param {string} schedule_type
         * @param {string} vehicle_level
         * @param {Object[]} schedules of peripheries for current battle mode
         * @param {int} hour of the cell in utc
         * @param {string[]} peripheriesOrder positions of bars to calculate top offset of the bar
         * @returns {React.Component} schedule table cell with gantt bars of schedules that start at {hour}
         */

    }, {
        key: 'getTableBody',
        value: function getTableBody() {
            var _this2 = this;

            var scheduleItems = this.props.playday.schedule_items.filter(function (scheduleItem) {
                return (0, _schedule.checkScheduleType)(scheduleItem, _this2.props.unitType);
            });

            var sorties = scheduleItems.filter(function (scheduleItem) {
                return scheduleItem.type === 'SORTIE';
            });
            var fortBattles = scheduleItems.filter(function (scheduleItem) {
                return scheduleItem.type === 'FORT_BATTLE';
            });
            var challenges = scheduleItems.filter(function (scheduleItem) {
                return scheduleItem.type === 'CHALLENGE';
            });

            var tableSectionsItems = [sorties, fortBattles, challenges];

            var getTableSection = function getTableSection(scheduleItems, sectionIndex) {
                if (!scheduleItems.length) return null;
                var style = {
                    flexGrow: scheduleItems.length
                };
                var date = (0, _moment2.default)(_this2.props.playday.date).get('date');

                var rows = scheduleItems.filter(function (scheduleItem) {
                    return (0, _schedule.vehicleLevelFilter)(scheduleItem, _this2.props.vehicleLevel);
                }).map(function (scheduleItem, itemIndex) {
                    return _this2.getTableRow(scheduleItem, itemIndex);
                });

                var sectionClassNames = (0, _classnames2.default)(_ScheduleTable2.default.tableSection, _this2.props.type === _constants2.SCHEDULE_TYPES.MAIN_SCHEDULE && _ScheduleTable2.default.tableSection__mainSchedule);

                return _react2.default.createElement(
                    'div',
                    {
                        className: sectionClassNames,
                        key: date + '_tableSection_' + sectionIndex,
                        style: style
                    },
                    rows
                );
            };

            return tableSectionsItems.map(getTableSection);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this,
                _classNames2;

            var scaleStart = this.props.playdayStart - 1;
            var isInsideExpandedPlayday = (0, _schedule.checkTimeInsidePlayday)(this.state.time, this.props.playday.date, scaleStart, this.props.playdayEnd);
            var isBattlesToday = this.props.playday.schedule_items.filter(function (item) {
                return (0, _schedule.vehicleLevelFilter)(item, _this3.props.vehicleLevel);
            }).some(function (item) {
                return (0, _schedule.checkScheduleType)(item, _this3.props.unitType);
            });

            var timeLine = void 0;
            if (isInsideExpandedPlayday && isBattlesToday) timeLine = _react2.default.createElement(_TimeLine2.default, {
                forOneBattleMode: this.props.type === 'oneBattleMode',
                forAllBattleModes: this.props.type === 'allBattleModes',
                scaleStartHour: scaleStart,
                scaleLengthHour: this.getPlaydayLength() + 2,
                now: this.state.time
            });

            var tableBody = void 0;
            if (!isBattlesToday) {
                tableBody = _react2.default.createElement(
                    'div',
                    { className: _ScheduleTable2.default.noBattles },
                    _react2.default.createElement(_NoBattlesMessage2.default, {
                        showDescription: (0, _datetime.isTodayDay)((0, _moment2.default)(this.props.playday.date)),
                        playdays: this.props.playdays,
                        playdayStart: this.props.playdayStart,
                        playdayEnd: this.props.playdayEnd,
                        unitType: this.props.unitType
                    })
                );
            } else {
                tableBody = this.getTableBody();
            }

            var baseClassNames = (0, _classnames2.default)(_ScheduleTable2.default.base, (_classNames2 = {}, _defineProperty(_classNames2, _ScheduleTable2.default.base__with_offset, _constants2.HAS_OFFSET), _defineProperty(_classNames2, _ScheduleTable2.default.forOneBattleMode, this.props.type === 'oneBattleMode'), _defineProperty(_classNames2, _ScheduleTable2.default.forAllBattleModes, this.props.type === 'allBattleModes'), _classNames2));

            return _react2.default.createElement(
                'div',
                { className: baseClassNames },
                this.getTableHead(),
                _react2.default.createElement(
                    'div',
                    { className: _ScheduleTable2.default.tableBody },
                    tableBody
                ),
                timeLine
            );
        }
    }]);

    return ScheduleTable;
}(_react2.default.Component);

ScheduleTable.propTypes = {
    playday: _propTypes2.default.object.isRequired,
    unitType: _propTypes2.default.oneOf(Object.values(_constants.UNIT_TYPES)),
    vehicleLevel: _propTypes2.default.number,
    type: _propTypes2.default.oneOf(Object.values(_constants2.SCHEDULE_TYPES)),

    playdayStart: _propTypes2.default.number.isRequired,
    playdayEnd: _propTypes2.default.number.isRequired,
    playdays: _propTypes2.default.array.isRequired,
    selectedPlaydayId: _propTypes2.default.number.isRequired
};
ScheduleTable.defaultProps = { type: _constants2.SCHEDULE_TYPES.MAIN_SCHEDULE };
var mapStateToProps = exports.mapStateToProps = function mapStateToProps(_ref) {
    var schedule = _ref.schedule;
    return {
        playdayStart: schedule.playday_start,
        playdayEnd: schedule.playday_end,
        playdays: schedule.playdays,
        selectedPlaydayId: schedule.selected_playday_id
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ScheduleTable);


function sortSchedulesByPrimetimeStart(a, b) {
    return a.periods[0][0] - b.periods[0][0];
}

function getLocalTimeFromUTCHour(hour) {
    return _moment2.default.utc().hours(hour).startOf('hour').local();
}

function utcHourToLocal(hour) {
    return _moment2.default.utc().hours(hour).local().hour();
}

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

var _reactWotBootstrap = __webpack_require__(5);

var _constants = __webpack_require__(4);

var _translations = __webpack_require__(77);

var _helpers = __webpack_require__(218);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NoBattlesMessage = function NoBattlesMessage(props) {
    var showDescription = props.showDescription,
        playdays = props.playdays,
        playdayStart = props.playdayStart,
        playdayEnd = props.playdayEnd,
        unitType = props.unitType;

    var currentHour = _moment2.default.utc().hour();

    var message = '';
    if (showDescription) {
        message = (0, _helpers.getNextBattleMessage)(playdays, playdayStart, playdayEnd, unitType, currentHour);
    }

    return _react2.default.createElement(_reactWotBootstrap.EmptyList, { title: _translations.BATTLES_UNAVAILABLE, message: message });
};

NoBattlesMessage.propTypes = {
    showDescription: _propTypes2.default.bool,
    playdays: _propTypes2.default.array,
    playdayStart: _propTypes2.default.number,
    playdayEnd: _propTypes2.default.number,
    unitType: _propTypes2.default.oneOf(Object.values(_constants.UNIT_TYPES))
};

exports.default = NoBattlesMessage;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getNextBattleMessage = getNextBattleMessage;

var _datetime = __webpack_require__(13);

var _translations = __webpack_require__(77);

var _schedule = __webpack_require__(27);

function getNextBattleMessage(playdays, playdayStart, playdayEnd, unitType, currentHour) {
    var closestPrimetimeStart = (0, _schedule.getClosestPrimetimeStart)(playdays, playdayStart, playdayEnd, unitType, currentHour);
    if (!closestPrimetimeStart) return '';
    if ((0, _datetime.isTodayDay)(closestPrimetimeStart.local())) {
        return (0, _translations.ALL_BATTLES_NEXT_PRIMETIME)((0, _datetime.getTodayTime)(closestPrimetimeStart));
    }
    if ((0, _datetime.isTomorrowDay)(closestPrimetimeStart.local())) {
        return (0, _translations.ALL_BATTLES_NEXT_PRIMETIME)((0, _datetime.getTomorrowTime)(closestPrimetimeStart));
    }
    return (0, _translations.ALL_BATTLES_NEXT_PRIMETIME)((0, _datetime.getCustomDateTime)(closestPrimetimeStart));
}

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactWotBootstrap = __webpack_require__(5);

var _constants = __webpack_require__(4);

var _translations = __webpack_require__(220);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BattleModeAtPeripheryOverriddenTooltip = function BattleModeAtPeripheryOverriddenTooltip(props) {
    var message = void 0;
    if (props.battleMode === _constants.SCHEDULE_TYPES.SORTIE) {
        message = (0, _translations.SORTIES_BY_VEHICLE_LEVEL_ON_PERIPHERY_OVERRIDDEN)(props.vehicleLevel, props.peripheryName, props.isDisabled);
    } else {
        message = (0, _translations.FORT_BATTLES_ON_PERIPHERY_OVERRIDDEN)(props.peripheryName, props.isDisabled);
    }
    return _react2.default.createElement(
        _reactWotBootstrap.Tooltip,
        { isWide: true, id: props.id },
        _react2.default.createElement(
            _reactWotBootstrap.TooltipBody,
            null,
            message
        )
    );
};

BattleModeAtPeripheryOverriddenTooltip.propTypes = {
    id: _propTypes2.default.string.isRequired,
    peripheryName: _propTypes2.default.string.isRequired,
    vehicleLevel: _propTypes2.default.number,
    battleMode: _propTypes2.default.string.isRequired,
    isDisabled: _propTypes2.default.bool.isRequired
};

exports.default = BattleModeAtPeripheryOverriddenTooltip;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FORT_BATTLES_ON_PERIPHERY_OVERRIDDEN = exports.SORTIES_BY_VEHICLE_LEVEL_ON_PERIPHERY_OVERRIDDEN = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _helpers = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// SHV2-04-1
var SORTIES_BY_VEHICLE_LEVEL_ON_PERIPHERY_OVERRIDDEN = exports.SORTIES_BY_VEHICLE_LEVEL_ON_PERIPHERY_OVERRIDDEN = function SORTIES_BY_VEHICLE_LEVEL_ON_PERIPHERY_OVERRIDDEN(vehicleLevel, peripheryName, isDisabled) {
    if (isDisabled) return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'schedule.sortie_vl_server_disabled.tooltip',
        defaultMessage: '\u0412\u044B\u043B\u0430\u0437\u043A\u0438 \u0432 {vehicleLevel} \u0434\u0438\u0432\u0438\u0437\u0438\u043E\u043D\u0435 \u043D\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0435 {peripheryName} \u0432 \u044D\u0442\u043E\u0442 \u0434\u0435\u043D\u044C \u043D\u0435 \u043F\u0440\u043E\u0432\u043E\u0434\u044F\u0442\u0441\u044F.',
        values: {
            vehicleLevel: (0, _helpers.toRoman)(vehicleLevel),
            peripheryName: peripheryName
        }
    });
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'schedule.sortie_vl_server_overridden.tooltip',
        defaultMessage: '\u0412\u044B\u043B\u0430\u0437\u043A\u0438 \u0432 {vehicleLevel} \u0434\u0438\u0432\u0438\u0437\u0438\u043E\u043D\u0435 \u043D\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0435 {peripheryName} \u0432 \u044D\u0442\u043E\u0442 \u0434\u0435\u043D\u044C \u043F\u0440\u043E\u0445\u043E\u0434\u044F\u0442 \u043F\u043E \u0438\u0437\u043C\u0435\u043D\u0451\u043D\u043D\u043E\u043C\u0443 \u0440\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u044E.',
        values: {
            vehicleLevel: (0, _helpers.toRoman)(vehicleLevel),
            peripheryName: peripheryName
        }
    });
}; /* eslint-disable react/no-multi-comp,max-len */
var FORT_BATTLES_ON_PERIPHERY_OVERRIDDEN = exports.FORT_BATTLES_ON_PERIPHERY_OVERRIDDEN = function FORT_BATTLES_ON_PERIPHERY_OVERRIDDEN(peripheryName, isDisabled) {
    if (isDisabled) return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'schedule.fort_battles_on_periphery_disabled.tooltip',
        defaultMessage: '\u041D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u044F \u043D\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0435 {peripheryName} \u0432 \u044D\u0442\u043E\u0442 \u0434\u0435\u043D\u044C \u043D\u0435 \u043F\u0440\u043E\u0432\u043E\u0434\u044F\u0442\u0441\u044F.',
        values: { peripheryName: peripheryName }
    });
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'schedule.fort_battles_on_periphery_overridden.tooltip',
        defaultMessage: '\u041D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u044F \u043D\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0435 {peripheryName} \u0432 \u044D\u0442\u043E\u0442 \u0434\u0435\u043D\u044C \u043F\u0440\u043E\u0445\u043E\u0434\u044F\u0442 \u043F\u043E \u0438\u0437\u043C\u0435\u043D\u0451\u043D\u043D\u043E\u043C\u0443 \u0440\u0430\u0441\u043F\u0438\u0441\u0430\u043D\u0438\u044E.',
        values: { peripheryName: peripheryName }
    });
};

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.calcPercentage = calcPercentage;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _schedule = __webpack_require__(27);

var _constants = __webpack_require__(108);

var _TimeLine = __webpack_require__(222);

var _TimeLine2 = _interopRequireDefault(_TimeLine);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TimeLine = function TimeLine(props) {
    var _classNames;

    var scaleLengthHour = props.scaleLengthHour,
        scaleStartHour = props.scaleStartHour,
        now = props.now;

    var timeLinePosition = calcPercentage(scaleStartHour, scaleLengthHour, now) + '%';
    var timeString = (0, _schedule.momentToLocal)(now).format('LT');
    var containerClassNames = (0, _classnames2.default)(_TimeLine2.default.timeLineContainer, (_classNames = {}, _defineProperty(_classNames, _TimeLine2.default.forOneBattleMode, props.forOneBattleMode), _defineProperty(_classNames, _TimeLine2.default.forAllBattleModes, props.forAllBattleModes), _classNames));
    var timeValueClassNames = (0, _classnames2.default)(_TimeLine2.default.timeValue, _defineProperty({}, _TimeLine2.default.timeValue__with_offset, _constants.HAS_OFFSET));

    return _react2.default.createElement(
        'div',
        { className: containerClassNames },
        _react2.default.createElement(
            'div',
            { className: _TimeLine2.default.base, style: { left: timeLinePosition } },
            _react2.default.createElement(
                'span',
                { className: timeValueClassNames },
                timeString
            ),
            _react2.default.createElement('div', { className: _TimeLine2.default.timeLine }),
            _react2.default.createElement('div', { className: _TimeLine2.default.headerHalo }),
            _react2.default.createElement('div', { className: _TimeLine2.default.footerHalo })
        )
    );
};

TimeLine.propTypes = {
    forOneBattleMode: _propTypes2.default.bool,
    forAllBattleModes: _propTypes2.default.bool,
    scaleLengthHour: _propTypes2.default.number,
    scaleStartHour: _propTypes2.default.number,
    now: _propTypes2.default.instanceOf(_moment2.default)
};

exports.default = TimeLine;
function calcPercentage(scaleStartHour, scaleLengthHour, now) {
    var startTime = (0, _moment2.default)(now).utc().hour(scaleStartHour).local().startOf('hour');
    if (startTime > now) startTime.subtract(1, 'days');
    var duration = _moment2.default.duration(scaleLengthHour, 'hours');
    var secondsPassed = now.diff(startTime, 'seconds');
    return secondsPassed * 100 / duration.asSeconds();
}

/***/ }),
/* 222 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"timeLineContainer":"TimeLine_timeLineContainer--3M99n","forOneBattleMode":"TimeLine_forOneBattleMode--2o12m","timeValue":"TimeLine_timeValue--3CiiT","forAllBattleModes":"TimeLine_forAllBattleModes--1_n_t","base":"TimeLine_base--3l0df","timeValue__with_offset":"TimeLine_timeValue__with_offset--3DFWr","timeValueWithOffset":"TimeLine_timeValue__with_offset--3DFWr","timeLine":"TimeLine_timeLine--s-dXO","headerHalo":"TimeLine_headerHalo--lgRT1","footerHalo":"TimeLine_footerHalo--2rupc"};

/***/ }),
/* 223 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"ScheduleTable_base--1Vuom","base__with_offset":"ScheduleTable_base__with_offset--5ZTP4","baseWithOffset":"ScheduleTable_base__with_offset--5ZTP4","forOneBattleMode":"ScheduleTable_forOneBattleMode--_qD1c","tableHead":"ScheduleTable_tableHead--12nm-","tableBody":"ScheduleTable_tableBody--AISb0","forAllBattleModes":"ScheduleTable_forAllBattleModes--3afwC","td_name":"ScheduleTable_td_name--23pwM","tdName":"ScheduleTable_td_name--23pwM","tableSection":"ScheduleTable_tableSection--1-awT","tr":"ScheduleTable_tr--3YwtV","tableSection__mainSchedule":"ScheduleTable_tableSection__mainSchedule--1IWN8","tableSectionMainSchedule":"ScheduleTable_tableSection__mainSchedule--1IWN8","td_name__disabled":"ScheduleTable_td_name__disabled--1xbY4","tdNameDisabled":"ScheduleTable_td_name__disabled--1xbY4","td_time":"ScheduleTable_td_time--54Xqh","tdTime":"ScheduleTable_td_time--54Xqh","td_wrapper":"ScheduleTable_td_wrapper--2vaZy","tdWrapper":"ScheduleTable_td_wrapper--2vaZy","td":"ScheduleTable_td--2xMVP","td_inner":"ScheduleTable_td_inner--165WD","tdInner":"ScheduleTable_td_inner--165WD","bar":"ScheduleTable_bar--2fSUa","bar__sortie":"ScheduleTable_bar__sortie--2XMuM","barSortie":"ScheduleTable_bar__sortie--2XMuM","bar__fort_battle":"ScheduleTable_bar__fort_battle--2czHL","barFortBattle":"ScheduleTable_bar__fort_battle--2czHL","bar__challenge":"ScheduleTable_bar__challenge--1AdOJ","barChallenge":"ScheduleTable_bar__challenge--1AdOJ","bar__disabled":"ScheduleTable_bar__disabled--3UyAH","barDisabled":"ScheduleTable_bar__disabled--3UyAH","bar__overridden":"ScheduleTable_bar__overridden--2V7Kh","barOverridden":"ScheduleTable_bar__overridden--2V7Kh","warningIcon":"ScheduleTable_warningIcon--1xynw","barName":"ScheduleTable_barName--29j2U","barName__challenge":"ScheduleTable_barName__challenge--1lFVX","barNameChallenge":"ScheduleTable_barName__challenge--1lFVX","noBattles":"ScheduleTable_noBattles--3qnzy"};

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AVAILABLE_INTERIM_BEFORE_PRIME = exports.GO_TO_ANOTHER_SERVER = exports.VEHICLES_NOT_SELECTED = exports.VEHICLES_NOT_READY = exports.START_PLAYERS_MATCHING = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-multi-comp */
var START_PLAYERS_MATCHING = exports.START_PLAYERS_MATCHING = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'players_matching.start',
    defaultMessage: '\u0412 \u0431\u043E\u0439!'
});

var VEHICLES_NOT_READY = exports.VEHICLES_NOT_READY = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'players_matching.vehicles_not_ready',
    defaultMessage: '\u0412\u044B\u0431\u0440\u0430\u043D\u043D\u0430\u044F \u0442\u0435\u0445\u043D\u0438\u043A\u0430 \u043D\u0435 \u0433\u043E\u0442\u043E\u0432\u0430 \u043A \u0431\u043E\u044E'
});

var VEHICLES_NOT_SELECTED = exports.VEHICLES_NOT_SELECTED = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'players_matching.vehicles_not_selected',
    defaultMessage: '\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0442\u0435\u0445\u043D\u0438\u043A\u0443, \u043D\u0430 \u043A\u043E\u0442\u043E\u0440\u043E\u0439 \u0441\u043E\u0431\u0438\u0440\u0430\u0435\u0442\u0435\u0441\u044C \u0432\u044B\u0439\u0442\u0438 \u0432 \u0431\u043E\u0439'
});

var GO_TO_ANOTHER_SERVER = exports.GO_TO_ANOTHER_SERVER = function GO_TO_ANOTHER_SERVER(peripheryNames) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'players_matching.go_to_another_server',
        defaultMessage: '\u041F\u0435\u0440\u0435\u0439\u0434\u0438\u0442\u0435 \u043D\u0430 \u0441\u0435\u0440\u0432\u0435\u0440 {peripheryNames}',
        values: { peripheryNames: peripheryNames }
    });
};

var AVAILABLE_INTERIM_BEFORE_PRIME = exports.AVAILABLE_INTERIM_BEFORE_PRIME = function AVAILABLE_INTERIM_BEFORE_PRIME(minutes) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'players_matching.available_interim_before_prime',
        defaultMessage: '\u041D\u0430\u0447\u0430\u0442\u044C \u043F\u043E\u0434\u0431\u043E\u0440 \u043E\u0442\u0440\u044F\u0434\u0430 \u043C\u043E\u0436\u043D\u043E \u0437\u0430 {minutes} \u043C\u0438\u043D. \u0434\u043E \u043D\u0430\u0447\u0430\u043B\u0430 \u0441\u0440\u0430\u0436\u0435\u043D\u0438\u0439',
        values: { minutes: minutes }
    });
};

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _NavigationArrow = __webpack_require__(59);

var _NavigationArrow2 = _interopRequireDefault(_NavigationArrow);

var _KineticScrolling = __webpack_require__(462);

var _KineticScrolling2 = _interopRequireDefault(_KineticScrolling);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TIME_CONSTANT = 325;

var KineticScrolling = function (_React$Component) {
    _inherits(KineticScrolling, _React$Component);

    function KineticScrolling(props) {
        _classCallCheck(this, KineticScrolling);

        var _this = _possibleConstructorReturn(this, (KineticScrolling.__proto__ || Object.getPrototypeOf(KineticScrolling)).call(this, props));

        _this.state = {
            pressed: false,
            reference: null,
            offset: 0,
            min: 0,
            max: 0,
            dragging: false
        };

        _this.prev = _this.prev.bind(_this);
        _this.next = _this.next.bind(_this);

        _this.handleTap = _this.handleTap.bind(_this);
        _this.handleDrag = _this.handleDrag.bind(_this);
        _this.handleRelease = _this.handleRelease.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        _this.handleWheel = _this.handleWheel.bind(_this);
        _this.handleResize = _this.handleResize.bind(_this);

        _this.autoScroll = _this.autoScroll.bind(_this);
        _this.scrollToItem = _this.scrollToItem.bind(_this);
        _this.update = _this.update.bind(_this);
        return _this;
    }

    _createClass(KineticScrolling, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.update();

            window.addEventListener('resize', this.handleResize);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('resize', this.handleResize);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (this.props.children.length !== prevProps.children.length) {
                this.update();
            }
        }
    }, {
        key: 'update',
        value: function update() {
            var _this2 = this;

            var max = this._view.offsetWidth - this._holder.offsetWidth;
            this.setState({ max: max }, function () {
                return _this2.scroll(_this2.state.offset);
            });
        }
    }, {
        key: 'pos',
        value: function pos(e) {
            // touch event
            var clientPos = 'clientX';
            if (e.targetTouches && e.targetTouches.length >= 1) {
                return e.targetTouches[0][clientPos];
            }

            // mouse event
            return e[clientPos];
        }
    }, {
        key: 'scroll',
        value: function scroll(x) {
            var offset = Math.min(Math.max(x, this.state.min), this.state.max); // clamp

            this.setState({ offset: offset });
            this.trackState();
        }
    }, {
        key: 'track',
        value: function track() {
            var now = Date.now();
            var elapsed = now - this.state.timestamp;
            this.setState({
                timestamp: now
            });
            var delta = this.state.offset - this.state.frame;
            var v = 1000 * delta / (1 + elapsed);

            this.setState({
                frame: this.state.offset,
                velocity: 0.8 * v + 0.2 * this.state.velocity
            });
        }
    }, {
        key: 'autoScroll',
        value: function autoScroll() {
            var elapsed = void 0;
            var delta = void 0;

            if (this.state.amplitude) {
                elapsed = Date.now() - this.state.timestamp;
                delta = this.state.amplitude * Math.exp(-elapsed / TIME_CONSTANT);

                if (delta > 5 || delta < -5) {
                    this.scroll(this.state.target - delta);
                    requestAnimationFrame(this.autoScroll);
                } else {
                    this.scroll(this.state.target);
                }
            }
        }
    }, {
        key: 'scrollToItem',
        value: function scrollToItem(idx) {
            if (this.props.snap) {
                var target = idx * this.props.snap;
                var amplitude = target - this.state.offset;

                this.setState({
                    target: target,
                    amplitude: amplitude,
                    timestamp: Date.now(),
                    enableTransitions: true
                });

                this.scroll(target);
            }
        }
    }, {
        key: 'prev',
        value: function prev() {
            if (this.props.snap) {
                this.scrollToItem(this.current() - 1);
            }
        }
    }, {
        key: 'next',
        value: function next() {
            if (this.props.snap) {
                this.scrollToItem(this.current() + 1);
            }
        }
    }, {
        key: 'current',
        value: function current() {
            var current = void 0;
            if (this.state.offset === 0) {
                current = 0;
            } else {
                current = Math.round(this.state.offset / this.props.snap);
            }
            return current;
        }
    }, {
        key: 'atBegin',
        value: function atBegin() {
            return this.state.offset === 0;
        }
    }, {
        key: 'atEnd',
        value: function atEnd() {
            return this.state.offset === this.state.max;
        }
    }, {
        key: 'handleTap',
        value: function handleTap(e) {
            this.setState({
                pressed: true,
                reference: this.pos(e),
                velocity: 0,
                amplitude: 0,
                timestamp: Date.now(),
                frame: this.state.offset
            });

            clearInterval(this.ticker);
            var boundTrack = this.track.bind(this);
            this.ticker = setInterval(boundTrack, 100);

            this.trackState();

            window.addEventListener('mousemove', this.handleDrag);
            window.addEventListener('mouseup', this.handleRelease);

            e.preventDefault();
            e.stopPropagation();
            return false;
        }
    }, {
        key: 'handleDrag',
        value: function handleDrag(e) {
            var x = void 0;
            var delta = void 0;

            if (this.state.pressed) {
                x = this.pos(e);
                delta = this.state.reference - x;

                if (delta > 2 || delta < -2) {
                    this.setState({
                        reference: x,
                        dragging: true,
                        enableTransitions: false
                    });

                    this.scroll(this.state.offset + delta);
                }
            }

            e.preventDefault();
            e.stopPropagation();
            return false;
        }
    }, {
        key: 'handleRelease',
        value: function handleRelease(e) {
            window.removeEventListener('mousemove', this.handleDrag);
            window.removeEventListener('mouseup', this.handleRelease);

            this.setState({
                pressed: false
            });

            clearInterval(this.ticker);

            if (!this.state.dragging) return;

            var amplitude = void 0;
            var target = this.state.offset;

            if (this.state.velocity > 10 || this.state.velocity < -10) {
                amplitude = 0.2 * this.state.velocity;
                target = Math.round(this.state.offset + amplitude);
            }

            target = Math.round(target / this.props.snap) * this.props.snap;
            amplitude = target - this.state.offset;

            this.setState({
                target: target,
                amplitude: amplitude,
                timestamp: Date.now()
            });

            this.autoScroll();
            if (!e.currentTarget.getAttribute || e.currentTarget.getAttribute('id') !== this._view.id) {
                this.setState({
                    dragging: false
                });
            }
        }
    }, {
        key: 'handleWheel',
        value: function handleWheel(e) {

            if (this.props.snap) {
                if (e.deltaY > 0) {
                    this.next();
                } else {
                    this.prev();
                }
                return;
            }

            var target = this.state.offset + e.deltaY;

            var amplitude = target - this.state.offset;

            this.setState({
                target: target,
                amplitude: amplitude,
                timestamp: Date.now(),
                enableTransitions: false
            });

            this.autoScroll();
        }
    }, {
        key: 'handleClick',
        value: function handleClick() {
            this.setState({
                dragging: false
            });
        }
    }, {
        key: 'handleResize',
        value: function handleResize() {
            this.update();
        }
    }, {
        key: 'trackState',
        value: function trackState() {
            if (this.props.trackState) {
                this.props.trackState({
                    dragging: this.state.dragging
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames,
                _this3 = this;

            var transform = 'translateX(-' + this.state.offset + 'px)';

            var wrapperClassName = (0, _classnames2.default)(_KineticScrolling2.default.wrapper, (_classNames = {}, _defineProperty(_classNames, _KineticScrolling2.default.scrolledLeft, !this.atBegin()), _defineProperty(_classNames, _KineticScrolling2.default.scrolledRight, !this.atEnd()), _classNames));

            return _react2.default.createElement(
                'div',
                { className: _KineticScrolling2.default.base },
                _react2.default.createElement(
                    'div',
                    { className: _KineticScrolling2.default.arrow },
                    _react2.default.createElement(_NavigationArrow2.default, {
                        type: 'left',
                        handleClick: this.prev,
                        disabled: this.atBegin()
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: wrapperClassName, ref: function ref(_) {
                            return _this3._holder = _;
                        } },
                    _react2.default.createElement(
                        'div',
                        {
                            ref: function ref(_) {
                                return _this3._view = _;
                            },
                            style: { transform: transform },
                            className: _KineticScrolling2.default.view,
                            onMouseDown: this.handleTap,
                            onMouseUp: this.handleRelease,
                            onClick: this.handleClick,
                            onWheel: this.handleWheel
                        },
                        this.props.children
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _KineticScrolling2.default.arrow },
                    _react2.default.createElement(_NavigationArrow2.default, {
                        type: 'right',
                        handleClick: this.next,
                        disabled: this.atEnd()
                    })
                )
            );
        }
    }]);

    return KineticScrolling;
}(_react2.default.Component);

KineticScrolling.propTypes = {
    children: _propTypes2.default.arrayOf(_propTypes2.default.node).isRequired,
    snap: _propTypes2.default.number,
    trackState: _propTypes2.default.func
};
exports.default = KineticScrolling;

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PLAYERS_MATCHING_AVAILABLE_ONLY_ON_THIS_BATTLEMODE = exports.FIGHT_IN_SORTIES_BY_LEVEL = exports.TIME_TO_BATTLES_END = exports.TIME_TO_BATTLES_START = exports.VEHICLE_NOT_READY = exports.REMOVE_VEHICLE_TOOLTIP = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-multi-comp */
var REMOVE_VEHICLE_TOOLTIP = exports.REMOVE_VEHICLE_TOOLTIP = {
    id: 'remove_vehicle_tooltip',
    message: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'remove_vehicle_tooltip',
        defaultMessage: '\u0423\u0431\u0440\u0430\u0442\u044C \u044D\u0442\u0443 \u043C\u0430\u0448\u0438\u043D\u0443 \u0438\u0437 \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u0439 \u0434\u043B\u044F \u0441\u0440\u0430\u0436\u0435\u043D\u0438\u0439 \u0442\u0435\u0445\u043D\u0438\u043A\u0438.'
    })
};

var VEHICLE_NOT_READY = exports.VEHICLE_NOT_READY = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'vehicle_not_ready',
    defaultMessage: '\u041D\u0435 \u0433\u043E\u0442\u043E\u0432\u0430 \u043A \u0431\u043E\u044E'
});

var TIME_TO_BATTLES_START = exports.TIME_TO_BATTLES_START = function TIME_TO_BATTLES_START(value) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'time_to_battles_start',
        defaultMessage: '\u0414\u043E \u043D\u0430\u0447\u0430\u043B\u0430 \u0441\u0440\u0430\u0436\u0435\u043D\u0438\u0439: {value}',
        values: { value: value }
    });
};

var TIME_TO_BATTLES_END = exports.TIME_TO_BATTLES_END = function TIME_TO_BATTLES_END(value) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'time_to_battles_end',
        defaultMessage: '\u0414\u043E \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0441\u0440\u0430\u0436\u0435\u043D\u0438\u0439: {value}',
        values: { value: value }
    });
};

var FIGHT_IN_SORTIES_BY_LEVEL = exports.FIGHT_IN_SORTIES_BY_LEVEL = function FIGHT_IN_SORTIES_BY_LEVEL(level) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'players_matching.fight_in_sorties_by_level',
        defaultMessage: '\u0421\u0440\u0430\u0436\u0430\u0442\u044C\u0441\u044F \u043B\u0435\u0433\u0438\u043E\u043D\u0435\u0440\u043E\u043C \u0432 \u0440\u0435\u0436\u0438\u043C\u0435 \u0412\u044B\u043B\u0430\u0437\u043A\u0438 {level}',
        values: { level: level }
    });
};

var PLAYERS_MATCHING_AVAILABLE_ONLY_ON_THIS_BATTLEMODE = exports.PLAYERS_MATCHING_AVAILABLE_ONLY_ON_THIS_BATTLEMODE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'players_matching_available_only_on_this_battle_mode',
    defaultMessage: '\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u043F\u043E\u0434\u0431\u043E\u0440 \u043E\u0442\u0440\u044F\u0434\u0430 \u0434\u043E\u0441\u0442\u0443\u043F\u0435\u043D \u0442\u043E\u043B\u044C\u043A\u043E \u0432 \u044D\u0442\u043E\u043C \u0440\u0435\u0436\u0438\u043C\u0435.'
});

/***/ }),
/* 227 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"PlayersMatchingView_base--3YV9H","base__nonClanMember":"PlayersMatchingView_base__nonClanMember--2g6_1","baseNonClanMember":"PlayersMatchingView_base__nonClanMember--2g6_1","battleModeTabs":"PlayersMatchingView_battleModeTabs--dLcUz","header":"PlayersMatchingView_header--1OZim","main":"PlayersMatchingView_main--2LXzQ","wrapper":"PlayersMatchingView_wrapper--1M-VH","ownClanUnitsHolder":"PlayersMatchingView_ownClanUnitsHolder--18rfU","title":"PlayersMatchingView_title--2jkZO","noOwnClanUnits":"PlayersMatchingView_noOwnClanUnits--J1STn","vehiclesFilter":"PlayersMatchingView_vehiclesFilter--2b1hi","submitButton":"PlayersMatchingView_submitButton--dqCDd","noVehiclesMessages":"PlayersMatchingView_noVehiclesMessages--3D7wC","selectedVehiclesCounter":"PlayersMatchingView_selectedVehiclesCounter--13jIr","highlight":"PlayersMatchingView_highlight--d364x","error":"PlayersMatchingView_error--2PZEF","resetSelectedVehiclesButton":"PlayersMatchingView_resetSelectedVehiclesButton--moYEo","infoIcon":"PlayersMatchingView_infoIcon--yOGm8","vehiclesNotSelectedMessage":"PlayersMatchingView_vehiclesNotSelectedMessage--2n8KQ","availableDuringChallenges":"PlayersMatchingView_availableDuringChallenges--16154","battleRoomsButton":"PlayersMatchingView_battleRoomsButton--25NSz"};

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactWotBootstrap = __webpack_require__(5);

var _constants = __webpack_require__(4);

var _constants2 = __webpack_require__(44);

var _ArenaTooltip = __webpack_require__(146);

var _ArenaTooltip2 = _interopRequireDefault(_ArenaTooltip);

var _LoadingScreen = __webpack_require__(29);

var _LoadingScreen2 = _interopRequireDefault(_LoadingScreen);

var _IndustrialResourceCoefTooltip = __webpack_require__(163);

var _IndustrialResourceCoefTooltip2 = _interopRequireDefault(_IndustrialResourceCoefTooltip);

var _components = __webpack_require__(69);

var _peripheries = __webpack_require__(37);

var _i18n = __webpack_require__(10);

var _BattleWizard = __webpack_require__(521);

var _BattleWizard2 = _interopRequireDefault(_BattleWizard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BattleWizard = function (_React$Component) {
    _inherits(BattleWizard, _React$Component);

    function BattleWizard(props) {
        _classCallCheck(this, BattleWizard);

        var _this = _possibleConstructorReturn(this, (BattleWizard.__proto__ || Object.getPrototypeOf(BattleWizard)).call(this, props));

        _this.update(props);
        return _this;
    }

    _createClass(BattleWizard, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.update(nextProps);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.clearTimeouts();
        }
    }, {
        key: 'update',
        value: function update() {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

            if (!props.loaded || props.loading) return;

            var nextUpdateAt = props.expiresAt;
            if (nextUpdateAt <= Date.now()) return;

            var timeout = nextUpdateAt - Date.now();

            this.clearTimeouts();
            this.timeoutId = setTimeout(props.requestInfo, timeout);
        }
    }, {
        key: 'clearTimeouts',
        value: function clearTimeouts() {
            if (this.timeoutId) clearTimeout(this.timeoutId);
        }
    }, {
        key: 'getSortiesContent',
        value: function getSortiesContent() {
            var _this2 = this;

            var _props$sorties = this.props.sorties,
                battleModes = _props$sorties.battle_modes,
                peripheries = _props$sorties.peripheries,
                primetimeStart = _props$sorties.primetimeStart,
                primetimeEnd = _props$sorties.primetimeEnd;


            var periphery = (0, _peripheries.getPeripheryById)(peripheries, this.props.peripheryId);

            var peripheryPrimetimeStart = periphery && periphery.primetime_start;

            var peripheryName = periphery !== undefined ? periphery.name : null;

            var msecondsToStart = primetimeStart ? primetimeStart - Date.now() : null;
            var msecondsToEnd = primetimeEnd ? primetimeEnd - Date.now() : null;

            var primetimeInProgress = msecondsToStart === null && msecondsToEnd !== null && msecondsToEnd < Date.now();
            var primetimeStartsSoon = msecondsToStart !== null && msecondsToStart <= _constants.SORTIES_START_INTERIM;
            var isAvailable = battleModes.length > 0 && (primetimeInProgress || primetimeStartsSoon);

            if (!isAvailable) return {
                content: _react2.default.createElement(_components.UnavailableBattle, {
                    type: _constants.UNIT_TYPES.SORTIE,
                    peripheries: peripheries,
                    peripheryName: peripheryName,
                    primetimeStart: peripheryPrimetimeStart
                }),
                tooltips: null
            };

            var getTooltipId = function getTooltipId(division) {
                return 'sortie-division-' + division + '-tooltip';
            };
            var getIsSortieSelected = function getIsSortieSelected(division) {
                if (!_this2.props.unitInfo) return false;
                return _this2.props.unitInfo.type === 'SORTIE' && _this2.props.unitInfo.battle_mode === division;
            };
            var tooltips = battleModes.map(function (_ref) {
                var division = _ref.division;
                return _react2.default.createElement(_components.SortieTooltip, {
                    key: getTooltipId(division),
                    tooltipId: getTooltipId(division),
                    division: division,
                    isSelected: getIsSortieSelected(division),
                    isRebuild: _this2.props.isRebuild
                });
            });

            var buttons = battleModes.map(function (item) {
                var handleClick = getIsSortieSelected(item.division) ? _this2.props.closeWindow : _this2.props.submit.bind(null, 'SORTIE', item.division, null);
                return _react2.default.createElement(_components.WizardButton, {
                    key: 'sorties-button-' + item.type,
                    handleClick: handleClick
                    // WGSH-2679 pass max vehicle level instead of division. Modify level component
                    , iconComponent: _react2.default.createElement(_components.Level, { level: item.division, tooltipId: getTooltipId(item.division) }),
                    contentComponent: _react2.default.createElement(_components.Options, { battleRegulations: item }),
                    rewardComponent: _react2.default.createElement(_components.Reward, { value: item.reward, valueTooltipId: _constants2.STATIC_TOOLTIPS_ID.sortie_reward }),
                    isSelected: getIsSortieSelected(item.division)
                });
            });

            return {
                content: _react2.default.createElement(
                    _components.Battle,
                    {
                        type: _constants.UNIT_TYPES.SORTIE,
                        primetimeStart: primetimeStart,
                        primetimeEnd: primetimeEnd
                    },
                    buttons
                ),
                tooltips: tooltips
            };
        }
    }, {
        key: 'getFortBattlesContent',
        value: function getFortBattlesContent() {
            var _this3 = this;

            var _props$fortBattles = this.props.fortBattles,
                directions = _props$fortBattles.directions,
                secondsToNextMatchMaker = _props$fortBattles.seconds_to_next_match_maker,
                peripheries = _props$fortBattles.peripheries,
                battleMode = _props$fortBattles.battle_mode;


            var msecondsToMatchMaker = secondsToNextMatchMaker ? secondsToNextMatchMaker * 1000 : null;
            var isAvailable = msecondsToMatchMaker !== null && msecondsToMatchMaker > 0 && msecondsToMatchMaker <= _constants.FORT_BATTLES_START_INTERIM;
            var periphery = (0, _peripheries.getPeripheryById)(peripheries, this.props.peripheryId);

            var peripherySchedule = periphery ? periphery.matchmaker_ticks : [];

            var peripheryName = periphery ? periphery.name : null;

            var isFine = this.props.clanIndustrialResource < 0;
            if (!isAvailable || isFine) {
                var primetimeStart = peripherySchedule.find(function (tick) {
                    return tick > Date.now();
                });

                return {
                    content: _react2.default.createElement(_components.UnavailableBattle, {
                        type: _constants.UNIT_TYPES.FORT_BATTLE,
                        peripheries: peripheries,
                        peripheryName: peripheryName,
                        primetimeStart: primetimeStart || null,
                        isFine: isFine
                    }),
                    tooltips: null
                };
            }

            var getButtonTooltipId = function getButtonTooltipId(direction) {
                return 'fort-battle-direction-' + direction + '-tooltip';
            };
            var getRewardTooltipId = function getRewardTooltipId(direction) {
                return 'fort-battle-direction-' + direction + '-reward-tooltip';
            };
            var getIsFortBattleSelected = function getIsFortBattleSelected(direction) {
                if (!_this3.props.unitInfo) return false;
                return _this3.props.unitInfo.type === 'FORT_BATTLE' && _this3.props.unitInfo.direction === direction;
            };

            var buttons = void 0;
            var tooltips = void 0;
            if (directions !== null) {
                buttons = directions.map(function (item) {
                    var isSelected = getIsFortBattleSelected(item.direction);
                    var iconComponent = _react2.default.createElement(_components.Direction, {
                        key: 'icon-' + item.direction,
                        direction: item.direction,
                        bonus: item.is_first_fort_battle_on_direction,
                        battle: item.is_engaged && !isSelected,
                        tooltipId: item.is_engaged ? null : getButtonTooltipId(item.direction),
                        isSelected: isSelected
                    });
                    var rewardComponent = _react2.default.createElement(_components.Reward, {
                        value: item.max_reward,
                        perBattleReward: battleMode.reward,
                        valueTooltipId: item.is_engaged ? null : getRewardTooltipId(item.direction),
                        perBattleTooltipId: item.is_engaged ? null : _constants2.STATIC_TOOLTIPS_ID.per_battle,
                        bonus: item.is_first_fort_battle_on_direction
                    });
                    var handleClick = _this3.props.submit.bind(null, 'FORT_BATTLE', null, item.direction);
                    if (isSelected) {
                        handleClick = _this3.props.closeWindow;
                    } else if (item.is_engaged) {
                        handleClick = null;
                    }

                    return _react2.default.createElement(_components.WizardButton, {
                        key: 'fort-battle-button-' + item.direction,
                        handleClick: handleClick,
                        iconComponent: iconComponent,
                        contentComponent: _react2.default.createElement(_components.Arenas, { arenas: item.arenas, direction: item.direction }),
                        rewardComponent: rewardComponent,
                        bonus: item.is_first_fort_battle_on_direction,
                        battle: item.is_engaged && !isSelected,
                        isSelected: isSelected,
                        tooltipId: item.is_engaged ? getButtonTooltipId(item.direction) : null
                    });
                });

                tooltips = directions.reduce(function (initial, item) {
                    var arenas = item.arenas,
                        direction = item.direction;


                    var arenaTooltips = arenas.map(function (arena, idx) {
                        var tooltipId = 'arena-' + direction + '-' + idx + '-tooltip';
                        return _react2.default.createElement(_ArenaTooltip2.default, {
                            key: tooltipId,
                            tooltipId: tooltipId,
                            point: idx,
                            direction: direction,
                            arena: arena
                        });
                    });
                    var buttonTooltip = _react2.default.createElement(_components.FortBattleTooltip, {
                        tooltipId: getButtonTooltipId(direction),
                        key: getButtonTooltipId(direction),
                        direction: direction,
                        bonus: item.is_first_fort_battle_on_direction,
                        battle: item.is_engaged,
                        isSelected: getIsFortBattleSelected(direction),
                        isRebuild: _this3.props.isRebuild
                    });
                    var tooltipText = item.is_first_fort_battle_on_direction ? _constants2.BATTLE_WIZARD_REWARD_TOOLTIP_X2 : _constants2.BATTLE_WIZARD_REWARD_TOOLTIP;
                    var rewardValueTooltip = _react2.default.createElement(
                        _reactWotBootstrap.Tooltip,
                        {
                            isWide: true,
                            id: getRewardTooltipId(direction),
                            key: getRewardTooltipId(direction)
                        },
                        _react2.default.createElement(
                            'div',
                            { className: _BattleWizard2.default.tooltipContent },
                            _react2.default.createElement(
                                'p',
                                { className: _BattleWizard2.default.tooltipMessage },
                                tooltipText
                            )
                        )
                    );

                    var tooltipsSet = item.is_engaged ? [buttonTooltip] : [].concat(_toConsumableArray(arenaTooltips), [buttonTooltip, rewardValueTooltip]);

                    return [].concat(_toConsumableArray(initial), _toConsumableArray(tooltipsSet));
                }, []);
            }

            return {
                content: _react2.default.createElement(
                    _components.Battle,
                    {
                        type: _constants.UNIT_TYPES.FORT_BATTLE,
                        battleRegulations: battleMode,
                        primetimeStart: msecondsToMatchMaker + Date.now(),
                        schedule: peripherySchedule
                    },
                    buttons
                ),
                tooltips: tooltips
            };
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.props.loaded || this.props.loading) return _react2.default.createElement(
                'div',
                { className: _BattleWizard2.default.base },
                _react2.default.createElement(_LoadingScreen2.default, { type: 'window' })
            );

            var _getSortiesContent = this.getSortiesContent(),
                sortiesContent = _getSortiesContent.content,
                sortiesTooltips = _getSortiesContent.tooltips;

            var _getFortBattlesConten = this.getFortBattlesContent(),
                fortBattlesContent = _getFortBattlesConten.content,
                fortBattleTooltips = _getFortBattlesConten.tooltips;

            var staticTooltips = Object.keys(_constants2.STATIC_TOOLTIPS_ID).map(function (item) {
                return _react2.default.createElement(
                    _components.WizardDefaultTooltip,
                    { key: _constants2.STATIC_TOOLTIPS_ID[item], tooltipId: _constants2.STATIC_TOOLTIPS_ID[item] },
                    _react2.default.createElement(
                        'p',
                        null,
                        _constants2.STATIC_TOOLTIPS_MESSAGES[item]
                    )
                );
            });

            return _react2.default.createElement(
                'div',
                { className: _BattleWizard2.default.base },
                this.props.industrialResourceMultiplier > 1 && _react2.default.createElement(
                    'div',
                    { className: _BattleWizard2.default.multiplier, 'data-tip': true, 'data-for': _IndustrialResourceCoefTooltip2.default.id },
                    (0, _i18n.INDUSTRIAL_RESOURCE_MULTIPLIER_TEXT)(_react2.default.createElement(
                        'span',
                        { className: _BattleWizard2.default.multiplierValue },
                        (0, _i18n.INDUSTRIAL_RESOURCE_MULTIPLIER)(this.props.industrialResourceMultiplier)
                    ), true)
                ),
                this.props.industrialResourceMultiplier > 1 && _react2.default.createElement(_IndustrialResourceCoefTooltip2.default, { multiplier: this.props.industrialResourceMultiplier }),
                _react2.default.createElement(
                    'div',
                    { className: _BattleWizard2.default.holder },
                    _react2.default.createElement(
                        'div',
                        { className: _BattleWizard2.default.part },
                        _react2.default.createElement(
                            'div',
                            { className: _BattleWizard2.default.inner },
                            sortiesContent
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _BattleWizard2.default.part },
                        _react2.default.createElement(
                            'div',
                            { className: _BattleWizard2.default.inner },
                            fortBattlesContent
                        )
                    )
                ),
                _react2.default.createElement(_components.BattleTitleTooltip, {
                    type: _constants.UNIT_TYPES.SORTIE,
                    peripheries: this.props.sorties.peripheries,
                    showSchedule: this.props.showSchedule
                }),
                _react2.default.createElement(_components.BattleTitleTooltip, {
                    type: _constants.UNIT_TYPES.FORT_BATTLE,
                    peripheries: this.props.fortBattles.peripheries,
                    showSchedule: this.props.showSchedule
                }),
                sortiesTooltips,
                fortBattleTooltips,
                staticTooltips
            );
        }
    }]);

    return BattleWizard;
}(_react2.default.Component);

BattleWizard.propTypes = {
    clanIndustrialResource: _propTypes2.default.number,
    loaded: _propTypes2.default.bool.isRequired,
    loading: _propTypes2.default.bool.isRequired,
    fortBattles: _propTypes2.default.object.isRequired,
    sorties: _propTypes2.default.object.isRequired,
    peripheryId: _propTypes2.default.number.isRequired,
    unitInfo: _propTypes2.default.object,
    isRebuild: _propTypes2.default.bool,
    showSchedule: _propTypes2.default.bool,
    industrialResourceMultiplier: _propTypes2.default.number.isRequired,

    submit: _propTypes2.default.func.isRequired,
    closeWindow: _propTypes2.default.func
};
exports.default = BattleWizard;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ARENA_EXCLUDED = exports.ARENA_TOOLTIP_BATTLE_MAP = exports.ARENA_TOOLTIP_DIRECTION = exports.ARENA_TOOLTIP_TITLE = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-multi-comp */
var ARENA_TOOLTIP_TITLE = exports.ARENA_TOOLTIP_TITLE = [_react2.default.createElement(_reactIntl.FormattedMessage, {
    key: 'arena_tooltip.point.1',
    id: 'arena_tooltip.point.1',
    defaultMessage: '\u041F\u0435\u0440\u0435\u0434\u043E\u0432\u043E\u0439 \u0440\u0443\u0431\u0435\u0436'
}), _react2.default.createElement(_reactIntl.FormattedMessage, {
    key: 'arena_tooltip.point.2',
    id: 'arena_tooltip.point.2',
    defaultMessage: '\u0417\u0430\u043F\u0430\u0441\u043D\u043E\u0439 \u0440\u0443\u0431\u0435\u0436'
}), _react2.default.createElement(_reactIntl.FormattedMessage, {
    key: 'arena_tooltip.point.3',
    id: 'arena_tooltip.point.3',
    defaultMessage: '\u0426\u0438\u0442\u0430\u0434\u0435\u043B\u044C'
})];

var ARENA_TOOLTIP_DIRECTION = exports.ARENA_TOOLTIP_DIRECTION = function ARENA_TOOLTIP_DIRECTION(direction) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'arena_tooltip.direction',
        defaultMessage: '{direction} \u043F\u043B\u0430\u0446\u0434\u0430\u0440\u043C',
        values: { direction: direction }
    });
};

var ARENA_TOOLTIP_BATTLE_MAP = exports.ARENA_TOOLTIP_BATTLE_MAP = function ARENA_TOOLTIP_BATTLE_MAP(map) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'arena_tooltip.battle_map',
        defaultMessage: '\u041A\u0430\u0440\u0442\u0430: {map}',
        values: { map: map }
    });
};

var ARENA_EXCLUDED = exports.ARENA_EXCLUDED = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'journal.battles_history.arena_excluded',
    defaultMessage: '\u041A\u0430\u0440\u0442\u0430 \u0432\u044B\u0432\u0435\u0434\u0435\u043D\u0430 \u0438\u0437 \u0438\u0433\u0440\u044B'
});

/***/ }),
/* 230 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"contents":"ArenaTooltip_contents--UhaN2","title":"ArenaTooltip_title--3UIzQ","details":"ArenaTooltip_details--1SSK-","caption":"ArenaTooltip_caption--2AJzx","minimap":"ArenaTooltip_minimap--M9757","minimapEmblem":"ArenaTooltip_minimapEmblem--4xVwg"};

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tabs = exports.Subtitle = exports.RoundResultTooltip = exports.Header = exports.FortBattleSeries = exports.Details = exports.BattleList = undefined;

var _BattleList2 = __webpack_require__(524);

var _BattleList3 = _interopRequireDefault(_BattleList2);

var _Details2 = __webpack_require__(527);

var _Details3 = _interopRequireDefault(_Details2);

var _FortBattleSeries2 = __webpack_require__(530);

var _FortBattleSeries3 = _interopRequireDefault(_FortBattleSeries2);

var _Header2 = __webpack_require__(533);

var _Header3 = _interopRequireDefault(_Header2);

var _RoundResultTooltip2 = __webpack_require__(536);

var _RoundResultTooltip3 = _interopRequireDefault(_RoundResultTooltip2);

var _Subtitle2 = __webpack_require__(539);

var _Subtitle3 = _interopRequireDefault(_Subtitle2);

var _Tabs2 = __webpack_require__(542);

var _Tabs3 = _interopRequireDefault(_Tabs2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.BattleList = _BattleList3.default;
exports.Details = _Details3.default;
exports.FortBattleSeries = _FortBattleSeries3.default;
exports.Header = _Header3.default;
exports.RoundResultTooltip = _RoundResultTooltip3.default;
exports.Subtitle = _Subtitle3.default;
exports.Tabs = _Tabs3.default;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(4);

var _StartingPoint = __webpack_require__(548);

var _StartingPoint2 = _interopRequireDefault(_StartingPoint);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StartingPoint = function StartingPoint(_ref) {
    var children = _ref.children,
        direction = _ref.direction;

    return _react2.default.createElement(
        'div',
        { className: _StartingPoint2.default.base },
        children.map(function (component, idx) {
            return _react2.default.createElement(
                'div',
                {
                    key: idx,
                    className: (0, _classnames2.default)(_StartingPoint2.default.placeholder, direction && _StartingPoint2.default['placeholder__' + direction + (idx + 1)])
                },
                _react2.default.createElement(
                    'div',
                    { className: _StartingPoint2.default.inner },
                    component
                )
            );
        })
    );
};

StartingPoint.propTypes = {
    direction: _propTypes2.default.oneOf(_constants.DIRECTIONS),
    children: _propTypes2.default.arrayOf(_propTypes2.default.element).isRequired
};

exports.default = StartingPoint;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toolbar = exports.StatsTooltip = exports.SlotTooltip = exports.ReserveTooltip = exports.ReserveButton = exports.ReserveActivationTimer = exports.ReserveActivationPopover = exports.RatingLabelTooltip = exports.RatingLabel = exports.Direction = exports.CommandCenter = exports.ClanInfoPanel = undefined;

var _ClanInfoPanel2 = __webpack_require__(2184);

var _ClanInfoPanel3 = _interopRequireDefault(_ClanInfoPanel2);

var _CommandCenter2 = __webpack_require__(550);

var _CommandCenter3 = _interopRequireDefault(_CommandCenter2);

var _Direction2 = __webpack_require__(554);

var _Direction3 = _interopRequireDefault(_Direction2);

var _RatingLabel2 = __webpack_require__(2187);

var _RatingLabel3 = _interopRequireDefault(_RatingLabel2);

var _RatingLabelTooltip2 = __webpack_require__(1348);

var _RatingLabelTooltip3 = _interopRequireDefault(_RatingLabelTooltip2);

var _ReserveActivationPopover2 = __webpack_require__(2190);

var _ReserveActivationPopover3 = _interopRequireDefault(_ReserveActivationPopover2);

var _ReserveActivationTimer2 = __webpack_require__(2195);

var _ReserveActivationTimer3 = _interopRequireDefault(_ReserveActivationTimer2);

var _ReserveButton2 = __webpack_require__(2197);

var _ReserveButton3 = _interopRequireDefault(_ReserveButton2);

var _ReserveTooltip2 = __webpack_require__(1350);

var _ReserveTooltip3 = _interopRequireDefault(_ReserveTooltip2);

var _SlotTooltip2 = __webpack_require__(2203);

var _SlotTooltip3 = _interopRequireDefault(_SlotTooltip2);

var _StatsTooltip2 = __webpack_require__(2206);

var _StatsTooltip3 = _interopRequireDefault(_StatsTooltip2);

var _Toolbar2 = __webpack_require__(2208);

var _Toolbar3 = _interopRequireDefault(_Toolbar2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ClanInfoPanel = _ClanInfoPanel3.default;
exports.CommandCenter = _CommandCenter3.default;
exports.Direction = _Direction3.default;
exports.RatingLabel = _RatingLabel3.default;
exports.RatingLabelTooltip = _RatingLabelTooltip3.default;
exports.ReserveActivationPopover = _ReserveActivationPopover3.default;
exports.ReserveActivationTimer = _ReserveActivationTimer3.default;
exports.ReserveButton = _ReserveButton3.default;
exports.ReserveTooltip = _ReserveTooltip3.default;
exports.SlotTooltip = _SlotTooltip3.default;
exports.StatsTooltip = _StatsTooltip3.default;
exports.Toolbar = _Toolbar3.default;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _constants = __webpack_require__(551);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _UpgradeIcon = __webpack_require__(552);

var _UpgradeIcon2 = _interopRequireDefault(_UpgradeIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UpgradeIcon = function UpgradeIcon() {

    var arrowLayers = Array.from({ length: _constants.ARROW_LAYERS_COUNT }, function (item, index) {
        var layerClass = (0, _classnames2.default)(_UpgradeIcon2.default.arrowLayer, _UpgradeIcon2.default['arrowLayer__' + index]);
        return _react2.default.createElement('div', { className: layerClass, key: 'arrowLayer_' + index });
    });

    return _react2.default.createElement(
        'div',
        { className: _UpgradeIcon2.default.base },
        arrowLayers
    );
};

exports.default = UpgradeIcon;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactWotBootstrap = __webpack_require__(5);

var _ButtonSimple = __webpack_require__(2245);

var _ButtonSimple2 = _interopRequireDefault(_ButtonSimple);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ButtonSimple = function (_React$PureComponent) {
    _inherits(ButtonSimple, _React$PureComponent);

    function ButtonSimple() {
        _classCallCheck(this, ButtonSimple);

        return _possibleConstructorReturn(this, (ButtonSimple.__proto__ || Object.getPrototypeOf(ButtonSimple)).apply(this, arguments));
    }

    _createClass(ButtonSimple, [{
        key: 'render',
        value: function render() {
            var _cx;

            var _props = this.props,
                isExternal = _props.isExternal,
                isGlow = _props.isGlow,
                isContrast = _props.isContrast,
                isDisabled = _props.isDisabled,
                tooltipId = _props.tooltipId,
                _onClick = _props.onClick,
                children = _props.children,
                className = _props.className;


            var dataAttrs = tooltipId ? {
                'data-tip': true,
                'data-for': tooltipId
            } : {};

            return _react2.default.createElement(
                'div',
                _extends({
                    className: (0, _classnames2.default)(_ButtonSimple2.default.base, (_cx = {}, _defineProperty(_cx, _ButtonSimple2.default.isExternal, isExternal), _defineProperty(_cx, _ButtonSimple2.default.isGlow, isGlow), _defineProperty(_cx, _ButtonSimple2.default.isContrast, isContrast), _defineProperty(_cx, _ButtonSimple2.default.isDisabled, isDisabled), _cx), className),
                    onClick: function onClick(e) {
                        return !isDisabled && _onClick(e);
                    },
                    onMouseDown: function onMouseDown(e) {
                        return !isDisabled && (0, _reactWotBootstrap.sendClickSoundCommand)(e);
                    },
                    onMouseEnter: function onMouseEnter(e) {
                        return !isDisabled && (0, _reactWotBootstrap.sendHoverSoundCommand)(e);
                    }
                }, dataAttrs),
                children,
                this.props.messages ? _react2.default.createElement(
                    'div',
                    { className: _ButtonSimple2.default.messages },
                    this.props.messages > 99 ? '99+' : this.props.messages
                ) : null
            );
        }
    }]);

    return ButtonSimple;
}(_react2.default.PureComponent);

ButtonSimple.propTypes = {
    children: _propTypes2.default.node.isRequired,
    isDisabled: _propTypes2.default.bool,
    isContrast: _propTypes2.default.bool,
    isExternal: _propTypes2.default.bool,
    isGlow: _propTypes2.default.bool,
    tooltipId: _propTypes2.default.string,
    onClick: _propTypes2.default.func.isRequired,
    messages: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    className: _propTypes2.default.string
};
exports.default = ButtonSimple;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RecommendedClansPropTypes = exports.RecommendedClanPropTypes = exports.JoinResultPropTypes = exports.AccountStatusPropTypes = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AccountStatusPropTypes = exports.AccountStatusPropTypes = _propTypes2.default.shape({
    hasError: _propTypes2.default.bool.isRequired,
    isAccountInClan: _propTypes2.default.bool.isRequired,
    isFetchingCompleted: _propTypes2.default.bool.isRequired
});

var JoinResultPropTypes = exports.JoinResultPropTypes = _propTypes2.default.shape({
    cooldownTill: _propTypes2.default.string,
    currentClan: _propTypes2.default.shape({
        color: _propTypes2.default.string.isRequired,
        emblem: _propTypes2.default.string.isRequired,
        name: _propTypes2.default.string.isRequired,
        tag: _propTypes2.default.string.isRequired
    }),
    hasNoErrors: _propTypes2.default.bool.isRequired,
    errors: _propTypes2.default.object.isRequired,
    applied: _propTypes2.default.array.isRequired,
    joinedClan: _propTypes2.default.shape({
        color: _propTypes2.default.string.isRequired,
        emblem: _propTypes2.default.string.isRequired,
        id: _propTypes2.default.number.isRequired,
        name: _propTypes2.default.string.isRequired,
        tag: _propTypes2.default.string.isRequired
    }),
    loading: _propTypes2.default.bool.isRequired
});

var RecommendedClanPropTypes = exports.RecommendedClanPropTypes = _propTypes2.default.shape({
    color: _propTypes2.default.string,
    emblems: _propTypes2.default.object.isRequired,
    id: _propTypes2.default.number.isRequired,
    isClanAcceptableForAutoJoining: _propTypes2.default.bool.isRequired,
    isRecruitingOpened: _propTypes2.default.bool.isRequired,
    languages: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
    membersCount: _propTypes2.default.number.isRequired,
    name: _propTypes2.default.string.isRequired,
    tag: _propTypes2.default.string.isRequired,
    dwhSquadScore: _propTypes2.default.number,
    dwhStrongholdScore: _propTypes2.default.number,
    dwhGlobalMapScore: _propTypes2.default.number,
    dwhClanReservesScore: _propTypes2.default.number,
    strongholdLevel: _propTypes2.default.number,
    status: _propTypes2.default.string
});

var RecommendedClansPropTypes = exports.RecommendedClansPropTypes = _propTypes2.default.arrayOf(RecommendedClanPropTypes);

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getTooltipTitleForGroup = exports.GROUP_CAPTIONS = exports.STYLE_IS_IN_INVENTORY_ALREADY = exports.TANK_STYLE_DESCRIPTION = exports.TANK_PURCHASE_REQUIREMENT_DETAILED = exports.TANK_PURCHASE_REQUIREMENT_SHORT = exports.PREMIUM_BONUSES_NOT_AVAILABLE_YET = exports.BACK_TO_MAIN = exports.CURRENCY_LEFT = exports.CURRENCY_TO_SPEND = exports.PURCHASE = exports.NO = exports.AFFIRMATIVE = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _WGCWXShopCard = __webpack_require__(297);

var _WGCWXShopCard2 = _interopRequireDefault(_WGCWXShopCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AFFIRMATIVE = exports.AFFIRMATIVE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.affirmative',
    defaultMessage: '\u0422\u0430\u043A \u0442\u043E\u0447\u043D\u043E!'
}); /* eslint-disable react/no-multi-comp, max-len */
var NO = exports.NO = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.no',
    defaultMessage: '\u041D\u0435\u0442'
});

var PURCHASE = exports.PURCHASE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.purchase',
    defaultMessage: '\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C'
});

var CURRENCY_TO_SPEND = exports.CURRENCY_TO_SPEND = function CURRENCY_TO_SPEND(currency) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop.currency_to_spend',
        defaultMessage: '\u041A \u043E\u0431\u043C\u0435\u043D\u0443: {currency}',
        values: { currency: currency }
    });
};

var CURRENCY_LEFT = exports.CURRENCY_LEFT = function CURRENCY_LEFT(currency) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop.currency_left',
        defaultMessage: '\u041D\u0430 \u0432\u0430\u0448\u0435\u043C \u0441\u0447\u0435\u0442\u0443 \u043E\u0441\u0442\u0430\u043D\u0435\u0442\u0441\u044F: {currency}',
        values: { currency: currency }
    });
};

var BACK_TO_MAIN = exports.BACK_TO_MAIN = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.back_to_main',
    defaultMessage: '\u041A \u0431\u043E\u043D\u0443\u0441\u0430\u043C'
});

var PREMIUM_BONUSES_NOT_AVAILABLE_YET = exports.PREMIUM_BONUSES_NOT_AVAILABLE_YET = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.premium_bonuses_unavailable',
    defaultMessage: '\u041F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435 \u043F\u0440\u0438\u0437\u043E\u0432 \u0441\u0442\u0430\u043D\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E \u0447\u0435\u0440\u0435\u0437 \u043D\u0435\u043A\u043E\u0442\u043E\u0440\u043E\u0435 \u0432\u0440\u0435\u043C\u044F \u043F\u043E\u0441\u043B\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0441\u043E\u0431\u044B\u0442\u0438\u044F.'
});

var TANK_CARD_SELECTION_TOP = function TANK_CARD_SELECTION_TOP(topPlaces) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop.tank_purchase.top',
        defaultMessage: '\u0442\u043E\u043F-{top}',
        values: { top: _react2.default.createElement(_reactIntl.FormattedNumber, { value: topPlaces }) }
    });
};

var TANK_PURCHASE_REQUIREMENT_SHORT = exports.TANK_PURCHASE_REQUIREMENT_SHORT = function TANK_PURCHASE_REQUIREMENT_SHORT(topPlaces) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop.tanks_purchase.requirement.short',
        defaultMessage: '\u0422\u0435\u0445\u043D\u0438\u043A\u0443 \u0437\u0430 \u0444\u0438\u043A\u0441\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0435 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0431\u043E\u043D \u0441\u043C\u043E\u0433\u0443\u0442 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0438\u0433\u0440\u043E\u043A\u0438, \u0432\u043E\u0448\u0435\u0434\u0448\u0438\u0435 \u0432 {top} \u043F\u043E \u0438\u0442\u043E\u0433\u0430\u043C \u0441\u043E\u0431\u044B\u0442\u0438\u044F.',
        values: {
            top: _react2.default.createElement(
                'span',
                { className: _WGCWXShopCard2.default.highlight },
                TANK_CARD_SELECTION_TOP(topPlaces)
            )
        }
    });
};

var TANK_PURCHASE_REQUIREMENT_DETAILED = exports.TANK_PURCHASE_REQUIREMENT_DETAILED = function TANK_PURCHASE_REQUIREMENT_DETAILED(topPlaces) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop.tanks_purchase.requirement.detailed',
        defaultMessage: '\u0422\u0435\u0445\u043D\u0438\u043A\u0443 \u0437\u0430 \u0444\u0438\u043A\u0441\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0435 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0431\u043E\u043D \u0441\u043C\u043E\u0433\u0443\u0442 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0438\u0433\u0440\u043E\u043A\u0438, \u0432\u043E\u0448\u0435\u0434\u0448\u0438\u0435 \u0432 {top} \u043F\u043E \u0438\u0442\u043E\u0433\u0430\u043C \u0441\u043E\u0431\u044B\u0442\u0438\u044F. \u041E\u0441\u0442\u0430\u043B\u044C\u043D\u044B\u0435 \u0438\u0433\u0440\u043E\u043A\u0438 \u043F\u043E\u043B\u0443\u0447\u0430\u0442 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044C \u0443\u0447\u0430\u0441\u0442\u0432\u043E\u0432\u0430\u0442\u044C \u0432 \u0431\u043E\u043D\u043E\u0432\u043E\u043C \u0430\u0443\u043A\u0446\u0438\u043E\u043D\u0435. \u041D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E\u0435 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043B\u0438\u0447\u043D\u044B\u0445 \u041E\u0447\u043A\u043E\u0432 \u0441\u043B\u0430\u0432\u044B \u0434\u043B\u044F \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u0442\u0435\u0445\u043D\u0438\u043A\u0438 \u0441\u0442\u0430\u043D\u0435\u0442 \u0438\u0437\u0432\u0435\u0441\u0442\u043D\u043E \u043F\u043E\u0441\u043B\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0441\u043E\u0431\u044B\u0442\u0438\u044F.',
        values: {
            top: _react2.default.createElement(
                'span',
                { className: _WGCWXShopCard2.default.highlight },
                TANK_CARD_SELECTION_TOP(topPlaces)
            )
        }
    });
};

var TANK_STYLE_DESCRIPTION = exports.TANK_STYLE_DESCRIPTION = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.tanks_style_pack',
    defaultMessage: '\u0412\u044B\u0431\u0440\u0430\u043D\u043D\u0430\u044F \u043F\u0440\u0438\u0437\u043E\u0432\u0430\u044F \u043C\u0430\u0448\u0438\u043D\u0430 \u0431\u0443\u0434\u0435\u0442 \u043D\u0430\u0447\u0438\u0441\u043B\u0435\u043D\u0430 \u0432\u043C\u0435\u0441\u0442\u0435 \u0441 \u043D\u0430\u0431\u043E\u0440\u043E\u043C \u043A\u0430\u0441\u0442\u043E\u043C\u0438\u0437\u0430\u0446\u0438\u0438 \xAB\u0412\u0435\u0442\u0435\u0440\u0430\u043D\xBB'
});

var STYLE_IS_IN_INVENTORY_ALREADY = exports.STYLE_IS_IN_INVENTORY_ALREADY = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.tanks_style_is_in_inventory_already',
    defaultMessage: '\u0423 \u0432\u0430\u0441 \u0443\u0436\u0435 \u0435\u0441\u0442\u044C \u044D\u0442\u043E\u0442 \u0441\u0442\u0438\u043B\u044C'
});

var GROUP_CAPTIONS = exports.GROUP_CAPTIONS = {
    ussr: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'nations_select.captions.ussr',
        defaultMessage: '\u0421\u0421\u0421\u0420'
    }),
    germany: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'nations_select.captions.germany',
        defaultMessage: '\u0413\u0435\u0440\u043C\u0430\u043D\u0438\u044F'
    }),
    usa: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'nations_select.captions.usa',
        defaultMessage: '\u0421\u0428\u0410'
    }),
    china: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'nations_select.captions.china',
        defaultMessage: '\u041A\u0438\u0442\u0430\u0439'
    }),
    france: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'nations_select.captions.france',
        defaultMessage: '\u0424\u0440\u0430\u043D\u0446\u0438\u044F'
    }),
    uk: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'nations_select.captions.uk',
        defaultMessage: '\u0412\u0435\u043B\u0438\u043A\u043E\u0431\u0440\u0438\u0442\u0430\u043D\u0438\u044F'
    }),
    japan: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'nations_select.captions.japan',
        defaultMessage: '\u042F\u043F\u043E\u043D\u0438\u044F'
    }),
    czech: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'nations_select.captions.czech',
        defaultMessage: '\u0427\u0435\u0445\u043E\u0441\u043B\u043E\u0432\u0430\u043A\u0438\u044F'
    }),
    sweden: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'nations_select.captions.sweden',
        defaultMessage: '\u0428\u0432\u0435\u0446\u0438\u044F'
    }),
    poland: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'nations_select.captions.poland',
        defaultMessage: '\u041F\u043E\u043B\u044C\u0448\u0430'
    }),
    italy: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'nations_select.captions.italy',
        defaultMessage: '\u0418\u0442\u0430\u043B\u0438\u044F'
    })
};

var getTooltipTitleForGroup = exports.getTooltipTitleForGroup = function getTooltipTitleForGroup(filterGroup) {
    return GROUP_CAPTIONS[filterGroup];
};

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactWotBootstrap = __webpack_require__(5);

var _constants = __webpack_require__(241);

var _constants2 = __webpack_require__(4);

var _WGCWXConfirmation = __webpack_require__(1376);

var _WGCWXConfirmation2 = _interopRequireDefault(_WGCWXConfirmation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WGCWXShopConfirmation = function (_React$Component) {
    _inherits(WGCWXShopConfirmation, _React$Component);

    function WGCWXShopConfirmation() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, WGCWXShopConfirmation);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WGCWXShopConfirmation.__proto__ || Object.getPrototypeOf(WGCWXShopConfirmation)).call.apply(_ref, [this].concat(args))), _this), _this.handleKeyPress = function (e) {
            if (e.keyCode !== _constants2.KEY_CODES.ESCAPE) return;

            _this.props.onClose();
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(WGCWXShopConfirmation, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.addEventListener('keydown', this.handleKeyPress);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('keydown', this.handleKeyPress);
        }
    }, {
        key: 'render',
        value: function render() {
            var imageClassNames = (0, _classnames2.default)(_WGCWXConfirmation2.default.image, this.props.messageType && _WGCWXConfirmation2.default['image__' + this.props.messageType]);
            return _react2.default.createElement(
                'div',
                { className: _WGCWXConfirmation2.default.base },
                _react2.default.createElement(
                    'div',
                    { className: _WGCWXConfirmation2.default.back },
                    _react2.default.createElement(_reactWotBootstrap.Back, {
                        side: 'right',
                        type: 'close',
                        caption: _constants.BACK_CAPTIONS.close,
                        onClick: this.props.onClose
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: _WGCWXConfirmation2.default.content },
                    _react2.default.createElement('div', { className: imageClassNames }),
                    _react2.default.createElement(
                        'h1',
                        { className: _WGCWXConfirmation2.default.header },
                        this.props.title
                    ),
                    this.props.description && _react2.default.createElement(
                        'p',
                        { className: _WGCWXConfirmation2.default.description },
                        this.props.description
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _WGCWXConfirmation2.default.separator },
                        _react2.default.createElement('span', { className: _WGCWXConfirmation2.default.separator_image })
                    ),
                    this.props.children,
                    _react2.default.createElement(
                        'div',
                        { className: _WGCWXConfirmation2.default.buttons },
                        this.props.buttonsOptions.map(function (button, index) {
                            return _react2.default.createElement(
                                _reactWotBootstrap.Button,
                                {
                                    key: index === 0 ? 'default' : 'secondary',
                                    type: index === 0 ? 'default' : 'secondary',
                                    onClick: button.callback,
                                    mixClassName: _WGCWXConfirmation2.default.button
                                },
                                button.caption
                            );
                        })
                    )
                )
            );
        }
    }]);

    return WGCWXShopConfirmation;
}(_react2.default.Component);

WGCWXShopConfirmation.propTypes = {
    buttonsOptions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        caption: _propTypes2.default.element.isRequired,
        callback: _propTypes2.default.func.isRequired
    })).isRequired,
    description: _propTypes2.default.node,
    title: _propTypes2.default.element.isRequired,
    messageType: _propTypes2.default.oneOf(['error', 'alert']),

    children: _propTypes2.default.element,

    onClose: _propTypes2.default.func.isRequired
};
exports.default = WGCWXShopConfirmation;

/***/ }),
/* 239 */,
/* 240 */,
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BACK_SIDES = exports.BACK_TYPES = exports.BACK_CAPTIONS = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BACK_CAPTIONS = exports.BACK_CAPTIONS = {
    back: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'back.caption_back',
        defaultMessage: '\u041D\u0410\u0417\u0410\u0414'
    }),
    close: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'back.caption_close',
        defaultMessage: '\u0417\u0410\u041A\u0420\u042B\u0422\u042C'
    }),
    stronghold: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'back.caption_stronghold',
        defaultMessage: '\u041A \u0423\u043A\u0440\u0435\u043F\u0440\u0430\u0439\u043E\u043D\u0443'
    })
};

var BACK_TYPES = exports.BACK_TYPES = {
    back: 'back',
    info: 'info',
    close: 'close'
};

var BACK_SIDES = exports.BACK_SIDES = {
    right: 'right',
    left: 'left'
};

/***/ }),
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



module.exports = __webpack_require__(2074);


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapStateToProps = exports.LackOfIndustrialResource = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(7);

var _i18n = __webpack_require__(10);

var _constants = __webpack_require__(2098);

var _LackOfIndustrialResource = __webpack_require__(2099);

var _LackOfIndustrialResource2 = _interopRequireDefault(_LackOfIndustrialResource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LackOfIndustrialResource = exports.LackOfIndustrialResource = function LackOfIndustrialResource(props) {
    return _react2.default.createElement(
        'div',
        { className: _LackOfIndustrialResource2.default.base },
        _react2.default.createElement(
            'div',
            { className: _LackOfIndustrialResource2.default.lack },
            (0, _constants.LACK)(props.resource)
        ),
        _react2.default.createElement(
            'div',
            { className: _LackOfIndustrialResource2.default.description },
            props.industrialResourceAvailable < 0 ? _i18n.NEGATIVE_IR_BALANCE_HINT : _constants.DESCRIPTION
        )
    );
};

LackOfIndustrialResource.propTypes = {
    resource: _propTypes2.default.node.isRequired,
    industrialResourceAvailable: _propTypes2.default.number.isRequired
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
    return {
        industrialResourceAvailable: state.clan.industrial_resource
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(LackOfIndustrialResource);

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _helpers = __webpack_require__(11);

var _reserves = __webpack_require__(28);

var _constants = __webpack_require__(391);

var _constants2 = __webpack_require__(4);

var _Reserve = __webpack_require__(2121);

var _Reserve2 = _interopRequireDefault(_Reserve);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Reserve = function (_React$Component) {
    _inherits(Reserve, _React$Component);

    function Reserve() {
        _classCallCheck(this, Reserve);

        return _possibleConstructorReturn(this, (Reserve.__proto__ || Object.getPrototypeOf(Reserve)).apply(this, arguments));
    }

    _createClass(Reserve, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.updateTimer(this.props.reserves);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.timerId) clearTimeout(this.timerId);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.updateTimer(nextProps.reserves);
        }
    }, {
        key: 'updateTimer',
        value: function updateTimer(reserves) {
            var _this2 = this;

            if (!this.props.reserves) return;

            if (this.timerId) clearTimeout(this.timerId);

            var now = Date.now();
            var upcomingReserve = reserves.filter(function (reserve) {
                return reserve.level === _this2.props.level && reserve.productionEnds !== null;
            }).sort(function (first, second) {
                return first.productionEnds - second.productionEnds;
            }).find(function (reserve) {
                return reserve.productionEnds >= now;
            });

            if (upcomingReserve !== undefined) {
                this.timerId = setTimeout(function () {
                    _this2.props.playSound && _this2.props.playSound();
                    _this2.forceUpdate();
                    _this2.updateTimer(reserves);
                }, upcomingReserve.productionEnds - now);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames, _classNames2;

            var isClanLanding = this.props.modifier === _constants.MODIFIER_CLAN_LANDING;
            var classNamesImage = (0, _classnames2.default)(_Reserve2.default.image, _Reserve2.default['image__' + (0, _helpers.toCssClass)(this.props.type)], (_classNames = {}, _defineProperty(_classNames, _Reserve2.default.image__elite, this.props.level > _constants2.MAX_BUILDING_LEVEL), _defineProperty(_classNames, _Reserve2.default.image__clanLanding, isClanLanding), _classNames));

            var reservesCount = void 0;
            if (this.props.reserves) {
                var readyReserves = (0, _reserves.getReadyReserves)(this.props.reserves);
                var highlighted = this.props.highlighted;


                var originalLevel = highlighted ? this.props.level - 1 : this.props.level;
                reservesCount = readyReserves.filter(function (reserve) {
                    return reserve.level === originalLevel;
                }).length;
            }

            var counterGradient = void 0;
            if (this.props.modifier === 'toolbar') {
                counterGradient = _react2.default.createElement(
                    'span',
                    { className: _Reserve2.default.counterGradient },
                    reservesCount
                );
            }

            var classNamesBase = (0, _classnames2.default)(_Reserve2.default.base, (_classNames2 = {}, _defineProperty(_classNames2, _Reserve2.default.base__toolbar, this.props.modifier === 'toolbar'), _defineProperty(_classNames2, _Reserve2.default.base__clanLanding, isClanLanding), _defineProperty(_classNames2, _Reserve2.default.base__highlighted, this.props.highlighted), _classNames2));

            return _react2.default.createElement(
                'div',
                { className: classNamesBase },
                _react2.default.createElement(
                    'span',
                    { className: _Reserve2.default.level },
                    (0, _helpers.toRoman)(this.props.level),
                    _react2.default.createElement(
                        'span',
                        { className: _Reserve2.default.levelGradient },
                        (0, _helpers.toRoman)(this.props.level)
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _Reserve2.default.thumbnail },
                    _react2.default.createElement('div', { className: classNamesImage })
                ),
                !isClanLanding && _react2.default.createElement(
                    'span',
                    { className: _Reserve2.default.counter },
                    reservesCount,
                    counterGradient
                )
            );
        }
    }]);

    return Reserve;
}(_react2.default.Component);

Reserve.defaultProps = {
    highlighted: false
};
Reserve.propTypes = {
    type: _propTypes2.default.string.isRequired,
    level: _propTypes2.default.number.isRequired,
    reserves: _propTypes2.default.arrayOf(_propTypes2.default.object),
    highlighted: _propTypes2.default.bool.isRequired,
    modifier: _propTypes2.default.oneOf(['toolbar', _constants.MODIFIER_CLAN_LANDING]),
    playSound: _propTypes2.default.func
};
exports.default = Reserve;

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapStateToProps = exports.BuildingTooltip = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = __webpack_require__(7);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

var _ReserveTooltipBody = __webpack_require__(206);

var _reactWotBootstrap = __webpack_require__(5);

var _helpers = __webpack_require__(11);

var _buildings = __webpack_require__(161);

var _reserves = __webpack_require__(28);

var _datetime = __webpack_require__(13);

var _isFunction = __webpack_require__(123);

var _isFunction2 = _interopRequireDefault(_isFunction);

var _i18n = __webpack_require__(10);

var _constants = __webpack_require__(394);

var _BuildingTooltip = __webpack_require__(395);

var _BuildingTooltip2 = _interopRequireDefault(_BuildingTooltip);

var _constants2 = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BuildingTooltip = exports.BuildingTooltip = function (_React$Component) {
    _inherits(BuildingTooltip, _React$Component);

    function BuildingTooltip(props) {
        _classCallCheck(this, BuildingTooltip);

        var _this = _possibleConstructorReturn(this, (BuildingTooltip.__proto__ || Object.getPrototypeOf(BuildingTooltip)).call(this, props));

        _this.state = { upcomingReserves: 0, productionEnds: null, uniqueLevels: [] };
        return _this;
    }

    _createClass(BuildingTooltip, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.processReserveQueue(nextProps.reserveQueue);
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.processReserveQueue(this.props.reserveQueue);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.timerId) {
                clearTimeout(this.timerId);
            }
        }
    }, {
        key: 'processReserveQueue',
        value: function processReserveQueue(reserveQueue) {
            var _this2 = this;

            if (this.timerId) {
                clearTimeout(this.timerId);
            }
            var reservesInProgress = (0, _reserves.getSortedProductionReserves)(reserveQueue);

            var upcomingReserves = reservesInProgress.length;
            var productionEnds = !!upcomingReserves && reservesInProgress[reservesInProgress.length - 1].productionEnds;

            var uniqueLevels = Array.from(new Set(reservesInProgress.map(function (_ref) {
                var level = _ref.level;
                return level;
            }))).sort(function (a, b) {
                return b - a;
            });

            if (upcomingReserves) {
                this.timerId = setTimeout(this.processReserveQueue.bind(this, reserveQueue), reservesInProgress[0].productionEnds - Date.now());
            }

            if (upcomingReserves !== this.state.upcomingReserves) {
                setTimeout(function () {
                    if (_this2._tooltip && _this2._tooltip.state.visible) {
                        _this2._tooltip.show();
                    }
                }, 0);
            }

            this.setState({ productionEnds: productionEnds, upcomingReserves: upcomingReserves, uniqueLevels: uniqueLevels });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props$building = this.props.building,
                level = _props$building.level,
                type = _props$building.type;

            var reserveType = this.props.reserveType;
            var uniqueLevels = this.state.uniqueLevels;

            // disable tooltip for inspiration and artillery strike in usual browser

            if (!(0, _isFunction2.default)(window.jsHostQuery) && (reserveType === _constants2.RESERVE_TYPES.INSPIRATION || reserveType === _constants2.RESERVE_TYPES.ARTILLERY_STRIKE)) {
                return null;
            }
            var reserveInfo = this.props.settings.reserves[reserveType];

            var reserveGroup = (0, _reserves.getGroupByReserve)(reserveType, this.props.settings);
            var bonusValuesArray = Object.values(reserveInfo.bonus.values[level - 1].battle_types);
            var targetType = (0, _reserves.getTargetType)(reserveGroup, bonusValuesArray);
            var isReserveHasParameters = Boolean(reserveInfo.bonus.values[level].parameters);
            var reserveBodyNeeded = this.state.upcomingReserves === 0 || uniqueLevels.length === 1;

            return _react2.default.createElement(
                _reactWotBootstrap.Tooltip,
                { id: this.props.id, bounds: this.props.bounds, isWide: true, ref: function ref(node) {
                        return _this3._tooltip = node;
                    } },
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)(_BuildingTooltip2.default.base, _BuildingTooltip2.default['base__type-' + targetType]) },
                    _react2.default.createElement(
                        'div',
                        { className: _BuildingTooltip2.default.header },
                        _react2.default.createElement(
                            'p',
                            { className: _BuildingTooltip2.default.title },
                            _i18n.BUILDING_TITLES[type]
                        ),
                        _react2.default.createElement(
                            'p',
                            { className: _BuildingTooltip2.default.level },
                            (0, _constants.BUILDING_LEVEL)(level)
                        )
                    ),
                    _react2.default.createElement('div', { className: _BuildingTooltip2.default.divider }),
                    _react2.default.createElement(
                        'div',
                        { className: _BuildingTooltip2.default.reserve },
                        _react2.default.createElement(
                            'div',
                            { className: _BuildingTooltip2.default.button },
                            _react2.default.createElement(
                                'div',
                                { className: _BuildingTooltip2.default.thumbnail },
                                _react2.default.createElement('div', { className: (0, _classnames2.default)(_BuildingTooltip2.default.image, _BuildingTooltip2.default['image__' + (0, _helpers.toCssClass)(reserveType)])
                                })
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _BuildingTooltip2.default.reserveInfo },
                            _react2.default.createElement(
                                'p',
                                { className: _BuildingTooltip2.default.reserveTitle },
                                _i18n.RESERVE_TITLES[reserveInfo.type]
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: _BuildingTooltip2.default.reserveLevel },
                                (0, _constants.AVAILABLE_RESERVES)(_react2.default.createElement(
                                    'span',
                                    { className: _BuildingTooltip2.default.reserveLevelValue },
                                    level === 1 ? (0, _i18n.LEVEL_STRING)(level) : (0, _i18n.LEVELS_RANGE_STRING)(1, level)
                                ))
                            )
                        )
                    ),
                    reserveBodyNeeded && _react2.default.createElement(_ReserveTooltipBody.ReserveTooltipBody, {
                        reserveType: reserveType,
                        reserveInfo: reserveInfo,
                        level: uniqueLevels.length === 1 ? uniqueLevels[0] : level
                    }),
                    Boolean(this.state.upcomingReserves) && _react2.default.createElement(
                        'div',
                        { className: _BuildingTooltip2.default.statusMessage },
                        (isReserveHasParameters || !reserveBodyNeeded) && _react2.default.createElement('div', { className: (0, _classnames2.default)(_BuildingTooltip2.default.divider, !reserveBodyNeeded && _BuildingTooltip2.default.divider__collapsed) }),
                        _react2.default.createElement(
                            'p',
                            { className: _BuildingTooltip2.default.status },
                            (0, _constants.RESERVE_QUEUE)(this.state.upcomingReserves)
                        ),
                        _react2.default.createElement(
                            'p',
                            { className: _BuildingTooltip2.default.statusLevels },
                            _i18n.LEVEL_STRING.apply(undefined, _toConsumableArray(uniqueLevels))
                        ),
                        _react2.default.createElement(
                            'p',
                            { className: (0, _classnames2.default)(_BuildingTooltip2.default.statusText, _BuildingTooltip2.default.finishText) },
                            (0, _constants.RESERVE_QUEUE_END)(_react2.default.createElement(
                                'span',
                                { className: _BuildingTooltip2.default.finishTime },
                                (0, _datetime.getEndDateMessage)((0, _moment2.default)(this.state.productionEnds))
                            ))
                        )
                    ),
                    Boolean(!this.state.upcomingReserves && this.props.isUpgradeAvailable) && _react2.default.createElement(
                        'div',
                        { className: (0, _classnames2.default)(_BuildingTooltip2.default.statusMessage, _BuildingTooltip2.default.statusMessage__positive) },
                        isReserveHasParameters && _react2.default.createElement('div', { className: _BuildingTooltip2.default.divider }),
                        _react2.default.createElement(
                            'p',
                            { className: _BuildingTooltip2.default.status },
                            _constants.UPGRADE_AVAILABLE
                        )
                    )
                )
            );
        }
    }]);

    return BuildingTooltip;
}(_react2.default.Component);

BuildingTooltip.propTypes = {
    id: _propTypes2.default.string.isRequired,
    building: _propTypes2.default.object.isRequired,
    settings: _propTypes2.default.object.isRequired,
    isUpgradeAvailable: _propTypes2.default.bool.isRequired,
    reserveQueue: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
    reserveType: _propTypes2.default.string.isRequired,
    bounds: _propTypes2.default.object
};
var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, _ref2) {
    var id = _ref2.id,
        building = _ref2.building;
    var settings = state.settings;


    var reserveType = state.settings.buildings[building.type].reserve_type;
    var reserveQueue = (0, _reserves.getSortedProductionReserves)(state.clanReserves[reserveType]);
    var isUpgradeAvailable = (0, _buildings.upgradeAvailability)(state, building);

    return {
        id: id,
        building: building,
        reserveQueue: reserveQueue,
        reserveType: reserveType,
        settings: settings,
        isUpgradeAvailable: isUpgradeAvailable
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(BuildingTooltip);

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapStateToProps = exports.CommandCenterTooltip = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = __webpack_require__(7);

var _reactWotBootstrap = __webpack_require__(5);

var _helpers = __webpack_require__(11);

var _stronghold = __webpack_require__(132);

var _i18n = __webpack_require__(10);

var _constants = __webpack_require__(396);

var _constants2 = __webpack_require__(4);

var _CommandCenterTooltip = __webpack_require__(397);

var _CommandCenterTooltip2 = _interopRequireDefault(_CommandCenterTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CommandCenterTooltip = exports.CommandCenterTooltip = function (_React$Component) {
    _inherits(CommandCenterTooltip, _React$Component);

    function CommandCenterTooltip() {
        _classCallCheck(this, CommandCenterTooltip);

        return _possibleConstructorReturn(this, (CommandCenterTooltip.__proto__ || Object.getPrototypeOf(CommandCenterTooltip)).apply(this, arguments));
    }

    _createClass(CommandCenterTooltip, [{
        key: 'render',
        value: function render() {
            var level = this.props.level;

            var upgradeAvailable = this.props.isUpgradeAvailable ? _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement('div', { className: _CommandCenterTooltip2.default.divider }),
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)(_CommandCenterTooltip2.default.statusMessage, _CommandCenterTooltip2.default.statusMessage__positive) },
                    _react2.default.createElement(
                        'p',
                        { className: _CommandCenterTooltip2.default.status },
                        _constants.UPGRADE_AVAILABLE
                    )
                )
            ) : null;
            return _react2.default.createElement(
                _reactWotBootstrap.Tooltip,
                { id: _constants2.COMMAND_CENTER_TOOLTIP_ID },
                _react2.default.createElement(
                    'div',
                    { className: _CommandCenterTooltip2.default.base },
                    _react2.default.createElement(
                        'div',
                        { className: _CommandCenterTooltip2.default.header },
                        _react2.default.createElement(
                            'p',
                            { className: _CommandCenterTooltip2.default.title },
                            _i18n.COMMAND_CENTER_TITLE
                        ),
                        _react2.default.createElement(
                            'p',
                            { className: _CommandCenterTooltip2.default.level },
                            (0, _i18n.LEVEL_STRING)(level)
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _CommandCenterTooltip2.default.info },
                        _react2.default.createElement(
                            'p',
                            null,
                            (0, _constants.BUILDING_INFO)(_react2.default.createElement(
                                'span',
                                { className: _CommandCenterTooltip2.default.infoLevel },
                                (0, _helpers.toRoman)(level)
                            ))
                        )
                    ),
                    upgradeAvailable
                )
            );
        }
    }]);

    return CommandCenterTooltip;
}(_react2.default.Component);

CommandCenterTooltip.propTypes = {
    level: _propTypes2.default.number.isRequired,
    isUpgradeAvailable: _propTypes2.default.bool.isRequired
};
var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
    return {
        isUpgradeAvailable: (0, _stronghold.upgradeAvailability)(state)
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(CommandCenterTooltip);

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UnitPreview = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(7);

var _reactWotBootstrap = __webpack_require__(5);

var _constants = __webpack_require__(4);

var _clan_units = __webpack_require__(207);

var _clan_units2 = _interopRequireDefault(_clan_units);

var _reactivity = __webpack_require__(67);

var _clan_units3 = __webpack_require__(105);

var _CreateUnitButton = __webpack_require__(133);

var _CreateUnitButton2 = _interopRequireDefault(_CreateUnitButton);

var _Title = __webpack_require__(134);

var _Title2 = _interopRequireDefault(_Title);

var _Squad = __webpack_require__(135);

var _Squad2 = _interopRequireDefault(_Squad);

var _propTypes3 = __webpack_require__(32);

var _constants2 = __webpack_require__(410);

var _UnitPreview = __webpack_require__(411);

var _UnitPreview2 = _interopRequireDefault(_UnitPreview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UnitPreview = exports.UnitPreview = function (_React$Component) {
    _inherits(UnitPreview, _React$Component);

    function UnitPreview(props) {
        _classCallCheck(this, UnitPreview);

        var _this = _possibleConstructorReturn(this, (UnitPreview.__proto__ || Object.getPrototypeOf(UnitPreview)).call(this, props));

        _this.onBackClick = function () {
            (0, _reactWotBootstrap.sendSelectClickSoundCommand)();

            _this.props.handleToBattleRoomsButtonClick();
        };

        _this.onKeyDown = function (event) {
            if (event.keyCode === _constants.KEY_CODES.ESCAPE) {
                _this.props.handleToBattleRoomsButtonClick();
            }
        };

        _this.updateChannel(props.reactiveUpdateUrl);
        return _this;
    }

    _createClass(UnitPreview, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            window.addEventListener('keydown', this.onKeyDown);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.updateChannel(null);
            window.removeEventListener('keydown', this.onKeyDown);
        }
    }, {
        key: 'updateChannel',
        value: function updateChannel(url) {
            if (this.channel) {
                this.channel.disconnect();
            }
            if (url) {
                this.channel = new _clan_units2.default(url);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var unit = this.props.unit;

            var content = unit.is_destroyed ? _react2.default.createElement(
                'div',
                { className: _UnitPreview2.default.unitDestroyed },
                _constants2.UNIT_DESTROYED,
                _react2.default.createElement(
                    _reactWotBootstrap.ButtonSmall,
                    { onClick: this.onBackClick },
                    _constants2.TO_UNIT_MATCHING
                )
            ) : _react2.default.createElement(_Squad2.default, { unitData: unit, forPreview: true });

            var unitDescription = (0, _constants2.UNIT_DESCRIPTION)(unit.type, unit.max_vehicle_level, unit.periphery.name);
            return _react2.default.createElement(
                'div',
                { className: _UnitPreview2.default.base },
                _react2.default.createElement(
                    'header',
                    { className: _UnitPreview2.default.header },
                    _react2.default.createElement(_reactWotBootstrap.Back, {
                        type: 'back',
                        caption: _constants2.TO_UNIT_MATCHING,
                        onClick: this.onBackClick,
                        side: 'left'
                    }),
                    _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            _Title2.default,
                            null,
                            _constants2.SQUAD_OF_MY_CLAN
                        ),
                        _react2.default.createElement(
                            'h2',
                            { className: _UnitPreview2.default.subtitle },
                            unitDescription
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _UnitPreview2.default.createDetachmentButton },
                        _react2.default.createElement(_CreateUnitButton2.default, null)
                    )
                ),
                _react2.default.createElement(
                    'main',
                    { className: _UnitPreview2.default.squad },
                    content
                )
            );
        }
    }]);

    return UnitPreview;
}(_react2.default.Component);

UnitPreview.propTypes = {
    unit: _propTypes3.UnitDataPropTypes.isRequired,
    reactiveUpdateUrl: _propTypes2.default.string,

    handleToBattleRoomsButtonClick: _propTypes2.default.func.isRequired
};


var mapStateToProps = function mapStateToProps(state) {
    return {
        reactiveUpdateUrl: (0, _reactivity.getReactiveUpdateUrl)(state.settings.pushStreamHost, state.clan.units_channel)
    };
};

var mapDispatchToProps = {
    handleToBattleRoomsButtonClick: _clan_units3.selectUnit
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UnitPreview);

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.INDUSTRIAL_RESOURCE_MULTIPLIER_TOOLTIP_TEXT = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _i18n = __webpack_require__(10);

var _IndustrialResourceCoefTooltip = __webpack_require__(432);

var _IndustrialResourceCoefTooltip2 = _interopRequireDefault(_IndustrialResourceCoefTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INDUSTRIAL_RESOURCE_MULTIPLIER_TOOLTIP_TEXT = exports.INDUSTRIAL_RESOURCE_MULTIPLIER_TOOLTIP_TEXT = function INDUSTRIAL_RESOURCE_MULTIPLIER_TOOLTIP_TEXT(multiplier) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'industrial_resource.multiplier.tooltip',
        defaultMessage: '\u041A\u043B\u0430\u043D \u043F\u043E\u043B\u0443\u0447\u0430\u0435\u0442 {multiplierElement} \u043A \u043F\u0440\u043E\u043C\u0440\u0435\u0441\u0443\u0440\u0441\u0443 \u0437\u0430 \u0431\u043E\u0438 \u0432 \u0412\u044B\u043B\u0430\u0437\u043A\u0430\u0445 \u0438 \u041D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u044F\u0445, \u0430 \u0442\u0430\u043A\u0436\u0435 \u043F\u043E \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0430\u043C \u041D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u0439.' // eslint-disable-line max-len
        , values: {
            multiplierElement: _react2.default.createElement(
                'span',
                { className: _IndustrialResourceCoefTooltip2.default.highlight },
                (0, _i18n.INDUSTRIAL_RESOURCE_MULTIPLIER)(multiplier)
            )
        }
    });
};

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.canUseDOM = exports.slidesOnLeft = exports.slidesOnRight = exports.siblingDirection = exports.getTotalSlides = exports.getPostClones = exports.getPreClones = exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = exports.checkSpecKeys = exports.getSlideCount = exports.checkNavigable = exports.getNavigableIndexes = exports.swipeEnd = exports.swipeMove = exports.swipeStart = exports.keyHandler = exports.changeSlide = exports.slideHandler = exports.initializedState = exports.extractObject = exports.canGoNext = exports.getSwipeDirection = exports.getHeight = exports.getWidth = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.lazyStartIndex = exports.getRequiredLazySlides = exports.getOnDemandLazySlides = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(75);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getOnDemandLazySlides = exports.getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
  var onDemandSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);
  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
      onDemandSlides.push(slideIndex);
    }
  }
  return onDemandSlides;
};

// return list of slides that need to be present
var getRequiredLazySlides = exports.getRequiredLazySlides = function getRequiredLazySlides(spec) {
  var requiredSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);
  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    requiredSlides.push(slideIndex);
  }
  return requiredSlides;
};

// startIndex that needs to be present
var lazyStartIndex = exports.lazyStartIndex = function lazyStartIndex(spec) {
  return spec.currentSlide - lazySlidesOnLeft(spec);
};
var lazyEndIndex = exports.lazyEndIndex = function lazyEndIndex(spec) {
  return spec.currentSlide + lazySlidesOnRight(spec);
};
var lazySlidesOnLeft = exports.lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};
var lazySlidesOnRight = exports.lazySlidesOnRight = function lazySlidesOnRight(spec) {
  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
};

// get width of an element
var getWidth = exports.getWidth = function getWidth(elem) {
  return elem && elem.offsetWidth || 0;
};
var getHeight = exports.getHeight = function getHeight(elem) {
  return elem && elem.offsetHeight || 0;
};
var getSwipeDirection = exports.getSwipeDirection = function getSwipeDirection(touchObject) {
  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var xDist, yDist, r, swipeAngle;
  xDist = touchObject.startX - touchObject.curX;
  yDist = touchObject.startY - touchObject.curY;
  r = Math.atan2(yDist, xDist);
  swipeAngle = Math.round(r * 180 / Math.PI);
  if (swipeAngle < 0) {
    swipeAngle = 360 - Math.abs(swipeAngle);
  }
  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
    return "left";
  }
  if (swipeAngle >= 135 && swipeAngle <= 225) {
    return "right";
  }
  if (verticalSwiping === true) {
    if (swipeAngle >= 35 && swipeAngle <= 135) {
      return "up";
    } else {
      return "down";
    }
  }

  return "vertical";
};

// whether or not we can go next
var canGoNext = exports.canGoNext = function canGoNext(spec) {
  var canGo = true;
  if (!spec.infinite) {
    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
      canGo = false;
    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
      canGo = false;
    }
  }
  return canGo;
};

// given an object and a list of keys, return new object with given keys
var extractObject = exports.extractObject = function extractObject(spec, keys) {
  var newObject = {};
  keys.forEach(function (key) {
    return newObject[key] = spec[key];
  });
  return newObject;
};

// get initialized state
var initializedState = exports.initializedState = function initializedState(spec) {
  // spec also contains listRef, trackRef
  var slideCount = _react2.default.Children.count(spec.children);
  var listWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.listRef)));
  var trackWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.trackRef)));
  var slideWidth = void 0;
  if (!spec.vertical) {
    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
      centerPaddingAdj *= listWidth / 100;
    }
    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
  } else {
    slideWidth = listWidth;
  }
  var slideHeight = _reactDom2.default.findDOMNode(spec.listRef) && getHeight(_reactDom2.default.findDOMNode(spec.listRef).querySelector('[data-index="0"]'));
  var listHeight = slideHeight * spec.slidesToShow;
  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
  if (spec.rtl && spec.currentSlide === undefined) {
    currentSlide = slideCount - 1 - spec.initialSlide;
  }
  var lazyLoadedList = spec.lazyLoadedList || [];
  var slidesToLoad = getOnDemandLazySlides({ currentSlide: currentSlide, lazyLoadedList: lazyLoadedList }, spec);
  lazyLoadedList.concat(slidesToLoad);

  var state = {
    slideCount: slideCount,
    slideWidth: slideWidth,
    listWidth: listWidth,
    trackWidth: trackWidth,
    currentSlide: currentSlide,
    slideHeight: slideHeight,
    listHeight: listHeight,
    lazyLoadedList: lazyLoadedList
  };

  if (spec.autoplaying === null && spec.autoplay) {
    state["autoplaying"] = "playing";
  }

  return state;
};

var slideHandler = exports.slideHandler = function slideHandler(spec) {
  var waitForAnimate = spec.waitForAnimate,
      animating = spec.animating,
      fade = spec.fade,
      infinite = spec.infinite,
      index = spec.index,
      slideCount = spec.slideCount,
      lazyLoadedList = spec.lazyLoadedList,
      lazyLoad = spec.lazyLoad,
      currentSlide = spec.currentSlide,
      centerMode = spec.centerMode,
      slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      useCSS = spec.useCSS;

  if (waitForAnimate && animating) return {};
  var animationSlide = index,
      finalSlide = void 0,
      animationLeft = void 0,
      finalLeft = void 0;
  var state = {},
      nextState = {};
  if (fade) {
    if (!infinite && (index < 0 || index >= slideCount)) return {};
    if (index < 0) {
      animationSlide = index + slideCount;
    } else if (index >= slideCount) {
      animationSlide = index - slideCount;
    }
    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
      lazyLoadedList.push(animationSlide);
    }
    state = {
      animating: true,
      currentSlide: animationSlide,
      lazyLoadedList: lazyLoadedList
    };
    nextState = { animating: false };
  } else {
    finalSlide = animationSlide;
    if (animationSlide < 0) {
      finalSlide = animationSlide + slideCount;
      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
      animationSlide = finalSlide = currentSlide;
    } else if (centerMode && animationSlide >= slideCount) {
      animationSlide = infinite ? slideCount : slideCount - 1;
      finalSlide = infinite ? 0 : slideCount - 1;
    } else if (animationSlide >= slideCount) {
      finalSlide = animationSlide - slideCount;
      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
    }
    animationLeft = getTrackLeft(_extends({}, spec, { slideIndex: animationSlide }));
    finalLeft = getTrackLeft(_extends({}, spec, { slideIndex: finalSlide }));
    if (!infinite) {
      if (animationLeft === finalLeft) animationSlide = finalSlide;
      animationLeft = finalLeft;
    }
    lazyLoad && lazyLoadedList.concat(getOnDemandLazySlides(_extends({}, spec, { currentSlide: animationSlide })));
    if (!useCSS) {
      state = {
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
        lazyLoadedList: lazyLoadedList
      };
    } else {
      state = {
        animating: true,
        currentSlide: finalSlide,
        trackStyle: getTrackAnimateCSS(_extends({}, spec, { left: animationLeft })),
        lazyLoadedList: lazyLoadedList
      };
      nextState = {
        animating: false,
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
        swipeLeft: null
      };
    }
  }
  return { state: state, nextState: nextState };
};

var changeSlide = exports.changeSlide = function changeSlide(spec, options) {
  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
  var slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      slideCount = spec.slideCount,
      currentSlide = spec.currentSlide,
      lazyLoad = spec.lazyLoad,
      infinite = spec.infinite;

  unevenOffset = slideCount % slidesToScroll !== 0;
  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;

  if (options.message === "previous") {
    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
    targetSlide = currentSlide - slideOffset;
    if (lazyLoad && !infinite) {
      previousInt = currentSlide - slideOffset;
      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
    }
  } else if (options.message === "next") {
    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
    targetSlide = currentSlide + slideOffset;
    if (lazyLoad && !infinite) {
      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
    }
  } else if (options.message === "dots") {
    // Click on dots
    targetSlide = options.index * options.slidesToScroll;
    if (targetSlide === options.currentSlide) {
      return null;
    }
  } else if (options.message === "children") {
    // Click on the slides
    targetSlide = options.index;
    if (targetSlide === options.currentSlide) {
      return null;
    }
    if (infinite) {
      var direction = siblingDirection(_extends({}, spec, { targetSlide: targetSlide }));
      if (targetSlide > options.currentSlide && direction === "left") {
        targetSlide = targetSlide - slideCount;
      } else if (targetSlide < options.currentSlide && direction === "right") {
        targetSlide = targetSlide + slideCount;
      }
    }
  } else if (options.message === "index") {
    targetSlide = Number(options.index);
    if (targetSlide === options.currentSlide) {
      return null;
    }
  }
  return targetSlide;
};
var keyHandler = exports.keyHandler = function keyHandler(e, accessibility, rtl) {
  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
  if (e.keyCode === 37) return rtl ? "next" : "previous";
  if (e.keyCode === 39) return rtl ? "previous" : "next";
  return "";
};

var swipeStart = exports.swipeStart = function swipeStart(e, swipe, draggable) {
  e.target.tagName === "IMG" && e.preventDefault();
  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
  return {
    dragging: true,
    touchObject: {
      startX: e.touches ? e.touches[0].pageX : e.clientX,
      startY: e.touches ? e.touches[0].pageY : e.clientY,
      curX: e.touches ? e.touches[0].pageX : e.clientX,
      curY: e.touches ? e.touches[0].pageY : e.clientY
    }
  };
};
var swipeMove = exports.swipeMove = function swipeMove(e, spec) {
  // spec also contains, trackRef and slideIndex
  var scrolling = spec.scrolling,
      animating = spec.animating,
      vertical = spec.vertical,
      swipeToSlide = spec.swipeToSlide,
      verticalSwiping = spec.verticalSwiping,
      rtl = spec.rtl,
      currentSlide = spec.currentSlide,
      edgeFriction = spec.edgeFriction,
      edgeDragged = spec.edgeDragged,
      onEdge = spec.onEdge,
      swiped = spec.swiped,
      swiping = spec.swiping,
      slideCount = spec.slideCount,
      slidesToScroll = spec.slidesToScroll,
      infinite = spec.infinite,
      touchObject = spec.touchObject,
      swipeEvent = spec.swipeEvent,
      listHeight = spec.listHeight,
      listWidth = spec.listWidth;

  if (scrolling) return;
  if (animating) return e.preventDefault();
  if (vertical && swipeToSlide && verticalSwiping) e.preventDefault();
  var swipeLeft = void 0,
      state = {};
  var curLeft = getTrackLeft(spec);
  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
    return { scrolling: true };
  }
  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;

  var dotCount = Math.ceil(slideCount / slidesToScroll);
  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
  var touchSwipeLength = touchObject.swipeLength;
  if (!infinite) {
    if (currentSlide === 0 && swipeDirection === "right" || currentSlide + 1 >= dotCount && swipeDirection === "left" || !canGoNext(spec) && swipeDirection === "left") {
      touchSwipeLength = touchObject.swipeLength * edgeFriction;
      if (edgeDragged === false && onEdge) {
        onEdge(swipeDirection);
        state["edgeDragged"] = true;
      }
    }
  }
  if (!swiped && swipeEvent) {
    swipeEvent(swipeDirection);
    state["swiped"] = true;
  }
  if (!vertical) {
    if (!rtl) {
      swipeLeft = curLeft + touchSwipeLength * positionOffset;
    } else {
      swipeLeft = curLeft - touchSwipeLength * positionOffset;
    }
  } else {
    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
  }
  if (verticalSwiping) {
    swipeLeft = curLeft + touchSwipeLength * positionOffset;
  }
  state = _extends({}, state, {
    touchObject: touchObject,
    swipeLeft: swipeLeft,
    trackStyle: getTrackCSS(_extends({}, spec, { left: swipeLeft }))
  });
  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
    return state;
  }
  if (touchObject.swipeLength > 10) {
    state["swiping"] = true;
    e.preventDefault();
  }
  return state;
};
var swipeEnd = exports.swipeEnd = function swipeEnd(e, spec) {
  var dragging = spec.dragging,
      swipe = spec.swipe,
      touchObject = spec.touchObject,
      listWidth = spec.listWidth,
      touchThreshold = spec.touchThreshold,
      verticalSwiping = spec.verticalSwiping,
      listHeight = spec.listHeight,
      currentSlide = spec.currentSlide,
      swipeToSlide = spec.swipeToSlide,
      scrolling = spec.scrolling,
      onSwipe = spec.onSwipe;

  if (!dragging) {
    if (swipe) e.preventDefault();
    return {};
  }
  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping);
  // reset the state of touch related state variables.
  var state = {
    dragging: false,
    edgeDragged: false,
    scrolling: false,
    swiping: false,
    swiped: false,
    swipeLeft: null,
    touchObject: {}
  };
  if (scrolling) {
    return state;
  }
  if (!touchObject.swipeLength) {
    return state;
  }
  if (touchObject.swipeLength > minSwipe) {
    e.preventDefault();
    if (onSwipe) {
      onSwipe(swipeDirection);
    }
    var slideCount = void 0,
        newSlide = void 0;
    switch (swipeDirection) {
      case "left":
      case "up":
        newSlide = currentSlide + getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 0;
        break;
      case "right":
      case "down":
        newSlide = currentSlide - getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 1;
        break;
      default:
        slideCount = currentSlide;
    }
    state["triggerSlideHandler"] = slideCount;
  } else {
    // Adjust the track back to it's original position.
    var currentLeft = getTrackLeft(spec);
    state["trackStyle"] = getTrackAnimateCSS(_extends({}, spec, { left: currentLeft }));
  }
  return state;
};
var getNavigableIndexes = exports.getNavigableIndexes = function getNavigableIndexes(spec) {
  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
  var indexes = [];
  while (breakpoint < max) {
    indexes.push(breakpoint);
    breakpoint = counter + spec.slidesToScroll;
    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
  }
  return indexes;
};
var checkNavigable = exports.checkNavigable = function checkNavigable(spec, index) {
  var navigables = getNavigableIndexes(spec);
  var prevNavigable = 0;
  if (index > navigables[navigables.length - 1]) {
    index = navigables[navigables.length - 1];
  } else {
    for (var n in navigables) {
      if (index < navigables[n]) {
        index = prevNavigable;
        break;
      }
      prevNavigable = navigables[n];
    }
  }
  return index;
};
var getSlideCount = exports.getSlideCount = function getSlideCount(spec) {
  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
  if (spec.swipeToSlide) {
    var swipedSlide = void 0;
    var slickList = _reactDom2.default.findDOMNode(spec.listRef);
    var slides = slickList.querySelectorAll(".slick-slide");
    Array.from(slides).every(function (slide) {
      if (!spec.vertical) {
        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      } else {
        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      }

      return true;
    });

    if (!swipedSlide) {
      return 0;
    }
    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
    return slidesTraversed;
  } else {
    return spec.slidesToScroll;
  }
};

var checkSpecKeys = exports.checkSpecKeys = function checkSpecKeys(spec, keysArray) {
  return keysArray.reduce(function (value, key) {
    return value && spec.hasOwnProperty(key);
  }, true) ? null : console.error("Keys Missing:", spec);
};

var getTrackCSS = exports.getTrackCSS = function getTrackCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
  var trackWidth = void 0,
      trackHeight = void 0;
  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
  if (!spec.vertical) {
    trackWidth = getTotalSlides(spec) * spec.slideWidth;
  } else {
    trackHeight = trackChildren * spec.slideHeight;
  }
  var style = {
    opacity: 1,
    transition: "",
    WebkitTransition: ""
  };
  if (spec.useTransform) {
    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
    style = _extends({}, style, {
      WebkitTransform: WebkitTransform,
      transform: transform,
      msTransform: msTransform
    });
  } else {
    if (spec.vertical) {
      style["top"] = spec.left;
    } else {
      style["left"] = spec.left;
    }
  }
  if (spec.fade) style = { opacity: 1 };
  if (trackWidth) style.width = trackWidth;
  if (trackHeight) style.height = trackHeight;

  // Fallback for IE8
  if (window && !window.addEventListener && window.attachEvent) {
    if (!spec.vertical) {
      style.marginLeft = spec.left + "px";
    } else {
      style.marginTop = spec.left + "px";
    }
  }

  return style;
};
var getTrackAnimateCSS = exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
  var style = getTrackCSS(spec);
  // useCSS is true by default so it can be undefined
  if (spec.useTransform) {
    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
  } else {
    if (spec.vertical) {
      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    } else {
      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    }
  }
  return style;
};
var getTrackLeft = exports.getTrackLeft = function getTrackLeft(spec) {
  if (spec.unslick) {
    return 0;
  }

  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);

  var slideIndex = spec.slideIndex,
      trackRef = spec.trackRef,
      infinite = spec.infinite,
      centerMode = spec.centerMode,
      slideCount = spec.slideCount,
      slidesToShow = spec.slidesToShow,
      slidesToScroll = spec.slidesToScroll,
      slideWidth = spec.slideWidth,
      listWidth = spec.listWidth,
      variableWidth = spec.variableWidth,
      slideHeight = spec.slideHeight,
      fade = spec.fade,
      vertical = spec.vertical;


  var slideOffset = 0;
  var targetLeft;
  var targetSlide;
  var verticalOffset = 0;

  if (fade || spec.slideCount === 1) {
    return 0;
  }

  var slidesToOffset = 0;
  if (infinite) {
    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
    }
    // shift current slide to center of the frame
    if (centerMode) {
      slidesToOffset += parseInt(slidesToShow / 2);
    }
  } else {
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
    }
    if (centerMode) {
      slidesToOffset = parseInt(slidesToShow / 2);
    }
  }
  slideOffset = slidesToOffset * slideWidth;
  verticalOffset = slidesToOffset * slideHeight;

  if (!vertical) {
    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
  } else {
    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
  }

  if (variableWidth === true) {
    var targetSlideIndex;
    var trackElem = _reactDom2.default.findDOMNode(trackRef);
    targetSlideIndex = slideIndex + getPreClones(spec);
    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
    if (centerMode === true) {
      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
      targetSlide = trackElem && trackElem.children[targetSlideIndex];
      targetLeft = 0;
      for (var slide = 0; slide < targetSlideIndex; slide++) {
        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
      }
      targetLeft -= parseInt(spec.centerPadding);
      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
    }
  }

  return targetLeft;
};

var getPreClones = exports.getPreClones = function getPreClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }
  if (spec.variableWidth) {
    return spec.slideCount;
  }
  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};

var getPostClones = exports.getPostClones = function getPostClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }
  return spec.slideCount;
};

var getTotalSlides = exports.getTotalSlides = function getTotalSlides(spec) {
  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
};
var siblingDirection = exports.siblingDirection = function siblingDirection(spec) {
  if (spec.targetSlide > spec.currentSlide) {
    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
      return "left";
    }
    return "right";
  } else {
    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
      return "right";
    }
    return "left";
  }
};

var slidesOnRight = exports.slidesOnRight = function slidesOnRight(_ref) {
  var slidesToShow = _ref.slidesToShow,
      centerMode = _ref.centerMode,
      rtl = _ref.rtl,
      centerPadding = _ref.centerPadding;

  // returns no of slides on the right of active slide
  if (centerMode) {
    var right = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) right += 1;
    if (rtl && slidesToShow % 2 === 0) right += 1;
    return right;
  }
  if (rtl) {
    return 0;
  }
  return slidesToShow - 1;
};

var slidesOnLeft = exports.slidesOnLeft = function slidesOnLeft(_ref2) {
  var slidesToShow = _ref2.slidesToShow,
      centerMode = _ref2.centerMode,
      rtl = _ref2.rtl,
      centerPadding = _ref2.centerPadding;

  // returns no of slides on the left of active slide
  if (centerMode) {
    var left = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) left += 1;
    if (!rtl && slidesToShow % 2 === 0) left += 1;
    return left;
  }
  if (rtl) {
    return slidesToShow - 1;
  }
  return 0;
};

var canUseDOM = exports.canUseDOM = function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__validate_js__ = __webpack_require__(296);

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

var byteToHex = [];

for (var i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).substr(1));
}

function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!Object(__WEBPACK_IMPORTED_MODULE_0__validate_js__["a" /* default */])(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* harmony default export */ __webpack_exports__["a"] = (stringify);

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__regex_js__ = __webpack_require__(2236);


function validate(uuid) {
  return typeof uuid === 'string' && __WEBPACK_IMPORTED_MODULE_0__regex_js__["a" /* default */].test(uuid);
}

/* harmony default export */ __webpack_exports__["a"] = (validate);

/***/ }),
/* 297 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"card":"WGCWXShopCard_card--17OyN","card__hover":"WGCWXShopCard_card__hover--238Ac","cardHover":"WGCWXShopCard_card__hover--238Ac","card__header":"WGCWXShopCard_card__header--1yhWq","cardHeader":"WGCWXShopCard_card__header--1yhWq","card__green_corner":"WGCWXShopCard_card__green_corner--3QfRp","cardGreenCorner":"WGCWXShopCard_card__green_corner--3QfRp","card__main":"WGCWXShopCard_card__main--2Cf1v","cardMain":"WGCWXShopCard_card__main--2Cf1v","highlight":"WGCWXShopCard_highlight--38U-N","inner":"WGCWXShopCard_inner--3MPDz","placeholder":"WGCWXShopCard_placeholder--2Y9ym","content":"WGCWXShopCard_content--k36UU","title":"WGCWXShopCard_title--3Jne2","title__freeXpAndCrewXp":"WGCWXShopCard_title__freeXpAndCrewXp--1ky8S","titleFreeXpAndCrewXp":"WGCWXShopCard_title__freeXpAndCrewXp--1ky8S","description":"WGCWXShopCard_description--1Lzhd","price":"WGCWXShopCard_price--1I2ES","bonds":"WGCWXShopCard_bonds--Wezca","bonds__with_margin":"WGCWXShopCard_bonds__with_margin--31V9v","bondsWithMargin":"WGCWXShopCard_bonds__with_margin--31V9v","items_count":"WGCWXShopCard_items_count--3tHLx","itemsCount":"WGCWXShopCard_items_count--3tHLx","items_count_description":"WGCWXShopCard_items_count_description--14pjL","itemsCountDescription":"WGCWXShopCard_items_count_description--14pjL","tank_description":"WGCWXShopCard_tank_description--20u_O","tankDescription":"WGCWXShopCard_tank_description--20u_O","tank_list":"WGCWXShopCard_tank_list--3kOV2","tankList":"WGCWXShopCard_tank_list--3kOV2","tank_style":"WGCWXShopCard_tank_style--3Akjy","tankStyle":"WGCWXShopCard_tank_style--3Akjy","image":"WGCWXShopCard_image--2K_37","card__large":"WGCWXShopCard_card__large--1D5N1","cardLarge":"WGCWXShopCard_card__large--1D5N1","image__PFP_BATTLES":"WGCWXShopCard_image__PFP_BATTLES--20df2","imagePfpBattles":"WGCWXShopCard_image__PFP_BATTLES--20df2","image__BONDS":"WGCWXShopCard_image__BONDS--CPHb2","imageBonds":"WGCWXShopCard_image__BONDS--CPHb2","image__SILVER":"WGCWXShopCard_image__SILVER--1Vc-0","imageSilver":"WGCWXShopCard_image__SILVER--1Vc-0","image__GOLD":"WGCWXShopCard_image__GOLD--1Xtil","imageGold":"WGCWXShopCard_image__GOLD--1Xtil","image__DIGITAL_STYLE":"WGCWXShopCard_image__DIGITAL_STYLE--1DiF2","imageDigitalStyle":"WGCWXShopCard_image__DIGITAL_STYLE--1DiF2","image__VETERAN_STYLE":"WGCWXShopCard_image__VETERAN_STYLE--1FrIg","imageVeteranStyle":"WGCWXShopCard_image__VETERAN_STYLE--1FrIg","image__VANQUISHER_STYLE":"WGCWXShopCard_image__VANQUISHER_STYLE--rnaGh","imageVanquisherStyle":"WGCWXShopCard_image__VANQUISHER_STYLE--rnaGh","image__BROKEN_STONE_STYLE":"WGCWXShopCard_image__BROKEN_STONE_STYLE--iKAmr","imageBrokenStoneStyle":"WGCWXShopCard_image__BROKEN_STONE_STYLE--iKAmr","image__CONQUEROR_STYLE":"WGCWXShopCard_image__CONQUEROR_STYLE--29tsL","imageConquerorStyle":"WGCWXShopCard_image__CONQUEROR_STYLE--29tsL","image__NIGHTFALL_STYLE":"WGCWXShopCard_image__NIGHTFALL_STYLE--rX91A","imageNightfallStyle":"WGCWXShopCard_image__NIGHTFALL_STYLE--rX91A","image__EMBLEM":"WGCWXShopCard_image__EMBLEM--3ZJbb","imageEmblem":"WGCWXShopCard_image__EMBLEM--3ZJbb","image__CREW_WOMAN":"WGCWXShopCard_image__CREW_WOMAN--1txWl","imageCrewWoman":"WGCWXShopCard_image__CREW_WOMAN--1txWl","image__DIRECTIVES_PACK":"WGCWXShopCard_image__DIRECTIVES_PACK--bK45D","imageDirectivesPack":"WGCWXShopCard_image__DIRECTIVES_PACK--bK45D","image__DIRECTIVES_PACK_30":"WGCWXShopCard_image__DIRECTIVES_PACK_30--3UYdD","imageDirectivesPack30":"WGCWXShopCard_image__DIRECTIVES_PACK_30--3UYdD","image__LIGHTNING_STYLE":"WGCWXShopCard_image__LIGHTNING_STYLE--2bZOc","imageLightningStyle":"WGCWXShopCard_image__LIGHTNING_STYLE--2bZOc","image__CREW_BOOK_NATIONAL":"WGCWXShopCard_image__CREW_BOOK_NATIONAL--3GDS_","imageCrewBookNational":"WGCWXShopCard_image__CREW_BOOK_NATIONAL--3GDS_","image__GRAPHITE_STYLE":"WGCWXShopCard_image__GRAPHITE_STYLE--3gla1","imageGraphiteStyle":"WGCWXShopCard_image__GRAPHITE_STYLE--3gla1","image__FIRE_STYLE":"WGCWXShopCard_image__FIRE_STYLE--z8xNQ","imageFireStyle":"WGCWXShopCard_image__FIRE_STYLE--z8xNQ","image__DIGITAL_ADAPTED_STYLE":"WGCWXShopCard_image__DIGITAL_ADAPTED_STYLE--uuVox","imageDigitalAdaptedStyle":"WGCWXShopCard_image__DIGITAL_ADAPTED_STYLE--uuVox","image__CLAN_URBAN_STYLE":"WGCWXShopCard_image__CLAN_URBAN_STYLE--12H4g","imageClanUrbanStyle":"WGCWXShopCard_image__CLAN_URBAN_STYLE--12H4g","image__GUARDIAN_OF_CROWN_STYLE":"WGCWXShopCard_image__GUARDIAN_OF_CROWN_STYLE--RUTrG","imageGuardianOfCrownStyle":"WGCWXShopCard_image__GUARDIAN_OF_CROWN_STYLE--RUTrG","image__PROPHESY_STYLE":"WGCWXShopCard_image__PROPHESY_STYLE--3zroF","imageProphesyStyle":"WGCWXShopCard_image__PROPHESY_STYLE--3zroF","image__JUDGEMENT_STYLE":"WGCWXShopCard_image__JUDGEMENT_STYLE--2nyer","imageJudgementStyle":"WGCWXShopCard_image__JUDGEMENT_STYLE--2nyer","image__REAPER_STYLE":"WGCWXShopCard_image__REAPER_STYLE--3hK2z","imageReaperStyle":"WGCWXShopCard_image__REAPER_STYLE--3hK2z","image__DIGITAL_CAMOUFLAGE_WINTER":"WGCWXShopCard_image__DIGITAL_CAMOUFLAGE_WINTER--vs4mx","imageDigitalCamouflageWinter":"WGCWXShopCard_image__DIGITAL_CAMOUFLAGE_WINTER--vs4mx","image__DIGITAL_CAMOUFLAGE_SUMMER":"WGCWXShopCard_image__DIGITAL_CAMOUFLAGE_SUMMER--ng9zu","imageDigitalCamouflageSummer":"WGCWXShopCard_image__DIGITAL_CAMOUFLAGE_SUMMER--ng9zu","image__DIGITAL_CAMOUFLAGE_DESERT":"WGCWXShopCard_image__DIGITAL_CAMOUFLAGE_DESERT--3qgP3","imageDigitalCamouflageDesert":"WGCWXShopCard_image__DIGITAL_CAMOUFLAGE_DESERT--3qgP3","image__AIR_ELEMENTAL_STYLE":"WGCWXShopCard_image__AIR_ELEMENTAL_STYLE--rZcPc","imageAirElementalStyle":"WGCWXShopCard_image__AIR_ELEMENTAL_STYLE--rZcPc","image__EARTH_ELEMENTAL_STYLE":"WGCWXShopCard_image__EARTH_ELEMENTAL_STYLE--2TbYJ","imageEarthElementalStyle":"WGCWXShopCard_image__EARTH_ELEMENTAL_STYLE--2TbYJ","image__WATER_ELEMENTAL_STYLE":"WGCWXShopCard_image__WATER_ELEMENTAL_STYLE--rfBPS","imageWaterElementalStyle":"WGCWXShopCard_image__WATER_ELEMENTAL_STYLE--rfBPS","image__FIRE_ELEMENTAL_STYLE":"WGCWXShopCard_image__FIRE_ELEMENTAL_STYLE--aJ6f6","imageFireElementalStyle":"WGCWXShopCard_image__FIRE_ELEMENTAL_STYLE--aJ6f6","image__PROSERPINA_STYLE":"WGCWXShopCard_image__PROSERPINA_STYLE--1WB6Q","imageProserpinaStyle":"WGCWXShopCard_image__PROSERPINA_STYLE--1WB6Q","image__NAMENLOS_STYLE":"WGCWXShopCard_image__NAMENLOS_STYLE--3gKWK","imageNamenlosStyle":"WGCWXShopCard_image__NAMENLOS_STYLE--3gKWK","image__CREW_EXPERIENCE":"WGCWXShopCard_image__CREW_EXPERIENCE--OtsaI","imageCrewExperience":"WGCWXShopCard_image__CREW_EXPERIENCE--OtsaI","image__FREE_EXPERIENCE":"WGCWXShopCard_image__FREE_EXPERIENCE--129cB","imageFreeExperience":"WGCWXShopCard_image__FREE_EXPERIENCE--129cB","image__EXPERIENCE":"WGCWXShopCard_image__EXPERIENCE--1CSAN","imageExperience":"WGCWXShopCard_image__EXPERIENCE--1CSAN","image__XP_RESERVE":"WGCWXShopCard_image__XP_RESERVE--37hmJ","imageXpReserve":"WGCWXShopCard_image__XP_RESERVE--37hmJ","image__FREE_XP_AND_CREW_XP":"WGCWXShopCard_image__FREE_XP_AND_CREW_XP--18ano","imageFreeXpAndCrewXp":"WGCWXShopCard_image__FREE_XP_AND_CREW_XP--18ano","image__HELLRAISER_STYLE":"WGCWXShopCard_image__HELLRAISER_STYLE--1ZuGj","imageHellraiserStyle":"WGCWXShopCard_image__HELLRAISER_STYLE--1ZuGj","image__WARRIOR_OF_THE_EAST_STYLE":"WGCWXShopCard_image__WARRIOR_OF_THE_EAST_STYLE--35JlE","imageWarriorOfTheEastStyle":"WGCWXShopCard_image__WARRIOR_OF_THE_EAST_STYLE--35JlE","image__WARRIOR_OF_THE_NORTH_STYLE":"WGCWXShopCard_image__WARRIOR_OF_THE_NORTH_STYLE--wz86E","imageWarriorOfTheNorthStyle":"WGCWXShopCard_image__WARRIOR_OF_THE_NORTH_STYLE--wz86E","image__WARRIOR_OF_THE_SOUTH_STYLE":"WGCWXShopCard_image__WARRIOR_OF_THE_SOUTH_STYLE--2lGl8","imageWarriorOfTheSouthStyle":"WGCWXShopCard_image__WARRIOR_OF_THE_SOUTH_STYLE--2lGl8","image__WARRIOR_OF_THE_WEST_STYLE":"WGCWXShopCard_image__WARRIOR_OF_THE_WEST_STYLE--d8zF3","imageWarriorOfTheWestStyle":"WGCWXShopCard_image__WARRIOR_OF_THE_WEST_STYLE--d8zF3","image__KRAIT_STYLE":"WGCWXShopCard_image__KRAIT_STYLE--L3EGD","imageKraitStyle":"WGCWXShopCard_image__KRAIT_STYLE--L3EGD","image__BASALT_STYLE":"WGCWXShopCard_image__BASALT_STYLE--1yK-s","imageBasaltStyle":"WGCWXShopCard_image__BASALT_STYLE--1yK-s","isCnRealm":"WGCWXShopCard_isCnRealm--2kSQ7","image__PREMIUM_PLUS_1":"WGCWXShopCard_image__PREMIUM_PLUS_1--2eDtS","imagePremiumPlus1":"WGCWXShopCard_image__PREMIUM_PLUS_1--2eDtS","image__PREMIUM_PLUS_3":"WGCWXShopCard_image__PREMIUM_PLUS_3--1Ikqm","imagePremiumPlus3":"WGCWXShopCard_image__PREMIUM_PLUS_3--1Ikqm","image__PERSONAL_RESERVE_BIG":"WGCWXShopCard_image__PERSONAL_RESERVE_BIG--1LlWa","imagePersonalReserveBig":"WGCWXShopCard_image__PERSONAL_RESERVE_BIG--1LlWa","image__PERSONAL_RESERVE_SMALL":"WGCWXShopCard_image__PERSONAL_RESERVE_SMALL--2zbOU","imagePersonalReserveSmall":"WGCWXShopCard_image__PERSONAL_RESERVE_SMALL--2zbOU"};

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.treasuryPropTypes = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var treasuryPropTypes = exports.treasuryPropTypes = _propTypes2.default.shape({
    credits: _propTypes2.default.number,
    crystal: _propTypes2.default.number,
    gold: _propTypes2.default.number
});

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DIALOG_CHANGE_COMMANDER_SUBMIT_BUTTON_CAPTION = exports.DIALOG_CHANGE_COMMANDER_CONTENT = exports.DIALOG_CHANGE_COMMANDER_TITLE = exports.DIALOG_REMOVE_MEMBERS_CONTENT_PLAYERS = exports.DIALOG_REMOVE_MEMBERS_CONTENT_1_PLAYER = exports.DIALOG_BUTTON_CANCEL_CAPTION = exports.DIALOG_REMOVE_MEMBERS_SUBMIT_BUTTON_CAPTION = exports.DIALOG_REMOVE_MEMBERS_TITLE = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DIALOG_REMOVE_MEMBERS_TITLE = exports.DIALOG_REMOVE_MEMBERS_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'members_control_block.dialog.remove_members.title',
    defaultMessage: '\u0418\u0441\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435 \u0438\u0437 \u043A\u043B\u0430\u043D\u0430'
});

var DIALOG_REMOVE_MEMBERS_SUBMIT_BUTTON_CAPTION = exports.DIALOG_REMOVE_MEMBERS_SUBMIT_BUTTON_CAPTION = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'members_control_block.dialog.remove_members.submit_button.caption',
    defaultMessage: '\u0418\u0441\u043A\u043B\u044E\u0447\u0438\u0442\u044C'
});

var DIALOG_BUTTON_CANCEL_CAPTION = exports.DIALOG_BUTTON_CANCEL_CAPTION = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'members_control_block.dialog.button_cancel.caption',
    defaultMessage: '\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C'
});

var DIALOG_REMOVE_MEMBERS_CONTENT_1_PLAYER = exports.DIALOG_REMOVE_MEMBERS_CONTENT_1_PLAYER = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'members_control_block.dialog_content.1_player',
    defaultMessage: '\u0418\u0441\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0438\u0437 \u043A\u043B\u0430\u043D\u0430 \u0438\u0433\u0440\u043E\u043A\u0430'
});

var DIALOG_REMOVE_MEMBERS_CONTENT_PLAYERS = exports.DIALOG_REMOVE_MEMBERS_CONTENT_PLAYERS = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'members_control_block.dialog_content.players',
    defaultMessage: '\u0418\u0441\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0438\u0437 \u043A\u043B\u0430\u043D\u0430 \u0438\u0433\u0440\u043E\u043A\u043E\u0432:'
});

var DIALOG_CHANGE_COMMANDER_TITLE = exports.DIALOG_CHANGE_COMMANDER_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'members_control_block.dialog.change_commander.title',
    defaultMessage: '\u0421\u043C\u0435\u043D\u0430 \u043A\u043E\u043C\u0430\u043D\u0434\u0443\u044E\u0449\u0435\u0433\u043E'
});

var DIALOG_CHANGE_COMMANDER_CONTENT = exports.DIALOG_CHANGE_COMMANDER_CONTENT = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'members_control_block.dialog.change_commander.content',
    defaultMessage: '\u041F\u0435\u0440\u0435\u0434\u0430\u0442\u044C \u043A\u043E\u043C\u0430\u043D\u0434\u043E\u0432\u0430\u043D\u0438\u0435 \u0438\u0433\u0440\u043E\u043A\u0443'
});

var DIALOG_CHANGE_COMMANDER_SUBMIT_BUTTON_CAPTION = exports.DIALOG_CHANGE_COMMANDER_SUBMIT_BUTTON_CAPTION = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'members_control_block.dialog.change_commander.submit_button.caption',
    defaultMessage: '\u041F\u0435\u0440\u0435\u0434\u0430\u0442\u044C \u043A\u043E\u043C\u0430\u043D\u0434\u043E\u0432\u0430\u043D\u0438\u0435'
});

/***/ }),
/* 300 */,
/* 301 */,
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ButtonTiny = __webpack_require__(414);

var _ButtonTiny2 = _interopRequireDefault(_ButtonTiny);

var _DefaultTooltip = __webpack_require__(30);

var _DefaultTooltip2 = _interopRequireDefault(_DefaultTooltip);

var _UpdateButton = __webpack_require__(416);

var _UpdateButton2 = _interopRequireDefault(_UpdateButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
    disabled: _propTypes2.default.bool,
    handleClick: _propTypes2.default.func.isRequired,
    tooltipTitle: _propTypes2.default.node,
    tooltipMessage: _propTypes2.default.node
};

var TOOLTIP_ID = 'updateButtonTooltip';

var UpdateButton = function UpdateButton(props) {
    return _react2.default.createElement(
        _ButtonTiny2.default,
        { type: 'secondary', handleClick: props.handleClick, disabled: props.disabled },
        _react2.default.createElement('span', { className: _UpdateButton2.default.icon, 'data-tip': true, 'data-for': TOOLTIP_ID }),
        _react2.default.createElement(_DefaultTooltip2.default, {
            id: TOOLTIP_ID,
            title: props.tooltipTitle,
            message: props.tooltipMessage
        })
    );
};

UpdateButton.propTypes = propTypes;

exports.default = UpdateButton;

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(271),
    arrayIncludes = __webpack_require__(366),
    arrayIncludesWith = __webpack_require__(367),
    cacheHas = __webpack_require__(272),
    createSet = __webpack_require__(445),
    setToArray = __webpack_require__(188);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 382 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Warning_base--2BIGy","base__message":"Warning_base__message--36548","baseMessage":"Warning_base__message--36548","base__warning":"Warning_base__warning--2ZEoG","baseWarning":"Warning_base__warning--2ZEoG","base__alert":"Warning_base__alert--QgS8c","baseAlert":"Warning_base__alert--QgS8c"};

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BaseBonusInfoTable = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _TableRow = __webpack_require__(2111);

var _constants = __webpack_require__(4);

var _BaseBonusInfoTable = __webpack_require__(1331);

var _BaseBonusInfoTable2 = _interopRequireDefault(_BaseBonusInfoTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseBonusInfoTable = exports.BaseBonusInfoTable = function (_React$Component) {
    _inherits(BaseBonusInfoTable, _React$Component);

    function BaseBonusInfoTable(props) {
        _classCallCheck(this, BaseBonusInfoTable);

        var _this = _possibleConstructorReturn(this, (BaseBonusInfoTable.__proto__ || Object.getPrototypeOf(BaseBonusInfoTable)).call(this, props));

        _this.setTableColumnsRefs = function (el, dataIndex) {
            if (!_this.tableColumnsRefs[dataIndex]) {
                _this.tableColumnsRefs[dataIndex] = [];
            }

            _this.tableColumnsRefs[dataIndex].push(el);
        };

        _this.setColumnWidthConfig = function () {
            var columnsWidthConfig = _this.props.columns.map(function (column) {
                return column.dataIndex;
            }).reduce(function (acc, columnKey) {
                var columnHeaderWidth = _this.tableHeaderRefs[columnKey].clientWidth;
                var columnCells = _this.tableColumnsRefs[columnKey];
                var columnCellsWidth = columnCells.map(function (columnCellEl) {
                    return columnCellEl.clientWidth;
                });

                acc[columnKey] = Math.max.apply(Math, [columnHeaderWidth].concat(_toConsumableArray(columnCellsWidth)));
                return acc;
            }, {});

            _this.setState({ columnsWidthConfig: columnsWidthConfig });
        };

        _this.componentDidMount = function () {
            _this.setColumnWidthConfig();
        };

        _this.tableHeaderRefs = {};
        _this.tableColumnsRefs = {};
        _this.state = {
            columnsWidthConfig: {}
        };
        return _this;
    }

    _createClass(BaseBonusInfoTable, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                className = _props.className,
                _props$classNames = _props.classNames,
                classNames = _props$classNames === undefined ? {} : _props$classNames,
                title = _props.title,
                notice = _props.notice,
                footer = _props.footer,
                columns = _props.columns,
                selectedRow = _props.selectedRow,
                dataSource = _props.dataSource;
            var columnsWidthConfig = this.state.columnsWidthConfig;


            return _react2.default.createElement(
                'div',
                { className: className },
                _react2.default.createElement(
                    'p',
                    { className: (0, _classnames2.default)(_BaseBonusInfoTable2.default.title, classNames.title) },
                    title
                ),
                notice && _react2.default.createElement(
                    'p',
                    { className: _BaseBonusInfoTable2.default.notice },
                    notice
                ),
                _react2.default.createElement(
                    'div',
                    { className: _BaseBonusInfoTable2.default.table },
                    _react2.default.createElement(
                        'div',
                        { className: _BaseBonusInfoTable2.default.thead },
                        _react2.default.createElement(
                            'div',
                            { className: _BaseBonusInfoTable2.default.tr },
                            columns.map(function (_ref) {
                                var title = _ref.title,
                                    _ref$classNames = _ref.classNames,
                                    columnClassNames = _ref$classNames === undefined ? {} : _ref$classNames,
                                    dataIndex = _ref.dataIndex,
                                    align = _ref.align,
                                    isCalculatedWidth = _ref.isCalculatedWidth;

                                return _react2.default.createElement(
                                    'div',
                                    {
                                        key: dataIndex,
                                        className: (0, _classnames2.default)(_BaseBonusInfoTable2.default.th, _BaseBonusInfoTable2.default.th__right || align && _BaseBonusInfoTable2.default['th__' + align], isCalculatedWidth && _BaseBonusInfoTable2.default.th__calculatedWidth, columnClassNames.th),
                                        ref: function ref(el) {
                                            return _this2.tableHeaderRefs[dataIndex] = el;
                                        },
                                        style: { '--cell-width': columnsWidthConfig[dataIndex] + 'px' }
                                    },
                                    title
                                );
                            })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _BaseBonusInfoTable2.default.tbody },
                        dataSource.map(function (bonus, rowIndex) {
                            if (rowIndex < _constants.MAX_BUILDING_LEVEL) {
                                return _react2.default.createElement(_TableRow.TableRow, {
                                    key: rowIndex,
                                    rowIndex: rowIndex,
                                    selectedRow: selectedRow,
                                    columns: columns,
                                    bonus: bonus,
                                    setTableColumnsRefs: _this2.setTableColumnsRefs,
                                    columnsWidthConfig: columnsWidthConfig
                                });
                            }
                        })
                    ),
                    footer && _react2.default.createElement(
                        'div',
                        { className: _BaseBonusInfoTable2.default.tfoot },
                        footer
                    )
                )
            );
        }
    }]);

    return BaseBonusInfoTable;
}(_react2.default.Component);

BaseBonusInfoTable.propTypes = {
    title: _propTypes2.default.node.isRequired,
    notice: _propTypes2.default.node,
    footer: _propTypes2.default.node,
    columns: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        title: _propTypes2.default.node.isRequired,
        dataIndex: _propTypes2.default.string.isRequired,
        render: _propTypes2.default.func
    })).isRequired,
    dataSource: _propTypes2.default.array.isRequired,
    selectedRow: _propTypes2.default.number,
    className: _propTypes2.default.string,
    classNames: _propTypes2.default.shape({
        title: _propTypes2.default.string
    })
};

exports.default = BaseBonusInfoTable;

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FOOTER_RESERVES_NOTES = exports.RESERVES_PARAMETERS_CAPTIONS = exports.ADDITIONAL_INDUSTRIAL_RESOURCE = exports.RESERVE_LEVEL = undefined;

var _RESERVES_PARAMETERS_;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _BaseBonusInfoTable = __webpack_require__(1331);

var _BaseBonusInfoTable2 = _interopRequireDefault(_BaseBonusInfoTable);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint-disable react/no-multi-comp */


var getLineBreak = function getLineBreak() {
    var isEnabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return isEnabled ? _react2.default.createElement('br', null) : ' ';
};

var RESERVE_LEVEL = exports.RESERVE_LEVEL = function RESERVE_LEVEL(isLineBreakEnabled) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'reserve_info_table.column_title.reserve_level',
        defaultMessage: '\u0423\u0440\u043E\u0432\u0435\u043D\u044C{lineBreak}\u0440\u0435\u0437\u0435\u0440\u0432\u0430',
        values: {
            lineBreak: getLineBreak(isLineBreakEnabled)
        }
    });
};

var ADDITIONAL_INDUSTRIAL_RESOURCE = exports.ADDITIONAL_INDUSTRIAL_RESOURCE = function ADDITIONAL_INDUSTRIAL_RESOURCE(isLineBreakEnabled) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'reserve_info_table.column_title.additional_industrial_resource',
        defaultMessage: '\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439{lineBreak}\u043F\u0440\u043E\u043C\u0440\u0435\u0441\u0443\u0440\u0441',
        values: {
            lineBreak: getLineBreak(isLineBreakEnabled)
        }
    });
};

var RESERVES_PARAMETERS_CAPTIONS = exports.RESERVES_PARAMETERS_CAPTIONS = (_RESERVES_PARAMETERS_ = {}, _defineProperty(_RESERVES_PARAMETERS_, _constants.RESERVE_PARAMETERS_TYPES.COMMON_AREA_RADIUS, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'reserve_info_table.column_title.reserve_parameters.common_area_radius',
    defaultMessage: '\u0420\u0430\u0434\u0438\u0443\u0441 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F'
})), _defineProperty(_RESERVES_PARAMETERS_, _constants.RESERVE_PARAMETERS_TYPES.CREW_ROLES_FACTOR, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'reserve_info_table.column_title.reserve_parameters.crew_roles_factor',
    defaultMessage: '\u0411\u043E\u043D\u0443\u0441 \u043A \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438 \u044D\u043A\u0438\u043F\u0430\u0436\u0430'
})), _defineProperty(_RESERVES_PARAMETERS_, _constants.RESERVE_PARAMETERS_TYPES.MAX_DAMAGE, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'reserve_info_table.column_title.reserve_parameters.max_damage',
    defaultMessage: '\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u044B\u0439{lineBreak}\u0443\u0440\u043E\u043D {asterisk}',
    values: {
        lineBreak: getLineBreak(),
        asterisk: _react2.default.createElement(
            'span',
            { className: _BaseBonusInfoTable2.default.asterisk },
            '*'
        )
    }
})), _defineProperty(_RESERVES_PARAMETERS_, _constants.RESERVE_PARAMETERS_TYPES.AREA_RADIUS, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'reserve_info_table.column_title.reserve_parameters.area_radius',
    defaultMessage: '\u0420\u0430\u0434\u0438\u0443\u0441{lineBreak}\u0437\u043E\u043D\u044B \u043F\u043E\u0440\u0430\u0436\u0435\u043D\u0438\u044F',
    values: {
        lineBreak: getLineBreak()
    }
})), _RESERVES_PARAMETERS_);

var FOOTER_RESERVES_NOTES = exports.FOOTER_RESERVES_NOTES = _defineProperty({}, _constants.RESERVE_TYPES.ARTILLERY_STRIKE, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'reserve_info_table.footer.artillery_strike_note',
    defaultMessage: '{asterisk} \u0434\u043B\u044F \u0431\u043E\u0451\u0432 \u043D\u0430 VI / VIII / X \u0443\u0440\u043E\u0432\u043D\u0435 \u0442\u0435\u0445\u043D\u0438\u043A\u0438',
    values: {
        asterisk: _react2.default.createElement(
            'span',
            { className: _BaseBonusInfoTable2.default.asterisk },
            '*'
        )
    }
}));

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SingleValueBonusDescription = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _i18n = __webpack_require__(10);

var _translations = __webpack_require__(386);

var _SingleValueBonusDescription = __webpack_require__(205);

var _SingleValueBonusDescription2 = _interopRequireDefault(_SingleValueBonusDescription);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SingleValueBonusDescription = exports.SingleValueBonusDescription = function SingleValueBonusDescription(_ref) {
    var _ref$layoutType = _ref.layoutType,
        layoutType = _ref$layoutType === undefined ? 'default' : _ref$layoutType,
        battleType = _ref.battleType,
        reserveType = _ref.reserveType,
        bonusType = _ref.bonusType,
        reserveParameters = _ref.reserveParameters;
    var bonus = reserveParameters.bonus,
        duration = reserveParameters.duration;


    return _react2.default.createElement(
        'p',
        { className: (0, _classnames2.default)(_SingleValueBonusDescription2.default.base, _SingleValueBonusDescription2.default['base__' + layoutType + 'Layout']) },
        _react2.default.createElement(
            'span',
            { className: (0, _classnames2.default)(_SingleValueBonusDescription2.default.value, bonus.isHighlightEnabled && _SingleValueBonusDescription2.default.value__glow) },
            _react2.default.createElement(
                'span',
                { className: _SingleValueBonusDescription2.default.sign },
                '+'
            ),
            _react2.default.createElement(
                'span',
                { className: _SingleValueBonusDescription2.default.number },
                bonus.value
            ),
            _react2.default.createElement(
                'span',
                { className: _SingleValueBonusDescription2.default.percent },
                '%'
            )
        ),
        '\u2002',
        _react2.default.createElement(
            'span',
            { className: _SingleValueBonusDescription2.default.description },
            _react2.default.createElement(
                'span',
                { className: _SingleValueBonusDescription2.default.target },
                _i18n.BONUS_TYPE_MESSAGES[bonusType],
                _translations.RESERVE_TYPE_CONDITION[reserveType] && _react2.default.createElement(
                    'span',
                    null,
                    '\u2009',
                    _translations.RESERVE_TYPE_CONDITION[reserveType]
                )
            ),
            _react2.default.createElement('br', null),
            duration ? _translations.BATTLE_TYPE_RESERVE_DURATION_DESCRIPTION[battleType](duration, bonusType) : _translations.BATTLE_TYPE_RESERVE_DESCRIPTION[battleType]
        )
    );
};

var reserveParameterPropTypes = _propTypes2.default.shape({
    value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
    isHighlightEnabled: _propTypes2.default.bool
});

SingleValueBonusDescription.propTypes = {
    reserveParameters: _propTypes2.default.shape({
        bonus: reserveParameterPropTypes.isRequired,
        duration: reserveParameterPropTypes
    }),
    reserveType: _propTypes2.default.string.isRequired,
    battleType: _propTypes2.default.string.isRequired,
    bonusType: _propTypes2.default.string.isRequired,
    layoutType: _propTypes2.default.oneOf(['default', 'tooltip', 'toolbar'])
};

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RESERVE_TYPE_CONDITION = exports.BATTLE_TYPE_RESERVE_DESCRIPTION = exports.BATTLE_TYPE_RESERVE_DURATION_DESCRIPTION = undefined;

var _BATTLE_TYPE_RESERVE_, _BATTLE_TYPE_RESERVE_2, _RESERVE_TYPE_CONDITI;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactIntl = __webpack_require__(3);

var _constants = __webpack_require__(4);

var _SingleValueBonusDescription = __webpack_require__(205);

var _SingleValueBonusDescription2 = _interopRequireDefault(_SingleValueBonusDescription);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint-disable react/no-multi-comp, max-len */


var nbsp = _react2.default.createElement(
    'span',
    null,
    '\xA0'
);

var BATTLE_TYPE_RESERVE_DURATION_DESCRIPTION = exports.BATTLE_TYPE_RESERVE_DURATION_DESCRIPTION = (_BATTLE_TYPE_RESERVE_ = {}, _defineProperty(_BATTLE_TYPE_RESERVE_, _constants.BATTLE_TYPES.ALL_BATTLES, function (duration) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'reserve_info_bar.battle_types.all_battles',
        defaultMessage: '\u0432\u043E \u0432\u0441\u0435\u0445 \u0440\u0435\u0436\u0438\u043C\u0430\u0445 \u0431\u043E\u0435\u0432 \u043D\u0430 {duration}{nbsp}\u0447',
        values: {
            duration: _react2.default.createElement(
                'span',
                { className: (0, _classnames2.default)(_SingleValueBonusDescription2.default.duration, duration.isHighlightEnabled && _SingleValueBonusDescription2.default.duration__glow) },
                duration.value
            ),
            nbsp: nbsp
        }
    });
}), _defineProperty(_BATTLE_TYPE_RESERVE_, _constants.BATTLE_TYPES.RANDOM_BATTLES, function (duration, bonusType) {
    if (bonusType === _constants.BONUS_TYPES.EXTRA_CREDITS) return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'reserve_info_bar.battle_types.random_battles_and_steel_hunter',
        defaultMessage: '\u0432 \u0421\u043B\u0443\u0447\u0430\u0439\u043D\u044B\u0445 \u0431\u043E\u044F\u0445, \u0430 \u0442\u0430\u043A\u0436\u0435 \u043D\u0430 \u041B\u0438\u043D\u0438\u0438 \u0444\u0440\u043E\u043D\u0442\u0430 \u0438 \u0432 \u0421\u0442\u0430\u043B\u044C\u043D\u043E\u043C \u043E\u0445\u043E\u0442\u043D\u0438\u043A\u0435 \u043D\u0430 {duration}{nbsp}\u0447',
        values: {
            duration: _react2.default.createElement(
                'span',
                { className: (0, _classnames2.default)(_SingleValueBonusDescription2.default.duration, duration.isHighlightEnabled && _SingleValueBonusDescription2.default.duration__glow) },
                duration.value
            ),
            nbsp: nbsp
        }
    });
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'reserve_info_bar.battle_types.random_battles',
        defaultMessage: '\u0432 \u0421\u043B\u0443\u0447\u0430\u0439\u043D\u044B\u0445 \u0431\u043E\u044F\u0445 \u0438 \u043D\u0430 \u041B\u0438\u043D\u0438\u0438 \u0444\u0440\u043E\u043D\u0442\u0430 \u043D\u0430 {duration}{nbsp}\u0447',
        values: {
            duration: _react2.default.createElement(
                'span',
                { className: (0, _classnames2.default)(_SingleValueBonusDescription2.default.duration, duration.isHighlightEnabled && _SingleValueBonusDescription2.default.duration__glow) },
                duration.value
            ),
            nbsp: nbsp
        }
    });
}), _defineProperty(_BATTLE_TYPE_RESERVE_, _constants.BATTLE_TYPES.CLAN_BATTLES, function (duration) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'reserve_info_bar.battle_types.clan_battles',
        defaultMessage: '\u0432 \u043A\u043B\u0430\u043D\u043E\u0432\u044B\u0445 \u0438 \u0442\u0443\u0440\u043D\u0438\u0440\u043D\u044B\u0445 \u0431\u043E\u044F\u0445 \u043D\u0430 {duration}{nbsp}\u0447',
        values: {
            duration: _react2.default.createElement(
                'span',
                { className: (0, _classnames2.default)(_SingleValueBonusDescription2.default.duration, duration.isHighlightEnabled && _SingleValueBonusDescription2.default.duration__glow) },
                duration.value
            ),
            nbsp: nbsp
        }
    });
}), _BATTLE_TYPE_RESERVE_);

var BATTLE_TYPE_RESERVE_DESCRIPTION = exports.BATTLE_TYPE_RESERVE_DESCRIPTION = (_BATTLE_TYPE_RESERVE_2 = {}, _defineProperty(_BATTLE_TYPE_RESERVE_2, _constants.BATTLE_TYPES.BATTLE_FOR_STRONGHOLD_AND_SORTIE, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'reserve_info_bar.battle_types.battles_for_stronghold_and_sorties',
    defaultMessage: '\u0432 \u0412\u044B\u043B\u0430\u0437\u043A\u0430\u0445 \u0438 \u043F\u0440\u0438 \u041D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u044F\u0445 \u043D\u0430 1 \u0431\u043E\u0439'
})), _defineProperty(_BATTLE_TYPE_RESERVE_2, _constants.BATTLE_TYPES.SORTIE, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'reserve_info_bar.battle_types.sortie',
    defaultMessage: '\u0432 \u0412\u044B\u043B\u0430\u0437\u043A\u0430\u0445 \u043D\u0430 1 \u0431\u043E\u0439'
})), _defineProperty(_BATTLE_TYPE_RESERVE_2, _constants.BATTLE_TYPES.BATTLE_FOR_STRONGHOLD, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'reserve_info_bar.battle_types.battles_for_stronghold',
    defaultMessage: '\u0437\u0430 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442 \u043F\u0440\u043E\u0432\u0435\u0434\u0451\u043D\u043D\u043E\u0433\u043E \u041D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u044F'
})), _BATTLE_TYPE_RESERVE_2);

var RESERVE_TYPE_CONDITION = exports.RESERVE_TYPE_CONDITION = (_RESERVE_TYPE_CONDITI = {}, _defineProperty(_RESERVE_TYPE_CONDITI, _constants.RESERVE_TYPES.ARTILLERY_STRIKE, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'reserve_info_bar.with_artillery_strike',
    defaultMessage: '\u043F\u0440\u0438 \u0432\u044B\u0437\u043E\u0432\u0435 \u0430\u0440\u0442\u043E\u0431\u0441\u0442\u0440\u0435\u043B\u0430'
})), _defineProperty(_RESERVE_TYPE_CONDITI, _constants.RESERVE_TYPES.AIRSTRIKE, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'reserve_info_bar.with_airstrike',
    defaultMessage: '\u043F\u0440\u0438 \u0432\u044B\u0437\u043E\u0432\u0435 \u0430\u0432\u0438\u0430\u0443\u0434\u0430\u0440\u0430'
})), _RESERVE_TYPE_CONDITI);

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BonusParametersDescription = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = __webpack_require__(93);

var _reserves = __webpack_require__(28);

var _constants = __webpack_require__(4);

var _translations = __webpack_require__(388);

var _BonusParametersDescription = __webpack_require__(389);

var _BonusParametersDescription2 = _interopRequireDefault(_BonusParametersDescription);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getParameterConfig = function getParameterConfig(key, currentBonus, nextBonus, isHighlighted) {
    var currentValue = (0, _reserves.getReserveParameterByKey)(currentBonus, key);
    var nextValue = (0, _reserves.getReserveParameterByKey)(nextBonus, key);

    return {
        parameterName: key,
        value: isHighlighted ? nextValue : currentValue,
        isHighlightEnabled: isHighlighted && !(0, _lodash.isEqual)(currentValue, nextValue)
    };
};

var BonusParametersDescription = exports.BonusParametersDescription = function BonusParametersDescription(_ref) {
    var _ref$layoutType = _ref.layoutType,
        layoutType = _ref$layoutType === undefined ? 'default' : _ref$layoutType,
        reserveType = _ref.reserveType,
        isNextLevelHighlighted = _ref.isNextLevelHighlighted,
        currentBonus = _ref.currentBonus,
        nextBonus = _ref.nextBonus,
        battleTypes = _ref.battleTypes;

    var sortedReserveParameters = Object.keys(currentBonus.parameters).filter(function (parameter) {
        var DURATION = _constants.RESERVE_PARAMETERS_TYPES.DURATION,
            COMMON_DELAY = _constants.RESERVE_PARAMETERS_TYPES.COMMON_DELAY;

        return !(layoutType !== 'tooltip' && [DURATION, COMMON_DELAY].includes(parameter));
    }).sort(_reserves.sortReserveParameters);

    var reserveParameters = function () {
        var clientParameters = sortedReserveParameters.map(function (key) {
            return getParameterConfig(key, currentBonus, nextBonus, isNextLevelHighlighted);
        });

        if (layoutType === 'tooltip') {
            return clientParameters;
        }

        var industrialResourceBonus = battleTypes.map(function (key) {
            var config = getParameterConfig(key, currentBonus, nextBonus, isNextLevelHighlighted);

            var parameterName = function () {
                switch (reserveType) {
                    case _constants.RESERVE_TYPES.INSPIRATION:
                        return _constants.RESERVE_PARAMETERS_TYPES.INSPIRATION_INDUSTRIAL_RESOURCE_BONUS;
                    case _constants.RESERVE_TYPES.ARTILLERY_STRIKE:
                        return _constants.RESERVE_PARAMETERS_TYPES.ARTILLERY_STRIKE_INDUSTRIAL_RESOURCE_BONUS;
                }
            }();

            return _extends({}, config, {
                parameterName: parameterName,
                value: '+' + config.value
            });
        });

        return clientParameters.concat(industrialResourceBonus);
    }();

    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_BonusParametersDescription2.default.base, _BonusParametersDescription2.default['base__' + layoutType + 'Layout']) },
        reserveParameters.map(function (_ref2, index) {
            var parameterName = _ref2.parameterName,
                value = _ref2.value,
                isHighlightEnabled = _ref2.isHighlightEnabled;

            return _react2.default.createElement(
                'div',
                { className: _BonusParametersDescription2.default.parameter, key: index },
                _react2.default.createElement(
                    'span',
                    {
                        className: (0, _classnames2.default)(_BonusParametersDescription2.default.parameterValue, isHighlightEnabled && _BonusParametersDescription2.default.parameterValue__glow, _BonusParametersDescription2.default['parameterValue__' + (0, _lodash.camelCase)(reserveType.toLowerCase())])
                    },
                    Array.isArray(value) ? value.map(function (value, index) {
                        return _react2.default.createElement(
                            'reactFragment',
                            { key: index },
                            index !== 0 && _react2.default.createElement(
                                'span',
                                { className: _BonusParametersDescription2.default.valueSeparator },
                                ' / '
                            ),
                            value
                        );
                    }) : value
                ),
                _react2.default.createElement(
                    'span',
                    { className: _BonusParametersDescription2.default.parameterDescription },
                    layoutType === 'default' ? _translations.DEFAULT_LAYOUT_PARAMETERS_DESCRIPTION[parameterName] : _translations.RESERVES_PARAMETERS_DESCRIPTION[parameterName]
                )
            );
        })
    );
};

BonusParametersDescription.propTypes = {
    layoutType: _propTypes2.default.oneOf(['default', 'tooltip', 'toolbar']),
    currentBonus: _propTypes2.default.object.isRequired,
    nextBonus: _propTypes2.default.object.isRequired,
    reserveType: _propTypes2.default.string.isRequired,
    isNextLevelHighlighted: _propTypes2.default.bool,
    battleTypes: _propTypes2.default.array.isRequired
};

exports.default = BonusParametersDescription;

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RESERVES_PARAMETERS_DESCRIPTION = exports.DEFAULT_LAYOUT_PARAMETERS_DESCRIPTION = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _DEFAULT_LAYOUT_PARAM, _extends2;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var nbsp = _react2.default.createElement(
    'span',
    null,
    '\xA0'
);

var DEFAULT_LAYOUT_PARAMETERS_DESCRIPTION = exports.DEFAULT_LAYOUT_PARAMETERS_DESCRIPTION = (_DEFAULT_LAYOUT_PARAM = {}, _defineProperty(_DEFAULT_LAYOUT_PARAM, _constants.RESERVE_PARAMETERS_TYPES.CREW_ROLES_FACTOR, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_reserve.default_layout.parameter_description.crew_roles_factor',
    defaultMessage: '\u043A \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0439 \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438 \u0438 \u0443\u043C\u0435\u043D\u0438\u044F\u043C \u044D\u043A\u0438\u043F\u0430\u0436\u0430'
})), _defineProperty(_DEFAULT_LAYOUT_PARAM, _constants.RESERVE_PARAMETERS_TYPES.COMMON_AREA_RADIUS, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_reserve.default_layout.parameter_description.common_area_radius',
    defaultMessage: '\u043C. \u0440\u0430\u0434\u0438\u0443\u0441 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F'
})), _defineProperty(_DEFAULT_LAYOUT_PARAM, _constants.RESERVE_PARAMETERS_TYPES.MAX_DAMAGE, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_reserve.default_layout.parameter_description.max_damage',
    defaultMessage: '\u0435\u0434. \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0443\u0440\u043E\u043D\u0430 \u0434\u043B\u044F \u0431\u043E\u0451\u0432 \u043D\u0430 VI / VIII / X \u0443\u0440\u043E\u0432\u043D\u0435 \u0442\u0435\u0445\u043D\u0438\u043A\u0438'
})), _defineProperty(_DEFAULT_LAYOUT_PARAM, _constants.RESERVE_PARAMETERS_TYPES.AREA_RADIUS, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_reserve.default_layout.parameter_description.area_radius',
    defaultMessage: '\u043C. \u0440\u0430\u0434\u0438\u0443\u0441 \u0437\u043E\u043D\u044B \u043F\u043E\u0440\u0430\u0436\u0435\u043D\u0438\u044F'
})), _defineProperty(_DEFAULT_LAYOUT_PARAM, _constants.RESERVE_PARAMETERS_TYPES.INSPIRATION_INDUSTRIAL_RESOURCE_BONUS, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_reserve.default_layout.parameter_description.inspiration_industrial_resource_bonus',
    defaultMessage: '\u043A \u043F\u0440\u043E\u043C\u0440\u0435\u0441\u0443\u0440\u0441\u0443 \u043F\u0440\u0438 \u0432\u043E\u043E\u0434\u0443\u0448\u0435\u0432\u043B\u0435\u043D\u0438\u0438'
})), _defineProperty(_DEFAULT_LAYOUT_PARAM, _constants.RESERVE_PARAMETERS_TYPES.ARTILLERY_STRIKE_INDUSTRIAL_RESOURCE_BONUS, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_reserve.default_layout.parameter_description.artillery_strike_industrial_resource_bonus',
    defaultMessage: '\u043A \u043F\u0440\u043E\u043C\u0440\u0435\u0441\u0443\u0440\u0441\u0443 \u043F\u0440\u0438 \u0432\u044B\u0437\u043E\u0432\u0435 \u0430\u0440\u0442\u043E\u0431\u0441\u0442\u0440\u0435\u043B\u0430'
})), _DEFAULT_LAYOUT_PARAM);

var RESERVES_PARAMETERS_DESCRIPTION = exports.RESERVES_PARAMETERS_DESCRIPTION = _extends({}, DEFAULT_LAYOUT_PARAMETERS_DESCRIPTION, (_extends2 = {}, _defineProperty(_extends2, _constants.RESERVE_PARAMETERS_TYPES.COMMON_AREA_RADIUS, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_reserve.parameter_description.common_area_radius',
    defaultMessage: '\u0420\u0430\u0434\u0438\u0443\u0441 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F{nbsp}(\u043C)',
    values: {
        nbsp: nbsp
    }
})), _defineProperty(_extends2, _constants.RESERVE_PARAMETERS_TYPES.CREW_ROLES_FACTOR, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_reserve.parameter_description.crew_roles_factor',
    defaultMessage: '\u043A \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0439 \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438 \u0438 \u0443\u043C\u0435\u043D\u0438\u044F\u043C \u044D\u043A\u0438\u043F\u0430\u0436\u0430'
})), _defineProperty(_extends2, _constants.RESERVE_PARAMETERS_TYPES.DURATION, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_reserve.parameter_description.duration',
    defaultMessage: '\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C{nbsp}(\u0441)',
    values: {
        nbsp: nbsp
    }
})), _defineProperty(_extends2, _constants.RESERVE_PARAMETERS_TYPES.INACTIVATION_DELAY, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_reserve.parameter_description.inactivation_delay',
    defaultMessage: '\u041E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u044B\u0439 \u044D\u0444\u0444\u0435\u043A\u0442{nbsp}(\u0441)',
    values: {
        nbsp: nbsp
    }
})), _defineProperty(_extends2, _constants.RESERVE_PARAMETERS_TYPES.MAX_DAMAGE, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_reserve.parameter_description.max_damage',
    defaultMessage: '\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u044B\u0439 \u0443\u0440\u043E\u043D \u0434\u043B\u044F \u0431\u043E\u0451\u0432 \u043D\u0430 VI / VIII / X \u0443\u0440\u043E\u0432\u043D\u0435 \u0442\u0435\u0445\u043D\u0438\u043A\u0438{nbsp}(\u0435\u0434.)',
    values: {
        nbsp: nbsp
    }
})), _defineProperty(_extends2, _constants.RESERVE_PARAMETERS_TYPES.AREA_RADIUS, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_reserve.parameter_description.area_radius',
    defaultMessage: '\u0420\u0430\u0434\u0438\u0443\u0441 \u0437\u043E\u043D\u044B \u043F\u043E\u0440\u0430\u0436\u0435\u043D\u0438\u044F{nbsp}(\u043C)',
    values: {
        nbsp: nbsp
    }
})), _defineProperty(_extends2, _constants.RESERVE_PARAMETERS_TYPES.COMMON_DELAY, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_reserve.parameter_description.common_delay',
    defaultMessage: '\u0412\u0440\u0435\u043C\u044F \u0440\u0430\u0437\u0432\u0451\u0440\u0442\u044B\u0432\u0430\u043D\u0438\u044F{nbsp}(\u0441)',
    values: {
        nbsp: nbsp
    }
})), _extends2));

/***/ }),
/* 389 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"BonusParametersDescription_base--1jbyE","base__tooltipLayout":"BonusParametersDescription_base__tooltipLayout--3g9EU","baseTooltipLayout":"BonusParametersDescription_base__tooltipLayout--3g9EU","base__toolbarLayout":"BonusParametersDescription_base__toolbarLayout--2PRqN","baseToolbarLayout":"BonusParametersDescription_base__toolbarLayout--2PRqN","parameter":"BonusParametersDescription_parameter--WFPUK","parameterValue":"BonusParametersDescription_parameterValue--2DsrE","base__defaultLayout":"BonusParametersDescription_base__defaultLayout--14z6M","baseDefaultLayout":"BonusParametersDescription_base__defaultLayout--14z6M","parameterValue__inspiration":"BonusParametersDescription_parameterValue__inspiration--2Fo_B","parameterValueInspiration":"BonusParametersDescription_parameterValue__inspiration--2Fo_B","parameterValue__artilleryStrike":"BonusParametersDescription_parameterValue__artilleryStrike--3DUvw","parameterValueArtilleryStrike":"BonusParametersDescription_parameterValue__artilleryStrike--3DUvw","parameterValue__glow":"BonusParametersDescription_parameterValue__glow--IKIE1","parameterValueGlow":"BonusParametersDescription_parameterValue__glow--IKIE1","parameterDescription":"BonusParametersDescription_parameterDescription--1jTUE","valueSeparator":"BonusParametersDescription_valueSeparator--mUdjp"};

/***/ }),
/* 390 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"ReserveBonus_base--2WtV9","base__toolbarLayout":"ReserveBonus_base__toolbarLayout--2TiWO","baseToolbarLayout":"ReserveBonus_base__toolbarLayout--2TiWO","base__tooltipLayout":"ReserveBonus_base__tooltipLayout--1L6cF","baseTooltipLayout":"ReserveBonus_base__tooltipLayout--1L6cF"};

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BOXES_COUNT = exports.COMMANDER_TOOLTIP_TEXT = exports.HEADER_MESSAGE = exports.MODIFIER_CLAN_LANDING = exports.RESERVES_TO_SHOW = exports.NEW_RESERVE_TOOLTIP_ID = exports.RESERVE_TOOLTIP_ID = undefined;

var _constants = __webpack_require__(4);

var _reactIntl = __webpack_require__(3);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RESERVE_TOOLTIP_ID = exports.RESERVE_TOOLTIP_ID = 'clan_landing.reserve_tooltip'; /* eslint-disable react/no-multi-comp */

var NEW_RESERVE_TOOLTIP_ID = exports.NEW_RESERVE_TOOLTIP_ID = 'clan_landing.reserve_new_tooltip';

var RESERVES_TO_SHOW = exports.RESERVES_TO_SHOW = [_constants.RESERVE_TYPES.BATTLE_PAYMENTS, _constants.RESERVE_TYPES.MILITARY_MANEUVERS, _constants.RESERVE_TYPES.TACTICAL_TRAINING, _constants.RESERVE_TYPES.ADDITIONAL_BRIEFING];

var MODIFIER_CLAN_LANDING = exports.MODIFIER_CLAN_LANDING = 'clanLanding';

var HEADER_MESSAGE = exports.HEADER_MESSAGE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.reserves.header',
    defaultMessage: '\u041A\u043B\u0430\u043D\u043E\u0432\u044B\u0435 \u0440\u0435\u0437\u0435\u0440\u0432\u044B'
});

var COMMANDER_TOOLTIP_TEXT = exports.COMMANDER_TOOLTIP_TEXT = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.reserves.commanderTooltip',
    defaultMessage: '\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043F\u0435\u0440\u0435\u0439\u0442\u0438 \u043A \u0432\u044B\u0431\u043E\u0440\u0443 \u0438 \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438 \u043A\u043B\u0430\u043D\u043E\u0432\u044B\u0445 \u0440\u0435\u0437\u0435\u0440\u0432\u043E\u0432.'
});

var BOXES_COUNT = exports.BOXES_COUNT = 2;

/***/ }),
/* 392 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"ReserveTooltipBody_root--fARE2","root__show":"ReserveTooltipBody_root__show--1ryT8","rootShow":"ReserveTooltipBody_root__show--1ryT8","body":"ReserveTooltipBody_body--1Glyq","wrapper":"ReserveTooltipBody_wrapper--3TxyN","content":"ReserveTooltipBody_content--2wgzK","title":"ReserveTooltipBody_title--1k5Xc","subtitle":"ReserveTooltipBody_subtitle--35xlP","message":"ReserveTooltipBody_message--2crk8","warning":"ReserveTooltipBody_warning--1JcHJ","divider":"ReserveTooltipBody_divider--3Thq5","highlight":"ReserveTooltipBody_highlight--1i7ky","ribbon":"ReserveTooltipBody_ribbon--d_X_N","statusMessage":"ReserveTooltipBody_statusMessage--272sf","statusMessage__positive":"ReserveTooltipBody_statusMessage__positive--2LE62","statusMessagePositive":"ReserveTooltipBody_statusMessage__positive--2LE62","status":"ReserveTooltipBody_status--dOOPv","statusMessage__negative":"ReserveTooltipBody_statusMessage__negative--2CqXW","statusMessageNegative":"ReserveTooltipBody_statusMessage__negative--2CqXW","statusMessage__noPermission":"ReserveTooltipBody_statusMessage__noPermission--12JO1","statusMessageNoPermission":"ReserveTooltipBody_statusMessage__noPermission--12JO1","status__positive":"ReserveTooltipBody_status__positive--1Ot_s","statusPositive":"ReserveTooltipBody_status__positive--1Ot_s","status__negative":"ReserveTooltipBody_status__negative--1YK8r","statusNegative":"ReserveTooltipBody_status__negative--1YK8r","statusText":"ReserveTooltipBody_statusText--3E3C-","sectionTitle":"ReserveTooltipBody_sectionTitle--16rrH","sectionTitle__effect":"ReserveTooltipBody_sectionTitle__effect--2S7tw","sectionTitleEffect":"ReserveTooltipBody_sectionTitle__effect--2S7tw","sectionTitle__additionalEffect":"ReserveTooltipBody_sectionTitle__additionalEffect--12Ijy","sectionTitleAdditionalEffect":"ReserveTooltipBody_sectionTitle__additionalEffect--12Ijy","effectDescription":"ReserveTooltipBody_effectDescription--2gkfG","parameter":"ReserveTooltipBody_parameter--3k4h4","parameterValue":"ReserveTooltipBody_parameterValue--1LJwF","parameterDescription":"ReserveTooltipBody_parameterDescription--1AmSU","bonuses":"ReserveTooltipBody_bonuses--37ySY"};

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LEVEL_BONUSES = undefined;

var _reactIntl = __webpack_require__(3);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _helpers = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LEVEL_BONUSES = exports.LEVEL_BONUSES = function LEVEL_BONUSES(level) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'reserve_tooltip_body.bonuses',
        defaultMessage: 'Level {level} bonuses',
        values: { level: (0, _helpers.toRoman)(level) }
    });
};

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BUILDING_LEVEL = exports.AVAILABLE_RESERVES = exports.UPGRADE_AVAILABLE = exports.RESERVE_QUEUE_END = exports.RESERVE_QUEUE = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _helpers = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RESERVE_QUEUE = exports.RESERVE_QUEUE = function RESERVE_QUEUE(counter) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'building_tooltip.reserve_queue',
        defaultMessage: 'Резервов в подготовке: {counter}',
        values: {
            counter: counter
        }
    });
}; /* eslint-disable react/no-multi-comp */
var RESERVE_QUEUE_END = exports.RESERVE_QUEUE_END = function RESERVE_QUEUE_END(date) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'building_tooltip.reserve_queue_end',
        defaultMessage: 'Reserves of all levels will be ready: {date}',
        values: {
            date: date
        }
    });
};

var UPGRADE_AVAILABLE = exports.UPGRADE_AVAILABLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'building_tooltip.upgrade_available',
    defaultMessage: 'Готово к модернизации'
});

var AVAILABLE_RESERVES = exports.AVAILABLE_RESERVES = function AVAILABLE_RESERVES(levels) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'building_tooltip.available_reserves',
        defaultMessage: 'Reserves can be prepared: {levels}',
        values: {
            levels: levels
        }
    });
};

var BUILDING_LEVEL = exports.BUILDING_LEVEL = function BUILDING_LEVEL(level) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'building_tooltip.building_level',
        defaultMessage: 'Building Level {level}',
        values: { level: (0, _helpers.toRoman)(level) }
    });
};

/***/ }),
/* 395 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"BuildingTooltip_root--1ry1Z","root__show":"BuildingTooltip_root__show--5YO7D","rootShow":"BuildingTooltip_root__show--5YO7D","body":"BuildingTooltip_body--h4iYS","wrapper":"BuildingTooltip_wrapper--1mgLY","content":"BuildingTooltip_content--1AuY4","title":"BuildingTooltip_title--36wz_","subtitle":"BuildingTooltip_subtitle--1C7uo","message":"BuildingTooltip_message--d3d6y","warning":"BuildingTooltip_warning--1t-5F","divider":"BuildingTooltip_divider--2_w2p","highlight":"BuildingTooltip_highlight--2ABn4","ribbon":"BuildingTooltip_ribbon--3t9x2","statusMessage":"BuildingTooltip_statusMessage--4oCd6","statusMessage__positive":"BuildingTooltip_statusMessage__positive--wHZ8i","statusMessagePositive":"BuildingTooltip_statusMessage__positive--wHZ8i","status":"BuildingTooltip_status--1GsCl","statusMessage__negative":"BuildingTooltip_statusMessage__negative--245hb","statusMessageNegative":"BuildingTooltip_statusMessage__negative--245hb","statusMessage__noPermission":"BuildingTooltip_statusMessage__noPermission--UuG8j","statusMessageNoPermission":"BuildingTooltip_statusMessage__noPermission--UuG8j","status__positive":"BuildingTooltip_status__positive--3Z6n5","statusPositive":"BuildingTooltip_status__positive--3Z6n5","status__negative":"BuildingTooltip_status__negative--1kUaB","statusNegative":"BuildingTooltip_status__negative--1kUaB","statusText":"BuildingTooltip_statusText--YGR6l","base":"BuildingTooltip_base--39xWE","base__type-economics-double":"BuildingTooltip_base__type-economics-double--xhF-c","baseTypeEconomicsDouble":"BuildingTooltip_base__type-economics-double--xhF-c","base__type-battle":"BuildingTooltip_base__type-battle--1Vv9-","baseTypeBattle":"BuildingTooltip_base__type-battle--1Vv9-","reserve":"BuildingTooltip_reserve--1k4Za","reserveTitle":"BuildingTooltip_reserveTitle--3dRjJ","reserveLevel":"BuildingTooltip_reserveLevel--3l3id","reserveLevelValue":"BuildingTooltip_reserveLevelValue--2mxi3","button":"BuildingTooltip_button--doBkS","thumbnail":"BuildingTooltip_thumbnail--2oiDP","image":"BuildingTooltip_image--fot4Z","image__artillery-strike":"BuildingTooltip_image__artillery-strike--3gjsH","imageArtilleryStrike":"BuildingTooltip_image__artillery-strike--3gjsH","image__airstrike":"BuildingTooltip_image__airstrike--3Kxyp","imageAirstrike":"BuildingTooltip_image__airstrike--3Kxyp","image__requisition":"BuildingTooltip_image__requisition--3SFu2","imageRequisition":"BuildingTooltip_image__requisition--3SFu2","image__high-capacity-transport":"BuildingTooltip_image__high-capacity-transport--1XZaS","imageHighCapacityTransport":"BuildingTooltip_image__high-capacity-transport--1XZaS","image__additional-briefing":"BuildingTooltip_image__additional-briefing--Y9qAH","imageAdditionalBriefing":"BuildingTooltip_image__additional-briefing--Y9qAH","image__tactical-training":"BuildingTooltip_image__tactical-training--3jHWZ","imageTacticalTraining":"BuildingTooltip_image__tactical-training--3jHWZ","image__military-maneuvers":"BuildingTooltip_image__military-maneuvers--2Vd-Z","imageMilitaryManeuvers":"BuildingTooltip_image__military-maneuvers--2Vd-Z","image__battle-payments":"BuildingTooltip_image__battle-payments--1YPf7","imageBattlePayments":"BuildingTooltip_image__battle-payments--1YPf7","image__inspiration":"BuildingTooltip_image__inspiration--2Y2xX","imageInspiration":"BuildingTooltip_image__inspiration--2Y2xX","level":"BuildingTooltip_level--2HheT","finishTime":"BuildingTooltip_finishTime--37SMS","finishText":"BuildingTooltip_finishText--2fq2p","statusLevels":"BuildingTooltip_statusLevels--H_hf6","divider__collapsed":"BuildingTooltip_divider__collapsed--3_hOr","dividerCollapsed":"BuildingTooltip_divider__collapsed--3_hOr"};

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BUILDING_INFO = exports.UPGRADE_AVAILABLE = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-multi-comp */
var UPGRADE_AVAILABLE = exports.UPGRADE_AVAILABLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'command_center_tooltip.upgrade_available',
    defaultMessage: 'Готов к модернизации'
});

var BUILDING_INFO = exports.BUILDING_INFO = function BUILDING_INFO(level) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'command_center_tooltip.building_info',
        defaultMessage: 'Позволяет модернизировать все строения до {level} уровня',
        values: {
            level: level
        }
    });
};

/***/ }),
/* 397 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"CommandCenterTooltip_root--fmaXh","root__show":"CommandCenterTooltip_root__show--25-gR","rootShow":"CommandCenterTooltip_root__show--25-gR","body":"CommandCenterTooltip_body--2T5hY","wrapper":"CommandCenterTooltip_wrapper--ky0LL","content":"CommandCenterTooltip_content--XTo1G","title":"CommandCenterTooltip_title--22ZvR","subtitle":"CommandCenterTooltip_subtitle--mlvbc","message":"CommandCenterTooltip_message--3CjGd","warning":"CommandCenterTooltip_warning--2Vj4B","divider":"CommandCenterTooltip_divider--9ATFO","highlight":"CommandCenterTooltip_highlight--3xJgj","ribbon":"CommandCenterTooltip_ribbon--3ktq5","statusMessage":"CommandCenterTooltip_statusMessage--25X7I","statusMessage__positive":"CommandCenterTooltip_statusMessage__positive--1pEMa","statusMessagePositive":"CommandCenterTooltip_statusMessage__positive--1pEMa","status":"CommandCenterTooltip_status--213sT","statusMessage__negative":"CommandCenterTooltip_statusMessage__negative--d_9sF","statusMessageNegative":"CommandCenterTooltip_statusMessage__negative--d_9sF","statusMessage__noPermission":"CommandCenterTooltip_statusMessage__noPermission--2yKjH","statusMessageNoPermission":"CommandCenterTooltip_statusMessage__noPermission--2yKjH","status__positive":"CommandCenterTooltip_status__positive--1VYzT","statusPositive":"CommandCenterTooltip_status__positive--1VYzT","status__negative":"CommandCenterTooltip_status__negative--3Os99","statusNegative":"CommandCenterTooltip_status__negative--3Os99","statusText":"CommandCenterTooltip_statusText--1MIXZ","base":"CommandCenterTooltip_base--3AdUH","level":"CommandCenterTooltip_level--3xaPR","infoLevel":"CommandCenterTooltip_infoLevel--3NugR","info":"CommandCenterTooltip_info--2_1OV","header":"CommandCenterTooltip_header--1Z6xo"};

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = exports.BattleRooms = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(7);

var _constants = __webpack_require__(4);

var _schedule = __webpack_require__(27);

var _peripheries2 = __webpack_require__(37);

var _playersMatching = __webpack_require__(57);

var _schedule2 = __webpack_require__(103);

var _UnitPreview = __webpack_require__(292);

var _UnitPreview2 = _interopRequireDefault(_UnitPreview);

var _UnitsView = __webpack_require__(412);

var _UnitsView2 = _interopRequireDefault(_UnitsView);

var _PlayersMatchingView = __webpack_require__(442);

var _PlayersMatchingView2 = _interopRequireDefault(_PlayersMatchingView);

var _FullSchedule = __webpack_require__(477);

var _FullSchedule2 = _interopRequireDefault(_FullSchedule);

var _propTypes3 = __webpack_require__(32);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BattleRooms = exports.BattleRooms = function (_React$Component) {
    _inherits(BattleRooms, _React$Component);

    function BattleRooms() {
        _classCallCheck(this, BattleRooms);

        return _possibleConstructorReturn(this, (BattleRooms.__proto__ || Object.getPrototypeOf(BattleRooms)).apply(this, arguments));
    }

    _createClass(BattleRooms, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var schedule_period = 7; // schedule repeats every week
            this.props.requestScheduleData(schedule_period);
        }
    }, {
        key: 'shouldShowSchedule',
        value: function shouldShowSchedule(unitType) {
            if (!this.props.meta) return false;

            if (unitType === _constants.UNIT_TYPES.SORTIE || unitType === undefined) {
                var peripheries = this.props.meta.sorties.peripheries;
                if ((0, _peripheries2.getAvailablePeripheries)(peripheries, _constants.UNIT_TYPES.SORTIE).length) return false;
            }

            if (unitType === _constants.UNIT_TYPES.FORT_BATTLE || unitType === undefined) {
                if ((0, _schedule.fortBattleStartedLessThanHourAgo)(this.props.todaySchedule)) return false;

                var _peripheries = this.props.meta.fort_battles.peripheries;
                if ((0, _peripheries2.getAvailablePeripheries)(_peripheries, _constants.UNIT_TYPES.FORT_BATTLE).length) return false;
            }

            return true;
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.shouldShowSchedule()) return _react2.default.createElement(_FullSchedule2.default, null);

            if (this.props.selectedClanUnit) {
                return _react2.default.createElement(_UnitPreview2.default, { unit: this.props.selectedClanUnit });
            }

            var showBattleModeSchedule = this.shouldShowSchedule(this.props.filter.unitType);
            if (this.props.playersMatchingTabOpen) {
                return _react2.default.createElement(_PlayersMatchingView2.default, { showSchedule: showBattleModeSchedule });
            } else {
                return _react2.default.createElement(_UnitsView2.default, { showSchedule: showBattleModeSchedule });
            }
        }
    }]);

    return BattleRooms;
}(_react2.default.Component);

BattleRooms.propTypes = {
    filter: _propTypes2.default.object.isRequired,
    meta: _propTypes2.default.object,
    selectedClanUnit: _propTypes3.UnitDataPropTypes,

    playersMatchingTabOpen: _propTypes2.default.bool.isRequired,

    todaySchedule: _propTypes2.default.object,

    requestScheduleData: _propTypes2.default.func.isRequired
};
var mapStateToProps = exports.mapStateToProps = function mapStateToProps(_ref) {
    var availableUnits = _ref.availableUnits,
        clanUnits = _ref.clanUnits,
        schedule = _ref.schedule,
        players_matching = _ref.players_matching,
        account = _ref.account;

    var meta = players_matching.active && clanUnits.loaded && clanUnits.meta || availableUnits.loaded && availableUnits.meta;

    var selectedClanUnit = clanUnits.units.find(function (unit) {
        return unit.id === clanUnits.selectedUnitId;
    });
    var playersMatchingAvailable = (0, _playersMatching.isPlayersMatchingAvailable)(account, players_matching);

    return {
        todaySchedule: schedule.playdays ? schedule.playdays[0] : null,
        filter: availableUnits.filter,
        meta: meta,
        selectedClanUnit: selectedClanUnit,
        playersMatchingTabOpen: playersMatchingAvailable && players_matching.active
    };
};

var mapDispatchToProps = exports.mapDispatchToProps = {
    requestScheduleData: _schedule2.requestScheduleData
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BattleRooms);

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

var _reactWotBootstrap = __webpack_require__(5);

var _datetime = __webpack_require__(13);

var _peripheries = __webpack_require__(37);

var _constants = __webpack_require__(400);

var _constants2 = __webpack_require__(4);

var _CreateUnitButtonTooltip = __webpack_require__(401);

var _CreateUnitButtonTooltip2 = _interopRequireDefault(_CreateUnitButtonTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CreateUnitButtonTooltip = function (_React$Component) {
    _inherits(CreateUnitButtonTooltip, _React$Component);

    function CreateUnitButtonTooltip() {
        _classCallCheck(this, CreateUnitButtonTooltip);

        return _possibleConstructorReturn(this, (CreateUnitButtonTooltip.__proto__ || Object.getPrototypeOf(CreateUnitButtonTooltip)).apply(this, arguments));
    }

    _createClass(CreateUnitButtonTooltip, [{
        key: 'getBattleTypeMessage',
        value: function getBattleTypeMessage(peripheries, type) {
            var availablePeripheries = (0, _peripheries.getAvailablePeripheries)(peripheries, type);
            if (availablePeripheries.length > 0) {
                var peripheriesList = (0, _peripheries.getPeripheriesList)(availablePeripheries);
                return _react2.default.createElement(
                    'p',
                    { className: _CreateUnitButtonTooltip2.default.peripheries },
                    _constants.UNAVAILABLE_BATTLE_AVAILABLE_SERVERS[type],
                    ' ',
                    _react2.default.createElement(
                        'span',
                        { className: _CreateUnitButtonTooltip2.default.highlight },
                        peripheriesList
                    )
                );
            } else {
                var closestPeripheries = type === _constants2.UNIT_TYPES.SORTIE ? (0, _peripheries.getSortiesPeripheriesByClosestPrimetime)(peripheries) : (0, _peripheries.getBattlesPeripheriesByClosestPrimetime)(peripheries);

                if (closestPeripheries.length) {
                    var primetimeStart = type === _constants2.UNIT_TYPES.SORTIE ? closestPeripheries[0].primetime_start : (0, _peripheries.getClosestMatchmakerTick)(closestPeripheries[0]);
                    var availableTime = (0, _datetime.getEndDateMessage)((0, _moment2.default)(primetimeStart));
                    var timeNode = _react2.default.createElement(
                        'span',
                        { className: _CreateUnitButtonTooltip2.default.highlight },
                        availableTime
                    );
                    var _peripheriesList = (0, _peripheries.getPeripheriesList)(closestPeripheries);

                    return _react2.default.createElement(
                        'p',
                        { className: _CreateUnitButtonTooltip2.default.peripheries },
                        (0, _constants.UNAVAILABLE_BATTLE_MESSAGES)(timeNode)[type],
                        ' ',
                        _react2.default.createElement(
                            'span',
                            { className: _CreateUnitButtonTooltip2.default.highlight },
                            _peripheriesList
                        )
                    );
                } else {
                    return _react2.default.createElement(
                        'p',
                        { className: _CreateUnitButtonTooltip2.default.peripheries },
                        _constants.UNAVAILABLE_BATTLE_UNAVAILABLE_SERVERS[type]
                    );
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var isAvailableSorties = (0, _peripheries.getAvailablePeripheries)(this.props.meta.sorties.peripheries, _constants2.UNIT_TYPES.SORTIE).length !== 0;

            var isAvailableBattles = (0, _peripheries.getAvailablePeripheries)(this.props.meta.fort_battles.peripheries, _constants2.UNIT_TYPES.FORT_BATTLE).length !== 0;

            var iconNode = _react2.default.createElement('span', { className: _CreateUnitButtonTooltip2.default.settings });
            return _react2.default.createElement(
                _reactWotBootstrap.Tooltip,
                { id: CreateUnitButtonTooltip.id, isWide: true },
                _react2.default.createElement(
                    'div',
                    { className: _CreateUnitButtonTooltip2.default.base },
                    _react2.default.createElement(
                        'p',
                        { className: _CreateUnitButtonTooltip2.default.title },
                        (0, _constants.CREATE_UNIT_BUTTON_TOOLTIP_TITLE)(this.props.peripheryName)
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _CreateUnitButtonTooltip2.default.ribbon },
                        this.getBattleTypeMessage(this.props.meta.sorties.peripheries, _constants2.UNIT_TYPES.SORTIE),
                        this.getBattleTypeMessage(this.props.meta.fort_battles.peripheries, _constants2.UNIT_TYPES.FORT_BATTLE)
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: _CreateUnitButtonTooltip2.default.footer },
                        (isAvailableSorties || isAvailableBattles) && (0, _constants.CHANGE_PERIPHERY_MESSAGE)(iconNode)
                    )
                )
            );
        }
    }]);

    return CreateUnitButtonTooltip;
}(_react2.default.Component);

CreateUnitButtonTooltip.id = 'CREATE_UNIT_BUTTON_TOOLTIP_ID';
CreateUnitButtonTooltip.propTypes = {
    meta: _propTypes2.default.shape({
        sorties: _propTypes2.default.object.isRequired,
        fort_battles: _propTypes2.default.object.isRequired
    }),
    peripheryName: _propTypes2.default.string.isRequired
};
exports.default = CreateUnitButtonTooltip;

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CHANGE_PERIPHERY_MESSAGE = exports.UNAVAILABLE_BATTLE_UNAVAILABLE_SERVERS = exports.UNAVAILABLE_BATTLE_AVAILABLE_SERVERS = exports.UNAVAILABLE_BATTLE_MESSAGES = exports.CREATE_UNIT_BUTTON_TOOLTIP_TITLE = undefined;

var _UNAVAILABLE_BATTLE_A, _UNAVAILABLE_BATTLE_U;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint-disable react/no-multi-comp */

var CREATE_UNIT_BUTTON_TOOLTIP_TITLE = exports.CREATE_UNIT_BUTTON_TOOLTIP_TITLE = function CREATE_UNIT_BUTTON_TOOLTIP_TITLE(periphery) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battle_rooms.create_unit_button_tooltip.title',
        defaultMessage: '\u0421\u0440\u0430\u0436\u0435\u043D\u0438\u044F \u043D\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0435 {periphery} \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B',
        values: { periphery: periphery }
    });
};

var UNAVAILABLE_BATTLE_MESSAGES = exports.UNAVAILABLE_BATTLE_MESSAGES = function UNAVAILABLE_BATTLE_MESSAGES(availableTime) {
    var _ref;

    return _ref = {}, _defineProperty(_ref, _constants.UNIT_TYPES.SORTIE, _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battle_rooms.create_unit_button_tooltip.unavailable_battle.message.sortie',
        defaultMessage: '\u0411\u043B\u0438\u0436\u0430\u0439\u0448\u0438\u0435 \u0412\u044B\u043B\u0430\u0437\u043A\u0438: {availableTime} \u043D\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430x:',
        values: { availableTime: availableTime }
    })), _defineProperty(_ref, _constants.UNIT_TYPES.FORT_BATTLE, _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battle_rooms.create_unit_button_tooltip.unavailable_battle.message.fort_battle',
        defaultMessage: '\u0411\u043B\u0438\u0436\u0430\u0439\u0448\u0438\u0435 \u041D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u044F: {availableTime} \u043D\u0430 \u0441\u0435\u0440\u0432\u0435\u0440ax:',
        values: { availableTime: availableTime }
    })), _ref;
};

var UNAVAILABLE_BATTLE_AVAILABLE_SERVERS = exports.UNAVAILABLE_BATTLE_AVAILABLE_SERVERS = (_UNAVAILABLE_BATTLE_A = {}, _defineProperty(_UNAVAILABLE_BATTLE_A, _constants.UNIT_TYPES.SORTIE, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_rooms.create_unit_button_tooltip.unavailable_battle.available_servers.sortie',
    defaultMessage: '\u0421\u0435\u0439\u0447\u0430\u0441 \u0412\u044B\u043B\u0430\u0437\u043A\u0438 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B \u043D\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430\u0445:'
})), _defineProperty(_UNAVAILABLE_BATTLE_A, _constants.UNIT_TYPES.FORT_BATTLE, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_rooms.create_unit_button_tooltip.unavailable_battle.available_servers.fort_battle',
    defaultMessage: '\u0421\u0435\u0439\u0447\u0430\u0441 \u041D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u044F \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B \u043D\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430\u0445:'
})), _UNAVAILABLE_BATTLE_A);

var UNAVAILABLE_BATTLE_UNAVAILABLE_SERVERS = exports.UNAVAILABLE_BATTLE_UNAVAILABLE_SERVERS = (_UNAVAILABLE_BATTLE_U = {}, _defineProperty(_UNAVAILABLE_BATTLE_U, _constants.UNIT_TYPES.SORTIE, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_rooms.create_unit_button_tooltip.unavailable_battle.unavailable_servers.sortie',
    defaultMessage: '\u0412\u0440\u0435\u043C\u044F \u043D\u0430\u0447\u0430\u043B\u0430 \u0412\u044B\u043B\u0430\u0437\u043E\u043A \u0441\u0442\u0430\u043D\u0435\u0442 \u0438\u0437\u0432\u0435\u0441\u0442\u043D\u043E \u043F\u043E\u0437\u0436\u0435'
})), _defineProperty(_UNAVAILABLE_BATTLE_U, _constants.UNIT_TYPES.FORT_BATTLE, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_rooms.create_unit_button_tooltip.unavailable_battle.unavailable_servers.fort_battle',
    defaultMessage: '\u0412\u0440\u0435\u043C\u044F \u043D\u0430\u0447\u0430\u043B\u0430 \u041D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u0439 \u0441\u0442\u0430\u043D\u0435\u0442 \u0438\u0437\u0432\u0435\u0441\u0442\u043D\u043E \u043F\u043E\u0437\u0436\u0435'
})), _UNAVAILABLE_BATTLE_U);

var CHANGE_PERIPHERY_MESSAGE = exports.CHANGE_PERIPHERY_MESSAGE = function CHANGE_PERIPHERY_MESSAGE(icon) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battle_rooms.create_unit_button_tooltip.change_periphery',
        defaultMessage: 'To select a different server, click the {icon} icon in the bottom right corner.',
        values: { icon: icon }
    });
};

/***/ }),
/* 401 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"CreateUnitButtonTooltip_root--bfht6","root__show":"CreateUnitButtonTooltip_root__show--1xNwc","rootShow":"CreateUnitButtonTooltip_root__show--1xNwc","body":"CreateUnitButtonTooltip_body--3eX09","wrapper":"CreateUnitButtonTooltip_wrapper--3hdZ_","content":"CreateUnitButtonTooltip_content--3XeR1","title":"CreateUnitButtonTooltip_title--3Xak7","subtitle":"CreateUnitButtonTooltip_subtitle--2Px0p","message":"CreateUnitButtonTooltip_message--2xfNs","warning":"CreateUnitButtonTooltip_warning--1T44-","divider":"CreateUnitButtonTooltip_divider--1NZrI","highlight":"CreateUnitButtonTooltip_highlight--2QfJG","ribbon":"CreateUnitButtonTooltip_ribbon--3P1Z_","statusMessage":"CreateUnitButtonTooltip_statusMessage--287AK","statusMessage__positive":"CreateUnitButtonTooltip_statusMessage__positive--3HWqV","statusMessagePositive":"CreateUnitButtonTooltip_statusMessage__positive--3HWqV","status":"CreateUnitButtonTooltip_status--2M3Jd","statusMessage__negative":"CreateUnitButtonTooltip_statusMessage__negative--_QOGG","statusMessageNegative":"CreateUnitButtonTooltip_statusMessage__negative--_QOGG","statusMessage__noPermission":"CreateUnitButtonTooltip_statusMessage__noPermission--2SeWi","statusMessageNoPermission":"CreateUnitButtonTooltip_statusMessage__noPermission--2SeWi","status__positive":"CreateUnitButtonTooltip_status__positive--3lGye","statusPositive":"CreateUnitButtonTooltip_status__positive--3lGye","status__negative":"CreateUnitButtonTooltip_status__negative--RP714","statusNegative":"CreateUnitButtonTooltip_status__negative--RP714","statusText":"CreateUnitButtonTooltip_statusText--1YCZ9","base":"CreateUnitButtonTooltip_base--dTXGX","peripheries":"CreateUnitButtonTooltip_peripheries--1r5uo","settings":"CreateUnitButtonTooltip_settings--1GQ6P","footer":"CreateUnitButtonTooltip_footer--uSgx_"};

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BATTLE_ROOMS_CREATE_UNIT_BUTTON_CAPTION = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BATTLE_ROOMS_CREATE_UNIT_BUTTON_CAPTION = exports.BATTLE_ROOMS_CREATE_UNIT_BUTTON_CAPTION = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_rooms.create_unit_button_caption',
    defaultMessage: '\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u043E\u0442\u0440\u044F\u0434'
});

/***/ }),
/* 403 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tooltip-root":"Title_tooltip-root--18Ug7","tooltipRoot":"Title_tooltip-root--18Ug7","tooltip-root__show":"Title_tooltip-root__show--1xT5O","tooltipRootShow":"Title_tooltip-root__show--1xT5O","tooltip-body":"Title_tooltip-body--PHvzy","tooltipBody":"Title_tooltip-body--PHvzy","tooltip-wrapper":"Title_tooltip-wrapper--3dH-j","tooltipWrapper":"Title_tooltip-wrapper--3dH-j","tooltip-content":"Title_tooltip-content--H1DOw","tooltipContent":"Title_tooltip-content--H1DOw","tooltip-title":"Title_tooltip-title--3TKUW","tooltipTitle":"Title_tooltip-title--3TKUW","tooltip-subtitle":"Title_tooltip-subtitle--2Sib7","tooltipSubtitle":"Title_tooltip-subtitle--2Sib7","tooltip-message":"Title_tooltip-message--3sFlo","tooltipMessage":"Title_tooltip-message--3sFlo","tooltip-warning":"Title_tooltip-warning--300th","tooltipWarning":"Title_tooltip-warning--300th","tooltip-divider":"Title_tooltip-divider--2h7tU","tooltipDivider":"Title_tooltip-divider--2h7tU","tooltip-highlight":"Title_tooltip-highlight--2lbdM","tooltipHighlight":"Title_tooltip-highlight--2lbdM","tooltip-ribbon":"Title_tooltip-ribbon--5nlqi","tooltipRibbon":"Title_tooltip-ribbon--5nlqi","tooltip-statusMessage":"Title_tooltip-statusMessage--3MevJ","tooltipStatusMessage":"Title_tooltip-statusMessage--3MevJ","tooltip-statusMessage__positive":"Title_tooltip-statusMessage__positive--wnScd","tooltipStatusMessagePositive":"Title_tooltip-statusMessage__positive--wnScd","tooltip-status":"Title_tooltip-status--1w22m","tooltipStatus":"Title_tooltip-status--1w22m","tooltip-statusMessage__negative":"Title_tooltip-statusMessage__negative--2OVgS","tooltipStatusMessageNegative":"Title_tooltip-statusMessage__negative--2OVgS","tooltip-statusMessage__noPermission":"Title_tooltip-statusMessage__noPermission--37bMc","tooltipStatusMessageNoPermission":"Title_tooltip-statusMessage__noPermission--37bMc","tooltip-status__positive":"Title_tooltip-status__positive--1F6t7","tooltipStatusPositive":"Title_tooltip-status__positive--1F6t7","tooltip-status__negative":"Title_tooltip-status__negative--2KXEs","tooltipStatusNegative":"Title_tooltip-status__negative--2KXEs","tooltip-statusText":"Title_tooltip-statusText--oTObC","tooltipStatusText":"Title_tooltip-statusText--oTObC","heading":"Title_heading--1SbIw","scheduleButton":"Title_scheduleButton--1Ae-l","scheduleButton__bubble":"Title_scheduleButton__bubble--1wMic","scheduleButtonBubble":"Title_scheduleButton__bubble--1wMic","scheduleIcon":"Title_scheduleIcon--1aFNe"};

/***/ }),
/* 404 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Clan_base--1F7fQ","base__battle":"Clan_base__battle--2sNYh","baseBattle":"Clan_base__battle--2sNYh","emblem":"Clan_emblem--1q_GQ","logo":"Clan_logo--2zhRa","name":"Clan_name--2Tu4a","battle":"Clan_battle--1xwCF"};

/***/ }),
/* 405 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"DefaultTooltip_root--3FM11","root__show":"DefaultTooltip_root__show--1Q1vk","rootShow":"DefaultTooltip_root__show--1Q1vk","body":"DefaultTooltip_body--3qHQd","wrapper":"DefaultTooltip_wrapper--3N6l4","content":"DefaultTooltip_content--ZbU8l","title":"DefaultTooltip_title--3yFNP","subtitle":"DefaultTooltip_subtitle--3rJSs","message":"DefaultTooltip_message--AoOoo","warning":"DefaultTooltip_warning--6-R0A","divider":"DefaultTooltip_divider--3UfF3","highlight":"DefaultTooltip_highlight--24L1H","ribbon":"DefaultTooltip_ribbon--3H1wD","statusMessage":"DefaultTooltip_statusMessage--26Z5t","statusMessage__positive":"DefaultTooltip_statusMessage__positive--1aatW","statusMessagePositive":"DefaultTooltip_statusMessage__positive--1aatW","status":"DefaultTooltip_status--3M-gv","statusMessage__negative":"DefaultTooltip_statusMessage__negative--3YMiG","statusMessageNegative":"DefaultTooltip_statusMessage__negative--3YMiG","statusMessage__noPermission":"DefaultTooltip_statusMessage__noPermission--3BKfn","statusMessageNoPermission":"DefaultTooltip_statusMessage__noPermission--3BKfn","status__positive":"DefaultTooltip_status__positive--2FFNC","statusPositive":"DefaultTooltip_status__positive--2FFNC","status__negative":"DefaultTooltip_status__negative--1LaJz","statusNegative":"DefaultTooltip_status__negative--1LaJz","statusText":"DefaultTooltip_statusText--YmRvP"};

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MemberSlot = exports.LegionarySlot = exports.FreeSlot = exports.DisabledSlot = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactWotBootstrap = __webpack_require__(5);

var _DefaultTooltip = __webpack_require__(30);

var _DefaultTooltip2 = _interopRequireDefault(_DefaultTooltip);

var _Vehicle = __webpack_require__(407);

var _Vehicle2 = _interopRequireDefault(_Vehicle);

var _constants = __webpack_require__(136);

var _Squad = __webpack_require__(208);

var _Squad2 = _interopRequireDefault(_Squad);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-multi-comp */
var DisabledSlot = exports.DisabledSlot = function DisabledSlot() {
    var className = (0, _classnames2.default)(_Squad2.default.tr, _Squad2.default.tr__disabled);

    return _react2.default.createElement(
        'div',
        { className: className },
        _react2.default.createElement('div', { className: _Squad2.default.td })
    );
};

var FreeSlot = exports.FreeSlot = function FreeSlot(_ref) {
    var index = _ref.index;

    var className = (0, _classnames2.default)(_Squad2.default.tr, _Squad2.default.tr__free);
    var tdClassName = (0, _classnames2.default)(_Squad2.default.td, _Squad2.default.td__nickname);

    return _react2.default.createElement(
        'div',
        { className: className },
        _react2.default.createElement(
            'div',
            { className: tdClassName },
            _react2.default.createElement(
                'span',
                { className: _Squad2.default.numeration },
                index
            ),
            _react2.default.createElement(
                'span',
                { className: _Squad2.default.name },
                _constants.FREE_SLOT_CAPTION
            )
        )
    );
};
FreeSlot.propTypes = {
    index: _propTypes2.default.number.isRequired
};

var LegionarySlot = exports.LegionarySlot = function LegionarySlot() {
    var className = (0, _classnames2.default)(_Squad2.default.tr, _Squad2.default.tr__lockedSlot);
    var tdClassName = (0, _classnames2.default)(_Squad2.default.td, _Squad2.default.td__nickname);

    return _react2.default.createElement(
        'div',
        { className: className },
        _react2.default.createElement(
            'div',
            { className: tdClassName },
            _react2.default.createElement('span', {
                className: _Squad2.default.lockedSlotIcon,
                'data-tip': true, 'data-for': _constants.TOOLTIPS.LEGIONARY.id
            }),
            _react2.default.createElement(
                'span',
                { className: _Squad2.default.name },
                _constants.LOCKED_SLOT_CAPTION
            )
        )
    );
};

var MemberSlot = exports.MemberSlot = function MemberSlot(_ref2) {
    var member = _ref2.member,
        index = _ref2.index,
        realm = _ref2.realm,
        isLegionary = _ref2.isLegionary;

    var nicknameTDClassName = (0, _classnames2.default)(_Squad2.default.td, _Squad2.default.td__nickname);
    var ratingTDClassName = (0, _classnames2.default)(_Squad2.default.td, _Squad2.default.td__rating);
    var vehicleTDClassName = (0, _classnames2.default)(_Squad2.default.td, _Squad2.default.td__vehicle);

    var name = member.account_nickname;


    var listCounter = void 0;
    if (member.is_commander) {
        listCounter = _react2.default.createElement(
            'span',
            {
                className: _Squad2.default.commanderIcon,
                'data-tip': true, 'data-for': _constants.TOOLTIPS.COMMANDER.id
            },
            _react2.default.createElement(_DefaultTooltip2.default, _constants.TOOLTIPS.COMMANDER)
        );
    } else if (isLegionary) {
        listCounter = _react2.default.createElement('span', {
            className: _Squad2.default.lockedSlotIcon,
            'data-tip': true, 'data-for': _constants.TOOLTIPS.LEGIONARY.id
        });
    } else {
        listCounter = _react2.default.createElement(
            'span',
            { className: _Squad2.default.numeration },
            index + '.'
        );
    }

    return _react2.default.createElement(
        'div',
        { className: _Squad2.default.tr },
        _react2.default.createElement(
            'div',
            { className: nicknameTDClassName },
            listCounter,
            _react2.default.createElement(
                'span',
                { className: _Squad2.default.name },
                _react2.default.createElement(_reactWotBootstrap.Member, {
                    name: name,
                    clanTag: member.clan_tag,
                    clanColor: '#c9c9b6',
                    tooltipId: _constants.TOOLTIPS.PARTICIPANT.id + '.' + name
                }),
                _react2.default.createElement(_DefaultTooltip2.default, {
                    id: _constants.TOOLTIPS.PARTICIPANT.id + '.' + name,
                    message: member.clan_tag ? name + '[' + member.clan_tag + ']' : name
                })
            )
        ),
        _react2.default.createElement(
            'div',
            { className: ratingTDClassName },
            _react2.default.createElement(
                'span',
                { className: _Squad2.default.rating },
                member.account_rating
            )
        ),
        _react2.default.createElement(
            'div',
            { className: vehicleTDClassName },
            _react2.default.createElement(_Vehicle2.default, { vehicle: member.vehicle, realm: realm })
        )
    );
};
MemberSlot.propTypes = {
    index: _propTypes2.default.number.isRequired,
    realm: _propTypes2.default.string.isRequired,
    member: _propTypes2.default.shape({
        account_nickname: _propTypes2.default.string.isRequired,
        account_rating: _propTypes2.default.number.isRequired,
        is_commander: _propTypes2.default.bool,
        clan_tag: _propTypes2.default.string,
        vehicle: _propTypes2.default.string
    }).isRequired,
    isLegionary: _propTypes2.default.bool
};

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _helpers = __webpack_require__(11);

var _reactWotBootstrap = __webpack_require__(5);

var _constants = __webpack_require__(136);

var _VehicleType = __webpack_require__(68);

var _VehicleType2 = _interopRequireDefault(_VehicleType);

var _Vehicle = __webpack_require__(409);

var _Vehicle2 = _interopRequireDefault(_Vehicle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Vehicle = function Vehicle(props) {
    if (!props.vehicle) {
        var _className = (0, _classnames2.default)(_Vehicle2.default.base, _Vehicle2.default.base__empty);
        return _react2.default.createElement('div', { className: _className, 'data-tip': true, 'data-for': _constants.TOOLTIPS.NO_VEHICLE.id });
    }

    var _props$vehicle = props.vehicle,
        nation = _props$vehicle.nation,
        name = _props$vehicle.name,
        level = _props$vehicle.level,
        type = _props$vehicle.type;


    var imageClassName = _Vehicle2.default.image;
    var nationClassName = (0, _classnames2.default)(_Vehicle2.default.nation, _Vehicle2.default['nation__' + nation]);

    var className = (0, _classnames2.default)(_Vehicle2.default.base, _defineProperty({}, _Vehicle2.default.base__cn, _reactWotBootstrap.helpers.isChineseRealm(props.realm)));

    var iconStyle = {
        backgroundImage: 'url(' + props.vehicle.icon_url + ')'
    };

    return _react2.default.createElement(
        'div',
        { className: className },
        _react2.default.createElement(
            'span',
            { className: _Vehicle2.default.level },
            (0, _helpers.toRoman)(level),
            _react2.default.createElement(
                'span',
                { className: _Vehicle2.default.levelGradient },
                (0, _helpers.toRoman)(level)
            )
        ),
        _react2.default.createElement('span', { className: nationClassName }),
        _react2.default.createElement(
            'span',
            { className: _Vehicle2.default.type },
            _react2.default.createElement(_VehicleType2.default, { mini: true, type: type })
        ),
        _react2.default.createElement('div', { className: imageClassName, style: iconStyle }),
        _react2.default.createElement(
            'span',
            { className: _Vehicle2.default.name },
            name
        )
    );
};

Vehicle.propTypes = {
    vehicle: _propTypes2.default.shape({
        level: _propTypes2.default.number,
        type: _propTypes2.default.string,
        name: _propTypes2.default.string,
        nation: _propTypes2.default.string,
        icon_url: _propTypes2.default.string
    }),
    realm: _propTypes2.default.string.isRequired
};

exports.default = Vehicle;

/***/ }),
/* 408 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"VehicleType_base--1GTHY","base__heavyTank":"VehicleType_base__heavyTank--2T--b","baseHeavyTank":"VehicleType_base__heavyTank--2T--b","base__mediumTank":"VehicleType_base__mediumTank--gyunA","baseMediumTank":"VehicleType_base__mediumTank--gyunA","base__lightTank":"VehicleType_base__lightTank--2QKiU","baseLightTank":"VehicleType_base__lightTank--2QKiU","base__SPG":"VehicleType_base__SPG--dtXXh","baseSpg":"VehicleType_base__SPG--dtXXh","base__AT-SPG":"VehicleType_base__AT-SPG--10IZX","baseAtSpg":"VehicleType_base__AT-SPG--10IZX","base__mini":"VehicleType_base__mini--2I4lG","baseMini":"VehicleType_base__mini--2I4lG","base__premium":"VehicleType_base__premium--tFijZ","basePremium":"VehicleType_base__premium--tFijZ"};

/***/ }),
/* 409 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Vehicle_base--1Jzyt","base__empty":"Vehicle_base__empty--2JTbi","baseEmpty":"Vehicle_base__empty--2JTbi","type":"Vehicle_type--OohYn","name":"Vehicle_name--2bURd","level":"Vehicle_level--34yBX","level-gradient":"Vehicle_level-gradient--3pM_d","levelGradient":"Vehicle_level-gradient--3pM_d","nation":"Vehicle_nation--2qY-p","nation__ussr":"Vehicle_nation__ussr--NjFR4","nationUssr":"Vehicle_nation__ussr--NjFR4","base__cn":"Vehicle_base__cn--2ljdZ","baseCn":"Vehicle_base__cn--2ljdZ","nation__germany":"Vehicle_nation__germany--2Bsla","nationGermany":"Vehicle_nation__germany--2Bsla","nation__usa":"Vehicle_nation__usa--7n8iC","nationUsa":"Vehicle_nation__usa--7n8iC","nation__china":"Vehicle_nation__china--2CQz-","nationChina":"Vehicle_nation__china--2CQz-","nation__france":"Vehicle_nation__france--2b_Sh","nationFrance":"Vehicle_nation__france--2b_Sh","nation__uk":"Vehicle_nation__uk--1_NvH","nationUk":"Vehicle_nation__uk--1_NvH","nation__japan":"Vehicle_nation__japan--2hdRE","nationJapan":"Vehicle_nation__japan--2hdRE","nation__czech":"Vehicle_nation__czech--2e5fP","nationCzech":"Vehicle_nation__czech--2e5fP","nation__sweden":"Vehicle_nation__sweden--cpEEt","nationSweden":"Vehicle_nation__sweden--cpEEt","nation__poland":"Vehicle_nation__poland--2-Xzn","nationPoland":"Vehicle_nation__poland--2-Xzn","nation__italy":"Vehicle_nation__italy--3V07n","nationItaly":"Vehicle_nation__italy--3V07n","image":"Vehicle_image--22HaY"};

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TO_UNIT_MATCHING = exports.UNIT_DESCRIPTION = exports.UNIT_DESTROYED = exports.SQUAD_OF_MY_CLAN = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _helpers = __webpack_require__(11);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SQUAD_OF_MY_CLAN = exports.SQUAD_OF_MY_CLAN = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_rooms.unit_preview.squad_of_my_clan',
    defaultMessage: '\u041E\u0442\u0440\u044F\u0434 \u043C\u043E\u0435\u0433\u043E \u043A\u043B\u0430\u043D\u0430'
});

var UNIT_DESTROYED = exports.UNIT_DESTROYED = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_rooms.unit_preview.destroyed',
    defaultMessage: '\u041E\u0442\u0440\u044F\u0434 \u0440\u0430\u0441\u0444\u043E\u0440\u043C\u0438\u0440\u043E\u0432\u0430\u043D'
});

var UNIT_DESCRIPTION = exports.UNIT_DESCRIPTION = function UNIT_DESCRIPTION(unitType, vehicleLevel, peripheryName) {
    var _descriptions;

    var descriptions = (_descriptions = {}, _defineProperty(_descriptions, _constants.UNIT_TYPES.SORTIE, _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battle_rooms.unit_preview.unit_sortie_description',
        defaultMessage: '\u0412\u044B\u043B\u0430\u0437\u043A\u0430 \u0432 {vehicleLevel} \u0434\u0438\u0432\u0438\u0437\u0438\u043E\u043D\u0435 \u043D\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0435 {peripheryName}',
        values: { vehicleLevel: (0, _helpers.toRoman)(vehicleLevel), peripheryName: peripheryName }
    })), _defineProperty(_descriptions, _constants.UNIT_TYPES.FORT_BATTLE, _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battle_rooms.unit_preview.unit_fort_battle_description',
        defaultMessage: '\u041D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u0435 \u043D\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0435 {peripheryName}',
        values: { peripheryName: peripheryName }
    })), _descriptions);

    return descriptions[unitType];
};

var TO_UNIT_MATCHING = exports.TO_UNIT_MATCHING = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_rooms.unit_preview.to_unit_matching',
    defaultMessage: '\u041A \u043F\u043E\u0434\u0431\u043E\u0440\u0443 \u043E\u0442\u0440\u044F\u0434\u0430'
});

/***/ }),
/* 411 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tooltip-root":"UnitPreview_tooltip-root--1arWl","tooltipRoot":"UnitPreview_tooltip-root--1arWl","tooltip-root__show":"UnitPreview_tooltip-root__show--2ZH4G","tooltipRootShow":"UnitPreview_tooltip-root__show--2ZH4G","tooltip-body":"UnitPreview_tooltip-body--1U8oG","tooltipBody":"UnitPreview_tooltip-body--1U8oG","tooltip-wrapper":"UnitPreview_tooltip-wrapper--RgaCB","tooltipWrapper":"UnitPreview_tooltip-wrapper--RgaCB","tooltip-content":"UnitPreview_tooltip-content--4Y4Si","tooltipContent":"UnitPreview_tooltip-content--4Y4Si","tooltip-title":"UnitPreview_tooltip-title--1vEAg","tooltipTitle":"UnitPreview_tooltip-title--1vEAg","tooltip-subtitle":"UnitPreview_tooltip-subtitle--2DTAp","tooltipSubtitle":"UnitPreview_tooltip-subtitle--2DTAp","tooltip-message":"UnitPreview_tooltip-message--387L_","tooltipMessage":"UnitPreview_tooltip-message--387L_","tooltip-warning":"UnitPreview_tooltip-warning--2Y8CK","tooltipWarning":"UnitPreview_tooltip-warning--2Y8CK","tooltip-divider":"UnitPreview_tooltip-divider--LLPDr","tooltipDivider":"UnitPreview_tooltip-divider--LLPDr","tooltip-highlight":"UnitPreview_tooltip-highlight--2kT8Y","tooltipHighlight":"UnitPreview_tooltip-highlight--2kT8Y","tooltip-ribbon":"UnitPreview_tooltip-ribbon--31ONc","tooltipRibbon":"UnitPreview_tooltip-ribbon--31ONc","tooltip-statusMessage":"UnitPreview_tooltip-statusMessage--1SPNV","tooltipStatusMessage":"UnitPreview_tooltip-statusMessage--1SPNV","tooltip-statusMessage__positive":"UnitPreview_tooltip-statusMessage__positive--3-RoV","tooltipStatusMessagePositive":"UnitPreview_tooltip-statusMessage__positive--3-RoV","tooltip-status":"UnitPreview_tooltip-status--2Sono","tooltipStatus":"UnitPreview_tooltip-status--2Sono","tooltip-statusMessage__negative":"UnitPreview_tooltip-statusMessage__negative--345Dg","tooltipStatusMessageNegative":"UnitPreview_tooltip-statusMessage__negative--345Dg","tooltip-statusMessage__noPermission":"UnitPreview_tooltip-statusMessage__noPermission--3-w58","tooltipStatusMessageNoPermission":"UnitPreview_tooltip-statusMessage__noPermission--3-w58","tooltip-status__positive":"UnitPreview_tooltip-status__positive--1GU0p","tooltipStatusPositive":"UnitPreview_tooltip-status__positive--1GU0p","tooltip-status__negative":"UnitPreview_tooltip-status__negative--2yJfN","tooltipStatusNegative":"UnitPreview_tooltip-status__negative--2yJfN","tooltip-statusText":"UnitPreview_tooltip-statusText--1LyYq","tooltipStatusText":"UnitPreview_tooltip-statusText--1LyYq","base":"UnitPreview_base--2IweR","header":"UnitPreview_header--sNDjK","subtitle":"UnitPreview_subtitle--2w8kR","createDetachmentButton":"UnitPreview_createDetachmentButton--3Encp","squad":"UnitPreview_squad--171bO","unitDestroyed":"UnitPreview_unitDestroyed--d5w1F"};

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapStateToProps = exports.UnitsView = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = __webpack_require__(7);

var _battlerooms = __webpack_require__(413);

var _battlerooms2 = _interopRequireDefault(_battlerooms);

var _available_units = __webpack_require__(50);

var _available_peripheries = __webpack_require__(376);

var _reactivity = __webpack_require__(67);

var _UpdateButton = __webpack_require__(302);

var _UpdateButton2 = _interopRequireDefault(_UpdateButton);

var _UnitCheckboxFilter = __webpack_require__(209);

var _UnitCheckboxFilter2 = _interopRequireDefault(_UnitCheckboxFilter);

var _UnitsList = __webpack_require__(210);

var _UnitsList2 = _interopRequireDefault(_UnitsList);

var _Squad = __webpack_require__(135);

var _Squad2 = _interopRequireDefault(_Squad);

var _BattleRoomsWrapper = __webpack_require__(215);

var _BattleRoomsWrapper2 = _interopRequireDefault(_BattleRoomsWrapper);

var _LoadingScreen = __webpack_require__(29);

var _LoadingScreen2 = _interopRequireDefault(_LoadingScreen);

var _constants = __webpack_require__(38);

var _BattleRoomsListFilter = __webpack_require__(434);

var _BattleRoomsListFilter2 = _interopRequireDefault(_BattleRoomsListFilter);

var _BattleRoomsSchedule = __webpack_require__(140);

var _BattleRoomsSchedule2 = _interopRequireDefault(_BattleRoomsSchedule);

var _propTypes3 = __webpack_require__(32);

var _UnitsView = __webpack_require__(441);

var _UnitsView2 = _interopRequireDefault(_UnitsView);

var _helpers = __webpack_require__(139);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var COOLDOWN = 3000;

var UnitsView = exports.UnitsView = function (_React$Component) {
    _inherits(UnitsView, _React$Component);

    function UnitsView(props) {
        _classCallCheck(this, UnitsView);

        var _this = _possibleConstructorReturn(this, (UnitsView.__proto__ || Object.getPrototypeOf(UnitsView)).call(this));

        _this.state = { updateCooldown: false };

        _this.updateList = function () {
            _this.props.requestAvailableUnits();

            _this.setState({ updateCooldown: true });
            _this.updateCooldown = setTimeout(function () {
                _this.setState({ updateCooldown: false });
            }, COOLDOWN);
        };

        if (props.pushStreamUrl) _this.updateChannel(props.pushStreamUrl);
        return _this;
    }

    _createClass(UnitsView, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.props.requestAvailableUnits({ showLoader: !this.props.loaded });
            this.props.requestAvailablePeripheries();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.updateChannel(null);
            if (this.updateCooldown) clearTimeout(this.updateCooldown);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (prevProps.pushStreamUrl !== this.props.pushStreamUrl) {
                this.updateChannel(this.props.pushStreamUrl);
            }
        }
    }, {
        key: 'updateChannel',
        value: function updateChannel(url) {
            if (this.channel) {
                this.channel.disconnect();
            }
            if (url) {
                this.channel = new _battlerooms2.default(url);
            }
        }
    }, {
        key: 'renderSelectedUnitView',
        value: function renderSelectedUnitView() {
            var _props = this.props,
                participantsError = _props.participantsError,
                selectedUnit = _props.selectedUnit,
                clanId = _props.clanId,
                availablePeripheries = _props.availablePeripheries;


            var isUnitSelected = this.props.selectedUnit !== undefined;

            if (!isUnitSelected) {
                var viewClassNames = (0, _classnames2.default)(_UnitsView2.default.view, _UnitsView2.default.view__empty);
                return _react2.default.createElement('div', { className: viewClassNames });
            }
            var isUnitDisabled = participantsError || (0, _helpers.isUnitDisabled)(selectedUnit, clanId) || !availablePeripheries.includes(selectedUnit.periphery.id);

            if (isUnitDisabled) {
                return _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)(_UnitsView2.default.view, _UnitsView2.default.view__empty) },
                    _react2.default.createElement(
                        'p',
                        { className: _UnitsView2.default.inactive },
                        _constants.BATTLE_ROOMS_UNIT_DISABLED
                    )
                );
            }

            return _react2.default.createElement(
                'div',
                { className: _UnitsView2.default.view },
                _react2.default.createElement(_Squad2.default, {
                    unitData: this.props.selectedUnit,
                    forPreview: false
                })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.props.showLoader) {
                return _react2.default.createElement(_LoadingScreen2.default, { type: 'fullscreen' });
            }

            var body = void 0;
            if (this.props.showSchedule) {
                var mainClassName = (0, _classnames2.default)(_UnitsView2.default.main, _UnitsView2.default.main__fullWidth);
                body = _react2.default.createElement(
                    'div',
                    { className: _UnitsView2.default.body },
                    _react2.default.createElement(
                        'div',
                        { className: mainClassName },
                        _react2.default.createElement(_BattleRoomsListFilter2.default, null)
                    ),
                    _react2.default.createElement(
                        'section',
                        { className: _UnitsView2.default.battleRoomsScheduleWrapper },
                        _react2.default.createElement(_BattleRoomsSchedule2.default, {
                            unitType: this.props.filter.unitType,
                            vehicleLevel: this.props.filter.level
                        })
                    )
                );
            } else {
                body = _react2.default.createElement(
                    'div',
                    { className: _UnitsView2.default.body },
                    _react2.default.createElement(
                        'div',
                        { className: _UnitsView2.default.main },
                        _react2.default.createElement(_BattleRoomsListFilter2.default, null),
                        _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                                'h2',
                                { className: _UnitsView2.default.subtitle },
                                _constants.BATTLE_ROOMS_UNITS_LIST,
                                _react2.default.createElement(
                                    'div',
                                    { className: _UnitsView2.default.updateButton },
                                    _react2.default.createElement(_UpdateButton2.default, {
                                        handleClick: this.updateList,
                                        disabled: this.state.updateCooldown,
                                        tooltipTitle: _constants.REFRESH_UNITS_LIST_TOOLTIP_TITLE,
                                        tooltipMessage: _constants.REFRESH_UNITS_LIST_TOOLTIP_BODY
                                    })
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _UnitsView2.default.unitCheckboxFilter },
                                _react2.default.createElement(_UnitCheckboxFilter2.default, null)
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _UnitsView2.default.list },
                            _react2.default.createElement(_UnitsList2.default, {
                                filter: this.props.filter,
                                updateListHandler: this.updateList,
                                updateCooldown: this.state.updateCooldown
                            })
                        )
                    ),
                    this.renderSelectedUnitView()
                );
            }

            return _react2.default.createElement(
                _BattleRoomsWrapper2.default,
                null,
                body
            );
        }
    }]);

    return UnitsView;
}(_react2.default.Component);

UnitsView.propTypes = {
    clanId: _propTypes2.default.number.isRequired,
    filter: _propTypes2.default.object.isRequired,
    loaded: _propTypes2.default.bool.isRequired,
    participantsError: _propTypes2.default.bool.isRequired,
    pushStreamUrl: _propTypes2.default.string,
    requestAvailableUnits: _propTypes2.default.func.isRequired,
    requestAvailablePeripheries: _propTypes2.default.func.isRequired,
    selectedUnit: _propTypes3.UnitDataPropTypes,
    showLoader: _propTypes2.default.bool.isRequired,
    showSchedule: _propTypes2.default.bool.isRequired,
    availablePeripheries: _propTypes2.default.array.isRequired
};
var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
    var _state$availableUnits = state.availableUnits,
        filter = _state$availableUnits.filter,
        loaded = _state$availableUnits.loaded,
        meta = _state$availableUnits.meta,
        showLoader = _state$availableUnits.showLoader,
        selectedUnitId = _state$availableUnits.selectedUnitId,
        units = _state$availableUnits.units;

    var availablePeripheries = [].concat(_toConsumableArray(state.availablePeripheries.ids), [state.account.periphery_id]);

    var _state$clan = state.clan,
        clanId = _state$clan.id,
        reactiveClanToken = _state$clan.token;
    var pushstream_prefix = meta.pushstream_prefix;
    var pushStreamHost = state.settings.pushStreamHost;


    var unitChannels = [];
    units.forEach(function (unit) {
        var publicUnitChannel = '' + pushstream_prefix + unit.id;
        unitChannels.push(publicUnitChannel);

        if (unit.clan.id === clanId) {
            var clanUnitChannel = '' + publicUnitChannel + reactiveClanToken;
            unitChannels.push(clanUnitChannel);
        }
    });
    var unitChannelsUrl = unitChannels.join('/');
    var pushStreamUrl = (0, _reactivity.getReactiveUpdateUrl)(pushStreamHost, unitChannelsUrl);

    var selectedUnit = units.find(function (unit) {
        return unit.id === selectedUnitId;
    });
    var participantsError = state.unitParticipants.error;

    return {
        clanId: clanId,
        filter: filter,
        loaded: loaded,
        participantsError: participantsError,
        pushStreamUrl: pushStreamUrl,
        selectedUnit: selectedUnit,
        showLoader: showLoader,
        availablePeripheries: availablePeripheries
    };
};

var mapDispatchToProps = {
    requestAvailableUnits: _available_units.requestAvailableUnits,
    requestAvailablePeripheries: _available_peripheries.requestAvailablePeripheries
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UnitsView);

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _store = __webpack_require__(56);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BattleRoomsChannel = function () {
    function BattleRoomsChannel(url) {
        _classCallCheck(this, BattleRoomsChannel);

        this.ws = new WebSocket(url);
        this.ws.onmessage = this.onMessage.bind(this);
    }

    _createClass(BattleRoomsChannel, [{
        key: 'disconnect',
        value: function disconnect() {
            this.ws.close();
        }
    }, {
        key: 'onMessage',
        value: function onMessage(_ref) {
            var data = _ref.data;

            var _JSON$parse = JSON.parse(data),
                payload = _JSON$parse.payload,
                type = _JSON$parse.type;

            if (!payload || !type) {
                console.error('Invalid action from battlerooms channel', data); // eslint-disable-line no-console
                return;
            }

            _store2.default.dispatch({
                type: type,
                payload: payload
            });
        }
    }]);

    return BattleRoomsChannel;
}();

exports.default = BattleRoomsChannel;

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ButtonTiny = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactWotBootstrap = __webpack_require__(5);

var _ButtonTiny = __webpack_require__(415);

var _ButtonTiny2 = _interopRequireDefault(_ButtonTiny);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ButtonTiny = exports.ButtonTiny = function ButtonTiny(props) {
    var className = (0, _classnames2.default)(_ButtonTiny2.default.base, _ButtonTiny2.default['base__' + props.type], _defineProperty({}, _ButtonTiny2.default.disabled, props.disabled));
    return _react2.default.createElement(
        'button',
        {
            className: className,
            onClick: props.disabled ? null : props.handleClick,
            onMouseDown: props.disabled ? null : _reactWotBootstrap.sendClickSoundCommand,
            onMouseEnter: props.disabled ? null : _reactWotBootstrap.sendHoverSoundCommand
        },
        _react2.default.createElement(
            'span',
            { className: _ButtonTiny2.default.icon },
            props.children
        )
    );
};

ButtonTiny.propTypes = {
    disabled: _propTypes2.default.bool,
    type: _propTypes2.default.oneOf(['default', 'secondary']),
    children: _propTypes2.default.node.isRequired,
    handleClick: _propTypes2.default.func.isRequired
};

ButtonTiny.defaultProps = {
    type: 'default'
};

exports.default = ButtonTiny;

/***/ }),
/* 415 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"ButtonTiny_base--2HcHp","base__default":"ButtonTiny_base__default--3JqZI","baseDefault":"ButtonTiny_base__default--3JqZI","base__secondary":"ButtonTiny_base__secondary--20NyJ","baseSecondary":"ButtonTiny_base__secondary--20NyJ","disabled":"ButtonTiny_disabled--2eZtJ","icon":"ButtonTiny_icon--1IPDo"};

/***/ }),
/* 416 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tooltip-root":"UpdateButton_tooltip-root--3B3pF","tooltipRoot":"UpdateButton_tooltip-root--3B3pF","tooltip-root__show":"UpdateButton_tooltip-root__show--38IT0","tooltipRootShow":"UpdateButton_tooltip-root__show--38IT0","tooltip-body":"UpdateButton_tooltip-body--3X1Qp","tooltipBody":"UpdateButton_tooltip-body--3X1Qp","tooltip-wrapper":"UpdateButton_tooltip-wrapper--16vkX","tooltipWrapper":"UpdateButton_tooltip-wrapper--16vkX","tooltip-content":"UpdateButton_tooltip-content--1aDe4","tooltipContent":"UpdateButton_tooltip-content--1aDe4","tooltip-title":"UpdateButton_tooltip-title--2f0NI","tooltipTitle":"UpdateButton_tooltip-title--2f0NI","tooltip-subtitle":"UpdateButton_tooltip-subtitle--3lO4G","tooltipSubtitle":"UpdateButton_tooltip-subtitle--3lO4G","tooltip-message":"UpdateButton_tooltip-message--1oM55","tooltipMessage":"UpdateButton_tooltip-message--1oM55","tooltip-warning":"UpdateButton_tooltip-warning--1yy_T","tooltipWarning":"UpdateButton_tooltip-warning--1yy_T","tooltip-divider":"UpdateButton_tooltip-divider--piUNd","tooltipDivider":"UpdateButton_tooltip-divider--piUNd","tooltip-highlight":"UpdateButton_tooltip-highlight--1j0ak","tooltipHighlight":"UpdateButton_tooltip-highlight--1j0ak","tooltip-ribbon":"UpdateButton_tooltip-ribbon--3Z-9N","tooltipRibbon":"UpdateButton_tooltip-ribbon--3Z-9N","tooltip-statusMessage":"UpdateButton_tooltip-statusMessage--1NtwM","tooltipStatusMessage":"UpdateButton_tooltip-statusMessage--1NtwM","tooltip-statusMessage__positive":"UpdateButton_tooltip-statusMessage__positive--4j2uO","tooltipStatusMessagePositive":"UpdateButton_tooltip-statusMessage__positive--4j2uO","tooltip-status":"UpdateButton_tooltip-status--2LJPS","tooltipStatus":"UpdateButton_tooltip-status--2LJPS","tooltip-statusMessage__negative":"UpdateButton_tooltip-statusMessage__negative--3tz59","tooltipStatusMessageNegative":"UpdateButton_tooltip-statusMessage__negative--3tz59","tooltip-statusMessage__noPermission":"UpdateButton_tooltip-statusMessage__noPermission--188d2","tooltipStatusMessageNoPermission":"UpdateButton_tooltip-statusMessage__noPermission--188d2","tooltip-status__positive":"UpdateButton_tooltip-status__positive--3i-C1","tooltipStatusPositive":"UpdateButton_tooltip-status__positive--3i-C1","tooltip-status__negative":"UpdateButton_tooltip-status__negative--3-Iw0","tooltipStatusNegative":"UpdateButton_tooltip-status__negative--3-Iw0","tooltip-statusText":"UpdateButton_tooltip-statusText--lLyHQ","tooltipStatusText":"UpdateButton_tooltip-statusText--lLyHQ","icon":"UpdateButton_icon--zLFw6"};

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HAS_FREE_SLOTS_TOOLTIP = exports.WAITING_FOR_PLAYERS_TOOLTIP = exports.BATTLE_ROOMS_FILTER = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BATTLE_ROOMS_FILTER = exports.BATTLE_ROOMS_FILTER = {
    notInBattle: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battle_rooms.filter_notInBattle',
        defaultMessage: '\u041D\u0435 \u0432 \u0431\u043E\u044E'
    }),
    places: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battle_rooms.filter_places',
        defaultMessage: '\u0415\u0441\u0442\u044C \u043C\u0435\u0441\u0442\u0430'
    })
};

var WAITING_FOR_PLAYERS_TOOLTIP = exports.WAITING_FOR_PLAYERS_TOOLTIP = {
    id: 'WAITING_FOR_PLAYERS_TOOLTIP_ID',
    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battle_rooms.filter.waiting_for_players_tooltip_title',
        defaultMessage: '\u041D\u0435 \u0432 \u0431\u043E\u044E'
    }),
    message: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battle_rooms.filter.waiting_for_players_tooltip',
        defaultMessage: '\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0442\u043E\u043B\u044C\u043A\u043E \u0442\u0435 \u043E\u0442\u0440\u044F\u0434\u044B, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043D\u0435 \u043D\u0430\u0445\u043E\u0434\u044F\u0442\u0441\u044F \u0432 \u0431\u043E\u044E.'
    })
};

var HAS_FREE_SLOTS_TOOLTIP = exports.HAS_FREE_SLOTS_TOOLTIP = {
    id: 'HAS_FREE_SLOTS_TOOLTIP_ID',
    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battle_rooms.filter.has_free_slots_tooltip_title',
        defaultMessage: '\u0415\u0441\u0442\u044C \u043C\u0435\u0441\u0442\u0430'
    }),
    message: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battle_rooms.filter.has_free_slots_tooltip',
        defaultMessage: '\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0442\u043E\u043B\u044C\u043A\u043E \u0442\u0435 \u043E\u0442\u0440\u044F\u0434\u044B, \u0432 \u043A\u043E\u0442\u043E\u0440\u044B\u0445 \u0435\u0441\u0442\u044C \u0441\u0432\u043E\u0431\u043E\u0434\u043D\u044B\u0435 \u043C\u0435\u0441\u0442\u0430.'
    })
};

/***/ }),
/* 418 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"filterItem":"UnitCheckboxFilter_filterItem--1dieM"};

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TableHeader = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = __webpack_require__(7);

var _reactWotBootstrap = __webpack_require__(5);

var _available_units = __webpack_require__(50);

var _DefaultTooltip = __webpack_require__(30);

var _DefaultTooltip2 = _interopRequireDefault(_DefaultTooltip);

var _constants = __webpack_require__(38);

var _tooltips = __webpack_require__(420);

var _UnitsList = __webpack_require__(137);

var _UnitsList2 = _interopRequireDefault(_UnitsList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TableHeader = exports.TableHeader = function (_React$Component) {
    _inherits(TableHeader, _React$Component);

    function TableHeader() {
        _classCallCheck(this, TableHeader);

        return _possibleConstructorReturn(this, (TableHeader.__proto__ || Object.getPrototypeOf(TableHeader)).apply(this, arguments));
    }

    _createClass(TableHeader, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var getSortableHeaderClassNames = function getSortableHeaderClassNames(name) {
                var _classNames;

                return (0, _classnames2.default)(_UnitsList2.default.th, _UnitsList2.default.th__sortable, _UnitsList2.default.th__center, (_classNames = {}, _defineProperty(_classNames, _UnitsList2.default.th__asc, _this2.props.sort.prop === name && _this2.props.sort.order === 'asc'), _defineProperty(_classNames, _UnitsList2.default.th__desc, _this2.props.sort.prop === name && _this2.props.sort.order === 'desc'), _classNames));
            };
            var basisTHClassName = (0, _classnames2.default)(_UnitsList2.default.th, _UnitsList2.default.th__basis);
            var centeredTHClassName = (0, _classnames2.default)(_UnitsList2.default.th, _UnitsList2.default.th__center);
            var theadTRCLassName = (0, _classnames2.default)(_UnitsList2.default.tr, _UnitsList2.default.tr__thead);

            var thConditionsNodes = [_react2.default.createElement('div', { key: 0, className: (0, _classnames2.default)(_UnitsList2.default.thCondition, _UnitsList2.default.thCondition__active) }), _react2.default.createElement('div', { key: 1, className: (0, _classnames2.default)(_UnitsList2.default.thCondition, _UnitsList2.default.thCondition__hover) })];

            return _react2.default.createElement(
                'div',
                { className: _UnitsList2.default.thead },
                _react2.default.createElement(
                    'div',
                    { className: theadTRCLassName },
                    _react2.default.createElement(
                        'div',
                        {
                            className: basisTHClassName,
                            onMouseEnter: _reactWotBootstrap.sendHoverSoundCommand,
                            onClick: function onClick() {
                                return _this2.props.changeSort(null);
                            },
                            'data-tip': true, 'data-for': _tooltips.TOOLTIPS.clan.id
                        },
                        _react2.default.createElement(
                            'div',
                            { className: _UnitsList2.default.thTitle },
                            _constants.BATTLE_ROOMS_COLUMNS.clan
                        ),
                        _react2.default.createElement(_DefaultTooltip2.default, _tooltips.TOOLTIPS.clan),
                        thConditionsNodes
                    ),
                    _react2.default.createElement(
                        'div',
                        {
                            className: centeredTHClassName,
                            'data-tip': true, 'data-for': _tooltips.TOOLTIPS.rating.id
                        },
                        _react2.default.createElement(
                            'div',
                            { className: _UnitsList2.default.thTitle },
                            _react2.default.createElement('div', { className: _UnitsList2.default.ratingIcon })
                        ),
                        _react2.default.createElement(_DefaultTooltip2.default, _tooltips.TOOLTIPS.rating)
                    ),
                    _react2.default.createElement(
                        'div',
                        {
                            className: getSortableHeaderClassNames('server'),
                            onMouseEnter: _reactWotBootstrap.sendHoverSoundCommand,
                            onClick: function onClick() {
                                return _this2.props.changeSort('server');
                            },
                            'data-tip': true, 'data-for': _tooltips.TOOLTIPS.server.id
                        },
                        _react2.default.createElement(
                            'div',
                            { className: _UnitsList2.default.thTitle },
                            _constants.BATTLE_ROOMS_COLUMNS.server
                        ),
                        _react2.default.createElement(_DefaultTooltip2.default, _tooltips.TOOLTIPS.server),
                        thConditionsNodes
                    ),
                    _react2.default.createElement(
                        'div',
                        {
                            className: centeredTHClassName,
                            'data-tip': true, 'data-for': _tooltips.TOOLTIPS.squad.id
                        },
                        _react2.default.createElement(
                            'div',
                            { className: _UnitsList2.default.thTitle },
                            _constants.BATTLE_ROOMS_COLUMNS.squad
                        ),
                        _react2.default.createElement(_DefaultTooltip2.default, _tooltips.TOOLTIPS.squad)
                    ),
                    _react2.default.createElement(
                        'div',
                        {
                            className: getSortableHeaderClassNames('places'),
                            onMouseEnter: _reactWotBootstrap.sendHoverSoundCommand,
                            onClick: function onClick() {
                                return _this2.props.changeSort('places');
                            },
                            'data-tip': true, 'data-for': _tooltips.TOOLTIPS.places.id
                        },
                        _react2.default.createElement(
                            'div',
                            { className: _UnitsList2.default.thTitle },
                            _constants.BATTLE_ROOMS_COLUMNS.places
                        ),
                        _react2.default.createElement(_DefaultTooltip2.default, _tooltips.TOOLTIPS.places),
                        thConditionsNodes
                    )
                )
            );
        }
    }]);

    return TableHeader;
}(_react2.default.Component);

TableHeader.propTypes = {
    sort: _propTypes2.default.shape({
        prop: _propTypes2.default.oneOf(['places', 'server']),
        order: _propTypes2.default.oneOf(['asc', 'desc'])
    }).isRequired,
    changeSort: _propTypes2.default.func.isRequired
};


var mapStateToProps = function mapStateToProps(state) {
    return {
        sort: state.availableUnits.sort
    };
};

var mapDispatchToProps = {
    changeSort: _available_units.changeSort
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TableHeader);

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TOOLTIPS = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _constants = __webpack_require__(38);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TOOLTIPS = exports.TOOLTIPS = {
    clan: {
        id: 'units_list.columns.tooltips.clan.id',
        title: _constants.BATTLE_ROOMS_COLUMNS.clan,
        message: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'units_list.columns.tooltips.clan.message',
            defaultMessage: '\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043E\u0442\u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043E\u0442\u0440\u044F\u0434\u044B \u043F\u043E \u0440\u0435\u0439\u0442\u0438\u043D\u0433\u0443, \u043F\u0440\u0438\u0431\u043B\u0438\u0436\u0435\u043D\u043D\u043E\u043C\u0443 \u043A \u0432\u0430\u0448\u0435\u043C\u0443 \u043B\u0438\u0447\u043D\u043E\u043C\u0443 \u0440\u0435\u0439\u0442\u0438\u043D\u0433\u0443.{newLine}\u041F\u0435\u0440\u0432\u044B\u043C\u0438 \u0431\u0443\u0434\u0443\u0442 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0442\u044C\u0441\u044F \u043E\u0442\u0440\u044F\u0434\u044B \u0441 \u043C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u044B\u043C \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E\u043C \u0441\u0432\u043E\u0431\u043E\u0434\u043D\u044B\u0445 \u043C\u0435\u0441\u0442.',
            values: {
                newLine: _react2.default.createElement('br', null)
            }
        })
    },
    rating: {
        id: 'units_list.columns.tooltips.rating.id',
        title: _constants.BATTLE_ROOMS_COLUMNS.rating,
        message: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'units_list.columns.tooltips.rating.message',
            defaultMessage: '\u0421\u0440\u0435\u0434\u043D\u0435\u0435 \u0430\u0440\u0438\u0444\u043C\u0435\u0442\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u0435\u043B\u0435\u0439 \u043B\u0438\u0447\u043D\u043E\u0433\u043E \u0440\u0435\u0439\u0442\u0438\u043D\u0433\u0430 \u0438\u0433\u0440\u043E\u043A\u043E\u0432 \u0432 \u043E\u0442\u0440\u044F\u0434\u0435.'
        })
    },
    mode: {
        id: 'units_list.columns.tooltips.mode.id',
        title: _constants.BATTLE_ROOMS_COLUMNS.mode,
        message: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'units_list.columns.tooltips.mode.message',
            defaultMessage: '\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043E\u0442\u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u043E \u0440\u0435\u0436\u0438\u043C\u0443 \u0431\u043E\u0451\u0432, \u0434\u043B\u044F \u043A\u043E\u0442\u043E\u0440\u043E\u0433\u043E \u0441\u043E\u0431\u0438\u0440\u0430\u0435\u0442\u0441\u044F \u043E\u0442\u0440\u044F\u0434.'
        })
    },
    server: {
        id: 'units_list.columns.tooltips.server.id',
        title: _constants.BATTLE_ROOMS_COLUMNS.server,
        message: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'units_list.columns.tooltips.server.message',
            defaultMessage: '\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043E\u0442\u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u043E \u0441\u0435\u0440\u0432\u0435\u0440\u0443, \u043D\u0430 \u043A\u043E\u0442\u043E\u0440\u043E\u043C \u043E\u0442\u0440\u044F\u0434 \u0432\u0435\u0434\u0451\u0442 \u0431\u043E\u0438.'
        })
    },
    squad: {
        id: 'units_list.columns.tooltips.squad.id',
        title: _constants.BATTLE_ROOMS_COLUMNS.squad,
        message: _constants.PLAYERS_COLUMN_DESCRIPTION
    },
    places: {
        id: 'units_list.columns.tooltips.places.id',
        title: _constants.BATTLE_ROOMS_COLUMNS.places,
        message: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'units_list.columns.free_slots_tooltip',
            defaultMessage: '\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043E\u0442\u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u043E \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u0443 \u0441\u0432\u043E\u0431\u043E\u0434\u043D\u044B\u0445 \u043C\u0435\u0441\u0442 \u0432 \u0441\u043E\u0441\u0442\u0430\u0432\u0435 \u043E\u0442\u0440\u044F\u0434\u0430.{newLine}\u041B\u0435\u0433\u0438\u043E\u043D\u0435\u0440\u044B \u0432\u0438\u0434\u044F\u0442 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0441\u0432\u043E\u0431\u043E\u0434\u043D\u044B\u0445 \u043C\u0435\u0441\u0442 \u0434\u043B\u044F \u043B\u0435\u0433\u0438\u043E\u043D\u0435\u0440\u043E\u0432.',
            values: {
                newLine: _react2.default.createElement('br', null)
            }
        })
    }
}; /* eslint-disable max-len */

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapStateToProps = exports.TableBody = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactWotBootstrap = __webpack_require__(5);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = __webpack_require__(7);

var _Clan = __webpack_require__(81);

var _Clan2 = _interopRequireDefault(_Clan);

var _constants = __webpack_require__(4);

var _ = __webpack_require__(422);

var _available_units = __webpack_require__(50);

var _join_unit = __webpack_require__(201);

var _helpers = __webpack_require__(139);

var _constants2 = __webpack_require__(431);

var _propTypes3 = __webpack_require__(32);

var _EmptyList = __webpack_require__(212);

var _EmptyList2 = _interopRequireDefault(_EmptyList);

var _UnitsList = __webpack_require__(137);

var _UnitsList2 = _interopRequireDefault(_UnitsList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TableBody = exports.TableBody = function (_React$Component) {
    _inherits(TableBody, _React$Component);

    function TableBody() {
        _classCallCheck(this, TableBody);

        var _this = _possibleConstructorReturn(this, (TableBody.__proto__ || Object.getPrototypeOf(TableBody)).call(this));

        _this.state = { hoveredUnitId: null };
        _this.handleRowClick = _this.handleRowClick.bind(_this);
        _this.handleRowDoubleClick = _this.handleRowDoubleClick.bind(_this);
        _this.hoverUnitHandler = _this.hoverUnitHandler.bind(_this);
        return _this;
    }

    _createClass(TableBody, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (this._scrollArea && this._scrollArea.state.topArrowEnabled) {
                // in tests there is no _scrollArea
                var wasFilterChanged = JSON.stringify(prevProps.filter) !== JSON.stringify(this.props.filter);
                if (wasFilterChanged) this._scrollArea.scrollToTop();
            }
        }
    }, {
        key: 'handleRowClick',
        value: function handleRowClick(item) {
            if (item.id !== this.props.selectedUnitId) {
                this.props.selectUnit(item);
                (0, _reactWotBootstrap.sendSelectClickSoundCommand)();
            }
        }
    }, {
        key: 'handleRowDoubleClick',
        value: function handleRowDoubleClick() {
            var _this2 = this;

            var selectedUnit = this.props.units.find(function (unit) {
                return unit.id === _this2.props.selectedUnitId;
            });
            this.props.joinToUnit(selectedUnit.server_id, selectedUnit.periphery.id);
        }
    }, {
        key: 'hoverUnitHandler',
        value: function hoverUnitHandler(unitId) {
            if (unitId) (0, _reactWotBootstrap.sendHoverSoundCommand)();
            this.setState({ hoveredUnitId: unitId });
        }
    }, {
        key: 'renderSubtitleRow',
        value: function renderSubtitleRow() {
            var subtitleRowClassName = (0, _classnames2.default)(_UnitsList2.default.tr, _UnitsList2.default.tr__subtitle);
            return _react2.default.createElement(
                'div',
                { className: subtitleRowClassName, key: 'available_units_row_subtitle' },
                _react2.default.createElement(
                    'div',
                    { className: _UnitsList2.default.td },
                    _constants2.UNITS_LIST_OTHERS_CLANS_SUBTITLE
                )
            );
        }
    }, {
        key: 'renderRow',
        value: function renderRow(unit, idx) {
            var _this3 = this;

            var average_rating = unit.average_rating,
                clan = unit.clan,
                max_members_number = unit.max_members_number,
                members_number = unit.members_number,
                periphery = unit.periphery;


            var freePlaces = this.props.clanId === clan.id ? unit.free_places_for_clan_members : unit.free_places_for_legionaries;

            var basisTDClassName = (0, _classnames2.default)(_UnitsList2.default.td, _UnitsList2.default.td__basis);
            var centeredTDClassName = (0, _classnames2.default)(_UnitsList2.default.td, _UnitsList2.default.td__center);
            var trClassName = (0, _classnames2.default)(_UnitsList2.default.tr, _defineProperty({}, _UnitsList2.default.tr__selected, unit.id === this.props.selectedUnitId));

            var trProps = {
                className: trClassName,
                key: 'available_units_row_' + idx,
                onClick: function onClick() {
                    return _this3.handleRowClick(unit);
                },
                onDoubleClick: function onDoubleClick() {
                    return _this3.handleRowDoubleClick();
                },
                onMouseEnter: function onMouseEnter() {
                    return _this3.hoverUnitHandler(unit.id);
                },
                onMouseLeave: function onMouseLeave() {
                    return _this3.hoverUnitHandler(null);
                },
                'data-tip': true,
                'data-for': _.UnitTooltip.id
            };

            if ((0, _helpers.isUnitDisabled)(unit, this.props.clanId)) {
                var mdash = _react2.default.createElement(
                    'span',
                    null,
                    '\u2014'
                );
                var emptyTd = _react2.default.createElement(
                    'div',
                    { className: centeredTDClassName },
                    mdash
                );
                return _react2.default.createElement(
                    'div',
                    trProps,
                    _react2.default.createElement(
                        'div',
                        { className: basisTDClassName },
                        _react2.default.createElement(_Clan2.default, clan)
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: centeredTDClassName },
                        _react2.default.createElement(
                            'span',
                            { className: _UnitsList2.default.rating },
                            mdash
                        )
                    ),
                    emptyTd,
                    emptyTd,
                    emptyTd
                );
            }

            var inBattleIcon = unit.in_battle || unit.players_matching_started_at !== null ? _react2.default.createElement('span', { className: _UnitsList2.default.inBattleIcon }) : null;

            return _react2.default.createElement(
                'div',
                trProps,
                _react2.default.createElement(
                    'div',
                    { className: basisTDClassName },
                    _react2.default.createElement(_Clan2.default, clan)
                ),
                _react2.default.createElement(
                    'div',
                    { className: centeredTDClassName },
                    _react2.default.createElement(
                        'span',
                        { className: _UnitsList2.default.rating },
                        average_rating
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: centeredTDClassName },
                    periphery.name
                ),
                _react2.default.createElement(
                    'div',
                    { className: centeredTDClassName },
                    members_number,
                    _react2.default.createElement(
                        'span',
                        { className: _UnitsList2.default.totalCount },
                        '/' + max_members_number
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: centeredTDClassName },
                    freePlaces
                ),
                inBattleIcon
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var _props = this.props,
                availablePeripheries = _props.availablePeripheries,
                units = _props.units,
                loading = _props.loading,
                clanId = _props.clanId;

            if (!units.length && !loading) {
                return _react2.default.createElement(_EmptyList2.default, {
                    handleListUpdate: this.props.updateListHandler,
                    updateCooldown: this.props.updateCooldown
                });
            }

            var rows = [];
            var availableUnits = units.filter(function (item) {
                return availablePeripheries.includes(item.periphery.id);
            });
            var myClanUnits = availableUnits.filter(function (item) {
                return item.clan.id === clanId;
            });
            var otherClansUnits = availableUnits.filter(function (item) {
                return item.clan.id !== clanId;
            });

            if (myClanUnits.length) {
                rows.push(myClanUnits.map(function (item, idx) {
                    return _this4.renderRow(item, idx);
                }));
            }
            if (myClanUnits.length && otherClansUnits.length) {
                rows.push(this.renderSubtitleRow());
            }
            rows.push(otherClansUnits.map(function (item, idx) {
                return _this4.renderRow(item, idx + myClanUnits.length);
            }));

            var unitTooltipComponent = void 0;
            if (this.state.hoveredUnitId) {
                unitTooltipComponent = _react2.default.createElement(_.UnitTooltip, { unitId: this.state.hoveredUnitId });
            }
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    _reactWotBootstrap.ScrollArea,
                    {
                        stepHeight: _constants2.UNITS_LIST_ITEM_HEIGHT,
                        scrollableAreaHeight: _constants2.UNITS_LIST_ITEM_HEIGHT * _constants2.UNITS_LIST_VISIBLE_ITEMS,
                        modifier: 'unitsList',
                        ref: function ref(elem) {
                            return _this4._scrollArea = elem;
                        }
                    },
                    _react2.default.createElement(
                        'div',
                        { className: _UnitsList2.default.table },
                        _react2.default.createElement(
                            'div',
                            { className: _UnitsList2.default.tbody },
                            rows
                        )
                    )
                ),
                unitTooltipComponent
            );
        }
    }]);

    return TableBody;
}(_react2.default.Component);

TableBody.propTypes = {
    filter: _propTypes2.default.shape({
        level: _propTypes2.default.number,
        unitType: _propTypes2.default.oneOf(Object.values(_constants.UNIT_TYPES))
    }).isRequired,
    updateCooldown: _propTypes2.default.bool.isRequired,
    updateListHandler: _propTypes2.default.func.isRequired,

    clanId: _propTypes2.default.number,
    loading: _propTypes2.default.bool,
    units: _propTypes2.default.arrayOf(_propTypes3.UnitDataPropTypes).isRequired,
    availablePeripheries: _propTypes2.default.array.isRequired,
    selectedUnitId: _propTypes2.default.number,

    joinToUnit: _propTypes2.default.func.isRequired,
    selectUnit: _propTypes2.default.func.isRequired
};
var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
    var availablePeripheries = [].concat(_toConsumableArray(state.availablePeripheries.ids), [state.account.periphery_id]);

    return {
        clanId: state.clan.id,
        loading: state.availableUnits.loading,
        units: state.availableUnits.units,
        availablePeripheries: availablePeripheries,
        selectedUnitId: state.availableUnits.selectedUnitId
    };
};

var mapDispatchToProps = {
    joinToUnit: _join_unit.joinToUnit,
    selectUnit: _available_units.selectUnit
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(TableBody);

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnitTooltip = exports.UnitsList = exports.Tabs = exports.Squad = exports.LevelFilterTooltip = exports.UnitCheckboxFilter = exports.EmptyList = exports.CreateUnitButton = exports.BattleModeFilter = undefined;

var _BattleModeFilter2 = __webpack_require__(138);

var _BattleModeFilter3 = _interopRequireDefault(_BattleModeFilter2);

var _CreateUnitButton2 = __webpack_require__(133);

var _CreateUnitButton3 = _interopRequireDefault(_CreateUnitButton2);

var _EmptyList2 = __webpack_require__(212);

var _EmptyList3 = _interopRequireDefault(_EmptyList2);

var _UnitCheckboxFilter2 = __webpack_require__(209);

var _UnitCheckboxFilter3 = _interopRequireDefault(_UnitCheckboxFilter2);

var _LevelFilterTooltip2 = __webpack_require__(211);

var _LevelFilterTooltip3 = _interopRequireDefault(_LevelFilterTooltip2);

var _Squad2 = __webpack_require__(135);

var _Squad3 = _interopRequireDefault(_Squad2);

var _Tabs2 = __webpack_require__(213);

var _Tabs3 = _interopRequireDefault(_Tabs2);

var _UnitsList2 = __webpack_require__(210);

var _UnitsList3 = _interopRequireDefault(_UnitsList2);

var _UnitTooltip2 = __webpack_require__(214);

var _UnitTooltip3 = _interopRequireDefault(_UnitTooltip2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.BattleModeFilter = _BattleModeFilter3.default;
exports.CreateUnitButton = _CreateUnitButton3.default;
exports.EmptyList = _EmptyList3.default;
exports.UnitCheckboxFilter = _UnitCheckboxFilter3.default;
exports.LevelFilterTooltip = _LevelFilterTooltip3.default;
exports.Squad = _Squad3.default;
exports.Tabs = _Tabs3.default;
exports.UnitsList = _UnitsList3.default;
exports.UnitTooltip = _UnitTooltip3.default;

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LEVEL_FILTER_TOOLTIP_FILTER_ACTIONS = exports.LEVEL_FILTER_TOOLTIP_DESCRIPTION = exports.LEVEL_FILTER_TOOLTIP_TITLE = undefined;

var _LEVEL_FILTER_TOOLTIP;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint-disable react/no-multi-comp */

var LEVEL_FILTER_TOOLTIP_TITLE = exports.LEVEL_FILTER_TOOLTIP_TITLE = function LEVEL_FILTER_TOOLTIP_TITLE(level) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battle_rooms.level_filter_tooltip_title',
        defaultMessage: '\u0412\u044B\u043B\u0430\u0437\u043A\u0438 \u0432 {level} \u0434\u0438\u0432\u0438\u0437\u0438\u043E\u043D\u0435',
        values: { level: level }
    });
};

var LEVEL_FILTER_TOOLTIP_DESCRIPTION = exports.LEVEL_FILTER_TOOLTIP_DESCRIPTION = {
    vehicleLevels: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battle_rooms.level_filter_tooltip_description.vehicalLevels',
        defaultMessage: '\u0443\u0440\u043E\u0432\u0435\u043D\u044C \u0442\u0435\u0445\u043D\u0438\u043A\u0438'
    }),
    playersNumber: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battle_rooms.level_filter_tooltip_description.playersCount',
        defaultMessage: '\u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0438\u0433\u0440\u043E\u043A\u043E\u0432 \u0432 \u043E\u0442\u0440\u044F\u0434\u0435, \u0432\u043A\u043B\u044E\u0447\u0430\u044F \u043B\u0435\u0433\u0438\u043E\u043D\u0435\u0440\u043E\u0432'
    }),
    legionariesNumber: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battle_rooms.level_filter_tooltip_description.maxLegioners',
        defaultMessage: '\u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0435 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043B\u0435\u0433\u0438\u043E\u043D\u0435\u0440\u043E\u0432 \u0432 \u043E\u0442\u0440\u044F\u0434\u0435'
    }),
    battleDuration: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battle_rooms.level_filter_tooltip_description.maxBattleDuration',
        defaultMessage: '\u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u0434\u043B\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C \u0431\u043E\u044F'
    })
};

var LEVEL_FILTER_TOOLTIP_FILTER_ACTIONS = exports.LEVEL_FILTER_TOOLTIP_FILTER_ACTIONS = (_LEVEL_FILTER_TOOLTIP = {}, _defineProperty(_LEVEL_FILTER_TOOLTIP, _constants.BATTLE_ROOMS_TAB_STATES.UNITS, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_rooms.units.level_filter_tooltip_filter_action',
    defaultMessage: '\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043E\u0442\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u044C \u043E\u0442\u0440\u044F\u0434\u044B \u0434\u043B\u044F \u0441\u0440\u0430\u0436\u0435\u043D\u0438\u0439 \u0432 \u044D\u0442\u043E\u043C \u0440\u0435\u0436\u0438\u043C\u0435.'
})), _defineProperty(_LEVEL_FILTER_TOOLTIP, _constants.BATTLE_ROOMS_TAB_STATES.MATCHING, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_rooms.matching.level_filter_tooltip_filter_action',
    defaultMessage: '\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u0432\u044B\u0431\u0440\u0430\u0442\u044C \u044D\u0442\u043E\u0442 \u0440\u0435\u0436\u0438\u043C.'
})), _LEVEL_FILTER_TOOLTIP);

/***/ }),
/* 424 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"LevelFilterTooltip_root--3iT5B","root__show":"LevelFilterTooltip_root__show--3cmMz","rootShow":"LevelFilterTooltip_root__show--3cmMz","body":"LevelFilterTooltip_body--DENUT","wrapper":"LevelFilterTooltip_wrapper--yaWg2","content":"LevelFilterTooltip_content--3f09u","title":"LevelFilterTooltip_title--3IJ_5","subtitle":"LevelFilterTooltip_subtitle--2i5YC","message":"LevelFilterTooltip_message--1oRrC","warning":"LevelFilterTooltip_warning--gvXfB","divider":"LevelFilterTooltip_divider--ZYe98","highlight":"LevelFilterTooltip_highlight--3q2sk","ribbon":"LevelFilterTooltip_ribbon--kY3Du","statusMessage":"LevelFilterTooltip_statusMessage--1tT4B","statusMessage__positive":"LevelFilterTooltip_statusMessage__positive--39e_x","statusMessagePositive":"LevelFilterTooltip_statusMessage__positive--39e_x","status":"LevelFilterTooltip_status--1IpaL","statusMessage__negative":"LevelFilterTooltip_statusMessage__negative--3g9sN","statusMessageNegative":"LevelFilterTooltip_statusMessage__negative--3g9sN","statusMessage__noPermission":"LevelFilterTooltip_statusMessage__noPermission--3SQHJ","statusMessageNoPermission":"LevelFilterTooltip_statusMessage__noPermission--3SQHJ","status__positive":"LevelFilterTooltip_status__positive--1m2bk","statusPositive":"LevelFilterTooltip_status__positive--1m2bk","status__negative":"LevelFilterTooltip_status__negative--37bgw","statusNegative":"LevelFilterTooltip_status__negative--37bgw","statusText":"LevelFilterTooltip_statusText--2Q0m0","base":"LevelFilterTooltip_base--1SqZM","details":"LevelFilterTooltip_details--nK-Rn","detailsItem":"LevelFilterTooltip_detailsItem--3SWnM","value":"LevelFilterTooltip_value--2s4Fw","description":"LevelFilterTooltip_description--3yeXT"};

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SHOW_BUTTON_TOOLTIP_MESSAGE = exports.SHOW_BUTTON_TOOLTIP_TITLE = exports.SHOW_BUTTON_CAPTION = exports.UPDATE_BUTTON_CAPTION = exports.BUTTON_TOOLTIP_ID = exports.BATTLES_ONLY_ON_X_LEVEL = exports.EMPTY_LIST_CREATE_UNIT_MESSAGE = exports.EMPTY_LIST_TITLE = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-multi-comp */
var EMPTY_LIST_TITLE = exports.EMPTY_LIST_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_rooms.empty_list.title',
    defaultMessage: '\u041E\u0442\u0440\u044F\u0434\u044B \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u044B'
});

var EMPTY_LIST_CREATE_UNIT_MESSAGE = exports.EMPTY_LIST_CREATE_UNIT_MESSAGE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_rooms.empty_list.create_unit_title',
    defaultMessage: '\u0427\u0442\u043E\u0431\u044B \u0443\u0447\u0430\u0441\u0442\u0432\u043E\u0432\u0430\u0442\u044C \u0432 \u0441\u0440\u0430\u0436\u0435\u043D\u0438\u044F\u0445, \u0441\u043E\u0437\u0434\u0430\u0439\u0442\u0435 \u043E\u0442\u0440\u044F\u0434.'
});

var BATTLES_ONLY_ON_X_LEVEL = exports.BATTLES_ONLY_ON_X_LEVEL = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_rooms.empty_list.battles_only_on_x_level',
    defaultMessage: '\u041D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u044F \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B \u0442\u043E\u043B\u044C\u043A\u043E \u043D\u0430 X \u0434\u0438\u0432\u0438\u0437\u0438\u043E\u043D\u0435'
});

// Buttons

var BUTTON_TOOLTIP_ID = exports.BUTTON_TOOLTIP_ID = 'EMPTY_LIST_BUTTON_TOOLTIP_ID';

var UPDATE_BUTTON_CAPTION = exports.UPDATE_BUTTON_CAPTION = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_rooms.empty_list.update_button_caption',
    defaultMessage: '\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0441\u043F\u0438\u0441\u043E\u043A'
});

var SHOW_BUTTON_CAPTION = exports.SHOW_BUTTON_CAPTION = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_rooms.empty_list.show_button',
    defaultMessage: '\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C'
});

var SHOW_BUTTON_TOOLTIP_TITLE = exports.SHOW_BUTTON_TOOLTIP_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_rooms.empty_list.show_button_tooltip_title',
    defaultMessage: '\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C'
});

var SHOW_BUTTON_TOOLTIP_MESSAGE = exports.SHOW_BUTTON_TOOLTIP_MESSAGE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_rooms.empty_list.show_button_tooltip',
    defaultMessage: '\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u043E\u0442\u0440\u044F\u0434\u044B \u0434\u043B\u044F \u0441\u0440\u0430\u0436\u0435\u043D\u0438\u0439 \u0432\u043E \u0432\u0441\u0435\u0445 \u0434\u0438\u0432\u0438\u0437\u0438\u043E\u043D\u0430\u0445.'
});

/***/ }),
/* 426 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"EmptyList_root--DT7AT","root__show":"EmptyList_root__show--25_pF","rootShow":"EmptyList_root__show--25_pF","body":"EmptyList_body--2QOp-","wrapper":"EmptyList_wrapper--S002t","content":"EmptyList_content--3a6W3","title":"EmptyList_title--3slb9","subtitle":"EmptyList_subtitle--1zzvp","message":"EmptyList_message--2AQi6","warning":"EmptyList_warning--3cBSF","divider":"EmptyList_divider--O5aX6","highlight":"EmptyList_highlight--1JlHN","ribbon":"EmptyList_ribbon--1eGTB","statusMessage":"EmptyList_statusMessage--2fIRN","statusMessage__positive":"EmptyList_statusMessage__positive--2DmEw","statusMessagePositive":"EmptyList_statusMessage__positive--2DmEw","status":"EmptyList_status--1aDnS","statusMessage__negative":"EmptyList_statusMessage__negative--1EN6s","statusMessageNegative":"EmptyList_statusMessage__negative--1EN6s","statusMessage__noPermission":"EmptyList_statusMessage__noPermission--2dyWI","statusMessageNoPermission":"EmptyList_statusMessage__noPermission--2dyWI","status__positive":"EmptyList_status__positive--18pql","statusPositive":"EmptyList_status__positive--18pql","status__negative":"EmptyList_status__negative--3CdA1","statusNegative":"EmptyList_status__negative--3CdA1","statusText":"EmptyList_statusText--3l_lN","base":"EmptyList_base--11K_M","holder":"EmptyList_holder--2LJj0","button":"EmptyList_button--1AB9j"};

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BATTLE_ROOMS_TABS = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BATTLE_ROOMS_TABS = exports.BATTLE_ROOMS_TABS = [{
    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battleRooms.tab.players_matching.title',
        defaultMessage: '\u041F\u043E\u0434\u0431\u043E\u0440 \u043E\u0442\u0440\u044F\u0434\u0430'
    }),
    id: 'battleRooms.tab.players_matching'
}, {
    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battleRooms.tab.unit_list.title',
        defaultMessage: '\u0421\u043F\u0438\u0441\u043E\u043A \u043E\u0442\u0440\u044F\u0434\u043E\u0432'
    }),
    id: 'battleRooms.tab.unit_list'
}];

/***/ }),
/* 428 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tooltip-root":"Tabs_tooltip-root--1E3K_","tooltipRoot":"Tabs_tooltip-root--1E3K_","tooltip-root__show":"Tabs_tooltip-root__show--1rOSu","tooltipRootShow":"Tabs_tooltip-root__show--1rOSu","tooltip-body":"Tabs_tooltip-body--3U68y","tooltipBody":"Tabs_tooltip-body--3U68y","tooltip-wrapper":"Tabs_tooltip-wrapper--1yBHL","tooltipWrapper":"Tabs_tooltip-wrapper--1yBHL","tooltip-content":"Tabs_tooltip-content--2SjKm","tooltipContent":"Tabs_tooltip-content--2SjKm","tooltip-title":"Tabs_tooltip-title--34olm","tooltipTitle":"Tabs_tooltip-title--34olm","tooltip-subtitle":"Tabs_tooltip-subtitle--33h0d","tooltipSubtitle":"Tabs_tooltip-subtitle--33h0d","tooltip-message":"Tabs_tooltip-message--1exbk","tooltipMessage":"Tabs_tooltip-message--1exbk","tooltip-warning":"Tabs_tooltip-warning--2zB9Y","tooltipWarning":"Tabs_tooltip-warning--2zB9Y","tooltip-divider":"Tabs_tooltip-divider--3PE3y","tooltipDivider":"Tabs_tooltip-divider--3PE3y","tooltip-highlight":"Tabs_tooltip-highlight--16CDX","tooltipHighlight":"Tabs_tooltip-highlight--16CDX","tooltip-ribbon":"Tabs_tooltip-ribbon--2FA3Z","tooltipRibbon":"Tabs_tooltip-ribbon--2FA3Z","tooltip-statusMessage":"Tabs_tooltip-statusMessage--2Fi8j","tooltipStatusMessage":"Tabs_tooltip-statusMessage--2Fi8j","tooltip-statusMessage__positive":"Tabs_tooltip-statusMessage__positive--3xQz2","tooltipStatusMessagePositive":"Tabs_tooltip-statusMessage__positive--3xQz2","tooltip-status":"Tabs_tooltip-status--3PmJO","tooltipStatus":"Tabs_tooltip-status--3PmJO","tooltip-statusMessage__negative":"Tabs_tooltip-statusMessage__negative--3PPAq","tooltipStatusMessageNegative":"Tabs_tooltip-statusMessage__negative--3PPAq","tooltip-statusMessage__noPermission":"Tabs_tooltip-statusMessage__noPermission--3q2d3","tooltipStatusMessageNoPermission":"Tabs_tooltip-statusMessage__noPermission--3q2d3","tooltip-status__positive":"Tabs_tooltip-status__positive--1Qlnu","tooltipStatusPositive":"Tabs_tooltip-status__positive--1Qlnu","tooltip-status__negative":"Tabs_tooltip-status__negative--1rDt9","tooltipStatusNegative":"Tabs_tooltip-status__negative--1rDt9","tooltip-statusText":"Tabs_tooltip-statusText--34nT-","tooltipStatusText":"Tabs_tooltip-statusText--34nT-","base":"Tabs_base--1JQ4Y","holder":"Tabs_holder--26UoV","item":"Tabs_item--iCrNm","tab":"Tabs_tab--1Dzb6","item__selected":"Tabs_item__selected--2etCc","itemSelected":"Tabs_item__selected--2etCc","overlay":"Tabs_overlay--2V9lh","borders":"Tabs_borders--2XHGQ","caption":"Tabs_caption--3yI8l","base__cn":"Tabs_base__cn--1Eye8","baseCn":"Tabs_base__cn--1Eye8"};

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UNIT_TOOLTIP_BATTLE_MODE = exports.UNIT_TOOLTIP_DATA_LABELS = exports.UNIT_TOOLTIP_DISABLED_TEXT = exports.UNIT_TOOLTIP_CREATION_TIME = exports.BATTLE_ROOMS_UNIT_TOOLTIP_ID = undefined;

var _UNIT_TOOLTIP_BATTLE_;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _constants = __webpack_require__(4);

var _i18n = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint-disable react/no-multi-comp */

var BATTLE_ROOMS_UNIT_TOOLTIP_ID = exports.BATTLE_ROOMS_UNIT_TOOLTIP_ID = 'UNIT_TOOLTIP_ID';

var UNIT_TOOLTIP_CREATION_TIME = exports.UNIT_TOOLTIP_CREATION_TIME = function UNIT_TOOLTIP_CREATION_TIME(time) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battle_rooms.unit_tooltip.creation_time',
        defaultMessage: '\u041D\u0430\u0431\u043E\u0440 \u043E\u0442\u043A\u0440\u044B\u0442 {time} \u043D\u0430\u0437\u0430\u0434',
        values: { time: time }
    });
};

var UNIT_TOOLTIP_DISABLED_TEXT = exports.UNIT_TOOLTIP_DISABLED_TEXT = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'units_list.tooltips.disabled_unit',
    defaultMessage: '\u041D\u0430\u0431\u043E\u0440 \u0432 \u0441\u043E\u0441\u0442\u0430\u0432 \u043E\u0442\u0440\u044F\u0434\u0430 \u0437\u0430\u043A\u0440\u044B\u0442'
});

var UNIT_TOOLTIP_DATA_LABELS = exports.UNIT_TOOLTIP_DATA_LABELS = {
    commander: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battle_rooms.unit_tooltip.commander',
        defaultMessage: '\u041A\u043E\u043C\u0430\u043D\u0434\u0438\u0440 \u043E\u0442\u0440\u044F\u0434\u0430'
    }),
    battles: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battle_rooms.unit_tooltip.battles',
        defaultMessage: '\u0411\u043E\u0438 \u0432 \u044D\u0442\u043E\u043C \u0440\u0435\u0436\u0438\u043Ce'
    }),
    wins: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battle_rooms.unit_tooltip.wins',
        defaultMessage: '\u041F\u043E\u0431\u0435\u0434\u044B'
    })
};

var UNIT_TOOLTIP_BATTLE_MODE = exports.UNIT_TOOLTIP_BATTLE_MODE = (_UNIT_TOOLTIP_BATTLE_ = {}, _defineProperty(_UNIT_TOOLTIP_BATTLE_, _constants.UNIT_TYPES.SORTIE, function (level) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battle_rooms.unit_tooltip.sortie_mode',
        defaultMessage: '\u0412\u044B\u043B\u0430\u0437\u043A\u0430 \u0432 {level} \u0434\u0438\u0432\u0438\u0437\u0438\u043E\u043D\u0435',
        values: { level: level }
    });
}), _defineProperty(_UNIT_TOOLTIP_BATTLE_, _constants.UNIT_TYPES.FORT_BATTLE, function () {
    return _i18n.FORT_BATTLE;
}), _UNIT_TOOLTIP_BATTLE_);

/***/ }),
/* 430 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"UnitTooltip_root--1SXRa","root__show":"UnitTooltip_root__show--1RA65","rootShow":"UnitTooltip_root__show--1RA65","body":"UnitTooltip_body--1Gikk","wrapper":"UnitTooltip_wrapper--2pPCp","content":"UnitTooltip_content--2gK8O","title":"UnitTooltip_title--F1ygk","subtitle":"UnitTooltip_subtitle--du43E","message":"UnitTooltip_message--1yYLG","warning":"UnitTooltip_warning--28bhv","divider":"UnitTooltip_divider--4aEN_","highlight":"UnitTooltip_highlight--3WKq0","ribbon":"UnitTooltip_ribbon--2KB89","statusMessage":"UnitTooltip_statusMessage--1X-kn","statusMessage__positive":"UnitTooltip_statusMessage__positive--1DIrj","statusMessagePositive":"UnitTooltip_statusMessage__positive--1DIrj","status":"UnitTooltip_status--1LUcD","statusMessage__negative":"UnitTooltip_statusMessage__negative--30p5T","statusMessageNegative":"UnitTooltip_statusMessage__negative--30p5T","statusMessage__noPermission":"UnitTooltip_statusMessage__noPermission--2pqyb","statusMessageNoPermission":"UnitTooltip_statusMessage__noPermission--2pqyb","status__positive":"UnitTooltip_status__positive--3SlCA","statusPositive":"UnitTooltip_status__positive--3SlCA","status__negative":"UnitTooltip_status__negative--r727z","statusNegative":"UnitTooltip_status__negative--r727z","statusText":"UnitTooltip_statusText--16KnY","base":"UnitTooltip_base--11a8l","commander":"UnitTooltip_commander--2cZGK","status__inBattle":"UnitTooltip_status__inBattle--2W67R","statusInBattle":"UnitTooltip_status__inBattle--2W67R","status__highlighted":"UnitTooltip_status__highlighted--34Na5","statusHighlighted":"UnitTooltip_status__highlighted--34Na5"};

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BATTLE_ROOMS_UNIT_TOOLTIP_ID = exports.UNITS_LIST_OTHERS_CLANS_SUBTITLE = exports.UNITS_LIST_VISIBLE_ITEMS = exports.UNITS_LIST_ITEM_HEIGHT = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UNITS_LIST_ITEM_HEIGHT = exports.UNITS_LIST_ITEM_HEIGHT = 50;
var UNITS_LIST_VISIBLE_ITEMS = exports.UNITS_LIST_VISIBLE_ITEMS = 8;

var UNITS_LIST_OTHERS_CLANS_SUBTITLE = exports.UNITS_LIST_OTHERS_CLANS_SUBTITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'units_list.others_clans_subtitle',
    defaultMessage: '\u041E\u0442\u0440\u044F\u0434\u044B \u0434\u0440\u0443\u0433\u0438\u0445 \u043A\u043B\u0430\u043D\u043E\u0432'
});

var BATTLE_ROOMS_UNIT_TOOLTIP_ID = exports.BATTLE_ROOMS_UNIT_TOOLTIP_ID = 'UNIT_TOOLTIP_ID';

/***/ }),
/* 432 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"IndustrialResourceCoefTooltip_root--3SRUI","root__show":"IndustrialResourceCoefTooltip_root__show--mj4jW","rootShow":"IndustrialResourceCoefTooltip_root__show--mj4jW","body":"IndustrialResourceCoefTooltip_body--1LcgA","wrapper":"IndustrialResourceCoefTooltip_wrapper--2XX_b","content":"IndustrialResourceCoefTooltip_content--28Fsm","title":"IndustrialResourceCoefTooltip_title--1NfVU","subtitle":"IndustrialResourceCoefTooltip_subtitle--15wO0","message":"IndustrialResourceCoefTooltip_message--2JwiE","warning":"IndustrialResourceCoefTooltip_warning--3gNF8","divider":"IndustrialResourceCoefTooltip_divider--3AN_p","highlight":"IndustrialResourceCoefTooltip_highlight--zKQaN","ribbon":"IndustrialResourceCoefTooltip_ribbon--YltMy","statusMessage":"IndustrialResourceCoefTooltip_statusMessage--a4wyw","statusMessage__positive":"IndustrialResourceCoefTooltip_statusMessage__positive--28rB2","statusMessagePositive":"IndustrialResourceCoefTooltip_statusMessage__positive--28rB2","status":"IndustrialResourceCoefTooltip_status--3iOOF","statusMessage__negative":"IndustrialResourceCoefTooltip_statusMessage__negative--2FROP","statusMessageNegative":"IndustrialResourceCoefTooltip_statusMessage__negative--2FROP","statusMessage__noPermission":"IndustrialResourceCoefTooltip_statusMessage__noPermission--24ewl","statusMessageNoPermission":"IndustrialResourceCoefTooltip_statusMessage__noPermission--24ewl","status__positive":"IndustrialResourceCoefTooltip_status__positive--3m1RG","statusPositive":"IndustrialResourceCoefTooltip_status__positive--3m1RG","status__negative":"IndustrialResourceCoefTooltip_status__negative--2TwXK","statusNegative":"IndustrialResourceCoefTooltip_status__negative--2TwXK","statusText":"IndustrialResourceCoefTooltip_statusText--q1j3B"};

/***/ }),
/* 433 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tooltip-root":"BattleRoomsWrapper_tooltip-root--XGe6p","tooltipRoot":"BattleRoomsWrapper_tooltip-root--XGe6p","tooltip-root__show":"BattleRoomsWrapper_tooltip-root__show--3gCSY","tooltipRootShow":"BattleRoomsWrapper_tooltip-root__show--3gCSY","tooltip-body":"BattleRoomsWrapper_tooltip-body--nCI7p","tooltipBody":"BattleRoomsWrapper_tooltip-body--nCI7p","tooltip-wrapper":"BattleRoomsWrapper_tooltip-wrapper--3eI6q","tooltipWrapper":"BattleRoomsWrapper_tooltip-wrapper--3eI6q","tooltip-content":"BattleRoomsWrapper_tooltip-content--2HR7Y","tooltipContent":"BattleRoomsWrapper_tooltip-content--2HR7Y","tooltip-title":"BattleRoomsWrapper_tooltip-title--YRX3s","tooltipTitle":"BattleRoomsWrapper_tooltip-title--YRX3s","tooltip-subtitle":"BattleRoomsWrapper_tooltip-subtitle--1Gw3E","tooltipSubtitle":"BattleRoomsWrapper_tooltip-subtitle--1Gw3E","tooltip-message":"BattleRoomsWrapper_tooltip-message--19GHs","tooltipMessage":"BattleRoomsWrapper_tooltip-message--19GHs","tooltip-warning":"BattleRoomsWrapper_tooltip-warning--ZJVIR","tooltipWarning":"BattleRoomsWrapper_tooltip-warning--ZJVIR","tooltip-divider":"BattleRoomsWrapper_tooltip-divider--2o_DO","tooltipDivider":"BattleRoomsWrapper_tooltip-divider--2o_DO","tooltip-highlight":"BattleRoomsWrapper_tooltip-highlight--7I0lI","tooltipHighlight":"BattleRoomsWrapper_tooltip-highlight--7I0lI","tooltip-ribbon":"BattleRoomsWrapper_tooltip-ribbon--2DhVK","tooltipRibbon":"BattleRoomsWrapper_tooltip-ribbon--2DhVK","tooltip-statusMessage":"BattleRoomsWrapper_tooltip-statusMessage--YsyPN","tooltipStatusMessage":"BattleRoomsWrapper_tooltip-statusMessage--YsyPN","tooltip-statusMessage__positive":"BattleRoomsWrapper_tooltip-statusMessage__positive--2-fQw","tooltipStatusMessagePositive":"BattleRoomsWrapper_tooltip-statusMessage__positive--2-fQw","tooltip-status":"BattleRoomsWrapper_tooltip-status--wdUHJ","tooltipStatus":"BattleRoomsWrapper_tooltip-status--wdUHJ","tooltip-statusMessage__negative":"BattleRoomsWrapper_tooltip-statusMessage__negative--Vj2Zc","tooltipStatusMessageNegative":"BattleRoomsWrapper_tooltip-statusMessage__negative--Vj2Zc","tooltip-statusMessage__noPermission":"BattleRoomsWrapper_tooltip-statusMessage__noPermission--ONVk2","tooltipStatusMessageNoPermission":"BattleRoomsWrapper_tooltip-statusMessage__noPermission--ONVk2","tooltip-status__positive":"BattleRoomsWrapper_tooltip-status__positive--1zgy_","tooltipStatusPositive":"BattleRoomsWrapper_tooltip-status__positive--1zgy_","tooltip-status__negative":"BattleRoomsWrapper_tooltip-status__negative--qjxw4","tooltipStatusNegative":"BattleRoomsWrapper_tooltip-status__negative--qjxw4","tooltip-statusText":"BattleRoomsWrapper_tooltip-statusText--2jI9W","tooltipStatusText":"BattleRoomsWrapper_tooltip-statusText--2jI9W","base":"BattleRoomsWrapper_base--Jcuh2","header":"BattleRoomsWrapper_header--3PLMV","base__cn":"BattleRoomsWrapper_base__cn--107rI","baseCn":"BattleRoomsWrapper_base__cn--107rI","createUnit":"BattleRoomsWrapper_createUnit--1uM29","holder":"BattleRoomsWrapper_holder--3fM5m","tabs":"BattleRoomsWrapper_tabs--39VzH","multiplier":"BattleRoomsWrapper_multiplier--3aBBV","multiplierValue":"BattleRoomsWrapper_multiplierValue--2wWdK"};

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapStateToProps = undefined;

var _reactRedux = __webpack_require__(7);

var _available_units = __webpack_require__(50);

var _constants = __webpack_require__(4);

var _BattleModeFilter = __webpack_require__(138);

var _helpers = __webpack_require__(200);

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(_ref) {
    var availableUnits = _ref.availableUnits;
    return {
        tab: _constants.BATTLE_ROOMS_TAB_STATES.UNITS,
        selectedUnitType: availableUnits.filter.unitType,
        selectedVehicleLevel: availableUnits.filter.level,

        battleModesSettings: (0, _helpers.sortBattleModeSettings)(availableUnits.meta.battle_modes_settings)
    };
}; /**
    * implementation of <BattleModeFilter /> for battle rooms list
    * @see https://confluence.wargaming.net/display/WEBDEV/%5BLeg%5D+UI+Legionaries+draft
    */

var mapDispatchToProps = {
    onChange: function onChange(unit_type, vehicle_level) {
        return (0, _available_units.filterUnitsByLevelAndUnitType)(unit_type, vehicle_level);
    }
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_BattleModeFilter.BattleModeFilter);

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.checkEnabledBattles = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.getLastHour = getLastHour;
exports.getFlatPrimetimes = getFlatPrimetimes;
exports.getCurrentPlayday = getCurrentPlayday;

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

var _schedule = __webpack_require__(27);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function getLastHour(scheduleItems, unitType, vehicleLevel) {
    var periods = getFlatPrimetimes(scheduleItems, unitType, vehicleLevel);

    return Math.max.apply(Math, _toConsumableArray(periods.map(function (period) {
        return period[1];
    })));
}

function getFlatPrimetimes(scheduleItems, unitType, vehicleLevel) {
    var selectedScheduleItem = scheduleItems.find(function (item) {
        return item.type === unitType && (!vehicleLevel || item.vehicle_level === vehicleLevel);
    });

    if (!selectedScheduleItem) return [];

    return selectedScheduleItem.schedules.filter(function (periphery) {
        return periphery.enabled === true;
    }).map(function (per) {
        return per.periods;
    }).reduce(function (flatList, primeItem) {
        return flatList.concat(primeItem);
    }, []);
}

var checkEnabledBattles = exports.checkEnabledBattles = function checkEnabledBattles(scheduleItems, unitType, vehicleLevel) {
    return scheduleItems.filter(function (item) {
        return (0, _schedule.vehicleLevelFilter)(item, vehicleLevel);
    }).filter(function (item) {
        return item.schedules.some(function (schedule) {
            return schedule.enabled && schedule.periods.length;
        });
    }).some(function (item) {
        return (0, _schedule.checkScheduleType)(item, unitType);
    });
};

function getCurrentPlayday(playdays, vehicleLevel, unitType) {
    var unitTypes = unitType ? [unitType] : [_constants.UNIT_TYPES.SORTIE, _constants.UNIT_TYPES.FORT_BATTLE];

    var _playdays = _slicedToArray(playdays, 2),
        today = _playdays[0],
        tomorrow = _playdays[1];

    var isInsidePlayday = unitTypes.map(function (unitType) {
        return getLastHour(today.schedule_items, unitType, vehicleLevel);
    }).some(function (lastPrimetimeHour) {
        return (0, _schedule.checkTimeInsidePlayday)((0, _moment2.default)(), today.date, 0, lastPrimetimeHour + 1);
    });

    var isBattlesAvailableToday = unitTypes.some(function (unitType) {
        return checkEnabledBattles(today.schedule_items, unitType, vehicleLevel);
    });

    if (isInsidePlayday && isBattlesAvailableToday) {
        return today;
    }

    var isBattlesAvailableTomorrow = unitTypes.some(function (unitType) {
        return checkEnabledBattles(tomorrow.schedule_items, unitType, vehicleLevel);
    });

    if (isBattlesAvailableTomorrow) {
        return tomorrow;
    }

    return null;
}

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

var _constants = __webpack_require__(4);

var _helpers = __webpack_require__(437);

var _BattlesNotHeldMessage = __webpack_require__(439);

var _BattlesNotHeldMessage2 = _interopRequireDefault(_BattlesNotHeldMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BattlesNotHeldMessage = function BattlesNotHeldMessage(props) {
    var playdayEnd = props.playdayEnd,
        playdays = props.playdays,
        playdayStart = props.playdayStart,
        unitType = props.unitType,
        vehicleLevel = props.vehicleLevel;

    var currentHour = _moment2.default.utc().hour();

    var notHeldMessage = (0, _helpers.getBattlesNotHeldMessage)(unitType, vehicleLevel);
    var nextBattleMessage = (0, _helpers.getNextBattleMessage)(playdays, playdayStart, playdayEnd, unitType, currentHour);
    return _react2.default.createElement(
        'span',
        { className: _BattlesNotHeldMessage2.default.base },
        notHeldMessage,
        '\xA0',
        _react2.default.createElement(
            'span',
            { className: _BattlesNotHeldMessage2.default.highlightedText },
            nextBattleMessage
        )
    );
};

BattlesNotHeldMessage.propTypes = {
    playdayEnd: _propTypes2.default.number,
    playdays: _propTypes2.default.array,
    playdayStart: _propTypes2.default.number,
    unitType: _propTypes2.default.oneOf(Object.values(_constants.UNIT_TYPES)),
    vehicleLevel: _propTypes2.default.number
};

exports.default = BattlesNotHeldMessage;

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getBattlesNotHeldMessage = undefined;
exports.getNextBattleMessage = getNextBattleMessage;

var _datetime = __webpack_require__(13);

var _i18n = __webpack_require__(10);

var _helpers = __webpack_require__(11);

var _constants = __webpack_require__(4);

var _translations = __webpack_require__(438);

var _schedule = __webpack_require__(27);

// todo: refactor, merge with Schedule/components/NoBattlesMessage/helpers
function getNextBattleMessage(playdays, playdayStart, playdayEnd, unitType, currentHour) {
    var closestPrimetimeStart = (0, _schedule.getClosestPrimetimeStart)(playdays, playdayStart, playdayEnd, unitType, currentHour);

    if (!closestPrimetimeStart) return null;
    if ((0, _datetime.isTodayDay)(closestPrimetimeStart.local())) {
        return (0, _datetime.getTodayTime)(closestPrimetimeStart);
    }
    if ((0, _datetime.isTomorrowDay)(closestPrimetimeStart.local())) {
        return (0, _datetime.getTomorrowTime)(closestPrimetimeStart);
    }
    return (0, _datetime.getCustomDateTime)(closestPrimetimeStart);
}

var getBattlesNotHeldMessage = exports.getBattlesNotHeldMessage = function getBattlesNotHeldMessage(battleType, vehicleLevel) {
    if (battleType === _constants.UNIT_TYPES.SORTIE) {
        return (0, _translations.NOT_HELD_WITH_NEXT)((0, _i18n.SORTIES_WITH_LEVEL)((0, _helpers.toRoman)(vehicleLevel)));
    }

    if (battleType === _constants.UNIT_TYPES.FORT_BATTLE) {
        return (0, _translations.NOT_HELD_WITH_NEXT)(_i18n.FORT_BATTLES);
    }

    return _translations.COMING;
};

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.COMING = exports.NOT_HELD = exports.NOT_HELD_WITH_NEXT = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-multi-comp */
var NOT_HELD_WITH_NEXT = exports.NOT_HELD_WITH_NEXT = function NOT_HELD_WITH_NEXT(battleType) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'schedule.not_held_text',
        defaultMessage: '{battleType} \u043D\u0435 \u043F\u0440\u043E\u0432\u043E\u0434\u044F\u0442\u0441\u044F, \u0431\u043B\u0438\u0436\u0430\u0439\u0448\u0438\u0435:',
        values: { battleType: battleType }
    });
};

var NOT_HELD = exports.NOT_HELD = function NOT_HELD(battleType) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'schedule.not_held',
        defaultMessage: '{battleType} \u043D\u0435 \u043F\u0440\u043E\u0432\u043E\u0434\u044F\u0442\u0441\u044F.',
        values: { battleType: battleType }
    });
};

var COMING = exports.COMING = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'players_matching.NEXT_BATTLES',
    defaultMessage: '\u0411\u043B\u0438\u0436\u0430\u0439\u0448\u0438\u0435:'
});

/***/ }),
/* 439 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"BattlesNotHeldMessage_base--jdA8H","highlightedText":"BattlesNotHeldMessage_highlightedText--sryyB"};

/***/ }),
/* 440 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"BattleRoomsSchedule_base--2GGvb","isAllModes":"BattleRoomsSchedule_isAllModes--2Pb4k","title":"BattleRoomsSchedule_title--uWG45","scheduleWrapper":"BattleRoomsSchedule_scheduleWrapper--1ct6F","scheduleTime":"BattleRoomsSchedule_scheduleTime--3Ew-h"};

/***/ }),
/* 441 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"body":"UnitsView_body--1FU54","main":"UnitsView_main--2T56Q","main__fullWidth":"UnitsView_main__fullWidth--3_9ka","mainFullWidth":"UnitsView_main__fullWidth--3_9ka","view":"UnitsView_view--ARkO2","view__empty":"UnitsView_view__empty--3-P5M","viewEmpty":"UnitsView_view__empty--3-P5M","inactive":"UnitsView_inactive--1LtGe","filters":"UnitsView_filters--tndhw","subtitle":"UnitsView_subtitle--3b0yW","list":"UnitsView_list--1yDUA","updateButton":"UnitsView_updateButton--25Uis","unitCheckboxFilter":"UnitsView_unitCheckboxFilter--1nCd3","battleRoomsScheduleWrapper":"UnitsView_battleRoomsScheduleWrapper--YK1QE"};

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = exports.PlayersMatchingView = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(7);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactWotBootstrap = __webpack_require__(5);

var _players_matching = __webpack_require__(36);

var _clan_units = __webpack_require__(105);

var _clan_units2 = __webpack_require__(207);

var _clan_units3 = _interopRequireDefault(_clan_units2);

var _reactivity = __webpack_require__(67);

var _helpers = __webpack_require__(11);

var _constants = __webpack_require__(4);

var _DefaultTooltip = __webpack_require__(30);

var _DefaultTooltip2 = _interopRequireDefault(_DefaultTooltip);

var _VehicleFilter = __webpack_require__(443);

var _VehicleFilter2 = _interopRequireDefault(_VehicleFilter);

var _PlayersMatchingBattleModeFilter = __webpack_require__(457);

var _PlayersMatchingBattleModeFilter2 = _interopRequireDefault(_PlayersMatchingBattleModeFilter);

var _BattleRoomsWrapper = __webpack_require__(215);

var _BattleRoomsWrapper2 = _interopRequireDefault(_BattleRoomsWrapper);

var _BattleRoomsSchedule = __webpack_require__(140);

var _BattleRoomsSchedule2 = _interopRequireDefault(_BattleRoomsSchedule);

var _PlayersMatchingButton = __webpack_require__(458);

var _PlayersMatchingButton2 = _interopRequireDefault(_PlayersMatchingButton);

var _VehiclesCarousel = __webpack_require__(461);

var _VehiclesCarousel2 = _interopRequireDefault(_VehiclesCarousel);

var _NoVehicles = __webpack_require__(466);

var _NoVehicles2 = _interopRequireDefault(_NoVehicles);

var _UnitsCarousel = __webpack_require__(469);

var _UnitsCarousel2 = _interopRequireDefault(_UnitsCarousel);

var _WaitingPopover = __webpack_require__(473);

var _WaitingPopover2 = _interopRequireDefault(_WaitingPopover);

var _i18n = __webpack_require__(10);

var _constants2 = __webpack_require__(38);

var _translations = __webpack_require__(476);

var _propTypes3 = __webpack_require__(32);

var _translations2 = __webpack_require__(224);

var _LoadingScreen = __webpack_require__(29);

var _LoadingScreen2 = _interopRequireDefault(_LoadingScreen);

var _PlayersMatchingView = __webpack_require__(227);

var _PlayersMatchingView2 = _interopRequireDefault(_PlayersMatchingView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var INVENTORY_REQUEST_INTERVAL = 3000;

var PlayersMatchingView = exports.PlayersMatchingView = function (_React$Component) {
    _inherits(PlayersMatchingView, _React$Component);

    function PlayersMatchingView(props) {
        _classCallCheck(this, PlayersMatchingView);

        var _this = _possibleConstructorReturn(this, (PlayersMatchingView.__proto__ || Object.getPrototypeOf(PlayersMatchingView)).call(this, props));

        _this.updateChannel(props.reactiveUpdateUrl);

        _this.selectVehicles = _this.selectVehicles.bind(_this);
        _this.state = { hoveredUnitId: null };
        return _this;
    }

    _createClass(PlayersMatchingView, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _this2 = this;

            Promise.all([this.requestVehicles(), this.props.requestClanUnits(!this.props.isUnitsLoaded)]).then(function () {
                return _this2.props.selectDefaultVehicles();
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.updateChannel(null);

            clearTimeout(this.requestInventoryTimer);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.props.reactiveUpdateUrl !== nextProps.reactiveUpdateUrl) {
                this.updateChannel(nextProps.reactiveUpdateUrl);
            }

            if (nextProps.shouldLoadUnits) {
                this.props.requestClanUnits();
            }
        }

        // we request full vehicles data and then poll only status

    }, {
        key: 'requestVehicles',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.props.requestVehicles();

                            case 2:

                                this.updateVehicles();

                            case 3:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function requestVehicles() {
                return _ref.apply(this, arguments);
            }

            return requestVehicles;
        }()
    }, {
        key: 'updateVehicles',
        value: function updateVehicles() {
            var _this3 = this;

            this.props.updateVehiclesReadiness();

            this.requestInventoryTimer = setTimeout(function () {
                return _this3.updateVehicles();
            }, INVENTORY_REQUEST_INTERVAL);
        }
    }, {
        key: 'updateChannel',
        value: function updateChannel(url) {
            if (this.channel) {
                this.channel.disconnect();
            }
            if (url) {
                this.channel = new _clan_units3.default(url);
            }
        }
    }, {
        key: 'renderOwnClanUnitsSection',
        value: function renderOwnClanUnitsSection() {
            if (!this.props.isClanMember) return null;

            if (!this.props.units || !this.props.units.length) {
                return _react2.default.createElement(
                    'div',
                    { className: _PlayersMatchingView2.default.ownClanUnitsHolder },
                    _react2.default.createElement(
                        'p',
                        { className: _PlayersMatchingView2.default.noOwnClanUnits },
                        _translations.NO_OWN_CLAN_UNITS
                    )
                );
            }
            var units = [].concat(_toConsumableArray(this.props.units)).sort(function (firstUnit, secondUnit) {
                return secondUnit.created_at - firstUnit.created_at;
            });
            return _react2.default.createElement(
                'div',
                { className: _PlayersMatchingView2.default.ownClanUnitsHolder },
                _react2.default.createElement(
                    'h2',
                    { className: _PlayersMatchingView2.default.title },
                    (0, _translations.OWN_CLAN_UNITS)(units.length)
                ),
                _react2.default.createElement(_UnitsCarousel2.default, { units: units })
            );
        }
    }, {
        key: 'selectVehicles',
        value: function selectVehicles(vehicle_cds, filter) {
            this.props.setSelectedVehicles(vehicle_cds, filter);
        }
    }, {
        key: 'renderBattleModeTabContent',
        value: function renderBattleModeTabContent() {
            var _this4 = this;

            if (this.props.enabledDuringChallenges) {
                var battleModeName = (0, _i18n.SORTIES_WITH_LEVEL)((0, _helpers.toRoman)(this.props.vehicleLevel));
                return _react2.default.createElement(
                    'section',
                    { className: _PlayersMatchingView2.default.main },
                    _react2.default.createElement(
                        'div',
                        { className: _PlayersMatchingView2.default.availableDuringChallenges },
                        (0, _translations.AVAILABLE_DURING_CHALLENGES)(battleModeName),
                        _translations.FIND_UNITS_IN_UNITS_LIST,
                        _react2.default.createElement(
                            'div',
                            { className: _PlayersMatchingView2.default.battleRoomsButton },
                            _react2.default.createElement(
                                _reactWotBootstrap.ButtonSmall,
                                {
                                    type: 'secondary',
                                    onClick: this.props.openUnitsList
                                },
                                _constants2.BATTLE_ROOMS_UNITS_LIST_BUTTON
                            )
                        )
                    )
                );
            }

            if (this.props.showSchedule) {
                return _react2.default.createElement(
                    'section',
                    { className: _PlayersMatchingView2.default.main },
                    _react2.default.createElement(_BattleRoomsSchedule2.default, {
                        unitType: _constants.UNIT_TYPES.SORTIE,
                        vehicleLevel: this.props.vehicleLevel
                    })
                );
            }

            if (this.props.availableVehiclesCount === 0) {
                return _react2.default.createElement(
                    'section',
                    { className: _PlayersMatchingView2.default.main },
                    _react2.default.createElement(_NoVehicles2.default, { level: this.props.vehicleLevel }),
                    _react2.default.createElement(
                        'div',
                        { className: _PlayersMatchingView2.default.submitButton },
                        _react2.default.createElement(_PlayersMatchingButton2.default, null)
                    )
                );
            }

            var isAnyVehicleSelected = this.props.selectedVehicles.length > 0;

            var selectedVehiclesCounter = _react2.default.createElement(
                'div',
                { className: _PlayersMatchingView2.default.selectedVehiclesCounter },
                (0, _translations.SELECTED_VEHICLES_COUNT)(this.props.selectedVehicles.length, this.props.availableVehiclesCount)
            );

            var resetSelectedVehiclesButton = null;
            if (this.props.selectedVehicles.length !== this.props.availableVehiclesCount) {
                resetSelectedVehiclesButton = _react2.default.createElement('button', {
                    className: _PlayersMatchingView2.default.resetSelectedVehiclesButton,
                    onClick: function onClick() {
                        return _this4.props.selectDefaultVehicles(true);
                    },
                    onMouseDown: _reactWotBootstrap.sendClickSoundCommand,
                    onMouseEnter: _reactWotBootstrap.sendHoverSoundCommand,
                    'data-tip': true, 'data-for': _translations.RESET_SELECTED_VEHICLES_TOOLTIP.id
                });
            }

            return _react2.default.createElement(
                'section',
                { className: _PlayersMatchingView2.default.main },
                _react2.default.createElement(
                    'div',
                    { className: _PlayersMatchingView2.default.vehiclesFilter },
                    _react2.default.createElement(_VehicleFilter2.default, { onSelect: this.selectVehicles }),
                    selectedVehiclesCounter,
                    resetSelectedVehiclesButton,
                    _react2.default.createElement(_DefaultTooltip2.default, _translations.RESET_SELECTED_VEHICLES_TOOLTIP)
                ),
                isAnyVehicleSelected ? _react2.default.createElement(_VehiclesCarousel2.default, null) : _react2.default.createElement(
                    'span',
                    { className: _PlayersMatchingView2.default.vehiclesNotSelectedMessage },
                    _translations2.VEHICLES_NOT_SELECTED
                ),
                _react2.default.createElement(
                    'div',
                    { className: _PlayersMatchingView2.default.submitButton },
                    _react2.default.createElement(_PlayersMatchingButton2.default, null)
                ),
                this.props.playersMatchingInProgress && _react2.default.createElement(_WaitingPopover2.default, null)
            );
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.props.showLoader) {
                return _react2.default.createElement(_LoadingScreen2.default, { type: 'fullscreen' });
            }

            var mainContent = this.renderBattleModeTabContent();

            var body = null;
            if (this.props.isClanMember) {
                body = _react2.default.createElement(
                    'div',
                    { className: _PlayersMatchingView2.default.base },
                    this.renderOwnClanUnitsSection(),
                    _react2.default.createElement(
                        'h2',
                        { className: _PlayersMatchingView2.default.title },
                        _translations.JOIN_RANDOM_UNIT_AS_LEGIONARY,
                        _react2.default.createElement(
                            'span',
                            { className: _PlayersMatchingView2.default.infoIcon },
                            _react2.default.createElement(_reactWotBootstrap.Info, { tooltipId: _translations.INFO_TOOLTIP.id })
                        ),
                        _react2.default.createElement(_DefaultTooltip2.default, _translations.INFO_TOOLTIP)
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _PlayersMatchingView2.default.battleModeTabs },
                        _react2.default.createElement(_PlayersMatchingBattleModeFilter2.default, null)
                    ),
                    mainContent
                );
            } else {
                var baseClassName = (0, _classnames2.default)(_PlayersMatchingView2.default.base, _PlayersMatchingView2.default.base__nonClanMember);
                body = _react2.default.createElement(
                    'div',
                    { className: baseClassName },
                    _react2.default.createElement(
                        'div',
                        { className: _PlayersMatchingView2.default.header },
                        _react2.default.createElement(
                            'div',
                            { className: _PlayersMatchingView2.default.battleModeTabs },
                            _react2.default.createElement(_PlayersMatchingBattleModeFilter2.default, null)
                        ),
                        _translations.INFO_FOR_LEGIONARY,
                        _react2.default.createElement(
                            'span',
                            { className: _PlayersMatchingView2.default.infoIcon },
                            _react2.default.createElement(_reactWotBootstrap.Info, { tooltipId: _translations.INFO_TOOLTIP.id })
                        ),
                        _react2.default.createElement(_DefaultTooltip2.default, _translations.INFO_TOOLTIP)
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _PlayersMatchingView2.default.wrapper },
                        mainContent
                    )
                );
            }

            return _react2.default.createElement(
                _BattleRoomsWrapper2.default,
                null,
                body
            );
        }
    }]);

    return PlayersMatchingView;
}(_react2.default.Component);

PlayersMatchingView.propTypes = {
    showSchedule: _propTypes2.default.bool,

    availableVehiclesCount: _propTypes2.default.number.isRequired,
    enabledDuringChallenges: _propTypes2.default.bool,
    isClanMember: _propTypes2.default.bool.isRequired,
    isUnitsLoaded: _propTypes2.default.bool.isRequired,
    playersMatchingInProgress: _propTypes2.default.bool.isRequired,
    reactiveUpdateUrl: _propTypes2.default.string,
    selectedVehicles: _propTypes2.default.arrayOf(_propTypes3.VehiclePropTypes),
    shouldLoadUnits: _propTypes2.default.bool,
    showLoader: _propTypes2.default.bool.isRequired,
    units: _propTypes2.default.arrayOf(_propTypes3.UnitDataPropTypes).isRequired,
    vehicleLevel: _propTypes2.default.number.isRequired,

    requestClanUnits: _propTypes2.default.func.isRequired,
    requestVehicles: _propTypes2.default.func.isRequired,
    selectDefaultVehicles: _propTypes2.default.func.isRequired,
    setSelectedVehicles: _propTypes2.default.func.isRequired,
    updateVehiclesReadiness: _propTypes2.default.func.isRequired,
    openUnitsList: _propTypes2.default.func.isRequired
};
PlayersMatchingView.defaultProps = {
    selectedVehicles: []
};
var mapStateToProps = exports.mapStateToProps = function mapStateToProps(_ref2) {
    var clan = _ref2.clan,
        clanUnits = _ref2.clanUnits,
        players_matching = _ref2.players_matching,
        settings = _ref2.settings;

    var showLoader = clanUnits.showLoader || players_matching.loading || !players_matching.selected_vehicle_cds;
    var clanUnitsChannelUrl = clan.units_channel;
    var reactiveUpdateUrl = (0, _reactivity.getReactiveUpdateUrl)(settings.pushStreamHost, clanUnitsChannelUrl);
    var selected_vehicle_cds = players_matching.selected_vehicle_cds;


    var selectedVehicles = selected_vehicle_cds ? players_matching.vehicles.filter(function (vehicle) {
        return selected_vehicle_cds.includes(vehicle.id);
    }) : players_matching.vehicles;

    var vehiclesBySelectedLevel = players_matching.vehicles.filter(function (vehicle) {
        return vehicle.level === players_matching.vehicle_level;
    });

    var playersMatchingSettings = players_matching.sortie_settings.find(function (setting) {
        return setting.level === players_matching.vehicle_level;
    });

    return {
        availableVehiclesCount: vehiclesBySelectedLevel.length,
        enabledDuringChallenges: playersMatchingSettings && playersMatchingSettings.show_challenges_message,
        isClanMember: clan.id !== null,
        isUnitsLoaded: clanUnits.loaded,
        playersMatchingInProgress: players_matching.start_time !== null,
        reactiveUpdateUrl: reactiveUpdateUrl,
        selectedVehicles: selectedVehicles,
        shouldLoadUnits: !clanUnits.loaded && !clanUnits.loading,
        showLoader: showLoader,
        units: clanUnits.units,
        vehicleLevel: players_matching.vehicle_level
    };
};

var mapDispatchToProps = exports.mapDispatchToProps = {
    requestClanUnits: _clan_units.requestClanUnits,
    requestVehicles: _players_matching.requestVehicles,
    selectDefaultVehicles: _players_matching.selectDefaultVehicles,
    setSelectedVehicles: _players_matching.setSelectedVehicles,
    openUnitsList: _players_matching.disablePlayerMatching,
    updateVehiclesReadiness: _players_matching.updateVehiclesReadiness
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PlayersMatchingView);

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = exports.VehicleFilter = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = __webpack_require__(7);

var _union = __webpack_require__(444);

var _union2 = _interopRequireDefault(_union);

var _reactWotBootstrap = __webpack_require__(5);

var _DefaultTooltip = __webpack_require__(30);

var _DefaultTooltip2 = _interopRequireDefault(_DefaultTooltip);

var _Nation = __webpack_require__(141);

var _Nation2 = _interopRequireDefault(_Nation);

var _VehicleFilterSelect = __webpack_require__(448);

var _VehicleFilterSelect2 = _interopRequireDefault(_VehicleFilterSelect);

var _VehiclesTable = __webpack_require__(450);

var _VehiclesTable2 = _interopRequireDefault(_VehiclesTable);

var _VehicleType = __webpack_require__(68);

var _VehicleType2 = _interopRequireDefault(_VehicleType);

var _i18n = __webpack_require__(10);

var _vehicles = __webpack_require__(91);

var _players_matching = __webpack_require__(36);

var _constants = __webpack_require__(4);

var _constants2 = __webpack_require__(455);

var _VehicleFilter = __webpack_require__(456);

var _VehicleFilter2 = _interopRequireDefault(_VehicleFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VehicleFilter = exports.VehicleFilter = function (_React$PureComponent) {
    _inherits(VehicleFilter, _React$PureComponent);

    function VehicleFilter(props) {
        _classCallCheck(this, VehicleFilter);

        var _this = _possibleConstructorReturn(this, (VehicleFilter.__proto__ || Object.getPrototypeOf(VehicleFilter)).call(this, props));

        _this.onKeyDown = function (event) {
            // todo: remove it after WCC-202
            if (event.keyCode === _constants.KEY_CODES.ESCAPE && _this.state.opened) {
                _this.hide();
            }
        };

        _this.beforeHide = function () {
            return _this.reset();
        };

        _this.changeNation = function (value) {
            var filter = _extends({}, _this.state.filter, { nation: value });
            _this.setState(function () {
                return {
                    filter: filter
                };
            });
        };

        _this.toggleFavorite = function () {
            var filter = _extends({}, _this.state.filter, { onlyFavorite: !_this.state.filter.onlyFavorite });
            _this.setState({
                filter: filter
            });
        };

        _this.updateSelectedVehiclesCds = function (selectedVehicleCds) {
            return _this.setState({ selectedVehicleCds: selectedVehicleCds });
        };

        _this.getSortedVehicles = function () {
            var _this$state = _this.state,
                filter = _this$state.filter,
                selectedVehicleCds = _this$state.selectedVehicleCds;

            var filteredVehicles = (0, _vehicles.filterVehicles)(_this.props.vehicles, filter);

            return (0, _vehicles.sortVehicles)(filteredVehicles, filter.sortColumn, _this.props.realm, filter.sortOrder === 'desc', selectedVehicleCds);
        };

        _this.state = {
            opened: false,
            filter: _extends({}, props.filter),
            selectedVehicleCds: props.selectedVehicleCds
        };

        _this.handleToggle = _this.toggle.bind(_this);
        _this.apply = _this.apply.bind(_this);
        _this.handleCancelClick = _this.hide.bind(_this);
        _this.handleHeaderClick = _this.handleHeaderClick.bind(_this);
        _this.handleNationChange = _this.changeNation.bind(_this);
        return _this;
    }

    _createClass(VehicleFilter, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.addEventListener('keydown', this.onKeyDown);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('keydown', this.onKeyDown);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            var _props = this.props,
                selectedVehicleCds = _props.selectedVehicleCds,
                filter = _props.filter;

            if (selectedVehicleCds !== prevProps.selectedVehicleCds || filter !== prevProps.filter) {
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({ selectedVehicleCds: selectedVehicleCds, filter: filter });
            }
        }
    }, {
        key: 'reset',
        value: function reset() {
            if (!this.state.opened) return;

            this.setState({
                filter: _extends({}, this.props.filter),
                opened: false,
                selectedVehicleCds: this.props.selectedVehicleCds
            });
            this.props.vehiclesFilterClose();
        }
    }, {
        key: 'toggle',
        value: function toggle(e) {
            this._popover.toggle(e.currentTarget);
            if (this.state.opened) {
                this.reset();
            } else {
                this.setState({ opened: true });
                this.props.vehiclesFilterOpen();
            }
        }
    }, {
        key: 'hide',
        value: function hide() {
            this._popover.hide();
            this.reset();
        }
    }, {
        key: 'apply',
        value: function apply() {
            this.hide();
            this.props.onSelect(this.state.selectedVehicleCds, this.state.filter);
        }
    }, {
        key: 'toggleVehicleType',
        value: function toggleVehicleType(value) {
            var vehicleTypes = [].concat(_toConsumableArray(this.state.filter.vehicleTypes));
            if (vehicleTypes.includes(value)) {
                vehicleTypes = vehicleTypes.filter(function (x) {
                    return x !== value;
                });
            } else {
                vehicleTypes.push(value);
            }
            var filter = _extends({}, this.state.filter, { vehicleTypes: vehicleTypes });
            this.setState({
                filter: filter
            });
        }
    }, {
        key: 'handleHeaderClick',
        value: function handleHeaderClick(column) {
            var sortOrder = this.state.filter.sortColumn === column ? this.state.filter.sortOrder === 'desc' ? 'asc' : 'desc' : 'desc';

            this.setState({
                filter: _extends({}, this.state.filter, {
                    sortColumn: column,
                    sortOrder: sortOrder
                })
            });
        }
    }, {
        key: 'getNationSelectOptions',
        value: function getNationSelectOptions() {
            var _this2 = this;

            var vehiclesNations = this.props.vehicles.map(function (vehicle) {
                return vehicle.nation;
            });
            var availableNations = [].concat(_toConsumableArray(new Set(vehiclesNations)));
            var realmNations = _constants.NATIONS_BY_REALM[this.props.realm];

            var otherNations = realmNations.filter(function (n) {
                return !availableNations.includes(n);
            });

            var nations = (0, _union2.default)(realmNations, otherNations);
            var nationSelectOptions = nations.map(function (item) {
                var value = item;
                var caption = _constants2.NATIONS_CAPTIONS[item];
                var icon = _react2.default.createElement(_Nation2.default, { nation: item, realm: _this2.props.realm });

                return {
                    value: value,
                    caption: caption,
                    icon: icon
                };
            });

            nationSelectOptions.unshift({
                value: 'all_nations',
                caption: _constants2.NATIONS_ALL_CAPTION,
                icon: _react2.default.createElement(_Nation2.default, { nation: 'all_nations' })
            });

            return nationSelectOptions;
        }
    }, {
        key: 'getVehicleTypesSelector',
        value: function getVehicleTypesSelector() {
            var _this3 = this;

            return _constants.VEHICLE_TYPES.map(function (type) {
                var icon = _react2.default.createElement(
                    'span',
                    { className: _VehicleFilter2.default.vehicleTypeFilterIcon },
                    _react2.default.createElement(_VehicleType2.default, { type: type, mini: true })
                );
                var isChecked = _this3.state.filter.vehicleTypes.includes(type);
                return _react2.default.createElement(
                    'span',
                    { className: _VehicleFilter2.default.vehicleType, key: type },
                    _react2.default.createElement(_reactWotBootstrap.ButtonToggleSmall, {
                        caption: icon,
                        isChecked: isChecked,
                        onClick: function onClick() {
                            return _this3.toggleVehicleType(type);
                        },
                        tooltipId: _constants2.VEHICLE_TYPES_TOOLTIPS[type].id
                    }),
                    _react2.default.createElement(_DefaultTooltip2.default, _extends({}, _constants2.VEHICLE_TYPES_TOOLTIPS[type], {
                        message: isChecked ? _constants2.VEHICLE_TYPES_TOOLTIP_BODY.OFF : _constants2.VEHICLE_TYPES_TOOLTIP_BODY.ON
                    }))
                );
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var nationSelectOptions = this.getNationSelectOptions();
            var vehicleTypesSelector = this.getVehicleTypesSelector();

            var classNameBase = (0, _classnames2.default)(_VehicleFilter2.default.base, _defineProperty({}, _VehicleFilter2.default.base__active, this.props.isHighlighted));
            return _react2.default.createElement(
                'div',
                {
                    className: classNameBase,
                    onClick: handleInsideClick
                },
                _react2.default.createElement(
                    _reactWotBootstrap.ButtonSmall,
                    {
                        type: 'miniSecondary',
                        tooltipId: _constants2.VEHICLE_FILTER_TOOLTIP.id,
                        onClick: this.handleToggle
                    },
                    _react2.default.createElement('div', { className: _VehicleFilter2.default.filterButton })
                ),
                _react2.default.createElement(
                    _reactWotBootstrap.Popover,
                    {
                        ref: function ref(c) {
                            return _this4._popover = c;
                        },
                        position: 'right',
                        alignment: 'middle',
                        width: 390,
                        beforeHide: this.beforeHide
                    },
                    _react2.default.createElement(
                        'h3',
                        { className: _VehicleFilter2.default.popoverTitle },
                        _constants2.CAPTION
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'div',
                            { className: _VehicleFilter2.default.select, 'data-tip': true, 'data-for': _constants2.NATIONS_FILTER_TOOOLTIP.id },
                            _react2.default.createElement(_VehicleFilterSelect2.default, {
                                items: nationSelectOptions,
                                selectedItem: this.state.filter.nation,
                                onItemChange: this.handleNationChange,
                                width: 'auto'
                            }),
                            _react2.default.createElement(_DefaultTooltip2.default, _constants2.NATIONS_FILTER_TOOOLTIP)
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: (0, _classnames2.default)(_VehicleFilter2.default.select, _VehicleFilter2.default.select__vehicleTypes) },
                            vehicleTypesSelector
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: (0, _classnames2.default)(_VehicleFilter2.default.select, _VehicleFilter2.default.select__favorite) },
                            _react2.default.createElement(_reactWotBootstrap.ButtonToggleSmall, {
                                caption: _react2.default.createElement('span', { className: _VehicleFilter2.default.favoriteVehicles }),
                                isChecked: this.state.filter.onlyFavorite,
                                onClick: this.toggleFavorite,
                                tooltipId: _constants2.FAVORITE_VEHICLE_TOOLTIP.id
                            }),
                            _react2.default.createElement(_DefaultTooltip2.default, _extends({}, _constants2.FAVORITE_VEHICLE_TOOLTIP, {
                                message: this.state.filter.onlyFavorite ? _constants2.FAVORITE_VEHICLE_TOOLTIP_BODY.OFF : _constants2.FAVORITE_VEHICLE_TOOLTIP_BODY.ON
                            }))
                        )
                    ),
                    _react2.default.createElement(_VehiclesTable2.default, {
                        isOpen: this.state.opened,
                        onHeaderClick: this.handleHeaderClick,
                        onSelectedVehicleCdsUpdate: this.updateSelectedVehiclesCds,
                        realm: this.props.realm,
                        selectedVehicleCds: this.state.selectedVehicleCds,
                        sortColumn: this.state.filter.sortColumn,
                        sortOrder: this.state.filter.sortOrder,
                        vehicles: this.getSortedVehicles()
                    }),
                    _react2.default.createElement(
                        'div',
                        { className: _VehicleFilter2.default.popoverFooter },
                        _react2.default.createElement(
                            'div',
                            { className: _VehicleFilter2.default.button },
                            _react2.default.createElement(
                                _reactWotBootstrap.ButtonSmall,
                                {
                                    isJustified: true,
                                    isDisabled: !this.state.selectedVehicleCds.length,
                                    onClick: this.apply
                                },
                                (0, _constants2.SELECT_VEHICLES)(this.state.selectedVehicleCds.length)
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _VehicleFilter2.default.button },
                            _react2.default.createElement(
                                _reactWotBootstrap.ButtonSmall,
                                { type: 'secondary', onClick: this.handleCancelClick },
                                _i18n.CANCEL
                            )
                        )
                    )
                ),
                _react2.default.createElement(_DefaultTooltip2.default, _constants2.VEHICLE_FILTER_TOOLTIP)
            );
        }
    }]);

    return VehicleFilter;
}(_react2.default.PureComponent);

VehicleFilter.propTypes = {
    filter: _propTypes2.default.shape({
        nation: _propTypes2.default.string.isRequired,
        vehicleTypes: _propTypes2.default.arrayOf(_propTypes2.default.oneOf(_constants.VEHICLE_TYPES)),
        onlyFavorite: _propTypes2.default.bool.isRequired,
        sortColumn: _propTypes2.default.string.isRequired,
        sortOrder: _propTypes2.default.oneOf(['asc', 'desc'])
    }).isRequired,
    isHighlighted: _propTypes2.default.bool.isRequired,
    onSelect: _propTypes2.default.func.isRequired,
    realm: _propTypes2.default.string.isRequired,
    selectedVehicleCds: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired,
    vehicles: _propTypes2.default.array.isRequired,

    vehiclesFilterClose: _propTypes2.default.func.isRequired,
    vehiclesFilterOpen: _propTypes2.default.func.isRequired
};
var mapStateToProps = exports.mapStateToProps = function mapStateToProps(_ref) {
    var settings = _ref.settings,
        players_matching = _ref.players_matching;
    var vehicles = players_matching.vehicles,
        selected_vehicle_cds = players_matching.selected_vehicle_cds,
        vehicle_level = players_matching.vehicle_level,
        vehiclesFilter = players_matching.vehiclesFilter;
    var realm = settings.realm;


    var vehiclesFilteredByLevel = vehicles.filter(function (vehicle) {
        return vehicle.level === vehicle_level;
    });

    return {
        filter: vehiclesFilter,
        isHighlighted: vehiclesFilteredByLevel.length !== selected_vehicle_cds.length,
        vehicles: vehiclesFilteredByLevel,
        selectedVehicleCds: selected_vehicle_cds,
        realm: realm
    };
};

var mapDispatchToProps = exports.mapDispatchToProps = {
    vehiclesFilterOpen: _players_matching.vehiclesFilterOpen,
    vehiclesFilterClose: _players_matching.vehiclesFilterClose
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(VehicleFilter);


function handleInsideClick(e) {
    e.stopPropagation();
}

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(189),
    baseRest = __webpack_require__(198),
    baseUniq = __webpack_require__(303),
    isArrayLikeObject = __webpack_require__(278);

/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */
var union = baseRest(function(arrays) {
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
});

module.exports = union;


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(358),
    noop = __webpack_require__(446),
    setToArray = __webpack_require__(188);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 446 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 447 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Nation_base--rw654","base__ussr":"Nation_base__ussr--3NO5C","baseUssr":"Nation_base__ussr--3NO5C","base__cn":"Nation_base__cn--211XI","baseCn":"Nation_base__cn--211XI","base__germany":"Nation_base__germany--Pkw3S","baseGermany":"Nation_base__germany--Pkw3S","base__usa":"Nation_base__usa--2aplR","baseUsa":"Nation_base__usa--2aplR","base__china":"Nation_base__china--1u6bP","baseChina":"Nation_base__china--1u6bP","base__france":"Nation_base__france--3MMAK","baseFrance":"Nation_base__france--3MMAK","base__uk":"Nation_base__uk--3uZIR","baseUk":"Nation_base__uk--3uZIR","base__japan":"Nation_base__japan--3SX1u","baseJapan":"Nation_base__japan--3SX1u","base__czech":"Nation_base__czech--2zUn8","baseCzech":"Nation_base__czech--2zUn8","base__sweden":"Nation_base__sweden--2Irp4","baseSweden":"Nation_base__sweden--2Irp4","base__poland":"Nation_base__poland--2z2B9","basePoland":"Nation_base__poland--2z2B9","base__italy":"Nation_base__italy--1gVAA","baseItaly":"Nation_base__italy--1gVAA","base__all_nations":"Nation_base__all_nations--3Iy9I","baseAllNations":"Nation_base__all_nations--3Iy9I"};

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.VehicleFilterSelect = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactWotBootstrap = __webpack_require__(5);

var _constants = __webpack_require__(4);

var _VehicleFilterSelect = __webpack_require__(449);

var _VehicleFilterSelect2 = _interopRequireDefault(_VehicleFilterSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
    caption: _propTypes2.default.node,
    captionPosition: _propTypes2.default.oneOf(['left', 'top']),
    items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
        caption: _propTypes2.default.node.isRequired,
        icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node])
    })).isRequired,
    selectedItem: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
    width: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    isDisabled: _propTypes2.default.bool,
    isJustified: _propTypes2.default.bool,
    onItemChange: _propTypes2.default.func.isRequired,
    onToggled: _propTypes2.default.func,
    tooltipId: _propTypes2.default.string
};

var defaultProps = {
    captionPosition: 'left',
    onToggled: function onToggled() {}
};

var MIN_WIDTH = 40;
var MAX_WIDTH = 300;

var VehicleFilterSelect = exports.VehicleFilterSelect = function (_React$PureComponent) {
    _inherits(VehicleFilterSelect, _React$PureComponent);

    function VehicleFilterSelect(props) {
        _classCallCheck(this, VehicleFilterSelect);

        var _this = _possibleConstructorReturn(this, (VehicleFilterSelect.__proto__ || Object.getPrototypeOf(VehicleFilterSelect)).call(this, props));

        _this.state = {
            isActive: false,
            selectWidth: null,
            selectedItem: props.selectedItem,
            dropdownPositionY: 'bottom',
            dropdownPositionX: 'left'
        };

        _this.handleToggle = _this.handleToggle.bind(_this);
        _this.handleBlur = _this.handleBlur.bind(_this);
        _this.handleKeyDown = _this.handleKeyDown.bind(_this);
        _this.handleItemChange = function (value) {
            return _this.changeItem.bind(_this, value);
        };
        _this.setPosition = _this.setPosition.bind(_this);
        return _this;
    }

    _createClass(VehicleFilterSelect, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.updateDropdownWidth();
            document.addEventListener('keydown', this.handleKeyDown);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.updateDropdownWidth();

            if (this.state.selectedItem !== nextProps.selectedItem) {
                this.setState({ selectedItem: nextProps.selectedItem });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.removeEventListener('keydown', this.handleKeyDown);
        }
    }, {
        key: 'hide',
        value: function hide() {
            var isActive = false;
            this.setState({ isActive: isActive });
            this.props.onToggled(isActive);
        }
    }, {
        key: 'handleToggle',
        value: function handleToggle() {
            var isActive = !this.state.isActive;
            this.setPosition();
            this.setState({ isActive: isActive });
            this.props.onToggled(isActive);
        }
    }, {
        key: 'handleBlur',
        value: function handleBlur() {
            this.hide();
            this.resetItem();
        }
    }, {
        key: 'handleKeyDown',
        value: function handleKeyDown(_ref) {
            var keyCode = _ref.keyCode;

            if (!this.state.isActive) {
                return;
            }

            if (keyCode === _constants.KEY_CODES.ESCAPE) {
                this.handleBlur();
            } else if (keyCode === _constants.KEY_CODES.ENTER || keyCode === _constants.KEY_CODES.SPACE) {
                this.changeItem(this.state.selectedItem);
            } else if (keyCode === _constants.KEY_CODES.UP || keyCode === _constants.KEY_CODES.DOWN) {
                this.selectItem(keyCode);
            }
        }
    }, {
        key: 'selectItem',
        value: function selectItem(keyCode) {
            var _this2 = this;

            var selectedItemIdx = this.props.items.findIndex(function (item) {
                return item.value === _this2.state.selectedItem;
            });
            var nextSelectedItemIdx = keyCode === _constants.KEY_CODES.UP ? Math.max(0, selectedItemIdx - 1) : Math.min(this.props.items.length - 1, selectedItemIdx + 1);
            var nextSelectedItem = this.props.items[nextSelectedItemIdx].value;

            if (this.state.selectedItem !== nextSelectedItem) {
                this.setState({ selectedItem: nextSelectedItem });
            }
        }
    }, {
        key: 'resetItem',
        value: function resetItem() {
            if (this.state.selectedItem !== this.props.selectedItem) {
                this.setState({ selectedItem: this.props.selectedItem });
            }
        }
    }, {
        key: 'changeItem',
        value: function changeItem(selectedItem) {
            if (selectedItem !== this.props.selectedItem) {
                this.props.onItemChange(selectedItem);
            } else if (this.state.selectedItem !== this.props.selectedItem) {
                this.resetItem();
            }

            this.hide();
            (0, _reactWotBootstrap.sendSelectClickSoundCommand)();
        }
    }, {
        key: 'updateDropdownWidth',
        value: function updateDropdownWidth() {
            if (this._dropdown) {
                var width = Math.max(this._dropdown.offsetWidth, MIN_WIDTH);

                this.setState({ selectWidth: width });
            }
        }
    }, {
        key: 'renderItems',
        value: function renderItems() {
            var _this3 = this;

            return this.props.items.map(function (item) {
                var icon = item.icon ? _react2.default.createElement(
                    'span',
                    { className: _VehicleFilterSelect2.default.icon },
                    item.icon
                ) : null;

                var itemClassName = (0, _classnames2.default)(_VehicleFilterSelect2.default.item, _defineProperty({}, _VehicleFilterSelect2.default.isSelected, _this3.state.selectedItem === item.value));

                return _react2.default.createElement(
                    'li',
                    {
                        className: itemClassName,
                        key: '' + item.value,
                        onClick: _this3.handleItemChange(item.value),
                        onMouseEnter: _reactWotBootstrap.sendHoverSoundCommand
                    },
                    _react2.default.createElement(
                        'span',
                        { className: _VehicleFilterSelect2.default.itemContainer },
                        icon,
                        item.caption
                    )
                );
            });
        }
    }, {
        key: 'renderCaption',
        value: function renderCaption() {
            if (!this.props.caption) {
                return null;
            }

            var classNameCaption = (0, _classnames2.default)(_VehicleFilterSelect2.default.caption, _VehicleFilterSelect2.default['caption__' + this.props.captionPosition]);

            return _react2.default.createElement(
                'span',
                { className: classNameCaption },
                this.props.caption
            );
        }
    }, {
        key: 'setPosition',
        value: function setPosition() {
            var _document$documentEle = document.documentElement,
                clientHeight = _document$documentEle.clientHeight,
                clientWidth = _document$documentEle.clientWidth;

            var dropdownOffset = this._dropdown.getBoundingClientRect();

            var offsetBottom = this.state.dropdownPositionY === 'bottom' ? dropdownOffset.bottom : dropdownOffset.bottom + this._dropdown.offsetHeight + this._select.offsetHeight;

            var offsetRight = this.state.dropdownPositionX === 'left' ? dropdownOffset.right : dropdownOffset.right + this._dropdown.offsetWidth + this._select.offsetWidth;

            this.setState({
                dropdownPositionY: offsetBottom > clientHeight ? 'top' : 'bottom',
                dropdownPositionX: offsetRight > clientWidth ? 'right' : 'left'
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames2,
                _classNames3,
                _this4 = this;

            var classNameBase = (0, _classnames2.default)(_VehicleFilterSelect2.default.base, (_classNames2 = {}, _defineProperty(_classNames2, _VehicleFilterSelect2.default.isActive, this.state.isActive), _defineProperty(_classNames2, _VehicleFilterSelect2.default.isDisabled, this.props.isDisabled), _defineProperty(_classNames2, _VehicleFilterSelect2.default.isJustified, this.props.isJustified), _classNames2));

            var classNameDropdown = (0, _classnames2.default)(_VehicleFilterSelect2.default.dropdown, (_classNames3 = {}, _defineProperty(_classNames3, _VehicleFilterSelect2.default[this.state.dropdownPositionY], this.state.dropdownPositionY), _defineProperty(_classNames3, _VehicleFilterSelect2.default[this.state.dropdownPositionX], this.state.dropdownPositionX), _classNames3));

            var caption = this.renderCaption();

            var selectedItem = this.props.items.find(function (obj) {
                return obj.value === _this4.state.selectedItem;
            }) || {};

            var selectWidth = this.props.width;
            if (!selectWidth) {
                selectWidth = this.state.selectWidth < MAX_WIDTH ? this.state.selectWidth : MAX_WIDTH;
            }
            var dropdownWidth = selectWidth;

            var dataAttrs = this.props.tooltipId ? {
                'data-tip': true,
                'data-for': this.props.tooltipId
            } : {};

            return _react2.default.createElement(
                'div',
                {
                    className: classNameBase,
                    tabIndex: 1,
                    onBlur: this.handleBlur
                },
                caption,
                _react2.default.createElement(
                    'div',
                    _extends({
                        ref: function ref(c) {
                            return _this4._select = c;
                        },
                        className: _VehicleFilterSelect2.default.selectContainer
                    }, dataAttrs),
                    _react2.default.createElement(
                        'div',
                        {
                            className: _VehicleFilterSelect2.default.decorator,
                            style: { width: selectWidth }
                        },
                        _react2.default.createElement(
                            'div',
                            {
                                className: _VehicleFilterSelect2.default.select,
                                onClick: this.props.isDisabled ? null : this.handleToggle,
                                onMouseDown: this.props.isDisabled ? null : _reactWotBootstrap.sendSelectClickSoundCommand,
                                onMouseEnter: this.props.isDisabled ? null : _reactWotBootstrap.sendHoverSoundCommand
                            },
                            selectedItem.icon ? _react2.default.createElement(
                                'span',
                                { className: _VehicleFilterSelect2.default.icon },
                                selectedItem.icon
                            ) : selectedItem.caption
                        )
                    ),
                    _react2.default.createElement(
                        'menu',
                        {
                            ref: function ref(c) {
                                return _this4._dropdown = c;
                            },
                            className: classNameDropdown,
                            style: { width: dropdownWidth }
                        },
                        this.renderItems()
                    )
                )
            );
        }
    }]);

    return VehicleFilterSelect;
}(_react2.default.PureComponent);

VehicleFilterSelect.propTypes = propTypes;
VehicleFilterSelect.defaultProps = defaultProps;

exports.default = VehicleFilterSelect;

/***/ }),
/* 449 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"VehicleFilterSelect_base--24EDE","isActive":"VehicleFilterSelect_isActive--2SyNq","isJustified":"VehicleFilterSelect_isJustified--1KMY-","caption":"VehicleFilterSelect_caption--r-DWv","caption__left":"VehicleFilterSelect_caption__left--1FqZt","captionLeft":"VehicleFilterSelect_caption__left--1FqZt","caption__top":"VehicleFilterSelect_caption__top--2d0Nm","captionTop":"VehicleFilterSelect_caption__top--2d0Nm","selectContainer":"VehicleFilterSelect_selectContainer--1e3Sd","decorator":"VehicleFilterSelect_decorator--1jCOu","isDisabled":"VehicleFilterSelect_isDisabled--mMoDN","select":"VehicleFilterSelect_select--Bq192","dropdown":"VehicleFilterSelect_dropdown--RNFAN","bottom":"VehicleFilterSelect_bottom--OXyR-","top":"VehicleFilterSelect_top--14CG2","left":"VehicleFilterSelect_left--2s6MR","right":"VehicleFilterSelect_right--3bQty","item":"VehicleFilterSelect_item--RMhUI","isSelected":"VehicleFilterSelect_isSelected--1737t","itemContainer":"VehicleFilterSelect_itemContainer--Zspdf","icon":"VehicleFilterSelect_icon--lrD7d"};

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.VehiclesTable = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _helpers = __webpack_require__(11);

var _reactWotBootstrap = __webpack_require__(5);

var _Nation = __webpack_require__(141);

var _Nation2 = _interopRequireDefault(_Nation);

var _VehicleFilterCheckbox = __webpack_require__(451);

var _VehicleFilterCheckbox2 = _interopRequireDefault(_VehicleFilterCheckbox);

var _VehicleType = __webpack_require__(68);

var _VehicleType2 = _interopRequireDefault(_VehicleType);

var _DefaultTooltip = __webpack_require__(30);

var _DefaultTooltip2 = _interopRequireDefault(_DefaultTooltip);

var _constants = __webpack_require__(453);

var _propTypes3 = __webpack_require__(32);

var _VehiclesTable = __webpack_require__(454);

var _VehiclesTable2 = _interopRequireDefault(_VehiclesTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TABLE_ROW_HEIGHT = 34;
var TABLE_HEIGHT = 264; // equals VehiclesTable.scss `.list` height

var VehiclesTable = exports.VehiclesTable = function (_React$Component) {
    _inherits(VehiclesTable, _React$Component);

    function VehiclesTable(props) {
        _classCallCheck(this, VehiclesTable);

        var _this = _possibleConstructorReturn(this, (VehiclesTable.__proto__ || Object.getPrototypeOf(VehiclesTable)).call(this, props));

        _this.toggleVehicleSelected = function (vehicleCd) {
            var selectedVehicleCds = _this.props.selectedVehicleCds;


            if (selectedVehicleCds.includes(vehicleCd)) {
                selectedVehicleCds = selectedVehicleCds.filter(function (id) {
                    return id !== vehicleCd;
                });
            } else {
                selectedVehicleCds = [].concat(_toConsumableArray(selectedVehicleCds), [vehicleCd]);
            }
            _this.props.onSelectedVehicleCdsUpdate(selectedVehicleCds);
        };

        _this.addVehicles = function (source, adding) {
            var sourceWithAdded = [].concat(_toConsumableArray(source));
            adding.forEach(function (vehicleCd) {
                return !source.includes(vehicleCd) && sourceWithAdded.push(vehicleCd);
            });
            return sourceWithAdded;
        };

        _this.removeVehicles = function (source, removing) {
            return source.filter(function (vehicle) {
                return !removing.includes(vehicle);
            });
        };

        _this.handleSelectAllClick = function () {
            var selectedVehicleCds = [].concat(_toConsumableArray(_this.props.selectedVehicleCds));
            var filteredVehicleCds = _this.props.vehicles.map(function (vehicle) {
                return vehicle.id;
            });
            _this.props.onSelectedVehicleCdsUpdate(_this.checkAllSelected() ? _this.removeVehicles(selectedVehicleCds, filteredVehicleCds) : _this.addVehicles(selectedVehicleCds, filteredVehicleCds));
        };

        _this.checkAllSelected = function () {
            return _this.props.vehicles.every(function (vehicle) {
                return _this.props.selectedVehicleCds.includes(vehicle.id);
            });
        };

        _this.getHeadProps = function (name) {
            var _classNames;

            var noTooltipsColumns = ['level', 'selectAll'];

            var clickHandler = void 0;
            if (name === 'selectAll') clickHandler = _this.handleSelectAllClick;else if (name !== 'level') clickHandler = function clickHandler() {
                return _this.handleHeaderClick(name);
            };

            return {
                className: (0, _classnames2.default)(_VehiclesTable2.default.th, (_classNames = {}, _defineProperty(_classNames, _VehiclesTable2.default.th__isSortable, name !== 'level'), _defineProperty(_classNames, _VehiclesTable2.default['th__' + _this.props.sortOrder], _this.props.sortColumn === name), _defineProperty(_classNames, _VehiclesTable2.default.th__basis, name === 'name'), _classNames)),
                onClick: clickHandler,
                'data-tip': !noTooltipsColumns.includes(name),
                'data-for': noTooltipsColumns.includes(name) ? null : _constants.HEADER_TOOLTIPS[name].id
            };
        };

        _this.renderTableRow = _this.renderTableRow.bind(_this);
        return _this;
    }

    _createClass(VehiclesTable, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (prevProps.isOpen !== this.props.isOpen && this._scrollArea) this._scrollArea.scrollTop(0);
        }
    }, {
        key: 'handleHeaderClick',
        value: function handleHeaderClick(name) {
            this.props.onHeaderClick(name);
        }
    }, {
        key: 'renderTableRow',
        value: function renderTableRow(vehicle) {
            var _this2 = this;

            var isSelected = this.props.selectedVehicleCds.includes(vehicle.id);
            var onClick = function onClick(event) {
                if (event.target.type === 'checkbox') return false;
                _this2.toggleVehicleSelected(vehicle.id);
            };

            return _react2.default.createElement(
                _reactWotBootstrap.TableRow,
                {
                    key: vehicle.techName,
                    isHoverable: true,
                    isClickable: true,
                    isActive: isSelected,
                    onClick: onClick
                },
                _react2.default.createElement(
                    'div',
                    { className: _VehiclesTable2.default.td },
                    _react2.default.createElement(_reactWotBootstrap.Checkbox, {
                        onChange: onClick,
                        isChecked: isSelected
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: _VehiclesTable2.default.td },
                    _react2.default.createElement(
                        'div',
                        { className: _VehiclesTable2.default.icon },
                        _react2.default.createElement(_Nation2.default, { nation: vehicle.nation, realm: this.props.realm })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _VehiclesTable2.default.td },
                    _react2.default.createElement(
                        'div',
                        { className: _VehiclesTable2.default.icon },
                        _react2.default.createElement(_VehicleType2.default, { type: vehicle.type, mini: true })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _VehiclesTable2.default.td },
                    _react2.default.createElement(
                        'div',
                        { className: _VehiclesTable2.default.icon },
                        _react2.default.createElement(
                            'span',
                            { className: _VehiclesTable2.default.level },
                            (0, _helpers.toRoman)(vehicle.level)
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)(_VehiclesTable2.default.td, _VehiclesTable2.default.td__basis) },
                    _react2.default.createElement('img', {
                        className: _VehiclesTable2.default.vehicleImage,
                        src: vehicle.smallIconUrl
                    }),
                    _react2.default.createElement(
                        'p',
                        { className: _VehiclesTable2.default.vehicleTitle },
                        vehicle.shortName
                    ),
                    vehicle.readiness && !vehicle.readiness.isReady && _react2.default.createElement('span', {
                        className: _VehiclesTable2.default.warningIcon,
                        'data-tip': true, 'data-for': _constants.VEHICLE_NOT_READY_TOOLTIP.id
                    })
                )
            );
        }
    }, {
        key: 'renderList',
        value: function renderList() {
            var _this3 = this;

            var tableRows = this.props.vehicles.map(this.renderTableRow);

            return _react2.default.createElement(
                'div',
                { className: _VehiclesTable2.default.list },
                _react2.default.createElement(
                    _reactWotBootstrap.ScrollArea,
                    {
                        ref: function ref(component) {
                            return _this3._scrollArea = component;
                        },
                        stepHeight: TABLE_ROW_HEIGHT,
                        scrollableAreaHeight: TABLE_HEIGHT,
                        modifier: 'table'
                    },
                    _react2.default.createElement(
                        _reactWotBootstrap.TableBody,
                        null,
                        tableRows
                    )
                )
            );
        }
    }, {
        key: 'renderEmptyList',
        value: function renderEmptyList() {
            return _react2.default.createElement(
                'div',
                { className: _VehiclesTable2.default.emptyList },
                _react2.default.createElement(
                    'p',
                    { className: _VehiclesTable2.default.message },
                    _constants.NOT_FOUND_MESSAGE
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var allChecked = this.checkAllSelected();
            return _react2.default.createElement(
                'div',
                { className: _VehiclesTable2.default.base },
                _react2.default.createElement(
                    _reactWotBootstrap.Table,
                    null,
                    _react2.default.createElement(
                        _reactWotBootstrap.TableHead,
                        null,
                        _react2.default.createElement(
                            'div',
                            this.getHeadProps('selectAll'),
                            _react2.default.createElement('span', { className: (0, _classnames2.default)(_VehiclesTable2.default.thCondition, _VehiclesTable2.default.thCondition__hover) }),
                            _react2.default.createElement('span', { className: (0, _classnames2.default)(_VehiclesTable2.default.thCondition, _VehiclesTable2.default.thCondition__active) }),
                            _react2.default.createElement(
                                'div',
                                { className: (0, _classnames2.default)(_VehiclesTable2.default.thKey, _VehiclesTable2.default.thKey__inactive) },
                                _react2.default.createElement(_VehicleFilterCheckbox2.default, { isChecked: allChecked, onChange: this.handleSelectAllClick })
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            this.getHeadProps('nation'),
                            _react2.default.createElement('span', { className: (0, _classnames2.default)(_VehiclesTable2.default.thCondition, _VehiclesTable2.default.thCondition__hover) }),
                            _react2.default.createElement('span', { className: (0, _classnames2.default)(_VehiclesTable2.default.thCondition, _VehiclesTable2.default.thCondition__active) }),
                            _react2.default.createElement(
                                'div',
                                { className: _VehiclesTable2.default.thKey },
                                _react2.default.createElement(
                                    'div',
                                    { className: _VehiclesTable2.default.icon },
                                    _react2.default.createElement(_Nation2.default, { nation: 'all_nations' })
                                )
                            ),
                            _react2.default.createElement(_DefaultTooltip2.default, _constants.HEADER_TOOLTIPS['nation'])
                        ),
                        _react2.default.createElement(
                            'div',
                            this.getHeadProps('type'),
                            _react2.default.createElement('span', { className: (0, _classnames2.default)(_VehiclesTable2.default.thCondition, _VehiclesTable2.default.thCondition__hover) }),
                            _react2.default.createElement('span', { className: (0, _classnames2.default)(_VehiclesTable2.default.thCondition, _VehiclesTable2.default.thCondition__active) }),
                            _react2.default.createElement(
                                'div',
                                { className: _VehiclesTable2.default.thKey },
                                _react2.default.createElement(
                                    'div',
                                    { className: _VehiclesTable2.default.icon },
                                    _react2.default.createElement('span', { className: _VehiclesTable2.default.iconVehicleTypes })
                                )
                            ),
                            _react2.default.createElement(_DefaultTooltip2.default, _constants.HEADER_TOOLTIPS['type'])
                        ),
                        _react2.default.createElement(
                            'div',
                            this.getHeadProps('level'),
                            _react2.default.createElement(
                                'div',
                                { className: _VehiclesTable2.default.thKey },
                                _react2.default.createElement(
                                    'div',
                                    { className: _VehiclesTable2.default.icon },
                                    _react2.default.createElement('span', { className: _VehiclesTable2.default.iconLevels })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            this.getHeadProps('name'),
                            _react2.default.createElement('span', { className: (0, _classnames2.default)(_VehiclesTable2.default.thCondition, _VehiclesTable2.default.thCondition__hover) }),
                            _react2.default.createElement('span', { className: (0, _classnames2.default)(_VehiclesTable2.default.thCondition, _VehiclesTable2.default.thCondition__active) }),
                            _react2.default.createElement(
                                'div',
                                { className: _VehiclesTable2.default.thKey },
                                _constants.NAME_COLUMN_TITLE
                            ),
                            _react2.default.createElement(_DefaultTooltip2.default, _constants.HEADER_TOOLTIPS['name'])
                        )
                    ),
                    this.props.vehicles.length ? this.renderList() : this.renderEmptyList()
                ),
                _react2.default.createElement(_DefaultTooltip2.default, _constants.VEHICLE_NOT_READY_TOOLTIP)
            );
        }
    }]);

    return VehiclesTable;
}(_react2.default.Component);

VehiclesTable.propTypes = {
    isOpen: _propTypes2.default.bool.isRequired,
    onHeaderClick: _propTypes2.default.func.isRequired,
    onSelectedVehicleCdsUpdate: _propTypes2.default.func.isRequired,
    realm: _propTypes2.default.string.isRequired,
    selectedVehicleCds: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired,
    sortColumn: _propTypes2.default.string.isRequired,
    sortOrder: _propTypes2.default.string,
    vehicles: _propTypes2.default.arrayOf(_propTypes3.VehiclePropTypes).isRequired
};
exports.default = VehiclesTable;

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _web_to_client = __webpack_require__(12);

var _VehicleFilterCheckbox = __webpack_require__(452);

var _VehicleFilterCheckbox2 = _interopRequireDefault(_VehicleFilterCheckbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
    isChecked: _propTypes2.default.bool,
    onChange: _propTypes2.default.func.isRequired
};

var defaultProps = {
    isChecked: false,
    onChange: function onChange() {}
};

var VehicleFilterCheckbox = function (_React$PureComponent) {
    _inherits(VehicleFilterCheckbox, _React$PureComponent);

    function VehicleFilterCheckbox() {
        _classCallCheck(this, VehicleFilterCheckbox);

        return _possibleConstructorReturn(this, (VehicleFilterCheckbox.__proto__ || Object.getPrototypeOf(VehicleFilterCheckbox)).apply(this, arguments));
    }

    _createClass(VehicleFilterCheckbox, [{
        key: 'render',
        value: function render() {
            var classNameBase = (0, _classnames2.default)(_VehicleFilterCheckbox2.default.base, _defineProperty({}, _VehicleFilterCheckbox2.default.base__isChecked, this.props.isChecked));

            return _react2.default.createElement(
                'label',
                {
                    className: classNameBase,
                    onMouseDown: _web_to_client.sendSelectClickSoundCommand,
                    onMouseEnter: _web_to_client.sendHoverSoundCommand
                },
                _react2.default.createElement('input', {
                    type: 'checkbox',
                    className: _VehicleFilterCheckbox2.default.input,
                    checked: this.props.isChecked,
                    onChange: this.props.onChange
                }),
                _react2.default.createElement('span', { className: _VehicleFilterCheckbox2.default.check })
            );
        }
    }]);

    return VehicleFilterCheckbox;
}(_react2.default.PureComponent);

VehicleFilterCheckbox.propTypes = propTypes;
VehicleFilterCheckbox.defaultProps = defaultProps;

exports.default = VehicleFilterCheckbox;

/***/ }),
/* 452 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"VehicleFilterCheckbox_base--P4814","input":"VehicleFilterCheckbox_input--2styo","check":"VehicleFilterCheckbox_check--2DZmE","base__isChecked":"VehicleFilterCheckbox_base__isChecked--3ORKm","baseIsChecked":"VehicleFilterCheckbox_base__isChecked--3ORKm"};

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HEADER_TOOLTIPS = exports.VEHICLE_NOT_READY_TOOLTIP = exports.NAME_COLUMN_TITLE = exports.NOT_FOUND_MESSAGE = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NOT_FOUND_MESSAGE = exports.NOT_FOUND_MESSAGE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'vehicles_table.not_found_message',
    defaultMessage: '\u041D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E \u0442\u0435\u0445\u043D\u0438\u043A\u0438, \u0443\u0434\u043E\u0432\u043B\u0435\u0442\u0432\u043E\u0440\u044F\u044E\u0449\u0435\u0439 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C \u043F\u043E\u0438\u0441\u043A\u0430'
});

var NAME_COLUMN_TITLE = exports.NAME_COLUMN_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'vehicles_table.name_column',
    defaultMessage: '\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435'
});

var VEHICLE_NOT_READY_TOOLTIP = exports.VEHICLE_NOT_READY_TOOLTIP = {
    id: 'vehicles_table.vehicle_not_ready_tooltip',
    message: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'vehicle_temporary_not_ready',
        defaultMessage: '\u042D\u0442\u0430 \u043C\u0430\u0448\u0438\u043D\u0430 \u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E \u043D\u0435 \u0433\u043E\u0442\u043E\u0432\u0430 \u0432\u0441\u0442\u0443\u043F\u0438\u0442\u044C \u0432 \u0431\u043E\u0439'
    })
};

var HEADER_TOOLTIPS = exports.HEADER_TOOLTIPS = {
    nation: {
        id: 'vehicles_table.header.tooltips.nation.id',
        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'vehicles_table.header.tooltips.nation.title',
            defaultMessage: '\u041D\u0430\u0446\u0438\u044F'
        }),
        message: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'vehicles_table.header.tooltips.nation.message',
            defaultMessage: '\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u043E \u043D\u0430\u0446\u0438\u0438.'
        })
    },
    type: {
        id: 'vehicles_table.header.tooltips.type.id',
        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'vehicles_table.header.tooltips.type.title',
            defaultMessage: '\u0422\u0438\u043F'
        }),
        message: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'vehicles_table.header.tooltips.type.message',
            defaultMessage: '\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u043E \u0442\u0438\u043F\u0443 \u0442\u0435\u0445\u043D\u0438\u043A\u0438.'
        })
    },
    name: {
        id: 'vehicles_table.header.tooltips.name.id',
        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'vehicles_table.header.tooltips.name.title',
            defaultMessage: '\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435'
        }),
        message: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'vehicles_table.header.tooltips.name.message',
            defaultMessage: '\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u043E \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044E \u043C\u0430\u0448\u0438\u043D.'
        })
    }
};

/***/ }),
/* 454 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"th":"VehiclesTable_th--1nxbG","td":"VehiclesTable_td--30rGT","table":"VehiclesTable_table--35aZg","table__isScrollable":"VehiclesTable_table__isScrollable--3MdoN","tableIsScrollable":"VehiclesTable_table__isScrollable--3MdoN","thead":"VehiclesTable_thead--3CoCm","tbody":"VehiclesTable_tbody--1411j","cellGroup":"VehiclesTable_cellGroup--cY7O2","spacer":"VehiclesTable_spacer--280vj","tr":"VehiclesTable_tr--2Sw6k","tr__isHoverable":"VehiclesTable_tr__isHoverable--16Tdm","trIsHoverable":"VehiclesTable_tr__isHoverable--16Tdm","tr__isActive":"VehiclesTable_tr__isActive--3eNWJ","trIsActive":"VehiclesTable_tr__isActive--3eNWJ","tr__isClickable":"VehiclesTable_tr__isClickable--3fyhO","trIsClickable":"VehiclesTable_tr__isClickable--3fyhO","trExpandable":"VehiclesTable_trExpandable--1fsr7","trExpandableCondition":"VehiclesTable_trExpandableCondition--2srkc","trExpandableCondition__hover":"VehiclesTable_trExpandableCondition__hover--1DSSc","trExpandableConditionHover":"VehiclesTable_trExpandableCondition__hover--1DSSc","trExpandableCondition__active":"VehiclesTable_trExpandableCondition__active--leWhu","trExpandableConditionActive":"VehiclesTable_trExpandableCondition__active--leWhu","trExpandable__isActive":"VehiclesTable_trExpandable__isActive--2Ge8n","trExpandableIsActive":"VehiclesTable_trExpandable__isActive--2Ge8n","trExpandableCondition__own":"VehiclesTable_trExpandableCondition__own--2MMyr","trExpandableConditionOwn":"VehiclesTable_trExpandableCondition__own--2MMyr","trArrow":"VehiclesTable_trArrow--1jgkA","trExpansion":"VehiclesTable_trExpansion--1_sR6","trExpansionInner":"VehiclesTable_trExpansionInner--2WjZv","trExpansionCondition":"VehiclesTable_trExpansionCondition--3xqjU","th__isSortable":"VehiclesTable_th__isSortable--2YvgG","thIsSortable":"VehiclesTable_th__isSortable--2YvgG","th__arrow":"VehiclesTable_th__arrow--3z5u3","thArrow":"VehiclesTable_th__arrow--3z5u3","th__number":"VehiclesTable_th__number--ypTpi","thNumber":"VehiclesTable_th__number--ypTpi","th__check":"VehiclesTable_th__check--9Kyt6","thCheck":"VehiclesTable_th__check--9Kyt6","th__role":"VehiclesTable_th__role--15j0D","thRole":"VehiclesTable_th__role--15j0D","th__basis":"VehiclesTable_th__basis--zR91g","thBasis":"VehiclesTable_th__basis--zR91g","th__basisGutter":"VehiclesTable_th__basisGutter--12aNc","thBasisGutter":"VehiclesTable_th__basisGutter--12aNc","th__alignLeft":"VehiclesTable_th__alignLeft--3keIy","thAlignLeft":"VehiclesTable_th__alignLeft--3keIy","th__alignCenter":"VehiclesTable_th__alignCenter--37Yqj","thAlignCenter":"VehiclesTable_th__alignCenter--37Yqj","th__alignRight":"VehiclesTable_th__alignRight--3O-3n","thAlignRight":"VehiclesTable_th__alignRight--3O-3n","thCondition":"VehiclesTable_thCondition--17566","thCondition__hover":"VehiclesTable_thCondition__hover--1R8kV","thConditionHover":"VehiclesTable_thCondition__hover--1R8kV","thCondition__active":"VehiclesTable_thCondition__active--A4nsh","thConditionActive":"VehiclesTable_thCondition__active--A4nsh","thKey":"VehiclesTable_thKey--1yZna","thKey__inactive":"VehiclesTable_thKey__inactive--10w8n","thKeyInactive":"VehiclesTable_thKey__inactive--10w8n","th__desc":"VehiclesTable_th__desc--Uqd23","thDesc":"VehiclesTable_th__desc--Uqd23","th__asc":"VehiclesTable_th__asc--3Ekws","thAsc":"VehiclesTable_th__asc--3Ekws","td__arrow":"VehiclesTable_td__arrow--3SSzt","tdArrow":"VehiclesTable_td__arrow--3SSzt","td__number":"VehiclesTable_td__number--30f6p","tdNumber":"VehiclesTable_td__number--30f6p","td__check":"VehiclesTable_td__check--3uCXM","tdCheck":"VehiclesTable_td__check--3uCXM","td__role":"VehiclesTable_td__role--3IgG2","tdRole":"VehiclesTable_td__role--3IgG2","td__basis":"VehiclesTable_td__basis--polOX","tdBasis":"VehiclesTable_td__basis--polOX","td__basisGutter":"VehiclesTable_td__basisGutter--28pcW","tdBasisGutter":"VehiclesTable_td__basisGutter--28pcW","td__alignLeft":"VehiclesTable_td__alignLeft--2XlQ-","tdAlignLeft":"VehiclesTable_td__alignLeft--2XlQ-","td__alignCenter":"VehiclesTable_td__alignCenter--3U9Ye","tdAlignCenter":"VehiclesTable_td__alignCenter--3U9Ye","td__alignRight":"VehiclesTable_td__alignRight--1DW98","tdAlignRight":"VehiclesTable_td__alignRight--1DW98","tdValue":"VehiclesTable_tdValue--287iX","tdValue__null":"VehiclesTable_tdValue__null--24QaL","tdValueNull":"VehiclesTable_tdValue__null--24QaL","tdValue__positive":"VehiclesTable_tdValue__positive--KNAiz","tdValuePositive":"VehiclesTable_tdValue__positive--KNAiz","tdValue__resource":"VehiclesTable_tdValue__resource--3DdKH","tdValueResource":"VehiclesTable_tdValue__resource--3DdKH","tdValue__isError":"VehiclesTable_tdValue__isError--1XlHU","tdValueIsError":"VehiclesTable_tdValue__isError--1XlHU","tdValue__isOwn":"VehiclesTable_tdValue__isOwn--caK3u","tdValueIsOwn":"VehiclesTable_tdValue__isOwn--caK3u","base":"VehiclesTable_base--1M8Rz","list":"VehiclesTable_list--11jp_","emptyList":"VehiclesTable_emptyList--2B8JE","message":"VehiclesTable_message--ipdN4","icon":"VehiclesTable_icon--1OuKU","level":"VehiclesTable_level--2jDmP","vehicleImage":"VehiclesTable_vehicleImage--3C5jy","vehicleTitle":"VehiclesTable_vehicleTitle--2MpKZ","iconVehicleTypes":"VehiclesTable_iconVehicleTypes--2eSAT","iconLevels":"VehiclesTable_iconLevels--_STZy","warningIcon":"VehiclesTable_warningIcon--2ksSz"};

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.VEHICLE_FILTER_TOOLTIP = exports.FAVORITE_VEHICLE_TOOLTIP_BODY = exports.FAVORITE_VEHICLE_TOOLTIP = exports.VEHICLE_TYPES_TOOLTIP_BODY = exports.VEHICLE_TYPES_TOOLTIPS = exports.NATIONS_FILTER_TOOOLTIP = exports.NATIONS_ALL_CAPTION = exports.NATIONS_CAPTIONS = exports.LEVELS_ALL_CAPTION = exports.TYPES = exports.SELECT_VEHICLES = exports.CAPTION = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CAPTION = exports.CAPTION = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'vehicle_filter.caption',
    defaultMessage: '\u0412\u044B\u0431\u043E\u0440 \u0442\u0435\u0445\u043D\u0438\u043A\u0438'
});

var SELECT_VEHICLES = exports.SELECT_VEHICLES = function SELECT_VEHICLES(count) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'vehicle_filter.apply',
        defaultMessage: '\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0432\u044B\u0431\u043E\u0440 ({count})',
        values: { count: count }
    });
};

var TYPES = exports.TYPES = ['lightTank', 'mediumTank', 'heavyTank', 'AT-SPG', 'SPG'];

var LEVELS_ALL_CAPTION = exports.LEVELS_ALL_CAPTION = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'level_select.all_caption',
    defaultMessage: '\u0412\u0441\u0435 \u0443\u0440\u043E\u0432\u043D\u0438'
});

var NATIONS_CAPTIONS = exports.NATIONS_CAPTIONS = {
    ussr: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'nations_select.captions.ussr',
        defaultMessage: '\u0421\u0421\u0421\u0420'
    }),
    germany: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'nations_select.captions.germany',
        defaultMessage: '\u0413\u0435\u0440\u043C\u0430\u043D\u0438\u044F'
    }),
    usa: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'nations_select.captions.usa',
        defaultMessage: '\u0421\u0428\u0410'
    }),
    china: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'nations_select.captions.china',
        defaultMessage: '\u041A\u0438\u0442\u0430\u0439'
    }),
    france: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'nations_select.captions.france',
        defaultMessage: '\u0424\u0440\u0430\u043D\u0446\u0438\u044F'
    }),
    uk: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'nations_select.captions.uk',
        defaultMessage: '\u0412\u0435\u043B\u0438\u043A\u043E\u0431\u0440\u0438\u0442\u0430\u043D\u0438\u044F'
    }),
    japan: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'nations_select.captions.japan',
        defaultMessage: '\u042F\u043F\u043E\u043D\u0438\u044F'
    }),
    czech: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'nations_select.captions.czech',
        defaultMessage: '\u0427\u0435\u0445\u043E\u0441\u043B\u043E\u0432\u0430\u043A\u0438\u044F'
    }),
    sweden: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'nations_select.captions.sweden',
        defaultMessage: '\u0428\u0432\u0435\u0446\u0438\u044F'
    }),
    poland: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'nations_select.captions.poland',
        defaultMessage: '\u041F\u043E\u043B\u044C\u0448\u0430'
    }),
    italy: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'nations_select.captions.italy',
        defaultMessage: '\u0418\u0442\u0430\u043B\u0438\u044F'
    })
};

var NATIONS_ALL_CAPTION = exports.NATIONS_ALL_CAPTION = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'nations_select.captions.all',
    defaultMessage: '\u0412\u0441\u0435 \u043D\u0430\u0446\u0438\u0438'
});

var NATIONS_FILTER_TOOOLTIP = exports.NATIONS_FILTER_TOOOLTIP = {
    id: 'nation_filter_tooltip.id',
    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'nation_filter_tooltip.title',
        defaultMessage: '\u041D\u0430\u0446\u0438\u044F'
    }),
    message: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'nation_filter_tooltip.body',
        defaultMessage: '\u0424\u0438\u043B\u044C\u0442\u0440\u043E\u0432\u0430\u0442\u044C \u0442\u0435\u0445\u043D\u0438\u043A\u0443 \u043F\u043E \u043D\u0430\u0446\u0438\u0438.'
    })
};

var VEHICLE_TYPES_TOOLTIPS = exports.VEHICLE_TYPES_TOOLTIPS = {
    heavyTank: {
        id: 'vehicle_types_select.tooltips.heavy_tank.id',
        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'vehicle_types_select.tooltips.heavy_tank.title',
            defaultMessage: '\u0422\u044F\u0436\u0451\u043B\u044B\u0435 \u0442\u0430\u043D\u043A\u0438'
        })
    },
    mediumTank: {
        id: 'vehicle_types_select.tooltips.medium_tank.id',
        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'vehicle_types_select.tooltips.medium_tank.title',
            defaultMessage: '\u0421\u0440\u0435\u0434\u043D\u0438\u0435 \u0442\u0430\u043D\u043A\u0438'
        })
    },
    lightTank: {
        id: 'vehicle_types_select.tooltips.light_tank.id',
        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'vehicle_types_select.tooltips.light_tank.title',
            defaultMessage: '\u041B\u0451\u0433\u043A\u0438\u0435 \u0442\u0430\u043D\u043A\u0438'
        })
    },
    SPG: {
        id: 'vehicle_types_select.tooltips.spg.id',
        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'vehicle_types_select.tooltips.spg.title',
            defaultMessage: '\u0421\u0410\u0423'
        })
    },
    'AT-SPG': {
        id: 'vehicle_types_select.tooltips.at_spg.id',
        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'vehicle_types_select.tooltips.at_spg.title',
            defaultMessage: '\u041F\u0422-\u0421\u0410\u0423'
        })
    }
};

var VEHICLE_TYPES_TOOLTIP_BODY = exports.VEHICLE_TYPES_TOOLTIP_BODY = {
    ON: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'vehicle_types_select.tooltips.on.body',
        defaultMessage: '\u0412\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435 \u0442\u0435\u0445\u043D\u0438\u043A\u0438 \u0434\u0430\u043D\u043D\u043E\u0433\u043E \u0442\u0438\u043F\u0430.'
    }),
    OFF: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'vehicle_types_select.tooltips.off.body',
        defaultMessage: '\u041E\u0442\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435 \u0442\u0435\u0445\u043D\u0438\u043A\u0438 \u0434\u0430\u043D\u043D\u043E\u0433\u043E \u0442\u0438\u043F\u0430.'
    })
};

var FAVORITE_VEHICLE_TOOLTIP = exports.FAVORITE_VEHICLE_TOOLTIP = {
    id: 'vehicle_types_select.tooltips.favorite.id',
    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'vehicle_types_select.tooltips.favorite.title',
        defaultMessage: '\u041E\u0441\u043D\u043E\u0432\u043D\u0430\u044F \u0442\u0435\u0445\u043D\u0438\u043A\u0430'
    })
};

var FAVORITE_VEHICLE_TOOLTIP_BODY = exports.FAVORITE_VEHICLE_TOOLTIP_BODY = {
    ON: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'vehicle_types_select.tooltips.favorite.on.body',
        defaultMessage: '\u0412\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0439 \u0442\u0435\u0445\u043D\u0438\u043A\u0438.'
    }),
    OFF: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'vehicle_types_select.tooltips.favorite.off.body',
        defaultMessage: '\u041E\u0442\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0439 \u0442\u0435\u0445\u043D\u0438\u043A\u0438.'
    })
};

var VEHICLE_FILTER_TOOLTIP = exports.VEHICLE_FILTER_TOOLTIP = {
    id: 'vehicle_filter_tooltip',
    title: CAPTION,
    message: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'vehicle_filter_tooltip.message',
        defaultMessage: '\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u0438\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0432\u044B\u0431\u043E\u0440 \u0442\u0435\u0445\u043D\u0438\u043A\u0438 \u0434\u043B\u044F \u0441\u0440\u0430\u0436\u0435\u043D\u0438\u0439.'
    })
};

/***/ }),
/* 456 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"popoverBase":"VehicleFilter_popoverBase--1oDY-","popoverBody":"VehicleFilter_popoverBody--13c2c","popoverWrapper":"VehicleFilter_popoverWrapper--3aNaw","popoverBackground":"VehicleFilter_popoverBackground--2N7gE","popoverContent":"VehicleFilter_popoverContent--1hF4f","popoverTitle":"VehicleFilter_popoverTitle--1GvZ6","popoverMessage":"VehicleFilter_popoverMessage--2_VEI","popoverDivider":"VehicleFilter_popoverDivider--i4MqV","popoverHighlight":"VehicleFilter_popoverHighlight--yk6x3","popoverRibbon":"VehicleFilter_popoverRibbon--34Lbs","popoverFooter":"VehicleFilter_popoverFooter--1b5ow","base":"VehicleFilter_base--3zaXD","base__active":"VehicleFilter_base__active--1XODs","baseActive":"VehicleFilter_base__active--1XODs","button":"VehicleFilter_button--22INg","select":"VehicleFilter_select--XIH1K","select__favorite":"VehicleFilter_select__favorite--115C5","selectFavorite":"VehicleFilter_select__favorite--115C5","select__vehicleTypes":"VehicleFilter_select__vehicleTypes--3G9WU","selectVehicleTypes":"VehicleFilter_select__vehicleTypes--3G9WU","iconVehicleTypes":"VehicleFilter_iconVehicleTypes--34_u0","filterButton":"VehicleFilter_filterButton--1Q8Ag","favoriteVehicles":"VehicleFilter_favoriteVehicles--22PPE","vehicleType":"VehicleFilter_vehicleType--2xk5q","vehicleTypeFilterIcon":"VehicleFilter_vehicleTypeFilterIcon--1KZ36"};

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapStateToProps = undefined;

var _reactRedux = __webpack_require__(7);

var _players_matching = __webpack_require__(36);

var _constants = __webpack_require__(4);

var _BattleModeFilter = __webpack_require__(138);

var _helpers = __webpack_require__(200);

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(_ref) {
    var availableUnits = _ref.availableUnits,
        players_matching = _ref.players_matching;

    var shouldShowTab = function shouldShowTab(battleMode) {
        if (battleMode.unit_type === _constants.UNIT_TYPES.FORT_BATTLE) return false;

        return players_matching.sortie_settings.some(function (setting) {
            return setting.level === battleMode.max_vehicle_level && (setting.enabled || setting.show_challenges_message);
        });
    };

    var battleModesSettings = availableUnits.meta.battle_modes_settings.filter(shouldShowTab);

    return {
        tab: _constants.BATTLE_ROOMS_TAB_STATES.MATCHING,
        selectedUnitType: _constants.UNIT_TYPES.SORTIE,
        selectedVehicleLevel: players_matching.vehicle_level,
        battleModesSettings: (0, _helpers.sortBattleModeSettings)(battleModesSettings)
    };
}; /**
    * implementation of <BattleModeFilter /> for selecting vehicles for unit autosearch
    * @see https://confluence.wargaming.net/display/WEBDEV/%5BLeg%5D+UI+Legionaries+draft
    */


var mapDispatchToProps = {
    onChange: function onChange(unit_type, vehicle_level) {
        return (0, _players_matching.setBattleModeFilter)(vehicle_level);
    }
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_BattleModeFilter.BattleModeFilter);

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapStateToProps = exports.PlayersMatchingButton = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = __webpack_require__(7);

var _players_matching = __webpack_require__(36);

var _constants = __webpack_require__(4);

var _web_to_client = __webpack_require__(17);

var _peripheries = __webpack_require__(37);

var _translations = __webpack_require__(224);

var _helpers = __webpack_require__(459);

var _PlayersMatchingButton = __webpack_require__(460);

var _PlayersMatchingButton2 = _interopRequireDefault(_PlayersMatchingButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PlayersMatchingButton = exports.PlayersMatchingButton = function (_React$Component) {
    _inherits(PlayersMatchingButton, _React$Component);

    function PlayersMatchingButton() {
        _classCallCheck(this, PlayersMatchingButton);

        var _this = _possibleConstructorReturn(this, (PlayersMatchingButton.__proto__ || Object.getPrototypeOf(PlayersMatchingButton)).call(this));

        _this.onClick = _this.onClick.bind(_this);
        return _this;
    }

    _createClass(PlayersMatchingButton, [{
        key: 'onClick',
        value: function onClick() {
            if (this.props.isDisabled) return null;

            this.props.onClick();
        }
    }, {
        key: 'render',
        value: function render() {
            var reason = null;
            if (this.props.isDisabled && this.props.isAnyVehicleSelected) {
                if (this.props.isAllVehiclesNotReady) {
                    reason = _translations.VEHICLES_NOT_READY;
                } else if (this.props.enabledBattleModePeripheriesNames) {
                    reason = !this.props.enabledBattleModePeripheriesNames.includes(this.props.currentPeripheryName) && (0, _translations.GO_TO_ANOTHER_SERVER)(this.props.enabledBattleModePeripheriesNames);
                } else {
                    reason = (0, _translations.AVAILABLE_INTERIM_BEFORE_PRIME)(this.props.availableInMinutesBeforePrime);
                }
            }

            var className = (0, _classnames2.default)(_PlayersMatchingButton2.default.base, _defineProperty({}, _PlayersMatchingButton2.default.base__disabled, this.props.isDisabled));
            return _react2.default.createElement(
                'section',
                null,
                _react2.default.createElement(
                    'p',
                    { className: _PlayersMatchingButton2.default.reason },
                    reason
                ),
                _react2.default.createElement(
                    'button',
                    {
                        className: className,
                        onClick: this.onClick,
                        onMouseDown: _web_to_client.sendClickSoundCommand,
                        onMouseEnter: _web_to_client.sendHoverSoundCommand
                    },
                    _translations.START_PLAYERS_MATCHING
                )
            );
        }
    }]);

    return PlayersMatchingButton;
}(_react2.default.Component);

PlayersMatchingButton.propTypes = {
    availableInMinutesBeforePrime: _propTypes2.default.number.isRequired,
    currentPeripheryName: _propTypes2.default.string.isRequired,
    enabledBattleModePeripheriesNames: _propTypes2.default.string.isRequired,
    isAllVehiclesNotReady: _propTypes2.default.bool.isRequired,
    isAnyVehicleSelected: _propTypes2.default.bool.isRequired,
    isDisabled: _propTypes2.default.bool.isRequired,

    onClick: _propTypes2.default.func.isRequired
};


function canJoinPlayersMatching(_ref, periphery) {
    var account = _ref.account,
        availableUnits = _ref.availableUnits,
        players_matching = _ref.players_matching;

    if (!players_matching.selected_vehicle_cds) return false;
    if (players_matching.selected_vehicle_cds.length === 0) return false;
    if (players_matching.start_time !== null) return false;

    var isSortiesUnavailable = !(0, _peripheries.isSortiesAvailable)(periphery, availableUnits.meta.sorties.players_matching_available_before * 1000);
    if (isSortiesUnavailable) return false;

    return (0, _helpers.anyOfSelectedVehiclesReady)(players_matching);
}

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
    var sorties = state.availableUnits.meta.sorties;
    var availableInSecondsBeforePrime = sorties.players_matching_available_before;

    var availableInMinutesBeforePrime = Math.floor(availableInSecondsBeforePrime / 60);
    var availablePeripheries = (0, _peripheries.getAvailablePeripheries)(sorties.peripheries, _constants.UNIT_TYPES.SORTIE, availableInSecondsBeforePrime * 1000);

    var selected_vehicle_cds = state.players_matching.selected_vehicle_cds;


    var periphery = (0, _peripheries.getPeripheryById)(state.availableUnits.meta.sorties.peripheries, state.account.periphery_id);
    var selectedSortieSetting = state.players_matching.sortie_settings.find(function (setting) {
        return setting.level === state.players_matching.vehicle_level;
    });
    var battleMode = selectedSortieSetting ? selectedSortieSetting.battle_mode : '';
    var isBattleModeAvailableAtPeriphery = (0, _peripheries.checkBattleModeAvailableAtPeriphery)(periphery, battleMode);

    var enabledBattleModePeripheries = availablePeripheries.filter(function (availablePeriphery) {
        return (0, _peripheries.checkBattleModeAvailableAtPeriphery)(availablePeriphery, battleMode);
    });
    var enabledBattleModePeripheriesNames = (0, _peripheries.getPeripheriesList)(enabledBattleModePeripheries);

    return {
        availableInMinutesBeforePrime: availableInMinutesBeforePrime,
        enabledBattleModePeripheriesNames: enabledBattleModePeripheriesNames,
        currentPeripheryName: state.account.periphery_name,
        isAllVehiclesNotReady: !(0, _helpers.anyOfSelectedVehiclesReady)(state.players_matching),
        isAnyVehicleSelected: selected_vehicle_cds !== null && selected_vehicle_cds.length > 0,
        isBattleModeAvailableAtPeriphery: isBattleModeAvailableAtPeriphery,
        isDisabled: !canJoinPlayersMatching(state, periphery) || !isBattleModeAvailableAtPeriphery
    };
};

var mapDispatchToProps = {
    onClick: _players_matching.startPlayerMatching
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PlayersMatchingButton);

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.anyOfSelectedVehiclesReady = undefined;

var _vehicles = __webpack_require__(91);

var anyOfSelectedVehiclesReady = exports.anyOfSelectedVehiclesReady = function anyOfSelectedVehiclesReady(_ref) {
    var selected_vehicle_cds = _ref.selected_vehicle_cds,
        vehicles = _ref.vehicles;

    if (!selected_vehicle_cds || !vehicles.length) return false;

    return selected_vehicle_cds.some(function (vehicle_cd) {
        return (0, _vehicles.isVehicleReadyForBattle)(vehicles.find(function (vehicle) {
            return vehicle.id === vehicle_cd;
        }));
    });
};

/***/ }),
/* 460 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"PlayersMatchingButton_base--1LHbx","base__disabled":"PlayersMatchingButton_base__disabled--2_qfY","baseDisabled":"PlayersMatchingButton_base__disabled--2_qfY","reason":"PlayersMatchingButton_reason--1N0x0"};

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = exports.VehiclesCarousel = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(7);

var _players_matching = __webpack_require__(36);

var _vehicles = __webpack_require__(91);

var _KineticScrolling = __webpack_require__(225);

var _KineticScrolling2 = _interopRequireDefault(_KineticScrolling);

var _DefaultTooltip = __webpack_require__(30);

var _DefaultTooltip2 = _interopRequireDefault(_DefaultTooltip);

var _propTypes3 = __webpack_require__(32);

var _Vehicle = __webpack_require__(463);

var _Vehicle2 = _interopRequireDefault(_Vehicle);

var _constants = __webpack_require__(226);

var _VehiclesCarousel = __webpack_require__(465);

var _VehiclesCarousel2 = _interopRequireDefault(_VehiclesCarousel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_VEHICLES_WITHOUT_ARROWS = 6;

var VehiclesCarousel = exports.VehiclesCarousel = function (_React$Component) {
    _inherits(VehiclesCarousel, _React$Component);

    function VehiclesCarousel() {
        _classCallCheck(this, VehiclesCarousel);

        return _possibleConstructorReturn(this, (VehiclesCarousel.__proto__ || Object.getPrototypeOf(VehiclesCarousel)).apply(this, arguments));
    }

    _createClass(VehiclesCarousel, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(props) {
            if (!this._scroll) return;
            if (this.props.vehicleLevel !== props.vehicleLevel) this._scroll.scrollToItem(0);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var sortedVehicles = (0, _vehicles.sortVehicles)([].concat(_toConsumableArray(this.props.vehicles)), 'nation', this.props.realm);

            var vehicleNodes = sortedVehicles.map(function (vehicle) {
                return _react2.default.createElement(
                    'div',
                    { key: vehicle.id, className: _VehiclesCarousel2.default.item },
                    _react2.default.createElement(_Vehicle2.default, {
                        vehicle: vehicle,
                        onClose: function onClose() {
                            return _this2.props.deselectVehicle(vehicle.id);
                        }
                    })
                );
            });

            if (this.props.vehicles.length > MAX_VEHICLES_WITHOUT_ARROWS) {
                vehicleNodes = _react2.default.createElement(
                    _KineticScrolling2.default,
                    { snap: 160, ref: function ref(c) {
                            return _this2._scroll = c;
                        } },
                    vehicleNodes
                );
            }

            return _react2.default.createElement(
                'div',
                { className: _VehiclesCarousel2.default.base },
                vehicleNodes,
                _react2.default.createElement(_DefaultTooltip2.default, _constants.REMOVE_VEHICLE_TOOLTIP)
            );
        }
    }]);

    return VehiclesCarousel;
}(_react2.default.Component);

VehiclesCarousel.propTypes = {
    deselectVehicle: _propTypes2.default.func.isRequired,
    realm: _propTypes2.default.string.isRequired,
    vehicleLevel: _propTypes2.default.number.isRequired,
    vehicles: _propTypes2.default.arrayOf(_propTypes3.VehiclePropTypes).isRequired
};
VehiclesCarousel.defaultProps = { vehicles: [] };
var mapStateToProps = exports.mapStateToProps = function mapStateToProps(_ref) {
    var players_matching = _ref.players_matching,
        settings = _ref.settings;

    var isSelected = function isSelected(vehicle) {
        return players_matching.selected_vehicle_cds.includes(vehicle.id);
    };
    var vehicles = players_matching.vehicles.filter(isSelected);

    return {
        vehicles: vehicles,
        realm: settings.realm,
        vehicleLevel: players_matching.vehicle_level
    };
};

var mapDispatchToProps = exports.mapDispatchToProps = { deselectVehicle: _players_matching.deselectVehicle };

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(VehiclesCarousel);

/***/ }),
/* 462 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"KineticScrolling_base--2Ssn4","wrapper":"KineticScrolling_wrapper--3O4RL","scrolledLeft":"KineticScrolling_scrolledLeft--u1KM0","scrolledRight":"KineticScrolling_scrolledRight--2-OA2","view":"KineticScrolling_view--3F4Oy","arrow":"KineticScrolling_arrow--3MreV"};

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Vehicle = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = __webpack_require__(7);

var _reactWotBootstrap = __webpack_require__(5);

var _helpers = __webpack_require__(11);

var _vehicles = __webpack_require__(91);

var _VehicleType = __webpack_require__(68);

var _VehicleType2 = _interopRequireDefault(_VehicleType);

var _Nation = __webpack_require__(141);

var _Nation2 = _interopRequireDefault(_Nation);

var _propTypes3 = __webpack_require__(32);

var _constants = __webpack_require__(226);

var _Vehicle = __webpack_require__(464);

var _Vehicle2 = _interopRequireDefault(_Vehicle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Vehicle = exports.Vehicle = function Vehicle(props) {
    var baseClasses = (0, _classnames2.default)(_Vehicle2.default.base, _defineProperty({}, _Vehicle2.default['base__cn'], _reactWotBootstrap.helpers.isChineseRealm(props.realm)));

    var bonusClasses = (0, _classnames2.default)(_Vehicle2.default.bonus, _Vehicle2.default['bonus__x' + props.vehicle.dailyXPFactor]);

    var isReady = (0, _vehicles.isVehicleReadyForBattle)(props.vehicle);

    return _react2.default.createElement(
        'div',
        { className: baseClasses },
        _react2.default.createElement('div', { className: _Vehicle2.default.vehicleImage, style: { backgroundImage: 'url(' + props.vehicle.iconUrl + ')' } }),
        _react2.default.createElement('div', { className: bonusClasses }),
        !isReady && _react2.default.createElement(
            'span',
            { className: _Vehicle2.default.notReady },
            _constants.VEHICLE_NOT_READY
        ),
        _react2.default.createElement(
            'footer',
            { className: _Vehicle2.default.footer },
            _react2.default.createElement(
                'div',
                { className: _Vehicle2.default.nation },
                _react2.default.createElement(_Nation2.default, { nation: props.vehicle.nation, realm: props.realm })
            ),
            '\xA0',
            _react2.default.createElement(_VehicleType2.default, {
                mini: true,
                type: props.vehicle.type,
                premium: props.vehicle.isPremium
            }),
            '\xA0',
            (0, _helpers.toRoman)(props.vehicle.level),
            '\xA0',
            _react2.default.createElement(
                'span',
                { className: (0, _classnames2.default)(_Vehicle2.default.name, _defineProperty({}, _Vehicle2.default.isPremium, props.vehicle.isPremium)) },
                props.vehicle.shortName
            )
        ),
        _react2.default.createElement('button', {
            className: _Vehicle2.default.closeButton,
            onClick: props.onClose,
            onMouseDown: _reactWotBootstrap.sendClickSoundCommand,
            onMouseEnter: _reactWotBootstrap.sendHoverSoundCommand,
            'data-tip': true, 'data-for': _constants.REMOVE_VEHICLE_TOOLTIP.id
        })
    );
};

Vehicle.propTypes = {
    onClose: _propTypes2.default.func.isRequired,
    vehicle: _propTypes3.VehiclePropTypes,
    realm: _propTypes2.default.string.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
    return {
        realm: state.settings.realm
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Vehicle);

/***/ }),
/* 464 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Vehicle_base--pJ40s","vehicleImage":"Vehicle_vehicleImage--3ciA9","footer":"Vehicle_footer--1EbkQ","name":"Vehicle_name--2Ordi","isPremium":"Vehicle_isPremium--3VA7V","type":"Vehicle_type--K75Ma","nation":"Vehicle_nation--3aYfS","level":"Vehicle_level--1KZEp","bonus":"Vehicle_bonus--3zeej","bonus__x2":"Vehicle_bonus__x2--I1P_K","bonusX2":"Vehicle_bonus__x2--I1P_K","bonus__x3":"Vehicle_bonus__x3--3DzKH","bonusX3":"Vehicle_bonus__x3--3DzKH","bonus__x4":"Vehicle_bonus__x4--1VnHE","bonusX4":"Vehicle_bonus__x4--1VnHE","bonus__x5":"Vehicle_bonus__x5--3f_xs","bonusX5":"Vehicle_bonus__x5--3f_xs","closeButton":"Vehicle_closeButton--1jjJX","notReady":"Vehicle_notReady--3Z6n4"};

/***/ }),
/* 465 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"VehiclesCarousel_base--2ETHc","item":"VehiclesCarousel_item--2jI-o"};

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NoVehicles = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _translations = __webpack_require__(467);

var _NoVehicles = __webpack_require__(468);

var _NoVehicles2 = _interopRequireDefault(_NoVehicles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NoVehicles = exports.NoVehicles = function NoVehicles(props) {
    return _react2.default.createElement(
        'section',
        { className: _NoVehicles2.default.base },
        _react2.default.createElement(
            'p',
            null,
            (0, _translations.DOESNT_HAVE_N_LEVEL_VEHICLE)(props.level)
        ),
        _react2.default.createElement(
            'p',
            null,
            (0, _translations.NEEDED_VEHICLES_OF_LEVEL)(props.level)
        )
    );
};

NoVehicles.propTypes = {
    level: _propTypes2.default.number.isRequired
};

exports.default = NoVehicles;

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NEEDED_VEHICLES_OF_LEVEL = exports.DOESNT_HAVE_N_LEVEL_VEHICLE = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _helpers = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DOESNT_HAVE_N_LEVEL_VEHICLE = exports.DOESNT_HAVE_N_LEVEL_VEHICLE = function DOESNT_HAVE_N_LEVEL_VEHICLE(level) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'players_matching.no_vehicles_of_level',
        defaultMessage: '\u0423 \u0432\u0430\u0441 \u043D\u0435\u0442 \u0442\u0435\u0445\u043D\u0438\u043A\u0438 {level} \u0443\u0440\u043E\u0432\u043D\u044F.',
        values: { level: (0, _helpers.toRoman)(level) }
    });
}; /* eslint-disable react/no-multi-comp */
var NEEDED_VEHICLES_OF_LEVEL = exports.NEEDED_VEHICLES_OF_LEVEL = function NEEDED_VEHICLES_OF_LEVEL(level) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'players_matching.needed_vehicles_of_level',
        defaultMessage: '\u0421\u0440\u0430\u0436\u0435\u043D\u0438\u044F \u0432 \u0440\u0435\u0436\u0438\u043C\u0435 \xAB\u0412\u044B\u043B\u0430\u0437\u043A\u0438 {level}\xBB \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B \u0442\u043E\u043B\u044C\u043A\u043E \u043D\u0430 \u0442\u0435\u0445\u043D\u0438\u043A\u0435 {level} \u0443\u0440\u043E\u0432\u043D\u044F.',
        values: { level: (0, _helpers.toRoman)(level) }
    });
};

/***/ }),
/* 468 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"NoVehicles_base--37dBn"};

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UnitsCarousel = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(7);

var _clan_units = __webpack_require__(105);

var _UnitTooltip = __webpack_require__(214);

var _UnitTooltip2 = _interopRequireDefault(_UnitTooltip);

var _KineticScrolling = __webpack_require__(225);

var _KineticScrolling2 = _interopRequireDefault(_KineticScrolling);

var _Unit = __webpack_require__(470);

var _Unit2 = _interopRequireDefault(_Unit);

var _propTypes3 = __webpack_require__(32);

var _UnitsCarousel = __webpack_require__(472);

var _UnitsCarousel2 = _interopRequireDefault(_UnitsCarousel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UnitsCarousel = exports.UnitsCarousel = function (_React$Component) {
    _inherits(UnitsCarousel, _React$Component);

    function UnitsCarousel() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, UnitsCarousel);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UnitsCarousel.__proto__ || Object.getPrototypeOf(UnitsCarousel)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            hoveredUnitId: null
        }, _this.showUnitTooltip = function (unitId) {
            _this.setState({ hoveredUnitId: unitId });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(UnitsCarousel, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var units = [].concat(_toConsumableArray(this.props.units)).sort(function (unit1, unit2) {
                return unit2.created_at - unit1.created_at;
            }).map(function (unit) {
                return _react2.default.createElement(
                    'div',
                    {
                        key: unit.id,
                        'data-tip': true,
                        'data-for': _UnitTooltip2.default.id,
                        onMouseEnter: function onMouseEnter() {
                            return _this2.showUnitTooltip(unit.id);
                        },
                        onMouseLeave: function onMouseLeave() {
                            return _this2.showUnitTooltip(null);
                        }
                    },
                    _react2.default.createElement(_Unit2.default, {
                        type: unit.type,
                        maxVehicleLevel: unit.max_vehicle_level,
                        commanderNickname: unit.commander_nickname,
                        membersNumber: unit.members_number,
                        maxMembersNumber: unit.max_members_number,
                        isInBattle: unit.in_battle,
                        onClick: function onClick() {
                            return _this2.props.selectUnit(unit);
                        }
                    })
                );
            });

            if (units.length > 2) {
                units = _react2.default.createElement(
                    _KineticScrolling2.default,
                    { snap: 365 },
                    units
                );
            }

            return _react2.default.createElement(
                'div',
                { className: _UnitsCarousel2.default.base },
                units,
                this.state.hoveredUnitId && _react2.default.createElement(_UnitTooltip2.default, { unitId: this.state.hoveredUnitId })
            );
        }
    }]);

    return UnitsCarousel;
}(_react2.default.Component);

UnitsCarousel.propTypes = {
    units: _propTypes2.default.arrayOf(_propTypes3.UnitDataPropTypes).isRequired,
    selectUnit: _propTypes2.default.func.isRequired
};


var mapDispatchToProps = {
    selectUnit: _clan_units.selectUnit
};

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(UnitsCarousel);

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Unit = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _web_to_client = __webpack_require__(17);

var _constants = __webpack_require__(4);

var _i18n = __webpack_require__(10);

var _helpers = __webpack_require__(11);

var _Unit = __webpack_require__(471);

var _Unit2 = _interopRequireDefault(_Unit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Unit = exports.Unit = function Unit(props) {
    var maxVehicleLevel = props.maxVehicleLevel,
        commanderNickname = props.commanderNickname,
        membersNumber = props.membersNumber,
        maxMembersNumber = props.maxMembersNumber,
        type = props.type;


    var battleModeMessage = type === _constants.UNIT_TYPES.SORTIE ? (0, _i18n.SORTIE_WITH_LEVEL)((0, _helpers.toRoman)(maxVehicleLevel)) : _i18n.FORT_BATTLE;

    return _react2.default.createElement(
        'div',
        {
            className: _Unit2.default.base,
            onClick: props.onClick,
            onMouseDown: _web_to_client.sendClickSoundCommand,
            onMouseEnter: _web_to_client.sendHoverSoundCommand
        },
        _react2.default.createElement(
            'div',
            { className: _Unit2.default.battleMode },
            battleModeMessage
        ),
        _react2.default.createElement(
            'div',
            { className: _Unit2.default.commanderName },
            commanderNickname
        ),
        _react2.default.createElement(
            'div',
            { className: _Unit2.default.counter },
            _react2.default.createElement(
                'span',
                { className: _Unit2.default.highlight },
                membersNumber
            ),
            ' / ',
            maxMembersNumber
        ),
        props.isInBattle && _react2.default.createElement('div', { className: _Unit2.default.inBattle })
    );
};

Unit.propTypes = {
    type: _propTypes2.default.string.isRequired,
    maxVehicleLevel: _propTypes2.default.number,
    commanderNickname: _propTypes2.default.string.isRequired,
    membersNumber: _propTypes2.default.number.isRequired,
    maxMembersNumber: _propTypes2.default.number.isRequired,
    isInBattle: _propTypes2.default.bool.isRequired,

    onClick: _propTypes2.default.func.isRequired
};

exports.default = Unit;

/***/ }),
/* 471 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Unit_base--2Vr51","battleMode":"Unit_battleMode--1hh4w","counter":"Unit_counter--3bSbz","inBattle":"Unit_inBattle--3xny0","highlight":"Unit_highlight--tuhHi","commanderName":"Unit_commanderName--2W6Tn"};

/***/ }),
/* 472 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"UnitsCarousel_base--NBG6_"};

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WaitingPopover = exports.POLL_INTERVAL_MS = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(7);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

var _reactWotBootstrap = __webpack_require__(5);

var _Timer = __webpack_require__(51);

var _Timer2 = _interopRequireDefault(_Timer);

var _i18n = __webpack_require__(10);

var _helpers = __webpack_require__(11);

var _players_matching = __webpack_require__(36);

var _constants = __webpack_require__(474);

var _WaitingPopover = __webpack_require__(475);

var _WaitingPopover2 = _interopRequireDefault(_WaitingPopover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var POLL_INTERVAL_MS = exports.POLL_INTERVAL_MS = 1000 * 30;

var WaitingPopover = exports.WaitingPopover = function (_React$PureComponent) {
    _inherits(WaitingPopover, _React$PureComponent);

    function WaitingPopover(props) {
        _classCallCheck(this, WaitingPopover);

        var _this = _possibleConstructorReturn(this, (WaitingPopover.__proto__ || Object.getPrototypeOf(WaitingPopover)).call(this, props));

        _this.componentDidUpdate = function () {
            return _this.handleUpdateProps();
        };

        _this.handleUpdateProps = function () {
            if (!_this.props.playersMatchingEnd || _this.props.playersMatchingEnd <= (0, _moment2.default)()) {
                clearInterval(_this.pollInterval);
            } else {
                _this.initPollTimer(_this.props.playersMatchingEnd);
            }
        };

        _this.initPollTimer = function () {
            if (_this.pollInterval) clearInterval(_this.pollInterval);

            _this.pollInterval = setInterval(_this.props.getStatus, POLL_INTERVAL_MS);
        };

        _this.componentWillUnmount = function () {
            return clearInterval(_this.pollInterval);
        };

        _this.handleUpdateProps();
        return _this;
    }

    _createClass(WaitingPopover, [{
        key: 'render',
        value: function render() {
            var timer = void 0;
            var description = void 0;

            if (this.props.playersMatchingStart === null) {
                timer = null;
                description = null;
            } else if (this.props.playersMatchingStart > (0, _moment2.default)()) {
                timer = _react2.default.createElement(_Timer2.default, {
                    endTime: this.props.playersMatchingStart,
                    onExpire: this.forceUpdate.bind(this),
                    shortFormat: true
                });
                description = _react2.default.createElement(
                    'p',
                    { className: _WaitingPopover2.default.description },
                    _constants.WAITING_BATTLES_START
                );
            } else {
                timer = _react2.default.createElement(_Timer2.default, {
                    startTime: this.props.playersMatchingStart,
                    shortFormat: true
                });
                description = _react2.default.createElement(
                    'div',
                    { className: _WaitingPopover2.default.description },
                    _react2.default.createElement(
                        'p',
                        null,
                        (0, _i18n.SORTIE_WITH_LEVEL)((0, _helpers.toRoman)(this.props.vehicleLevel))
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _constants.UNIT_MATCHING
                    )
                );
            }

            return _react2.default.createElement(
                'div',
                { className: _WaitingPopover2.default.background },
                _react2.default.createElement(
                    'div',
                    { className: _WaitingPopover2.default.wrapper },
                    _react2.default.createElement(
                        'div',
                        { className: _WaitingPopover2.default.spinner },
                        _react2.default.createElement(_reactWotBootstrap.Spinner, null)
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _WaitingPopover2.default.timer },
                        timer
                    ),
                    description,
                    _react2.default.createElement(
                        'div',
                        { className: _WaitingPopover2.default.button },
                        _react2.default.createElement(
                            _reactWotBootstrap.ButtonSmall,
                            { type: 'secondary', onClick: this.props.handleCancel },
                            _i18n.CANCEL
                        )
                    )
                )
            );
        }
    }]);

    return WaitingPopover;
}(_react2.default.PureComponent);

WaitingPopover.propTypes = {
    vehicleLevel: _propTypes2.default.number.isRequired,
    playersMatchingStart: _propTypes2.default.instanceOf(_moment2.default),
    playersMatchingEnd: _propTypes2.default.instanceOf(_moment2.default),
    handleCancel: _propTypes2.default.func.isRequired,
    getStatus: _propTypes2.default.func.isRequired
};


var mapStateToProps = function mapStateToProps(_ref) {
    var players_matching = _ref.players_matching;
    return {
        vehicleLevel: players_matching.vehicle_level,
        playersMatchingStart: players_matching.start_time ? (0, _moment2.default)(players_matching.start_time) : null,
        playersMatchingEnd: players_matching.end_time ? (0, _moment2.default)(players_matching.end_time) : null
    };
};

var mapDispatchToProps = {
    handleCancel: _players_matching.stopPlayerMatching,
    getStatus: _players_matching.getPlayerMatchingStatus
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(WaitingPopover);

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WAITING_BATTLES_START = exports.UNIT_MATCHING = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UNIT_MATCHING = exports.UNIT_MATCHING = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battleRooms.tab.players_matching.unit_matching',
    defaultMessage: '\u041F\u043E\u0434\u0431\u043E\u0440 \u043E\u0442\u0440\u044F\u0434\u0430...'
});

var WAITING_BATTLES_START = exports.WAITING_BATTLES_START = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battleRooms.tab.players_matching.waiting_battles_start',
    defaultMessage: '\u041E\u0436\u0438\u0434\u0430\u043D\u0438\u0435 \u043D\u0430\u0447\u0430\u043B\u0430 \u0431\u043E\u0451\u0432...'
});

/***/ }),
/* 475 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"background":"WaitingPopover_background--3xSkN","wrapper":"WaitingPopover_wrapper--30tx1","spinner":"WaitingPopover_spinner--tJ6wE","timer":"WaitingPopover_timer--3N1Y0","description":"WaitingPopover_description--2Yvn8","button":"WaitingPopover_button--2uoB2"};

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FIND_UNITS_IN_UNITS_LIST = exports.AVAILABLE_DURING_CHALLENGES = exports.INFO_FOR_LEGIONARY = exports.INFO_TOOLTIP = exports.RESET_SELECTED_VEHICLES_TOOLTIP = exports.SELECTED_VEHICLES_COUNT = exports.NO_OWN_CLAN_UNITS = exports.OWN_CLAN_UNITS = exports.JOIN_RANDOM_UNIT_AS_LEGIONARY = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _PlayersMatchingView = __webpack_require__(227);

var _PlayersMatchingView2 = _interopRequireDefault(_PlayersMatchingView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var JOIN_RANDOM_UNIT_AS_LEGIONARY = exports.JOIN_RANDOM_UNIT_AS_LEGIONARY = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'players_matching.join_unit.title',
    defaultMessage: '\u0421\u0440\u0430\u0436\u0430\u0442\u044C\u0441\u044F \u043B\u0435\u0433\u0438\u043E\u043D\u0435\u0440\u043E\u043C'
}); /* eslint-disable react/no-multi-comp */
var OWN_CLAN_UNITS = exports.OWN_CLAN_UNITS = function OWN_CLAN_UNITS(count) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'players_matching.own_clan_unit',
        defaultMessage: '\u041E\u0442\u0440\u044F\u0434\u044B \u043C\u043E\u0435\u0433\u043E \u043A\u043B\u0430\u043D\u0430 ({count})',
        values: { count: count }
    });
};

var NO_OWN_CLAN_UNITS = exports.NO_OWN_CLAN_UNITS = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'players_matching.no_own_clan_units',
    defaultMessage: '\u0423 \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043B\u0430\u043D\u0430 \u043D\u0435\u0442 \u0441\u0444\u043E\u0440\u043C\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0445 \u043E\u0442\u0440\u044F\u0434\u043E\u0432'
});

var SELECTED_VEHICLES_COUNT = exports.SELECTED_VEHICLES_COUNT = function SELECTED_VEHICLES_COUNT(selected, total) {
    var selectedVehiclesClassName = selected > 0 ? _PlayersMatchingView2.default.highlight : _PlayersMatchingView2.default.error;

    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'players_matching.selected_vehicles_count',
        defaultMessage: '\u0412\u044B\u0431\u0440\u0430\u043D\u043E \u043C\u0430\u0448\u0438\u043D: {selected} / {total}',
        values: {
            selected: _react2.default.createElement(
                'span',
                { className: selectedVehiclesClassName },
                selected
            ),
            total: total
        }
    });
};

var RESET_SELECTED_VEHICLES_TOOLTIP = exports.RESET_SELECTED_VEHICLES_TOOLTIP = {
    id: 'reset_selected_vehicles',
    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'players_matching.reset_selected_vehicles.title',
        defaultMessage: '\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C \u0432\u044B\u0431\u043E\u0440 \u0442\u0435\u0445\u043D\u0438\u043A\u0438'
    }),
    message: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'players_matching.reset_selected_vehicles.message',
        defaultMessage: '\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u0432\u044B\u0431\u0440\u0430\u0442\u044C \u0432\u0441\u044E \u0442\u0435\u0445\u043D\u0438\u043A\u0443, \u0440\u0430\u0437\u0440\u0435\u0448\u0451\u043D\u043D\u0443\u044E \u0432 \u044D\u0442\u043E\u043C \u0440\u0435\u0436\u0438\u043C\u0435.'
    })
};

var INFO_TOOLTIP = exports.INFO_TOOLTIP = {
    id: 'info_tooltip',
    message: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'players_matching.info_tooltip.message',
        defaultMessage: '\u0412\u044B \u0432\u044B\u0439\u0434\u0438\u0442\u0435 \u0432 \u0431\u043E\u0439 \u0441 \u043E\u0442\u0440\u044F\u0434\u043E\u043C, \u043A\u043E\u0442\u043E\u0440\u043E\u043C\u0443 \u043D\u0443\u0436\u043D\u0430 \u043E\u0434\u043D\u0430 \u0438\u0437 \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0445 \u0432\u0430\u043C\u0438 \u043C\u0430\u0448\u0438\u043D.'
    })
};

var INFO_FOR_LEGIONARY = exports.INFO_FOR_LEGIONARY = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'players_matching.info_for_legionary',
    defaultMessage: '\u041E\u0442\u0440\u044F\u0434 \u043F\u043E\u0434\u0431\u0435\u0440\u0451\u0442\u0441\u044F \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438'
});

var AVAILABLE_DURING_CHALLENGES = exports.AVAILABLE_DURING_CHALLENGES = function AVAILABLE_DURING_CHALLENGES(battle_mode) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'players_matching_available_during_challenges',
        defaultMessage: '\u0410\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u043F\u043E\u0434\u0431\u043E\u0440 \u043E\u0442\u0440\u044F\u0434\u0430 \u0432 \u0440\u0435\u0436\u0438\u043C\u0435 "{battle_mode}" \u0431\u0443\u0434\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u0435\u043D \u0432 \u0434\u0435\u043D\u044C \u0412\u043E\u0435\u043D\u043D\u044B\u0445 \u0438\u0433\u0440.',
        values: { battle_mode: battle_mode }
    });
};

var FIND_UNITS_IN_UNITS_LIST = exports.FIND_UNITS_IN_UNITS_LIST = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'players_matching.find_units_in_units_list',
    defaultMessage: '\u041D\u0430\u0439\u0442\u0438 \u043E\u0442\u0440\u044F\u0434 \u0432 \u044D\u0442\u043E\u0442 \u0440\u0435\u0436\u0438\u043C \u0441\u0435\u0439\u0447\u0430\u0441 \u043C\u043E\u0436\u043D\u043E \u0432 \u0441\u043F\u0438\u0441\u043A\u0435 \u043E\u0442\u0440\u044F\u0434\u043E\u0432.'
});

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FullSchedule = FullSchedule;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _translations = __webpack_require__(77);

var _BattleRoomsSchedule = __webpack_require__(140);

var _BattleRoomsSchedule2 = _interopRequireDefault(_BattleRoomsSchedule);

var _Title = __webpack_require__(134);

var _Title2 = _interopRequireDefault(_Title);

var _FullSchedule = __webpack_require__(478);

var _FullSchedule2 = _interopRequireDefault(_FullSchedule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FullSchedule() {
    return _react2.default.createElement(
        'section',
        { className: _FullSchedule2.default.base },
        _react2.default.createElement(
            _Title2.default,
            null,
            _translations.BATTLES_UNAVAILABLE
        ),
        _react2.default.createElement(_BattleRoomsSchedule2.default, { type: 'allBattleModes' })
    );
}

exports.default = FullSchedule;

/***/ }),
/* 478 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"FullSchedule_base--qEFMk","heading":"FullSchedule_heading--pZZv8"};

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = exports.UnitCreateWizard = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(7);

var _BattleWizard = __webpack_require__(228);

var _BattleWizard2 = _interopRequireDefault(_BattleWizard);

var _LoadingScreen = __webpack_require__(29);

var _LoadingScreen2 = _interopRequireDefault(_LoadingScreen);

var _constants = __webpack_require__(4);

var _accounts = __webpack_require__(33);

var _locale = __webpack_require__(21);

var _window_titles = __webpack_require__(80);

var _window_titles2 = _interopRequireDefault(_window_titles);

var _unit_create = __webpack_require__(129);

var _unit_create2 = _interopRequireDefault(_unit_create);

var _unit_create_info = __webpack_require__(285);

var _unit_create_info2 = _interopRequireDefault(_unit_create_info);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UnitCreateWizard = exports.UnitCreateWizard = function (_React$Component) {
    _inherits(UnitCreateWizard, _React$Component);

    function UnitCreateWizard() {
        _classCallCheck(this, UnitCreateWizard);

        return _possibleConstructorReturn(this, (UnitCreateWizard.__proto__ || Object.getPrototypeOf(UnitCreateWizard)).apply(this, arguments));
    }

    _createClass(UnitCreateWizard, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            document.title = (0, _locale.formatMessage)(_window_titles2.default.wizard_create);
            this.props.requestUnitCreateInfo();
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.props.loaded || this.props.loading) {
                return _react2.default.createElement(_LoadingScreen2.default, { type: 'window' });
            }

            return _react2.default.createElement(_BattleWizard2.default, {
                clanIndustrialResource: this.props.clanIndustrialResource,
                loaded: this.props.loaded,
                loading: this.props.loading,
                fortBattles: this.props.fortBattles,
                sorties: this.props.sorties,
                peripheryId: this.props.peripheryId,
                submit: this.props.createUnit,
                showSchedule: this.props.showOldSchedule,
                industrialResourceMultiplier: this.props.industrialResourceMultiplier
            });
        }
    }]);

    return UnitCreateWizard;
}(_react2.default.Component);

UnitCreateWizard.propTypes = {
    clanIndustrialResource: _propTypes2.default.number,
    loaded: _propTypes2.default.bool.isRequired,
    loading: _propTypes2.default.bool.isRequired,
    fortBattles: _propTypes2.default.object.isRequired,
    sorties: _propTypes2.default.object.isRequired,
    peripheryId: _propTypes2.default.number.isRequired,
    showOldSchedule: _propTypes2.default.bool,
    industrialResourceMultiplier: _propTypes2.default.number.isRequired,

    createUnit: _propTypes2.default.func.isRequired,
    requestUnitCreateInfo: _propTypes2.default.func.isRequired
};
var mapStateToProps = exports.mapStateToProps = function mapStateToProps(_ref) {
    var account = _ref.account,
        clan = _ref.clan,
        unitCreateInfo = _ref.unitCreateInfo,
        settings = _ref.settings;
    var peripheryId = account.periphery_id;
    var loading = unitCreateInfo.loading,
        loaded = unitCreateInfo.loaded,
        fortBattles = unitCreateInfo.fort_battles,
        sorties = unitCreateInfo.sorties,
        expiresAt = unitCreateInfo.expiresAt;
    var industrialResourceMultiplier = settings.industrialResourceMultiplier;


    var clanIndustrialResource = clan ? clan.industrial_resource : null;
    return {
        clanIndustrialResource: clanIndustrialResource,
        loading: loading,
        loaded: loaded,
        fortBattles: fortBattles,
        sorties: sorties,
        peripheryId: peripheryId,
        expiresAt: expiresAt,
        showOldSchedule: !(0, _accounts.isFeatureAvailable)(account, _constants.FEATURE_TYPES.SCHEDULE),
        industrialResourceMultiplier: industrialResourceMultiplier
    };
};

var mapDispatchToProps = exports.mapDispatchToProps = {
    createUnit: _unit_create2.default,
    requestUnitCreateInfo: _unit_create_info2.default
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UnitCreateWizard);

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Arenas = __webpack_require__(481);

var _Arenas2 = _interopRequireDefault(_Arenas);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Arenas = function Arenas(props) {

    var arenas = props.arenas.map(function (item, idx) {
        var tooltipId = 'arena-' + props.direction + '-' + idx + '-tooltip';

        return _react2.default.createElement(
            'div',
            { className: _Arenas2.default.item, key: item.id },
            _react2.default.createElement(
                'span',
                { className: _Arenas2.default.caption, 'data-tip': true, 'data-for': tooltipId },
                item.name
            )
        );
    });
    return _react2.default.createElement(
        'div',
        { className: _Arenas2.default.base },
        arenas
    );
};

Arenas.propTypes = {
    arenas: _propTypes2.default.array.isRequired,
    direction: _propTypes2.default.string.isRequired
};

exports.default = Arenas;

/***/ }),
/* 481 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Arenas_base--3e2pL","item":"Arenas_item--1QiG2","caption":"Arenas_caption--2ToII"};

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _helpers = __webpack_require__(11);

var _constants = __webpack_require__(4);

var _components = __webpack_require__(69);

var _constants2 = __webpack_require__(483);

var _Battle = __webpack_require__(484);

var _Battle2 = _interopRequireDefault(_Battle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Battle = function Battle(props) {
    var optionsComponent = props.type === _constants.UNIT_TYPES.SORTIE ? null : _react2.default.createElement(_components.Options, { battleRegulations: props.battleRegulations, inline: true });

    var buttons = props.children.map(function (component, idx) {
        return _react2.default.createElement(
            'div',
            { className: _Battle2.default.item, key: props.type + '-button-' + idx },
            component
        );
    });

    var className = (0, _classnames2.default)(_Battle2.default.base, _Battle2.default['base__' + (0, _helpers.toCssClass)(props.type)]);

    return _react2.default.createElement(
        'div',
        { className: className },
        _react2.default.createElement(
            'div',
            { className: _Battle2.default.header },
            _react2.default.createElement(_components.BattleTitle, { type: props.type })
        ),
        _react2.default.createElement(_components.Status, {
            primetimeStart: props.primetimeStart,
            primetimeEnd: props.primetimeEnd,
            type: props.type,
            isAvailable: true
        }),
        optionsComponent,
        _react2.default.createElement(
            'p',
            { className: _Battle2.default.caption },
            _constants2.BATTLE_LIST_CAPTIONS[props.type]
        ),
        _react2.default.createElement(
            'div',
            { className: _Battle2.default.list },
            buttons
        )
    );
};

Battle.propTypes = {
    type: _propTypes2.default.oneOf(Object.values(_constants.UNIT_TYPES)).isRequired,
    children: _propTypes2.default.array.isRequired,
    battleRegulations: _propTypes2.default.object,
    primetimeStart: _propTypes2.default.number,
    primetimeEnd: _propTypes2.default.number
};

exports.default = Battle;

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BATTLE_LIST_CAPTIONS = undefined;

var _BATTLE_LIST_CAPTIONS;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BATTLE_LIST_CAPTIONS = exports.BATTLE_LIST_CAPTIONS = (_BATTLE_LIST_CAPTIONS = {}, _defineProperty(_BATTLE_LIST_CAPTIONS, _constants.UNIT_TYPES.SORTIE, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_wizard.battle_list_captions.sortie',
    defaultMessage: '\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0434\u0438\u0432\u0438\u0437\u0438\u043E\u043D'
})), _defineProperty(_BATTLE_LIST_CAPTIONS, _constants.UNIT_TYPES.FORT_BATTLE, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_wizard.battle_list_captions.fort_battles',
    defaultMessage: '\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u041F\u043B\u0430\u0446\u0434\u0430\u0440\u043C \u0434\u043B\u044F \u0431\u0438\u0442\u0432\u044B'
})), _BATTLE_LIST_CAPTIONS);

/***/ }),
/* 484 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Battle_base--2MO3x","header":"Battle_header--24pBi","base__sortie":"Battle_base__sortie--3-k22","baseSortie":"Battle_base__sortie--3-k22","base__fort-battle":"Battle_base__fort-battle--2Mcrv","baseFortBattle":"Battle_base__fort-battle--2Mcrv","caption":"Battle_caption--2gtCJ","list":"Battle_list--3OxwG","item":"Battle_item--1Ce4p"};

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _constants = __webpack_require__(4);

var _i18n = __webpack_require__(10);

var _constants2 = __webpack_require__(44);

var _BattleTitle = __webpack_require__(486);

var _BattleTitle2 = _interopRequireDefault(_BattleTitle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BattleTitle = function BattleTitle(props) {
    return _react2.default.createElement(
        'h2',
        { className: _BattleTitle2.default.base },
        _i18n.BATTLE_TITLES[props.type],
        _react2.default.createElement('span', {
            className: _BattleTitle2.default.info,
            'data-tip': true,
            'data-for': _constants2.BATTLE_TITLE_TOOLTIPS_ID[props.type]
        })
    );
};

BattleTitle.propTypes = {
    type: _propTypes2.default.oneOf(Object.values(_constants.UNIT_TYPES)).isRequired
};

exports.default = BattleTitle;

/***/ }),
/* 486 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"BattleTitle_base--lRO_0","info":"BattleTitle_info--1HoXj"};

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _constants = __webpack_require__(4);

var _i18n = __webpack_require__(10);

var _constants2 = __webpack_require__(44);

var _constants3 = __webpack_require__(488);

var _reactWotBootstrap = __webpack_require__(5);

var _components = __webpack_require__(69);

var _BattleTitleTooltip = __webpack_require__(489);

var _BattleTitleTooltip2 = _interopRequireDefault(_BattleTitleTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BattleTitleTooltip = function BattleTitleTooltip(props) {
    var scheduleComponent = void 0;
    if (props.showSchedule) scheduleComponent = _react2.default.createElement(
        'div',
        { className: _BattleTitleTooltip2.default.schedule },
        _react2.default.createElement(_components.Schedule, { peripheries: props.peripheries, type: props.type, tooltip: true })
    );

    var contents = void 0;
    switch (props.type) {
        case _constants.UNIT_TYPES.SORTIE:
            contents = _react2.default.createElement(
                'div',
                { className: _BattleTitleTooltip2.default.contents },
                _react2.default.createElement(
                    'p',
                    null,
                    _constants3.SORTIE_CONTENTS.definition
                ),
                scheduleComponent,
                _react2.default.createElement(
                    'h4',
                    { className: _BattleTitleTooltip2.default.subtitle },
                    _constants3.DESCRIPTION_SUBTITLE
                ),
                _react2.default.createElement(
                    'p',
                    null,
                    _constants3.SORTIE_CONTENTS.description
                ),
                _react2.default.createElement(
                    'div',
                    { className: _BattleTitleTooltip2.default.reward },
                    _react2.default.createElement(
                        'h4',
                        { className: _BattleTitleTooltip2.default.rewardSubtitle },
                        _constants3.REWARD_SUBTITLE
                    ),
                    _react2.default.createElement(
                        'p',
                        null,
                        _constants3.SORTIE_CONTENTS.reward
                    )
                )
            );
            break;
        case _constants.UNIT_TYPES.FORT_BATTLE:
            {

                var fortBattleModeDescription = _constants3.FORT_BATTLE_CONTENTS.description.map(function (item, idx) {
                    return _react2.default.createElement(
                        'li',
                        { className: _BattleTitleTooltip2.default.item, key: idx },
                        item
                    );
                });
                contents = _react2.default.createElement(
                    'div',
                    { className: _BattleTitleTooltip2.default.contents },
                    _react2.default.createElement(
                        'p',
                        null,
                        _constants3.FORT_BATTLE_CONTENTS.definition
                    ),
                    scheduleComponent,
                    _react2.default.createElement(
                        'h4',
                        { className: _BattleTitleTooltip2.default.subtitle },
                        _constants3.DESCRIPTION_SUBTITLE
                    ),
                    _react2.default.createElement(
                        'ul',
                        { className: _BattleTitleTooltip2.default.list },
                        fortBattleModeDescription
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _BattleTitleTooltip2.default.reward },
                        _react2.default.createElement(
                            'h4',
                            { className: _BattleTitleTooltip2.default.rewardSubtitle },
                            _constants3.REWARD_SUBTITLE
                        ),
                        _react2.default.createElement(
                            'p',
                            null,
                            _constants3.FORT_BATTLE_CONTENTS.reward
                        )
                    )
                );
                break;
            }
    }

    return _react2.default.createElement(
        _reactWotBootstrap.Tooltip,
        { id: _constants2.BATTLE_TITLE_TOOLTIPS_ID[props.type], isWide: true },
        _react2.default.createElement(
            'h3',
            { className: _BattleTitleTooltip2.default.title },
            _i18n.BATTLE_TITLES[props.type]
        ),
        contents
    );
};

BattleTitleTooltip.propTypes = {
    type: _propTypes2.default.oneOf(Object.values(_constants.UNIT_TYPES)).isRequired,
    peripheries: _propTypes2.default.array.isRequired,
    showSchedule: _propTypes2.default.bool
};

exports.default = BattleTitleTooltip;

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SORTIE_CONTENTS = exports.FORT_BATTLE_CONTENTS = exports.REWARD_SUBTITLE = exports.DESCRIPTION_SUBTITLE = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

var DESCRIPTION_SUBTITLE = exports.DESCRIPTION_SUBTITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_title_tooltip.description_subtitle',
    defaultMessage: '\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u0440\u0435\u0436\u0438\u043C\u0430'
});

var REWARD_SUBTITLE = exports.REWARD_SUBTITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_title_tooltip.reward_subtitle',
    defaultMessage: '\u041D\u0430\u0433\u0440\u0430\u0434\u0430'
});

var FORT_BATTLE_CONTENTS = exports.FORT_BATTLE_CONTENTS = {
    definition: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battle_title_tooltip.fort_battle.definition',
        defaultMessage: '\u0421\u0435\u0440\u0438\u044F \u0431\u043E\u0451\u0432 \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 \u0447\u0430\u0441\u0430 \u0438\u043B\u0438 \u043C\u0435\u043D\u044C\u0448\u0435 \u0437\u0430 \u043F\u0440\u043E\u043C\u0440\u0435\u0441\u0443\u0440\u0441 \u043D\u0430 \u043F\u043B\u0430\u0446\u0434\u0430\u0440\u043C\u0430\u0445 \u0423\u043A\u0440\u0435\u043F\u0440\u0430\u0439\u043E\u043D\u043E\u0432 \u043F\u0440\u043E\u0442\u0438\u0432\u043E\u0441\u0442\u043E\u044F\u0449\u0438\u0445 \u043A\u043B\u0430\u043D\u043E\u0432.'
    }),
    description: [_react2.default.createElement(_reactIntl.FormattedMessage, {
        key: 'battle_title_tooltip.fort_battle.description_item1',
        id: 'battle_title_tooltip.fort_battle.description_item1',
        defaultMessage: '\u041A\u043B\u0430\u043D\u044B \u0444\u043E\u0440\u043C\u0438\u0440\u0443\u044E\u0442 \u043E\u0442\u0440\u044F\u0434\u044B \u0438 \u043E\u0436\u0438\u0434\u0430\u044E\u0442 \u043D\u0430\u0447\u0430\u043B\u0430 \u041D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u044F. \u041F\u0440\u043E\u0442\u0438\u0432\u043D\u0438\u043A \u043F\u043E\u0434\u0431\u0438\u0440\u0430\u0435\u0442\u0441\u044F \u0441\u043B\u0443\u0447\u0430\u0439\u043D\u044B\u043C \u043E\u0431\u0440\u0430\u0437\u043E\u043C.'
    }), _react2.default.createElement(_reactIntl.FormattedMessage, {
        key: 'battle_title_tooltip.fort_battle.description_item2',
        id: 'battle_title_tooltip.fort_battle.description_item2',
        defaultMessage: '\u041D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u0435 \u043D\u0430\u0447\u0438\u043D\u0430\u0435\u0442\u0441\u044F \u0441 \u0431\u043E\u044F \u043D\u0430 \u043D\u0435\u0439\u0442\u0440\u0430\u043B\u044C\u043D\u043E\u0439 \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u0438 (\u0441\u043B\u0443\u0447\u0430\u0439\u043D\u0430\u044F \u043A\u0430\u0440\u0442\u0430). \u041F\u043E\u0431\u0435\u0434\u0438\u0442\u0435\u043B\u044C \u0431\u0443\u0434\u0435\u0442 \u0430\u0442\u0430\u043A\u043E\u0432\u0430\u0442\u044C \u0440\u0443\u0431\u0435\u0436 \u043F\u0440\u043E\u0442\u0438\u0432\u043D\u0438\u043A\u0430.'
    }), _react2.default.createElement(_reactIntl.FormattedMessage, {
        key: 'battle_title_tooltip.fort_battle.description_item3',
        id: 'battle_title_tooltip.fort_battle.description_item3',
        defaultMessage: '\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0435 \u0431\u043E\u0438 \u043F\u0440\u043E\u0445\u043E\u0434\u044F\u0442 \u0437\u0430 \u0440\u0443\u0431\u0435\u0436\u0438 \u043A\u043B\u0430\u043D\u043E\u0432.'
    }), _react2.default.createElement(_reactIntl.FormattedMessage, {
        key: 'battle_title_tooltip.fort_battle.description_item4',
        id: 'battle_title_tooltip.fort_battle.description_item4',
        defaultMessage: '\u041D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u0441\u044F \u043B\u0438\u0431\u043E \u0437\u0430\u0445\u0432\u0430\u0442\u043E\u043C \u0426\u0438\u0442\u0430\u0434\u0435\u043B\u0438 \u043F\u0440\u043E\u0442\u0438\u0432\u043D\u0438\u043A\u0430, \u043B\u0438\u0431\u043E \u043F\u043E \u0438\u0441\u0442\u0435\u0447\u0435\u043D\u0438\u0438 \u043E\u0442\u0432\u0435\u0434\u0451\u043D\u043D\u043E\u0433\u043E \u0432\u0440\u0435\u043C\u0435\u043D\u0438.'
    })],
    reward: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battle_title_tooltip.fort_battle.reward',
        defaultMessage: '\u041A\u043B\u0430\u043D \u043F\u043E\u043B\u0443\u0447\u0430\u0435\u0442 \u043D\u0430\u0433\u0440\u0430\u0434\u0443 \u0437\u0430 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043A\u043E\u043D\u0442\u0440\u043E\u043B\u0438\u0440\u0443\u0435\u043C\u044B\u0445 \u0438\u043C \u0440\u0443\u0431\u0435\u0436\u0435\u0439 \u043F\u043E \u0438\u0442\u043E\u0433\u0430\u043C \u041D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u044F. \u0427\u0435\u043C \u0431\u043E\u043B\u044C\u0448\u0435 \u0440\u0443\u0431\u0435\u0436\u0435\u0439 \u043F\u043E\u0434 \u043A\u043E\u043D\u0442\u0440\u043E\u043B\u0435\u043C \u043A\u043B\u0430\u043D\u0430, \u0442\u0435\u043C \u0432\u044B\u0448\u0435 \u043D\u0430\u0433\u0440\u0430\u0434\u0430. \u041A\u0440\u043E\u043C\u0435 \u0442\u043E\u0433\u043E, \u043A\u043B\u0430\u043D \u043F\u043E\u043B\u0443\u0447\u0430\u0435\u0442 \u043F\u0440\u043E\u043C\u0440\u0435\u0441\u0443\u0440\u0441 \u0437\u0430 \u043A\u0430\u0436\u0434\u044B\u0439 \u0431\u043E\u0439 \u0432 \u0445\u043E\u0434\u0435 \u041D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u044F.'
    })
};

var SORTIE_CONTENTS = exports.SORTIE_CONTENTS = {
    definition: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battle_title_tooltip.sortie.definition',
        defaultMessage: '\u0411\u043E\u0439 \u043C\u0435\u0436\u0434\u0443 \u043A\u043B\u0430\u043D\u0430\u043C\u0438 \u0437\u0430 \u043F\u0440\u043E\u043C\u0440\u0435\u0441\u0443\u0440\u0441 \u043D\u0430 \u043D\u0435\u0439\u0442\u0440\u0430\u043B\u044C\u043D\u043E\u0439 \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u0438.'
    }),
    description: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battle_title_tooltip.sortie.description',
        defaultMessage: '\u041A\u043B\u0430\u043D \u0441\u043E\u0431\u0438\u0440\u0430\u0435\u0442 \u043E\u0442\u0440\u044F\u0434 \u0438 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u0435\u0442 \u0433\u043E\u0442\u043E\u0432\u043D\u043E\u0441\u0442\u044C, \u043F\u043E\u0441\u043B\u0435 \u0447\u0435\u0433\u043E \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u043F\u043E\u0434\u0431\u0438\u0440\u0430\u0435\u0442\u0441\u044F \u043F\u0440\u043E\u0442\u0438\u0432\u043D\u0438\u043A. \u0411\u043E\u0439 \u043F\u0440\u043E\u0438\u0441\u0445\u043E\u0434\u0438\u0442 \u043D\u0430 \u0441\u043B\u0443\u0447\u0430\u0439\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435.'
    }),
    reward: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battle_title_tooltip.sortie.reward',
        defaultMessage: '\u0422\u0440\u043E\u0444\u0435\u0439\u043D\u044B\u0439 \u043F\u0440\u043E\u043C\u0440\u0435\u0441\u0443\u0440\u0441 \u0440\u0430\u0437\u0434\u0435\u043B\u044F\u0435\u0442\u0441\u044F \u043C\u0435\u0436\u0434\u0443 \u043A\u043B\u0430\u043D\u0430\u043C\u0438. \u041F\u043E\u0431\u0435\u0434\u0438\u0442\u0435\u043B\u044C \u043F\u043E\u043B\u0443\u0447\u0430\u0435\u0442 \u043E\u0441\u043D\u043E\u0432\u043D\u0443\u044E \u0434\u043E\u043B\u044E \u043D\u0430\u0433\u0440\u0430\u0434\u044B.'
    })
};

/***/ }),
/* 489 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"contents":"BattleTitleTooltip_contents--28yDi","title":"BattleTitleTooltip_title--2UroL","subtitle":"BattleTitleTooltip_subtitle--AJpgk","rewardSubtitle":"BattleTitleTooltip_rewardSubtitle--1Mvu2","schedule":"BattleTitleTooltip_schedule--2XMbX","list":"BattleTitleTooltip_list--33Z01","item":"BattleTitleTooltip_item--1LMTb","reward":"BattleTitleTooltip_reward--1eydC"};

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _translations = __webpack_require__(491);

var _Direction = __webpack_require__(492);

var _Direction2 = _interopRequireDefault(_Direction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Direction = function Direction(props) {
    var _classNames;

    var bonusNode = !props.bonus ? null : _react2.default.createElement(
        'div',
        { className: _Direction2.default.bonus },
        'x2'
    );
    var battleNode = !props.battle ? null : _react2.default.createElement('div', { className: _Direction2.default.battle });
    var modifierComponent = battleNode || bonusNode;

    var className = (0, _classnames2.default)(_Direction2.default.base, (_classNames = {}, _defineProperty(_classNames, _Direction2.default.base__bonus, props.bonus), _defineProperty(_classNames, _Direction2.default.base__battle, props.battle), _classNames));

    var tooltipProps = props.tooltipId ? {
        'data-tip': true,
        'data-for': props.tooltipId
    } : null;

    return _react2.default.createElement(
        'div',
        _extends({ className: className }, tooltipProps),
        modifierComponent,
        _react2.default.createElement(
            'div',
            { className: _Direction2.default.icon },
            _react2.default.createElement(
                'span',
                { className: _Direction2.default.shortName },
                _translations.NAME_BY_DIRECTION_SHORT[props.direction]
            )
        )
    );
};

Direction.propTypes = {
    direction: _propTypes2.default.string.isRequired,
    bonus: _propTypes2.default.bool,
    battle: _propTypes2.default.bool,
    tooltipId: _propTypes2.default.string
};

exports.default = Direction;

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NAME_BY_DIRECTION_SHORT = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NAME_BY_DIRECTION_SHORT = exports.NAME_BY_DIRECTION_SHORT = {
    A: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'postbattle_screen_subtitle.battle.direction_a_short',
        defaultMessage: 'С'
    }),
    B: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'postbattle_screen_subtitle.battle.direction_b_short',
        defaultMessage: 'В'
    }),
    C: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'postbattle_screen_subtitle.battle.direction_c_short',
        defaultMessage: 'Ю'
    }),
    D: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'postbattle_screen_subtitle.battle.direction_d_short',
        defaultMessage: 'З'
    })
};

/***/ }),
/* 492 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Direction_base--3OPCh","icon":"Direction_icon--LxwrV","base__bonus":"Direction_base__bonus---Dx4x","baseBonus":"Direction_base__bonus---Dx4x","base__battle":"Direction_base__battle--2xHvX","baseBattle":"Direction_base__battle--2xHvX","bonus":"Direction_bonus--2Efhz","battle":"Direction_battle--3kmCN","shortName":"Direction_shortName--1DG07"};

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactWotBootstrap = __webpack_require__(5);

var _constants = __webpack_require__(44);

var _constants2 = __webpack_require__(494);

var _FortBattleTooltip = __webpack_require__(495);

var _FortBattleTooltip2 = _interopRequireDefault(_FortBattleTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FortBattleTooltip = function FortBattleTooltip(props) {
    var bonusMessage = !props.bonus ? null : _react2.default.createElement(
        'div',
        { className: _FortBattleTooltip2.default.ribbon },
        _react2.default.createElement(
            'p',
            { className: _FortBattleTooltip2.default.bonus },
            _react2.default.createElement(
                'span',
                { className: _FortBattleTooltip2.default.icon },
                'x2'
            ),
            _constants2.FORT_BATTLE_TOOLTIP_BONUS
        )
    );

    var footer = void 0;
    if (props.isSelected) {
        footer = _constants.TOOLTIP_BACK_FOOTER;
    } else if (props.isRebuild) {
        footer = _constants.TOOLTIP_FOOTER_REBUILD;
    } else {
        footer = _constants.TOOLTIP_FOOTER;
    }

    return _react2.default.createElement(
        _reactWotBootstrap.Tooltip,
        { id: props.tooltipId },
        _react2.default.createElement(
            'div',
            { className: _FortBattleTooltip2.default.content },
            _react2.default.createElement(
                'h3',
                { className: _FortBattleTooltip2.default.title },
                (0, _constants2.FORT_BATTLE_TOOLTIP_TITLE)(props.direction)
            ),
            props.isSelected && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'p',
                    { className: _FortBattleTooltip2.default.selected },
                    _constants2.FORT_BATTLE_TOOLTIP_SELECTED
                ),
                _react2.default.createElement('div', { className: _FortBattleTooltip2.default.divider }),
                _react2.default.createElement(
                    'p',
                    { className: _FortBattleTooltip2.default.footer },
                    footer
                )
            ),
            !props.isSelected && _react2.default.createElement(
                'div',
                null,
                bonusMessage,
                props.battle ? _react2.default.createElement(
                    'p',
                    { className: _FortBattleTooltip2.default.engaged },
                    _constants2.FORT_BATTLE_TOOLTIP_ENGAGED
                ) : _react2.default.createElement(
                    'p',
                    { className: _FortBattleTooltip2.default.footer },
                    footer
                )
            )
        )
    );
};

FortBattleTooltip.propTypes = {
    tooltipId: _propTypes2.default.string.isRequired,
    direction: _propTypes2.default.string.isRequired,
    bonus: _propTypes2.default.bool,
    battle: _propTypes2.default.bool,
    isSelected: _propTypes2.default.bool,
    isRebuild: _propTypes2.default.bool
};

exports.default = FortBattleTooltip;

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FORT_BATTLE_TOOLTIP_SELECTED = exports.FORT_BATTLE_TOOLTIP_ENGAGED = exports.FORT_BATTLE_TOOLTIP_BONUS = exports.FORT_BATTLE_TOOLTIP_TITLE = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _i18n = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FORT_BATTLE_TOOLTIP_TITLE = exports.FORT_BATTLE_TOOLTIP_TITLE = function FORT_BATTLE_TOOLTIP_TITLE(direction) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'fort_battle_tooltip.title',
        defaultMessage: '\u041D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u0435 \u0441 {direction} \u043F\u043B\u0430\u0446\u0434\u0430\u0440\u043C\u0430',
        values: {
            direction: _i18n.NAME_BY_DIRECTION_SPELLED[direction]
        }
    });
};

var FORT_BATTLE_TOOLTIP_BONUS = exports.FORT_BATTLE_TOOLTIP_BONUS = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'fort_battle_tooltip.bonus_text',
    defaultMessage: '\u0423\u0434\u0432\u043E\u0435\u043D\u043D\u044B\u0439 \u043F\u0440\u043E\u043C\u0440\u0435\u0441\u0443\u0440\u0441 \u0437\u0430 \u043F\u0435\u0440\u0432\u0443\u044E \u043F\u043E\u0431\u0435\u0434\u0443 \u0432 \u0434\u0435\u043D\u044C \u043F\u0440\u0438 \u041D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u0438 \u0441 \u044D\u0442\u043E\u0433\u043E \u043F\u043B\u0430\u0446\u0434\u0430\u0440\u043C\u0430'
});

var FORT_BATTLE_TOOLTIP_ENGAGED = exports.FORT_BATTLE_TOOLTIP_ENGAGED = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'fort_battle_tooltip.engaged',
    defaultMessage: '\u041F\u043B\u0430\u0446\u0434\u0430\u0440\u043C \u0437\u0430\u043D\u044F\u0442 \u0434\u0440\u0443\u0433\u0438\u043C \u043E\u0442\u0440\u044F\u0434\u043E\u043C \u043A\u043B\u0430\u043D\u0430'
});

var FORT_BATTLE_TOOLTIP_SELECTED = exports.FORT_BATTLE_TOOLTIP_SELECTED = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'fort_battle_tooltip.selected',
    defaultMessage: '\u0422\u0435\u043A\u0443\u0449\u0438\u0439 \u043F\u043B\u0430\u0446\u0434\u0430\u0440\u043C'
});

/***/ }),
/* 495 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"FortBattleTooltip_root--1gzOn","root__show":"FortBattleTooltip_root__show--3RzmT","rootShow":"FortBattleTooltip_root__show--3RzmT","body":"FortBattleTooltip_body--1V56F","wrapper":"FortBattleTooltip_wrapper--17BIM","content":"FortBattleTooltip_content--3sOjV","title":"FortBattleTooltip_title--3Wc8d","subtitle":"FortBattleTooltip_subtitle--3TjT1","message":"FortBattleTooltip_message--RSXOE","warning":"FortBattleTooltip_warning--3twNa","divider":"FortBattleTooltip_divider--1--OV","highlight":"FortBattleTooltip_highlight--3sMRy","ribbon":"FortBattleTooltip_ribbon--2zS8D","statusMessage":"FortBattleTooltip_statusMessage--3ON4E","statusMessage__positive":"FortBattleTooltip_statusMessage__positive--XSdTA","statusMessagePositive":"FortBattleTooltip_statusMessage__positive--XSdTA","status":"FortBattleTooltip_status--XcLt4","statusMessage__negative":"FortBattleTooltip_statusMessage__negative--SqkJG","statusMessageNegative":"FortBattleTooltip_statusMessage__negative--SqkJG","statusMessage__noPermission":"FortBattleTooltip_statusMessage__noPermission--1cIEk","statusMessageNoPermission":"FortBattleTooltip_statusMessage__noPermission--1cIEk","status__positive":"FortBattleTooltip_status__positive--1U8rf","statusPositive":"FortBattleTooltip_status__positive--1U8rf","status__negative":"FortBattleTooltip_status__negative--2SE7L","statusNegative":"FortBattleTooltip_status__negative--2SE7L","statusText":"FortBattleTooltip_statusText--1SiXJ","bonus":"FortBattleTooltip_bonus--1XnS2","icon":"FortBattleTooltip_icon--1JzDE","selected":"FortBattleTooltip_selected--cz6OZ","engaged":"FortBattleTooltip_engaged--1UiPH","footer":"FortBattleTooltip_footer--18TH5"};

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _helpers = __webpack_require__(11);

var _constants = __webpack_require__(4);

var _Level = __webpack_require__(497);

var _Level2 = _interopRequireDefault(_Level);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Level = function Level(props) {
    return _react2.default.createElement(
        'div',
        { className: _Level2.default.base, 'data-tip': true, 'data-for': props.tooltipId },
        _react2.default.createElement(
            'span',
            { className: _Level2.default.icon },
            (0, _helpers.toRoman)(_constants.SORTIE_LEVELS[props.level]),
            _react2.default.createElement(
                'span',
                { className: _Level2.default['icon-shadow'] },
                (0, _helpers.toRoman)(_constants.SORTIE_LEVELS[props.level])
            )
        )
    );
};

Level.propTypes = {
    // WGSH-2679 replace string property into integer and use data from response
    level: _propTypes2.default.string.isRequired,
    tooltipId: _propTypes2.default.string.isRequired
};

exports.default = Level;

/***/ }),
/* 497 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Level_base--1Kwer","icon":"Level_icon--26LzJ","icon-shadow":"Level_icon-shadow--nPucD","iconShadow":"Level_icon-shadow--nPucD"};

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(499);

var _Option = __webpack_require__(500);

var _Option2 = _interopRequireDefault(_Option);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Option = function Option(props) {
    var className = (0, _classnames2.default)(_Option2.default.base, _Option2.default['base__' + props.type]);

    return _react2.default.createElement(
        'div',
        { className: className, 'data-tip': true, 'data-for': props.tooltipId },
        props.value
    );
};

Option.TYPES = _constants.OPTION_TYPES;

Option.propTypes = {
    value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number, _propTypes2.default.element]).isRequired,
    type: _propTypes2.default.oneOf(Object.values(_constants.OPTION_TYPES)),
    tooltipId: _propTypes2.default.string.isRequired
};

exports.default = Option;

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var OPTION_TYPES = exports.OPTION_TYPES = {
    level: 'level',
    duration: 'duration',
    players: 'players',
    legionaries: 'legionaries'
};

/***/ }),
/* 500 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Option_base--1XONE","base__level":"Option_base__level--39Kt0","baseLevel":"Option_base__level--39Kt0","base__duration":"Option_base__duration--1FcvE","baseDuration":"Option_base__duration--1FcvE","base__players":"Option_base__players--rqMon","basePlayers":"Option_base__players--rqMon","base__legionaries":"Option_base__legionaries--1nlp5","baseLegionaries":"Option_base__legionaries--1nlp5"};

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _helpers = __webpack_require__(11);

var _datetime = __webpack_require__(13);

var _components = __webpack_require__(69);

var _constants = __webpack_require__(44);

var _Options = __webpack_require__(502);

var _Options2 = _interopRequireDefault(_Options);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Options = function Options(props) {

    var vehicleLevels = function vehicleLevels() {
        var min = props.battleRegulations.min_vehicle_level;
        var max = props.battleRegulations.max_vehicle_level;

        return min === max ? (0, _helpers.toRoman)(max) : (0, _helpers.toRoman)(min) + '-' + (0, _helpers.toRoman)(max);
    };

    var playersNumber = function playersNumber() {
        var min = props.battleRegulations.min_players_number;
        var max = props.battleRegulations.max_players_number;

        return min === max ? max : min + '-' + max;
    };

    var battleDuration = (0, _datetime.getMinutesFormat)(props.battleRegulations.battle_duration / 60);

    var className = (0, _classnames2.default)(_Options2.default.base, _defineProperty({}, _Options2.default.base__viewInline, props.inline));

    var battleDurationTooltipId = props.inline ? _constants.STATIC_TOOLTIPS_ID.fort_battle_duration : _constants.STATIC_TOOLTIPS_ID.sortie_duration;

    return _react2.default.createElement(
        'div',
        { className: className },
        _react2.default.createElement(
            'div',
            { className: _Options2.default.item },
            _react2.default.createElement(_components.Option, {
                type: _components.Option.TYPES.level,
                value: vehicleLevels(),
                tooltipId: _constants.STATIC_TOOLTIPS_ID.vehicle_levels
            })
        ),
        _react2.default.createElement(
            'div',
            { className: _Options2.default.item },
            _react2.default.createElement(_components.Option, {
                type: _components.Option.TYPES.players,
                value: playersNumber(),
                tooltipId: _constants.STATIC_TOOLTIPS_ID.players_count
            })
        ),
        _react2.default.createElement(
            'div',
            { className: _Options2.default.item },
            _react2.default.createElement(_components.Option, {
                type: _components.Option.TYPES.duration,
                value: battleDuration,
                tooltipId: battleDurationTooltipId
            })
        ),
        _react2.default.createElement(
            'div',
            { className: _Options2.default.item },
            _react2.default.createElement(_components.Option, {
                type: _components.Option.TYPES.legionaries,
                value: props.battleRegulations.max_legionaries_number,
                tooltipId: _constants.STATIC_TOOLTIPS_ID.legionaries_count
            })
        )
    );
};

Options.propTypes = {
    battleRegulations: _propTypes2.default.object.isRequired,
    inline: _propTypes2.default.bool
};

exports.default = Options;

/***/ }),
/* 502 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Options_base--1hFbu","base__viewInline":"Options_base__viewInline--1Wgnj","baseViewInline":"Options_base__viewInline--1Wgnj","item":"Options_item--1Kyr5"};

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _IndustrialResource = __webpack_require__(35);

var _IndustrialResource2 = _interopRequireDefault(_IndustrialResource);

var _constants = __webpack_require__(504);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _Reward = __webpack_require__(505);

var _Reward2 = _interopRequireDefault(_Reward);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Reward = function Reward(props) {

    var perBattleTooltipProps = props.perBattleTooltipId ? {
        'data-tip': true,
        'data-for': props.perBattleTooltipId
    } : null;

    var valueClassName = (0, _classnames2.default)(_Reward2.default.value, _defineProperty({}, _Reward2.default.value__bonus, props.bonus));

    return _react2.default.createElement(
        'div',
        { className: _Reward2.default.base },
        _react2.default.createElement(
            'div',
            { className: valueClassName },
            _react2.default.createElement(_IndustrialResource2.default, { value: props.value, popoverId: props.valueTooltipId, custom: true })
        ),
        props.perBattleReward && _react2.default.createElement(
            'p',
            _extends({ className: _Reward2.default.perBattleReward }, perBattleTooltipProps),
            _react2.default.createElement(
                'span',
                { className: _Reward2.default.sign },
                '+'
            ),
            _react2.default.createElement(_IndustrialResource2.default, { value: props.perBattleReward, small: true }),
            '\u2002',
            _constants.REWARD_PER_BATTLE
        )
    );
};

Reward.propTypes = {
    value: _propTypes2.default.number.isRequired,
    perBattleReward: _propTypes2.default.number,
    valueTooltipId: _propTypes2.default.string,
    perBattleTooltipId: _propTypes2.default.string,
    bonus: _propTypes2.default.bool
};

exports.default = Reward;

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.REWARD_PER_BATTLE = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REWARD_PER_BATTLE = exports.REWARD_PER_BATTLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_wizard.reward_per_battle',
    defaultMessage: '\u0437\u0430 \u043A\u0430\u0436\u0434\u044B\u0439 \u0431\u043E\u0439'
});

/***/ }),
/* 505 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Reward_base--2SKmW","perBattleReward":"Reward_perBattleReward--1lmS5","sign":"Reward_sign--2_uHb","value":"Reward_value--3chV2","value__bonus":"Reward_value__bonus--1KY1p","valueBonus":"Reward_value__bonus--1KY1p"};

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

var _constants = __webpack_require__(4);

var _constants2 = __webpack_require__(507);

var _Schedule = __webpack_require__(508);

var _Schedule2 = _interopRequireDefault(_Schedule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var formatTime = function formatTime(time) {
    return _moment2.default.utc(time).local().format('LT');
};

var Schedule = function (_React$Component) {
    _inherits(Schedule, _React$Component);

    function Schedule() {
        _classCallCheck(this, Schedule);

        return _possibleConstructorReturn(this, (Schedule.__proto__ || Object.getPrototypeOf(Schedule)).apply(this, arguments));
    }

    _createClass(Schedule, [{
        key: 'getSortieSchedule',
        value: function getSortieSchedule() {
            return _react2.default.createElement(
                'div',
                null,
                this.props.peripheries.map(function (periphery) {
                    return _react2.default.createElement(
                        'p',
                        { className: _Schedule2.default.item, key: 'sorties-periphery-' + periphery.periphery_id },
                        _react2.default.createElement(
                            'span',
                            { className: _Schedule2.default.periphery },
                            periphery.name,
                            ':'
                        ),
                        _react2.default.createElement(
                            'span',
                            null,
                            formatTime(periphery.primetime_start),
                            ' - ',
                            formatTime(periphery.primetime_end)
                        )
                    );
                })
            );
        }
    }, {
        key: 'getFortBattleSchedule',
        value: function getFortBattleSchedule() {
            return _react2.default.createElement(
                'div',
                null,
                this.props.peripheries.map(function (periphery) {
                    var tickLastIdx = periphery.matchmaker_ticks.length - 1;
                    var ticks = periphery.matchmaker_ticks.map(function (time, idx) {
                        var isLastTick = idx === tickLastIdx;
                        var divider = isLastTick ? '' : ', ';
                        return _react2.default.createElement(
                            'span',
                            { key: 'fort-battle-time-' + time },
                            formatTime(time),
                            divider
                        );
                    });
                    return _react2.default.createElement(
                        'p',
                        { className: _Schedule2.default.item, key: 'fort-battle-periphery-' + periphery.periphery_id },
                        _react2.default.createElement(
                            'span',
                            { className: _Schedule2.default.periphery },
                            periphery.name,
                            ':'
                        ),
                        ticks
                    );
                })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var peripheriesSchedule = void 0;
            if (this.props.type === _constants.UNIT_TYPES.SORTIE) {
                peripheriesSchedule = this.getSortieSchedule();
            } else if (this.props.type === _constants.UNIT_TYPES.FORT_BATTLE) {
                peripheriesSchedule = this.getFortBattleSchedule();
            }

            var className = (0, _classnames2.default)(_Schedule2.default.base, _defineProperty({}, _Schedule2.default.base__tooltip, this.props.tooltip));

            var titleComponent = _react2.default.createElement(
                'p',
                { className: _Schedule2.default.title },
                _constants2.TITLES[this.props.type],
                this.props.tooltip ? ':' : ''
            );

            return _react2.default.createElement(
                'div',
                { className: className },
                titleComponent,
                peripheriesSchedule
            );
        }
    }]);

    return Schedule;
}(_react2.default.Component);

Schedule.propTypes = {
    type: _propTypes2.default.oneOf(Object.values(_constants.UNIT_TYPES)).isRequired,
    peripheries: _propTypes2.default.array.isRequired,
    tooltip: _propTypes2.default.bool
};
exports.default = Schedule;

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TITLES = undefined;

var _TITLES;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TITLES = exports.TITLES = (_TITLES = {}, _defineProperty(_TITLES, _constants.UNIT_TYPES.SORTIE, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battles_schedule.sortie.title',
    defaultMessage: '\u041F\u0435\u0440\u0438\u043E\u0434\u044B \u0432\u044B\u043B\u0430\u0437\u043E\u043A'
})), _defineProperty(_TITLES, _constants.UNIT_TYPES.FORT_BATTLE, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battles_schedule.fort_battle.title',
    defaultMessage: '\u041D\u0430\u0447\u0430\u043B\u043E \u041D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u0439'
})), _TITLES);

/***/ }),
/* 508 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Schedule_base--1lU3e","base__tooltip":"Schedule_base__tooltip--26E_a","baseTooltip":"Schedule_base__tooltip--26E_a","title":"Schedule_title--2jL_N","item":"Schedule_item--1GbIK","periphery":"Schedule_periphery--1zO6R"};

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _helpers = __webpack_require__(11);

var _reactWotBootstrap = __webpack_require__(5);

var _constants = __webpack_require__(44);

var _constants2 = __webpack_require__(4);

var _constants3 = __webpack_require__(510);

var _SortieTooltip = __webpack_require__(511);

var _SortieTooltip2 = _interopRequireDefault(_SortieTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SortieTooltip = function SortieTooltip(props) {
    return _react2.default.createElement(
        _reactWotBootstrap.Tooltip,
        { id: props.tooltipId },
        _react2.default.createElement(
            'div',
            { className: _SortieTooltip2.default.content },
            _react2.default.createElement(
                'h3',
                { className: _SortieTooltip2.default.title },
                (0, _constants3.SORTIE_TOOLTIP_TITLE)((0, _helpers.toRoman)(_constants2.SORTIE_LEVELS[props.division]))
            ),
            props.isSelected && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'p',
                    { className: _SortieTooltip2.default.selected },
                    _constants3.SORTIE_TOOLTIP_SELECTED
                ),
                _react2.default.createElement('div', { className: _SortieTooltip2.default.divider }),
                _react2.default.createElement(
                    'p',
                    { className: _SortieTooltip2.default.footer },
                    _constants.TOOLTIP_BACK_FOOTER
                )
            ),
            !props.isSelected && _react2.default.createElement(
                'p',
                { className: _SortieTooltip2.default.footer },
                props.isRebuild ? _constants.TOOLTIP_FOOTER_REBUILD : _constants.TOOLTIP_FOOTER
            )
        )
    );
};

SortieTooltip.propTypes = {
    tooltipId: _propTypes2.default.string.isRequired,
    division: _propTypes2.default.string.isRequired,
    isSelected: _propTypes2.default.bool,
    isRebuild: _propTypes2.default.bool
};

exports.default = SortieTooltip;

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SORTIE_TOOLTIP_SELECTED = exports.SORTIE_TOOLTIP_TITLE = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SORTIE_TOOLTIP_TITLE = exports.SORTIE_TOOLTIP_TITLE = function SORTIE_TOOLTIP_TITLE(level) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'sortie_tooltip.title',
        defaultMessage: '\u0412\u044B\u043B\u0430\u0437\u043A\u0430 \u0432 {level} \u0434\u0438\u0432\u0438\u0437\u0438\u043E\u043D\u0435',
        values: {
            level: level
        }
    });
};

var SORTIE_TOOLTIP_SELECTED = exports.SORTIE_TOOLTIP_SELECTED = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'sortie_tooltip.selected',
    defaultMessage: '\u0422\u0435\u043A\u0443\u0449\u0438\u0439 \u0434\u0438\u0432\u0438\u0437\u0438\u043E\u043D'
});

/***/ }),
/* 511 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"SortieTooltip_root--39hIm","root__show":"SortieTooltip_root__show--1jnsp","rootShow":"SortieTooltip_root__show--1jnsp","body":"SortieTooltip_body--KFc_e","wrapper":"SortieTooltip_wrapper--2FySh","content":"SortieTooltip_content--3AXNH","title":"SortieTooltip_title--3oPLp","subtitle":"SortieTooltip_subtitle--3CRim","message":"SortieTooltip_message--1mH9S","warning":"SortieTooltip_warning--2WELx","divider":"SortieTooltip_divider--1v-rQ","highlight":"SortieTooltip_highlight--3qEV8","ribbon":"SortieTooltip_ribbon--3aC9I","statusMessage":"SortieTooltip_statusMessage--HCsfp","statusMessage__positive":"SortieTooltip_statusMessage__positive--3Ghbd","statusMessagePositive":"SortieTooltip_statusMessage__positive--3Ghbd","status":"SortieTooltip_status--3hW0g","statusMessage__negative":"SortieTooltip_statusMessage__negative--39hfQ","statusMessageNegative":"SortieTooltip_statusMessage__negative--39hfQ","statusMessage__noPermission":"SortieTooltip_statusMessage__noPermission--3sMPd","statusMessageNoPermission":"SortieTooltip_statusMessage__noPermission--3sMPd","status__positive":"SortieTooltip_status__positive--n02XX","statusPositive":"SortieTooltip_status__positive--n02XX","status__negative":"SortieTooltip_status__negative--3sUks","statusNegative":"SortieTooltip_status__negative--3sUks","statusText":"SortieTooltip_statusText--3s1ub","selected":"SortieTooltip_selected--3QbR7","footer":"SortieTooltip_footer--36YAr"};

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _datetime = __webpack_require__(13);

var _Timer = __webpack_require__(51);

var _Timer2 = _interopRequireDefault(_Timer);

var _constants = __webpack_require__(4);

var _constants2 = __webpack_require__(513);

var _constants3 = __webpack_require__(44);

var _i18n = __webpack_require__(10);

var _Status = __webpack_require__(514);

var _Status2 = _interopRequireDefault(_Status);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Status = function (_React$Component) {
    _inherits(Status, _React$Component);

    function Status() {
        _classCallCheck(this, Status);

        return _possibleConstructorReturn(this, (Status.__proto__ || Object.getPrototypeOf(Status)).apply(this, arguments));
    }

    _createClass(Status, [{
        key: 'getTimer',
        value: function getTimer() {
            var _props = this.props,
                primetimeStart = _props.primetimeStart,
                primetimeEnd = _props.primetimeEnd,
                type = _props.type;


            if (!this.props.isAvailable) {
                return {
                    timer: (0, _datetime.getEndDateMessage)((0, _moment2.default)(primetimeStart)),
                    status: _constants2.STATUS_MESSAGES.STARTS_NOT_SOON,
                    expiresSoon: false
                };
            }

            if (type === _constants.UNIT_TYPES.SORTIE) {
                var mSecondsTillStart = primetimeStart ? primetimeStart - Date.now() : null;
                var mSecondsTillEnd = primetimeEnd ? primetimeEnd - Date.now() : null;

                if (primetimeStart && primetimeEnd && primetimeStart < primetimeEnd && mSecondsTillStart > 0) {
                    return {
                        status: _constants2.STATUS_MESSAGES.STARTS_SOON,
                        timer: _react2.default.createElement(_Timer2.default, { endTime: (0, _moment2.default)(primetimeStart), shortFormat: true }),
                        expiresSoon: true
                    };
                } else if (mSecondsTillEnd && mSecondsTillEnd < _constants3.SORTIES_END_INTERIM) {
                    return {
                        status: _i18n.CHALLENGES_END,
                        timer: _react2.default.createElement(_Timer2.default, { endTime: (0, _moment2.default)(primetimeEnd), shortFormat: true }),
                        expiresSoon: true
                    };
                } else {
                    return {
                        status: _constants2.STATUS_MESSAGES.BATTLES_AVAILABLE,
                        timer: null,
                        expiresSoon: false
                    };
                }
            } else if (type === _constants.UNIT_TYPES.FORT_BATTLE) {
                return {
                    status: _constants2.STATUS_MESSAGES.STARTS_SOON,
                    timer: _react2.default.createElement(_Timer2.default, { endTime: (0, _moment2.default)(primetimeStart), shortFormat: true }),
                    expiresSoon: true
                };
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _getTimer = this.getTimer(),
                status = _getTimer.status,
                timer = _getTimer.timer,
                expiresSoon = _getTimer.expiresSoon;

            var className = (0, _classnames2.default)(_Status2.default.base, _defineProperty({}, _Status2.default.base__soon, expiresSoon));
            return _react2.default.createElement(
                'div',
                { className: className },
                _react2.default.createElement(
                    'div',
                    { className: _Status2.default.holder },
                    _react2.default.createElement(
                        'div',
                        { className: _Status2.default.content },
                        _react2.default.createElement(
                            'p',
                            { className: _Status2.default.title },
                            status
                        ),
                        _react2.default.createElement(
                            'p',
                            { className: _Status2.default.timer },
                            timer
                        )
                    )
                )
            );
        }
    }]);

    return Status;
}(_react2.default.Component);

Status.propTypes = {
    primetimeStart: _propTypes2.default.number,
    primetimeEnd: _propTypes2.default.number,
    isAvailable: _propTypes2.default.bool,
    type: _propTypes2.default.oneOf(Object.values(_constants.UNIT_TYPES)).isRequired
};
Status.defaultProps = {
    isAvailable: false
};
exports.default = Status;

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.STATUS_MESSAGES = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STATUS_MESSAGES = exports.STATUS_MESSAGES = {
    BATTLES_AVAILABLE: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battle_wizard_status.battles_available',
        defaultMessage: '\u0412\u044B\u043B\u0430\u0437\u043A\u0438 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B'
    }),
    START_UNKNOWN: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battle_wizard_status.begin_unknown',
        defaultMessage: '\u041D\u0430\u0447\u0430\u043B\u043E \u0443\u0442\u043E\u0447\u043D\u0438\u0442\u0441\u044F \u043F\u043E\u0437\u0436\u0435'
    }),
    STARTS_NOT_SOON: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battle_wizard_status.begin_not_soon',
        defaultMessage: '\u041D\u0430\u0447\u0430\u043B\u043E:'
    }),
    STARTS_SOON: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'battle_wizard_status.begin_soon',
        defaultMessage: '\u0414\u043E \u043D\u0430\u0447\u0430\u043B\u0430'
    })
};

/***/ }),
/* 514 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Status_base--2RLkO","holder":"Status_holder--798ey","content":"Status_content--2grUB","title":"Status_title--m4sYD","timer":"Status_timer--2NUZi","base__soon":"Status_base__soon--2SMkZ","baseSoon":"Status_base__soon--2SMkZ"};

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _helpers = __webpack_require__(11);

var _datetime = __webpack_require__(13);

var _peripheries = __webpack_require__(37);

var _i18n = __webpack_require__(10);

var _Warning = __webpack_require__(107);

var _Warning2 = _interopRequireDefault(_Warning);

var _components = __webpack_require__(69);

var _constants = __webpack_require__(4);

var _constants2 = __webpack_require__(516);

var _UnavailableBattle = __webpack_require__(517);

var _UnavailableBattle2 = _interopRequireDefault(_UnavailableBattle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var UnavailableBattle = function UnavailableBattle(props) {
    var availablePeripheries = (0, _peripheries.getAvailablePeripheries)(props.peripheries, props.type);

    var isPeripheriesAvailable = props.peripheries.length > 0;

    var warning = _constants2.UNAVAILABLE_CURRENT_PERIPHERY_MESSAGES[props.type];
    var contentComponent = void 0;
    var footerComponent = void 0;
    var status = void 0;

    if (props.isFine) {
        warning = _constants2.UNAVAILABLE_BATTLE_FINE_WARNING;
        status = _react2.default.createElement(_components.Status, {
            primetimeStart: props.primetimeStart,
            type: props.type,
            isAvailable: true
        });
        contentComponent = _react2.default.createElement(
            'div',
            { className: _UnavailableBattle2.default.information },
            _constants2.UNAVAILABLE_BATTLE_FINE_CONDITIONS
        );
        footerComponent = _react2.default.createElement(
            'div',
            { className: _UnavailableBattle2.default.footer },
            _i18n.NEGATIVE_IR_BALANCE_HINT
        );
    } else if (isPeripheriesAvailable) {

        var isAvailableOnCurrentPeriphery = props.peripheryName !== null;
        var startTime = (0, _moment2.default)(props.primetimeStart);

        if (isAvailableOnCurrentPeriphery) {
            if ((0, _datetime.isTodayDay)(startTime)) {
                warning = (0, _constants2.UNAVAILABLE_BATTLE_MESSAGES_TODAY)(props.peripheryName, startTime.format('LT'))[props.type];
            } else if ((0, _datetime.isTomorrowDay)(startTime)) {
                warning = (0, _constants2.UNAVAILABLE_BATTLE_MESSAGES_TOMORROW)(props.peripheryName, startTime.format('LT'))[props.type];
            }
        }

        var isAvailableOnAnyPeriphery = availablePeripheries.length > 0;
        if (isAvailableOnAnyPeriphery) {
            var peripheriesList = (0, _peripheries.getPeripheriesList)(availablePeripheries);

            contentComponent = _react2.default.createElement(
                'div',
                { className: _UnavailableBattle2.default.information },
                _react2.default.createElement(
                    'p',
                    { className: _UnavailableBattle2.default.peripheries },
                    _constants2.UNAVAILABLE_BATTLE_AVAILABLE_SERVERS[props.type],
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                        'span',
                        { className: _UnavailableBattle2.default.servers },
                        peripheriesList
                    )
                )
            );
            footerComponent = _react2.default.createElement(
                'div',
                { className: _UnavailableBattle2.default.footer },
                (0, _constants2.UNAVAILABLE_BATTLE_FOOTER_MESSAGE)(_react2.default.createElement('span', { className: _UnavailableBattle2.default.settings }))
            );
        } else {
            contentComponent = _react2.default.createElement(
                'div',
                { className: _UnavailableBattle2.default.information },
                _react2.default.createElement(_components.Schedule, {
                    peripheries: props.peripheries,
                    type: props.type
                })
            );
        }
    }

    var className = (0, _classnames2.default)(_UnavailableBattle2.default.base, _UnavailableBattle2.default['base__' + (0, _helpers.toCssClass)(props.type)]);

    var messageClassName = (0, _classnames2.default)(_UnavailableBattle2.default.message, _defineProperty({}, _UnavailableBattle2.default.message__unavailablePeripheries, !isPeripheriesAvailable));

    return _react2.default.createElement(
        'div',
        { className: className },
        _react2.default.createElement(
            'div',
            { className: _UnavailableBattle2.default.holder },
            _react2.default.createElement(
                'div',
                { className: _UnavailableBattle2.default.header },
                _react2.default.createElement(_components.BattleTitle, { type: props.type })
            ),
            status,
            _react2.default.createElement(
                'div',
                { className: messageClassName },
                _react2.default.createElement(
                    _Warning2.default,
                    { type: 'warning' },
                    warning
                )
            ),
            contentComponent,
            footerComponent
        )
    );
};

UnavailableBattle.propTypes = {
    type: _propTypes2.default.oneOf(Object.values(_constants.UNIT_TYPES)).isRequired,
    peripheries: _propTypes2.default.array,
    peripheryName: _propTypes2.default.string,
    primetimeStart: _propTypes2.default.number,
    isFine: _propTypes2.default.bool
};

exports.default = UnavailableBattle;

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UNAVAILABLE_BATTLE_FINE_CONDITIONS = exports.UNAVAILABLE_BATTLE_FINE_WARNING = exports.UNAVAILABLE_BATTLE_FOOTER_MESSAGE = exports.UNAVAILABLE_BATTLE_AVAILABLE_SERVERS = exports.UNAVAILABLE_CURRENT_PERIPHERY_MESSAGES = exports.UNAVAILABLE_BATTLE_MESSAGES_TOMORROW = exports.UNAVAILABLE_BATTLE_MESSAGES_TODAY = undefined;

var _UNAVAILABLE_CURRENT_, _UNAVAILABLE_BATTLE_A;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint-disable react/no-multi-comp */

var UNAVAILABLE_BATTLE_MESSAGES_TODAY = exports.UNAVAILABLE_BATTLE_MESSAGES_TODAY = function UNAVAILABLE_BATTLE_MESSAGES_TODAY(peripheryName, availableTime) {
    var _ref;

    return _ref = {}, _defineProperty(_ref, _constants.UNIT_TYPES.SORTIE, _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'unavailable_battle.message.sortie_today',
        defaultMessage: '\u0412\u044B\u043B\u0430\u0437\u043A\u0438 \u043D\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0435 {peripheryName} \u043D\u0430\u0447\u043D\u0443\u0442\u0441\u044F \u0441\u0435\u0433\u043E\u0434\u043D\u044F \u0432 {availableTime}',
        values: {
            peripheryName: peripheryName,
            availableTime: availableTime
        }
    })), _defineProperty(_ref, _constants.UNIT_TYPES.FORT_BATTLE, _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'unavailable_battle.message.fort_battle_today',
        defaultMessage: '\u041D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u044F \u043D\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0435 {peripheryName} \u043D\u0430\u0447\u043D\u0443\u0442\u0441\u044F \u0441\u0435\u0433\u043E\u0434\u043D\u044F \u0432 {availableTime}',
        values: {
            peripheryName: peripheryName,
            availableTime: availableTime
        }
    })), _ref;
};

var UNAVAILABLE_BATTLE_MESSAGES_TOMORROW = exports.UNAVAILABLE_BATTLE_MESSAGES_TOMORROW = function UNAVAILABLE_BATTLE_MESSAGES_TOMORROW(peripheryName, availableTime) {
    var _ref2;

    return _ref2 = {}, _defineProperty(_ref2, _constants.UNIT_TYPES.SORTIE, _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'unavailable_battle.message.sortie_tomorrow',
        defaultMessage: '\u0412\u044B\u043B\u0430\u0437\u043A\u0438 \u043D\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0435 {peripheryName} \u043D\u0430\u0447\u043D\u0443\u0442\u0441\u044F \u0437\u0430\u0432\u0442\u0440\u0430 \u0432 {availableTime}',
        values: {
            peripheryName: peripheryName,
            availableTime: availableTime
        }
    })), _defineProperty(_ref2, _constants.UNIT_TYPES.FORT_BATTLE, _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'unavailable_battle.message.fort_battle_tomorrow',
        defaultMessage: '\u041D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u044F \u043D\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0435 {peripheryName} \u0437\u0430\u0432\u0442\u0440\u0430 \u0432 {availableTime}',
        values: {
            peripheryName: peripheryName,
            availableTime: availableTime
        }
    })), _ref2;
};

var UNAVAILABLE_CURRENT_PERIPHERY_MESSAGES = exports.UNAVAILABLE_CURRENT_PERIPHERY_MESSAGES = (_UNAVAILABLE_CURRENT_ = {}, _defineProperty(_UNAVAILABLE_CURRENT_, _constants.UNIT_TYPES.SORTIE, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'unavailable_current_periphery.sorties',
    defaultMessage: '\u0412\u044B\u043B\u0430\u0437\u043A\u0438 \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B. \u0412\u0440\u0435\u043C\u044F \u043D\u0430\u0447\u0430\u043B\u0430 \u0441\u0442\u0430\u043D\u0435\u0442 \u0438\u0437\u0432\u0435\u0441\u0442\u043D\u043E \u043F\u043E\u0437\u0436\u0435.'
})), _defineProperty(_UNAVAILABLE_CURRENT_, _constants.UNIT_TYPES.FORT_BATTLE, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'unavailable_current_periphery.fort_battles',
    defaultMessage: '\u041D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u044F \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B. \u0412\u0440\u0435\u043C\u044F \u043D\u0430\u0447\u0430\u043B\u0430 \u0441\u0442\u0430\u043D\u0435\u0442 \u0438\u0437\u0432\u0435\u0441\u0442\u043D\u043E \u043F\u043E\u0437\u0436\u0435.'
})), _UNAVAILABLE_CURRENT_);

var UNAVAILABLE_BATTLE_AVAILABLE_SERVERS = exports.UNAVAILABLE_BATTLE_AVAILABLE_SERVERS = (_UNAVAILABLE_BATTLE_A = {}, _defineProperty(_UNAVAILABLE_BATTLE_A, _constants.UNIT_TYPES.SORTIE, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'unavailable_battle.available_servers.sortie',
    defaultMessage: '\u0421\u0435\u0439\u0447\u0430\u0441 \u0412\u044B\u043B\u0430\u0437\u043A\u0438 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B \u043D\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430\u0445:'
})), _defineProperty(_UNAVAILABLE_BATTLE_A, _constants.UNIT_TYPES.FORT_BATTLE, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'unavailable_battle.available_servers.fort_battle',
    defaultMessage: '\u0421\u0435\u0439\u0447\u0430\u0441 \u041D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u044F \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B \u043D\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0430\u0445:'
})), _UNAVAILABLE_BATTLE_A);

var UNAVAILABLE_BATTLE_FOOTER_MESSAGE = exports.UNAVAILABLE_BATTLE_FOOTER_MESSAGE = function UNAVAILABLE_BATTLE_FOOTER_MESSAGE(icon) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'unavailable_battle.footer_message',
        defaultMessage: 'To select a different server, close the mode selection window and click on {icon} in the bottom right corner.' // eslint-disable-line max-len
        , values: { icon: icon }
    });
};

var UNAVAILABLE_BATTLE_FINE_WARNING = exports.UNAVAILABLE_BATTLE_FINE_WARNING = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'unavailable_battle.fine_warning',
    defaultMessage: '\u0414\u0435\u0439\u0441\u0442\u0432\u0443\u0435\u0442 \u0448\u0442\u0440\u0430\u0444: \u0443\u0447\u0430\u0441\u0442\u0438\u0435 \u0432 \u041D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u044F\u0445 \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E'
});

var UNAVAILABLE_BATTLE_FINE_CONDITIONS = exports.UNAVAILABLE_BATTLE_FINE_CONDITIONS = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'unavailable_battle.fine_conditions',
    defaultMessage: '\u0418\u0433\u0440\u043E\u043A\u0438 \u043A\u043B\u0430\u043D\u0430 \u0441\u043C\u043E\u0433\u0443\u0442 \u0441\u043E\u0437\u0434\u0430\u0432\u0430\u0442\u044C \u043E\u0442\u0440\u044F\u0434\u044B \u0434\u043B\u044F \u041D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u0439, \u043A\u0430\u043A \u0442\u043E\u043B\u044C\u043A\u043E \u0431\u0443\u0434\u0435\u0442 \u0437\u0430\u0440\u0430\u0431\u043E\u0442\u0430\u043D \u043D\u0435\u0434\u043E\u0441\u0442\u0430\u044E\u0449\u0438\u0439 \u043F\u0440\u043E\u043C\u0440\u0435\u0441\u0443\u0440\u0441 \u0434\u043B\u044F \u043F\u043E\u0433\u0430\u0448\u0435\u043D\u0438\u044F \u0448\u0442\u0440\u0430\u0444\u0430.' // eslint-disable-line max-len
});

/***/ }),
/* 517 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"UnavailableBattle_base--1pLrn","base__sortie":"UnavailableBattle_base__sortie--1gm7d","baseSortie":"UnavailableBattle_base__sortie--1gm7d","base__fort-battle":"UnavailableBattle_base__fort-battle--1ZVsF","baseFortBattle":"UnavailableBattle_base__fort-battle--1ZVsF","holder":"UnavailableBattle_holder--sEOKz","header":"UnavailableBattle_header--1NjBp","message":"UnavailableBattle_message--2sZww","message__unavailablePeripheries":"UnavailableBattle_message__unavailablePeripheries--tZPzv","messageUnavailablePeripheries":"UnavailableBattle_message__unavailablePeripheries--tZPzv","information":"UnavailableBattle_information--2hdO2","peripheries":"UnavailableBattle_peripheries--227lO","servers":"UnavailableBattle_servers--3HmjR","footer":"UnavailableBattle_footer--yyHdb","settings":"UnavailableBattle_settings--1HAt9"};

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WizardButton = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(7);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _sounds = __webpack_require__(22);

var _WizardButton = __webpack_require__(519);

var _WizardButton2 = _interopRequireDefault(_WizardButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var WizardButton = exports.WizardButton = function WizardButton(props) {
    var _classNames;

    var cellIconClass = (0, _classnames2.default)(_WizardButton2.default.cell, _WizardButton2.default.cell__icon);
    var cellContentClass = (0, _classnames2.default)(_WizardButton2.default.cell, _WizardButton2.default.cell__content);
    var cellRewardClass = (0, _classnames2.default)(_WizardButton2.default.cell, _WizardButton2.default.cell__reward);

    var className = (0, _classnames2.default)(_WizardButton2.default.base, (_classNames = {}, _defineProperty(_classNames, _WizardButton2.default.base__bonus, props.bonus), _defineProperty(_classNames, _WizardButton2.default.base__battle, props.battle), _defineProperty(_classNames, _WizardButton2.default.base__selected, props.isSelected), _classNames));

    var tooltipProps = props.tooltipId ? {
        'data-tip': true,
        'data-for': props.tooltipId
    } : null;

    var handleMouseDown = function handleMouseDown() {
        return props.playSelectBattleClickSound();
    };
    var handleHover = function handleHover() {
        return props.playHoverSound();
    };

    return _react2.default.createElement(
        'div',
        _extends({
            className: className,
            onClick: props.handleClick,
            onMouseDown: handleMouseDown,
            onMouseEnter: handleHover
        }, tooltipProps),
        _react2.default.createElement(
            'div',
            { className: _WizardButton2.default.border },
            _react2.default.createElement(
                'div',
                { className: _WizardButton2.default.body },
                _react2.default.createElement(
                    'div',
                    { className: _WizardButton2.default.holder },
                    _react2.default.createElement(
                        'div',
                        { className: cellIconClass },
                        props.iconComponent
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: cellContentClass },
                        _react2.default.createElement(
                            'div',
                            { className: _WizardButton2.default.content },
                            props.contentComponent
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: cellRewardClass },
                        _react2.default.createElement(
                            'div',
                            { className: _WizardButton2.default.reward },
                            _react2.default.createElement(
                                'div',
                                { className: _WizardButton2.default.industrialResource },
                                props.rewardComponent
                            )
                        )
                    )
                )
            )
        )
    );
};

WizardButton.propTypes = {
    handleClick: _propTypes2.default.func,
    playHoverSound: _propTypes2.default.func.isRequired,
    playSelectBattleClickSound: _propTypes2.default.func.isRequired,
    iconComponent: _propTypes2.default.element.isRequired,
    contentComponent: _propTypes2.default.element.isRequired,
    rewardComponent: _propTypes2.default.element.isRequired,
    bonus: _propTypes2.default.bool,
    battle: _propTypes2.default.bool,
    isSelected: _propTypes2.default.bool,
    tooltipId: _propTypes2.default.string
};
var mapDispatchToProps = { playHoverSound: _sounds.playHoverSound, playSelectBattleClickSound: _sounds.playSelectBattleClickSound };
exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(WizardButton);

/***/ }),
/* 519 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"WizardButton_base--UNYi6","border":"WizardButton_border--tEMx8","base__bonus":"WizardButton_base__bonus--2WGTF","baseBonus":"WizardButton_base__bonus--2WGTF","base__battle":"WizardButton_base__battle--3ybix","baseBattle":"WizardButton_base__battle--3ybix","base__selected":"WizardButton_base__selected--1IIpJ","baseSelected":"WizardButton_base__selected--1IIpJ","body":"WizardButton_body--1QT5z","holder":"WizardButton_holder--Qm89i","cell":"WizardButton_cell--1IMIS","cell__icon":"WizardButton_cell__icon--3bkWp","cellIcon":"WizardButton_cell__icon--3bkWp","cell__content":"WizardButton_cell__content--1hqCb","cellContent":"WizardButton_cell__content--1hqCb","cell__reward":"WizardButton_cell__reward--b3_0s","cellReward":"WizardButton_cell__reward--b3_0s","content":"WizardButton_content--2tLWt","reward":"WizardButton_reward--3Blea","industrialResource":"WizardButton_industrialResource--3nQ_q"};

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactWotBootstrap = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WizardDefaultTooltip = function WizardDefaultTooltip(props) {
    return _react2.default.createElement(
        _reactWotBootstrap.Tooltip,
        { id: props.tooltipId },
        props.children
    );
};

WizardDefaultTooltip.propTypes = {
    tooltipId: _propTypes2.default.string.isRequired,
    children: _propTypes2.default.element.isRequired
};

exports.default = WizardDefaultTooltip;

/***/ }),
/* 521 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tooltip-root":"BattleWizard_tooltip-root--2yZ5U","tooltipRoot":"BattleWizard_tooltip-root--2yZ5U","tooltip-root__show":"BattleWizard_tooltip-root__show--1Tmq1","tooltipRootShow":"BattleWizard_tooltip-root__show--1Tmq1","tooltip-body":"BattleWizard_tooltip-body--2GDh3","tooltipBody":"BattleWizard_tooltip-body--2GDh3","tooltip-wrapper":"BattleWizard_tooltip-wrapper--1H0DW","tooltipWrapper":"BattleWizard_tooltip-wrapper--1H0DW","tooltip-content":"BattleWizard_tooltip-content--2rhaz","tooltipContent":"BattleWizard_tooltip-content--2rhaz","tooltip-title":"BattleWizard_tooltip-title--3EMWm","tooltipTitle":"BattleWizard_tooltip-title--3EMWm","tooltip-subtitle":"BattleWizard_tooltip-subtitle--7SsM3","tooltipSubtitle":"BattleWizard_tooltip-subtitle--7SsM3","tooltip-message":"BattleWizard_tooltip-message--emSJE","tooltipMessage":"BattleWizard_tooltip-message--emSJE","tooltip-warning":"BattleWizard_tooltip-warning--26PfM","tooltipWarning":"BattleWizard_tooltip-warning--26PfM","tooltip-divider":"BattleWizard_tooltip-divider--3_5c4","tooltipDivider":"BattleWizard_tooltip-divider--3_5c4","tooltip-highlight":"BattleWizard_tooltip-highlight--1tHLJ","tooltipHighlight":"BattleWizard_tooltip-highlight--1tHLJ","tooltip-ribbon":"BattleWizard_tooltip-ribbon--jqrMB","tooltipRibbon":"BattleWizard_tooltip-ribbon--jqrMB","tooltip-statusMessage":"BattleWizard_tooltip-statusMessage--1gT2r","tooltipStatusMessage":"BattleWizard_tooltip-statusMessage--1gT2r","tooltip-statusMessage__positive":"BattleWizard_tooltip-statusMessage__positive--P_ZTy","tooltipStatusMessagePositive":"BattleWizard_tooltip-statusMessage__positive--P_ZTy","tooltip-status":"BattleWizard_tooltip-status--2_3fY","tooltipStatus":"BattleWizard_tooltip-status--2_3fY","tooltip-statusMessage__negative":"BattleWizard_tooltip-statusMessage__negative--1tys-","tooltipStatusMessageNegative":"BattleWizard_tooltip-statusMessage__negative--1tys-","tooltip-statusMessage__noPermission":"BattleWizard_tooltip-statusMessage__noPermission--2Td_K","tooltipStatusMessageNoPermission":"BattleWizard_tooltip-statusMessage__noPermission--2Td_K","tooltip-status__positive":"BattleWizard_tooltip-status__positive--1I5Ku","tooltipStatusPositive":"BattleWizard_tooltip-status__positive--1I5Ku","tooltip-status__negative":"BattleWizard_tooltip-status__negative--1dbP_","tooltipStatusNegative":"BattleWizard_tooltip-status__negative--1dbP_","tooltip-statusText":"BattleWizard_tooltip-statusText--3nev-","tooltipStatusText":"BattleWizard_tooltip-statusText--3nev-","base":"BattleWizard_base--3hr1R","holder":"BattleWizard_holder--2qAOD","part":"BattleWizard_part--3HvBd","inner":"BattleWizard_inner--5jNlb","multiplier":"BattleWizard_multiplier--3Zvuo","multiplierValue":"BattleWizard_multiplierValue--X4ouO"};

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = exports.UnitRebuildWizard = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(7);

var _BattleWizard = __webpack_require__(228);

var _BattleWizard2 = _interopRequireDefault(_BattleWizard);

var _LoadingScreen = __webpack_require__(29);

var _LoadingScreen2 = _interopRequireDefault(_LoadingScreen);

var _constants = __webpack_require__(4);

var _accounts = __webpack_require__(33);

var _locale = __webpack_require__(21);

var _window_titles = __webpack_require__(80);

var _window_titles2 = _interopRequireDefault(_window_titles);

var _unit_rebuild = __webpack_require__(380);

var _unit_rebuild2 = _interopRequireDefault(_unit_rebuild);

var _unit_rebuild_info = __webpack_require__(286);

var _unit_rebuild_info2 = _interopRequireDefault(_unit_rebuild_info);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UnitRebuildWizard = exports.UnitRebuildWizard = function (_React$Component) {
    _inherits(UnitRebuildWizard, _React$Component);

    function UnitRebuildWizard() {
        _classCallCheck(this, UnitRebuildWizard);

        return _possibleConstructorReturn(this, (UnitRebuildWizard.__proto__ || Object.getPrototypeOf(UnitRebuildWizard)).apply(this, arguments));
    }

    _createClass(UnitRebuildWizard, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            document.title = (0, _locale.formatMessage)(_window_titles2.default.wizard_rebuild);
            this.props.requestUnitRebuildInfo(this.props.unitServerId);
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.props.loaded || this.props.loading) {
                return _react2.default.createElement(_LoadingScreen2.default, { type: 'window' });
            }

            var unitServerId = this.props.unitServerId;

            var rebuildUnit = this.props.rebuildUnit.bind(null, unitServerId);
            var requestUnitRebuildInfo = this.props.requestUnitRebuildInfo.bind(null, unitServerId);
            return _react2.default.createElement(_BattleWizard2.default, {
                clanIndustrialResource: this.props.clanIndustrialResource,
                loaded: this.props.loaded,
                loading: this.props.loading,
                fortBattles: this.props.fortBattles,
                sorties: this.props.sorties,
                peripheryId: this.props.peripheryId,
                expiresAt: this.props.expiresAt,
                submit: rebuildUnit,
                requestInfo: requestUnitRebuildInfo,
                unitInfo: this.props.unitInfo,
                closeWindow: this.props.closeWindow,
                isRebuild: true,
                showSchedule: this.props.showOldSchedule,
                industrialResourceMultiplier: this.props.industrialResourceMultiplier
            });
        }
    }]);

    return UnitRebuildWizard;
}(_react2.default.Component);

UnitRebuildWizard.propTypes = {
    clanIndustrialResource: _propTypes2.default.number,
    loaded: _propTypes2.default.bool.isRequired,
    loading: _propTypes2.default.bool.isRequired,
    fortBattles: _propTypes2.default.object.isRequired,
    sorties: _propTypes2.default.object.isRequired,
    peripheryId: _propTypes2.default.number.isRequired,
    expiresAt: _propTypes2.default.number,
    unitServerId: _propTypes2.default.number.isRequired,
    unitInfo: _propTypes2.default.object.isRequired,
    showOldSchedule: _propTypes2.default.bool,
    industrialResourceMultiplier: _propTypes2.default.number.isRequired,

    rebuildUnit: _propTypes2.default.func.isRequired,
    requestUnitRebuildInfo: _propTypes2.default.func.isRequired,
    closeWindow: _propTypes2.default.func.isRequired
};
var mapStateToProps = exports.mapStateToProps = function mapStateToProps(_ref, ownProps) {
    var account = _ref.account,
        clan = _ref.clan,
        unitRebuildInfo = _ref.unitRebuildInfo,
        settings = _ref.settings;
    var peripheryId = account.periphery_id;
    var loading = unitRebuildInfo.loading,
        loaded = unitRebuildInfo.loaded,
        fortBattles = unitRebuildInfo.fort_battles,
        sorties = unitRebuildInfo.sorties,
        expiresAt = unitRebuildInfo.expiresAt,
        unitInfo = unitRebuildInfo.unit_info;
    var industrialResourceMultiplier = settings.industrialResourceMultiplier;


    var unitServerId = parseInt(ownProps.params.unitServerId);
    var clanIndustrialResource = clan ? clan.industrial_resource : null;

    return {
        clanIndustrialResource: clanIndustrialResource,
        loading: loading,
        loaded: loaded,
        fortBattles: fortBattles,
        sorties: sorties,
        peripheryId: peripheryId,
        expiresAt: expiresAt,
        unitServerId: unitServerId,
        unitInfo: unitInfo,
        showOldSchedule: !(0, _accounts.isFeatureAvailable)(account, _constants.FEATURE_TYPES.SCHEDULE),
        industrialResourceMultiplier: industrialResourceMultiplier
    };
};

var mapDispatchToProps = exports.mapDispatchToProps = {
    rebuildUnit: _unit_rebuild2.default,
    requestUnitRebuildInfo: _unit_rebuild_info2.default,
    closeWindow: _unit_rebuild_info.closeWindow
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UnitRebuildWizard);

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = exports.PostbattleScreen = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(7);

var _LoadingScreen = __webpack_require__(29);

var _LoadingScreen2 = _interopRequireDefault(_LoadingScreen);

var _locale = __webpack_require__(21);

var _window_titles = __webpack_require__(80);

var _window_titles2 = _interopRequireDefault(_window_titles);

var _fort_battle_results = __webpack_require__(306);

var _fort_battle_results2 = _interopRequireDefault(_fort_battle_results);

var _constants = __webpack_require__(4);

var _components = __webpack_require__(231);

var _constants2 = __webpack_require__(142);

var _PostbattleScreen = __webpack_require__(545);

var _PostbattleScreen2 = _interopRequireDefault(_PostbattleScreen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PostbattleScreen = exports.PostbattleScreen = function (_React$Component) {
    _inherits(PostbattleScreen, _React$Component);

    function PostbattleScreen() {
        _classCallCheck(this, PostbattleScreen);

        var _this = _possibleConstructorReturn(this, (PostbattleScreen.__proto__ || Object.getPrototypeOf(PostbattleScreen)).call(this));

        _this.state = { selectedTab: _constants2.POSTBATTLE_TABS_LIST[0] };
        _this.selectTab = _this.selectTab.bind(_this);
        return _this;
    }

    _createClass(PostbattleScreen, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.props.requestFortBattleResults();
            document.title = (0, _locale.formatMessage)(_window_titles2.default.postbattle);
        }
    }, {
        key: 'selectTab',
        value: function selectTab(name) {
            this.setState({ selectedTab: name });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                loading = _props.loading,
                results = _props.results;


            if (loading) return _react2.default.createElement(
                'div',
                { className: _PostbattleScreen2.default.base },
                _react2.default.createElement(_LoadingScreen2.default, { type: 'window' })
            );

            if (!results.result) return null;

            var ownClanId = results.own_clan_id,
                enemyClanId = results.enemy_clan_id,
                direction = results.direction,
                enemyClan = results.enemy_clan,
                rounds = results.rounds,
                _results$result = results.result,
                result = _results$result === undefined ? {} : _results$result;
            var pointsUnderControl = result.points_under_control,
                reward = result.reward;


            var outcome = result.is_win ? _constants.FORT_BATTLE_SERIES_RESULT.VICTORY : result.is_draw ? _constants.FORT_BATTLE_SERIES_RESULT.DRAW : _constants.FORT_BATTLE_SERIES_RESULT.DEFEAT;
            var isTimeoutFinish = result.finish_reason === _constants.FORT_BATTLE_SERIES_FINISH_REASONS.TIMEOUT;

            var resultNode = void 0;
            var detailsNode = void 0;
            if (this.state.selectedTab === _constants2.POSTBATTLE_TABS_LIST[0]) {
                resultNode = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_components.Header, {
                        isTimeoutFinish: isTimeoutFinish,
                        outcome: outcome,
                        pointsUnderControl: pointsUnderControl,
                        reward: reward.total
                    }),
                    _react2.default.createElement(_components.Subtitle, { direction: direction, clan: enemyClan }),
                    _react2.default.createElement(_components.BattleList, { battles: rounds, ownClanId: ownClanId, enemyClanId: enemyClanId })
                );
            }

            if (this.state.selectedTab === _constants2.POSTBATTLE_TABS_LIST[1]) {
                detailsNode = _react2.default.createElement(_components.Details, { pointsUnderControl: pointsUnderControl, reward: reward, rounds: rounds });
            }

            return _react2.default.createElement(
                'div',
                { className: _PostbattleScreen2.default.base },
                _react2.default.createElement(_components.Tabs, {
                    tabs: _constants2.POSTBATTLE_TABS_LIST,
                    selected: this.state.selectedTab,
                    handleClick: this.selectTab
                }),
                _react2.default.createElement(
                    'div',
                    { className: _PostbattleScreen2.default.tabsContent },
                    resultNode,
                    detailsNode
                )
            );
        }
    }]);

    return PostbattleScreen;
}(_react2.default.Component);

PostbattleScreen.propTypes = {
    loading: _propTypes2.default.bool.isRequired,
    results: _propTypes2.default.shape({
        direction: _propTypes2.default.oneOf(_constants.DIRECTIONS),
        enemy_clan: _propTypes2.default.object,
        own_clan_id: _propTypes2.default.number,
        enemy_clan_id: _propTypes2.default.number,
        result: _propTypes2.default.object,
        rounds: _propTypes2.default.array
    }),
    requestFortBattleResults: _propTypes2.default.func.isRequired
};
var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
    var _state$fortBattleResu = state.fortBattleResults,
        loading = _state$fortBattleResu.loading,
        results = _state$fortBattleResu.results;

    return { loading: loading, results: results };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
    var _ownProps$params = ownProps.params,
        seriesId = _ownProps$params.seriesId,
        clanId = _ownProps$params.clanId;

    return {
        requestFortBattleResults: function requestFortBattleResults() {
            return dispatch((0, _fort_battle_results2.default)(seriesId, clanId));
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(PostbattleScreen);

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BattleList = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactWotBootstrap = __webpack_require__(5);

var _ArenaTooltip = __webpack_require__(146);

var _ArenaTooltip2 = _interopRequireDefault(_ArenaTooltip);

var _helpers = __webpack_require__(11);

var _components = __webpack_require__(231);

var _constants = __webpack_require__(142);

var _constants2 = __webpack_require__(525);

var _constants3 = __webpack_require__(4);

var _i18n = __webpack_require__(10);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _BattleList = __webpack_require__(526);

var _BattleList2 = _interopRequireDefault(_BattleList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BattleList = exports.BattleList = function (_React$Component) {
    _inherits(BattleList, _React$Component);

    function BattleList() {
        _classCallCheck(this, BattleList);

        return _possibleConstructorReturn(this, (BattleList.__proto__ || Object.getPrototypeOf(BattleList)).apply(this, arguments));
    }

    _createClass(BattleList, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var columnClassName = function columnClassName(type, name) {
                return (0, _classnames2.default)(_BattleList2.default['' + type], _BattleList2.default[type + '__' + name]);
            };
            var rows = this.props.battles.map(function (battle, index) {

                var outcome = battle.is_win ? _constants3.FORT_BATTLE_SERIES_RESULT.VICTORY : battle.is_draw ? _constants3.FORT_BATTLE_SERIES_RESULT.DRAW : _constants3.FORT_BATTLE_SERIES_RESULT.DEFEAT;

                var rowClassName = (0, _classnames2.default)(_BattleList2.default.tr, _BattleList2.default['tr__' + outcome]);
                var resultOutcomeClassName = (0, _classnames2.default)(_BattleList2.default.result, _BattleList2.default.result__outcome);

                var arenaTooltipId = 'battle_series_arena_' + battle.arena.id + '_' + index;
                var resultTooltipId = 'round_result_' + index;

                var roundResult = _extends({}, battle, {
                    fort_battle_state: _this2.props.battles[index - 1] && _this2.props.battles[index - 1].fort_battle_state
                });

                return _react2.default.createElement(
                    'div',
                    { key: 'battle_' + index, className: rowClassName },
                    _react2.default.createElement(
                        'div',
                        { className: columnClassName('td', 'results'), 'data-tip': true, 'data-for': resultTooltipId },
                        _react2.default.createElement(
                            'span',
                            { className: resultOutcomeClassName },
                            _constants2.POST_BATTLE_BATTLE_LIST_OUTCOMES[outcome]
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: columnClassName('td', 'points'), 'data-tip': true, 'data-for': resultTooltipId },
                        _react2.default.createElement(_components.FortBattleSeries, {
                            fortBattleSeries: battle.fort_battle_state,
                            ownClanId: _this2.props.ownClanId,
                            enemyClanId: _this2.props.enemyClanId,
                            isEngagement: index === 0
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: columnClassName('td', 'maps') },
                        _react2.default.createElement(
                            'span',
                            { 'data-tip': true, 'data-for': arenaTooltipId },
                            battle.arena.name + ' (' + (0, _helpers.toRoman)(battle.respawn) + ')'
                        )
                    ),
                    _react2.default.createElement(_ArenaTooltip2.default, { arena: battle.arena, tooltipId: arenaTooltipId }),
                    _react2.default.createElement(_components.RoundResultTooltip, {
                        tooltipId: resultTooltipId,
                        roundResult: roundResult
                    })
                );
            });

            var header = _react2.default.createElement(
                'div',
                { className: _BattleList2.default.tr },
                _react2.default.createElement(
                    'div',
                    { className: columnClassName('th', 'results') },
                    _i18n.POST_BATTLE_TABLE_HEADER.results
                ),
                _react2.default.createElement(
                    'div',
                    { className: columnClassName('th', 'points') },
                    _i18n.POST_BATTLE_TABLE_HEADER.points
                ),
                _react2.default.createElement(
                    'div',
                    { className: columnClassName('th', 'maps') },
                    _i18n.POST_BATTLE_TABLE_HEADER.maps
                )
            );

            return _react2.default.createElement(
                'div',
                { className: _BattleList2.default.base },
                _react2.default.createElement(
                    'div',
                    { className: _BattleList2.default.table },
                    _react2.default.createElement(
                        'div',
                        { className: _BattleList2.default.thead },
                        header
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _BattleList2.default.tbody },
                        _react2.default.createElement(
                            _reactWotBootstrap.ScrollArea,
                            {
                                stepHeight: _constants.POSTBATTLE_ROW_HEIGHT,
                                scrollableAreaHeight: _constants.POSTBATTLE_ROW_HEIGHT * _constants.POSTBATTLE_MAX_ROWS,
                                modifier: 'postbattleDetails'
                            },
                            rows
                        )
                    )
                )
            );
        }
    }]);

    return BattleList;
}(_react2.default.Component);

BattleList.propTypes = {
    battles: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
    ownClanId: _propTypes2.default.number.isRequired,
    enemyClanId: _propTypes2.default.number.isRequired
};
exports.default = BattleList;

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.POST_BATTLE_BATTLE_LIST_OUTCOMES = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-multi-comp */
var POST_BATTLE_BATTLE_LIST_OUTCOMES = exports.POST_BATTLE_BATTLE_LIST_OUTCOMES = {
    victory: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'post_battle_battles_outcome.victory',
        defaultMessage: '\u041F\u043E\u0431\u0435\u0434\u0430!'
    }),
    defeat: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'post_battle_battles_outcome.defeat',
        defaultMessage: '\u041F\u043E\u0440\u0430\u0436\u0435\u043D\u0438\u0435'
    }),
    draw: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'post_battle_battles_outcome.draw',
        defaultMessage: '\u041D\u0438\u0447\u044C\u044F'
    })
};

/***/ }),
/* 526 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"table":"BattleList_table--3BGk4","thead":"BattleList_thead--3_1H9","tbody":"BattleList_tbody--1li-J","tr":"BattleList_tr--1hhcr","tr__defeat":"BattleList_tr__defeat--e_IZH","trDefeat":"BattleList_tr__defeat--e_IZH","tr__draw":"BattleList_tr__draw--2dhiG","trDraw":"BattleList_tr__draw--2dhiG","th":"BattleList_th--3dMAo","td":"BattleList_td--1I_RU","th__results":"BattleList_th__results--3DAPW","thResults":"BattleList_th__results--3DAPW","td__results":"BattleList_td__results--1-MXH","tdResults":"BattleList_td__results--1-MXH","th__maps":"BattleList_th__maps--d-Dq7","thMaps":"BattleList_th__maps--d-Dq7","td__maps":"BattleList_td__maps--2V0Fh","tdMaps":"BattleList_td__maps--2V0Fh","th__points":"BattleList_th__points--SKc_H","thPoints":"BattleList_th__points--SKc_H","td__points":"BattleList_td__points--3rUx2","tdPoints":"BattleList_td__points--3rUx2","th__rewards":"BattleList_th__rewards--Bd4cP","thRewards":"BattleList_th__rewards--Bd4cP","td__rewards":"BattleList_td__rewards--2dDbH","tdRewards":"BattleList_td__rewards--2dDbH","result":"BattleList_result--fgYIY","result__outcome":"BattleList_result__outcome--2Fheu","resultOutcome":"BattleList_result__outcome--2Fheu"};

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Details = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactWotBootstrap = __webpack_require__(5);

var _IndustrialResource = __webpack_require__(35);

var _IndustrialResource2 = _interopRequireDefault(_IndustrialResource);

var _constants = __webpack_require__(4);

var _constants2 = __webpack_require__(142);

var _constants3 = __webpack_require__(528);

var _i18n = __webpack_require__(10);

var _Details = __webpack_require__(529);

var _Details2 = _interopRequireDefault(_Details);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Details = exports.Details = function (_React$Component) {
    _inherits(Details, _React$Component);

    function Details() {
        _classCallCheck(this, Details);

        return _possibleConstructorReturn(this, (Details.__proto__ || Object.getPrototypeOf(Details)).apply(this, arguments));
    }

    _createClass(Details, [{
        key: 'getLineNode',
        value: function getLineNode(caption, value, modifier) {
            var listLineClassName = (0, _classnames2.default)(_Details2.default.listLine, _defineProperty({}, _Details2.default['listLine__' + modifier], modifier));

            var industrialResourceSize = !(modifier === 'grandTotal') ? { small: true } : null;

            return _react2.default.createElement(
                'div',
                { className: listLineClassName },
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)(_Details2.default.listItem, _Details2.default.listItem__caption) },
                    caption
                ),
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)(_Details2.default.listItem, _Details2.default.listItem__value) },
                    _react2.default.createElement(_IndustrialResource2.default, _extends({ value: value }, industrialResourceSize))
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                rounds = _props.rounds,
                reward = _props.reward;


            var seriesResult = _react2.default.createElement(
                'div',
                { className: _Details2.default.section },
                _react2.default.createElement(
                    'h2',
                    { className: _Details2.default.header },
                    _i18n.SERIES_RESULT
                ),
                _react2.default.createElement(
                    'div',
                    { className: _Details2.default.list },
                    this.getLineNode(_constants3.POINTS_UNDER_CONTROL[this.props.pointsUnderControl], reward.points_under_control),
                    !!reward.first_victory_on_direction && this.getLineNode(_constants3.REWARDS.first_victory_on_direction, reward.first_victory_on_direction),
                    !!reward.requisition && this.getLineNode(_constants3.REWARDS.requisition(reward.requisition.percent), reward.requisition.value),
                    !!reward.legionary && this.getLineNode(_constants3.REWARDS.legionary, reward.legionary * -1),
                    this.getLineNode(_constants3.SERIES_REWARD, reward.series, 'total')
                )
            );

            var battleResults = this.props.rounds.map(function (round, idx) {
                return _react2.default.createElement(
                    'div',
                    { className: _Details2.default.section, key: 'round_' + (idx + 1) },
                    _react2.default.createElement(
                        'h2',
                        { className: _Details2.default.header },
                        (0, _constants3.ROUND_TITLE)(idx + 1, round.arena.name)
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _Details2.default.list },
                        _this2.getLineNode(round.finish_reason !== _constants.FORT_BATTLE_SERIES_FINISH_REASONS.TECHNICAL ? _constants3.REWARDS.clan_efficiency : _constants3.TECHNICAL[round.is_win ? 'VICTORY' : 'DEFEAT'], round.reward.clan_efficiency),
                        !!round.reward.artillery_strike && _this2.getLineNode(_constants3.REWARDS.artillery_strike(round.reward.artillery_strike.percent), round.reward.artillery_strike.value),
                        !!round.reward.inspiration && _this2.getLineNode(_constants3.REWARDS.inspiration(round.reward.inspiration.percent), round.reward.inspiration.value),
                        !!round.reward.airstrike && _this2.getLineNode(_constants3.REWARDS.airstrike(round.reward.airstrike.percent), round.reward.airstrike.value),
                        !!round.reward.high_capacity_transport && _this2.getLineNode(_constants3.REWARDS.high_capacity_transport(round.reward.high_capacity_transport.percent), round.reward.high_capacity_transport.value),
                        !!round.reward.legionary && _this2.getLineNode(_constants3.REWARDS.legionary, round.reward.legionary * -1),
                        _this2.getLineNode(_constants3.BATTLE_REWARD, round.reward.total, 'total')
                    )
                );
            });

            var rowsMultiplier = rounds.length < _constants2.POSTBATTLE_MAX_ROWS ? rounds.length : _constants2.POSTBATTLE_MAX_ROWS;
            var scrollableAreaHeight = _constants2.POSTBATTLE_ROW_HEIGHT * rowsMultiplier + _constants2.POSTBATTLE_HEADER_HEIGHT;

            return _react2.default.createElement(
                'div',
                { className: _Details2.default.base },
                _react2.default.createElement(
                    _reactWotBootstrap.ScrollArea,
                    {
                        stepHeight: _constants3.SCROLL_STEP_HEIGHT,
                        scrollableAreaHeight: scrollableAreaHeight,
                        modifier: 'postbattleDetails'
                    },
                    _react2.default.createElement(
                        'div',
                        { className: _Details2.default.content },
                        seriesResult,
                        battleResults,
                        _react2.default.createElement(
                            'div',
                            { className: _Details2.default.section },
                            this.getLineNode(_constants3.TOTAL_REWARD, reward.total, 'grandTotal')
                        )
                    )
                )
            );
        }
    }]);

    return Details;
}(_react2.default.Component);

Details.propTypes = {
    reward: _propTypes2.default.shape({
        points_under_control: _propTypes2.default.number,
        series: _propTypes2.default.number,
        total: _propTypes2.default.number,
        first_victory_on_direction: _propTypes2.default.number,
        legionary: _propTypes2.default.number,
        requisition: _propTypes2.default.shape({
            percent: _propTypes2.default.number,
            value: _propTypes2.default.number
        })
    }).isRequired,
    rounds: _propTypes2.default.array,
    pointsUnderControl: _propTypes2.default.number
};
exports.default = Details;

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TOTAL_REWARD = exports.SERIES_REWARD = exports.BATTLE_REWARD = exports.REWARDS = exports.POINTS_UNDER_CONTROL = exports.TECHNICAL = exports.ROUND_TITLE = exports.SCROLL_STEP_HEIGHT = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-multi-comp */

var SCROLL_STEP_HEIGHT = exports.SCROLL_STEP_HEIGHT = 30;

var ROUND_TITLE = exports.ROUND_TITLE = function ROUND_TITLE(round, arena) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'postbattle_details.round.title',
        defaultMessage: '{round} \u0431\u043E\u0439 ({arena})',
        values: { round: round, arena: arena }
    });
};

var TECHNICAL = exports.TECHNICAL = {
    VICTORY: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'postbattle_details.round.technical.victory',
        defaultMessage: '\u041F\u0440\u043E\u0442\u0438\u0432\u043D\u0438\u043A \u043D\u0435 \u0432\u044B\u0448\u0435\u043B \u0432 \u0431\u043E\u0439'
    }),
    DEFEAT: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'postbattle_details.round.technical.defeat',
        defaultMessage: '\u0421\u043E\u044E\u0437\u043D\u0438\u043A\u0438 \u043D\u0435 \u0432\u044B\u0448\u043B\u0438 \u0432 \u0431\u043E\u0439'
    })
};

var POINTS_UNDER_CONTROL = exports.POINTS_UNDER_CONTROL = [_react2.default.createElement(_reactIntl.FormattedMessage, {
    key: '0-points',
    id: 'postbattle_details.series_result.0',
    defaultMessage: '\u0426\u0438\u0442\u0430\u0434\u0435\u043B\u044C \u0441\u043E\u044E\u0437\u043D\u0438\u043A\u043E\u0432 \u0437\u0430\u0445\u0432\u0430\u0447\u0435\u043D\u0430'
}), _react2.default.createElement(_reactIntl.FormattedMessage, {
    key: '1-point',
    id: 'postbattle_details.series_result.1',
    defaultMessage: '\u0423\u0434\u0435\u0440\u0436\u0430\u043D\u0438\u0435 \u0426\u0438\u0442\u0430\u0434\u0435\u043B\u0438 \u043F\u0440\u0438 \u043F\u043E\u0442\u0435\u0440\u0435 \u043E\u0431\u043E\u0438\u0445 \u0440\u0443\u0431\u0435\u0436\u0435\u0439'
}), _react2.default.createElement(_reactIntl.FormattedMessage, {
    key: '2-points',
    id: 'postbattle_details.series_result.2',
    defaultMessage: '\u0423\u0434\u0435\u0440\u0436\u0430\u043D\u0438\u0435 \u0437\u0430\u043F\u0430\u0441\u043D\u043E\u0433\u043E \u0440\u0443\u0431\u0435\u0436\u0430 \u043F\u0440\u0438 \u043F\u043E\u0442\u0435\u0440\u0435 \u043F\u0435\u0440\u0435\u0434\u043E\u0432\u043E\u0433\u043E'
}), _react2.default.createElement(_reactIntl.FormattedMessage, {
    key: '3-points',
    id: 'postbattle_details.series_result.3',
    defaultMessage: '\u0423\u0434\u0435\u0440\u0436\u0430\u043D\u0438\u0435 \u043E\u0431\u043E\u0438\u0445 \u0440\u0443\u0431\u0435\u0436\u0435\u0439 \u0431\u0435\u0437 \u0437\u0430\u0445\u0432\u0430\u0442\u0430 \u0440\u0443\u0431\u0435\u0436\u0435\u0439 \u043F\u0440\u043E\u0442\u0438\u0432\u043D\u0438\u043A\u0430'
}), _react2.default.createElement(_reactIntl.FormattedMessage, {
    key: '4-points',
    id: 'postbattle_details.series_result.4',
    defaultMessage: '\u0417\u0430\u0445\u0432\u0430\u0442 \u0442\u043E\u043B\u044C\u043A\u043E \u043F\u0435\u0440\u0435\u0434\u043E\u0432\u043E\u0433\u043E \u0440\u0443\u0431\u0435\u0436\u0430'
}), _react2.default.createElement(_reactIntl.FormattedMessage, {
    key: '5-points',
    id: 'postbattle_details.series_result.5',
    defaultMessage: '\u0417\u0430\u0445\u0432\u0430\u0442 \u043E\u0431\u043E\u0438\u0445 \u0440\u0443\u0431\u0435\u0436\u0435\u0439 \u0431\u0435\u0437 \u0437\u0430\u0445\u0432\u0430\u0442\u0430 \u0426\u0438\u0442\u0430\u0434\u0435\u043B\u0438'
}), _react2.default.createElement(_reactIntl.FormattedMessage, {
    key: '6-points',
    id: 'postbattle_details.series_result.6',
    defaultMessage: '\u0417\u0430\u0445\u0432\u0430\u0442 \u0426\u0438\u0442\u0430\u0434\u0435\u043B\u0438 \u043F\u0440\u043E\u0442\u0438\u0432\u043D\u0438\u043A\u0430'
})];

var REWARDS = exports.REWARDS = {
    first_victory_on_direction: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'postbattle_details.rewards.first_victory_on_direction',
        defaultMessage: 'x2 \u0437\u0430 \u043F\u0435\u0440\u0432\u0443\u044E \u043F\u043E\u0431\u0435\u0434\u0443 \u043D\u0430 \u043F\u043B\u0430\u0446\u0434\u0430\u0440\u043C\u0435'
    }),
    requisition: function requisition(percent) {
        return _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'postbattle_details.rewards.requisition',
            defaultMessage: '+ {percent}% \u0437\u0430 \u0440\u0435\u0437\u0435\u0440\u0432 \xAB\u0420\u0435\u043A\u0432\u0438\u0437\u0438\u0446\u0438\u044F\xBB',
            values: { percent: percent }
        });
    },
    legionary: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'postbattle_details.rewards.legionary',
        defaultMessage: '\u041D\u0430\u0433\u0440\u0430\u0434\u0430 \u043B\u0435\u0433\u0438\u043E\u043D\u0435\u0440\u0430\u043C'
    }),
    clan_efficiency: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'postbattle_details.rewards.clan_efficiency',
        defaultMessage: '\u042D\u0444\u0444\u0435\u043A\u0442\u0438\u0432\u043D\u043E\u0441\u0442\u044C \u043E\u0442\u0440\u044F\u0434\u0430'
    }),
    high_capacity_transport: function high_capacity_transport(percent) {
        return _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'postbattle_details.rewards.high_capacity_transport',
            defaultMessage: '+ {percent}% \u0437\u0430 \u0440\u0435\u0437\u0435\u0440\u0432 \xAB\u0411\u043E\u043B\u044C\u0448\u0435\u0433\u0440\u0443\u0437\u043D\u044B\u0439 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\xBB',
            values: { percent: percent }
        });
    },
    airstrike: function airstrike(percent) {
        return _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'postbattle_details.rewards.airstrike',
            defaultMessage: '+ {percent}% \u0437\u0430 \u0440\u0435\u0437\u0435\u0440\u0432 \xAB\u0410\u0432\u0438\u0430\u0443\u0434\u0430\u0440\xBB',
            values: { percent: percent }
        });
    },
    artillery_strike: function artillery_strike(percent) {
        return _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'postbattle_details.rewards.artillery_strike',
            defaultMessage: '+ {percent}% \u0437\u0430 \u0440\u0435\u0437\u0435\u0440\u0432 \xAB\u0410\u0440\u0442\u043E\u0431\u0441\u0442\u0440\u0435\u043B\xBB',
            values: { percent: percent }
        });
    },
    inspiration: function inspiration(percent) {
        return _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'postbattle_details.rewards.inspiration',
            defaultMessage: '+ {percent}% \u0437\u0430 \u0440\u0435\u0437\u0435\u0440\u0432 \xAB\u0412\u043E\u043E\u0434\u0443\u0448\u0435\u0432\u043B\u0435\u043D\u0438\u0435\xBB',
            values: { percent: percent }
        });
    }
};

var BATTLE_REWARD = exports.BATTLE_REWARD = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'postbattle_details.battle_reward',
    defaultMessage: '\u0418\u0442\u043E\u0433\u043E \u0437\u0430 \u0431\u043E\u0439'
});

var SERIES_REWARD = exports.SERIES_REWARD = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'postbattle_details.series_reward',
    defaultMessage: '\u0418\u0442\u043E\u0433\u043E \u0437\u0430 \u041D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u0435'
});

var TOTAL_REWARD = exports.TOTAL_REWARD = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'postbattle_details.total_reward',
    defaultMessage: '\u0418\u0442\u043E\u0433\u043E'
});

/***/ }),
/* 529 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"content":"Details_content--FpDGq","header":"Details_header--3jTKJ","list":"Details_list--2-HbA","section":"Details_section--3cX2f","listLine":"Details_listLine--nqtVu","listLine__total":"Details_listLine__total--1nHrP","listLineTotal":"Details_listLine__total--1nHrP","listLine__grandTotal":"Details_listLine__grandTotal--1fv7S","listLineGrandTotal":"Details_listLine__grandTotal--1fv7S","listItem__caption":"Details_listItem__caption--xNtSt","listItemCaption":"Details_listItem__caption--xNtSt","listItem__value":"Details_listItem__value--aYezZ","listItemValue":"Details_listItem__value--aYezZ"};

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FortBattleSeries = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(531);

var _FortBattleSeries = __webpack_require__(532);

var _FortBattleSeries2 = _interopRequireDefault(_FortBattleSeries);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FortBattleSeries = exports.FortBattleSeries = function (_React$Component) {
    _inherits(FortBattleSeries, _React$Component);

    function FortBattleSeries() {
        _classCallCheck(this, FortBattleSeries);

        return _possibleConstructorReturn(this, (FortBattleSeries.__proto__ || Object.getPrototypeOf(FortBattleSeries)).apply(this, arguments));
    }

    _createClass(FortBattleSeries, [{
        key: 'getFortPoints',
        value: function getFortPoints() {
            var _props = this.props,
                ownClanId = _props.ownClanId,
                enemyClanId = _props.enemyClanId,
                isEngagement = _props.isEngagement,
                fortBattleSeries = _props.fortBattleSeries;

            var length = Object.keys(fortBattleSeries).length;
            var isAllItemsCaptured = fortBattleSeries.every(function (fortPoint) {
                return fortPoint.owner_clan_id === ownClanId;
            });
            var isAllItemsLost = fortBattleSeries.every(function (fortPoint) {
                return fortPoint.owner_clan_id === enemyClanId;
            });

            return fortBattleSeries.map(function (fortPoint, index) {
                var ownerClanId = fortPoint.owner_clan_id,
                    attackerClanId = fortPoint.attacker_clan_id;


                var isFirst = index === 0;
                var isLast = index + 1 === length;

                var isAttack = attackerClanId === ownClanId;
                var isDefense = attackerClanId === enemyClanId;

                var isOwn = ownerClanId === ownClanId;
                var isOpponent = ownerClanId === enemyClanId;

                var type = isFirst || isLast ? _constants.FORT_POINT_TYPES.COMMAND_CENTER : _constants.FORT_POINT_TYPES.SLOT;

                return {
                    isFirst: isFirst,
                    isLast: isLast,
                    ownerClanId: ownerClanId,
                    attackerClanId: attackerClanId,
                    isAttack: isAttack,
                    isDefense: isDefense,
                    isOwn: isOwn,
                    isOpponent: isOpponent,
                    type: type
                };
            }).reduce(function (pointsAcc, currentPoint, index, initialArray) {
                var isFirst = currentPoint.isFirst,
                    isLast = currentPoint.isLast;


                var prevPoint = isFirst ? null : pointsAcc[pointsAcc.length - 1];
                var nextPoint = isLast ? null : initialArray[index + 1];

                var battleDirection = null;
                if (nextPoint && nextPoint.isAttack) battleDirection = _constants.BATTLE_DIRECTIONS.ATTACK;
                if (currentPoint.isDefense) battleDirection = _constants.BATTLE_DIRECTIONS.DEFENSE;

                var isDefeat = !isEngagement && prevPoint && prevPoint.isDefense || isFirst && isAllItemsLost;
                var isVictory = !isEngagement && nextPoint && nextPoint.isAttack || isLast && isAllItemsCaptured;

                return [].concat(_toConsumableArray(pointsAcc), [_extends({}, currentPoint, {
                    battleDirection: battleDirection,
                    isDefeat: isDefeat,
                    isVictory: isVictory
                })]);
            }, []);
        }
    }, {
        key: 'render',
        value: function render() {
            var fortPoints = this.getFortPoints();
            var fortBattleSeriesState = fortPoints.reduce(function (pointsAcc, fortPoint, index) {
                var _classNames, _classNames3, _classNames4;

                var isOwn = fortPoint.isOwn,
                    isOpponent = fortPoint.isOpponent,
                    battleDirection = fortPoint.battleDirection,
                    isLast = fortPoint.isLast,
                    isDefeat = fortPoint.isDefeat,
                    isVictory = fortPoint.isVictory,
                    type = fortPoint.type;


                var pointClassName = (0, _classnames2.default)(_FortBattleSeries2.default.point, _FortBattleSeries2.default['point__' + type]);

                var pointIconClassName = (0, _classnames2.default)(_FortBattleSeries2.default.icon, _FortBattleSeries2.default['icon__' + type], (_classNames = {}, _defineProperty(_classNames, _FortBattleSeries2.default['icon__' + type + '-green'], isOwn && !isDefeat && !isVictory), _defineProperty(_classNames, _FortBattleSeries2.default['icon__' + type + '-green-current'], isOwn && isVictory), _defineProperty(_classNames, _FortBattleSeries2.default['icon__' + type + '-red'], isOpponent && !isDefeat && !isVictory), _defineProperty(_classNames, _FortBattleSeries2.default['icon__' + type + '-red-current'], isOpponent && isDefeat), _classNames));

                var point = _react2.default.createElement(
                    'span',
                    { key: 'point_' + index, className: pointClassName },
                    _react2.default.createElement('span', { className: pointIconClassName })
                );

                if (isLast) return [].concat(_toConsumableArray(pointsAcc), [point]);

                var isLongJoint = fortPoints.length / 2 - 1 === index;
                var jointClassName = (0, _classnames2.default)(_FortBattleSeries2.default.joint, _defineProperty({}, _FortBattleSeries2.default.joint__long, isLongJoint));
                var jointIconClassName = isLongJoint ? (0, _classnames2.default)(_FortBattleSeries2.default.icon, _FortBattleSeries2.default.icon__joint, (_classNames3 = {}, _defineProperty(_classNames3, _FortBattleSeries2.default['icon__line-green-long'], isOwn && battleDirection === null), _defineProperty(_classNames3, _FortBattleSeries2.default['icon__line-red-long'], isOpponent && battleDirection === null), _defineProperty(_classNames3, _FortBattleSeries2.default['icon__arrow-' + battleDirection + '-long'], battleDirection !== null && index !== 2), _defineProperty(_classNames3, _FortBattleSeries2.default['icon__arrow-' + battleDirection + '-long-highlight'], battleDirection !== null && index === 2), _classNames3)) : (0, _classnames2.default)(_FortBattleSeries2.default.icon, _FortBattleSeries2.default.icon__joint, (_classNames4 = {}, _defineProperty(_classNames4, _FortBattleSeries2.default['icon__line-green-short'], isOwn && battleDirection === null), _defineProperty(_classNames4, _FortBattleSeries2.default['icon__line-red-short'], isOpponent && battleDirection === null), _defineProperty(_classNames4, _FortBattleSeries2.default['icon__arrow-' + battleDirection + '-short'], battleDirection !== null), _classNames4));

                var joint = _react2.default.createElement(
                    'span',
                    { key: 'joint_' + index, className: jointClassName },
                    _react2.default.createElement('span', { className: jointIconClassName })
                );

                return [].concat(_toConsumableArray(pointsAcc), [point, joint]);
            }, []);

            return _react2.default.createElement(
                'div',
                { className: _FortBattleSeries2.default.base },
                fortBattleSeriesState
            );
        }
    }]);

    return FortBattleSeries;
}(_react2.default.Component);

FortBattleSeries.propTypes = {
    fortBattleSeries: _propTypes2.default.array.isRequired,
    ownClanId: _propTypes2.default.number.isRequired,
    enemyClanId: _propTypes2.default.number.isRequired,
    isEngagement: _propTypes2.default.bool.isRequired
};
exports.default = FortBattleSeries;

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var FORT_POINT_TYPES = exports.FORT_POINT_TYPES = {
    SLOT: 'flag',
    COMMAND_CENTER: 'stronghold'
};

var BATTLE_DIRECTIONS = exports.BATTLE_DIRECTIONS = {
    ATTACK: 'attack',
    DEFENSE: 'defense'
};

/***/ }),
/* 532 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"FortBattleSeries_base--7zrVF","point":"FortBattleSeries_point--1PqGP","point__stronghold":"FortBattleSeries_point__stronghold--16axv","pointStronghold":"FortBattleSeries_point__stronghold--16axv","point__flag":"FortBattleSeries_point__flag--2CB3I","pointFlag":"FortBattleSeries_point__flag--2CB3I","icon":"FortBattleSeries_icon--N96J2","icon__stronghold":"FortBattleSeries_icon__stronghold--RUuHw","iconStronghold":"FortBattleSeries_icon__stronghold--RUuHw","icon__flag":"FortBattleSeries_icon__flag--oYEpl","iconFlag":"FortBattleSeries_icon__flag--oYEpl","icon__joint":"FortBattleSeries_icon__joint--2wg9Y","iconJoint":"FortBattleSeries_icon__joint--2wg9Y","icon__arrow-attack-long":"FortBattleSeries_icon__arrow-attack-long--2xpiK","iconArrowAttackLong":"FortBattleSeries_icon__arrow-attack-long--2xpiK","icon__arrow-attack-long-highlight":"FortBattleSeries_icon__arrow-attack-long-highlight--Gxxgt","iconArrowAttackLongHighlight":"FortBattleSeries_icon__arrow-attack-long-highlight--Gxxgt","icon__arrow-attack-short":"FortBattleSeries_icon__arrow-attack-short--3Jb-4","iconArrowAttackShort":"FortBattleSeries_icon__arrow-attack-short--3Jb-4","icon__arrow-defense-long":"FortBattleSeries_icon__arrow-defense-long--2f934","iconArrowDefenseLong":"FortBattleSeries_icon__arrow-defense-long--2f934","icon__arrow-defense-long-highlight":"FortBattleSeries_icon__arrow-defense-long-highlight--18Mi3","iconArrowDefenseLongHighlight":"FortBattleSeries_icon__arrow-defense-long-highlight--18Mi3","icon__arrow-defense-short":"FortBattleSeries_icon__arrow-defense-short--YF6Bz","iconArrowDefenseShort":"FortBattleSeries_icon__arrow-defense-short--YF6Bz","icon__line-green-long":"FortBattleSeries_icon__line-green-long--2t_Pw","iconLineGreenLong":"FortBattleSeries_icon__line-green-long--2t_Pw","icon__line-green-short":"FortBattleSeries_icon__line-green-short--3o-aD","iconLineGreenShort":"FortBattleSeries_icon__line-green-short--3o-aD","icon__line-red-long":"FortBattleSeries_icon__line-red-long--1erLL","iconLineRedLong":"FortBattleSeries_icon__line-red-long--1erLL","icon__line-red-short":"FortBattleSeries_icon__line-red-short--2GjT_","iconLineRedShort":"FortBattleSeries_icon__line-red-short--2GjT_","icon__flag-green":"FortBattleSeries_icon__flag-green--2BHys","iconFlagGreen":"FortBattleSeries_icon__flag-green--2BHys","icon__flag-green-current":"FortBattleSeries_icon__flag-green-current--2ZCa4","iconFlagGreenCurrent":"FortBattleSeries_icon__flag-green-current--2ZCa4","icon__flag-red":"FortBattleSeries_icon__flag-red--3_Eq-","iconFlagRed":"FortBattleSeries_icon__flag-red--3_Eq-","icon__flag-red-current":"FortBattleSeries_icon__flag-red-current--2QuoQ","iconFlagRedCurrent":"FortBattleSeries_icon__flag-red-current--2QuoQ","icon__stronghold-green":"FortBattleSeries_icon__stronghold-green--2iNmL","iconStrongholdGreen":"FortBattleSeries_icon__stronghold-green--2iNmL","icon__stronghold-green-current":"FortBattleSeries_icon__stronghold-green-current--3gJbp","iconStrongholdGreenCurrent":"FortBattleSeries_icon__stronghold-green-current--3gJbp","icon__stronghold-red":"FortBattleSeries_icon__stronghold-red--2bwgO","iconStrongholdRed":"FortBattleSeries_icon__stronghold-red--2bwgO","icon__stronghold-red-current":"FortBattleSeries_icon__stronghold-red-current--2FjNP","iconStrongholdRedCurrent":"FortBattleSeries_icon__stronghold-red-current--2FjNP","joint":"FortBattleSeries_joint--2sgYx","joint__long":"FortBattleSeries_joint__long--1jl8w","jointLong":"FortBattleSeries_joint__long--1jl8w"};

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _IndustrialResource = __webpack_require__(35);

var _IndustrialResource2 = _interopRequireDefault(_IndustrialResource);

var _i18n = __webpack_require__(10);

var _constants = __webpack_require__(4);

var _constants2 = __webpack_require__(534);

var _Header = __webpack_require__(535);

var _Header2 = _interopRequireDefault(_Header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = function Header(props) {

    var className = (0, _classnames2.default)(_Header2.default.base, _Header2.default['base__' + props.outcome]);

    return _react2.default.createElement(
        'div',
        { className: className },
        _react2.default.createElement(
            'div',
            { className: _Header2.default.outcome },
            _react2.default.createElement(
                'h1',
                { className: _Header2.default.title },
                _constants2.POSTBATTLE_SCREEN_HEADER_TITLES[props.outcome]
            ),
            _react2.default.createElement(
                'p',
                { className: _Header2.default.outcomeMessage },
                (0, _i18n.getMessageForControllingPointsCount)(props.pointsUnderControl)
            )
        ),
        _react2.default.createElement(
            'div',
            { className: _Header2.default.reward },
            _react2.default.createElement(
                'div',
                { className: _Header2.default.earnedResource },
                _react2.default.createElement(_IndustrialResource2.default, { value: props.reward, custom: true })
            )
        )
    );
};

Header.propTypes = {
    outcome: _propTypes2.default.oneOf(Object.values(_constants.FORT_BATTLE_SERIES_RESULT)).isRequired,
    pointsUnderControl: _propTypes2.default.number,
    reward: _propTypes2.default.number.isRequired
};

exports.default = Header;

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.POSTBATTLE_SCREEN_HEADER_TITLES = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-multi-comp, max-len */
var POSTBATTLE_SCREEN_HEADER_TITLES = exports.POSTBATTLE_SCREEN_HEADER_TITLES = {
    victory: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'postbattle_screen_header_titles.victory',
        defaultMessage: '\u041F\u043E\u0431\u0435\u0434\u0430!'
    }),
    defeat: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'postbattle_screen_header_titles.defeat',
        defaultMessage: '\u041F\u043E\u0440\u0430\u0436\u0435\u043D\u0438\u0435'
    }),
    draw: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'postbattle_screen_header_titles.draw',
        defaultMessage: '\u041D\u0438\u0447\u044C\u044F'
    })
};

/***/ }),
/* 535 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Header_base--wZiCK","base__victory":"Header_base__victory--RxiM3","baseVictory":"Header_base__victory--RxiM3","base__defeat":"Header_base__defeat--3dX6f","baseDefeat":"Header_base__defeat--3dX6f","base__draw":"Header_base__draw--3JIWa","baseDraw":"Header_base__draw--3JIWa","outcome":"Header_outcome--2QYhK","title":"Header_title--25QdW","outcomeMessage":"Header_outcomeMessage--34YNo","reward":"Header_reward--1QdK2","earnedResource":"Header_earnedResource--8Bu31"};

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RoundResultTooltip = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactWotBootstrap = __webpack_require__(5);

var _datetime = __webpack_require__(13);

var _i18n = __webpack_require__(10);

var _constants = __webpack_require__(4);

var _constants2 = __webpack_require__(537);

var _RoundResultTooltip = __webpack_require__(538);

var _RoundResultTooltip2 = _interopRequireDefault(_RoundResultTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RoundResultTooltip = exports.RoundResultTooltip = function (_React$Component) {
    _inherits(RoundResultTooltip, _React$Component);

    function RoundResultTooltip() {
        _classCallCheck(this, RoundResultTooltip);

        return _possibleConstructorReturn(this, (RoundResultTooltip.__proto__ || Object.getPrototypeOf(RoundResultTooltip)).apply(this, arguments));
    }

    _createClass(RoundResultTooltip, [{
        key: 'getTitle',
        value: function getTitle() {
            var roundResult = this.props.roundResult;

            var result = (roundResult.is_win ? _constants.FORT_BATTLE_SERIES_RESULT.VICTORY : roundResult.is_draw ? _constants.FORT_BATTLE_SERIES_RESULT.DRAW : _constants.FORT_BATTLE_SERIES_RESULT.DEFEAT).toUpperCase();

            // FIRST BATTLE_
            if (!roundResult.fort_battle_state) {
                return _constants2.ROUND_RESULT_TITLES['FIRST_BATTLE_' + result];
            }

            var point = roundResult.fort_battle_state.findIndex(function (battle) {
                return battle.attacker_clan_id !== null;
            });

            /* 0 - 1 - 2 - 3 - 4 - 5
            own citadel - own back line - own front line - enemy front line - enemy back line - enemy citadel
            */

            switch (point) {
                case 0:
                    return _constants2.ROUND_RESULT_TITLES['CITADEL_OWN_' + result];
                case 1:
                    return _constants2.ROUND_RESULT_TITLES['BACK_LINE_OWN_' + result];
                case 2:
                    return _constants2.ROUND_RESULT_TITLES['FRONT_LINE_OWN_' + result];
                case 3:
                    return _constants2.ROUND_RESULT_TITLES['FRONT_LINE_ENEMY_' + result];
                case 4:
                    return _constants2.ROUND_RESULT_TITLES['BACK_LINE_ENEMY_' + result];
                case 5:
                    return _constants2.ROUND_RESULT_TITLES['CITADEL_ENEMY_' + result];
            }
        }
    }, {
        key: 'getMessage',
        value: function getMessage() {
            var roundResult = this.props.roundResult;

            var isTimeoutFinish = roundResult.finish_reason === _constants.FORT_BATTLE_SERIES_FINISH_REASONS.TIMEOUT;
            var result = (roundResult.is_win ? _constants.FORT_BATTLE_SERIES_RESULT.VICTORY : roundResult.is_draw ? _constants.FORT_BATTLE_SERIES_RESULT.DRAW : _constants.FORT_BATTLE_SERIES_RESULT.DEFEAT).toUpperCase();

            var key = isTimeoutFinish ? roundResult.finish_reason : roundResult.finish_reason + '_' + result;

            var durationMinutes = Math.floor(roundResult.battle_duration / 60);
            var durationSeconds = roundResult.battle_duration % 60;
            return _i18n.ROUND_RESULT_MESSAGES[key]((0, _datetime.getMinutesAndSecondsFormat)(durationMinutes, durationSeconds));
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _reactWotBootstrap.Tooltip,
                { id: this.props.tooltipId, offset: { top: 0, left: 100 } },
                _react2.default.createElement(
                    'div',
                    { className: _RoundResultTooltip2.default.tooltipContent },
                    _react2.default.createElement(
                        'h3',
                        { className: _RoundResultTooltip2.default.tooltipTitle },
                        this.getTitle()
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: _RoundResultTooltip2.default.tooltipMessage },
                        this.getMessage()
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: _RoundResultTooltip2.default.tooltipMessage },
                        _i18n.ROUND_SCORE_TITLE,
                        ': ',
                        _react2.default.createElement(
                            'span',
                            { className: _RoundResultTooltip2.default.score },
                            this.props.roundResult.score.join(' : ')
                        )
                    )
                )
            );
        }
    }]);

    return RoundResultTooltip;
}(_react2.default.Component);

RoundResultTooltip.propTypes = {
    tooltipId: _propTypes2.default.string.isRequired,
    roundResult: _propTypes2.default.object.isRequired
};
exports.default = RoundResultTooltip;

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ROUND_RESULT_TITLES = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-multi-comp */
var ROUND_RESULT_TITLES = exports.ROUND_RESULT_TITLES = {
    FIRST_BATTLE_VICTORY: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'post_battle.round_result.titles.first_battle.victory',
        defaultMessage: '\u041F\u043E\u0431\u0435\u0434\u0430 \u0432 \u0431\u043E\u044E \u043D\u0430 \u0433\u0440\u0430\u043D\u0438\u0446\u0435'
    }),
    FIRST_BATTLE_DEFEAT: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'post_battle.round_result.titles.first_battle.defeat',
        defaultMessage: '\u041F\u043E\u0440\u0430\u0436\u0435\u043D\u0438\u0435 \u0432 \u0431\u043E\u044E \u043D\u0430 \u0433\u0440\u0430\u043D\u0438\u0446\u0435'
    }),
    FIRST_BATTLE_DRAW: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'post_battle.round_result.titles.first_battle.draw',
        defaultMessage: '\u041D\u0438\u0447\u044C\u044F \u0432 \u0431\u043E\u044E \u043D\u0430 \u0433\u0440\u0430\u043D\u0438\u0446\u0435'
    }),
    FRONT_LINE_OWN_VICTORY: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'post_battle.round_result.titles.front_line_battle.own.victory',
        defaultMessage: '\u041F\u043E\u0431\u0435\u0434\u0430 \u0432 \u0437\u0430\u0449\u0438\u0442\u0435 \u043F\u0435\u0440\u0435\u0434\u043E\u0432\u043E\u0433\u043E \u0440\u0443\u0431\u0435\u0436\u0430 \u0441\u043E\u044E\u0437\u043D\u0438\u043A\u043E\u0432'
    }),
    FRONT_LINE_OWN_DEFEAT: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'post_battle.round_result.titles.front_line_battle.own.defeat',
        defaultMessage: '\u041F\u043E\u0440\u0430\u0436\u0435\u043D\u0438\u0435 \u0432 \u0437\u0430\u0449\u0438\u0442\u0435 \u043F\u0435\u0440\u0435\u0434\u043E\u0432\u043E\u0433\u043E \u0440\u0443\u0431\u0435\u0436\u0430 \u0441\u043E\u044E\u0437\u043D\u0438\u043A\u043E\u0432'
    }),
    FRONT_LINE_ENEMY_VICTORY: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'post_battle.round_result.titles.front_line_battle.enemy.victory',
        defaultMessage: '\u041F\u043E\u0431\u0435\u0434\u0430 \u0432 \u0430\u0442\u0430\u043A\u0435 \u043F\u0435\u0440\u0435\u0434\u043E\u0432\u043E\u0433\u043E \u0440\u0443\u0431\u0435\u0436\u0430 \u043F\u0440\u043E\u0442\u0438\u0432\u043D\u0438\u043A\u0430'
    }),
    FRONT_LINE_ENEMY_DEFEAT: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'post_battle.round_result.titles.front_line_battle.enemy.defeat',
        defaultMessage: '\u041F\u043E\u0440\u0430\u0436\u0435\u043D\u0438\u0435 \u0432 \u0430\u0442\u0430\u043A\u0435 \u043F\u0435\u0440\u0435\u0434\u043E\u0432\u043E\u0433\u043E \u0440\u0443\u0431\u0435\u0436\u0430 \u043F\u0440\u043E\u0442\u0438\u0432\u043D\u0438\u043A\u0430'
    }),
    BACK_LINE_OWN_VICTORY: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'post_battle.round_result.titles.back_line_battle.own.victory',
        defaultMessage: '\u041F\u043E\u0431\u0435\u0434\u0430 \u0432 \u0437\u0430\u0449\u0438\u0442\u0435 \u0437\u0430\u043F\u0430\u0441\u043D\u043E\u0433\u043E \u0440\u0443\u0431\u0435\u0436\u0430 \u0441\u043E\u044E\u0437\u043D\u0438\u043A\u043E\u0432'
    }),
    BACK_LINE_OWN_DEFEAT: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'post_battle.round_result.titles.back_line_battle.own.defeat',
        defaultMessage: '\u041F\u043E\u0440\u0430\u0436\u0435\u043D\u0438\u0435 \u0432 \u0437\u0430\u0449\u0438\u0442\u0435 \u0437\u0430\u043F\u0430\u0441\u043D\u043E\u0433\u043E \u0440\u0443\u0431\u0435\u0436\u0430 \u0441\u043E\u044E\u0437\u043D\u0438\u043A\u043E\u0432'
    }),
    BACK_LINE_ENEMY_VICTORY: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'post_battle.round_result.titles.back_line_battle.enemy.victory',
        defaultMessage: '\u041F\u043E\u0431\u0435\u0434\u0430 \u0432 \u0430\u0442\u0430\u043A\u0435 \u0437\u0430\u043F\u0430\u0441\u043D\u043E\u0433\u043E \u0440\u0443\u0431\u0435\u0436\u0430 \u043F\u0440\u043E\u0442\u0438\u0432\u043D\u0438\u043A\u0430'
    }),
    BACK_LINE_ENEMY_DEFEAT: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'post_battle.round_result.titles.back_line_battle.enemy.defeat',
        defaultMessage: '\u041F\u043E\u0440\u0430\u0436\u0435\u043D\u0438\u0435 \u0432 \u0430\u0442\u0430\u043A\u0435 \u0437\u0430\u043F\u0430\u0441\u043D\u043E\u0433\u043E \u0440\u0443\u0431\u0435\u0436\u0430 \u043F\u0440\u043E\u0442\u0438\u0432\u043D\u0438\u043A\u0430'
    }),
    CITADEL_OWN_VICTORY: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'post_battle.round_result.titles.citadel_battle.own.victory',
        defaultMessage: '\u041F\u043E\u0431\u0435\u0434\u0430 \u0432 \u0437\u0430\u0449\u0438\u0442\u0435 \u0426\u0438\u0442\u0430\u0434\u0435\u043B\u0438 \u0441\u043E\u044E\u0437\u043D\u0438\u043A\u043E\u0432'
    }),
    CITADEL_OWN_DEFEAT: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'post_battle.round_result.titles.citadel_battle.own.defeat',
        defaultMessage: '\u041F\u043E\u0440\u0430\u0436\u0435\u043D\u0438\u0435 \u0432 \u0437\u0430\u0449\u0438\u0442\u0435 \u0426\u0438\u0442\u0430\u0434\u0435\u043B\u0438 \u0441\u043E\u044E\u0437\u043D\u0438\u043A\u043E\u0432'
    }),
    CITADEL_ENEMY_VICTORY: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'post_battle.round_result.titles.citadel_battle.enemy.victory',
        defaultMessage: '\u041F\u043E\u0431\u0435\u0434\u0430 \u0432 \u0430\u0442\u0430\u043A\u0435 \u0426\u0438\u0442\u0430\u0434\u0435\u043B\u0438 \u043F\u0440\u043E\u0442\u0438\u0432\u043D\u0438\u043A\u0430'
    }),
    CITADEL_ENEMY_DEFEAT: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'post_battle.round_result.titles.citadel_battle.enemy.defeat',
        defaultMessage: '\u041F\u043E\u0440\u0430\u0436\u0435\u043D\u0438\u0435 \u0432 \u0430\u0442\u0430\u043A\u0435 \u0426\u0438\u0442\u0430\u0434\u0435\u043B\u0438 \u043F\u0440\u043E\u0442\u0438\u0432\u043D\u0438\u043A\u0430'
    })
};

/***/ }),
/* 538 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tooltip-root":"RoundResultTooltip_tooltip-root--2u8b7","tooltipRoot":"RoundResultTooltip_tooltip-root--2u8b7","tooltip-root__show":"RoundResultTooltip_tooltip-root__show--rhWV3","tooltipRootShow":"RoundResultTooltip_tooltip-root__show--rhWV3","tooltip-body":"RoundResultTooltip_tooltip-body--3eAWc","tooltipBody":"RoundResultTooltip_tooltip-body--3eAWc","tooltip-wrapper":"RoundResultTooltip_tooltip-wrapper--litTy","tooltipWrapper":"RoundResultTooltip_tooltip-wrapper--litTy","tooltip-content":"RoundResultTooltip_tooltip-content--uWXAw","tooltipContent":"RoundResultTooltip_tooltip-content--uWXAw","tooltip-title":"RoundResultTooltip_tooltip-title--1FNRO","tooltipTitle":"RoundResultTooltip_tooltip-title--1FNRO","tooltip-subtitle":"RoundResultTooltip_tooltip-subtitle--tCUrf","tooltipSubtitle":"RoundResultTooltip_tooltip-subtitle--tCUrf","tooltip-message":"RoundResultTooltip_tooltip-message--2rYUs","tooltipMessage":"RoundResultTooltip_tooltipMessage--35Eu4","tooltip-warning":"RoundResultTooltip_tooltip-warning--3UcAO","tooltipWarning":"RoundResultTooltip_tooltip-warning--3UcAO","tooltip-divider":"RoundResultTooltip_tooltip-divider--NQdCx","tooltipDivider":"RoundResultTooltip_tooltip-divider--NQdCx","tooltip-highlight":"RoundResultTooltip_tooltip-highlight--1daNQ","tooltipHighlight":"RoundResultTooltip_tooltip-highlight--1daNQ","tooltip-ribbon":"RoundResultTooltip_tooltip-ribbon--3os_A","tooltipRibbon":"RoundResultTooltip_tooltip-ribbon--3os_A","tooltip-statusMessage":"RoundResultTooltip_tooltip-statusMessage--2Llm4","tooltipStatusMessage":"RoundResultTooltip_tooltip-statusMessage--2Llm4","tooltip-statusMessage__positive":"RoundResultTooltip_tooltip-statusMessage__positive--2NyvV","tooltipStatusMessagePositive":"RoundResultTooltip_tooltip-statusMessage__positive--2NyvV","tooltip-status":"RoundResultTooltip_tooltip-status--3kWXK","tooltipStatus":"RoundResultTooltip_tooltip-status--3kWXK","tooltip-statusMessage__negative":"RoundResultTooltip_tooltip-statusMessage__negative--1znbZ","tooltipStatusMessageNegative":"RoundResultTooltip_tooltip-statusMessage__negative--1znbZ","tooltip-statusMessage__noPermission":"RoundResultTooltip_tooltip-statusMessage__noPermission--2mShq","tooltipStatusMessageNoPermission":"RoundResultTooltip_tooltip-statusMessage__noPermission--2mShq","tooltip-status__positive":"RoundResultTooltip_tooltip-status__positive--JrWT4","tooltipStatusPositive":"RoundResultTooltip_tooltip-status__positive--JrWT4","tooltip-status__negative":"RoundResultTooltip_tooltip-status__negative--10gOT","tooltipStatusNegative":"RoundResultTooltip_tooltip-status__negative--10gOT","tooltip-statusText":"RoundResultTooltip_tooltip-statusText--u3vIi","tooltipStatusText":"RoundResultTooltip_tooltip-statusText--u3vIi","score":"RoundResultTooltip_score--3dYqp"};

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactWotBootstrap = __webpack_require__(5);

var _constants = __webpack_require__(540);

var _constants2 = __webpack_require__(4);

var _Subtitle = __webpack_require__(541);

var _Subtitle2 = _interopRequireDefault(_Subtitle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Subtitle = function Subtitle(props) {
    return _react2.default.createElement(
        'div',
        { className: _Subtitle2.default.base },
        (0, _constants.POSTBATTLE_SCREEN_SUBTITLE_BATTLE_DIRECTION)(props.direction),
        _react2.default.createElement(
            'span',
            { className: _Subtitle2.default.clan },
            _react2.default.createElement(_reactWotBootstrap.ClanTag, props.clan)
        )
    );
};

Subtitle.propTypes = {
    clan: _propTypes2.default.shape({
        id: _propTypes2.default.number.isRequired,
        name: _propTypes2.default.string.isRequired,
        tag: _propTypes2.default.string.isRequired,
        color: _propTypes2.default.string,
        emblem: _propTypes2.default.string.isRequired
    }).isRequired,
    direction: _propTypes2.default.oneOf(_constants2.DIRECTIONS).isRequired
};

exports.default = Subtitle;

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.POSTBATTLE_SCREEN_SUBTITLE_BATTLE_DIRECTION = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _i18n = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var POSTBATTLE_SCREEN_SUBTITLE_BATTLE_DIRECTION = exports.POSTBATTLE_SCREEN_SUBTITLE_BATTLE_DIRECTION = function POSTBATTLE_SCREEN_SUBTITLE_BATTLE_DIRECTION(direction) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'postbattle_screen_subtitle.battle.direction',
        defaultMessage: 'Наступление с {direction} плацдарма на рубежи клана',
        values: {
            direction: _i18n.NAME_BY_DIRECTION_SPELLED[direction]
        }
    });
};

/***/ }),
/* 541 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Subtitle_base--GUE67","clan":"Subtitle_clan--DDSxE"};

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Tabs = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _constants = __webpack_require__(543);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _Tabs = __webpack_require__(544);

var _Tabs2 = _interopRequireDefault(_Tabs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Tabs = exports.Tabs = function (_React$Component) {
    _inherits(Tabs, _React$Component);

    function Tabs() {
        _classCallCheck(this, Tabs);

        return _possibleConstructorReturn(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).apply(this, arguments));
    }

    _createClass(Tabs, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var tabs = this.props.tabs.map(function (tab, index) {
                var selected = _this2.props.selected === tab;
                var className = (0, _classnames2.default)(_Tabs2.default.item, _defineProperty({}, _Tabs2.default.item__selected, selected));

                return _react2.default.createElement(
                    'div',
                    {
                        key: index,
                        className: className,
                        onClick: _this2.props.handleClick.bind(_this2, tab)
                    },
                    _react2.default.createElement(
                        'div',
                        { className: _Tabs2.default.caption },
                        _constants.POSTBATTLE_TABS_CAPTIONS[tab]
                    ),
                    _react2.default.createElement('div', { className: _Tabs2.default.overlay })
                );
            });

            return _react2.default.createElement(
                'div',
                { className: _Tabs2.default.base },
                tabs
            );
        }
    }]);

    return Tabs;
}(_react2.default.Component);

Tabs.propTypes = {
    tabs: _propTypes2.default.array.isRequired,
    selected: _propTypes2.default.string.isRequired,
    handleClick: _propTypes2.default.func.isRequired
};
exports.default = Tabs;

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.POSTBATTLE_TABS_CAPTIONS = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var POSTBATTLE_TABS_CAPTIONS = exports.POSTBATTLE_TABS_CAPTIONS = {
    result: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'postbattle_tabs.result',
        defaultMessage: '\u041E\u0431\u0449\u0438\u0439 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442'
    }),
    details: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'postbattle_tabs.datails',
        defaultMessage: '\u041E\u0442\u0447\u0451\u0442 \u043E \u043D\u0430\u0433\u0440\u0430\u0434\u0435'
    })
};

/***/ }),
/* 544 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Tabs_base--2MRzh","item":"Tabs_item--3ogmn","item__selected":"Tabs_item__selected--3_cGD","itemSelected":"Tabs_item__selected--3_cGD","overlay":"Tabs_overlay--2Gx3H","caption":"Tabs_caption--WcgFt"};

/***/ }),
/* 545 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"PostbattleScreen_base--OffP3","tabsContent":"PostbattleScreen_tabsContent--7GtHp"};

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _Gamefield = __webpack_require__(547);

var _Gamefield2 = _interopRequireDefault(_Gamefield);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Gamefield = function Gamefield(props) {
    var className = (0, _classnames2.default)(_Gamefield2.default.base, _defineProperty({}, _Gamefield2.default.base__external, props.type === 'external'));
    return _react2.default.createElement(
        'div',
        { className: className },
        props.children
    );
};

Gamefield.propTypes = {
    children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.array]).isRequired,
    type: _propTypes2.default.oneOf(['external'])
};

Gamefield.TYPES = {
    external: 'external'
};

exports.default = Gamefield;

/***/ }),
/* 547 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Gamefield_base--34xhk","base__external":"Gamefield_base__external--PV4WQ","baseExternal":"Gamefield_base__external--PV4WQ"};

/***/ }),
/* 548 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"StartingPoint_base--17m5v","placeholder":"StartingPoint_placeholder--31zfz","placeholder__A1":"StartingPoint_placeholder__A1--3RuGR","placeholderA1":"StartingPoint_placeholder__A1--3RuGR","placeholder__A2":"StartingPoint_placeholder__A2--8RvoV","placeholderA2":"StartingPoint_placeholder__A2--8RvoV","placeholder__B1":"StartingPoint_placeholder__B1--3dDN4","placeholderB1":"StartingPoint_placeholder__B1--3dDN4","placeholder__B2":"StartingPoint_placeholder__B2--2olEa","placeholderB2":"StartingPoint_placeholder__B2--2olEa","placeholder__C1":"StartingPoint_placeholder__C1--xIq0Y","placeholderC1":"StartingPoint_placeholder__C1--xIq0Y","placeholder__C2":"StartingPoint_placeholder__C2--GxK86","placeholderC2":"StartingPoint_placeholder__C2--GxK86","placeholder__D1":"StartingPoint_placeholder__D1--30BUG","placeholderD1":"StartingPoint_placeholder__D1--30BUG","placeholder__D2":"StartingPoint_placeholder__D2--36yyS","placeholderD2":"StartingPoint_placeholder__D2--36yyS","inner":"StartingPoint_inner--32r_F"};

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.INDUSTRIAL_RESOURCE_BUYIN_BUTTON = exports.OPEN_BATTLE_LIST_BUTTON_TOOLTIP_UNITS_AVAILABLE = exports.OPEN_BATTLE_LIST_BUTTON_TOOLTIP_MESSAGE = exports.OPEN_BATTLE_LIST_BUTTON_TOOLTIP_ID = exports.CHALLENGES_TOOLTIP_ID = exports.CHALLENGES_TOOLTIP_STAGE_ENDS = exports.CHALLENGES_TOOLTIP_NEXT_STAGE_TOMORROW = exports.CHALLENGES_TOOLTIP_NEXT_STAGE_TODAY = exports.CHALLENGES_TOOLTIP_NEXT_STAGE_CUSTOM_DATE = exports.CHALLENGES_TOOLTIP_ENDS = exports.CHALLENGES_TOOLTIP_NEXT_TOMORROW = exports.CHALLENGES_TOOLTIP_NEXT_TODAY = exports.CHALLENGES_TOOLTIP_NEXT_CUSTOM_DATE = exports.CHALLENGES_TOOLTIP_FOOTER = exports.CHALLENGES_TOOLTIP_OFF = exports.CHALLENGES_TIMER = exports.CHALLENGES_OFF = exports.CHALLENGES_TITLE = exports.MEMBERS_ONLINE_TOOLTIP = exports.MEMBERS_ONLINE = exports.CLAN_MANAGEMENT_TOOLTIP_ID = exports.CLAN_MANAGEMENT_TOOLTIP_FOOTER = exports.CLAN_MANAGEMENT_TITLE = exports.JOURNAL_TOOLTIP_ID = exports.JOURNAL_TOOLTIP = exports.JOURNAL_DETAILS = exports.JOURNAL_TITLE = exports.OPEN_BATTLE_LIST_BUTTON_CAPTION = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-multi-comp */

var emptyPlaceholder = '--';

var OPEN_BATTLE_LIST_BUTTON_CAPTION = exports.OPEN_BATTLE_LIST_BUTTON_CAPTION = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_panel.unit_create_button_caption',
    defaultMessage: '\u0421\u0440\u0430\u0436\u0435\u043D\u0438\u044F \u043A\u043B\u0430\u043D\u043E\u0432'
});

var JOURNAL_TITLE = exports.JOURNAL_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_panel.item.journal_title',
    defaultMessage: '\u0416\u0443\u0440\u043D\u0430\u043B'
});

var JOURNAL_DETAILS = exports.JOURNAL_DETAILS = function JOURNAL_DETAILS(count) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'clan_panel.item.journal_details',
        defaultMessage: '{count} \u0441\u043E\u0431\u044B\u0442\u0438\u0439 \u0441\u0435\u0433\u043E\u0434\u043D\u044F',
        values: { count: count }
    });
};

var JOURNAL_TOOLTIP = exports.JOURNAL_TOOLTIP = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_panel.item.journal_tooltip',
    defaultMessage: '\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u043F\u0440\u043E\u0448\u0435\u0434\u0448\u0438\u0435 \u0441\u043E\u0431\u044B\u0442\u0438\u044F \u0432 \u0423\u043A\u0440\u0435\u043F\u0440\u0430\u0439\u043E\u043D\u0435.'
});

var JOURNAL_TOOLTIP_ID = exports.JOURNAL_TOOLTIP_ID = 'clan_panel_journal_tooltip';

var CLAN_MANAGEMENT_TITLE = exports.CLAN_MANAGEMENT_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_panel.item.clan_management.title',
    defaultMessage: '\u041B\u0438\u0447\u043D\u044B\u0439 \u0441\u043E\u0441\u0442\u0430\u0432'
});

var CLAN_MANAGEMENT_TOOLTIP_FOOTER = exports.CLAN_MANAGEMENT_TOOLTIP_FOOTER = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_panel.item.clan_management.tooltip.footer',
    defaultMessage: '\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043F\u0435\u0440\u0435\u0439\u0442\u0438 \u043A \u0441\u043F\u0438\u0441\u043A\u0443 \u0438\u0433\u0440\u043E\u043A\u043E\u0432 \u043A\u043B\u0430\u043D\u0430.'
});

var CLAN_MANAGEMENT_TOOLTIP_ID = exports.CLAN_MANAGEMENT_TOOLTIP_ID = 'clan_panel_management_tooltip';

var MEMBERS_ONLINE = exports.MEMBERS_ONLINE = function MEMBERS_ONLINE(membersOnline, membersTotal) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'clan_panel.item.clan_management.members',
        defaultMessage: '\u0412 \u0441\u0435\u0442\u0438: {membersOnline}/{membersTotal}',
        values: {
            membersOnline: membersOnline || emptyPlaceholder,
            membersTotal: membersTotal || emptyPlaceholder
        }
    });
};

var MEMBERS_ONLINE_TOOLTIP = exports.MEMBERS_ONLINE_TOOLTIP = function MEMBERS_ONLINE_TOOLTIP(membersOnline, membersTotal) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'clan_panel.item.clan_management.tooltip.members',
        defaultMessage: '\u0418\u0433\u0440\u043E\u043A\u043E\u0432 \u043A\u043B\u0430\u043D\u0430 \u0432 \u0441\u0435\u0442\u0438: {membersOnline} \u0438\u0437 {membersTotal}',
        values: {
            membersOnline: membersOnline || emptyPlaceholder,
            membersTotal: membersTotal || emptyPlaceholder
        }
    });
};

var CHALLENGES_TITLE = exports.CHALLENGES_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_panel.challenges_title',
    defaultMessage: '\u0412\u043E\u0435\u043D\u043D\u044B\u0435 \u0438\u0433\u0440\u044B'
});

var CHALLENGES_OFF = exports.CHALLENGES_OFF = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_panel.challenges_off',
    defaultMessage: '\u041E\u0442\u043A\u043B\u044E\u0447\u0435\u043D\u044B'
});

var CHALLENGES_TIMER = exports.CHALLENGES_TIMER = function CHALLENGES_TIMER(timer) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'clan_panel.challenges_timer_left',
        defaultMessage: '\u041E\u0441\u0442\u0430\u043B\u043E\u0441\u044C {timer}',
        values: { timer: timer }
    });
};

var CHALLENGES_TOOLTIP_OFF = exports.CHALLENGES_TOOLTIP_OFF = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_panel.challenges_tooltip.off',
    defaultMessage: '\u0412\u043E\u0435\u043D\u043D\u044B\u0435 \u0438\u0433\u0440\u044B \u043E\u0442\u043A\u043B\u044E\u0447\u0435\u043D\u044B'
});

var CHALLENGES_TOOLTIP_FOOTER = exports.CHALLENGES_TOOLTIP_FOOTER = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_panel.challenges_tooltip.footer',
    defaultMessage: '\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043F\u0435\u0440\u0435\u0439\u0442\u0438 \u043A \u0432\u043E\u0435\u043D\u043D\u044B\u043C \u0438\u0433\u0440\u0430\u043C.'
});

var CHALLENGES_TOOLTIP_NEXT_CUSTOM_DATE = exports.CHALLENGES_TOOLTIP_NEXT_CUSTOM_DATE = function CHALLENGES_TOOLTIP_NEXT_CUSTOM_DATE(dateTime) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'clan_panel.challenges_tooltip.next_custom',
        defaultMessage: '\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0435 \u0412\u043E\u0435\u043D\u043D\u044B\u0435 \u0438\u0433\u0440\u044B \u043D\u0430\u0447\u043D\u0443\u0442\u0441\u044F {date} \u0432 {time}',
        values: {
            date: dateTime.format('D MMMM'),
            time: dateTime.format('LT')
        }
    });
};

var CHALLENGES_TOOLTIP_NEXT_TODAY = exports.CHALLENGES_TOOLTIP_NEXT_TODAY = function CHALLENGES_TOOLTIP_NEXT_TODAY(dateTime) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'clan_panel.challenges_tooltip.next_today',
        defaultMessage: '\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0435 \u0412\u043E\u0435\u043D\u043D\u044B\u0435 \u0438\u0433\u0440\u044B \u043D\u0430\u0447\u043D\u0443\u0442\u0441\u044F \u0441\u0435\u0433\u043E\u0434\u043D\u044F \u0432 {time}',
        values: {
            time: dateTime.format('LT')
        }
    });
};

var CHALLENGES_TOOLTIP_NEXT_TOMORROW = exports.CHALLENGES_TOOLTIP_NEXT_TOMORROW = function CHALLENGES_TOOLTIP_NEXT_TOMORROW(dateTime) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'clan_panel.challenges_tooltip.next_tomorrow',
        defaultMessage: '\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0435 \u0412\u043E\u0435\u043D\u043D\u044B\u0435 \u0438\u0433\u0440\u044B \u043D\u0430\u0447\u043D\u0443\u0442\u0441\u044F \u0437\u0430\u0432\u0442\u0440\u0430 \u0432 {time}',
        values: {
            time: dateTime.format('LT')
        }
    });
};

var CHALLENGES_TOOLTIP_ENDS = exports.CHALLENGES_TOOLTIP_ENDS = function CHALLENGES_TOOLTIP_ENDS(timer) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'clan_panel.challenges_tooltip.ends',
        defaultMessage: '\u0414\u043E \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0442\u0435\u043A\u0443\u0449\u0438\u0445 \u0412\u043E\u0435\u043D\u043D\u044B\u0445 \u0438\u0433\u0440 \u043E\u0441\u0442\u0430\u043B\u043E\u0441\u044C {timer}',
        values: { timer: timer }
    });
};

var CHALLENGES_TOOLTIP_NEXT_STAGE_CUSTOM_DATE = exports.CHALLENGES_TOOLTIP_NEXT_STAGE_CUSTOM_DATE = function CHALLENGES_TOOLTIP_NEXT_STAGE_CUSTOM_DATE(dateTime) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'clan_panel.challenges_tooltip.next_stage_custom',
        defaultMessage: '\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 \u044D\u0442\u0430\u043F \u0412\u043E\u0435\u043D\u043D\u044B\u0445 \u0438\u0433\u0440 \u043D\u0430\u0447\u043D\u0451\u0442\u0441\u044F {date} \u0432 {time}',
        values: {
            date: dateTime.format('D MMMM'),
            time: dateTime.format('LT')
        }
    });
};

var CHALLENGES_TOOLTIP_NEXT_STAGE_TODAY = exports.CHALLENGES_TOOLTIP_NEXT_STAGE_TODAY = function CHALLENGES_TOOLTIP_NEXT_STAGE_TODAY(dateTime) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'clan_panel.challenges_tooltip.next_stage_today',
        defaultMessage: '\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 \u044D\u0442\u0430\u043F \u0412\u043E\u0435\u043D\u043D\u044B\u0445 \u0438\u0433\u0440 \u043D\u0430\u0447\u043D\u0451\u0442\u0441\u044F \u0441\u0435\u0433\u043E\u0434\u043D\u044F \u0432 {time}',
        values: {
            time: dateTime.format('LT')
        }
    });
};

var CHALLENGES_TOOLTIP_NEXT_STAGE_TOMORROW = exports.CHALLENGES_TOOLTIP_NEXT_STAGE_TOMORROW = function CHALLENGES_TOOLTIP_NEXT_STAGE_TOMORROW(dateTime) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'clan_panel.challenges_tooltip.next_stage_tomorrow',
        defaultMessage: '\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 \u044D\u0442\u0430\u043F \u0412\u043E\u0435\u043D\u043D\u044B\u0445 \u0438\u0433\u0440 \u043D\u0430\u0447\u043D\u0451\u0442\u0441\u044F \u0437\u0430\u0432\u0442\u0440\u0430 \u0432 {time}',
        values: {
            time: dateTime.format('LT')
        }
    });
};

var CHALLENGES_TOOLTIP_STAGE_ENDS = exports.CHALLENGES_TOOLTIP_STAGE_ENDS = function CHALLENGES_TOOLTIP_STAGE_ENDS(timer) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'clan_panel.challenges_tooltip.stage_ends',
        defaultMessage: '\u0414\u043E \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0442\u0435\u043A\u0443\u0449\u0435\u0433\u043E \u044D\u0442\u0430\u043F\u0430 \u0412\u043E\u0435\u043D\u043D\u044B\u0445 \u0438\u0433\u0440 \u043E\u0441\u0442\u0430\u043B\u043E\u0441\u044C {timer}',
        values: { timer: timer }
    });
};

var CHALLENGES_TOOLTIP_ID = exports.CHALLENGES_TOOLTIP_ID = 'clan_panel_challenges_tooltip';

var OPEN_BATTLE_LIST_BUTTON_TOOLTIP_ID = exports.OPEN_BATTLE_LIST_BUTTON_TOOLTIP_ID = 'clan_panel_create_unit_button_tooltip';

var OPEN_BATTLE_LIST_BUTTON_TOOLTIP_MESSAGE = exports.OPEN_BATTLE_LIST_BUTTON_TOOLTIP_MESSAGE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_panel.item.open_battle_list_button_tooltip',
    defaultMessage: '\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043F\u0435\u0440\u0435\u0439\u0442\u0438 \u043A \u043F\u043E\u0434\u0431\u043E\u0440\u0443 \u043E\u0442\u0440\u044F\u0434\u0430.'
});

var OPEN_BATTLE_LIST_BUTTON_TOOLTIP_UNITS_AVAILABLE = exports.OPEN_BATTLE_LIST_BUTTON_TOOLTIP_UNITS_AVAILABLE = function OPEN_BATTLE_LIST_BUTTON_TOOLTIP_UNITS_AVAILABLE(count) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'clan_panel.item.open_battle_list_button_tooltip_units_available',
        defaultMessage: '\u041E\u0442\u0440\u044F\u0434\u044B, \u0441\u043E\u0437\u0434\u0430\u043D\u043D\u044B\u0435 \u0432\u0430\u0448\u0438\u043C \u043A\u043B\u0430\u043D\u043E\u043C: {count}',
        values: { count: count }
    });
};

var INDUSTRIAL_RESOURCE_BUYIN_BUTTON = exports.INDUSTRIAL_RESOURCE_BUYIN_BUTTON = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_panel.item.industrial_resource_buyin_button',
    defaultMessage: '\u041A\u0443\u043F\u0438\u0442\u044C \u043F\u0440\u043E\u043C\u0440\u0435\u0441\u0443\u0440\u0441'
});

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapStateToProps = exports.CommandCenter = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(7);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _helpers = __webpack_require__(11);

var _stronghold = __webpack_require__(132);

var _i18n = __webpack_require__(10);

var _UpgradeIcon = __webpack_require__(234);

var _UpgradeIcon2 = _interopRequireDefault(_UpgradeIcon);

var _constants = __webpack_require__(4);

var _CommandCenter = __webpack_require__(553);

var _CommandCenter2 = _interopRequireDefault(_CommandCenter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CommandCenter = exports.CommandCenter = function (_React$Component) {
    _inherits(CommandCenter, _React$Component);

    function CommandCenter() {
        _classCallCheck(this, CommandCenter);

        return _possibleConstructorReturn(this, (CommandCenter.__proto__ || Object.getPrototypeOf(CommandCenter)).apply(this, arguments));
    }

    _createClass(CommandCenter, [{
        key: 'render',
        value: function render() {

            var upgradeAvailable = this.props.isUpgradeAvailable ? _react2.default.createElement(
                'div',
                { className: _CommandCenter2.default.upgradeAvailable },
                _react2.default.createElement(_UpgradeIcon2.default, null)
            ) : null;

            var imageClassName = (0, _classnames2.default)(_CommandCenter2.default.image, _CommandCenter2.default['image__' + this.props.level]);

            var className = (0, _classnames2.default)(_CommandCenter2.default.base, _defineProperty({}, _CommandCenter2.default.base__foreign, !this.props.isOwn));

            return _react2.default.createElement(
                'div',
                {
                    className: className,
                    onClick: this.props.handleClick,
                    onMouseEnter: this.props.handleHover,
                    'data-tip': true,
                    'data-for': _constants.COMMAND_CENTER_TOOLTIP_ID
                },
                _react2.default.createElement(
                    'p',
                    { className: _CommandCenter2.default.title },
                    _react2.default.createElement(
                        'span',
                        { className: _CommandCenter2.default.level },
                        (0, _helpers.toRoman)(this.props.level),
                        _react2.default.createElement(
                            'span',
                            { className: _CommandCenter2.default.levelShadow },
                            (0, _helpers.toRoman)(this.props.level)
                        )
                    ),
                    _i18n.COMMAND_CENTER_TITLE
                ),
                upgradeAvailable,
                _react2.default.createElement('div', { className: imageClassName })
            );
        }
    }]);

    return CommandCenter;
}(_react2.default.Component);

CommandCenter.propTypes = {
    level: _propTypes2.default.number,
    isUpgradeAvailable: _propTypes2.default.bool.isRequired,
    isOwn: _propTypes2.default.bool.isRequired,

    handleClick: _propTypes2.default.func,
    handleHover: _propTypes2.default.func
};
var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
    return {
        isUpgradeAvailable: (0, _stronghold.upgradeAvailability)(state)
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(CommandCenter);

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ARROW_LAYERS_COUNT = exports.ARROW_LAYERS_COUNT = 5;

/***/ }),
/* 552 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"UpgradeIcon_base--2RVSm","arrowLayer":"UpgradeIcon_arrowLayer--2WTDq","arrow-flow":"UpgradeIcon_arrow-flow--1hLW6","arrowFlow":"UpgradeIcon_arrow-flow--1hLW6","arrowLayer__0":"UpgradeIcon_arrowLayer__0--33tnC","arrowLayer0":"UpgradeIcon_arrowLayer__0--33tnC","arrowLayer__1":"UpgradeIcon_arrowLayer__1--2nIFz","arrowLayer1":"UpgradeIcon_arrowLayer__1--2nIFz","arrowLayer__2":"UpgradeIcon_arrowLayer__2--3Wipd","arrowLayer2":"UpgradeIcon_arrowLayer__2--3Wipd","arrowLayer__3":"UpgradeIcon_arrowLayer__3--t60Sm","arrowLayer3":"UpgradeIcon_arrowLayer__3--t60Sm","arrowLayer__4":"UpgradeIcon_arrowLayer__4--Gb3ri","arrowLayer4":"UpgradeIcon_arrowLayer__4--Gb3ri"};

/***/ }),
/* 553 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"title":"CommandCenter_title--1hSr3","level":"CommandCenter_level--1tU-N","levelShadow":"CommandCenter_levelShadow--3-4Bd","base":"CommandCenter_base--lioqD","base__foreign":"CommandCenter_base__foreign--1cLbI","baseForeign":"CommandCenter_base__foreign--1cLbI","image":"CommandCenter_image--1RiCu","image__1":"CommandCenter_image__1--2hixE","image1":"CommandCenter_image__1--2hixE","image__2":"CommandCenter_image__2--3jKB6","image2":"CommandCenter_image__2--3jKB6","image__3":"CommandCenter_image__3--g8opy","image3":"CommandCenter_image__3--g8opy","image__4":"CommandCenter_image__4--Z9I2T","image4":"CommandCenter_image__4--Z9I2T","image__5":"CommandCenter_image__5--3uQyY","image5":"CommandCenter_image__5--3uQyY","image__6":"CommandCenter_image__6--1buts","image6":"CommandCenter_image__6--1buts","image__7":"CommandCenter_image__7--24cFK","image7":"CommandCenter_image__7--24cFK","image__8":"CommandCenter_image__8--34OWF","image8":"CommandCenter_image__8--34OWF","image__9":"CommandCenter_image__9--3N1Qa","image9":"CommandCenter_image__9--3N1Qa","image__10":"CommandCenter_image__10--3r0i7","image10":"CommandCenter_image__10--3r0i7","upgradeAvailable":"CommandCenter_upgradeAvailable--3Q2MV"};

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _StartingPoint = __webpack_require__(232);

var _StartingPoint2 = _interopRequireDefault(_StartingPoint);

var _Slot = __webpack_require__(555);

var _Slot2 = _interopRequireDefault(_Slot);

var _Building = __webpack_require__(558);

var _Building2 = _interopRequireDefault(_Building);

var _Direction = __webpack_require__(560);

var _Direction2 = _interopRequireDefault(_Direction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Direction = function Direction(props) {
    var buildingClickHandler = props.buildingClickHandler,
        buildingHoverHandler = props.buildingHoverHandler,
        buildingConstructionAnimated = props.buildingConstructionAnimated,
        emptySlotClickHandler = props.emptySlotClickHandler,
        emptySlotHoverHandler = props.emptySlotHoverHandler,
        hasPermission = props.hasPermission,
        isOwn = props.isOwn;


    var children = props.slots.map(function (slot) {
        var building = slot.building;

        if (building !== null) {
            var clickHandler = buildingClickHandler ? buildingClickHandler.bind(null, building.id) : null;
            var hoverHandler = buildingHoverHandler ? buildingHoverHandler.bind(null, building.id) : null;
            var constructionAnimatedHandler = buildingConstructionAnimated ? buildingConstructionAnimated.bind(null, building.id) : null;
            return _react2.default.createElement(_Building2.default, {
                key: building.id,
                building: building,
                handleClick: clickHandler,
                handleHover: hoverHandler,
                buildingConstructionAnimated: constructionAnimatedHandler,
                isOwn: isOwn
            });
        } else {
            var _clickHandler = emptySlotClickHandler ? emptySlotClickHandler.bind(null, slot.id) : null;
            var _hoverHandler = emptySlotHoverHandler ? emptySlotHoverHandler.bind(null, slot.id) : null;

            return _react2.default.createElement(_Slot2.default, {
                key: slot.id,
                slotId: slot.id,
                handleClick: _clickHandler,
                handleHover: _hoverHandler,
                hasPermission: hasPermission,
                isOwn: isOwn
            });
        }
    });

    var className = (0, _classnames2.default)(_Direction2.default.base, _Direction2.default['base__' + props.name], _Direction2.default['base__lvl' + props.level]);

    return _react2.default.createElement(
        'div',
        { className: className },
        _react2.default.createElement(
            _StartingPoint2.default,
            { direction: props.name },
            children
        )
    );
};

Direction.propTypes = {
    level: _propTypes2.default.number.isRequired,
    name: _propTypes2.default.string.isRequired,
    slots: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
    emptySlotClickHandler: _propTypes2.default.func,
    buildingClickHandler: _propTypes2.default.func,
    emptySlotHoverHandler: _propTypes2.default.func,
    buildingHoverHandler: _propTypes2.default.func,
    hasPermission: _propTypes2.default.bool.isRequired,
    isOwn: _propTypes2.default.bool.isRequired,
    buildingConstructionAnimated: _propTypes2.default.func
};

exports.default = Direction;

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(556);

var _Slot = __webpack_require__(557);

var _Slot2 = _interopRequireDefault(_Slot);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Slot = function Slot(props) {
    var icon = !props.hasPermission ? null : _react2.default.createElement('div', { className: _Slot2.default.icon });
    var dataAttrs = {};
    if (props.isOwn) {
        dataAttrs = {
            'data-tip': true,
            'data-for': 'slot_' + props.slotId
        };
    }

    var className = (0, _classnames2.default)(_Slot2.default.base, _defineProperty({}, _Slot2.default.base__own, props.isOwn));

    return _react2.default.createElement(
        'div',
        _extends({
            className: className,
            onClick: props.handleClick,
            onMouseEnter: props.handleHover
        }, dataAttrs),
        _react2.default.createElement('div', { className: _Slot2.default.clickArea }),
        _react2.default.createElement(
            'p',
            { className: _Slot2.default.caption },
            _react2.default.createElement(
                'span',
                { className: _Slot2.default.captionInner },
                _constants.SLOT_CAPTION
            )
        ),
        icon
    );
};

Slot.propTypes = {
    handleClick: _propTypes2.default.func,
    handleHover: _propTypes2.default.func,
    slotId: _propTypes2.default.number.isRequired,
    hasPermission: _propTypes2.default.bool.isRequired,
    isOwn: _propTypes2.default.bool.isRequired
};

exports.default = Slot;

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SLOT_CAPTION = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SLOT_CAPTION = exports.SLOT_CAPTION = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'slot.caption',

    defaultMessage: '\u0421\u0442\u0440\u043E\u0439\u043F\u043B\u043E\u0449\u0430\u0434\u043A\u0430'
});

/***/ }),
/* 557 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"caption":"Slot_caption--1vyHw","base":"Slot_base--1dk8f","base__own":"Slot_base__own--32jL8","baseOwn":"Slot_base__own--32jL8","clickArea":"Slot_clickArea--1MEIE","captionInner":"Slot_captionInner--2oDjg","icon":"Slot_icon--GC_n3"};

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapStateToProps = exports.Building = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(7);

var _helpers = __webpack_require__(11);

var _buildings = __webpack_require__(161);

var _i18n = __webpack_require__(10);

var _UpgradeIcon = __webpack_require__(234);

var _UpgradeIcon2 = _interopRequireDefault(_UpgradeIcon);

var _constants = __webpack_require__(4);

var _Building = __webpack_require__(559);

var _Building2 = _interopRequireDefault(_Building);

var _reserves = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Building = exports.Building = function (_React$Component) {
    _inherits(Building, _React$Component);

    function Building(props) {
        _classCallCheck(this, Building);

        var _this = _possibleConstructorReturn(this, (Building.__proto__ || Object.getPrototypeOf(Building)).call(this, props));

        _this.state = { productionInProgress: false };
        return _this;
    }

    _createClass(Building, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.processReserveQueue(nextProps.reserveQueue);
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.processReserveQueue(this.props.reserveQueue);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.props.building.modified === true && this.props.buildingConstructionAnimated !== null) {
                this.props.buildingConstructionAnimated();
            }
            if (this.timerId) {
                clearTimeout(this.timerId);
            }
        }
    }, {
        key: 'processReserveQueue',
        value: function processReserveQueue(reserveQueue) {
            if (this.timerId) {
                clearTimeout(this.timerId);
            }

            var productionEnds = reserveQueue.length ? reserveQueue[reserveQueue.length - 1].productionEnds : null;
            var productionInProgress = !!productionEnds && productionEnds > Date.now();

            if (productionInProgress) {
                this.timerId = setTimeout(this.processReserveQueue.bind(this, reserveQueue), productionEnds - Date.now());
            }

            this.setState({ productionInProgress: productionInProgress });
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames;

            var modified = this.props.building.modified === true;
            var className = (0, _classnames2.default)(_Building2.default.base, (_classNames = {}, _defineProperty(_classNames, _Building2.default.base__foreign, !this.props.isOwn), _defineProperty(_classNames, _Building2.default.base__completed, !modified), _defineProperty(_classNames, _Building2.default.base__animateCompleted, modified), _classNames));

            var imageClassName = (0, _classnames2.default)(_Building2.default.image, _Building2.default['image__' + (0, _helpers.toCssClass)(this.props.building.type)], _Building2.default['image__level-' + this.props.building.level]);

            var upgradeAvailable = !this.state.productionInProgress && this.props.isUpgradeAvailable ? _react2.default.createElement(
                'div',
                { className: _Building2.default.upgradeAvailable },
                _react2.default.createElement(_UpgradeIcon2.default, null)
            ) : null;

            var reserveProgress = this.state.productionInProgress ? _react2.default.createElement('div', { className: _Building2.default.reserveProgress }) : null;

            return _react2.default.createElement(
                'div',
                {
                    className: className,
                    onClick: this.props.handleClick,
                    onMouseEnter: this.props.handleHover,
                    'data-tip': true,
                    'data-for': _constants.BUILDING_TOOLTIP_ID + '_' + this.props.building.type
                },
                _react2.default.createElement(
                    'p',
                    { className: _Building2.default.title },
                    _react2.default.createElement(
                        'span',
                        { className: _Building2.default.level },
                        (0, _helpers.toRoman)(this.props.building.level),
                        _react2.default.createElement(
                            'span',
                            { className: _Building2.default.levelShadow },
                            (0, _helpers.toRoman)(this.props.building.level)
                        )
                    ),
                    _i18n.BUILDING_TITLES[this.props.building.type]
                ),
                upgradeAvailable,
                reserveProgress,
                _react2.default.createElement('div', { className: _Building2.default.yard }),
                _react2.default.createElement('div', { className: imageClassName }),
                _react2.default.createElement('div', { className: _Building2.default.smoke })
            );
        }
    }]);

    return Building;
}(_react2.default.Component);

Building.propTypes = {
    building: _propTypes2.default.object.isRequired,
    isUpgradeAvailable: _propTypes2.default.bool.isRequired,
    reserveQueue: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
    isOwn: _propTypes2.default.bool,

    handleClick: _propTypes2.default.func,
    handleHover: _propTypes2.default.func,
    buildingConstructionAnimated: _propTypes2.default.func
};
var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, _ref) {
    var building = _ref.building;


    var reserveType = state.settings.buildings[building.type].reserve_type;
    var reserveQueue = (0, _reserves.getSortedProductionReserves)(state.clanReserves[reserveType]);

    var isUpgradeAvailable = (0, _buildings.upgradeAvailability)(state, building);

    return {
        isUpgradeAvailable: isUpgradeAvailable,
        reserveQueue: reserveQueue
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, null)(Building);

/***/ }),
/* 559 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"title":"Building_title--3hNst","level":"Building_level--3ngLU","levelShadow":"Building_levelShadow--am1Nz","base":"Building_base--13H0v","image":"Building_image--3ZGCs","base__foreign":"Building_base__foreign--3hC8f","baseForeign":"Building_base__foreign--3hC8f","image__attack-bomber-squadrons":"Building_image__attack-bomber-squadrons--3R8in","imageAttackBomberSquadrons":"Building_image__attack-bomber-squadrons--3R8in","image__level-1":"Building_image__level-1--I5FJL","imageLevel1":"Building_image__level-1--I5FJL","image__level-2":"Building_image__level-2--2ZIJr","imageLevel2":"Building_image__level-2--2ZIJr","image__level-3":"Building_image__level-3--3Ctar","imageLevel3":"Building_image__level-3--3Ctar","image__level-4":"Building_image__level-4--p9OZ6","imageLevel4":"Building_image__level-4--p9OZ6","image__level-5":"Building_image__level-5--2s4G8","imageLevel5":"Building_image__level-5--2s4G8","image__level-6":"Building_image__level-6--25z7V","imageLevel6":"Building_image__level-6--25z7V","image__level-7":"Building_image__level-7--2MA_V","imageLevel7":"Building_image__level-7--2MA_V","image__level-8":"Building_image__level-8--1BN7t","imageLevel8":"Building_image__level-8--1BN7t","image__level-9":"Building_image__level-9--1DnZl","imageLevel9":"Building_image__level-9--1DnZl","image__level-10":"Building_image__level-10--3w6Mw","imageLevel10":"Building_image__level-10--3w6Mw","image__training-unit":"Building_image__training-unit--16xUd","imageTrainingUnit":"Building_image__training-unit--16xUd","image__tankodrome":"Building_image__tankodrome--29hYy","imageTankodrome":"Building_image__tankodrome--29hYy","image__financial-unit":"Building_image__financial-unit--2tLpo","imageFinancialUnit":"Building_image__financial-unit--2tLpo","image__transportation-unit":"Building_image__transportation-unit--3JJLa","imageTransportationUnit":"Building_image__transportation-unit--3JJLa","image__trophy-brigade":"Building_image__trophy-brigade--ucSxt","imageTrophyBrigade":"Building_image__trophy-brigade--ucSxt","image__artillery-battalion":"Building_image__artillery-battalion--3dPhV","imageArtilleryBattalion":"Building_image__artillery-battalion--3dPhV","image__military-school":"Building_image__military-school--1t5U7","imageMilitarySchool":"Building_image__military-school--1t5U7","image__home-front-service":"Building_image__home-front-service--39Mw2","imageHomeFrontService":"Building_image__home-front-service--39Mw2","base__completed":"Building_base__completed--1-B8p","baseCompleted":"Building_base__completed--1-B8p","base__animateCompleted":"Building_base__animateCompleted--2DqsP","baseAnimateCompleted":"Building_base__animateCompleted--2DqsP","building-down":"Building_building-down--3eEgK","buildingDown":"Building_building-down--3eEgK","smoke":"Building_smoke--13TGZ","base__animateStarted":"Building_base__animateStarted--2Mzl5","baseAnimateStarted":"Building_base__animateStarted--2Mzl5","smoke-in":"Building_smoke-in--3j86S","smokeIn":"Building_smoke-in--3j86S","smoke-out":"Building_smoke-out--2EyW6","smokeOut":"Building_smoke-out--2EyW6","reserveProgress":"Building_reserveProgress--1o51V","upgradeAvailable":"Building_upgradeAvailable--rHtFn"};

/***/ }),
/* 560 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Direction_base--2ua8y","base__A":"Direction_base__A--3e63o","baseA":"Direction_base__A--3e63o","base__lvl1":"Direction_base__lvl1--24FZ5","baseLvl1":"Direction_base__lvl1--24FZ5","base__lvl2":"Direction_base__lvl2--H4TrE","baseLvl2":"Direction_base__lvl2--H4TrE","base__lvl3":"Direction_base__lvl3--2lEKP","baseLvl3":"Direction_base__lvl3--2lEKP","base__lvl4":"Direction_base__lvl4--3fzrV","baseLvl4":"Direction_base__lvl4--3fzrV","base__lvl5":"Direction_base__lvl5--wyY7z","baseLvl5":"Direction_base__lvl5--wyY7z","base__lvl6":"Direction_base__lvl6--3KoMZ","baseLvl6":"Direction_base__lvl6--3KoMZ","base__lvl7":"Direction_base__lvl7--1lzkZ","baseLvl7":"Direction_base__lvl7--1lzkZ","base__lvl8":"Direction_base__lvl8--3YMCD","baseLvl8":"Direction_base__lvl8--3YMCD","base__lvl9":"Direction_base__lvl9--2ZsqE","baseLvl9":"Direction_base__lvl9--2ZsqE","base__lvl10":"Direction_base__lvl10--1tRVI","baseLvl10":"Direction_base__lvl10--1tRVI","base__B":"Direction_base__B--1-eRz","baseB":"Direction_base__B--1-eRz","base__C":"Direction_base__C--1YmPR","baseC":"Direction_base__C--1YmPR","base__D":"Direction_base__D--BGRwc","baseD":"Direction_base__D--BGRwc"};

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _StatsTable$themes;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _helpers = __webpack_require__(11);

var _i18n = __webpack_require__(10);

var _constants = __webpack_require__(562);

var _StatsTableTooltip = __webpack_require__(563);

var _StatsTableTooltip2 = _interopRequireDefault(_StatsTableTooltip);

var _StatsTableExternal = __webpack_require__(564);

var _StatsTableExternal2 = _interopRequireDefault(_StatsTableExternal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var THEMES = {
    tooltip: 'tooltip',
    external: 'external'
};

var StatsTable = function StatsTable(props) {
    var _themes;

    var elo = props.elo,
        sorties = props.sorties,
        fortBattles = props.fort_battles,
        level = props.level,
        elo_details = props.elo_details;


    var themes = (_themes = {}, _defineProperty(_themes, THEMES.tooltip, _StatsTableTooltip2.default), _defineProperty(_themes, THEMES.external, _StatsTableExternal2.default), _themes);
    var styles = themes[props.theme];

    var hasSorties = sorties.battles_count;
    var hasFortBattles = fortBattles && fortBattles.battles_count;
    var fortBattlesUnavailable = !fortBattles;

    var tableTitleClassName = function tableTitleClassName(cell) {
        return (0, _classnames2.default)(styles[cell], styles[cell + '__title'], styles[cell + '__left']);
    };
    var tableValuesClassName = function tableValuesClassName(cell) {
        return (0, _classnames2.default)(styles[cell], styles[cell + '__values'], styles[cell + '__right']);
    };

    var ratingMessage = void 0;
    if (!elo_details) {
        ratingMessage = null;
    } else if (elo_details.position && elo_details.position !== null) {
        var message = (0, _i18n.RATING_POSITION)(_react2.default.createElement(
            'span',
            { className: styles.descriptionValue },
            _react2.default.createElement(_reactIntl.FormattedNumber, { value: elo_details.position })
        ));
        ratingMessage = _react2.default.createElement(
            'p',
            { className: styles.description },
            message
        );
    } else {
        var _message = (0, _i18n.LESS_THAN_REQUIRED_BATTLES_COUNT)(_react2.default.createElement(_reactIntl.FormattedNumber, { value: elo_details.battles_count }), _react2.default.createElement(_reactIntl.FormattedNumber, { value: elo_details.required_battles_count }));
        ratingMessage = _react2.default.createElement(
            'p',
            { className: styles.description },
            _message
        );
    }

    var noSortiesNode = _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            'p',
            { className: styles.noBattlesTitle },
            _i18n.SORTIES
        ),
        _react2.default.createElement(
            'p',
            { className: styles.noBattles },
            (0, _constants.STATS_TOOLTIP_NO_SORTIES)((0, _helpers.toRoman)(level))
        )
    );

    var sortiesNode = hasSorties ? _react2.default.createElement(
        'div',
        { className: styles.table },
        _react2.default.createElement(
            'div',
            { className: styles.thead },
            _react2.default.createElement(
                'div',
                { className: styles.tr },
                _react2.default.createElement(
                    'div',
                    { className: tableTitleClassName('th') },
                    _i18n.SORTIES
                ),
                _react2.default.createElement(
                    'div',
                    { className: tableValuesClassName('th') },
                    _constants.STATS_TOOLTIP_ALL_TIME_STATS
                ),
                _react2.default.createElement(
                    'div',
                    { className: tableValuesClassName('th') },
                    _constants.STATS_TOOLTIP_28_DAYS_STATS
                )
            )
        ),
        _react2.default.createElement(
            'div',
            { className: styles.tbody },
            _react2.default.createElement(
                'div',
                { className: styles.tr },
                _react2.default.createElement(
                    'div',
                    { className: tableTitleClassName('td') },
                    _constants.STATS_TOOLTIP_SORTIES_COUNT
                ),
                _react2.default.createElement(
                    'div',
                    { className: tableValuesClassName('td') },
                    _react2.default.createElement(_reactIntl.FormattedNumber, { value: sorties.battles_count })
                ),
                _react2.default.createElement(
                    'div',
                    { className: tableValuesClassName('td') },
                    _react2.default.createElement(_reactIntl.FormattedNumber, { value: sorties.battles_count_for_last_28_days })
                )
            ),
            _react2.default.createElement(
                'div',
                { className: styles.tr },
                _react2.default.createElement(
                    'div',
                    { className: tableTitleClassName('td') },
                    _constants.STATS_TOOLTIP_WIN_RATE
                ),
                _react2.default.createElement(
                    'div',
                    { className: tableValuesClassName('td') },
                    sorties.wins_percent + '%'
                ),
                _react2.default.createElement(
                    'div',
                    { className: tableValuesClassName('td') },
                    sorties.wins_percent_for_last_28_days + '%'
                )
            )
        )
    ) : noSortiesNode;

    var noFortBattlesNode = !fortBattlesUnavailable ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            'p',
            { className: styles.noBattlesTitle },
            _constants.STATS_TOOLTIP_FORT_BATTLES
        ),
        _react2.default.createElement(
            'p',
            { className: styles.noBattles },
            _constants.STATS_TOOLTIP_NO_FORT_BATTLES
        )
    ) : null;

    var fortBattlesNode = hasFortBattles ? _react2.default.createElement(
        'div',
        { className: styles.table },
        _react2.default.createElement(
            'div',
            { className: styles.thead },
            _react2.default.createElement(
                'div',
                { className: styles.tr },
                _react2.default.createElement(
                    'div',
                    { className: tableTitleClassName('th') },
                    _constants.STATS_TOOLTIP_FORT_BATTLES
                ),
                _react2.default.createElement(
                    'div',
                    { className: tableValuesClassName('th') },
                    _constants.STATS_TOOLTIP_ALL_TIME_STATS
                ),
                _react2.default.createElement(
                    'div',
                    { className: tableValuesClassName('th') },
                    _constants.STATS_TOOLTIP_28_DAYS_STATS
                )
            )
        ),
        _react2.default.createElement(
            'div',
            { className: styles.tbody },
            _react2.default.createElement(
                'div',
                { className: styles.tr },
                _react2.default.createElement(
                    'div',
                    { className: tableTitleClassName('td') },
                    _constants.STATS_TOOLTIP_FORT_BATTLES_COUNT
                ),
                _react2.default.createElement(
                    'div',
                    { className: tableValuesClassName('td') },
                    _react2.default.createElement(_reactIntl.FormattedNumber, { value: fortBattles.battles_count })
                ),
                _react2.default.createElement(
                    'div',
                    { className: tableValuesClassName('td') },
                    _react2.default.createElement(_reactIntl.FormattedNumber, { value: fortBattles.battles_count_for_last_28_days })
                )
            ),
            _react2.default.createElement(
                'div',
                { className: styles.tr },
                _react2.default.createElement(
                    'div',
                    { className: tableTitleClassName('td') },
                    _constants.STATS_TOOLTIP_WIN_RATE
                ),
                _react2.default.createElement(
                    'div',
                    { className: tableValuesClassName('td') },
                    fortBattles.wins_percent + '%'
                ),
                _react2.default.createElement(
                    'div',
                    { className: tableValuesClassName('td') },
                    fortBattles.wins_percent_for_last_28_days + '%'
                )
            )
        )
    ) : noFortBattlesNode;

    var divider = _react2.default.createElement('div', { className: styles.divider });

    if (!hasSorties && !hasFortBattles) {
        return _react2.default.createElement(
            'div',
            { className: styles.base },
            _react2.default.createElement(
                'p',
                { className: styles.title },
                (0, _constants.STATS_TOOLTIP_HEADER)((0, _helpers.toRoman)(level))
            ),
            _react2.default.createElement(
                'p',
                { className: styles.noBattles },
                (0, _constants.STATS_TOOLTIP_NO_STATS)((0, _helpers.toRoman)(level))
            )
        );
    }

    return _react2.default.createElement(
        'div',
        { className: styles.base },
        _react2.default.createElement(
            'p',
            { className: styles.title },
            (0, _constants.STATS_TOOLTIP_HEADER)((0, _helpers.toRoman)(level))
        ),
        _react2.default.createElement(
            'p',
            { className: styles.description },
            _react2.default.createElement(
                'span',
                { className: styles.descriptionTitle },
                _i18n.ELO_RATING_TEXT,
                ': '
            ),
            _react2.default.createElement(
                'span',
                { className: styles.descriptionValue },
                _react2.default.createElement(_reactIntl.FormattedNumber, { value: elo })
            )
        ),
        ratingMessage,
        divider,
        sortiesNode,
        divider,
        fortBattlesNode
    );
};

StatsTable.propTypes = {
    elo: _propTypes2.default.number.isRequired,
    level: _propTypes2.default.string.isRequired,
    fort_battles: _propTypes2.default.shape({
        battles_count: _propTypes2.default.number.isRequired,
        battles_count_for_last_28_days: _propTypes2.default.number.isRequired,
        wins_percent: _propTypes2.default.number.isRequired,
        wins_percent_for_last_28_days: _propTypes2.default.number.isRequired
    }),
    sorties: _propTypes2.default.shape({
        battles_count: _propTypes2.default.number.isRequired,
        battles_count_for_last_28_days: _propTypes2.default.number.isRequired,
        wins_percent: _propTypes2.default.number.isRequired,
        wins_percent_for_last_28_days: _propTypes2.default.number.isRequired
    }).isRequired,
    theme: _propTypes2.default.oneOf(Object.values(THEMES)).isRequired,
    elo_details: _propTypes2.default.shape({
        position: _propTypes2.default.number,
        battles_count: _propTypes2.default.number,
        required_battles_count: _propTypes2.default.number
    })
};

StatsTable.defaultProps = {
    theme: THEMES.tooltip
};

StatsTable.themes = (_StatsTable$themes = {}, _defineProperty(_StatsTable$themes, THEMES.tooltip, THEMES.tooltip), _defineProperty(_StatsTable$themes, THEMES.external, THEMES.external), _StatsTable$themes);

exports.default = StatsTable;

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.STATS_TOOLTIP_HEADER = exports.STATS_TOOLTIP_NO_STATS = exports.STATS_TOOLTIP_FORT_BATTLES = exports.STATS_TOOLTIP_NO_FORT_BATTLES = exports.STATS_TOOLTIP_NO_SORTIES = exports.STATS_TOOLTIP_FORT_BATTLES_COUNT = exports.STATS_TOOLTIP_SORTIES_COUNT = exports.STATS_TOOLTIP_WIN_RATE = exports.STATS_TOOLTIP_28_DAYS_STATS = exports.STATS_TOOLTIP_ALL_TIME_STATS = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-multi-comp */
var STATS_TOOLTIP_ALL_TIME_STATS = exports.STATS_TOOLTIP_ALL_TIME_STATS = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'stats_tooltip.all_time_stats',
    defaultMessage: '\u0417\u0430 \u0432\u0441\u0451 \u0432\u0440\u0435\u043C\u044F'
});

var STATS_TOOLTIP_28_DAYS_STATS = exports.STATS_TOOLTIP_28_DAYS_STATS = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'stats_tooltip.28_days_stats',
    defaultMessage: '\u0417\u0430 28 \u0434\u043D\u0435\u0439'
});

var STATS_TOOLTIP_WIN_RATE = exports.STATS_TOOLTIP_WIN_RATE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'stats_tooltip.win_rate',
    defaultMessage: '\u041F\u0440\u043E\u0446\u0435\u043D\u0442 \u043F\u043E\u0431\u0435\u0434'
});

var STATS_TOOLTIP_SORTIES_COUNT = exports.STATS_TOOLTIP_SORTIES_COUNT = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'stats_tooltip.sorties_count',
    defaultMessage: '\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0431\u043E\u0451\u0432'
});
var STATS_TOOLTIP_FORT_BATTLES_COUNT = exports.STATS_TOOLTIP_FORT_BATTLES_COUNT = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'stats_tooltip.fort_battles_count',
    defaultMessage: '\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u041D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u0439'
});

var STATS_TOOLTIP_NO_SORTIES = exports.STATS_TOOLTIP_NO_SORTIES = function STATS_TOOLTIP_NO_SORTIES(level) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'stats_tooltip.no_sorties',
        defaultMessage: '\u041A\u043B\u0430\u043D \u043D\u0435 \u043F\u0440\u043E\u0432\u043E\u0434\u0438\u043B \u0412\u044B\u043B\u0430\u0437\u043A\u0438 {level} \u0434\u0438\u0432\u0438\u0437\u0438\u043E\u043D\u0430',
        values: { level: level }
    });
};
var STATS_TOOLTIP_NO_FORT_BATTLES = exports.STATS_TOOLTIP_NO_FORT_BATTLES = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'stats_tooltip.no_fort_battles',
    defaultMessage: '\u041A\u043B\u0430\u043D \u043D\u0435 \u043F\u0440\u043E\u0432\u043E\u0434\u0438\u043B \u041D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u044F'
});

var STATS_TOOLTIP_FORT_BATTLES = exports.STATS_TOOLTIP_FORT_BATTLES = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'stats_tooltip.fort_battles',
    defaultMessage: '\u041D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u044F'
});

var STATS_TOOLTIP_NO_STATS = exports.STATS_TOOLTIP_NO_STATS = function STATS_TOOLTIP_NO_STATS(level) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'stats_tooltip.no_stats',
        defaultMessage: '\u041A\u043B\u0430\u043D \u043D\u0435 \u043F\u0440\u043E\u0432\u043E\u0434\u0438\u043B \u0441\u0440\u0430\u0436\u0435\u043D\u0438\u044F \u043D\u0430 {level} \u0434\u0438\u0432\u0438\u0437\u0438\u043E\u043D\u0435',
        values: { level: level }
    });
};

var STATS_TOOLTIP_HEADER = exports.STATS_TOOLTIP_HEADER = function STATS_TOOLTIP_HEADER(level) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'stats_tooltip.header',
        defaultMessage: '\u0421\u0440\u0430\u0436\u0435\u043D\u0438\u044F \u043D\u0430 {level} \u0443\u0440\u043E\u0432\u043D\u0435',
        values: { level: level }
    });
};

/***/ }),
/* 563 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"table":"StatsTable-tooltip_table--2eQbl","thead":"StatsTable-tooltip_thead--3alLz","tbody":"StatsTable-tooltip_tbody--tfOV9","tr":"StatsTable-tooltip_tr--2TPSM","tr__selected":"StatsTable-tooltip_tr__selected--3GvG9","trSelected":"StatsTable-tooltip_tr__selected--3GvG9","tr__clickable":"StatsTable-tooltip_tr__clickable--eD8WX","trClickable":"StatsTable-tooltip_tr__clickable--eD8WX","tr__hoverable":"StatsTable-tooltip_tr__hoverable--2ejz6","trHoverable":"StatsTable-tooltip_tr__hoverable--2ejz6","th":"StatsTable-tooltip_th--1Anh3","td":"StatsTable-tooltip_td--28q_I","th__basis":"StatsTable-tooltip_th__basis--3LE7l","thBasis":"StatsTable-tooltip_th__basis--3LE7l","td__basis":"StatsTable-tooltip_td__basis--2d1nK","tdBasis":"StatsTable-tooltip_td__basis--2d1nK","th__left":"StatsTable-tooltip_th__left--2d-bk","thLeft":"StatsTable-tooltip_th__left--2d-bk","td__left":"StatsTable-tooltip_td__left--1D_ct","tdLeft":"StatsTable-tooltip_td__left--1D_ct","th__center":"StatsTable-tooltip_th__center--1BQZI","thCenter":"StatsTable-tooltip_th__center--1BQZI","td__center":"StatsTable-tooltip_td__center--2evWB","tdCenter":"StatsTable-tooltip_td__center--2evWB","th__right":"StatsTable-tooltip_th__right--3vui8","thRight":"StatsTable-tooltip_th__right--3vui8","td__right":"StatsTable-tooltip_td__right--1Ttvk","tdRight":"StatsTable-tooltip_td__right--1Ttvk","th__top":"StatsTable-tooltip_th__top--39TOG","thTop":"StatsTable-tooltip_th__top--39TOG","td__top":"StatsTable-tooltip_td__top--MgKOW","tdTop":"StatsTable-tooltip_td__top--MgKOW","td__span4":"StatsTable-tooltip_td__span4--1CSD3","tdSpan4":"StatsTable-tooltip_td__span4--1CSD3","base__debug":"StatsTable-tooltip_base__debug--37Upv","baseDebug":"StatsTable-tooltip_base__debug--37Upv","spacer":"StatsTable-tooltip_spacer--3RQ6T","th__title":"StatsTable-tooltip_th__title--1HMTj","thTitle":"StatsTable-tooltip_th__title--1HMTj","td__title":"StatsTable-tooltip_td__title--TwRng","tdTitle":"StatsTable-tooltip_td__title--TwRng","th__values":"StatsTable-tooltip_th__values--ikZvs","thValues":"StatsTable-tooltip_th__values--ikZvs","td__values":"StatsTable-tooltip_td__values--3mfjS","tdValues":"StatsTable-tooltip_td__values--3mfjS","noBattlesTitle":"StatsTable-tooltip_noBattlesTitle--1K2V2","noBattles":"StatsTable-tooltip_noBattles--rrueN","divider":"StatsTable-tooltip_divider--cxePT","title":"StatsTable-tooltip_title--1pHG8"};

/***/ }),
/* 564 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"table":"StatsTable-external_table--2mvHd","thead":"StatsTable-external_thead--Ut-LY","tbody":"StatsTable-external_tbody--2TBVU","tr":"StatsTable-external_tr--3XrTO","tr__selected":"StatsTable-external_tr__selected--K764c","trSelected":"StatsTable-external_tr__selected--K764c","tr__clickable":"StatsTable-external_tr__clickable--19nwo","trClickable":"StatsTable-external_tr__clickable--19nwo","tr__hoverable":"StatsTable-external_tr__hoverable--1-nBV","trHoverable":"StatsTable-external_tr__hoverable--1-nBV","th":"StatsTable-external_th--1B4Yw","td":"StatsTable-external_td--hVkHu","th__basis":"StatsTable-external_th__basis--3c1HO","thBasis":"StatsTable-external_th__basis--3c1HO","td__basis":"StatsTable-external_td__basis--3nXh1","tdBasis":"StatsTable-external_td__basis--3nXh1","th__left":"StatsTable-external_th__left--2okl8","thLeft":"StatsTable-external_th__left--2okl8","td__left":"StatsTable-external_td__left--KG2R6","tdLeft":"StatsTable-external_td__left--KG2R6","th__center":"StatsTable-external_th__center--o_1Rf","thCenter":"StatsTable-external_th__center--o_1Rf","td__center":"StatsTable-external_td__center--bXHjl","tdCenter":"StatsTable-external_td__center--bXHjl","th__right":"StatsTable-external_th__right--305G3","thRight":"StatsTable-external_th__right--305G3","td__right":"StatsTable-external_td__right--3VRe2","tdRight":"StatsTable-external_td__right--3VRe2","th__top":"StatsTable-external_th__top--2Gf2l","thTop":"StatsTable-external_th__top--2Gf2l","td__top":"StatsTable-external_td__top--2ChQj","tdTop":"StatsTable-external_td__top--2ChQj","td__span4":"StatsTable-external_td__span4--2riK_","tdSpan4":"StatsTable-external_td__span4--2riK_","base__debug":"StatsTable-external_base__debug--352yg","baseDebug":"StatsTable-external_base__debug--352yg","spacer":"StatsTable-external_spacer--2GVod","th__title":"StatsTable-external_th__title--aB27_","thTitle":"StatsTable-external_th__title--aB27_","td__title":"StatsTable-external_td__title--3dXIA","tdTitle":"StatsTable-external_td__title--3dXIA","th__values":"StatsTable-external_th__values--oSW7-","thValues":"StatsTable-external_th__values--oSW7-","td__values":"StatsTable-external_td__values--9eVTk","tdValues":"StatsTable-external_td__values--9eVTk","noBattlesTitle":"StatsTable-external_noBattlesTitle--2rx-1","noBattles":"StatsTable-external_noBattles--1iql_","divider":"StatsTable-external_divider--2Ih5-","title":"StatsTable-external_title--jnvUq","description":"StatsTable-external_description--3iD9x","descriptionValue":"StatsTable-external_descriptionValue--SY1a3"};

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _slider = __webpack_require__(2217);

var _slider2 = _interopRequireDefault(_slider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _slider2.default;

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.openClanSearch = openClanSearch;
exports.openInvitations = openInvitations;
var WEB_TO_CLIENT_COMMAND = exports.WEB_TO_CLIENT_COMMAND = 'app/WEB_TO_CLIENT_COMMAND';

function openClanSearch() {
    var webToClient = {
        handler: 'openWindow',
        params: {
            windowId: 'clan_search_window'
        }
    };

    return {
        type: WEB_TO_CLIENT_COMMAND,
        meta: { webToClient: webToClient }
    };
}

function openInvitations() {
    var webToClient = {
        handler: 'openWindow',
        params: {
            windowId: 'clan_personal_invites_window'
        }
    };

    return {
        type: WEB_TO_CLIENT_COMMAND,
        meta: { webToClient: webToClient }
    };
}

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LANDING_GOTO_CLAN_SUPPLY_IS_DISABLED_TOOLTIP = exports.LANDING_GOTO_CLAN_SUPPLY_TOOLTIP = exports.LANDING_GOTO_CLAN_SUPPLY = exports.LANDING_GOTO_MANEUVERS_EVENT = exports.LANDING_GOTO_MANEUVERS_EVENT_TOOLTIP = exports.LANDING_GOTO_GLOBAL_MAP_EVENT_TOOLTIP = exports.LANDING_PROMO_AWARD_MESSAGE = exports.LANDING_PROMO_AWARD_HEADER = exports.LANDING_GOTO_SELECTION_CLAN_TOOLTIP = exports.LANDING_GOTO_SELECTION_CLAN = exports.LANDING_GOTO_INVITATIONS_TOOLTIP = exports.LANDING_GOTO_INVITATIONS = exports.LANDING_GOTO_CREATE_CLAN_TOOLTIP = exports.LANDING_GOTO_CREATE_CLAN = exports.LANDING_GOTO_BATTLE_TOOLTIP = exports.LANDING_GOTO_BATTLE = exports.LANDING_GOTO_BACK = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LANDING_GOTO_BACK = exports.LANDING_GOTO_BACK = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'landing.goto.back',
    defaultMessage: '\u041A \u041E\u041F\u0418\u0421\u0410\u041D\u0418\u042E'
});

var LANDING_GOTO_BATTLE = exports.LANDING_GOTO_BATTLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'landing.goto.battle',
    defaultMessage: '\u0421\u0442\u0430\u0442\u044C \u043B\u0435\u0433\u0438\u043E\u043D\u0435\u0440\u043E\u043C'
});

var LANDING_GOTO_BATTLE_TOOLTIP = exports.LANDING_GOTO_BATTLE_TOOLTIP = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'landing.goto.battle.tooltip',
    defaultMessage: '\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043A \u043F\u043E\u0434\u0431\u043E\u0440\u0443 \u043E\u0442\u0440\u044F\u0434\u0430 \u0434\u043B\u044F \u0443\u0447\u0430\u0441\u0442\u0438\u044F \u0432 \u043A\u043B\u0430\u043D\u043E\u0432\u044B\u0445 \u0431\u043E\u044F\u0445 \u0432 \u0440\u043E\u043B\u0438 \u043B\u0435\u0433\u0438\u043E\u043D\u0435\u0440\u0430'
});

var LANDING_GOTO_CREATE_CLAN = exports.LANDING_GOTO_CREATE_CLAN = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'landing.goto.create.clan',
    defaultMessage: '\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u043A\u043B\u0430\u043D'
});

var LANDING_GOTO_CREATE_CLAN_TOOLTIP = exports.LANDING_GOTO_CREATE_CLAN_TOOLTIP = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'landing.goto.create.clan.tooltip',
    defaultMessage: '\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u043A\u043B\u0430\u043D\u043E\u0432\u044B\u0439 \u043F\u043E\u0440\u0442\u0430\u043B \u0434\u043B\u044F \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u044F \u043A\u043B\u0430\u043D\u0430'
});

var LANDING_GOTO_INVITATIONS = exports.LANDING_GOTO_INVITATIONS = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'landing.goto.invitations',
    defaultMessage: '\u041F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u0432 \u043A\u043B\u0430\u043D'
});

var LANDING_GOTO_INVITATIONS_TOOLTIP = exports.LANDING_GOTO_INVITATIONS_TOOLTIP = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'landing.goto.invitations.tooltip',
    defaultMessage: '\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043A \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F\u043C \u0432 \u043A\u043B\u0430\u043D'
});

var LANDING_GOTO_SELECTION_CLAN = exports.LANDING_GOTO_SELECTION_CLAN = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'landing.goto.selection.clan',
    defaultMessage: '\u041A \u043F\u043E\u0434\u0431\u043E\u0440\u0443 \u043A\u043B\u0430\u043D\u0430'
});

var LANDING_GOTO_SELECTION_CLAN_TOOLTIP = exports.LANDING_GOTO_SELECTION_CLAN_TOOLTIP = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'landing.goto.selection.clan.tooltip',
    defaultMessage: '\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043A \u043F\u043E\u0434\u0431\u043E\u0440\u0443 \u043A\u043B\u0430\u043D\u0430'
});

var LANDING_PROMO_AWARD_HEADER = exports.LANDING_PROMO_AWARD_HEADER = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'landing_promo.award_header',
    defaultMessage: '\u0423\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0439 \u0441\u0442\u0438\u043B\u044C \u0434\u043B\u044F \u043A\u043B\u0430\u043D\u043E\u0432\u044B\u0445 \u0438\u0433\u0440\u043E\u043A\u043E\u0432'
});

var LANDING_PROMO_AWARD_MESSAGE = exports.LANDING_PROMO_AWARD_MESSAGE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'landing_promo.award_message'
    // eslint-disable-next-line max-len
    , defaultMessage: '\u041A\u0430\u0436\u0434\u044B\u0439 \u0438\u0433\u0440\u043E\u043A, \u043D\u0430\u0445\u043E\u0434\u044F\u0449\u0438\u0439\u0441\u044F \u0432 \u043A\u043B\u0430\u043D\u0435, \u043F\u043E\u043B\u0443\u0447\u0430\u0435\u0442 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0439 \u0441\u0442\u0438\u043B\u044C \xAB\u041A\u043B\u0430\u043D\u043E\u0432\u044B\u0439 \u043F\u043E\u0432\u0441\u0435\u0434\u043D\u0435\u0432\u043D\u044B\u0439\xBB, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u043C\u043E\u0436\u043D\u043E \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u043D\u0430 \u043C\u0430\u0448\u0438\u043D\u0443 \u043B\u044E\u0431\u043E\u0433\u043E \u0443\u0440\u043E\u0432\u043D\u044F.'
});

var LANDING_GOTO_GLOBAL_MAP_EVENT_TOOLTIP = exports.LANDING_GOTO_GLOBAL_MAP_EVENT_TOOLTIP = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'landing.goto.global_map_event.tooltip',
    defaultMessage: '\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043A \u0441\u043E\u0431\u044B\u0442\u0438\u044E'
});

var LANDING_GOTO_MANEUVERS_EVENT_TOOLTIP = exports.LANDING_GOTO_MANEUVERS_EVENT_TOOLTIP = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'landing.goto.maneuvers_event.tooltip',
    defaultMessage: '\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043A \u0441\u043E\u0431\u044B\u0442\u0438\u044E'
});

var LANDING_GOTO_MANEUVERS_EVENT = exports.LANDING_GOTO_MANEUVERS_EVENT = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'landing.goto.maneuvers_event',
    defaultMessage: '\u041C\u0430\u043D\u0451\u0432\u0440\u044B'
});

var LANDING_GOTO_CLAN_SUPPLY = exports.LANDING_GOTO_CLAN_SUPPLY = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'landing.goto.clan_supply',
    defaultMessage: '\u0411\u043E\u0435\u0432\u043E\u0439 \u043F\u043E\u0445\u043E\u0434'
});

var LANDING_GOTO_CLAN_SUPPLY_TOOLTIP = exports.LANDING_GOTO_CLAN_SUPPLY_TOOLTIP = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'landing.goto.clan_supply.tooltip',
    defaultMessage: '\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043A \u0431\u043E\u0435\u0432\u043E\u043C\u0443 \u043F\u043E\u0445\u043E\u0434\u0443'
});

var LANDING_GOTO_CLAN_SUPPLY_IS_DISABLED_TOOLTIP = exports.LANDING_GOTO_CLAN_SUPPLY_IS_DISABLED_TOOLTIP = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'landing.goto.clan_supply.is_disabled.tooltip',
    defaultMessage: '\u041F\u0440\u043E\u0433\u0440\u0435\u0441\u0441 \u0431\u043E\u0435\u0432\u043E\u0433\u043E \u043F\u043E\u0445\u043E\u0434\u0430 \u043F\u0440\u0438\u043E\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D'
});

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SlideInner = __webpack_require__(2291);

var _SlideInner2 = _interopRequireDefault(_SlideInner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SlideInner = function SlideInner(props) {
    var description = props.description.map(function (message, i) {
        return _react2.default.createElement(
            'div',
            { key: i, className: _SlideInner2.default.slideMessage },
            message
        );
    });

    return _react2.default.createElement(
        'div',
        { className: _SlideInner2.default.base },
        _react2.default.createElement(
            'div',
            { className: _SlideInner2.default.slideContainer },
            props.children,
            _react2.default.createElement(
                'div',
                { className: _SlideInner2.default.description },
                _react2.default.createElement(
                    'div',
                    { className: _SlideInner2.default.slideHeader },
                    props.title
                ),
                description
            )
        )
    );
};

SlideInner.propTypes = {
    title: _propTypes2.default.element,
    description: _propTypes2.default.array,
    children: _propTypes2.default.node.isRequired
};

exports.default = SlideInner;

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectMapProgress = exports.selectMapSettings = exports.selectQuests = undefined;

var _models = __webpack_require__(2349);

var selectQuests = exports.selectQuests = function selectQuests(state) {
  return (0, _models.questsDataModel)(state.clanSupplyQuests);
};
var selectMapSettings = exports.selectMapSettings = function selectMapSettings(state) {
  return (0, _models.mapSettingsDataModel)(state.clanSupplyProgressionSettings);
};
var selectMapProgress = exports.selectMapProgress = function selectMapProgress(state) {
  return (0, _models.mapProgressDataModel)(state.clanSupplyProgression);
};

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EARNED_RESOURCE_TOOLTIP_TITLE = exports.TREASURY = exports.MEMBERS_ONLINE = exports.CAPTION_ABOUT_INDICATORS = exports.TITLE_STAFF = exports.STATISTICS_BATTLE_TYPE_SELECT_CAPTION = exports.STATISTICS_BATTLE_GLOBAL_MAP = exports.STATISTICS_BATTLE_TYPES_FORT = exports.STATISTICS_BATTLE_TYPES_SKIRMISHES = exports.STATISTICS_BATTLE_TYPES_TEAM = exports.STATISTICS_BATTLE_TYPES_RANKED = exports.STATISTICS_BATTLE_TYPES_RANDOM = exports.BLOCK_TYPES_STATISTICS = exports.BLOCK_TYPES_CLAN_MODES = exports.PERIOD_ALL_TIME = exports.PERIOD_1_DAY = exports.PERIOD_7_DAYS = exports.PERIOD_28_DAYS = exports.PERIOD_FILTER_CAPTION = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _reactWotBootstrap = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PERIOD_FILTER_CAPTION = exports.PERIOD_FILTER_CAPTION = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clanmanagement.period.filter.caption',
    defaultMessage: '\u041F\u0435\u0440\u0438\u043E\u0434:'
});

var PERIOD_28_DAYS = exports.PERIOD_28_DAYS = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clanmanagement.period.28_days',
    defaultMessage: '28 \u0434.'
});

var PERIOD_7_DAYS = exports.PERIOD_7_DAYS = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clanmanagement.period.7_days',
    defaultMessage: '7 \u0434.'
});

var PERIOD_1_DAY = exports.PERIOD_1_DAY = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clanmanagement.period.1_day',
    defaultMessage: '1 \u0434.'
});

var PERIOD_ALL_TIME = exports.PERIOD_ALL_TIME = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clanmanagement.period.all_time',
    defaultMessage: '\u0412\u0441\u0451 \u0432\u0440\u0435\u043C\u044F'
});

var BLOCK_TYPES_CLAN_MODES = exports.BLOCK_TYPES_CLAN_MODES = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clanmanagement.block_types.clan_modes',
    defaultMessage: '\u041A\u043B\u0430\u043D\u043E\u0432\u044B\u0435 \u0440\u0435\u0436\u0438\u043C\u044B'
});

var BLOCK_TYPES_STATISTICS = exports.BLOCK_TYPES_STATISTICS = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clanmanagement.block_types.statistics',
    defaultMessage: '\u0421\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0430'
});

var STATISTICS_BATTLE_TYPES_RANDOM = exports.STATISTICS_BATTLE_TYPES_RANDOM = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clanmanagement.statistics_battle_types.random',
    defaultMessage: '\u0421\u043B\u0443\u0447\u0430\u0439\u043D\u044B\u0439'
});

var STATISTICS_BATTLE_TYPES_RANKED = exports.STATISTICS_BATTLE_TYPES_RANKED = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clanmanagement.statistics_battle_types.ranked',
    defaultMessage: '\u0420\u0430\u043D\u0433\u043E\u0432\u044B\u0439'
});

var STATISTICS_BATTLE_TYPES_TEAM = exports.STATISTICS_BATTLE_TYPES_TEAM = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clanmanagement.statistics_battle_types.team',
    defaultMessage: '\u041A\u043E\u043C\u0430\u043D\u0434\u043D\u044B\u0439'
});

var STATISTICS_BATTLE_TYPES_SKIRMISHES = exports.STATISTICS_BATTLE_TYPES_SKIRMISHES = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clanmanagement.statistics_battle_types.skirmishes',
    defaultMessage: '\u0412\u044B\u043B\u0430\u0437\u043A\u0430'
});

var STATISTICS_BATTLE_TYPES_FORT = exports.STATISTICS_BATTLE_TYPES_FORT = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clanmanagement.statistics_battle_types.fort',
    defaultMessage: '\u0411\u043E\u0438 \u0432 \u041D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u044F\u0445'
});

var STATISTICS_BATTLE_GLOBAL_MAP = exports.STATISTICS_BATTLE_GLOBAL_MAP = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clanmanagement.statistics_battle_types.global_map',
    defaultMessage: '\u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u0430\u044F \u043A\u0430\u0440\u0442\u0430'
});

var STATISTICS_BATTLE_TYPE_SELECT_CAPTION = exports.STATISTICS_BATTLE_TYPE_SELECT_CAPTION = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clanmanagement.statistics_battle_types_select.caption',
    defaultMessage: '\u0420\u0435\u0436\u0438\u043C \u0431\u043E\u044F:'
});

var TITLE_STAFF = exports.TITLE_STAFF = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clanmanagement.title.staff',
    defaultMessage: '\u041B\u0438\u0447\u043D\u044B\u0439 \u0441\u043E\u0441\u0442\u0430\u0432'
});

var CAPTION_ABOUT_INDICATORS = exports.CAPTION_ABOUT_INDICATORS = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clanmanagement.title.about_indicators',
    defaultMessage: '\u041E \u043F\u043E\u043A\u0430\u0437\u0430\u0442\u0435\u043B\u044F\u0445'
});

var emptyPlaceholder = '--';
var MEMBERS_ONLINE = exports.MEMBERS_ONLINE = function MEMBERS_ONLINE(membersOnline, membersTotal) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'clan_management.members',
        defaultMessage: '\u0418\u0433\u0440\u043E\u043A\u043E\u0432 \u0432 \u0441\u0435\u0442\u0438: {membersOnline}/{membersTotal}',
        values: {
            membersOnline: _react2.default.createElement(_reactWotBootstrap.Member, { name: membersOnline || emptyPlaceholder, status: 'online' }),
            membersTotal: membersTotal || emptyPlaceholder
        }
    });
};

var TREASURY = exports.TREASURY = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'treasury_subtitle',
    defaultMessage: '\u041A\u0430\u0437\u043D\u0430 \u043A\u043B\u0430\u043D\u0430:'
});

var EARNED_RESOURCE_TOOLTIP_TITLE = exports.EARNED_RESOURCE_TOOLTIP_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clanmanagement.tooltips.earned_resource_header',
    defaultMessage: '\u041F\u0440\u043E\u043C\u0440\u0435\u0441\u0443\u0440\u0441 \u0434\u043B\u044F \u043A\u043B\u0430\u043D\u0430'
});

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DaysInClanColumnTooltipContent = exports.DamageColumnTooltipContent = exports.ExperienceColumnTooltipContent = exports.WinRateColumnTooltipContent = exports.BattlesCountColumnTooltipContent = exports.PersonalRatingColumnTooltipContent = exports.BattleTypeTooltip = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _reactWotBootstrap = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BattleTypeTooltip = exports.BattleTypeTooltip = function BattleTypeTooltip() {
    return _react2.default.createElement(
        _reactWotBootstrap.Tooltip,
        { id: BattleTypeTooltip.id },
        _react2.default.createElement(
            _reactWotBootstrap.TooltipBody,
            null,
            _react2.default.createElement(
                _reactWotBootstrap.TooltipSubtitle,
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'clanmanagement.tooltips.battle_type_header',
                    defaultMessage: '\u0421\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u043A\u0430 \u043F\u043E \u0440\u0435\u0436\u0438\u043C\u0443 \u0431\u043E\u044F'
                })
            ),
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'clanmanagement.tooltips.battle_type_body',
                defaultMessage: '\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0441\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0443 \u0438\u0433\u0440\u043E\u043A\u043E\u0432 \u0432 \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u043C \u0440\u0435\u0436\u0438\u043C\u0435 \u0431\u043E\u044F.'
            })
        )
    );
}; /* eslint-disable react/no-multi-comp, max-len */

BattleTypeTooltip.id = 'battle-type-tooltip';

var PersonalRatingColumnTooltipContent = exports.PersonalRatingColumnTooltipContent = function PersonalRatingColumnTooltipContent() {
    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            _reactWotBootstrap.TooltipBody,
            null,
            _react2.default.createElement(
                _reactWotBootstrap.TooltipSubtitle,
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'clanmanagement.tooltips.personal_rating_column_header',
                    defaultMessage: '\u041B\u0438\u0447\u043D\u044B\u0439 \u0440\u0435\u0439\u0442\u0438\u043D\u0433'
                })
            ),
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'clanmanagement.tooltips.personal_rating_column_body',
                defaultMessage: '\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043E\u0442\u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0438\u0433\u0440\u043E\u043A\u043E\u0432 \u043F\u043E \u043B\u0438\u0447\u043D\u043E\u043C\u0443 \u0440\u0435\u0439\u0442\u0438\u043D\u0433\u0443.'
            })
        )
    );
};
PersonalRatingColumnTooltipContent.tip = 'personal-rating-column-tooltip-tip';

var BattlesCountColumnTooltipContent = exports.BattlesCountColumnTooltipContent = function BattlesCountColumnTooltipContent() {
    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            _reactWotBootstrap.TooltipBody,
            null,
            _react2.default.createElement(
                _reactWotBootstrap.TooltipSubtitle,
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'clanmanagement.tooltips.battles_count_column_header',
                    defaultMessage: '\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0431\u043E\u0451\u0432'
                })
            ),
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'clanmanagement.tooltips.battles_count_column_body',
                defaultMessage: '\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043E\u0442\u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0438\u0433\u0440\u043E\u043A\u043E\u0432 \u043F\u043E \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u0443 \u0431\u043E\u0451\u0432 \u0432 \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u043E\u043C \u0440\u0435\u0436\u0438\u043C\u0435 \u0437\u0430 \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0439 \u043F\u0435\u0440\u0438\u043E\u0434.'
            })
        )
    );
};
BattlesCountColumnTooltipContent.tip = 'battles-count-column-tooltip-tip';

var WinRateColumnTooltipContent = exports.WinRateColumnTooltipContent = function WinRateColumnTooltipContent() {
    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            _reactWotBootstrap.TooltipBody,
            null,
            _react2.default.createElement(
                _reactWotBootstrap.TooltipSubtitle,
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'clanmanagement.tooltips.win_rate_column_header',
                    defaultMessage: '\u041F\u043E\u0431\u0435\u0434\u044B'
                })
            ),
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'clanmanagement.tooltips.win_rate_column_body',
                defaultMessage: '\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043E\u0442\u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0438\u0433\u0440\u043E\u043A\u043E\u0432 \u043F\u043E \u043F\u0440\u043E\u0446\u0435\u043D\u0442\u0443 \u043F\u043E\u0431\u0435\u0434 \u0432 \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u043E\u043C \u0440\u0435\u0436\u0438\u043C\u0435 \u0437\u0430 \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0439 \u043F\u0435\u0440\u0438\u043E\u0434.'
            })
        )
    );
};
WinRateColumnTooltipContent.tip = 'win-rate-column-tooltip-tip';

var ExperienceColumnTooltipContent = exports.ExperienceColumnTooltipContent = function ExperienceColumnTooltipContent() {
    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            _reactWotBootstrap.TooltipBody,
            null,
            _react2.default.createElement(
                _reactWotBootstrap.TooltipSubtitle,
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'clanmanagement.tooltips.experience_column_header',
                    defaultMessage: '\u041E\u043F\u044B\u0442'
                })
            ),
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'clanmanagement.tooltips.experience_column_body',
                defaultMessage: '\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043E\u0442\u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0438\u0433\u0440\u043E\u043A\u043E\u0432 \u043F\u043E \u0441\u0440\u0435\u0434\u043D\u0435\u043C\u0443 \u043E\u043F\u044B\u0442\u0443 \u0437\u0430 \u0431\u043E\u0439 \u0432 \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u043E\u043C \u0440\u0435\u0436\u0438\u043C\u0435 \u0437\u0430 \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0439 \u043F\u0435\u0440\u0438\u043E\u0434.'
            })
        )
    );
};
ExperienceColumnTooltipContent.tip = 'experience-column-tooltip-tip';

var DamageColumnTooltipContent = exports.DamageColumnTooltipContent = function DamageColumnTooltipContent() {
    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            _reactWotBootstrap.TooltipBody,
            null,
            _react2.default.createElement(
                _reactWotBootstrap.TooltipSubtitle,
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'clanmanagement.tooltips.damage_column_header',
                    defaultMessage: '\u0423\u0440\u043E\u043D'
                })
            ),
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'clanmanagement.tooltips.damage_column_body',
                defaultMessage: '\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043E\u0442\u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0438\u0433\u0440\u043E\u043A\u043E\u0432 \u043F\u043E \u0441\u0440\u0435\u0434\u043D\u0435\u043C\u0443 \u0443\u0440\u043E\u043D\u0443 \u0437\u0430 \u0431\u043E\u0439 \u0432 \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u043E\u043C \u0440\u0435\u0436\u0438\u043C\u0435 \u0437\u0430 \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0439 \u043F\u0435\u0440\u0438\u043E\u0434.'
            })
        )
    );
};
DamageColumnTooltipContent.tip = 'damage-column-tooltip-tip';

var DaysInClanColumnTooltipContent = exports.DaysInClanColumnTooltipContent = function DaysInClanColumnTooltipContent() {
    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            _reactWotBootstrap.TooltipBody,
            null,
            _react2.default.createElement(
                _reactWotBootstrap.TooltipSubtitle,
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'clanmanagement.tooltips.days_in_clan_column_header',
                    defaultMessage: '\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0434\u043D\u0435\u0439 \u0432 \u043A\u043B\u0430\u043D\u0435'
                })
            ),
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'clanmanagement.tooltips.days_in_clan_column_body',
                defaultMessage: '\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043E\u0442\u0441\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0438\u0433\u0440\u043E\u043A\u043E\u0432 \u043F\u043E \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u0443 \u0434\u043D\u0435\u0439, \u043F\u0440\u043E\u0432\u0435\u0434\u0451\u043D\u043D\u044B\u0445 \u0432 \u043A\u043B\u0430\u043D\u0435 \u0441 \u043C\u043E\u043C\u0435\u043D\u0442\u0430 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0435\u0433\u043E \u0432\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u044F \u0432 \u043D\u0435\u0433\u043E.'
            })
        )
    );
};
DaysInClanColumnTooltipContent.tip = 'days-in-clan-column-tooltip-tip';

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var LINE_CLAMP_LINES = exports.LINE_CLAMP_LINES = 28;

/***/ }),
/* 573 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tooltip-root":"Dialogs_tooltip-root--3KU9E","tooltipRoot":"Dialogs_tooltip-root--3KU9E","tooltip-root__show":"Dialogs_tooltip-root__show--L5d_6","tooltipRootShow":"Dialogs_tooltip-root__show--L5d_6","tooltip-body":"Dialogs_tooltip-body--3XaHc","tooltipBody":"Dialogs_tooltip-body--3XaHc","tooltip-wrapper":"Dialogs_tooltip-wrapper--Z-viK","tooltipWrapper":"Dialogs_tooltip-wrapper--Z-viK","tooltip-content":"Dialogs_tooltip-content--11QTc","tooltipContent":"Dialogs_tooltip-content--11QTc","tooltip-title":"Dialogs_tooltip-title--1e9F4","tooltipTitle":"Dialogs_tooltip-title--1e9F4","tooltip-subtitle":"Dialogs_tooltip-subtitle--l3pGO","tooltipSubtitle":"Dialogs_tooltip-subtitle--l3pGO","tooltip-message":"Dialogs_tooltip-message--3Qe4X","tooltipMessage":"Dialogs_tooltipMessage--3570x","tooltip-warning":"Dialogs_tooltip-warning--3IkzH","tooltipWarning":"Dialogs_tooltip-warning--3IkzH","tooltip-divider":"Dialogs_tooltip-divider--1xHrd","tooltipDivider":"Dialogs_tooltip-divider--1xHrd","tooltip-highlight":"Dialogs_tooltip-highlight--1XVqT","tooltipHighlight":"Dialogs_tooltip-highlight--1XVqT","tooltip-ribbon":"Dialogs_tooltip-ribbon--3AuIH","tooltipRibbon":"Dialogs_tooltip-ribbon--3AuIH","tooltip-statusMessage":"Dialogs_tooltip-statusMessage--1pfH2","tooltipStatusMessage":"Dialogs_tooltip-statusMessage--1pfH2","tooltip-statusMessage__positive":"Dialogs_tooltip-statusMessage__positive--1IJKC","tooltipStatusMessagePositive":"Dialogs_tooltip-statusMessage__positive--1IJKC","tooltip-status":"Dialogs_tooltip-status--HXH9O","tooltipStatus":"Dialogs_tooltip-status--HXH9O","tooltip-statusMessage__negative":"Dialogs_tooltip-statusMessage__negative--3yJfi","tooltipStatusMessageNegative":"Dialogs_tooltip-statusMessage__negative--3yJfi","tooltip-statusMessage__noPermission":"Dialogs_tooltip-statusMessage__noPermission--SGAIT","tooltipStatusMessageNoPermission":"Dialogs_tooltip-statusMessage__noPermission--SGAIT","tooltip-status__positive":"Dialogs_tooltip-status__positive--FMrsx","tooltipStatusPositive":"Dialogs_tooltip-status__positive--FMrsx","tooltip-status__negative":"Dialogs_tooltip-status__negative--1N_rs","tooltipStatusNegative":"Dialogs_tooltip-status__negative--1N_rs","tooltip-statusText":"Dialogs_tooltip-statusText--27wRC","tooltipStatusText":"Dialogs_tooltip-statusText--27wRC","base":"Dialogs_base--1Bwb4","header":"Dialogs_header--bDHgh","body":"Dialogs_body--2gNBr","members":"Dialogs_members--wgJT6","membersCount":"Dialogs_membersCount--13mE5","row":"Dialogs_row--2mnaf","caption":"Dialogs_caption--1a8ag","caption__treasury":"Dialogs_caption__treasury--1D9uq","captionTreasury":"Dialogs_caption__treasury--1D9uq","caption__changeRole":"Dialogs_caption__changeRole--2ICR7","captionChangeRole":"Dialogs_caption__changeRole--2ICR7","value":"Dialogs_value--1NJKB","value__currency":"Dialogs_value__currency--2eima","valueCurrency":"Dialogs_value__currency--2eima","divider":"Dialogs_divider--2HQby","dividerArrow":"Dialogs_dividerArrow--1cxOD","input":"Dialogs_input--1zxEY"};

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(154);

/** Used to generate unique IDs. */
var idCounter = 0;

/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */
function uniqueId(prefix) {
  var id = ++idCounter;
  return toString(prefix) + id;
}

module.exports = uniqueId;


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.GLOBAL_MAP_EVENT_NAME = exports.GO_TO_GLOBAL_MAP = exports.PREMIUM_BONUSES_SECTION = exports.PFP_BATTLES_BONUS_SECTION = exports.PRICE_STARTS_FROM = exports.PRODUCT_ITEMS_RECEIVED = exports.TANK_CARD_AUCTION_TITLE = exports.TANK_CARD_SELECTION_TITLE = exports.TANK_CARD_DESCRIPTION = exports.MIN_BET = exports.YOUR_BET = exports.PURCHASE_DATETIME_END = exports.PERSONAL_FAME_POINTS_BONUS = exports.PERSONAL_FAME_POINTS = exports.PERSONAL_BONUSES = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _WGCWXShopCard = __webpack_require__(297);

var _WGCWXShopCard2 = _interopRequireDefault(_WGCWXShopCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PERSONAL_BONUSES = exports.PERSONAL_BONUSES = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.personal_bonuses',
    defaultMessage: '\u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0431\u043E\u043D\u0443\u0441\u044B'
}); /* eslint-disable react/no-multi-comp, max-len */
var PERSONAL_FAME_POINTS = exports.PERSONAL_FAME_POINTS = function PERSONAL_FAME_POINTS(pfp) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop.personal_fame_points',
        defaultMessage: '\u041B\u0438\u0447\u043D\u044B\u0435 \u043E\u0447\u043A\u0438 \u0441\u043B\u0430\u0432\u044B: {pfp}',
        values: { pfp: pfp }
    });
};

var PERSONAL_FAME_POINTS_BONUS = exports.PERSONAL_FAME_POINTS_BONUS = function PERSONAL_FAME_POINTS_BONUS(pfpBonus) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop.personal_fame_points_bonus',
        defaultMessage: '\u0422\u0435\u043A\u0443\u0449\u0438\u0439 \u0431\u043E\u043D\u0443\u0441: {pfpBonus}',
        values: { pfpBonus: pfpBonus }
    });
};

var PURCHASE_DATETIME_END = exports.PURCHASE_DATETIME_END = function PURCHASE_DATETIME_END(dateTime) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop.purchase_datetime_end',
        defaultMessage: '\u041F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0431\u043E\u043D\u0443\u0441\u043E\u0432 \u0431\u0443\u0434\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E \u0434\u043E {dateTime}',
        values: {
            dateTime: _react2.default.createElement(
                'span',
                { className: _WGCWXShopCard2.default.highlight },
                dateTime.format('L, LT')
            )
        }
    });
};

var YOUR_BET = exports.YOUR_BET = function YOUR_BET(bet) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop.cards.tank.your_bet',
        defaultMessage: '\u0412\u0430\u0448\u0430 \u0441\u0442\u0430\u0432\u043A\u0430: {bet}',
        values: { bet: bet }
    });
};

var MIN_BET = exports.MIN_BET = function MIN_BET(bet) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop.cards.tank.min_bet',
        defaultMessage: '\u041C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u0441\u0442\u0430\u0432\u043A\u0430 \u0432 \u0430\u0443\u043A\u0446\u0438\u043E\u043D\u0435: {bet}',
        values: { bet: bet }
    });
};

var TANK_CARD_DESCRIPTION = exports.TANK_CARD_DESCRIPTION = function TANK_CARD_DESCRIPTION(tanks) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop.cards.tank.description',
        defaultMessage: '\u041F\u0440\u0438\u0437\u043E\u0432\u044B\u0435 \u043C\u0430\u0448\u0438\u043D\u044B \u0425 \u0443\u0440\u043E\u0432\u043D\u044F \u043D\u0430 \u0432\u044B\u0431\u043E\u0440: {tanks}',
        values: {
            tanks: _react2.default.createElement(
                'span',
                null,
                tanks.map(function (tank, idx) {
                    return _react2.default.createElement(
                        'span',
                        { key: tank.id },
                        _react2.default.createElement(
                            'span',
                            { className: _WGCWXShopCard2.default.highlight },
                            tank.name
                        ),
                        idx !== tanks.length - 1 && ', '
                    );
                })
            )
        }
    });
};

var TANK_CARD_SELECTION_TITLE = exports.TANK_CARD_SELECTION_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.cards.tank.title.selection',
    defaultMessage: '\u041F\u0440\u0438\u0437\u043E\u0432\u044B\u0435 \u043C\u0430\u0448\u0438\u043D\u044B \u043D\u0430 \u0432\u044B\u0431\u043E\u0440'
});

var TANK_CARD_AUCTION_TITLE = exports.TANK_CARD_AUCTION_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.cards.tank.title.auction',
    defaultMessage: '\u0410\u0443\u043A\u0446\u0438\u043E\u043D \u0437\u0430 \u043F\u0440\u0438\u0437\u043E\u0432\u044B\u0435 \u043C\u0430\u0448\u0438\u043D\u044B'
});

var PRODUCT_ITEMS_RECEIVED = exports.PRODUCT_ITEMS_RECEIVED = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.cards.product.received',
    defaultMessage: '\u041F\u043E\u043B\u0443\u0447\u0435\u043D\u043E:'
});

var PRICE_STARTS_FROM = exports.PRICE_STARTS_FROM = function PRICE_STARTS_FROM(price) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop.cards.product.price',
        defaultMessage: '\u043E\u0442 {price}',
        values: { price: price }
    });
};

var PFP_BATTLES_BONUS_SECTION = exports.PFP_BATTLES_BONUS_SECTION = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.sections.pfp_battles',
    defaultMessage: '\u0411\u043E\u043D\u0443\u0441\u044B \u043A \u043B\u0438\u0447\u043D\u044B\u043C \u043E\u0447\u043A\u0430\u043C \u0441\u043B\u0430\u0432\u044B'
});

var PREMIUM_BONUSES_SECTION = exports.PREMIUM_BONUSES_SECTION = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.sections.premium_bonuses',
    defaultMessage: '\u041F\u0440\u0438\u0437\u043E\u0432\u044B\u0435 \u0431\u043E\u043D\u0443\u0441\u044B'
});

var GO_TO_GLOBAL_MAP = exports.GO_TO_GLOBAL_MAP = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.go_to_global_map',
    defaultMessage: '\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043A \u043A\u0430\u0440\u0442\u0435'
});

var GLOBAL_MAP_EVENT_NAME = exports.GLOBAL_MAP_EVENT_NAME = function GLOBAL_MAP_EVENT_NAME(eventName) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop.global_map_event_name',
        defaultMessage: '\u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u0430\u044F \u043A\u0430\u0440\u0442\u0430: "{eventName}".',
        values: { eventName: eventName }
    });
};

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NO_DESCRIPTION_VEHICLES = exports.PRODUCTS_CONFIG = exports.PRODUCTS_GRID_CONFIG_CN = exports.PRODUCTS_GRID_CONFIG = exports.PRODUCTS_SIZE_CONFIG = undefined;

var _PRODUCTS_CONFIG;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _format_number = __webpack_require__(109);

var _constants = __webpack_require__(92);

var _WGCWXShopDetailedProduct = __webpack_require__(1377);

var _WGCWXShopDetailedProduct2 = _interopRequireDefault(_WGCWXShopDetailedProduct);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint-disable max-lines */
/* eslint-disable react/no-multi-comp, max-len */


var getAmount = function getAmount(value) {
    return _react2.default.createElement(
        'span',
        { className: _WGCWXShopDetailedProduct2.default.itemContent_amount },
        'x' + value
    );
};
var getStyleProductName = function getStyleProductName(name) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop.products.style',
        defaultMessage: '2D-\u0441\u0442\u0438\u043B\u044C {name}',
        values: {
            name: _react2.default.createElement(
                'span',
                { className: _WGCWXShopDetailedProduct2.default.highlight },
                name
            )
        }
    });
};
var getStyleProductName907 = function getStyleProductName907(name) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop.products.style.907',
        defaultMessage: '3D-\u0441\u0442\u0438\u043B\u044C {name} \u0434\u043B\u044F \u041E\u0431\u044A\u0435\u043A\u0442a 907',
        values: {
            name: _react2.default.createElement(
                'span',
                { className: _WGCWXShopDetailedProduct2.default.highlight },
                name
            )
        }
    });
};
var getStyleProductNameChiftein = function getStyleProductNameChiftein(name) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop.products.style.chiftein',
        defaultMessage: '3D-\u0441\u0442\u0438\u043B\u044C {name} \u0434\u043B\u044F T95/FV4201 Chieftain',
        values: {
            name: _react2.default.createElement(
                'span',
                { className: _WGCWXShopDetailedProduct2.default.highlight },
                name
            )
        }
    });
};
var getStyleProductNameNamenlos = function getStyleProductNameNamenlos(name) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop.products.style.namenlos',
        defaultMessage: '3D-\u0441\u0442\u0438\u043B\u044C {name} \u0434\u043B\u044F VK 72.01 (K)',
        values: {
            name: _react2.default.createElement(
                'span',
                { className: _WGCWXShopDetailedProduct2.default.highlight },
                name
            )
        }
    });
};
var getStyleProductNameProserpina = function getStyleProductNameProserpina(name) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop.products.style.proserpina',
        defaultMessage: '3D-\u0441\u0442\u0438\u043B\u044C {name} \u0434\u043B\u044F Carro da Combattimento 45 t',
        values: {
            name: _react2.default.createElement(
                'span',
                { className: _WGCWXShopDetailedProduct2.default.highlight },
                name
            )
        }
    });
};
var getStyleProductNameHellraiser = function getStyleProductNameHellraiser(name) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop.products.style.hellraiser',
        defaultMessage: '3D-\u0441\u0442\u0438\u043B\u044C {name} \u0434\u043B\u044F \u041C60',
        values: {
            name: _react2.default.createElement(
                'span',
                { className: _WGCWXShopDetailedProduct2.default.highlight },
                name
            )
        }
    });
};
var getStyleProductNameKrait = function getStyleProductNameKrait(name) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop.products.style.krait',
        defaultMessage: '3D-\u0441\u0442\u0438\u043B\u044C {name} \u0434\u043B\u044F 121\u0412',
        values: {
            name: _react2.default.createElement(
                'span',
                { className: _WGCWXShopDetailedProduct2.default.highlight },
                name
            )
        }
    });
};
var getStyleProductNameBasalt = function getStyleProductNameBasalt(name) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop.products.style.basalt',
        defaultMessage: '3D-\u0441\u0442\u0438\u043B\u044C {name} \u0434\u043B\u044F \u041E\u0431\u044A\u0435\u043A\u0442\u0430 907',
        values: {
            name: _react2.default.createElement(
                'span',
                { className: _WGCWXShopDetailedProduct2.default.highlight },
                name
            )
        }
    });
};
var getCrewBookProductName = function getCrewBookProductName(experience) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop.products.experience',
        defaultMessage: '\u0423\u0447\u0435\u0431\u043D\u043E\u0435 \u0440\u0443\u043A\u043E\u0432\u043E\u0434\u0441\u0442\u0432\u043E \u043D\u0430 {experience}',
        values: {
            experience: _react2.default.createElement(
                'span',
                { className: _WGCWXShopDetailedProduct2.default.highlight },
                experience
            )
        }
    });
};
var PERSONAL_RESERVE_CONFIG = function PERSONAL_RESERVE_CONFIG(productType) {
    return function (product) {
        var reservesType = productType === _constants.PRODUCT_TYPES.PERSONAL_RESERVE_BIG ? _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.personal_reserve_big.title',
            defaultMessage: '\u043F\u0430\u043A\u0435\u0442 \xAB\u0411\u043E\u043B\u044C\u0448\u043E\u0439\xBB'
        }) : _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.personal_reserve_small.title',
            defaultMessage: '\u043F\u0430\u043A\u0435\u0442 \xAB\u041C\u0430\u043B\u044B\u0439\xBB'
        });

        var title = _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.personal_reserve.title',
            defaultMessage: '\u041B\u0438\u0447\u043D\u044B\u0435 \u0440\u0435\u0437\u0435\u0440\u0432\u044B: {type}',
            values: {
                type: _react2.default.createElement(
                    'span',
                    { className: _WGCWXShopDetailedProduct2.default.highlight },
                    reservesType
                )
            }
        });

        var amount = getAmount(product.value);

        return {
            title: title,
            description: _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'wgcwx_shop.products.personal_reserve.description',
                defaultMessage: '\u0414\u0430\u044E\u0442 \u043D\u0430\u0434\u0431\u0430\u0432\u043A\u0438 \u043F\u043E \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0430\u043C \u0431\u043E\u0435\u0432. \u0414\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0442 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u043E\u0435 \u0432\u0440\u0435\u043C\u044F.'
            }),
            content: _react2.default.createElement(
                'ul',
                { className: _WGCWXShopDetailedProduct2.default.itemContent_list },
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'wgcwx_shop.products.personal_reserve.content.crew_bonus',
                        defaultMessage: '{amount} {percent} \u043A \u043E\u043F\u044B\u0442\u0443 \u044D\u043A\u0438\u043F\u0430\u0436\u0430 \u043D\u0430 1 \u0447\u0430\u0441',
                        values: { amount: amount, percent: (0, _format_number.formatPercent)(300) }
                    })
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'wgcwx_shop.products.personal_reserve.content.free_xp_bonus',
                        defaultMessage: '{amount} {percent} \u043A \u0441\u0432\u043E\u0431\u043E\u0434\u043D\u043E\u043C\u0443 \u043E\u043F\u044B\u0442\u0443 \u043D\u0430 1 \u0447\u0430\u0441',
                        values: { amount: amount, percent: (0, _format_number.formatPercent)(300) }
                    })
                ),
                _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'wgcwx_shop.products.personal_reserve.content.battle_bonus',
                        defaultMessage: '{amount} {percent} \u043A \u0431\u043E\u0435\u0432\u043E\u043C\u0443 \u043E\u043F\u044B\u0442\u0443 \u043D\u0430 1 \u0447\u0430\u0441',
                        values: { amount: amount, percent: (0, _format_number.formatPercent)(200) }
                    })
                )
            )
        };
    };
};

var PRODUCTS_SIZE_CONFIG = exports.PRODUCTS_SIZE_CONFIG = ['large', 'medium', 'small'];

var PRODUCTS_GRID_CONFIG = exports.PRODUCTS_GRID_CONFIG = [['KRAIT_STYLE', 'GRAPHITE_STYLE'], ['CREW_BOOK_NATIONAL', 'CREW_WOMAN'], ['WARRIOR_OF_THE_NORTH_STYLE', 'WARRIOR_OF_THE_SOUTH_STYLE'], ['WARRIOR_OF_THE_WEST_STYLE', 'WARRIOR_OF_THE_EAST_STYLE'], ['PREMIUM_PLUS', 'SILVER', 'BONDS'], ['EXPERIENCE', 'FREE_XP_AND_CREW_XP']];

var PRODUCTS_GRID_CONFIG_CN = exports.PRODUCTS_GRID_CONFIG_CN = [['KRAIT_STYLE', 'GRAPHITE_STYLE'], ['CREW_BOOK_NATIONAL', 'CREW_WOMAN'], ['WARRIOR_OF_THE_NORTH_STYLE', 'WARRIOR_OF_THE_SOUTH_STYLE'], ['WARRIOR_OF_THE_WEST_STYLE', 'WARRIOR_OF_THE_EAST_STYLE'], ['PREMIUM_PLUS', 'SILVER', 'BONDS'], ['EXPERIENCE', 'FREE_XP_AND_CREW_XP']];

var PRODUCTS_CONFIG = exports.PRODUCTS_CONFIG = (_PRODUCTS_CONFIG = {}, _defineProperty(_PRODUCTS_CONFIG, _constants.PRODUCT_TYPES.NAMENLOS_STYLE, function (product) {
    return {
        title: getStyleProductNameNamenlos(_react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.namenlos_style.title',
            defaultMessage: '\xAB\u041D\u0430\u043C\u0435\u043D\u043B\u043E\u0441\xBB'
        })),
        description: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.namenlos_style.description',
            defaultMessage: '\u0412\u0441\u0435\u0441\u0435\u0437\u043E\u043D\u043D\u044B\u0439 \u0438\u0441\u0442\u043E\u0440\u0438\u0447\u043D\u044B\u0439 3D-\u0441\u0442\u0438\u043B\u044C, \u0432\u044B\u0434\u0430\u0432\u0430\u0435\u043C\u044B\u0439 \u0438\u0433\u0440\u043E\u043A\u0430\u043C \u0437\u0430 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0438 \u043A\u043B\u0430\u043D\u043E\u0432\u044B\u0435 \u0434\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u044F \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435. \u041F\u043E\u0434\u0445\u043E\u0434\u0438\u0442 \u0442\u043E\u043B\u044C\u043A\u043E \u0434\u043B\u044F \u043C\u0430\u0448\u0438\u043D\u044B VK 72.01 (K).'
        })
    };
}), _defineProperty(_PRODUCTS_CONFIG, _constants.PRODUCT_TYPES.AIR_ELEMENTAL_STYLE, function (product) {
    return {
        title: getStyleProductName(_react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.air_elemental_style.title',
            defaultMessage: '\xAB\u042D\u043B\u0435\u043C\u0435\u043D\u0442 \u0432\u043E\u0437\u0434\u0443\u0445\u0430\xBB'
        })),
        description: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.air_elemental_style.description',
            defaultMessage: '\u0412\u0441\u0435\u0441\u0435\u0437\u043E\u043D\u043D\u044B\u0439 \u0441\u0442\u0438\u043B\u044C, \u0432\u044B\u0434\u0430\u0432\u0430\u0435\u043C\u044B\u0439 \u0438\u0433\u0440\u043E\u043A\u0430\u043C \u0437\u0430 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0438 \u043A\u043B\u0430\u043D\u043E\u0432\u044B\u0435 \u0434\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u044F \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435. \u041D\u0430\u043D\u043E\u0441\u0438\u0442\u0441\u044F \u043D\u0430 \u0442\u0435\u0445\u043D\u0438\u043A\u0443 VIII\u2013X \u0443\u0440\u043E\u0432\u043D\u0435\u0439.'
        })
    };
}), _defineProperty(_PRODUCTS_CONFIG, _constants.PRODUCT_TYPES.EARTH_ELEMENTAL_STYLE, function (product) {
    return {
        title: getStyleProductName(_react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.earth_elemental_style.title',
            defaultMessage: '\xAB\u042D\u043B\u0435\u043C\u0435\u043D\u0442 \u0437\u0435\u043C\u043B\u0438\xBB'
        })),
        description: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.air_elemental_style.description',
            defaultMessage: '\u0412\u0441\u0435\u0441\u0435\u0437\u043E\u043D\u043D\u044B\u0439 \u0441\u0442\u0438\u043B\u044C, \u0432\u044B\u0434\u0430\u0432\u0430\u0435\u043C\u044B\u0439 \u0438\u0433\u0440\u043E\u043A\u0430\u043C \u0437\u0430 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0438 \u043A\u043B\u0430\u043D\u043E\u0432\u044B\u0435 \u0434\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u044F \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435. \u041D\u0430\u043D\u043E\u0441\u0438\u0442\u0441\u044F \u043D\u0430 \u0442\u0435\u0445\u043D\u0438\u043A\u0443 VIII\u2013X \u0443\u0440\u043E\u0432\u043D\u0435\u0439.'
        })
    };
}), _defineProperty(_PRODUCTS_CONFIG, _constants.PRODUCT_TYPES.WATER_ELEMENTAL_STYLE, function (product) {
    return {
        title: getStyleProductName(_react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.water_elemental_style.title',
            defaultMessage: '\xAB\u042D\u043B\u0435\u043C\u0435\u043D\u0442 \u0432\u043E\u0434\u044B\xBB'
        })),
        description: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.air_elemental_style.description',
            defaultMessage: '\u0412\u0441\u0435\u0441\u0435\u0437\u043E\u043D\u043D\u044B\u0439 \u0441\u0442\u0438\u043B\u044C, \u0432\u044B\u0434\u0430\u0432\u0430\u0435\u043C\u044B\u0439 \u0438\u0433\u0440\u043E\u043A\u0430\u043C \u0437\u0430 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0438 \u043A\u043B\u0430\u043D\u043E\u0432\u044B\u0435 \u0434\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u044F \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435. \u041D\u0430\u043D\u043E\u0441\u0438\u0442\u0441\u044F \u043D\u0430 \u0442\u0435\u0445\u043D\u0438\u043A\u0443 VIII\u2013X \u0443\u0440\u043E\u0432\u043D\u0435\u0439.'
        })
    };
}), _defineProperty(_PRODUCTS_CONFIG, _constants.PRODUCT_TYPES.FIRE_ELEMENTAL_STYLE, function (product) {
    return {
        title: getStyleProductName(_react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.fire_elemental_style.title',
            defaultMessage: '\xAB\u042D\u043B\u0435\u043C\u0435\u043D\u0442 \u043E\u0433\u043D\u044F\xBB'
        })),
        description: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.air_elemental_style.description',
            defaultMessage: '\u0412\u0441\u0435\u0441\u0435\u0437\u043E\u043D\u043D\u044B\u0439 \u0441\u0442\u0438\u043B\u044C, \u0432\u044B\u0434\u0430\u0432\u0430\u0435\u043C\u044B\u0439 \u0438\u0433\u0440\u043E\u043A\u0430\u043C \u0437\u0430 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0438 \u043A\u043B\u0430\u043D\u043E\u0432\u044B\u0435 \u0434\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u044F \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435. \u041D\u0430\u043D\u043E\u0441\u0438\u0442\u0441\u044F \u043D\u0430 \u0442\u0435\u0445\u043D\u0438\u043A\u0443 VIII\u2013X \u0443\u0440\u043E\u0432\u043D\u0435\u0439.'
        })
    };
}), _defineProperty(_PRODUCTS_CONFIG, _constants.PRODUCT_TYPES.PROSERPINA_STYLE, function (product) {
    return {
        title: getStyleProductNameProserpina(_react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.proserpina.title',
            defaultMessage: '\xAB\u041F\u0440\u043E\u0437\u0435\u0440\u043F\u0438\u043D\u0430\xBB'
        })),
        description: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.proserpina.description',
            defaultMessage: '\u0412\u0441\u0435\u0441\u0435\u0437\u043E\u043D\u043D\u044B\u0439 \u0438\u0441\u0442\u043E\u0440\u0438\u0447\u043D\u044B\u0439 3D-\u0441\u0442\u0438\u043B\u044C, \u0432\u044B\u0434\u0430\u0432\u0430\u0435\u043C\u044B\u0439 \u0438\u0433\u0440\u043E\u043A\u0430\u043C \u0437\u0430 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0438 \u043A\u043B\u0430\u043D\u043E\u0432\u044B\u0435 \u0434\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u044F \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435. \u041F\u043E\u0434\u0445\u043E\u0434\u0438\u0442 \u0442\u043E\u043B\u044C\u043A\u043E \u0434\u043B\u044F \u043C\u0430\u0448\u0438\u043D\u044B Carro da Combattimento 45 t.'
        })
    };
}), _defineProperty(_PRODUCTS_CONFIG, _constants.PRODUCT_TYPES.PFP_BATTLES, function (product) {
    return {
        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.pfp_battles.title',
            defaultMessage: '{bonus} \u043A \u043B\u0438\u0447\u043D\u044B\u043C \u041E\u0447\u043A\u0430\u043C \u0441\u043B\u0430\u0432\u044B \u0432 \u0431\u043E\u044F\u0445',
            values: {
                bonus: _react2.default.createElement(
                    'span',
                    { className: _WGCWXShopDetailedProduct2.default.highlight },
                    '+',
                    _react2.default.createElement(_reactIntl.FormattedNumber, { value: product.value }),
                    '%'
                )
            }
        }),
        description: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.bonds.pfp_battles.description',
            defaultMessage: '\u0423\u0441\u043A\u043E\u0440\u044F\u0439\u0442\u0435 \u043F\u0440\u043E\u0446\u0435\u0441\u0441 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u043B\u0438\u0447\u043D\u044B\u0445 \u041E\u0447\u043A\u043E\u0432 \u0441\u043B\u0430\u0432\u044B \u0437\u0430 \u0443\u0447\u0430\u0441\u0442\u0438\u0435 \u0432 \u0431\u043E\u044F\u0445. \u041F\u043E\u043B\u0443\u0447\u0435\u043D\u043D\u044B\u0435 \u0431\u043E\u043D\u0443\u0441\u044B \u0441\u0443\u043C\u043C\u0438\u0440\u0443\u044E\u0442\u0441\u044F.'
        })
    };
}), _defineProperty(_PRODUCTS_CONFIG, _constants.PRODUCT_TYPES.GOLD, function (product) {
    return {
        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.gold.title',
            defaultMessage: '{bonus} \u0437\u043E\u043B\u043E\u0442\u0430',
            values: {
                bonus: _react2.default.createElement(
                    'span',
                    { className: _WGCWXShopDetailedProduct2.default.highlight },
                    _react2.default.createElement(_reactIntl.FormattedNumber, { value: product.value })
                )
            }
        }),
        description: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.gold.description',
            defaultMessage: '\u041F\u0440\u0435\u043A\u0440\u0430\u0441\u043D\u0430\u044F \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044C \u0441\u0434\u0435\u043B\u0430\u0442\u044C \u0438\u0433\u0440\u043E\u0432\u043E\u0439 \u043F\u0440\u043E\u0446\u0435\u0441\u0441 \u043A\u043E\u043C\u0444\u043E\u0440\u0442\u043D\u0435\u0435.'
        })
    };
}), _defineProperty(_PRODUCTS_CONFIG, _constants.PRODUCT_TYPES.BONDS, function (product) {
    return {
        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.bonds.title',
            defaultMessage: '{bonus} \u0431\u043E\u043D',
            values: {
                bonus: _react2.default.createElement(
                    'span',
                    { className: _WGCWXShopDetailedProduct2.default.highlight },
                    _react2.default.createElement(_reactIntl.FormattedNumber, { value: product.value })
                )
            }
        }),
        description: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.bonds.description',
            defaultMessage: '\u042D\u0442\u043E \u043F\u043E\u0437\u0432\u043E\u043B\u0438\u0442 \u043F\u043E\u043A\u0443\u043F\u0430\u0442\u044C \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0435 \u0442\u043E\u0432\u0430\u0440\u044B, \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0435 \u0437\u0430 \u0434\u0440\u0443\u0433\u0443\u044E \u0432\u0430\u043B\u044E\u0442\u0443.'
        })
    };
}), _defineProperty(_PRODUCTS_CONFIG, _constants.PRODUCT_TYPES.SILVER, function (product) {
    return {
        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.silver.title',
            defaultMessage: '{bonus} \u043A\u0440\u0435\u0434\u0438\u0442\u043E\u0432',
            values: {
                bonus: _react2.default.createElement(
                    'span',
                    { className: _WGCWXShopDetailedProduct2.default.highlight },
                    (0, _format_number.thousands)(product.value)
                )
            }
        }),
        description: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.silver.description',
            defaultMessage: '\u042D\u0442\u043E \u043E\u0431\u043B\u0435\u0433\u0447\u0438\u0442 \u0432\u0430\u0448\u0435 \u043F\u0440\u043E\u0434\u0432\u0438\u0436\u0435\u043D\u0438\u0435 \u043F\u043E \u0434\u0435\u0440\u0435\u0432\u0443 \u0438\u0441\u0441\u043B\u0435\u0434\u043E\u0432\u0430\u043D\u0438\u0439.'
        })
    };
}), _defineProperty(_PRODUCTS_CONFIG, _constants.PRODUCT_TYPES.PREMIUM_PLUS, function (product) {
    var title = void 0;

    if (product.value === 1) title = _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop.products.premium_plus.title.1_day',
        defaultMessage: '1 \u0434\u0435\u043D\u044C \u0442\u0430\u043D\u043A\u043E\u0432\u043E\u0433\u043E \u043F\u0440\u0435\u043C\u0438\u0443\u043C \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430'
    });

    if (product.value === 3) title = _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop.products.premium_plus.title.3_days',
        defaultMessage: '3 \u0434\u043D\u044F \u0442\u0430\u043D\u043A\u043E\u0432\u043E\u0433\u043E \u043F\u0440\u0435\u043C\u0438\u0443\u043C \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430'
    });

    if (product.value === 7) title = _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop.products.premium_plus.title.7_days',
        defaultMessage: '7 \u0434\u043D\u0435\u0439 \u0442\u0430\u043D\u043A\u043E\u0432\u043E\u0433\u043E \u043F\u0440\u0435\u043C\u0438\u0443\u043C \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430'
    });

    return {
        title: title,
        description: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.premium_plus.description',
            defaultMessage: '\u042D\u0442\u043E \u043F\u043E\u0437\u0432\u043E\u043B\u0438\u0442 \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u044C \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 {percent} \u043A \u043A\u0440\u0435\u0434\u0438\u0442\u0430\u043C \u0438 \u043E\u043F\u044B\u0442\u0443.',
            values: { percent: (0, _format_number.formatPercent)(50) }
        })
    };
}), _defineProperty(_PRODUCTS_CONFIG, _constants.PRODUCT_TYPES.PERSONAL_RESERVE_SMALL, PERSONAL_RESERVE_CONFIG(_constants.PRODUCT_TYPES.PERSONAL_RESERVE_SMALL)), _defineProperty(_PRODUCTS_CONFIG, _constants.PRODUCT_TYPES.PERSONAL_RESERVE_BIG, PERSONAL_RESERVE_CONFIG(_constants.PRODUCT_TYPES.PERSONAL_RESERVE_BIG)), _defineProperty(_PRODUCTS_CONFIG, _constants.PRODUCT_TYPES.DIGITAL_STYLE, function (product) {
    return {
        title: getStyleProductName(_react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.digital_style.title',
            defaultMessage: '\xAB\u041A\u043B\u0430\u043D\u043E\u0432\u044B\u0439 \u0446\u0438\u0444\u0440\u043E\u0432\u043E\u0439\xBB'
        })),
        description: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.digital_style.description',
            defaultMessage: '\u0421\u0442\u0438\u043B\u044C \u0441 \u0438\u043D\u0434\u0438\u0432\u0438\u0434\u0443\u0430\u043B\u044C\u043D\u043E\u0439 \u0440\u0430\u0441\u043A\u0440\u0430\u0441\u043A\u043E\u0439 \u0434\u043B\u044F \u043A\u0430\u0436\u0434\u043E\u0433\u043E \u0438\u0437 \u0441\u0435\u0437\u043E\u043D\u043E\u0432, \u0432\u044B\u0434\u0430\u0432\u0430\u0435\u043C\u044B\u0439 \u0438\u0433\u0440\u043E\u043A\u0430\u043C \u0437\u0430 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0438 \u043A\u043B\u0430\u043D\u043E\u0432\u044B\u0435 \u0434\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u044F \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435. \u041D\u0430\u043D\u043E\u0441\u0438\u0442\u0441\u044F \u043D\u0430 \u0442\u0435\u0445\u043D\u0438\u043A\u0443 VIII\u2013X \u0443\u0440\u043E\u0432\u043D\u0435\u0439.'
        })
    };
}), _defineProperty(_PRODUCTS_CONFIG, _constants.PRODUCT_TYPES.VETERAN_STYLE, function (product) {
    return {
        title: getStyleProductName(_react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.veteran_style.title',
            defaultMessage: '\xAB\u0412\u0435\u0442\u0435\u0440\u0430\u043D\xBB'
        })),
        description: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.veteran_style.description',
            defaultMessage: '\u0412\u0441\u0435\u0441\u0435\u0437\u043E\u043D\u043D\u044B\u0439 \u0441\u0442\u0438\u043B\u044C, \u0432\u044B\u0434\u0430\u0432\u0430\u0435\u043C\u044B\u0439 \u0438\u0433\u0440\u043E\u043A\u0430\u043C \u0437\u0430 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0438 \u043A\u043B\u0430\u043D\u043E\u0432\u044B\u0435 \u0434\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u044F \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435. \u041D\u0430\u043D\u043E\u0441\u0438\u0442\u0441\u044F \u043D\u0430 \u0442\u0435\u0445\u043D\u0438\u043A\u0443 X \u0443\u0440\u043E\u0432\u043D\u044F.'
        })
    };
}), _defineProperty(_PRODUCTS_CONFIG, _constants.PRODUCT_TYPES.GRAPHITE_STYLE, function (product) {
    return {
        title: getStyleProductName907(_react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.graphite_style.title',
            defaultMessage: '\xAB\u0413\u0440\u0430\u0444\u0438\u0442\xBB'
        })),
        description: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.graphite_style.description',
            defaultMessage: '\u0412\u0441\u0435\u0441\u0435\u0437\u043E\u043D\u043D\u044B\u0439 3D-\u0441\u0442\u0438\u043B\u044C, \u0432\u044B\u0434\u0430\u0432\u0430\u0435\u043C\u044B\u0439 \u0438\u0433\u0440\u043E\u043A\u0430\u043C \u0437\u0430 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0438 \u043A\u043B\u0430\u043D\u043E\u0432\u044B\u0435 \u0434\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u044F \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435. \u041F\u043E\u0434\u0445\u043E\u0434\u0438\u0442 \u0442\u043E\u043B\u044C\u043A\u043E \u0434\u043B\u044F \u043C\u0430\u0448\u0438\u043D\u044B \u041E\u0431\u044A\u0435\u043A\u0442 907.'
        })
    };
}), _defineProperty(_PRODUCTS_CONFIG, _constants.PRODUCT_TYPES.CLAN_URBAN_STYLE, function (product) {
    return {
        title: getStyleProductName(_react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.clan_urban_style.title',
            defaultMessage: '\xAB\u041A\u043B\u0430\u043D\u043E\u0432\u044B\u0439 \u0433\u043E\u0440\u043E\u0434\u0441\u043A\u043E\u0439\xBB'
        })),
        description: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.clan_urban_style.description',
            defaultMessage: '\u0421\u0442\u0438\u043B\u044C \u0441 \u0438\u043D\u0434\u0438\u0432\u0438\u0434\u0443\u0430\u043B\u044C\u043D\u043E\u0439 \u0440\u0430\u0441\u043A\u0440\u0430\u0441\u043A\u043E\u0439 \u0434\u043B\u044F \u043A\u0430\u0436\u0434\u043E\u0433\u043E \u0438\u0437 \u0441\u0435\u0437\u043E\u043D\u043E\u0432, \u0432\u044B\u0434\u0430\u0432\u0430\u0435\u043C\u044B\u0439 \u0438\u0433\u0440\u043E\u043A\u0430\u043C \u0437\u0430 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0438 \u043A\u043B\u0430\u043D\u043E\u0432\u044B\u0435 \u0434\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u044F \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435. \u041D\u0430\u043D\u043E\u0441\u0438\u0442\u0441\u044F \u043D\u0430 \u0442\u0435\u0445\u043D\u0438\u043A\u0443 VIII\u2013X \u0443\u0440\u043E\u0432\u043D\u0435\u0439.'
        })
    };
}), _defineProperty(_PRODUCTS_CONFIG, _constants.PRODUCT_TYPES.DIGITAL_ADAPTED_STYLE, function (product) {
    return {
        title: getStyleProductName(_react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.digital_adapted_style.title',
            defaultMessage: '\xAB\u0426\u0438\u0444\u0440\u043E\u0432\u043E\u0439 \u0430\u0434\u0430\u043F\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439\xBB'
        })),
        description: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.digital_adapted_style.description',
            defaultMessage: '\u0421\u0442\u0438\u043B\u044C \u0441 \u0438\u043D\u0434\u0438\u0432\u0438\u0434\u0443\u0430\u043B\u044C\u043D\u043E\u0439 \u0440\u0430\u0441\u043A\u0440\u0430\u0441\u043A\u043E\u0439 \u0434\u043B\u044F \u043A\u0430\u0436\u0434\u043E\u0433\u043E \u0438\u0437 \u0441\u0435\u0437\u043E\u043D\u043E\u0432, \u0432\u044B\u0434\u0430\u0432\u0430\u0435\u043C\u044B\u0439 \u0438\u0433\u0440\u043E\u043A\u0430\u043C \u0437\u0430 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0438 \u043A\u043B\u0430\u043D\u043E\u0432\u044B\u0435 \u0434\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u044F \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435. \u041D\u0430\u043D\u043E\u0441\u0438\u0442\u0441\u044F \u043D\u0430 \u0442\u0435\u0445\u043D\u0438\u043A\u0443 VIII\u2013X \u0443\u0440\u043E\u0432\u043D\u0435\u0439.'
        })
    };
}), _defineProperty(_PRODUCTS_CONFIG, _constants.PRODUCT_TYPES.FIRE_STYLE, function (product) {
    return {
        title: getStyleProductName(_react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.fire_style.title',
            defaultMessage: '\xAB\u041F\u043B\u0430\u043C\u0435\u043D\u044C\xBB'
        })),
        description: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.fire_style.description',
            defaultMessage: '\u0412\u0441\u0435\u0441\u0435\u0437\u043E\u043D\u043D\u044B\u0439 \u0441\u0442\u0438\u043B\u044C, \u0432\u044B\u0434\u0430\u0432\u0430\u0435\u043C\u044B\u0439 \u0438\u0433\u0440\u043E\u043A\u0430\u043C \u0437\u0430 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0438 \u043A\u043B\u0430\u043D\u043E\u0432\u044B\u0435 \u0434\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u044F \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435. \u041D\u0430\u043D\u043E\u0441\u0438\u0442\u0441\u044F \u043D\u0430 \u0442\u0435\u0445\u043D\u0438\u043A\u0443 VIII\u2013X \u0443\u0440\u043E\u0432\u043D\u0435\u0439.'
        })
    };
}), _defineProperty(_PRODUCTS_CONFIG, _constants.PRODUCT_TYPES.WARRIOR_OF_THE_EAST_STYLE, function (product) {
    return {
        title: getStyleProductName(_react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.east_warrior_style.title',
            defaultMessage: '\xAB\u0412\u043E\u0438\u043D \u0412\u043E\u0441\u0442\u043E\u043A\u0430\xBB'
        })),
        description: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.east_warrior_style.description',
            defaultMessage: '\u0412\u0441\u0435\u0441\u0435\u0437\u043E\u043D\u043D\u044B\u0439 \u0441\u0442\u0438\u043B\u044C, \u0432\u044B\u0434\u0430\u0432\u0430\u0435\u043C\u044B\u0439 \u0438\u0433\u0440\u043E\u043A\u0430\u043C \u0437\u0430 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0438 \u043A\u043B\u0430\u043D\u043E\u0432\u044B\u0435 \u0434\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u044F \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435. \u041D\u0430\u043D\u043E\u0441\u0438\u0442\u0441\u044F \u043D\u0430 \u0442\u0435\u0445\u043D\u0438\u043A\u0443 VIII\u2013X \u0443\u0440\u043E\u0432\u043D\u0435\u0439.'
        })
    };
}), _defineProperty(_PRODUCTS_CONFIG, _constants.PRODUCT_TYPES.VANQUISHER_STYLE, function (product) {
    return {
        title: getStyleProductName(_react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.vanquisher_style.title',
            defaultMessage: '\xAB\u041F\u043E\u043A\u043E\u0440\u0438\u0442\u0435\u043B\u044C\xBB'
        })),
        description: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.vanquisher_style.description',
            defaultMessage: '\u0421\u0442\u0438\u043B\u044C \u0441 \u0438\u043D\u0434\u0438\u0432\u0438\u0434\u0443\u0430\u043B\u044C\u043D\u043E\u0439 \u0440\u0430\u0441\u043A\u0440\u0430\u0441\u043A\u043E\u0439 \u0434\u043B\u044F \u043A\u0430\u0436\u0434\u043E\u0433\u043E \u0438\u0437 \u0441\u0435\u0437\u043E\u043D\u043E\u0432, \u0432\u044B\u0434\u0430\u0432\u0430\u0435\u043C\u044B\u0439 \u0438\u0433\u0440\u043E\u043A\u0430\u043C \u0437\u0430 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0438 \u043A\u043B\u0430\u043D\u043E\u0432\u044B\u0435 \u0434\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u044F \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435. \u041D\u0430\u043D\u043E\u0441\u0438\u0442\u0441\u044F \u043D\u0430 \u0442\u0435\u0445\u043D\u0438\u043A\u0443 VIII\u2013X \u0443\u0440\u043E\u0432\u043D\u0435\u0439.'
        })
    };
}), _defineProperty(_PRODUCTS_CONFIG, _constants.PRODUCT_TYPES.CONQUEROR_STYLE, function (product) {
    return {
        title: getStyleProductName(_react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.conqueror_style.title',
            defaultMessage: '\xAB\u0417\u0430\u0432\u043E\u0435\u0432\u0430\u0442\u0435\u043B\u044C\xBB'
        })),
        description: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.conqueror_style.description',
            defaultMessage: '\u0412\u0441\u0435\u0441\u0435\u0437\u043E\u043D\u043D\u044B\u0439 \u0441\u0442\u0438\u043B\u044C, \u0432\u044B\u0434\u0430\u0432\u0430\u0435\u043C\u044B\u0439 \u0438\u0433\u0440\u043E\u043A\u0430\u043C \u0437\u0430 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0438 \u043A\u043B\u0430\u043D\u043E\u0432\u044B\u0435 \u0434\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u044F \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435. \u041D\u0430\u043D\u043E\u0441\u0438\u0442\u0441\u044F \u043D\u0430 \u0442\u0435\u0445\u043D\u0438\u043A\u0443 VIII\u2013X \u0443\u0440\u043E\u0432\u043D\u0435\u0439.'
        })
    };
}), _defineProperty(_PRODUCTS_CONFIG, _constants.PRODUCT_TYPES.NIGHTFALL_STYLE, function (product) {
    return {
        title: getStyleProductName(_react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.nightfall_style.title',
            defaultMessage: '\xAB\u0421\u0443\u043C\u0440\u0430\u043A\xBB'
        })),
        description: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.nightfall_style.description',
            defaultMessage: '\u0412\u0441\u0435\u0441\u0435\u0437\u043E\u043D\u043D\u044B\u0439 \u0441\u0442\u0438\u043B\u044C, \u0432\u044B\u0434\u0430\u0432\u0430\u0435\u043C\u044B\u0439 \u0438\u0433\u0440\u043E\u043A\u0430\u043C \u0437\u0430 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0438 \u043A\u043B\u0430\u043D\u043E\u0432\u044B\u0435 \u0434\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u044F \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435. \u041D\u0430\u043D\u043E\u0441\u0438\u0442\u0441\u044F \u043D\u0430 \u0442\u0435\u0445\u043D\u0438\u043A\u0443 VIII\u2013X \u0443\u0440\u043E\u0432\u043D\u0435\u0439.'
        })
    };
}), _defineProperty(_PRODUCTS_CONFIG, _constants.PRODUCT_TYPES.LIGHTNING_STYLE, function (product) {
    return {
        title: getStyleProductName(_react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.lightning_style.title',
            defaultMessage: '\xAB\u041C\u043E\u043B\u043D\u0438\u044F\xBB'
        })),
        description: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.lightning_style.description',
            defaultMessage: '\u0412\u0441\u0435\u0441\u0435\u0437\u043E\u043D\u043D\u044B\u0439 \u0441\u0442\u0438\u043B\u044C, \u0432\u044B\u0434\u0430\u0432\u0430\u0435\u043C\u044B\u0439 \u0438\u0433\u0440\u043E\u043A\u0430\u043C \u0437\u0430 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0438 \u043A\u043B\u0430\u043D\u043E\u0432\u044B\u0435 \u0434\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u044F \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435. \u041D\u0430\u043D\u043E\u0441\u0438\u0442\u0441\u044F \u043D\u0430 \u0442\u0435\u0445\u043D\u0438\u043A\u0443 \u043B\u044E\u0431\u043E\u0433\u043E \u0443\u0440\u043E\u0432\u043D\u044F.'
        })
    };
}), _defineProperty(_PRODUCTS_CONFIG, _constants.PRODUCT_TYPES.CREW_BOOK_NATIONAL, function (product) {
    return {
        title: getCrewBookProductName(_react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.crew_book_national.title',
            defaultMessage: '{quantity} \u043E\u043F\u044B\u0442\u0430',
            values: {
                quantity: (0, _format_number.thousands)(100000)
            }
        })),
        description: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.crew_book_national.description',
            defaultMessage: '\u041E\u0434\u043D\u043E\u0440\u0430\u0437\u043E\u0432\u044B\u0439 \u043F\u0440\u0435\u0434\u043C\u0435\u0442, \u043F\u0440\u0438\u043C\u0435\u043D\u044F\u0435\u0442\u0441\u044F \u043D\u0430 \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0439 \u044D\u043A\u0438\u043F\u0430\u0436. \u041F\u0440\u043E\u0447\u0442\u0435\u043D\u0438\u0435 \u0434\u0430\u0451\u0442 \u043F\u043E 100 000 \u043E\u043F\u044B\u0442\u0430 \u043A\u0430\u0436\u0434\u043E\u043C\u0443 \u0447\u043B\u0435\u043D\u0443 \u044D\u043A\u0438\u043F\u0430\u0436\u0430.'
        })
    };
}), _defineProperty(_PRODUCTS_CONFIG, _constants.PRODUCT_TYPES.BROKEN_STONE_STYLE, function (product) {
    return {
        title: getStyleProductName(_react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.broken_stone_style.title',
            defaultMessage: '\xAB\u041A\u043E\u043B\u043E\u0442\u044B\u0439 \u043A\u0430\u043C\u0435\u043D\u044C\xBB'
        })),
        description: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.broken_stone_style.description',
            defaultMessage: '\u0421\u0442\u0438\u043B\u044C \u0441 \u0438\u043D\u0434\u0438\u0432\u0438\u0434\u0443\u0430\u043B\u044C\u043D\u043E\u0439 \u0440\u0430\u0441\u043A\u0440\u0430\u0441\u043A\u043E\u0439 \u0434\u043B\u044F \u043A\u0430\u0436\u0434\u043E\u0433\u043E \u0438\u0437 \u0441\u0435\u0437\u043E\u043D\u043E\u0432, \u0432\u044B\u0434\u0430\u0432\u0430\u0435\u043C\u044B\u0439 \u0438\u0433\u0440\u043E\u043A\u0430\u043C \u0437\u0430 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0438 \u043A\u043B\u0430\u043D\u043E\u0432\u044B\u0435 \u0434\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u044F \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435. \u041D\u0430\u043D\u043E\u0441\u0438\u0442\u0441\u044F \u043D\u0430 \u0442\u0435\u0445\u043D\u0438\u043A\u0443 VIII\u2013X \u0443\u0440\u043E\u0432\u043D\u0435\u0439.'
        })
    };
}), _defineProperty(_PRODUCTS_CONFIG, _constants.PRODUCT_TYPES.DIGITAL_CAMOUFLAGE_WINTER, function (product) {
    return {
        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.digital_camouflage_winter.title',
            defaultMessage: '\u0417\u0438\u043C\u043D\u0438\u0439 \u0446\u0438\u0444\u0440\u043E\u0432\u043E\u0439 \u043A\u0430\u043C\u0443\u0444\u043B\u044F\u0436'
        }),
        description: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.digital_camouflage_winter.description',
            defaultMessage: '\u0417\u0438\u043C\u043D\u0438\u0439 \u0447\u0435\u0442\u044B\u0440\u0451\u0445\u0446\u0432\u0435\u0442\u043D\u044B\u0439 \xAB\u043F\u0438\u043A\u0441\u0435\u043B\u044C\u043D\u044B\u0439\xBB \u043A\u0430\u043C\u0443\u0444\u043B\u044F\u0436. \u0412\u0430\u043C \u0431\u0443\u0434\u0435\u0442 \u043D\u0430\u0447\u0438\u0441\u043B\u0435\u043D\u043E \u043F\u043E 3 \u0435\u0434\u0438\u043D\u0438\u0446\u044B \u043A\u0430\u043C\u0443\u0444\u043B\u044F\u0436\u0430 \u0434\u043B\u044F \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u0439 \u043D\u0430\u0446\u0438\u0438.'
        })
    };
}), _defineProperty(_PRODUCTS_CONFIG, _constants.PRODUCT_TYPES.DIGITAL_CAMOUFLAGE_SUMMER, function (product) {
    return {
        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.digital_camouflage_summer.title',
            defaultMessage: '\u041B\u0435\u0442\u043D\u0438\u0439 \u0446\u0438\u0444\u0440\u043E\u0432\u043E\u0439 \u043A\u0430\u043C\u0443\u0444\u043B\u044F\u0436'
        }),
        description: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.digital_camouflage_summer.description',
            defaultMessage: '\u041B\u0435\u0442\u043D\u0438\u0439 \u0447\u0435\u0442\u044B\u0440\u0451\u0445\u0446\u0432\u0435\u0442\u043D\u044B\u0439 \xAB\u043F\u0438\u043A\u0441\u0435\u043B\u044C\u043D\u044B\u0439\xBB \u043A\u0430\u043C\u0443\u0444\u043B\u044F\u0436. \u0412\u0430\u043C \u0431\u0443\u0434\u0435\u0442 \u043D\u0430\u0447\u0438\u0441\u043B\u0435\u043D\u043E \u043F\u043E 3 \u0435\u0434\u0438\u043D\u0438\u0446\u044B \u043A\u0430\u043C\u0443\u0444\u043B\u044F\u0436\u0430 \u0434\u043B\u044F \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u0439 \u043D\u0430\u0446\u0438\u0438.'
        })
    };
}), _defineProperty(_PRODUCTS_CONFIG, _constants.PRODUCT_TYPES.DIGITAL_CAMOUFLAGE_DESERT, function (product) {
    return {
        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.digital_camouflage_desert.title',
            defaultMessage: '\u041F\u0443\u0441\u0442\u044B\u043D\u043D\u044B\u0439 \u0446\u0438\u0444\u0440\u043E\u0432\u043E\u0439 \u043A\u0430\u043C\u0443\u0444\u043B\u044F\u0436'
        }),
        description: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.digital_camouflage_desert.description',
            defaultMessage: '\u041F\u0443\u0441\u0442\u044B\u043D\u043D\u044B\u0439 \u0447\u0435\u0442\u044B\u0440\u0451\u0445\u0446\u0432\u0435\u0442\u043D\u044B\u0439 \xAB\u043F\u0438\u043A\u0441\u0435\u043B\u044C\u043D\u044B\u0439\xBB \u043A\u0430\u043C\u0443\u0444\u043B\u044F\u0436. \u0412\u0430\u043C \u0431\u0443\u0434\u0435\u0442 \u043D\u0430\u0447\u0438\u0441\u043B\u0435\u043D\u043E \u043F\u043E 3 \u0435\u0434\u0438\u043D\u0438\u0446\u044B \u043A\u0430\u043C\u0443\u0444\u043B\u044F\u0436\u0430 \u0434\u043B\u044F \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u0439 \u043D\u0430\u0446\u0438\u0438.'
        })
    };
}), _defineProperty(_PRODUCTS_CONFIG, _constants.PRODUCT_TYPES.GUARDIAN_OF_CROWN_STYLE, function (product) {
    return {
        title: getStyleProductNameChiftein(_react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.guardian_of_crown_style.title',
            defaultMessage: '\xAB\u0421\u0442\u0440\u0430\u0436 \u041A\u043E\u0440\u043E\u043D\u044B\xBB'
        })),
        description: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.guardian_of_crown_style.description',
            defaultMessage: '\u0412\u0441\u0435\u0441\u0435\u0437\u043E\u043D\u043D\u044B\u0439 \u0438\u0441\u0442\u043E\u0440\u0438\u0447\u043D\u044B\u0439 3D-\u0441\u0442\u0438\u043B\u044C, \u0432\u044B\u0434\u0430\u0432\u0430\u0435\u043C\u044B\u0439 \u0438\u0433\u0440\u043E\u043A\u0430\u043C \u0437\u0430 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0438 \u043A\u043B\u0430\u043D\u043E\u0432\u044B\u0435 \u0434\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u044F \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435. \u041F\u043E\u0434\u0445\u043E\u0434\u0438\u0442 \u0442\u043E\u043B\u044C\u043A\u043E \u0434\u043B\u044F \u043C\u0430\u0448\u0438\u043D\u044B T95/FV4201 Chieftain.'
        })
    };
}), _defineProperty(_PRODUCTS_CONFIG, _constants.PRODUCT_TYPES.HELLRAISER_STYLE, function (product) {
    return {
        title: getStyleProductNameHellraiser(_react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.hellraiser_style.title',
            defaultMessage: '\xAB\u0425\u044D\u043B\u0440\u0435\u0439\u0437\u0435\u0440\xBB'
        })),
        description: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.hellraiser_style.description',
            defaultMessage: '\u0412\u0441\u0435\u0441\u0435\u0437\u043E\u043D\u043D\u044B\u0439 3D-\u0441\u0442\u0438\u043B\u044C, \u0432\u044B\u0434\u0430\u0432\u0430\u0435\u043C\u044B\u0439 \u0438\u0433\u0440\u043E\u043A\u0430\u043C \u0437\u0430 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0438 \u043A\u043B\u0430\u043D\u043E\u0432\u044B\u0435 \u0434\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u044F \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435. \u041F\u043E\u0434\u0445\u043E\u0434\u0438\u0442 \u0442\u043E\u043B\u044C\u043A\u043E \u0434\u043B\u044F \u043C\u0430\u0448\u0438\u043D\u044B \u041C60.'
        })
    };
}), _defineProperty(_PRODUCTS_CONFIG, _constants.PRODUCT_TYPES.PROPHESY_STYLE, function (product) {
    return {
        title: getStyleProductName(_react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.prophesy_style.title',
            defaultMessage: '\xAB\u041F\u0440\u0435\u0434\u0432\u0435\u0441\u0442\u043D\u0438\u043A\xBB'
        })),
        description: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.prophesy_style.description',
            defaultMessage: '\u0412\u0441\u0435\u0441\u0435\u0437\u043E\u043D\u043D\u044B\u0439 \u0441\u0442\u0438\u043B\u044C, \u0432\u044B\u0434\u0430\u0432\u0430\u0435\u043C\u044B\u0439 \u0438\u0433\u0440\u043E\u043A\u0430\u043C \u0437\u0430 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0438 \u043A\u043B\u0430\u043D\u043E\u0432\u044B\u0435 \u0434\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u044F \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435. \u041D\u0430\u043D\u043E\u0441\u0438\u0442\u0441\u044F \u043D\u0430 \u0442\u0435\u0445\u043D\u0438\u043A\u0443 VIII\u2013X \u0443\u0440\u043E\u0432\u043D\u0435\u0439.'
        })
    };
}), _defineProperty(_PRODUCTS_CONFIG, _constants.PRODUCT_TYPES.JUDGEMENT_STYLE, function (product) {
    return {
        title: getStyleProductName(_react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.judgement_style.title',
            defaultMessage: '\xAB\u0412\u043E\u0437\u0434\u0430\u044F\u043D\u0438\u0435\xBB'
        })),
        description: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.judgement_style.description',
            defaultMessage: '\u0412\u0441\u0435\u0441\u0435\u0437\u043E\u043D\u043D\u044B\u0439 \u0441\u0442\u0438\u043B\u044C, \u0432\u044B\u0434\u0430\u0432\u0430\u0435\u043C\u044B\u0439 \u0438\u0433\u0440\u043E\u043A\u0430\u043C \u0437\u0430 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0438 \u043A\u043B\u0430\u043D\u043E\u0432\u044B\u0435 \u0434\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u044F \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435. \u041D\u0430\u043D\u043E\u0441\u0438\u0442\u0441\u044F \u043D\u0430 \u0442\u0435\u0445\u043D\u0438\u043A\u0443 VIII\u2013X \u0443\u0440\u043E\u0432\u043D\u0435\u0439.'
        })
    };
}), _defineProperty(_PRODUCTS_CONFIG, _constants.PRODUCT_TYPES.REAPER_STYLE, function (product) {
    return {
        title: getStyleProductName(_react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.reaper_style.title',
            defaultMessage: '\xAB\u0416\u043D\u0435\u0446\xBB'
        })),
        description: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.reaper_style.description',
            defaultMessage: '\u0412\u0441\u0435\u0441\u0435\u0437\u043E\u043D\u043D\u044B\u0439 \u0441\u0442\u0438\u043B\u044C, \u0432\u044B\u0434\u0430\u0432\u0430\u0435\u043C\u044B\u0439 \u0438\u0433\u0440\u043E\u043A\u0430\u043C \u0437\u0430 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0438 \u043A\u043B\u0430\u043D\u043E\u0432\u044B\u0435 \u0434\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u044F \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435. \u041D\u0430\u043D\u043E\u0441\u0438\u0442\u0441\u044F \u043D\u0430 \u0442\u0435\u0445\u043D\u0438\u043A\u0443 VIII\u2013X \u0443\u0440\u043E\u0432\u043D\u0435\u0439.'
        })
    };
}), _defineProperty(_PRODUCTS_CONFIG, _constants.PRODUCT_TYPES.EMBLEM, function (product) {
    return {
        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.emblem.title',
            defaultMessage: '\u041D\u0430\u0431\u043E\u0440 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0445 \u043A\u043B\u0430\u043D\u043E\u0432\u044B\u0445 \u044D\u043C\u0431\u043B\u0435\u043C'
        }),
        description: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.emblem.description',
            defaultMessage: '\u041D\u0430\u0431\u043E\u0440 \u0438\u0437 \u043F\u044F\u0442\u0438 \u0432\u0438\u0434\u043E\u0432 \u044D\u043C\u0431\u043B\u0435\u043C, \u0440\u0430\u043D\u0435\u0435 \u0432\u044B\u0434\u0430\u0432\u0430\u0432\u0448\u0438\u0445\u0441\u044F \u0437\u0430 \u0441\u043E\u0431\u044B\u0442\u0438\u044F \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435. \u0412\u0430\u043C \u0431\u0443\u0434\u0435\u0442 \u043D\u0430\u0447\u0438\u0441\u043B\u0435\u043D\u043E 6 \u044D\u043C\u0431\u043B\u0435\u043C \u043A\u0430\u0436\u0434\u043E\u0433\u043E \u0432\u0438\u0434\u0430.'
        })
    };
}), _defineProperty(_PRODUCTS_CONFIG, _constants.PRODUCT_TYPES.CREW_WOMAN, function (product) {
    return {
        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.crew_woman.title',
            defaultMessage: '\u0414\u0435\u0432\u0443\u0448\u043A\u0430-\u0442\u0430\u043D\u043A\u0438\u0441\u0442'
        }),
        description: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.crew_woman.description',
            defaultMessage: '\u0414\u0435\u0432\u0443\u0448\u043A\u0438-\u0442\u0430\u043D\u043A\u0438\u0441\u0442\u044B \u0443\u0436\u0435 \u0438\u043C\u0435\u044E\u0442 \u043D\u0430\u0432\u044B\u043A \xAB\u0411\u043E\u0435\u0432\u043E\u0435 \u0431\u0440\u0430\u0442\u0441\u0442\u0432\u043E\xBB. \u041C\u043E\u0436\u043D\u043E \u0432\u044B\u0431\u0440\u0430\u0442\u044C \u043D\u0430\u0446\u0438\u044E, \u0442\u0438\u043F \u0442\u0435\u0445\u043D\u0438\u043A\u0438 \u0438 \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u044C, \u0438\u0437\u0443\u0447\u0435\u043D\u043D\u0443\u044E \u0441\u0440\u0430\u0437\u0443 \u043D\u0430 {percent}.',
            values: { percent: (0, _format_number.formatPercent)(100) }
        })
    };
}), _defineProperty(_PRODUCTS_CONFIG, _constants.PRODUCT_TYPES.DIRECTIVES_PACK, function (product) {
    return {
        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.directives_pack.title',
            defaultMessage: '{amount} \u043F\u0440\u0435\u0434\u0431\u043E\u0435\u0432\u044B\u0445 \u0438\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u0439',
            values: {
                amount: _react2.default.createElement(
                    'span',
                    { className: _WGCWXShopDetailedProduct2.default.highlight },
                    'x' + product.value * DIRECTIVES_TYPES_COUNT
                )
            }
        }),
        description: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.directives_pack.description',
            defaultMessage: '\u041F\u0440\u0435\u0434\u0431\u043E\u0435\u0432\u044B\u0435 \u0438\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u0438 \u043F\u043E\u0432\u044B\u0448\u0430\u044E\u0442 \u044D\u0444\u0444\u0435\u043A\u0442\u0438\u0432\u043D\u043E\u0441\u0442\u044C \u043E\u0431\u043E\u0440\u0443\u0434\u043E\u0432\u0430\u043D\u0438\u044F \u0438 \u043D\u0430\u0432\u044B\u043A\u043E\u0432/\u0443\u043C\u0435\u043D\u0438\u0439 \u044D\u043A\u0438\u043F\u0430\u0436\u0430, \u0447\u0442\u043E \u043F\u043E\u0437\u0432\u043E\u043B\u044F\u0435\u0442 \u043B\u0443\u0447\u0448\u0435 \u0440\u0430\u0441\u043A\u0440\u044B\u0442\u044C \u043F\u043E\u0442\u0435\u043D\u0446\u0438\u0430\u043B \u043C\u0430\u0448\u0438\u043D\u044B.'
        }),
        content: _react2.default.createElement(
            'ul',
            { className: _WGCWXShopDetailedProduct2.default.itemContent_list },
            _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'wgcwx_shop.products.directives_pack.content.1',
                    defaultMessage: '{amount} \u041F\u043E\u0432\u044B\u0448\u0435\u043D\u043D\u043E\u0435 \u0432\u043D\u0438\u043C\u0430\u043D\u0438\u0435',
                    values: { amount: getAmount(product.value) }
                })
            ),
            _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'wgcwx_shop.products.directives_pack.content.2',
                    defaultMessage: '{amount} \u0423\u043A\u0440\u044B\u0442\u0438\u044F \u043D\u0430 \u043C\u0435\u0441\u0442\u043D\u043E\u0441\u0442\u0438',
                    values: { amount: getAmount(product.value) }
                })
            ),
            _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'wgcwx_shop.products.directives_pack.content.3',
                    defaultMessage: '{amount} \u0418\u0441\u043A\u0443\u0441\u0441\u0442\u0432\u043E \u0441\u0431\u0438\u0432\u0430\u0442\u044C \u043F\u043B\u0430\u043C\u044F',
                    values: { amount: getAmount(product.value) }
                })
            ),
            _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'wgcwx_shop.products.directives_pack.content.4',
                    defaultMessage: '{amount} \u041F\u0440\u043E\u0434\u0443\u0432\u043A\u0430 \u0432\u043E\u0437\u0434\u0443\u0445\u043E\u0432\u043E\u0434\u043E\u0432',
                    values: { amount: getAmount(product.value) }
                })
            ),
            _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'wgcwx_shop.products.directives_pack.content.5',
                    defaultMessage: '{amount} \u0420\u0430\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u0430\u044F \u0431\u043E\u0435\u0443\u043A\u043B\u0430\u0434\u043A\u0430',
                    values: { amount: getAmount(product.value) }
                })
            ),
            _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'wgcwx_shop.products.directives_pack.content.6',
                    defaultMessage: '{amount} \u041A\u0430\u043B\u0438\u0431\u0440\u043E\u0432\u043A\u0430 \u043E\u043F\u0442\u0438\u043A\u0438',
                    values: { amount: getAmount(product.value) }
                })
            )
        )
    };
}), _defineProperty(_PRODUCTS_CONFIG, _constants.PRODUCT_TYPES.DIRECTIVES_PACK_30, function (product) {
    return {
        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.directives_pack_30.title',
            defaultMessage: '\u041F\u0440\u0435\u0434\u0431\u043E\u0435\u0432\u044B\u0435 \u0438\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u0438'
        }),
        description: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.directives_pack_30.description',
            defaultMessage: '\u041F\u0440\u0435\u0434\u0431\u043E\u0435\u0432\u044B\u0435 \u0438\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u0438 \u043F\u043E\u0432\u044B\u0448\u0430\u044E\u0442 \u044D\u0444\u0444\u0435\u043A\u0442\u0438\u0432\u043D\u043E\u0441\u0442\u044C \u043E\u0431\u043E\u0440\u0443\u0434\u043E\u0432\u0430\u043D\u0438\u044F \u0438 \u043D\u0430\u0432\u044B\u043A\u043E\u0432/\u0443\u043C\u0435\u043D\u0438\u0439 \u044D\u043A\u0438\u043F\u0430\u0436\u0430, \u0447\u0442\u043E \u043F\u043E\u0437\u0432\u043E\u043B\u044F\u0435\u0442 \u043B\u0443\u0447\u0448\u0435 \u0440\u0430\u0441\u043A\u0440\u044B\u0442\u044C \u043F\u043E\u0442\u0435\u043D\u0446\u0438\u0430\u043B \u043C\u0430\u0448\u0438\u043D\u044B.'
        }),
        content: _react2.default.createElement(
            'ul',
            { className: _WGCWXShopDetailedProduct2.default.itemContent_list },
            _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'wgcwx_shop.products.directives_pack_30.content.4',
                    defaultMessage: '{amount} \u041F\u0440\u043E\u0434\u0443\u0432\u043A\u0430 \u0432\u043E\u0437\u0434\u0443\u0445\u043E\u0432\u043E\u0434\u043E\u0432',
                    values: { amount: getAmount(product.value) }
                })
            ),
            _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'wgcwx_shop.products.directives_pack_30.content.5',
                    defaultMessage: '{amount} \u0420\u0430\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u0430\u044F \u0431\u043E\u0435\u0443\u043A\u043B\u0430\u0434\u043A\u0430',
                    values: { amount: getAmount(product.value) }
                })
            ),
            _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'wgcwx_shop.products.directives_pack_30.content.6',
                    defaultMessage: '{amount} \u041A\u0430\u043B\u0438\u0431\u0440\u043E\u0432\u043A\u0430 \u043E\u043F\u0442\u0438\u043A\u0438',
                    values: { amount: getAmount(product.value) }
                })
            )
        )
    };
}), _defineProperty(_PRODUCTS_CONFIG, _constants.PRODUCT_TYPES.CREW_EXPERIENCE, function (product) {
    return {
        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.crew_experience.title',
            defaultMessage: '{bonus} \u043A \u043E\u043F\u044B\u0442\u0443 \u044D\u043A\u0438\u043F\u0430\u0436\u0430 \u043D\u0430 1 \u0447',
            values: {
                bonus: _react2.default.createElement(
                    'span',
                    { className: _WGCWXShopDetailedProduct2.default.highlight },
                    '+' + (0, _format_number.formatPercent)(300)
                )
            }
        })
    };
}), _defineProperty(_PRODUCTS_CONFIG, _constants.PRODUCT_TYPES.FREE_EXPERIENCE, function (product) {
    return {
        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.free_experience.title',
            defaultMessage: '{bonus} \u043A \u0441\u0432\u043E\u0431\u043E\u0434\u043D\u043E\u043C\u0443 \u043E\u043F\u044B\u0442\u0443 \u043D\u0430 1 \u0447',
            values: {
                bonus: _react2.default.createElement(
                    'span',
                    { className: _WGCWXShopDetailedProduct2.default.highlight },
                    '+' + (0, _format_number.formatPercent)(300)
                )
            }
        })
    };
}), _defineProperty(_PRODUCTS_CONFIG, _constants.PRODUCT_TYPES.EXPERIENCE, function (product) {
    return {
        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.expecience.title',
            defaultMessage: '{bonus} \u043A \u043E\u043F\u044B\u0442\u0443 \u043D\u0430 1 \u0447',
            values: {
                bonus: _react2.default.createElement(
                    'span',
                    { className: _WGCWXShopDetailedProduct2.default.highlight },
                    '+' + (0, _format_number.formatPercent)(50)
                )
            }
        })
    };
}), _defineProperty(_PRODUCTS_CONFIG, _constants.PRODUCT_TYPES.WARRIOR_OF_THE_WEST_STYLE, function (product) {
    return {
        title: getStyleProductName(_react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.west_warrior_style.title',
            defaultMessage: '\xAB\u0412\u043E\u0438\u043D \u0417\u0430\u043F\u0430\u0434\u0430\xBB'
        })),
        description: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.west_warrior_style.description',
            defaultMessage: '\u0412\u0441\u0435\u0441\u0435\u0437\u043E\u043D\u043D\u044B\u0439 \u0441\u0442\u0438\u043B\u044C, \u0432\u044B\u0434\u0430\u0432\u0430\u0435\u043C\u044B\u0439 \u0438\u0433\u0440\u043E\u043A\u0430\u043C \u0437\u0430 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0438 \u043A\u043B\u0430\u043D\u043E\u0432\u044B\u0435 \u0434\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u044F \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435. \u041D\u0430\u043D\u043E\u0441\u0438\u0442\u0441\u044F \u043D\u0430 \u0442\u0435\u0445\u043D\u0438\u043A\u0443 VIII\u2013X \u0443\u0440\u043E\u0432\u043D\u0435\u0439.'
        })
    };
}), _defineProperty(_PRODUCTS_CONFIG, _constants.PRODUCT_TYPES.WARRIOR_OF_THE_NORTH_STYLE, function (product) {
    return {
        title: getStyleProductName(_react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.north_warrior_style.title',
            defaultMessage: '\xAB\u0412\u043E\u0438\u043D \u0421\u0435\u0432\u0435\u0440\u0430\xBB'
        })),
        description: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.north_warrior_style.description',
            defaultMessage: '\u0412\u0441\u0435\u0441\u0435\u0437\u043E\u043D\u043D\u044B\u0439 \u0441\u0442\u0438\u043B\u044C, \u0432\u044B\u0434\u0430\u0432\u0430\u0435\u043C\u044B\u0439 \u0438\u0433\u0440\u043E\u043A\u0430\u043C \u0437\u0430 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0438 \u043A\u043B\u0430\u043D\u043E\u0432\u044B\u0435 \u0434\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u044F \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435. \u041D\u0430\u043D\u043E\u0441\u0438\u0442\u0441\u044F \u043D\u0430 \u0442\u0435\u0445\u043D\u0438\u043A\u0443 VIII\u2013X \u0443\u0440\u043E\u0432\u043D\u0435\u0439.'
        })
    };
}), _defineProperty(_PRODUCTS_CONFIG, _constants.PRODUCT_TYPES.WARRIOR_OF_THE_SOUTH_STYLE, function (product) {
    return {
        title: getStyleProductName(_react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.south_warrior_style.title',
            defaultMessage: '\xAB\u0412\u043E\u0438\u043D \u042E\u0433\u0430\xBB'
        })),
        description: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.south_warrior_style.description',
            defaultMessage: '\u0412\u0441\u0435\u0441\u0435\u0437\u043E\u043D\u043D\u044B\u0439 \u0441\u0442\u0438\u043B\u044C, \u0432\u044B\u0434\u0430\u0432\u0430\u0435\u043C\u044B\u0439 \u0438\u0433\u0440\u043E\u043A\u0430\u043C \u0437\u0430 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0438 \u043A\u043B\u0430\u043D\u043E\u0432\u044B\u0435 \u0434\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u044F \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435. \u041D\u0430\u043D\u043E\u0441\u0438\u0442\u0441\u044F \u043D\u0430 \u0442\u0435\u0445\u043D\u0438\u043A\u0443 VIII\u2013X \u0443\u0440\u043E\u0432\u043D\u0435\u0439.'
        })
    };
}), _defineProperty(_PRODUCTS_CONFIG, _constants.PRODUCT_TYPES.KRAIT_STYLE, function (product) {
    return {
        title: getStyleProductNameKrait(_react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.krait_style.title',
            defaultMessage: '\xAB\u041A\u0440\u0430\u0439\u0442\xBB'
        })),
        description: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.krait_style.description',
            defaultMessage: '\u0412\u0441\u0435\u0441\u0435\u0437\u043E\u043D\u043D\u044B\u0439 3D-\u0441\u0442\u0438\u043B\u044C, \u0432\u044B\u0434\u0430\u0432\u0430\u0435\u043C\u044B\u0439 \u0438\u0433\u0440\u043E\u043A\u0430\u043C \u0437\u0430 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0438 \u043A\u043B\u0430\u043D\u043E\u0432\u044B\u0435 \u0434\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u044F \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435. \u041F\u043E\u0434\u0445\u043E\u0434\u0438\u0442 \u0442\u043E\u043B\u044C\u043A\u043E \u0434\u043B\u044F \u043C\u0430\u0448\u0438\u043D\u044B 121B.'
        })
    };
}), _defineProperty(_PRODUCTS_CONFIG, _constants.PRODUCT_TYPES.BASALT_STYLE, function (product) {
    return {
        title: getStyleProductNameBasalt(_react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.basalt_style.title',
            defaultMessage: '\xAB\u0411\u0430\u0437\u0430\u043B\u044C\u0442\xBB'
        })),
        description: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.basalt_style.description',
            defaultMessage: '\u0412\u0441\u0435\u0441\u0435\u0437\u043E\u043D\u043D\u044B\u0439 3D-\u0441\u0442\u0438\u043B\u044C, \u0432\u044B\u0434\u0430\u0432\u0430\u0435\u043C\u044B\u0439 \u0438\u0433\u0440\u043E\u043A\u0430\u043C \u0437\u0430 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0438 \u043A\u043B\u0430\u043D\u043E\u0432\u044B\u0435 \u0434\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u044F \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435. \u041F\u043E\u0434\u0445\u043E\u0434\u0438\u0442 \u0442\u043E\u043B\u044C\u043A\u043E \u0434\u043B\u044F \u043C\u0430\u0448\u0438\u043D\u044B \u041E\u0431\u044A\u0435\u043A\u0442 907.'
        })
    };
}), _defineProperty(_PRODUCTS_CONFIG, _constants.PRODUCT_TYPES.FREE_XP_AND_CREW_XP, function (product) {
    return {
        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.free_xp_and_crew_xp.title',
            defaultMessage: '{bonus} \u043A \u0441\u0432\u043E\u0431\u043E\u0434\u043D\u043E\u043C\u0443 \u043E\u043F\u044B\u0442\u0443 \u0438 \u043E\u043F\u044B\u0442\u0443 \u044D\u043A\u0438\u043F\u0430\u0436\u0430 \u043D\u0430 1 \u0447',
            values: {
                bonus: _react2.default.createElement(
                    'span',
                    { className: _WGCWXShopDetailedProduct2.default.highlight },
                    '+' + (0, _format_number.formatPercent)(200)
                )
            }
        }),
        shortDetailedTitle: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.free_xp_and_crew_xp.short_title',
            defaultMessage: '\u041B\u0438\u0447\u043D\u044B\u0439 \u0440\u0435\u0437\u0435\u0440\u0432'
        })
    };
}), _defineProperty(_PRODUCTS_CONFIG, _constants.PRODUCT_TYPES.XP_RESERVE, function (product) {
    return {
        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'wgcwx_shop.products.xp_reserve.title',
            defaultMessage: '{bonus} \u043A \u043E\u043F\u044B\u0442\u0443 \u043D\u0430 1 \u0447',
            values: {
                bonus: _react2.default.createElement(
                    'span',
                    { className: _WGCWXShopDetailedProduct2.default.highlight },
                    '+' + (0, _format_number.formatPercent)(50)
                )
            }
        })
    };
}), _PRODUCTS_CONFIG);

/**
 * number of types of items in directives pack,
 * should be adjusted manually with content of
 * ```PRODUCTS_CONFIG.DIRECTIVES_PACK(product).content```
 */
var DIRECTIVES_TYPES_COUNT = 6;
var NO_DESCRIPTION_VEHICLES = exports.NO_DESCRIPTION_VEHICLES = [];

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EVENT_FINISHED_HAS_NO_AUCTION_TICKET = exports.AUCTION_BET_APPLIED = exports.AUCTION_START_FROM = exports.PFP_NAME = exports.OTHER_REWARD_SELECTED = exports.REWARD_RECEIVED = exports.TANK_IS_IN_HANGAR = exports.NOT_ENOUGH_PFP_FOR_TANK_RECEIVING = exports.ENOUGH_PFP_FOR_TANK_RECEIVING = exports.LACK_OF_BATTLES = exports.REWARDS_TANK_HAS_NO_AUCTION_TICKET = exports.REWARDS_TANK_HAS_AUCTION_TICKET = exports.REWARDS_TANKS_SECTION = exports.EVENT_REWARDS = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _WGCWXRewards = __webpack_require__(578);

var _WGCWXRewards2 = _interopRequireDefault(_WGCWXRewards);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EVENT_REWARDS = exports.EVENT_REWARDS = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.rewards.event_rewards',
    defaultMessage: '\u041D\u0430\u0433\u0440\u0430\u0436\u0434\u0435\u043D\u0438\u0435 \u043F\u043E\u0431\u0435\u0434\u0438\u0442\u0435\u043B\u0435\u0439'
}); /* eslint-disable react/no-multi-comp, max-len */
var REWARDS_TANKS_SECTION = exports.REWARDS_TANKS_SECTION = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.rewards.sections.tanks',
    defaultMessage: '\u041F\u0440\u0438\u0437\u043E\u0432\u0430\u044F \u0442\u0435\u0445\u043D\u0438\u043A\u0430'
});

var AUCTION_ACCESS = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.rewards.sections.auction_access',
    defaultMessage: '\u0434\u043E\u043F\u0443\u0441\u043A \u043D\u0430 \u0430\u0443\u043A\u0446\u0438\u043E\u043D \u0442\u0435\u0445\u043D\u0438\u043A\u0438'
});

var REWARDS_TANK_HAS_AUCTION_TICKET = exports.REWARDS_TANK_HAS_AUCTION_TICKET = function REWARDS_TANK_HAS_AUCTION_TICKET(topPlaces) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop.rewards.has_auction_ticket.requirement',
        defaultMessage: '\u0422\u0435\u0445\u043D\u0438\u043A\u0443 \u0437\u0430 \u0444\u0438\u043A\u0441\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0435 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0431\u043E\u043D \u0441\u043C\u043E\u0433\u0443\u0442 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0438\u0433\u0440\u043E\u043A\u0438, \u0432\u043E\u0448\u0435\u0434\u0448\u0438\u0435 \u0432 {top} \u043F\u043E \u0438\u0442\u043E\u0433\u0430\u043C \u0441\u043E\u0431\u044B\u0442\u0438\u044F. \u0412\u044B \u0443\u0436\u0435 \u0441\u043E\u0431\u0440\u0430\u043B\u0438 \u0432 \u041C\u0430\u0441\u0442\u0435\u0440\u0441\u043A\u043E\u0439 {access} \u0434\u043B\u044F \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u0438 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043F\u0440\u0438\u0437\u043E\u0432\u044B\u0435 \u043C\u0430\u0448\u0438\u043D\u044B, \u0434\u0435\u043B\u0430\u044F \u0441\u0442\u0430\u0432\u043A\u0438 \u043D\u0430 \u0430\u0443\u043A\u0446\u0438\u043E\u043D\u0435. \u041D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E\u0435 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043B\u0438\u0447\u043D\u044B\u0445 \u041E\u0447\u043A\u043E\u0432 \u0441\u043B\u0430\u0432\u044B \u0434\u043B\u044F \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u0442\u0435\u0445\u043D\u0438\u043A\u0438 \u0441\u0442\u0430\u043D\u0435\u0442 \u0438\u0437\u0432\u0435\u0441\u0442\u043D\u043E \u043F\u043E\u0441\u043B\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0441\u043E\u0431\u044B\u0442\u0438\u044F.',
        values: {
            access: _react2.default.createElement(
                'span',
                { className: _WGCWXRewards2.default.highlight },
                AUCTION_ACCESS
            ),
            top: _react2.default.createElement(
                'span',
                { className: _WGCWXRewards2.default.highlight },
                REWARDS_TANK_SELECTION_TOP(topPlaces)
            )
        }
    });
};

var REWARDS_TANK_HAS_NO_AUCTION_TICKET = exports.REWARDS_TANK_HAS_NO_AUCTION_TICKET = function REWARDS_TANK_HAS_NO_AUCTION_TICKET(topPlaces) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop.rewards.has_no_auction_ticket.requirement',
        defaultMessage: '\u0422\u0435\u0445\u043D\u0438\u043A\u0443 \u0437\u0430 \u0444\u0438\u043A\u0441\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0435 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0431\u043E\u043D \u0441\u043C\u043E\u0433\u0443\u0442 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0438\u0433\u0440\u043E\u043A\u0438, \u0432\u043E\u0448\u0435\u0434\u0448\u0438\u0435 \u0432 {top} \u043F\u043E \u0438\u0442\u043E\u0433\u0430\u043C \u0441\u043E\u0431\u044B\u0442\u0438\u044F. \u041E\u0441\u0442\u0430\u043B\u044C\u043D\u044B\u043C \u0438\u0433\u0440\u043E\u043A\u0430\u043C \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0441\u043E\u0431\u0440\u0430\u0442\u044C \u0432 \u041C\u0430\u0441\u0442\u0435\u0440\u0441\u043A\u043E\u0439 {access} \u0434\u043B\u044F \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u0438 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043F\u0440\u0438\u0437\u043E\u0432\u044B\u0435 \u043C\u0430\u0448\u0438\u043D\u044B, \u0434\u0435\u043B\u0430\u044F \u0441\u0442\u0430\u0432\u043A\u0438 \u0432 \u0431\u043E\u043D\u043E\u0432\u043E\u043C \u0430\u0443\u043A\u0446\u0438\u043E\u043D\u0435. \u041D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E\u0435 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043B\u0438\u0447\u043D\u044B\u0445 \u041E\u0447\u043A\u043E\u0432 \u0441\u043B\u0430\u0432\u044B \u0434\u043B\u044F \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u0442\u0435\u0445\u043D\u0438\u043A\u0438 \u0441\u0442\u0430\u043D\u0435\u0442 \u0438\u0437\u0432\u0435\u0441\u0442\u043D\u043E \u043F\u043E\u0441\u043B\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0441\u043E\u0431\u044B\u0442\u0438\u044F.',
        values: {
            access: _react2.default.createElement(
                'span',
                { className: _WGCWXRewards2.default.highlight },
                AUCTION_ACCESS
            ),
            top: _react2.default.createElement(
                'span',
                { className: _WGCWXRewards2.default.highlight },
                REWARDS_TANK_SELECTION_TOP(topPlaces)
            )
        }
    });
};

var REWARDS_TANK_SELECTION_TOP = function REWARDS_TANK_SELECTION_TOP(topPlaces) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop.rewards.tank_receiving.top',
        defaultMessage: '\u0442\u043E\u043F-{top}',
        values: { top: _react2.default.createElement(_reactIntl.FormattedNumber, { value: topPlaces }) }
    });
};

var LACK_OF_BATTLES = exports.LACK_OF_BATTLES = function LACK_OF_BATTLES(battlesPlayed, minBattles) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop.rewards.tank_receiving.lack_of_battles',
        defaultMessage: '\u041F\u0440\u043E\u0432\u0435\u0434\u0435\u043D\u043E \u0431\u043E\u0451\u0432 {battlesPlayed} / {minBattles}.',
        values: { battlesPlayed: battlesPlayed, minBattles: minBattles }
    });
};

var ENOUGH_PFP_FOR_TANK_RECEIVING = exports.ENOUGH_PFP_FOR_TANK_RECEIVING = function ENOUGH_PFP_FOR_TANK_RECEIVING(dateTime, topPlaces) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop.rewards.tank_receiving.enough_pfp_for_tank_receiving',
        defaultMessage: '\u041F\u043E\u0437\u0434\u0440\u0430\u0432\u043B\u044F\u0435\u043C! \u0412\u044B \u0432\u043E\u0448\u043B\u0438 \u0432 {top} \u0438\u0433\u0440\u043E\u043A\u043E\u0432 \u043F\u043E \u0438\u0442\u043E\u0433\u0430\u043C \u0441\u043E\u0431\u044B\u0442\u0438\u044F \u0438 \u043F\u043E\u043B\u0443\u0447\u0438\u043B\u0438 \u043F\u0440\u0430\u0432\u043E \u043D\u0430 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435 \u043D\u0430\u0433\u0440\u0430\u0434\u044B. \u041D\u0430\u0433\u0440\u0430\u0436\u0434\u0435\u043D\u0438\u0435 \u0431\u0443\u0434\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E \u0434\u043E {dateTime}.',
        values: {
            top: _react2.default.createElement(
                'span',
                { className: _WGCWXRewards2.default.highlight },
                REWARDS_TANK_SELECTION_TOP(topPlaces)
            ),
            dateTime: _react2.default.createElement(
                'span',
                { className: _WGCWXRewards2.default.highlight },
                dateTime.format('L, LT')
            )
        }
    });
};

var NOT_ENOUGH_PFP_FOR_TANK_RECEIVING = exports.NOT_ENOUGH_PFP_FOR_TANK_RECEIVING = function NOT_ENOUGH_PFP_FOR_TANK_RECEIVING(dateTime) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop.rewards.tank_receiving.auction.not_enough_pfp_for_tank_receiving',
        defaultMessage: '\u041A \u0441\u043E\u0436\u0430\u043B\u0435\u043D\u0438\u044E, \u0432\u044B \u043D\u0430\u0431\u0440\u0430\u043B\u0438 \u043D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E\u0435 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u041E\u0447\u043A\u043E\u0432 \u0441\u043B\u0430\u0432\u044B \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 \u0441\u043E\u0431\u044B\u0442\u0438\u044F, \u043D\u043E \u0432\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0411\u043E\u043D\u044B \u0434\u043B\u044F \u0443\u0447\u0430\u0441\u0442\u0438\u044F \u0432 \u0430\u0443\u043A\u0446\u0438\u043E\u043D\u0435 \u0437\u0430 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435 \u043D\u0430\u0433\u0440\u0430\u0434. \u041D\u0430\u0433\u0440\u0430\u0436\u0434\u0435\u043D\u0438\u0435 \u0431\u0443\u0434\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E \u0434\u043E {dateTime}.',
        values: {
            dateTime: _react2.default.createElement(
                'span',
                { className: _WGCWXRewards2.default.highlight },
                dateTime.format('L, LT')
            )
        }
    });
};

var TANK_IS_IN_HANGAR = exports.TANK_IS_IN_HANGAR = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.rewards.tank_receiving.already_in_hangar',
    defaultMessage: '\u0412 \u0410\u043D\u0433\u0430\u0440\u0435'
});

var REWARD_RECEIVED = exports.REWARD_RECEIVED = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.rewards.tank_receiving.already_received',
    defaultMessage: '\u041D\u0430\u0433\u0440\u0430\u0434\u0430 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0430'
});

var OTHER_REWARD_SELECTED = exports.OTHER_REWARD_SELECTED = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.rewards.tank_receiving.other_reward_selected',
    defaultMessage: '\u041D\u0430\u0433\u0440\u0430\u0434\u0430 \u0443\u0436\u0435 \u0432\u044B\u0431\u0440\u0430\u043D\u0430'
});

var PFP_NAME = exports.PFP_NAME = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.rewards.tank_receiving.pfp_name',
    defaultMessage: '\u041E\u0447\u043A\u0438 \u0441\u043B\u0430\u0432\u044B'
});

var AUCTION_START_FROM = exports.AUCTION_START_FROM = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.rewards.tank_receiving.auction.start_from',
    defaultMessage: '\u0410\u0443\u043A\u0446\u0438\u043E\u043D \u043E\u0442'
});

var AUCTION_BET_APPLIED = exports.AUCTION_BET_APPLIED = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.rewards.tank_receiving.auction.bet_applied',
    defaultMessage: '\u041F\u0440\u0438\u043D\u044F\u0442\u0430 \u0441\u0442\u0430\u0432\u043A\u0430'
});

var EVENT_FINISHED_HAS_NO_AUCTION_TICKET = exports.EVENT_FINISHED_HAS_NO_AUCTION_TICKET = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.rewards.tank_receiving.event_finished_has_no_auction_ticket',
    defaultMessage: '\u0412\u044B \u043D\u0435 \u0441\u043E\u0431\u0440\u0430\u043B\u0438 \u0432 \u041C\u0430\u0441\u0442\u0435\u0440\u0441\u043A\u043E\u0439 \u0434\u043E\u043F\u0443\u0441\u043A \u043D\u0430 \u0430\u0443\u043A\u0446\u0438\u043E\u043D \u0442\u0435\u0445\u043D\u0438\u043A\u0438 \u0434\u043B\u044F \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u043F\u0440\u0438\u0437\u043E\u0432\u044B\u0445 \u043C\u0430\u0448\u0438\u043D \u0437\u0430 \u0431\u043E\u043D\u044B.',
    values: {
        access: _react2.default.createElement(
            'span',
            { className: _WGCWXRewards2.default.highlight },
            AUCTION_ACCESS
        )
    }
});

/***/ }),
/* 578 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"WGCWXRewards_base--20HDQ","hangar":"WGCWXRewards_hangar--3AO3B","container":"WGCWXRewards_container--1ZmAY","content":"WGCWXRewards_content--1KL5I","title":"WGCWXRewards_title--1cNlK","category":"WGCWXRewards_category--sE1Au","body":"WGCWXRewards_body--2zJTF","grid":"WGCWXRewards_grid--2i6TR","requirements":"WGCWXRewards_requirements--2Y2Hv","highlight":"WGCWXRewards_highlight--1ZQgh","highlight__red":"WGCWXRewards_highlight__red--2aieR","highlightRed":"WGCWXRewards_highlight__red--2aieR"};

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.VEHICLE_TO_COMPARE_TOOLTIP = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VEHICLE_TO_COMPARE_TOOLTIP = exports.VEHICLE_TO_COMPARE_TOOLTIP = {
    id: 'vehicle_add_to_compare.tooltip.id',
    message: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'vehicle_add_to_compare.tooltip.message',
        defaultMessage: '\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043A \u0441\u0440\u0430\u0432\u043D\u0435\u043D\u0438\u044E'
    })
};

/***/ }),
/* 580 */,
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var GA_LABEL = exports.GA_LABEL = {
    FROM_CLAN_LANDING_SCREEN: 'Clan page click',
    FROM_STRONGHOLD_SCREEN: 'Panel click',
    FROM_INGAME_SHOP_BANNER: 'Banner click',
    PACKAGE_S: 'Click package_s',
    PACKAGE_M: 'Click package_m',
    PACKAGE_L: 'Click package_l',
    PACKAGE_XL: 'Click package_xl',
    CLOSE_CLICK: 'Click bundle close',
    BUY: 'Click buy',
    BACK_CLICK: 'Click back_l',
    CANNOT_BUY_CLICK: 'Click close',
    CONGRATULATION_CLOSE_CLICK: 'Click close',
    MAX_PRODUCTS_LIMIT: 'Forbidden to buy more offers',
    NO_MONEY: 'Not enough money to buy offer',
    JOIN_AFTER_ACTION_START: 'Was already in a clan'
};

var GA_ACTIONS = exports.GA_ACTIONS = {
    TO_STOREFRONT: 'Come to offer page',
    STOREFRONT: 'Offer page',
    PREVIEW: 'Preview page',
    CONGRATULATION: 'Congratulation window'
};

var trackEvent = exports.trackEvent = function trackEvent(eventAction, eventLabel) {
    window.dataLayer.push({
        event: 'GAevent',
        eventCategory: 'Clan offers promresource',
        eventAction: eventAction,
        eventLabel: eventLabel,
        realm: window.config.REALM,
        role: window.__WGSH_GA_ROLE__
    });
};

/***/ }),
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */,
/* 1233 */,
/* 1234 */,
/* 1235 */,
/* 1236 */,
/* 1237 */,
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */,
/* 1244 */,
/* 1245 */,
/* 1246 */,
/* 1247 */,
/* 1248 */,
/* 1249 */,
/* 1250 */,
/* 1251 */,
/* 1252 */,
/* 1253 */,
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */,
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */,
/* 1277 */,
/* 1278 */,
/* 1279 */,
/* 1280 */,
/* 1281 */,
/* 1282 */,
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.nameShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  leaveActive: _propTypes2.default.string,
  appear: _propTypes2.default.string,
  appearActive: _propTypes2.default.string
})]);

/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FirstChild = function FirstChild(props) {
    var childrenArray = _react2.default.Children.toArray(props.children);
    return childrenArray[0] || null;
};

exports.default = FirstChild;

/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ModernizationOverlay = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _Back = __webpack_require__(70);

var _Back2 = _interopRequireDefault(_Back);

var _constants = __webpack_require__(4);

var _ModernizationOverlay = __webpack_require__(2086);

var _ModernizationOverlay2 = _interopRequireDefault(_ModernizationOverlay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ModernizationOverlay = exports.ModernizationOverlay = function (_React$Component) {
    _inherits(ModernizationOverlay, _React$Component);

    function ModernizationOverlay(props) {
        _classCallCheck(this, ModernizationOverlay);

        var _this = _possibleConstructorReturn(this, (ModernizationOverlay.__proto__ || Object.getPrototypeOf(ModernizationOverlay)).call(this, props));

        _this.state = {
            opened: false
        };
        _this.onKeyUp = _this.onKeyUp.bind(_this);
        return _this;
    }

    _createClass(ModernizationOverlay, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            window.addEventListener('keydown', this.onKeyUp);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('keydown', this.onKeyUp);
        }
    }, {
        key: 'onKeyUp',
        value: function onKeyUp(e) {
            if (e.keyCode === _constants.KEY_CODES.ESCAPE && this.state.opened) {
                this.hide();
            }
        }
    }, {
        key: 'show',
        value: function show() {
            this.setState({
                opened: true
            });
        }
    }, {
        key: 'hide',
        value: function hide() {
            this.setState({
                opened: false
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var handleClose = this.hide.bind(this);

            var className = (0, _classnames2.default)(_ModernizationOverlay2.default.base, _defineProperty({}, _ModernizationOverlay2.default.base__opened, this.state.opened));

            return _react2.default.createElement(
                'div',
                { className: className },
                _react2.default.createElement(
                    'div',
                    { className: _ModernizationOverlay2.default.back },
                    _react2.default.createElement(_Back2.default, { handleClick: handleClose })
                ),
                _react2.default.createElement(
                    'div',
                    { className: _ModernizationOverlay2.default.content },
                    this.props.children
                )
            );
        }
    }]);

    return ModernizationOverlay;
}(_react2.default.Component);

ModernizationOverlay.propTypes = {
    children: _propTypes2.default.object
};
exports.default = ModernizationOverlay;

/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UpgradeEffect = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactWotBootstrap = __webpack_require__(5);

var _constants = __webpack_require__(2087);

var _UpgradeEffect = __webpack_require__(2088);

var _UpgradeEffect2 = _interopRequireDefault(_UpgradeEffect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var UpgradeEffect = exports.UpgradeEffect = function UpgradeEffect(props) {
    var _classNames;

    var tooltip = void 0;
    // if same tooltip already exists - skip
    var sameTooltipExists = _reactWotBootstrap.Tooltip.manager.tooltips.has(_constants.UPGRADE_EFFECT_TOOLTIP_ID);
    if (!sameTooltipExists) {
        tooltip = _react2.default.createElement(
            _reactWotBootstrap.Tooltip,
            { id: _constants.UPGRADE_EFFECT_TOOLTIP_ID },
            _react2.default.createElement(
                'div',
                { className: _UpgradeEffect2.default.tooltipContent },
                _react2.default.createElement(
                    'h3',
                    { className: _UpgradeEffect2.default.tooltipSubtitle },
                    _constants.MODERNIZATION_BUTTON_TITLE
                ),
                _react2.default.createElement(
                    'p',
                    { className: _UpgradeEffect2.default.tooltipMessage },
                    _constants.TOOLTIP_BODY
                )
            )
        );
    }

    var className = (0, _classnames2.default)(_UpgradeEffect2.default.base, (_classNames = {}, _defineProperty(_classNames, _UpgradeEffect2.default.base__underCost, props.hasPermission && !props.topLevel || props.fade), _defineProperty(_classNames, _UpgradeEffect2.default.base__fade, props.fade), _classNames));

    return _react2.default.createElement(
        'div',
        { className: className },
        _react2.default.createElement(
            'div',
            { className: _UpgradeEffect2.default.holder, 'data-tip': true, 'data-for': _constants.UPGRADE_EFFECT_TOOLTIP_ID },
            _react2.default.createElement(
                'div',
                {
                    className: _UpgradeEffect2.default.inner,
                    onClick: props.handleClick,
                    onMouseEnter: props.handleHover
                },
                _react2.default.createElement('span', { className: _UpgradeEffect2.default.info }),
                _react2.default.createElement(
                    'span',
                    { className: _UpgradeEffect2.default.title },
                    _constants.MODERNIZATION_BUTTON_TITLE
                )
            )
        ),
        tooltip
    );
};

UpgradeEffect.propTypes = {
    handleClick: _propTypes2.default.func,
    handleHover: _propTypes2.default.func,
    hasPermission: _propTypes2.default.bool.isRequired,
    fade: _propTypes2.default.bool.isRequired,
    topLevel: _propTypes2.default.bool
};

exports.default = UpgradeEffect;

/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Confirmation = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(7);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(4);

var _reactWotBootstrap = __webpack_require__(5);

var _sounds = __webpack_require__(22);

var _Confirmation = __webpack_require__(2091);

var _Confirmation2 = _interopRequireDefault(_Confirmation);

var _constants2 = __webpack_require__(2092);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Confirmation = exports.Confirmation = function (_React$Component) {
    _inherits(Confirmation, _React$Component);

    function Confirmation() {
        _classCallCheck(this, Confirmation);

        var _this = _possibleConstructorReturn(this, (Confirmation.__proto__ || Object.getPrototypeOf(Confirmation)).call(this));

        _this.onKeyUp = _this.onKeyUp.bind(_this);
        _this.handleCloseClick = _this.handleCloseClick.bind(_this);
        _this.handleCloseHover = _this.handleCloseHover.bind(_this);
        return _this;
    }

    _createClass(Confirmation, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            window.addEventListener('keydown', this.onKeyUp);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('keydown', this.onKeyUp);
        }
    }, {
        key: 'onKeyUp',
        value: function onKeyUp(e) {
            if (this.props.opened) {
                if (e.keyCode === _constants.KEY_CODES.ESCAPE) {
                    this.props.onClose();
                }
                if (e.keyCode === _constants.KEY_CODES.ENTER) {
                    this.props.onSubmit();
                }
            }
        }
    }, {
        key: 'handleCloseClick',
        value: function handleCloseClick() {
            this.props.playCancelClickSound();
            this.props.onClose();
        }
    }, {
        key: 'handleCloseHover',
        value: function handleCloseHover() {
            this.props.playHoverSound();
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames;

            var _props = this.props,
                opened = _props.opened,
                onSubmit = _props.onSubmit,
                onClose = _props.onClose,
                title = _props.title,
                submitCaption = _props.submitCaption;

            var className = (0, _classnames2.default)(_Confirmation2.default.base, (_classNames = {}, _defineProperty(_classNames, _Confirmation2.default.base__opened, opened), _defineProperty(_classNames, _Confirmation2.default.base__closed, !opened), _classNames));

            return _react2.default.createElement(
                'div',
                { className: className },
                _react2.default.createElement('div', { className: _Confirmation2.default.overlay }),
                _react2.default.createElement(
                    'div',
                    { className: _Confirmation2.default.wrapper },
                    _react2.default.createElement(
                        'div',
                        { className: _Confirmation2.default.body },
                        _react2.default.createElement('div', { className: _Confirmation2.default.background }),
                        _react2.default.createElement(
                            'header',
                            { className: _Confirmation2.default.header },
                            _react2.default.createElement(
                                'p',
                                { className: _Confirmation2.default.title },
                                title
                            ),
                            _react2.default.createElement('button', {
                                className: _Confirmation2.default.close,
                                onClick: this.handleCloseClick,
                                onMouseEnter: this.handleCloseHover
                            })
                        ),
                        _react2.default.createElement(
                            'main',
                            { className: _Confirmation2.default.content },
                            this.props.children
                        ),
                        _react2.default.createElement(
                            'footer',
                            { className: _Confirmation2.default.footer },
                            _react2.default.createElement(
                                'div',
                                { className: _Confirmation2.default.button },
                                _react2.default.createElement(
                                    _reactWotBootstrap.ButtonSmall,
                                    { onClick: onSubmit },
                                    submitCaption
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _Confirmation2.default.button },
                                _react2.default.createElement(
                                    _reactWotBootstrap.ButtonSmall,
                                    {
                                        onClick: onClose,
                                        type: 'secondary',
                                        isCancel: true
                                    },
                                    this.props.closeCaption
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return Confirmation;
}(_react2.default.Component);

Confirmation.propTypes = {
    title: _propTypes2.default.node.isRequired,
    opened: _propTypes2.default.bool.isRequired,
    submitCaption: _propTypes2.default.node.isRequired,
    closeCaption: _propTypes2.default.node,
    onSubmit: _propTypes2.default.func.isRequired,
    onClose: _propTypes2.default.func.isRequired,
    playCancelClickSound: _propTypes2.default.func.isRequired,
    playHoverSound: _propTypes2.default.func.isRequired
};
Confirmation.defaultProps = {
    closeCaption: _constants2.CLOSE_BUTTON_CAPTION
};


var mapDispatchToProps = { playCancelClickSound: _sounds.playCancelClickSound, playHoverSound: _sounds.playHoverSound };

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(Confirmation);

/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _helpers = __webpack_require__(11);

var _IndustrialResource = __webpack_require__(35);

var _IndustrialResource2 = _interopRequireDefault(_IndustrialResource);

var _constants = __webpack_require__(2095);

var _BuildingCardImage = __webpack_require__(2096);

var _BuildingCardImage2 = _interopRequireDefault(_BuildingCardImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BuildingCardImage = function (_React$Component) {
    _inherits(BuildingCardImage, _React$Component);

    function BuildingCardImage() {
        _classCallCheck(this, BuildingCardImage);

        return _possibleConstructorReturn(this, (BuildingCardImage.__proto__ || Object.getPrototypeOf(BuildingCardImage)).apply(this, arguments));
    }

    _createClass(BuildingCardImage, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                buildingLevel = _props.buildingLevel,
                buildingType = _props.buildingType,
                isUpgradeAvailable = _props.isUpgradeAvailable,
                showUpgrade = _props.showUpgrade,
                upgradeCost = _props.upgradeCost,
                hasEnoughIndustrialResource = _props.hasEnoughIndustrialResource,
                hasEnoughBuildingLevelSumm = _props.hasEnoughBuildingLevelSumm,
                isMaxCommandCenter = _props.isMaxCommandCenter;


            var upgradeLayout = void 0;
            if (showUpgrade) {
                var arrowLayers = Array.from({ length: _constants.ARROW_LAYERS_COUNT }, function (item, index) {
                    var layerClass = (0, _classnames2.default)(_BuildingCardImage2.default.arrowLayer, _BuildingCardImage2.default['arrowLayer__' + index]);
                    return _react2.default.createElement('div', { className: layerClass, key: 'arrowLayer_' + index });
                });

                var notEnoughIndustrialResource = !hasEnoughIndustrialResource && !(hasEnoughBuildingLevelSumm === false);

                var upgradeCostClass = (0, _classnames2.default)(_BuildingCardImage2.default.cost, _defineProperty({}, _BuildingCardImage2.default.cost__notEnough, notEnoughIndustrialResource));

                var upgradeArrow = void 0;
                if (hasEnoughIndustrialResource && isUpgradeAvailable) {
                    upgradeArrow = _react2.default.createElement(
                        'div',
                        { className: _BuildingCardImage2.default.arrow },
                        arrowLayers
                    );
                }

                var handleClick = isUpgradeAvailable ? this.props.onClick : null;
                var onMouseEnter = isUpgradeAvailable ? this.props.onMouseEnter : null;
                var onMouseLeave = isUpgradeAvailable ? this.props.onMouseLeave : null;

                var tooltipProps = this.props.tooltipId ? {
                    'data-tip': true,
                    'data-for': this.props.tooltipId
                } : null;

                var innerProps = {
                    onClick: handleClick,
                    onMouseEnter: onMouseEnter,
                    onMouseLeave: onMouseLeave
                };

                var upgradeCostProps = void 0;

                if (isUpgradeAvailable) {
                    innerProps = _extends({}, innerProps, tooltipProps);
                } else {
                    upgradeCostProps = _extends({}, tooltipProps);
                }

                upgradeLayout = _react2.default.createElement(
                    'div',
                    _extends({ className: _BuildingCardImage2.default.upgradeLayout }, innerProps),
                    _react2.default.createElement('div', { className: _BuildingCardImage2.default.clickArea }),
                    _react2.default.createElement(
                        'div',
                        _extends({ className: upgradeCostClass }, upgradeCostProps),
                        _react2.default.createElement(
                            'div',
                            { className: _BuildingCardImage2.default.label },
                            _constants.UPGRADE_COST_LABEL
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _BuildingCardImage2.default.industrialResource },
                            _react2.default.createElement(_IndustrialResource2.default, {
                                value: upgradeCost,
                                notEnough: notEnoughIndustrialResource
                            })
                        )
                    ),
                    upgradeArrow
                );
            }

            var className = (0, _classnames2.default)(_BuildingCardImage2.default.base, _defineProperty({}, _BuildingCardImage2.default.base__upgradeDisabled, !isUpgradeAvailable || !showUpgrade));

            var imageClassName = !isMaxCommandCenter ? (0, _classnames2.default)(_BuildingCardImage2.default.image, _BuildingCardImage2.default['image__' + (0, _helpers.toCssClass)(buildingType)], _BuildingCardImage2.default['image__level-' + buildingLevel]) : (0, _classnames2.default)(_BuildingCardImage2.default.image, _BuildingCardImage2.default['image__max-command-center']);

            return _react2.default.createElement(
                'div',
                { className: className },
                _react2.default.createElement('div', { className: imageClassName }),
                upgradeLayout
            );
        }
    }]);

    return BuildingCardImage;
}(_react2.default.Component);

BuildingCardImage.propTypes = {
    buildingType: _propTypes2.default.string.isRequired,
    buildingLevel: _propTypes2.default.number.isRequired,
    hasEnoughIndustrialResource: _propTypes2.default.bool.isRequired,
    hasEnoughBuildingLevelSumm: _propTypes2.default.bool,
    upgradeCost: _propTypes2.default.number,
    tooltipId: _propTypes2.default.string,
    isUpgradeAvailable: _propTypes2.default.bool.isRequired,
    showUpgrade: _propTypes2.default.bool.isRequired,
    isMaxCommandCenter: _propTypes2.default.bool,

    onMouseEnter: _propTypes2.default.func.isRequired,
    onMouseLeave: _propTypes2.default.func.isRequired,
    onClick: _propTypes2.default.func.isRequired
};
exports.default = BuildingCardImage;

/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactWotBootstrap = __webpack_require__(5);

var _datetime = __webpack_require__(13);

var _i18n = __webpack_require__(10);

var _constants = __webpack_require__(2100);

var _ProductionProgress = __webpack_require__(2101);

var _ProductionProgress2 = _interopRequireDefault(_ProductionProgress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProductionProgress = function (_React$Component) {
    _inherits(ProductionProgress, _React$Component);

    function ProductionProgress(props) {
        _classCallCheck(this, ProductionProgress);

        var _this = _possibleConstructorReturn(this, (ProductionProgress.__proto__ || Object.getPrototypeOf(ProductionProgress)).call(this, props));

        _this.handleHover = _this.handleHover.bind(_this);
        return _this;
    }

    _createClass(ProductionProgress, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.refreshQueue(nextProps.reserveQueue);
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.refreshQueue(this.props.reserveQueue);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.clearTimeouts();
        }
    }, {
        key: 'handleHover',
        value: function handleHover() {
            this.props.playHoverSound();
        }
    }, {
        key: 'refreshQueue',
        value: function refreshQueue(queue) {
            this.clearTimeouts();

            var actualQueue = queue.filter(function (reserve) {
                return reserve.productionEnds > Date.now();
            });

            if (actualQueue.length === 0) {
                this.setState({
                    actualQueue: actualQueue
                });
                return;
            }

            var _actualQueue = _toArray(actualQueue),
                currentReserve = _actualQueue[0],
                rest = _actualQueue.slice(1);

            this.timerId = setTimeout(this.refreshQueue.bind(this, rest), currentReserve.productionEnds - Date.now());
            this.intervalId = setInterval(this.forceUpdate.bind(this), 1000);

            this.setState({
                actualQueue: actualQueue,
                productionTime: currentReserve.production_time * 1000,
                productionEnds: currentReserve.productionEnds,
                allProductionsEnd: actualQueue[actualQueue.length - 1].productionEnds
            });
        }
    }, {
        key: 'clearTimeouts',
        value: function clearTimeouts() {
            if (this.intervalId) clearInterval(this.intervalId);
            if (this.timerId) clearTimeout(this.timerId);
        }
    }, {
        key: 'isDelayed',
        value: function isDelayed() {
            return this.state.productionEnds - Date.now() > this.state.productionTime;
        }
    }, {
        key: 'getAvailabilityPercentage',
        value: function getAvailabilityPercentage() {
            if (this.isDelayed()) {
                return 0;
            }

            var percentage = 100 - (this.state.productionEnds - Date.now() - 1000) / this.state.productionTime * 100;

            return percentage <= 100 ? percentage : 100;
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.state.actualQueue.length === 0) {
                return null;
            }

            var cancelButton = void 0;
            var cancelButtonTooltip = void 0;
            if (this.props.hasPermission && !this.props.simplified) {
                cancelButton = _react2.default.createElement('div', {
                    onClick: this.props.onCancel,
                    onMouseEnter: this.handleHover,
                    className: _ProductionProgress2.default.cancel,
                    'data-tip': true,
                    'data-for': _constants.CANCEL_TOOLTIP_ID
                });

                cancelButtonTooltip = _react2.default.createElement(
                    _reactWotBootstrap.Tooltip,
                    { id: _constants.CANCEL_TOOLTIP_ID },
                    _react2.default.createElement(
                        'div',
                        { className: _ProductionProgress2.default.tooltipContent },
                        _react2.default.createElement(
                            'h3',
                            { className: _ProductionProgress2.default.tooltipSubtitle },
                            _i18n.CANCEL
                        ),
                        _react2.default.createElement(
                            'p',
                            { className: _ProductionProgress2.default.tooltipMessage },
                            _constants.CANCEL_TOOLTIP_CONTENT
                        )
                    )
                );
            }

            var title = void 0;
            if (!this.props.simplified) {
                if (this.props.hasPermission) {
                    title = _react2.default.createElement(
                        'h3',
                        { className: _ProductionProgress2.default.title },
                        _constants.ADD_RESERVE_TO_QUEUE_TITLE
                    );
                }
            }

            var componentBody = _react2.default.createElement(
                'div',
                { className: _ProductionProgress2.default.grid },
                _react2.default.createElement(
                    'div',
                    { className: _ProductionProgress2.default.progress },
                    _react2.default.createElement(
                        'div',
                        { className: _ProductionProgress2.default.holder },
                        _react2.default.createElement(
                            'div',
                            { className: _ProductionProgress2.default.wrapper },
                            _react2.default.createElement('div', {
                                className: _ProductionProgress2.default.bar,
                                style: { width: this.getAvailabilityPercentage() + '%' }
                            })
                        )
                    ),
                    !this.props.simplified ? _react2.default.createElement(
                        'span',
                        { className: _ProductionProgress2.default.timeLeft },
                        this.isDelayed() ? (0, _datetime.getFormattedTime)(this.state.productionTime, true) : (0, _datetime.getFormattedTime)(this.state.productionEnds - Date.now(), true)
                    ) : null
                ),
                _react2.default.createElement(
                    'div',
                    { className: _ProductionProgress2.default.controls },
                    _react2.default.createElement(
                        'div',
                        { className: _ProductionProgress2.default.multiplier },
                        '\xD7 ' + this.state.actualQueue.length
                    ),
                    cancelButton
                )
            );

            var className = (0, _classnames2.default)(_ProductionProgress2.default.base, _defineProperty({}, _ProductionProgress2.default.base__simplified, this.props.simplified));

            return _react2.default.createElement(
                'div',
                { className: className },
                componentBody,
                cancelButtonTooltip,
                title
            );
        }
    }]);

    return ProductionProgress;
}(_react2.default.Component);

ProductionProgress.propTypes = {
    hasPermission: _propTypes2.default.bool.isRequired,
    reserveQueue: _propTypes2.default.arrayOf(_propTypes2.default.object),
    onCancel: _propTypes2.default.func,
    playHoverSound: _propTypes2.default.func,
    simplified: _propTypes2.default.bool
};
ProductionProgress.defaultProps = {
    reserveQueue: [],
    simplified: false,
    hasPermission: false
};
exports.default = ProductionProgress;

/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UpgradeConfirmationView = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactWotBootstrap = __webpack_require__(5);

var _IndustrialResource = __webpack_require__(35);

var _IndustrialResource2 = _interopRequireDefault(_IndustrialResource);

var _helpers = __webpack_require__(11);

var _constants = __webpack_require__(4);

var _i18n = __webpack_require__(10);

var _constants2 = __webpack_require__(2108);

var _UpgradeConfirmationView = __webpack_require__(2109);

var _UpgradeConfirmationView2 = _interopRequireDefault(_UpgradeConfirmationView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UpgradeConfirmationView = exports.UpgradeConfirmationView = function (_React$Component) {
    _inherits(UpgradeConfirmationView, _React$Component);

    function UpgradeConfirmationView() {
        _classCallCheck(this, UpgradeConfirmationView);

        var _this = _possibleConstructorReturn(this, (UpgradeConfirmationView.__proto__ || Object.getPrototypeOf(UpgradeConfirmationView)).call(this));

        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.handleCancel = _this.handleCancel.bind(_this);
        _this.onKeyUp = _this.onKeyUp.bind(_this);
        return _this;
    }

    _createClass(UpgradeConfirmationView, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            window.addEventListener('keydown', this.onKeyUp);

            // this component do the animation and during the animation
            // props might have been changed and incorrect level will be shown
            this.setState({
                levelBeforeUpgrade: this.props.level,
                upgradeCostBeforeUpgrade: this.props.upgradeCost
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('keydown', this.onKeyUp);
        }
    }, {
        key: 'onKeyUp',
        value: function onKeyUp(e) {
            if (e.keyCode === _constants.KEY_CODES.ESCAPE) {
                this.handleCancel();
            }
            if (e.keyCode === _constants.KEY_CODES.ENTER) {
                this.handleSubmit();
            }
        }
    }, {
        key: 'handleSubmit',
        value: function handleSubmit() {
            this.props.submitHandler();
        }
    }, {
        key: 'handleCancel',
        value: function handleCancel() {
            this.props.cancelHandler();
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                type = _props.type,
                name = _props.name,
                level = _props.level;

            var nextLevel = this.state.levelBeforeUpgrade + 1;

            var radianceLayers = Array.from({ length: _constants2.RADIANCE_LAYERS_COUNT }, function (item, index) {
                var layerClass = (0, _classnames2.default)(_UpgradeConfirmationView2.default.radianceLayer, _UpgradeConfirmationView2.default['radianceLayer__' + index]);
                return _react2.default.createElement('div', { className: layerClass, key: 'radianceLayer_' + index });
            });

            var levelComponent = _react2.default.createElement(
                'span',
                { className: _UpgradeConfirmationView2.default.level },
                (0, _helpers.toRoman)(nextLevel),
                _react2.default.createElement(
                    'span',
                    { className: _UpgradeConfirmationView2.default.levelGradient },
                    (0, _helpers.toRoman)(nextLevel)
                )
            );

            var levelSubstringComponent = _react2.default.createElement(
                'span',
                { className: _UpgradeConfirmationView2.default.levelSubstring },
                _constants2.UPGRADE_CONFIRMATION_LEVEL,
                _react2.default.createElement(
                    'span',
                    { className: _UpgradeConfirmationView2.default.levelSubstringGradient },
                    _constants2.UPGRADE_CONFIRMATION_LEVEL
                )
            );

            var inlineNameComponent = _react2.default.createElement(
                'span',
                { className: _UpgradeConfirmationView2.default.inlineName },
                name
            );

            var inlineLevelComponent = _react2.default.createElement(
                'span',
                { className: _UpgradeConfirmationView2.default.inlineLevel },
                (0, _helpers.toRoman)(nextLevel),
                _react2.default.createElement(
                    'span',
                    { className: _UpgradeConfirmationView2.default.inlineLevelGradient },
                    (0, _helpers.toRoman)(nextLevel)
                )
            );

            var imageLevel = this.props.upgraded ? nextLevel : level;
            var imageClassName = (0, _classnames2.default)(_UpgradeConfirmationView2.default.image, _UpgradeConfirmationView2.default['image__' + (0, _helpers.toCssClass)(type)], _UpgradeConfirmationView2.default['image__level-' + imageLevel]);

            var className = (0, _classnames2.default)(_UpgradeConfirmationView2.default.base, _defineProperty({}, _UpgradeConfirmationView2.default.base__animateUpgrading, this.props.upgraded));

            return _react2.default.createElement(
                'div',
                { className: className },
                _react2.default.createElement(
                    'div',
                    { className: _UpgradeConfirmationView2.default.building },
                    _react2.default.createElement('div', { className: imageClassName }),
                    _react2.default.createElement(
                        'div',
                        { className: _UpgradeConfirmationView2.default.levelHolder },
                        levelComponent,
                        levelSubstringComponent
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _UpgradeConfirmationView2.default.radiance },
                        radianceLayers
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _UpgradeConfirmationView2.default.footer },
                    _react2.default.createElement(
                        'p',
                        { className: _UpgradeConfirmationView2.default.message },
                        (0, _constants2.UPGRADE_CONFIRMATION_MESSAGE)(inlineNameComponent, inlineLevelComponent, _react2.default.createElement(_IndustrialResource2.default, { value: this.state.upgradeCostBeforeUpgrade, small: true }))
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _UpgradeConfirmationView2.default.button },
                        _react2.default.createElement(
                            _reactWotBootstrap.ButtonSmall,
                            { onClick: this.handleSubmit },
                            _constants2.UPGRADE_CONFIRMATION_SUBMIT
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _UpgradeConfirmationView2.default.button },
                        _react2.default.createElement(
                            _reactWotBootstrap.ButtonSmall,
                            {
                                onClick: this.handleCancel,
                                type: 'secondary',
                                isCancel: true
                            },
                            _i18n.CANCEL
                        )
                    )
                )
            );
        }
    }]);

    return UpgradeConfirmationView;
}(_react2.default.Component);

UpgradeConfirmationView.propTypes = {
    type: _propTypes2.default.string.isRequired,
    name: _propTypes2.default.node.isRequired,
    level: _propTypes2.default.number.isRequired,
    upgraded: _propTypes2.default.bool.isRequired,
    upgradeCost: _propTypes2.default.number.isRequired,
    submitHandler: _propTypes2.default.func.isRequired,
    cancelHandler: _propTypes2.default.func.isRequired
};
exports.default = UpgradeConfirmationView;

/***/ }),
/* 1331 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"BaseBonusInfoTable_base--38lIB","body":"BaseBonusInfoTable_body--2sm4z","wrapper":"BaseBonusInfoTable_wrapper--VgXhW","background":"BaseBonusInfoTable_background--T5aBv","content":"BaseBonusInfoTable_content--2HuQz","title":"BaseBonusInfoTable_title--9nWT4","message":"BaseBonusInfoTable_message--3oYHf","divider":"BaseBonusInfoTable_divider--1nTbb","highlight":"BaseBonusInfoTable_highlight--1uODo","ribbon":"BaseBonusInfoTable_ribbon--fVaDO","table":"BaseBonusInfoTable_table--3ZR8y","thead":"BaseBonusInfoTable_thead--1328I","tbody":"BaseBonusInfoTable_tbody--1gxEJ","tr":"BaseBonusInfoTable_tr--1Rsu6","tr__selected":"BaseBonusInfoTable_tr__selected--1nyjY","trSelected":"BaseBonusInfoTable_tr__selected--1nyjY","tr__clickable":"BaseBonusInfoTable_tr__clickable--3eQ7Q","trClickable":"BaseBonusInfoTable_tr__clickable--3eQ7Q","tr__hoverable":"BaseBonusInfoTable_tr__hoverable--3TWIW","trHoverable":"BaseBonusInfoTable_tr__hoverable--3TWIW","th":"BaseBonusInfoTable_th--4d1ge","td":"BaseBonusInfoTable_td--36E9i","th__basis":"BaseBonusInfoTable_th__basis--3_5EP","thBasis":"BaseBonusInfoTable_th__basis--3_5EP","td__basis":"BaseBonusInfoTable_td__basis--2rRE7","tdBasis":"BaseBonusInfoTable_td__basis--2rRE7","th__left":"BaseBonusInfoTable_th__left--SQJr0","thLeft":"BaseBonusInfoTable_th__left--SQJr0","td__left":"BaseBonusInfoTable_td__left--3oBKS","tdLeft":"BaseBonusInfoTable_td__left--3oBKS","th__center":"BaseBonusInfoTable_th__center--3iEuU","thCenter":"BaseBonusInfoTable_th__center--3iEuU","td__center":"BaseBonusInfoTable_td__center--w-hNt","tdCenter":"BaseBonusInfoTable_td__center--w-hNt","th__right":"BaseBonusInfoTable_th__right--1JElf","thRight":"BaseBonusInfoTable_th__right--1JElf","td__right":"BaseBonusInfoTable_td__right--1gDfj","tdRight":"BaseBonusInfoTable_td__right--1gDfj","th__top":"BaseBonusInfoTable_th__top--2Dbum","thTop":"BaseBonusInfoTable_th__top--2Dbum","td__top":"BaseBonusInfoTable_td__top--1ogQT","tdTop":"BaseBonusInfoTable_td__top--1ogQT","td__span4":"BaseBonusInfoTable_td__span4--2RF9u","tdSpan4":"BaseBonusInfoTable_td__span4--2RF9u","base__debug":"BaseBonusInfoTable_base__debug--1wMf1","baseDebug":"BaseBonusInfoTable_base__debug--1wMf1","spacer":"BaseBonusInfoTable_spacer--2DcQq","notice":"BaseBonusInfoTable_notice--EoFjC","tfoot":"BaseBonusInfoTable_tfoot--3_2o3","th__calculatedWidth":"BaseBonusInfoTable_th__calculatedWidth--3Hlz1","thCalculatedWidth":"BaseBonusInfoTable_th__calculatedWidth--3Hlz1","asterisk":"BaseBonusInfoTable_asterisk--1SJXj"};

/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getReserveTableColumns = exports.getBattleBonusesColumns = undefined;

var _i18n = __webpack_require__(10);

var _reserves = __webpack_require__(28);

var _datetime = __webpack_require__(13);

var _translations = __webpack_require__(384);

var _constants = __webpack_require__(4);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var getBattleBonusesColumns = exports.getBattleBonusesColumns = function getBattleBonusesColumns(bonus, bonusType) {
    var battleBonusesColumns = Object.keys(bonus.battle_types).sort(_reserves.sortReserveBattleTypes).map(function (battleType) {
        return {
            title: bonusType === _constants.BONUS_TYPES.EXTRA_CREDITS && battleType === _constants.BATTLE_TYPES.RANDOM_BATTLES ? _i18n.BATTLE_TYPE_MESSAGES[_constants.BATTLE_TYPES.RANDOM_BATTLES_AND_STEEL_HUNTER] : _i18n.BATTLE_TYPE_MESSAGES[battleType],
            dataIndex: battleType
        };
    });

    var columns = [{
        title: (0, _translations.RESERVE_LEVEL)(),
        dataIndex: 'level',
        align: 'left',
        isCalculatedWidth: true
    }].concat(_toConsumableArray(battleBonusesColumns));

    if (bonus.duration) {
        columns.push({
            title: _i18n.DURATION,
            dataIndex: 'duration',
            render: function render(value) {
                return (0, _datetime.getHoursFormat)(value / 3600);
            }
        });
    }

    return columns;
};

var getInspirationReserveColumns = function getInspirationReserveColumns() {
    return [{
        title: (0, _translations.RESERVE_LEVEL)(),
        dataIndex: 'level',
        align: 'left',
        isCalculatedWidth: true
    }, {
        title: _translations.RESERVES_PARAMETERS_CAPTIONS[_constants.RESERVE_PARAMETERS_TYPES.CREW_ROLES_FACTOR],
        dataIndex: _constants.RESERVE_PARAMETERS_TYPES.CREW_ROLES_FACTOR,
        render: function render(value) {
            return value.replace('+', '');
        }
    }, {
        title: _translations.RESERVES_PARAMETERS_CAPTIONS[_constants.RESERVE_PARAMETERS_TYPES.COMMON_AREA_RADIUS],
        dataIndex: _constants.RESERVE_PARAMETERS_TYPES.COMMON_AREA_RADIUS,
        render: function render(value) {
            return (0, _i18n.METERS_VALUE)(value);
        }
    }, {
        title: (0, _translations.ADDITIONAL_INDUSTRIAL_RESOURCE)(),
        dataIndex: _constants.BATTLE_TYPES.BATTLE_FOR_STRONGHOLD_AND_SORTIE
    }];
};

var getArtilleryStrikeReserveColumns = function getArtilleryStrikeReserveColumns() {
    return [{
        title: (0, _translations.RESERVE_LEVEL)(true),
        dataIndex: 'level',
        align: 'left',
        isCalculatedWidth: true
    }, {
        title: _translations.RESERVES_PARAMETERS_CAPTIONS[_constants.RESERVE_PARAMETERS_TYPES.MAX_DAMAGE],
        dataIndex: _constants.RESERVE_PARAMETERS_TYPES.MAX_DAMAGE,
        isCalculatedWidth: true,
        render: function render(values) {
            return values.join(' / ');
        }
    }, {
        title: _translations.RESERVES_PARAMETERS_CAPTIONS[_constants.RESERVE_PARAMETERS_TYPES.AREA_RADIUS],
        dataIndex: _constants.RESERVE_PARAMETERS_TYPES.AREA_RADIUS,
        isCalculatedWidth: true,
        render: function render(value) {
            return (0, _i18n.METERS_VALUE)(value);
        }
    }, {
        title: (0, _translations.ADDITIONAL_INDUSTRIAL_RESOURCE)(true),
        isCalculatedWidth: true,
        dataIndex: _constants.BATTLE_TYPES.BATTLE_FOR_STRONGHOLD_AND_SORTIE
    }];
};

var getReserveTableColumns = exports.getReserveTableColumns = function getReserveTableColumns(reserveType, bonus, bonusType) {
    switch (reserveType) {
        case _constants.RESERVE_TYPES.INSPIRATION:
            return getInspirationReserveColumns();
        case _constants.RESERVE_TYPES.ARTILLERY_STRIKE:
            return getArtilleryStrikeReserveColumns();
        default:
            return getBattleBonusesColumns(bonus, bonusType);
    }
};

/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MODERNIZATION_OVERLAY_TITLE = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MODERNIZATION_OVERLAY_TITLE = exports.MODERNIZATION_OVERLAY_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'modernization_overlay.title',
    defaultMessage: '\u041E \u043C\u043E\u0434\u0435\u0440\u043D\u0438\u0437\u0430\u0446\u0438\u0438'
});

/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TutorialArrow = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(1335);

var _TutorialArrow = __webpack_require__(2125);

var _TutorialArrow2 = _interopRequireDefault(_TutorialArrow);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TutorialArrow = exports.TutorialArrow = function (_React$PureComponent) {
    _inherits(TutorialArrow, _React$PureComponent);

    function TutorialArrow() {
        _classCallCheck(this, TutorialArrow);

        return _possibleConstructorReturn(this, (TutorialArrow.__proto__ || Object.getPrototypeOf(TutorialArrow)).apply(this, arguments));
    }

    _createClass(TutorialArrow, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.onCancel) {
                document.addEventListener('click', this.props.onCancel);
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (prevProps.onCancel !== this.props.onCancel) {
                if (prevProps.onCancel) {
                    document.removeEventListener('click', prevProps.onCancel);
                }
                if (this.props.onCancel) {
                    document.addEventListener('click', this.props.onCancel);
                }
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.props.onCancel) {
                document.removeEventListener('click', this.props.onCancel);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                isHidden = _props.isHidden,
                arrowPosition = _props.arrowPosition,
                className = _props.className,
                classNames = _props.classNames;


            if (isHidden) {
                return null;
            }

            return _react2.default.createElement(
                'div',
                {
                    className: (0, _classnames2.default)(_TutorialArrow2.default.base, _TutorialArrow2.default['base__' + arrowPosition], className),
                    onClick: this.props.onClick
                },
                this.props.showBorder && _react2.default.createElement('div', { className: _TutorialArrow2.default.border }),
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)(_TutorialArrow2.default.hint, classNames.hint) },
                    _react2.default.createElement('div', { className: _TutorialArrow2.default.hintSubstrate }),
                    _react2.default.createElement('div', { className: _TutorialArrow2.default.hintArrow }),
                    _react2.default.createElement(
                        'div',
                        { className: _TutorialArrow2.default.hintText },
                        this.props.text
                    )
                )
            );
        }
    }]);

    return TutorialArrow;
}(_react2.default.PureComponent);

TutorialArrow.defaultProps = {
    arrowPosition: _constants.ArrowPosition.LEFT,
    showBorder: true,
    classNames: {}
};
TutorialArrow.propTypes = {
    text: _propTypes2.default.element.isRequired,
    onClick: _propTypes2.default.func,
    onCancel: _propTypes2.default.func,
    isHidden: _propTypes2.default.bool,
    showBorder: _propTypes2.default.bool,
    arrowPosition: _propTypes2.default.oneOf(Object.values(_constants.ArrowPosition)),
    className: _propTypes2.default.string,
    classNames: _propTypes2.default.shape({
        hint: _propTypes2.default.string
    })
};

/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var ArrowPosition = exports.ArrowPosition = {
    LEFT: 'left',
    RIGHT: 'right',
    TOP: 'top'
};

/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var MAX_BUILDINGS_COUNT = exports.MAX_BUILDINGS_COUNT = 9;

var CAROUSEL_ITEM_WIDTH = exports.CAROUSEL_ITEM_WIDTH = 280;

/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _helpers = __webpack_require__(11);

var _i18n = __webpack_require__(10);

var _ConstructBuilding = __webpack_require__(2157);

var _ConstructBuilding2 = _interopRequireDefault(_ConstructBuilding);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConstructBuilding = function ConstructBuilding(_ref) {
    var isActive = _ref.isActive,
        type = _ref.type;

    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_ConstructBuilding2.default.base, isActive && _ConstructBuilding2.default.base__active) },
        _react2.default.createElement(
            'p',
            { className: _ConstructBuilding2.default.caption },
            _i18n.BUILDING_TITLES[type]
        ),
        _react2.default.createElement(
            'div',
            { className: _ConstructBuilding2.default.thumbnail },
            _react2.default.createElement('div', { className: (0, _classnames2.default)(_ConstructBuilding2.default.image, _ConstructBuilding2.default['image__' + (0, _helpers.toCssClass)(type)]) }),
            _react2.default.createElement('span', { className: _ConstructBuilding2.default.shadow })
        )
    );
};
ConstructBuilding.propTypes = {
    type: _propTypes2.default.string.isRequired,
    isActive: _propTypes2.default.bool.isRequired
};

exports.default = ConstructBuilding;

/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = __webpack_require__(93);

var _reactWotBootstrap = __webpack_require__(5);

var _BaseBonusInfoTable = __webpack_require__(383);

var _BaseBonusInfoTable2 = _interopRequireDefault(_BaseBonusInfoTable);

var _columns = __webpack_require__(1332);

var _translations = __webpack_require__(384);

var _constants = __webpack_require__(2161);

var _ConstructReserveTooltip = __webpack_require__(2162);

var _ConstructReserveTooltip2 = _interopRequireDefault(_ConstructReserveTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConstructReserveTooltip = function ConstructReserveTooltip(_ref) {
    var bonus = _ref.bonus,
        reserveType = _ref.reserveType;

    var minBonus = bonus.values[0];

    var tableTitle = minBonus.duration ? _react2.default.createElement(
        'span',
        null,
        _constants.BONUS_TYPE_MESSAGES[bonus.type]
    ) : _react2.default.createElement(
        'span',
        null,
        _constants.HEADERS[reserveType] || _constants.HEADERS.SINGLE_USAGE
    );

    var tableColumns = (0, _columns.getReserveTableColumns)(reserveType, minBonus, bonus.type);

    return _react2.default.createElement(
        _reactWotBootstrap.Tooltip,
        { id: reserveType, isWide: true },
        _react2.default.createElement(_BaseBonusInfoTable2.default, {
            className: (0, _classnames2.default)(_ConstructReserveTooltip2.default.infoTable, _ConstructReserveTooltip2.default['infoTable__' + (0, _lodash.camelCase)(reserveType)]),
            key: reserveType,
            title: tableTitle,
            notice: _constants.EXTRA_DESCRIPTIONS[reserveType],
            footer: _translations.FOOTER_RESERVES_NOTES[reserveType],
            dataSource: bonus.values,
            columns: tableColumns
        })
    );
};

ConstructReserveTooltip.propTypes = {
    reserveType: _propTypes2.default.string.isRequired,
    bonus: _propTypes2.default.object.isRequired
};

exports.default = ConstructReserveTooltip;

/***/ }),
/* 1339 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"ConstructReserve_base--1N0zV","name":"ConstructReserve_name--25OY5","description":"ConstructReserve_description--3QYlL","info":"ConstructReserve_info--PATiC","bonuses":"ConstructReserve_bonuses--Hq9_d","bonus":"ConstructReserve_bonus--3CaKV","value":"ConstructReserve_value--2rTcx","rate":"ConstructReserve_rate--X_n0F","rate__prefix":"ConstructReserve_rate__prefix--13E-n","ratePrefix":"ConstructReserve_rate__prefix--13E-n","rate__sign":"ConstructReserve_rate__sign--2s-Ah","rateSign":"ConstructReserve_rate__sign--2s-Ah","rate__value":"ConstructReserve_rate__value--2d-jZ","rateValue":"ConstructReserve_rate__value--2d-jZ","condition":"ConstructReserve_condition--ZRU0Q","target":"ConstructReserve_target--2vRMD","where":"ConstructReserve_where--Uwh2M","image":"ConstructReserve_image---RCNv","base__artillery-strike":"ConstructReserve_base__artillery-strike--1do6S","baseArtilleryStrike":"ConstructReserve_base__artillery-strike--1do6S","base__airstrike":"ConstructReserve_base__airstrike--3c0up","baseAirstrike":"ConstructReserve_base__airstrike--3c0up","base__requisition":"ConstructReserve_base__requisition--3vqsM","baseRequisition":"ConstructReserve_base__requisition--3vqsM","base__high-capacity-transport":"ConstructReserve_base__high-capacity-transport--3iD0H","baseHighCapacityTransport":"ConstructReserve_base__high-capacity-transport--3iD0H","base__additional-briefing":"ConstructReserve_base__additional-briefing--19IO1","baseAdditionalBriefing":"ConstructReserve_base__additional-briefing--19IO1","base__tactical-training":"ConstructReserve_base__tactical-training--EYil8","baseTacticalTraining":"ConstructReserve_base__tactical-training--EYil8","base__military-maneuvers":"ConstructReserve_base__military-maneuvers--3ASb7","baseMilitaryManeuvers":"ConstructReserve_base__military-maneuvers--3ASb7","base__battle-payments":"ConstructReserve_base__battle-payments--_oRxX","baseBattlePayments":"ConstructReserve_base__battle-payments--_oRxX","base__inspiration":"ConstructReserve_base__inspiration--14TsW","baseInspiration":"ConstructReserve_base__inspiration--14TsW","parameterValue":"ConstructReserve_parameterValue--2lxnM"};

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = exports.Stronghold = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(7);

var _reactRouterRedux = __webpack_require__(15);

var _constants = __webpack_require__(4);

var _urls = __webpack_require__(19);

var _accounts = __webpack_require__(33);

var _constants2 = __webpack_require__(1341);

var _reactWotBootstrap = __webpack_require__(5);

var _BuildingTooltip = __webpack_require__(290);

var _BuildingTooltip2 = _interopRequireDefault(_BuildingTooltip);

var _CommandCenterTooltip = __webpack_require__(291);

var _CommandCenterTooltip2 = _interopRequireDefault(_CommandCenterTooltip);

var _Gamefield = __webpack_require__(546);

var _Gamefield2 = _interopRequireDefault(_Gamefield);

var _StartingPoint = __webpack_require__(232);

var _StartingPoint2 = _interopRequireDefault(_StartingPoint);

var _LoadingScreen = __webpack_require__(29);

var _LoadingScreen2 = _interopRequireDefault(_LoadingScreen);

var _ClanPanel = __webpack_require__(1393);

var _ClanPanel2 = _interopRequireDefault(_ClanPanel);

var _MigrationScreen = __webpack_require__(2176);

var _MigrationScreen2 = _interopRequireDefault(_MigrationScreen);

var _components = __webpack_require__(233);

var _building_construction = __webpack_require__(127);

var _sounds = __webpack_require__(22);

var _leaderboard = __webpack_require__(583);

var _stronghold = __webpack_require__(192);

var _migration_screen = __webpack_require__(375);

var _client_counters = __webpack_require__(374);

var _Stronghold = __webpack_require__(2214);

var _Stronghold2 = _interopRequireDefault(_Stronghold);

var _shop = __webpack_require__(242);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Stronghold = exports.Stronghold = function (_React$Component) {
    _inherits(Stronghold, _React$Component);

    function Stronghold() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Stronghold);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Stronghold.__proto__ || Object.getPrototypeOf(Stronghold)).call.apply(_ref, [this].concat(args))), _this), _this.onKeyDown = function (e) {
            if (e.keyCode !== _constants.KEY_CODES.ESCAPE) return;

            var ignoreEscape = _this.props.children || _this.props.popoverOpened || _this.props.isMigrationScreenVisible || _this.props.ignoreEscape;

            if (ignoreEscape) return;

            _this.handleOpenclanlanding();
        }, _this.handleOpenclanlanding = function () {
            _this.props.openClanLanding();
            _this.props.playExitStrongholdSound();
        }, _this.getRatingLabels = function () {
            if (!_this.props.elo_leaderboards || !_this.props.isOwn) return null;

            var labels = _this.props.elo_leaderboards.map(function (leaderboard) {
                return _react2.default.createElement(_components.RatingLabel, _extends({}, leaderboard, {
                    key: leaderboard.vehicle_level,
                    onClick: function onClick() {
                        return _this.props.openLeaderboard(leaderboard.vehicle_level);
                    }
                }));
            });

            return _react2.default.createElement(
                'div',
                { className: _Stronghold2.default.ratings },
                labels
            );
        }, _this.getTooltips = function () {
            var tooltips = _this.props.slots.map(function (slot) {
                return slot.building ? _react2.default.createElement(_BuildingTooltip2.default, {
                    key: _constants.BUILDING_TOOLTIP_ID + '_' + slot.building.type,
                    id: _constants.BUILDING_TOOLTIP_ID + '_' + slot.building.type,
                    building: slot.building,
                    bounds: { top: 33 }
                }) : _react2.default.createElement(_components.SlotTooltip, {
                    key: 'slot_tooltip_' + slot.id,
                    slotId: slot.id,
                    showConstructMessage: _this.props.isOwn,
                    hasPermission: _this.props.hasPermission
                });
            });

            tooltips.push(_react2.default.createElement(_CommandCenterTooltip2.default, {
                key: 'command_center_tooltip',
                level: _this.props.level
            }));

            return tooltips;
        }, _this.getDirections = function () {
            var emptySlotClickHandler = null;
            var buildingClickHandler = null;

            if (_this.props.isOwn) {
                emptySlotClickHandler = function emptySlotClickHandler(slotId) {
                    _this.props.playBuildingClickSound();
                    _this.props.pushState('stronghold/build/' + slotId);
                };

                buildingClickHandler = function buildingClickHandler(buildingId) {
                    _this.props.playBuildingClickSound();
                    _this.props.pushState('stronghold/building/' + buildingId);
                };
            }

            return _constants.DIRECTIONS.map(function (directionName) {
                var directionSlots = _this.props.slots.filter(function (slot) {
                    return slot.direction === directionName;
                }).sort(function (firstSlot, secondSlot) {
                    return firstSlot.position > secondSlot.position;
                });

                return _react2.default.createElement(_components.Direction, {
                    key: directionName,
                    level: _this.props.level,
                    name: directionName,
                    slots: directionSlots,
                    emptySlotClickHandler: emptySlotClickHandler,
                    buildingClickHandler: buildingClickHandler,
                    emptySlotHoverHandler: _this.props.isOwn ? _this.props.playHoverSound : null,
                    buildingHoverHandler: _this.props.playHoverSound,
                    buildingConstructionAnimated: _this.props.constructionAnimated,
                    hasPermission: _this.props.hasPermission,
                    isOwn: _this.props.isOwn
                });
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Stronghold, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.onComponentDidMount(this.props);
            window.addEventListener('keydown', this.onKeyDown);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState, snapshot) {
            if (this.props.isOwn && !prevProps.clientCounters.isLoaded && this.props.clientCounters.items.clanNews > 0) {
                this.props.showMigrationScreen();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('keydown', this.onKeyDown);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            if (this.props.showLoading) {
                if (!this.props.isOwn) return _react2.default.createElement(_LoadingScreen2.default, { type: 'gamefield' });
                return _react2.default.createElement(
                    'div',
                    { className: _Stronghold2.default.base },
                    this.props.isOwn ? _react2.default.createElement(_ClanPanel2.default, null) : _react2.default.createElement(_components.ClanInfoPanel, {
                        stats: this.props.clanStats,
                        clan: this.props.clanInfo,
                        elo_leaderboards: this.props.elo_leaderboards
                    }),
                    _react2.default.createElement(
                        _Gamefield2.default,
                        null,
                        _react2.default.createElement(_LoadingScreen2.default, { type: 'gamefield' })
                    )
                );
            }

            if (this.props.children) {
                return _react2.default.createElement(
                    'div',
                    { className: _Stronghold2.default.base },
                    this.props.isOwn && _react2.default.createElement(_ClanPanel2.default, null),
                    this.props.children
                );
            }

            var commandCenterClickHandler = null;

            if (this.props.isOwn) {
                commandCenterClickHandler = function commandCenterClickHandler() {
                    _this2.props.playBuildingClickSound();
                    _this2.props.pushState('stronghold/building/command_center');
                };
            }

            var commandCenter = _react2.default.createElement(_components.CommandCenter, {
                key: 1,
                level: this.props.level,
                handleClick: commandCenterClickHandler,
                handleHover: this.props.isOwn ? this.props.playHoverSound : null,
                isOwn: this.props.isOwn
            });

            return _react2.default.createElement(
                'div',
                { className: _Stronghold2.default.base },
                this.props.isOwn ? _react2.default.createElement(_ClanPanel2.default, null) : _react2.default.createElement(_components.ClanInfoPanel, {
                    stats: this.props.clanStats,
                    clan: this.props.clanInfo,
                    elo_leaderboards: this.props.elo_leaderboards
                }),
                this.props.isOwn && _react2.default.createElement(
                    'div',
                    { className: _Stronghold2.default.back },
                    _react2.default.createElement(_reactWotBootstrap.Back, {
                        onClick: this.handleOpenclanlanding,
                        type: 'back',
                        side: 'left',
                        caption: _constants2.BACK_TO_CLAN_INFO
                    })
                ),
                this.getRatingLabels(),
                _react2.default.createElement(
                    _Gamefield2.default,
                    null,
                    this.props.isMigrationScreenVisible && _react2.default.createElement(_MigrationScreen2.default, null),
                    this.getDirections(),
                    this.getTooltips(),
                    _react2.default.createElement(_StartingPoint2.default, { children: [commandCenter] })
                ),
                this.props.isOwn && _react2.default.createElement(_components.Toolbar, null)
            );
        }
    }]);

    return Stronghold;
}(_react2.default.Component);

Stronghold.propTypes = {
    // state props
    level: _propTypes2.default.number.isRequired,
    showLoading: _propTypes2.default.bool.isRequired,
    slots: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
    clanId: _propTypes2.default.number.isRequired,
    isOwn: _propTypes2.default.bool.isRequired,
    isShopStateLoaded: _propTypes2.default.bool.isRequired,
    clanInfo: _propTypes2.default.object,
    clanStats: _propTypes2.default.object,
    popoverOpened: _propTypes2.default.bool.isRequired,
    userFlags: _propTypes2.default.object.isRequired,
    clientCounters: _propTypes2.default.object.isRequired,
    elo_leaderboards: _propTypes2.default.array,
    hasPermission: _propTypes2.default.bool.isRequired,
    isMigrationScreenVisible: _propTypes2.default.bool.isRequired,

    // ownProps
    ignoreEscape: _propTypes2.default.bool,

    // redux bound actions
    pushState: _propTypes2.default.func.isRequired,
    constructionAnimated: _propTypes2.default.func.isRequired,
    playBuildingClickSound: _propTypes2.default.func.isRequired,
    playHoverSound: _propTypes2.default.func.isRequired,
    openLeaderboard: _propTypes2.default.func.isRequired,
    openClanLanding: _propTypes2.default.func.isRequired,
    onComponentDidMount: _propTypes2.default.func.isRequired,
    playExitStrongholdSound: _propTypes2.default.func.isRequired,
    showMigrationScreen: _propTypes2.default.func.isRequired
};
var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
    var slots = state.slots,
        buildings = state.buildings,
        stronghold = state.stronghold,
        account = state.account,
        toolbar = state.toolbar,
        userFlags = state.userFlags,
        shop = state.shop,
        migrationScreen = state.migrationScreen,
        clientCounters = state.clientCounters;


    var clanId = ownProps.params && ownProps.params.clanId ? parseInt(ownProps.params.clanId) : state.clan.id;

    var isOwn = state.clan.id === clanId;
    var hasPermission = isOwn && (0, _accounts.canManageBuilding)(account);

    var loading = stronghold.loading,
        loaded = stronghold.loaded,
        level = stronghold.level,
        clanInfo = stronghold.clan,
        clanStats = stronghold.stats,
        elo_leaderboards = stronghold.elo_leaderboards;


    var showLoading = loaded !== loading && loading || !loaded;
    var isShopStateLoaded = shop.productsLoaded || shop.statusLoaded;

    slots = Object.keys(slots).reduce(function (acc, slotId) {
        return [].concat(_toConsumableArray(acc), [slots[slotId]]);
    }, []).map(function (slot) {
        return _extends({}, slot, {
            building: slot.building !== null ? buildings[slot.building] : null
        });
    });

    var popoverOpened = toolbar.popoverOpened;


    return {
        slots: slots,
        level: level,
        showLoading: showLoading,
        clanId: clanId,
        isOwn: isOwn,
        isShopStateLoaded: isShopStateLoaded,
        hasPermission: hasPermission,
        popoverOpened: popoverOpened,
        clanInfo: clanInfo,
        clanStats: clanStats,
        userFlags: userFlags,
        elo_leaderboards: elo_leaderboards,
        clientCounters: clientCounters,
        isMigrationScreenVisible: migrationScreen.isVisible
    };
};

var mapDispatchToProps = exports.mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        pushState: function pushState(path) {
            return dispatch((0, _reactRouterRedux.push)(path));
        },
        constructionAnimated: function constructionAnimated(buildingId) {
            return dispatch((0, _building_construction.constructionAnimated)(buildingId));
        },
        onComponentDidMount: function onComponentDidMount(props) {
            if (!props.clientCounters.isLoaded) {
                dispatch((0, _client_counters.requestClientCounters)());
            } else if (props.isOwn && props.clientCounters.items.clanNews > 0) {
                dispatch((0, _migration_screen.showMigrationScreen)());
            }

            if (props.isOwn) {
                dispatch((0, _stronghold.requestStronghold)());
            } else {
                dispatch((0, _stronghold.requestStronghold)(props.clanId));
            }

            if (!props.isShopStateLoaded) {
                dispatch((0, _shop.requestShopStatus)());
            }
        },
        showMigrationScreen: function showMigrationScreen() {
            return dispatch((0, _migration_screen.showMigrationScreen)());
        },
        playHoverSound: function playHoverSound() {
            return dispatch((0, _sounds.playHoverSound)());
        },
        playBuildingClickSound: function playBuildingClickSound() {
            return dispatch((0, _sounds.playBuildingClickSound)());
        },
        openClanLanding: function openClanLanding() {
            return dispatch((0, _reactRouterRedux.push)(_urls.CLAN_LANDING));
        },
        openLeaderboard: function openLeaderboard(vehicle_level) {
            return dispatch((0, _leaderboard.openLeaderboard)(vehicle_level));
        },
        playExitStrongholdSound: function playExitStrongholdSound() {
            return dispatch((0, _sounds.playExitStrongholdSound)());
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Stronghold);

/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BACK_TO_CLAN_INFO = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BACK_TO_CLAN_INFO = exports.BACK_TO_CLAN_INFO = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'back_to_clan_info',
    defaultMessage: '\u041A \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u043E \u043A\u043B\u0430\u043D\u0435'
});

/***/ }),
/* 1342 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tooltip-root":"BattlesButton_tooltip-root--atLhR","tooltipRoot":"BattlesButton_tooltip-root--atLhR","tooltip-root__show":"BattlesButton_tooltip-root__show--3fUtN","tooltipRootShow":"BattlesButton_tooltip-root__show--3fUtN","tooltip-body":"BattlesButton_tooltip-body--29BM2","tooltipBody":"BattlesButton_tooltip-body--29BM2","tooltip-wrapper":"BattlesButton_tooltip-wrapper--KrLQx","tooltipWrapper":"BattlesButton_tooltip-wrapper--KrLQx","tooltip-content":"BattlesButton_tooltip-content--2_eCY","tooltipContent":"BattlesButton_tooltip-content--2_eCY","tooltip-title":"BattlesButton_tooltip-title--28TwM","tooltipTitle":"BattlesButton_tooltip-title--28TwM","tooltip-subtitle":"BattlesButton_tooltip-subtitle--2lkcA","tooltipSubtitle":"BattlesButton_tooltip-subtitle--2lkcA","tooltip-message":"BattlesButton_tooltip-message--eT-zh","tooltipMessage":"BattlesButton_tooltip-message--eT-zh","tooltip-warning":"BattlesButton_tooltip-warning--1W5Z0","tooltipWarning":"BattlesButton_tooltip-warning--1W5Z0","tooltip-divider":"BattlesButton_tooltip-divider--5Sgfr","tooltipDivider":"BattlesButton_tooltip-divider--5Sgfr","tooltip-highlight":"BattlesButton_tooltip-highlight--2poG9","tooltipHighlight":"BattlesButton_tooltip-highlight--2poG9","tooltip-ribbon":"BattlesButton_tooltip-ribbon--1El8J","tooltipRibbon":"BattlesButton_tooltip-ribbon--1El8J","tooltip-statusMessage":"BattlesButton_tooltip-statusMessage--3-ayP","tooltipStatusMessage":"BattlesButton_tooltip-statusMessage--3-ayP","tooltip-statusMessage__positive":"BattlesButton_tooltip-statusMessage__positive--1nXEr","tooltipStatusMessagePositive":"BattlesButton_tooltip-statusMessage__positive--1nXEr","tooltip-status":"BattlesButton_tooltip-status--2E_fj","tooltipStatus":"BattlesButton_tooltip-status--2E_fj","tooltip-statusMessage__negative":"BattlesButton_tooltip-statusMessage__negative--1YSH9","tooltipStatusMessageNegative":"BattlesButton_tooltip-statusMessage__negative--1YSH9","tooltip-statusMessage__noPermission":"BattlesButton_tooltip-statusMessage__noPermission--1jPLm","tooltipStatusMessageNoPermission":"BattlesButton_tooltip-statusMessage__noPermission--1jPLm","tooltip-status__positive":"BattlesButton_tooltip-status__positive---7yjf","tooltipStatusPositive":"BattlesButton_tooltip-status__positive---7yjf","tooltip-status__negative":"BattlesButton_tooltip-status__negative--2pCzh","tooltipStatusNegative":"BattlesButton_tooltip-status__negative--2pCzh","tooltip-statusText":"BattlesButton_tooltip-statusText--1NA5P","tooltipStatusText":"BattlesButton_tooltip-statusText--1NA5P","base":"BattlesButton_base--30e_D","base__primary":"BattlesButton_base__primary--1Ph63","basePrimary":"BattlesButton_base__primary--1Ph63","glow":"BattlesButton_glow--2o-NG","caption":"BattlesButton_caption--3ocNb","caption__glow":"BattlesButton_caption__glow--2syhw","captionGlow":"BattlesButton_caption__glow--2syhw","caption-gradient":"BattlesButton_caption-gradient--2DZJc","captionGradient":"BattlesButton_caption-gradient--2DZJc","schedule":"BattlesButton_schedule--34yp2","schedule__primary":"BattlesButton_schedule__primary--45oqy","schedulePrimary":"BattlesButton_schedule__primary--45oqy","schedule__bubble":"BattlesButton_schedule__bubble--3Mb7a","scheduleBubble":"BattlesButton_schedule__bubble--3Mb7a","multiplier":"BattlesButton_multiplier--2jpeh"};

/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(4);

var _Item = __webpack_require__(2168);

var _Item2 = _interopRequireDefault(_Item);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var views = ['journal', 'challenges', 'management'];
var currencies = ['industrial', _constants.MONEY_TYPES.gold, _constants.MONEY_TYPES.crystal];

var Item = function Item(props) {
    var _classNames;

    var className = (0, _classnames2.default)(_Item2.default.base, _Item2.default['base__' + props.type], (_classNames = {}, _defineProperty(_classNames, _Item2.default.base__currency, currencies.includes(props.type)), _defineProperty(_classNames, _Item2.default.base__selected, props.selected), _classNames));

    return _react2.default.createElement(
        'div',
        {
            onClick: props.handleClick,
            onMouseEnter: props.handleHover,
            className: className,
            'data-tip': !!props.tooltipId,
            'data-for': props.tooltipId
        },
        _react2.default.createElement(
            'div',
            { className: _Item2.default.holder },
            _react2.default.createElement(
                'div',
                { className: _Item2.default.title },
                _react2.default.createElement('span', { className: _Item2.default.icon }),
                _react2.default.createElement(
                    'span',
                    { className: _Item2.default.caption },
                    props.title
                )
            ),
            props.contents && _react2.default.createElement(
                'div',
                { className: _Item2.default.contents },
                props.contents
            )
        )
    );
};

Item.propTypes = {
    selected: _propTypes2.default.bool,
    title: _propTypes2.default.node.isRequired,
    contents: _propTypes2.default.node,
    type: _propTypes2.default.oneOf([].concat(views, currencies)).isRequired,
    handleClick: _propTypes2.default.func,
    handleHover: _propTypes2.default.func,
    tooltipId: _propTypes2.default.string
};

exports.default = Item;

/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StorageTooltip = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactWotBootstrap = __webpack_require__(5);

var _IndustrialResource = __webpack_require__(35);

var _IndustrialResource2 = _interopRequireDefault(_IndustrialResource);

var _constants = __webpack_require__(1345);

var _i18n = __webpack_require__(10);

var _StorageTooltip = __webpack_require__(2171);

var _StorageTooltip2 = _interopRequireDefault(_StorageTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StorageTooltip = exports.StorageTooltip = function StorageTooltip(_ref) {
    var industrialResource = _ref.industrialResource,
        showFooter = _ref.showFooter;

    var hasFines = industrialResource < 0;
    var volatile_content = void 0;
    var irValue = _react2.default.createElement(_IndustrialResource2.default, {
        value: industrialResource,
        notEnough: hasFines,
        small: true,
        iconAtLeft: true
    });

    if (hasFines) {
        volatile_content = _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'p',
                { className: _StorageTooltip2.default.message },
                (0, _constants.INDUSTRIAL_RESOURCE_TOOLTIP_WITH_FINES)(irValue)
            ),
            _react2.default.createElement(
                'p',
                { className: _StorageTooltip2.default.message },
                _constants.INDUSTRIAL_RESOURCE_TOOLTIP_ACTIVATE_RESERVES
            )
        );
    } else {
        volatile_content = _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'p',
                { className: _StorageTooltip2.default.message },
                (0, _constants.INDUSTRIAL_RESOURCE_TOOLTIP)(irValue)
            )
        );
    }

    return _react2.default.createElement(
        _reactWotBootstrap.Tooltip,
        { id: StorageTooltip.id },
        _react2.default.createElement(
            'div',
            { className: _StorageTooltip2.default.content },
            _react2.default.createElement(
                'p',
                { className: _StorageTooltip2.default.subtitle },
                _constants.INDUSTRIAL_RESOURCE_DETAILS
            ),
            volatile_content,
            _react2.default.createElement('div', { className: _StorageTooltip2.default.divider }),
            _react2.default.createElement(
                'p',
                { className: _StorageTooltip2.default.message },
                hasFines ? _i18n.NEGATIVE_IR_BALANCE_HINT : _constants.INDUSTRIAL_RESOURCE_TOOLTIP_EARN_ALL
            ),
            showFooter && _react2.default.createElement(
                'p',
                { className: _StorageTooltip2.default.message },
                _constants.CLICK_TO_OPEN_RESOURCE_JOURNAL
            )
        )
    );
};

StorageTooltip.id = 'clan_panel_industrial_resource_tooltip';

StorageTooltip.propTypes = {
    industrialResource: _propTypes2.default.number.isRequired,
    showFooter: _propTypes2.default.bool
};

StorageTooltip.defaultProps = {
    showFooter: false
};

exports.default = StorageTooltip;

/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.INDUSTRIAL_RESOURCE_TOOLTIP_FINE_DESCRIPTION = exports.INDUSTRIAL_RESOURCE_TOOLTIP_ACTIVATE_RESERVES = exports.INDUSTRIAL_RESOURCE_TOOLTIP_EARN_ALL_CLAN_LEGIONAIRE = exports.INDUSTRIAL_RESOURCE_TOOLTIP_EARN_ALL = exports.INDUSTRIAL_RESOURCE_TOOLTIP_EARN_SORTIE_FORT_BATTLE = exports.INDUSTRIAL_RESOURCE_TOOLTIP_WITH_FINES = exports.CLICK_TO_OPEN_RESOURCE_JOURNAL = exports.INDUSTRIAL_RESOURCE_TOOLTIP = exports.INDUSTRIAL_RESOURCE_DETAILS = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _i18n = __webpack_require__(10);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-multi-comp */

var INDUSTRIAL_RESOURCE_DETAILS = exports.INDUSTRIAL_RESOURCE_DETAILS = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_panel.item.industrial_resource_details',
    defaultMessage: '\u0421\u043A\u043B\u0430\u0434'
});

var INDUSTRIAL_RESOURCE_TOOLTIP = exports.INDUSTRIAL_RESOURCE_TOOLTIP = function INDUSTRIAL_RESOURCE_TOOLTIP(value) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'clan_panel.item.industrial_resource_tooltip_text',
        defaultMessage: '\u0421\u0435\u0439\u0447\u0430\u0441 \u043D\u0430 \u0441\u043A\u043B\u0430\u0434\u0435 {value}',
        values: { value: value }
    });
};

var CLICK_TO_OPEN_RESOURCE_JOURNAL = exports.CLICK_TO_OPEN_RESOURCE_JOURNAL = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_panel.item.industrial_resource_tooltip_hint_tracking_journal',
    defaultMessage: '\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043F\u0435\u0440\u0435\u0439\u0442\u0438 \u043A \u0436\u0443\u0440\u043D\u0430\u043B\u0443 \u0443\u0447\u0451\u0442\u0430 \u043F\u0440\u043E\u043C\u0440\u0435\u0441\u0443\u0440\u0441\u0430.'
});

var INDUSTRIAL_RESOURCE_TOOLTIP_WITH_FINES = exports.INDUSTRIAL_RESOURCE_TOOLTIP_WITH_FINES = function INDUSTRIAL_RESOURCE_TOOLTIP_WITH_FINES(value) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'clan_panel.item.industrial_resource_tooltip_text_with_fines',
        defaultMessage: '\u0421\u0435\u0439\u0447\u0430\u0441 \u043D\u0430 \u0441\u043A\u043B\u0430\u0434\u0435 {value} (\u0448\u0442\u0440\u0430\u0444)',
        values: { value: value }
    });
};

var INDUSTRIAL_RESOURCE_TOOLTIP_EARN_SORTIE_FORT_BATTLE = exports.INDUSTRIAL_RESOURCE_TOOLTIP_EARN_SORTIE_FORT_BATTLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_panel.item.industrial_resource_tooltip_earn_sortie_fort_battle',
    defaultMessage: '\u0414\u043E\u0431\u044B\u0442\u044C \u043F\u0440\u043E\u043C\u0440\u0435\u0441\u0443\u0440\u0441 \u043C\u043E\u0436\u043D\u043E \u0432 \u0412\u044B\u043B\u0430\u0437\u043A\u0430\u0445 \u0438 \u041D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u044F\u0445'
});

var INDUSTRIAL_RESOURCE_TOOLTIP_EARN_ALL = exports.INDUSTRIAL_RESOURCE_TOOLTIP_EARN_ALL = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_panel.item.industrial_resource_tooltip_earn_all',
    defaultMessage: 'You can earn Industrial Resource in Skirmishes, Advances, and Tour Missions.'
});

var INDUSTRIAL_RESOURCE_TOOLTIP_EARN_ALL_CLAN_LEGIONAIRE = exports.INDUSTRIAL_RESOURCE_TOOLTIP_EARN_ALL_CLAN_LEGIONAIRE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_panel.item.industrial_resource_tooltip_earn_all_clan',
    defaultMessage: '\u0417\u0430\u0440\u0430\u0431\u043E\u0442\u0430\u0442\u044C \u043F\u0440\u043E\u043C\u0440\u0435\u0441\u0443\u0440\u0441 \u043C\u043E\u0436\u043D\u043E \u0432 \u0412\u044B\u043B\u0430\u0437\u043A\u0430\u0445 \u0441\u0432\u043E\u0435\u0433\u043E \u043A\u043B\u0430\u043D\u0430 \u0438\u043B\u0438 \u0441\u0440\u0430\u0436\u0430\u044F\u0441\u044C \u043B\u0435\u0433\u0438\u043E\u043D\u0435\u0440\u043E\u043C \u0432 \u043E\u0442\u0440\u044F\u0434\u0430\u0445 \u0434\u0440\u0443\u0433\u0438\u0445 \u043A\u043B\u0430\u043D\u043E\u0432.' // eslint-disable-line max-len
});

var INDUSTRIAL_RESOURCE_TOOLTIP_ACTIVATE_RESERVES = exports.INDUSTRIAL_RESOURCE_TOOLTIP_ACTIVATE_RESERVES = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_panel.item.industrial_resource_tooltip_activate_reserves',
    defaultMessage: '\u0427\u0442\u043E\u0431\u044B \u0430\u043A\u0442\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0440\u0435\u0437\u0435\u0440\u0432\u044B {battle_payments}, {tactical_training}, {additional_briefing}, {military_maneuvers} \u0438 \u0441\u043E\u0437\u0434\u0430\u0432\u0430\u0442\u044C \u043E\u0442\u0440\u044F\u0434\u044B \u0434\u043B\u044F \u041D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u0439, \u0437\u0430\u0440\u0430\u0431\u043E\u0442\u0430\u0439\u0442\u0435 \u043D\u0435\u0434\u043E\u0441\u0442\u0430\u044E\u0449\u0438\u0439 \u043F\u0440\u043E\u043C\u0440\u0435\u0441\u0443\u0440\u0441 \u0438 \u043F\u043E\u0433\u0430\u0441\u0438\u0442\u0435 \u0448\u0442\u0440\u0430\u0444.' // eslint-disable-line max-len
    , values: {
        battle_payments: _i18n.RESERVE_TITLES[_constants.RESERVE_TYPES.BATTLE_PAYMENTS],
        tactical_training: _i18n.RESERVE_TITLES[_constants.RESERVE_TYPES.TACTICAL_TRAINING],
        additional_briefing: _i18n.RESERVE_TITLES[_constants.RESERVE_TYPES.ADDITIONAL_BRIEFING],
        military_maneuvers: _i18n.RESERVE_TITLES[_constants.RESERVE_TYPES.MILITARY_MANEUVERS]
    }
});

var INDUSTRIAL_RESOURCE_TOOLTIP_FINE_DESCRIPTION = exports.INDUSTRIAL_RESOURCE_TOOLTIP_FINE_DESCRIPTION = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_panel.item.industrial_resource_tooltip_fine_description',
    defaultMessage: '\u0427\u0442\u043E\u0431\u044B \u0430\u043A\u0442\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0440\u0435\u0437\u0435\u0440\u0432\u044B \u0438 \u0441\u043E\u0437\u0434\u0430\u0432\u0430\u0442\u044C \u043E\u0442\u0440\u044F\u0434\u044B \u0434\u043B\u044F \u041D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u0439, \u0437\u0430\u0440\u0430\u0431\u043E\u0442\u0430\u0439\u0442\u0435 \u043D\u0435\u0434\u043E\u0441\u0442\u0430\u044E\u0449\u0438\u0439 \u043F\u0440\u043E\u043C\u0440\u0435\u0441\u0443\u0440\u0441 \u0438 \u043F\u043E\u0433\u0430\u0441\u0438\u0442\u0435 \u0448\u0442\u0440\u0430\u0444.' // eslint-disable-line max-len
});

/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.IndustrialBuyinTooltip = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactWotBootstrap = __webpack_require__(5);

var _constants = __webpack_require__(2174);

var _IndustrialTooltip = __webpack_require__(2175);

var _IndustrialTooltip2 = _interopRequireDefault(_IndustrialTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IndustrialBuyinTooltip = exports.IndustrialBuyinTooltip = function IndustrialBuyinTooltip() {
    return _react2.default.createElement(
        _reactWotBootstrap.Tooltip,
        { id: IndustrialBuyinTooltip.id },
        _react2.default.createElement(
            'div',
            { className: _IndustrialTooltip2.default.content },
            _react2.default.createElement(
                'p',
                { className: _IndustrialTooltip2.default.subtitle },
                _constants.INDUSTRIAL_RESOURCE_TITLE
            ),
            _react2.default.createElement(
                'p',
                { className: _IndustrialTooltip2.default.message },
                _constants.INDUSTRIAL_RESOURCE_MESSAGE
            )
        )
    );
};

IndustrialBuyinTooltip.id = 'clan_panel_industrial_resource_buyin_tooltip';

exports.default = IndustrialBuyinTooltip;

/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.STATS_TOOLTIP_HEADER = exports.STATS_TOOLTIP_NO_STATS = exports.STATS_TOOLTIPS_IDS = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-multi-comp */
var STATS_TOOLTIPS_IDS = exports.STATS_TOOLTIPS_IDS = {
    6: 'stats_tooltip_id_6',
    8: 'stats_tooltip_id_8',
    10: 'stats_tooltip_id_10'
};

var STATS_TOOLTIP_NO_STATS = exports.STATS_TOOLTIP_NO_STATS = function STATS_TOOLTIP_NO_STATS(level) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'stats_tooltip.no_stats',
        defaultMessage: '\u041A\u043B\u0430\u043D \u043D\u0435 \u043F\u0440\u043E\u0432\u043E\u0434\u0438\u043B \u0441\u0440\u0430\u0436\u0435\u043D\u0438\u044F \u043D\u0430 {level} \u0434\u0438\u0432\u0438\u0437\u0438\u043E\u043D\u0435',
        values: { level: level }
    });
};

var STATS_TOOLTIP_HEADER = exports.STATS_TOOLTIP_HEADER = function STATS_TOOLTIP_HEADER(level) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'stats_tooltip.header',
        defaultMessage: '\u0421\u0440\u0430\u0436\u0435\u043D\u0438\u044F \u043D\u0430 {level} \u0443\u0440\u043E\u0432\u043D\u0435',
        values: { level: level }
    });
};

/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _RatingLabelTooltip = __webpack_require__(2188);

var _RatingLabelTooltip2 = _interopRequireDefault(_RatingLabelTooltip);

var _reactWotBootstrap = __webpack_require__(5);

var _reactIntl = __webpack_require__(3);

var _i18n = __webpack_require__(10);

var _constants = __webpack_require__(1395);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RatingLabelTooltip = function (_React$Component) {
    _inherits(RatingLabelTooltip, _React$Component);

    function RatingLabelTooltip() {
        _classCallCheck(this, RatingLabelTooltip);

        return _possibleConstructorReturn(this, (RatingLabelTooltip.__proto__ || Object.getPrototypeOf(RatingLabelTooltip)).apply(this, arguments));
    }

    _createClass(RatingLabelTooltip, [{
        key: 'render',
        value: function render() {
            var eloRating = _react2.default.createElement(
                'div',
                { className: _RatingLabelTooltip2.default.message },
                _i18n.ELO_RATING_TEXT,
                ': ',
                _react2.default.createElement(
                    'span',
                    { className: _RatingLabelTooltip2.default.highlight },
                    _react2.default.createElement(_reactIntl.FormattedNumber, { value: this.props.elo })
                )
            );
            var position = this.props.position && _react2.default.createElement(
                'div',
                { className: _RatingLabelTooltip2.default.message },
                (0, _i18n.RATING_POSITION)(_react2.default.createElement(
                    'span',
                    { className: _RatingLabelTooltip2.default.highlight },
                    _react2.default.createElement(_reactIntl.FormattedNumber, { value: this.props.position })
                ))
            );

            var footer = _react2.default.createElement(
                'div',
                { className: _RatingLabelTooltip2.default.statusText },
                _react2.default.createElement('div', { className: _RatingLabelTooltip2.default.divider }),
                _constants.CLICK_TO_OPEN_LEADERBOARD
            );

            return _react2.default.createElement(
                _reactWotBootstrap.Tooltip,
                { id: this.props.id },
                _react2.default.createElement(
                    'div',
                    { className: _RatingLabelTooltip2.default.content },
                    _react2.default.createElement(
                        'div',
                        { className: _RatingLabelTooltip2.default.subtitle },
                        (0, _i18n.BATTLES_ON_LEVEL)(this.props.vehicle_level)
                    ),
                    eloRating,
                    this.props.show_leaderboard && position,
                    this.props.show_leaderboard && footer
                )
            );
        }
    }]);

    return RatingLabelTooltip;
}(_react2.default.Component);

RatingLabelTooltip.propTypes = {
    id: _propTypes2.default.string.isRequired,
    elo: _propTypes2.default.number.isRequired,
    position: _propTypes2.default.number,
    vehicle_level: _propTypes2.default.number.isRequired,
    show_leaderboard: _propTypes2.default.bool
};
exports.default = RatingLabelTooltip;

/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

var _ReserveProgress = __webpack_require__(2198);

var _ReserveProgress2 = _interopRequireDefault(_ReserveProgress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReserveProgress = function (_React$Component) {
    _inherits(ReserveProgress, _React$Component);

    function ReserveProgress() {
        _classCallCheck(this, ReserveProgress);

        return _possibleConstructorReturn(this, (ReserveProgress.__proto__ || Object.getPrototypeOf(ReserveProgress)).apply(this, arguments));
    }

    _createClass(ReserveProgress, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.update();
        }
    }, {
        key: 'update',
        value: function update() {
            this.clearTimeouts();
            if (!this.props.endTime) return;

            this.timeoutId = setTimeout(this.update.bind(this), 1000);

            this.setState({
                percents: this.getPercents()
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.clearTimeouts();
        }
    }, {
        key: 'clearTimeouts',
        value: function clearTimeouts() {
            if (this.timeoutId) clearTimeout(this.timeoutId);
        }
    }, {
        key: 'getPercents',
        value: function getPercents() {
            var totalDurationMilliseconds = this.props.totalDuration * 1000;
            return Math.round(this.props.endTime.diff((0, _moment2.default)()) / totalDurationMilliseconds * 100) + '%';
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.props.endTime) return null;

            return _react2.default.createElement('div', { className: _ReserveProgress2.default.base, style: { height: this.state.percents } });
        }
    }]);

    return ReserveProgress;
}(_react2.default.Component);

ReserveProgress.propTypes = {
    totalDuration: _propTypes2.default.number,
    endTime: _propTypes2.default.object
};
exports.default = ReserveProgress;

/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapStateToProps = exports.ReserveTooltip = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = __webpack_require__(7);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

var _reactWotBootstrap = __webpack_require__(5);

var _Warning = __webpack_require__(107);

var _Warning2 = _interopRequireDefault(_Warning);

var _ReserveTooltipBody = __webpack_require__(206);

var _Timer = __webpack_require__(51);

var _Timer2 = _interopRequireDefault(_Timer);

var _helpers = __webpack_require__(11);

var _accounts = __webpack_require__(33);

var _i18n = __webpack_require__(10);

var _reserves = __webpack_require__(28);

var _constants = __webpack_require__(4);

var _constants2 = __webpack_require__(2201);

var _ReserveTooltip = __webpack_require__(2202);

var _ReserveTooltip2 = _interopRequireDefault(_ReserveTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReserveTooltip = exports.ReserveTooltip = function (_React$Component) {
    _inherits(ReserveTooltip, _React$Component);

    function ReserveTooltip() {
        _classCallCheck(this, ReserveTooltip);

        return _possibleConstructorReturn(this, (ReserveTooltip.__proto__ || Object.getPrototypeOf(ReserveTooltip)).apply(this, arguments));
    }

    _createClass(ReserveTooltip, [{
        key: 'getMessage',
        value: function getMessage() {
            var reservesAreAbsent = (0, _reserves.getIsReservesAbsent)(this.props.reserves);
            var reserveGroup = (0, _reserves.getGroupByReserve)(this.props.reserveType, this.props.settings);
            var firstActiveReserveInGroup = (0, _reserves.findFirstActiveReserveInGroup)(this.props.clanReserves, this.props.settings.reserve_groups[reserveGroup]);
            var canActivate = (0, _accounts.canActivateReserves)(this.props.account);

            var message = void 0;
            if (reserveGroup === _constants.RESERVE_GROUPS.DISPOSABLE) {
                message = ReserveTooltip.MESSAGES.DISPOSABLE(canActivate, reservesAreAbsent);
            } else if (this.props.strongholdIsFrozen) {
                if (!canActivate) {
                    message = ReserveTooltip.MESSAGES.NO_PERMISSION();
                } else {
                    message = ReserveTooltip.MESSAGES.ACTIVATION_IS_IMPOSSIBLE(_constants2.EARN_LACKING_INDUSTRIAL_RESOURCE);
                }
            } else if (firstActiveReserveInGroup) {
                message = ReserveTooltip.MESSAGES.FIRST_ACTIVE_RESERVE_IN_GROUP(firstActiveReserveInGroup, canActivate, this.props.reserveType);
            } else if (!canActivate) {
                message = ReserveTooltip.MESSAGES.NO_PERMISSION();
            } else if (reservesAreAbsent) {
                message = ReserveTooltip.MESSAGES.ACTIVATION_IS_IMPOSSIBLE(_constants2.RESERVE_DOES_NOT_EXIST);
            } else {
                message = _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)(_ReserveTooltip2.default.statusMessage, _ReserveTooltip2.default.statusMessage__positive) },
                    _react2.default.createElement(
                        'p',
                        { className: _ReserveTooltip2.default.status },
                        _constants2.READY_FOR_ACTIVATION
                    )
                );
            }
            return message;
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.props.reserveType) {
                return null;
            }
            var reserveInfo = this.props.settings.reserves[this.props.reserveType];
            var activatedReserve = (0, _reserves.getActivatedReserve)(this.props.reserves);
            var currentLevel = (0, _reserves.getCurrentLevel)(activatedReserve, this.props.reserves);
            var currentLevelReserves = this.props.reserves[currentLevel];
            var readyReserves = (0, _reserves.getReadyReserves)(currentLevelReserves);

            var canActivate = (0, _accounts.canActivateReserves)(this.props.account);

            var buildingType = (0, _reserves.getBuildingTypeByReserve)(this.props.reserveType, this.props.settings);
            var buildingName = _i18n.BUILDING_TITLES[buildingType];

            var currentBonus = reserveInfo.bonus.values[currentLevel - 1];

            var reserveGroup = (0, _reserves.getGroupByReserve)(this.props.reserveType, this.props.settings);
            var bonusValuesArray = Object.values(currentBonus.battle_types);
            var targetType = (0, _reserves.getTargetType)(reserveGroup, bonusValuesArray);
            var className = (0, _classnames2.default)(_ReserveTooltip2.default.base, _ReserveTooltip2.default['base__type-' + targetType]);

            var imageClassName = (0, _classnames2.default)(_ReserveTooltip2.default.image, _ReserveTooltip2.default['image__' + (0, _helpers.toCssClass)(this.props.reserveType)], _defineProperty({}, _ReserveTooltip2.default.image__elite, currentLevel > _constants.MAX_BUILDING_LEVEL));

            var counterInfo = void 0;
            if (readyReserves.length > 0) {
                var counter = _react2.default.createElement(
                    'span',
                    { className: _ReserveTooltip2.default.counter },
                    readyReserves.length
                );
                counterInfo = _react2.default.createElement(
                    'p',
                    { className: _ReserveTooltip2.default.counterInfo },
                    (0, _constants2.RESERVE_COUNTER)(counter)
                );
            }

            var isSpecialCondition = currentBonus.special_conditions.includes(_constants.SPECIAL_CONDITIONS_X_LEVEL_ONLY);

            var buildingMessage = currentLevel <= _constants.MAX_BUILDING_LEVEL && canActivate ? _react2.default.createElement(
                'div',
                { className: _ReserveTooltip2.default.reserveMessage },
                (0, _constants2.RESERVE_BUILDING)(buildingName)
            ) : null;

            var specialConditionMessage = isSpecialCondition ? _react2.default.createElement(
                'div',
                { className: _ReserveTooltip2.default.reserveMessage },
                _react2.default.createElement(
                    _Warning2.default,
                    null,
                    _constants2.X_LEVEL_ONLY
                )
            ) : null;

            var challengesMessage = currentLevel > _constants.MAX_BUILDING_LEVEL && canActivate ? _react2.default.createElement(
                'div',
                { className: _ReserveTooltip2.default.reserveMessage },
                _constants2.FROM_CHALLENGES
            ) : null;

            var reservistBonusMessage = _i18n.BONUS_NOT_APPLIED_TO_RESERVIST;

            var bonusNotAppliedToReservistMessage = reserveGroup === _constants.RESERVE_GROUPS.DISPOSABLE ? null : _react2.default.createElement(
                'div',
                { className: _ReserveTooltip2.default.reserveMessage },
                reservistBonusMessage
            );

            var specialConditions = function () {
                if (isSpecialCondition || canActivate) {
                    var conditions = [buildingMessage, bonusNotAppliedToReservistMessage, specialConditionMessage, challengesMessage].filter(Boolean);

                    return conditions.length ? conditions : null;
                }

                return bonusNotAppliedToReservistMessage;
            }();

            return _react2.default.createElement(
                _reactWotBootstrap.Tooltip,
                { id: this.props.id, isWide: true },
                _react2.default.createElement(
                    'div',
                    { className: className },
                    _react2.default.createElement(
                        'div',
                        { className: _ReserveTooltip2.default.header },
                        _react2.default.createElement(
                            'div',
                            { className: _ReserveTooltip2.default.button },
                            _react2.default.createElement(
                                'div',
                                { className: _ReserveTooltip2.default.thumbnail },
                                _react2.default.createElement('div', { className: imageClassName })
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _ReserveTooltip2.default.info },
                            _react2.default.createElement(
                                'p',
                                { className: _ReserveTooltip2.default.title },
                                _i18n.RESERVE_TITLES[reserveInfo.type]
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: _ReserveTooltip2.default.level },
                                (0, _i18n.LEVEL_STRING)(currentLevel)
                            ),
                            counterInfo
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _ReserveTooltip2.default.content },
                        _react2.default.createElement(_ReserveTooltipBody.ReserveTooltipBody, {
                            reserveType: this.props.reserveType,
                            reserveInfo: reserveInfo,
                            level: currentLevel
                        }),
                        specialConditions && _react2.default.createElement(
                            'div',
                            { className: _ReserveTooltip2.default.reserveMessages },
                            currentBonus.parameters && _react2.default.createElement('div', { className: _ReserveTooltip2.default.divider }),
                            specialConditions
                        ),
                        (specialConditions || currentBonus.parameters) && _react2.default.createElement('div', { className: _ReserveTooltip2.default.divider }),
                        this.getMessage()
                    )
                )
            );
        }
    }]);

    return ReserveTooltip;
}(_react2.default.Component);

ReserveTooltip.propTypes = {
    id: _propTypes2.default.string.isRequired,
    account: _propTypes2.default.object.isRequired,
    clanReserves: _propTypes2.default.object.isRequired,
    strongholdIsFrozen: _propTypes2.default.bool.isRequired,
    reserveType: _propTypes2.default.string,
    reserves: _propTypes2.default.object,
    settings: _propTypes2.default.object.isRequired
};
ReserveTooltip.MESSAGES = {
    NO_PERMISSION: function NO_PERMISSION() {
        return _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)(_ReserveTooltip2.default.statusMessage, _ReserveTooltip2.default.statusMessage__noPermission) },
            _react2.default.createElement(
                'p',
                { className: _ReserveTooltip2.default.statusText },
                _constants2.DOES_NOT_HAVE_PERMISSION
            )
        );
    },
    ACTIVATION_IS_IMPOSSIBLE: function ACTIVATION_IS_IMPOSSIBLE(reason) {
        return _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)(_ReserveTooltip2.default.statusMessage, _ReserveTooltip2.default.statusMessage__negative) },
            _react2.default.createElement(
                'p',
                { className: _ReserveTooltip2.default.status },
                _constants2.ACTIVATION_IS_IMPOSSIBLE
            ),
            _react2.default.createElement(
                'p',
                { className: _ReserveTooltip2.default.statusText },
                reason
            )
        );
    },
    DISPOSABLE: function DISPOSABLE(canActivate, reservesAreAbsent) {
        if (!canActivate) {
            return _react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)(_ReserveTooltip2.default.statusMessage, _ReserveTooltip2.default.statusMessage__noPermission) },
                _react2.default.createElement(
                    'p',
                    { className: _ReserveTooltip2.default.statusText },
                    _constants2.ACTIVATABLE_IN_BATTLE_ROOM_DOES_NOT_HAVE_PERMISSION
                )
            );
        } else if (reservesAreAbsent) {
            return _react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)(_ReserveTooltip2.default.statusMessage, _ReserveTooltip2.default.statusMessage__negative) },
                _react2.default.createElement(
                    'p',
                    { className: _ReserveTooltip2.default.status },
                    _constants2.ACTIVATABLE_IN_BATTLE_ROOM_INSTALL_IS_NOT_POSSIBLE
                ),
                _react2.default.createElement(
                    'p',
                    { className: _ReserveTooltip2.default.statusText },
                    _constants2.ACTIVATABLE_IN_BATTLE_ROOM_RESERVE_DOES_NOT_EXIST
                )
            );
        } else {
            return _react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)(_ReserveTooltip2.default.statusMessage, _ReserveTooltip2.default.statusMessage__positive) },
                _react2.default.createElement(
                    'p',
                    { className: _ReserveTooltip2.default.status },
                    _constants2.ACTIVATABLE_IN_BATTLE_ROOM_READY_TO_INSTALL
                )
            );
        }
    },
    FIRST_ACTIVE_RESERVE_IN_GROUP: function FIRST_ACTIVE_RESERVE_IN_GROUP(firstActiveReserveInGroup, canActivate, reserveType) {
        if (firstActiveReserveInGroup.type === reserveType) {
            var endTime = (0, _moment2.default)(firstActiveReserveInGroup.effectEnds);
            var timer = _react2.default.createElement(_Timer2.default, { endTime: endTime });
            return _react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)(_ReserveTooltip2.default.statusMessage, _ReserveTooltip2.default.statusMessage__positive) },
                _react2.default.createElement(
                    'p',
                    { className: _ReserveTooltip2.default.status },
                    (0, _constants2.RESERVE_IS_ACTIVATED)(timer)
                )
            );
        } else {
            if (!canActivate) {
                return ReserveTooltip.MESSAGES.NO_PERMISSION();
            } else {
                return ReserveTooltip.MESSAGES.ACTIVATION_IS_IMPOSSIBLE(_constants2.ANOTHER_RESERVE_IS_ACTIVATED);
            }
        }
    }
};
var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, _ref) {
    var id = _ref.id,
        reservesByLevel = _ref.reservesByLevel,
        _ref$reserveType = _ref.reserveType,
        reserveType = _ref$reserveType === undefined ? null : _ref$reserveType,
        _ref$reserves = _ref.reserves,
        reserves = _ref$reserves === undefined ? null : _ref$reserves;
    var clanReserves = state.clanReserves,
        account = state.account,
        settings = state.settings,
        toolbar = state.toolbar,
        clan = state.clan;

    var tooltipReserveType = reserveType || toolbar.tooltipReserveType;
    var strongholdIsFrozen = clan ? clan.industrial_resource < 0 : false;
    return {
        id: id,
        account: account,
        clanReserves: clanReserves,
        strongholdIsFrozen: strongholdIsFrozen,
        reserveType: tooltipReserveType,
        reserves: reserves || reservesByLevel[tooltipReserveType],
        settings: settings
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ReserveTooltip);

/***/ }),
/* 1351 */
/***/ (function(module, exports) {

/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */
function each(collection, fn) {
    var i      = 0,
        length = collection.length,
        cont;

    for(i; i < length; i++) {
        cont = fn(collection[i], i);
        if(cont === false) {
            break; //allow early exit
        }
    }
}

/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */
function isArray(target) {
    return Object.prototype.toString.apply(target) === '[object Array]';
}

/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */
function isFunction(target) {
    return typeof target === 'function';
}

module.exports = {
    isFunction : isFunction,
    isArray : isArray,
    each : each
};


/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useCallbackOnEsc = undefined;

var _react = __webpack_require__(0);

var _EscManager = __webpack_require__(2232);

var _useEvent = __webpack_require__(2233);

var useCallbackOnEsc = exports.useCallbackOnEsc = function useCallbackOnEsc(callback) {
    var eventCallback = (0, _useEvent.useEvent)(callback);

    (0, _react.useEffect)(function () {
        _EscManager.EscManager.getInstance().addCallback(eventCallback);

        return function () {
            _EscManager.EscManager.getInstance().removeCallback(eventCallback);
        };
    }, []);
};

/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.useIsTimestampExpired = useIsTimestampExpired;

var _react = __webpack_require__(0);

var _reactRedux = __webpack_require__(7);

var _constants = __webpack_require__(4);

var getIsTimestampExpired = function getIsTimestampExpired(timestamp, delta) {
    return timestamp <= Date.now() + delta;
};

function useIsTimestampExpired(timestamp) {
    var _useSelector = (0, _reactRedux.useSelector)(function (state) {
        return state.client;
    }),
        deltaTime = _useSelector.deltaTime;

    var intervalRef = (0, _react.useRef)();

    var _useState = (0, _react.useState)(getIsTimestampExpired(timestamp, deltaTime)),
        _useState2 = _slicedToArray(_useState, 2),
        isTimestampExpired = _useState2[0],
        setIsTimestampExpired = _useState2[1];

    (0, _react.useEffect)(function () {
        var intervalId = setInterval(function () {
            return setIsTimestampExpired(getIsTimestampExpired(timestamp, deltaTime));
        }, _constants.ONE_SECOND);
        intervalRef.current = intervalId;
        return function () {
            return clearInterval(intervalId);
        };
    }, [deltaTime, timestamp]);

    (0, _react.useEffect)(function () {
        if (isTimestampExpired) clearInterval(intervalRef.current);
    }, [isTimestampExpired]);

    return getIsTimestampExpired(timestamp, deltaTime);
}

/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sendLogs = exports.createPartnerID = undefined;

var _uuid = __webpack_require__(2234);

var _reactWotBootstrap = __webpack_require__(5);

var WoTClientMessageCallbacks = {};
var SEND_LOGS = 'send_logs';

var createPartnerID = exports.createPartnerID = function createPartnerID() {
    return (0, _uuid.v4)();
};

var sendLogs = exports.sendLogs = function sendLogs(feature, group, action, logLevel, params) {
    return new Promise(function (resolve, reject) {
        var commandData = {
            command: 'ui_logging',
            params: {
                action: 'log',
                feature: feature,
                group: group,
                log_action: action,
                log_level: logLevel,
                params: params
            },
            web_id: SEND_LOGS
        };

        WoTClientMessageCallbacks[commandData.web_id] = function (data) {
            if (Object.keys(data).length) {
                resolve(data);
            } else {
                reject();
            }
        };
        (0, _reactWotBootstrap.sendCommand)(commandData);
    });
};

/***/ }),
/* 1355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = rng;
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
    // find the complete implementation of crypto (msCrypto) on IE11.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}

/***/ }),
/* 1356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DNS */
/* unused harmony export URL */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stringify_js__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parse_js__ = __webpack_require__(1357);



function stringToBytes(str) {
  str = unescape(encodeURIComponent(str)); // UTF8 escape

  var bytes = [];

  for (var i = 0; i < str.length; ++i) {
    bytes.push(str.charCodeAt(i));
  }

  return bytes;
}

var DNS = '6ba7b810-9dad-11d1-80b4-00c04fd430c8';
var URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8';
/* harmony default export */ __webpack_exports__["a"] = (function (name, version, hashfunc) {
  function generateUUID(value, namespace, buf, offset) {
    if (typeof value === 'string') {
      value = stringToBytes(value);
    }

    if (typeof namespace === 'string') {
      namespace = Object(__WEBPACK_IMPORTED_MODULE_1__parse_js__["a" /* default */])(namespace);
    }

    if (namespace.length !== 16) {
      throw TypeError('Namespace must be array-like (16 iterable integer values, 0-255)');
    } // Compute hash of namespace and value, Per 4.3
    // Future: Use spread syntax when supported on all platforms, e.g. `bytes =
    // hashfunc([...namespace, ... value])`


    var bytes = new Uint8Array(16 + value.length);
    bytes.set(namespace);
    bytes.set(value, namespace.length);
    bytes = hashfunc(bytes);
    bytes[6] = bytes[6] & 0x0f | version;
    bytes[8] = bytes[8] & 0x3f | 0x80;

    if (buf) {
      offset = offset || 0;

      for (var i = 0; i < 16; ++i) {
        buf[offset + i] = bytes[i];
      }

      return buf;
    }

    return Object(__WEBPACK_IMPORTED_MODULE_0__stringify_js__["a" /* default */])(bytes);
  } // Function#name is not settable on some platforms (#270)


  try {
    generateUUID.name = name; // eslint-disable-next-line no-empty
  } catch (err) {} // For CommonJS default export support


  generateUUID.DNS = DNS;
  generateUUID.URL = URL;
  return generateUUID;
});

/***/ }),
/* 1357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__validate_js__ = __webpack_require__(296);


function parse(uuid) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__validate_js__["a" /* default */])(uuid)) {
    throw TypeError('Invalid UUID');
  }

  var v;
  var arr = new Uint8Array(16); // Parse ########-....-....-....-............

  arr[0] = (v = parseInt(uuid.slice(0, 8), 16)) >>> 24;
  arr[1] = v >>> 16 & 0xff;
  arr[2] = v >>> 8 & 0xff;
  arr[3] = v & 0xff; // Parse ........-####-....-....-............

  arr[4] = (v = parseInt(uuid.slice(9, 13), 16)) >>> 8;
  arr[5] = v & 0xff; // Parse ........-....-####-....-............

  arr[6] = (v = parseInt(uuid.slice(14, 18), 16)) >>> 8;
  arr[7] = v & 0xff; // Parse ........-....-....-####-............

  arr[8] = (v = parseInt(uuid.slice(19, 23), 16)) >>> 8;
  arr[9] = v & 0xff; // Parse ........-....-....-....-############
  // (Use "/" to avoid 32-bit truncation when bit-shifting high-order bytes)

  arr[10] = (v = parseInt(uuid.slice(24, 36), 16)) / 0x10000000000 & 0xff;
  arr[11] = v / 0x100000000 & 0xff;
  arr[12] = v >>> 24 & 0xff;
  arr[13] = v >>> 16 & 0xff;
  arr[14] = v >>> 8 & 0xff;
  arr[15] = v & 0xff;
  return arr;
}

/* harmony default export */ __webpack_exports__["a"] = (parse);

/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/LandingClans/components/Card/components/Back/images/banner.c46da848.png";

/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _Flag = __webpack_require__(2258);

var _Flag2 = _interopRequireDefault(_Flag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Flag = function Flag(_ref) {
    var code = _ref.code;
    return _react2.default.createElement('div', { className: (0, _classnames2.default)(_Flag2.default.base, _Flag2.default['base__' + code]) });
};

Flag.propTypes = {
    code: _propTypes2.default.string.isRequired
};

exports.default = Flag;

/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CurrencyTooltip = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _reactWotBootstrap = __webpack_require__(5);

var _i18n = __webpack_require__(10);

var _constants = __webpack_require__(2309);

var _CurrencyTooltip = __webpack_require__(2310);

var _CurrencyTooltip2 = _interopRequireDefault(_CurrencyTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CurrencyTooltip = exports.CurrencyTooltip = function (_React$PureComponent) {
    _inherits(CurrencyTooltip, _React$PureComponent);

    function CurrencyTooltip() {
        _classCallCheck(this, CurrencyTooltip);

        return _possibleConstructorReturn(this, (CurrencyTooltip.__proto__ || Object.getPrototypeOf(CurrencyTooltip)).apply(this, arguments));
    }

    _createClass(CurrencyTooltip, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _reactWotBootstrap.Tooltip,
                { id: CurrencyTooltip.base_id + '_' + this.props.type },
                _react2.default.createElement(
                    'div',
                    { className: _CurrencyTooltip2.default.content },
                    _react2.default.createElement(
                        'p',
                        { className: _CurrencyTooltip2.default.subtitle },
                        _i18n.CURRENCIES[this.props.type]
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _CurrencyTooltip2.default.message },
                        _constants.NOW_IN_TREASURY,
                        '\xA0',
                        _react2.default.createElement(_reactWotBootstrap.Currency, {
                            small: true,
                            iconPosition: 'after',
                            type: this.props.type,
                            value: _react2.default.createElement(_reactIntl.FormattedNumber, { value: this.props.amount })
                        })
                    ),
                    _react2.default.createElement('span', { className: _CurrencyTooltip2.default.divider }),
                    _react2.default.createElement(
                        'p',
                        { className: _CurrencyTooltip2.default.message },
                        _constants.EARN_RESOURCES_ON_GLOBAL_MAP[this.props.type]
                    )
                )
            );
        }
    }]);

    return CurrencyTooltip;
}(_react2.default.PureComponent);

CurrencyTooltip.propTypes = {
    amount: _propTypes2.default.number.isRequired,
    type: _propTypes2.default.oneOf(Object.values(_reactWotBootstrap.Currency.TYPES)).isRequired
};
CurrencyTooltip.base_id = 'clan_panel_currency_tooltip';
exports.default = CurrencyTooltip;

/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = __webpack_require__(3);

var _reactWotBootstrap = __webpack_require__(5);

var _ButtonInbox = __webpack_require__(2311);

var _ButtonInbox2 = _interopRequireDefault(_ButtonInbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ButtonInbox = function (_React$PureComponent) {
    _inherits(ButtonInbox, _React$PureComponent);

    function ButtonInbox() {
        _classCallCheck(this, ButtonInbox);

        return _possibleConstructorReturn(this, (ButtonInbox.__proto__ || Object.getPrototypeOf(ButtonInbox)).apply(this, arguments));
    }

    _createClass(ButtonInbox, [{
        key: 'render',
        value: function render() {
            var messages = this.props.messages ? _react2.default.createElement(
                'div',
                { className: _ButtonInbox2.default.messages },
                this.props.messages > 99 ? '99+' : this.props.messages
            ) : null;
            var buttonClassName = this.props.messages > 0 ? _ButtonInbox2.default['base__new-message'] : '';

            return _react2.default.createElement(
                _reactWotBootstrap.ButtonSmall,
                {
                    type: this.props.type,
                    onClick: this.props.onClick,
                    muteClick: this.props.muteClick,
                    tooltipId: 'invites-applications-tooltip',
                    mixClassName: buttonClassName
                },
                messages,
                _react2.default.createElement('div', { className: _ButtonInbox2.default.icon }),
                _react2.default.createElement(
                    _reactWotBootstrap.Tooltip,
                    { id: 'invites-applications-tooltip' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'invites_applications_tooltip',
                        defaultMessage: '\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043E\u0442\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u044C \u0437\u0430\u044F\u0432\u043A\u0438 \u0438 \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u0432 \u0432\u0430\u0448 \u043A\u043B\u0430\u043D.'
                    })
                )
            );
        }
    }]);

    return ButtonInbox;
}(_react2.default.PureComponent);

ButtonInbox.propTypes = {
    messages: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    onClick: _propTypes2.default.func.isRequired,
    muteClick: _propTypes2.default.bool,
    type: _propTypes2.default.string
};
ButtonInbox.defaultProps = { type: 'mini' };
exports.default = ButtonInbox;

/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Navigation = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _NavigationArrow = __webpack_require__(59);

var _NavigationArrow2 = _interopRequireDefault(_NavigationArrow);

var _constants = __webpack_require__(131);

var _constants2 = __webpack_require__(43);

var _Navigation = __webpack_require__(2319);

var _Navigation2 = _interopRequireDefault(_Navigation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Navigation = exports.Navigation = function Navigation(props) {
    var disabled = props.disabled,
        disabledLeft = props.disabledLeft,
        disabledRight = props.disabledRight,
        size = props.size,
        onClick = props.onClick,
        _onMouseEnter = props.onMouseEnter,
        _onMouseLeave = props.onMouseLeave;


    return _react2.default.createElement(
        'div',
        { className: _Navigation2.default.base },
        _react2.default.createElement(
            'div',
            {
                className: _Navigation2.default.arrow,
                onMouseEnter: function onMouseEnter(e) {
                    return _onMouseEnter && _onMouseEnter(e, _constants2.NAVIGATION_DIRECTION.LEFT);
                },
                onMouseLeave: function onMouseLeave(e) {
                    return _onMouseLeave && _onMouseLeave(e, _constants2.NAVIGATION_DIRECTION.LEFT);
                }
            },
            _react2.default.createElement(_NavigationArrow2.default, {
                type: _constants.ARROW_TYPES.left,
                size: size,
                disabled: disabled || disabledLeft,
                handleClick: function handleClick(e) {
                    return onClick(e, _constants2.NAVIGATION_DIRECTION.LEFT);
                }
            })
        ),
        _react2.default.createElement(
            'div',
            {
                className: _Navigation2.default.arrow,
                onMouseEnter: function onMouseEnter(e) {
                    return _onMouseEnter && _onMouseEnter(e, _constants2.NAVIGATION_DIRECTION.RIGHT);
                },
                onMouseLeave: function onMouseLeave(e) {
                    return _onMouseLeave && _onMouseLeave(e, _constants2.NAVIGATION_DIRECTION.RIGHT);
                }
            },
            _react2.default.createElement(_NavigationArrow2.default, {
                type: _constants.ARROW_TYPES.right,
                size: size,
                disabled: disabled || disabledRight,
                handleClick: function handleClick(e) {
                    return onClick(e, _constants2.NAVIGATION_DIRECTION.RIGHT);
                }
            })
        )
    );
};

Navigation.propTypes = {
    disabled: _propTypes2.default.bool,
    disabledLeft: _propTypes2.default.bool,
    disabledRight: _propTypes2.default.bool,
    size: _propTypes2.default.oneOf(Object.values(_constants.ARROW_SIZES)),
    onClick: _propTypes2.default.func.isRequired,
    onMouseEnter: _propTypes2.default.func,
    onMouseLeave: _propTypes2.default.func
};

Navigation.defaultProps = {
    disabled: false,
    disabledLeft: false,
    disabledRight: false,
    size: _constants.ARROW_SIZES.big
};

/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CopyrightInfo = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

var _reactWotBootstrap = __webpack_require__(5);

var _datetime = __webpack_require__(13);

var _constants = __webpack_require__(43);

var _CopyrightInfo = __webpack_require__(2320);

var _CopyrightInfo2 = _interopRequireDefault(_CopyrightInfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CopyrightInfo = exports.CopyrightInfo = function CopyrightInfo(props) {
    var onContextMenu = function onContextMenu() {
        (0, _reactWotBootstrap.userContextMenu)(props.author_id, props.author_name);
    };

    var time = (0, _moment2.default)(props.created_at * 1000);
    if ((0, _datetime.isTodayDay)(time)) {
        time = (0, _datetime.getTodayTime)(time);
    } else if ((0, _datetime.isYesterdayDay)(time)) {
        time = (0, _datetime.getYesterdayTime)(time);
    } else {
        time = (0, _datetime.getCustomDateTime)(time);
    }

    var memberStatusClassNames = (0, _classnames2.default)(_CopyrightInfo2.default.memberStatus, _CopyrightInfo2.default['memberStatus__' + props.author_status], props.author_is_friend && _CopyrightInfo2.default.memberStatus__isFriend);

    var timeClassNames = (0, _classnames2.default)(_CopyrightInfo2.default.time, props.timeClassName);

    return _react2.default.createElement(
        'div',
        { className: _CopyrightInfo2.default.base },
        props.author_role && _react2.default.createElement(
            'span',
            { 'data-tip': true, 'data-for': '' + _constants.TOOLTIP_IDS.AUTHOR_ROLE + props.message_id },
            _react2.default.createElement(_reactWotBootstrap.Role, { role: props.author_role })
        ),
        _react2.default.createElement(
            'span',
            {
                className: memberStatusClassNames,
                onContextMenu: onContextMenu,
                'data-tip': true, 'data-for': props.author_role ? null : _constants.TOOLTIP_IDS.OUT_OF_CLAN
            },
            _react2.default.createElement(_reactWotBootstrap.Member, {
                name: props.author_name,
                isOwn: props.author_id === props.accountId
            })
        ),
        _react2.default.createElement(
            'span',
            { className: timeClassNames },
            time
        ),
        props.group_type === _constants.GROUP_LIST.COMMAND_STAFF && _react2.default.createElement('span', {
            className: _CopyrightInfo2.default.lock,
            'data-tip': true, 'data-for': _constants.TOOLTIP_IDS.LOCKED_ANNOUNCEMENT
        })
    );
};

CopyrightInfo.propTypes = {
    message_id: _propTypes2.default.number.isRequired,
    created_at: _propTypes2.default.number.isRequired,
    author_id: _propTypes2.default.number.isRequired,
    author_name: _propTypes2.default.string.isRequired,
    author_status: _propTypes2.default.string.isRequired,
    accountId: _propTypes2.default.number.isRequired,

    author_role: _propTypes2.default.string,
    author_is_friend: _propTypes2.default.bool,
    group_type: _propTypes2.default.string,
    timeClassName: _propTypes2.default.string
};

/***/ }),
/* 1364 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Footer_base--3EEAC","base__edit":"Footer_base__edit--5ytuk","baseEdit":"Footer_base__edit--5ytuk","button":"Footer_button--mjCUZ","button__right":"Footer_button__right--3GqVT","buttonRight":"Footer_button__right--3GqVT","buttonText":"Footer_buttonText--krHy8"};

/***/ }),
/* 1365 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"ClanLandingReserves_base--26SKz","header":"ClanLandingReserves_header--350b1","header__fullSize":"ClanLandingReserves_header__fullSize--4gSVe","headerFullSize":"ClanLandingReserves_header__fullSize--4gSVe","reservesWrapper":"ClanLandingReserves_reservesWrapper--3J9Dh","reserveContainer":"ClanLandingReserves_reserveContainer--34_4r","progressContainer":"ClanLandingReserves_progressContainer--3raGB","reserveImage":"ClanLandingReserves_reserveImage--IL8MI","reserveCaption":"ClanLandingReserves_reserveCaption--2AaMp","blankImage":"ClanLandingReserves_blankImage--S41g0"};

/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RULE_FRAGS = exports.RULE_EXP = exports.RULE_FULL_DAMAGE = exports.REWARD_TAKEN = exports.DONE_DESCRIPTION = exports.DONE = exports.REWARD = exports.LIMITS_DESCRIPTION = exports.LIMITS = exports.TASK = exports.TASK_COMPLETE_PREVIOUS = exports.TASK_TAKE_PREV_REWARD = exports.TASK_NOT_AVAILABLE = exports.PENDING = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _helpers = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len, react/no-multi-comp */

var PENDING = exports.PENDING = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.progressbar_tooltip.pending',
    defaultMessage: '\u041E\u0436\u0438\u0434\u0430\u043D\u0438\u0435 \u043D\u0430\u0447\u0438\u0441\u043B\u0435\u043D\u0438\u044F \u043D\u0430\u0433\u0440\u0430\u0434\u044B'
});

var TASK_NOT_AVAILABLE = exports.TASK_NOT_AVAILABLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.progressbar_tooltip.task_not_available',
    defaultMessage: '\u0417\u0430\u0434\u0430\u0447\u0430 \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430'
});

var TASK_TAKE_PREV_REWARD = exports.TASK_TAKE_PREV_REWARD = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.progressbar_tooltip.task_take_prev_reward',
    defaultMessage: '\u041D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0437\u0430\u0431\u0440\u0430\u0442\u044C \u043D\u0430\u0433\u0440\u0430\u0434\u044B \u0437\u0430 \u043F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0438\u0435 \u0437\u0430\u0434\u0430\u0447\u0438.'
});

var TASK_COMPLETE_PREVIOUS = exports.TASK_COMPLETE_PREVIOUS = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.progressbar_tooltip.task_complete_previous',
    defaultMessage: '\u041D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0437\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C \u043F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0443\u044E \u0437\u0430\u0434\u0430\u0447\u0443.'
});

var TASK = exports.TASK = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.progressbar_tooltip.task',
    defaultMessage: '\u0417\u0430\u0434\u0430\u0447\u0430'
});

var LIMITS = exports.LIMITS = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.progressbar_tooltip.limits',
    defaultMessage: '\u041E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u044F'
});

var LIMITS_DESCRIPTION = exports.LIMITS_DESCRIPTION = function LIMITS_DESCRIPTION(levelFrom, levelTo, isClanSquad) {
    if (levelFrom === levelTo) {
        if (isClanSquad) {
            return _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'clan_landing.progressbar_tooltip.limits_description_one_tier_squad',
                defaultMessage: '\u0422\u0435\u0445\u043D\u0438\u043A\u0430 {vehicleLevel} \u0443\u0440\u043E\u0432\u043D\u044F. \u0412\u043E \u0432\u0437\u0432\u043E\u0434\u0435/\u043E\u0442\u0440\u044F\u0434\u0435 \u0434\u043E\u043B\u0436\u0435\u043D \u0431\u044B\u0442\u044C \u0441\u043E\u043A\u043B\u0430\u043D\u043E\u0432\u0435\u0446.',
                values: {
                    vehicleLevel: (0, _helpers.toRoman)(levelFrom)
                }
            });
        }
        return _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'clan_landing.progressbar_tooltip.limits_description_one_tier',
            defaultMessage: '\u0422\u0435\u0445\u043D\u0438\u043A\u0430 {vehicleLevel} \u0443\u0440\u043E\u0432\u043D\u044F.',
            values: {
                vehicleLevel: (0, _helpers.toRoman)(levelFrom)
            }
        });
    }
    if (isClanSquad) {
        return _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'clan_landing.progressbar_tooltip.limits_description_tiers_range_squad',
            defaultMessage: '\u0422\u0435\u0445\u043D\u0438\u043A\u0430 {vehicleLevelFrom}-{vehicleLevelTo} \u0443\u0440\u043E\u0432\u043D\u0435\u0439. \u0412\u043E \u0432\u0437\u0432\u043E\u0434\u0435/\u043E\u0442\u0440\u044F\u0434\u0435 \u0434\u043E\u043B\u0436\u0435\u043D \u0431\u044B\u0442\u044C \u0441\u043E\u043A\u043B\u0430\u043D\u043E\u0432\u0435\u0446.',
            values: {
                vehicleLevelFrom: (0, _helpers.toRoman)(levelFrom),
                vehicleLevelTo: (0, _helpers.toRoman)(levelTo)
            }
        });
    }

    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'clan_landing.progressbar_tooltip.limits_description_tiers_range',
        defaultMessage: '\u0422\u0435\u0445\u043D\u0438\u043A\u0430 {vehicleLevelFrom}-{vehicleLevelTo} \u0443\u0440\u043E\u0432\u043D\u0435\u0439.',
        values: {
            vehicleLevelFrom: (0, _helpers.toRoman)(levelFrom),
            vehicleLevelTo: (0, _helpers.toRoman)(levelTo)
        }
    });
};

var REWARD = exports.REWARD = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.progressbar_tooltip.reward',
    defaultMessage: '\u041D\u0430\u0433\u0440\u0430\u0434\u0430'
});

var DONE = exports.DONE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.progressbar_tooltip.done',
    defaultMessage: '\u0417\u0430\u0434\u0430\u0447\u0430 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0430'
});

var DONE_DESCRIPTION = exports.DONE_DESCRIPTION = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.progressbar_tooltip.done_description',
    defaultMessage: '\u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0437\u0430\u0431\u0440\u0430\u0442\u044C \u043D\u0430\u0433\u0440\u0430\u0434\u0443.'
});

var REWARD_TAKEN = exports.REWARD_TAKEN = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.progressbar_tooltip.reward_taken',
    defaultMessage: '\u041D\u0430\u0433\u0440\u0430\u0434\u0430 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0430'
});

var RULE_FULL_DAMAGE = exports.RULE_FULL_DAMAGE = function RULE_FULL_DAMAGE(value, isSoloAvailable) {
    if (isSoloAvailable) {
        return _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'clan_landing.progressbar_tooltip.rule_full_damage_solo_and_squad',
            defaultMessage: '\u041D\u0430\u043D\u0435\u0441\u0442\u0438 \u0438\u043B\u0438 \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0438\u0442\u044C \u043D\u0430\u043D\u0435\u0441\u0435\u043D\u0438\u0435 {value} \u0435\u0434. \u0443\u0440\u043E\u043D\u0430 \u0437\u0430 \u0431\u043E\u0439 \u0432 \u043E\u0434\u0438\u043D\u043E\u0447\u043A\u0443/\u0432\u043E \u0432\u0437\u0432\u043E\u0434\u0435 \u0438\u043B\u0438 \u043F\u043E\u0431\u0435\u0434\u0438\u0442\u044C \u0432 \u0441\u043E\u0441\u0442\u0430\u0432\u0435 \u043E\u0442\u0440\u044F\u0434\u0430.',
            values: {
                value: value
            }
        });
    }

    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'clan_landing.progressbar_tooltip.rule_full_damage_squad',
        defaultMessage: '\u041D\u0430\u043D\u0435\u0441\u0442\u0438 \u0438\u043B\u0438 \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0438\u0442\u044C \u043D\u0430\u043D\u0435\u0441\u0435\u043D\u0438\u0435 {value} \u0435\u0434. \u0443\u0440\u043E\u043D\u0430 \u0437\u0430 \u0431\u043E\u0439 \u0432 \u0441\u043E\u0441\u0442\u0430\u0432\u0435 \u0432\u0437\u0432\u043E\u0434\u0430 \u0438\u043B\u0438 \u043F\u043E\u0431\u0435\u0434\u0438\u0442\u044C \u0432 \u0441\u043E\u0441\u0442\u0430\u0432\u0435 \u043E\u0442\u0440\u044F\u0434\u0430.',
        values: {
            value: value
        }
    });
};

var RULE_EXP = exports.RULE_EXP = function RULE_EXP(value, isSoloAvailable) {
    if (isSoloAvailable) {
        return _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'clan_landing.progressbar_tooltip.rule_exp_solo_and_squad',
            defaultMessage: '\u0417\u0430\u0440\u0430\u0431\u043E\u0442\u0430\u0442\u044C {value} \xAB\u0447\u0438\u0441\u0442\u043E\u0433\u043E\xBB \u043E\u043F\u044B\u0442\u0430 \u0437\u0430 \u0431\u043E\u0439 \u0432 \u043E\u0434\u0438\u043D\u043E\u0447\u043A\u0443/\u0432\u043E \u0432\u0437\u0432\u043E\u0434\u0435 \u0438\u043B\u0438 \u043F\u043E\u0431\u0435\u0434\u0438\u0442\u044C \u0432 \u0441\u043E\u0441\u0442\u0430\u0432\u0435 \u043E\u0442\u0440\u044F\u0434\u0430.',
            values: {
                value: value
            }
        });
    }

    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'clan_landing.progressbar_tooltip.rule_exp_squad',
        defaultMessage: '\u0417\u0430\u0440\u0430\u0431\u043E\u0442\u0430\u0442\u044C {value} \xAB\u0447\u0438\u0441\u0442\u043E\u0433\u043E\xBB \u043E\u043F\u044B\u0442\u0430 \u0437\u0430 \u0431\u043E\u0439 \u0432 \u0441\u043E\u0441\u0442\u0430\u0432\u0435 \u0432\u0437\u0432\u043E\u0434\u0430 \u0438\u043B\u0438 \u043F\u043E\u0431\u0435\u0434\u0438\u0442\u044C \u0432 \u0441\u043E\u0441\u0442\u0430\u0432\u0435 \u043E\u0442\u0440\u044F\u0434\u0430.',
        values: {
            value: value
        }
    });
};

var RULE_FRAGS = exports.RULE_FRAGS = function RULE_FRAGS(value, isSoloAvailable) {
    if (isSoloAvailable) {
        return _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'clan_landing.progressbar_tooltip.rule_frags_solo_and_squad',
            defaultMessage: '\u0423\u043D\u0438\u0447\u0442\u043E\u0436\u0438\u0442\u044C {value} \u0435\u0434. \u0442\u0435\u0445\u043D\u0438\u043A\u0438 \u0437\u0430 \u0431\u043E\u0439 \u0432 \u043E\u0434\u0438\u043D\u043E\u0447\u043A\u0443/\u0432\u043E \u0432\u0437\u0432\u043E\u0434\u0435 \u0438\u043B\u0438 \u043F\u043E\u0431\u0435\u0434\u0438\u0442\u044C \u0432 \u0441\u043E\u0441\u0442\u0430\u0432\u0435 \u043E\u0442\u0440\u044F\u0434\u0430.',
            values: {
                value: value
            }
        });
    }

    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'clan_landing.progressbar_tooltip.rule_frags_squad',
        defaultMessage: '\u0423\u043D\u0438\u0447\u0442\u043E\u0436\u0438\u0442\u044C {value} \u0435\u0434. \u0442\u0435\u0445\u043D\u0438\u043A\u0438 \u0437\u0430 \u0431\u043E\u0439 \u0432 \u0441\u043E\u0441\u0442\u0430\u0432\u0435 \u0432\u0437\u0432\u043E\u0434\u0430 \u0438\u043B\u0438 \u043F\u043E\u0431\u0435\u0434\u0438\u0442\u044C \u0432 \u0441\u043E\u0441\u0442\u0430\u0432\u0435 \u043E\u0442\u0440\u044F\u0434\u0430.',
        values: {
            value: value
        }
    });
};

/***/ }),
/* 1367 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tooltip-root":"ClanSupplyTooltips_tooltip-root--3sTG4","tooltipRoot":"ClanSupplyTooltips_tooltip-root--3sTG4","tooltip-root__show":"ClanSupplyTooltips_tooltip-root__show--23NyA","tooltipRootShow":"ClanSupplyTooltips_tooltip-root__show--23NyA","tooltip-body":"ClanSupplyTooltips_tooltip-body--28pYM","tooltipBody":"ClanSupplyTooltips_tooltip-body--28pYM","tooltip-wrapper":"ClanSupplyTooltips_tooltip-wrapper--1FqYc","tooltipWrapper":"ClanSupplyTooltips_tooltip-wrapper--1FqYc","tooltip-content":"ClanSupplyTooltips_tooltip-content--BVElf","tooltipContent":"ClanSupplyTooltips_tooltip-content--BVElf","tooltip-title":"ClanSupplyTooltips_tooltip-title--1MXJf","tooltipTitle":"ClanSupplyTooltips_tooltip-title--1MXJf","tooltip-subtitle":"ClanSupplyTooltips_tooltip-subtitle--2Ua7X","tooltipSubtitle":"ClanSupplyTooltips_tooltip-subtitle--2Ua7X","tooltip-message":"ClanSupplyTooltips_tooltip-message--2pQaU","tooltipMessage":"ClanSupplyTooltips_tooltip-message--2pQaU","tooltip-warning":"ClanSupplyTooltips_tooltip-warning--Grp98","tooltipWarning":"ClanSupplyTooltips_tooltip-warning--Grp98","tooltip-divider":"ClanSupplyTooltips_tooltip-divider--8Y5pL","tooltipDivider":"ClanSupplyTooltips_tooltip-divider--8Y5pL","tooltip-highlight":"ClanSupplyTooltips_tooltip-highlight--2KnWM","tooltipHighlight":"ClanSupplyTooltips_tooltip-highlight--2KnWM","tooltip-ribbon":"ClanSupplyTooltips_tooltip-ribbon--1LVG7","tooltipRibbon":"ClanSupplyTooltips_tooltip-ribbon--1LVG7","tooltip-statusMessage":"ClanSupplyTooltips_tooltip-statusMessage--2ErQV","tooltipStatusMessage":"ClanSupplyTooltips_tooltip-statusMessage--2ErQV","tooltip-statusMessage__positive":"ClanSupplyTooltips_tooltip-statusMessage__positive--33MgB","tooltipStatusMessagePositive":"ClanSupplyTooltips_tooltip-statusMessage__positive--33MgB","tooltip-status":"ClanSupplyTooltips_tooltip-status--2q95p","tooltipStatus":"ClanSupplyTooltips_tooltip-status--2q95p","tooltip-statusMessage__negative":"ClanSupplyTooltips_tooltip-statusMessage__negative--3r4jd","tooltipStatusMessageNegative":"ClanSupplyTooltips_tooltip-statusMessage__negative--3r4jd","tooltip-statusMessage__noPermission":"ClanSupplyTooltips_tooltip-statusMessage__noPermission--2tftZ","tooltipStatusMessageNoPermission":"ClanSupplyTooltips_tooltip-statusMessage__noPermission--2tftZ","tooltip-status__positive":"ClanSupplyTooltips_tooltip-status__positive--8tpwK","tooltipStatusPositive":"ClanSupplyTooltips_tooltip-status__positive--8tpwK","tooltip-status__negative":"ClanSupplyTooltips_tooltip-status__negative--1nS25","tooltipStatusNegative":"ClanSupplyTooltips_tooltip-status__negative--1nS25","tooltip-statusText":"ClanSupplyTooltips_tooltip-statusText--1WVON","tooltipStatusText":"ClanSupplyTooltips_tooltip-statusText--1WVON","wrapper":"ClanSupplyTooltips_wrapper--3f5W_","title":"ClanSupplyTooltips_title--2ucaf","description":"ClanSupplyTooltips_description--1rPFO","restrictions":"ClanSupplyTooltips_restrictions--2kyuS","infoIcon":"ClanSupplyTooltips_infoIcon--239nA","vehicleTier":"ClanSupplyTooltips_vehicleTier--2MSsW","reward":"ClanSupplyTooltips_reward--1yqtq","currency":"ClanSupplyTooltips_currency--2mCgv","currency__tourCoin":"ClanSupplyTooltips_currency__tourCoin--1Rpkc","currencyTourCoin":"ClanSupplyTooltips_currency__tourCoin--1Rpkc","currency__industrialResource":"ClanSupplyTooltips_currency__industrialResource--1_BUw","currencyIndustrialResource":"ClanSupplyTooltips_currency__industrialResource--1_BUw","divider":"ClanSupplyTooltips_divider--1HVL1","iconPlus":"ClanSupplyTooltips_iconPlus--1zzkV","done":"ClanSupplyTooltips_done--2g9UL"};

/***/ }),
/* 1368 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"ClanSupplyFooter_base--30M6T","base__status-default":"ClanSupplyFooter_base__status-default--1xUJ-","baseStatusDefault":"ClanSupplyFooter_base__status-default--1xUJ-","base__status-takePrize":"ClanSupplyFooter_base__status-takePrize--1tnPx","baseStatusTakePrize":"ClanSupplyFooter_base__status-takePrize--1tnPx","base__status-success":"ClanSupplyFooter_base__status-success--2CUhP","baseStatusSuccess":"ClanSupplyFooter_base__status-success--2CUhP","base__status-canExamine":"ClanSupplyFooter_base__status-canExamine--1zKNg","baseStatusCanExamine":"ClanSupplyFooter_base__status-canExamine--1zKNg","canExamineEffect":"ClanSupplyFooter_canExamineEffect--HzmfT","iconStatus":"ClanSupplyFooter_iconStatus--1NR4l","text":"ClanSupplyFooter_text--3Rurj","text__success":"ClanSupplyFooter_text__success--1XrR9","textSuccess":"ClanSupplyFooter_text__success--1XrR9","typeIcon":"ClanSupplyFooter_typeIcon--9gDeA","typeIcon__lightTank":"ClanSupplyFooter_typeIcon__lightTank--1prux","typeIconLightTank":"ClanSupplyFooter_typeIcon__lightTank--1prux","typeIcon__mediumTank":"ClanSupplyFooter_typeIcon__mediumTank--2ATTs","typeIconMediumTank":"ClanSupplyFooter_typeIcon__mediumTank--2ATTs","typeIcon__heavyTank":"ClanSupplyFooter_typeIcon__heavyTank--25G72","typeIconHeavyTank":"ClanSupplyFooter_typeIcon__heavyTank--25G72","typeIcon__AT-SPG":"ClanSupplyFooter_typeIcon__AT-SPG--3usNN","typeIconAtSpg":"ClanSupplyFooter_typeIcon__AT-SPG--3usNN","typeIcon__SPG":"ClanSupplyFooter_typeIcon__SPG--SMViL","typeIconSpg":"ClanSupplyFooter_typeIcon__SPG--SMViL","vehicleLevel":"ClanSupplyFooter_vehicleLevel--1GyLb","vehicleTitle":"ClanSupplyFooter_vehicleTitle--2qpzL"};

/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.subscribeToChannel = subscribeToChannel;
exports.unsubscribeFromChannel = unsubscribeFromChannel;
exports.parseHermodJSONData = parseHermodJSONData;

var _client2web = __webpack_require__(126);

var _web_to_client = __webpack_require__(12);

function subscribeToChannel(channel, callback) {
    (0, _web_to_client.subscribeToChannel)(channel);
    (0, _client2web.addWOTReactiveListener)(channel, callback);
}

function unsubscribeFromChannel(channel, callback) {
    (0, _web_to_client.unsubscribeFromChannel)(channel);
    (0, _client2web.removeWOTReactiveListener)(channel, callback);
}

function parseHermodJSONData(_ref) {
    var c2wEventData = _ref.data;

    var jsonString = c2wEventData && c2wEventData.data;
    try {
        return JSON.parse(jsonString);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('>> WGSH cannot parse hermod data', jsonString);
        return null;
    }
}

/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var ArrowDirection = exports.ArrowDirection = {
    Back: 'back',
    Forward: 'forward'
};

/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NotEarnedResourceTooltip = exports.EarnedResourceTooltipContent = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactIntl = __webpack_require__(3);

var _reactWotBootstrap = __webpack_require__(5);

var _FormattedIndustrialResource = __webpack_require__(2378);

var _FormattedIndustrialResource2 = _interopRequireDefault(_FormattedIndustrialResource);

var _EarnedResourceTooltip = __webpack_require__(2379);

var _EarnedResourceTooltip2 = _interopRequireDefault(_EarnedResourceTooltip);

var _translations = __webpack_require__(570);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-multi-comp */
var TITLE_BY_PERIOD = {
    1: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'clanmanagement.tooltips.earned_resource_body1_1_day',
        defaultMessage: '\u0417\u0430 1 \u0434\u0435\u043D\u044C'
    }),
    7: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'clanmanagement.tooltips.earned_resource_body1_7_days',
        defaultMessage: '\u0417\u0430 7 \u0434\u043D\u0435\u0439'
    }),
    28: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'clanmanagement.tooltips.earned_resource_body1_28_days',
        defaultMessage: '\u0417\u0430 28 \u0434\u043D\u0435\u0439'
    })
};

var EarnedResourceTooltipContent = exports.EarnedResourceTooltipContent = function EarnedResourceTooltipContent(props) {
    var _props$statistics = props.statistics,
        industrialResourceEarnedAsClanmate = _props$statistics.industrialResourceEarnedAsClanmate,
        industrialResourceEarnedAsLegionary = _props$statistics.industrialResourceEarnedAsLegionary,
        industrialResourceEarnedInRandomInClanmatePlatoon = _props$statistics.industrialResourceEarnedInRandomInClanmatePlatoon,
        industrialResourceEarnedInRandom = _props$statistics.industrialResourceEarnedInRandom,
        industrialResourceForClanPurchaseProduct = _props$statistics.industrialResourceForClanPurchaseProduct,
        industrialResourceClansupply = _props$statistics.industrialResourceClansupply,
        industrialResource = _props$statistics.industrialResource,
        industrialResourceWhole = _props$statistics.industrialResourceWhole;


    return _react2.default.createElement(
        _reactWotBootstrap.TooltipBody,
        null,
        _react2.default.createElement(
            _reactWotBootstrap.TooltipSubtitle,
            null,
            _translations.EARNED_RESOURCE_TOOLTIP_TITLE
        ),
        _react2.default.createElement(
            'div',
            { className: _EarnedResourceTooltip2.default.base },
            _react2.default.createElement(
                'div',
                { className: _EarnedResourceTooltip2.default.period },
                _react2.default.createElement(
                    'div',
                    { className: _EarnedResourceTooltip2.default.item },
                    _react2.default.createElement(
                        'div',
                        { className: _EarnedResourceTooltip2.default.key },
                        _react2.default.createElement(
                            'span',
                            { className: _EarnedResourceTooltip2.default.keyInner },
                            TITLE_BY_PERIOD[props.selectedPeriod]
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _EarnedResourceTooltip2.default.value },
                        _react2.default.createElement(_FormattedIndustrialResource2.default, { size: 'small', amount: industrialResource })
                    )
                )
            ),
            _react2.default.createElement(
                'div',
                { className: _EarnedResourceTooltip2.default.block },
                _react2.default.createElement('div', { className: (0, _classnames2.default)(_EarnedResourceTooltip2.default.icon, _EarnedResourceTooltip2.default['icon__strongholds']) }),
                _react2.default.createElement(
                    'div',
                    { className: _EarnedResourceTooltip2.default.content },
                    _react2.default.createElement(
                        'div',
                        { className: _EarnedResourceTooltip2.default.caption },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'clanmanagement.tooltips.earned_resource_body2',
                            defaultMessage: '\u0412\u044B\u043B\u0430\u0437\u043A\u0438 \u0438 \u041D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u044F'
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'div',
                            { className: _EarnedResourceTooltip2.default.item },
                            _react2.default.createElement(
                                'div',
                                { className: _EarnedResourceTooltip2.default.key },
                                _react2.default.createElement(
                                    'span',
                                    { className: _EarnedResourceTooltip2.default.keyInner },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'clanmanagement.tooltips.earned_resource_body3',
                                        defaultMessage: '\u0421 \u043A\u043B\u0430\u043D\u043E\u043C'
                                    })
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _EarnedResourceTooltip2.default.value },
                                _react2.default.createElement(_FormattedIndustrialResource2.default, {
                                    size: 'small',
                                    amount: industrialResourceEarnedAsClanmate
                                })
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _EarnedResourceTooltip2.default.item },
                            _react2.default.createElement(
                                'div',
                                { className: _EarnedResourceTooltip2.default.key },
                                _react2.default.createElement(
                                    'span',
                                    { className: _EarnedResourceTooltip2.default.keyInner },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'clanmanagement.tooltips.earned_resource_body4',
                                        defaultMessage: '\u041B\u0435\u0433\u0438\u043E\u043D\u0435\u0440\u043E\u043C'
                                    })
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _EarnedResourceTooltip2.default.value },
                                _react2.default.createElement(_FormattedIndustrialResource2.default, {
                                    size: 'small',
                                    amount: industrialResourceEarnedAsLegionary
                                })
                            )
                        )
                    )
                )
            ),
            _react2.default.createElement(
                'div',
                { className: _EarnedResourceTooltip2.default.block },
                _react2.default.createElement('div', { className: (0, _classnames2.default)(_EarnedResourceTooltip2.default.icon, _EarnedResourceTooltip2.default['icon__random']) }),
                _react2.default.createElement(
                    'div',
                    { className: _EarnedResourceTooltip2.default.content },
                    _react2.default.createElement(
                        'div',
                        { className: _EarnedResourceTooltip2.default.caption },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'clanmanagement.tooltips.earned_resource_body5',
                            defaultMessage: '\u0421\u043B\u0443\u0447\u0430\u0439\u043D\u044B\u0435 \u0431\u043E\u0438 \u043D\u0430 X \u0443\u0440\u043E\u0432\u043D\u0435 \u0442\u0435\u0445\u043D\u0438\u043A\u0438'
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'div',
                            { className: _EarnedResourceTooltip2.default.item },
                            _react2.default.createElement(
                                'div',
                                { className: _EarnedResourceTooltip2.default.key },
                                _react2.default.createElement(
                                    'span',
                                    { className: _EarnedResourceTooltip2.default.keyInner },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'clanmanagement.tooltips.earned_resource_body6',
                                        defaultMessage: '\u0412\u043E \u0432\u0437\u0432\u043E\u0434\u0435 \u0441 \u0441\u043E\u043A\u043B\u0430\u043D\u043E\u0432\u0446\u0435\u043C'
                                    })
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _EarnedResourceTooltip2.default.value },
                                _react2.default.createElement(_FormattedIndustrialResource2.default, {
                                    size: 'small',
                                    amount: industrialResourceEarnedInRandomInClanmatePlatoon
                                })
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _EarnedResourceTooltip2.default.item },
                            _react2.default.createElement(
                                'div',
                                { className: _EarnedResourceTooltip2.default.key },
                                _react2.default.createElement(
                                    'span',
                                    { className: _EarnedResourceTooltip2.default.keyInner },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'clanmanagement.tooltips.earned_resource_body7',
                                        defaultMessage: '\u0411\u0435\u0437 \u0441\u043E\u043A\u043B\u0430\u043D\u043E\u0432\u0446\u0435\u0432'
                                    })
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _EarnedResourceTooltip2.default.value },
                                _react2.default.createElement(_FormattedIndustrialResource2.default, {
                                    size: 'small',
                                    amount: industrialResourceEarnedInRandom
                                })
                            )
                        )
                    )
                )
            ),
            industrialResourceForClanPurchaseProduct > 0 && _react2.default.createElement(
                'div',
                { className: _EarnedResourceTooltip2.default.block },
                _react2.default.createElement('div', { className: (0, _classnames2.default)(_EarnedResourceTooltip2.default.icon, _EarnedResourceTooltip2.default['icon__purchase']) }),
                _react2.default.createElement(
                    'div',
                    { className: _EarnedResourceTooltip2.default.content },
                    _react2.default.createElement(
                        'div',
                        { className: _EarnedResourceTooltip2.default.caption },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'clanmanagement.tooltips.purchased_resource1',
                            defaultMessage: '\u041F\u043E\u043C\u043E\u0449\u044C \u043A\u043B\u0430\u043D\u0443'
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'div',
                            { className: _EarnedResourceTooltip2.default.item },
                            _react2.default.createElement(
                                'div',
                                { className: _EarnedResourceTooltip2.default.key },
                                _react2.default.createElement(
                                    'span',
                                    { className: _EarnedResourceTooltip2.default.keyInner },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'clanmanagement.tooltips.purchased_resource2',
                                        defaultMessage: '\u041A\u0443\u043F\u043B\u0435\u043D\u043E \u043F\u0440\u043E\u043C\u0440\u0435\u0441\u0443\u0440\u0441\u0430'
                                    })
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _EarnedResourceTooltip2.default.value },
                                _react2.default.createElement(_FormattedIndustrialResource2.default, {
                                    size: 'small',
                                    amount: industrialResourceForClanPurchaseProduct
                                })
                            )
                        )
                    )
                )
            ),
            props.showClanQuestsCard && _react2.default.createElement(
                'div',
                { className: _EarnedResourceTooltip2.default.block },
                _react2.default.createElement('div', { className: (0, _classnames2.default)(_EarnedResourceTooltip2.default.icon, _EarnedResourceTooltip2.default['icon__quests']) }),
                _react2.default.createElement(
                    'div',
                    { className: _EarnedResourceTooltip2.default.content },
                    _react2.default.createElement(
                        'div',
                        { className: _EarnedResourceTooltip2.default.caption },
                        _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: 'clanmanagement.tooltips.clan_supply_quests1',
                            defaultMessage: '\u0411\u043E\u0435\u0432\u043E\u0439 \u043F\u043E\u0445\u043E\u0434'
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'div',
                            { className: _EarnedResourceTooltip2.default.item },
                            _react2.default.createElement(
                                'div',
                                { className: _EarnedResourceTooltip2.default.key },
                                _react2.default.createElement(
                                    'span',
                                    { className: _EarnedResourceTooltip2.default.keyInner },
                                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                                        id: 'clanmanagement.tooltips.clan_supply_quests2',
                                        defaultMessage: '\u0417\u0430 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435 \u0437\u0430\u0434\u0430\u0447 \u043F\u043E\u0445\u043E\u0434\u0430'
                                    })
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _EarnedResourceTooltip2.default.value },
                                _react2.default.createElement(_FormattedIndustrialResource2.default, {
                                    size: 'small',
                                    amount: industrialResourceClansupply
                                })
                            )
                        )
                    )
                )
            )
        ),
        _react2.default.createElement(
            'div',
            { className: _EarnedResourceTooltip2.default.item },
            _react2.default.createElement(
                'div',
                { className: _EarnedResourceTooltip2.default.key },
                _react2.default.createElement(
                    'span',
                    { className: _EarnedResourceTooltip2.default.keyInner },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'clanmanagement.tooltips.earned_resource_body10',
                        defaultMessage: '\u0417\u0430 \u0432\u0441\u0451 \u0432\u0440\u0435\u043C\u044F'
                    })
                )
            ),
            _react2.default.createElement(
                'div',
                { className: _EarnedResourceTooltip2.default.value },
                _react2.default.createElement(_FormattedIndustrialResource2.default, { size: 'small', amount: industrialResourceWhole })
            )
        )
    );
};
EarnedResourceTooltipContent.propTypes = {
    selectedPeriod: _propTypes2.default.oneOf([1, 7, 28]).isRequired,
    statistics: _propTypes2.default.shape({
        industrialResourceEarnedAsClanmate: _propTypes2.default.number.isRequired,
        industrialResourceEarnedAsLegionary: _propTypes2.default.number.isRequired,
        industrialResourceEarnedInRandomInClanmatePlatoon: _propTypes2.default.number.isRequired,
        industrialResourceEarnedInRandom: _propTypes2.default.number.isRequired,
        industrialResourceForClanPurchaseProduct: _propTypes2.default.number.isRequired,
        industrialResourceClansupply: _propTypes2.default.number.isRequired,
        industrialResource: _propTypes2.default.number.isRequired,
        industrialResourceWhole: _propTypes2.default.number.isRequired
    }).isRequired,
    showClanQuestsCard: _propTypes2.default.bool.isRequired
};

var NotEarnedResourceTooltip = exports.NotEarnedResourceTooltip = function NotEarnedResourceTooltip() {
    return _react2.default.createElement(
        _reactWotBootstrap.Tooltip,
        { id: NotEarnedResourceTooltip.id },
        _react2.default.createElement(
            _reactWotBootstrap.TooltipBody,
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'clanmanagement.tooltips.not_earned_resource_body',
                defaultMessage: '\u041F\u0440\u043E\u043C\u0440\u0435\u0441\u0443\u0440\u0441 \u043D\u0435 \u0437\u0430\u0440\u0430\u0431\u043E\u0442\u0430\u043D'
            })
        )
    );
};
NotEarnedResourceTooltip.id = 'clanmanagement.tooltip.not_earned_resource';

/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactWotBootstrap = __webpack_require__(5);

var _tooltips = __webpack_require__(144);

var _TableBodyCellWithCM = __webpack_require__(2380);

var _TableBodyCellWithCM2 = _interopRequireDefault(_TableBodyCellWithCM);

var _FormattedTimeSince = __webpack_require__(2382);

var _FormattedTimeSince2 = _interopRequireDefault(_FormattedTimeSince);

var _translations = __webpack_require__(1373);

var _roles = __webpack_require__(49);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BaseMembersTableItem = function (_React$PureComponent) {
    _inherits(BaseMembersTableItem, _React$PureComponent);

    function BaseMembersTableItem(props) {
        _classCallCheck(this, BaseMembersTableItem);

        var _this = _possibleConstructorReturn(this, (BaseMembersTableItem.__proto__ || Object.getPrototypeOf(BaseMembersTableItem)).call(this, props));

        _this.onContextMenu = _this.onContextMenu.bind(_this);
        _this.onContextMenuItemSelected = _this.onContextMenuItemSelected.bind(_this);
        _this.onCheckboxChange = _this.onCheckboxChange.bind(_this);
        _this.onRowClick = _this.onRowClick.bind(_this);
        return _this;
    }

    _createClass(BaseMembersTableItem, [{
        key: 'isRowActive',
        value: function isRowActive() {
            return this.props.isActive || this.props.isCMDisplayed;
        }
    }, {
        key: 'needPlayHoverSound',
        value: function needPlayHoverSound() {
            return this.props.displayCheckbox && !this.isRowActive();
        }
    }, {
        key: 'onContextMenu',
        value: function onContextMenu() {
            this.props.onContextMenuStateChanged(this.props.memberId, true);
        }
    }, {
        key: 'onContextMenuItemSelected',
        value: function onContextMenuItemSelected(data) {
            this.props.onContextMenuStateChanged(this.props.memberId, false);
            this.props.onContextMenuItemSelected(data);
        }
    }, {
        key: 'onCheckboxChange',
        value: function onCheckboxChange() {
            this.props.onTickMember(this.props.memberId);
        }
    }, {
        key: 'onRowClick',
        value: function onRowClick() {
            this.props.onTickMember(this.props.memberId);
        }
    }, {
        key: 'renderTableCellCheckbox',
        value: function renderTableCellCheckbox() {
            return this.props.displayCheckbox ? _react2.default.createElement(
                _reactWotBootstrap.TableBodyCell,
                { type: 'check' },
                _react2.default.createElement(_reactWotBootstrap.Checkbox, {
                    isSilent: true,
                    isChecked: this.props.isChecked,
                    onChange: this.onCheckboxChange
                })
            ) : null;
        }
    }, {
        key: 'renderTableCellRole',
        value: function renderTableCellRole() {
            var role = this.props.memberRole;
            return _react2.default.createElement(
                _reactWotBootstrap.TableBodyCell,
                {
                    tooltipId: 'member-role-tooltip',
                    tooltipTip: role,
                    type: 'role'
                },
                _react2.default.createElement(_reactWotBootstrap.Role, { role: role })
            );
        }
    }, {
        key: 'renderTableCellMember',
        value: function renderTableCellMember(children) {
            var id = this.props.memberId;
            return _react2.default.createElement(
                _TableBodyCellWithCM2.default,
                {
                    id: id,
                    type: 'basis',
                    tooltipId: this.props.isCMDisplayed ? null : 'member-name-tooltip',
                    tooltipTip: this.props.isCMDisplayed ? null : '' + id,
                    onContextMenu: this.onContextMenu,
                    onContextMenuItemSelected: this.onContextMenuItemSelected
                },
                _react2.default.createElement(_reactWotBootstrap.Member, {
                    name: this.props.memberName,
                    status: this.props.memberStatus,
                    isOwn: this.props.isOwn,
                    isFriend: this.props.isFriend
                }),
                children
            );
        }
    }, {
        key: 'renderTableCellMemberStatus',
        value: function renderTableCellMemberStatus() {
            var status = this.props.memberStatus;
            var isOnline = status === 'online' || status === 'busy';

            var message = null;
            var tooltipId = null;
            if (isOnline) {
                message = _translations.PLAYER_STATUS_ONLINE;
            } else {
                message = _react2.default.createElement(_FormattedTimeSince2.default, { timestamp: this.props.memberLogoutAt });
                tooltipId = this.props.memberLogoutAt ? null : _tooltips.NotLoggedInEverTooltip.id;
            }

            var valueType = isOnline ? 'positive' : undefined;
            return _react2.default.createElement(
                _reactWotBootstrap.TableBodyCell,
                {
                    tooltipId: tooltipId,
                    type: 'center',
                    valueType: valueType
                },
                message
            );
        }
    }]);

    return BaseMembersTableItem;
}(_react2.default.PureComponent);

BaseMembersTableItem.propTypes = {
    memberId: _propTypes2.default.number.isRequired,
    memberDaysInClan: _propTypes2.default.number.isRequired, // eslint-disable-line react/no-unused-prop-types
    memberRole: _propTypes2.default.oneOf(_roles.roleNames).isRequired,
    memberName: _propTypes2.default.string.isRequired,

    memberStatus: _propTypes2.default.string,
    memberLogoutAt: _propTypes2.default.number,
    isOwn: _propTypes2.default.bool,
    isFriend: _propTypes2.default.bool,
    isActive: _propTypes2.default.bool,
    isChecked: _propTypes2.default.bool,
    displayCheckbox: _propTypes2.default.bool,
    isCMDisplayed: _propTypes2.default.bool,

    onTickMember: _propTypes2.default.func,
    onContextMenuItemSelected: _propTypes2.default.func,
    onContextMenuStateChanged: _propTypes2.default.func
};
BaseMembersTableItem.defaultProps = {
    isActive: false,
    isFriend: false,
    isChecked: false,
    displayCheckbox: false,
    memberStatus: 'offline',
    onTickMember: function onTickMember() {},
    onContextMenuStateChanged: function onContextMenuStateChanged() {}
};
exports.default = BaseMembersTableItem;

/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PLAYER_STATUS_ONLINE = exports.HEAD_PLAYER_TITLE = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HEAD_PLAYER_TITLE = exports.HEAD_PLAYER_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clanmanagement.memberstable.head.player.title',
    defaultMessage: '\u0418\u0433\u0440\u043E\u043A'
});

var PLAYER_STATUS_ONLINE = exports.PLAYER_STATUS_ONLINE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clanmanagement.memberstable.player.status.online',
    defaultMessage: '\u0412 \u0441\u0435\u0442\u0438'
});

/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LastCommonHeaders = exports.FirstCommonHeaders = undefined;

var _translations = __webpack_require__(1373);

var _tooltips = __webpack_require__(144);

var FirstCommonHeaders = exports.FirstCommonHeaders = [{
    type: 'role',
    isSortable: true,
    icon: 'role',
    key: 'head-role',
    tooltipId: 'members-table-column-tooltip',
    tooltipTip: _tooltips.RoleColumnTooltipContent.tip
}, {
    type: 'basis',
    isSortable: true,
    text: _translations.HEAD_PLAYER_TITLE,
    key: 'head-player',
    tooltipId: 'members-table-column-tooltip',
    tooltipTip: _tooltips.PlayerColumnTooltipContent.tip
}];

var LastCommonHeaders = exports.LastCommonHeaders = [{
    isSortable: true,
    icon: 'status',
    key: 'head-player-status-in-game',
    tooltipId: 'members-table-column-tooltip',
    tooltipTip: _tooltips.PlayerStatusColumnTooltipContent.tip
}];

/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DIALOG_ALLOCATING_RESOURCES_AFTER_DIVIDE_TITLE = exports.DIALOG_ALLOCATING_RESOURCES_AMOUNT_OF_CHARGES_TITLE = exports.DIALOG_ALLOCATING_RESOURCES_DIVIDE_EACH_TITLE = exports.DIALOG_ALLOCATING_RESOURCES_DIVIDE_TO_ONE_TITLE = exports.DIALOG_ALLOCATING_RESOURCES_BEFORE_DIVIDE_TITLE = exports.DIALOG_ALLOCATING_RESOURCES_SELECT_CURRENCY = exports.DIALOG_ALLOCATING_RESOURCES_DIVIDE_TO_MEMBERS_TITLE = exports.DIALOG_ALLOCATING_RESOURCES_DIVIDE_TO_MEMBER_TITLE = exports.DIALOG_ALLOCATING_RESOURCES_SUBMIT_BUTTON_CAPTION = exports.DIALOG_ALLOCATING_RESOURCES_TITLE = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DIALOG_ALLOCATING_RESOURCES_TITLE = exports.DIALOG_ALLOCATING_RESOURCES_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'members_control_block.dialog.allocating_resources.title',
    defaultMessage: '\u0420\u0430\u0441\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u0435 \u0440\u0435\u0441\u0443\u0440\u0441\u043E\u0432'
});

var DIALOG_ALLOCATING_RESOURCES_SUBMIT_BUTTON_CAPTION = exports.DIALOG_ALLOCATING_RESOURCES_SUBMIT_BUTTON_CAPTION = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'members_control_block.dialog.allocating_resources.submit_button.caption',
    defaultMessage: '\u0420\u0430\u0441\u043F\u0440\u0435\u0434\u0435\u043B\u0438\u0442\u044C'
});

var DIALOG_ALLOCATING_RESOURCES_DIVIDE_TO_MEMBER_TITLE = exports.DIALOG_ALLOCATING_RESOURCES_DIVIDE_TO_MEMBER_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'members_control_block.dialog.allocating_resources.divide_to_member.title',
    defaultMessage: '\u041D\u0430\u0447\u0438\u0441\u043B\u0438\u0442\u044C \u0440\u0435\u0441\u0443\u0440\u0441\u044B \u0438\u0433\u0440\u043E\u043A\u0443:'
});

var DIALOG_ALLOCATING_RESOURCES_DIVIDE_TO_MEMBERS_TITLE = exports.DIALOG_ALLOCATING_RESOURCES_DIVIDE_TO_MEMBERS_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'members_control_block.dialog.allocating_resources.divide_to_members.title',
    defaultMessage: '\u0420\u0430\u0441\u043F\u0440\u0435\u0434\u0435\u043B\u0438\u0442\u044C \u0440\u0435\u0441\u0443\u0440\u0441\u044B \u043C\u0435\u0436\u0434\u0443 \u0438\u0433\u0440\u043E\u043A\u0430\u043C\u0438:'
});

var DIALOG_ALLOCATING_RESOURCES_SELECT_CURRENCY = exports.DIALOG_ALLOCATING_RESOURCES_SELECT_CURRENCY = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'members_control_block.dialog.allocating_resources.select_currency.title',
    defaultMessage: '\u0420\u0430\u0441\u043F\u0440\u0435\u0434\u0435\u043B\u044F\u0435\u043C\u044B\u0439 \u0440\u0435\u0441\u0443\u0440\u0441:'
});

var DIALOG_ALLOCATING_RESOURCES_BEFORE_DIVIDE_TITLE = exports.DIALOG_ALLOCATING_RESOURCES_BEFORE_DIVIDE_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'members_control_block.dialog.allocating_resources.before_divide.title',
    defaultMessage: '\u0414\u043E \u0440\u0430\u0441\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u044F:'
});

var DIALOG_ALLOCATING_RESOURCES_DIVIDE_TO_ONE_TITLE = exports.DIALOG_ALLOCATING_RESOURCES_DIVIDE_TO_ONE_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'members_control_block.dialog.allocating_resources.divide_to_one.title',
    defaultMessage: '\u041D\u0430\u0447\u0438\u0441\u043B\u0438\u0442\u044C:'
});

var DIALOG_ALLOCATING_RESOURCES_DIVIDE_EACH_TITLE = exports.DIALOG_ALLOCATING_RESOURCES_DIVIDE_EACH_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'members_control_block.dialog.allocating_resources.divide_each.title',
    defaultMessage: '\u041D\u0430\u0447\u0438\u0441\u043B\u0438\u0442\u044C \u043A\u0430\u0436\u0434\u043E\u043C\u0443:'
});

var DIALOG_ALLOCATING_RESOURCES_AMOUNT_OF_CHARGES_TITLE = exports.DIALOG_ALLOCATING_RESOURCES_AMOUNT_OF_CHARGES_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'members_control_block.dialog.allocating_resources.amount_of_charges.title',
    defaultMessage: '\u0421\u0443\u043C\u043C\u0430 \u043D\u0430\u0447\u0438\u0441\u043B\u0435\u043D\u0438\u0439:'
});

var DIALOG_ALLOCATING_RESOURCES_AFTER_DIVIDE_TITLE = exports.DIALOG_ALLOCATING_RESOURCES_AFTER_DIVIDE_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'members_control_block.dialog.allocating_resources.after_divide.title',
    defaultMessage: '\u041F\u043E\u0441\u043B\u0435 \u0440\u0430\u0441\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u044F:'
});

/***/ }),
/* 1376 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"WGCWXConfirmation_base--1VYLo","content":"WGCWXConfirmation_content--3ioJj","back":"WGCWXConfirmation_back--Vx7So","header":"WGCWXConfirmation_header--QulKv","description":"WGCWXConfirmation_description--13cFi","image":"WGCWXConfirmation_image--3Xhlh","image__error":"WGCWXConfirmation_image__error--3nWES","imageError":"WGCWXConfirmation_image__error--3nWES","image__alert":"WGCWXConfirmation_image__alert--1ucRh","imageAlert":"WGCWXConfirmation_image__alert--1ucRh","separator":"WGCWXConfirmation_separator--Nh2M0","separator_image":"WGCWXConfirmation_separator_image--2ZIDA","separatorImage":"WGCWXConfirmation_separator_image--2ZIDA","buttons":"WGCWXConfirmation_buttons--2Uxu8","button":"WGCWXConfirmation_button--sHBdT","price":"WGCWXConfirmation_price--2u1MN","price_divider":"WGCWXConfirmation_price_divider--1IG_U","priceDivider":"WGCWXConfirmation_price_divider--1IG_U","plus":"WGCWXConfirmation_plus--1aR0H"};

/***/ }),
/* 1377 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"WGCWXShopDetailedProduct_base--3SmbO","holder":"WGCWXShopDetailedProduct_holder--2tlcv","back":"WGCWXShopDetailedProduct_back--2kN38","backTitle":"WGCWXShopDetailedProduct_backTitle--3eHa6","header":"WGCWXShopDetailedProduct_header--P_ucM","content":"WGCWXShopDetailedProduct_content--1gfYa","info":"WGCWXShopDetailedProduct_info--3yeXa","description":"WGCWXShopDetailedProduct_description--2xuXS","itemContent":"WGCWXShopDetailedProduct_itemContent--3whOj","itemContent_title":"WGCWXShopDetailedProduct_itemContent_title--1l3DS","itemContentTitle":"WGCWXShopDetailedProduct_itemContent_title--1l3DS","itemContent_list":"WGCWXShopDetailedProduct_itemContent_list--34H1N","itemContentList":"WGCWXShopDetailedProduct_itemContent_list--34H1N","itemContent_amount":"WGCWXShopDetailedProduct_itemContent_amount--1dzLY","itemContentAmount":"WGCWXShopDetailedProduct_itemContent_amount--1dzLY","highlight":"WGCWXShopDetailedProduct_highlight--8EuBn","list":"WGCWXShopDetailedProduct_list--2WtVN","list_item":"WGCWXShopDetailedProduct_list_item--2EY0z","listItem":"WGCWXShopDetailedProduct_list_item--2EY0z","list_item__current":"WGCWXShopDetailedProduct_list_item__current--1gePx","listItemCurrent":"WGCWXShopDetailedProduct_list_item__current--1gePx","list_item__bought":"WGCWXShopDetailedProduct_list_item__bought--1gC41","listItemBought":"WGCWXShopDetailedProduct_list_item__bought--1gC41","list_item_title":"WGCWXShopDetailedProduct_list_item_title--YAoTN","listItemTitle":"WGCWXShopDetailedProduct_list_item_title--YAoTN","pfp":"WGCWXShopDetailedProduct_pfp--1O07W","status":"WGCWXShopDetailedProduct_status--35Bvg","action":"WGCWXShopDetailedProduct_action--203_G","price":"WGCWXShopDetailedProduct_price--2IopA","footer":"WGCWXShopDetailedProduct_footer--2KOPq","imageContainer":"WGCWXShopDetailedProduct_imageContainer--1Bfo_","image":"WGCWXShopDetailedProduct_image--2Nv-i","image__PFP_BATTLES":"WGCWXShopDetailedProduct_image__PFP_BATTLES--kWMLd","imagePfpBattles":"WGCWXShopDetailedProduct_image__PFP_BATTLES--kWMLd","image__BONDS":"WGCWXShopDetailedProduct_image__BONDS--2rh6v","imageBonds":"WGCWXShopDetailedProduct_image__BONDS--2rh6v","image__SILVER":"WGCWXShopDetailedProduct_image__SILVER--1_naR","imageSilver":"WGCWXShopDetailedProduct_image__SILVER--1_naR","image__GOLD":"WGCWXShopDetailedProduct_image__GOLD--1Jc59","imageGold":"WGCWXShopDetailedProduct_image__GOLD--1Jc59","image__DIGITAL_STYLE":"WGCWXShopDetailedProduct_image__DIGITAL_STYLE--1l1V8","imageDigitalStyle":"WGCWXShopDetailedProduct_image__DIGITAL_STYLE--1l1V8","image__VETERAN_STYLE":"WGCWXShopDetailedProduct_image__VETERAN_STYLE--1lXdN","imageVeteranStyle":"WGCWXShopDetailedProduct_image__VETERAN_STYLE--1lXdN","image__VANQUISHER_STYLE":"WGCWXShopDetailedProduct_image__VANQUISHER_STYLE--1a7WE","imageVanquisherStyle":"WGCWXShopDetailedProduct_image__VANQUISHER_STYLE--1a7WE","image__BROKEN_STONE_STYLE":"WGCWXShopDetailedProduct_image__BROKEN_STONE_STYLE--x5xAQ","imageBrokenStoneStyle":"WGCWXShopDetailedProduct_image__BROKEN_STONE_STYLE--x5xAQ","image__CONQUEROR_STYLE":"WGCWXShopDetailedProduct_image__CONQUEROR_STYLE--2FByl","imageConquerorStyle":"WGCWXShopDetailedProduct_image__CONQUEROR_STYLE--2FByl","image__NIGHTFALL_STYLE":"WGCWXShopDetailedProduct_image__NIGHTFALL_STYLE--1h8nk","imageNightfallStyle":"WGCWXShopDetailedProduct_image__NIGHTFALL_STYLE--1h8nk","image__EMBLEM":"WGCWXShopDetailedProduct_image__EMBLEM--2UFRp","imageEmblem":"WGCWXShopDetailedProduct_image__EMBLEM--2UFRp","image__CREW_WOMAN":"WGCWXShopDetailedProduct_image__CREW_WOMAN--MkaTz","imageCrewWoman":"WGCWXShopDetailedProduct_image__CREW_WOMAN--MkaTz","image__DIRECTIVES_PACK":"WGCWXShopDetailedProduct_image__DIRECTIVES_PACK--2IF_k","imageDirectivesPack":"WGCWXShopDetailedProduct_image__DIRECTIVES_PACK--2IF_k","image__DIRECTIVES_PACK_30":"WGCWXShopDetailedProduct_image__DIRECTIVES_PACK_30--156Np","imageDirectivesPack30":"WGCWXShopDetailedProduct_image__DIRECTIVES_PACK_30--156Np","image__GRAPHITE_STYLE":"WGCWXShopDetailedProduct_image__GRAPHITE_STYLE--1spqL","imageGraphiteStyle":"WGCWXShopDetailedProduct_image__GRAPHITE_STYLE--1spqL","image__FIRE_STYLE":"WGCWXShopDetailedProduct_image__FIRE_STYLE--1h22_","imageFireStyle":"WGCWXShopDetailedProduct_image__FIRE_STYLE--1h22_","image__DIGITAL_ADAPTED_STYLE":"WGCWXShopDetailedProduct_image__DIGITAL_ADAPTED_STYLE--1q7jn","imageDigitalAdaptedStyle":"WGCWXShopDetailedProduct_image__DIGITAL_ADAPTED_STYLE--1q7jn","image__CLAN_URBAN_STYLE":"WGCWXShopDetailedProduct_image__CLAN_URBAN_STYLE--W8oVM","imageClanUrbanStyle":"WGCWXShopDetailedProduct_image__CLAN_URBAN_STYLE--W8oVM","image__GUARDIAN_OF_CROWN_STYLE":"WGCWXShopDetailedProduct_image__GUARDIAN_OF_CROWN_STYLE--N726S","imageGuardianOfCrownStyle":"WGCWXShopDetailedProduct_image__GUARDIAN_OF_CROWN_STYLE--N726S","image__PROPHESY_STYLE":"WGCWXShopDetailedProduct_image__PROPHESY_STYLE--1CoFa","imageProphesyStyle":"WGCWXShopDetailedProduct_image__PROPHESY_STYLE--1CoFa","image__JUDGEMENT_STYLE":"WGCWXShopDetailedProduct_image__JUDGEMENT_STYLE--5z8nr","imageJudgementStyle":"WGCWXShopDetailedProduct_image__JUDGEMENT_STYLE--5z8nr","image__REAPER_STYLE":"WGCWXShopDetailedProduct_image__REAPER_STYLE--1nefR","imageReaperStyle":"WGCWXShopDetailedProduct_image__REAPER_STYLE--1nefR","image__AIR_ELEMENTAL_STYLE":"WGCWXShopDetailedProduct_image__AIR_ELEMENTAL_STYLE--29PHk","imageAirElementalStyle":"WGCWXShopDetailedProduct_image__AIR_ELEMENTAL_STYLE--29PHk","image__EARTH_ELEMENTAL_STYLE":"WGCWXShopDetailedProduct_image__EARTH_ELEMENTAL_STYLE--6SrfT","imageEarthElementalStyle":"WGCWXShopDetailedProduct_image__EARTH_ELEMENTAL_STYLE--6SrfT","image__WATER_ELEMENTAL_STYLE":"WGCWXShopDetailedProduct_image__WATER_ELEMENTAL_STYLE--25KGy","imageWaterElementalStyle":"WGCWXShopDetailedProduct_image__WATER_ELEMENTAL_STYLE--25KGy","image__FIRE_ELEMENTAL_STYLE":"WGCWXShopDetailedProduct_image__FIRE_ELEMENTAL_STYLE--3DNYi","imageFireElementalStyle":"WGCWXShopDetailedProduct_image__FIRE_ELEMENTAL_STYLE--3DNYi","image__PROSERPINA_STYLE":"WGCWXShopDetailedProduct_image__PROSERPINA_STYLE--3j6JD","imageProserpinaStyle":"WGCWXShopDetailedProduct_image__PROSERPINA_STYLE--3j6JD","image__NAMENLOS_STYLE":"WGCWXShopDetailedProduct_image__NAMENLOS_STYLE--3s2jL","imageNamenlosStyle":"WGCWXShopDetailedProduct_image__NAMENLOS_STYLE--3s2jL","image__CREW_EXPERIENCE":"WGCWXShopDetailedProduct_image__CREW_EXPERIENCE--7Uexg","imageCrewExperience":"WGCWXShopDetailedProduct_image__CREW_EXPERIENCE--7Uexg","image__FREE_EXPERIENCE":"WGCWXShopDetailedProduct_image__FREE_EXPERIENCE--3eH9u","imageFreeExperience":"WGCWXShopDetailedProduct_image__FREE_EXPERIENCE--3eH9u","image__EXPERIENCE":"WGCWXShopDetailedProduct_image__EXPERIENCE--2FON6","imageExperience":"WGCWXShopDetailedProduct_image__EXPERIENCE--2FON6","image__FREE_XP_AND_CREW_XP":"WGCWXShopDetailedProduct_image__FREE_XP_AND_CREW_XP--2t26v","imageFreeXpAndCrewXp":"WGCWXShopDetailedProduct_image__FREE_XP_AND_CREW_XP--2t26v","image__XP_RESERVE":"WGCWXShopDetailedProduct_image__XP_RESERVE--37EmN","imageXpReserve":"WGCWXShopDetailedProduct_image__XP_RESERVE--37EmN","image__HELLRAISER_STYLE":"WGCWXShopDetailedProduct_image__HELLRAISER_STYLE--3Y8da","imageHellraiserStyle":"WGCWXShopDetailedProduct_image__HELLRAISER_STYLE--3Y8da","image__WARRIOR_OF_THE_EAST_STYLE":"WGCWXShopDetailedProduct_image__WARRIOR_OF_THE_EAST_STYLE--3RYfe","imageWarriorOfTheEastStyle":"WGCWXShopDetailedProduct_image__WARRIOR_OF_THE_EAST_STYLE--3RYfe","image__WARRIOR_OF_THE_NORTH_STYLE":"WGCWXShopDetailedProduct_image__WARRIOR_OF_THE_NORTH_STYLE--12lJ7","imageWarriorOfTheNorthStyle":"WGCWXShopDetailedProduct_image__WARRIOR_OF_THE_NORTH_STYLE--12lJ7","image__WARRIOR_OF_THE_SOUTH_STYLE":"WGCWXShopDetailedProduct_image__WARRIOR_OF_THE_SOUTH_STYLE--36JEs","imageWarriorOfTheSouthStyle":"WGCWXShopDetailedProduct_image__WARRIOR_OF_THE_SOUTH_STYLE--36JEs","image__WARRIOR_OF_THE_WEST_STYLE":"WGCWXShopDetailedProduct_image__WARRIOR_OF_THE_WEST_STYLE--1aOG9","imageWarriorOfTheWestStyle":"WGCWXShopDetailedProduct_image__WARRIOR_OF_THE_WEST_STYLE--1aOG9","image__KRAIT_STYLE":"WGCWXShopDetailedProduct_image__KRAIT_STYLE--3wsD0","imageKraitStyle":"WGCWXShopDetailedProduct_image__KRAIT_STYLE--3wsD0","image__BASALT_STYLE":"WGCWXShopDetailedProduct_image__BASALT_STYLE--2a_gV","imageBasaltStyle":"WGCWXShopDetailedProduct_image__BASALT_STYLE--2a_gV","image__LIGHTNING_STYLE_china":"WGCWXShopDetailedProduct_image__LIGHTNING_STYLE_china--34On6","imageLightningStyleChina":"WGCWXShopDetailedProduct_image__LIGHTNING_STYLE_china--34On6","image__LIGHTNING_STYLE_czech":"WGCWXShopDetailedProduct_image__LIGHTNING_STYLE_czech--3IE_y","imageLightningStyleCzech":"WGCWXShopDetailedProduct_image__LIGHTNING_STYLE_czech--3IE_y","image__LIGHTNING_STYLE_france":"WGCWXShopDetailedProduct_image__LIGHTNING_STYLE_france--3avOs","imageLightningStyleFrance":"WGCWXShopDetailedProduct_image__LIGHTNING_STYLE_france--3avOs","image__LIGHTNING_STYLE_germany":"WGCWXShopDetailedProduct_image__LIGHTNING_STYLE_germany--2SEpN","imageLightningStyleGermany":"WGCWXShopDetailedProduct_image__LIGHTNING_STYLE_germany--2SEpN","image__LIGHTNING_STYLE_italy":"WGCWXShopDetailedProduct_image__LIGHTNING_STYLE_italy--2RuzI","imageLightningStyleItaly":"WGCWXShopDetailedProduct_image__LIGHTNING_STYLE_italy--2RuzI","image__LIGHTNING_STYLE_japan":"WGCWXShopDetailedProduct_image__LIGHTNING_STYLE_japan--1qpqw","imageLightningStyleJapan":"WGCWXShopDetailedProduct_image__LIGHTNING_STYLE_japan--1qpqw","image__LIGHTNING_STYLE_poland":"WGCWXShopDetailedProduct_image__LIGHTNING_STYLE_poland--3YJFQ","imageLightningStylePoland":"WGCWXShopDetailedProduct_image__LIGHTNING_STYLE_poland--3YJFQ","image__LIGHTNING_STYLE_sweden":"WGCWXShopDetailedProduct_image__LIGHTNING_STYLE_sweden--3PmQs","imageLightningStyleSweden":"WGCWXShopDetailedProduct_image__LIGHTNING_STYLE_sweden--3PmQs","image__LIGHTNING_STYLE_uk":"WGCWXShopDetailedProduct_image__LIGHTNING_STYLE_uk--a8abg","imageLightningStyleUk":"WGCWXShopDetailedProduct_image__LIGHTNING_STYLE_uk--a8abg","image__LIGHTNING_STYLE_usa":"WGCWXShopDetailedProduct_image__LIGHTNING_STYLE_usa--1Rwl5","imageLightningStyleUsa":"WGCWXShopDetailedProduct_image__LIGHTNING_STYLE_usa--1Rwl5","image__LIGHTNING_STYLE_ussr":"WGCWXShopDetailedProduct_image__LIGHTNING_STYLE_ussr--1pcQ4","imageLightningStyleUssr":"WGCWXShopDetailedProduct_image__LIGHTNING_STYLE_ussr--1pcQ4","image__DIGITAL_CAMOUFLAGE_WINTER_china":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_WINTER_china--3yW2e","imageDigitalCamouflageWinterChina":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_WINTER_china--3yW2e","image__DIGITAL_CAMOUFLAGE_WINTER_czech":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_WINTER_czech--3Xsbh","imageDigitalCamouflageWinterCzech":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_WINTER_czech--3Xsbh","image__DIGITAL_CAMOUFLAGE_WINTER_france":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_WINTER_france--2I11s","imageDigitalCamouflageWinterFrance":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_WINTER_france--2I11s","image__DIGITAL_CAMOUFLAGE_WINTER_germany":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_WINTER_germany--2OEHg","imageDigitalCamouflageWinterGermany":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_WINTER_germany--2OEHg","image__DIGITAL_CAMOUFLAGE_WINTER_italy":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_WINTER_italy--uW1Zn","imageDigitalCamouflageWinterItaly":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_WINTER_italy--uW1Zn","image__DIGITAL_CAMOUFLAGE_WINTER_japan":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_WINTER_japan--S1W2o","imageDigitalCamouflageWinterJapan":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_WINTER_japan--S1W2o","image__DIGITAL_CAMOUFLAGE_WINTER_poland":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_WINTER_poland--syJy4","imageDigitalCamouflageWinterPoland":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_WINTER_poland--syJy4","image__DIGITAL_CAMOUFLAGE_WINTER_sweden":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_WINTER_sweden--2u4_V","imageDigitalCamouflageWinterSweden":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_WINTER_sweden--2u4_V","image__DIGITAL_CAMOUFLAGE_WINTER_uk":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_WINTER_uk--34eFc","imageDigitalCamouflageWinterUk":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_WINTER_uk--34eFc","image__DIGITAL_CAMOUFLAGE_WINTER_usa":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_WINTER_usa--2npjn","imageDigitalCamouflageWinterUsa":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_WINTER_usa--2npjn","image__DIGITAL_CAMOUFLAGE_WINTER_ussr":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_WINTER_ussr--3iRfY","imageDigitalCamouflageWinterUssr":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_WINTER_ussr--3iRfY","image__DIGITAL_CAMOUFLAGE_SUMMER_china":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_SUMMER_china--3cOaY","imageDigitalCamouflageSummerChina":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_SUMMER_china--3cOaY","image__DIGITAL_CAMOUFLAGE_SUMMER_czech":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_SUMMER_czech--3S3SU","imageDigitalCamouflageSummerCzech":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_SUMMER_czech--3S3SU","image__DIGITAL_CAMOUFLAGE_SUMMER_france":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_SUMMER_france--7OY90","imageDigitalCamouflageSummerFrance":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_SUMMER_france--7OY90","image__DIGITAL_CAMOUFLAGE_SUMMER_germany":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_SUMMER_germany--YUEq1","imageDigitalCamouflageSummerGermany":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_SUMMER_germany--YUEq1","image__DIGITAL_CAMOUFLAGE_SUMMER_italy":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_SUMMER_italy--2CeUe","imageDigitalCamouflageSummerItaly":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_SUMMER_italy--2CeUe","image__DIGITAL_CAMOUFLAGE_SUMMER_japan":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_SUMMER_japan--7HMYm","imageDigitalCamouflageSummerJapan":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_SUMMER_japan--7HMYm","image__DIGITAL_CAMOUFLAGE_SUMMER_poland":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_SUMMER_poland--2Rq10","imageDigitalCamouflageSummerPoland":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_SUMMER_poland--2Rq10","image__DIGITAL_CAMOUFLAGE_SUMMER_sweden":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_SUMMER_sweden--1GsEP","imageDigitalCamouflageSummerSweden":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_SUMMER_sweden--1GsEP","image__DIGITAL_CAMOUFLAGE_SUMMER_uk":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_SUMMER_uk--2b6wC","imageDigitalCamouflageSummerUk":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_SUMMER_uk--2b6wC","image__DIGITAL_CAMOUFLAGE_SUMMER_usa":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_SUMMER_usa--1Ljg-","imageDigitalCamouflageSummerUsa":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_SUMMER_usa--1Ljg-","image__DIGITAL_CAMOUFLAGE_SUMMER_ussr":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_SUMMER_ussr--1H2la","imageDigitalCamouflageSummerUssr":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_SUMMER_ussr--1H2la","image__DIGITAL_CAMOUFLAGE_DESERT_china":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_DESERT_china--DVtLU","imageDigitalCamouflageDesertChina":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_DESERT_china--DVtLU","image__DIGITAL_CAMOUFLAGE_DESERT_czech":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_DESERT_czech--32mV8","imageDigitalCamouflageDesertCzech":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_DESERT_czech--32mV8","image__DIGITAL_CAMOUFLAGE_DESERT_france":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_DESERT_france--2l_RQ","imageDigitalCamouflageDesertFrance":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_DESERT_france--2l_RQ","image__DIGITAL_CAMOUFLAGE_DESERT_germany":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_DESERT_germany--2C9x6","imageDigitalCamouflageDesertGermany":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_DESERT_germany--2C9x6","image__DIGITAL_CAMOUFLAGE_DESERT_italy":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_DESERT_italy--11SPR","imageDigitalCamouflageDesertItaly":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_DESERT_italy--11SPR","image__DIGITAL_CAMOUFLAGE_DESERT_japan":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_DESERT_japan--bof8I","imageDigitalCamouflageDesertJapan":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_DESERT_japan--bof8I","image__DIGITAL_CAMOUFLAGE_DESERT_poland":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_DESERT_poland--1gYsX","imageDigitalCamouflageDesertPoland":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_DESERT_poland--1gYsX","image__DIGITAL_CAMOUFLAGE_DESERT_sweden":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_DESERT_sweden--2YXMR","imageDigitalCamouflageDesertSweden":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_DESERT_sweden--2YXMR","image__DIGITAL_CAMOUFLAGE_DESERT_uk":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_DESERT_uk--insIF","imageDigitalCamouflageDesertUk":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_DESERT_uk--insIF","image__DIGITAL_CAMOUFLAGE_DESERT_usa":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_DESERT_usa--1F_b7","imageDigitalCamouflageDesertUsa":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_DESERT_usa--1F_b7","image__DIGITAL_CAMOUFLAGE_DESERT_ussr":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_DESERT_ussr--3aYu9","imageDigitalCamouflageDesertUssr":"WGCWXShopDetailedProduct_image__DIGITAL_CAMOUFLAGE_DESERT_ussr--3aYu9","image__CREW_BOOK_NATIONAL_china":"WGCWXShopDetailedProduct_image__CREW_BOOK_NATIONAL_china--1Jolc","imageCrewBookNationalChina":"WGCWXShopDetailedProduct_image__CREW_BOOK_NATIONAL_china--1Jolc","isCnRealm":"WGCWXShopDetailedProduct_isCnRealm--1DZhh","image__CREW_BOOK_NATIONAL_czech":"WGCWXShopDetailedProduct_image__CREW_BOOK_NATIONAL_czech--10Lc0","imageCrewBookNationalCzech":"WGCWXShopDetailedProduct_image__CREW_BOOK_NATIONAL_czech--10Lc0","image__CREW_BOOK_NATIONAL_france":"WGCWXShopDetailedProduct_image__CREW_BOOK_NATIONAL_france--b6Ka6","imageCrewBookNationalFrance":"WGCWXShopDetailedProduct_image__CREW_BOOK_NATIONAL_france--b6Ka6","image__CREW_BOOK_NATIONAL_germany":"WGCWXShopDetailedProduct_image__CREW_BOOK_NATIONAL_germany--3JJy_","imageCrewBookNationalGermany":"WGCWXShopDetailedProduct_image__CREW_BOOK_NATIONAL_germany--3JJy_","image__CREW_BOOK_NATIONAL_italy":"WGCWXShopDetailedProduct_image__CREW_BOOK_NATIONAL_italy--1qfA_","imageCrewBookNationalItaly":"WGCWXShopDetailedProduct_image__CREW_BOOK_NATIONAL_italy--1qfA_","image__CREW_BOOK_NATIONAL_japan":"WGCWXShopDetailedProduct_image__CREW_BOOK_NATIONAL_japan--3xrnN","imageCrewBookNationalJapan":"WGCWXShopDetailedProduct_image__CREW_BOOK_NATIONAL_japan--3xrnN","image__CREW_BOOK_NATIONAL_poland":"WGCWXShopDetailedProduct_image__CREW_BOOK_NATIONAL_poland--30Wd6","imageCrewBookNationalPoland":"WGCWXShopDetailedProduct_image__CREW_BOOK_NATIONAL_poland--30Wd6","image__CREW_BOOK_NATIONAL_sweden":"WGCWXShopDetailedProduct_image__CREW_BOOK_NATIONAL_sweden--3lIMz","imageCrewBookNationalSweden":"WGCWXShopDetailedProduct_image__CREW_BOOK_NATIONAL_sweden--3lIMz","image__CREW_BOOK_NATIONAL_uk":"WGCWXShopDetailedProduct_image__CREW_BOOK_NATIONAL_uk--2zI6-","imageCrewBookNationalUk":"WGCWXShopDetailedProduct_image__CREW_BOOK_NATIONAL_uk--2zI6-","image__CREW_BOOK_NATIONAL_usa":"WGCWXShopDetailedProduct_image__CREW_BOOK_NATIONAL_usa--1JboM","imageCrewBookNationalUsa":"WGCWXShopDetailedProduct_image__CREW_BOOK_NATIONAL_usa--1JboM","image__CREW_BOOK_NATIONAL_ussr":"WGCWXShopDetailedProduct_image__CREW_BOOK_NATIONAL_ussr--mzlPZ","imageCrewBookNationalUssr":"WGCWXShopDetailedProduct_image__CREW_BOOK_NATIONAL_ussr--mzlPZ","image__PREMIUM_PLUS_1":"WGCWXShopDetailedProduct_image__PREMIUM_PLUS_1--cucLu","imagePremiumPlus1":"WGCWXShopDetailedProduct_image__PREMIUM_PLUS_1--cucLu","image__PREMIUM_PLUS_3":"WGCWXShopDetailedProduct_image__PREMIUM_PLUS_3--1TSyH","imagePremiumPlus3":"WGCWXShopDetailedProduct_image__PREMIUM_PLUS_3--1TSyH","image__PERSONAL_RESERVE_BIG":"WGCWXShopDetailedProduct_image__PERSONAL_RESERVE_BIG--yk3Hy","imagePersonalReserveBig":"WGCWXShopDetailedProduct_image__PERSONAL_RESERVE_BIG--yk3Hy","image__PERSONAL_RESERVE_SMALL":"WGCWXShopDetailedProduct_image__PERSONAL_RESERVE_SMALL--3zrz_","imagePersonalReserveSmall":"WGCWXShopDetailedProduct_image__PERSONAL_RESERVE_SMALL--3zrz_","flag":"WGCWXShopDetailedProduct_flag--2Tgca","flag__china":"WGCWXShopDetailedProduct_flag__china--21lp-","flagChina":"WGCWXShopDetailedProduct_flag__china--21lp-","flag__czech":"WGCWXShopDetailedProduct_flag__czech--3C1sU","flagCzech":"WGCWXShopDetailedProduct_flag__czech--3C1sU","flag__france":"WGCWXShopDetailedProduct_flag__france--3PUfY","flagFrance":"WGCWXShopDetailedProduct_flag__france--3PUfY","flag__germany":"WGCWXShopDetailedProduct_flag__germany--2AIA2","flagGermany":"WGCWXShopDetailedProduct_flag__germany--2AIA2","flag__italy":"WGCWXShopDetailedProduct_flag__italy--3oVzK","flagItaly":"WGCWXShopDetailedProduct_flag__italy--3oVzK","flag__japan":"WGCWXShopDetailedProduct_flag__japan--1ainW","flagJapan":"WGCWXShopDetailedProduct_flag__japan--1ainW","flag__poland":"WGCWXShopDetailedProduct_flag__poland--OX-TD","flagPoland":"WGCWXShopDetailedProduct_flag__poland--OX-TD","flag__sweden":"WGCWXShopDetailedProduct_flag__sweden--2FeUQ","flagSweden":"WGCWXShopDetailedProduct_flag__sweden--2FeUQ","flag__uk":"WGCWXShopDetailedProduct_flag__uk--2vG-6","flagUk":"WGCWXShopDetailedProduct_flag__uk--2vG-6","flag__usa":"WGCWXShopDetailedProduct_flag__usa--1yzKh","flagUsa":"WGCWXShopDetailedProduct_flag__usa--1yzKh","flag__ussr":"WGCWXShopDetailedProduct_flag__ussr--1MXGC","flagUssr":"WGCWXShopDetailedProduct_flag__ussr--1MXGC","buttons":"WGCWXShopDetailedProduct_buttons--Tw7PQ","button":"WGCWXShopDetailedProduct_button--1865E","button__isBought":"WGCWXShopDetailedProduct_button__isBought--101Kg","buttonIsBought":"WGCWXShopDetailedProduct_button__isBought--101Kg","group":"WGCWXShopDetailedProduct_group--19eYq","group__china":"WGCWXShopDetailedProduct_group__china--395KP","groupChina":"WGCWXShopDetailedProduct_group__china--395KP","group__czech":"WGCWXShopDetailedProduct_group__czech--3HXQx","groupCzech":"WGCWXShopDetailedProduct_group__czech--3HXQx","group__france":"WGCWXShopDetailedProduct_group__france--TfjFC","groupFrance":"WGCWXShopDetailedProduct_group__france--TfjFC","group__germany":"WGCWXShopDetailedProduct_group__germany--2VSNg","groupGermany":"WGCWXShopDetailedProduct_group__germany--2VSNg","group__italy":"WGCWXShopDetailedProduct_group__italy--2MtHe","groupItaly":"WGCWXShopDetailedProduct_group__italy--2MtHe","group__japan":"WGCWXShopDetailedProduct_group__japan--10pYp","groupJapan":"WGCWXShopDetailedProduct_group__japan--10pYp","group__poland":"WGCWXShopDetailedProduct_group__poland--1OyWH","groupPoland":"WGCWXShopDetailedProduct_group__poland--1OyWH","group__sweden":"WGCWXShopDetailedProduct_group__sweden--3BZos","groupSweden":"WGCWXShopDetailedProduct_group__sweden--3BZos","group__uk":"WGCWXShopDetailedProduct_group__uk--2RYO4","groupUk":"WGCWXShopDetailedProduct_group__uk--2RYO4","group__usa":"WGCWXShopDetailedProduct_group__usa--2eyPr","groupUsa":"WGCWXShopDetailedProduct_group__usa--2eyPr","group__ussr":"WGCWXShopDetailedProduct_group__ussr--1teHI","groupUssr":"WGCWXShopDetailedProduct_group__ussr--1teHI","isActive":"WGCWXShopDetailedProduct_isActive--3HamB"};

/***/ }),
/* 1378 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"WGCWXShopProducts_base--23Vgb","content":"WGCWXShopProducts_content--1jq66","title":"WGCWXShopProducts_title--3Z9fM","eventInfo":"WGCWXShopProducts_eventInfo--SwkpZ","subtitle":"WGCWXShopProducts_subtitle--bjY8z","body":"WGCWXShopProducts_body--2kTPF","subtitle_value":"WGCWXShopProducts_subtitle_value--SUqC6","subtitleValue":"WGCWXShopProducts_subtitle_value--SUqC6","header":"WGCWXShopProducts_header--3e6br","info":"WGCWXShopProducts_info--1mdUI","info__center":"WGCWXShopProducts_info__center--rn9EO","infoCenter":"WGCWXShopProducts_info__center--rn9EO","separator":"WGCWXShopProducts_separator--1Hvgv","grid":"WGCWXShopProducts_grid--2DUSv","grid_row":"WGCWXShopProducts_grid_row--1QCVv","gridRow":"WGCWXShopProducts_grid_row--1QCVv","grid_column":"WGCWXShopProducts_grid_column--2h8L9","gridColumn":"WGCWXShopProducts_grid_column--2h8L9","wgcwxLink":"WGCWXShopProducts_wgcwxLink--380nS"};

/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactWotBootstrap = __webpack_require__(5);

var _constants = __webpack_require__(579);

var _VehicleAddToComparison = __webpack_require__(2438);

var _VehicleAddToComparison2 = _interopRequireDefault(_VehicleAddToComparison);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VehicleAddToComparison = function (_React$PureComponent) {
    _inherits(VehicleAddToComparison, _React$PureComponent);

    function VehicleAddToComparison() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, VehicleAddToComparison);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = VehicleAddToComparison.__proto__ || Object.getPrototypeOf(VehicleAddToComparison)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
            event.preventDefault();
            event.stopPropagation();

            (0, _reactWotBootstrap.addVehicleToComparison)(_this.props.vehicleCd);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(VehicleAddToComparison, [{
        key: 'render',
        value: function render() {
            var className = (0, _classnames2.default)(_VehicleAddToComparison2.default.base, this.props.mixClassName);

            var dataAttrs = this.props.isDisabled ? {} : {
                'data-tip': true,
                'data-for': _constants.VEHICLE_TO_COMPARE_TOOLTIP.id
            };

            return _react2.default.createElement('span', _extends({
                className: className,
                onClick: this.handleClick,
                onMouseDown: _reactWotBootstrap.sendClickSoundCommand,
                onMouseEnter: _reactWotBootstrap.sendHoverSoundCommand
            }, dataAttrs));
        }
    }]);

    return VehicleAddToComparison;
}(_react2.default.PureComponent);

VehicleAddToComparison.propTypes = {
    vehicleCd: _propTypes2.default.number.isRequired,
    isDisabled: _propTypes2.default.bool,
    mixClassName: _propTypes2.default.string
};
exports.default = VehicleAddToComparison;

/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TANK_TECH_STATS = exports.MORE_ABOUT_TANK = exports.TTC_TITLE = exports.CANCEL_BET = exports.INFO_TEXT_STYLE = exports.STYLE_VETERAN = exports.CANCEL_BET_DESCRIPTION = exports.CANCEL_BET_TITLE = exports.NO = exports.CURRENCY_LEFT = exports.CURRENCY_TO_SPEND = exports.PURCHASE = exports.PURCHASE_TANK = exports.AFFIRMATIVE_BUTTON = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-multi-comp, max-len */
var AFFIRMATIVE_BUTTON = exports.AFFIRMATIVE_BUTTON = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.rewards.tank.affirmative.button',
    defaultMessage: '\u043A \u0432\u044B\u0431\u043E\u0440\u0443 \u043D\u0430\u0433\u0440\u0430\u0434'
});

var PURCHASE_TANK = exports.PURCHASE_TANK = function PURCHASE_TANK(tankName) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop.rewards.tank.tankpurchase',
        defaultMessage: '\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043D\u0430\u0433\u0440\u0430\u0434\u0443 \xAB{tankName}\xBB?',
        values: { tankName: tankName }
    });
};

var PURCHASE = exports.PURCHASE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.rewards.tank.purchase',
    defaultMessage: '\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C'
});

var CURRENCY_TO_SPEND = exports.CURRENCY_TO_SPEND = function CURRENCY_TO_SPEND(currency) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop.rewards.tank.currency_to_spend',
        defaultMessage: '\u041A \u043E\u0431\u043C\u0435\u043D\u0443: {currency}',
        values: { currency: currency }
    });
};

var CURRENCY_LEFT = exports.CURRENCY_LEFT = function CURRENCY_LEFT(currency) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop.rewards.tank.currency_left',
        defaultMessage: '\u041D\u0430 \u0432\u0430\u0448\u0435\u043C \u0441\u0447\u0435\u0442\u0443 \u043E\u0441\u0442\u0430\u043D\u0435\u0442\u0441\u044F: {currency}',
        values: { currency: currency }
    });
};

var NO = exports.NO = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.rewards.tank.tank.no',
    defaultMessage: '\u041D\u0435\u0442'
});

var CANCEL_BET_TITLE = exports.CANCEL_BET_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.rewards.tank.auction.cancel_bet.title',
    defaultMessage: '\u041E\u0442\u043C\u0435\u043D\u0430 \u0441\u0442\u0430\u0432\u043A\u0438'
});

var CANCEL_BET_DESCRIPTION = exports.CANCEL_BET_DESCRIPTION = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.rewards.tank.auction.cancel_bet.description',
    defaultMessage: '\u0421\u0442\u0430\u0432\u043A\u0430 \u043D\u0430 \u0430\u0443\u043A\u0446\u0438\u043E\u043D\u0435 \u043D\u0430 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435 \u043F\u0440\u0438\u0437\u043E\u0432\u043E\u0439 \u043C\u0430\u0448\u0438\u043D\u044B \u0431\u0443\u0434\u0435\u0442 \u043E\u0442\u043C\u0435\u043D\u0435\u043D\u0430, \u0431\u043E\u043D\u044B \u0432\u0435\u0440\u043D\u0443\u0442\u0441\u044F \u043D\u0430 \u0432\u0430\u0448 \u0441\u0447\u0451\u0442.'
});

var STYLE_VETERAN = exports.STYLE_VETERAN = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.rewards.tank.info_text_style.style_veteran',
    defaultMessage: '\xAB\u0412\u0435\u0442\u0435\u0440\u0430\u043D\xBB'
});

var INFO_TEXT_STYLE = exports.INFO_TEXT_STYLE = function INFO_TEXT_STYLE(style_veteran) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop.rewards.tank.info_text_style',
        defaultMessage: '\u0414\u0430\u043D\u043D\u0430\u044F \u043F\u0440\u0438\u0437\u043E\u0432\u0430\u044F \u043C\u0430\u0448\u0438\u043D\u0430 \u043D\u0430\u0447\u0438\u0441\u043B\u044F\u0435\u0442\u0441\u044F \u0432\u043C\u0435\u0441\u0442\u0435 \u0441 \u043D\u0430\u0431\u043E\u0440\u043E\u043C \u043A\u0430\u0441\u0442\u043E\u043C\u0438\u0437\u0430\u0446\u0438\u0438 {style_veteran}',
        values: { style_veteran: style_veteran }
    });
};

var CANCEL_BET = exports.CANCEL_BET = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.rewards.tank.cancel_bet',
    defaultMessage: '\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C \u0441\u0442\u0430\u0432\u043A\u0443'
});

var TTC_TITLE = exports.TTC_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.rewards.tank.TTC.title',
    defaultMessage: '\u041A\u043B\u044E\u0447\u0435\u0432\u044B\u0435 \u0422\u0422\u0425:'
});

var MORE_ABOUT_TANK = exports.MORE_ABOUT_TANK = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.rewards.tank.more_about_tank',
    defaultMessage: '\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435 \u0432 \u0422\u0430\u043D\u043A\u043E\u0432\u0435\u0434\u0435\u043D\u0438\u0438'
});

var TANK_TECH_STATS = exports.TANK_TECH_STATS = {
    MAX_HEALTH: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop.rewards.tank.tank_tech_stats.max_health',
        defaultMessage: '\u041F\u0440\u043E\u0447\u043D\u043E\u0441\u0442\u044C (\u0435\u0434.)'
    }),
    HULL_ARMORS: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop.rewards.tank.tank_tech_stats.hull_armors',
        defaultMessage: '\u0411\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u043A\u043E\u0440\u043F\u0443\u0441\u0430 (\u043C\u043C)'
    }),
    TURRET_ARMORS: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop.rewards.tank.tank_tech_stats.turret_armors',
        defaultMessage: '\u0411\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0431\u0430\u0448\u043D\u0438 (\u043C\u043C)'
    }),
    DAMAGE: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop.rewards.tank.tank_tech_stats.damage',
        defaultMessage: '\u0421\u0440\u0435\u0434\u043D\u0438\u0439 \u0443\u0440\u043E\u043D (\u0435\u0434.)'
    }),
    PIERCING: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop.rewards.tank.tank_tech_stats.piercing',
        defaultMessage: '\u0421\u0440\u0435\u0434\u043D\u044F\u044F \u0431\u0440\u043E\u043D\u0435\u043F\u0440\u043E\u0431\u0438\u0432\u0430\u0435\u043C\u043E\u0441\u0442\u044C (\u043C\u043C)'
    }),
    GUN_RATE_CYCLE: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop.rewards.tank.tank_tech_stats.gun_rate_cycle',
        defaultMessage: '\u0421\u043A\u043E\u0440\u043E\u0441\u0442\u0440\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u044C \u043E\u0440\u0443\u0434\u0438\u044F (\u0432\u044B\u0441\u0442\u0440/\u043C\u0438\u043D)'
    }),
    GUN_RATE: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop.rewards.tank.tank_tech_stats.gun_rate',
        defaultMessage: '\u041F\u0435\u0440\u0435\u0437\u0430\u0440\u044F\u0434\u043A\u0430 (\u043F\u043E\u043B\u043D\u0430\u044F/\u043C\u0435\u0436\u0434\u0443/\u043A\u043E\u043B-\u0432\u043E)'
    })
};

/***/ }),
/* 1381 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"footer":"Footer_footer--3ww7B","footer__rewardPurchased":"Footer_footer__rewardPurchased--ImWs9","footerRewardPurchased":"Footer_footer__rewardPurchased--ImWs9","footer__betAccepted":"Footer_footer__betAccepted--346i5","footerBetAccepted":"Footer_footer__betAccepted--346i5","wrapperContainer":"Footer_wrapperContainer--iby6_","textBlock":"Footer_textBlock--1Gd8m","footerIcon":"Footer_footerIcon--8g9cY","footerIcon__rewardInHangar":"Footer_footerIcon__rewardInHangar--30Ju_","footerIconRewardInHangar":"Footer_footerIcon__rewardInHangar--30Ju_","footerIcon__rewardSelected":"Footer_footerIcon__rewardSelected--2WHLl","footerIconRewardSelected":"Footer_footerIcon__rewardSelected--2WHLl","footerIcon__wgMoneyUnavailable":"Footer_footerIcon__wgMoneyUnavailable--1lPrm","footerIconWgMoneyUnavailable":"Footer_footerIcon__wgMoneyUnavailable--1lPrm","text":"Footer_text--2BYFO","action":"Footer_action--2R1t-","top_count":"Footer_top_count--1ttOa","topCount":"Footer_top_count--1ttOa","finishedDate":"Footer_finishedDate--1-SW0","toChangeText":"Footer_toChangeText--2RpY6","footer__enoughPfpNotEnoughBonds":"Footer_footer__enoughPfpNotEnoughBonds--_7_aE","footerEnoughPfpNotEnoughBonds":"Footer_footer__enoughPfpNotEnoughBonds--_7_aE","yourBetText":"Footer_yourBetText--3Mehx","footerBons":"Footer_footerBons--1Jj6G","footerFamePoints":"Footer_footerFamePoints--146nX","warningMessage":"Footer_warningMessage--3blCb","battlesPlayed":"Footer_battlesPlayed--2Mgl-","battlesNeeded":"Footer_battlesNeeded--11l02","buttonAfirmative":"Footer_buttonAfirmative--3rDC5","buttonMakeBet":"Footer_buttonMakeBet--hkbrZ","buttonPurchase":"Footer_buttonPurchase--T8GeN","cancelBetWrapper":"Footer_cancelBetWrapper--3qISR","buttonCancelBet":"Footer_buttonCancelBet--1nPxY"};

/***/ }),
/* 1382 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"WGCWXRewardsTankConfirmation_base--2NSG4","content":"WGCWXRewardsTankConfirmation_content--1dfjg","back":"WGCWXRewardsTankConfirmation_back--1md2p","header":"WGCWXRewardsTankConfirmation_header--15olN","description":"WGCWXRewardsTankConfirmation_description--DcVCR","image":"WGCWXRewardsTankConfirmation_image--2_2Ci","image__error":"WGCWXRewardsTankConfirmation_image__error--2kWii","imageError":"WGCWXRewardsTankConfirmation_image__error--2kWii","image__alert":"WGCWXRewardsTankConfirmation_image__alert--2VLxg","imageAlert":"WGCWXRewardsTankConfirmation_image__alert--2VLxg","separator":"WGCWXRewardsTankConfirmation_separator--2fFFe","separator_image":"WGCWXRewardsTankConfirmation_separator_image--2YOhb","separatorImage":"WGCWXRewardsTankConfirmation_separator_image--2YOhb","buttons":"WGCWXRewardsTankConfirmation_buttons--F9vte","button":"WGCWXRewardsTankConfirmation_button--1F-mY","price":"WGCWXRewardsTankConfirmation_price--2hecR","price_divider":"WGCWXRewardsTankConfirmation_price_divider--39zRx","priceDivider":"WGCWXRewardsTankConfirmation_price_divider--39zRx","plus":"WGCWXRewardsTankConfirmation_plus--3k2eH"};

/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.battleInfoPropTypes = exports.clanInfoPropTypes = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clanInfoPropTypes = exports.clanInfoPropTypes = _propTypes2.default.shape({
    id: _propTypes2.default.number.isRequired,
    name: _propTypes2.default.string.isRequired,
    tag: _propTypes2.default.string.isRequired,
    color: _propTypes2.default.string.isRequired,
    emblemUrl: _propTypes2.default.string.isRequired
});

var battleInfoPropTypes = exports.battleInfoPropTypes = _propTypes2.default.shape({
    provinceId: _propTypes2.default.number,
    provinceName: _propTypes2.default.string.isRequired,
    arenaName: _propTypes2.default.string.isRequired,
    peripheryName: _propTypes2.default.string.isRequired,
    respawnName: _propTypes2.default.string,
    isPlanned: _propTypes2.default.bool.isRequired,
    enemyClan: clanInfoPropTypes,
    startsAt: _propTypes2.default.string.isRequired
});

/***/ }),
/* 1384 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"RatingCard_base--3KfXw","ratingHeader":"RatingCard_ratingHeader--3TUiY","title":"RatingCard_title--2QlBe","date":"RatingCard_date--1i2i3","footer":"RatingCard_footer--10egO","positionBlock":"RatingCard_positionBlock--3Ifgy","positionBlock__noPosition":"RatingCard_positionBlock__noPosition--1T881","positionBlockNoPosition":"RatingCard_positionBlock__noPosition--1T881","positionNumber":"RatingCard_positionNumber--3qtT4","positionDescription":"RatingCard_positionDescription--2gaKZ","positionText":"RatingCard_positionText--1oRSf","description":"RatingCard_description--30Bo0","rewards":"RatingCard_rewards--Zm7j3","rewards__granted":"RatingCard_rewards__granted--1K70b","rewardsGranted":"RatingCard_rewards__granted--1K70b","important":"RatingCard_important--1r-Ix","rewardBox":"RatingCard_rewardBox--1VAL8"};

/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/WGCWXLeaderboards/components/RewardTooltip/images/medal_elite.4d742213.png";

/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/WGCWXLeaderboards/components/RewardTooltip/images/medal_first.75b2dd6c.png";

/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/WGCWXLeaderboards/components/RewardTooltip/images/medal_second.f17bfa7e.png";

/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/WGCWXLeaderboards/components/RewardTooltip/images/medal_third.ad72a37e.png";

/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/WGCWXLeaderboards/components/RewardTooltip/images/medal_veteran.1d85b81a.png";

/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapStateToProps = exports.ReserveTooltip = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = __webpack_require__(7);

var _reactWotBootstrap = __webpack_require__(5);

var _ReserveTooltipBody = __webpack_require__(206);

var _constants = __webpack_require__(4);

var _helpers = __webpack_require__(11);

var _i18n = __webpack_require__(10);

var _reserves = __webpack_require__(28);

var _ReserveTooltip = __webpack_require__(2134);

var _ReserveTooltip2 = _interopRequireDefault(_ReserveTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReserveTooltip = exports.ReserveTooltip = function (_React$Component) {
    _inherits(ReserveTooltip, _React$Component);

    function ReserveTooltip() {
        _classCallCheck(this, ReserveTooltip);

        return _possibleConstructorReturn(this, (ReserveTooltip.__proto__ || Object.getPrototypeOf(ReserveTooltip)).apply(this, arguments));
    }

    _createClass(ReserveTooltip, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                _props$classNames = _props.classNames,
                classNames = _props$classNames === undefined ? {} : _props$classNames,
                id = _props.id,
                type = _props.type,
                level = _props.level,
                settings = _props.settings,
                isClientParametersVisible = _props.isClientParametersVisible,
                footer = _props.footer;


            var imageClassName = (0, _classnames2.default)(_ReserveTooltip2.default.image, _ReserveTooltip2.default['image__' + (0, _helpers.toCssClass)(type)], _defineProperty({}, _ReserveTooltip2.default.image__elite, level > _constants.MAX_BUILDING_LEVEL));
            var reserveInfo = settings.reserves[type];

            var currentBonus = reserveInfo.bonus.values[level - 1];
            var reserveGroup = (0, _reserves.getGroupByReserve)(type, settings);
            var bonusValuesArray = Object.values(currentBonus.battle_types);
            var targetType = (0, _reserves.getTargetType)(reserveGroup, bonusValuesArray);

            return _react2.default.createElement(
                _reactWotBootstrap.Tooltip,
                { id: id, isWide: true },
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)(_ReserveTooltip2.default.base, _ReserveTooltip2.default['base__type-' + targetType], className) },
                    _react2.default.createElement(
                        'div',
                        { className: _ReserveTooltip2.default.header },
                        _react2.default.createElement(
                            'div',
                            { className: _ReserveTooltip2.default.button },
                            _react2.default.createElement(
                                'div',
                                { className: _ReserveTooltip2.default.thumbnail },
                                _react2.default.createElement('div', { className: imageClassName })
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: (0, _classnames2.default)(_ReserveTooltip2.default.info, classNames.info) },
                            _react2.default.createElement(
                                'p',
                                { className: _ReserveTooltip2.default.title },
                                _i18n.RESERVE_TITLES[reserveInfo.type]
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: _ReserveTooltip2.default.level },
                                (0, _i18n.LEVEL_STRING)(level)
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _ReserveTooltip2.default.content },
                        _react2.default.createElement(_ReserveTooltipBody.ReserveTooltipBody, {
                            reserveType: type,
                            reserveInfo: reserveInfo,
                            level: level,
                            isClientParametersVisible: isClientParametersVisible
                        })
                    ),
                    footer && _react2.default.createElement(
                        'div',
                        { className: _ReserveTooltip2.default.content },
                        footer
                    )
                )
            );
        }
    }]);

    return ReserveTooltip;
}(_react2.default.Component);

ReserveTooltip.propTypes = {
    id: _propTypes2.default.string.isRequired,
    level: _propTypes2.default.number.isRequired,
    type: _propTypes2.default.string.isRequired,
    settings: _propTypes2.default.object.isRequired,
    footer: _propTypes2.default.node,
    isClientParametersVisible: _propTypes2.default.bool,
    className: _propTypes2.default.string,
    classNames: _propTypes2.default.shape({
        info: _propTypes2.default.string
    })
};
var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, _ref) {
    var id = _ref.id,
        type = _ref.type,
        level = _ref.level;
    var settings = state.settings;

    return {
        id: id,
        level: level,
        type: type,
        settings: settings
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ReserveTooltip);

/***/ }),
/* 1391 */,
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RewardReserve = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _helpers = __webpack_require__(11);

var _constants = __webpack_require__(4);

var _RewardReserve = __webpack_require__(2147);

var _RewardReserve2 = _interopRequireDefault(_RewardReserve);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var RewardReserve = exports.RewardReserve = function RewardReserve(props) {
    var _classNames;

    var imageClassName = (0, _classnames2.default)(_RewardReserve2.default.base, _RewardReserve2.default['base__' + (0, _helpers.toCssClass)(props.type)], (_classNames = {}, _defineProperty(_classNames, _RewardReserve2.default.base__elite, props.level > _constants.MAX_BUILDING_LEVEL), _defineProperty(_classNames, _RewardReserve2.default.base__adaptive, props.adaptive), _classNames));

    var level = props.showLevel && _react2.default.createElement(
        'span',
        { className: _RewardReserve2.default.level },
        (0, _helpers.toRoman)(props.level),
        _react2.default.createElement(
            'span',
            { className: _RewardReserve2.default.levelGradient },
            (0, _helpers.toRoman)(props.level)
        )
    );

    var tooltipId = props.type + '_' + props.level + '_reserve_tooltip_id';

    return _react2.default.createElement(
        'div',
        { className: imageClassName, 'data-tip': true, 'data-for': tooltipId },
        level,
        _react2.default.createElement(
            'span',
            { className: _RewardReserve2.default.counter },
            props.count
        )
    );
};

RewardReserve.propTypes = {
    level: _propTypes2.default.number.isRequired,
    type: _propTypes2.default.string.isRequired,
    count: _propTypes2.default.number.isRequired,
    showLevel: _propTypes2.default.bool,
    adaptive: _propTypes2.default.bool
};

exports.default = RewardReserve;

/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = exports.ClanPanel = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(7);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

var _reactWotBootstrap = __webpack_require__(5);

var _unit_create = __webpack_require__(129);

var _journal = __webpack_require__(582);

var _challenges = __webpack_require__(240);

var _sounds = __webpack_require__(22);

var _schedule = __webpack_require__(103);

var _constants = __webpack_require__(293);

var _Timer = __webpack_require__(51);

var _Timer2 = _interopRequireDefault(_Timer);

var _datetime = __webpack_require__(13);

var _accounts = __webpack_require__(33);

var _schedule2 = __webpack_require__(27);

var _urls = __webpack_require__(19);

var _constants2 = __webpack_require__(4);

var _components = __webpack_require__(2166);

var _constants3 = __webpack_require__(549);

var _ClanPanel = __webpack_require__(2173);

var _ClanPanel2 = _interopRequireDefault(_ClanPanel);

var _Button = __webpack_require__(788);

var _Button2 = _interopRequireDefault(_Button);

var _reactRouterRedux = __webpack_require__(15);

var _IndustrialBuyinTooltip = __webpack_require__(1346);

var _IndustrialBuyinTooltip2 = _interopRequireDefault(_IndustrialBuyinTooltip);

var _googleAnalytic = __webpack_require__(581);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ClanPanel = exports.ClanPanel = function (_React$Component) {
    _inherits(ClanPanel, _React$Component);

    function ClanPanel() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ClanPanel);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ClanPanel.__proto__ || Object.getPrototypeOf(ClanPanel)).call.apply(_ref, [this].concat(args))), _this), _this.openBattleRooms = function () {
            _this.props.playButtonClickSound();
            _this.props.openBattleRooms();
        }, _this.openChallenges = function () {
            _this.props.playClickSound();
            _this.props.openChallenges();
        }, _this.openJournal = function (tab) {
            if (!_this.props.isClanJournalEnabled) return;

            _this.props.playClickSound();
            _this.props.openJournal(tab);
        }, _this.handleChallengesStatusChange = function () {
            _this.props.requestNextChallengeInfo();
        }, _this.openResourcesJournal = function () {
            _this.openJournal(_journal.JOURNAL_TABS.resources);
        }, _this.openShop = function () {
            (0, _googleAnalytic.trackEvent)(_googleAnalytic.GA_ACTIONS.TO_STOREFRONT, _googleAnalytic.GA_LABEL.FROM_STRONGHOLD_SCREEN);

            _this.props.openShop();
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ClanPanel, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.clearTimeouts();
        }
    }, {
        key: 'setUpdateTimer',
        value: function setUpdateTimer() {
            if (this.timer) clearTimeout(this.timer);

            var now = (0, _moment2.default)();
            var nowValue = now.valueOf();
            var start = this.props.challenge.start_datetime;

            if (start && nowValue > start) return;

            var updateTimeout = start && nowValue < start ? start - nowValue : now.endOf('hour').valueOf() - nowValue;

            this.timer = setTimeout(this.handleChallengesStatusChange, Math.min(updateTimeout, _constants2.MAX_SET_TIMEOUT_VALUE));
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.requestNextChallengeInfo();
            this.setUpdateTimer();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.setUpdateTimer();
        }
    }, {
        key: 'getChallengesStatusContent',
        value: function getChallengesStatusContent() {
            var now = Date.now();
            var _props$challenge = this.props.challenge,
                start = _props$challenge.start_datetime,
                end = _props$challenge.end_datetime,
                primetimesCount = _props$challenge.primetimes_count,
                primetimeIndex = _props$challenge.primetime_index;

            var isNotLoaded = start === undefined && end === undefined;
            var isDisabled = start === null && end === null;
            var isActive = now > start && now < end;

            if (isNotLoaded) return ['\xA0', null];
            if (isDisabled) return [_constants3.CHALLENGES_OFF, _constants3.CHALLENGES_TOOLTIP_OFF];
            if (isActive) {
                var timer = _react2.default.createElement(_Timer2.default, {
                    endTime: (0, _moment2.default)(end),
                    onExpire: this.props.requestNextChallengeInfo,
                    onExpireDelay: 1000
                });
                if (primetimesCount > 1 && primetimeIndex < primetimesCount - 1) {
                    return [(0, _constants3.CHALLENGES_TIMER)(_react2.default.createElement(
                        'span',
                        { className: _ClanPanel2.default.timer },
                        timer
                    )), (0, _constants3.CHALLENGES_TOOLTIP_STAGE_ENDS)(timer)];
                }
                return [(0, _constants3.CHALLENGES_TIMER)(_react2.default.createElement(
                    'span',
                    { className: _ClanPanel2.default.timer },
                    timer
                )), (0, _constants3.CHALLENGES_TOOLTIP_ENDS)(timer)];
            }

            var isNextStage = primetimesCount > 1 && primetimeIndex > 0;
            var momentDate = (0, _moment2.default)(start);
            if ((0, _datetime.isTodayDay)(momentDate)) return [(0, _datetime.getTodayTime)(momentDate), isNextStage ? (0, _constants3.CHALLENGES_TOOLTIP_NEXT_STAGE_TODAY)(momentDate) : (0, _constants3.CHALLENGES_TOOLTIP_NEXT_TODAY)(momentDate)];
            if ((0, _datetime.isTomorrowDay)(momentDate)) return [(0, _datetime.getTomorrowTime)(momentDate), isNextStage ? (0, _constants3.CHALLENGES_TOOLTIP_NEXT_STAGE_TOMORROW)(momentDate) : (0, _constants3.CHALLENGES_TOOLTIP_NEXT_TOMORROW)(momentDate)];
            return [(0, _datetime.getCustomDateTime)(momentDate), isNextStage ? (0, _constants3.CHALLENGES_TOOLTIP_NEXT_STAGE_CUSTOM_DATE)(momentDate) : (0, _constants3.CHALLENGES_TOOLTIP_NEXT_CUSTOM_DATE)(momentDate)];
        }
    }, {
        key: 'clearTimeouts',
        value: function clearTimeouts() {
            if (this.timeoutId) clearTimeout(this.timeoutId);
            if (this.timer) clearTimeout(this.timer);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var activeBattleRooms = this.props.clanUnitsNumber > 0;

            var _getChallengesStatusC = this.getChallengesStatusContent(),
                _getChallengesStatusC2 = _slicedToArray(_getChallengesStatusC, 2),
                challengeStatus = _getChallengesStatusC2[0],
                challengeTooltipText = _getChallengesStatusC2[1];

            var challengesTabSelected = this.props.location.includes(_urls.CHALLENGES);
            var challengesComponent = _react2.default.createElement(
                'div',
                { className: _ClanPanel2.default.cell },
                _react2.default.createElement(_components.Item, {
                    selected: challengesTabSelected,
                    title: _constants3.CHALLENGES_TITLE,
                    contents: challengeStatus,
                    type: 'challenges',
                    tooltipId: _constants3.CHALLENGES_TOOLTIP_ID,
                    handleClick: challengesTabSelected ? null : this.openChallenges,
                    handleHover: challengesTabSelected ? null : this.props.playHoverSound
                }),
                _react2.default.createElement(
                    _reactWotBootstrap.Tooltip,
                    { id: _constants3.CHALLENGES_TOOLTIP_ID },
                    _react2.default.createElement(
                        'div',
                        { className: _ClanPanel2.default.tooltipContent },
                        _react2.default.createElement(
                            'p',
                            { className: _ClanPanel2.default.tooltipSubtitle },
                            _constants3.CHALLENGES_TITLE
                        ),
                        _react2.default.createElement(
                            'p',
                            { className: _ClanPanel2.default.tooltipMessage },
                            challengeTooltipText
                        ),
                        _react2.default.createElement(
                            'p',
                            { className: _ClanPanel2.default.tooltipMessage },
                            _constants3.CHALLENGES_TOOLTIP_FOOTER
                        )
                    )
                )
            );

            var isJournalTabSelected = this.props.location === _urls.LOG;
            var journalComponent = this.props.isClanJournalEnabled && _react2.default.createElement(
                'div',
                { className: _ClanPanel2.default.cell },
                _react2.default.createElement(_components.Item, {
                    selected: isJournalTabSelected,
                    title: _constants3.JOURNAL_TITLE,
                    type: 'journal',
                    tooltipId: _constants3.JOURNAL_TOOLTIP_ID,
                    handleClick: isJournalTabSelected ? null : this.openJournal,
                    handleHover: isJournalTabSelected ? null : this.props.playHoverSound
                }),
                _react2.default.createElement(
                    _reactWotBootstrap.Tooltip,
                    { id: _constants3.JOURNAL_TOOLTIP_ID },
                    _react2.default.createElement(
                        'div',
                        { className: _ClanPanel2.default.tooltipContent },
                        _react2.default.createElement(
                            'p',
                            { className: _ClanPanel2.default.tooltipSubtitle },
                            _constants3.JOURNAL_TITLE
                        ),
                        _react2.default.createElement(
                            'p',
                            { className: _ClanPanel2.default.tooltipMessage },
                            _constants3.JOURNAL_TOOLTIP
                        )
                    )
                )
            );

            var onScheduleButtonClick = function onScheduleButtonClick() {
                return _schedule2.scheduleOpenThrottler.throttle(_this2.props.openSchedule);
            };
            var scheduleButtonComponent = this.props.isScheduleEnabled && _react2.default.createElement(_components.ScheduleButton, {
                onClick: onScheduleButtonClick,
                primary: activeBattleRooms,
                showBubble: this.props.showScheduleBubble
            });

            var battlesComponent = _react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)(_ClanPanel2.default.button, _defineProperty({}, _ClanPanel2.default.button__highlight, this.props.industrialResourceMultiplier > 1))
                },
                _react2.default.createElement(_components.BattlesButton, {
                    handleClick: this.openBattleRooms,
                    handleHover: this.props.playHoverSound,
                    caption: _constants3.OPEN_BATTLE_LIST_BUTTON_CAPTION,
                    primary: activeBattleRooms,
                    tooltipId: _constants3.OPEN_BATTLE_LIST_BUTTON_TOOLTIP_ID,
                    industrialResourceMultiplier: this.props.industrialResourceMultiplier
                }),
                scheduleButtonComponent,
                _react2.default.createElement(
                    _reactWotBootstrap.Tooltip,
                    { id: _constants3.OPEN_BATTLE_LIST_BUTTON_TOOLTIP_ID },
                    _react2.default.createElement(
                        'div',
                        { className: _ClanPanel2.default.tooltipContent },
                        _react2.default.createElement(
                            'p',
                            { className: _ClanPanel2.default.tooltipSubtitle },
                            _constants3.OPEN_BATTLE_LIST_BUTTON_CAPTION
                        ),
                        activeBattleRooms && _react2.default.createElement(
                            'p',
                            { className: _ClanPanel2.default.tooltipMessage },
                            (0, _constants3.OPEN_BATTLE_LIST_BUTTON_TOOLTIP_UNITS_AVAILABLE)(this.props.clanUnitsNumber)
                        ),
                        this.props.industrialResourceMultiplier > 1 && _react2.default.createElement(
                            'p',
                            { className: _ClanPanel2.default.tooltipMessage },
                            (0, _constants.INDUSTRIAL_RESOURCE_MULTIPLIER_TOOLTIP_TEXT)(this.props.industrialResourceMultiplier)
                        ),
                        _react2.default.createElement(
                            'p',
                            { className: _ClanPanel2.default.tooltipMessage },
                            _constants3.OPEN_BATTLE_LIST_BUTTON_TOOLTIP_MESSAGE
                        )
                    )
                )
            );

            var storageIsOpen = this.props.location === _urls.LOG && this.props.journalSelectedTab === _journal.JOURNAL_TABS.resources;

            var storage = this.props.clanId && _react2.default.createElement(
                'div',
                { className: _ClanPanel2.default.cell },
                _react2.default.createElement(_components.Storage, {
                    selected: storageIsOpen,
                    industrialResource: this.props.clanIndustrialResource,
                    handleClick: this.openResourcesJournal
                })
            );

            var industrialResourceBuyinButton = this.props.industrialResourceBuyinAvailable && _react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)(_ClanPanel2.default.cell, _ClanPanel2.default.industrialResourceBuyinButton) },
                _react2.default.createElement(
                    _Button2.default,
                    {
                        type: 'secondary',
                        onClick: this.openShop,
                        tooltipId: _IndustrialBuyinTooltip2.default.id
                    },
                    _react2.default.createElement(
                        'span',
                        { className: _ClanPanel2.default.industrialResourceBuyinText },
                        _constants3.INDUSTRIAL_RESOURCE_BUYIN_BUTTON
                    )
                ),
                _react2.default.createElement(_IndustrialBuyinTooltip2.default, null)
            );

            var className = (0, _classnames2.default)(_ClanPanel2.default.base, _defineProperty({}, _ClanPanel2.default.base__active, activeBattleRooms));

            var leftPartClassName = (0, _classnames2.default)(_ClanPanel2.default.part, _ClanPanel2.default.part__left);
            var rightPartClassName = (0, _classnames2.default)(_ClanPanel2.default.part, _ClanPanel2.default.part__right);
            var centralPartClassName = (0, _classnames2.default)(_ClanPanel2.default.part, _ClanPanel2.default.part__center);
            return _react2.default.createElement(
                'div',
                { className: className },
                _react2.default.createElement('div', { className: _ClanPanel2.default.background }),
                _react2.default.createElement(
                    'div',
                    { className: leftPartClassName },
                    challengesComponent,
                    journalComponent
                ),
                _react2.default.createElement(
                    'div',
                    { className: centralPartClassName },
                    battlesComponent
                ),
                _react2.default.createElement(
                    'div',
                    { className: rightPartClassName },
                    storage,
                    industrialResourceBuyinButton
                )
            );
        }
    }]);

    return ClanPanel;
}(_react2.default.Component);

ClanPanel.contextTypes = {
    router: _propTypes2.default.object
};
ClanPanel.propTypes = {
    challenge: _propTypes2.default.shape({
        start_datetime: _propTypes2.default.number,
        end_datetime: _propTypes2.default.number,
        primetimes_count: _propTypes2.default.number,
        primetime_index: _propTypes2.default.number
    }),
    clanId: _propTypes2.default.number,
    clanIndustrialResource: _propTypes2.default.number,
    clanUnitsNumber: _propTypes2.default.number,
    isClanJournalEnabled: _propTypes2.default.bool.isRequired,
    isScheduleEnabled: _propTypes2.default.bool.isRequired,
    industrialResourceBuyinAvailable: _propTypes2.default.bool.isRequired,
    journalSelectedTab: _propTypes2.default.string,
    location: _propTypes2.default.string.isRequired,
    showScheduleBubble: _propTypes2.default.bool,
    industrialResourceMultiplier: _propTypes2.default.number,

    openShop: _propTypes2.default.func.isRequired,
    openBattleRooms: _propTypes2.default.func.isRequired,
    openChallenges: _propTypes2.default.func.isRequired,
    openJournal: _propTypes2.default.func.isRequired,
    openSchedule: _propTypes2.default.func.isRequired,
    playButtonClickSound: _propTypes2.default.func.isRequired,
    playClickSound: _propTypes2.default.func.isRequired,
    playHoverSound: _propTypes2.default.func.isRequired,
    requestNextChallengeInfo: _propTypes2.default.func.isRequired
};
var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
    var account = state.account,
        challenge = state.challenges.nextChallenge,
        clan = state.clan,
        userFlags = state.userFlags,
        journalSelectedTab = state.journal.selectedTab,
        routing = state.routing,
        industrialResourceMultiplier = state.settings.industrialResourceMultiplier;


    var location = routing.locationBeforeTransitions.pathname;

    var isScheduleEnabled = (0, _accounts.isFeatureAvailable)(account, _constants2.FEATURE_TYPES.SCHEDULE);
    var isClanJournalEnabled = clan.id !== null && (0, _accounts.isFeatureAvailable)(account, _constants2.FEATURE_TYPES.CLAN_JOURNAL);

    var showClanTreasuryTabs = account.permissions.see_treasury || false;

    var showScheduleBubble = !userFlags.schedule_visited;

    return {
        industrialResourceBuyinAvailable: !!state.shop.status && state.shop.status.enabled,
        challenge: challenge,
        clanId: clan.id,
        clanIndustrialResource: clan.industrial_resource,
        clanTreasury: clan.treasury,
        clanUnitsNumber: clan.units_number,
        isClanJournalEnabled: isClanJournalEnabled,
        isScheduleEnabled: isScheduleEnabled,
        journalSelectedTab: journalSelectedTab,
        location: location,
        showClanTreasuryTabs: showClanTreasuryTabs,
        showScheduleBubble: showScheduleBubble,
        industrialResourceMultiplier: industrialResourceMultiplier
    };
};

var mapDispatchToProps = exports.mapDispatchToProps = {
    openBattleRooms: _unit_create.openBattleRooms,
    openChallenges: _challenges.openChallenges,
    openJournal: _journal.openJournal,
    openSchedule: _schedule.openSchedule,
    openShop: function openShop() {
        return (0, _reactRouterRedux.push)(_urls.SHOP_STOREFRONT);
    },

    requestNextChallengeInfo: _challenges.requestNextChallengeInfo,

    playHoverSound: _sounds.playHoverSound,
    playButtonClickSound: _sounds.playButtonClickSound,
    playClickSound: _sounds.playClickSound
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ClanPanel);

/***/ }),
/* 1394 */,
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ELO_LEADERBOARD_UPDATE = exports.ELO_LEADERBOARD_UPDATED_DATE_MESSAGE = exports.ELO_LEADERBOARD_DISABLED_BATTLE_MODE_FILTER_FOOTER = exports.CLICK_TO_OPEN_LEADERBOARD = exports.ELO_LEADERBOARD_UPDATE_RATE_MESSAGE = exports.ELO_LEADERBOARD_TITLE = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

var _datetime = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-multi-comp */
var ELO_LEADERBOARD_TITLE = exports.ELO_LEADERBOARD_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'leaderboard.title',
    defaultMessage: '\u0420\u0435\u0439\u0442\u0438\u043D\u0433 \u043A\u043B\u0430\u043D\u043E\u0432 \u043F\u043E \u042D\u043B\u043E'
});

var ELO_LEADERBOARD_UPDATE_RATE_MESSAGE = exports.ELO_LEADERBOARD_UPDATE_RATE_MESSAGE = function ELO_LEADERBOARD_UPDATE_RATE_MESSAGE(recalculationPeriod) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'UpdateRatingTooltip.title',
        defaultMessage: '\u0414\u0430\u043D\u043D\u044B\u0435 \u043E\u0431\u043D\u043E\u0432\u043B\u044F\u044E\u0442\u0441\u044F \u0440\u0430\u0437 \u0432 {recalculationPeriod} \u043C\u0438\u043D.',
        values: { recalculationPeriod: recalculationPeriod }
    });
};

var CLICK_TO_OPEN_LEADERBOARD = exports.CLICK_TO_OPEN_LEADERBOARD = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'ActiveDivisionClanList.message',
    defaultMessage: '\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043F\u0435\u0440\u0435\u0439\u0442\u0438 \u043A \u0441\u043F\u0438\u0441\u043A\u0443 \u043A\u043B\u0430\u043D\u043E\u0432 \u044D\u0442\u043E\u0433\u043E \u0434\u0438\u0432\u0438\u0437\u0438\u043E\u043D\u0430.'
});

var ELO_LEADERBOARD_DISABLED_BATTLE_MODE_FILTER_FOOTER = exports.ELO_LEADERBOARD_DISABLED_BATTLE_MODE_FILTER_FOOTER = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'DisabledDivisionClanList.message',
    defaultMessage: '\u0421\u043F\u0438\u0441\u043E\u043A \u043A\u043B\u0430\u043D\u043E\u0432 \u044D\u0442\u043E\u0433\u043E \u0434\u0438\u0432\u0438\u0437\u0438\u043E\u043D\u0430 \u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u0435\u043D.'
});

var ELO_LEADERBOARD_UPDATED_DATE_MESSAGE = exports.ELO_LEADERBOARD_UPDATED_DATE_MESSAGE = function ELO_LEADERBOARD_UPDATED_DATE_MESSAGE(updateDate) {
    updateDate = (0, _moment2.default)(updateDate);

    if ((0, _datetime.isTodayDay)(updateDate)) {
        updateDate = (0, _datetime.getTodayTime)(updateDate);
    } else if ((0, _datetime.isYesterdayDay)(updateDate)) {
        updateDate = (0, _datetime.getYesterdayTime)(updateDate);
    } else {
        updateDate = (0, _datetime.getCustomDateTime)(updateDate);
    }

    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'UpdatedRatingTooltip.date',
        defaultMessage: '\u041E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u043E {updateDate}',
        values: { updateDate: updateDate }
    });
};

var ELO_LEADERBOARD_UPDATE = exports.ELO_LEADERBOARD_UPDATE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'leaderboard.update',
    defaultMessage: '\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0440\u0435\u0439\u0442\u0438\u043D\u0433'
});

/***/ }),
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(168);
module.exports = __webpack_require__(1603);


/***/ }),
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */,
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */,
/* 1505 */,
/* 1506 */,
/* 1507 */,
/* 1508 */,
/* 1509 */,
/* 1510 */,
/* 1511 */,
/* 1512 */,
/* 1513 */,
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */,
/* 1521 */,
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */,
/* 1534 */,
/* 1535 */,
/* 1536 */,
/* 1537 */,
/* 1538 */,
/* 1539 */,
/* 1540 */,
/* 1541 */,
/* 1542 */,
/* 1543 */,
/* 1544 */,
/* 1545 */,
/* 1546 */,
/* 1547 */,
/* 1548 */,
/* 1549 */,
/* 1550 */,
/* 1551 */,
/* 1552 */,
/* 1553 */,
/* 1554 */,
/* 1555 */,
/* 1556 */,
/* 1557 */,
/* 1558 */,
/* 1559 */,
/* 1560 */,
/* 1561 */,
/* 1562 */,
/* 1563 */,
/* 1564 */,
/* 1565 */,
/* 1566 */,
/* 1567 */,
/* 1568 */,
/* 1569 */,
/* 1570 */,
/* 1571 */,
/* 1572 */,
/* 1573 */,
/* 1574 */,
/* 1575 */,
/* 1576 */,
/* 1577 */,
/* 1578 */,
/* 1579 */,
/* 1580 */,
/* 1581 */,
/* 1582 */,
/* 1583 */,
/* 1584 */,
/* 1585 */,
/* 1586 */,
/* 1587 */,
/* 1588 */,
/* 1589 */,
/* 1590 */,
/* 1591 */,
/* 1592 */,
/* 1593 */,
/* 1594 */,
/* 1595 */,
/* 1596 */,
/* 1597 */,
/* 1598 */,
/* 1599 */,
/* 1600 */,
/* 1601 */,
/* 1602 */,
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(75);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = __webpack_require__(7);

var _reactRouter = __webpack_require__(145);

var _reactRouterRedux = __webpack_require__(15);

var _urls = __webpack_require__(19);

__webpack_require__(175);

var _App = __webpack_require__(176);

var _App2 = _interopRequireDefault(_App);

var _AuthWrapper = __webpack_require__(190);

var _AuthWrapper2 = _interopRequireDefault(_AuthWrapper);

var _BuildingView = __webpack_require__(2073);

var _BuildingView2 = _interopRequireDefault(_BuildingView);

var _BattleRooms = __webpack_require__(398);

var _BattleRooms2 = _interopRequireDefault(_BattleRooms);

var _UnitCreateWizard = __webpack_require__(479);

var _UnitCreateWizard2 = _interopRequireDefault(_UnitCreateWizard);

var _UnitRebuildWizard = __webpack_require__(522);

var _UnitRebuildWizard2 = _interopRequireDefault(_UnitRebuildWizard);

var _Construct = __webpack_require__(2153);

var _Construct2 = _interopRequireDefault(_Construct);

var _PostbattleScreen = __webpack_require__(523);

var _PostbattleScreen2 = _interopRequireDefault(_PostbattleScreen);

var _Stronghold = __webpack_require__(1340);

var _Stronghold2 = _interopRequireDefault(_Stronghold);

var _StrongholdWrapper = __webpack_require__(2215);

var _StrongholdWrapper2 = _interopRequireDefault(_StrongholdWrapper);

var _UnitPreview = __webpack_require__(292);

var _UnitPreview2 = _interopRequireDefault(_UnitPreview);

var _ClanLandingContainer = __webpack_require__(2306);

var _ClanLandingContainer2 = _interopRequireDefault(_ClanLandingContainer);

var _ClanManagement = __webpack_require__(2370);

var _ClanManagement2 = _interopRequireDefault(_ClanManagement);

var _ClanLeaving = __webpack_require__(2407);

var _ClanLeaving2 = _interopRequireDefault(_ClanLeaving);

var _WGCWXWrapper = __webpack_require__(2417);

var _WGCWXWrapper2 = _interopRequireDefault(_WGCWXWrapper);

var _WGCWXShop = __webpack_require__(2426);

var _WGCWXShop2 = _interopRequireDefault(_WGCWXShop);

var _WGCWXBattleSchedule = __webpack_require__(2452);

var _WGCWXBattleSchedule2 = _interopRequireDefault(_WGCWXBattleSchedule);

var _WGCWXLeaderboards = __webpack_require__(2461);

var _WGCWXLeaderboards2 = _interopRequireDefault(_WGCWXLeaderboards);

var _Stub = __webpack_require__(239);

var _Stub2 = _interopRequireDefault(_Stub);

var _store = __webpack_require__(56);

var _store2 = _interopRequireDefault(_store);

var _ShopView = __webpack_require__(2486);

var _ShopView2 = _interopRequireDefault(_ShopView);

var _web_to_client = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.hashHistory, _store2.default); /* global process */
/* eslint-disable react/jsx-closing-bracket-location */

__webpack_require__(2488);

if (true) {
    window.oncontextmenu = function () {
        return false;
    };
}

window.onBeforeUnloadHandlers = {};
window.onbeforeunload = function () {
    Object.values(window.onBeforeUnloadHandlers).forEach(function (handler) {
        try {
            handler();
        } catch (e) {
            console.error(e); // eslint-disable-line no-console
        }
    });
};
window.onBeforeUnloadHandlers.hideTooltip = function () {
    // we wanna be ensure that all ingame tooltips became closed when we close interface @see WGCQ-573
    (0, _web_to_client.hideTooltip)();
};

var loadShopProductPreviewScreen = function loadShopProductPreviewScreen(location, cb) {
    return __webpack_require__.e/* require.ensure */(7).then((function (require) {
        return cb(null, __webpack_require__(3872).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var loadShopStorefrontScreen = function loadShopStorefrontScreen(location, cb) {
    return __webpack_require__.e/* require.ensure */(6).then((function (require) {
        return cb(null, __webpack_require__(3873).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var loadShopErrorScreen = function loadShopErrorScreen(location, cb) {
    return __webpack_require__.e/* require.ensure */(8).then((function (require) {
        return cb(null, __webpack_require__(3874).default);
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var loadShopCongratulationScreen = function loadShopCongratulationScreen(location, cb) {
    return __webpack_require__.e/* require.ensure */(9).then((function (require) {
        return (
            // eslint-disable-next-line max-len
            cb(null, __webpack_require__(3875).default)
        );
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var loadShopStubScreen = function loadShopStubScreen(location, cb) {
    return __webpack_require__.e/* require.ensure */(10).then((function (require) {
        return (
            // eslint-disable-next-line max-len
            cb(null, __webpack_require__(3876).default)
        );
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

_reactDom2.default.render(_react2.default.createElement(
    _reactRedux.Provider,
    { store: _store2.default },
    _react2.default.createElement(
        _reactRouter.Router,
        { history: history },
        _react2.default.createElement(
            _reactRouter.Route,
            { path: '/', component: _App2.default },
            _react2.default.createElement(_reactRouter.IndexRedirect, { to: _urls.CLAN_LANDING }),
            _react2.default.createElement(
                _reactRouter.Route,
                { component: _AuthWrapper2.default },
                _react2.default.createElement(_reactRouter.Route, { path: 'battlerooms', component: _BattleRooms2.default }),
                _react2.default.createElement(_reactRouter.Route, { path: 'units/create', component: _UnitCreateWizard2.default }),
                _react2.default.createElement(_reactRouter.Route, { path: 'units/rebuild/:unitServerId', component: _UnitRebuildWizard2.default }),
                _react2.default.createElement(_reactRouter.Route, { path: 'units/preview/:unitServerId', component: _UnitPreview2.default }),
                _react2.default.createElement(
                    _reactRouter.Route,
                    { component: _StrongholdWrapper2.default },
                    _react2.default.createElement(_reactRouter.Route, { path: _urls.CLAN_LANDING, component: _ClanLandingContainer2.default }),
                    _react2.default.createElement(
                        _reactRouter.Route,
                        { path: 'stronghold', component: _Stronghold2.default },
                        _react2.default.createElement(_reactRouter.Route, { path: 'build/:slotId', component: _Construct2.default }),
                        _react2.default.createElement(_reactRouter.Route, { path: 'building/:buildingId', component: _BuildingView2.default }),
                        _react2.default.createElement(_reactRouter.Route, { path: 'log', getComponent: function getComponent(_, cb) {
                                return __webpack_require__.e/* require.ensure */(1).then((function (require) {
                                    return cb(null, __webpack_require__(3877).default);
                                }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                            } })
                    ),
                    _react2.default.createElement(_reactRouter.Route, { path: _urls.CLAN_LEAVING, component: _ClanLeaving2.default }),
                    _react2.default.createElement(_reactRouter.Route, { path: _urls.CLAN_MANAGEMENT, component: _ClanManagement2.default }),
                    _react2.default.createElement(_reactRouter.Route, { path: 'stronghold/leaderboard', getComponent: function getComponent(_, cb) {
                            return __webpack_require__.e/* require.ensure */(5).then((function (require) {
                                return cb(null, __webpack_require__(3878).default);
                            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                        } }),
                    _react2.default.createElement(_reactRouter.Route, { path: 'challenges-results/:challengeId', getComponent: function getComponent(_, cb) {
                            return __webpack_require__.e/* require.ensure */(3).then((function (require) {
                                return cb(null, __webpack_require__(3879).default);
                            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                        } }),
                    _react2.default.createElement(_reactRouter.Route, { path: _urls.CHALLENGES + '(/:challengeId)', getComponent: function getComponent(location, cb) {
                            return __webpack_require__.e/* require.ensure */(2).then((function (require) {
                                return cb(null, __webpack_require__(3880).default);
                            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                        } }),
                    _react2.default.createElement(_reactRouter.Route, { path: _urls.CHALLENGES + '/:challengeId/:challengeName', getComponent: function getComponent(location, cb) {
                            return __webpack_require__.e/* require.ensure */(4).then((function (require) {
                                return cb(null, __webpack_require__(3881).default);
                            }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
                        } }),
                    _react2.default.createElement(
                        _reactRouter.Route,
                        { component: _ShopView2.default },
                        _react2.default.createElement(_reactRouter.Route, { path: (0, _urls.SHOP_PRODUCT_PREVIEW)(), getComponent: loadShopProductPreviewScreen }),
                        _react2.default.createElement(_reactRouter.Route, { path: (0, _urls.SHOP_ERROR)(), getComponent: loadShopErrorScreen }),
                        _react2.default.createElement(_reactRouter.Route, { path: _urls.SHOP_STOREFRONT, getComponent: loadShopStorefrontScreen }),
                        _react2.default.createElement(_reactRouter.Route, { path: (0, _urls.SHOP_CONGRATULATIONS)(), getComponent: loadShopCongratulationScreen }),
                        _react2.default.createElement(_reactRouter.Route, { path: (0, _urls.SHOP_STUB)(), getComponent: loadShopStubScreen })
                    )
                )
            ),
            _react2.default.createElement(_reactRouter.Route, { path: 'postbattle/:seriesId/:clanId', component: _PostbattleScreen2.default }),
            _react2.default.createElement(_reactRouter.Route, { path: 'stronghold/:clanId', component: _Stronghold2.default }),
            _react2.default.createElement(
                _reactRouter.Route,
                { component: _WGCWXWrapper2.default },
                _react2.default.createElement(_reactRouter.Route, { path: 'personal_shop/:partitionType', component: _WGCWXShop2.default }),
                _react2.default.createElement(_reactRouter.Route, { path: _urls.WGCWX_BATTLE_SCHEDULE, component: _WGCWXBattleSchedule2.default }),
                _react2.default.createElement(_reactRouter.Route, { path: _urls.WGCWX_LEADERBOARDS, component: _WGCWXLeaderboards2.default })
            ),
            _react2.default.createElement(_reactRouter.Route, { path: 'stub', component: _Stub2.default })
        )
    )
), document.getElementById('content'));

/***/ }),
/* 1604 */,
/* 1605 */,
/* 1606 */,
/* 1607 */,
/* 1608 */,
/* 1609 */,
/* 1610 */,
/* 1611 */,
/* 1612 */,
/* 1613 */,
/* 1614 */,
/* 1615 */,
/* 1616 */,
/* 1617 */,
/* 1618 */,
/* 1619 */,
/* 1620 */,
/* 1621 */,
/* 1622 */,
/* 1623 */,
/* 1624 */,
/* 1625 */,
/* 1626 */,
/* 1627 */,
/* 1628 */,
/* 1629 */,
/* 1630 */,
/* 1631 */,
/* 1632 */,
/* 1633 */,
/* 1634 */,
/* 1635 */,
/* 1636 */,
/* 1637 */,
/* 1638 */,
/* 1639 */,
/* 1640 */,
/* 1641 */,
/* 1642 */,
/* 1643 */,
/* 1644 */,
/* 1645 */,
/* 1646 */,
/* 1647 */,
/* 1648 */,
/* 1649 */,
/* 1650 */,
/* 1651 */,
/* 1652 */,
/* 1653 */,
/* 1654 */,
/* 1655 */,
/* 1656 */,
/* 1657 */,
/* 1658 */,
/* 1659 */,
/* 1660 */,
/* 1661 */,
/* 1662 */,
/* 1663 */,
/* 1664 */,
/* 1665 */,
/* 1666 */,
/* 1667 */,
/* 1668 */,
/* 1669 */,
/* 1670 */,
/* 1671 */,
/* 1672 */,
/* 1673 */,
/* 1674 */,
/* 1675 */,
/* 1676 */,
/* 1677 */,
/* 1678 */,
/* 1679 */,
/* 1680 */,
/* 1681 */,
/* 1682 */,
/* 1683 */,
/* 1684 */,
/* 1685 */,
/* 1686 */,
/* 1687 */,
/* 1688 */,
/* 1689 */,
/* 1690 */,
/* 1691 */,
/* 1692 */,
/* 1693 */,
/* 1694 */,
/* 1695 */,
/* 1696 */,
/* 1697 */,
/* 1698 */,
/* 1699 */,
/* 1700 */,
/* 1701 */,
/* 1702 */,
/* 1703 */,
/* 1704 */,
/* 1705 */,
/* 1706 */,
/* 1707 */,
/* 1708 */,
/* 1709 */,
/* 1710 */,
/* 1711 */,
/* 1712 */,
/* 1713 */,
/* 1714 */,
/* 1715 */,
/* 1716 */,
/* 1717 */,
/* 1718 */,
/* 1719 */,
/* 1720 */,
/* 1721 */,
/* 1722 */,
/* 1723 */,
/* 1724 */,
/* 1725 */,
/* 1726 */,
/* 1727 */,
/* 1728 */,
/* 1729 */,
/* 1730 */,
/* 1731 */,
/* 1732 */,
/* 1733 */,
/* 1734 */,
/* 1735 */,
/* 1736 */,
/* 1737 */,
/* 1738 */,
/* 1739 */,
/* 1740 */,
/* 1741 */,
/* 1742 */,
/* 1743 */,
/* 1744 */,
/* 1745 */,
/* 1746 */,
/* 1747 */,
/* 1748 */,
/* 1749 */,
/* 1750 */,
/* 1751 */,
/* 1752 */,
/* 1753 */,
/* 1754 */,
/* 1755 */,
/* 1756 */,
/* 1757 */,
/* 1758 */,
/* 1759 */,
/* 1760 */,
/* 1761 */,
/* 1762 */,
/* 1763 */,
/* 1764 */,
/* 1765 */,
/* 1766 */,
/* 1767 */,
/* 1768 */,
/* 1769 */,
/* 1770 */,
/* 1771 */,
/* 1772 */,
/* 1773 */,
/* 1774 */,
/* 1775 */,
/* 1776 */,
/* 1777 */,
/* 1778 */,
/* 1779 */,
/* 1780 */,
/* 1781 */,
/* 1782 */,
/* 1783 */,
/* 1784 */,
/* 1785 */,
/* 1786 */,
/* 1787 */,
/* 1788 */,
/* 1789 */,
/* 1790 */,
/* 1791 */,
/* 1792 */,
/* 1793 */,
/* 1794 */,
/* 1795 */,
/* 1796 */,
/* 1797 */,
/* 1798 */,
/* 1799 */,
/* 1800 */,
/* 1801 */,
/* 1802 */,
/* 1803 */,
/* 1804 */,
/* 1805 */,
/* 1806 */,
/* 1807 */,
/* 1808 */,
/* 1809 */,
/* 1810 */,
/* 1811 */,
/* 1812 */,
/* 1813 */,
/* 1814 */,
/* 1815 */,
/* 1816 */,
/* 1817 */,
/* 1818 */,
/* 1819 */,
/* 1820 */,
/* 1821 */,
/* 1822 */,
/* 1823 */,
/* 1824 */,
/* 1825 */,
/* 1826 */,
/* 1827 */,
/* 1828 */,
/* 1829 */,
/* 1830 */,
/* 1831 */,
/* 1832 */,
/* 1833 */,
/* 1834 */,
/* 1835 */,
/* 1836 */,
/* 1837 */,
/* 1838 */,
/* 1839 */,
/* 1840 */,
/* 1841 */,
/* 1842 */,
/* 1843 */,
/* 1844 */,
/* 1845 */,
/* 1846 */,
/* 1847 */,
/* 1848 */,
/* 1849 */,
/* 1850 */,
/* 1851 */,
/* 1852 */,
/* 1853 */,
/* 1854 */,
/* 1855 */,
/* 1856 */,
/* 1857 */,
/* 1858 */,
/* 1859 */,
/* 1860 */,
/* 1861 */,
/* 1862 */,
/* 1863 */,
/* 1864 */,
/* 1865 */,
/* 1866 */,
/* 1867 */,
/* 1868 */,
/* 1869 */,
/* 1870 */,
/* 1871 */,
/* 1872 */,
/* 1873 */,
/* 1874 */,
/* 1875 */,
/* 1876 */,
/* 1877 */,
/* 1878 */,
/* 1879 */,
/* 1880 */,
/* 1881 */,
/* 1882 */,
/* 1883 */,
/* 1884 */,
/* 1885 */,
/* 1886 */,
/* 1887 */,
/* 1888 */,
/* 1889 */,
/* 1890 */,
/* 1891 */,
/* 1892 */,
/* 1893 */,
/* 1894 */,
/* 1895 */,
/* 1896 */,
/* 1897 */,
/* 1898 */,
/* 1899 */,
/* 1900 */,
/* 1901 */,
/* 1902 */,
/* 1903 */,
/* 1904 */,
/* 1905 */,
/* 1906 */,
/* 1907 */,
/* 1908 */,
/* 1909 */,
/* 1910 */,
/* 1911 */,
/* 1912 */,
/* 1913 */,
/* 1914 */,
/* 1915 */,
/* 1916 */,
/* 1917 */,
/* 1918 */,
/* 1919 */,
/* 1920 */,
/* 1921 */,
/* 1922 */,
/* 1923 */,
/* 1924 */,
/* 1925 */,
/* 1926 */,
/* 1927 */,
/* 1928 */,
/* 1929 */,
/* 1930 */,
/* 1931 */,
/* 1932 */,
/* 1933 */,
/* 1934 */,
/* 1935 */,
/* 1936 */,
/* 1937 */,
/* 1938 */,
/* 1939 */,
/* 1940 */,
/* 1941 */,
/* 1942 */,
/* 1943 */,
/* 1944 */,
/* 1945 */,
/* 1946 */,
/* 1947 */,
/* 1948 */,
/* 1949 */,
/* 1950 */,
/* 1951 */,
/* 1952 */,
/* 1953 */,
/* 1954 */,
/* 1955 */,
/* 1956 */,
/* 1957 */,
/* 1958 */,
/* 1959 */,
/* 1960 */,
/* 1961 */,
/* 1962 */,
/* 1963 */,
/* 1964 */,
/* 1965 */,
/* 1966 */,
/* 1967 */,
/* 1968 */,
/* 1969 */,
/* 1970 */,
/* 1971 */,
/* 1972 */,
/* 1973 */,
/* 1974 */,
/* 1975 */,
/* 1976 */,
/* 1977 */,
/* 1978 */,
/* 1979 */,
/* 1980 */,
/* 1981 */,
/* 1982 */,
/* 1983 */,
/* 1984 */,
/* 1985 */,
/* 1986 */,
/* 1987 */,
/* 1988 */,
/* 1989 */,
/* 1990 */,
/* 1991 */,
/* 1992 */,
/* 1993 */,
/* 1994 */,
/* 1995 */,
/* 1996 */,
/* 1997 */,
/* 1998 */,
/* 1999 */,
/* 2000 */,
/* 2001 */,
/* 2002 */,
/* 2003 */,
/* 2004 */,
/* 2005 */,
/* 2006 */,
/* 2007 */,
/* 2008 */,
/* 2009 */,
/* 2010 */,
/* 2011 */,
/* 2012 */,
/* 2013 */,
/* 2014 */,
/* 2015 */,
/* 2016 */,
/* 2017 */,
/* 2018 */,
/* 2019 */,
/* 2020 */,
/* 2021 */,
/* 2022 */,
/* 2023 */,
/* 2024 */,
/* 2025 */,
/* 2026 */,
/* 2027 */,
/* 2028 */,
/* 2029 */,
/* 2030 */,
/* 2031 */,
/* 2032 */,
/* 2033 */,
/* 2034 */,
/* 2035 */,
/* 2036 */,
/* 2037 */,
/* 2038 */,
/* 2039 */,
/* 2040 */,
/* 2041 */,
/* 2042 */,
/* 2043 */,
/* 2044 */,
/* 2045 */,
/* 2046 */,
/* 2047 */,
/* 2048 */,
/* 2049 */,
/* 2050 */,
/* 2051 */,
/* 2052 */,
/* 2053 */,
/* 2054 */,
/* 2055 */,
/* 2056 */,
/* 2057 */,
/* 2058 */,
/* 2059 */,
/* 2060 */,
/* 2061 */,
/* 2062 */,
/* 2063 */,
/* 2064 */,
/* 2065 */,
/* 2066 */,
/* 2067 */,
/* 2068 */,
/* 2069 */,
/* 2070 */,
/* 2071 */,
/* 2072 */,
/* 2073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = exports.BuildingView = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(7);

var _reactRouterRedux = __webpack_require__(15);

var _reactAddonsCssTransitionGroup = __webpack_require__(287);

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _BuildingCard = __webpack_require__(2084);

var _BuildingCard2 = _interopRequireDefault(_BuildingCard);

var _BuildingsCarousel = __webpack_require__(2128);

var _BuildingsCarousel2 = _interopRequireDefault(_BuildingsCarousel);

var _CommandCenterCard = __webpack_require__(2133);

var _CommandCenterCard2 = _interopRequireDefault(_CommandCenterCard);

var _BuildingTooltip = __webpack_require__(290);

var _BuildingTooltip2 = _interopRequireDefault(_BuildingTooltip);

var _CommandCenterTooltip = __webpack_require__(291);

var _CommandCenterTooltip2 = _interopRequireDefault(_CommandCenterTooltip);

var _Back = __webpack_require__(70);

var _Back2 = _interopRequireDefault(_Back);

var _urls = __webpack_require__(19);

var _constants = __webpack_require__(4);

var _BuildingView = __webpack_require__(2152);

var _BuildingView2 = _interopRequireDefault(_BuildingView);

var _reserve_level_select = __webpack_require__(371);

var _reserves = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BuildingView = exports.BuildingView = function (_React$Component) {
    _inherits(BuildingView, _React$Component);

    function BuildingView(props) {
        _classCallCheck(this, BuildingView);

        var _this = _possibleConstructorReturn(this, (BuildingView.__proto__ || Object.getPrototypeOf(BuildingView)).call(this, props));

        props.changeSelectedLevel(props.selectedLevel);
        return _this;
    }

    _createClass(BuildingView, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate(_ref) {
            var buildingId = _ref.buildingId,
                buildingLevel = _ref.buildingLevel;

            if (buildingId !== this.props.buildingId || buildingLevel !== this.props.buildingLevel) {
                this.props.changeSelectedLevel(this.props.selectedLevel);
            }
        }
    }, {
        key: 'getTooltips',
        value: function getTooltips() {
            var tooltips = this.props.buildings.map(function (building) {
                return _react2.default.createElement(_BuildingTooltip2.default, {
                    key: _constants.CAROUSEL_BUILDING_TOOLTIP_ID + '_' + building.type,
                    id: _constants.CAROUSEL_BUILDING_TOOLTIP_ID + '_' + building.type,
                    building: building
                });
            });
            tooltips.push(_react2.default.createElement(_CommandCenterTooltip2.default, {
                key: _constants.CAROUSEL_COMMAND_CENTER_TOOLTIP_ID,
                id: _constants.CAROUSEL_COMMAND_CENTER_TOOLTIP_ID,
                level: this.props.level
            }));
            return tooltips;
        }
    }, {
        key: 'render',
        value: function render() {
            var building = void 0;
            if (this.props.buildingId === _constants.COMMAND_CENTER_ID) {
                building = _react2.default.createElement(_CommandCenterCard2.default, { key: _constants.COMMAND_CENTER_ID });
            } else {
                building = _react2.default.createElement(_BuildingCard2.default, { buildingId: this.props.buildingId, key: 'building_' + this.props.buildingId });
            }

            return _react2.default.createElement(
                'div',
                { className: _BuildingView2.default.base },
                _react2.default.createElement(
                    'div',
                    { className: _BuildingView2.default.view },
                    _react2.default.createElement(
                        'div',
                        { className: _BuildingView2.default.back },
                        _react2.default.createElement(_Back2.default, { handleClick: this.props.pushState.bind(null, _urls.STRONGHOLD) })
                    ),
                    _react2.default.createElement(
                        _reactAddonsCssTransitionGroup2.default,
                        {
                            transitionName: 'building',
                            transitionAppear: true,
                            transitionAppearTimeout: 500,
                            transitionEnter: true,
                            transitionEnterTimeout: 500,
                            transitionLeave: true,
                            transitionLeaveTimeout: 200
                        },
                        building
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _BuildingView2.default.carousel },
                    _react2.default.createElement(_BuildingsCarousel2.default, { selectedBuildingId: this.props.buildingId })
                ),
                this.getTooltips()
            );
        }
    }]);

    return BuildingView;
}(_react2.default.Component);

BuildingView.propTypes = {
    pushState: _propTypes2.default.func.isRequired,
    buildings: _propTypes2.default.array.isRequired,
    buildingId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
    level: _propTypes2.default.number.isRequired,
    selectedLevel: _propTypes2.default.number.isRequired,
    buildingLevel: _propTypes2.default.number.isRequired,
    changeSelectedLevel: _propTypes2.default.func.isRequired
};
var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
    var stronghold = state.stronghold;

    var buildingId = parseInt(ownProps.params.buildingId) || ownProps.params.buildingId;
    var level = stronghold.level;


    var buildings = Object.keys(state.buildings).map(function (buildingId) {
        var _state$buildings$buil = state.buildings[buildingId],
            id = _state$buildings$buil.id,
            name = _state$buildings$buil.name,
            type = _state$buildings$buil.type,
            level = _state$buildings$buil.level;

        return { id: id, name: name, type: type, level: level };
    });

    var selectedLevel = 1;
    var buildingLevel = 1;
    var building = state.buildings[buildingId];
    if (building) {
        var reserveType = state.settings.buildings[building.type].reserve_type;
        var reserves = (0, _reserves.getSortedProductionReserves)(state.clanReserves[reserveType]);
        selectedLevel = reserves[0] ? reserves[0].level : building.level;
        buildingLevel = building.level;
    }

    return {
        buildings: buildings,
        buildingId: buildingId,
        selectedLevel: selectedLevel,
        buildingLevel: buildingLevel,
        level: level
    };
};

var mapDispatchToProps = exports.mapDispatchToProps = {
    pushState: _reactRouterRedux.push,
    changeSelectedLevel: _reserve_level_select.changeSelectedLevel
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BuildingView);

/***/ }),
/* 2074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TransitionGroup = __webpack_require__(2075);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _CSSTransitionGroupChild = __webpack_require__(2078);

var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);

var _PropTypes = __webpack_require__(1323);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  transitionName: _PropTypes.nameShape.isRequired,

  transitionAppear: _propTypes2.default.bool,
  transitionEnter: _propTypes2.default.bool,
  transitionLeave: _propTypes2.default.bool,
  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
};

var defaultProps = {
  transitionAppear: false,
  transitionEnter: true,
  transitionLeave: true
};

var CSSTransitionGroup = function (_React$Component) {
  _inherits(CSSTransitionGroup, _React$Component);

  function CSSTransitionGroup() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
        name: _this.props.transitionName,
        appear: _this.props.transitionAppear,
        enter: _this.props.transitionEnter,
        leave: _this.props.transitionLeave,
        appearTimeout: _this.props.transitionAppearTimeout,
        enterTimeout: _this.props.transitionEnterTimeout,
        leaveTimeout: _this.props.transitionLeaveTimeout
      }, child);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // We need to provide this childFactory so that
  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
  // leave while it is leaving.


  CSSTransitionGroup.prototype.render = function render() {
    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
  };

  return CSSTransitionGroup;
}(_react2.default.Component);

CSSTransitionGroup.displayName = 'CSSTransitionGroup';


CSSTransitionGroup.propTypes =  false ? propTypes : {};
CSSTransitionGroup.defaultProps = defaultProps;

exports.default = CSSTransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 2075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _chainFunction = __webpack_require__(2076);

var _chainFunction2 = _interopRequireDefault(_chainFunction);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(85);

var _warning2 = _interopRequireDefault(_warning);

var _ChildMapping = __webpack_require__(2077);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  component: _propTypes2.default.any,
  childFactory: _propTypes2.default.func,
  children: _propTypes2.default.node
};

var defaultProps = {
  component: 'span',
  childFactory: function childFactory(child) {
    return child;
  }
};

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.performAppear = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillAppear) {
        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
      } else {
        _this._handleDoneAppearing(key, component);
      }
    };

    _this._handleDoneAppearing = function (key, component) {
      if (component.componentDidAppear) {
        component.componentDidAppear();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully appeared. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performEnter = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillEnter) {
        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
      } else {
        _this._handleDoneEntering(key, component);
      }
    };

    _this._handleDoneEntering = function (key, component) {
      if (component.componentDidEnter) {
        component.componentDidEnter();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully entered. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performLeave = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillLeave) {
        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
      } else {
        // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        _this._handleDoneLeaving(key, component);
      }
    };

    _this._handleDoneLeaving = function (key, component) {
      if (component.componentDidLeave) {
        component.componentDidLeave();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
        // This entered again before it fully left. Add it again.
        _this.keysToEnter.push(key);
      } else {
        _this.setState(function (state) {
          var newChildren = _extends({}, state.children);
          delete newChildren[key];
          return { children: newChildren };
        });
      }
    };

    _this.childRefs = Object.create(null);

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children)
    };
    return _this;
  }

  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
    this.currentlyTransitioningKeys = {};
    this.keysToEnter = [];
    this.keysToLeave = [];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    var initialChildMapping = this.state.children;
    for (var key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key, this.childRefs[key]);
      }
    }
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
    var prevChildMapping = this.state.children;

    this.setState({
      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
    });

    for (var key in nextChildMapping) {
      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
        this.keysToEnter.push(key);
      }
    }

    for (var _key in prevChildMapping) {
      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
        this.keysToLeave.push(_key);
      }
    }

    // If we want to someday check for reordering, we could do it here.
  };

  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    var keysToEnter = this.keysToEnter;
    this.keysToEnter = [];
    keysToEnter.forEach(function (key) {
      return _this2.performEnter(key, _this2.childRefs[key]);
    });

    var keysToLeave = this.keysToLeave;
    this.keysToLeave = [];
    keysToLeave.forEach(function (key) {
      return _this2.performLeave(key, _this2.childRefs[key]);
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _this3 = this;

    // TODO: we could get rid of the need for the wrapper node
    // by cloning a single child
    var childrenToRender = [];

    var _loop = function _loop(key) {
      var child = _this3.state.children[key];
      if (child) {
        var isCallbackRef = typeof child.ref !== 'string';
        var factoryChild = _this3.props.childFactory(child);
        var ref = function ref(r) {
          _this3.childRefs[key] = r;
        };

         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;

        // Always chaining the refs leads to problems when the childFactory
        // wraps the child. The child ref callback gets called twice with the
        // wrapper and the child. So we only need to chain the ref if the
        // factoryChild is not different from child.
        if (factoryChild === child && isCallbackRef) {
          ref = (0, _chainFunction2.default)(child.ref, ref);
        }

        // You may need to apply reactive updates to a child as it is leaving.
        // The normal React way to do it won't work since the child will have
        // already been removed. In case you need this behavior you can provide
        // a childFactory function to wrap every child, even the ones that are
        // leaving.
        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
          key: key,
          ref: ref
        }));
      }
    };

    for (var key in this.state.children) {
      _loop(key);
    }

    // Do not forward TransitionGroup props to primitive DOM nodes
    var props = _extends({}, this.props);
    delete props.transitionLeave;
    delete props.transitionName;
    delete props.transitionAppear;
    delete props.transitionEnter;
    delete props.childFactory;
    delete props.transitionLeaveTimeout;
    delete props.transitionEnterTimeout;
    delete props.transitionAppearTimeout;
    delete props.component;

    return _react2.default.createElement(this.props.component, props, childrenToRender);
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.displayName = 'TransitionGroup';


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 2076 */
/***/ (function(module, exports) {


module.exports = function chain(){
  var len = arguments.length
  var args = [];

  for (var i = 0; i < len; i++)
    args[i] = arguments[i]

  args = args.filter(function(fn){ return fn != null })

  if (args.length === 0) return undefined
  if (args.length === 1) return args[0]

  return args.reduce(function(current, next){
    return function chainedFunction() {
      current.apply(this, arguments);
      next.apply(this, arguments);
    };
  })
}


/***/ }),
/* 2077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children) {
  if (!children) {
    return children;
  }
  var result = {};
  _react.Children.map(children, function (child) {
    return child;
  }).forEach(function (child) {
    result[child.key] = child;
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    if (next.hasOwnProperty(key)) {
      return next[key];
    }

    return prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = {};

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (next.hasOwnProperty(prevKey)) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending.hasOwnProperty(nextKey)) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),
/* 2078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _addClass = __webpack_require__(2079);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(2081);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _requestAnimationFrame = __webpack_require__(2082);

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

var _properties = __webpack_require__(2083);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(75);

var _PropTypes = __webpack_require__(1323);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var events = [];
if (_properties.transitionEnd) events.push(_properties.transitionEnd);
if (_properties.animationEnd) events.push(_properties.animationEnd);

function addEndListener(node, listener) {
  if (events.length) {
    events.forEach(function (e) {
      return node.addEventListener(e, listener, false);
    });
  } else {
    setTimeout(listener, 0);
  }

  return function () {
    if (!events.length) return;
    events.forEach(function (e) {
      return node.removeEventListener(e, listener, false);
    });
  };
}

var propTypes = {
  children: _propTypes2.default.node,
  name: _PropTypes.nameShape.isRequired,

  // Once we require timeouts to be specified, we can remove the
  // boolean flags (appear etc.) and just accept a number
  // or a bool for the timeout flags (appearTimeout etc.)
  appear: _propTypes2.default.bool,
  enter: _propTypes2.default.bool,
  leave: _propTypes2.default.bool,
  appearTimeout: _propTypes2.default.number,
  enterTimeout: _propTypes2.default.number,
  leaveTimeout: _propTypes2.default.number
};

var CSSTransitionGroupChild = function (_React$Component) {
  _inherits(CSSTransitionGroupChild, _React$Component);

  function CSSTransitionGroupChild() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroupChild);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
      if (_this.props.appear) {
        _this.transition('appear', done, _this.props.appearTimeout);
      } else {
        done();
      }
    }, _this.componentWillEnter = function (done) {
      if (_this.props.enter) {
        _this.transition('enter', done, _this.props.enterTimeout);
      } else {
        done();
      }
    }, _this.componentWillLeave = function (done) {
      if (_this.props.leave) {
        _this.transition('leave', done, _this.props.leaveTimeout);
      } else {
        done();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
    this.classNameAndNodeQueue = [];
    this.transitionTimeouts = [];
  };

  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounted = true;

    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.transitionTimeouts.forEach(function (timeout) {
      clearTimeout(timeout);
    });

    this.classNameAndNodeQueue.length = 0;
  };

  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
    var node = (0, _reactDom.findDOMNode)(this);

    if (!node) {
      if (finishCallback) {
        finishCallback();
      }
      return;
    }

    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
    var timer = null;
    var removeListeners = void 0;

    (0, _addClass2.default)(node, className);

    // Need to do this to actually trigger a transition.
    this.queueClassAndNode(activeClassName, node);

    // Clean-up the animation after the specified delay
    var finish = function finish(e) {
      if (e && e.target !== node) {
        return;
      }

      clearTimeout(timer);
      if (removeListeners) removeListeners();

      (0, _removeClass2.default)(node, className);
      (0, _removeClass2.default)(node, activeClassName);

      if (removeListeners) removeListeners();

      // Usually this optional callback is used for informing an owner of
      // a leave animation and telling it to remove the child.
      if (finishCallback) {
        finishCallback();
      }
    };

    if (timeout) {
      timer = setTimeout(finish, timeout);
      this.transitionTimeouts.push(timer);
    } else if (_properties.transitionEnd) {
      removeListeners = addEndListener(node, finish);
    }
  };

  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
    var _this2 = this;

    this.classNameAndNodeQueue.push({
      className: className,
      node: node
    });

    if (!this.rafHandle) {
      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
        return _this2.flushClassNameAndNodeQueue();
      });
    }
  };

  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
    if (!this.unmounted) {
      this.classNameAndNodeQueue.forEach(function (obj) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        /* eslint-disable no-unused-expressions */
        obj.node.scrollTop;
        /* eslint-enable no-unused-expressions */
        (0, _addClass2.default)(obj.node, obj.className);
      });
    }
    this.classNameAndNodeQueue.length = 0;
    this.rafHandle = null;
  };

  CSSTransitionGroupChild.prototype.render = function render() {
    var props = _extends({}, this.props);
    delete props.name;
    delete props.appear;
    delete props.enter;
    delete props.leave;
    delete props.appearTimeout;
    delete props.enterTimeout;
    delete props.leaveTimeout;
    delete props.children;
    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
  };

  return CSSTransitionGroupChild;
}(_react2.default.Component);

CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';


CSSTransitionGroupChild.propTypes =  false ? propTypes : {};

exports.default = CSSTransitionGroupChild;
module.exports = exports['default'];

/***/ }),
/* 2079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(381);

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__(2080));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),
/* 2080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),
/* 2081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 2082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(381);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(1322));

var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
var cancel = 'clearTimeout';
var raf = fallback;
var compatRaf;

var getKey = function getKey(vendor, k) {
  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
};

if (_inDOM.default) {
  vendors.some(function (vendor) {
    var rafKey = getKey(vendor, 'request');

    if (rafKey in window) {
      cancel = getKey(vendor, 'cancel');
      return raf = function raf(cb) {
        return window[rafKey](cb);
      };
    }
  });
}
/* https://github.com/component/raf */


var prev = new Date().getTime();

function fallback(fn) {
  var curr = new Date().getTime(),
      ms = Math.max(0, 16 - (curr - prev)),
      req = setTimeout(fn, ms);
  prev = curr;
  return req;
}

compatRaf = function compatRaf(cb) {
  return raf(cb);
};

compatRaf.cancel = function (id) {
  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
};

var _default = compatRaf;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(381);

exports.__esModule = true;
exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(1322));

var transform = 'transform';
exports.transform = transform;
var prefix, transitionEnd, animationEnd;
exports.animationEnd = animationEnd;
exports.transitionEnd = transitionEnd;
var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
exports.transitionDelay = transitionDelay;
exports.transitionTiming = transitionTiming;
exports.transitionDuration = transitionDuration;
exports.transitionProperty = transitionProperty;
var animationName, animationDuration, animationTiming, animationDelay;
exports.animationDelay = animationDelay;
exports.animationTiming = animationTiming;
exports.animationDuration = animationDuration;
exports.animationName = animationName;

if (_inDOM.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
  exports.transform = transform = prefix + "-" + transform;
  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
  exports.animationName = animationName = prefix + "-animation-name";
  exports.animationDuration = animationDuration = prefix + "-animation-duration";
  exports.animationTiming = animationTiming = prefix + "-animation-delay";
  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
}

var _default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};
exports.default = _default;

function getTransitionProperties() {
  var style = document.createElement('div').style;
  var vendorMap = {
    O: function O(e) {
      return "o" + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return "webkit" + e;
    },
    ms: function ms(e) {
      return "MS" + e;
    }
  };
  var vendors = Object.keys(vendorMap);
  var transitionEnd, animationEnd;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + "TransitionProperty" in style) {
      prefix = "-" + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
  style = null;
  return {
    animationEnd: animationEnd,
    transitionEnd: transitionEnd,
    prefix: prefix
  };
}

/***/ }),
/* 2084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = exports.BuildingCard = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactAddonsCssTransitionGroup = __webpack_require__(287);

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = __webpack_require__(7);

var _reactRouterRedux = __webpack_require__(15);

var _helpers = __webpack_require__(11);

var _accounts = __webpack_require__(33);

var _i18n = __webpack_require__(10);

var _slots = __webpack_require__(276);

var _slots2 = _interopRequireDefault(_slots);

var _sounds = __webpack_require__(22);

var _FirstChild = __webpack_require__(1324);

var _FirstChild2 = _interopRequireDefault(_FirstChild);

var _ModernizationOverlay = __webpack_require__(1325);

var _ModernizationOverlay2 = _interopRequireDefault(_ModernizationOverlay);

var _UpgradeEffect = __webpack_require__(1326);

var _UpgradeEffect2 = _interopRequireDefault(_UpgradeEffect);

var _LoadingScreen = __webpack_require__(29);

var _LoadingScreen2 = _interopRequireDefault(_LoadingScreen);

var _NavigationArrow = __webpack_require__(59);

var _NavigationArrow2 = _interopRequireDefault(_NavigationArrow);

var _components = __webpack_require__(2089);

var _urls = __webpack_require__(19);

var _constants = __webpack_require__(4);

var _constants2 = __webpack_require__(2126);

var _BuildingCard = __webpack_require__(2127);

var _BuildingCard2 = _interopRequireDefault(_BuildingCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BuildingCard = exports.BuildingCard = function (_React$Component) {
    _inherits(BuildingCard, _React$Component);

    function BuildingCard(props) {
        _classCallCheck(this, BuildingCard);

        var _this = _possibleConstructorReturn(this, (BuildingCard.__proto__ || Object.getPrototypeOf(BuildingCard)).call(this, props));

        _this.state = {
            loading: true
        };
        _this.backHandler = props.pushState.bind(null, _urls.STRONGHOLD);
        _this.onKeyUp = _this.onKeyUp.bind(_this);
        return _this;
    }

    _createClass(BuildingCard, [{
        key: 'onKeyUp',
        value: function onKeyUp(e) {
            if (e.keyCode !== _constants.KEY_CODES.ESCAPE) return;

            var confirmationOpened = this.props.buildingUpgrade.confirmationOpened || this.refs.overlay && this.refs.overlay.state.opened || this.props.reserveProduceConfirmationOpened;
            if (!confirmationOpened) {
                this.backHandler();
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.setState({ loading: nextProps.loading });
            if (this.props.slotId !== nextProps.slotId) {
                this.props.requestSlotInfo(this.props.slotId);
                this.setState({ loading: true });
            }
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.props.requestSlotInfo(this.props.slotId);
            window.addEventListener('keydown', this.onKeyUp);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('keydown', this.onKeyUp);
        }
    }, {
        key: 'handleUpgradeEffectClick',
        value: function handleUpgradeEffectClick() {
            this.props.playClickSound();
            this.refs.overlay.show();
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.state.loading) return _react2.default.createElement(
                'div',
                { className: _BuildingCard2.default.base },
                _react2.default.createElement(_LoadingScreen2.default, null)
            );

            var _props = this.props,
                building = _props.building,
                buildings = _props.buildings,
                buildingUpgrade = _props.buildingUpgrade,
                reserveInfo = _props.reserveInfo;


            var buildingLevel = buildingUpgrade.highlighted ? building.level + 1 : building.level;

            var overlayClassName = (0, _classnames2.default)(_BuildingCard2.default.overlay, _defineProperty({}, _BuildingCard2.default.overlay__enabled, buildingUpgrade.highlighted));

            var arrowLeftClassName = (0, _classnames2.default)(_BuildingCard2.default.arrow, _BuildingCard2.default.arrow__left);
            var arrowRightClassName = (0, _classnames2.default)(_BuildingCard2.default.arrow, _BuildingCard2.default.arrow__right);

            var handleClickPrev = null;
            var handleClickNext = null;
            var rightArrowDisabled = true;

            var buildingsIds = Object.keys(buildings).map(function (buildingId) {
                return parseInt(buildingId);
            });
            var buildingId = parseInt(building.id);
            var currentBuildingIdx = buildingsIds.indexOf(buildingId);
            if (currentBuildingIdx === 0) {
                handleClickPrev = this.props.pushState.bind(null, (0, _urls.BUILDING)(_constants.COMMAND_CENTER_ID));
            } else {
                handleClickPrev = this.props.pushState.bind(null, (0, _urls.BUILDING)(buildingsIds[currentBuildingIdx - 1]));
            }
            if (currentBuildingIdx < buildingsIds.length - 1) {
                handleClickNext = this.props.pushState.bind(null, (0, _urls.BUILDING)(buildingsIds[currentBuildingIdx + 1]));
                rightArrowDisabled = false;
            }

            return _react2.default.createElement(
                'div',
                { className: _BuildingCard2.default.base },
                _react2.default.createElement('div', { className: overlayClassName }),
                _react2.default.createElement(
                    'div',
                    { className: _BuildingCard2.default.header },
                    _react2.default.createElement(
                        'h2',
                        { className: _BuildingCard2.default.title },
                        _react2.default.createElement(
                            'span',
                            { className: _BuildingCard2.default.level },
                            (0, _helpers.toRoman)(buildingLevel),
                            _react2.default.createElement(
                                'span',
                                { className: _BuildingCard2.default.levelShadow },
                                (0, _helpers.toRoman)(buildingLevel)
                            )
                        ),
                        _i18n.BUILDING_TITLES[building.type]
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _BuildingCard2.default.main },
                    _react2.default.createElement(
                        'div',
                        { className: _BuildingCard2.default.wrapper },
                        _react2.default.createElement(
                            'div',
                            { className: _BuildingCard2.default.holder },
                            _react2.default.createElement(
                                'div',
                                { className: _BuildingCard2.default.grid },
                                _react2.default.createElement(
                                    'div',
                                    { className: (0, _classnames2.default)(_BuildingCard2.default.cell, _BuildingCard2.default.cell__centred) },
                                    _react2.default.createElement(_components.CardImage, {
                                        tooltipId: '' + _constants2.UPGRADE_TOOLTIP_ID + building.id,
                                        building: building,
                                        reserveType: reserveInfo.type
                                    }),
                                    _react2.default.createElement(_UpgradeEffect2.default, {
                                        handleClick: this.handleUpgradeEffectClick.bind(this),
                                        handleHover: this.props.playHoverSound,
                                        hasPermission: this.props.hasPermission,
                                        topLevel: buildingLevel === _constants.MAX_BUILDING_LEVEL,
                                        fade: buildingUpgrade.highlighted
                                    })
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: _BuildingCard2.default.cell },
                                    _react2.default.createElement(
                                        'div',
                                        { className: _BuildingCard2.default.reserve },
                                        _react2.default.createElement(
                                            'h3',
                                            { className: _BuildingCard2.default.heading },
                                            _i18n.RESERVE_TITLES[reserveInfo.type]
                                        ),
                                        _i18n.RESERVE_USAGE_BATTLE_TYPES[reserveInfo.type] && _react2.default.createElement(
                                            'p',
                                            { className: _BuildingCard2.default.reserveDescription },
                                            _i18n.RESERVE_USAGE_BATTLE_TYPES[reserveInfo.type]
                                        ),
                                        _react2.default.createElement(_components.ReserveSelect, { buildingId: this.props.buildingId })
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: _BuildingCard2.default.produce },
                                        _react2.default.createElement(_components.ReserveProduce, {
                                            reserve: reserveInfo,
                                            buildingId: building.id
                                        })
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: arrowLeftClassName },
                            _react2.default.createElement(_NavigationArrow2.default, {
                                size: _NavigationArrow2.default.SIZES.big,
                                type: _NavigationArrow2.default.TYPES.left,
                                handleClick: handleClickPrev
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: arrowRightClassName },
                            _react2.default.createElement(_NavigationArrow2.default, {
                                size: _NavigationArrow2.default.SIZES.big,
                                type: _NavigationArrow2.default.TYPES.right,
                                handleClick: handleClickNext,
                                disabled: rightArrowDisabled
                            })
                        )
                    )
                ),
                this.props.hasPermission ? _react2.default.createElement(
                    'div',
                    null,
                    buildingLevel < _constants.MAX_BUILDING_LEVEL ? _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(_components.UpgradeTooltip, {
                            id: '' + _constants2.UPGRADE_TOOLTIP_ID + building.id,
                            building: this.props.building,
                            reserve: reserveInfo
                        })
                    ) : null,
                    _react2.default.createElement(
                        _reactAddonsCssTransitionGroup2.default,
                        {
                            component: _FirstChild2.default,
                            transitionName: 'upgradeConfirmation',
                            transitionEnterTimeout: 200,
                            transitionLeaveTimeout: 200
                        },
                        this.props.buildingUpgrade.confirmationOpened ? _react2.default.createElement(_components.UpgradeConfirmation, { building: this.props.building }) : null
                    )
                ) : null,
                this.props.hasPermissionPrepareReserve && _react2.default.createElement(_components.CancelConfirmation, { buildingId: this.props.building.id }),
                _react2.default.createElement(
                    _ModernizationOverlay2.default,
                    { ref: 'overlay' },
                    _react2.default.createElement(_components.UpgradeEffectContent, { slotId: this.props.slotId })
                )
            );
        }
    }]);

    return BuildingCard;
}(_react2.default.Component);

BuildingCard.propTypes = {
    buildingId: _propTypes2.default.number.isRequired,
    slotId: _propTypes2.default.number.isRequired,
    loading: _propTypes2.default.bool.isRequired,
    reserveProduceConfirmationOpened: _propTypes2.default.bool.isRequired,
    hasPermission: _propTypes2.default.bool.isRequired,
    hasPermissionPrepareReserve: _propTypes2.default.bool.isRequired,
    building: _propTypes2.default.object.isRequired,
    buildings: _propTypes2.default.object.isRequired,
    buildingUpgrade: _propTypes2.default.shape({
        confirmationOpened: _propTypes2.default.bool.isRequired,
        submitting: _propTypes2.default.bool.isRequired,
        highlighted: _propTypes2.default.bool.isRequired
    }).isRequired,
    reserveInfo: _propTypes2.default.object.isRequired,

    playHoverSound: _propTypes2.default.func.isRequired,
    playClickSound: _propTypes2.default.func.isRequired,
    pushState: _propTypes2.default.func.isRequired,
    requestSlotInfo: _propTypes2.default.func.isRequired
};
var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, _ref) {
    var buildingId = _ref.buildingId;
    var account = state.account,
        buildings = state.buildings,
        buildingUpgrade = state.buildingUpgrade,
        reserveProduce = state.reserveProduce,
        reserveProduceCancel = state.reserveProduceCancel,
        slots = state.slots,
        settings = state.settings;


    var building = buildings[buildingId];
    var slotId = Object.keys(slots).find(function (slotId) {
        return slots[slotId]['building'] === buildingId;
    });
    var slot = slots[slotId];
    var reserveType = settings.buildings[building.type].reserve_type;
    var reserveInfo = settings.reserves[reserveType];

    return {
        building: building,
        buildings: buildings,
        buildingUpgrade: buildingUpgrade,
        reserveInfo: reserveInfo,
        slotId: parseInt(slotId),
        loading: slot.loading === true || reserveProduce.submitting === true || reserveProduceCancel.submitting === true,
        reserveProduceConfirmationOpened: reserveProduceCancel.confirmationOpened,
        hasPermission: (0, _accounts.canManageBuilding)(account),
        hasPermissionPrepareReserve: (0, _accounts.canPrepareReserve)(account)
    };
};

var mapDispatchToProps = exports.mapDispatchToProps = {
    playHoverSound: _sounds.playHoverSound,
    playClickSound: _sounds.playClickSound,
    pushState: _reactRouterRedux.push,
    requestSlotInfo: _slots2.default
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BuildingCard);

/***/ }),
/* 2085 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Back_base--xbjPm","base__left":"Back_base__left--3ZXTj","baseLeft":"Back_base__left--3ZXTj","base__right":"Back_base__right--21AmG","baseRight":"Back_base__right--21AmG","base__back":"Back_base__back--2Ej9C","baseBack":"Back_base__back--2Ej9C","base__close":"Back_base__close--RNDPr","baseClose":"Back_base__close--RNDPr","icon":"Back_icon--3e5tl","base__info":"Back_base__info--1ZcxY","baseInfo":"Back_base__info--1ZcxY","caption":"Back_caption--2L3CJ","base__cn":"Back_base__cn--kHaYB","baseCn":"Back_base__cn--kHaYB"};

/***/ }),
/* 2086 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"ModernizationOverlay_base--shK16","base__opened":"ModernizationOverlay_base__opened--jIhKD","baseOpened":"ModernizationOverlay_base__opened--jIhKD","content":"ModernizationOverlay_content--3u3bw","back":"ModernizationOverlay_back--q0e8Z"};

/***/ }),
/* 2087 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UPGRADE_EFFECT_TOOLTIP_ID = exports.MODERNIZATION_BUTTON_TITLE = exports.TOOLTIP_BODY = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TOOLTIP_BODY = exports.TOOLTIP_BODY = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'card_image.tooltip_body',
    defaultMessage: '\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u0443\u0437\u043D\u0430\u0442\u044C \u0443\u0441\u043B\u043E\u0432\u0438\u044F \u043C\u043E\u0434\u0435\u0440\u043D\u0438\u0437\u0430\u0446\u0438\u0438 \u0441\u0442\u0440\u043E\u0435\u043D\u0438\u044F \u0432 \u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0441\u0442\u0438 \u043E\u0442 \u0435\u0433\u043E \u0443\u0440\u043E\u0432\u043D\u044F.'
});

var MODERNIZATION_BUTTON_TITLE = exports.MODERNIZATION_BUTTON_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'modernization_button.title',
    defaultMessage: '\u041E \u043C\u043E\u0434\u0435\u0440\u043D\u0438\u0437\u0430\u0446\u0438\u0438'
});

var UPGRADE_EFFECT_TOOLTIP_ID = exports.UPGRADE_EFFECT_TOOLTIP_ID = 'upgrade_effect_tooltip';

/***/ }),
/* 2088 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tooltip-root":"UpgradeEffect_tooltip-root--2qdFE","tooltipRoot":"UpgradeEffect_tooltip-root--2qdFE","tooltip-root__show":"UpgradeEffect_tooltip-root__show--3YPvB","tooltipRootShow":"UpgradeEffect_tooltip-root__show--3YPvB","tooltip-body":"UpgradeEffect_tooltip-body--1v6Kj","tooltipBody":"UpgradeEffect_tooltip-body--1v6Kj","tooltip-wrapper":"UpgradeEffect_tooltip-wrapper--1zDOR","tooltipWrapper":"UpgradeEffect_tooltip-wrapper--1zDOR","tooltip-content":"UpgradeEffect_tooltip-content--1xTTi","tooltipContent":"UpgradeEffect_tooltip-content--1xTTi","tooltip-title":"UpgradeEffect_tooltip-title--2k9Bk","tooltipTitle":"UpgradeEffect_tooltip-title--2k9Bk","tooltip-subtitle":"UpgradeEffect_tooltip-subtitle--dSdfn","tooltipSubtitle":"UpgradeEffect_tooltip-subtitle--dSdfn","tooltip-message":"UpgradeEffect_tooltip-message--T2lGP","tooltipMessage":"UpgradeEffect_tooltip-message--T2lGP","tooltip-warning":"UpgradeEffect_tooltip-warning--2lmJz","tooltipWarning":"UpgradeEffect_tooltip-warning--2lmJz","tooltip-divider":"UpgradeEffect_tooltip-divider--3zIyy","tooltipDivider":"UpgradeEffect_tooltip-divider--3zIyy","tooltip-highlight":"UpgradeEffect_tooltip-highlight---m2dx","tooltipHighlight":"UpgradeEffect_tooltip-highlight---m2dx","tooltip-ribbon":"UpgradeEffect_tooltip-ribbon--2XKKl","tooltipRibbon":"UpgradeEffect_tooltip-ribbon--2XKKl","tooltip-statusMessage":"UpgradeEffect_tooltip-statusMessage--vsD4z","tooltipStatusMessage":"UpgradeEffect_tooltip-statusMessage--vsD4z","tooltip-statusMessage__positive":"UpgradeEffect_tooltip-statusMessage__positive--2WXah","tooltipStatusMessagePositive":"UpgradeEffect_tooltip-statusMessage__positive--2WXah","tooltip-status":"UpgradeEffect_tooltip-status--241oX","tooltipStatus":"UpgradeEffect_tooltip-status--241oX","tooltip-statusMessage__negative":"UpgradeEffect_tooltip-statusMessage__negative--wq02-","tooltipStatusMessageNegative":"UpgradeEffect_tooltip-statusMessage__negative--wq02-","tooltip-statusMessage__noPermission":"UpgradeEffect_tooltip-statusMessage__noPermission--3X2ky","tooltipStatusMessageNoPermission":"UpgradeEffect_tooltip-statusMessage__noPermission--3X2ky","tooltip-status__positive":"UpgradeEffect_tooltip-status__positive--2TsnO","tooltipStatusPositive":"UpgradeEffect_tooltip-status__positive--2TsnO","tooltip-status__negative":"UpgradeEffect_tooltip-status__negative--1_5KO","tooltipStatusNegative":"UpgradeEffect_tooltip-status__negative--1_5KO","tooltip-statusText":"UpgradeEffect_tooltip-statusText--1Mi_y","tooltipStatusText":"UpgradeEffect_tooltip-statusText--1Mi_y","base":"UpgradeEffect_base--2q3k2","base__underCost":"UpgradeEffect_base__underCost--2zyoL","baseUnderCost":"UpgradeEffect_base__underCost--2zyoL","base__fade":"UpgradeEffect_base__fade--3c5Fd","baseFade":"UpgradeEffect_base__fade--3c5Fd","holder":"UpgradeEffect_holder--bRCXf","inner":"UpgradeEffect_inner--2rd4R","title":"UpgradeEffect_title--2P3tT","info":"UpgradeEffect_info--AgJqh"};

/***/ }),
/* 2089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReserveSelect = exports.UpgradeTooltip = exports.UpgradeEffectContent = exports.UpgradeConfirmation = exports.ReserveProduce = exports.CardImage = exports.CancelConfirmation = undefined;

var _CancelConfirmation2 = __webpack_require__(2090);

var _CancelConfirmation3 = _interopRequireDefault(_CancelConfirmation2);

var _CardImage2 = __webpack_require__(2094);

var _CardImage3 = _interopRequireDefault(_CardImage2);

var _ReserveProduce2 = __webpack_require__(2097);

var _ReserveProduce3 = _interopRequireDefault(_ReserveProduce2);

var _UpgradeConfirmation2 = __webpack_require__(2107);

var _UpgradeConfirmation3 = _interopRequireDefault(_UpgradeConfirmation2);

var _UpgradeEffectContent2 = __webpack_require__(2110);

var _UpgradeEffectContent3 = _interopRequireDefault(_UpgradeEffectContent2);

var _UpgradeTooltip2 = __webpack_require__(2115);

var _UpgradeTooltip3 = _interopRequireDefault(_UpgradeTooltip2);

var _ReserveSelect2 = __webpack_require__(2118);

var _ReserveSelect3 = _interopRequireDefault(_ReserveSelect2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.CancelConfirmation = _CancelConfirmation3.default;
exports.CardImage = _CardImage3.default;
exports.ReserveProduce = _ReserveProduce3.default;
exports.UpgradeConfirmation = _UpgradeConfirmation3.default;
exports.UpgradeEffectContent = _UpgradeEffectContent3.default;
exports.UpgradeTooltip = _UpgradeTooltip3.default;
exports.ReserveSelect = _ReserveSelect3.default;

/***/ }),
/* 2090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CancelConfirmation = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(7);

var _Confirmation = __webpack_require__(1327);

var _Confirmation2 = _interopRequireDefault(_Confirmation);

var _reserve_produce_cancel = __webpack_require__(194);

var _reserve_produce_cancel2 = _interopRequireDefault(_reserve_produce_cancel);

var _constants = __webpack_require__(2093);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CancelConfirmation = exports.CancelConfirmation = function (_React$Component) {
    _inherits(CancelConfirmation, _React$Component);

    function CancelConfirmation() {
        _classCallCheck(this, CancelConfirmation);

        return _possibleConstructorReturn(this, (CancelConfirmation.__proto__ || Object.getPrototypeOf(CancelConfirmation)).apply(this, arguments));
    }

    _createClass(CancelConfirmation, [{
        key: 'render',
        value: function render() {
            var handleReserveProduceCancel = this.props.reserveProduceCancel.bind(null, this.props.buildingId, this.props.selectedLevel);
            return _react2.default.createElement(
                _Confirmation2.default,
                {
                    title: _constants.CANCEL_CONFIRMATION_TITLE,
                    submitCaption: _constants.CANCEL_CONFIRMATION_SUBMIT,
                    closeCaption: _constants.CANCEL_CONFIRMATION_CANCEL,
                    opened: this.props.opened,
                    onSubmit: handleReserveProduceCancel,
                    onClose: this.props.handleCloseCancelConfirmation
                },
                _react2.default.createElement(
                    'p',
                    null,
                    _constants.CANCEL_CONFIRMATION_CONTENT
                )
            );
        }
    }]);

    return CancelConfirmation;
}(_react2.default.Component);

CancelConfirmation.propTypes = {
    buildingId: _propTypes2.default.number.isRequired,
    opened: _propTypes2.default.bool.isRequired,
    selectedLevel: _propTypes2.default.number.isRequired,
    reserveProduceCancel: _propTypes2.default.func.isRequired,
    handleCloseCancelConfirmation: _propTypes2.default.func.isRequired
};


var mapStateToProps = function mapStateToProps(state, _ref) {
    var buildingId = _ref.buildingId;
    return {
        buildingId: buildingId,
        opened: state.reserveProduceCancel.confirmationOpened,
        selectedLevel: state.reserveLevelSelect.selectedLevel
    };
};

var mapDispatchToProps = {
    reserveProduceCancel: _reserve_produce_cancel2.default,
    handleCloseCancelConfirmation: _reserve_produce_cancel.closeCancelConfirmation
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CancelConfirmation);

/***/ }),
/* 2091 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Confirmation_base--DQ2L-","base__opened":"Confirmation_base__opened--142UA","baseOpened":"Confirmation_base__opened--142UA","base__closed":"Confirmation_base__closed--3_U3u","baseClosed":"Confirmation_base__closed--3_U3u","wrapper":"Confirmation_wrapper--2_dq1","body":"Confirmation_body--2lnab","background":"Confirmation_background--3iIBd","header":"Confirmation_header--33C9K","title":"Confirmation_title--1fuEZ","close":"Confirmation_close--XSNwy","content":"Confirmation_content--1MEHj","footer":"Confirmation_footer--2sK9U","button":"Confirmation_button--2j4Xg","overlay":"Confirmation_overlay--3D01l"};

/***/ }),
/* 2092 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CLOSE_BUTTON_CAPTION = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLOSE_BUTTON_CAPTION = exports.CLOSE_BUTTON_CAPTION = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'confirmation.close_button',
    defaultMessage: 'Закрыть'
});

/***/ }),
/* 2093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CANCEL_CONFIRMATION_CONTENT = exports.CANCEL_CONFIRMATION_CANCEL = exports.CANCEL_CONFIRMATION_SUBMIT = exports.CANCEL_CONFIRMATION_TITLE = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CANCEL_CONFIRMATION_TITLE = exports.CANCEL_CONFIRMATION_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'production_progress.cancel_confirmation_title',
    defaultMessage: '\u041E\u0442\u043C\u0435\u043D\u0430 \u043F\u043E\u0434\u0433\u043E\u0442\u043E\u0432\u043A\u0438'
});
var CANCEL_CONFIRMATION_SUBMIT = exports.CANCEL_CONFIRMATION_SUBMIT = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'production_progress.cancel_confirmation_submit',
    defaultMessage: '\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C \u043F\u043E\u0434\u0433\u043E\u0442\u043E\u0432\u043A\u0443'
});

var CANCEL_CONFIRMATION_CANCEL = exports.CANCEL_CONFIRMATION_CANCEL = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'production_progress.cancel_confirmation_cancel',
    defaultMessage: '\u0417\u0430\u043A\u0440\u044B\u0442\u044C'
});

var CANCEL_CONFIRMATION_CONTENT = exports.CANCEL_CONFIRMATION_CONTENT = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'production_progress.cancel_confirmation_content',
    defaultMessage: '\u041F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u043E\u0442\u043C\u0435\u043D\u0443 \u043F\u043E\u0434\u0433\u043E\u0442\u043E\u0432\u043A\u0438 \u0440\u0435\u0437\u0435\u0440\u0432\u043E\u0432.{newLine}\u0417\u0430\u0442\u0440\u0430\u0447\u0435\u043D\u043D\u044B\u0439 \u043D\u0430 \u043F\u043E\u0434\u0433\u043E\u0442\u043E\u0432\u043A\u0443 \u043F\u0440\u043E\u043C\u0440\u0435\u0441\u0443\u0440\u0441 \u0431\u0443\u0434\u0435\u0442 \u0432\u043E\u0437\u0432\u0440\u0430\u0449\u0451\u043D \u043D\u0430 \u0441\u043A\u043B\u0430\u0434.' // eslint-disable-line max-len
    , values: {
        newLine: _react2.default.createElement('br', null)
    }
});

/***/ }),
/* 2094 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = exports.CardImage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(7);

var _buildings = __webpack_require__(161);

var _BuildingCardImage = __webpack_require__(1328);

var _BuildingCardImage2 = _interopRequireDefault(_BuildingCardImage);

var _building_upgrade = __webpack_require__(193);

var _reserves = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CardImage = exports.CardImage = function (_React$Component) {
    _inherits(CardImage, _React$Component);

    function CardImage(props) {
        _classCallCheck(this, CardImage);

        var _this = _possibleConstructorReturn(this, (CardImage.__proto__ || Object.getPrototypeOf(CardImage)).call(this, props));

        _this.state = { productionInProgress: false };
        return _this;
    }

    _createClass(CardImage, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.processReserveQueue(nextProps.reserveQueue);
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.processReserveQueue(this.props.reserveQueue);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.timerId) {
                clearTimeout(this.timerId);
            }
            this.props.handleMouseLeave();
        }
    }, {
        key: 'processReserveQueue',
        value: function processReserveQueue(reserveQueue) {
            if (this.timerId) {
                clearTimeout(this.timerId);
            }

            var productionEnds = reserveQueue.length ? reserveQueue[reserveQueue.length - 1].productionEnds : null;
            var productionInProgress = !!productionEnds && productionEnds > Date.now();

            if (productionInProgress) {
                this.timerId = setTimeout(this.processReserveQueue.bind(this, reserveQueue), productionEnds - Date.now());
            }

            this.setState({ productionInProgress: productionInProgress });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                building = _props.building,
                tooltipId = _props.tooltipId,
                hasEnoughIndustrialResource = _props.hasEnoughIndustrialResource,
                showUpgrade = _props.showUpgrade,
                isUpgradeAvailable = _props.isUpgradeAvailable,
                upgradeCost = _props.upgradeCost;


            var upgradeAvailable = !this.state.productionInProgress && isUpgradeAvailable;

            return _react2.default.createElement(_BuildingCardImage2.default, {
                buildingType: building.type,
                buildingLevel: building.level,
                hasEnoughIndustrialResource: hasEnoughIndustrialResource,
                upgradeCost: upgradeCost,
                tooltipId: tooltipId,
                isUpgradeAvailable: upgradeAvailable,
                showUpgrade: showUpgrade,
                onMouseEnter: this.props.handleMouseEnter,
                onMouseLeave: this.props.handleMouseLeave,
                onClick: this.props.handleClick
            });
        }
    }]);

    return CardImage;
}(_react2.default.Component);

CardImage.propTypes = {
    building: _propTypes2.default.object.isRequired,
    tooltipId: _propTypes2.default.string.isRequired,
    reserveQueue: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
    upgradeCost: _propTypes2.default.number,
    hasEnoughIndustrialResource: _propTypes2.default.bool.isRequired,
    showUpgrade: _propTypes2.default.bool.isRequired,
    isUpgradeAvailable: _propTypes2.default.bool.isRequired,

    handleMouseEnter: _propTypes2.default.func.isRequired,
    handleMouseLeave: _propTypes2.default.func.isRequired,
    handleClick: _propTypes2.default.func.isRequired
};
var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, _ref) {
    var building = _ref.building,
        reserveType = _ref.reserveType,
        tooltipId = _ref.tooltipId;


    var hasEnoughIndustrialResource = (0, _buildings.checkIndustrialResource)(state, building);
    var showUpgrade = (0, _buildings.checkUpgradeVisibility)(state, building);
    var nextLevelIsValid = building.level + 1 <= state.stronghold.level;

    var isUpgradeAvailable = hasEnoughIndustrialResource && showUpgrade && nextLevelIsValid;

    var upgradeCost = state.settings.buildings[building.type].costs[building.level];
    var reserveQueue = (0, _reserves.getSortedProductionReserves)(state.clanReserves[reserveType]);

    return {
        tooltipId: tooltipId,
        building: building,
        upgradeCost: upgradeCost,
        reserveQueue: reserveQueue,
        hasEnoughIndustrialResource: hasEnoughIndustrialResource,
        showUpgrade: showUpgrade,
        isUpgradeAvailable: isUpgradeAvailable
    };
};

var mapDispatchToProps = exports.mapDispatchToProps = {
    handleMouseEnter: _building_upgrade.showUpgradeHighlight,
    handleMouseLeave: _building_upgrade.hideUpgradeHighlight,
    handleClick: _building_upgrade.openUpgradeConfirmation
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CardImage);

/***/ }),
/* 2095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UPGRADE_COST_LABEL = exports.ARROW_LAYERS_COUNT = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ARROW_LAYERS_COUNT = exports.ARROW_LAYERS_COUNT = 5;

var UPGRADE_COST_LABEL = exports.UPGRADE_COST_LABEL = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'building_card_image.upgrade_cost_label',
    defaultMessage: '\u041C\u043E\u0434\u0435\u0440\u043D\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u0442\u044C'
});

/***/ }),
/* 2096 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"BuildingCardImage_base--30jTN","image":"BuildingCardImage_image--2SLuO","base__upgradeDisabled":"BuildingCardImage_base__upgradeDisabled--31nPY","baseUpgradeDisabled":"BuildingCardImage_base__upgradeDisabled--31nPY","upgradeLayout":"BuildingCardImage_upgradeLayout--nbJN4","clickArea":"BuildingCardImage_clickArea--2i76Q","image__attack-bomber-squadrons":"BuildingCardImage_image__attack-bomber-squadrons--2yySt","imageAttackBomberSquadrons":"BuildingCardImage_image__attack-bomber-squadrons--2yySt","image__level-1":"BuildingCardImage_image__level-1--105Oh","imageLevel1":"BuildingCardImage_image__level-1--105Oh","image__level-2":"BuildingCardImage_image__level-2--2WQZp","imageLevel2":"BuildingCardImage_image__level-2--2WQZp","image__level-3":"BuildingCardImage_image__level-3--1PibF","imageLevel3":"BuildingCardImage_image__level-3--1PibF","image__level-4":"BuildingCardImage_image__level-4--14OIW","imageLevel4":"BuildingCardImage_image__level-4--14OIW","image__level-5":"BuildingCardImage_image__level-5--3WArh","imageLevel5":"BuildingCardImage_image__level-5--3WArh","image__level-6":"BuildingCardImage_image__level-6--diLYY","imageLevel6":"BuildingCardImage_image__level-6--diLYY","image__level-7":"BuildingCardImage_image__level-7--3LD_q","imageLevel7":"BuildingCardImage_image__level-7--3LD_q","image__level-8":"BuildingCardImage_image__level-8--UuqNg","imageLevel8":"BuildingCardImage_image__level-8--UuqNg","image__level-9":"BuildingCardImage_image__level-9--VwwJP","imageLevel9":"BuildingCardImage_image__level-9--VwwJP","image__level-10":"BuildingCardImage_image__level-10--1ZpPU","imageLevel10":"BuildingCardImage_image__level-10--1ZpPU","image__training-unit":"BuildingCardImage_image__training-unit--1tCOf","imageTrainingUnit":"BuildingCardImage_image__training-unit--1tCOf","image__tankodrome":"BuildingCardImage_image__tankodrome--3hHuq","imageTankodrome":"BuildingCardImage_image__tankodrome--3hHuq","image__financial-unit":"BuildingCardImage_image__financial-unit--2QhAM","imageFinancialUnit":"BuildingCardImage_image__financial-unit--2QhAM","image__transportation-unit":"BuildingCardImage_image__transportation-unit--1UAtX","imageTransportationUnit":"BuildingCardImage_image__transportation-unit--1UAtX","image__trophy-brigade":"BuildingCardImage_image__trophy-brigade--2Rtrq","imageTrophyBrigade":"BuildingCardImage_image__trophy-brigade--2Rtrq","image__artillery-battalion":"BuildingCardImage_image__artillery-battalion--3txcy","imageArtilleryBattalion":"BuildingCardImage_image__artillery-battalion--3txcy","image__military-school":"BuildingCardImage_image__military-school--2LHDl","imageMilitarySchool":"BuildingCardImage_image__military-school--2LHDl","image__home-front-service":"BuildingCardImage_image__home-front-service--1ZXxx","imageHomeFrontService":"BuildingCardImage_image__home-front-service--1ZXxx","image__command-center":"BuildingCardImage_image__command-center--1BALx","imageCommandCenter":"BuildingCardImage_image__command-center--1BALx","image__max-command-center":"BuildingCardImage_image__max-command-center--1OvCJ","imageMaxCommandCenter":"BuildingCardImage_image__max-command-center--1OvCJ","cost":"BuildingCardImage_cost--q4g9e","label":"BuildingCardImage_label--1BAFv","industrialResource":"BuildingCardImage_industrialResource--1y1Wp","cost__notEnough":"BuildingCardImage_cost__notEnough--3mnHy","costNotEnough":"BuildingCardImage_cost__notEnough--3mnHy","arrow":"BuildingCardImage_arrow--FRk-O","arrowLayer":"BuildingCardImage_arrowLayer--2iSQs","arrow-flow":"BuildingCardImage_arrow-flow--PFWRz","arrowFlow":"BuildingCardImage_arrow-flow--PFWRz","arrowLayer__0":"BuildingCardImage_arrowLayer__0--2W2Tf","arrowLayer0":"BuildingCardImage_arrowLayer__0--2W2Tf","arrowLayer__1":"BuildingCardImage_arrowLayer__1--3Vtu4","arrowLayer1":"BuildingCardImage_arrowLayer__1--3Vtu4","arrowLayer__2":"BuildingCardImage_arrowLayer__2--36qBg","arrowLayer2":"BuildingCardImage_arrowLayer__2--36qBg","arrowLayer__3":"BuildingCardImage_arrowLayer__3--171tm","arrowLayer3":"BuildingCardImage_arrowLayer__3--171tm","arrowLayer__4":"BuildingCardImage_arrowLayer__4--2ile9","arrowLayer4":"BuildingCardImage_arrowLayer__4--2ile9","arrow-flow-fast":"BuildingCardImage_arrow-flow-fast--2ccf8","arrowFlowFast":"BuildingCardImage_arrow-flow-fast--2ccf8"};

/***/ }),
/* 2097 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = exports.ReserveProduce = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(7);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

var _accounts = __webpack_require__(33);

var _datetime = __webpack_require__(13);

var _reactWotBootstrap = __webpack_require__(5);

var _LackOfIndustrialResource = __webpack_require__(288);

var _LackOfIndustrialResource2 = _interopRequireDefault(_LackOfIndustrialResource);

var _ProductionProgress = __webpack_require__(1329);

var _ProductionProgress2 = _interopRequireDefault(_ProductionProgress);

var _Warning = __webpack_require__(107);

var _Warning2 = _interopRequireDefault(_Warning);

var _IndustrialResource = __webpack_require__(35);

var _IndustrialResource2 = _interopRequireDefault(_IndustrialResource);

var _ReservesSlider = __webpack_require__(2102);

var _ReservesSlider2 = _interopRequireDefault(_ReservesSlider);

var _reserve_produce = __webpack_require__(277);

var _reserve_produce2 = _interopRequireDefault(_reserve_produce);

var _reserve_produce_cancel = __webpack_require__(194);

var _sounds = __webpack_require__(22);

var _constants = __webpack_require__(2105);

var _ReserveProduce = __webpack_require__(2106);

var _ReserveProduce2 = _interopRequireDefault(_ReserveProduce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReserveProduce = exports.ReserveProduce = function (_React$Component) {
    _inherits(ReserveProduce, _React$Component);

    function ReserveProduce(props) {
        _classCallCheck(this, ReserveProduce);

        var _this = _possibleConstructorReturn(this, (ReserveProduce.__proto__ || Object.getPrototypeOf(ReserveProduce)).call(this, props));

        _this.handleCancelClick = _this.handleCancelClick.bind(_this);
        return _this;
    }

    _createClass(ReserveProduce, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.props.changeSelectedCount(1, false);
        }
    }, {
        key: 'getTotalDurationTooltipContent',
        value: function getTotalDurationTooltipContent(seconds) {
            return (0, _constants.TOTAL_DURATION_TOOLTIP_CONTENT)(_react2.default.createElement(
                'span',
                { className: _ReserveProduce2.default.finish },
                (0, _datetime.getEndDateMessage)((0, _moment2.default)().add(_moment2.default.duration({ seconds: seconds })))
            ));
        }
    }, {
        key: 'handleCancelClick',
        value: function handleCancelClick() {
            this.props.playCancelClickSound();
            this.props.handleCancel();
        }
    }, {
        key: 'render',
        value: function render() {

            var totalDuration = this.props.duration * this.props.selectedCount;
            var productionEndsFor = totalDuration;
            if (this.props.reserveQueue.length > 0) {
                var lastReserveInQueue = this.props.reserveQueue[this.props.reserveQueue.length - 1];

                if (lastReserveInQueue.productionEnds > Date.now()) {
                    productionEndsFor += Math.round((lastReserveInQueue.productionEnds - Date.now()) / 1000);
                }
            }

            var totalDurationTooltip = void 0;

            var availableCount = Math.floor(this.props.industrialResourceAvailable / this.props.cost);
            var notEnough = this.props.selectedCount > availableCount;
            var totalCost = this.props.cost * this.props.selectedCount;
            var buildingId = this.props.buildingId;

            var industrialResourceTooltip = void 0;
            var footerComponent = void 0;
            var sliderComponent = void 0;
            var expandedCostColumn = void 0;
            var expandedDurationColumn = void 0;

            if (this.props.hasPermission) {

                if (notEnough) {
                    var notEnoughResourceComponent = _react2.default.createElement(_IndustrialResource2.default, {
                        value: Math.abs(this.props.industrialResourceAvailable - totalCost),
                        small: true
                    });
                    industrialResourceTooltip = _react2.default.createElement(
                        _reactWotBootstrap.Tooltip,
                        { id: _constants.INDUSTRIAL_RESOURCE_TOOLTIP_ID },
                        _react2.default.createElement(_LackOfIndustrialResource2.default, { resource: notEnoughResourceComponent })
                    );
                }

                sliderComponent = _react2.default.createElement(_ReservesSlider2.default, {
                    value: this.props.selectedCount,
                    handleChange: this.props.changeSelectedCount,
                    handleHover: this.props.playHoverSound,
                    maxAvailableValue: Math.floor(this.props.industrialResourceAvailable / this.props.cost)
                });
                expandedCostColumn = _react2.default.createElement(
                    'td',
                    { className: _ReserveProduce2.default.td },
                    this.props.selectedCount + ' \xD7 ',
                    _react2.default.createElement(_IndustrialResource2.default, { value: this.props.cost, small: true })
                );
                expandedDurationColumn = _react2.default.createElement(
                    'td',
                    { className: _ReserveProduce2.default.td },
                    this.props.selectedCount + ' \xD7 ',
                    _react2.default.createElement(
                        'span',
                        { className: _ReserveProduce2.default.duration + ' ' + _ReserveProduce2.default.duration__small },
                        (0, _datetime.getFormattedTime)(this.props.duration * 1000)
                    )
                );
                footerComponent = _react2.default.createElement(
                    'div',
                    { className: _ReserveProduce2.default.footer },
                    _react2.default.createElement(
                        _reactWotBootstrap.Button,
                        {
                            onClick: this.props.submitReserveProduce.bind(null, buildingId, this.props.selectedCount, this.props.selectedLevel),
                            isDisabled: notEnough,
                            tooltipId: _constants.INDUSTRIAL_RESOURCE_TOOLTIP_ID
                        },
                        _constants.RESERVE_PRODUCE_SUBMIT
                    )
                );

                totalDurationTooltip = _react2.default.createElement(_reactWotBootstrap.Tooltip, {
                    id: '' + _constants.TOTAL_DURATION_TOOLTIP_ID + this.props.buildingId,
                    getContent: this.getTotalDurationTooltipContent.bind(null, productionEndsFor)
                });
            } else {
                footerComponent = _react2.default.createElement(
                    'div',
                    { className: _ReserveProduce2.default.warning },
                    _react2.default.createElement(
                        _Warning2.default,
                        null,
                        _constants.RESERVE_PRODUCE_WARNING
                    )
                );
            }
            var baseClassName = (0, _classnames2.default)(_ReserveProduce2.default.base, _defineProperty({}, _ReserveProduce2.default.base__fade, this.props.fade));

            return _react2.default.createElement(
                'div',
                { className: baseClassName },
                _react2.default.createElement(
                    'h3',
                    { className: _ReserveProduce2.default.title },
                    _constants.RESERVE_PRODUCE_TITLE
                ),
                _react2.default.createElement(_ProductionProgress2.default, {
                    key: this.props.selectedLevel,
                    hasPermission: this.props.hasPermission,
                    reserveQueue: this.props.reserveQueue,
                    onCancel: this.handleCancelClick,
                    playHoverSound: this.props.playHoverSound
                }),
                _react2.default.createElement(
                    'div',
                    { className: _ReserveProduce2.default.holder },
                    sliderComponent,
                    _react2.default.createElement(
                        'table',
                        { className: _ReserveProduce2.default.table },
                        _react2.default.createElement(
                            'tbody',
                            null,
                            _react2.default.createElement(
                                'tr',
                                { className: _ReserveProduce2.default.tr },
                                _react2.default.createElement(
                                    'th',
                                    { className: _ReserveProduce2.default.th },
                                    _constants.RESERVE_PRODUCE_COST
                                ),
                                expandedCostColumn,
                                _react2.default.createElement(
                                    'td',
                                    { className: _ReserveProduce2.default.td },
                                    _react2.default.createElement(_IndustrialResource2.default, {
                                        value: totalCost,
                                        notEnough: this.props.hasPermission ? notEnough : false,
                                        popoverId: _constants.INDUSTRIAL_RESOURCE_TOOLTIP_ID
                                    })
                                )
                            ),
                            _react2.default.createElement(
                                'tr',
                                { className: _ReserveProduce2.default.tr },
                                _react2.default.createElement(
                                    'th',
                                    { className: _ReserveProduce2.default.th },
                                    _constants.RESERVE_PRODUCE_DURATION
                                ),
                                expandedDurationColumn,
                                _react2.default.createElement(
                                    'td',
                                    { className: _ReserveProduce2.default.td },
                                    _react2.default.createElement(
                                        'span',
                                        {
                                            className: _ReserveProduce2.default.duration,
                                            'data-tip': true, 'data-for': '' + _constants.TOTAL_DURATION_TOOLTIP_ID + this.props.buildingId
                                        },
                                        (0, _datetime.getFormattedTime)(totalDuration * 1000)
                                    ),
                                    totalDurationTooltip
                                )
                            )
                        )
                    )
                ),
                footerComponent,
                industrialResourceTooltip
            );
        }
    }]);

    return ReserveProduce;
}(_react2.default.Component);

ReserveProduce.propTypes = {
    buildingId: _propTypes2.default.number.isRequired,
    cost: _propTypes2.default.number.isRequired,
    duration: _propTypes2.default.number.isRequired,
    reserveQueue: _propTypes2.default.arrayOf(_propTypes2.default.object),
    industrialResourceAvailable: _propTypes2.default.number.isRequired,
    selectedCount: _propTypes2.default.number.isRequired,
    hasPermission: _propTypes2.default.bool.isRequired,
    fade: _propTypes2.default.bool,
    selectedLevel: _propTypes2.default.number.isRequired,
    changeSelectedCount: _propTypes2.default.func.isRequired,
    playCancelClickSound: _propTypes2.default.func.isRequired,
    playHoverSound: _propTypes2.default.func.isRequired,
    submitReserveProduce: _propTypes2.default.func.isRequired,
    handleCancel: _propTypes2.default.func.isRequired
};
var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, _ref) {
    var buildingId = _ref.buildingId,
        reserve = _ref.reserve;

    var building = state.buildings[buildingId];
    var selectedLevel = state.reserveLevelSelect.selectedLevel;

    return {
        cost: reserve.conditions[selectedLevel - 1].production_cost,
        duration: reserve.conditions[selectedLevel - 1].production_time,
        reserveQueue: state.clanReserves[reserve.type].filter(function (_ref2) {
            var level = _ref2.level;
            return level === selectedLevel;
        }),
        industrialResourceAvailable: state.clan.industrial_resource,
        selectedCount: state.reserveProduce.selectedCount,
        hasPermission: (0, _accounts.canPrepareReserve)(state.account),
        fade: state.buildingUpgrade.highlighted,
        buildingId: building.id,
        selectedLevel: selectedLevel
    };
};

var mapDispatchToProps = exports.mapDispatchToProps = {
    changeSelectedCount: _reserve_produce.changeSelectedCount,
    handleCancel: _reserve_produce_cancel.openCancelConfirmation,
    playCancelClickSound: _sounds.playCancelClickSound,
    playHoverSound: _sounds.playHoverSound,
    submitReserveProduce: _reserve_produce2.default
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ReserveProduce);

/***/ }),
/* 2098 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DESCRIPTION = exports.LACK = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LACK = exports.LACK = function LACK(resource) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'lack_of_industrial_resource.lack',
        defaultMessage: '\u041D\u0435 \u0445\u0432\u0430\u0442\u0430\u0435\u0442 {resource}',
        values: { resource: resource }
    });
};

var DESCRIPTION = exports.DESCRIPTION = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'lack_of_industrial_resource.description',
    defaultMessage: '\u0417\u0430\u0440\u0430\u0431\u043E\u0442\u0430\u0439\u0442\u0435 \u043F\u0440\u043E\u043C\u0440\u0435\u0441\u0443\u0440\u0441 \u0432 \u0412\u044B\u043B\u0430\u0437\u043A\u0430\u0445, \u041D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u044F\u0445 \u0438\u043B\u0438 \u0421\u043B\u0443\u0447\u0430\u0439\u043D\u044B\u0445 \u0431\u043E\u044F\u0445 (\u043D\u0430 \u0442\u0435\u0445\u043D\u0438\u043A\u0435 X \u0443\u0440\u043E\u0432\u043D\u044F).' // eslint-disable-line max-len
});

/***/ }),
/* 2099 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"LackOfIndustrialResource_base--14kXC","description":"LackOfIndustrialResource_description--1JwOo","lack":"LackOfIndustrialResource_lack--1Qxy6"};

/***/ }),
/* 2100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CANCEL_TOOLTIP_ID = exports.ADD_RESERVE_TO_QUEUE_TITLE = exports.CANCEL_TOOLTIP_CONTENT = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CANCEL_TOOLTIP_CONTENT = exports.CANCEL_TOOLTIP_CONTENT = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'production_progress.cancel_tooltip_content',
    defaultMessage: '\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043E\u0442\u043C\u0435\u043D\u0438\u0442\u044C \u043F\u043E\u0434\u0433\u043E\u0442\u043E\u0432\u043A\u0443 \u0440\u0435\u0437\u0435\u0440\u0432\u043E\u0432.{newLine}\u0417\u0430\u0442\u0440\u0430\u0447\u0435\u043D\u043D\u044B\u0439 \u043D\u0430 \u043F\u043E\u0434\u0433\u043E\u0442\u043E\u0432\u043A\u0443 \u043F\u0440\u043E\u043C\u0440\u0435\u0441\u0443\u0440\u0441 \u0431\u0443\u0434\u0435\u0442 \u0432\u043E\u0437\u0432\u0440\u0430\u0449\u0451\u043D \u043D\u0430 \u0441\u043A\u043B\u0430\u0434.' // eslint-disable-line max-len
    , values: {
        newLine: _react2.default.createElement('br', null)
    }
});

var ADD_RESERVE_TO_QUEUE_TITLE = exports.ADD_RESERVE_TO_QUEUE_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'building_reserve_produce.add_reserve_to_queue_title',
    defaultMessage: '\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043A \u043F\u043E\u0434\u0433\u043E\u0442\u043E\u0432\u043A\u0435'
});

var CANCEL_TOOLTIP_ID = exports.CANCEL_TOOLTIP_ID = 'production_progress.cancel_tooltip';

/***/ }),
/* 2101 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tooltip-root":"ProductionProgress_tooltip-root--1jti6","tooltipRoot":"ProductionProgress_tooltip-root--1jti6","tooltip-root__show":"ProductionProgress_tooltip-root__show--3tS12","tooltipRootShow":"ProductionProgress_tooltip-root__show--3tS12","tooltip-body":"ProductionProgress_tooltip-body--3Jk7L","tooltipBody":"ProductionProgress_tooltip-body--3Jk7L","tooltip-wrapper":"ProductionProgress_tooltip-wrapper--3eZL0","tooltipWrapper":"ProductionProgress_tooltip-wrapper--3eZL0","tooltip-content":"ProductionProgress_tooltip-content--1b5h0","tooltipContent":"ProductionProgress_tooltip-content--1b5h0","tooltip-title":"ProductionProgress_tooltip-title--3YSGJ","tooltipTitle":"ProductionProgress_tooltip-title--3YSGJ","tooltip-subtitle":"ProductionProgress_tooltip-subtitle--f0X6B","tooltipSubtitle":"ProductionProgress_tooltip-subtitle--f0X6B","tooltip-message":"ProductionProgress_tooltip-message--1WSa0","tooltipMessage":"ProductionProgress_tooltip-message--1WSa0","tooltip-warning":"ProductionProgress_tooltip-warning--ml-8i","tooltipWarning":"ProductionProgress_tooltip-warning--ml-8i","tooltip-divider":"ProductionProgress_tooltip-divider--2fbGP","tooltipDivider":"ProductionProgress_tooltip-divider--2fbGP","tooltip-highlight":"ProductionProgress_tooltip-highlight--1kCs6","tooltipHighlight":"ProductionProgress_tooltip-highlight--1kCs6","tooltip-ribbon":"ProductionProgress_tooltip-ribbon--3mz99","tooltipRibbon":"ProductionProgress_tooltip-ribbon--3mz99","tooltip-statusMessage":"ProductionProgress_tooltip-statusMessage--1h59H","tooltipStatusMessage":"ProductionProgress_tooltip-statusMessage--1h59H","tooltip-statusMessage__positive":"ProductionProgress_tooltip-statusMessage__positive--3Qd7t","tooltipStatusMessagePositive":"ProductionProgress_tooltip-statusMessage__positive--3Qd7t","tooltip-status":"ProductionProgress_tooltip-status--1pHmW","tooltipStatus":"ProductionProgress_tooltip-status--1pHmW","tooltip-statusMessage__negative":"ProductionProgress_tooltip-statusMessage__negative--1fGLG","tooltipStatusMessageNegative":"ProductionProgress_tooltip-statusMessage__negative--1fGLG","tooltip-statusMessage__noPermission":"ProductionProgress_tooltip-statusMessage__noPermission--3b6We","tooltipStatusMessageNoPermission":"ProductionProgress_tooltip-statusMessage__noPermission--3b6We","tooltip-status__positive":"ProductionProgress_tooltip-status__positive--3vC4q","tooltipStatusPositive":"ProductionProgress_tooltip-status__positive--3vC4q","tooltip-status__negative":"ProductionProgress_tooltip-status__negative--2Q2b3","tooltipStatusNegative":"ProductionProgress_tooltip-status__negative--2Q2b3","tooltip-statusText":"ProductionProgress_tooltip-statusText--2XOxs","tooltipStatusText":"ProductionProgress_tooltip-statusText--2XOxs","base":"ProductionProgress_base--3KWUc","base__simplified":"ProductionProgress_base__simplified--tIgfX","baseSimplified":"ProductionProgress_base__simplified--tIgfX","title":"ProductionProgress_title--3HzxJ","grid":"ProductionProgress_grid--sWV9W","progress":"ProductionProgress_progress--3i9XI","holder":"ProductionProgress_holder--1ZVKE","wrapper":"ProductionProgress_wrapper--3Tf7B","bar":"ProductionProgress_bar--3nEJU","timeLeft":"ProductionProgress_timeLeft--BsZdO","controls":"ProductionProgress_controls--1cW8j","multiplier":"ProductionProgress_multiplier--3XSca","cancel":"ProductionProgress_cancel--48qm-"};

/***/ }),
/* 2102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _ReservesSlider = __webpack_require__(2103);

var _ReservesSlider2 = _interopRequireDefault(_ReservesSlider);

var _constants = __webpack_require__(2104);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReservesSlider = function (_React$Component) {
    _inherits(ReservesSlider, _React$Component);

    function ReservesSlider() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ReservesSlider);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReservesSlider.__proto__ || Object.getPrototypeOf(ReservesSlider)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (event) {
            var value = ReservesSlider.values[event.target.value];
            if (value > 0) {
                _this.props.handleChange(value);
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ReservesSlider, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var scaleItems = ReservesSlider.values.map(function (value, index) {
                var scaleItemClassName = (0, _classnames2.default)(_ReservesSlider2.default.scaleItem, _defineProperty({}, _ReservesSlider2.default.scaleItem__unavailable, value > _this2.props.maxAvailableValue));
                return _react2.default.createElement(
                    'div',
                    { className: scaleItemClassName, key: index },
                    _react2.default.createElement(
                        'span',
                        { className: _ReservesSlider2.default.scaleCaption },
                        value,
                        _react2.default.createElement(
                            'span',
                            { className: _ReservesSlider2.default.scaleCaptionGradient },
                            value
                        )
                    )
                );
            });

            var lastValueIndex = ReservesSlider.values.length - 1;

            var availableWidth = void 0;
            if (this.props.maxAvailableValue >= this.props.maxValue) {
                availableWidth = 1;
            } else {
                var maxAvailableValue = ReservesSlider.values.find(function (value, index) {
                    var nextValue = ReservesSlider.values[index + 1];
                    return value <= _this2.props.maxAvailableValue && nextValue > _this2.props.maxAvailableValue;
                });
                availableWidth = ReservesSlider.values.indexOf(maxAvailableValue) / lastValueIndex;
            }

            var valueIndex = ReservesSlider.values.indexOf(this.props.value);
            var selectedWidth = valueIndex / lastValueIndex;

            var availableSelectionWidth = Math.min(selectedWidth, availableWidth);

            return _react2.default.createElement(
                'div',
                { className: _ReservesSlider2.default.base },
                _react2.default.createElement(
                    'p',
                    { className: _ReservesSlider2.default.label },
                    _constants.RESERVES_SLIDER_RANGE_LABEL
                ),
                _react2.default.createElement(
                    'div',
                    { className: _ReservesSlider2.default.range },
                    _react2.default.createElement(
                        'div',
                        { className: _ReservesSlider2.default.scale },
                        scaleItems
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _ReservesSlider2.default.holder },
                        _react2.default.createElement('div', { className: _ReservesSlider2.default.available, style: { width: availableWidth * 100 + '%' } }),
                        _react2.default.createElement('div', { className: _ReservesSlider2.default.selected, style: { width: availableSelectionWidth * 100 + '%' } }),
                        _react2.default.createElement(
                            'div',
                            { className: _ReservesSlider2.default.wrapper },
                            _react2.default.createElement('input', {
                                className: _ReservesSlider2.default.input,
                                type: 'range',
                                min: 0,
                                value: valueIndex,
                                max: lastValueIndex,
                                onMouseEnter: this.props.handleHover,
                                onChange: this.handleChange
                            })
                        )
                    )
                )
            );
        }
    }]);

    return ReservesSlider;
}(_react2.default.Component);

ReservesSlider.propTypes = {
    maxValue: _propTypes2.default.number.isRequired,
    value: _propTypes2.default.number.isRequired,
    maxAvailableValue: _propTypes2.default.number.isRequired,
    handleChange: _propTypes2.default.func.isRequired,
    handleHover: _propTypes2.default.func.isRequired
};
ReservesSlider.defaultProps = {
    maxValue: 50, // values.last
    value: 1
};
ReservesSlider.values = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 20, 30, 40, 50];
exports.default = ReservesSlider;

/***/ }),
/* 2103 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"range":"ReservesSlider_range--36qYH","holder":"ReservesSlider_holder--UsHvY","selected":"ReservesSlider_selected--2y2cn","available":"ReservesSlider_available--3TSkD","wrapper":"ReservesSlider_wrapper--1kp72","input":"ReservesSlider_input--1Y25X","base":"ReservesSlider_base--3x-Bo","label":"ReservesSlider_label--Dpwsd","scale":"ReservesSlider_scale--6Mbub","scaleItem":"ReservesSlider_scaleItem--1llHJ","scaleCaption":"ReservesSlider_scaleCaption--23byF","scaleItem__unavailable":"ReservesSlider_scaleItem__unavailable--10jff","scaleItemUnavailable":"ReservesSlider_scaleItem__unavailable--10jff","scaleCaptionGradient":"ReservesSlider_scaleCaptionGradient--3iD9B"};

/***/ }),
/* 2104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RESERVES_SLIDER_RANGE_LABEL = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RESERVES_SLIDER_RANGE_LABEL = exports.RESERVES_SLIDER_RANGE_LABEL = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'reserves_slider.range_label',
    defaultMessage: '\u0415\u0434\u0438\u043D\u0438\u0446 \u0440\u0435\u0437\u0435\u0440\u0432\u0430'
});

/***/ }),
/* 2105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.INDUSTRIAL_RESOURCE_TOOLTIP_ID = exports.TOTAL_DURATION_TOOLTIP_ID = exports.TOTAL_DURATION_TOOLTIP_CONTENT = exports.RESERVE_PRODUCE_WARNING = exports.RESERVE_PRODUCE_SUBMIT = exports.RESERVE_PRODUCE_DURATION = exports.RESERVE_PRODUCE_COST = exports.RESERVE_PRODUCE_TITLE = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-multi-comp */
var RESERVE_PRODUCE_TITLE = exports.RESERVE_PRODUCE_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'building_reserve_produce.title',
    defaultMessage: '\u041F\u043E\u0434\u0433\u043E\u0442\u043E\u0432\u043A\u0430 \u0440\u0435\u0437\u0435\u0440\u0432\u043E\u0432'
});

var RESERVE_PRODUCE_COST = exports.RESERVE_PRODUCE_COST = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'building_reserve_produce.cost',
    defaultMessage: '\u0421\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C \u043F\u043E\u0434\u0433\u043E\u0442\u043E\u0432\u043A\u0438'
});

var RESERVE_PRODUCE_DURATION = exports.RESERVE_PRODUCE_DURATION = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'building_reserve_produce.duration',
    defaultMessage: '\u0412\u0440\u0435\u043C\u044F \u043F\u043E\u0434\u0433\u043E\u0442\u043E\u0432\u043A\u0438'
});

var RESERVE_PRODUCE_SUBMIT = exports.RESERVE_PRODUCE_SUBMIT = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'building_reserve_produce.submit',
    defaultMessage: '\u041F\u043E\u0434\u0433\u043E\u0442\u043E\u0432\u0438\u0442\u044C'
});

var RESERVE_PRODUCE_WARNING = exports.RESERVE_PRODUCE_WARNING = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'building_reserve_produce.warning',
    defaultMessage: '\u041F\u043E\u0434\u0433\u043E\u0442\u0430\u0432\u043B\u0438\u0432\u0430\u0442\u044C \u0440\u0435\u0437\u0435\u0440\u0432\u044B \u043C\u043E\u0433\u0443\u0442 \u043A\u043E\u043C\u0430\u043D\u0434\u0443\u044E\u0449\u0438\u0439, \u0435\u0433\u043E \u0437\u0430\u043C\u0435\u0441\u0442\u0438\u0442\u0435\u043B\u0438 \u0438 \u043E\u0444\u0438\u0446\u0435\u0440\u044B \u0448\u0442\u0430\u0431\u0430.'
});

var TOTAL_DURATION_TOOLTIP_CONTENT = exports.TOTAL_DURATION_TOOLTIP_CONTENT = function TOTAL_DURATION_TOOLTIP_CONTENT(timeNode) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'building_reserve_produce.total_duration_tooltip_content',
        defaultMessage: '\u0412\u0441\u0435 \u0440\u0435\u0437\u0435\u0440\u0432\u044B \u0431\u0443\u0434\u0443\u0442 \u0433\u043E\u0442\u043E\u0432\u044B {timeNode}',
        values: {
            timeNode: timeNode
        }
    });
};

var TOTAL_DURATION_TOOLTIP_ID = exports.TOTAL_DURATION_TOOLTIP_ID = 'reserveProduceTimeLeft';
var INDUSTRIAL_RESOURCE_TOOLTIP_ID = exports.INDUSTRIAL_RESOURCE_TOOLTIP_ID = 'notEnoughIndustrialResource';

/***/ }),
/* 2106 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"ReserveProduce_base--2S1g3","base__fade":"ReserveProduce_base__fade--3cUNv","baseFade":"ReserveProduce_base__fade--3cUNv","title":"ReserveProduce_title--2J3Mb","holder":"ReserveProduce_holder--222wr","footer":"ReserveProduce_footer--3ku4I","warning":"ReserveProduce_warning--2ivGT","duration":"ReserveProduce_duration--1PGBn","duration__small":"ReserveProduce_duration__small--5IhTN","durationSmall":"ReserveProduce_duration__small--5IhTN","table":"ReserveProduce_table--1ZviQ","th":"ReserveProduce_th--22d0O","td":"ReserveProduce_td--1BzO_","tr":"ReserveProduce_tr--3O8kU","finish":"ReserveProduce_finish--3daU7"};

/***/ }),
/* 2107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapStateToProps = exports.UpgradeConfirmation = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(7);

var _UpgradeConfirmationView = __webpack_require__(1330);

var _UpgradeConfirmationView2 = _interopRequireDefault(_UpgradeConfirmationView);

var _building_upgrade = __webpack_require__(193);

var _building_upgrade2 = _interopRequireDefault(_building_upgrade);

var _i18n = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UpgradeConfirmation = exports.UpgradeConfirmation = function (_React$Component) {
    _inherits(UpgradeConfirmation, _React$Component);

    function UpgradeConfirmation() {
        _classCallCheck(this, UpgradeConfirmation);

        var _this = _possibleConstructorReturn(this, (UpgradeConfirmation.__proto__ || Object.getPrototypeOf(UpgradeConfirmation)).call(this));

        _this.submitHandler = _this.submitHandler.bind(_this);
        _this.cancelHandler = _this.cancelHandler.bind(_this);
        return _this;
    }

    _createClass(UpgradeConfirmation, [{
        key: 'submitHandler',
        value: function submitHandler() {
            var _props$building = this.props.building,
                id = _props$building.id,
                level = _props$building.level;

            this.props.upgradeBuilding(id, level + 1);
        }
    }, {
        key: 'cancelHandler',
        value: function cancelHandler() {
            this.props.cancelUpgradeHandler();
        }
    }, {
        key: 'render',
        value: function render() {
            var _props$building2 = this.props.building,
                type = _props$building2.type,
                level = _props$building2.level;


            return _react2.default.createElement(_UpgradeConfirmationView2.default, {
                type: type,
                name: _i18n.BUILDING_TITLES[type],
                level: level,
                upgraded: this.props.upgraded,
                upgradeCost: this.props.upgradeCost,
                submitHandler: this.submitHandler,
                cancelHandler: this.cancelHandler
            });
        }
    }]);

    return UpgradeConfirmation;
}(_react2.default.Component);

UpgradeConfirmation.propTypes = {
    building: _propTypes2.default.shape({
        id: _propTypes2.default.number.isRequired,
        type: _propTypes2.default.string.isRequired,
        level: _propTypes2.default.number.isRequired
    }).isRequired,
    upgraded: _propTypes2.default.bool.isRequired,
    upgradeCost: _propTypes2.default.number.isRequired,
    upgradeBuilding: _propTypes2.default.func.isRequired,
    cancelUpgradeHandler: _propTypes2.default.func.isRequired
};
var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, _ref) {
    var building = _ref.building;
    var settings = state.settings,
        buildingUpgrade = state.buildingUpgrade;


    return {
        building: building,
        upgradeCost: settings.buildings[building.type].costs[building.level],
        upgraded: buildingUpgrade.submitted
    };
};

var mapDispatchToProps = {
    upgradeBuilding: _building_upgrade2.default,
    cancelUpgradeHandler: _building_upgrade.closeUpgradeConfirmation
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UpgradeConfirmation);

/***/ }),
/* 2108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UPGRADE_CONFIRMATION_COMMAND_CENTER_MESSAGE = exports.UPGRADE_CONFIRMATION_MESSAGE = exports.UPGRADE_CONFIRMATION_LEVEL = exports.UPGRADE_CONFIRMATION_SUBMIT = exports.RADIANCE_LAYERS_COUNT = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-multi-comp */

var RADIANCE_LAYERS_COUNT = exports.RADIANCE_LAYERS_COUNT = 10;

var UPGRADE_CONFIRMATION_SUBMIT = exports.UPGRADE_CONFIRMATION_SUBMIT = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'building_upgrade_confirmation.submit',
    defaultMessage: 'Модернизировать'
});

var UPGRADE_CONFIRMATION_LEVEL = exports.UPGRADE_CONFIRMATION_LEVEL = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'building_upgrade_confirmation.level',
    defaultMessage: 'уровень'
});

var UPGRADE_CONFIRMATION_MESSAGE = exports.UPGRADE_CONFIRMATION_MESSAGE = function UPGRADE_CONFIRMATION_MESSAGE(name, level, industrialResource) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'building_upgrade_confirmation.message',
        defaultMessage: 'Модернизировать строение {name} до {level} за {industrialResource}?',
        values: {
            name: name,
            level: level,
            industrialResource: industrialResource
        }
    });
};

var UPGRADE_CONFIRMATION_COMMAND_CENTER_MESSAGE = exports.UPGRADE_CONFIRMATION_COMMAND_CENTER_MESSAGE = function UPGRADE_CONFIRMATION_COMMAND_CENTER_MESSAGE(level, industrialResource) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'building_upgrade_confirmation.command_center_message',
        defaultMessage: 'Модернизировать Командный центр до {level} за {industrialResource}?',
        values: {
            level: level,
            industrialResource: industrialResource
        }
    });
};

/***/ }),
/* 2109 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"UpgradeConfirmationView_base--2F2eE","building":"UpgradeConfirmationView_building--1k9L0","image":"UpgradeConfirmationView_image--1lEI_","base__animateUpgrading":"UpgradeConfirmationView_base__animateUpgrading--jH3CX","baseAnimateUpgrading":"UpgradeConfirmationView_base__animateUpgrading--jH3CX","image__attack-bomber-squadrons":"UpgradeConfirmationView_image__attack-bomber-squadrons--BnrWL","imageAttackBomberSquadrons":"UpgradeConfirmationView_image__attack-bomber-squadrons--BnrWL","image__level-1":"UpgradeConfirmationView_image__level-1--JPl4p","imageLevel1":"UpgradeConfirmationView_image__level-1--JPl4p","image__level-2":"UpgradeConfirmationView_image__level-2--3sRZi","imageLevel2":"UpgradeConfirmationView_image__level-2--3sRZi","image__level-3":"UpgradeConfirmationView_image__level-3--2z7je","imageLevel3":"UpgradeConfirmationView_image__level-3--2z7je","image__level-4":"UpgradeConfirmationView_image__level-4--2IuHM","imageLevel4":"UpgradeConfirmationView_image__level-4--2IuHM","image__level-5":"UpgradeConfirmationView_image__level-5--33X9V","imageLevel5":"UpgradeConfirmationView_image__level-5--33X9V","image__level-6":"UpgradeConfirmationView_image__level-6--12PT9","imageLevel6":"UpgradeConfirmationView_image__level-6--12PT9","image__level-7":"UpgradeConfirmationView_image__level-7--20PqH","imageLevel7":"UpgradeConfirmationView_image__level-7--20PqH","image__level-8":"UpgradeConfirmationView_image__level-8--3ZVAe","imageLevel8":"UpgradeConfirmationView_image__level-8--3ZVAe","image__level-9":"UpgradeConfirmationView_image__level-9--ykMIQ","imageLevel9":"UpgradeConfirmationView_image__level-9--ykMIQ","image__level-10":"UpgradeConfirmationView_image__level-10--1uK6U","imageLevel10":"UpgradeConfirmationView_image__level-10--1uK6U","image__training-unit":"UpgradeConfirmationView_image__training-unit--2pKSK","imageTrainingUnit":"UpgradeConfirmationView_image__training-unit--2pKSK","image__tankodrome":"UpgradeConfirmationView_image__tankodrome--25ZSR","imageTankodrome":"UpgradeConfirmationView_image__tankodrome--25ZSR","image__financial-unit":"UpgradeConfirmationView_image__financial-unit--2sh6N","imageFinancialUnit":"UpgradeConfirmationView_image__financial-unit--2sh6N","image__transportation-unit":"UpgradeConfirmationView_image__transportation-unit--2el6R","imageTransportationUnit":"UpgradeConfirmationView_image__transportation-unit--2el6R","image__trophy-brigade":"UpgradeConfirmationView_image__trophy-brigade--2MPx3","imageTrophyBrigade":"UpgradeConfirmationView_image__trophy-brigade--2MPx3","image__artillery-battalion":"UpgradeConfirmationView_image__artillery-battalion--3iRbI","imageArtilleryBattalion":"UpgradeConfirmationView_image__artillery-battalion--3iRbI","image__military-school":"UpgradeConfirmationView_image__military-school--3L7u9","imageMilitarySchool":"UpgradeConfirmationView_image__military-school--3L7u9","image__home-front-service":"UpgradeConfirmationView_image__home-front-service--2posI","imageHomeFrontService":"UpgradeConfirmationView_image__home-front-service--2posI","image__command-center":"UpgradeConfirmationView_image__command-center--1NHn5","imageCommandCenter":"UpgradeConfirmationView_image__command-center--1NHn5","levelHolder":"UpgradeConfirmationView_levelHolder--384QB","level":"UpgradeConfirmationView_level--2RXoe","levelSubstring":"UpgradeConfirmationView_levelSubstring--1OSjp","level-gradient":"UpgradeConfirmationView_level-gradient--1B2Iy","levelGradient":"UpgradeConfirmationView_level-gradient--1B2Iy","levelSubstring-gradient":"UpgradeConfirmationView_levelSubstring-gradient--1H47K","levelSubstringGradient":"UpgradeConfirmationView_levelSubstring-gradient--1H47K","footer":"UpgradeConfirmationView_footer--3T1Bd","message":"UpgradeConfirmationView_message--p4OWU","button":"UpgradeConfirmationView_button--PZi1_","inlineName":"UpgradeConfirmationView_inlineName--1t9CZ","inlineLevel":"UpgradeConfirmationView_inlineLevel--30bY9","inlineLevel-gradient":"UpgradeConfirmationView_inlineLevel-gradient--1Pj0k","inlineLevelGradient":"UpgradeConfirmationView_inlineLevel-gradient--1Pj0k","radiance":"UpgradeConfirmationView_radiance--F8ZKU","radianceLayer":"UpgradeConfirmationView_radianceLayer--3Fu8k","radianceLayer__0":"UpgradeConfirmationView_radianceLayer__0--3Q4Rs","radianceLayer0":"UpgradeConfirmationView_radianceLayer__0--3Q4Rs","radianceLayer__1":"UpgradeConfirmationView_radianceLayer__1--zIfd_","radianceLayer1":"UpgradeConfirmationView_radianceLayer__1--zIfd_","radianceLayer__2":"UpgradeConfirmationView_radianceLayer__2--bW4N5","radianceLayer2":"UpgradeConfirmationView_radianceLayer__2--bW4N5","radianceLayer__3":"UpgradeConfirmationView_radianceLayer__3--1MBo4","radianceLayer3":"UpgradeConfirmationView_radianceLayer__3--1MBo4","radianceLayer__4":"UpgradeConfirmationView_radianceLayer__4--1hlpL","radianceLayer4":"UpgradeConfirmationView_radianceLayer__4--1hlpL","radianceLayer__5":"UpgradeConfirmationView_radianceLayer__5--3hZhr","radianceLayer5":"UpgradeConfirmationView_radianceLayer__5--3hZhr","radianceLayer__6":"UpgradeConfirmationView_radianceLayer__6--3mJGR","radianceLayer6":"UpgradeConfirmationView_radianceLayer__6--3mJGR","radianceLayer__7":"UpgradeConfirmationView_radianceLayer__7--2Oikc","radianceLayer7":"UpgradeConfirmationView_radianceLayer__7--2Oikc","radianceLayer__8":"UpgradeConfirmationView_radianceLayer__8--3bmt3","radianceLayer8":"UpgradeConfirmationView_radianceLayer__8--3bmt3","radianceLayer__9":"UpgradeConfirmationView_radianceLayer__9--1GN3m","radianceLayer9":"UpgradeConfirmationView_radianceLayer__9--1GN3m","radiance-opacity":"UpgradeConfirmationView_radiance-opacity--muanu","radianceOpacity":"UpgradeConfirmationView_radiance-opacity--muanu","radiance-transform":"UpgradeConfirmationView_radiance-transform--ojFK8","radianceTransform":"UpgradeConfirmationView_radiance-transform--ojFK8","radiance-opacity-infinite":"UpgradeConfirmationView_radiance-opacity-infinite--xRR9E","radianceOpacityInfinite":"UpgradeConfirmationView_radiance-opacity-infinite--xRR9E","radiance-transform-infinite":"UpgradeConfirmationView_radiance-transform-infinite--xSt-Y","radianceTransformInfinite":"UpgradeConfirmationView_radiance-transform-infinite--xSt-Y"};

/***/ }),
/* 2110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapStateToProps = exports.UpgradeEffectContent = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(7);

var _BaseBonusInfoTable = __webpack_require__(383);

var _BaseBonusInfoTable2 = _interopRequireDefault(_BaseBonusInfoTable);

var _columns = __webpack_require__(1332);

var _translations = __webpack_require__(384);

var _Warning = __webpack_require__(107);

var _Warning2 = _interopRequireDefault(_Warning);

var _IndustrialResource = __webpack_require__(35);

var _IndustrialResource2 = _interopRequireDefault(_IndustrialResource);

var _constants = __webpack_require__(1333);

var _constants2 = __webpack_require__(2113);

var _i18n = __webpack_require__(10);

var _constants3 = __webpack_require__(4);

var _UpgradeEffectContent = __webpack_require__(2114);

var _UpgradeEffectContent2 = _interopRequireDefault(_UpgradeEffectContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UpgradeEffectContent = exports.UpgradeEffectContent = function UpgradeEffectContent(_ref) {
    var bonus = _ref.bonus,
        reserveType = _ref.reserveType,
        reserveName = _ref.reserveName,
        upgradeCosts = _ref.upgradeCosts,
        currentLevel = _ref.currentLevel,
        hasPermission = _ref.hasPermission;

    var minBonus = bonus.values[0];

    var tableColumns = (0, _columns.getReserveTableColumns)(reserveType, minBonus, bonus.type);

    tableColumns.push({
        title: (0, _constants2.UPGRADE_COST_HEADER)(true),
        dataIndex: 'upgradeCost',
        isCalculatedWidth: reserveType === _constants3.RESERVE_TYPES.ARTILLERY_STRIKE,
        render: function render(value) {
            return _react2.default.createElement(_IndustrialResource2.default, {
                value: value,
                small: true
            });
        }
    });

    var dataSource = bonus.values.map(function (bonusParameters, index) {
        return _extends({}, bonusParameters, {
            upgradeCost: upgradeCosts[index]
        });
    });

    var isMaxLevelReached = currentLevel === _constants3.MAX_BUILDING_LEVEL;

    return _react2.default.createElement(
        'div',
        { className: _UpgradeEffectContent2.default.base },
        _react2.default.createElement(
            'div',
            { className: _UpgradeEffectContent2.default.header },
            _react2.default.createElement(
                'h2',
                { className: _UpgradeEffectContent2.default.title },
                _react2.default.createElement(
                    'span',
                    { className: _UpgradeEffectContent2.default.titleText },
                    _constants.MODERNIZATION_OVERLAY_TITLE
                )
            ),
            !hasPermission && !isMaxLevelReached && _react2.default.createElement(
                'div',
                { className: _UpgradeEffectContent2.default.warning },
                _react2.default.createElement(
                    _Warning2.default,
                    { type: 'warning' },
                    _constants2.PERMISSIONS_REQUIRED_MESSAGE
                )
            ),
            _react2.default.createElement(
                'div',
                { className: _UpgradeEffectContent2.default.description },
                isMaxLevelReached ? _constants2.MAX_LEVEL_MESSAGE : (0, _constants2.UPGRADE_DESCRIPTION)(reserveName)
            )
        ),
        _react2.default.createElement(
            'div',
            { className: _UpgradeEffectContent2.default.content },
            _react2.default.createElement(
                'div',
                { className: _UpgradeEffectContent2.default.bonusHolder },
                _react2.default.createElement(_BaseBonusInfoTable2.default, {
                    classNames: {
                        title: _UpgradeEffectContent2.default.tableTitle
                    },
                    title: _constants2.RESERVE_TYPE_MESSAGES[reserveType],
                    footer: _translations.FOOTER_RESERVES_NOTES[reserveType],
                    columns: tableColumns,
                    dataSource: dataSource,
                    selectedRow: currentLevel - 1
                })
            )
        )
    );
};

UpgradeEffectContent.propTypes = {
    reserveType: _propTypes2.default.string.isRequired,
    bonus: _propTypes2.default.object.isRequired,
    reserveName: _propTypes2.default.object.isRequired,
    upgradeCosts: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired,
    currentLevel: _propTypes2.default.number.isRequired,
    hasPermission: _propTypes2.default.bool.isRequired
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
    var settings = state.settings,
        slots = state.slots,
        buildings = state.buildings,
        account = state.account;


    var slotId = parseInt(ownProps.slotId);
    var slot = slots[slotId];
    var building = buildings[slot.building];
    var reserveType = settings.buildings[building.type].reserve_type;
    var reserveInfo = settings.reserves[reserveType];

    var upgradeCosts = settings.buildings[building.type].costs;
    var hasPermission = account.permissions.manage_building === true;
    return {
        upgradeCosts: upgradeCosts,
        hasPermission: hasPermission,
        reserveType: reserveType,
        currentLevel: building.level,
        bonus: reserveInfo.bonus,
        reserveName: _i18n.RESERVE_TITLES[reserveInfo.type]
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(UpgradeEffectContent);

/***/ }),
/* 2111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TableRow = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reserves = __webpack_require__(28);

var _TableRow = __webpack_require__(2112);

var _TableRow2 = _interopRequireDefault(_TableRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TableRow = exports.TableRow = function TableRow(_ref) {
    var rowIndex = _ref.rowIndex,
        selectedRow = _ref.selectedRow,
        columns = _ref.columns,
        bonus = _ref.bonus,
        setTableColumnsRefs = _ref.setTableColumnsRefs,
        columnsWidthConfig = _ref.columnsWidthConfig;

    return _react2.default.createElement(
        'div',
        {
            className: (0, _classnames2.default)(_TableRow2.default.tr, rowIndex < selectedRow && _TableRow2.default.tr__previous, rowIndex === selectedRow && _TableRow2.default.tr__selected, rowIndex === selectedRow + 1 && _TableRow2.default.tr__next)
        },
        columns.map(function (column) {
            var dataIndex = column.dataIndex,
                _column$classNames = column.classNames,
                classNames = _column$classNames === undefined ? {} : _column$classNames,
                align = column.align,
                isCalculatedWidth = column.isCalculatedWidth;

            var value = (0, _reserves.getReserveParameterByKey)(bonus, dataIndex);
            return _react2.default.createElement(
                'div',
                {
                    key: dataIndex,
                    className: (0, _classnames2.default)(_TableRow2.default.td, _TableRow2.default.td__right || align && _TableRow2.default['td__' + align], isCalculatedWidth && _TableRow2.default.td__calculatedWidth, classNames.td),
                    ref: function ref(el) {
                        return setTableColumnsRefs(el, dataIndex);
                    },
                    style: { '--cell-width': columnsWidthConfig[dataIndex] + 'px' }
                },
                column.render ? column.render(value) : value
            );
        })
    );
};

TableRow.propTypes = {
    columns: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        title: _propTypes2.default.node.isRequired,
        dataIndex: _propTypes2.default.string.isRequired,
        render: _propTypes2.default.func
    })).isRequired,
    selectedRow: _propTypes2.default.number,
    rowIndex: _propTypes2.default.number.isRequired,
    bonus: _propTypes2.default.object.isRequired,
    setTableColumnsRefs: _propTypes2.default.func.isRequired,
    columnsWidthConfig: _propTypes2.default.object.isRequired
};

exports.default = TableRow;

/***/ }),
/* 2112 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"table":"TableRow_table--3jzmB","thead":"TableRow_thead--ex2Yl","tbody":"TableRow_tbody--3dKmQ","tr":"TableRow_tr--3Q2uj","tr__selected":"TableRow_tr__selected--2IOxt","trSelected":"TableRow_tr__selected--2IOxt","tr__clickable":"TableRow_tr__clickable--1JbyN","trClickable":"TableRow_tr__clickable--1JbyN","tr__hoverable":"TableRow_tr__hoverable--1pMT1","trHoverable":"TableRow_tr__hoverable--1pMT1","th":"TableRow_th--aDawc","td":"TableRow_td--ZSsEj","th__basis":"TableRow_th__basis--14cQD","thBasis":"TableRow_th__basis--14cQD","td__basis":"TableRow_td__basis--WYUvS","tdBasis":"TableRow_td__basis--WYUvS","th__left":"TableRow_th__left--rWjAr","thLeft":"TableRow_th__left--rWjAr","td__left":"TableRow_td__left--28tcU","tdLeft":"TableRow_td__left--28tcU","th__center":"TableRow_th__center--2ZzC9","thCenter":"TableRow_th__center--2ZzC9","td__center":"TableRow_td__center--3wyay","tdCenter":"TableRow_td__center--3wyay","th__right":"TableRow_th__right--3088L","thRight":"TableRow_th__right--3088L","td__right":"TableRow_td__right--2XalF","tdRight":"TableRow_td__right--2XalF","th__top":"TableRow_th__top--2HLAw","thTop":"TableRow_th__top--2HLAw","td__top":"TableRow_td__top--1YKnY","tdTop":"TableRow_td__top--1YKnY","td__span4":"TableRow_td__span4--2EDKM","tdSpan4":"TableRow_td__span4--2EDKM","base__debug":"TableRow_base__debug--2_Mgc","baseDebug":"TableRow_base__debug--2_Mgc","spacer":"TableRow_spacer--3zyZC","td__centerLineAlign":"TableRow_td__centerLineAlign--2KD-a","tdCenterLineAlign":"TableRow_td__centerLineAlign--2KD-a","td__calculatedWidth":"TableRow_td__calculatedWidth--32aeV","tdCalculatedWidth":"TableRow_td__calculatedWidth--32aeV","tr__previous":"TableRow_tr__previous--2EO3b","trPrevious":"TableRow_tr__previous--2EO3b","tr__next":"TableRow_tr__next--30oK7","trNext":"TableRow_tr__next--30oK7"};

/***/ }),
/* 2113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MAX_LEVEL_MESSAGE = exports.UPGRADE_DESCRIPTION = exports.PERMISSIONS_REQUIRED_MESSAGE = exports.UPGRADE_COST_HEADER = exports.RESERVE_LEVEL_HEADER = exports.RESERVE_TYPE_MESSAGES = exports.UPGRADE_EFFECT_POPOVER_ID = undefined;

var _RESERVE_TYPE_MESSAGE;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint-disable react/no-multi-comp */


var UPGRADE_EFFECT_POPOVER_ID = exports.UPGRADE_EFFECT_POPOVER_ID = 'upgrade_effect_popover';

var RESERVE_TYPE_MESSAGES = exports.RESERVE_TYPE_MESSAGES = (_RESERVE_TYPE_MESSAGE = {}, _defineProperty(_RESERVE_TYPE_MESSAGE, _constants.RESERVE_TYPES.BATTLE_PAYMENTS, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'upgrade_effect_popover.reserve_types.battle_payments',
    defaultMessage: '\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u043A\u0440\u0435\u0434\u0438\u0442\u044B'
})), _defineProperty(_RESERVE_TYPE_MESSAGE, _constants.RESERVE_TYPES.MILITARY_MANEUVERS, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'upgrade_effect_popover.reserve_types.military_maneuvers',
    defaultMessage: '\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u0441\u0432\u043E\u0431\u043E\u0434\u043D\u044B\u0439 \u043E\u043F\u044B\u0442'
})), _defineProperty(_RESERVE_TYPE_MESSAGE, _constants.RESERVE_TYPES.TACTICAL_TRAINING, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'upgrade_effect_popover.reserve_types.tactical_training',
    defaultMessage: '\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u0431\u043E\u0435\u0432\u043E\u0439 \u043E\u043F\u044B\u0442'
})), _defineProperty(_RESERVE_TYPE_MESSAGE, _constants.RESERVE_TYPES.ADDITIONAL_BRIEFING, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'upgrade_effect_popover.reserve_types.additional_briefing',
    defaultMessage: '\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u043E\u043F\u044B\u0442 \u044D\u043A\u0438\u043F\u0430\u0436\u0430'
})), _defineProperty(_RESERVE_TYPE_MESSAGE, _constants.RESERVE_TYPES.AIRSTRIKE, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'upgrade_effect_popover.reserve_types.airstrike',
    defaultMessage: '\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u043F\u0440\u043E\u043C\u0440\u0435\u0441\u0443\u0440\u0441 \u043D\u0430 1 \u0431\u043E\u0439'
})), _defineProperty(_RESERVE_TYPE_MESSAGE, _constants.RESERVE_TYPES.ARTILLERY_STRIKE, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'upgrade_effect_popover.reserve_types.artillery_strike',
    defaultMessage: '\u0410\u0440\u0442\u043E\u0431\u0441\u0442\u0440\u0435\u043B \u0432 \u0412\u044B\u043B\u0430\u0437\u043A\u0430\u0445 \u0438 \u043F\u0440\u0438 \u041D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u044F\u0445 \u043D\u0430 1 \u0431\u043E\u0439'
})), _defineProperty(_RESERVE_TYPE_MESSAGE, _constants.RESERVE_TYPES.HIGH_CAPACITY_TRANSPORT, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'upgrade_effect_popover.reserve_types.high_capacity_transport',
    defaultMessage: '\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u043F\u0440\u043E\u043C\u0440\u0435\u0441\u0443\u0440\u0441 \u043D\u0430 1 \u0431\u043E\u0439'
})), _defineProperty(_RESERVE_TYPE_MESSAGE, _constants.RESERVE_TYPES.REQUISITION, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'upgrade_effect_popover.reserve_types.requisition',
    defaultMessage: '\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u043F\u0440\u043E\u043C\u0440\u0435\u0441\u0443\u0440\u0441 \u043D\u0430 1 \u041D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u0435'
})), _defineProperty(_RESERVE_TYPE_MESSAGE, _constants.RESERVE_TYPES.INSPIRATION, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'upgrade_effect_popover.reserve_types.inspiration',
    defaultMessage: '\u0412\u043E\u043E\u0434\u0443\u0448\u0435\u0432\u043B\u0435\u043D\u0438\u0435 \u0432 \u0412\u044B\u043B\u0430\u0437\u043A\u0430\u0445 \u0438 \u043F\u0440\u0438 \u041D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u044F\u0445 \u043D\u0430 1 \u0431\u043E\u0439'
})), _RESERVE_TYPE_MESSAGE);

var RESERVE_LEVEL_HEADER = exports.RESERVE_LEVEL_HEADER = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'upgrade_effect_popover.reserve_level_header',
    defaultMessage: '\u0423\u0440\u043E\u0432\u0435\u043D\u044C \u0440\u0435\u0437\u0435\u0440\u0432\u0430'
});

var UPGRADE_COST_HEADER = exports.UPGRADE_COST_HEADER = function UPGRADE_COST_HEADER(isLineBreakEnabled) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'upgrade_effect_popover.upgrade_cost_header',
        defaultMessage: '\u0421\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C{lineBreak}\u043C\u043E\u0434\u0435\u0440\u043D\u0438\u0437\u0430\u0446\u0438\u0438',
        values: {
            lineBreak: isLineBreakEnabled ? _react2.default.createElement('br', null) : ' '
        }
    });
};

var PERMISSIONS_REQUIRED_MESSAGE = exports.PERMISSIONS_REQUIRED_MESSAGE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'upgrade_effect_popover.permissions_required_message',
    defaultMessage: '\u041C\u043E\u0434\u0435\u0440\u043D\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0441\u0442\u0440\u043E\u0435\u043D\u0438\u0435 \u043C\u043E\u0433\u0443\u0442 \u043A\u043E\u043C\u0430\u043D\u0434\u0443\u044E\u0449\u0438\u0439 \u0438 \u0435\u0433\u043E \u0437\u0430\u043C\u0435\u0441\u0442\u0438\u0442\u0435\u043B\u0438'
});

var UPGRADE_DESCRIPTION = exports.UPGRADE_DESCRIPTION = function UPGRADE_DESCRIPTION(reserve) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'upgrade_effect_popover.upgrade.description',
        defaultMessage: '\u041F\u043E\u0441\u043B\u0435 \u043C\u043E\u0434\u0435\u0440\u043D\u0438\u0437\u0430\u0446\u0438\u0438 \u0441\u0442\u0430\u043D\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430 \u043F\u043E\u0434\u0433\u043E\u0442\u043E\u0432\u043A\u0430 \u0440\u0435\u0437\u0435\u0440\u0432\u0430 \xAB{reserve}\xBB \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0433\u043E \u0443\u0440\u043E\u0432\u043D\u044F.',
        values: {
            reserve: reserve
        }
    });
};

var MAX_LEVEL_MESSAGE = exports.MAX_LEVEL_MESSAGE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'upgrade_effect_popover.max_level_message',
    defaultMessage: '\u0421\u0442\u0440\u043E\u0435\u043D\u0438\u0435 \u043C\u043E\u0434\u0435\u0440\u043D\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u043D\u043E \u0434\u043E \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0443\u0440\u043E\u0432\u043D\u044F'
});

/***/ }),
/* 2114 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"header":"UpgradeEffectContent_header--2Qo3A","title":"UpgradeEffectContent_title--2JCDP","base":"UpgradeEffectContent_base--3djgL","tableTitle":"UpgradeEffectContent_tableTitle--1dOdN","titleText":"UpgradeEffectContent_titleText--2qMF6","description":"UpgradeEffectContent_description--1xhd8","content":"UpgradeEffectContent_content--9B6vM","bonusHolder":"UpgradeEffectContent_bonusHolder--2-gtP","warning":"UpgradeEffectContent_warning--2F0ud"};

/***/ }),
/* 2115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapStateToProps = exports.UpgradeTooltip = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(7);

var _reactWotBootstrap = __webpack_require__(5);

var _LackOfIndustrialResource = __webpack_require__(288);

var _LackOfIndustrialResource2 = _interopRequireDefault(_LackOfIndustrialResource);

var _IndustrialResource = __webpack_require__(35);

var _IndustrialResource2 = _interopRequireDefault(_IndustrialResource);

var _constants = __webpack_require__(2116);

var _UpgradeTooltip = __webpack_require__(2117);

var _UpgradeTooltip2 = _interopRequireDefault(_UpgradeTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UpgradeTooltip = exports.UpgradeTooltip = function UpgradeTooltip(props) {
    var message = _constants.MODERNIZATION_ALLOWED_MESSAGE;

    if (props.strongholdLevel < props.nextLevel) {
        message = _constants.UPGRADE_COMMAND_CENTER;
    } else if (props.reserveProductionInProgress) {
        message = _constants.RESERVE_PRODUCTION_IN_PROGRESS;
    } else if (props.industrialResourceAvailable < props.upgradeCost) {
        var industrialResource = _react2.default.createElement(_IndustrialResource2.default, {
            value: props.upgradeCost - props.industrialResourceAvailable,
            small: true
        });
        message = _react2.default.createElement(_LackOfIndustrialResource2.default, { resource: industrialResource });
    }

    return _react2.default.createElement(
        _reactWotBootstrap.Tooltip,
        { id: props.id },
        _react2.default.createElement(
            'div',
            { className: _UpgradeTooltip2.default.base },
            _react2.default.createElement(
                'div',
                { className: _UpgradeTooltip2.default.message },
                message
            )
        )
    );
};

UpgradeTooltip.propTypes = {
    id: _propTypes2.default.string.isRequired,
    nextLevel: _propTypes2.default.number.isRequired,
    upgradeCost: _propTypes2.default.number.isRequired,
    industrialResourceAvailable: _propTypes2.default.number.isRequired,
    reserveProductionInProgress: _propTypes2.default.bool.isRequired,
    strongholdLevel: _propTypes2.default.number.isRequired
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, _ref) {
    var id = _ref.id,
        building = _ref.building,
        reserve = _ref.reserve;

    var upgradeCost = state.settings.buildings[building.type].costs[building.level];
    var reserveInProduction = state.clanReserves[reserve.type].filter(function (reserve) {
        return reserve.productionEnds !== null;
    }).find(function (reserve) {
        return reserve.productionEnds > Date.now();
    });
    return {
        id: id,
        nextLevel: building.level + 1,
        upgradeCost: upgradeCost,
        industrialResourceAvailable: state.clan.industrial_resource,
        reserveProductionInProgress: reserveInProduction !== undefined,
        strongholdLevel: state.stronghold.level
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(UpgradeTooltip);

/***/ }),
/* 2116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.UPGRADE_COMMAND_CENTER = exports.RESERVE_PRODUCTION_IN_PROGRESS = exports.MODERNIZATION_ALLOWED_MESSAGE = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-multi-comp */
var MODERNIZATION_ALLOWED_MESSAGE = exports.MODERNIZATION_ALLOWED_MESSAGE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'building_upgrade_tooltip.modernization_allowed_message',
    defaultMessage: '\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043C\u043E\u0434\u0435\u0440\u043D\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u0442\u044C.'
});

var RESERVE_PRODUCTION_IN_PROGRESS = exports.RESERVE_PRODUCTION_IN_PROGRESS = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'building_upgrade_tooltip.reserve_production_in_progress',
    defaultMessage: '\u041A\u043E\u043C\u0430\u043D\u0434\u0443\u044E\u0449\u0438\u0439 \u0438 \u0435\u0433\u043E \u0437\u0430\u043C\u0435\u0441\u0442\u0438\u0442\u0435\u043B\u0438 \u0441\u043C\u043E\u0433\u0443\u0442 \u043C\u043E\u0434\u0435\u0440\u043D\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0441\u0442\u0440\u043E\u0435\u043D\u0438\u0435 \u043F\u043E\u0441\u043B\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0432 \u043D\u0451\u043C \u0442\u0435\u043A\u0443\u0449\u0435\u0439 \u043F\u043E\u0434\u0433\u043E\u0442\u043E\u0432\u043A\u0438 \u0440\u0435\u0437\u0435\u0440\u0432\u043E\u0432.' // eslint-disable-line max-len
});

var UPGRADE_COMMAND_CENTER = exports.UPGRADE_COMMAND_CENTER = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'building_upgrade_tooltip.upgrade_command_center',
    defaultMessage: '\u041A\u043E\u043C\u0430\u043D\u0434\u0443\u044E\u0449\u0438\u0439 \u0438 \u0435\u0433\u043E \u0437\u0430\u043C\u0435\u0441\u0442\u0438\u0442\u0435\u043B\u0438 \u0441\u043C\u043E\u0433\u0443\u0442 \u043C\u043E\u0434\u0435\u0440\u043D\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0441\u0442\u0440\u043E\u0435\u043D\u0438\u0435 \u043F\u043E\u0441\u043B\u0435 \u043C\u043E\u0434\u0435\u0440\u043D\u0438\u0437\u0430\u0446\u0438\u0438 \u043A\u043E\u043C\u0430\u043D\u0434\u043D\u043E\u0433\u043E \u0446\u0435\u043D\u0442\u0440\u0430.' // eslint-disable-line max-len
});

/***/ }),
/* 2117 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"UpgradeTooltip_base--FBgXb","body":"UpgradeTooltip_body--1Ue88","wrapper":"UpgradeTooltip_wrapper--1afgZ","background":"UpgradeTooltip_background--tHVrC","content":"UpgradeTooltip_content--1Fds9","title":"UpgradeTooltip_title--2S_qU","message":"UpgradeTooltip_message--8EUSs","divider":"UpgradeTooltip_divider--zA3iP","highlight":"UpgradeTooltip_highlight--ujkkl","ribbon":"UpgradeTooltip_ribbon--1qCj6"};

/***/ }),
/* 2118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(7);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _sounds = __webpack_require__(22);

var _user_flags = __webpack_require__(307);

var _user_flags2 = _interopRequireDefault(_user_flags);

var _ReserveSelect = __webpack_require__(2119);

var _ReserveSelect2 = _interopRequireDefault(_ReserveSelect);

var _constants = __webpack_require__(4);

var _ReserveSelectItem = __webpack_require__(2120);

var _ReserveSelectItem2 = _interopRequireDefault(_ReserveSelectItem);

var _reserve_level_select = __webpack_require__(371);

var _reserves = __webpack_require__(28);

var _reactWotBootstrap = __webpack_require__(5);

var _constants2 = __webpack_require__(2124);

var _datetime = __webpack_require__(13);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

var _TutorialArrow = __webpack_require__(1334);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReserveSelect = function (_React$Component) {
    _inherits(ReserveSelect, _React$Component);

    function ReserveSelect(props) {
        _classCallCheck(this, ReserveSelect);

        var _this = _possibleConstructorReturn(this, (ReserveSelect.__proto__ || Object.getPrototypeOf(ReserveSelect)).call(this, props));

        _this.handleMediaQueryChange = function (event) {
            var mediumScreen = event.matches;

            if (_this.state.mediumScreen !== mediumScreen) {
                _this.setState({ mediumScreen: mediumScreen });
            }
        };

        _this.state = {
            opened: false,
            reservesQueueByLevel: {},
            mediumScreen: window.matchMedia(_constants.MEDIA_QUERIES.MEDIUM).matches
        };
        _this.onKeyUp = _this.onKeyUp.bind(_this);
        _this.handleClickaway = _this.handleClickaway.bind(_this);
        return _this;
    }

    _createClass(ReserveSelect, [{
        key: 'update',
        value: function update() {
            var _this2 = this;

            var reserves = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.reserves;

            clearTimeout(this.timeoutId);

            this.setState({
                reservesQueueByLevel: (0, _reserves.getReservesQueueByLevel)(reserves)
            });

            var reserve = (0, _reserves.getSortedProductionReserves)(reserves).find(function (reserve) {
                return reserve.productionEnds > Date.now();
            });

            if (reserve) {
                this.timeoutId = setTimeout(function () {
                    _this2.update();
                }, reserve.productionEnds - Date.now());
            }
        }
    }, {
        key: 'onKeyUp',
        value: function onKeyUp(e) {
            if (e.keyCode === _constants.KEY_CODES.ESCAPE && this.state.opened) {
                e.stopImmediatePropagation();
                this.setState({ opened: false });
            }
        }
    }, {
        key: 'handleClickaway',
        value: function handleClickaway(e) {
            if (this.refs.popup && !this.refs.popup.contains(e.target) && !this.refs.bar.contains(e.target)) {
                this.setState({ opened: false });
            }
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.update();
            window.addEventListener('keydown', this.onKeyUp, true);
            window.addEventListener('mousedown', this.handleClickaway);
            window.matchMedia(_constants.MEDIA_QUERIES.MEDIUM).addEventListener('change', this.handleMediaQueryChange);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('keydown', this.onKeyUp, true);
            window.removeEventListener('mousedown', this.handleClickaway);
            window.matchMedia(_constants.MEDIA_QUERIES.MEDIUM).removeEventListener('change', this.handleMediaQueryChange);
            clearTimeout(this.timeoutId);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref) {
            var reserves = _ref.reserves;

            this.update(reserves);
        }
    }, {
        key: 'render',
        value: function render() {
            var _cx,
                _this3 = this;

            var _props = this.props,
                building = _props.building,
                buildingUpgrade = _props.buildingUpgrade,
                reserveInfo = _props.reserveInfo,
                reserves = _props.reserves,
                selectedLevel = _props.selectedLevel;
            var _state = this.state,
                opened = _state.opened,
                reservesQueueByLevel = _state.reservesQueueByLevel;

            var advanced = building.level > 1;

            var className = (0, _classnames2.default)(_ReserveSelect2.default.bar, (_cx = {}, _defineProperty(_cx, _ReserveSelect2.default.bar__advanced, advanced), _defineProperty(_cx, _ReserveSelect2.default.bar__opened, opened), _defineProperty(_cx, _ReserveSelect2.default.bar__queue, advanced && Boolean(reservesQueueByLevel[selectedLevel])), _cx));

            var allReservesByLevel = (0, _reserves.groupReservesByLevel)(reserves.filter(_reserves.isReserveVisible));
            var reservesByLevel = {};
            for (var level = 1; level < building.level + 1; level++) {
                reservesByLevel[level] = allReservesByLevel[level] || [];
            }
            var orderedLevels = Object.keys(reservesByLevel).map(function (level) {
                return parseInt(level);
            }).sort(function (a, b) {
                return b - a;
            });

            var sortedProductionReserves = (0, _reserves.getSortedProductionReserves)(reserves);
            var lastReserve = sortedProductionReserves[sortedProductionReserves.length - 1];

            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                lastReserve && _react2.default.createElement(
                    'div',
                    { className: _ReserveSelect2.default.reserveQueueEnd },
                    (0, _constants2.ALL_RESERVE_QUEUES_END)(_react2.default.createElement(
                        'span',
                        { className: _ReserveSelect2.default.highlight },
                        (0, _datetime.getEndDateMessage)((0, _moment2.default)(lastReserve.productionEnds))
                    ))
                ),
                _react2.default.createElement(
                    'div',
                    { className: _ReserveSelect2.default.base },
                    _react2.default.createElement(
                        'div',
                        {
                            ref: 'bar',
                            className: className,
                            onMouseEnter: function onMouseEnter() {
                                advanced && _this3.props.playHoverSound();
                            },
                            onClick: function onClick() {
                                if (advanced) {
                                    _this3.props.playButtonClickSound();
                                    _this3.setState({ opened: !opened });
                                }

                                if (_this3.props.tutorialVisible) {
                                    _this3.props.submitUserFlag(_constants.USER_FLAGS.LOW_LEVEL_RESERVES_VISITED);
                                }
                            }
                        },
                        _react2.default.createElement(
                            _ReserveSelectItem2.default,
                            {
                                level: buildingUpgrade.highlighted ? building.level : selectedLevel,
                                reserveInfo: reserveInfo,
                                reserves: reserves,
                                highlighted: buildingUpgrade.highlighted,
                                playSound: this.props.playOneReserveProduceSuccessSound,
                                reservesQueueInfo: advanced ? reservesQueueByLevel[selectedLevel] : undefined
                            },
                            _react2.default.createElement('div', { className: _ReserveSelect2.default.holder }),
                            _react2.default.createElement(
                                'div',
                                {
                                    className: (0, _classnames2.default)(_ReserveSelect2.default.tutorialWrapper, this.props.tutorialVisible && _ReserveSelect2.default.tutorialWrapper__active)
                                },
                                _react2.default.createElement('div', { className: _ReserveSelect2.default.arrow }),
                                _react2.default.createElement(_TutorialArrow.TutorialArrow, {
                                    isHidden: !this.props.tutorialVisible,
                                    showBorder: false,
                                    arrowPosition: 'top',
                                    text: _constants2.TUTORIAL_TEXT
                                })
                            )
                        )
                    ),
                    opened && _react2.default.createElement(
                        'div',
                        { ref: 'popup', className: _ReserveSelect2.default.popup },
                        _react2.default.createElement(
                            _reactWotBootstrap.ScrollArea,
                            {
                                scrollableAreaHeight: this.state.mediumScreen ? 360 : 280,
                                modifier: 'toolbar'
                            },
                            orderedLevels.map(function (level) {
                                return _react2.default.createElement(
                                    'div',
                                    {
                                        key: 'reserves_of_' + level + '_level',
                                        className: (0, _classnames2.default)(_ReserveSelect2.default.row, reservesQueueByLevel[level] && _ReserveSelect2.default.row__queue),
                                        onMouseEnter: function onMouseEnter() {
                                            _this3.props.playHoverSound();
                                        },
                                        onClick: function onClick() {
                                            _this3.props.playTabClickSound();
                                            _this3.props.changeSelectedLevel(level);
                                            _this3.setState({ opened: false });
                                        }
                                    },
                                    _react2.default.createElement(
                                        _ReserveSelectItem2.default,
                                        {
                                            level: level,
                                            reserveInfo: reserveInfo,
                                            reserves: reservesByLevel[level],
                                            highlighted: false,
                                            reservesQueueInfo: reservesQueueByLevel[level]
                                        },
                                        _react2.default.createElement('div', { className: _ReserveSelect2.default.holder })
                                    )
                                );
                            })
                        )
                    )
                )
            );
        }
    }]);

    return ReserveSelect;
}(_react2.default.Component);

ReserveSelect.propTypes = {
    building: _propTypes2.default.object.isRequired,
    buildingUpgrade: _propTypes2.default.shape({
        highlighted: _propTypes2.default.bool.isRequired
    }).isRequired,
    reserveInfo: _propTypes2.default.object.isRequired,
    reserves: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
    selectedLevel: _propTypes2.default.number.isRequired,
    tutorialVisible: _propTypes2.default.bool.isRequired,
    changeSelectedLevel: _propTypes2.default.func.isRequired,
    submitUserFlag: _propTypes2.default.func.isRequired,
    playOneReserveProduceSuccessSound: _propTypes2.default.func.isRequired,
    playHoverSound: _propTypes2.default.func.isRequired,
    playButtonClickSound: _propTypes2.default.func.isRequired,
    playTabClickSound: _propTypes2.default.func.isRequired
};
var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, _ref2) {
    var buildingId = _ref2.buildingId;
    var buildings = state.buildings,
        buildingUpgrade = state.buildingUpgrade,
        clanReserves = state.clanReserves,
        reserveLevelSelect = state.reserveLevelSelect,
        settings = state.settings;


    var building = buildings[buildingId];
    var reserveType = settings.buildings[building.type].reserve_type;

    return {
        building: building,
        buildingUpgrade: buildingUpgrade,
        reserveInfo: settings.reserves[reserveType],
        reserves: clanReserves[reserveType],
        selectedLevel: reserveLevelSelect.selectedLevel,
        tutorialVisible: !state.userFlags[_constants.USER_FLAGS.LOW_LEVEL_RESERVES_VISITED] && building.level > 1
    };
};

var mapDispatchToProps = exports.mapDispatchToProps = {
    changeSelectedLevel: _reserve_level_select.changeSelectedLevel,
    submitUserFlag: _user_flags2.default,
    playOneReserveProduceSuccessSound: _sounds.playOneReserveProduceSuccessSound,
    playHoverSound: _sounds.playHoverSound,
    playButtonClickSound: _sounds.playButtonClickSound,
    playTabClickSound: _sounds.playTabClickSound
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ReserveSelect);

/***/ }),
/* 2119 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"reserveQueueEnd":"ReserveSelect_reserveQueueEnd--3_etC","highlight":"ReserveSelect_highlight--3kZpb","base":"ReserveSelect_base--29Qhn","bar":"ReserveSelect_bar--2Np1h","bar__advanced":"ReserveSelect_bar__advanced--3n5tc","barAdvanced":"ReserveSelect_bar__advanced--3n5tc","bar__queue":"ReserveSelect_bar__queue--2BaqH","barQueue":"ReserveSelect_bar__queue--2BaqH","tutorialWrapper":"ReserveSelect_tutorialWrapper--20x7e","tutorialWrapper__active":"ReserveSelect_tutorialWrapper__active--afQca","tutorialWrapperActive":"ReserveSelect_tutorialWrapper__active--afQca","arrow":"ReserveSelect_arrow--3GwtA","bar__opened":"ReserveSelect_bar__opened--L5MsA","barOpened":"ReserveSelect_bar__opened--L5MsA","popup":"ReserveSelect_popup--2RpaD","show":"ReserveSelect_show--HXdDi","row":"ReserveSelect_row--1kSoQ","row__queue":"ReserveSelect_row__queue--ZV5vM","rowQueue":"ReserveSelect_row__queue--ZV5vM","holder":"ReserveSelect_holder--3HAcv"};

/***/ }),
/* 2120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ReserveBonus = __webpack_require__(204);

var _ReserveBonus2 = _interopRequireDefault(_ReserveBonus);

var _Reserve = __webpack_require__(289);

var _Reserve2 = _interopRequireDefault(_Reserve);

var _constants = __webpack_require__(4);

var _ReserveSelectItem = __webpack_require__(2122);

var _ReserveSelectItem2 = _interopRequireDefault(_ReserveSelectItem);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants2 = __webpack_require__(2123);

var _datetime = __webpack_require__(13);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReserveSelectItem = function ReserveSelectItem(props) {
    var nextLevel = props.level < _constants.MAX_BUILDING_LEVEL ? props.level + 1 : props.level;

    return _react2.default.createElement(
        'div',
        { className: _ReserveSelectItem2.default.base },
        _react2.default.createElement(
            'div',
            { className: _ReserveSelectItem2.default.reserveWrapper },
            _react2.default.createElement(
                'div',
                { className: _ReserveSelectItem2.default.reserve },
                _react2.default.createElement(_Reserve2.default, {
                    type: props.reserveInfo.type,
                    level: props.highlighted ? nextLevel : props.level,
                    reserves: props.reserves,
                    highlighted: props.highlighted,
                    playSound: props.playSound || null
                })
            ),
            _react2.default.createElement(
                'div',
                { className: _ReserveSelectItem2.default.content },
                _react2.default.createElement(_ReserveBonus2.default, {
                    reserveInfo: props.reserveInfo,
                    level: props.level,
                    nextLevel: nextLevel,
                    isNextLevelHighlighted: props.highlighted,
                    layoutType: 'tooltip'
                })
            ),
            props.children
        ),
        props.reservesQueueInfo && _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement('div', { className: _ReserveSelectItem2.default.divider }),
            props.reservesQueueInfo.order === 0 ? _react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)(_ReserveSelectItem2.default.status, _ReserveSelectItem2.default.status__inProgress) },
                (0, _constants2.RESERVE_IN_PROGRESS)((0, _datetime.getEndDateMessage)((0, _moment2.default)(props.reservesQueueInfo.productionEnds)))
            ) : _react2.default.createElement(
                'div',
                { className: _ReserveSelectItem2.default.status },
                (0, _constants2.RESERVE_DELAYED)(_react2.default.createElement(
                    'span',
                    { className: _ReserveSelectItem2.default.highlighted },
                    props.reservesQueueInfo.order
                ), _react2.default.createElement(
                    'span',
                    { className: _ReserveSelectItem2.default.highlighted },
                    (0, _datetime.getEndDateMessage)((0, _moment2.default)(props.reservesQueueInfo.productionEnds))
                ))
            )
        )
    );
};

ReserveSelectItem.propTypes = {
    reserveInfo: _propTypes2.default.object.isRequired,
    level: _propTypes2.default.number.isRequired,
    reserves: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
    highlighted: _propTypes2.default.bool.isRequired,
    children: _propTypes2.default.node,
    reservesQueueInfo: _propTypes2.default.object,
    playSound: _propTypes2.default.func
};

exports.default = ReserveSelectItem;

/***/ }),
/* 2121 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Reserve_base--PVL3l","base__toolbar":"Reserve_base__toolbar--1fRy1","baseToolbar":"Reserve_base__toolbar--1fRy1","level":"Reserve_level--3H_my","level-gradient":"Reserve_level-gradient--3B8wF","levelGradient":"Reserve_level-gradient--3B8wF","base__clanLanding":"Reserve_base__clanLanding--39uJP","baseClanLanding":"Reserve_base__clanLanding--39uJP","counter":"Reserve_counter--ArTjg","base__highlighted":"Reserve_base__highlighted--19fNJ","baseHighlighted":"Reserve_base__highlighted--19fNJ","counter-gradient":"Reserve_counter-gradient--xvnSh","counterGradient":"Reserve_counter-gradient--xvnSh","thumbnail":"Reserve_thumbnail--2B0P_","image":"Reserve_image--3DEFh","image__military-maneuvers":"Reserve_image__military-maneuvers--QgOHx","imageMilitaryManeuvers":"Reserve_image__military-maneuvers--QgOHx","image__elite":"Reserve_image__elite--1Z8l5","imageElite":"Reserve_image__elite--1Z8l5","image__additional-briefing":"Reserve_image__additional-briefing--YkJEZ","imageAdditionalBriefing":"Reserve_image__additional-briefing--YkJEZ","image__battle-payments":"Reserve_image__battle-payments--1BbEB","imageBattlePayments":"Reserve_image__battle-payments--1BbEB","image__tactical-training":"Reserve_image__tactical-training--2buZD","imageTacticalTraining":"Reserve_image__tactical-training--2buZD","image__artillery-strike":"Reserve_image__artillery-strike--1OLYF","imageArtilleryStrike":"Reserve_image__artillery-strike--1OLYF","image__airstrike":"Reserve_image__airstrike--3yY1n","imageAirstrike":"Reserve_image__airstrike--3yY1n","image__requisition":"Reserve_image__requisition--Zosad","imageRequisition":"Reserve_image__requisition--Zosad","image__high-capacity-transport":"Reserve_image__high-capacity-transport--PeiCR","imageHighCapacityTransport":"Reserve_image__high-capacity-transport--PeiCR","image__inspiration":"Reserve_image__inspiration--3wui4","imageInspiration":"Reserve_image__inspiration--3wui4","image__clanLanding":"Reserve_image__clanLanding--an6m7","imageClanLanding":"Reserve_image__clanLanding--an6m7"};

/***/ }),
/* 2122 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"ReserveSelectItem_base--26lqf","reserveWrapper":"ReserveSelectItem_reserveWrapper--1ZmKr","content":"ReserveSelectItem_content--1hwl5","reserve":"ReserveSelectItem_reserve--iyVNj","divider":"ReserveSelectItem_divider--1Mkcd","highlighted":"ReserveSelectItem_highlighted--3sU_i","status":"ReserveSelectItem_status--2r2o9","status__inProgress":"ReserveSelectItem_status__inProgress--_OhOQ","statusInProgress":"ReserveSelectItem_status__inProgress--_OhOQ"};

/***/ }),
/* 2123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RESERVE_DELAYED = exports.RESERVE_IN_PROGRESS = undefined;

var _reactIntl = __webpack_require__(3);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-multi-comp, max-lines, max-len */
var RESERVE_IN_PROGRESS = exports.RESERVE_IN_PROGRESS = function RESERVE_IN_PROGRESS(timeNode) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'reserve_select_item.status.in_progress',
        defaultMessage: 'In progress (will be ready: {timeNode})',
        values: {
            timeNode: timeNode
        }
    });
};

var RESERVE_DELAYED = exports.RESERVE_DELAYED = function RESERVE_DELAYED(order, timeNode) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'reserve_select_item.status.delayed',
        defaultMessage: 'In queue: {order} (will be ready: {timeNode})',
        values: {
            order: order,
            timeNode: timeNode
        }
    });
};

/***/ }),
/* 2124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TUTORIAL_TEXT = exports.ALL_RESERVE_QUEUES_END = undefined;

var _reactIntl = __webpack_require__(3);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ALL_RESERVE_QUEUES_END = exports.ALL_RESERVE_QUEUES_END = function ALL_RESERVE_QUEUES_END(timeNode) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'reserve_select.status.delayed',
        defaultMessage: 'Reserves of all levels will be ready: {timeNode}',
        values: {
            timeNode: timeNode
        }
    });
};

var TUTORIAL_TEXT = exports.TUTORIAL_TEXT = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'reserve_select.tutorial_text',
    defaultMessage: 'SELECT RESERVE{lineBreak}LEVEL',
    values: {
        lineBreak: _react2.default.createElement('br', null)
    }
});

/***/ }),
/* 2125 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"TutorialArrow_base--2RcHZ","border":"TutorialArrow_border--1PGn3","hint":"TutorialArrow_hint--1gbVc","base__left":"TutorialArrow_base__left--1bJFJ","baseLeft":"TutorialArrow_base__left--1bJFJ","base__right":"TutorialArrow_base__right--2bwk_","baseRight":"TutorialArrow_base__right--2bwk_","base__top":"TutorialArrow_base__top--1S0pF","baseTop":"TutorialArrow_base__top--1S0pF","hintSubstrate":"TutorialArrow_hintSubstrate--2futU","hintArrow":"TutorialArrow_hintArrow--3vJpl","blinkFromLeft":"TutorialArrow_blinkFromLeft--1Kq-C","blinkFromRight":"TutorialArrow_blinkFromRight--25OgF","blinkFromTop":"TutorialArrow_blinkFromTop--2wBYF","hintText":"TutorialArrow_hintText--3pXvG"};

/***/ }),
/* 2126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var UPGRADE_TOOLTIP_ID = exports.UPGRADE_TOOLTIP_ID = 'building_card.upgrade_tooltip';

/***/ }),
/* 2127 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"header":"BuildingCard_header--1kFdm","title":"BuildingCard_title--1c1Wv","base":"BuildingCard_base--3CYu0","grid":"BuildingCard_grid--9eIzE","cell":"BuildingCard_cell--1RxIN","overlay":"BuildingCard_overlay--2VWzZ","overlay__enabled":"BuildingCard_overlay__enabled--tT5Vq","overlayEnabled":"BuildingCard_overlay__enabled--tT5Vq","main":"BuildingCard_main--dmQtj","wrapper":"BuildingCard_wrapper--16rye","holder":"BuildingCard_holder--1npDK","arrow":"BuildingCard_arrow--1YTIB","arrow__left":"BuildingCard_arrow__left--H_61F","arrowLeft":"BuildingCard_arrow__left--H_61F","arrow__right":"BuildingCard_arrow__right--1twG0","arrowRight":"BuildingCard_arrow__right--1twG0","level":"BuildingCard_level--3_ccf","levelShadow":"BuildingCard_levelShadow--2yLo0","reserve":"BuildingCard_reserve--18Ocq","heading":"BuildingCard_heading--27wM5","reserveDescription":"BuildingCard_reserveDescription--n4zye","produce":"BuildingCard_produce--JMvqd","overlayTitleIcon":"BuildingCard_overlayTitleIcon--38gRU","informationIcon":"BuildingCard_informationIcon--2zUo6","cell__centred":"BuildingCard_cell__centred--VA7QK","cellCentred":"BuildingCard_cell__centred--VA7QK"};

/***/ }),
/* 2128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = exports.BuildingsCarousel = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(7);

var _reactRouterRedux = __webpack_require__(15);

var _helpers = __webpack_require__(11);

var _i18n = __webpack_require__(10);

var _ProductionProgress = __webpack_require__(1329);

var _ProductionProgress2 = _interopRequireDefault(_ProductionProgress);

var _KineticScrolling = __webpack_require__(2129);

var _KineticScrolling2 = _interopRequireDefault(_KineticScrolling);

var _sounds = __webpack_require__(22);

var _urls = __webpack_require__(19);

var _constants = __webpack_require__(4);

var _constants2 = __webpack_require__(1336);

var _BuildingsCarousel = __webpack_require__(2132);

var _BuildingsCarousel2 = _interopRequireDefault(_BuildingsCarousel);

var _reserves = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var COMMAND_CENTER = 'COMMAND_CENTER';

var BuildingsCarousel = exports.BuildingsCarousel = function (_React$Component) {
    _inherits(BuildingsCarousel, _React$Component);

    function BuildingsCarousel() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, BuildingsCarousel);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BuildingsCarousel.__proto__ || Object.getPrototypeOf(BuildingsCarousel)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            dragging: false
        }, _this.trackCarouselState = function (_ref2) {
            var dragging = _ref2.dragging;

            _this.setState({ dragging: dragging });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(BuildingsCarousel, [{
        key: 'getBuildingsList',
        value: function getBuildingsList() {
            var _this2 = this;

            var buildingsList = this.props.buildings.map(function (building) {
                var isActive = building.id === _this2.props.selectedBuildingId;
                var imageClassName = (0, _classnames2.default)(_BuildingsCarousel2.default.image, _BuildingsCarousel2.default['image__' + (0, _helpers.toCssClass)(building.type)], _BuildingsCarousel2.default['image__level-' + building.level]);
                var progressBar = void 0;
                if (building.reserveType) {
                    progressBar = _react2.default.createElement(
                        'div',
                        { className: _BuildingsCarousel2.default.progress },
                        _react2.default.createElement(_ProductionProgress2.default, {
                            reserveQueue: building.reserveQueue,
                            simplified: true
                        })
                    );
                }

                var handleClick = function handleClick() {
                    _this2.props.playCarouselClickSound();
                    _this2.props.pushState((0, _urls.BUILDING)(building.id));
                };

                var handleHover = function handleHover() {
                    return _this2.props.playCarouselHoverSound();
                };

                var itemClassName = (0, _classnames2.default)(_BuildingsCarousel2.default.item, _defineProperty({}, _BuildingsCarousel2.default.item__active, isActive));

                var buildingTitle = building.type === COMMAND_CENTER ? _i18n.COMMAND_CENTER_TITLE : _i18n.BUILDING_TITLES[building.type];

                var buildingTooltipId = building.type === COMMAND_CENTER ? _constants.CAROUSEL_COMMAND_CENTER_TOOLTIP_ID : _constants.CAROUSEL_BUILDING_TOOLTIP_ID + '_' + building.type;

                return _react2.default.createElement(
                    'div',
                    {
                        className: itemClassName,
                        key: 'buildingItem__' + building.id,
                        onClick: _this2.state.dragging || isActive ? null : handleClick,
                        onMouseEnter: handleHover,
                        'data-tip': true,
                        'data-for': buildingTooltipId
                    },
                    _react2.default.createElement('div', { className: _BuildingsCarousel2.default.background }),
                    _react2.default.createElement('div', { className: _BuildingsCarousel2.default.overlay }),
                    progressBar,
                    _react2.default.createElement(
                        'div',
                        { className: _BuildingsCarousel2.default.content },
                        _react2.default.createElement(
                            'span',
                            { className: _BuildingsCarousel2.default.level },
                            (0, _helpers.toRoman)(building.level)
                        ),
                        _react2.default.createElement('div', { className: imageClassName }),
                        _react2.default.createElement(
                            'p',
                            { className: _BuildingsCarousel2.default.title },
                            buildingTitle
                        )
                    )
                );
            });

            return buildingsList;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var emptyItemsCount = _constants2.MAX_BUILDINGS_COUNT - this.props.buildings.length;
            var emptySlots = Array.from({ length: emptyItemsCount }, function (item, index) {
                var className = (0, _classnames2.default)(_BuildingsCarousel2.default.item, _BuildingsCarousel2.default.item__empty);
                return _react2.default.createElement(
                    'div',
                    { className: className, key: 'emptyItem__' + index },
                    _react2.default.createElement('div', { className: _BuildingsCarousel2.default.background })
                );
            });
            var activeItemIdx = this.props.buildings.findIndex(function (building) {
                return building.id === _this3.props.selectedBuildingId;
            });
            return _react2.default.createElement(
                'div',
                { className: _BuildingsCarousel2.default.base },
                _react2.default.createElement(
                    _KineticScrolling2.default,
                    {
                        snap: _constants2.CAROUSEL_ITEM_WIDTH,
                        activeItemIdx: activeItemIdx,
                        trackState: this.trackCarouselState
                    },
                    this.getBuildingsList(),
                    emptySlots
                )
            );
        }
    }]);

    return BuildingsCarousel;
}(_react2.default.Component);

BuildingsCarousel.propTypes = {
    buildings: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
        type: _propTypes2.default.string.isRequired,
        level: _propTypes2.default.number.isRequired,
        reserveType: _propTypes2.default.string,
        reserveQueue: _propTypes2.default.arrayOf(_propTypes2.default.object)
    })).isRequired,
    selectedBuildingId: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
    playCarouselClickSound: _propTypes2.default.func.isRequired,
    playCarouselHoverSound: _propTypes2.default.func.isRequired,
    pushState: _propTypes2.default.func.isRequired
};
var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, _ref3) {
    var selectedBuildingId = _ref3.selectedBuildingId;
    var settings = state.settings,
        stronghold = state.stronghold;

    var commandCenter = {
        id: _constants.COMMAND_CENTER_ID,
        type: COMMAND_CENTER,
        level: stronghold.level
    };
    var buildings = Object.keys(state.buildings).map(function (buildingId) {
        var _state$buildings$buil = state.buildings[buildingId],
            id = _state$buildings$buil.id,
            type = _state$buildings$buil.type,
            level = _state$buildings$buil.level;

        var reserveType = settings.buildings[type].reserve_type;
        var reserveQueue = (0, _reserves.getSortedProductionReserves)(state.clanReserves[reserveType]);
        return { id: id, type: type, level: level, reserveType: reserveType, reserveQueue: reserveQueue };
    });
    buildings = [commandCenter].concat(_toConsumableArray(buildings));

    return {
        buildings: buildings,
        selectedBuildingId: selectedBuildingId
    };
};

var mapDispatchToProps = exports.mapDispatchToProps = {
    playCarouselClickSound: _sounds.playCarouselClickSound,
    playCarouselHoverSound: _sounds.playCarouselHoverSound,
    pushState: _reactRouterRedux.push
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BuildingsCarousel);

/***/ }),
/* 2129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _NavigationArrow = __webpack_require__(59);

var _NavigationArrow2 = _interopRequireDefault(_NavigationArrow);

var _constants = __webpack_require__(1336);

var _constants2 = __webpack_require__(2130);

var _KineticScrolling = __webpack_require__(2131);

var _KineticScrolling2 = _interopRequireDefault(_KineticScrolling);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KineticScrolling = function (_React$Component) {
    _inherits(KineticScrolling, _React$Component);

    function KineticScrolling(props) {
        _classCallCheck(this, KineticScrolling);

        var _this = _possibleConstructorReturn(this, (KineticScrolling.__proto__ || Object.getPrototypeOf(KineticScrolling)).call(this, props));

        _this.state = {
            showArrows: false,
            visibleItems: _this.countVisibleItems(),
            pressed: false,
            reference: null,
            offset: 0,
            min: 0,
            max: 0,
            dragging: false
        };

        _this.prev = _this.prev.bind(_this);
        _this.next = _this.next.bind(_this);

        _this.handleTap = _this.handleTap.bind(_this);
        _this.handleDrag = _this.handleDrag.bind(_this);
        _this.handleRelease = _this.handleRelease.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        _this.handleWheel = _this.handleWheel.bind(_this);
        _this.handleResize = _this.handleResize.bind(_this);

        _this.countVisibleItems = _this.countVisibleItems.bind(_this);
        return _this;
    }

    _createClass(KineticScrolling, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.update();
            if (this.props.activeItemIdx >= this.state.visibleItems) {
                setTimeout(function () {
                    return _this2.scrollToItem(_this2.props.activeItemIdx);
                }, 300);
            }
            window.addEventListener('resize', this.handleResize);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('resize', this.handleResize);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(newProps) {
            if (newProps.activeItemIdx !== this.props.activeItemIdx) {
                var newOffset = newProps.activeItemIdx * this.props.snap;
                var maxVisibleOffsetDifference = this.state.visibleItems * this.props.snap;
                var scrollToLeft = newOffset - this.state.offset <= 0;
                var scrollToRight = newOffset - this.state.offset >= maxVisibleOffsetDifference;

                if (scrollToLeft || scrollToRight) {
                    this.scrollToItem(newProps.activeItemIdx);
                }
            }
        }
    }, {
        key: 'setMaxTransform',
        value: function setMaxTransform() {
            var max = this._view.offsetWidth - this._holder.offsetWidth;
            this.setState({ max: max });
        }
    }, {
        key: 'update',
        value: function update() {
            this.setMaxTransform();
            this.setState({
                visibleItems: this.countVisibleItems(),
                showArrows: this._view.offsetWidth > this._holder.offsetWidth
            });

            var boundAutoscroll = this.autoScroll.bind(this);
            requestAnimationFrame(boundAutoscroll);
        }
    }, {
        key: 'pos',
        value: function pos(e) {
            // touch event
            var clientPos = 'clientX';
            if (e.targetTouches && e.targetTouches.length >= 1) {
                return e.targetTouches[0][clientPos];
            }

            // mouse event
            return e[clientPos];
        }
    }, {
        key: 'scroll',
        value: function scroll(x) {
            var _state = this.state,
                min = _state.min,
                max = _state.max;

            var offset = x > max ? max : null;
            if (!offset) {
                offset = x < min ? min : x;
            }

            this.setState({ offset: offset });
            this.trackState();
        }
    }, {
        key: 'track',
        value: function track() {
            var now = Date.now();
            var elapsed = now - this.state.timestamp;
            this.setState({
                timestamp: now
            });
            var delta = this.state.offset - this.state.frame;
            var v = 1000 * delta / (1 + elapsed);

            this.setState({
                frame: this.state.offset,
                velocity: 0.8 * v + 0.2 * this.state.velocity
            });
        }
    }, {
        key: 'autoScroll',
        value: function autoScroll() {
            var elapsed = void 0;
            var delta = void 0;

            if (this.state.amplitude) {
                elapsed = Date.now() - this.state.timestamp;
                delta = -this.state.amplitude * Math.exp(-elapsed / _constants2.TIME_CONSTANT);
                if (delta > 5 || delta < -5) {
                    this.scroll(this.state.target + delta);
                    var boundAutoscroll = this.autoScroll.bind(this);
                    requestAnimationFrame(boundAutoscroll);
                } else {
                    this.scroll(this.state.target);
                }
            }
        }

        // Public methods

    }, {
        key: 'scrollToItem',
        value: function scrollToItem(idx) {
            if (this.props.snap) {
                var target = idx * this.props.snap;
                var amplitude = target - this.state.offset;

                this.setState({
                    target: target,
                    amplitude: amplitude,
                    timestamp: Date.now(),
                    enableTransitions: true
                });

                this.scroll(target);
            }
        }
    }, {
        key: 'prev',
        value: function prev() {
            if (this.props.snap) {
                this.scrollToItem(this.current() - 1);
            }
        }
    }, {
        key: 'next',
        value: function next() {
            if (this.props.snap) {
                this.scrollToItem(this.current() + 1);
            }
        }
    }, {
        key: 'current',
        value: function current() {
            var current = void 0;
            if (this.state.offset === 0) {
                current = 0;
            } else {
                current = Math.round(this.state.offset / this.props.snap);
            }
            return current;
        }
    }, {
        key: 'atBegin',
        value: function atBegin() {
            return this.state.offset === 0;
        }
    }, {
        key: 'atEnd',
        value: function atEnd() {
            return this.state.offset === this.state.max;
        }

        // Events handlers

    }, {
        key: 'handleTap',
        value: function handleTap(e) {
            this.setState({
                pressed: true,
                reference: this.pos(e),
                velocity: 0,
                amplitude: 0,
                timestamp: Date.now(),
                frame: this.state.offset
            });

            clearInterval(this.ticker);
            var boundTrack = this.track.bind(this);
            this.ticker = setInterval(boundTrack, 100);

            this.trackState();

            window.addEventListener('mousemove', this.handleDrag);
            window.addEventListener('mouseup', this.handleRelease);

            e.preventDefault();
            e.stopPropagation();
            return false;
        }
    }, {
        key: 'handleDrag',
        value: function handleDrag(e) {
            var x = void 0;
            var delta = void 0;

            if (this.state.pressed) {
                x = this.pos(e);
                delta = this.state.reference - x;

                if (delta > 2 || delta < -2) {
                    this.setState({
                        reference: x,
                        dragging: true,
                        enableTransitions: false
                    });

                    this.scroll(this.state.offset + delta);
                }
            }

            e.preventDefault();
            e.stopPropagation();
            return false;
        }
    }, {
        key: 'handleRelease',
        value: function handleRelease(e) {
            window.removeEventListener('mousemove', this.handleDrag);
            window.removeEventListener('mouseup', this.handleRelease);

            this.setState({
                pressed: false
            });

            clearInterval(this.ticker);

            if (!this.state.dragging) return;

            var amplitude = void 0;
            var target = this.state.offset;

            if (this.state.velocity > 10 || this.state.velocity < -10) {
                amplitude = 0.2 * this.state.velocity;
                target = Math.round(this.state.offset + amplitude);
            }

            target = Math.round(target / this.props.snap) * this.props.snap;
            amplitude = target - this.state.offset;

            this.setState({
                target: target,
                amplitude: amplitude,
                timestamp: Date.now()
            });

            var boundAutoscroll = this.autoScroll.bind(this);
            requestAnimationFrame(boundAutoscroll);
            if (!e.currentTarget.getAttribute || e.currentTarget.getAttribute('id') !== this._view.id) {
                this.setState({
                    dragging: false
                });
            }
        }
    }, {
        key: 'handleWheel',
        value: function handleWheel(e) {
            var target = this.state.offset + e.deltaY;

            if (this.props.snap) {
                if (e.deltaY > 0) {
                    target = (this.current() + 1) * this.props.snap;
                } else {
                    target = (this.current() - 1) * this.props.snap;
                }
            }
            var amplitude = target - this.state.offset;

            this.setState({
                target: target,
                amplitude: amplitude,
                timestamp: Date.now(),
                enableTransitions: false
            });

            var boundAutoscroll = this.autoScroll.bind(this);
            requestAnimationFrame(boundAutoscroll);
        }
    }, {
        key: 'handleClick',
        value: function handleClick() {
            this.setState({
                dragging: false
            });
        }
    }, {
        key: 'handleResize',
        value: function handleResize() {
            this.update();
            this.forceUpdate();
        }
    }, {
        key: 'countVisibleItems',
        value: function countVisibleItems() {
            var visibleItems = 1;
            for (var n = 1; n < _constants.MAX_BUILDINGS_COUNT; n++) {
                var maxWidth = _constants2.CAROUSEL_MARGINS + this.props.snap * n;

                if (!window.matchMedia('(max-width: ' + maxWidth + 'px)').matches) {
                    visibleItems = n;
                }
            }
            return visibleItems;
        }

        // Callback returning KineticCarousel state

    }, {
        key: 'trackState',
        value: function trackState() {
            if (this.props.trackState) {
                this.props.trackState({
                    dragging: this.state.dragging
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames,
                _this3 = this;

            var arrowLeftClass = (0, _classnames2.default)(_KineticScrolling2.default.arrow, _KineticScrolling2.default.arrow__left);
            var arrowRightClass = (0, _classnames2.default)(_KineticScrolling2.default.arrow, _KineticScrolling2.default.arrow__right);

            var leftArrowDisabled = this.atBegin();
            var rightArrowDisabled = this.atEnd();

            var arrows = void 0;
            if (this.state.showArrows) {
                arrows = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: arrowLeftClass },
                        _react2.default.createElement(_NavigationArrow2.default, {
                            type: 'left',
                            handleClick: this.prev,
                            disabled: leftArrowDisabled
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: arrowRightClass },
                        _react2.default.createElement(_NavigationArrow2.default, {
                            type: 'right',
                            handleClick: this.next,
                            disabled: rightArrowDisabled
                        })
                    )
                );
            }

            var holderClass = (0, _classnames2.default)(_KineticScrolling2.default.holder, (_classNames = {}, _defineProperty(_classNames, _KineticScrolling2.default.holder__hideLeft, leftArrowDisabled), _defineProperty(_classNames, _KineticScrolling2.default.holder__hideRight, rightArrowDisabled), _classNames));

            var viewStyle = {
                transform: this.state.showArrows ? 'translateX(' + -this.state.offset + 'px)' : null
            };

            var viewClass = (0, _classnames2.default)(_KineticScrolling2.default.view, _defineProperty({}, _KineticScrolling2.default.view__enableTransitions, this.state.enableTransitions));

            var className = (0, _classnames2.default)(_KineticScrolling2.default.base, _defineProperty({}, _KineticScrolling2.default.base__disabled, !this.state.showArrows));

            return _react2.default.createElement(
                'div',
                { className: className },
                _react2.default.createElement(
                    'div',
                    { className: holderClass, ref: function ref(_) {
                            return _this3._holder = _;
                        } },
                    _react2.default.createElement(
                        'div',
                        {
                            ref: function ref(_) {
                                return _this3._view = _;
                            },
                            style: viewStyle,
                            className: viewClass,
                            onMouseDown: this.handleTap,
                            onMouseUp: this.handleRelease,
                            onClick: this.handleClick,
                            onWheel: this.handleWheel
                        },
                        this.props.children
                    )
                ),
                arrows
            );
        }
    }]);

    return KineticScrolling;
}(_react2.default.Component);

KineticScrolling.propTypes = {
    children: _propTypes2.default.arrayOf(_propTypes2.default.node).isRequired,
    snap: _propTypes2.default.number,
    activeItemIdx: _propTypes2.default.number,
    trackState: _propTypes2.default.func
};

exports.default = KineticScrolling;

/***/ }),
/* 2130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var TIME_CONSTANT = exports.TIME_CONSTANT = 325;
var CAROUSEL_MARGINS = exports.CAROUSEL_MARGINS = 94;

/***/ }),
/* 2131 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"KineticScrolling_base--3x2xZ","holder":"KineticScrolling_holder--3R3Qc","holder__hideLeft":"KineticScrolling_holder__hideLeft--ULwOj","holderHideLeft":"KineticScrolling_holder__hideLeft--ULwOj","holder__hideRight":"KineticScrolling_holder__hideRight--1m-dF","holderHideRight":"KineticScrolling_holder__hideRight--1m-dF","view":"KineticScrolling_view--1-S2n","view__enableTransitions":"KineticScrolling_view__enableTransitions--1PuuG","viewEnableTransitions":"KineticScrolling_view__enableTransitions--1PuuG","base__disabled":"KineticScrolling_base__disabled--3WWha","baseDisabled":"KineticScrolling_base__disabled--3WWha","arrow":"KineticScrolling_arrow--2ScT_","arrow__left":"KineticScrolling_arrow__left--3NBUy","arrowLeft":"KineticScrolling_arrow__left--3NBUy","arrow__right":"KineticScrolling_arrow__right--1misG","arrowRight":"KineticScrolling_arrow__right--1misG"};

/***/ }),
/* 2132 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"BuildingsCarousel_base--guCXm","item":"BuildingsCarousel_item--30a4i","item__empty":"BuildingsCarousel_item__empty--VvbvV","itemEmpty":"BuildingsCarousel_item__empty--VvbvV","item__active":"BuildingsCarousel_item__active--H1CSn","itemActive":"BuildingsCarousel_item__active--H1CSn","background":"BuildingsCarousel_background--18Mwi","overlay":"BuildingsCarousel_overlay--1BfCv","progress":"BuildingsCarousel_progress--gOIAb","content":"BuildingsCarousel_content--bXs0k","level":"BuildingsCarousel_level--3DjaW","image":"BuildingsCarousel_image--2iWwT","image__attack-bomber-squadrons":"BuildingsCarousel_image__attack-bomber-squadrons--1w6PG","imageAttackBomberSquadrons":"BuildingsCarousel_image__attack-bomber-squadrons--1w6PG","image__level-1":"BuildingsCarousel_image__level-1--1Cfby","imageLevel1":"BuildingsCarousel_image__level-1--1Cfby","image__level-2":"BuildingsCarousel_image__level-2--2iBgd","imageLevel2":"BuildingsCarousel_image__level-2--2iBgd","image__level-3":"BuildingsCarousel_image__level-3--1c7ya","imageLevel3":"BuildingsCarousel_image__level-3--1c7ya","image__level-4":"BuildingsCarousel_image__level-4--r93Gf","imageLevel4":"BuildingsCarousel_image__level-4--r93Gf","image__level-5":"BuildingsCarousel_image__level-5--1STfD","imageLevel5":"BuildingsCarousel_image__level-5--1STfD","image__level-6":"BuildingsCarousel_image__level-6--1XA2N","imageLevel6":"BuildingsCarousel_image__level-6--1XA2N","image__level-7":"BuildingsCarousel_image__level-7--kwtlI","imageLevel7":"BuildingsCarousel_image__level-7--kwtlI","image__level-8":"BuildingsCarousel_image__level-8--2gKsR","imageLevel8":"BuildingsCarousel_image__level-8--2gKsR","image__level-9":"BuildingsCarousel_image__level-9--17kQK","imageLevel9":"BuildingsCarousel_image__level-9--17kQK","image__level-10":"BuildingsCarousel_image__level-10--2Q6Tp","imageLevel10":"BuildingsCarousel_image__level-10--2Q6Tp","image__training-unit":"BuildingsCarousel_image__training-unit--hAMdM","imageTrainingUnit":"BuildingsCarousel_image__training-unit--hAMdM","image__tankodrome":"BuildingsCarousel_image__tankodrome--1C7pL","imageTankodrome":"BuildingsCarousel_image__tankodrome--1C7pL","image__financial-unit":"BuildingsCarousel_image__financial-unit--1vxRX","imageFinancialUnit":"BuildingsCarousel_image__financial-unit--1vxRX","image__transportation-unit":"BuildingsCarousel_image__transportation-unit--P6AwZ","imageTransportationUnit":"BuildingsCarousel_image__transportation-unit--P6AwZ","image__trophy-brigade":"BuildingsCarousel_image__trophy-brigade--1FbAo","imageTrophyBrigade":"BuildingsCarousel_image__trophy-brigade--1FbAo","image__artillery-battalion":"BuildingsCarousel_image__artillery-battalion--1Whzd","imageArtilleryBattalion":"BuildingsCarousel_image__artillery-battalion--1Whzd","image__military-school":"BuildingsCarousel_image__military-school--pij41","imageMilitarySchool":"BuildingsCarousel_image__military-school--pij41","image__home-front-service":"BuildingsCarousel_image__home-front-service--3AeJL","imageHomeFrontService":"BuildingsCarousel_image__home-front-service--3AeJL","image__command-center":"BuildingsCarousel_image__command-center--dLHtJ","imageCommandCenter":"BuildingsCarousel_image__command-center--dLHtJ","title":"BuildingsCarousel_title--11lhg"};

/***/ }),
/* 2133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = exports.CommandCenterCard = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactAddonsCssTransitionGroup = __webpack_require__(287);

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = __webpack_require__(7);

var _reactRouterRedux = __webpack_require__(15);

var _FirstChild = __webpack_require__(1324);

var _FirstChild2 = _interopRequireDefault(_FirstChild);

var _ModernizationOverlay = __webpack_require__(1325);

var _ModernizationOverlay2 = _interopRequireDefault(_ModernizationOverlay);

var _ReserveTooltip = __webpack_require__(1390);

var _ReserveTooltip2 = _interopRequireDefault(_ReserveTooltip);

var _UpgradeEffect = __webpack_require__(1326);

var _UpgradeEffect2 = _interopRequireDefault(_UpgradeEffect);

var _NavigationArrow = __webpack_require__(59);

var _NavigationArrow2 = _interopRequireDefault(_NavigationArrow);

var _components = __webpack_require__(2135);

var _helpers = __webpack_require__(11);

var _i18n = __webpack_require__(10);

var _sounds = __webpack_require__(22);

var _constants = __webpack_require__(2150);

var _constants2 = __webpack_require__(4);

var _urls = __webpack_require__(19);

var _CommandCenterCard = __webpack_require__(2151);

var _CommandCenterCard2 = _interopRequireDefault(_CommandCenterCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CommandCenterCard = exports.CommandCenterCard = function (_React$Component) {
    _inherits(CommandCenterCard, _React$Component);

    function CommandCenterCard(props) {
        _classCallCheck(this, CommandCenterCard);

        var _this = _possibleConstructorReturn(this, (CommandCenterCard.__proto__ || Object.getPrototypeOf(CommandCenterCard)).call(this, props));

        _this.backHandler = props.pushState.bind(null, _urls.STRONGHOLD);
        _this.onKeyUp = _this.onKeyUp.bind(_this);
        return _this;
    }

    _createClass(CommandCenterCard, [{
        key: 'onKeyUp',
        value: function onKeyUp(e) {
            if (e.keyCode !== _constants2.KEY_CODES.ESCAPE) return;

            var confirmationsOpened = this.props.confirmationOpened || this.refs.overlay.state.opened;
            if (!confirmationsOpened) this.backHandler();
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            window.addEventListener('keydown', this.onKeyUp);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('keydown', this.onKeyUp);
        }
    }, {
        key: 'handleUpgradeEffectClick',
        value: function handleUpgradeEffectClick() {
            this.props.playClickSound();
            this.refs.overlay.show();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var highlighted = this.props.upgrade.highlighted;

            var level = highlighted ? this.props.level + 1 : this.props.level;
            var nextLevel = _react2.default.createElement(
                'span',
                { className: _CommandCenterCard2.default.planLevel },
                (0, _helpers.toRoman)(this.props.level + 1)
            );

            var planLevelClassName = (0, _classnames2.default)(_CommandCenterCard2.default.planLevel, _defineProperty({}, _CommandCenterCard2.default.planLevel__highlighted, highlighted));

            var planLevel = _react2.default.createElement(
                'span',
                { className: planLevelClassName },
                (0, _helpers.toRoman)(level)
            );

            var overlayClassName = (0, _classnames2.default)(_CommandCenterCard2.default.overlay, _defineProperty({}, _CommandCenterCard2.default.overlay__enabled, highlighted));

            var arrowLeftClassName = (0, _classnames2.default)(_CommandCenterCard2.default.arrow, _CommandCenterCard2.default.arrow__left);
            var arrowRightClassName = (0, _classnames2.default)(_CommandCenterCard2.default.arrow, _CommandCenterCard2.default.arrow__right);

            var handleClickNext = null;
            var nextArrowDisabled = true;
            if (this.props.nextBuildingId !== undefined) {
                handleClickNext = this.props.pushState.bind(null, (0, _urls.BUILDING)(this.props.nextBuildingId));
                nextArrowDisabled = false;
            }

            var rewards = [];
            var tooltips = [];

            var _loop = function _loop(_level) {
                if (_level in _this2.props.rewardsByLevel) {
                    var reward = _this2.props.rewardsByLevel[_level];
                    rewards.push(_react2.default.createElement(_components.Reward, {
                        key: 'reward_' + _level,
                        reward: reward
                    }));
                    reward.reserves.forEach(function (reserve) {
                        var tooltipId = reserve.type + '_' + _level + '_reserve_tooltip_id';
                        tooltips.push(_react2.default.createElement(_ReserveTooltip2.default, {
                            key: tooltipId,
                            id: tooltipId,
                            level: _level,
                            type: reserve.type,
                            classNames: {
                                info: _CommandCenterCard2.default.tooltipInfo
                            }
                        }));
                    });
                }
            };

            for (var _level = _constants.MINIMUM_POSSIBLE_RESERVE_LEVEL; _level <= _constants2.MAX_RESERVE_LEVEL; _level++) {
                _loop(_level);
            }

            var rewardsClassName = (0, _classnames2.default)(_CommandCenterCard2.default.rewards, _defineProperty({}, _CommandCenterCard2.default.rewards__highlighted, highlighted));

            var upgradePlanComponent = this.props.level < _constants2.MAX_BUILDING_LEVEL ? _react2.default.createElement(
                'div',
                { className: _CommandCenterCard2.default.cell },
                _react2.default.createElement(
                    'p',
                    { className: _CommandCenterCard2.default.modernizationDescription },
                    (0, _constants.COMMAND_CENTER_MODERNIZATION_PLAN_DESCRIPTION)(planLevel)
                ),
                _react2.default.createElement(
                    'div',
                    { className: rewardsClassName },
                    _react2.default.createElement(
                        'h3',
                        { className: _CommandCenterCard2.default.heading },
                        (0, _constants.COMMAND_CENTER_REWARDS_TITLE)(nextLevel)
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _CommandCenterCard2.default.rewardsDescription },
                        rewards
                    )
                ),
                tooltips
            ) : null;

            return _react2.default.createElement(
                'div',
                { className: _CommandCenterCard2.default.base },
                _react2.default.createElement('div', { className: overlayClassName }),
                _react2.default.createElement(
                    'div',
                    { className: _CommandCenterCard2.default.header },
                    _react2.default.createElement(
                        'h2',
                        { className: _CommandCenterCard2.default.title },
                        _react2.default.createElement(
                            'span',
                            { className: _CommandCenterCard2.default.level },
                            (0, _helpers.toRoman)(level),
                            _react2.default.createElement(
                                'span',
                                { className: _CommandCenterCard2.default.levelShadow },
                                (0, _helpers.toRoman)(level)
                            )
                        ),
                        _i18n.COMMAND_CENTER_TITLE
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _CommandCenterCard2.default.main },
                    _react2.default.createElement(
                        'div',
                        { className: _CommandCenterCard2.default.wrapper },
                        _react2.default.createElement(
                            'div',
                            { className: _CommandCenterCard2.default.holder },
                            _react2.default.createElement(
                                'div',
                                { className: _CommandCenterCard2.default.grid },
                                _react2.default.createElement(
                                    'div',
                                    { className: _CommandCenterCard2.default.cell },
                                    _react2.default.createElement(_components.CardImage, {
                                        tooltipId: _constants.COMMAND_CENTER_UPGRADE_TOOLTIP_ID,
                                        isMaxCommandCenter: this.props.level === _constants2.MAX_BUILDING_LEVEL
                                    }),
                                    _react2.default.createElement(_UpgradeEffect2.default, {
                                        handleClick: this.handleUpgradeEffectClick.bind(this),
                                        handleHover: this.props.playHoverSound,
                                        hasPermission: true,
                                        fade: this.props.upgrade.highlighted
                                    })
                                ),
                                upgradePlanComponent
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: arrowLeftClassName },
                            _react2.default.createElement(_NavigationArrow2.default, {
                                size: _NavigationArrow2.default.SIZES.big,
                                type: _NavigationArrow2.default.TYPES.left,
                                handleClick: null,
                                disabled: true
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: arrowRightClassName },
                            _react2.default.createElement(_NavigationArrow2.default, {
                                size: _NavigationArrow2.default.SIZES.big,
                                type: _NavigationArrow2.default.TYPES.right,
                                handleClick: handleClickNext,
                                disabled: nextArrowDisabled
                            })
                        )
                    )
                ),
                level < _constants2.MAX_BUILDING_LEVEL && _react2.default.createElement(_components.UpgradeTooltip, { id: _constants.COMMAND_CENTER_UPGRADE_TOOLTIP_ID }),
                _react2.default.createElement(
                    _reactAddonsCssTransitionGroup2.default,
                    {
                        component: _FirstChild2.default,
                        transitionName: 'upgradeConfirmation',
                        transitionEnterTimeout: 200,
                        transitionLeaveTimeout: 200
                    },
                    this.props.upgrade.confirmationOpened ? _react2.default.createElement(_components.UpgradeConfirmation, null) : null
                ),
                _react2.default.createElement(
                    _ModernizationOverlay2.default,
                    { ref: 'overlay' },
                    _react2.default.createElement(_components.UpgradeEffectContent, null)
                )
            );
        }
    }]);

    return CommandCenterCard;
}(_react2.default.Component);

CommandCenterCard.propTypes = {
    level: _propTypes2.default.number.isRequired,
    upgrade: _propTypes2.default.shape({
        confirmationOpened: _propTypes2.default.bool.isRequired,
        submitting: _propTypes2.default.bool.isRequired,
        highlighted: _propTypes2.default.bool.isRequired
    }).isRequired,
    nextBuildingId: _propTypes2.default.number,
    rewardsByLevel: _propTypes2.default.object,
    confirmationOpened: _propTypes2.default.bool.isRequired,

    playHoverSound: _propTypes2.default.func.isRequired,
    playClickSound: _propTypes2.default.func.isRequired,
    pushState: _propTypes2.default.func.isRequired
};
var mapStateToProps = exports.mapStateToProps = function mapStateToProps(_ref) {
    var commandCenterUpgrade = _ref.commandCenterUpgrade,
        buildings = _ref.buildings,
        stronghold = _ref.stronghold,
        settings = _ref.settings;

    var level = stronghold.level;
    var confirmationOpened = commandCenterUpgrade.confirmationOpened,
        highlighted = commandCenterUpgrade.highlighted,
        submitting = commandCenterUpgrade.submitting;

    var buildingIds = Object.keys(buildings);

    var rewardsByLevel = {};
    if (level < _constants2.MAX_BUILDING_LEVEL) {
        var commandCenterUpgradeReward = settings.command_center.upgrade_rewards[level + 1];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = _constants.RESERVE_TYPES_ORDER[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var reserveType = _step.value;

                var reserveSettings = commandCenterUpgradeReward[reserveType];

                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = reserveSettings[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var _ref3 = _step2.value;
                        var _level2 = _ref3.level,
                            count = _ref3.count;

                        if (!(_level2 in rewardsByLevel)) {
                            rewardsByLevel[_level2] = {
                                rewardLevel: _level2,
                                reserves: []
                            };
                        }

                        rewardsByLevel[_level2].reserves.push({
                            type: reserveType,
                            count: count
                        });
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }

    return {
        level: level,
        upgrade: { confirmationOpened: confirmationOpened, highlighted: highlighted, submitting: submitting },
        nextBuildingId: buildingIds.length > 0 ? Number(buildingIds[0]) : undefined,
        rewardsByLevel: rewardsByLevel,
        confirmationOpened: confirmationOpened
    };
};

var mapDispatchToProps = exports.mapDispatchToProps = {
    playHoverSound: _sounds.playHoverSound,
    playClickSound: _sounds.playClickSound,
    pushState: _reactRouterRedux.push
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CommandCenterCard);

/***/ }),
/* 2134 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"ReserveTooltip_root--2VYKF","root__show":"ReserveTooltip_root__show--37g8C","rootShow":"ReserveTooltip_root__show--37g8C","body":"ReserveTooltip_body--10hKf","wrapper":"ReserveTooltip_wrapper--tTuhm","content":"ReserveTooltip_content--1qtHa","title":"ReserveTooltip_title--3wi_3","subtitle":"ReserveTooltip_subtitle--2anyI","message":"ReserveTooltip_message--f6lFI","warning":"ReserveTooltip_warning--1oeMp","divider":"ReserveTooltip_divider--3cGIc","highlight":"ReserveTooltip_highlight--1Bkvy","ribbon":"ReserveTooltip_ribbon--1HXYi","statusMessage":"ReserveTooltip_statusMessage--1Crdi","statusMessage__positive":"ReserveTooltip_statusMessage__positive--2-3VU","statusMessagePositive":"ReserveTooltip_statusMessage__positive--2-3VU","status":"ReserveTooltip_status--EtQI2","statusMessage__negative":"ReserveTooltip_statusMessage__negative--3CE7-","statusMessageNegative":"ReserveTooltip_statusMessage__negative--3CE7-","statusMessage__noPermission":"ReserveTooltip_statusMessage__noPermission--3PJIl","statusMessageNoPermission":"ReserveTooltip_statusMessage__noPermission--3PJIl","status__positive":"ReserveTooltip_status__positive--2Kc5O","statusPositive":"ReserveTooltip_status__positive--2Kc5O","status__negative":"ReserveTooltip_status__negative--4EjqE","statusNegative":"ReserveTooltip_status__negative--4EjqE","statusText":"ReserveTooltip_statusText--3ey_g","base__type-economics":"ReserveTooltip_base__type-economics--2wvmY","baseTypeEconomics":"ReserveTooltip_base__type-economics--2wvmY","base__type-economics-double":"ReserveTooltip_base__type-economics-double--2umVb","baseTypeEconomicsDouble":"ReserveTooltip_base__type-economics-double--2umVb","base__type-battle":"ReserveTooltip_base__type-battle--2BO76","baseTypeBattle":"ReserveTooltip_base__type-battle--2BO76","header":"ReserveTooltip_header--3ujDJ","button":"ReserveTooltip_button--23ADn","thumbnail":"ReserveTooltip_thumbnail--3-2bt","image":"ReserveTooltip_image--suQzC","image__artillery-strike":"ReserveTooltip_image__artillery-strike--oTKqe","imageArtilleryStrike":"ReserveTooltip_image__artillery-strike--oTKqe","image__elite":"ReserveTooltip_image__elite--1X9sq","imageElite":"ReserveTooltip_image__elite--1X9sq","image__airstrike":"ReserveTooltip_image__airstrike--2RG7n","imageAirstrike":"ReserveTooltip_image__airstrike--2RG7n","image__requisition":"ReserveTooltip_image__requisition--1oQmb","imageRequisition":"ReserveTooltip_image__requisition--1oQmb","image__high-capacity-transport":"ReserveTooltip_image__high-capacity-transport--2zZ--","imageHighCapacityTransport":"ReserveTooltip_image__high-capacity-transport--2zZ--","image__additional-briefing":"ReserveTooltip_image__additional-briefing--TjWQ1","imageAdditionalBriefing":"ReserveTooltip_image__additional-briefing--TjWQ1","image__tactical-training":"ReserveTooltip_image__tactical-training--hxbZL","imageTacticalTraining":"ReserveTooltip_image__tactical-training--hxbZL","image__military-maneuvers":"ReserveTooltip_image__military-maneuvers--1OSYb","imageMilitaryManeuvers":"ReserveTooltip_image__military-maneuvers--1OSYb","image__battle-payments":"ReserveTooltip_image__battle-payments--1DOCW","imageBattlePayments":"ReserveTooltip_image__battle-payments--1DOCW","image__inspiration":"ReserveTooltip_image__inspiration--2NWm2","imageInspiration":"ReserveTooltip_image__inspiration--2NWm2","info":"ReserveTooltip_info--1onpF","level":"ReserveTooltip_level--bp0Mt"};

/***/ }),
/* 2135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Reward = exports.UpgradeEffectContent = exports.UpgradeTooltip = exports.UpgradeConfirmation = exports.CardImage = undefined;

var _CardImage2 = __webpack_require__(2136);

var _CardImage3 = _interopRequireDefault(_CardImage2);

var _UpgradeConfirmation2 = __webpack_require__(2139);

var _UpgradeConfirmation3 = _interopRequireDefault(_UpgradeConfirmation2);

var _UpgradeTooltip2 = __webpack_require__(2140);

var _UpgradeTooltip3 = _interopRequireDefault(_UpgradeTooltip2);

var _UpgradeEffectContent2 = __webpack_require__(2143);

var _UpgradeEffectContent3 = _interopRequireDefault(_UpgradeEffectContent2);

var _Reward2 = __webpack_require__(2146);

var _Reward3 = _interopRequireDefault(_Reward2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.CardImage = _CardImage3.default;
exports.UpgradeConfirmation = _UpgradeConfirmation3.default;
exports.UpgradeTooltip = _UpgradeTooltip3.default;
exports.UpgradeEffectContent = _UpgradeEffectContent3.default;
exports.Reward = _Reward3.default;

/***/ }),
/* 2136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = exports.CardImage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(7);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _CardImage = __webpack_require__(2137);

var _CardImage2 = _interopRequireDefault(_CardImage);

var _BuildingCardImage = __webpack_require__(1328);

var _BuildingCardImage2 = _interopRequireDefault(_BuildingCardImage);

var _stronghold = __webpack_require__(132);

var _constants = __webpack_require__(2138);

var _command_center_upgrade = __webpack_require__(195);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CardImage = exports.CardImage = function (_React$Component) {
    _inherits(CardImage, _React$Component);

    function CardImage() {
        _classCallCheck(this, CardImage);

        return _possibleConstructorReturn(this, (CardImage.__proto__ || Object.getPrototypeOf(CardImage)).apply(this, arguments));
    }

    _createClass(CardImage, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.props.handleMouseLeave();
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                tooltipId = _props.tooltipId,
                isMaxCommandCenter = _props.isMaxCommandCenter,
                upgradeCost = _props.upgradeCost,
                hasEnoughIndustrialResource = _props.hasEnoughIndustrialResource,
                showUpgrade = _props.showUpgrade,
                hasEnoughBuildingLevelSumm = _props.hasEnoughBuildingLevelSumm,
                isUpgradeAvailable = _props.isUpgradeAvailable,
                strongholdLevel = _props.strongholdLevel,
                buildingsLevelSumm = _props.buildingsLevelSumm,
                necessaryBuildingsLevel = _props.necessaryBuildingsLevel;


            var buildingsLevelLacks = necessaryBuildingsLevel - buildingsLevelSumm;

            var notEnoughLevel = !hasEnoughBuildingLevelSumm && showUpgrade ? _react2.default.createElement(
                'div',
                { className: _CardImage2.default.notEnoughLevel },
                _react2.default.createElement(
                    'span',
                    { className: _CardImage2.default.necessaryLevel },
                    _constants.NECESSARY_LEVEL_MESSAGE,
                    ' ',
                    _react2.default.createElement(
                        'span',
                        { className: _CardImage2.default.buildingsLevel },
                        necessaryBuildingsLevel
                    )
                ),
                _react2.default.createElement(
                    'span',
                    { className: _CardImage2.default.levelIllustration },
                    '(',
                    _constants.BUILDINGS_LEVEL_MESSAGE,
                    ' ',
                    _react2.default.createElement(
                        'span',
                        { className: _CardImage2.default.buildingsLevel },
                        ' ',
                        buildingsLevelSumm
                    ),
                    ', ',
                    _react2.default.createElement(
                        'span',
                        { className: _CardImage2.default.levelLacks },
                        _constants.BUILDINGS_LEVEL_LACKS_MESSAGE
                    ),
                    _react2.default.createElement(
                        'span',
                        { className: _CardImage2.default.buildingsLevel },
                        ' ',
                        buildingsLevelLacks
                    ),
                    ')'
                )
            ) : null;

            var buildingType = 'COMMAND_CENTER';
            var buildingLevel = strongholdLevel;
            var innerProps = {
                buildingType: buildingType,
                buildingLevel: buildingLevel,
                hasEnoughIndustrialResource: hasEnoughIndustrialResource,
                hasEnoughBuildingLevelSumm: hasEnoughBuildingLevelSumm,
                upgradeCost: upgradeCost,
                tooltipId: tooltipId,
                isMaxCommandCenter: isMaxCommandCenter,
                isUpgradeAvailable: isUpgradeAvailable,
                showUpgrade: showUpgrade,
                onMouseEnter: this.props.handleMouseEnter,
                onMouseLeave: this.props.handleMouseLeave,
                onClick: this.props.handleClick
            };

            var className = (0, _classnames2.default)(_CardImage2.default.base, _defineProperty({}, _CardImage2.default.base__elite, isMaxCommandCenter));

            var maxLevelMessage = isMaxCommandCenter ? _react2.default.createElement(
                'div',
                { className: _CardImage2.default.maxLevelMessage },
                _constants.MAX_LEVEL_MESSAGE
            ) : null;

            return _react2.default.createElement(
                'div',
                { className: className },
                _react2.default.createElement(_BuildingCardImage2.default, innerProps),
                notEnoughLevel,
                maxLevelMessage
            );
        }
    }]);

    return CardImage;
}(_react2.default.Component);

CardImage.propTypes = {
    tooltipId: _propTypes2.default.string.isRequired,
    isMaxCommandCenter: _propTypes2.default.bool,
    upgradeCost: _propTypes2.default.number,
    showUpgrade: _propTypes2.default.bool.isRequired,
    hasEnoughIndustrialResource: _propTypes2.default.bool.isRequired,
    hasEnoughBuildingLevelSumm: _propTypes2.default.bool.isRequired,
    isUpgradeAvailable: _propTypes2.default.bool.isRequired,
    strongholdLevel: _propTypes2.default.number.isRequired,
    buildingsLevelSumm: _propTypes2.default.number.isRequired,
    necessaryBuildingsLevel: _propTypes2.default.number.isRequired,

    handleMouseEnter: _propTypes2.default.func.isRequired,
    handleMouseLeave: _propTypes2.default.func.isRequired,
    handleClick: _propTypes2.default.func.isRequired
};
var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, _ref) {
    var tooltipId = _ref.tooltipId;


    var upgradeCost = state.settings.command_center.costs[state.stronghold.level];
    var hasEnoughIndustrialResource = (0, _stronghold.checkIndustrialResource)(state);
    var showUpgrade = (0, _stronghold.checkUpgradeVisibility)(state);
    var hasEnoughBuildingLevelSumm = (0, _stronghold.checkBuildingsLevelSumm)(state);
    var necessaryBuildingsLevel = (0, _stronghold.getNecessaryBuildingsLevel)(state);
    var buildingsLevelSumm = (0, _stronghold.getBuildingsLevelSumm)(state);
    var isUpgradeAvailable = hasEnoughIndustrialResource && showUpgrade && hasEnoughBuildingLevelSumm;

    return {
        tooltipId: tooltipId,
        upgradeCost: upgradeCost,
        hasEnoughIndustrialResource: hasEnoughIndustrialResource,
        showUpgrade: showUpgrade,
        hasEnoughBuildingLevelSumm: hasEnoughBuildingLevelSumm,
        isUpgradeAvailable: isUpgradeAvailable,
        necessaryBuildingsLevel: necessaryBuildingsLevel,
        buildingsLevelSumm: buildingsLevelSumm,

        strongholdLevel: state.stronghold.level
    };
};

var mapDispatchToProps = exports.mapDispatchToProps = {
    handleMouseEnter: _command_center_upgrade.showUpgradeHighlight,
    handleMouseLeave: _command_center_upgrade.hideUpgradeHighlight,
    handleClick: _command_center_upgrade.openConfirmation
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(CardImage);

/***/ }),
/* 2137 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"CardImage_base--1Gp5J","base__elite":"CardImage_base__elite--csXK5","baseElite":"CardImage_base__elite--csXK5","notEnoughLevel":"CardImage_notEnoughLevel--aiFHn","necessaryLevel":"CardImage_necessaryLevel--1677S","levelIllustration":"CardImage_levelIllustration--FyD4p","buildingsLevel":"CardImage_buildingsLevel--24slk","levelLacks":"CardImage_levelLacks--1cdiD","maxLevelMessage":"CardImage_maxLevelMessage--3Jrcv"};

/***/ }),
/* 2138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MAX_LEVEL_MESSAGE = exports.BUILDINGS_LEVEL_LACKS_MESSAGE = exports.BUILDINGS_LEVEL_MESSAGE = exports.NECESSARY_LEVEL_MESSAGE = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-multi-comp */
var NECESSARY_LEVEL_MESSAGE = exports.NECESSARY_LEVEL_MESSAGE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'command_center_card.nessesary_level',
    defaultMessage: '\u0422\u0440\u0435\u0431\u0443\u0435\u043C\u044B\u0439 \u0441\u0443\u043C\u043C\u0430\u0440\u043D\u044B\u0439 \u0443\u0440\u043E\u0432\u0435\u043D\u044C \u0441\u0442\u0440\u043E\u0435\u043D\u0438\u0439:'
});

var BUILDINGS_LEVEL_MESSAGE = exports.BUILDINGS_LEVEL_MESSAGE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'command_center_card.buildings_level_summ',
    defaultMessage: '\u0442\u0435\u043A\u0443\u0449\u0438\u0439:'
});

var BUILDINGS_LEVEL_LACKS_MESSAGE = exports.BUILDINGS_LEVEL_LACKS_MESSAGE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'command_center_card.buildings_level_summ_lacks',
    defaultMessage: '\u043D\u0435 \u0445\u0432\u0430\u0442\u0430\u0435\u0442:'
});

var MAX_LEVEL_MESSAGE = exports.MAX_LEVEL_MESSAGE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'command_center_card.max_level_message',
    defaultMessage: '\u041F\u043E\u0437\u0432\u043E\u043B\u044F\u0435\u0442 \u043C\u043E\u0434\u0435\u0440\u043D\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0432\u0441\u0435 \u0441\u0442\u0440\u043E\u0435\u043D\u0438\u044F \u0434\u043E \u0425 \u0443\u0440\u043E\u0432\u043D\u044F.'
});

/***/ }),
/* 2139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapStateToProps = exports.UpgradeConfirmation = exports.commandCenterMessages = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _reactRedux = __webpack_require__(7);

var _command_center_upgrade = __webpack_require__(195);

var _command_center_upgrade2 = _interopRequireDefault(_command_center_upgrade);

var _i18n = __webpack_require__(10);

var _UpgradeConfirmationView = __webpack_require__(1330);

var _UpgradeConfirmationView2 = _interopRequireDefault(_UpgradeConfirmationView);

var _locale = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var commandCenterMessages = exports.commandCenterMessages = (0, _reactIntl.defineMessages)({
    buildingName: {
        'id': 'command_center.notification_title',
        'defaultMessage': '\u041A\u043E\u043C\u0430\u043D\u0434\u043D\u044B\u0439 \u0446\u0435\u043D\u0442\u0440'
    }
});

var UpgradeConfirmation = exports.UpgradeConfirmation = function (_React$Component) {
    _inherits(UpgradeConfirmation, _React$Component);

    function UpgradeConfirmation() {
        _classCallCheck(this, UpgradeConfirmation);

        return _possibleConstructorReturn(this, (UpgradeConfirmation.__proto__ || Object.getPrototypeOf(UpgradeConfirmation)).apply(this, arguments));
    }

    _createClass(UpgradeConfirmation, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.currentLevel = this.props.level;
        }
    }, {
        key: 'getBuildingName',
        value: function getBuildingName() {
            return (0, _locale.formatMessage)(commandCenterMessages.buildingName);
        }
    }, {
        key: 'render',
        value: function render() {
            var level = this.props.level;

            var buildingName = this.getBuildingName();
            var submitHandler = this.props.upgradeCommandCenter.bind(null, level + 1, buildingName);
            var cancelHandler = this.props.cancelUpgradeHandler;

            return _react2.default.createElement(_UpgradeConfirmationView2.default, {
                type: 'COMMAND_CENTER',
                name: _i18n.COMMAND_CENTER_TITLE,
                level: this.currentLevel,
                upgraded: this.props.upgraded,
                upgradeCost: this.props.upgradeCost,
                submitHandler: submitHandler,
                cancelHandler: cancelHandler
            });
        }
    }]);

    return UpgradeConfirmation;
}(_react2.default.Component);

UpgradeConfirmation.propTypes = {
    level: _propTypes2.default.number.isRequired,
    upgraded: _propTypes2.default.bool.isRequired,
    upgradeCost: _propTypes2.default.number.isRequired,
    upgradeCommandCenter: _propTypes2.default.func.isRequired,
    cancelUpgradeHandler: _propTypes2.default.func.isRequired
};
var mapStateToProps = exports.mapStateToProps = function mapStateToProps(_ref) {
    var settings = _ref.settings,
        stronghold = _ref.stronghold,
        commandCenterUpgrade = _ref.commandCenterUpgrade;
    return {
        upgradeCost: settings.command_center.costs[stronghold.level],
        level: stronghold.level,
        upgraded: commandCenterUpgrade.submitted
    };
};

var mapDispatchToProps = {
    upgradeCommandCenter: _command_center_upgrade2.default,
    cancelUpgradeHandler: _command_center_upgrade.closeConfirmation
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UpgradeConfirmation);

/***/ }),
/* 2140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapStateToProps = exports.UpgradeTooltip = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(7);

var _helpers = __webpack_require__(11);

var _reactWotBootstrap = __webpack_require__(5);

var _LackOfIndustrialResource = __webpack_require__(288);

var _LackOfIndustrialResource2 = _interopRequireDefault(_LackOfIndustrialResource);

var _IndustrialResource = __webpack_require__(35);

var _IndustrialResource2 = _interopRequireDefault(_IndustrialResource);

var _constants = __webpack_require__(2141);

var _stronghold = __webpack_require__(132);

var _UpgradeTooltip = __webpack_require__(2142);

var _UpgradeTooltip2 = _interopRequireDefault(_UpgradeTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UpgradeTooltip = exports.UpgradeTooltip = function UpgradeTooltip(props) {
    var description = _react2.default.createElement(
        'div',
        { className: _UpgradeTooltip2.default.description },
        (0, _constants.COMMAND_CENTER_MODERNIZATION_DESCRIPTION_ALLOWED)(_react2.default.createElement(
            'span',
            { className: _UpgradeTooltip2.default.valueHighlight },
            (0, _helpers.toRoman)(props.nextLevel)
        ))
    );

    var message = void 0;
    var divider = void 0;

    if (!props.isBuildingsLevelEnough) {
        var necessaryLevelComponent = _react2.default.createElement(
            'span',
            { className: _UpgradeTooltip2.default.valueHighlight },
            props.necessaryBuildingsLevel
        );
        message = _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'p',
                { className: _UpgradeTooltip2.default.messageTitle },
                _constants.MODERNIZATION_NOT_AVAILABLE_TITLE
            ),
            _react2.default.createElement(
                'p',
                { className: _UpgradeTooltip2.default.messageDescription },
                (0, _constants.NOT_ENOUGH_BUILDINGS_LEVEL)(necessaryLevelComponent)
            ),
            _react2.default.createElement(
                'p',
                { className: _UpgradeTooltip2.default.messageDescription },
                _constants.NOT_ENOUGH_BUILDINGS_LEVEL_DESCRIPTION
            )
        );
    } else if (props.industrialResourceAvailable < props.upgradeCost) {
        var industrialResource = _react2.default.createElement(_IndustrialResource2.default, {
            value: props.upgradeCost - props.industrialResourceAvailable,
            small: true
        });
        message = _react2.default.createElement(_LackOfIndustrialResource2.default, { resource: industrialResource });
    }

    if (props.industrialResourceAvailable < props.upgradeCost || !props.isBuildingsLevelEnough) {
        divider = _react2.default.createElement('div', { className: _UpgradeTooltip2.default.divider });

        description = _react2.default.createElement(
            'div',
            { className: _UpgradeTooltip2.default.message },
            (0, _constants.COMMAND_CENTER_MODERNIZATION_DESCRIPTION)(_react2.default.createElement(
                'span',
                { className: _UpgradeTooltip2.default.valueHighlight },
                (0, _helpers.toRoman)(props.nextLevel)
            ))
        );
    }

    return _react2.default.createElement(
        _reactWotBootstrap.Tooltip,
        { id: props.id, isWide: true },
        _react2.default.createElement(
            'div',
            { className: _UpgradeTooltip2.default.base },
            _react2.default.createElement(
                'p',
                { className: _UpgradeTooltip2.default.title },
                _constants.MODERNIZATION_TOOLTIP_TITLE
            ),
            description,
            divider,
            message
        )
    );
};

UpgradeTooltip.propTypes = {
    id: _propTypes2.default.string.isRequired,
    nextLevel: _propTypes2.default.number.isRequired,
    upgradeCost: _propTypes2.default.number.isRequired,
    industrialResourceAvailable: _propTypes2.default.number.isRequired,
    necessaryBuildingsLevel: _propTypes2.default.number.isRequired,
    isBuildingsLevelEnough: _propTypes2.default.bool.isRequired
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, _ref) {
    var id = _ref.id;

    var upgradeCost = state.settings.command_center.costs[state.stronghold.level];

    return {
        id: id,
        nextLevel: state.stronghold.level + 1,
        upgradeCost: upgradeCost,
        industrialResourceAvailable: state.clan.industrial_resource,
        necessaryBuildingsLevel: (0, _stronghold.getNecessaryBuildingsLevel)(state),
        isBuildingsLevelEnough: (0, _stronghold.checkBuildingsLevelSumm)(state)
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(UpgradeTooltip);

/***/ }),
/* 2141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.COMMAND_CENTER_MODERNIZATION_DESCRIPTION = exports.NOT_ENOUGH_BUILDINGS_LEVEL_DESCRIPTION = exports.NOT_ENOUGH_BUILDINGS_LEVEL = exports.MODERNIZATION_NOT_AVAILABLE_TITLE = exports.MODERNIZATION_TOOLTIP_TITLE = exports.COMMAND_CENTER_MODERNIZATION_DESCRIPTION_ALLOWED = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-multi-comp, max-len */
var COMMAND_CENTER_MODERNIZATION_DESCRIPTION_ALLOWED = exports.COMMAND_CENTER_MODERNIZATION_DESCRIPTION_ALLOWED = function COMMAND_CENTER_MODERNIZATION_DESCRIPTION_ALLOWED(level) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'command_center.upgrade_tooltip.command_center_modernization_description_allowed',
        defaultMessage: '\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043C\u043E\u0434\u0435\u0440\u043D\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u041A\u043E\u043C\u0430\u043D\u0434\u043D\u044B\u0439 \u0446\u0435\u043D\u0442\u0440, \u0447\u0442\u043E \u043F\u043E\u0437\u0432\u043E\u043B\u0438\u0442 \u043C\u043E\u0434\u0435\u0440\u043D\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0432\u0441\u0435 \u0441\u0442\u0440\u043E\u0435\u043D\u0438\u044F \u0434\u043E {level} \u0443\u0440\u043E\u0432\u043D\u044F',
        values: { level: level }
    });
};

var MODERNIZATION_TOOLTIP_TITLE = exports.MODERNIZATION_TOOLTIP_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'command_center.upgrade_tooltip.modernization_tooltip_title',
    defaultMessage: '\u041C\u043E\u0434\u0435\u0440\u043D\u0438\u0437\u0430\u0446\u0438\u044F'
});

var MODERNIZATION_NOT_AVAILABLE_TITLE = exports.MODERNIZATION_NOT_AVAILABLE_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'command_center.upgrade_tooltip.modernization_not_available_title',
    defaultMessage: '\u041C\u043E\u0434\u0435\u0440\u043D\u0438\u0437\u0430\u0446\u0438\u044F \u043D\u0435 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430'
});

var NOT_ENOUGH_BUILDINGS_LEVEL = exports.NOT_ENOUGH_BUILDINGS_LEVEL = function NOT_ENOUGH_BUILDINGS_LEVEL(level) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'command_center.upgrade_tooltip.not_enough_buildings_level',
        defaultMessage: '\u0414\u043B\u044F \u043C\u043E\u0434\u0435\u0440\u043D\u0438\u0437\u0430\u0446\u0438\u0438 \u043A\u043E\u043C\u0430\u043D\u0434\u043D\u043E\u0433\u043E \u0446\u0435\u043D\u0442\u0440\u0430 \u0442\u0440\u0435\u0431\u0443\u0435\u0442\u0441\u044F \u0441\u0443\u043C\u043C\u0430\u0440\u043D\u044B\u0439 \u0443\u0440\u043E\u0432\u0435\u043D\u044C \u0441\u0442\u0440\u043E\u0435\u043D\u0438\u0439 \u043D\u0435 \u043D\u0438\u0436\u0435 {level}',
        values: { level: level }
    });
};

var NOT_ENOUGH_BUILDINGS_LEVEL_DESCRIPTION = exports.NOT_ENOUGH_BUILDINGS_LEVEL_DESCRIPTION = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'command_center.upgrade_tooltip.not_enough_buildings_level_description',
    defaultMessage: '\u041C\u043E\u0434\u0435\u0440\u043D\u0438\u0437\u0438\u0440\u0443\u0439\u0442\u0435 \u0434\u0440\u0443\u0433\u0438\u0435 \u0441\u0442\u0440\u043E\u0435\u043D\u0438\u044F \u0423\u043A\u0440\u0435\u043F\u0440\u0430\u0439\u043E\u043D\u0430'
});

var COMMAND_CENTER_MODERNIZATION_DESCRIPTION = exports.COMMAND_CENTER_MODERNIZATION_DESCRIPTION = function COMMAND_CENTER_MODERNIZATION_DESCRIPTION(level) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'command_center.upgrade_tooltip.command_center_modernization_description',
        defaultMessage: '\u041F\u043E\u0441\u043B\u0435 \u043C\u043E\u0434\u0435\u0440\u043D\u0438\u0437\u0430\u0446\u0438\u0438 \u041A\u043E\u043C\u0430\u043D\u0434\u043D\u043E\u0433\u043E \u0446\u0435\u043D\u0442\u0440\u0430 \u0441\u0442\u0430\u043D\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430 \u043C\u043E\u0434\u0435\u0440\u043D\u0438\u0437\u0430\u0446\u0438\u044F \u0432\u0441\u0435\u0445 \u0441\u0442\u0440\u043E\u0435\u043D\u0438\u0439 \u0434\u043E {level} \u0443\u0440\u043E\u0432\u043D\u044F',
        values: { level: level }
    });
};

/***/ }),
/* 2142 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"UpgradeTooltip_root--1PV4S","root__show":"UpgradeTooltip_root__show--3s_y7","rootShow":"UpgradeTooltip_root__show--3s_y7","body":"UpgradeTooltip_body--31WP1","wrapper":"UpgradeTooltip_wrapper--3KXZR","content":"UpgradeTooltip_content--3AzS3","title":"UpgradeTooltip_title--1RTzg","subtitle":"UpgradeTooltip_subtitle--3Mv_O","message":"UpgradeTooltip_message--38oKH","warning":"UpgradeTooltip_warning--1uPn5","divider":"UpgradeTooltip_divider--1HRLq","highlight":"UpgradeTooltip_highlight--2h4RI","ribbon":"UpgradeTooltip_ribbon--1nt_o","statusMessage":"UpgradeTooltip_statusMessage--cGgqc","statusMessage__positive":"UpgradeTooltip_statusMessage__positive--2nNEV","statusMessagePositive":"UpgradeTooltip_statusMessage__positive--2nNEV","status":"UpgradeTooltip_status--34VWr","statusMessage__negative":"UpgradeTooltip_statusMessage__negative--2wheU","statusMessageNegative":"UpgradeTooltip_statusMessage__negative--2wheU","statusMessage__noPermission":"UpgradeTooltip_statusMessage__noPermission--2qfZk","statusMessageNoPermission":"UpgradeTooltip_statusMessage__noPermission--2qfZk","status__positive":"UpgradeTooltip_status__positive--1zjFU","statusPositive":"UpgradeTooltip_status__positive--1zjFU","status__negative":"UpgradeTooltip_status__negative--2pVUR","statusNegative":"UpgradeTooltip_status__negative--2pVUR","statusText":"UpgradeTooltip_statusText--98hoN","base":"UpgradeTooltip_base--3z-JR","messageTitle":"UpgradeTooltip_messageTitle--MmrRg","valueHighlight":"UpgradeTooltip_valueHighlight--3Jslk","messageDescription":"UpgradeTooltip_messageDescription--4DEyM"};

/***/ }),
/* 2143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapStateToProps = exports.UpgradeEffectContent = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(7);

var _helpers = __webpack_require__(11);

var _accounts = __webpack_require__(33);

var _constants = __webpack_require__(1333);

var _BaseBonusInfoTable = __webpack_require__(383);

var _BaseBonusInfoTable2 = _interopRequireDefault(_BaseBonusInfoTable);

var _Warning = __webpack_require__(107);

var _Warning2 = _interopRequireDefault(_Warning);

var _IndustrialResource = __webpack_require__(35);

var _IndustrialResource2 = _interopRequireDefault(_IndustrialResource);

var _constants2 = __webpack_require__(2144);

var _constants3 = __webpack_require__(4);

var _UpgradeEffectContent = __webpack_require__(2145);

var _UpgradeEffectContent2 = _interopRequireDefault(_UpgradeEffectContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var UpgradeEffectContent = exports.UpgradeEffectContent = function UpgradeEffectContent(_ref) {
    var upgradeCosts = _ref.upgradeCosts,
        requiredLevels = _ref.requiredLevels,
        currentLevel = _ref.currentLevel,
        hasPermission = _ref.hasPermission;

    var columns = [{
        title: _constants2.COMMAND_CENTER_LEVEL_HEADER,
        dataIndex: 'level',
        align: 'left'
    }, {
        title: _constants2.REQUIRED_BUILDINGS_LEVEL_SUMM_HEADER,
        dataIndex: 'buildingsLevelSum'
    }, {
        title: _constants2.UPGRADE_COMMAND_CENTER_COST_HEADER,
        dataIndex: 'upgradeCost',
        render: function render(value) {
            return _react2.default.createElement(_IndustrialResource2.default, {
                value: value,
                small: true
            });
        }
    }];

    var dataSource = upgradeCosts.map(function (upgradeCost, index) {
        return {
            level: index + 1,
            buildingsLevelSum: requiredLevels[index],
            upgradeCost: upgradeCost
        };
    });

    var isMaxLevelReached = currentLevel === _constants3.MAX_BUILDING_LEVEL;

    return _react2.default.createElement(
        'div',
        { className: _UpgradeEffectContent2.default.base },
        _react2.default.createElement(
            'div',
            { className: _UpgradeEffectContent2.default.header },
            _react2.default.createElement(
                'h2',
                { className: _UpgradeEffectContent2.default.title },
                _react2.default.createElement(
                    'span',
                    { className: _UpgradeEffectContent2.default.titleText },
                    _constants.MODERNIZATION_OVERLAY_TITLE
                )
            ),
            !hasPermission && !isMaxLevelReached && _react2.default.createElement(
                'div',
                { className: _UpgradeEffectContent2.default.warning },
                _react2.default.createElement(
                    _Warning2.default,
                    { type: 'warning' },
                    _constants2.PERMISSIONS_REQUIRED_MESSAGE
                )
            ),
            _react2.default.createElement(
                'div',
                { className: _UpgradeEffectContent2.default.description },
                isMaxLevelReached ? _constants2.MAX_COMMAND_CENTER_LEVEL_MESSAGE : (0, _constants2.UPGRADE_COMMAND_CENTER_DECRIPTION)(_react2.default.createElement(
                    'span',
                    { className: _UpgradeEffectContent2.default.nextLevel },
                    (0, _helpers.toRoman)(currentLevel + 1)
                ))
            )
        ),
        _react2.default.createElement(
            'div',
            { className: _UpgradeEffectContent2.default.content },
            _react2.default.createElement(
                'div',
                { className: _UpgradeEffectContent2.default.bonusHolder },
                _react2.default.createElement(_BaseBonusInfoTable2.default, {
                    classNames: {
                        title: _UpgradeEffectContent2.default.tableTitle
                    },
                    title: _constants2.COMMAND_CENTER_UPGRADE_TABLE_TITLE,
                    columns: columns,
                    selectedRow: currentLevel - 1,
                    dataSource: dataSource
                })
            )
        )
    );
};

UpgradeEffectContent.propTypes = {
    upgradeCosts: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired,
    requiredLevels: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired,
    currentLevel: _propTypes2.default.number.isRequired,
    hasPermission: _propTypes2.default.bool.isRequired
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
    var currentLevel = state.stronghold.level;
    var requiredLevels = [0].concat(_toConsumableArray(state.settings.command_center.required_total_stronghold_level_to_upgrade));
    var upgradeCosts = state.settings.command_center.costs;
    var hasPermission = (0, _accounts.canManageBuilding)(state.account);
    return {
        upgradeCosts: upgradeCosts,
        requiredLevels: requiredLevels,
        hasPermission: hasPermission,
        currentLevel: currentLevel
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(UpgradeEffectContent);

/***/ }),
/* 2144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.COMMAND_CENTER_UPGRADE_TABLE_TITLE = exports.MAX_COMMAND_CENTER_LEVEL_MESSAGE = exports.UPGRADE_COMMAND_CENTER_DECRIPTION = exports.PERMISSIONS_REQUIRED_MESSAGE = exports.UPGRADE_COMMAND_CENTER_COST_HEADER = exports.REQUIRED_BUILDINGS_LEVEL_SUMM_HEADER = exports.COMMAND_CENTER_LEVEL_HEADER = exports.UPGRADE_EFFECT_POPOVER_ID = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-multi-comp */
var UPGRADE_EFFECT_POPOVER_ID = exports.UPGRADE_EFFECT_POPOVER_ID = 'upgrade_effect_popover';

var COMMAND_CENTER_LEVEL_HEADER = exports.COMMAND_CENTER_LEVEL_HEADER = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'upgrade_effect_popover.command_center_level_header',
    defaultMessage: '\u0423\u0440\u043E\u0432\u0435\u043D\u044C \u041A\u043E\u043C\u043C\u0430\u043D\u0434\u043D\u043E\u0433\u043E \u0446\u0435\u043D\u0442\u0440\u0430'
});

var REQUIRED_BUILDINGS_LEVEL_SUMM_HEADER = exports.REQUIRED_BUILDINGS_LEVEL_SUMM_HEADER = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'upgrade_effect_popover.required_buildings_level_summ_header',
    defaultMessage: '\u0421\u0443\u043C\u043C\u0430\u0440\u043D\u044B\u0439 \u0443\u0440\u043E\u0432\u0435\u043D\u044C \u0441\u0442\u0440\u043E\u0435\u043D\u0438\u0439'
});

var UPGRADE_COMMAND_CENTER_COST_HEADER = exports.UPGRADE_COMMAND_CENTER_COST_HEADER = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'upgrade_effect_popover.upgrade_command_center_cost_header',
    defaultMessage: '\u0421\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C \u043C\u043E\u0434\u0435\u0440\u043D\u0438\u0437\u0430\u0446\u0438\u0438'
});

var PERMISSIONS_REQUIRED_MESSAGE = exports.PERMISSIONS_REQUIRED_MESSAGE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'upgrade_effect_popover.command_center_permissions_required_message',
    defaultMessage: '\u041C\u043E\u0434\u0435\u0440\u043D\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u041A\u043E\u043C\u0430\u043D\u0434\u043D\u044B\u0439 \u0446\u0435\u043D\u0442\u0440 \u043C\u043E\u0433\u0443\u0442 \u043A\u043E\u043C\u0430\u043D\u0434\u0443\u044E\u0449\u0438\u0439 \u0438 \u0435\u0433\u043E \u0437\u0430\u043C\u0435\u0441\u0442\u0438\u0442\u0435\u043B\u0438'
});

var UPGRADE_COMMAND_CENTER_DECRIPTION = exports.UPGRADE_COMMAND_CENTER_DECRIPTION = function UPGRADE_COMMAND_CENTER_DECRIPTION(level) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'upgrade_effect_popover.upgrade.command_center_description',
        defaultMessage: '\u041C\u043E\u0434\u0435\u0440\u043D\u0438\u0437\u0430\u0446\u0438\u044F \u041A\u043E\u043C\u0430\u043D\u0434\u043D\u043E\u0433\u043E \u0446\u0435\u043D\u0442\u0440\u0430 \u043F\u043E\u0437\u0432\u043E\u043B\u0438\u0442 \u043C\u043E\u0434\u0435\u0440\u043D\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043E\u0441\u0442\u0430\u043B\u044C\u043D\u044B\u0435 \u0441\u0442\u0440\u043E\u0435\u043D\u0438\u044F \u0434\u043E {level} \u0443\u0440\u043E\u0432\u043D\u044F',
        values: {
            level: level
        }
    });
};

var MAX_COMMAND_CENTER_LEVEL_MESSAGE = exports.MAX_COMMAND_CENTER_LEVEL_MESSAGE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'upgrade_effect_popover.max_command_center_level_message',
    defaultMessage: '\u041A\u043E\u043C\u0430\u043D\u0434\u043D\u044B\u0439 \u0446\u0435\u043D\u0442\u0440 \u043C\u043E\u0434\u0435\u0440\u043D\u0438\u0437\u0438\u0440\u043E\u0432\u0430\u043D \u0434\u043E \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0443\u0440\u043E\u0432\u043D\u044F'
});

var COMMAND_CENTER_UPGRADE_TABLE_TITLE = exports.COMMAND_CENTER_UPGRADE_TABLE_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'upgrade_effect_popover.command_center_upgrade_table_title',
    defaultMessage: '\u0423\u0441\u043B\u043E\u0432\u0438\u044F \u043C\u043E\u0434\u0435\u0440\u043D\u0438\u0437\u0430\u0446\u0438\u0438 \u043A\u043E\u043C\u0430\u043D\u0434\u043D\u043E\u0433\u043E \u0446\u0435\u043D\u0442\u0440\u0430 \u0432 \u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0441\u0442\u0438 \u043E\u0442 \u0435\u0433\u043E \u0443\u0440\u043E\u0432\u043D\u044F'
});

/***/ }),
/* 2145 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"header":"UpgradeEffectContent_header--lJ_12","title":"UpgradeEffectContent_title--3SRUx","base":"UpgradeEffectContent_base--1q0tY","tableTitle":"UpgradeEffectContent_tableTitle--37t6R","titleText":"UpgradeEffectContent_titleText--qaA5a","description":"UpgradeEffectContent_description--SDNlY","content":"UpgradeEffectContent_content--2arC-","bonusHolder":"UpgradeEffectContent_bonusHolder--1Kpp0","warning":"UpgradeEffectContent_warning--zFu4-","nextLevel":"UpgradeEffectContent_nextLevel--Hihpg"};

/***/ }),
/* 2146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Reward = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _helpers = __webpack_require__(11);

var _RewardReserve = __webpack_require__(1392);

var _RewardReserve2 = _interopRequireDefault(_RewardReserve);

var _Reward = __webpack_require__(2148);

var _Reward2 = _interopRequireDefault(_Reward);

var _constants = __webpack_require__(2149);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Reward = exports.Reward = function (_React$Component) {
    _inherits(Reward, _React$Component);

    function Reward() {
        _classCallCheck(this, Reward);

        return _possibleConstructorReturn(this, (Reward.__proto__ || Object.getPrototypeOf(Reward)).apply(this, arguments));
    }

    _createClass(Reward, [{
        key: 'reservesCounter',
        value: function reservesCounter(reserves) {
            var total = 0;
            reserves.forEach(function (reserve) {
                return total += reserve.count;
            });
            return total;
        }
    }, {
        key: 'render',
        value: function render() {
            var reward = this.props.reward;

            var count = this.reservesCounter(reward.reserves);
            var level = (0, _helpers.toRoman)(reward.rewardLevel);

            var reserves = reward.reserves.map(function (reserve) {
                return _react2.default.createElement(
                    'div',
                    { key: reserve.type, className: _Reward2.default.reserveItem },
                    _react2.default.createElement(_RewardReserve2.default, {
                        type: reserve.type,
                        count: reserve.count,
                        level: reward.rewardLevel
                    })
                );
            });

            return _react2.default.createElement(
                'div',
                { className: _Reward2.default.base },
                _react2.default.createElement(
                    'div',
                    { className: _Reward2.default.description },
                    _react2.default.createElement(
                        'span',
                        { className: _Reward2.default.reservesCount },
                        (0, _constants.REWARD_COUNT)(count, _react2.default.createElement(
                            'span',
                            { className: _Reward2.default.reservesLevel },
                            level
                        ))
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _Reward2.default.reservesList },
                    reserves
                )
            );
        }
    }]);

    return Reward;
}(_react2.default.Component);

Reward.propTypes = {
    reward: _propTypes2.default.shape({
        rewardLevel: _propTypes2.default.number,
        reserves: _propTypes2.default.arrayOf(_propTypes2.default.shape({
            type: _propTypes2.default.string,
            count: _propTypes2.default.number
        }))
    }).isRequired
};
exports.default = Reward;

/***/ }),
/* 2147 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"RewardReserve_base--2ve5V","base__artillery-strike":"RewardReserve_base__artillery-strike--1i8Fj","baseArtilleryStrike":"RewardReserve_base__artillery-strike--1i8Fj","base__elite":"RewardReserve_base__elite--150Hc","baseElite":"RewardReserve_base__elite--150Hc","base__airstrike":"RewardReserve_base__airstrike--8cyqu","baseAirstrike":"RewardReserve_base__airstrike--8cyqu","base__requisition":"RewardReserve_base__requisition--1yq9Z","baseRequisition":"RewardReserve_base__requisition--1yq9Z","base__high-capacity-transport":"RewardReserve_base__high-capacity-transport--GJrPv","baseHighCapacityTransport":"RewardReserve_base__high-capacity-transport--GJrPv","base__additional-briefing":"RewardReserve_base__additional-briefing--2DrZb","baseAdditionalBriefing":"RewardReserve_base__additional-briefing--2DrZb","base__tactical-training":"RewardReserve_base__tactical-training--1cJtA","baseTacticalTraining":"RewardReserve_base__tactical-training--1cJtA","base__military-maneuvers":"RewardReserve_base__military-maneuvers--2kclP","baseMilitaryManeuvers":"RewardReserve_base__military-maneuvers--2kclP","base__battle-payments":"RewardReserve_base__battle-payments--1GZg1","baseBattlePayments":"RewardReserve_base__battle-payments--1GZg1","base__inspiration":"RewardReserve_base__inspiration--7ph9E","baseInspiration":"RewardReserve_base__inspiration--7ph9E","base__adaptive":"RewardReserve_base__adaptive--hFeEJ","baseAdaptive":"RewardReserve_base__adaptive--hFeEJ","level":"RewardReserve_level--1WuAh","level-gradient":"RewardReserve_level-gradient--2Nczv","levelGradient":"RewardReserve_level-gradient--2Nczv","counter":"RewardReserve_counter--1X-Ry"};

/***/ }),
/* 2148 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Reward_base--1YEGN","description":"Reward_description--2FsJI","reservesCount":"Reward_reservesCount--3Cyi3","reservesLevel":"Reward_reservesLevel--1Z_MH","reservesList":"Reward_reservesList--2gfXl","reserveItem":"Reward_reserveItem--3UmlN"};

/***/ }),
/* 2149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.REWARD_COUNT = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REWARD_COUNT = exports.REWARD_COUNT = function REWARD_COUNT(count, level) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'command_center_reward.count',
        defaultMessage: '{count} \u043A\u043B\u0430\u043D\u043E\u0432\u044B\u0445 \u0440\u0435\u0437\u0435\u0440\u0432\u043E\u0432 {level} \u0443\u0440\u043E\u0432\u043D\u044F',
        values: {
            count: count,
            level: level
        }
    });
};

/***/ }),
/* 2150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MINIMUM_POSSIBLE_RESERVE_LEVEL = exports.RESERVE_TYPES_ORDER = exports.COMMAND_CENTER_REWARDS_TITLE = exports.COMMAND_CENTER_MODERNIZATION_PLAN_DESCRIPTION = exports.COMMAND_CENTER_UPGRADE_TOOLTIP_ID = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COMMAND_CENTER_UPGRADE_TOOLTIP_ID = exports.COMMAND_CENTER_UPGRADE_TOOLTIP_ID = 'command_center.upgrade_tooltip'; /* eslint-disable react/no-multi-comp */
var COMMAND_CENTER_MODERNIZATION_PLAN_DESCRIPTION = exports.COMMAND_CENTER_MODERNIZATION_PLAN_DESCRIPTION = function COMMAND_CENTER_MODERNIZATION_PLAN_DESCRIPTION(level) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'command_center.modernization_plan.description',
        defaultMessage: 'Позволяет модернизировать все строения до {level} уровня.',
        values: { level: level }
    });
};

var COMMAND_CENTER_REWARDS_TITLE = exports.COMMAND_CENTER_REWARDS_TITLE = function COMMAND_CENTER_REWARDS_TITLE(level) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'command_center.rewards.title',
        defaultMessage: 'Награда за модернизацию командного центра до {level} уровня',
        values: { level: level }
    });
};

var RESERVE_TYPES_ORDER = exports.RESERVE_TYPES_ORDER = [_constants.RESERVE_TYPES.MILITARY_MANEUVERS, _constants.RESERVE_TYPES.ADDITIONAL_BRIEFING, _constants.RESERVE_TYPES.BATTLE_PAYMENTS, _constants.RESERVE_TYPES.TACTICAL_TRAINING, _constants.RESERVE_TYPES.ARTILLERY_STRIKE, _constants.RESERVE_TYPES.INSPIRATION, _constants.RESERVE_TYPES.REQUISITION, _constants.RESERVE_TYPES.HIGH_CAPACITY_TRANSPORT];

var MINIMUM_POSSIBLE_RESERVE_LEVEL = exports.MINIMUM_POSSIBLE_RESERVE_LEVEL = 3;

/***/ }),
/* 2151 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"header":"CommandCenterCard_header--2PYe2","title":"CommandCenterCard_title--Du4kU","base":"CommandCenterCard_base--7fG4V","grid":"CommandCenterCard_grid--19l9S","cell":"CommandCenterCard_cell--3ejiH","overlay":"CommandCenterCard_overlay--1A8ZN","overlay__enabled":"CommandCenterCard_overlay__enabled--_hV4n","overlayEnabled":"CommandCenterCard_overlay__enabled--_hV4n","main":"CommandCenterCard_main--KfmB0","wrapper":"CommandCenterCard_wrapper--1vfmH","holder":"CommandCenterCard_holder--w8QHG","arrow":"CommandCenterCard_arrow--VXIbj","arrow__left":"CommandCenterCard_arrow__left--3KttN","arrowLeft":"CommandCenterCard_arrow__left--3KttN","arrow__right":"CommandCenterCard_arrow__right--UxUAV","arrowRight":"CommandCenterCard_arrow__right--UxUAV","level":"CommandCenterCard_level--PyTBb","levelShadow":"CommandCenterCard_levelShadow--2Rlvz","base__maxLevel":"CommandCenterCard_base__maxLevel--L95fD","baseMaxLevel":"CommandCenterCard_base__maxLevel--L95fD","heading":"CommandCenterCard_heading---_HTG","modernizationDescription":"CommandCenterCard_modernizationDescription--5ffF7","rewards":"CommandCenterCard_rewards--cQnVF","rewards__highlighted":"CommandCenterCard_rewards__highlighted--3Yz-M","rewardsHighlighted":"CommandCenterCard_rewards__highlighted--3Yz-M","rewardsDescription":"CommandCenterCard_rewardsDescription--1rHkE","planLevel":"CommandCenterCard_planLevel--3iKU3","planLevel__highlighted":"CommandCenterCard_planLevel__highlighted--xLZbL","planLevelHighlighted":"CommandCenterCard_planLevel__highlighted--xLZbL","tooltipInfo":"CommandCenterCard_tooltipInfo--3IIcQ"};

/***/ }),
/* 2152 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"BuildingView_base--2P3-c","view":"BuildingView_view--3RX5N","back":"BuildingView_back--1pf40","carousel":"BuildingView_carousel--2VG_R"};

/***/ }),
/* 2153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = exports.Construct = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(7);

var _reactRouterRedux = __webpack_require__(15);

var _urls = __webpack_require__(19);

var _constants = __webpack_require__(4);

var _reactWotBootstrap = __webpack_require__(5);

var _LackOfIndustrialResource = __webpack_require__(288);

var _LackOfIndustrialResource2 = _interopRequireDefault(_LackOfIndustrialResource);

var _Warning = __webpack_require__(107);

var _Warning2 = _interopRequireDefault(_Warning);

var _LoadingScreen = __webpack_require__(29);

var _LoadingScreen2 = _interopRequireDefault(_LoadingScreen);

var _IndustrialResource = __webpack_require__(35);

var _IndustrialResource2 = _interopRequireDefault(_IndustrialResource);

var _Back = __webpack_require__(70);

var _Back2 = _interopRequireDefault(_Back);

var _components = __webpack_require__(2154);

var _available_buildings = __webpack_require__(965);

var _available_buildings2 = _interopRequireDefault(_available_buildings);

var _building_construction = __webpack_require__(127);

var _sounds = __webpack_require__(22);

var _constants2 = __webpack_require__(2164);

var _i18n = __webpack_require__(10);

var _Construct = __webpack_require__(2165);

var _Construct2 = _interopRequireDefault(_Construct);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Construct = exports.Construct = function (_React$Component) {
    _inherits(Construct, _React$Component);

    function Construct(props) {
        _classCallCheck(this, Construct);

        var _this = _possibleConstructorReturn(this, (Construct.__proto__ || Object.getPrototypeOf(Construct)).call(this, props));

        _this.selectHandler = function (index) {
            return _this.props.selectBuilding(index);
        };
        _this.backHandler = props.pushState.bind(null, _urls.STRONGHOLD);
        _this.onKeyUp = _this.onKeyUp.bind(_this);
        _this.handleBuildButtonClick = props.openConstructConfirmation;
        return _this;
    }

    _createClass(Construct, [{
        key: 'onKeyUp',
        value: function onKeyUp(e) {
            if (e.keyCode === _constants.KEY_CODES.ESCAPE && !this.props.confirmationOpened) {
                this.backHandler();
            }
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.props.requestAvailableBuildings();
            window.addEventListener('keydown', this.onKeyUp);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('keydown', this.onKeyUp);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            // if there no available buildings had been returned send user back to stronghold
            // here we asssume that user will receive update with new building by websocket
            if (nextProps.buildings.length === 0 && nextProps.loaded) {
                this.props.pushState(_urls.STRONGHOLD);
            }

            if (!this.props.submitted && nextProps.submitted) {
                this.props.pushState(_urls.STRONGHOLD);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var loadingScreen = _react2.default.createElement(_LoadingScreen2.default, null);
            var component = void 0;
            if (this.props.loading || !this.props.loaded) {
                component = loadingScreen;
            } else {
                if (this.props.buildings.length === 0) return null;

                var building = this.props.buildings[this.props.selectedBuildingIdx].building;

                var reserveType = this.props.settings.buildings[building.type].reserve_type;
                var reserveInfo = this.props.settings.reserves[reserveType];
                var hasEnoughIndustrialResource = this.props.clanIndustrialResource >= building.cost;
                var title = this.props.hasPermission ? _constants2.CONSTRUCT_HEADERS.title : _constants2.CONSTRUCT_HEADERS.title_no_permission;

                var constructCost = _react2.default.createElement(
                    'p',
                    { className: _Construct2.default.cost, 'data-tip': true, 'data-for': _constants2.NOT_ENOUGH_TOOLTIP_ID },
                    _constants2.CONSTRUCTION_COST,
                    _react2.default.createElement(_IndustrialResource2.default, { value: building.cost, notEnough: !hasEnoughIndustrialResource })
                );

                var constructFooter = void 0;
                if (this.props.hasPermission) {
                    var tooltip = void 0;
                    if (!hasEnoughIndustrialResource) {
                        var industrialResource = _react2.default.createElement(_IndustrialResource2.default, {
                            value: building.cost - this.props.clanIndustrialResource,
                            notEnough: false,
                            small: true
                        });

                        tooltip = _react2.default.createElement(
                            _reactWotBootstrap.Tooltip,
                            { id: _constants2.NOT_ENOUGH_TOOLTIP_ID },
                            _react2.default.createElement(_LackOfIndustrialResource2.default, { resource: industrialResource })
                        );
                    }

                    constructFooter = _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            _reactWotBootstrap.Button,
                            {
                                onClick: this.handleBuildButtonClick,
                                isDisabled: !hasEnoughIndustrialResource,
                                tooltipId: !hasEnoughIndustrialResource ? _constants2.NOT_ENOUGH_TOOLTIP_ID : null
                            },
                            _constants2.BUILD_BUTTON_CAPTION
                        ),
                        _react2.default.createElement(_components.ConstructConfirmation, { slotId: this.props.slotId, building: building }),
                        tooltip
                    );
                } else {
                    constructFooter = _react2.default.createElement(
                        'div',
                        { className: _Construct2.default.warning },
                        _react2.default.createElement(
                            _Warning2.default,
                            null,
                            _constants2.PERMISSION_WARNING
                        )
                    );
                }

                component = _react2.default.createElement(
                    'div',
                    { className: _Construct2.default.holder },
                    _react2.default.createElement(
                        'div',
                        { className: _Construct2.default.header },
                        _react2.default.createElement(
                            'div',
                            { className: 'contstruct_centered' },
                            _react2.default.createElement(
                                'div',
                                { className: _Construct2.default.titleWrapper },
                                _react2.default.createElement(
                                    'div',
                                    { className: _Construct2.default.back },
                                    _react2.default.createElement(_Back2.default, { handleClick: this.backHandler })
                                ),
                                _react2.default.createElement(
                                    'h1',
                                    { className: _Construct2.default.title },
                                    title
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _Construct2.default.main },
                        _react2.default.createElement(
                            'div',
                            { className: _Construct2.default.centered },
                            _react2.default.createElement(_components.ConstructCarousel, {
                                onItemClick: this.selectHandler,
                                onItemHover: this.props.playCarouselHoverSound,
                                selectedBuildingIdx: this.props.selectedBuildingIdx,
                                buildings: this.props.buildings
                            }),
                            _react2.default.createElement(_components.ConstructReserve, {
                                name: _i18n.RESERVE_TITLES[reserveInfo.type],
                                type: reserveInfo.type,
                                description: _constants2.RESERVE_DESCRIPTIONS[reserveInfo.type],
                                bonus: reserveInfo.bonus
                            })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _Construct2.default.footer },
                        _react2.default.createElement(
                            'div',
                            null,
                            constructCost,
                            constructFooter
                        )
                    ),
                    this.props.submitting ? loadingScreen : null
                );
            }

            return _react2.default.createElement(
                'div',
                { className: _Construct2.default.base },
                component
            );
        }
    }]);

    return Construct;
}(_react2.default.Component);

Construct.propTypes = {
    loaded: _propTypes2.default.bool.isRequired,
    loading: _propTypes2.default.bool.isRequired,
    submitting: _propTypes2.default.bool.isRequired,
    submitted: _propTypes2.default.bool.isRequired,
    confirmationOpened: _propTypes2.default.bool.isRequired,
    slotId: _propTypes2.default.number.isRequired,
    buildings: _propTypes2.default.arrayOf(_propTypes2.default.object),
    selectedBuildingIdx: _propTypes2.default.number.isRequired,
    hasPermission: _propTypes2.default.bool.isRequired,
    clanIndustrialResource: _propTypes2.default.number.isRequired,
    settings: _propTypes2.default.object.isRequired,

    selectBuilding: _propTypes2.default.func.isRequired,
    openConstructConfirmation: _propTypes2.default.func.isRequired,
    requestAvailableBuildings: _propTypes2.default.func.isRequired,
    playCarouselHoverSound: _propTypes2.default.func.isRequired,
    pushState: _propTypes2.default.func.isRequired
};
var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
    var slotId = parseInt(ownProps.params.slotId);
    var account = state.account,
        clan = state.clan,
        settings = state.settings;
    var _state$availableBuild = state.availableBuildings,
        loading = _state$availableBuild.loading,
        loaded = _state$availableBuild.loaded,
        buildings = _state$availableBuild.buildings,
        selectedBuildingIdx = _state$availableBuild.selectedBuildingIdx;
    var _state$buildingConstr = state.buildingConstruction,
        submitting = _state$buildingConstr.submitting,
        submitted = _state$buildingConstr.submitted;

    var clanIndustrialResource = clan ? clan.industrial_resource : 0;
    var hasPermission = account.permissions.manage_building === true;
    var confirmationOpened = state.buildingConstruction.confirmationOpened;
    return {
        slotId: slotId,
        buildings: buildings,
        selectedBuildingIdx: selectedBuildingIdx,
        loading: loading,
        loaded: loaded,
        submitting: submitting,
        submitted: submitted,
        clanIndustrialResource: clanIndustrialResource,
        hasPermission: hasPermission,
        settings: settings,
        confirmationOpened: confirmationOpened
    };
};

var mapDispatchToProps = exports.mapDispatchToProps = {
    requestAvailableBuildings: _available_buildings2.default,
    selectBuilding: _available_buildings.selectBuilding,
    openConstructConfirmation: _building_construction.openConstructConfirmation,
    playCarouselHoverSound: _sounds.playCarouselHoverSound,
    pushState: _reactRouterRedux.push
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Construct);

/***/ }),
/* 2154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConstructReserveTooltip = exports.ConstructReserve = exports.ConstructCarousel = exports.ConstructBuilding = exports.ConstructConfirmation = undefined;

var _ConstructConfirmation2 = __webpack_require__(2155);

var _ConstructConfirmation3 = _interopRequireDefault(_ConstructConfirmation2);

var _ConstructBuilding2 = __webpack_require__(1337);

var _ConstructBuilding3 = _interopRequireDefault(_ConstructBuilding2);

var _ConstructCarousel2 = __webpack_require__(2158);

var _ConstructCarousel3 = _interopRequireDefault(_ConstructCarousel2);

var _ConstructReserve2 = __webpack_require__(2160);

var _ConstructReserve3 = _interopRequireDefault(_ConstructReserve2);

var _ConstructReserveTooltip2 = __webpack_require__(1338);

var _ConstructReserveTooltip3 = _interopRequireDefault(_ConstructReserveTooltip2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ConstructConfirmation = _ConstructConfirmation3.default;
exports.ConstructBuilding = _ConstructBuilding3.default;
exports.ConstructCarousel = _ConstructCarousel3.default;
exports.ConstructReserve = _ConstructReserve3.default;
exports.ConstructReserveTooltip = _ConstructReserveTooltip3.default;

/***/ }),
/* 2155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapStateToProps = exports.ConstructConfirmation = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(7);

var _Confirmation = __webpack_require__(1327);

var _Confirmation2 = _interopRequireDefault(_Confirmation);

var _IndustrialResource = __webpack_require__(35);

var _IndustrialResource2 = _interopRequireDefault(_IndustrialResource);

var _building_construction = __webpack_require__(127);

var _building_construction2 = _interopRequireDefault(_building_construction);

var _i18n = __webpack_require__(10);

var _constants = __webpack_require__(2156);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ConstructConfirmation = exports.ConstructConfirmation = function (_React$Component) {
    _inherits(ConstructConfirmation, _React$Component);

    function ConstructConfirmation() {
        _classCallCheck(this, ConstructConfirmation);

        return _possibleConstructorReturn(this, (ConstructConfirmation.__proto__ || Object.getPrototypeOf(ConstructConfirmation)).apply(this, arguments));
    }

    _createClass(ConstructConfirmation, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                _Confirmation2.default,
                {
                    title: _constants.CONSTRUCT_CONFIRMATION_TITLE,
                    submitCaption: _constants.CONSTRUCT_CONFIRMATION_SUBMIT,
                    closeCaption: _i18n.CANCEL,
                    opened: this.props.opened,
                    onSubmit: this.props.constructBuilding.bind(null, this.props.slotId, this.props.building.type),
                    onClose: this.props.handleClose
                },
                _react2.default.createElement(
                    'p',
                    null,
                    (0, _constants.CONSTRUCT_CONFIRMATION_QUESTION)(_i18n.BUILDING_TITLES[this.props.building.type], _react2.default.createElement(_IndustrialResource2.default, { value: this.props.constructCost, small: true }))
                )
            );
        }
    }]);

    return ConstructConfirmation;
}(_react2.default.Component);

ConstructConfirmation.propTypes = {
    slotId: _propTypes2.default.number.isRequired,
    building: _propTypes2.default.object.isRequired,
    constructCost: _propTypes2.default.number.isRequired,
    opened: _propTypes2.default.bool.isRequired,
    constructBuilding: _propTypes2.default.func.isRequired,
    handleClose: _propTypes2.default.func.isRequired
};
var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, _ref) {
    var slotId = _ref.slotId,
        building = _ref.building;
    return {
        opened: state.buildingConstruction.confirmationOpened,
        slotId: slotId,
        building: building,
        constructCost: state.settings.buildings[building.type].costs[0]
    };
};

var mapDispatchToProps = {
    constructBuilding: _building_construction2.default,
    handleClose: _building_construction.closeConstructConfirmation
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ConstructConfirmation);

/***/ }),
/* 2156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CONSTRUCT_CONFIRMATION_QUESTION = exports.CONSTRUCT_CONFIRMATION_SUBMIT = exports.CONSTRUCT_CONFIRMATION_TITLE = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CONSTRUCT_CONFIRMATION_TITLE = exports.CONSTRUCT_CONFIRMATION_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'building_construct_confirmation.title',
    defaultMessage: 'Подтверждение строительства'
});

var CONSTRUCT_CONFIRMATION_SUBMIT = exports.CONSTRUCT_CONFIRMATION_SUBMIT = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'building_construct_confirmation.submit',
    defaultMessage: 'Подтвердить'
});

var CONSTRUCT_CONFIRMATION_QUESTION = exports.CONSTRUCT_CONFIRMATION_QUESTION = function CONSTRUCT_CONFIRMATION_QUESTION(buildingName, industrialResource) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'building_construct_confirmation.construct_confirmation_question',
        defaultMessage: '\u0412\u043E\u0437\u0432\u0435\u0441\u0442\u0438 \u0441\u0442\u0440\u043E\u0435\u043D\u0438\u0435 {buildingName} \u0437\u0430 {industrialResource}\xA0?',
        values: {
            industrialResource: industrialResource,
            buildingName: buildingName
        }
    });
};

/***/ }),
/* 2157 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"ConstructBuilding_base--3CxO2","base__active":"ConstructBuilding_base__active--1Rwo6","baseActive":"ConstructBuilding_base__active--1Rwo6","caption":"ConstructBuilding_caption--2-T5c","thumbnail":"ConstructBuilding_thumbnail--3Ops2","image":"ConstructBuilding_image--3_BnO","image__attack-bomber-squadrons":"ConstructBuilding_image__attack-bomber-squadrons--3Z1yn","imageAttackBomberSquadrons":"ConstructBuilding_image__attack-bomber-squadrons--3Z1yn","image__training-unit":"ConstructBuilding_image__training-unit--BX6f_","imageTrainingUnit":"ConstructBuilding_image__training-unit--BX6f_","image__tankodrome":"ConstructBuilding_image__tankodrome--1dY1I","imageTankodrome":"ConstructBuilding_image__tankodrome--1dY1I","image__financial-unit":"ConstructBuilding_image__financial-unit--EGt-S","imageFinancialUnit":"ConstructBuilding_image__financial-unit--EGt-S","image__transportation-unit":"ConstructBuilding_image__transportation-unit--2mO3e","imageTransportationUnit":"ConstructBuilding_image__transportation-unit--2mO3e","image__trophy-brigade":"ConstructBuilding_image__trophy-brigade--3svc0","imageTrophyBrigade":"ConstructBuilding_image__trophy-brigade--3svc0","image__artillery-battalion":"ConstructBuilding_image__artillery-battalion--22LPJ","imageArtilleryBattalion":"ConstructBuilding_image__artillery-battalion--22LPJ","image__military-school":"ConstructBuilding_image__military-school--2pzkY","imageMilitarySchool":"ConstructBuilding_image__military-school--2pzkY","image__home-front-service":"ConstructBuilding_image__home-front-service--cLy84","imageHomeFrontService":"ConstructBuilding_image__home-front-service--cLy84","shadow":"ConstructBuilding_shadow--6LIwb"};

/***/ }),
/* 2158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _NavigationArrow = __webpack_require__(59);

var _NavigationArrow2 = _interopRequireDefault(_NavigationArrow);

var _ConstructBuilding = __webpack_require__(1337);

var _ConstructBuilding2 = _interopRequireDefault(_ConstructBuilding);

var _ConstructCarousel = __webpack_require__(2159);

var _ConstructCarousel2 = _interopRequireDefault(_ConstructCarousel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConstructCarousel = function ConstructCarousel(_ref) {
    var buildings = _ref.buildings,
        selectedBuildingIdx = _ref.selectedBuildingIdx,
        onItemClick = _ref.onItemClick,
        onItemHover = _ref.onItemHover;

    var isFirstSlide = selectedBuildingIdx === 0;
    var isLastSlide = selectedBuildingIdx === buildings.length - 1;

    var handleNextClick = function handleNextClick() {
        if (!isLastSlide) {
            onItemClick(selectedBuildingIdx + 1);
        }
    };

    var handlePrevClick = function handlePrevClick() {
        if (!isFirstSlide) {
            onItemClick(selectedBuildingIdx - 1);
        }
    };

    var handleSlideItemClick = function handleSlideItemClick(itemIndex, isItemActive) {
        if (!isItemActive) {
            onItemClick(itemIndex);
        }
    };

    var handleSlideItemMouseEnter = function handleSlideItemMouseEnter(isItemActive) {
        if (!isItemActive) {
            onItemHover();
        }
    };

    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_ConstructCarousel2.default.base, _ConstructCarousel2.default['base__selected-item-' + selectedBuildingIdx]) },
        _react2.default.createElement(
            'div',
            { className: _ConstructCarousel2.default.holder },
            _react2.default.createElement(
                'div',
                { className: _ConstructCarousel2.default.list },
                buildings.map(function (_ref2, index) {
                    var building = _ref2.building;

                    var isActive = index === selectedBuildingIdx;

                    return _react2.default.createElement(
                        'div',
                        {
                            className: (0, _classnames2.default)(_ConstructCarousel2.default.item, isActive && _ConstructCarousel2.default.item__active),
                            key: building.type,
                            onClick: function onClick() {
                                return handleSlideItemClick(index, isActive);
                            },
                            onMouseEnter: function onMouseEnter() {
                                return handleSlideItemMouseEnter(isActive);
                            }
                        },
                        _react2.default.createElement(_ConstructBuilding2.default, _extends({ isActive: isActive }, building))
                    );
                })
            )
        ),
        _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)(_ConstructCarousel2.default.arrow, _ConstructCarousel2.default.arrow__left) },
            _react2.default.createElement(_NavigationArrow2.default, { type: 'left', handleClick: handlePrevClick, disabled: isFirstSlide })
        ),
        _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)(_ConstructCarousel2.default.arrow, _ConstructCarousel2.default.arrow__right) },
            _react2.default.createElement(_NavigationArrow2.default, { type: 'right', handleClick: handleNextClick, disabled: isLastSlide })
        )
    );
};

ConstructCarousel.propTypes = {
    buildings: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
    onItemClick: _propTypes2.default.func.isRequired,
    onItemHover: _propTypes2.default.func.isRequired,
    selectedBuildingIdx: _propTypes2.default.number.isRequired
};

exports.default = ConstructCarousel;

/***/ }),
/* 2159 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"ConstructCarousel_base--2R3o5","holder":"ConstructCarousel_holder--2Gf-j","list":"ConstructCarousel_list--26DIU","base__selected-item-0":"ConstructCarousel_base__selected-item-0--1vzmP","baseSelectedItem0":"ConstructCarousel_base__selected-item-0--1vzmP","base__selected-item-1":"ConstructCarousel_base__selected-item-1--2pW5K","baseSelectedItem1":"ConstructCarousel_base__selected-item-1--2pW5K","base__selected-item-2":"ConstructCarousel_base__selected-item-2--3EyTV","baseSelectedItem2":"ConstructCarousel_base__selected-item-2--3EyTV","base__selected-item-3":"ConstructCarousel_base__selected-item-3--sP2sd","baseSelectedItem3":"ConstructCarousel_base__selected-item-3--sP2sd","base__selected-item-4":"ConstructCarousel_base__selected-item-4--2VPXj","baseSelectedItem4":"ConstructCarousel_base__selected-item-4--2VPXj","base__selected-item-5":"ConstructCarousel_base__selected-item-5--3L2-P","baseSelectedItem5":"ConstructCarousel_base__selected-item-5--3L2-P","base__selected-item-6":"ConstructCarousel_base__selected-item-6--2XoUp","baseSelectedItem6":"ConstructCarousel_base__selected-item-6--2XoUp","base__selected-item-7":"ConstructCarousel_base__selected-item-7--2mOv_","baseSelectedItem7":"ConstructCarousel_base__selected-item-7--2mOv_","base__selected-item-8":"ConstructCarousel_base__selected-item-8--2Z8WC","baseSelectedItem8":"ConstructCarousel_base__selected-item-8--2Z8WC","base__selected-item-9":"ConstructCarousel_base__selected-item-9--2TqCV","baseSelectedItem9":"ConstructCarousel_base__selected-item-9--2TqCV","item":"ConstructCarousel_item--1TReL","item__active":"ConstructCarousel_item__active--AQ4F2","itemActive":"ConstructCarousel_item__active--AQ4F2","arrow":"ConstructCarousel_arrow--5VQ2L","arrow__left":"ConstructCarousel_arrow__left--3UlgM","arrowLeft":"ConstructCarousel_arrow__left--3UlgM","arrow__right":"ConstructCarousel_arrow__right--KOQ8y","arrowRight":"ConstructCarousel_arrow__right--KOQ8y"};

/***/ }),
/* 2160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _ConstructReserveTooltip = __webpack_require__(1338);

var _ConstructReserveTooltip2 = _interopRequireDefault(_ConstructReserveTooltip);

var _helpers = __webpack_require__(11);

var _i18n = __webpack_require__(10);

var _constants = __webpack_require__(2163);

var _constants2 = __webpack_require__(4);

var _ConstructReserve = __webpack_require__(1339);

var _ConstructReserve2 = _interopRequireDefault(_ConstructReserve);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConstructReserve = function ConstructReserve(_ref) {
    var bonus = _ref.bonus,
        type = _ref.type,
        name = _ref.name,
        description = _ref.description;

    var maxBonus = bonus.values[_constants2.MAX_BUILDING_LEVEL - 1];

    var reserveDescription = function () {
        if (!maxBonus.parameters) {
            return;
        }

        switch (type) {
            case _constants2.RESERVE_TYPES.ARTILLERY_STRIKE:
                return [(0, _constants.MAX_DAMAGE_FOR_VEHICLE_LEVELS)(maxBonus.parameters.maxDamage), (0, _constants.RANGE_OF_AFFECTED_AREA)(maxBonus.parameters.areaRadius), (0, _constants.ARTILLERY_STRIKE_INDUSTRIAL_RESOURCE_BONUS)(maxBonus.battle_types.battle_for_stronghold_and_sortie)];
            case _constants2.RESERVE_TYPES.INSPIRATION:
                return [(0, _constants.CREW_EFFECTIVITY_BONUS)(maxBonus.parameters.crewRolesFactor), (0, _constants.RANGE_OF_ACTION)(maxBonus.parameters.commonAreaRadius), (0, _constants.INSPIRATION_INDUSTRIAL_RESOURCE_BONUS)(maxBonus.battle_types.battle_for_stronghold_and_sortie)];
        }
    }();

    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_ConstructReserve2.default.base, _ConstructReserve2.default['base__' + (0, _helpers.toCssClass)(type)]) },
        _react2.default.createElement(_ConstructReserveTooltip2.default, {
            reserveType: type,
            bonus: bonus
        }),
        _react2.default.createElement('div', { className: _ConstructReserve2.default.image }),
        _react2.default.createElement(
            'h3',
            { className: _ConstructReserve2.default.name },
            name
        ),
        _react2.default.createElement(
            'p',
            { className: _ConstructReserve2.default.description },
            description,
            _react2.default.createElement('span', { className: _ConstructReserve2.default.info, 'data-tip': true, 'data-for': type })
        ),
        _react2.default.createElement(
            'div',
            { className: _ConstructReserve2.default.bonuses },
            reserveDescription ? _react2.default.createElement(
                'div',
                { className: _ConstructReserve2.default.bonus },
                reserveDescription.map(function (description, index) {
                    return _react2.default.createElement(
                        'div',
                        { key: index },
                        description
                    );
                })
            ) : Object.keys(maxBonus.battle_types).map(function (battleType) {
                return _react2.default.createElement(
                    'div',
                    { className: _ConstructReserve2.default.bonus, key: battleType + '_item' },
                    _react2.default.createElement(
                        'div',
                        { className: _ConstructReserve2.default.value },
                        _react2.default.createElement(
                            'div',
                            { className: (0, _classnames2.default)(_ConstructReserve2.default.rate, _ConstructReserve2.default.rate__prefix) },
                            _constants.BEFORE_PREFIX
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: (0, _classnames2.default)(_ConstructReserve2.default.rate, _ConstructReserve2.default.rate__sign) },
                            '+'
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: (0, _classnames2.default)(_ConstructReserve2.default.rate, _ConstructReserve2.default.rate__value) },
                            maxBonus.battle_types[battleType]
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _ConstructReserve2.default.condition },
                        _react2.default.createElement(
                            'div',
                            { className: _ConstructReserve2.default.target },
                            _i18n.BONUS_TYPE_MESSAGES[bonus.type]
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _ConstructReserve2.default.where },
                            bonus.type === _constants2.BONUS_TYPES.EXTRA_CREDITS && battleType === _constants2.BATTLE_TYPES.RANDOM_BATTLES ? _constants.BATTLE_TYPE_MESSAGES[_constants2.BATTLE_TYPES.RANDOM_BATTLES_AND_STEEL_HUNTER] : _constants.BATTLE_TYPE_MESSAGES[battleType]
                        )
                    )
                );
            })
        )
    );
};
ConstructReserve.propTypes = {
    name: _propTypes2.default.object.isRequired,
    type: _propTypes2.default.string.isRequired,
    description: _propTypes2.default.node.isRequired,
    bonus: _propTypes2.default.object.isRequired
};

exports.default = ConstructReserve;

/***/ }),
/* 2161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WINS_ONLY_MESSAGE = exports.ALL_RESULTS_MESSAGE = exports.HEADERS = exports.EXTRA_DESCRIPTIONS = exports.BONUS_TYPE_MESSAGES = undefined;

var _BONUS_TYPE_MESSAGES, _EXTRA_DESCRIPTIONS, _HEADERS;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint-disable react/no-multi-comp */


var BONUS_TYPE_MESSAGES = exports.BONUS_TYPE_MESSAGES = (_BONUS_TYPE_MESSAGES = {}, _defineProperty(_BONUS_TYPE_MESSAGES, _constants.BONUS_TYPES.EXTRA_CREDITS, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'construct_reserve_popover.bonus_types.extra_credits_title',
    defaultMessage: '\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u043A\u0440\u0435\u0434\u0438\u0442\u044B'
})), _defineProperty(_BONUS_TYPE_MESSAGES, _constants.BONUS_TYPES.EXTRA_FREE_XP, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'construct_reserve_popover.bonus_types.extra_free_xp_title',
    defaultMessage: '\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u0441\u0432\u043E\u0431\u043E\u0434\u043D\u044B\u0439 \u043E\u043F\u044B\u0442'
})), _defineProperty(_BONUS_TYPE_MESSAGES, _constants.BONUS_TYPES.EXTRA_BATTLE_XP, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'construct_reserve_popover.bonus_types.extra_battle_xp_title',
    defaultMessage: '\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u0431\u043E\u0435\u0432\u043E\u0439 \u043E\u043F\u044B\u0442'
})), _defineProperty(_BONUS_TYPE_MESSAGES, _constants.BONUS_TYPES.EXTRA_CREW_XP, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'construct_reserve_popover.bonus_types.extra_crew_xp_title',
    defaultMessage: '\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u043E\u043F\u044B\u0442 \u044D\u043A\u0438\u043F\u0430\u0436\u0430'
})), _BONUS_TYPE_MESSAGES);

var EXTRA_DESCRIPTIONS = exports.EXTRA_DESCRIPTIONS = (_EXTRA_DESCRIPTIONS = {}, _defineProperty(_EXTRA_DESCRIPTIONS, _constants.RESERVE_TYPES.AIRSTRIKE, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'construct_reserve_popover.extra_descriptions.airstrike',
    defaultMessage: '\u041F\u0440\u0438 \u0432\u044B\u0437\u043E\u0432\u0435 \u0430\u0432\u0438\u0430\u0443\u0434\u0430\u0440\u0430'
})), _defineProperty(_EXTRA_DESCRIPTIONS, _constants.RESERVE_TYPES.ARTILLERY_STRIKE, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'construct_reserve_popover.extra_descriptions.artillery_strike',
    defaultMessage: '\u0412 \u0412\u044B\u043B\u0430\u0437\u043A\u0430\u0445 \u0438 \u043F\u0440\u0438 \u041D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u044F\u0445  \u043D\u0430 1 \u0431\u043E\u0439'
})), _defineProperty(_EXTRA_DESCRIPTIONS, _constants.RESERVE_TYPES.INSPIRATION, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'construct_reserve_popover.extra_descriptions.inspiration',
    defaultMessage: '\u0412 \u0412\u044B\u043B\u0430\u0437\u043A\u0430\u0445 \u0438 \u043F\u0440\u0438 \u041D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u044F\u0445'
})), _EXTRA_DESCRIPTIONS);

var HEADERS = exports.HEADERS = (_HEADERS = {
    SINGLE_USAGE: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'construct_reserve_popover.single_usage_title',
        defaultMessage: '\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u043F\u0440\u043E\u043C\u0440\u0435\u0441\u0443\u0440\u0441 \u043D\u0430 1 \u0431\u043E\u0439'
    })
}, _defineProperty(_HEADERS, _constants.RESERVE_TYPES.REQUISITION, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'construct_reserve_popover.requisition_usage_title',
    defaultMessage: '\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u043F\u0440\u043E\u043C\u0440\u0435\u0441\u0443\u0440\u0441 \u043D\u0430 1 \u041D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u0435'
})), _defineProperty(_HEADERS, _constants.RESERVE_TYPES.INSPIRATION, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'construct_reserve_popover.inspiration_usage_title',
    defaultMessage: '\u0412\u043E\u043E\u0434\u0443\u0448\u0435\u0432\u043B\u0435\u043D\u0438\u0435 \u043D\u0430 1 \u0431\u043E\u0439'
})), _defineProperty(_HEADERS, _constants.RESERVE_TYPES.ARTILLERY_STRIKE, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'construct_reserve_popover.art_usage_title',
    defaultMessage: '\u0410\u0440\u0442\u043E\u0431\u0441\u0442\u0440\u0435\u043B'
})), _HEADERS);

var ALL_RESULTS_MESSAGE = exports.ALL_RESULTS_MESSAGE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'construct_reserve_popover.all_results',
    defaultMessage: '\u0414\u043B\u044F \u0432\u0441\u0435\u0445 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u043E\u0432'
});

var WINS_ONLY_MESSAGE = exports.WINS_ONLY_MESSAGE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'construct_reserve_popover.only_wins',
    defaultMessage: '\u0422\u043E\u043B\u044C\u043A\u043E \u0434\u043B\u044F \u043F\u043E\u0431\u0435\u0434'
});

/***/ }),
/* 2162 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"infoTable__battlePayments":"ConstructReserveTooltip_infoTable__battlePayments--11nSZ","infoTableBattlePayments":"ConstructReserveTooltip_infoTable__battlePayments--11nSZ","infoTable__additionalBriefing":"ConstructReserveTooltip_infoTable__additionalBriefing--3UjF3","infoTableAdditionalBriefing":"ConstructReserveTooltip_infoTable__additionalBriefing--3UjF3"};

/***/ }),
/* 2163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ARTILLERY_STRIKE_INDUSTRIAL_RESOURCE_BONUS = exports.INSPIRATION_INDUSTRIAL_RESOURCE_BONUS = exports.RANGE_OF_AFFECTED_AREA = exports.MAX_DAMAGE_FOR_VEHICLE_LEVELS = exports.RANGE_OF_ACTION = exports.CREW_EFFECTIVITY_BONUS = exports.BEFORE_PREFIX = exports.BATTLE_TYPE_MESSAGES = undefined;

var _BATTLE_TYPE_MESSAGES;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _constants = __webpack_require__(4);

var _ConstructReserve = __webpack_require__(1339);

var _ConstructReserve2 = _interopRequireDefault(_ConstructReserve);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint-disable react/no-multi-comp */

// almost the same text contains in helpers/i18n but here the are lowercase
// if it posible to fix it with css delete this texts and use from helpers
var BATTLE_TYPE_MESSAGES = exports.BATTLE_TYPE_MESSAGES = (_BATTLE_TYPE_MESSAGES = {}, _defineProperty(_BATTLE_TYPE_MESSAGES, _constants.BATTLE_TYPES.ALL_BATTLES, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'construct_reserve.battle_types.all_battles',
    defaultMessage: '\u0432\u043E \u0432\u0441\u0435\u0445 \u0440\u0435\u0436\u0438\u043C\u0430\u0445 \u0431\u043E\u0435\u0432'
})), _defineProperty(_BATTLE_TYPE_MESSAGES, _constants.BATTLE_TYPES.RANDOM_BATTLES, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'construct_reserve.battle_types.random_battles',
    defaultMessage: '\u0432 \u0421\u043B\u0443\u0447\u0430\u0439\u043D\u044B\u0445 \u0431\u043E\u044F\u0445 \u0438 \u043D\u0430 \u041B\u0438\u043D\u0438\u0438 \u0444\u0440\u043E\u043D\u0442\u0430'
})), _defineProperty(_BATTLE_TYPE_MESSAGES, _constants.BATTLE_TYPES.RANDOM_BATTLES_AND_STEEL_HUNTER, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'construct_reserve.battle_types.random_battles_and_steel_hunter',
    defaultMessage: '\u0432 \u0421\u043B\u0443\u0447\u0430\u0439\u043D\u044B\u0445 \u0431\u043E\u044F\u0445, \u0430 \u0442\u0430\u043A\u0436\u0435 \u043D\u0430 \u041B\u0438\u043D\u0438\u0438 \u0444\u0440\u043E\u043D\u0442\u0430 \u0438 \u0432 \u0421\u0442\u0430\u043B\u044C\u043D\u043E\u043C \u043E\u0445\u043E\u0442\u043D\u0438\u043A\u0435'
})), _defineProperty(_BATTLE_TYPE_MESSAGES, _constants.BATTLE_TYPES.CLAN_BATTLES, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'construct_reserve.battle_types.clan_battles',
    defaultMessage: '\u0432 \u043A\u043B\u0430\u043D\u043E\u0432\u044B\u0445 \u0438 \u0442\u0443\u0440\u043D\u0438\u0440\u043D\u044B\u0445 \u0431\u043E\u044F\u0445'
})), _defineProperty(_BATTLE_TYPE_MESSAGES, _constants.BATTLE_TYPES.SORTIE, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'construct_reserve.battle_types.sortie',
    defaultMessage: '\u0432 \u0412\u044B\u043B\u0430\u0437\u043A\u0430\u0445'
})), _defineProperty(_BATTLE_TYPE_MESSAGES, _constants.BATTLE_TYPES.BATTLE_FOR_STRONGHOLD, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'construct_reserve.battle_types.battles_for_stronghold',
    defaultMessage: '\u0437\u0430 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442 \u043F\u0440\u043E\u0432\u0435\u0434\u0451\u043D\u043D\u043E\u0433\u043E \u041D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u044F'
})), _defineProperty(_BATTLE_TYPE_MESSAGES, _constants.BATTLE_TYPES.BATTLE_FOR_STRONGHOLD_AND_SORTIE, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'construct_reserve.battles_types.battle_for_stronghold_and_sortie',
    defaultMessage: '\u0432 \u0412\u044B\u043B\u0430\u0437\u043A\u0430\u0445 \u0438 \u043F\u0440\u0438 \u041D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u044F\u0445 \u043D\u0430 1 \u0431\u043E\u0439'
})), _BATTLE_TYPE_MESSAGES);

var BEFORE_PREFIX = exports.BEFORE_PREFIX = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'construct_reserve.before_prefix',
    defaultMessage: '\u0434\u043E'
});

var CREW_EFFECTIVITY_BONUS = exports.CREW_EFFECTIVITY_BONUS = function CREW_EFFECTIVITY_BONUS(value) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'construct_reserve.parameters.crew_effectivity_bonus',
        defaultMessage: '\u0434\u043E {value} \u043A \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u0439 \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438 \u0438 \u0443\u043C\u0435\u043D\u0438\u044F\u043C \u044D\u043A\u0438\u043F\u0430\u0436\u0430',
        values: {
            value: _react2.default.createElement(
                'span',
                { className: _ConstructReserve2.default.parameterValue },
                value
            )
        }
    });
};

var RANGE_OF_ACTION = exports.RANGE_OF_ACTION = function RANGE_OF_ACTION(value) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'construct_reserve.parameters.range_of_action',
        defaultMessage: '\u0434\u043E {value} \u043C. \u0440\u0430\u0434\u0438\u0443\u0441 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F',
        values: {
            value: _react2.default.createElement(
                'span',
                { className: _ConstructReserve2.default.parameterValue },
                value
            )
        }
    });
};

var MAX_DAMAGE_FOR_VEHICLE_LEVELS = exports.MAX_DAMAGE_FOR_VEHICLE_LEVELS = function MAX_DAMAGE_FOR_VEHICLE_LEVELS(values) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'construct_reserve.parameters.max_damage_for_vehicle_levels',
        defaultMessage: '\u0434\u043E {value} \u0435\u0434. \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0443\u0440\u043E\u043D\u0430 \u0434\u043B\u044F \u0431\u043E\u0451\u0432 \u043D\u0430 VI / VIII / X \u0443\u0440\u043E\u0432\u043D\u0435 \u0442\u0435\u0445\u043D\u0438\u043A\u0438',
        values: {
            value: _react2.default.createElement(
                'span',
                null,
                values.map(function (value, index) {
                    return _react2.default.createElement(
                        'span',
                        { key: index },
                        index !== 0 && _react2.default.createElement(
                            'span',
                            { className: _ConstructReserve2.default.valueSeparator },
                            ' / '
                        ),
                        _react2.default.createElement(
                            'span',
                            { className: _ConstructReserve2.default.parameterValue },
                            value
                        )
                    );
                })
            )
        }
    });
};

var RANGE_OF_AFFECTED_AREA = exports.RANGE_OF_AFFECTED_AREA = function RANGE_OF_AFFECTED_AREA(value) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'construct_reserve.parameters.range_of_affected_area',
        defaultMessage: '\u0434\u043E {value} \u043C. \u0440\u0430\u0434\u0438\u0443\u0441 \u0437\u043E\u043D\u044B \u043F\u043E\u0440\u0430\u0436\u0435\u043D\u0438\u044F',
        values: {
            value: _react2.default.createElement(
                'span',
                { className: _ConstructReserve2.default.parameterValue },
                value
            )
        }
    });
};

var INSPIRATION_INDUSTRIAL_RESOURCE_BONUS = exports.INSPIRATION_INDUSTRIAL_RESOURCE_BONUS = function INSPIRATION_INDUSTRIAL_RESOURCE_BONUS(value) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'construct_reserve.parameters.inspiration_industrial_resource_bonus',
        defaultMessage: '\u0434\u043E {value} \u043A \u043F\u0440\u043E\u043C\u0440\u0435\u0441\u0443\u0440\u0441\u0443 \u043F\u0440\u0438 \u0432\u043E\u043E\u0434\u0443\u0448\u0435\u0432\u043B\u0435\u043D\u0438\u0438',
        values: {
            value: _react2.default.createElement(
                'span',
                { className: _ConstructReserve2.default.parameterValue },
                '+' + value
            )
        }
    });
};

var ARTILLERY_STRIKE_INDUSTRIAL_RESOURCE_BONUS = exports.ARTILLERY_STRIKE_INDUSTRIAL_RESOURCE_BONUS = function ARTILLERY_STRIKE_INDUSTRIAL_RESOURCE_BONUS(value) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'construct_reserve.parameters.artillery_strike_industrial_resource_bonus',
        defaultMessage: '\u0434\u043E {value} \u043A \u043F\u0440\u043E\u043C\u0440\u0435\u0441\u0443\u0440\u0441\u0443 \u043F\u0440\u0438 \u0432\u044B\u0437\u043E\u0432\u0435 \u0430\u0440\u0442\u043E\u0431\u0441\u0442\u0440\u0435\u043B\u0430',
        values: {
            value: _react2.default.createElement(
                'span',
                { className: _ConstructReserve2.default.parameterValue },
                '+' + value
            )
        }
    });
};

/***/ }),
/* 2164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NOT_ENOUGH_TOOLTIP_ID = exports.BUILD_BUTTON_CAPTION = exports.CONSTRUCTION_COST = exports.PERMISSION_WARNING = exports.CONSTRUCT_HEADERS = exports.RESERVE_DESCRIPTIONS = undefined;

var _RESERVE_DESCRIPTIONS;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint-disable max-len */


var RESERVE_DESCRIPTIONS = exports.RESERVE_DESCRIPTIONS = (_RESERVE_DESCRIPTIONS = {}, _defineProperty(_RESERVE_DESCRIPTIONS, _constants.RESERVE_TYPES.REQUISITION, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'construct.reserve_descriptions.requisition',
    defaultMessage: '\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u043F\u0440\u043E\u043C\u0440\u0435\u0441\u0443\u0440\u0441 \u0432 \u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0441\u0442\u0438 \u043E\u0442 \u0443\u0440\u043E\u0432\u043D\u044F \u0440\u0435\u0437\u0435\u0440\u0432\u0430.'
})), _defineProperty(_RESERVE_DESCRIPTIONS, _constants.RESERVE_TYPES.BATTLE_PAYMENTS, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'construct.reserve_descriptions.battle_payments',
    defaultMessage: '\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u043A\u0440\u0435\u0434\u0438\u0442\u044B \u0432 \u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0441\u0442\u0438 \u043E\u0442 \u0443\u0440\u043E\u0432\u043D\u044F \u0440\u0435\u0437\u0435\u0440\u0432\u0430.'
})), _defineProperty(_RESERVE_DESCRIPTIONS, _constants.RESERVE_TYPES.TACTICAL_TRAINING, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'construct.reserve_descriptions.tactical_training',
    defaultMessage: '\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u0431\u043E\u0435\u0432\u043E\u0439 \u043E\u043F\u044B\u0442 \u0432 \u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0441\u0442\u0438 \u043E\u0442 \u0443\u0440\u043E\u0432\u043D\u044F \u0440\u0435\u0437\u0435\u0440\u0432\u0430.'
})), _defineProperty(_RESERVE_DESCRIPTIONS, _constants.RESERVE_TYPES.ARTILLERY_STRIKE, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'construct.reserve_descriptions.artillery_strike',
    defaultMessage: '\u0412\u044B\u0437\u043E\u0432 \u0430\u0440\u0442\u0443\u0434\u0430\u0440\u0430 \u0438 \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u043F\u0440\u043E\u043C\u0440\u0435\u0441\u0443\u0440\u0441 \u0432 \u0412\u044B\u043B\u0430\u0437\u043A\u0430\u0445 \u0438 \u043F\u0440\u0438 \u041D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u044F\u0445 \u043D\u0430 1 \u0431\u043E\u0439'
})), _defineProperty(_RESERVE_DESCRIPTIONS, _constants.RESERVE_TYPES.MILITARY_MANEUVERS, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'construct.reserve_descriptions.military_maneuvers',
    defaultMessage: '\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u0441\u0432\u043E\u0431\u043E\u0434\u043D\u044B\u0439 \u043E\u043F\u044B\u0442 \u0432 \u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0441\u0442\u0438 \u043E\u0442 \u0443\u0440\u043E\u0432\u043D\u044F \u0440\u0435\u0437\u0435\u0440\u0432\u0430.'
})), _defineProperty(_RESERVE_DESCRIPTIONS, _constants.RESERVE_TYPES.AIRSTRIKE, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'construct.reserve_descriptions.airstrike',
    defaultMessage: '\u0412\u044B\u0437\u043E\u0432 \u0430\u0432\u0438\u0430\u0443\u0434\u0430\u0440\u0430 \u0438 \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u043F\u0440\u043E\u043C\u0440\u0435\u0441\u0443\u0440\u0441 \u043F\u0440\u0438 \u0432\u044B\u0437\u043E\u0432\u0435 \u0430\u0432\u0438\u0430\u0443\u0434\u0430\u0440\u0430'
})), _defineProperty(_RESERVE_DESCRIPTIONS, _constants.RESERVE_TYPES.ADDITIONAL_BRIEFING, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'construct.reserve_descriptions.additional_briefing',
    defaultMessage: '\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u043E\u043F\u044B\u0442 \u044D\u043A\u0438\u043F\u0430\u0436\u0430 \u0432 \u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0441\u0442\u0438 \u043E\u0442 \u0443\u0440\u043E\u0432\u043D\u044F \u0440\u0435\u0437\u0435\u0440\u0432\u0430.'
})), _defineProperty(_RESERVE_DESCRIPTIONS, _constants.RESERVE_TYPES.HIGH_CAPACITY_TRANSPORT, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'construct.reserve_descriptions.high_capacity_transport',
    defaultMessage: '\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u043F\u0440\u043E\u043C\u0440\u0435\u0441\u0443\u0440\u0441 \u0432 \u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0441\u0442\u0438 \u043E\u0442 \u0443\u0440\u043E\u0432\u043D\u044F \u0440\u0435\u0437\u0435\u0440\u0432\u0430.'
})), _defineProperty(_RESERVE_DESCRIPTIONS, _constants.RESERVE_TYPES.INSPIRATION, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'construct.reserve_descriptions.inspiration',
    defaultMessage: '\u0411\u043E\u043D\u0443\u0441 \u043A \u043E\u0441\u043D\u043E\u0432\u043D\u044B\u043C \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u044F\u043C \u0438 \u0432\u0441\u0435\u043C \u0443\u043C\u0435\u043D\u0438\u044F\u043C \u044D\u043A\u0438\u043F\u0430\u0436\u0430 \u043C\u0430\u0448\u0438\u043D\u044B \u0438\u0433\u0440\u043E\u043A\u0430 \u0441 \u0412\u043E\u043E\u0434\u0443\u0448\u0435\u0432\u043B\u0435\u043D\u0438\u0435\u043C \u0438 \u0431\u043B\u0438\u0436\u0430\u0439\u0448\u0438\u0445 \u0441\u043E\u044E\u0437\u043D\u0438\u043A\u043E\u0432, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u043F\u0440\u043E\u043C\u0440\u0435\u0441\u0443\u0440\u0441 \u0432 \u0412\u044B\u043B\u0430\u0437\u043A\u0430\u0445 \u0438 \u043F\u0440\u0438 \u041D\u0430\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u044F\u0445 \u043D\u0430 1 \u0431\u043E\u0439'
})), _RESERVE_DESCRIPTIONS);

var CONSTRUCT_HEADERS = exports.CONSTRUCT_HEADERS = {
    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'construct.construct_headers.title',
        defaultMessage: '\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u0442\u0440\u043E\u0435\u043D\u0438\u0435, \u043A\u043E\u0442\u043E\u0440\u043E\u0435 \u0445\u043E\u0442\u0438\u0442\u0435 \u0432\u043E\u0437\u0432\u0435\u0441\u0442\u0438'
    }),
    title_no_permission: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'construct.construct_headers.title_no_permission',
        defaultMessage: '\u041D\u0435\u0432\u043E\u0437\u0432\u0435\u0434\u0451\u043D\u043D\u044B\u0435 \u0441\u0442\u0440\u043E\u0435\u043D\u0438\u044F'
    })
};

var PERMISSION_WARNING = exports.PERMISSION_WARNING = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'construct.permission_warning',
    defaultMessage: '\u0412\u043E\u0437\u0432\u0435\u0441\u0442\u0438 \u0441\u0442\u0440\u043E\u0435\u043D\u0438\u0435 \u043C\u043E\u0433\u0443\u0442 \u043A\u043E\u043C\u0430\u043D\u0434\u0443\u044E\u0449\u0438\u0439 \u0438 \u0435\u0433\u043E \u0437\u0430\u043C\u0435\u0441\u0442\u0438\u0442\u0435\u043B\u0438.'
});

var CONSTRUCTION_COST = exports.CONSTRUCTION_COST = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'construct.construction_cost',
    defaultMessage: '\u0421\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C'
});

var BUILD_BUTTON_CAPTION = exports.BUILD_BUTTON_CAPTION = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'construct.build_button_caption',

    defaultMessage: '\u041F\u043E\u0441\u0442\u0440\u043E\u0438\u0442\u044C'
});

var NOT_ENOUGH_TOOLTIP_ID = exports.NOT_ENOUGH_TOOLTIP_ID = 'not_enough_tooltp_id';

/***/ }),
/* 2165 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"header":"Construct_header--1K4I3","main":"Construct_main--1q5XC","footer":"Construct_footer--i_laI","base":"Construct_base--2Q8RI","holder":"Construct_holder--3knpG","titleWrapper":"Construct_titleWrapper--9rkL-","back":"Construct_back--25JPI","warning":"Construct_warning--a7EO-","title":"Construct_title--3pFym","cost":"Construct_cost--1zsro"};

/***/ }),
/* 2166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Storage = exports.ScheduleButton = exports.Item = exports.BattlesButton = undefined;

var _BattlesButton2 = __webpack_require__(2167);

var _BattlesButton3 = _interopRequireDefault(_BattlesButton2);

var _Item2 = __webpack_require__(1343);

var _Item3 = _interopRequireDefault(_Item2);

var _ScheduleButton2 = __webpack_require__(2169);

var _ScheduleButton3 = _interopRequireDefault(_ScheduleButton2);

var _Storage2 = __webpack_require__(2170);

var _Storage3 = _interopRequireDefault(_Storage2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.BattlesButton = _BattlesButton3.default;
exports.Item = _Item3.default;
exports.ScheduleButton = _ScheduleButton3.default;
exports.Storage = _Storage3.default;

/***/ }),
/* 2167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _i18n = __webpack_require__(10);

var _BattlesButton = __webpack_require__(1342);

var _BattlesButton2 = _interopRequireDefault(_BattlesButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BattlesButton = function BattlesButton(props) {
    var className = (0, _classnames2.default)(_BattlesButton2.default.base, _defineProperty({}, _BattlesButton2.default.base__primary, props.primary));

    var glow = props.primary ? _react2.default.createElement('span', { className: _BattlesButton2.default.glow }) : null;

    var multiplier = props.industrialResourceMultiplier > 1 ? _react2.default.createElement(
        'span',
        { className: _BattlesButton2.default.multiplier },
        (0, _i18n.INDUSTRIAL_RESOURCE_MULTIPLIER)(props.industrialResourceMultiplier)
    ) : null;

    return _react2.default.createElement(
        'button',
        {
            className: className,
            onClick: props.handleClick,
            onMouseEnter: props.handleHover,
            'data-tip': true, 'data-for': props.tooltipId
        },
        glow,
        _react2.default.createElement(
            'span',
            { className: (0, _classnames2.default)(_BattlesButton2.default.caption, _defineProperty({}, _BattlesButton2.default.caption__glow, !!multiplier)) },
            props.caption,
            multiplier,
            _react2.default.createElement(
                'span',
                { className: _BattlesButton2.default.captionGradient },
                props.caption,
                multiplier
            )
        )
    );
};

BattlesButton.propTypes = {
    caption: _propTypes2.default.node.isRequired,
    handleClick: _propTypes2.default.func.isRequired,
    handleHover: _propTypes2.default.func.isRequired,
    primary: _propTypes2.default.bool,
    tooltipId: _propTypes2.default.string,
    industrialResourceMultiplier: _propTypes2.default.number
};

exports.default = BattlesButton;

/***/ }),
/* 2168 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Item_base--1MCAL","base__selected":"Item_base__selected--3P1Wh","baseSelected":"Item_base__selected--3P1Wh","base__gold":"Item_base__gold--3LzhN","baseGold":"Item_base__gold--3LzhN","base__crystal":"Item_base__crystal--SkKFH","baseCrystal":"Item_base__crystal--SkKFH","holder":"Item_holder--1gWep","base__currency":"Item_base__currency--1XS9u","baseCurrency":"Item_base__currency--1XS9u","icon":"Item_icon--3wir-","base__journal":"Item_base__journal--2g5Zw","baseJournal":"Item_base__journal--2g5Zw","base__challenges":"Item_base__challenges--2fvoS","baseChallenges":"Item_base__challenges--2fvoS","base__industrial":"Item_base__industrial--23-sd","baseIndustrial":"Item_base__industrial--23-sd","title":"Item_title--3DMhy","contents":"Item_contents--KRS3i"};

/***/ }),
/* 2169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactWotBootstrap = __webpack_require__(5);

var _shared_translations = __webpack_require__(162);

var _BattlesButton = __webpack_require__(1342);

var _BattlesButton2 = _interopRequireDefault(_BattlesButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ScheduleButton = function ScheduleButton(props) {
    var className = (0, _classnames2.default)(_BattlesButton2.default.schedule, _defineProperty({}, _BattlesButton2.default.schedule__primary, props.primary));
    var tooltipId = 'sheduleIconTooltip';

    var onClick = function onClick() {
        (0, _reactWotBootstrap.sendClickSoundCommand)();
        props.onClick();
    };

    return _react2.default.createElement(
        'button',
        {
            className: className,
            onClick: onClick,
            onMouseEnter: _reactWotBootstrap.sendHoverSoundCommand,
            'data-tip': true,
            'data-for': tooltipId
        },
        _react2.default.createElement('div', { className: _BattlesButton2.default.icon }),
        props.primary && _react2.default.createElement('span', { className: _BattlesButton2.default.glow }),
        props.showBubble && _react2.default.createElement(
            'div',
            { className: _BattlesButton2.default.schedule__bubble },
            '!'
        ),
        _react2.default.createElement(
            _reactWotBootstrap.Tooltip,
            { id: tooltipId },
            _react2.default.createElement(
                'div',
                { className: _BattlesButton2.default.tooltipContent },
                _react2.default.createElement(
                    'p',
                    { className: _BattlesButton2.default.tooltipSubtitle },
                    _shared_translations.SCHEDULE_TITLE
                ),
                props.showBubble && _react2.default.createElement(
                    'p',
                    { className: _BattlesButton2.default.tooltipMessage },
                    _shared_translations.SCHEDULE_HAS_CHANGES
                ),
                _react2.default.createElement(
                    'p',
                    { className: _BattlesButton2.default.tooltipMessage },
                    _shared_translations.SCHEDULE_TOOLTIP
                )
            )
        )
    );
};

ScheduleButton.propTypes = {
    onClick: _propTypes2.default.func.isRequired,
    primary: _propTypes2.default.bool,
    showBubble: _propTypes2.default.bool.isRequired
};

ScheduleButton.defaultProps = {
    showBubble: false
};

exports.default = ScheduleButton;

/***/ }),
/* 2170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Storage = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _web_to_client = __webpack_require__(17);

var _Item = __webpack_require__(1343);

var _Item2 = _interopRequireDefault(_Item);

var _StorageTooltip = __webpack_require__(1344);

var _constants = __webpack_require__(1345);

var _Storage = __webpack_require__(2172);

var _Storage2 = _interopRequireDefault(_Storage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Storage = exports.Storage = function Storage(_ref) {
    var _ref$industrialResour = _ref.industrialResource,
        industrialResource = _ref$industrialResour === undefined ? 0 : _ref$industrialResour,
        handleClick = _ref.handleClick,
        selected = _ref.selected;

    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_Item2.default, {
            title: _react2.default.createElement(
                'span',
                { className: industrialResource < 0 ? _Storage2.default.negative : null },
                _react2.default.createElement(_reactIntl.FormattedNumber, { value: industrialResource })
            ),
            contents: _constants.INDUSTRIAL_RESOURCE_DETAILS,
            type: 'industrial',
            tooltipId: _StorageTooltip.StorageTooltip.id,
            handleClick: selected ? null : handleClick,
            handleHover: selected ? null : _web_to_client.sendHoverSoundCommand,
            selected: selected
        }),
        _react2.default.createElement(_StorageTooltip.StorageTooltip, { industrialResource: industrialResource })
    );
};

Storage.propTypes = {
    industrialResource: _propTypes2.default.number,
    handleClick: _propTypes2.default.func,
    selected: _propTypes2.default.bool
};

exports.default = Storage;

/***/ }),
/* 2171 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"StorageTooltip_root--3trfT","root__show":"StorageTooltip_root__show--3yc8M","rootShow":"StorageTooltip_root__show--3yc8M","body":"StorageTooltip_body--1owx8","wrapper":"StorageTooltip_wrapper--2YWNu","content":"StorageTooltip_content--28r3m","title":"StorageTooltip_title--19URh","subtitle":"StorageTooltip_subtitle--8pwth","message":"StorageTooltip_message--156Tq","warning":"StorageTooltip_warning--2gqlV","divider":"StorageTooltip_divider--2Oa1F","highlight":"StorageTooltip_highlight--1SqCY","ribbon":"StorageTooltip_ribbon--1N-2W","statusMessage":"StorageTooltip_statusMessage--2YzQ2","statusMessage__positive":"StorageTooltip_statusMessage__positive--r_MTI","statusMessagePositive":"StorageTooltip_statusMessage__positive--r_MTI","status":"StorageTooltip_status--1SzZh","statusMessage__negative":"StorageTooltip_statusMessage__negative--3AE90","statusMessageNegative":"StorageTooltip_statusMessage__negative--3AE90","statusMessage__noPermission":"StorageTooltip_statusMessage__noPermission--1eyPQ","statusMessageNoPermission":"StorageTooltip_statusMessage__noPermission--1eyPQ","status__positive":"StorageTooltip_status__positive--nSwY3","statusPositive":"StorageTooltip_status__positive--nSwY3","status__negative":"StorageTooltip_status__negative--3L6UK","statusNegative":"StorageTooltip_status__negative--3L6UK","statusText":"StorageTooltip_statusText--2N55u"};

/***/ }),
/* 2172 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"negative":"Storage_negative--1dji0"};

/***/ }),
/* 2173 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tooltip-root":"ClanPanel_tooltip-root--2jjDq","tooltipRoot":"ClanPanel_tooltip-root--2jjDq","tooltip-root__show":"ClanPanel_tooltip-root__show--2_F7v","tooltipRootShow":"ClanPanel_tooltip-root__show--2_F7v","tooltip-body":"ClanPanel_tooltip-body--35MQj","tooltipBody":"ClanPanel_tooltip-body--35MQj","tooltip-wrapper":"ClanPanel_tooltip-wrapper--34VWx","tooltipWrapper":"ClanPanel_tooltip-wrapper--34VWx","tooltip-content":"ClanPanel_tooltip-content--16hNg","tooltipContent":"ClanPanel_tooltip-content--16hNg","tooltip-title":"ClanPanel_tooltip-title--3VQls","tooltipTitle":"ClanPanel_tooltip-title--3VQls","tooltip-subtitle":"ClanPanel_tooltip-subtitle--1w90p","tooltipSubtitle":"ClanPanel_tooltip-subtitle--1w90p","tooltip-message":"ClanPanel_tooltip-message--1higx","tooltipMessage":"ClanPanel_tooltip-message--1higx","tooltip-warning":"ClanPanel_tooltip-warning--2AfBI","tooltipWarning":"ClanPanel_tooltip-warning--2AfBI","tooltip-divider":"ClanPanel_tooltip-divider--2-9RV","tooltipDivider":"ClanPanel_tooltip-divider--2-9RV","tooltip-highlight":"ClanPanel_tooltip-highlight--I5qyM","tooltipHighlight":"ClanPanel_tooltip-highlight--I5qyM","tooltip-ribbon":"ClanPanel_tooltip-ribbon--rbcrJ","tooltipRibbon":"ClanPanel_tooltip-ribbon--rbcrJ","tooltip-statusMessage":"ClanPanel_tooltip-statusMessage--3DHx8","tooltipStatusMessage":"ClanPanel_tooltip-statusMessage--3DHx8","tooltip-statusMessage__positive":"ClanPanel_tooltip-statusMessage__positive--3isK2","tooltipStatusMessagePositive":"ClanPanel_tooltip-statusMessage__positive--3isK2","tooltip-status":"ClanPanel_tooltip-status--3EriO","tooltipStatus":"ClanPanel_tooltip-status--3EriO","tooltip-statusMessage__negative":"ClanPanel_tooltip-statusMessage__negative--BIhSy","tooltipStatusMessageNegative":"ClanPanel_tooltip-statusMessage__negative--BIhSy","tooltip-statusMessage__noPermission":"ClanPanel_tooltip-statusMessage__noPermission--GIKI6","tooltipStatusMessageNoPermission":"ClanPanel_tooltip-statusMessage__noPermission--GIKI6","tooltip-status__positive":"ClanPanel_tooltip-status__positive--1WL9F","tooltipStatusPositive":"ClanPanel_tooltip-status__positive--1WL9F","tooltip-status__negative":"ClanPanel_tooltip-status__negative--asUfd","tooltipStatusNegative":"ClanPanel_tooltip-status__negative--asUfd","tooltip-statusText":"ClanPanel_tooltip-statusText--7-9lj","tooltipStatusText":"ClanPanel_tooltip-statusText--7-9lj","base":"ClanPanel_base--3JFxy","part":"ClanPanel_part--NpRnA","part__center":"ClanPanel_part__center--3l8UD","partCenter":"ClanPanel_part__center--3l8UD","part__left":"ClanPanel_part__left--1TZTs","partLeft":"ClanPanel_part__left--1TZTs","part__right":"ClanPanel_part__right--2zIhq","partRight":"ClanPanel_part__right--2zIhq","background":"ClanPanel_background--1l5-K","base__active":"ClanPanel_base__active--MtsXa","baseActive":"ClanPanel_base__active--MtsXa","button":"ClanPanel_button--19wq4","button__highlight":"ClanPanel_button__highlight--3LQ7E","buttonHighlight":"ClanPanel_button__highlight--3LQ7E","industrialResourceBuyinButton":"ClanPanel_industrialResourceBuyinButton--drvIm","industrialResourceBuyinText":"ClanPanel_industrialResourceBuyinText--1lC_T","cell":"ClanPanel_cell--3Ue3v","tooltipBase":"ClanPanel_tooltipBase--1tVNr","timer":"ClanPanel_timer--2xW76","treasuryValue":"ClanPanel_treasuryValue--3Aq62"};

/***/ }),
/* 2174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.INDUSTRIAL_RESOURCE_MESSAGE = exports.INDUSTRIAL_RESOURCE_TITLE = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-multi-comp */

var INDUSTRIAL_RESOURCE_TITLE = exports.INDUSTRIAL_RESOURCE_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_panel.buyin.industrial_resource.title',
    defaultMessage: '\u041F\u0440\u043E\u043C\u0440\u0435\u0441\u0443\u0440\u0441 \u0434\u043B\u044F \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043B\u0430\u043D\u0430'
});

var INDUSTRIAL_RESOURCE_MESSAGE = exports.INDUSTRIAL_RESOURCE_MESSAGE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_panel.buyin.industrial_resource.message'
    // eslint-disable-next-line max-len
    , defaultMessage: '\u041F\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435 \u0437\u0430\u043F\u0430\u0441\u0430 \u043F\u0440\u043E\u043C\u0440\u0435\u0441\u0443\u0440\u0441\u0430 \u043F\u043E\u0437\u0432\u043E\u043B\u0438\u0442 \u0432\u0430\u0448\u0435\u043C\u0443 \u043A\u043B\u0430\u043D\u0443 \u0431\u044B\u0441\u0442\u0440\u0435\u0435 \u0440\u0430\u0437\u0432\u0438\u0442\u044C\u0441\u044F, \u043C\u043E\u0434\u0435\u0440\u043D\u0438\u0437\u0438\u0440\u0443\u044F \u0441\u0442\u0440\u043E\u0435\u043D\u0438\u044F \u0423\u043A\u0440\u0435\u043F\u0440\u0430\u0439\u043E\u043D\u0430 \u0438 \u043F\u043E\u0434\u0433\u043E\u0442\u0430\u0432\u043B\u0438\u0432\u0430\u044F \u0440\u0430\u0437\u043B\u0438\u0447\u043D\u044B\u0435 \u043A\u043B\u0430\u043D\u043E\u0432\u044B\u0435 \u0440\u0435\u0437\u0435\u0440\u0432\u044B.'
});

/***/ }),
/* 2175 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"IndustrialTooltip_root--3ZdNl","root__show":"IndustrialTooltip_root__show--20IQY","rootShow":"IndustrialTooltip_root__show--20IQY","body":"IndustrialTooltip_body--1vD2w","wrapper":"IndustrialTooltip_wrapper--2E4w_","content":"IndustrialTooltip_content--2pPI6","title":"IndustrialTooltip_title--1FpiN","subtitle":"IndustrialTooltip_subtitle--1OyK-","message":"IndustrialTooltip_message--1BbD9","warning":"IndustrialTooltip_warning--X8uU6","divider":"IndustrialTooltip_divider--1Cryi","highlight":"IndustrialTooltip_highlight--nyZev","ribbon":"IndustrialTooltip_ribbon--2h4zj","statusMessage":"IndustrialTooltip_statusMessage--2kmIr","statusMessage__positive":"IndustrialTooltip_statusMessage__positive--104lG","statusMessagePositive":"IndustrialTooltip_statusMessage__positive--104lG","status":"IndustrialTooltip_status--cZuzX","statusMessage__negative":"IndustrialTooltip_statusMessage__negative--2ShCy","statusMessageNegative":"IndustrialTooltip_statusMessage__negative--2ShCy","statusMessage__noPermission":"IndustrialTooltip_statusMessage__noPermission--21yBB","statusMessageNoPermission":"IndustrialTooltip_statusMessage__noPermission--21yBB","status__positive":"IndustrialTooltip_status__positive--1gx_M","statusPositive":"IndustrialTooltip_status__positive--1gx_M","status__negative":"IndustrialTooltip_status__negative--2WAAJ","statusNegative":"IndustrialTooltip_status__negative--2WAAJ","statusText":"IndustrialTooltip_statusText--22NcE"};

/***/ }),
/* 2176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapDispatchToProps = exports.MigrationScreen = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = __webpack_require__(7);

var _migration_screen = __webpack_require__(375);

var _web_to_client = __webpack_require__(12);

var _Back = __webpack_require__(70);

var _Back2 = _interopRequireDefault(_Back);

var _Slider = __webpack_require__(2177);

var _Slider2 = _interopRequireDefault(_Slider);

var _translations = __webpack_require__(2182);

var _constants = __webpack_require__(4);

var _MigrationScreen = __webpack_require__(2183);

var _MigrationScreen2 = _interopRequireDefault(_MigrationScreen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CLAN_NEWS_KEY = 'clanNews';

var MigrationScreen = exports.MigrationScreen = function (_React$Component) {
    _inherits(MigrationScreen, _React$Component);

    function MigrationScreen() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, MigrationScreen);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MigrationScreen.__proto__ || Object.getPrototypeOf(MigrationScreen)).call.apply(_ref, [this].concat(args))), _this), _this.componentDidMount = function () {
            (0, _web_to_client.setNewsCounter)(CLAN_NEWS_KEY, 0);
            window.addEventListener('keydown', _this.handleKeyDown);
        }, _this.componentWillUnmount = function () {
            window.removeEventListener('keydown', _this.handleKeyDown);
        }, _this.handleKeyDown = function (e) {
            if (e.keyCode === _constants.KEY_CODES.ESCAPE) {
                _this.props.hideMigrationScreen();
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(MigrationScreen, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: _MigrationScreen2.default.base },
                _react2.default.createElement(
                    'div',
                    { className: _MigrationScreen2.default.close },
                    _react2.default.createElement(_Back2.default, {
                        caption: _Back2.default.CAPTIONS.close,
                        handleClick: this.props.hideMigrationScreen,
                        side: _Back2.default.SIDES.right,
                        type: _Back2.default.TYPES.close
                    })
                ),
                _react2.default.createElement(
                    _Slider2.default,
                    {
                        handleClose: this.props.hideMigrationScreen,
                        classNames: {
                            paging: _MigrationScreen2.default.paging,
                            navContainer: _MigrationScreen2.default.navContainer,
                            buttonContainer: _MigrationScreen2.default.buttonContainer
                        }
                    },
                    Object.keys(_translations.SLIDES_TEXTS).map(function (slide, index) {
                        var _SLIDES_TEXTS$slide = _translations.SLIDES_TEXTS[slide],
                            title = _SLIDES_TEXTS$slide.title,
                            descriptions = _SLIDES_TEXTS$slide.descriptions;

                        return _react2.default.createElement(
                            'reactFragment',
                            { key: slide },
                            _react2.default.createElement(
                                'h1',
                                { className: _MigrationScreen2.default.title },
                                title
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _MigrationScreen2.default.content },
                                descriptions.map(function (description, index) {
                                    return _react2.default.createElement(
                                        'p',
                                        { className: _MigrationScreen2.default.text, key: index },
                                        description
                                    );
                                }),
                                _react2.default.createElement('div', { className: (0, _classnames2.default)(_MigrationScreen2.default.slideImage, _MigrationScreen2.default['slideImage__' + (index + 1)]) })
                            )
                        );
                    })
                )
            );
        }
    }]);

    return MigrationScreen;
}(_react2.default.Component);

MigrationScreen.propTypes = {
    hideMigrationScreen: _propTypes2.default.func.isRequired
};
var mapDispatchToProps = exports.mapDispatchToProps = {
    hideMigrationScreen: _migration_screen.hideMigrationScreen
};

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(MigrationScreen);

/***/ }),
/* 2177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactWotBootstrap = __webpack_require__(5);

var _NavigationArrow = __webpack_require__(59);

var _NavigationArrow2 = _interopRequireDefault(_NavigationArrow);

var _Paging = __webpack_require__(2178);

var _Paging2 = _interopRequireDefault(_Paging);

var _translations = __webpack_require__(2180);

var _Slider = __webpack_require__(2181);

var _Slider2 = _interopRequireDefault(_Slider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Slider = function (_React$Component) {
    _inherits(Slider, _React$Component);

    function Slider(props) {
        _classCallCheck(this, Slider);

        var _this = _possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props));

        _this.handleNextClick = function () {
            _this.setState({
                activeSlide: _this.state.activeSlide + 1
            });
        };

        _this.handlePrevClick = function () {
            _this.setState({
                activeSlide: _this.state.activeSlide - 1
            });
        };

        _this.state = {
            activeSlide: 1
        };
        return _this;
    }

    _createClass(Slider, [{
        key: 'render',
        value: function render() {
            var activeSlide = this.state.activeSlide;
            var _props = this.props,
                classNames = _props.classNames,
                children = _props.children;


            var isPrevNavDisabled = activeSlide === 1;
            var isNextNavDisabled = activeSlide === children.length;

            return _react2.default.createElement(
                'div',
                { className: _Slider2.default.base },
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)(_Slider2.default.navigation, classNames.navContainer) },
                    _react2.default.createElement(_NavigationArrow2.default, {
                        type: 'left',
                        handleClick: this.handlePrevClick,
                        disabled: isPrevNavDisabled
                    }),
                    _react2.default.createElement(_NavigationArrow2.default, {
                        type: 'right',
                        handleClick: this.handleNextClick,
                        disabled: isNextNavDisabled
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: _Slider2.default.content, key: activeSlide },
                    _react2.default.createElement(_Paging2.default, {
                        className: (0, _classnames2.default)(_Slider2.default.paging, classNames.paging),
                        currentPage: activeSlide,
                        totalPages: children.length
                    }),
                    this.props.children[activeSlide - 1],
                    _react2.default.createElement(
                        'div',
                        { className: (0, _classnames2.default)(_Slider2.default.button, classNames.buttonContainer) },
                        isNextNavDisabled ? _react2.default.createElement(
                            _reactWotBootstrap.Button,
                            { onClick: this.props.handleClose },
                            _translations.TO_STRONGHOLD
                        ) : _react2.default.createElement(
                            _reactWotBootstrap.Button,
                            { onClick: this.handleNextClick },
                            _translations.NEXT
                        )
                    )
                )
            );
        }
    }]);

    return Slider;
}(_react2.default.Component);

Slider.propTypes = {
    children: _propTypes2.default.arrayOf(_propTypes2.default.node),
    handleClose: _propTypes2.default.func.isRequired,
    classNames: _propTypes2.default.shape({
        paging: _propTypes2.default.string,
        navContainer: _propTypes2.default.string,
        buttonContainer: _propTypes2.default.string
    })
};
exports.default = Slider;

/***/ }),
/* 2178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _Paging = __webpack_require__(2179);

var _Paging2 = _interopRequireDefault(_Paging);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Paging = function Paging(_ref) {
    var currentPage = _ref.currentPage,
        totalPages = _ref.totalPages,
        className = _ref.className;

    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_Paging2.default.base, className) },
        _react2.default.createElement(
            'span',
            { className: _Paging2.default.current },
            currentPage
        ),
        _react2.default.createElement(
            'span',
            { className: _Paging2.default.total },
            ' / ',
            totalPages
        )
    );
};

Paging.propTypes = {
    currentPage: _propTypes2.default.number.isRequired,
    totalPages: _propTypes2.default.number.isRequired,
    className: _propTypes2.default.string
};

exports.default = Paging;

/***/ }),
/* 2179 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Paging_base--2HNVX","current":"Paging_current--3RFjc","total":"Paging_total--3TTNL"};

/***/ }),
/* 2180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TO_STRONGHOLD = exports.NEXT = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NEXT = exports.NEXT = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'migration_screen.navigation.next',
    defaultMessage: '\u0414\u0430\u043B\u0435\u0435'
});

var TO_STRONGHOLD = exports.TO_STRONGHOLD = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'migration_screen.navigation.to_stronghold',
    defaultMessage: '\u041A \u0423\u043A\u0440\u0435\u043F\u0440\u0430\u0439\u043E\u043D\u0443'
});

/***/ }),
/* 2181 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Slider_base--Y9z36","navigation":"Slider_navigation--q5Z2-","content":"Slider_content--_-3AW","button":"Slider_button--3g4e5"};

/***/ }),
/* 2182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SLIDES_TEXTS = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len, react/jsx-key */

var SLIDES_TEXTS = exports.SLIDES_TEXTS = {
    SLIDE_1: {
        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'migration_screen.reserves_update.title',
            defaultMessage: '\u041E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u0440\u0435\u0437\u0435\u0440\u0432\u043E\u0432'
        }),
        descriptions: [_react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'migration_screen.reserves_update.description_1',
            defaultMessage: '\u0410\u0440\u0442\u043E\u0431\u0441\u0442\u0440\u0435\u043B \u0442\u0435\u043F\u0435\u0440\u044C \u043D\u0430\u043D\u043E\u0441\u0438\u0442 \u0441\u0442\u0430\u0431\u0438\u043B\u044C\u043D\u044B\u0439 \u043F\u0435\u0440\u0438\u043E\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u0443\u0440\u043E\u043D. \u041C\u0435\u0441\u0442\u043E, \u043A\u0443\u0434\u0430 \u0432\u044B\u0437\u0432\u0430\u043D \u0430\u0440\u0442\u043E\u0431\u0441\u0442\u0440\u0435\u043B, \u0431\u0443\u0434\u0435\u0442 \u043F\u043E\u043A\u0430\u0437\u0430\u043D\u043E \u0437\u0430\u0440\u0430\u043D\u0435\u0435.'
        }), _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'migration_screen.reserves_update.description_2',
            defaultMessage: '\u0420\u0435\u0437\u0435\u0440\u0432 \xAB\u0410\u0432\u0438\u0430\u0443\u0434\u0430\u0440\xBB \u0437\u0430\u043C\u0435\u043D\u0451\u043D \u043D\u0430 \xAB\u0412\u043E\u043E\u0434\u0443\u0448\u0435\u0432\u043B\u0435\u043D\u0438\u0435\xBB. \u0418\u0433\u0440\u043E\u043A, \u0430\u043A\u0442\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u0432\u0448\u0438\u0439 \u044D\u0442\u043E\u0442 \u0440\u0435\u0437\u0435\u0440\u0432, \u0438 \u0441\u043E\u044E\u0437\u043D\u0438\u043A\u0438 \u0432 \u0440\u0430\u0434\u0438\u0443\u0441\u0435 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u0440\u0435\u0437\u0435\u0440\u0432\u0430 \u043F\u043E\u043B\u0443\u0447\u0430\u044E\u0442 \u0431\u043E\u043D\u0443\u0441 \u043A \u043E\u0441\u043D\u043E\u0432\u043D\u044B\u043C \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u044F\u043C \u0438 \u0432\u0441\u0435\u043C \u0443\u043C\u0435\u043D\u0438\u044F\u043C \u044D\u043A\u0438\u043F\u0430\u0436\u0435\u0439.'
        }), _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'migration_screen.reserves_update.description_3',
            defaultMessage: '\xAB\u0410\u0440\u0442\u043E\u0431\u0441\u0442\u0440\u0435\u043B\xBB \u0438 \xAB\u0412\u043E\u043E\u0434\u0443\u0448\u0435\u0432\u043B\u0435\u043D\u0438\u0435\xBB \u043C\u043E\u0436\u043D\u043E \u0431\u0440\u0430\u0442\u044C \u0432 \u0431\u043E\u0439 \u043E\u0434\u043D\u043E\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E.'
        })]
    },
    SLIDE_2: {
        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'migration_screen.buildings_update.title',
            defaultMessage: '\u041E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u0441\u0442\u0440\u043E\u0435\u043D\u0438\u0439'
        }),
        descriptions: [_react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'migration_screen.buildings_update.description_1',
            defaultMessage: '\u0421\u0442\u0440\u043E\u0435\u043D\u0438\u0435 \xAB\u041F\u043E\u043B\u043A \u0431\u043E\u043C\u0431\u0430\u0440\u0434\u0438\u0440\u043E\u0432\u043E\u0447\u043D\u043E\u0439 \u0430\u0432\u0438\u0430\u0446\u0438\u0438\xBB \u0437\u0430\u043C\u0435\u043D\u0435\u043D\u043E \u043D\u0430 \xAB\u0421\u043B\u0443\u0436\u0431\u0430 \u0442\u044B\u043B\u0430\xBB, \u0432 \u043A\u043E\u0442\u043E\u0440\u043E\u043C \u043C\u043E\u0436\u043D\u043E \u043F\u043E\u0434\u0433\u043E\u0442\u0430\u0432\u043B\u0438\u0432\u0430\u0442\u044C \u0440\u0435\u0437\u0435\u0440\u0432 \xAB\u0412\u043E\u043E\u0434\u0443\u0448\u0435\u0432\u043B\u0435\u043D\u0438\u0435\xBB.'
        })]
    },
    SLIDE_3: {
        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'migration_screen.compensation.title',
            defaultMessage: '\u041A\u043E\u043C\u043F\u0435\u043D\u0441\u0430\u0446\u0438\u044F'
        }),
        descriptions: [_react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'migration_screen.compensation.description_1',
            defaultMessage: '\u0423 \u043A\u043B\u0430\u043D\u043E\u0432 \u0431\u044B\u043B\u0438 \u0443\u0431\u0440\u0430\u043D\u044B \u0443\u0436\u0435 \u043F\u043E\u0434\u0433\u043E\u0442\u043E\u0432\u043B\u0435\u043D\u043D\u044B\u0435 \u0440\u0435\u0437\u0435\u0440\u0432\u044B \xAB\u0410\u0440\u0442\u043E\u0431\u0441\u0442\u0440\u0435\u043B\xBB \u0438 \xAB\u0410\u0432\u0438\u0430\u0443\u0434\u0430\u0440\xBB. \u0417\u0430\u0442\u0440\u0430\u0447\u0435\u043D\u043D\u044B\u0439 \u043D\u0430 \u0438\u0445 \u043F\u043E\u0434\u0433\u043E\u0442\u043E\u0432\u043A\u0443 \u043F\u0440\u043E\u043C\u0440\u0435\u0441\u0443\u0440\u0441 \u0432\u043E\u0437\u0432\u0440\u0430\u0449\u0451\u043D.'
        }), _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'migration_screen.compensation.description_2',
            defaultMessage: '\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0432\u043E\u0437\u0432\u0440\u0430\u0449\u0451\u043D\u043D\u043E\u0433\u043E \u043F\u0440\u043E\u043C\u0440\u0435\u0441\u0443\u0440\u0441\u0430 \u043C\u043E\u0436\u043D\u043E \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0432 \u0423\u043A\u0440\u0435\u043F\u0440\u0430\u0439\u043E\u043D\u0435 \u043D\u0430 \u044D\u043A\u0440\u0430\u043D\u0435 \xAB\u0416\u0443\u0440\u043D\u0430\u043B\xBB, \u0432\u043A\u043B\u0430\u0434\u043A\u0430 \xAB\u041F\u0440\u043E\u043C\u0440\u0435\u0441\u0443\u0440\u0441\xBB.'
        })]
    }
};

/***/ }),
/* 2183 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"MigrationScreen_base--3WSpu","close":"MigrationScreen_close--2cdjL","paging":"MigrationScreen_paging--7gvwQ","contentSlideUp":"MigrationScreen_contentSlideUp--2ujvu","buttonContainer":"MigrationScreen_buttonContainer--LE9ck","navContainer":"MigrationScreen_navContainer--3H2Fi","fadeIn":"MigrationScreen_fadeIn--tJrol","title":"MigrationScreen_title--3ziZr","content":"MigrationScreen_content--1xvPL","slideImage":"MigrationScreen_slideImage--3bZh_","slideImage__1":"MigrationScreen_slideImage__1--1vBCV","slideImage1":"MigrationScreen_slideImage__1--1vBCV","slideImage__2":"MigrationScreen_slideImage__2--1Q1Mx","slideImage2":"MigrationScreen_slideImage__2--1Q1Mx","slideImage__3":"MigrationScreen_slideImage__3--21MfX","slideImage3":"MigrationScreen_slideImage__3--21MfX","text":"MigrationScreen_text--1d9CA"};

/***/ }),
/* 2184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactIntl = __webpack_require__(3);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

var _i18n = __webpack_require__(10);

var _components = __webpack_require__(233);

var _constants = __webpack_require__(2185);

var _constants2 = __webpack_require__(1347);

var _ClanInfoPanel = __webpack_require__(2186);

var _ClanInfoPanel2 = _interopRequireDefault(_ClanInfoPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ClanInfoPanel = function ClanInfoPanel(props) {
    var clan = props.clan,
        stats = props.stats,
        elo_leaderboards = props.elo_leaderboards;

    var vehicleLevels = Object.keys(stats).sort(function (a, b) {
        return b - a;
    });

    var divisionsComponent = vehicleLevels.map(function (vehicle_level) {
        var divisionClassName = (0, _classnames2.default)(_ClanInfoPanel2.default.division, _ClanInfoPanel2.default['division__' + vehicle_level]);
        var vehicleLevelInElo = function vehicleLevelInElo(leaderboard) {
            return leaderboard.vehicle_level === parseInt(vehicle_level);
        };

        return _react2.default.createElement(
            'div',
            { key: 'rating-in-' + vehicle_level, className: _ClanInfoPanel2.default.divisionItem },
            _react2.default.createElement(
                'div',
                { className: divisionClassName, 'data-tip': true, 'data-for': _constants2.STATS_TOOLTIPS_IDS[vehicle_level] },
                _react2.default.createElement(_reactIntl.FormattedNumber, { value: stats[vehicle_level].elo })
            ),
            _react2.default.createElement(_components.StatsTooltip, _extends({}, stats[vehicle_level], {
                level: vehicle_level,
                elo_details: elo_leaderboards.find(vehicleLevelInElo)
            }))
        );
    });

    return _react2.default.createElement(
        'div',
        { className: _ClanInfoPanel2.default.base },
        _react2.default.createElement('div', { className: _ClanInfoPanel2.default.background }),
        _react2.default.createElement(
            'div',
            { className: _ClanInfoPanel2.default.clan },
            _react2.default.createElement('span', { className: _ClanInfoPanel2.default.emblem, style: { backgroundImage: 'url(' + clan.emblem + ')' } }),
            _react2.default.createElement(
                'p',
                { className: _ClanInfoPanel2.default.name },
                '[' + clan.tag + '] ' + clan.name
            ),
            _react2.default.createElement(
                'p',
                { className: _ClanInfoPanel2.default.date },
                (0, _constants.CLAN_INFO_PANEL_CREATED_AT)((0, _moment2.default)(clan.created_at).format('LL'))
            )
        ),
        _react2.default.createElement(
            'div',
            { className: _ClanInfoPanel2.default.details },
            _react2.default.createElement(
                'div',
                { className: _ClanInfoPanel2.default.ratings },
                _react2.default.createElement(
                    'p',
                    { className: _ClanInfoPanel2.default.subtitle },
                    _i18n.ELO_RATING_TEXT
                ),
                _react2.default.createElement(
                    'div',
                    { className: _ClanInfoPanel2.default.divisions },
                    divisionsComponent
                )
            )
        )
    );
};

ClanInfoPanel.propTypes = {
    clan: _propTypes2.default.shape({
        tag: _propTypes2.default.string.isRequired,
        name: _propTypes2.default.string.isRequired,
        emblem: _propTypes2.default.string.isRequired,
        created_at: _propTypes2.default.number.isRequired
    }).isRequired,
    // WGSH-2679 extend with new levels
    stats: _propTypes2.default.shape({
        6: _propTypes2.default.object.isRequired,
        8: _propTypes2.default.object.isRequired,
        10: _propTypes2.default.object.isRequired
    }).isRequired,
    elo_leaderboards: _propTypes2.default.array
};

exports.default = ClanInfoPanel;

/***/ }),
/* 2185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CLAN_INFO_PANEL_CREATED_AT = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-multi-comp */
var CLAN_INFO_PANEL_CREATED_AT = exports.CLAN_INFO_PANEL_CREATED_AT = function CLAN_INFO_PANEL_CREATED_AT(date) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'clan_info_panel.created_at',
        defaultMessage: '\u0421\u043E\u0437\u0434\u0430\u043D {date}',
        values: { date: date }
    });
};

/***/ }),
/* 2186 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"ClanInfoPanel_base--1ILi4","background":"ClanInfoPanel_background--2dewh","clan":"ClanInfoPanel_clan--xZ1lt","details":"ClanInfoPanel_details--18QJv","emblem":"ClanInfoPanel_emblem--3mmNx","name":"ClanInfoPanel_name--1Wa9m","date":"ClanInfoPanel_date--3W2Nu","ratings":"ClanInfoPanel_ratings--pFm83","subtitle":"ClanInfoPanel_subtitle--UYDyJ","divisions":"ClanInfoPanel_divisions--1Ssrh","divisionItem":"ClanInfoPanel_divisionItem--3PC0i","division":"ClanInfoPanel_division--1jBjp","division__6":"ClanInfoPanel_division__6--3JlTR","division6":"ClanInfoPanel_division__6--3JlTR","division__8":"ClanInfoPanel_division__8--bGa-v","division8":"ClanInfoPanel_division__8--bGa-v","division__10":"ClanInfoPanel_division__10--1Yv8k","division10":"ClanInfoPanel_division__10--1Yv8k"};

/***/ }),
/* 2187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactIntl = __webpack_require__(3);

var _reactWotBootstrap = __webpack_require__(5);

var _RatingLabelTooltip = __webpack_require__(1348);

var _RatingLabelTooltip2 = _interopRequireDefault(_RatingLabelTooltip);

var _RatingLabel = __webpack_require__(2189);

var _RatingLabel2 = _interopRequireDefault(_RatingLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RatingLabel = function (_React$Component) {
    _inherits(RatingLabel, _React$Component);

    function RatingLabel() {
        _classCallCheck(this, RatingLabel);

        var _this = _possibleConstructorReturn(this, (RatingLabel.__proto__ || Object.getPrototypeOf(RatingLabel)).call(this));

        _this.onClick = _this.onClick.bind(_this);
        return _this;
    }

    _createClass(RatingLabel, [{
        key: 'onClick',
        value: function onClick() {
            if (this.props.show_leaderboard) {
                this.props.onClick();
                (0, _reactWotBootstrap.sendClickSoundCommand)();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var tooltipId = 'RatingLabelTooltip' + this.props.vehicle_level;

            var className = (0, _classnames2.default)(_RatingLabel2.default.base, _defineProperty({}, _RatingLabel2.default.isDisabled, !this.props.show_leaderboard));
            var iconClassName = (0, _classnames2.default)(_RatingLabel2.default.vehicleLevelIcon, _RatingLabel2.default['level-' + this.props.vehicle_level]);

            return _react2.default.createElement(
                'div',
                {
                    className: className,
                    'data-tip': true, 'data-for': tooltipId,
                    onClick: this.onClick,
                    onMouseEnter: _reactWotBootstrap.sendHoverSoundCommand
                },
                _react2.default.createElement('div', { className: iconClassName }),
                _react2.default.createElement(_reactIntl.FormattedNumber, { value: this.props.elo }),
                _react2.default.createElement(_RatingLabelTooltip2.default, _extends({ id: tooltipId }, this.props))
            );
        }
    }]);

    return RatingLabel;
}(_react2.default.Component);

RatingLabel.propTypes = {
    elo: _propTypes2.default.number.isRequired,
    position: _propTypes2.default.number,
    vehicle_level: _propTypes2.default.number.isRequired,
    show_leaderboard: _propTypes2.default.bool,
    onClick: _propTypes2.default.func.isRequired
};
exports.default = RatingLabel;

/***/ }),
/* 2188 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"RatingLabelTooltip_root--1-qgp","root__show":"RatingLabelTooltip_root__show--36F0Q","rootShow":"RatingLabelTooltip_root__show--36F0Q","body":"RatingLabelTooltip_body--1knoE","wrapper":"RatingLabelTooltip_wrapper--QaKDg","content":"RatingLabelTooltip_content--3B2sY","title":"RatingLabelTooltip_title--2IpaT","subtitle":"RatingLabelTooltip_subtitle--wu718","message":"RatingLabelTooltip_message--BPq_g","warning":"RatingLabelTooltip_warning--2l6_H","divider":"RatingLabelTooltip_divider--3iWfJ","highlight":"RatingLabelTooltip_highlight--NYrLK","ribbon":"RatingLabelTooltip_ribbon--1foyM","statusMessage":"RatingLabelTooltip_statusMessage--3TYgn","statusMessage__positive":"RatingLabelTooltip_statusMessage__positive--3gam1","statusMessagePositive":"RatingLabelTooltip_statusMessage__positive--3gam1","status":"RatingLabelTooltip_status--EEKtQ","statusMessage__negative":"RatingLabelTooltip_statusMessage__negative--1jMzn","statusMessageNegative":"RatingLabelTooltip_statusMessage__negative--1jMzn","statusMessage__noPermission":"RatingLabelTooltip_statusMessage__noPermission--1HAcO","statusMessageNoPermission":"RatingLabelTooltip_statusMessage__noPermission--1HAcO","status__positive":"RatingLabelTooltip_status__positive--369t7","statusPositive":"RatingLabelTooltip_status__positive--369t7","status__negative":"RatingLabelTooltip_status__negative--3axpB","statusNegative":"RatingLabelTooltip_status__negative--3axpB","statusText":"RatingLabelTooltip_statusText--1CNSD"};

/***/ }),
/* 2189 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"RatingLabel_base--2SDiO","isDisabled":"RatingLabel_isDisabled--_yWEe","vehicleLevelIcon":"RatingLabel_vehicleLevelIcon--3b0Ml","level-6":"RatingLabel_level-6--2hMAx","level6":"RatingLabel_level-6--2hMAx","level-8":"RatingLabel_level-8--2bL6q","level8":"RatingLabel_level-8--2bL6q","level-10":"RatingLabel_level-10--3-IpA","level10":"RatingLabel_level-10--3-IpA"};

/***/ }),
/* 2190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = exports.ReserveActivationPopover = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(7);

var _reactRouterRedux = __webpack_require__(15);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

var _reactWotBootstrap = __webpack_require__(5);

var _ReserveInfoBar = __webpack_require__(2191);

var _ReserveInfoBar2 = _interopRequireDefault(_ReserveInfoBar);

var _components = __webpack_require__(233);

var _accounts = __webpack_require__(33);

var _i18n = __webpack_require__(10);

var _reserves = __webpack_require__(28);

var _reserve_activation = __webpack_require__(370);

var _reserve_activation2 = _interopRequireDefault(_reserve_activation);

var _constants = __webpack_require__(4);

var _urls = __webpack_require__(19);

var _constants2 = __webpack_require__(2193);

var _ReserveActivationPopover = __webpack_require__(2194);

var _ReserveActivationPopover2 = _interopRequireDefault(_ReserveActivationPopover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-unused-prop-types */


var ScrollAreaWrapper = (0, _reactRedux.connect)(null, null, null, { forwardRef: true })(_reactWotBootstrap.ScrollArea);

var ReserveActivationPopover = exports.ReserveActivationPopover = function (_React$Component) {
    _inherits(ReserveActivationPopover, _React$Component);

    function ReserveActivationPopover() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ReserveActivationPopover);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReserveActivationPopover.__proto__ || Object.getPrototypeOf(ReserveActivationPopover)).call.apply(_ref, [this].concat(args))), _this), _this.handleProduceClick = function () {
            _this.props.pushState((0, _urls.BUILDING)(_this.state.buildingInfo.existingBuilding.id));
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ReserveActivationPopover, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            if (this.props.reserveType) {
                this.update(this.props);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.clearTimeouts();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps && nextProps.reserveType) {
                this.update(nextProps);
            } else {
                this.clearTimeouts();
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (!this.state || !prevState) return;

            if (this.props.popoverOpened !== prevProps.popoverOpened || this.props.reserveType !== prevProps.reserveType || this.state.firstActiveReserveInGroup !== prevState.firstActiveReserveInGroup) {
                var firstActiveReserveInGroup = this.state.firstActiveReserveInGroup;
                if (firstActiveReserveInGroup) {
                    var reservesByLevel = this.state.reservesByLevel;
                    var levels = Object.keys(reservesByLevel).map(function (level) {
                        return parseInt(level);
                    });
                    var activeLevel = firstActiveReserveInGroup.level;
                    var isLevelNotVisible = levels.length - levels.indexOf(activeLevel) > _constants2.VISIBLE_ROWS_COUNTER;
                    if (isLevelNotVisible) {
                        var top = (levels.length - levels.indexOf(activeLevel) - _constants2.VISIBLE_ROWS_COUNTER) * _constants2.ROW_HEIGHT;
                        this.scrollTop(top);
                    } else {
                        this.scrollToTop();
                    }
                } else {
                    this.scrollToTop();
                }
            }
        }
    }, {
        key: 'update',
        value: function update(props) {
            this.clearTimeouts();

            var reserveGroup = (0, _reserves.getGroupByReserve)(props.reserveType, props.settings);

            // building info
            var buildingType = (0, _reserves.getBuildingTypeByReserve)(props.reserveType, props.settings);
            var buildingName = _i18n.BUILDING_TITLES[buildingType];
            var building = Object.values(props.buildings).find(function (building) {
                return building.type === buildingType;
            }) || null;

            var availableReserves = props.clanReserves[props.reserveType].filter(_reserves.isReserveVisible);

            var firstActiveReserveInGroup = (0, _reserves.findFirstActiveReserveInGroup)(props.clanReserves, props.settings.reserve_groups[reserveGroup]);

            var firstProducingReserveInGroup = (0, _reserves.findFirstProducingReserveInGroup)(props.clanReserves, props.settings.reserve_groups[reserveGroup]);
            // group reserves by level
            var reservesByLevel = (0, _reserves.groupReservesByLevel)(availableReserves);

            if (Object.keys(reservesByLevel).length === 0) {
                if (building) {
                    reservesByLevel[building.level] = [];
                } else {
                    reservesByLevel[1] = [];
                }
            }
            this.setState({
                reserveGroup: reserveGroup,
                reservesByLevel: reservesByLevel,
                firstActiveReserveInGroup: firstActiveReserveInGroup,
                buildingInfo: {
                    name: buildingName,
                    existingBuilding: building
                }
            });

            if (!firstActiveReserveInGroup && !firstProducingReserveInGroup) return;
            this.timeoutId = setTimeout(this.update.bind(this, props), 1000);
        }
    }, {
        key: 'clearTimeouts',
        value: function clearTimeouts() {
            if (this.timeoutId) clearTimeout(this.timeoutId);
        }
    }, {
        key: 'scrollTop',
        value: function scrollTop(top) {
            if (this.props.popoverOpened) this._scrollArea.scrollTop(top);
        }
    }, {
        key: 'scrollToTop',
        value: function scrollToTop() {
            if (this.props.popoverOpened) this._scrollArea.scrollToTop();
        }
    }, {
        key: 'getMessageOrButton',
        value: function getMessageOrButton(reserveLevel) {
            var _this2 = this;

            var reservesAreAbsent = (0, _reserves.getIsReservesAbsent)(this.state.reservesByLevel);
            var message = _constants2.READY_FOR_ACTIVATION;

            if (this.state.reserveGroup === _constants.RESERVE_GROUPS.DISPOSABLE) {
                message = _constants2.ACTIVATABLE_IN_BATTLE_ROOM;
            } else if (!(0, _accounts.canReceiveReserveBonus)(this.props.account)) {
                message = _i18n.BONUS_NOT_APPLIED_TO_RESERVIST;
            } else if (this.props.strongholdIsFrozen && this.state.reserveGroup !== _constants.RESERVE_GROUPS.DISPOSABLE) {
                message = _constants2.NEGATIVE_BALANCE;
            } else if (reservesAreAbsent) {
                if (!this.state.buildingInfo.existingBuilding) {
                    message = (0, _constants2.BUILDING_IS_ABSENT)(this.state.buildingInfo.name);
                } else if ((0, _accounts.canPrepareReserve)(this.props.account)) {
                    return _react2.default.createElement(
                        _reactWotBootstrap.ButtonSmall,
                        { onClick: this.handleProduceClick },
                        _constants2.BUTTON_CAPTION_PRODUCE
                    );
                } else {
                    message = _constants2.RESERVE_DOES_NOT_EXIST;
                }
            } else if (this.state.firstActiveReserveInGroup) {

                if (this.state.firstActiveReserveInGroup.type === this.props.reserveType && this.state.firstActiveReserveInGroup.level === reserveLevel) {
                    message = _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'p',
                            { className: _ReserveActivationPopover2.default.timerCaption },
                            _constants2.RESERVE_IS_ACTIVATED
                        ),
                        _react2.default.createElement(_components.ReserveActivationTimer, { endTime: (0, _moment2.default)(this.state.firstActiveReserveInGroup.effectEnds) })
                    );
                } else {
                    message = _constants2.ANOTHER_RESERVE_IS_ACTIVATED;
                }
            } else if ((0, _accounts.canActivateReserves)(this.props.account)) {
                var handleClick = function handleClick() {
                    var firstReserve = _this2.state.reservesByLevel[reserveLevel][0].id;
                    _this2.props.activateReserve(firstReserve);
                    _this2.props.hide();
                };

                return _react2.default.createElement(
                    'div',
                    { className: _ReserveActivationPopover2.default.activationButton },
                    _react2.default.createElement(
                        _reactWotBootstrap.ButtonSmall,
                        { onClick: handleClick },
                        _constants2.BUTTON_CAPTION_ACTIVATE
                    )
                );
            }
            return _react2.default.createElement(
                'div',
                { className: _ReserveActivationPopover2.default.controlMessage },
                message
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            if (!this.props.reserveType) {
                return null;
            }

            var reserveInfo = this.props.settings.reserves[this.props.reserveType];
            var orderedLevels = Object.keys(this.state.reservesByLevel).sort(function (a, b) {
                return b - a;
            });
            var accountRecievesBonus = (0, _accounts.canReceiveReserveBonus)(this.props.account);

            var rows = [];
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = orderedLevels[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var _classNames;

                    var level = _step.value;

                    var activated = this.state.firstActiveReserveInGroup ? this.state.firstActiveReserveInGroup.type === reserveInfo.type && this.state.firstActiveReserveInGroup.level === parseInt(level) : false;

                    var reservesAreAbsent = this.state.reservesByLevel[level].length === 0;
                    var isExistingReserveDisabled = (this.props.strongholdIsFrozen || !accountRecievesBonus) && this.state.reserveGroup !== _constants.RESERVE_GROUPS.DISPOSABLE;
                    var isDisabled = isExistingReserveDisabled || reservesAreAbsent;

                    var className = (0, _classnames2.default)(_ReserveActivationPopover2.default.row, (_classNames = {}, _defineProperty(_classNames, _ReserveActivationPopover2.default.row__activated, activated), _defineProperty(_classNames, _ReserveActivationPopover2.default.row__inactive, this.state.firstActiveReserveInGroup && !activated), _defineProperty(_classNames, _ReserveActivationPopover2.default.row__disabled, isDisabled), _classNames));

                    rows.push(_react2.default.createElement(
                        'div',
                        { key: 'reserves_of_' + level + '_level', className: className },
                        _react2.default.createElement(
                            'div',
                            { className: _ReserveActivationPopover2.default.details },
                            _react2.default.createElement(_ReserveInfoBar2.default, {
                                reserveInfo: reserveInfo,
                                level: parseInt(level),
                                reserves: this.state.reservesByLevel[level],
                                highlighted: false,
                                viewType: 'toolbar'
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _ReserveActivationPopover2.default.control },
                            this.getMessageOrButton(parseInt(level))
                        )
                    ));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return _react2.default.createElement(
                'div',
                { className: _ReserveActivationPopover2.default.base },
                _react2.default.createElement(
                    'div',
                    { className: _ReserveActivationPopover2.default.header },
                    _react2.default.createElement(
                        'p',
                        { className: _ReserveActivationPopover2.default.title },
                        _i18n.RESERVE_TITLES[reserveInfo.type]
                    ),
                    _i18n.RESERVE_USAGE_BATTLE_TYPES[reserveInfo.type] && _react2.default.createElement(
                        'p',
                        { className: _ReserveActivationPopover2.default.subtitle },
                        _i18n.RESERVE_USAGE_BATTLE_TYPES[reserveInfo.type]
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _ReserveActivationPopover2.default.holder },
                    _react2.default.createElement(
                        ScrollAreaWrapper,
                        {
                            ref: function ref(node) {
                                return _this3._scrollArea = node;
                            },
                            stepHeight: _constants2.ROW_HEIGHT,
                            scrollableAreaHeight: _constants2.ROW_HEIGHT * _constants2.VISIBLE_ROWS_COUNTER,
                            modifier: 'toolbar'
                        },
                        rows
                    )
                )
            );
        }
    }]);

    return ReserveActivationPopover;
}(_react2.default.Component);

ReserveActivationPopover.propTypes = {
    clanReserves: _propTypes2.default.object.isRequired,
    reserveType: _propTypes2.default.string,
    settings: _propTypes2.default.object.isRequired,
    account: _propTypes2.default.object.isRequired,
    buildings: _propTypes2.default.object.isRequired,
    popoverOpened: _propTypes2.default.bool.isRequired,
    strongholdIsFrozen: _propTypes2.default.bool.isRequired,

    pushState: _propTypes2.default.func.isRequired,
    activateReserve: _propTypes2.default.func.isRequired,
    hide: _propTypes2.default.func.isRequired
};
var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
    var clan = state.clan,
        clanReserves = state.clanReserves,
        settings = state.settings,
        account = state.account,
        buildings = state.buildings,
        toolbar = state.toolbar;
    var reserveType = toolbar.reserveType,
        popoverOpened = toolbar.popoverOpened;

    var strongholdIsFrozen = clan ? clan.industrial_resource < 0 : false;

    return {
        account: account,
        clanReserves: clanReserves,
        reserveType: reserveType,
        settings: settings,
        buildings: buildings,
        popoverOpened: popoverOpened,
        strongholdIsFrozen: strongholdIsFrozen
    };
};

var mapDispatchToProps = exports.mapDispatchToProps = {
    pushState: _reactRouterRedux.push,
    activateReserve: _reserve_activation2.default
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ReserveActivationPopover);

/***/ }),
/* 2191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ReserveBonus = __webpack_require__(204);

var _ReserveBonus2 = _interopRequireDefault(_ReserveBonus);

var _Reserve = __webpack_require__(289);

var _Reserve2 = _interopRequireDefault(_Reserve);

var _constants = __webpack_require__(4);

var _ReserveInfoBar = __webpack_require__(2192);

var _ReserveInfoBar2 = _interopRequireDefault(_ReserveInfoBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReserveInfoBar = function ReserveInfoBar(props) {
    var reserveType = props.reserveInfo.type;

    var nextLevel = props.level < _constants.MAX_BUILDING_LEVEL ? props.level + 1 : props.level;

    var bonusType = props.viewType ? props.viewType : 'default';

    return _react2.default.createElement(
        'div',
        { className: _ReserveInfoBar2.default.base },
        _react2.default.createElement(
            'div',
            { className: _ReserveInfoBar2.default.button },
            _react2.default.createElement(_Reserve2.default, {
                type: reserveType,
                level: props.highlighted ? nextLevel : props.level,
                reserves: props.reserves,
                highlighted: props.highlighted,
                playSound: props.playSound || null
            })
        ),
        _react2.default.createElement(
            'div',
            { className: _ReserveInfoBar2.default.content },
            _react2.default.createElement(_ReserveBonus2.default, {
                reserveInfo: props.reserveInfo,
                level: props.level,
                nextLevel: nextLevel,
                isNextLevelHighlighted: props.highlighted,
                layoutType: bonusType
            })
        )
    );
};

ReserveInfoBar.propTypes = {
    reserveInfo: _propTypes2.default.object.isRequired,
    level: _propTypes2.default.number.isRequired,
    reserves: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
    highlighted: _propTypes2.default.bool.isRequired,
    viewType: _propTypes2.default.oneOf(['default', 'tooltip', 'toolbar']),
    playSound: _propTypes2.default.func
};

exports.default = ReserveInfoBar;

/***/ }),
/* 2192 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"ReserveInfoBar_base--oxrLw","base__toolbar":"ReserveInfoBar_base__toolbar--3D_cM","baseToolbar":"ReserveInfoBar_base__toolbar--3D_cM","content":"ReserveInfoBar_content--2_v6v","button":"ReserveInfoBar_button--3VumP"};

/***/ }),
/* 2193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.VISIBLE_ROWS_COUNTER = exports.ROW_HEIGHT = exports.RESERVIST_DOESNT_RECEIVE_BONUS = exports.NEGATIVE_BALANCE = exports.ACTIVATABLE_IN_BATTLE_ROOM = exports.RESERVE_IS_ACTIVATED = exports.ANOTHER_RESERVE_IS_ACTIVATED = exports.READY_FOR_ACTIVATION = exports.BUILDING_IS_ABSENT = exports.RESERVE_DOES_NOT_EXIST = exports.BUTTON_CAPTION_ACTIVATE = exports.BUTTON_CAPTION_PRODUCE = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-multi-comp */
var BUTTON_CAPTION_PRODUCE = exports.BUTTON_CAPTION_PRODUCE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'reserve_activation_popover.button_caption_produce',
    defaultMessage: '\u041F\u043E\u0434\u0433\u043E\u0442\u043E\u0432\u0438\u0442\u044C'
});

var BUTTON_CAPTION_ACTIVATE = exports.BUTTON_CAPTION_ACTIVATE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'reserve_activation_popover.button_caption_activate',
    defaultMessage: '\u0410\u043A\u0442\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u0442\u044C'
});

var RESERVE_DOES_NOT_EXIST = exports.RESERVE_DOES_NOT_EXIST = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'reserve_activation_popover.reserve_does_not_exist',
    defaultMessage: '\u041D\u0435\u0442 \u043D\u0430 \u0441\u043A\u043B\u0430\u0434\u0435'
});

var BUILDING_IS_ABSENT = exports.BUILDING_IS_ABSENT = function BUILDING_IS_ABSENT(buildingName) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'reserve_activation_popover.building_is_absent',
        defaultMessage: '\u0414\u043B\u044F \u043F\u043E\u0434\u0433\u043E\u0442\u043E\u0432\u043A\u0438 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0441\u0442\u0440\u043E\u0435\u043D\u0438\u0435 {buildingName}',
        values: {
            buildingName: buildingName
        }
    });
};

var READY_FOR_ACTIVATION = exports.READY_FOR_ACTIVATION = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'reserve_activation_popover.ready_for_activation',
    defaultMessage: '\u0413\u043E\u0442\u043E\u0432 \u043A \u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u0438'
});

var ANOTHER_RESERVE_IS_ACTIVATED = exports.ANOTHER_RESERVE_IS_ACTIVATED = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'reserve_activation_popover.another_reserve_is_activated',
    defaultMessage: '\u0410\u043A\u0442\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u043D \u0434\u0440\u0443\u0433\u043E\u0439 \u0440\u0435\u0437\u0435\u0440\u0432 \u044D\u0442\u043E\u0439 \u0433\u0440\u0443\u043F\u043F\u044B'
});

var RESERVE_IS_ACTIVATED = exports.RESERVE_IS_ACTIVATED = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'reserve_activation_popover.reserve_is_activated',
    defaultMessage: '\u0410\u043A\u0442\u0438\u0432\u0438\u0440\u043E\u0432\u0430\u043D'
});

var ACTIVATABLE_IN_BATTLE_ROOM = exports.ACTIVATABLE_IN_BATTLE_ROOM = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'reserve_activation_popover.activatable_in_battle_room',
    defaultMessage: '\u0410\u043A\u0442\u0438\u0432\u0438\u0440\u0443\u0435\u0442\u0441\u044F \u0432 \u0431\u043E\u0435\u0432\u043E\u0439 \u043A\u043E\u043C\u043D\u0430\u0442\u0435'
});
var NEGATIVE_BALANCE = exports.NEGATIVE_BALANCE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'reserve_activation_popover.negative_balance',
    defaultMessage: '\u0414\u0435\u0439\u0441\u0442\u0432\u0443\u0435\u0442 \u0448\u0442\u0440\u0430\u0444'
});

var RESERVIST_DOESNT_RECEIVE_BONUS = exports.RESERVIST_DOESNT_RECEIVE_BONUS = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'reserve_activation_popover.reservist_doesnt_receive_bonus',
    defaultMessage: '\u0420\u0435\u0437\u0435\u0440\u0432\u0438\u0441\u0442\u044B \u043D\u0435 \u043F\u043E\u043B\u0443\u0447\u0430\u044E\u0442 \u043D\u0430\u0434\u0431\u0430\u0432\u043E\u043A'
});

var ROW_HEIGHT = exports.ROW_HEIGHT = 118;
var VISIBLE_ROWS_COUNTER = exports.VISIBLE_ROWS_COUNTER = 3;

/***/ }),
/* 2194 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"ReserveActivationPopover_base--3M1o_","body":"ReserveActivationPopover_body--2hiBJ","wrapper":"ReserveActivationPopover_wrapper--T6Enn","background":"ReserveActivationPopover_background--2oFAZ","content":"ReserveActivationPopover_content--1C0sd","title":"ReserveActivationPopover_title--ESCDA","message":"ReserveActivationPopover_message--1SOjg","divider":"ReserveActivationPopover_divider--3Tf89","highlight":"ReserveActivationPopover_highlight--3iSBn","ribbon":"ReserveActivationPopover_ribbon--3Ce5H","header":"ReserveActivationPopover_header--2p6d1","subtitle":"ReserveActivationPopover_subtitle--3N7o8","holder":"ReserveActivationPopover_holder--2k-yW","row":"ReserveActivationPopover_row--1w7H8","row__activated":"ReserveActivationPopover_row__activated--2KCf5","rowActivated":"ReserveActivationPopover_row__activated--2KCf5","row__disabled":"ReserveActivationPopover_row__disabled--2R3E3","rowDisabled":"ReserveActivationPopover_row__disabled--2R3E3","details":"ReserveActivationPopover_details--OrhMO","row__inactive":"ReserveActivationPopover_row__inactive--22BPt","rowInactive":"ReserveActivationPopover_row__inactive--22BPt","control":"ReserveActivationPopover_control--2Keui","controlMessage":"ReserveActivationPopover_controlMessage--1cZAP","timerCaption":"ReserveActivationPopover_timerCaption--2E8U8","activationButton":"ReserveActivationPopover_activationButton--ejFNe"};

/***/ }),
/* 2195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Timer = __webpack_require__(51);

var _Timer2 = _interopRequireDefault(_Timer);

var _ReserveActivationTimer = __webpack_require__(2196);

var _ReserveActivationTimer2 = _interopRequireDefault(_ReserveActivationTimer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReserveActivationTimer = function (_React$Component) {
    _inherits(ReserveActivationTimer, _React$Component);

    function ReserveActivationTimer() {
        _classCallCheck(this, ReserveActivationTimer);

        return _possibleConstructorReturn(this, (ReserveActivationTimer.__proto__ || Object.getPrototypeOf(ReserveActivationTimer)).apply(this, arguments));
    }

    _createClass(ReserveActivationTimer, [{
        key: 'render',
        value: function render() {
            if (!this.props.endTime) return null;

            return _react2.default.createElement(
                'div',
                { className: _ReserveActivationTimer2.default.base },
                _react2.default.createElement(
                    'p',
                    { className: _ReserveActivationTimer2.default.time },
                    _react2.default.createElement(_Timer2.default, { endTime: this.props.endTime })
                )
            );
        }
    }]);

    return ReserveActivationTimer;
}(_react2.default.Component);

ReserveActivationTimer.propTypes = {
    endTime: _propTypes2.default.object
};
exports.default = ReserveActivationTimer;

/***/ }),
/* 2196 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"ReserveActivationTimer_base--3V7F_","time":"ReserveActivationTimer_time--3x6_s"};

/***/ }),
/* 2197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapStateToProps = exports.ReserveButton = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(7);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

var _web_to_client = __webpack_require__(17);

var _Reserve = __webpack_require__(289);

var _Reserve2 = _interopRequireDefault(_Reserve);

var _ReserveProgress = __webpack_require__(1349);

var _ReserveProgress2 = _interopRequireDefault(_ReserveProgress);

var _components = __webpack_require__(233);

var _translations = __webpack_require__(2199);

var _i18n = __webpack_require__(10);

var _accounts = __webpack_require__(33);

var _reserves = __webpack_require__(28);

var _constants = __webpack_require__(4);

var _ReserveButton = __webpack_require__(2200);

var _ReserveButton2 = _interopRequireDefault(_ReserveButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReserveButton = exports.ReserveButton = function (_React$Component) {
    _inherits(ReserveButton, _React$Component);

    function ReserveButton() {
        _classCallCheck(this, ReserveButton);

        return _possibleConstructorReturn(this, (ReserveButton.__proto__ || Object.getPrototypeOf(ReserveButton)).apply(this, arguments));
    }

    _createClass(ReserveButton, [{
        key: 'render',
        value: function render() {
            var _this2 = this,
                _classNames;

            var battleReserve = _constants.RESERVE_GROUPS.DISPOSABLE === this.props.group;
            var activatedReserve = (0, _reserves.getActivatedReserve)(this.props.reserves);
            var currentLevel = (0, _reserves.getCurrentLevel)(activatedReserve, this.props.reserves);
            var reserveParameters = this.props.reserveBonus.values[currentLevel - 1].parameters;
            var bonusValuesArray = (0, _reserves.getBonusValues)(this.props.reserveBonus, currentLevel);

            var bonusValue = function () {
                switch (_this2.props.reserveType) {
                    case _constants.RESERVE_TYPES.INSPIRATION:
                        return reserveParameters && reserveParameters.crewRolesFactor;
                    case _constants.RESERVE_TYPES.ARTILLERY_STRIKE:
                        return reserveParameters && reserveParameters.maxDamage && reserveParameters.maxDamage.slice(-1);
                    default:
                        return bonusValuesArray.map(function (value) {
                            return '+' + value;
                        }).join('\u2009/\u2009'); // &thinsp;
                }
            }();
            var bonusText = function () {
                switch (_this2.props.reserveType) {
                    case _constants.RESERVE_TYPES.INSPIRATION:
                    case _constants.RESERVE_TYPES.ARTILLERY_STRIKE:
                        return _translations.RESERVE_MAIN_BONUS_DESCRIPTION[_this2.props.reserveType];
                    default:
                        return _i18n.BONUS_TYPE_MESSAGES[_this2.props.reserveBonus.type];
                }
            }();

            var activationBlocked = this.props.hasActiveReserveInGroup && !activatedReserve;
            var hasReservesOfMultipleLevels = Object.keys(this.props.reserves).length > 1;
            var isCurrentReserveSelected = this.props.popoverOpened && this.props.popoverReserveType === this.props.reserveType;
            var currentLevelReserves = this.props.reserves[currentLevel];

            var popoverOffset = void 0;
            if (battleReserve) {
                popoverOffset = '{ "bottom": 3 }';

                if (window.matchMedia(_constants.MEDIA_QUERIES.MEDIUM).matches) {
                    popoverOffset = '{ "bottom": 12 }';
                }
            }

            var popoverType = (0, _reserves.getTargetType)(this.props.group, bonusValuesArray);

            var isDisabled = this.props.isEconomicsReserve && (this.props.strongholdIsFrozen || !(0, _accounts.canReceiveReserveBonus)(this.props.account)) || this.props.reserves[currentLevel].length === 0;

            var className = (0, _classnames2.default)(_ReserveButton2.default.base, (_classNames = {}, _defineProperty(_classNames, _ReserveButton2.default.base__typeEconomics, this.props.isEconomicsReserve), _defineProperty(_classNames, _ReserveButton2.default.base__typeBattle, battleReserve), _defineProperty(_classNames, _ReserveButton2.default.base__stateActivated, activatedReserve), _defineProperty(_classNames, _ReserveButton2.default.base__stateDisabled, isDisabled), _defineProperty(_classNames, _ReserveButton2.default.base__stateActivationBlocked, activationBlocked), _defineProperty(_classNames, _ReserveButton2.default.base__viewStack, hasReservesOfMultipleLevels), _defineProperty(_classNames, _ReserveButton2.default.base__selected, isCurrentReserveSelected), _classNames));

            var timer = void 0;
            var progress = void 0;
            if (activatedReserve) {
                timer = _react2.default.createElement(
                    'div',
                    { className: _ReserveButton2.default.timer },
                    _react2.default.createElement(_components.ReserveActivationTimer, { endTime: (0, _moment2.default)(activatedReserve.effectEnds) })
                );
                progress = _react2.default.createElement(_ReserveProgress2.default, {
                    endTime: (0, _moment2.default)(activatedReserve.effectEnds),
                    totalDuration: this.props.reserveBonus.values[activatedReserve.level - 1].duration
                });
            }

            // sendButtonClickSoundCommand accepts arguments, so we can't pass it directly to onMouseDown handler
            var playButtonClickSound = _web_to_client.sendButtonClickSoundCommand.bind(null, undefined);

            return _react2.default.createElement(
                'div',
                { key: this.props.reserveType, className: className },
                timer,
                _react2.default.createElement(
                    'div',
                    {
                        key: this.props.reserveType,
                        className: _ReserveButton2.default.button,
                        onClick: this.props.handleClick,
                        onMouseDown: playButtonClickSound,
                        onMouseEnter: this.props.handleMouseEnter,
                        onMouseLeave: this.props.handleMouseLeave,
                        'data-popover-offset': popoverOffset,
                        'data-popover-type': popoverType,
                        'data-tip': true,
                        'data-for': this.props.tooltipId
                    },
                    _react2.default.createElement(
                        'div',
                        { className: _ReserveButton2.default.reserve },
                        _react2.default.createElement(_Reserve2.default, {
                            type: this.props.reserveType,
                            level: currentLevel,
                            modifier: 'toolbar',
                            reserves: currentLevelReserves
                        })
                    ),
                    progress
                ),
                _react2.default.createElement(
                    'div',
                    { className: _ReserveButton2.default.bonus },
                    _react2.default.createElement(
                        'p',
                        { className: _ReserveButton2.default.value },
                        bonusValue
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: _ReserveButton2.default.text },
                        bonusText
                    )
                )
            );
        }
    }]);

    return ReserveButton;
}(_react2.default.Component);

ReserveButton.propTypes = {
    handleClick: _propTypes2.default.func.isRequired,
    handleMouseEnter: _propTypes2.default.func.isRequired,
    handleMouseLeave: _propTypes2.default.func.isRequired,
    group: _propTypes2.default.string.isRequired,
    reserveBonus: _propTypes2.default.shape({
        type: _propTypes2.default.string.isRequired,
        values: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired
    }),
    reserveType: _propTypes2.default.string.isRequired,
    reserves: _propTypes2.default.object,
    hasActiveReserveInGroup: _propTypes2.default.bool,
    tooltipId: _propTypes2.default.string,

    account: _propTypes2.default.object.isRequired,
    isEconomicsReserve: _propTypes2.default.bool.isRequired,
    popoverOpened: _propTypes2.default.bool,
    popoverReserveType: _propTypes2.default.string,
    strongholdIsFrozen: _propTypes2.default.bool.isRequired
};
var mapStateToProps = exports.mapStateToProps = function mapStateToProps(_ref, ownProps) {
    var account = _ref.account,
        clan = _ref.clan,
        toolbar = _ref.toolbar;
    var popoverOpened = toolbar.popoverOpened,
        reserveType = toolbar.reserveType;

    var strongholdIsFrozen = clan ? clan.industrial_resource < 0 : false;

    var isEconomicsReserve = [_constants.RESERVE_GROUPS.DEVELOPMENT, _constants.RESERVE_GROUPS.ECONOMIC].includes(ownProps.group);

    return {
        account: account,
        popoverOpened: popoverOpened,
        popoverReserveType: reserveType,
        strongholdIsFrozen: strongholdIsFrozen,
        isEconomicsReserve: isEconomicsReserve
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ReserveButton);

/***/ }),
/* 2198 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"ReserveProgress_base--2snys"};

/***/ }),
/* 2199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RESERVE_MAIN_BONUS_DESCRIPTION = undefined;

var _RESERVE_MAIN_BONUS_D;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var RESERVE_MAIN_BONUS_DESCRIPTION = exports.RESERVE_MAIN_BONUS_DESCRIPTION = (_RESERVE_MAIN_BONUS_D = {}, _defineProperty(_RESERVE_MAIN_BONUS_D, _constants.RESERVE_TYPES.INSPIRATION, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'reserves_toolbar.main_bonus_description.crew_roles_factor',
    defaultMessage: '\u043A{nbsp}\u0441\u043F\u0435\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438 \u044D\u043A\u0438\u043F\u0430\u0436\u0430',
    values: {
        nbsp: _react2.default.createElement(
            'span',
            null,
            '\xA0'
        )
    }
})), _defineProperty(_RESERVE_MAIN_BONUS_D, _constants.RESERVE_TYPES.ARTILLERY_STRIKE, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'reserves_toolbar.main_bonus_description.artillery_strike',
    defaultMessage: '\u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u044B\u0439 \u0443\u0440\u043E\u043D (\u0435\u0434.)'
})), _RESERVE_MAIN_BONUS_D);

/***/ }),
/* 2200 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"ReserveButton_base--2K7eF","base__typeEconomics":"ReserveButton_base__typeEconomics--2Thws","baseTypeEconomics":"ReserveButton_base__typeEconomics--2Thws","base__typeBattle":"ReserveButton_base__typeBattle--bZ5u5","baseTypeBattle":"ReserveButton_base__typeBattle--bZ5u5","base__selected":"ReserveButton_base__selected--AicbA","baseSelected":"ReserveButton_base__selected--AicbA","button":"ReserveButton_button--1Vouq","base__viewStack":"ReserveButton_base__viewStack--2HQZ8","baseViewStack":"ReserveButton_base__viewStack--2HQZ8","base__stateActivated":"ReserveButton_base__stateActivated--17RjU","baseStateActivated":"ReserveButton_base__stateActivated--17RjU","base__stateDisabled":"ReserveButton_base__stateDisabled--3PBoA","baseStateDisabled":"ReserveButton_base__stateDisabled--3PBoA","base__stateActivationBlocked":"ReserveButton_base__stateActivationBlocked--3jQaC","baseStateActivationBlocked":"ReserveButton_base__stateActivationBlocked--3jQaC","bonus":"ReserveButton_bonus--3YXuJ","value":"ReserveButton_value--2MO-9","text":"ReserveButton_text--2Z7p-","timer":"ReserveButton_timer--OyLwW","reserve":"ReserveButton_reserve--Qxvg-"};

/***/ }),
/* 2201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RESERVIST_DOESNT_RECEIVE_BONUS = exports.EARN_LACKING_INDUSTRIAL_RESOURCE = exports.FROM_CHALLENGES = exports.X_LEVEL_ONLY = exports.READY_FOR_ACTIVATION = exports.RESERVE_DOES_NOT_EXIST = exports.ANOTHER_RESERVE_IS_ACTIVATED = exports.ACTIVATION_IS_IMPOSSIBLE = exports.DOES_NOT_HAVE_PERMISSION = exports.RESERVE_IS_ACTIVATED = exports.ACTIVATABLE_IN_BATTLE_ROOM_READY_TO_INSTALL = exports.ACTIVATABLE_IN_BATTLE_ROOM_RESERVE_DOES_NOT_EXIST = exports.ACTIVATABLE_IN_BATTLE_ROOM_INSTALL_IS_NOT_POSSIBLE = exports.ACTIVATABLE_IN_BATTLE_ROOM_DOES_NOT_HAVE_PERMISSION = exports.RESERVE_BUILDING = exports.RESERVE_COUNTER = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-multi-comp */
var RESERVE_COUNTER = exports.RESERVE_COUNTER = function RESERVE_COUNTER(counter) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'reserve_tooltip.counter',
        defaultMessage: '{counter} на складе',
        values: {
            counter: counter
        }
    });
};

var RESERVE_BUILDING = exports.RESERVE_BUILDING = function RESERVE_BUILDING(buildingName) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'reserve_tooltip.building',
        defaultMessage: 'Подготавливается в строении {buildingName}',
        values: { buildingName: buildingName }
    });
};

var ACTIVATABLE_IN_BATTLE_ROOM_DOES_NOT_HAVE_PERMISSION = exports.ACTIVATABLE_IN_BATTLE_ROOM_DOES_NOT_HAVE_PERMISSION = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'reserve_tooltip.activatable_in_battle_room_does_not_have_permission',
    defaultMessage: 'Устанавливается командиром отряда с должностью командующего, заместителя командующего, офицера штаба или командира подразделения' // eslint-disable-line max-len
});

var ACTIVATABLE_IN_BATTLE_ROOM_INSTALL_IS_NOT_POSSIBLE = exports.ACTIVATABLE_IN_BATTLE_ROOM_INSTALL_IS_NOT_POSSIBLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'reserve_tooltip.activatable_in_battle_room_install_is_not_possible',
    defaultMessage: 'Установка недоступна.'
});

var ACTIVATABLE_IN_BATTLE_ROOM_RESERVE_DOES_NOT_EXIST = exports.ACTIVATABLE_IN_BATTLE_ROOM_RESERVE_DOES_NOT_EXIST = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'reserve_tooltip.activatable_in_battle_room_reserve_does_not_exist',
    defaultMessage: 'Резерва нет на складе'
});

var ACTIVATABLE_IN_BATTLE_ROOM_READY_TO_INSTALL = exports.ACTIVATABLE_IN_BATTLE_ROOM_READY_TO_INSTALL = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'reserve_tooltip.activatable_in_battle_room_ready_to_install',
    defaultMessage: 'Готов к установке в окне отряда'
});

var RESERVE_IS_ACTIVATED = exports.RESERVE_IS_ACTIVATED = function RESERVE_IS_ACTIVATED(time) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'reserve_tooltip.reserve_is_activated',
        defaultMessage: 'Активирован. Действует в течение {time}',
        values: { time: time }
    });
};

var DOES_NOT_HAVE_PERMISSION = exports.DOES_NOT_HAVE_PERMISSION = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'reserve_tooltip.does_not_have_permission',
    defaultMessage: 'Активируется командующим, заместителем командующего, офицером штаба или командиром подразделения' // eslint-disable-line max-len
});

var ACTIVATION_IS_IMPOSSIBLE = exports.ACTIVATION_IS_IMPOSSIBLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'reserve_tooltip.activation_is_impossible',
    defaultMessage: 'Активация невозможна.'
});

var ANOTHER_RESERVE_IS_ACTIVATED = exports.ANOTHER_RESERVE_IS_ACTIVATED = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'reserve_tooltip.another_reserve_is_activated',
    defaultMessage: 'Ожидайте завершения действия другого резерва из этой группы'
});

var RESERVE_DOES_NOT_EXIST = exports.RESERVE_DOES_NOT_EXIST = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'reserve_tooltip.reserve_does_not_exist',
    defaultMessage: 'Резерва нет на складе'
});

var READY_FOR_ACTIVATION = exports.READY_FOR_ACTIVATION = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'reserve_tooltip.ready_for_activation',
    defaultMessage: 'Готов к активации'
});

var X_LEVEL_ONLY = exports.X_LEVEL_ONLY = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'reserve_tooltip.x_level_only',
    defaultMessage: 'Only for Tier X-XI vehicles'
});

var FROM_CHALLENGES = exports.FROM_CHALLENGES = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'reserve_tooltip.from_challenges',
    defaultMessage: 'Можно получить наградой в Военных играх'
});

var EARN_LACKING_INDUSTRIAL_RESOURCE = exports.EARN_LACKING_INDUSTRIAL_RESOURCE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'reserve_tooltip.activation_id_frozen',
    defaultMessage: 'Заработайте недостающий промресурс, чтобы погасить штраф.'
});

var RESERVIST_DOESNT_RECEIVE_BONUS = exports.RESERVIST_DOESNT_RECEIVE_BONUS = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'reserve_tooltip.reservist_doesnt_receive',
    defaultMessage: 'Резервисты не получают надбавок от клановых резервов.'
});

/***/ }),
/* 2202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"ReserveTooltip_root--1r0vh","root__show":"ReserveTooltip_root__show--1rSxj","rootShow":"ReserveTooltip_root__show--1rSxj","body":"ReserveTooltip_body--ZI0bo","wrapper":"ReserveTooltip_wrapper--Pz_SE","content":"ReserveTooltip_content--3VhLr","title":"ReserveTooltip_title--2T9cT","subtitle":"ReserveTooltip_subtitle--2h5lr","message":"ReserveTooltip_message--2BCTR","warning":"ReserveTooltip_warning--xvio5","divider":"ReserveTooltip_divider--17di_","highlight":"ReserveTooltip_highlight--1Nhk4","ribbon":"ReserveTooltip_ribbon--URMDq","statusMessage":"ReserveTooltip_statusMessage--1bchU","statusMessage__positive":"ReserveTooltip_statusMessage__positive--1Z2TN","statusMessagePositive":"ReserveTooltip_statusMessage__positive--1Z2TN","status":"ReserveTooltip_status--2KLFw","statusMessage__negative":"ReserveTooltip_statusMessage__negative--1t_u1","statusMessageNegative":"ReserveTooltip_statusMessage__negative--1t_u1","statusMessage__noPermission":"ReserveTooltip_statusMessage__noPermission--DeT3n","statusMessageNoPermission":"ReserveTooltip_statusMessage__noPermission--DeT3n","status__positive":"ReserveTooltip_status__positive--1XNJX","statusPositive":"ReserveTooltip_status__positive--1XNJX","status__negative":"ReserveTooltip_status__negative--3UauC","statusNegative":"ReserveTooltip_status__negative--3UauC","statusText":"ReserveTooltip_statusText--1Aays","base__type-economics":"ReserveTooltip_base__type-economics--1vQlK","baseTypeEconomics":"ReserveTooltip_base__type-economics--1vQlK","base__type-economics-double":"ReserveTooltip_base__type-economics-double--VouLM","baseTypeEconomicsDouble":"ReserveTooltip_base__type-economics-double--VouLM","base__type-battle":"ReserveTooltip_base__type-battle--1o6wM","baseTypeBattle":"ReserveTooltip_base__type-battle--1o6wM","header":"ReserveTooltip_header--4X8E1","button":"ReserveTooltip_button--3VZUe","thumbnail":"ReserveTooltip_thumbnail--1vEX5","image":"ReserveTooltip_image--DVVLA","image__artillery-strike":"ReserveTooltip_image__artillery-strike--2yG7L","imageArtilleryStrike":"ReserveTooltip_image__artillery-strike--2yG7L","image__elite":"ReserveTooltip_image__elite--1q6pz","imageElite":"ReserveTooltip_image__elite--1q6pz","image__airstrike":"ReserveTooltip_image__airstrike--ltHz7","imageAirstrike":"ReserveTooltip_image__airstrike--ltHz7","image__requisition":"ReserveTooltip_image__requisition--LVzqV","imageRequisition":"ReserveTooltip_image__requisition--LVzqV","image__high-capacity-transport":"ReserveTooltip_image__high-capacity-transport--3I3Ta","imageHighCapacityTransport":"ReserveTooltip_image__high-capacity-transport--3I3Ta","image__additional-briefing":"ReserveTooltip_image__additional-briefing--3wkMT","imageAdditionalBriefing":"ReserveTooltip_image__additional-briefing--3wkMT","image__tactical-training":"ReserveTooltip_image__tactical-training--3x_b5","imageTacticalTraining":"ReserveTooltip_image__tactical-training--3x_b5","image__military-maneuvers":"ReserveTooltip_image__military-maneuvers--3VwdY","imageMilitaryManeuvers":"ReserveTooltip_image__military-maneuvers--3VwdY","image__battle-payments":"ReserveTooltip_image__battle-payments--1-3Ap","imageBattlePayments":"ReserveTooltip_image__battle-payments--1-3Ap","image__inspiration":"ReserveTooltip_image__inspiration--2Ap4Z","imageInspiration":"ReserveTooltip_image__inspiration--2Ap4Z","info":"ReserveTooltip_info--MZY3q","level":"ReserveTooltip_level--39D8J","counterInfo":"ReserveTooltip_counterInfo--1oPbl","counter":"ReserveTooltip_counter--qKnzl","reserveMessages":"ReserveTooltip_reserveMessages--1WCZI","reserveMessage":"ReserveTooltip_reserveMessage--1HYVl"};

/***/ }),
/* 2203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactWotBootstrap = __webpack_require__(5);

var _constants = __webpack_require__(2204);

var _SlotTooltip = __webpack_require__(2205);

var _SlotTooltip2 = _interopRequireDefault(_SlotTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SlotTooltip = function SlotTooltip(props) {
    var message = props.hasPermission ? _constants.SLOT_TOOLTIP_MESSAGE : _constants.SLOT_TOOLTIP_MESSAGE_NO_PERMISSION;
    return _react2.default.createElement(
        _reactWotBootstrap.Tooltip,
        { id: 'slot_' + props.slotId },
        _react2.default.createElement(
            'div',
            { className: _SlotTooltip2.default.content },
            _react2.default.createElement(
                'p',
                { className: _SlotTooltip2.default.message },
                props.showConstructMessage ? message : null
            )
        )
    );
};

SlotTooltip.defaultProps = {
    showConstructMessage: true
};

SlotTooltip.propTypes = {
    slotId: _propTypes2.default.number.isRequired,
    showConstructMessage: _propTypes2.default.bool,
    hasPermission: _propTypes2.default.bool.isRequired
};

exports.default = SlotTooltip;

/***/ }),
/* 2204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SLOT_TOOLTIP_MESSAGE_NO_PERMISSION = exports.SLOT_TOOLTIP_MESSAGE = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SLOT_TOOLTIP_MESSAGE = exports.SLOT_TOOLTIP_MESSAGE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'slot_tooltip.message',
    defaultMessage: '\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u0432\u044B\u0431\u0440\u0430\u0442\u044C \u0438 \u0432\u043E\u0437\u0432\u0435\u0441\u0442\u0438 \u043D\u043E\u0432\u043E\u0435 \u0441\u0442\u0440\u043E\u0435\u043D\u0438\u0435 \u043D\u0430 \u044D\u0442\u043E\u043C \u043C\u0435\u0441\u0442\u0435.'
});

var SLOT_TOOLTIP_MESSAGE_NO_PERMISSION = exports.SLOT_TOOLTIP_MESSAGE_NO_PERMISSION = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'slot_tooltip.message_no_permission',
    defaultMessage: '\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u0441\u043F\u0438\u0441\u043E\u043A \u043D\u0435\u0432\u043E\u0437\u0432\u0435\u0434\u0451\u043D\u043D\u044B\u0445 \u0441\u0442\u0440\u043E\u0435\u043D\u0438\u0439.'
});

/***/ }),
/* 2205 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"SlotTooltip_root--2ASp0","root__show":"SlotTooltip_root__show--3yM6l","rootShow":"SlotTooltip_root__show--3yM6l","body":"SlotTooltip_body--3NZqE","wrapper":"SlotTooltip_wrapper--Ie4hI","content":"SlotTooltip_content--2e4lv","title":"SlotTooltip_title--36PTs","subtitle":"SlotTooltip_subtitle--2KZJ7","message":"SlotTooltip_message--VfpwF","warning":"SlotTooltip_warning--3miz3","divider":"SlotTooltip_divider--2sloz","highlight":"SlotTooltip_highlight--3jRKf","ribbon":"SlotTooltip_ribbon--2xFuX","statusMessage":"SlotTooltip_statusMessage--21lI-","statusMessage__positive":"SlotTooltip_statusMessage__positive--2TgCe","statusMessagePositive":"SlotTooltip_statusMessage__positive--2TgCe","status":"SlotTooltip_status--1jpzv","statusMessage__negative":"SlotTooltip_statusMessage__negative--_pIT_","statusMessageNegative":"SlotTooltip_statusMessage__negative--_pIT_","statusMessage__noPermission":"SlotTooltip_statusMessage__noPermission--bNRyd","statusMessageNoPermission":"SlotTooltip_statusMessage__noPermission--bNRyd","status__positive":"SlotTooltip_status__positive--5c7XQ","statusPositive":"SlotTooltip_status__positive--5c7XQ","status__negative":"SlotTooltip_status__negative--11Yk_","statusNegative":"SlotTooltip_status__negative--11Yk_","statusText":"SlotTooltip_statusText--1Lb1z"};

/***/ }),
/* 2206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StatsTooltip = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _helpers = __webpack_require__(11);

var _reactWotBootstrap = __webpack_require__(5);

var _StatsTable = __webpack_require__(561);

var _StatsTable2 = _interopRequireDefault(_StatsTable);

var _constants = __webpack_require__(1347);

var _StatsTooltip = __webpack_require__(2207);

var _StatsTooltip2 = _interopRequireDefault(_StatsTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StatsTooltip = exports.StatsTooltip = function StatsTooltip(props) {
    var level = props.level,
        sorties = props.sorties,
        fort_battles = props.fort_battles;


    var hasSorties = sorties.battles_count;
    var hasFortBattles = fort_battles && fort_battles.battles_count;

    if (!hasSorties && !hasFortBattles) {
        return _react2.default.createElement(
            _reactWotBootstrap.Tooltip,
            { id: _constants.STATS_TOOLTIPS_IDS[level] },
            _react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)(_StatsTooltip2.default.base, _StatsTooltip2.default.base__noBattles) },
                _react2.default.createElement(
                    'p',
                    { className: _StatsTooltip2.default.tooltipMessage },
                    (0, _constants.STATS_TOOLTIP_NO_STATS)((0, _helpers.toRoman)(level))
                )
            )
        );
    }

    return _react2.default.createElement(
        _reactWotBootstrap.Tooltip,
        { id: _constants.STATS_TOOLTIPS_IDS[level], isWide: true },
        _react2.default.createElement(
            'div',
            { className: _StatsTooltip2.default.base },
            _react2.default.createElement(_StatsTable2.default, props)
        )
    );
};

StatsTooltip.propTypes = {
    elo: _propTypes2.default.number,
    level: _propTypes2.default.string.isRequired,
    fort_battles: _propTypes2.default.object,
    sorties: _propTypes2.default.object.isRequired,
    elo_details: _propTypes2.default.shape({
        position: _propTypes2.default.number,
        battles_count: _propTypes2.default.number,
        required_battles_count: _propTypes2.default.number,
        recalculation_period: _propTypes2.default.number
    })
};

exports.default = StatsTooltip;

/***/ }),
/* 2207 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tooltip-root":"StatsTooltip_tooltip-root--1nCEs","tooltipRoot":"StatsTooltip_tooltip-root--1nCEs","tooltip-root__show":"StatsTooltip_tooltip-root__show--20fpI","tooltipRootShow":"StatsTooltip_tooltip-root__show--20fpI","tooltip-body":"StatsTooltip_tooltip-body--3hzW8","tooltipBody":"StatsTooltip_tooltip-body--3hzW8","tooltip-wrapper":"StatsTooltip_tooltip-wrapper--2_NJe","tooltipWrapper":"StatsTooltip_tooltip-wrapper--2_NJe","tooltip-content":"StatsTooltip_tooltip-content--2VaN2","tooltipContent":"StatsTooltip_tooltip-content--2VaN2","tooltip-title":"StatsTooltip_tooltip-title--3u9g6","tooltipTitle":"StatsTooltip_tooltip-title--3u9g6","tooltip-subtitle":"StatsTooltip_tooltip-subtitle--2GXgO","tooltipSubtitle":"StatsTooltip_tooltip-subtitle--2GXgO","tooltip-message":"StatsTooltip_tooltip-message--3W_jJ","tooltipMessage":"StatsTooltip_tooltip-message--3W_jJ","tooltip-warning":"StatsTooltip_tooltip-warning--3idq0","tooltipWarning":"StatsTooltip_tooltip-warning--3idq0","tooltip-divider":"StatsTooltip_tooltip-divider--JmXwu","tooltipDivider":"StatsTooltip_tooltip-divider--JmXwu","tooltip-highlight":"StatsTooltip_tooltip-highlight--z1iFv","tooltipHighlight":"StatsTooltip_tooltip-highlight--z1iFv","tooltip-ribbon":"StatsTooltip_tooltip-ribbon--35jUh","tooltipRibbon":"StatsTooltip_tooltip-ribbon--35jUh","tooltip-statusMessage":"StatsTooltip_tooltip-statusMessage--1Alad","tooltipStatusMessage":"StatsTooltip_tooltip-statusMessage--1Alad","tooltip-statusMessage__positive":"StatsTooltip_tooltip-statusMessage__positive--nwnHt","tooltipStatusMessagePositive":"StatsTooltip_tooltip-statusMessage__positive--nwnHt","tooltip-status":"StatsTooltip_tooltip-status--37sWu","tooltipStatus":"StatsTooltip_tooltip-status--37sWu","tooltip-statusMessage__negative":"StatsTooltip_tooltip-statusMessage__negative--3zpOW","tooltipStatusMessageNegative":"StatsTooltip_tooltip-statusMessage__negative--3zpOW","tooltip-statusMessage__noPermission":"StatsTooltip_tooltip-statusMessage__noPermission--25cNQ","tooltipStatusMessageNoPermission":"StatsTooltip_tooltip-statusMessage__noPermission--25cNQ","tooltip-status__positive":"StatsTooltip_tooltip-status__positive--FjLOO","tooltipStatusPositive":"StatsTooltip_tooltip-status__positive--FjLOO","tooltip-status__negative":"StatsTooltip_tooltip-status__negative--1mIHQ","tooltipStatusNegative":"StatsTooltip_tooltip-status__negative--1mIHQ","tooltip-statusText":"StatsTooltip_tooltip-statusText--3Xp30","tooltipStatusText":"StatsTooltip_tooltip-statusText--3Xp30","base":"StatsTooltip_base--1pcJ-","base__noBattles":"StatsTooltip_base__noBattles--2940v","baseNoBattles":"StatsTooltip_base__noBattles--2940v"};

/***/ }),
/* 2208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = exports.Toolbar = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(7);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _toolbar = __webpack_require__(997);

var _sounds = __webpack_require__(22);

var _helpers = __webpack_require__(11);

var _Popover = __webpack_require__(2209);

var _Popover2 = _interopRequireDefault(_Popover);

var _components = __webpack_require__(233);

var _reserves = __webpack_require__(28);

var _constants = __webpack_require__(2212);

var _constants2 = __webpack_require__(4);

var _Toolbar = __webpack_require__(2213);

var _Toolbar2 = _interopRequireDefault(_Toolbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Toolbar = exports.Toolbar = function (_React$Component) {
    _inherits(Toolbar, _React$Component);

    function Toolbar() {
        _classCallCheck(this, Toolbar);

        return _possibleConstructorReturn(this, (Toolbar.__proto__ || Object.getPrototypeOf(Toolbar)).apply(this, arguments));
    }

    _createClass(Toolbar, [{
        key: 'handleClick',
        value: function handleClick(reserveType, e) {
            e.stopPropagation();
            if (this.props.popoverReserveType === reserveType) {
                this.refs.popover.hide();
            } else {
                this.refs.popover.hide();
                this.props.chooseReserveType(reserveType);
                setTimeout(this.showPopover.bind(this), 100, e.currentTarget);
            }
        }
    }, {
        key: 'hidePopover',
        value: function hidePopover() {
            return this.refs.popover.hide();
        }
    }, {
        key: 'showPopover',
        value: function showPopover(target) {
            return this.refs.popover.show(target);
        }
    }, {
        key: 'afterHidePopover',
        value: function afterHidePopover() {
            this.props.setPopoverClosedFlag();
            this.props.chooseReserveType(null);
        }
    }, {
        key: 'handleMouseEnter',
        value: function handleMouseEnter(reserveType, e) {
            e.stopPropagation();
            this.props.chooseTooltipReserveType(reserveType);
        }
    }, {
        key: 'handleMouseLeave',
        value: function handleMouseLeave(reserveType, e) {
            e.stopPropagation();
            this.props.chooseTooltipReserveType(null);
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.props.setPopoverClosedFlag();
            this.props.chooseReserveType(null);
            this.update(this.props);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.update(nextProps);
        }
    }, {
        key: 'update',
        value: function update(props) {
            this.clearTimeouts();

            var reservesByLevel = {};
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                var _loop = function _loop() {
                    var reserveType = _step.value;


                    var buildingType = (0, _reserves.getBuildingTypeByReserve)(reserveType, props.settings);
                    var building = Object.values(props.buildings).find(function (value) {
                        return value.type === buildingType;
                    }) || null;
                    var availableReserves = props.clanReserves[reserveType].filter(_reserves.isReserveVisible);

                    reservesByLevel[reserveType] = (0, _reserves.groupReservesByLevel)(availableReserves);
                    if (Object.keys(reservesByLevel[reserveType]).length === 0) {
                        if (building) {
                            reservesByLevel[reserveType][building.level] = [];
                        } else {
                            reservesByLevel[reserveType][1] = [];
                        }
                    }
                };

                for (var _iterator = Object.keys(props.clanReserves)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    _loop();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            this.timeoutId = setTimeout(this.update.bind(this, props), 1000);

            this.setState({
                reservesByLevel: reservesByLevel,
                reserveType: props.reserveType,
                reserveGroups: props.settings.reserve_groups,
                reserveSettings: props.settings.reserves
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.clearTimeouts();
        }
    }, {
        key: 'clearTimeouts',
        value: function clearTimeouts() {
            if (this.timeoutId) clearTimeout(this.timeoutId);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var groups = [];
            var reserveGroups = Object.keys(this.state.reserveGroups);
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                var _loop2 = function _loop2() {
                    var group = _step2.value;

                    var header = void 0;
                    if (group === _constants2.RESERVE_GROUPS.DISPOSABLE) {
                        header = _react2.default.createElement(
                            'div',
                            { className: _Toolbar2.default.header },
                            _react2.default.createElement(
                                'p',
                                { className: _Toolbar2.default.subtitle },
                                _constants.ACTIVATABLE_IN_BATTLE_ROOM
                            )
                        );
                    }

                    var firstActiveReserveInGroup = (0, _reserves.findFirstActiveReserveInGroup)(_this2.props.clanReserves, _this2.props.settings.reserve_groups[group]);

                    var buttons = _this2.state.reserveGroups[group].map(function (reserveType) {
                        var reserves = _this2.state.reservesByLevel[reserveType];
                        var reserveBonus = (0, _reserves.getReserveBonus)(_this2.state.reserveSettings, reserveType);
                        var clickHandler = _this2.handleClick.bind(_this2, reserveType);
                        var mouseEnterHandler = _this2.handleMouseEnter.bind(_this2, reserveType);
                        var mouseEnterLeave = _this2.handleMouseLeave.bind(_this2, reserveType);
                        return _react2.default.createElement(_components.ReserveButton, {
                            key: reserveType,
                            handleClick: clickHandler,
                            handleMouseEnter: mouseEnterHandler,
                            handleMouseLeave: mouseEnterLeave,
                            group: group,
                            reserveBonus: reserveBonus,
                            reserveType: reserveType,
                            reserves: reserves,
                            hasActiveReserveInGroup: !!firstActiveReserveInGroup,
                            tooltipId: _constants.RESERVE_TOOLTIP_ID
                        });
                    });

                    var className = (0, _classnames2.default)(_Toolbar2.default.group, _Toolbar2.default['group__' + (0, _helpers.toCssClass)(group)]);
                    groups.push(_react2.default.createElement(
                        'div',
                        { className: className, key: group },
                        header,
                        _react2.default.createElement(
                            'div',
                            { className: _Toolbar2.default.wrapper },
                            buttons
                        )
                    ));
                };

                for (var _iterator2 = reserveGroups[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    _loop2();
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            var tooltipComponent = void 0;
            var isPopoverOpened = this.props.popoverOpened && this.props.popoverReserveType === this.props.tooltipReserveType;
            if (!isPopoverOpened || this.props.popoverReserveType !== this.props.tooltipReserveType) {
                tooltipComponent = _react2.default.createElement(_components.ReserveTooltip, {
                    id: _constants.RESERVE_TOOLTIP_ID,
                    reservesByLevel: this.state.reservesByLevel
                });
            }
            return _react2.default.createElement(
                'div',
                { className: _Toolbar2.default.base },
                _react2.default.createElement(
                    'div',
                    { className: _Toolbar2.default.holder },
                    groups
                ),
                _react2.default.createElement(
                    _Popover2.default,
                    {
                        ref: 'popover',
                        place: 'top',
                        afterShow: this.props.setPopoverOpenedFlag,
                        afterHide: this.afterHidePopover.bind(this),
                        playHoverSound: this.props.playHoverSound,
                        playCancelClickSound: this.props.playCancelClickSound
                    },
                    _react2.default.createElement(_components.ReserveActivationPopover, { hide: this.hidePopover.bind(this) })
                ),
                tooltipComponent
            );
        }
    }]);

    return Toolbar;
}(_react2.default.Component);

Toolbar.propTypes = {
    clanReserves: _propTypes2.default.object.isRequired,
    settings: _propTypes2.default.object.isRequired,
    buildings: _propTypes2.default.object.isRequired, // eslint-disable-line react/no-unused-prop-types
    popoverOpened: _propTypes2.default.bool.isRequired,
    popoverReserveType: _propTypes2.default.string,
    tooltipReserveType: _propTypes2.default.string,

    chooseReserveType: _propTypes2.default.func.isRequired,
    chooseTooltipReserveType: _propTypes2.default.func.isRequired,
    setPopoverOpenedFlag: _propTypes2.default.func.isRequired,
    setPopoverClosedFlag: _propTypes2.default.func.isRequired,
    playCancelClickSound: _propTypes2.default.func.isRequired,
    playHoverSound: _propTypes2.default.func.isRequired
};
var mapStateToProps = exports.mapStateToProps = function mapStateToProps(_ref) {
    var clanReserves = _ref.clanReserves,
        settings = _ref.settings,
        buildings = _ref.buildings,
        toolbar = _ref.toolbar;
    var popoverReserveType = toolbar.reserveType,
        tooltipReserveType = toolbar.tooltipReserveType,
        popoverOpened = toolbar.popoverOpened;


    return {
        clanReserves: clanReserves,
        settings: settings,
        buildings: buildings,
        popoverOpened: popoverOpened,
        popoverReserveType: popoverReserveType,
        tooltipReserveType: tooltipReserveType
    };
};

var mapDispatchToProps = exports.mapDispatchToProps = {
    chooseReserveType: _toolbar.chooseReserveType,
    chooseTooltipReserveType: _toolbar.chooseTooltipReserveType,
    setPopoverOpenedFlag: _toolbar.setPopoverOpenedFlag,
    setPopoverClosedFlag: _toolbar.setPopoverClosedFlag,
    playCancelClickSound: _sounds.playCancelClickSound,
    playHoverSound: _sounds.playHoverSound
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Toolbar);

/***/ }),
/* 2209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Popover = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(4);

var _constants2 = __webpack_require__(2210);

var _Popover = __webpack_require__(2211);

var _Popover2 = _interopRequireDefault(_Popover);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Popover = exports.Popover = function (_React$Component) {
    _inherits(Popover, _React$Component);

    function Popover(props) {
        _classCallCheck(this, Popover);

        var _this = _possibleConstructorReturn(this, (Popover.__proto__ || Object.getPrototypeOf(Popover)).call(this, props));

        _this.target = null;
        _this.state = {
            opened: false,
            type: null
        };
        _this.onKeyDown = _this.onKeyDown.bind(_this);
        _this.boundHide = _this.hide.bind(_this);
        return _this;
    }

    _createClass(Popover, [{
        key: 'handleClick',
        value: function handleClick(e) {
            e.stopPropagation();
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            window.addEventListener('click', this.boundHide);
            window.addEventListener('keydown', this.onKeyDown);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('click', this.boundHide);
            window.removeEventListener('keydown', this.onKeyDown);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (!this.state.opened) return;

            this.setPosition();
        }
    }, {
        key: 'setPosition',
        value: function setPosition() {
            // Calculate position
            var targetPosition = this.target.getBoundingClientRect();
            var popoverNode = this.refs.base;
            var arrowNode = this.refs.arrow;

            // Calculate left position of the popover
            var popoverLeft = Math.round(targetPosition.left + targetPosition.width / 2 - popoverNode.clientWidth / 2);
            var arrowLeft = popoverNode.clientWidth / 2;

            if (popoverLeft < 0) {
                popoverLeft = _constants2.WINDOW_BOUNDS_OFFSET;
                arrowLeft = targetPosition.left + targetPosition.width / 2 - popoverLeft;
            } else if (popoverLeft + popoverNode.clientWidth > window.innerWidth) {
                popoverLeft = window.innerWidth - popoverNode.clientWidth - _constants2.WINDOW_BOUNDS_OFFSET;
                arrowLeft = targetPosition.left + targetPosition.width / 2 - popoverLeft;
            }

            var popoverOffset = this.target.dataset.popoverOffset;
            var offset = {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            };
            if (popoverOffset) {
                offset = _extends({
                    offset: offset
                }, JSON.parse(popoverOffset));
            }

            if (this.props.place === 'top') {
                var popoverBottom = window.innerHeight - targetPosition.top + offset.bottom;
                popoverNode.style.bottom = popoverBottom + 'px';
            } else {
                var popoverTop = targetPosition.top - popoverNode.clientHeight;
                popoverNode.style.top = popoverTop + 'px';
            }

            arrowNode.style.left = arrowLeft + 'px';
            popoverNode.style.left = popoverLeft + 'px';
        }
    }, {
        key: 'show',
        value: function show(target) {
            this.target = target;
            this.setState({
                opened: true,
                type: this.target.dataset.popoverType
            });
            if (this.props.afterShow) this.props.afterShow();
        }
    }, {
        key: 'hide',
        value: function hide() {
            if (!this.state.opened) return;
            this.setState({
                opened: false,
                type: null
            });
            if (this.props.afterHide) this.props.afterHide();
        }
    }, {
        key: 'toggle',
        value: function toggle(target) {
            if (this.state.opened) {
                this.hide();
            } else {
                this.show(target);
            }
        }
    }, {
        key: 'onKeyDown',
        value: function onKeyDown(e) {
            if (e.keyCode === _constants.KEY_CODES.ESCAPE) {
                this.hide();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var className = (0, _classnames2.default)(_Popover2.default.base, _Popover2.default['base__place-' + this.props.place], _Popover2.default['base__type-' + this.state.type], _defineProperty({}, _Popover2.default.base__open, this.state.opened));
            var handleClose = function handleClose() {
                _this2.props.playCancelClickSound();
                _this2.hide();
            };
            var handleHover = this.props.playHoverSound.bind(this);
            return _react2.default.createElement(
                'div',
                { className: className, ref: 'base', onClick: this.handleClick },
                _react2.default.createElement(
                    'div',
                    { className: _Popover2.default.body },
                    _react2.default.createElement(
                        'div',
                        { className: _Popover2.default.wrapper },
                        _react2.default.createElement('div', { className: _Popover2.default.background })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _Popover2.default.content },
                        _react2.default.createElement('div', { onClick: handleClose, onMouseEnter: handleHover, className: _Popover2.default.cancel }),
                        this.props.children
                    ),
                    _react2.default.createElement('div', { className: _Popover2.default.arrow, ref: 'arrow' })
                )
            );
        }
    }]);

    return Popover;
}(_react2.default.Component);

Popover.propTypes = {
    place: _propTypes2.default.string.isRequired,

    afterShow: _propTypes2.default.func,
    afterHide: _propTypes2.default.func,

    playHoverSound: _propTypes2.default.func,
    playCancelClickSound: _propTypes2.default.func
};
Popover.defaultProps = {
    place: 'top'
};
exports.default = Popover;

/***/ }),
/* 2210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var WINDOW_BOUNDS_OFFSET = exports.WINDOW_BOUNDS_OFFSET = 20;

/***/ }),
/* 2211 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Popover_base--2KLMx","body":"Popover_body--3tK9Z","wrapper":"Popover_wrapper--1nQ6B","background":"Popover_background--3tNNq","content":"Popover_content--3n-__","title":"Popover_title--1G6IQ","message":"Popover_message--3vncz","divider":"Popover_divider--1nyNs","highlight":"Popover_highlight--1sLrM","ribbon":"Popover_ribbon--36XIR","base__open":"Popover_base__open--KZa1d","baseOpen":"Popover_base__open--KZa1d","base__place-left":"Popover_base__place-left--2OJiA","basePlaceLeft":"Popover_base__place-left--2OJiA","base__place-right":"Popover_base__place-right--i24nG","basePlaceRight":"Popover_base__place-right--i24nG","base__place-top":"Popover_base__place-top--2g_OX","basePlaceTop":"Popover_base__place-top--2g_OX","base__place-bottom":"Popover_base__place-bottom--1LfPF","basePlaceBottom":"Popover_base__place-bottom--1LfPF","base__type-economics":"Popover_base__type-economics--2l-db","baseTypeEconomics":"Popover_base__type-economics--2l-db","base__type-economics-double":"Popover_base__type-economics-double--1F46s","baseTypeEconomicsDouble":"Popover_base__type-economics-double--1F46s","base__type-battle":"Popover_base__type-battle--3wW-f","baseTypeBattle":"Popover_base__type-battle--3wW-f","arrow":"Popover_arrow--2xK34","cancel":"Popover_cancel--1oWG6"};

/***/ }),
/* 2212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RESERVE_TOOLTIP_ID = exports.ACTIVATABLE_IN_BATTLE_ROOM = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-multi-comp */
var ACTIVATABLE_IN_BATTLE_ROOM = exports.ACTIVATABLE_IN_BATTLE_ROOM = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'toolbar.activatable_in_battle_room',
    defaultMessage: '\u0423\u0441\u0442\u0430\u043D\u0430\u0432\u043B\u0438\u0432\u0430\u044E\u0442\u0441\u044F \u043F\u0435\u0440\u0435\u0434 \u0431\u043E\u0435\u043C'
});

var RESERVE_TOOLTIP_ID = exports.RESERVE_TOOLTIP_ID = 'toolbar.reserve_tooltip';

/***/ }),
/* 2213 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"holder":"Toolbar_holder--3gQ-V","group":"Toolbar_group--2doO8","group__development":"Toolbar_group__development--Om9VO","groupDevelopment":"Toolbar_group__development--Om9VO","group__economic":"Toolbar_group__economic--3QFpU","groupEconomic":"Toolbar_group__economic--3QFpU","group__disposable":"Toolbar_group__disposable--2ajon","groupDisposable":"Toolbar_group__disposable--2ajon","wrapper":"Toolbar_wrapper--31It1","header":"Toolbar_header--3ea6A","subtitle":"Toolbar_subtitle--3VCMh"};

/***/ }),
/* 2214 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Stronghold_base--2OVAJ","ratings":"Stronghold_ratings--1UD0N","back":"Stronghold_back--37kJN"};

/***/ }),
/* 2215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapStateToProps = exports.StrongholdWrapper = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(7);

var _Landing = __webpack_require__(2216);

var _Landing2 = _interopRequireDefault(_Landing);

var _urls = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StrongholdWrapper = exports.StrongholdWrapper = function (_React$PureComponent) {
    _inherits(StrongholdWrapper, _React$PureComponent);

    function StrongholdWrapper() {
        _classCallCheck(this, StrongholdWrapper);

        return _possibleConstructorReturn(this, (StrongholdWrapper.__proto__ || Object.getPrototypeOf(StrongholdWrapper)).apply(this, arguments));
    }

    _createClass(StrongholdWrapper, [{
        key: 'render',
        value: function render() {
            if (this.props.isNonClanUser) {
                if (this.props.canVisitLocation) return this.props.children;

                return _react2.default.createElement(_Landing2.default, null);
            }

            return this.props.children;
        }
    }]);

    return StrongholdWrapper;
}(_react2.default.PureComponent);

StrongholdWrapper.propTypes = {
    isNonClanUser: _propTypes2.default.bool,
    canVisitLocation: _propTypes2.default.bool
};


function locationAllowedForNonClanUser(location) {
    return location === _urls.LEADERBOARD || location.includes(_urls.CHALLENGES);
}

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, ownProps) {
    var account = state.account,
        clan = state.clan;


    var isAuthenticated = account.id !== null;
    var hasClan = clan.id !== null;
    var isNonClanUser = isAuthenticated && !hasClan;

    return {
        isNonClanUser: isNonClanUser,
        canVisitLocation: !isNonClanUser || locationAllowedForNonClanUser(ownProps.location.pathname)
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(StrongholdWrapper);

/***/ }),
/* 2216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Landing = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactAddonsCssTransitionGroup = __webpack_require__(287);

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSlick = __webpack_require__(565);

var _reactSlick2 = _interopRequireDefault(_reactSlick);

var _reactRedux = __webpack_require__(7);

var _reactRouterRedux = __webpack_require__(15);

var _lodash = __webpack_require__(93);

var _useCallbackOnEsc = __webpack_require__(1352);

var _useIsTimestampExpired = __webpack_require__(1353);

var _hooks = __webpack_require__(164);

var _helpers = __webpack_require__(1354);

var _playersMatching = __webpack_require__(57);

var _logConstants = __webpack_require__(165);

var _reactWotBootstrap = __webpack_require__(5);

var _app = __webpack_require__(566);

var _unit_create = __webpack_require__(129);

var _account = __webpack_require__(42);

var _account2 = _interopRequireDefault(_account);

var _recommended_clans = __webpack_require__(159);

var _global_map = __webpack_require__(282);

var _stronghold_maneuvers = __webpack_require__(378);

var _clan_supply_progression_settings = __webpack_require__(362);

var _clan_supply_quests = __webpack_require__(283);

var _craft_machine = __webpack_require__(281);

var _clan_invites = __webpack_require__(377);

var _client = __webpack_require__(373);

var _ButtonSimple = __webpack_require__(235);

var _ButtonSimple2 = _interopRequireDefault(_ButtonSimple);

var _LoadingScreen = __webpack_require__(29);

var _LoadingScreen2 = _interopRequireDefault(_LoadingScreen);

var _LandingBonus = __webpack_require__(2246);

var _LandingBonus2 = _interopRequireDefault(_LandingBonus);

var _LandingClans = __webpack_require__(2249);

var _LandingClans2 = _interopRequireDefault(_LandingClans);

var _LandingPromo = __webpack_require__(2284);

var _LandingPromo2 = _interopRequireDefault(_LandingPromo);

var _LandingResult = __webpack_require__(2287);

var _LandingResult2 = _interopRequireDefault(_LandingResult);

var _LandingToursOfDuty = __webpack_require__(2290);

var _LandingToursOfDuty2 = _interopRequireDefault(_LandingToursOfDuty);

var _NextSliderButton = __webpack_require__(2294);

var _NextSliderButton2 = _interopRequireDefault(_NextSliderButton);

var _PrevSliderButton = __webpack_require__(2296);

var _PrevSliderButton2 = _interopRequireDefault(_PrevSliderButton);

var _LandingStronghold = __webpack_require__(2298);

var _LandingStronghold2 = _interopRequireDefault(_LandingStronghold);

var _LandingGlobalMap = __webpack_require__(2301);

var _LandingGlobalMap2 = _interopRequireDefault(_LandingGlobalMap);

var _LogWrapper = __webpack_require__(2304);

var _LogWrapper2 = _interopRequireDefault(_LogWrapper);

var _sounds = __webpack_require__(22);

var _constants = __webpack_require__(4);

var _urls = __webpack_require__(19);

var _web_to_client = __webpack_require__(12);

var _propTypes3 = __webpack_require__(236);

var _translations = __webpack_require__(567);

var _constants2 = __webpack_require__(90);

var _Landing = __webpack_require__(2305);

var _Landing2 = _interopRequireDefault(_Landing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var COMPONENTS = {
    landingPromo: _LandingPromo2.default,
    landingBonus: _LandingBonus2.default,
    landingToursOfDuty: _LandingToursOfDuty2.default,
    landingClans: _LandingClans2.default,
    landingStronghold: _LandingStronghold2.default,
    landingGlobalMap: _LandingGlobalMap2.default
};
var FOOTER_ANIMATION_TIMEOUT = 500;
var SLIDE_BG_ANIMATION_TIMEOUT = 300;
var SLIDE_ANIMATION_TIMEOUT = 500;
var TAB_KEY_CODE = 9;

var Landing = exports.Landing = function Landing(props) {
    var slidesCount = props.clanSlides.length;
    var checkLastSlideToShow = function checkLastSlideToShow() {
        return (0, _playersMatching.getParsedStorageItem)(_constants.LOCAL_STORAGE_KEYS.LANDING_CLAN_SELECTION_SHOWN) ? slidesCount - 1 : 0;
    };

    var _useState = (0, _react.useState)(checkLastSlideToShow()),
        _useState2 = _slicedToArray(_useState, 2),
        nextSlide = _useState2[0],
        setNextSlide = _useState2[1];

    var _useState3 = (0, _react.useState)(checkLastSlideToShow()),
        _useState4 = _slicedToArray(_useState3, 2),
        currentSlide = _useState4[0],
        setCurrentSlide = _useState4[1];

    var _useState5 = (0, _react.useState)(window.innerWidth),
        _useState6 = _slicedToArray(_useState5, 2),
        sliderItemWidth = _useState6[0],
        setSliderItemWidth = _useState6[1];

    var _useState7 = (0, _react.useState)(window.innerHeight),
        _useState8 = _slicedToArray(_useState7, 2),
        sliderItemHeight = _useState8[0],
        setSliderItemHeight = _useState8[1];

    var _useState9 = (0, _react.useState)((0, _helpers.createPartnerID)()),
        _useState10 = _slicedToArray(_useState9, 1),
        partnerID = _useState10[0];

    var slider = (0, _react.useRef)(null);
    var currentSlideRef = (0, _react.useRef)(0);
    var isVisibleStartExpired = (0, _useIsTimestampExpired.useIsTimestampExpired)(props.maneuversVisibleStartDate || 0);
    var isVisibleEndExpired = (0, _useIsTimestampExpired.useIsTimestampExpired)(props.maneuversVisibleEndDate || 0);

    (0, _react.useEffect)(function () {
        var handleWindowResize = function handleWindowResize() {
            setSliderItemWidth(window.innerWidth);
            setSliderItemHeight(window.innerHeight);
        };

        var handleKeyDown = function handleKeyDown(e) {
            switch (e.keyCode) {
                case TAB_KEY_CODE:
                    e.preventDefault();
                    break;
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        window.addEventListener('resize', handleWindowResize);

        return function () {
            window.removeEventListener('keydown', handleKeyDown);
            window.removeEventListener('resize', handleWindowResize);
        };
    }, [sliderItemWidth, sliderItemHeight]);

    (0, _react.useEffect)(function () {
        props.requestServerTimestamp();
        props.requestGlobalMapInfo();
        props.requestCraftMachineInfo();
        props.requestClanInvites();
        props.sendEnterLandingSoundState();
        props.requestStrongholdManeuversInfo();
        props.requestClanSupplyProgressionSettingsInfo();
        props.requestClanSupplyQuestsInfo();
    }, []);

    (0, _react.useEffect)(function () {
        currentSlideRef.current = currentSlide;
        if (isLastSlide) {
            (0, _playersMatching.saveToStorage)(_constants.LOCAL_STORAGE_KEYS.LANDING_CLAN_SELECTION_SHOWN, true);
        }
    }, [currentSlide]);

    var log = (0, _hooks.useMetricsLog)(_logConstants.FEATURE);

    var handleLandingClose = (0, _react.useCallback)(function () {
        var slideName = (0, _lodash.upperFirst)(props.clanSlides[currentSlideRef.current]);
        log({
            action: _logConstants.Actions.Close,
            item: _logConstants.Items[slideName],
            parentScreen: _logConstants.Items.Hangar,
            partnerID: partnerID
        });
    }, [log]);

    var handleButtonClick = (0, _react.useCallback)(function (item) {
        log({
            action: _logConstants.Actions.Click,
            item: item,
            parentScreen: _logConstants.Items.Hangar,
            partnerID: partnerID
        });
    }, [log]);

    (0, _useCallbackOnEsc.useCallbackOnEsc)(function () {
        handleLandingClose();
        (0, _reactWotBootstrap.openHangar)();
    });

    var handleCreateClanClick = function handleCreateClanClick() {
        handleButtonClick(_logConstants.Items.CreateClanButton);
        (0, _reactWotBootstrap.openExternalBrowser)(props.clanCreateUrl);
    };

    var handleInvitationsClick = function handleInvitationsClick() {
        handleButtonClick(_logConstants.Items.ClanInvitationsButton);
        props.openInvitations();
        props.clanInvitesChecked();
    };

    var handleOpenBattleRoomsClick = function handleOpenBattleRoomsClick() {
        handleButtonClick(_logConstants.Items.LegionnaireBattleButton);
        props.openBattleRooms();
    };

    var handleGoToRecommendedClansClick = function handleGoToRecommendedClansClick() {
        if (slider.current) {
            slider.current.slickGoTo(slidesCount - 1, true);
        }
    };

    var handleGoToFirstSlideClick = function handleGoToFirstSlideClick() {
        if (slider.current) {
            slider.current.slickGoTo(0, true);
        }
    };

    var handleLandingResultClick = function handleLandingResultClick() {
        if (!props.accountStatus.isAccountInClan && !props.joinResult.currentClan) {
            (0, _reactWotBootstrap.openHangar)();
        } else {
            props.fetchAccountInfo();
        }
    };

    var handleSliderBeforeChange = function handleSliderBeforeChange(oldSlide, nextSlide) {
        setTimeout(function () {
            return setNextSlide(nextSlide);
        }, 0);
        setTimeout(function () {
            return setCurrentSlide(nextSlide);
        }, SLIDE_ANIMATION_TIMEOUT);
    };

    var isLastSlide = nextSlide === slidesCount - 1;

    var handleGoToClanSupplyClick = function handleGoToClanSupplyClick() {
        if (props.isClanSupplyProgressionEnabled) {
            (0, _web_to_client.openClanSupplyProgression)();
        } else if (props.areClanSupplyQuestsEnabled) {
            (0, _web_to_client.openClanSupplyQuests)();
        }
    };

    var renderFooter = function renderFooter() {
        var isCraftServiceEnabled = props.isCraftServiceEnabled,
            personalBonusesEnabled = props.personalBonusesEnabled,
            eventRewardsEnabled = props.eventRewardsEnabled;

        var personalShopEnabled = personalBonusesEnabled || eventRewardsEnabled;
        var isManeuversEventVisible = isVisibleStartExpired && !isVisibleEndExpired;

        var handleClickEvent = function handleClickEvent() {
            handleButtonClick(_logConstants.Items.GlobalMapEventButton);

            if (isCraftServiceEnabled) {
                window.location = props.craftMachineUrl;
                return;
            }
            if (personalShopEnabled) {
                props.sendEnterGlobalMapSoundState();
                props.playEnterGlobalMapSound();

                if (eventRewardsEnabled) {
                    props.openEventRewards();
                    return;
                }
                if (personalBonusesEnabled) {
                    props.openPersonalShop();
                    return;
                }
            }
        };

        var handleClickEventManeuvers = function handleClickEventManeuvers() {
            var url = new URL(props.wgshEventsUrl);
            var urlParams = new URLSearchParams(url.search);
            urlParams.append('isAutoRedirect', 'true');
            url.search = urlParams.toString();
            window.location = url.toString();
        };

        return _react2.default.createElement(
            _reactAddonsCssTransitionGroup2.default,
            {
                transitionName: 'footerAnimation',
                transitionEnterTimeout: FOOTER_ANIMATION_TIMEOUT,
                transitionLeaveTimeout: FOOTER_ANIMATION_TIMEOUT
            },
            !isLastSlide && _react2.default.createElement(
                'div',
                { className: _Landing2.default.footer },
                _react2.default.createElement(
                    'div',
                    { className: _Landing2.default.footerContainer },
                    _react2.default.createElement(
                        'div',
                        null,
                        (personalShopEnabled || isCraftServiceEnabled) && props.eventName && _react2.default.createElement(
                            'div',
                            { className: _Landing2.default.button },
                            _react2.default.createElement(
                                _reactWotBootstrap.Button,
                                { tooltipId: 'goto_personal_bonuses', onClick: handleClickEvent },
                                props.eventName
                            ),
                            _react2.default.createElement(
                                _reactWotBootstrap.Tooltip,
                                { id: 'goto_personal_bonuses' },
                                _translations.LANDING_GOTO_GLOBAL_MAP_EVENT_TOOLTIP
                            )
                        ),
                        isManeuversEventVisible && _react2.default.createElement(
                            'div',
                            { className: _Landing2.default.button },
                            _react2.default.createElement(
                                _reactWotBootstrap.Button,
                                { tooltipId: 'goto_maneuvers', onClick: handleClickEventManeuvers },
                                _translations.LANDING_GOTO_MANEUVERS_EVENT
                            ),
                            _react2.default.createElement(
                                _reactWotBootstrap.Tooltip,
                                { id: 'goto_maneuvers' },
                                _translations.LANDING_GOTO_MANEUVERS_EVENT_TOOLTIP
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _Landing2.default.button },
                            _react2.default.createElement(
                                _reactWotBootstrap.Button,
                                {
                                    type: 'secondary',
                                    tooltipId: 'goto_clan_supply',
                                    onClick: handleGoToClanSupplyClick,
                                    isDisabled: !props.isClanSupplyProgressionEnabled && !props.areClanSupplyQuestsEnabled
                                },
                                _translations.LANDING_GOTO_CLAN_SUPPLY
                            ),
                            _react2.default.createElement(
                                _reactWotBootstrap.Tooltip,
                                { id: 'goto_clan_supply' },
                                props.isClanSupplyProgressionEnabled || props.areClanSupplyQuestsEnabled ? _translations.LANDING_GOTO_CLAN_SUPPLY_TOOLTIP : _translations.LANDING_GOTO_CLAN_SUPPLY_IS_DISABLED_TOOLTIP
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        null,
                        renderLegionnaireButton(),
                        _react2.default.createElement(
                            'div',
                            { className: _Landing2.default.button },
                            _react2.default.createElement(
                                _ButtonSimple2.default,
                                {
                                    tooltipId: 'goto_invitations_tooltip',
                                    onClick: handleInvitationsClick,
                                    messages: props.clanInvitesTotal
                                },
                                _translations.LANDING_GOTO_INVITATIONS
                            ),
                            _react2.default.createElement(
                                _reactWotBootstrap.Tooltip,
                                { id: 'goto_invitations_tooltip' },
                                _translations.LANDING_GOTO_INVITATIONS_TOOLTIP
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _Landing2.default.button },
                            _react2.default.createElement(
                                _ButtonSimple2.default,
                                {
                                    isExternal: true,
                                    tooltipId: 'goto_create_clan_tooltip',
                                    onClick: handleCreateClanClick
                                },
                                _translations.LANDING_GOTO_CREATE_CLAN
                            ),
                            _react2.default.createElement(
                                _reactWotBootstrap.Tooltip,
                                { id: 'goto_create_clan_tooltip' },
                                _translations.LANDING_GOTO_CREATE_CLAN_TOOLTIP
                            )
                        )
                    )
                )
            )
        );
    };

    var renderLegionnaireButton = function renderLegionnaireButton() {
        return _react2.default.createElement(
            'div',
            { className: _Landing2.default.button },
            _react2.default.createElement(
                _ButtonSimple2.default,
                {
                    tooltipId: 'goto_battle_tooltip',
                    onClick: handleOpenBattleRoomsClick
                },
                _translations.LANDING_GOTO_BATTLE
            ),
            _react2.default.createElement(
                _reactWotBootstrap.Tooltip,
                { id: 'goto_battle_tooltip' },
                _translations.LANDING_GOTO_BATTLE_TOOLTIP
            )
        );
    };

    var renderSliderBackground = function renderSliderBackground() {
        var clanSlides = props.clanSlides;


        var slideBgBattlesClassNames = (0, _classnames2.default)(_Landing2.default['' + clanSlides[nextSlide]], _defineProperty({}, _Landing2.default.isCNRealm, props.isCNRealm));

        var slidesBg = _react2.default.createElement('div', {
            className: slideBgBattlesClassNames,
            key: 'slideBg_' + clanSlides[nextSlide]
        });

        return _react2.default.createElement(
            _reactAddonsCssTransitionGroup2.default,
            {
                transitionName: 'slideBackground',
                transitionEnterTimeout: SLIDE_BG_ANIMATION_TIMEOUT,
                transitionLeaveTimeout: SLIDE_BG_ANIMATION_TIMEOUT
            },
            slidesBg
        );
    };

    var renderSlider = function renderSlider() {
        var clanSlides = props.clanSlides;


        var style = {
            width: sliderItemWidth,
            height: sliderItemHeight
        };

        var slides = clanSlides.map(function (slideName, i) {
            var ComponentName = COMPONENTS[slideName];
            return _react2.default.createElement(
                'div',
                { key: i },
                _react2.default.createElement(
                    'div',
                    { className: _Landing2.default.item, style: style },
                    _react2.default.createElement(_LogWrapper2.default, {
                        WrappedComponent: ComponentName,
                        partnerID: partnerID,
                        isCurrent: currentSlide === i,
                        slideName: slideName,
                        isLastSlide: isLastSlide,
                        onLastSlideBackClick: handleGoToFirstSlideClick,
                        onGoToRecommendedClansButtonClick: handleGoToRecommendedClansClick
                    })
                )
            );
        });

        return _react2.default.createElement(
            _reactSlick2.default,
            {
                accessibility: false,
                arrows: !isLastSlide,
                speed: SLIDE_ANIMATION_TIMEOUT,
                dots: !isLastSlide,
                draggable: false,
                infinite: false,
                initialSlide: currentSlide,
                nextArrow: _react2.default.createElement(_NextSliderButton2.default, null),
                prevArrow: _react2.default.createElement(_PrevSliderButton2.default, null),
                ref: slider,
                beforeChange: handleSliderBeforeChange
            },
            slides
        );
    };

    if (props.accountStatus.hasError) {
        return _react2.default.createElement(
            'div',
            { className: _Landing2.default.emptyListContainer },
            _react2.default.createElement(_reactWotBootstrap.EmptyList, {
                title: _constants2.LANDING_CLANS_TABLE_ERROR_TITLE,
                message: _constants2.LANDING_CLANS_TABLE_ERROR_MESSAGE,
                buttonCaption: _constants2.LANDING_CLANS_TABLE_ERROR_BUTTON,
                onButtonClick: props.refreshAccountStatus
            })
        );
    }

    if (props.accountStatus.isFetchingCompleted && props.joinResult.joinedClan) {
        return _react2.default.createElement(_LandingResult2.default, {
            isWaiting: !props.accountStatus.isAccountInClan,
            onClick: handleLandingResultClick
        });
    }

    if (props.joinResult.currentClan) {
        return _react2.default.createElement(_LandingResult2.default, {
            isWaiting: false,
            onClick: handleLandingResultClick
        });
    }

    if (props.accountStatus.loading || props.globalMapLoading) {
        return _react2.default.createElement(_LoadingScreen2.default, null);
    }

    return _react2.default.createElement(
        'div',
        { className: _Landing2.default.base },
        _react2.default.createElement(
            'div',
            { className: _Landing2.default.body },
            renderSliderBackground(),
            renderSlider(),
            renderFooter()
        )
    );
};

var mapStateToProps = function mapStateToProps(_ref) {
    var craftMachine = _ref.craftMachine,
        recommendedClans = _ref.recommendedClans,
        globalMap = _ref.globalMap,
        settings = _ref.settings,
        clanInvites = _ref.clanInvites,
        strongholdManeuvers = _ref.strongholdManeuvers,
        clanSupplyProgressionSettings = _ref.clanSupplyProgressionSettings,
        clanSupplyQuests = _ref.clanSupplyQuests;
    return {
        accountStatus: recommendedClans.accountStatus,
        isCraftServiceEnabled: craftMachine.is_craft_service_enabled,
        craftMachineUrl: settings.craftMachineUrl,
        wgshEventsUrl: settings.wgshEventsUrl,
        eventName: globalMap.context_id,
        joinResult: recommendedClans.joinResult,
        personalBonusesEnabled: globalMap.personal_bonuses_enabled,
        eventRewardsEnabled: globalMap.event_rewards_enabled,
        globalMapLoading: globalMap.loading,
        isCNRealm: settings.isCNRealm,
        clanCreateUrl: settings.clanCreateUrl,
        clanSlides: settings.clanSlides,
        clanInvitesTotal: clanInvites.total,
        maneuversVisibleStartDate: strongholdManeuvers.visibleStartDate,
        maneuversVisibleEndDate: strongholdManeuvers.visibleEndDate,
        isClanSupplyProgressionEnabled: clanSupplyProgressionSettings.enabled,
        areClanSupplyQuestsEnabled: clanSupplyQuests.enabled
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        openBattleRooms: function openBattleRooms() {
            dispatch((0, _unit_create.openBattleRooms)());
        },
        refreshAccountStatus: function refreshAccountStatus() {
            dispatch((0, _recommended_clans.clearAccountStatus)());
            dispatch((0, _account2.default)());
        },
        fetchAccountInfo: function fetchAccountInfo() {
            dispatch((0, _account2.default)());
        },
        openInvitations: function openInvitations() {
            return dispatch((0, _app.openInvitations)());
        },
        clanInvitesChecked: function clanInvitesChecked() {
            return dispatch((0, _clan_invites.clanInvitesChecked)());
        },
        openPersonalShop: function openPersonalShop() {
            return dispatch((0, _reactRouterRedux.push)(_urls.WGCWX_SHOP));
        },
        openEventRewards: function openEventRewards() {
            return dispatch((0, _reactRouterRedux.push)(_urls.WGCWX_SHOP_REWARDS));
        },
        openBattleSchedule: function openBattleSchedule() {
            return dispatch((0, _reactRouterRedux.push)(_urls.WGCWX_BATTLE_SCHEDULE));
        },
        openLeaderboards: function openLeaderboards() {
            return dispatch((0, _reactRouterRedux.push)(_urls.WGCWX_LEADERBOARDS));
        },
        requestGlobalMapInfo: function requestGlobalMapInfo() {
            return dispatch((0, _global_map.requestGlobalMapInfo)());
        },
        requestClanInvites: function requestClanInvites() {
            return dispatch((0, _clan_invites.requestClanInvites)());
        },
        requestCraftMachineInfo: function requestCraftMachineInfo() {
            return dispatch((0, _craft_machine.requestCraftMachineInfo)());
        },
        sendEnterLandingSoundState: function sendEnterLandingSoundState() {
            return dispatch((0, _sounds.sendEnterLandingSoundState)());
        },
        sendEnterGlobalMapSoundState: function sendEnterGlobalMapSoundState() {
            return dispatch((0, _sounds.sendEnterGlobalMapSoundState)());
        },
        playEnterGlobalMapSound: function playEnterGlobalMapSound() {
            return dispatch((0, _sounds.playEnterGlobalMapSound)());
        },
        requestStrongholdManeuversInfo: function requestStrongholdManeuversInfo() {
            return dispatch((0, _stronghold_maneuvers.requestStrongholdManeuversInfo)());
        },
        requestServerTimestamp: function requestServerTimestamp() {
            return dispatch((0, _client.requestServerTimestamp)());
        },
        requestClanSupplyProgressionSettingsInfo: function requestClanSupplyProgressionSettingsInfo() {
            return dispatch((0, _clan_supply_progression_settings.requestClanSupplyProgressionSettingsInfo)());
        },
        requestClanSupplyQuestsInfo: function requestClanSupplyQuestsInfo() {
            return dispatch((0, _clan_supply_quests.requestClanSupplyQuestsInfo)());
        }
    };
};

Landing.propTypes = {
    accountStatus: _propTypes3.AccountStatusPropTypes.isRequired,
    isCraftServiceEnabled: _propTypes2.default.bool,
    clanCreateUrl: _propTypes2.default.string.isRequired,
    craftMachineUrl: _propTypes2.default.string,
    wgshEventsUrl: _propTypes2.default.string,
    eventName: _propTypes2.default.string,
    joinResult: _propTypes3.JoinResultPropTypes.isRequired,
    personalBonusesEnabled: _propTypes2.default.bool,
    eventRewardsEnabled: _propTypes2.default.bool,
    globalMapLoading: _propTypes2.default.bool,
    isCNRealm: _propTypes2.default.bool,
    clanSlides: _propTypes2.default.array.isRequired,
    clanInvitesTotal: _propTypes2.default.number,

    openBattleRooms: _propTypes2.default.func.isRequired,
    openInvitations: _propTypes2.default.func.isRequired,
    clanInvitesChecked: _propTypes2.default.func.isRequired,
    openPersonalShop: _propTypes2.default.func.isRequired,
    openEventRewards: _propTypes2.default.func.isRequired,
    refreshAccountStatus: _propTypes2.default.func.isRequired,
    fetchAccountInfo: _propTypes2.default.func.isRequired,
    requestGlobalMapInfo: _propTypes2.default.func.isRequired,
    requestCraftMachineInfo: _propTypes2.default.func.isRequired,
    requestClanInvites: _propTypes2.default.func.isRequired,
    sendEnterLandingSoundState: _propTypes2.default.func.isRequired,
    sendEnterGlobalMapSoundState: _propTypes2.default.func.isRequired,
    playEnterGlobalMapSound: _propTypes2.default.func.isRequired,
    requestStrongholdManeuversInfo: _propTypes2.default.func.isRequired,
    maneuversVisibleStartDate: _propTypes2.default.number,
    maneuversVisibleEndDate: _propTypes2.default.number,
    requestServerTimestamp: _propTypes2.default.func.isRequired,
    requestClanSupplyProgressionSettingsInfo: _propTypes2.default.func.isRequired,
    isClanSupplyProgressionEnabled: _propTypes2.default.bool,
    requestClanSupplyQuestsInfo: _propTypes2.default.func.isRequired,
    areClanSupplyQuestsEnabled: _propTypes2.default.bool
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Landing);

/***/ }),
/* 2217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _innerSlider = __webpack_require__(2218);

var _json2mq = __webpack_require__(2225);

var _json2mq2 = _interopRequireDefault(_json2mq);

var _defaultProps = __webpack_require__(2227);

var _defaultProps2 = _interopRequireDefault(_defaultProps);

var _innerSliderUtils = __webpack_require__(294);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__(2228);

var Slider = function (_React$Component) {
  _inherits(Slider, _React$Component);

  function Slider(props) {
    _classCallCheck(this, Slider);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.innerSliderRefHandler = function (ref) {
      return _this.innerSlider = ref;
    };

    _this.slickPrev = function () {
      return _this.innerSlider.slickPrev();
    };

    _this.slickNext = function () {
      return _this.innerSlider.slickNext();
    };

    _this.slickGoTo = function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return _this.innerSlider.slickGoTo(slide, dontAnimate);
    };

    _this.slickPause = function () {
      return _this.innerSlider.pause("paused");
    };

    _this.slickPlay = function () {
      return _this.innerSlider.autoPlay("play");
    };

    _this.state = {
      breakpoint: null
    };
    _this._responsiveMediaHandlers = [];
    return _this;
  }

  Slider.prototype.media = function media(query, handler) {
    // javascript handler for  css media query
    enquire.register(query, handler);
    this._responsiveMediaHandlers.push({ query: query, handler: handler });
  };

  // handles responsive breakpoints


  Slider.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    // performance monitoring
    //if (process.env.NODE_ENV !== 'production') {
    //const { whyDidYouUpdate } = require('why-did-you-update')
    //whyDidYouUpdate(React)
    //}
    if (this.props.responsive) {
      var breakpoints = this.props.responsive.map(function (breakpt) {
        return breakpt.breakpoint;
      });
      // sort them in increasing order of their numerical value
      breakpoints.sort(function (x, y) {
        return x - y;
      });

      breakpoints.forEach(function (breakpoint, index) {
        // media query for each breakpoint
        var bQuery = void 0;
        if (index === 0) {
          bQuery = (0, _json2mq2.default)({ minWidth: 0, maxWidth: breakpoint });
        } else {
          bQuery = (0, _json2mq2.default)({
            minWidth: breakpoints[index - 1] + 1,
            maxWidth: breakpoint
          });
        }
        // when not using server side rendering
        (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
          _this2.setState({ breakpoint: breakpoint });
        });
      });

      // Register media query for full screen. Need to support resize from small to large
      // convert javascript object to media query string
      var query = (0, _json2mq2.default)({ minWidth: breakpoints.slice(-1)[0] });

      (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
        _this2.setState({ breakpoint: null });
      });
    }
  };

  Slider.prototype.componentWillUnmount = function componentWillUnmount() {
    this._responsiveMediaHandlers.forEach(function (obj) {
      enquire.unregister(obj.query, obj.handler);
    });
  };

  Slider.prototype.render = function render() {
    var _this3 = this;

    var settings;
    var newProps;
    if (this.state.breakpoint) {
      newProps = this.props.responsive.filter(function (resp) {
        return resp.breakpoint === _this3.state.breakpoint;
      });
      settings = newProps[0].settings === "unslick" ? "unslick" : _extends({}, _defaultProps2.default, this.props, newProps[0].settings);
    } else {
      settings = _extends({}, _defaultProps2.default, this.props);
    }

    // force scrolling by one if centerMode is on
    if (settings.centerMode) {
      if (settings.slidesToScroll > 1 && "production" !== "production") {
        console.warn("slidesToScroll should be equal to 1 in centerMode, you are using " + settings.slidesToScroll);
      }
      settings.slidesToScroll = 1;
    }
    // force showing one slide and scrolling by one if the fade mode is on
    if (settings.fade) {
      if (settings.slidesToShow > 1 && "production" !== "production") {
        console.warn("slidesToShow should be equal to 1 when fade is true, you're using " + settings.slidesToShow);
      }
      if (settings.slidesToScroll > 1 && "production" !== "production") {
        console.warn("slidesToScroll should be equal to 1 when fade is true, you're using " + settings.slidesToScroll);
      }
      settings.slidesToShow = 1;
      settings.slidesToScroll = 1;
    }

    // makes sure that children is an array, even when there is only 1 child
    var children = _react2.default.Children.toArray(this.props.children);

    // Children may contain false or null, so we should filter them
    // children may also contain string filled with spaces (in certain cases where we use jsx strings)
    children = children.filter(function (child) {
      if (typeof child === "string") {
        return !!child.trim();
      }
      return !!child;
    });

    // rows and slidesPerRow logic is handled here
    if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
      console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
      settings.variableWidth = false;
    }
    var newChildren = [];
    var currentWidth = null;
    for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
      var newSlide = [];
      for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
        var row = [];
        for (var k = j; k < j + settings.slidesPerRow; k += 1) {
          if (settings.variableWidth && children[k].props.style) {
            currentWidth = children[k].props.style.width;
          }
          if (k >= children.length) break;
          row.push(_react2.default.cloneElement(children[k], {
            key: 100 * i + 10 * j + k,
            tabIndex: -1,
            style: {
              width: 100 / settings.slidesPerRow + "%",
              display: "inline-block"
            }
          }));
        }
        newSlide.push(_react2.default.createElement(
          "div",
          { key: 10 * i + j },
          row
        ));
      }
      if (settings.variableWidth) {
        newChildren.push(_react2.default.createElement(
          "div",
          { key: i, style: { width: currentWidth } },
          newSlide
        ));
      } else {
        newChildren.push(_react2.default.createElement(
          "div",
          { key: i },
          newSlide
        ));
      }
    }

    if (settings === "unslick") {
      var className = "regular slider " + (this.props.className || "");
      return _react2.default.createElement(
        "div",
        { className: className },
        newChildren
      );
    } else if (newChildren.length <= settings.slidesToShow) {
      settings.unslick = true;
    }
    return _react2.default.createElement(
      _innerSlider.InnerSlider,
      _extends({ ref: this.innerSliderRefHandler }, settings),
      newChildren
    );
  };

  return Slider;
}(_react2.default.Component);

exports.default = Slider;

/***/ }),
/* 2218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.InnerSlider = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(75);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _initialState = __webpack_require__(2219);

var _initialState2 = _interopRequireDefault(_initialState);

var _lodash = __webpack_require__(2220);

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _innerSliderUtils = __webpack_require__(294);

var _track = __webpack_require__(2221);

var _dots = __webpack_require__(2222);

var _arrows = __webpack_require__(2223);

var _resizeObserverPolyfill = __webpack_require__(2224);

var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InnerSlider = exports.InnerSlider = function (_React$Component) {
  _inherits(InnerSlider, _React$Component);

  function InnerSlider(props) {
    _classCallCheck(this, InnerSlider);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.listRefHandler = function (ref) {
      return _this.list = ref;
    };

    _this.trackRefHandler = function (ref) {
      return _this.track = ref;
    };

    _this.adaptHeight = function () {
      if (_this.props.adaptiveHeight && _this.list) {
        var elem = _this.list.querySelector("[data-index=\"" + _this.state.currentSlide + "\"]");
        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
      }
    };

    _this.componentWillMount = function () {
      _this.ssrInit();
      _this.props.onInit && _this.props.onInit();
      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });
          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }
    };

    _this.componentDidMount = function () {
      var spec = _extends({ listRef: _this.list, trackRef: _this.track }, _this.props);
      _this.updateState(spec, true, function () {
        _this.adaptHeight();
        _this.props.autoplay && _this.autoPlay("update");
      });
      if (_this.props.lazyLoad === "progressive") {
        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
      }
      _this.ro = new _resizeObserverPolyfill2.default(function () {
        if (_this.state.animating) {
          _this.onWindowResized(false); // don't set trackStyle hence don't break animation
          _this.callbackTimers.push(setTimeout(function () {
            return _this.onWindowResized();
          }, _this.props.speed));
        } else {
          _this.onWindowResized();
        }
      });
      _this.ro.observe(_this.list);
      Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
      });
      // To support server-side rendering
      if (!window) {
        return;
      }
      if (window.addEventListener) {
        window.addEventListener("resize", _this.onWindowResized);
      } else {
        window.attachEvent("onresize", _this.onWindowResized);
      }
    };

    _this.componentWillUnmount = function () {
      if (_this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
      }
      if (_this.lazyLoadTimer) {
        clearInterval(_this.lazyLoadTimer);
      }
      if (_this.callbackTimers.length) {
        _this.callbackTimers.forEach(function (timer) {
          return clearTimeout(timer);
        });
        _this.callbackTimers = [];
      }
      if (window.addEventListener) {
        window.removeEventListener("resize", _this.onWindowResized);
      } else {
        window.detachEvent("onresize", _this.onWindowResized);
      }
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }
    };

    _this.componentWillReceiveProps = function (nextProps) {
      var spec = _extends({
        listRef: _this.list,
        trackRef: _this.track
      }, nextProps, _this.state);
      var setTrackStyle = false;
      for (var _iterator = Object.keys(_this.props), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var key = _ref;

        if (!nextProps.hasOwnProperty(key)) {
          setTrackStyle = true;
          break;
        }
        if (_typeof(nextProps[key]) === "object" || typeof nextProps[key] === "function") {
          continue;
        }
        if (nextProps[key] !== _this.props[key]) {
          setTrackStyle = true;
          break;
        }
      }
      _this.updateState(spec, setTrackStyle, function () {
        if (_this.state.currentSlide >= _react2.default.Children.count(nextProps.children)) {
          _this.changeSlide({
            message: "index",
            index: _react2.default.Children.count(nextProps.children) - nextProps.slidesToShow,
            currentSlide: _this.state.currentSlide
          });
        }
        if (nextProps.autoplay) {
          _this.autoPlay("update");
        } else {
          _this.pause("paused");
        }
      });
    };

    _this.componentDidUpdate = function () {
      _this.checkImagesLoad();
      _this.props.onReInit && _this.props.onReInit();
      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });
          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }
      // if (this.props.onLazyLoad) {
      //   this.props.onLazyLoad([leftMostSlide])
      // }
      _this.adaptHeight();
    };

    _this.onWindowResized = function (setTrackStyle) {
      if (_this.debouncedResize) _this.debouncedResize.cancel();
      _this.debouncedResize = (0, _lodash2.default)(function () {
        return _this.resizeWindow(setTrackStyle);
      }, 50);
      _this.debouncedResize();
    };

    _this.resizeWindow = function () {
      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (!_reactDom2.default.findDOMNode(_this.track)) return;
      var spec = _extends({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props, _this.state);
      _this.updateState(spec, setTrackStyle, function () {
        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
      });
      // animating state should be cleared while resizing, otherwise autoplay stops working
      _this.setState({
        animating: false
      });
      clearTimeout(_this.animationEndCallback);
      delete _this.animationEndCallback;
    };

    _this.updateState = function (spec, setTrackStyle, callback) {
      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
      spec = _extends({}, spec, updatedState, { slideIndex: updatedState.currentSlide });
      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
      spec = _extends({}, spec, { left: targetLeft });
      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);
      if (setTrackStyle || _react2.default.Children.count(_this.props.children) !== _react2.default.Children.count(spec.children)) {
        updatedState["trackStyle"] = trackStyle;
      }
      _this.setState(updatedState, callback);
    };

    _this.ssrInit = function () {
      if (_this.props.variableWidth) {
        var _trackWidth = 0,
            _trackLeft = 0;
        var childrenWidths = [];
        var preClones = (0, _innerSliderUtils.getPreClones)(_extends({}, _this.props, _this.state, {
          slideCount: _this.props.children.length
        }));
        var postClones = (0, _innerSliderUtils.getPostClones)(_extends({}, _this.props, _this.state, {
          slideCount: _this.props.children.length
        }));
        _this.props.children.forEach(function (child) {
          childrenWidths.push(child.props.style.width);
          _trackWidth += child.props.style.width;
        });
        for (var i = 0; i < preClones; i++) {
          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
        }
        for (var _i2 = 0; _i2 < postClones; _i2++) {
          _trackWidth += childrenWidths[_i2];
        }
        for (var _i3 = 0; _i3 < _this.state.currentSlide; _i3++) {
          _trackLeft += childrenWidths[_i3];
        }
        var _trackStyle = {
          width: _trackWidth + "px",
          left: -_trackLeft + "px"
        };
        if (_this.props.centerMode) {
          var currentWidth = childrenWidths[_this.state.currentSlide] + "px";
          _trackStyle.left = "calc(" + _trackStyle.left + " + (100% - " + currentWidth + ") / 2 ) ";
        }
        _this.setState({
          trackStyle: _trackStyle
        });
        return;
      }
      var childrenCount = _react2.default.Children.count(_this.props.children);
      var spec = _extends({}, _this.props, _this.state, { slideCount: childrenCount });
      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
      var slideWidth = 100 / slideCount;
      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
      if (_this.props.centerMode) {
        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
      }
      var trackStyle = {
        width: trackWidth + "%",
        left: trackLeft + "%"
      };
      _this.setState({
        slideWidth: slideWidth + "%",
        trackStyle: trackStyle
      });
    };

    _this.checkImagesLoad = function () {
      var images = document.querySelectorAll(".slick-slide img");
      var imagesCount = images.length,
          loadedCount = 0;
      Array.prototype.forEach.call(images, function (image) {
        var handler = function handler() {
          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
        };
        if (!image.onclick) {
          image.onclick = function () {
            return image.parentNode.focus();
          };
        } else {
          var prevClickHandler = image.onclick;
          image.onclick = function () {
            prevClickHandler();
            image.parentNode.focus();
          };
        }
        if (!image.onload) {
          if (_this.props.lazyLoad) {
            image.onload = function () {
              _this.adaptHeight();
              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
            };
          } else {
            image.onload = handler;
            image.onerror = function () {
              handler();
              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
            };
          }
        }
      });
    };

    _this.progressiveLazyLoad = function () {
      var slidesToLoad = [];
      var spec = _extends({}, _this.props, _this.state);
      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
          slidesToLoad.push(index);
          break;
        }
      }
      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
          slidesToLoad.push(_index);
          break;
        }
      }
      if (slidesToLoad.length > 0) {
        _this.setState(function (state) {
          return {
            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
          };
        });
        if (_this.props.onLazyLoad) {
          _this.props.onLazyLoad(slidesToLoad);
        }
      } else {
        if (_this.lazyLoadTimer) {
          clearInterval(_this.lazyLoadTimer);
          delete _this.lazyLoadTimer;
        }
      }
    };

    _this.slideHandler = function (index) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props = _this.props,
          asNavFor = _this$props.asNavFor,
          beforeChange = _this$props.beforeChange,
          onLazyLoad = _this$props.onLazyLoad,
          speed = _this$props.speed,
          afterChange = _this$props.afterChange;
      // capture currentslide before state is updated

      var currentSlide = _this.state.currentSlide;

      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_extends({
        index: index
      }, _this.props, _this.state, {
        trackRef: _this.track,
        useCSS: _this.props.useCSS && !dontAnimate
      })),
          state = _slideHandler.state,
          nextState = _slideHandler.nextState;

      if (!state) return;
      beforeChange && beforeChange(currentSlide, state.currentSlide);
      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
        return _this.state.lazyLoadedList.indexOf(value) < 0;
      });
      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
      _this.setState(state, function () {
        asNavFor && asNavFor.innerSlider.state.currentSlide !== currentSlide && asNavFor.innerSlider.slideHandler(index);
        if (!nextState) return;
        _this.animationEndCallback = setTimeout(function () {
          var animating = nextState.animating,
              firstBatch = _objectWithoutProperties(nextState, ["animating"]);

          _this.setState(firstBatch, function () {
            _this.callbackTimers.push(setTimeout(function () {
              return _this.setState({ animating: animating });
            }, 10));
            afterChange && afterChange(state.currentSlide);
            delete _this.animationEndCallback;
          });
        }, speed);
      });
    };

    _this.changeSlide = function (options) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var spec = _extends({}, _this.props, _this.state);
      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
      if (targetSlide !== 0 && !targetSlide) return;
      if (dontAnimate === true) {
        _this.slideHandler(targetSlide, dontAnimate);
      } else {
        _this.slideHandler(targetSlide);
      }
    };

    _this.clickHandler = function (e) {
      if (_this.clickable === false) {
        e.stopPropagation();
        e.preventDefault();
      }
      _this.clickable = true;
    };

    _this.keyHandler = function (e) {
      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
      dir !== "" && _this.changeSlide({ message: dir });
    };

    _this.selectHandler = function (options) {
      _this.changeSlide(options);
    };

    _this.disableBodyScroll = function () {
      var preventDefault = function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault) e.preventDefault();
        e.returnValue = false;
      };
      window.ontouchmove = preventDefault;
    };

    _this.enableBodyScroll = function () {
      window.ontouchmove = null;
    };

    _this.swipeStart = function (e) {
      if (_this.props.verticalSwiping) {
        _this.disableBodyScroll();
      }
      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
      state !== "" && _this.setState(state);
    };

    _this.swipeMove = function (e) {
      var state = (0, _innerSliderUtils.swipeMove)(e, _extends({}, _this.props, _this.state, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      if (state["swiping"]) {
        _this.clickable = false;
      }
      _this.setState(state);
    };

    _this.swipeEnd = function (e) {
      var state = (0, _innerSliderUtils.swipeEnd)(e, _extends({}, _this.props, _this.state, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      var triggerSlideHandler = state["triggerSlideHandler"];
      delete state["triggerSlideHandler"];
      _this.setState(state);
      if (triggerSlideHandler === undefined) return;
      _this.slideHandler(triggerSlideHandler);
      if (_this.props.verticalSwiping) {
        _this.enableBodyScroll();
      }
    };

    _this.slickPrev = function () {
      // this and fellow methods are wrapped in setTimeout
      // to make sure initialize setState has happened before
      // any of such methods are called
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({ message: "previous" });
      }, 0));
    };

    _this.slickNext = function () {
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({ message: "next" });
      }, 0));
    };

    _this.slickGoTo = function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      slide = Number(slide);
      if (isNaN(slide)) return "";
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "index",
          index: slide,
          currentSlide: _this.state.currentSlide
        }, dontAnimate);
      }, 0));
    };

    _this.play = function () {
      var nextIndex;
      if (_this.props.rtl) {
        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
      } else {
        if ((0, _innerSliderUtils.canGoNext)(_extends({}, _this.props, _this.state))) {
          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
        } else {
          return false;
        }
      }

      _this.slideHandler(nextIndex);
    };

    _this.autoPlay = function (playType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }
      var autoplaying = _this.state.autoplaying;
      if (playType === "update") {
        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
          return;
        }
      } else if (playType === "leave") {
        if (autoplaying === "paused" || autoplaying === "focused") {
          return;
        }
      } else if (playType === "blur") {
        if (autoplaying === "paused" || autoplaying === "hovered") {
          return;
        }
      }
      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
      _this.setState({ autoplaying: "playing" });
    };

    _this.pause = function (pauseType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
        _this.autoplayTimer = null;
      }
      var autoplaying = _this.state.autoplaying;
      if (pauseType === "paused") {
        _this.setState({ autoplaying: "paused" });
      } else if (pauseType === "focused") {
        if (autoplaying === "hovered" || autoplaying === "playing") {
          _this.setState({ autoplaying: "focused" });
        }
      } else {
        // pauseType  is 'hovered'
        if (autoplaying === "playing") {
          _this.setState({ autoplaying: "hovered" });
        }
      }
    };

    _this.onDotsOver = function () {
      return _this.props.autoplay && _this.pause("hovered");
    };

    _this.onDotsLeave = function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    };

    _this.onTrackOver = function () {
      return _this.props.autoplay && _this.pause("hovered");
    };

    _this.onTrackLeave = function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    };

    _this.onSlideFocus = function () {
      return _this.props.autoplay && _this.pause("focused");
    };

    _this.onSlideBlur = function () {
      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
    };

    _this.render = function () {
      var className = (0, _classnames2.default)("slick-slider", _this.props.className, {
        "slick-vertical": _this.props.vertical,
        "slick-initialized": true
      });
      var spec = _extends({}, _this.props, _this.state);
      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding"]);
      var pauseOnHover = _this.props.pauseOnHover;

      trackProps = _extends({}, trackProps, {
        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
        focusOnSelect: _this.props.focusOnSelect ? _this.selectHandler : null
      });

      var dots;
      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
        var pauseOnDotsHover = _this.props.pauseOnDotsHover;

        dotProps = _extends({}, dotProps, {
          clickHandler: _this.changeSlide,
          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
        });
        dots = _react2.default.createElement(_dots.Dots, dotProps);
      }

      var prevArrow, nextArrow;
      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
      arrowProps.clickHandler = _this.changeSlide;

      if (_this.props.arrows) {
        prevArrow = _react2.default.createElement(_arrows.PrevArrow, arrowProps);
        nextArrow = _react2.default.createElement(_arrows.NextArrow, arrowProps);
      }

      var verticalHeightStyle = null;

      if (_this.props.vertical) {
        verticalHeightStyle = {
          height: _this.state.listHeight
        };
      }

      var centerPaddingStyle = null;

      if (_this.props.vertical === false) {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: "0px " + _this.props.centerPadding
          };
        }
      } else {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: _this.props.centerPadding + " 0px"
          };
        }
      }

      var listStyle = _extends({}, verticalHeightStyle, centerPaddingStyle);
      var touchMove = _this.props.touchMove;
      var listProps = {
        className: "slick-list",
        style: listStyle,
        onClick: _this.clickHandler,
        onMouseDown: touchMove ? _this.swipeStart : null,
        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onMouseUp: touchMove ? _this.swipeEnd : null,
        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onTouchStart: touchMove ? _this.swipeStart : null,
        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onTouchEnd: touchMove ? _this.swipeEnd : null,
        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
      };

      var innerSliderProps = {
        className: className,
        dir: "ltr"
      };

      if (_this.props.unslick) {
        listProps = { className: "slick-list" };
        innerSliderProps = { className: className };
      }
      return _react2.default.createElement(
        "div",
        innerSliderProps,
        !_this.props.unslick ? prevArrow : "",
        _react2.default.createElement(
          "div",
          _extends({ ref: _this.listRefHandler }, listProps),
          _react2.default.createElement(
            _track.Track,
            _extends({ ref: _this.trackRefHandler }, trackProps),
            _this.props.children
          )
        ),
        !_this.props.unslick ? nextArrow : "",
        !_this.props.unslick ? dots : ""
      );
    };

    _this.list = null;
    _this.track = null;
    _this.state = _extends({}, _initialState2.default, {
      currentSlide: _this.props.initialSlide,
      slideCount: _react2.default.Children.count(_this.props.children)
    });
    _this.callbackTimers = [];
    _this.clickable = true;
    _this.debouncedResize = null;
    return _this;
  }

  return InnerSlider;
}(_react2.default.Component);

/***/ }),
/* 2219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var initialState = {
  animating: false,
  autoplaying: null,
  currentDirection: 0,
  currentLeft: null,
  currentSlide: 0,
  direction: 1,
  dragging: false,
  edgeDragged: false,
  initialized: false,
  lazyLoadedList: [],
  listHeight: null,
  listWidth: null,
  scrolling: false,
  slideCount: null,
  slideHeight: null,
  slideWidth: null,
  swipeLeft: null,
  swiped: false, // used by swipeEvent. differentites between touch and swipe.
  swiping: false,
  touchObject: { startX: 0, startY: 0, curX: 0, curY: 0 },
  trackStyle: {},
  trackWidth: 0
};

exports.default = initialState;

/***/ }),
/* 2220 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(58)))

/***/ }),
/* 2221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Track = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _innerSliderUtils = __webpack_require__(294);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var getSlideClasses = function getSlideClasses(spec) {
  var slickActive, slickCenter, slickCloned;
  var centerOffset, index;

  if (spec.rtl) {
    index = spec.slideCount - 1 - spec.index;
  } else {
    index = spec.index;
  }
  slickCloned = index < 0 || index >= spec.slideCount;
  if (spec.centerMode) {
    centerOffset = Math.floor(spec.slidesToShow / 2);
    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
      slickActive = true;
    }
  } else {
    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
  }
  var slickCurrent = index === spec.currentSlide;
  return {
    "slick-slide": true,
    "slick-active": slickActive,
    "slick-center": slickCenter,
    "slick-cloned": slickCloned,
    "slick-current": slickCurrent // dubious in case of RTL
  };
};

var getSlideStyle = function getSlideStyle(spec) {
  var style = {};

  if (spec.variableWidth === undefined || spec.variableWidth === false) {
    style.width = spec.slideWidth;
  }

  if (spec.fade) {
    style.position = "relative";
    if (spec.vertical) {
      style.top = -spec.index * parseInt(spec.slideHeight);
    } else {
      style.left = -spec.index * parseInt(spec.slideWidth);
    }
    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
    style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    style.WebkitTransition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
  }

  return style;
};

var getKey = function getKey(child, fallbackKey) {
  return child.key || fallbackKey;
};

var renderSlides = function renderSlides(spec) {
  var key;
  var slides = [];
  var preCloneSlides = [];
  var postCloneSlides = [];
  var childrenCount = _react2.default.Children.count(spec.children);
  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);

  _react2.default.Children.forEach(spec.children, function (elem, index) {
    var child = void 0;
    var childOnClickOptions = {
      message: "children",
      index: index,
      slidesToScroll: spec.slidesToScroll,
      currentSlide: spec.currentSlide
    };

    // in case of lazyLoad, whether or not we want to fetch the slide
    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
      child = elem;
    } else {
      child = _react2.default.createElement("div", null);
    }
    var childStyle = getSlideStyle(_extends({}, spec, { index: index }));
    var slideClass = child.props.className || "";
    var slideClasses = getSlideClasses(_extends({}, spec, { index: index }));
    // push a cloned element of the desired slide
    slides.push(_react2.default.cloneElement(child, {
      key: "original" + getKey(child, index),
      "data-index": index,
      className: (0, _classnames2.default)(slideClasses, slideClass),
      tabIndex: "-1",
      "aria-hidden": !slideClasses["slick-active"],
      style: _extends({ outline: "none" }, child.props.style || {}, childStyle),
      onClick: function onClick(e) {
        child.props && child.props.onClick && child.props.onClick(e);
        if (spec.focusOnSelect) {
          spec.focusOnSelect(childOnClickOptions);
        }
      }
    }));

    // if slide needs to be precloned or postcloned
    if (spec.infinite && spec.fade === false) {
      var preCloneNo = childrenCount - index;
      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
        key = -preCloneNo;
        if (key >= startIndex) {
          child = elem;
        }
        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
        preCloneSlides.push(_react2.default.cloneElement(child, {
          key: "precloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames2.default)(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _extends({}, child.props.style || {}, childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);
            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }

      if (childrenCount !== spec.slidesToShow) {
        key = childrenCount + index;
        if (key < endIndex) {
          child = elem;
        }
        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
        postCloneSlides.push(_react2.default.cloneElement(child, {
          key: "postcloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames2.default)(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _extends({}, child.props.style || {}, childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);
            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }
    }
  });

  if (spec.rtl) {
    return preCloneSlides.concat(slides, postCloneSlides).reverse();
  } else {
    return preCloneSlides.concat(slides, postCloneSlides);
  }
};

var Track = exports.Track = function (_React$PureComponent) {
  _inherits(Track, _React$PureComponent);

  function Track() {
    _classCallCheck(this, Track);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Track.prototype.render = function render() {
    var slides = renderSlides(this.props);
    var _props = this.props,
        onMouseEnter = _props.onMouseEnter,
        onMouseOver = _props.onMouseOver,
        onMouseLeave = _props.onMouseLeave;

    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
    return _react2.default.createElement(
      "div",
      _extends({
        className: "slick-track",
        style: this.props.trackStyle
      }, mouseEvents),
      slides
    );
  };

  return Track;
}(_react2.default.PureComponent);

/***/ }),
/* 2222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Dots = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getDotCount = function getDotCount(spec) {
  var dots;

  if (spec.infinite) {
    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
  } else {
    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
  }

  return dots;
};

var Dots = exports.Dots = function (_React$PureComponent) {
  _inherits(Dots, _React$PureComponent);

  function Dots() {
    _classCallCheck(this, Dots);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Dots.prototype.clickHandler = function clickHandler(options, e) {
    // In Autoplay the focus stays on clicked button even after transition
    // to next slide. That only goes away by click somewhere outside
    e.preventDefault();
    this.props.clickHandler(options);
  };

  Dots.prototype.render = function render() {
    var _this2 = this;

    var dotCount = getDotCount({
      slideCount: this.props.slideCount,
      slidesToScroll: this.props.slidesToScroll,
      slidesToShow: this.props.slidesToShow,
      infinite: this.props.infinite
    });

    // Apply join & split to Array to pre-fill it for IE8
    //
    // Credit: http://stackoverflow.com/a/13735425/1849458
    var _props = this.props,
        onMouseEnter = _props.onMouseEnter,
        onMouseOver = _props.onMouseOver,
        onMouseLeave = _props.onMouseLeave;

    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
    var dots = Array.apply(null, Array(dotCount + 1).join("0").split("")).map(function (x, i) {
      var leftBound = i * _this2.props.slidesToScroll;
      var rightBound = i * _this2.props.slidesToScroll + (_this2.props.slidesToScroll - 1);
      var className = (0, _classnames2.default)({
        "slick-active": _this2.props.currentSlide >= leftBound && _this2.props.currentSlide <= rightBound
      });

      var dotOptions = {
        message: "dots",
        index: i,
        slidesToScroll: _this2.props.slidesToScroll,
        currentSlide: _this2.props.currentSlide
      };

      var onClick = _this2.clickHandler.bind(_this2, dotOptions);
      return _react2.default.createElement(
        "li",
        { key: i, className: className },
        _react2.default.cloneElement(_this2.props.customPaging(i), { onClick: onClick })
      );
    });

    return _react2.default.cloneElement(this.props.appendDots(dots), _extends({
      className: this.props.dotsClass
    }, mouseEvents));
  };

  return Dots;
}(_react2.default.PureComponent);

/***/ }),
/* 2223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.NextArrow = exports.PrevArrow = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _innerSliderUtils = __webpack_require__(294);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PrevArrow = exports.PrevArrow = function (_React$PureComponent) {
  _inherits(PrevArrow, _React$PureComponent);

  function PrevArrow() {
    _classCallCheck(this, PrevArrow);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  PrevArrow.prototype.clickHandler = function clickHandler(options, e) {
    if (e) {
      e.preventDefault();
    }
    this.props.clickHandler(options, e);
  };

  PrevArrow.prototype.render = function render() {
    var prevClasses = { "slick-arrow": true, "slick-prev": true };
    var prevHandler = this.clickHandler.bind(this, { message: "previous" });

    if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
      prevClasses["slick-disabled"] = true;
      prevHandler = null;
    }

    var prevArrowProps = {
      key: "0",
      "data-role": "none",
      className: (0, _classnames2.default)(prevClasses),
      style: { display: "block" },
      onClick: prevHandler
    };
    var customProps = {
      currentSlide: this.props.currentSlide,
      slideCount: this.props.slideCount
    };
    var prevArrow = void 0;

    if (this.props.prevArrow) {
      prevArrow = _react2.default.cloneElement(this.props.prevArrow, _extends({}, prevArrowProps, customProps));
    } else {
      prevArrow = _react2.default.createElement(
        "button",
        _extends({ key: "0", type: "button" }, prevArrowProps),
        " ",
        "Previous"
      );
    }

    return prevArrow;
  };

  return PrevArrow;
}(_react2.default.PureComponent);

var NextArrow = exports.NextArrow = function (_React$PureComponent2) {
  _inherits(NextArrow, _React$PureComponent2);

  function NextArrow() {
    _classCallCheck(this, NextArrow);

    return _possibleConstructorReturn(this, _React$PureComponent2.apply(this, arguments));
  }

  NextArrow.prototype.clickHandler = function clickHandler(options, e) {
    if (e) {
      e.preventDefault();
    }
    this.props.clickHandler(options, e);
  };

  NextArrow.prototype.render = function render() {
    var nextClasses = { "slick-arrow": true, "slick-next": true };
    var nextHandler = this.clickHandler.bind(this, { message: "next" });

    if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
      nextClasses["slick-disabled"] = true;
      nextHandler = null;
    }

    var nextArrowProps = {
      key: "1",
      "data-role": "none",
      className: (0, _classnames2.default)(nextClasses),
      style: { display: "block" },
      onClick: nextHandler
    };
    var customProps = {
      currentSlide: this.props.currentSlide,
      slideCount: this.props.slideCount
    };
    var nextArrow = void 0;

    if (this.props.nextArrow) {
      nextArrow = _react2.default.cloneElement(this.props.nextArrow, _extends({}, nextArrowProps, customProps));
    } else {
      nextArrow = _react2.default.createElement(
        "button",
        _extends({ key: "1", type: "button" }, nextArrowProps),
        " ",
        "Next"
      );
    }

    return nextArrow;
  };

  return NextArrow;
}(_react2.default.PureComponent);

/***/ }),
/* 2224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["default"] = (index);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(58)))

/***/ }),
/* 2225 */
/***/ (function(module, exports, __webpack_require__) {

var camel2hyphen = __webpack_require__(2226);

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and '
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', '
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

module.exports = json2mq;

/***/ }),
/* 2226 */
/***/ (function(module, exports) {

var camel2hyphen = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

module.exports = camel2hyphen;

/***/ }),
/* 2227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultProps = {
  accessibility: true,
  adaptiveHeight: false,
  afterChange: null,
  appendDots: function appendDots(dots) {
    return _react2.default.createElement(
      "ul",
      { style: { display: "block" } },
      dots
    );
  },
  arrows: true,
  autoplay: false,
  autoplaySpeed: 3000,
  beforeChange: null,
  centerMode: false,
  centerPadding: "50px",
  className: "",
  cssEase: "ease",
  customPaging: function customPaging(i) {
    return _react2.default.createElement(
      "button",
      null,
      i + 1
    );
  },
  dots: false,
  dotsClass: "slick-dots",
  draggable: true,
  easing: "linear",
  edgeFriction: 0.35,
  fade: false,
  focusOnSelect: false,
  infinite: true,
  initialSlide: 0,
  lazyLoad: null,
  nextArrow: null,
  onEdge: null,
  onInit: null,
  onLazyLoadError: null,
  onReInit: null,
  pauseOnDotsHover: false,
  pauseOnFocus: false,
  pauseOnHover: true,
  prevArrow: null,
  responsive: null,
  rows: 1,
  rtl: false,
  slide: "div",
  slidesPerRow: 1,
  slidesToScroll: 1,
  slidesToShow: 1,
  speed: 500,
  swipe: true,
  swipeEvent: null,
  swipeToSlide: false,
  touchMove: true,
  touchThreshold: 5,
  useCSS: true,
  useTransform: true,
  variableWidth: false,
  vertical: false,
  waitForAnimate: true
};

exports.default = defaultProps;

/***/ }),
/* 2228 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQueryDispatch = __webpack_require__(2229);
module.exports = new MediaQueryDispatch();


/***/ }),
/* 2229 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQuery = __webpack_require__(2230);
var Util = __webpack_require__(1351);
var each = Util.each;
var isFunction = Util.isFunction;
var isArray = Util.isArray;

/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */
function MediaQueryDispatch () {
    if(!window.matchMedia) {
        throw new Error('matchMedia not present, legacy browsers require a polyfill');
    }

    this.queries = {};
    this.browserIsIncapable = !window.matchMedia('only all').matches;
}

MediaQueryDispatch.prototype = {

    constructor : MediaQueryDispatch,

    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */
    register : function(q, options, shouldDegrade) {
        var queries         = this.queries,
            isUnconditional = shouldDegrade && this.browserIsIncapable;

        if(!queries[q]) {
            queries[q] = new MediaQuery(q, isUnconditional);
        }

        //normalise to object in an array
        if(isFunction(options)) {
            options = { match : options };
        }
        if(!isArray(options)) {
            options = [options];
        }
        each(options, function(handler) {
            if (isFunction(handler)) {
                handler = { match : handler };
            }
            queries[q].addHandler(handler);
        });

        return this;
    },

    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */
    unregister : function(q, handler) {
        var query = this.queries[q];

        if(query) {
            if(handler) {
                query.removeHandler(handler);
            }
            else {
                query.clear();
                delete this.queries[q];
            }
        }

        return this;
    }
};

module.exports = MediaQueryDispatch;


/***/ }),
/* 2230 */
/***/ (function(module, exports, __webpack_require__) {

var QueryHandler = __webpack_require__(2231);
var each = __webpack_require__(1351).each;

/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */
function MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);

    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}

MediaQuery.prototype = {

    constuctor : MediaQuery,

    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */
    addHandler : function(handler) {
        var qh = new QueryHandler(handler);
        this.handlers.push(qh);

        this.matches() && qh.on();
    },

    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */
    removeHandler : function(handler) {
        var handlers = this.handlers;
        each(handlers, function(h, i) {
            if(h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i,1); //remove from array and exit each early
            }
        });
    },

    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */
    matches : function() {
        return this.mql.matches || this.isUnconditional;
    },

    /**
     * Clears all handlers and unbinds events
     */
    clear : function() {
        each(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },

    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */
    assess : function() {
        var action = this.matches() ? 'on' : 'off';

        each(this.handlers, function(handler) {
            handler[action]();
        });
    }
};

module.exports = MediaQuery;


/***/ }),
/* 2231 */
/***/ (function(module, exports) {

/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */
function QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}

QueryHandler.prototype = {

    constructor : QueryHandler,

    /**
     * coordinates setup of the handler
     *
     * @function
     */
    setup : function() {
        if(this.options.setup) {
            this.options.setup();
        }
        this.initialised = true;
    },

    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */
    on : function() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },

    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */
    off : function() {
        this.options.unmatch && this.options.unmatch();
    },

    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */
    destroy : function() {
        this.options.destroy ? this.options.destroy() : this.off();
    },

    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */
    equals : function(target) {
        return this.options === target || this.options.match === target;
    }

};

module.exports = QueryHandler;


/***/ }),
/* 2232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ESC_KEY_CODE = 27;

var EscManager = exports.EscManager = function () {
    function EscManager() {
        var _this = this;

        _classCallCheck(this, EscManager);

        this._handleKeydown = function (e) {
            if (e.keyCode === ESC_KEY_CODE && _this._escMap.size !== 0) {
                _this._invokeCallbacks(e);
            }
        };

        this._escMap = new Map();

        document.body.addEventListener('keydown', this._handleKeydown);
    }

    _createClass(EscManager, [{
        key: 'addCallback',
        value: function addCallback(callback) {
            this._escMap.set(callback, callback);
        }
    }, {
        key: 'removeCallback',
        value: function removeCallback(callback) {
            if (this._escMap.has(callback)) {
                this._escMap.delete(callback);
            }
        }
    }, {
        key: '_invokeCallbacks',
        value: function _invokeCallbacks(e) {
            var callbacksArray = Array.from(this._escMap.values());
            var shouldPassControlToNextEsc = void 0;
            var callback = function callback() {
                return shouldPassControlToNextEsc = true;
            };

            for (var i = callbacksArray.length - 1; i >= 0; i--) {
                shouldPassControlToNextEsc = false;
                callbacksArray[i](e, callback);

                if (shouldPassControlToNextEsc) {
                    continue;
                }

                break;
            }
        }
    }], [{
        key: 'getInstance',
        value: function getInstance() {
            if (!EscManager._instance) {
                EscManager._instance = new EscManager();
            }

            return EscManager._instance;
        }
    }]);

    return EscManager;
}();

/***/ }),
/* 2233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useEvent = useEvent;

var _react = __webpack_require__(0);

var STATIC_DEPS = [];

/**
 * This is proposal: https://github.com/reactjs/rfcs/pull/220
 *
 * See also: https://github.com/reactjs/rfcs/blob/useevent/text/0000-useevent.md
 *
 * Example to use:
 * ```tsx
 * function Foo() {
 *   const [text, setText] = useState('');
 *
 *   const handleClick = useEvent(() => {
 *       sendMessage(text);
 *   });
 *
 *   // SendButton has memo HOC wrapper
 *   return <SendButton onClick={handleClick} />;
 * }
 * ```
 */
function useEvent(handler) {
    var handlerRef = (0, _react.useRef)(handler);

    (0, _react.useLayoutEffect)(function () {
        handlerRef.current = handler;
    });

    return (0, _react.useCallback)(function () {
        var fn = handlerRef.current;
        return fn.apply(undefined, arguments);
    }, STATIC_DEPS);
}

/***/ }),
/* 2234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__v1_js__ = __webpack_require__(2235);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v1", function() { return __WEBPACK_IMPORTED_MODULE_0__v1_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__v3_js__ = __webpack_require__(2237);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v3", function() { return __WEBPACK_IMPORTED_MODULE_1__v3_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__v4_js__ = __webpack_require__(2239);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v4", function() { return __WEBPACK_IMPORTED_MODULE_2__v4_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__v5_js__ = __webpack_require__(2240);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v5", function() { return __WEBPACK_IMPORTED_MODULE_3__v5_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__nil_js__ = __webpack_require__(2242);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NIL", function() { return __WEBPACK_IMPORTED_MODULE_4__nil_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__version_js__ = __webpack_require__(2243);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "version", function() { return __WEBPACK_IMPORTED_MODULE_5__version_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__validate_js__ = __webpack_require__(296);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "validate", function() { return __WEBPACK_IMPORTED_MODULE_6__validate_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__stringify_js__ = __webpack_require__(295);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stringify", function() { return __WEBPACK_IMPORTED_MODULE_7__stringify_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__parse_js__ = __webpack_require__(1357);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "parse", function() { return __WEBPACK_IMPORTED_MODULE_8__parse_js__["a"]; });










/***/ }),
/* 2235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rng_js__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stringify_js__ = __webpack_require__(295);

 // **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;

var _clockseq; // Previous uuid creation time


var _lastMSecs = 0;
var _lastNSecs = 0; // See https://github.com/uuidjs/uuid for API details

function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || new Array(16);
  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq; // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189

  if (node == null || clockseq == null) {
    var seedBytes = options.random || (options.rng || __WEBPACK_IMPORTED_MODULE_0__rng_js__["a" /* default */])();

    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [seedBytes[0] | 0x01, seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]];
    }

    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  } // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.


  var msecs = options.msecs !== undefined ? options.msecs : Date.now(); // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock

  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1; // Time since last uuid creation (in msecs)

  var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000; // Per 4.2.1.2, Bump clockseq on clock regression

  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  } // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval


  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  } // Per 4.2.1.2 Throw error if too many uuids are requested


  if (nsecs >= 10000) {
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq; // Per 4.1.4 - Convert from unix epoch to Gregorian epoch

  msecs += 12219292800000; // `time_low`

  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff; // `time_mid`

  var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff; // `time_high_and_version`

  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version

  b[i++] = tmh >>> 16 & 0xff; // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)

  b[i++] = clockseq >>> 8 | 0x80; // `clock_seq_low`

  b[i++] = clockseq & 0xff; // `node`

  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf || Object(__WEBPACK_IMPORTED_MODULE_1__stringify_js__["a" /* default */])(b);
}

/* harmony default export */ __webpack_exports__["a"] = (v1);

/***/ }),
/* 2236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (/^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i);

/***/ }),
/* 2237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__v35_js__ = __webpack_require__(1356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__md5_js__ = __webpack_require__(2238);


var v3 = Object(__WEBPACK_IMPORTED_MODULE_0__v35_js__["a" /* default */])('v3', 0x30, __WEBPACK_IMPORTED_MODULE_1__md5_js__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (v3);

/***/ }),
/* 2238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
 * Browser-compatible JavaScript MD5
 *
 * Modification of JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */
function md5(bytes) {
  if (typeof bytes === 'string') {
    var msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = new Uint8Array(msg.length);

    for (var i = 0; i < msg.length; ++i) {
      bytes[i] = msg.charCodeAt(i);
    }
  }

  return md5ToHexEncodedArray(wordsToMd5(bytesToWords(bytes), bytes.length * 8));
}
/*
 * Convert an array of little-endian words to an array of bytes
 */


function md5ToHexEncodedArray(input) {
  var output = [];
  var length32 = input.length * 32;
  var hexTab = '0123456789abcdef';

  for (var i = 0; i < length32; i += 8) {
    var x = input[i >> 5] >>> i % 32 & 0xff;
    var hex = parseInt(hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f), 16);
    output.push(hex);
  }

  return output;
}
/**
 * Calculate output length with padding and bit length
 */


function getOutputLength(inputLength8) {
  return (inputLength8 + 64 >>> 9 << 4) + 14 + 1;
}
/*
 * Calculate the MD5 of an array of little-endian words, and a bit length.
 */


function wordsToMd5(x, len) {
  /* append padding */
  x[len >> 5] |= 0x80 << len % 32;
  x[getOutputLength(len) - 1] = len;
  var a = 1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d = 271733878;

  for (var i = 0; i < x.length; i += 16) {
    var olda = a;
    var oldb = b;
    var oldc = c;
    var oldd = d;
    a = md5ff(a, b, c, d, x[i], 7, -680876936);
    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5gg(b, c, d, a, x[i], 20, -373897302);
    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5hh(d, a, b, c, x[i], 11, -358537222);
    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
    a = md5ii(a, b, c, d, x[i], 6, -198630844);
    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
    a = safeAdd(a, olda);
    b = safeAdd(b, oldb);
    c = safeAdd(c, oldc);
    d = safeAdd(d, oldd);
  }

  return [a, b, c, d];
}
/*
 * Convert an array bytes to an array of little-endian words
 * Characters >255 have their high-byte silently ignored.
 */


function bytesToWords(input) {
  if (input.length === 0) {
    return [];
  }

  var length8 = input.length * 8;
  var output = new Uint32Array(getOutputLength(length8));

  for (var i = 0; i < length8; i += 8) {
    output[i >> 5] |= (input[i / 8] & 0xff) << i % 32;
  }

  return output;
}
/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */


function safeAdd(x, y) {
  var lsw = (x & 0xffff) + (y & 0xffff);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return msw << 16 | lsw & 0xffff;
}
/*
 * Bitwise rotate a 32-bit number to the left.
 */


function bitRotateLeft(num, cnt) {
  return num << cnt | num >>> 32 - cnt;
}
/*
 * These functions implement the four basic operations the algorithm uses.
 */


function md5cmn(q, a, b, x, s, t) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}

function md5ff(a, b, c, d, x, s, t) {
  return md5cmn(b & c | ~b & d, a, b, x, s, t);
}

function md5gg(a, b, c, d, x, s, t) {
  return md5cmn(b & d | c & ~d, a, b, x, s, t);
}

function md5hh(a, b, c, d, x, s, t) {
  return md5cmn(b ^ c ^ d, a, b, x, s, t);
}

function md5ii(a, b, c, d, x, s, t) {
  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
}

/* harmony default export */ __webpack_exports__["a"] = (md5);

/***/ }),
/* 2239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rng_js__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stringify_js__ = __webpack_require__(295);



function v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || __WEBPACK_IMPORTED_MODULE_0__rng_js__["a" /* default */])(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1__stringify_js__["a" /* default */])(rnds);
}

/* harmony default export */ __webpack_exports__["a"] = (v4);

/***/ }),
/* 2240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__v35_js__ = __webpack_require__(1356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sha1_js__ = __webpack_require__(2241);


var v5 = Object(__WEBPACK_IMPORTED_MODULE_0__v35_js__["a" /* default */])('v5', 0x50, __WEBPACK_IMPORTED_MODULE_1__sha1_js__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (v5);

/***/ }),
/* 2241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Adapted from Chris Veness' SHA1 code at
// http://www.movable-type.co.uk/scripts/sha1.html
function f(s, x, y, z) {
  switch (s) {
    case 0:
      return x & y ^ ~x & z;

    case 1:
      return x ^ y ^ z;

    case 2:
      return x & y ^ x & z ^ y & z;

    case 3:
      return x ^ y ^ z;
  }
}

function ROTL(x, n) {
  return x << n | x >>> 32 - n;
}

function sha1(bytes) {
  var K = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xca62c1d6];
  var H = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0];

  if (typeof bytes === 'string') {
    var msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = [];

    for (var i = 0; i < msg.length; ++i) {
      bytes.push(msg.charCodeAt(i));
    }
  } else if (!Array.isArray(bytes)) {
    // Convert Array-like to Array
    bytes = Array.prototype.slice.call(bytes);
  }

  bytes.push(0x80);
  var l = bytes.length / 4 + 2;
  var N = Math.ceil(l / 16);
  var M = new Array(N);

  for (var _i = 0; _i < N; ++_i) {
    var arr = new Uint32Array(16);

    for (var j = 0; j < 16; ++j) {
      arr[j] = bytes[_i * 64 + j * 4] << 24 | bytes[_i * 64 + j * 4 + 1] << 16 | bytes[_i * 64 + j * 4 + 2] << 8 | bytes[_i * 64 + j * 4 + 3];
    }

    M[_i] = arr;
  }

  M[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
  M[N - 1][14] = Math.floor(M[N - 1][14]);
  M[N - 1][15] = (bytes.length - 1) * 8 & 0xffffffff;

  for (var _i2 = 0; _i2 < N; ++_i2) {
    var W = new Uint32Array(80);

    for (var t = 0; t < 16; ++t) {
      W[t] = M[_i2][t];
    }

    for (var _t = 16; _t < 80; ++_t) {
      W[_t] = ROTL(W[_t - 3] ^ W[_t - 8] ^ W[_t - 14] ^ W[_t - 16], 1);
    }

    var a = H[0];
    var b = H[1];
    var c = H[2];
    var d = H[3];
    var e = H[4];

    for (var _t2 = 0; _t2 < 80; ++_t2) {
      var s = Math.floor(_t2 / 20);
      var T = ROTL(a, 5) + f(s, b, c, d) + e + K[s] + W[_t2] >>> 0;
      e = d;
      d = c;
      c = ROTL(b, 30) >>> 0;
      b = a;
      a = T;
    }

    H[0] = H[0] + a >>> 0;
    H[1] = H[1] + b >>> 0;
    H[2] = H[2] + c >>> 0;
    H[3] = H[3] + d >>> 0;
    H[4] = H[4] + e >>> 0;
  }

  return [H[0] >> 24 & 0xff, H[0] >> 16 & 0xff, H[0] >> 8 & 0xff, H[0] & 0xff, H[1] >> 24 & 0xff, H[1] >> 16 & 0xff, H[1] >> 8 & 0xff, H[1] & 0xff, H[2] >> 24 & 0xff, H[2] >> 16 & 0xff, H[2] >> 8 & 0xff, H[2] & 0xff, H[3] >> 24 & 0xff, H[3] >> 16 & 0xff, H[3] >> 8 & 0xff, H[3] & 0xff, H[4] >> 24 & 0xff, H[4] >> 16 & 0xff, H[4] >> 8 & 0xff, H[4] & 0xff];
}

/* harmony default export */ __webpack_exports__["a"] = (sha1);

/***/ }),
/* 2242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ('00000000-0000-0000-0000-000000000000');

/***/ }),
/* 2243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__validate_js__ = __webpack_require__(296);


function version(uuid) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__validate_js__["a" /* default */])(uuid)) {
    throw TypeError('Invalid UUID');
  }

  return parseInt(uuid.substr(14, 1), 16);
}

/* harmony default export */ __webpack_exports__["a"] = (version);

/***/ }),
/* 2244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var LogLevel = exports.LogLevel = {
    NonSet: 0,
    Debug: 10,
    Info: 20,
    Warning: 30
};

var TOOLTIP_ACTION = exports.TOOLTIP_ACTION = 'tooltip_watched';
var TOOLTIP_TIME_LIMIT = exports.TOOLTIP_TIME_LIMIT = 2;

/***/ }),
/* 2245 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"ButtonSimple_base--1DwII","isContrast":"ButtonSimple_isContrast--1QTN2","isExternal":"ButtonSimple_isExternal--K_HEz","isGlow":"ButtonSimple_isGlow--3Pb1l","isDisabled":"ButtonSimple_isDisabled--1lRP9","messages":"ButtonSimple_messages--Kkan9"};

/***/ }),
/* 2246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _constants = __webpack_require__(2247);

var _LandingBonus = __webpack_require__(2248);

var _LandingBonus2 = _interopRequireDefault(_LandingBonus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LandingBonus = function LandingBonus() {
    return _react2.default.createElement(
        'div',
        { className: _LandingBonus2.default.base },
        _react2.default.createElement(
            'div',
            { className: _LandingBonus2.default.items },
            _react2.default.createElement(
                'div',
                { className: _LandingBonus2.default.itemsContainer },
                _react2.default.createElement(
                    'div',
                    { className: _LandingBonus2.default.item },
                    _react2.default.createElement(
                        'div',
                        { className: _LandingBonus2.default.imageContainer },
                        _react2.default.createElement('div', { className: _LandingBonus2.default.reserve })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _LandingBonus2.default.itemHeader },
                        _constants.LANDING_BONUS_THIRD_ITEM_HEADER
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _LandingBonus2.default.itemMessage },
                        _constants.LANDING_BONUS_THIRD_ITEM_MESSAGE
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _LandingBonus2.default.item },
                    _react2.default.createElement(
                        'div',
                        { className: _LandingBonus2.default.imageContainer },
                        _react2.default.createElement('div', { className: _LandingBonus2.default.gold })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _LandingBonus2.default.itemHeader },
                        _constants.LANDING_BONUS_SECOND_ITEM_HEADER
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _LandingBonus2.default.itemMessage },
                        _constants.LANDING_BONUS_SECOND_ITEM_MESSAGE
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _LandingBonus2.default.item },
                    _react2.default.createElement(
                        'div',
                        { className: _LandingBonus2.default.imageContainer },
                        _react2.default.createElement('div', { className: _LandingBonus2.default.vehicle })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _LandingBonus2.default.itemHeader },
                        _constants.LANDING_BONUS_FIRST_ITEM_HEADER
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _LandingBonus2.default.itemMessage },
                        _constants.LANDING_BONUS_FIRST_ITEM_MESSAGE
                    )
                )
            )
        )
    );
};

exports.default = LandingBonus;

/***/ }),
/* 2247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LANDING_BONUS_THIRD_ITEM_MESSAGE = exports.LANDING_BONUS_SECOND_ITEM_MESSAGE = exports.LANDING_BONUS_FIRST_ITEM_MESSAGE = exports.LANDING_BONUS_THIRD_ITEM_HEADER = exports.LANDING_BONUS_SECOND_ITEM_HEADER = exports.LANDING_BONUS_FIRST_ITEM_HEADER = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LANDING_BONUS_FIRST_ITEM_HEADER = exports.LANDING_BONUS_FIRST_ITEM_HEADER = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'landing_bonus.first_item.header',
    defaultMessage: '\u0422\u0435\u0445\u043D\u0438\u043A\u0430 \u0438 3D-\u0441\u0442\u0438\u043B\u0438'
});

var LANDING_BONUS_SECOND_ITEM_HEADER = exports.LANDING_BONUS_SECOND_ITEM_HEADER = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'landing_bonus.second_item.header',
    defaultMessage: '\u0417\u043E\u043B\u043E\u0442\u043E \u0438 \u0431\u043E\u043D\u044B'
});

var LANDING_BONUS_THIRD_ITEM_HEADER = exports.LANDING_BONUS_THIRD_ITEM_HEADER = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'landing_bonus.third_item.header',
    defaultMessage: '\u041A\u043B\u0430\u043D\u043E\u0432\u044B\u0435 \u0440\u0435\u0437\u0435\u0440\u0432\u044B \u0438 \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u044B \u0432\u043D\u0435\u0448\u043D\u0435\u0433\u043E \u0432\u0438\u0434\u0430'
});

var LANDING_BONUS_FIRST_ITEM_MESSAGE = exports.LANDING_BONUS_FIRST_ITEM_MESSAGE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'landing_bonus.first_item.message',
    defaultMessage: '\u041F\u043E\u043B\u0443\u0447\u0430\u0439\u0442\u0435 \u0442\u0435\u0445\u043D\u0438\u043A\u0443, \u0430 \u0442\u0430\u043A\u0436\u0435 \u043E\u0441\u043E\u0431\u044B\u0435 3D-\u0441\u0442\u0438\u043B\u0438 \u0437\u0430 \u043F\u043E\u0431\u0435\u0434\u044B \u0432 \u0441\u043E\u0431\u044B\u0442\u0438\u044F\u0445 \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435.'
});

var LANDING_BONUS_SECOND_ITEM_MESSAGE = exports.LANDING_BONUS_SECOND_ITEM_MESSAGE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'landing_bonus.second_item.message'
    // eslint-disable-next-line max-len
    , defaultMessage: '\u0417\u0430\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0439\u0442\u0435 \u0437\u043E\u043B\u043E\u0442\u043E \u0432 \u0412\u043E\u0435\u043D\u043D\u044B\u0445 \u0438\u0433\u0440\u0430\u0445, \u0430 \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435 \u2014 \u0437\u043E\u043B\u043E\u0442\u043E \u0438 \u0431\u043E\u043D\u044B. \u0417\u0430 \u043D\u0438\u0445 \u0432\u044B \u0441\u043C\u043E\u0436\u0435\u0442\u0435 \u043A\u0443\u043F\u0438\u0442\u044C \u0442\u0435\u0445\u043D\u0438\u043A\u0443 \u0438 \u043C\u043D\u043E\u0433\u043E\u0435 \u0434\u0440\u0443\u0433\u043E\u0435.'
});

var LANDING_BONUS_THIRD_ITEM_MESSAGE = exports.LANDING_BONUS_THIRD_ITEM_MESSAGE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'landing_bonus.third_item.message'
    // eslint-disable-next-line max-len
    , defaultMessage: '\u0412\u044B\u043F\u043E\u043B\u043D\u044F\u0439\u0442\u0435 \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u044C\u043D\u044B\u0435 \u0437\u0430\u0434\u0430\u0447\u0438 \u0438 \u043F\u043E\u043B\u0443\u0447\u0430\u0439\u0442\u0435 \u0440\u0430\u0437\u043B\u0438\u0447\u043D\u044B\u0435 \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u044B \u0432\u043D\u0435\u0448\u043D\u0435\u0433\u043E \u0432\u0438\u0434\u0430, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0434\u0440\u0443\u0433\u0438\u0435 \u043D\u0430\u0433\u0440\u0430\u0434\u044B. \u0420\u0430\u0437\u0432\u0438\u0432\u0430\u0439\u0442\u0435 \u0423\u043A\u0440\u0435\u043F\u0440\u0430\u0439\u043E\u043D \u0438 \u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435\u0441\u044C \u043A\u043B\u0430\u043D\u043E\u0432\u044B\u043C\u0438 \u0440\u0435\u0437\u0435\u0440\u0432\u0430\u043C\u0438, \u0434\u0430\u044E\u0449\u0438\u043C\u0438 \u0431\u043E\u043D\u0443\u0441\u044B \u043A \u043E\u043F\u044B\u0442\u0443 \u0438 \u043A\u0440\u0435\u0434\u0438\u0442\u0430\u043C.'
});

/***/ }),
/* 2248 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"LandingBonus_base--2_7GI","items":"LandingBonus_items--2FCGb","itemsContainer":"LandingBonus_itemsContainer--y4CuM","item":"LandingBonus_item--xhYB6","itemHeader":"LandingBonus_itemHeader--1ayqQ","imageContainer":"LandingBonus_imageContainer--2uNim","gold":"LandingBonus_gold--239M9","vehicle":"LandingBonus_vehicle--3hL9M","reserve":"LandingBonus_reserve--i9gF5","itemMessage":"LandingBonus_itemMessage--1qdIf"};

/***/ }),
/* 2249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LandingClans = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(7);

var _logConstants = __webpack_require__(165);

var _hooks = __webpack_require__(164);

var _reactWotBootstrap = __webpack_require__(5);

var _ButtonSimple = __webpack_require__(235);

var _ButtonSimple2 = _interopRequireDefault(_ButtonSimple);

var _recommended_clans = __webpack_require__(159);

var _app = __webpack_require__(566);

var _clan_invites = __webpack_require__(377);

var _recommended_clans2 = __webpack_require__(368);

var _constants = __webpack_require__(90);

var _translations = __webpack_require__(567);

var _Card = __webpack_require__(2250);

var _Card2 = _interopRequireDefault(_Card);

var _SearchControl = __webpack_require__(2265);

var _SearchControl2 = _interopRequireDefault(_SearchControl);

var _Pagination = __webpack_require__(2270);

var _Pagination2 = _interopRequireDefault(_Pagination);

var _FiltersButton = __webpack_require__(2273);

var _FiltersButton2 = _interopRequireDefault(_FiltersButton);

var _SearchResult = __webpack_require__(2275);

var _SearchResult2 = _interopRequireDefault(_SearchResult);

var _Filters = __webpack_require__(2277);

var _Filters2 = _interopRequireDefault(_Filters);

var _Back = __webpack_require__(70);

var _Back2 = _interopRequireDefault(_Back);

var _LandingClans = __webpack_require__(2283);

var _LandingClans2 = _interopRequireDefault(_LandingClans);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var LandingClans = exports.LandingClans = function LandingClans(_ref) {
    var partnerID = _ref.partnerID,
        onLastSlideBackClick = _ref.onLastSlideBackClick;

    var dispatch = (0, _reactRedux.useDispatch)();

    var _useSelector = (0, _reactRedux.useSelector)(function (state) {
        return state.recommendedClans;
    }),
        loadedBefore = _useSelector.loadedBefore,
        loading = _useSelector.loading,
        items = _useSelector.items,
        hasError = _useSelector.hasError,
        paging = _useSelector.paging,
        pagingSearch = _useSelector.pagingSearch,
        searchTerm = _useSelector.searchTerm,
        total = _useSelector.total,
        dwhType = _useSelector.dwhType,
        membersCount = _useSelector.membersCount,
        listType = _useSelector.listType,
        languages = _useSelector.languages,
        joinResult = _useSelector.joinResult,
        loadingSettings = _useSelector.loadingSettings;

    var _useSelector2 = (0, _reactRedux.useSelector)(function (state) {
        return state.clanInvites;
    }),
        clanInvitesTotal = _useSelector2.total;

    var cooldownTill = joinResult.cooldownTill;

    var log = (0, _hooks.useMetricsLog)(_logConstants.FEATURE);
    var isSearch = searchTerm !== null;
    var activePaging = isSearch ? pagingSearch : paging;

    var _useState = (0, _react.useState)(false),
        _useState2 = _slicedToArray(_useState, 2),
        isFiltersOpened = _useState2[0],
        setIsFiltersOpened = _useState2[1];

    var _useState3 = (0, _react.useState)(false),
        _useState4 = _slicedToArray(_useState3, 2),
        isPageChanging = _useState4[0],
        setIsPageChanging = _useState4[1];

    var _useState5 = (0, _react.useState)([]),
        _useState6 = _slicedToArray(_useState5, 2),
        visibleItems = _useState6[0],
        setVisibleItems = _useState6[1];

    var _useState7 = (0, _react.useState)(false),
        _useState8 = _slicedToArray(_useState7, 2),
        isFilterEnabled = _useState8[0],
        setIsFilerEnabled = _useState8[1];

    (0, _react.useLayoutEffect)(function () {
        if (!loadedBefore && !loadingSettings) {
            dispatch((0, _recommended_clans.fetchRecommendedClansWithSettings)());
        }
    }, [loadedBefore, loadingSettings]);

    (0, _react.useLayoutEffect)(function () {
        setVisibleItems([].concat(_toConsumableArray(items)).splice(activePaging.current * _recommended_clans2.ITEMS_PER_PAGE, _recommended_clans2.ITEMS_PER_PAGE));

        setIsPageChanging(true);
        var timerId = setTimeout(function () {
            setIsPageChanging(false);
        }, 100);
        setIsFilerEnabled(false);

        return function () {
            return clearTimeout(timerId);
        };
    }, [items, activePaging]);

    var toggleFiltersPopup = (0, _react.useCallback)(function (isFiltersApplied) {
        handleFiltersPopup();
        setIsFiltersOpened(!isFiltersOpened);

        setIsFilerEnabled(isFiltersApplied === true);
    }, [isFiltersOpened]);

    var handleSetSearchTerm = (0, _react.useCallback)(function (searchTerm) {
        dispatch((0, _recommended_clans.setSearchTerm)(searchTerm));
        dispatch((0, _recommended_clans.fetchRecommendedClans)());
    }, []);

    var handleSelectNextPage = (0, _react.useCallback)(function () {
        dispatch((0, _recommended_clans.selectNextPage)());
        handlePaginationClick(_logConstants.Items.PaginationRightButton);
    }, []);

    var handleSelectPrevPage = (0, _react.useCallback)(function () {
        dispatch((0, _recommended_clans.selectPrevPage)());
        handlePaginationClick(_logConstants.Items.PaginationLeftButton);
    }, []);

    var handleButtonClick = (0, _react.useCallback)(function (item) {
        log({
            action: _logConstants.Actions.Click,
            item: item,
            parentScreen: _logConstants.Items.Hangar,
            partnerID: partnerID
        });
    }, [log]);

    var handleInvitationsClick = function handleInvitationsClick() {
        handleButtonClick(_logConstants.Items.ClanInvitationsButton);
        dispatch((0, _app.openInvitations)());
        dispatch((0, _clan_invites.clanInvitesChecked)());
    };

    var handleFiltersPopup = (0, _react.useCallback)(function () {
        log({
            action: isFiltersOpened ? _logConstants.Actions.Close : _logConstants.Actions.Open,
            item: _logConstants.Items.FiltersSettingsWindow,
            parentScreen: _logConstants.Items.LandingClans,
            partnerID: partnerID
        });
    }, [log]);

    var handlePaginationClick = (0, _react.useCallback)(function (item) {
        log({
            action: _logConstants.Actions.Click,
            item: item,
            parentScreen: _logConstants.Items.LandingClans,
            partnerID: partnerID
        });
    }, [log]);

    if (hasError) {
        return _react2.default.createElement(
            'div',
            { className: _LandingClans2.default.container },
            _react2.default.createElement(
                'div',
                { className: _LandingClans2.default.header },
                _react2.default.createElement(
                    'div',
                    { className: _LandingClans2.default.title },
                    _constants.LANDING_CLANS_HEADER
                )
            ),
            _react2.default.createElement(
                'div',
                { className: _LandingClans2.default.content },
                _react2.default.createElement(_reactWotBootstrap.EmptyList, {
                    title: _constants.LANDING_CLANS_ERROR_TITLE,
                    message: _constants.LANDING_CLANS_ERROR_MESSAGE,
                    buttonCaption: _constants.LANDING_CLANS_ERROR_BUTTON,
                    onButtonClick: function onButtonClick() {
                        return dispatch((0, _recommended_clans.fetchRecommendedClans)());
                    }
                })
            )
        );
    }

    return _react2.default.createElement(
        'div',
        { className: _LandingClans2.default.base },
        _react2.default.createElement(
            'div',
            { className: _LandingClans2.default.header },
            _react2.default.createElement(
                'div',
                { className: _LandingClans2.default.title },
                _constants.LANDING_CLANS_HEADER
            ),
            _react2.default.createElement(
                'div',
                { className: _LandingClans2.default.subtitle },
                !isSearch && cooldownTill === null && _constants.LANDING_CLANS_SUBTITLE,
                !isSearch && cooldownTill !== null && (0, _recommended_clans.formatCooldownError)(cooldownTill, true),
                isSearch && _constants.LANDING_CLANS_SUBTITLE_SEARCH
            )
        ),
        _react2.default.createElement(
            'div',
            { className: _LandingClans2.default.filters },
            _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    _ButtonSimple2.default,
                    {
                        className: _LandingClans2.default.button,
                        tooltipId: 'goto_invitations_tooltip_clans',
                        isContrast: true,
                        onClick: handleInvitationsClick,
                        messages: clanInvitesTotal
                    },
                    _translations.LANDING_GOTO_INVITATIONS
                ),
                _react2.default.createElement(
                    _reactWotBootstrap.Tooltip,
                    { id: 'goto_invitations_tooltip_clans' },
                    _translations.LANDING_GOTO_INVITATIONS_TOOLTIP
                )
            ),
            _react2.default.createElement(
                'div',
                { className: _LandingClans2.default.filtersItem },
                isSearch ? _react2.default.createElement(_SearchResult2.default, { result: searchTerm }) : _react2.default.createElement(_FiltersButton2.default, { onClick: toggleFiltersPopup })
            ),
            _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_SearchControl2.default, {
                    setSearchTerm: handleSetSearchTerm,
                    partnerID: partnerID,
                    searchTerm: searchTerm
                })
            )
        ),
        _react2.default.createElement(
            'div',
            { className: _LandingClans2.default.content },
            _react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)(_LandingClans2.default.clans, isPageChanging && _LandingClans2.default.clans__blured) },
                loading && _react2.default.createElement(_reactWotBootstrap.Spinner, { caption: isFilterEnabled ? _constants.LANDING_CLANS_FILTER_SPINNER : _constants.LANDING_CLANS_SPINNER }),
                !loading && _react2.default.createElement(
                    _react.Fragment,
                    null,
                    visibleItems.map(function (item, index) {
                        return _react2.default.createElement(_Card2.default, {
                            key: item.id,
                            clan: item,
                            partnerID: partnerID,
                            clanNumber: index,
                            dwhType: dwhType,
                            total: total,
                            membersCount: membersCount,
                            listType: listType,
                            languages: languages
                        });
                    }),
                    items.length === 0 && _react2.default.createElement(
                        'div',
                        { className: _LandingClans2.default.message },
                        isSearch ? _constants.LANDING_CLANS_EMPTY_SEARCH_MESSAGE : _constants.LANDING_CLANS_EMPTY_MESSAGE
                    )
                )
            )
        ),
        _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)(_LandingClans2.default.pagination, (loading || activePaging.total < 2) && _LandingClans2.default.pagination__invisible) },
            _react2.default.createElement(_Pagination2.default, {
                paging: activePaging,
                selectPrevPage: handleSelectPrevPage,
                selectNextPage: handleSelectNextPage
            })
        ),
        _react2.default.createElement(
            _reactWotBootstrap.Tooltip,
            { id: 'disabled-filters-tooltip' },
            _constants.LANDING_CLANS_DISABLED_FILTER_TOOLTIP
        ),
        _react2.default.createElement(
            'div',
            { className: _LandingClans2.default.back },
            _react2.default.createElement(
                _Back2.default,
                { handleClick: onLastSlideBackClick },
                _react2.default.createElement(
                    'span',
                    { className: _LandingClans2.default.backTitle },
                    _translations.LANDING_GOTO_BACK
                )
            )
        ),
        _react2.default.createElement(_Filters2.default, {
            isFull: dwhType !== null,
            isOpened: isFiltersOpened,
            onClose: toggleFiltersPopup,
            partnerID: partnerID
        })
    );
};

LandingClans.propTypes = {
    partnerID: _propTypes2.default.string.isRequired,
    onLastSlideBackClick: _propTypes2.default.func.isRequired
};

exports.default = LandingClans;

/***/ }),
/* 2250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Card = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactWotBootstrap = __webpack_require__(5);

var _Back = __webpack_require__(2251);

var _Back2 = _interopRequireDefault(_Back);

var _Front = __webpack_require__(2253);

var _Front2 = _interopRequireDefault(_Front);

var _EnterClan = __webpack_require__(2262);

var _EnterClan2 = _interopRequireDefault(_EnterClan);

var _hooks = __webpack_require__(164);

var _logConstants = __webpack_require__(165);

var _propTypes3 = __webpack_require__(236);

var _Card = __webpack_require__(2264);

var _Card2 = _interopRequireDefault(_Card);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Card = exports.Card = function Card(_ref) {
    var clan = _ref.clan,
        partnerID = _ref.partnerID,
        dwhType = _ref.dwhType,
        total = _ref.total,
        membersCount = _ref.membersCount,
        listType = _ref.listType,
        languages = _ref.languages,
        clanNumber = _ref.clanNumber;

    var log = (0, _hooks.useMetricsLog)(_logConstants.FEATURE);

    var _useMetricsLogTimeSpe = (0, _hooks.useMetricsLogTimeSpent)(_logConstants.FEATURE),
        _useMetricsLogTimeSpe2 = _slicedToArray(_useMetricsLogTimeSpe, 2),
        start = _useMetricsLogTimeSpe2[0],
        stop = _useMetricsLogTimeSpe2[1];

    var handleMouseEnter = (0, _react.useCallback)(function () {
        start(_logConstants.Actions.Hover);
        (0, _reactWotBootstrap.sendHoverSoundCommand)();
    }, [start]);

    var handleMouseLeave = (0, _react.useCallback)(function () {
        stop({
            action: _logConstants.Actions.Hover,
            item: _logConstants.Items.ClanInfoCard,
            timeLimit: 1.0,
            parentScreen: _logConstants.Items.LandingClans,
            partnerID: partnerID,
            info: JSON.stringify({
                type: dwhType,
                total: total,
                membersCount: membersCount,
                gameLevel: listType,
                languages: languages,
                clanNumber: clanNumber,
                clanId: clan.id
            })
        });
    }, [stop]);
    var handleButtonClick = (0, _react.useCallback)(function () {
        log({
            action: _logConstants.Actions.Click,
            item: _logConstants.Items.JoinClanButton,
            parentScreen: _logConstants.Items.LandingClans,
            partnerID: partnerID,
            info: JSON.stringify({
                type: dwhType,
                total: total,
                membersCount: membersCount,
                gameLevel: listType,
                languages: languages,
                clanNumber: clanNumber,
                clanId: clan.id
            })
        });
    }, [log]);
    var dwhClanReservesScore = clan.dwhClanReservesScore,
        dwhSquadScore = clan.dwhSquadScore,
        dwhGlobalMapScore = clan.dwhGlobalMapScore,
        dwhStrongholdScore = clan.dwhStrongholdScore,
        description = clan.description;

    var isSimple = [dwhClanReservesScore, dwhSquadScore, dwhGlobalMapScore, dwhStrongholdScore].includes(undefined);

    return _react2.default.createElement(
        'div',
        { className: _Card2.default.base, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave },
        _react2.default.createElement(
            'div',
            { className: _Card2.default.flipWrapper },
            _react2.default.createElement(
                'div',
                { className: _Card2.default.front },
                _react2.default.createElement(_Front2.default, { clan: clan, isSimple: isSimple })
            ),
            _react2.default.createElement(
                'div',
                { className: _Card2.default.back },
                _react2.default.createElement(
                    _Back2.default,
                    { description: description, clanNumber: clanNumber, clan: clan },
                    _react2.default.createElement(_EnterClan2.default, { onClickButton: handleButtonClick, clan: clan })
                )
            )
        )
    );
};

Card.propTypes = {
    clan: _propTypes3.RecommendedClanPropTypes,
    partnerID: _propTypes2.default.string.isRequired,
    dwhType: _propTypes2.default.string,
    total: _propTypes2.default.number,
    membersCount: _propTypes2.default.number,
    listType: _propTypes2.default.string,
    languages: _propTypes2.default.array,
    clanNumber: _propTypes2.default.number
};

exports.default = Card;

/***/ }),
/* 2251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Back = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactWotBootstrap = __webpack_require__(5);

var _sounds = __webpack_require__(177);

var _sounds2 = _interopRequireDefault(_sounds);

var _constants = __webpack_require__(90);

var _propTypes3 = __webpack_require__(236);

var _web_to_client = __webpack_require__(12);

var _Back = __webpack_require__(2252);

var _Back2 = _interopRequireDefault(_Back);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Back = exports.Back = function Back(_ref) {
    var description = _ref.description,
        children = _ref.children,
        clanNumber = _ref.clanNumber,
        clan = _ref.clan;

    var _useState = (0, _react.useState)(false),
        _useState2 = _slicedToArray(_useState, 2),
        isShadowVisible = _useState2[0],
        setIsShadowVisible = _useState2[1];

    var _useState3 = (0, _react.useState)(0),
        _useState4 = _slicedToArray(_useState3, 2),
        scrollHeight = _useState4[0],
        setScrollHeight = _useState4[1];

    var scrollAreaRef = (0, _react.useRef)(null);

    var onChangeScrollView = function onChangeScrollView(isScrollbarVisible) {
        if (isScrollbarVisible === isShadowVisible) return;
        setIsShadowVisible(isScrollbarVisible);
    };

    (0, _react.useEffect)(function () {
        var setScrollableAreaHeight = function setScrollableAreaHeight() {
            if (!scrollAreaRef.current) return;
            setScrollHeight(scrollAreaRef.current.clientHeight);
        };

        setScrollableAreaHeight();

        window.addEventListener('resize', setScrollableAreaHeight);

        return function () {
            window.removeEventListener('resize', setScrollableAreaHeight);
        };
    }, []);

    return _react2.default.createElement(
        'div',
        { className: _Back2.default.base },
        _react2.default.createElement(
            'div',
            { className: _Back2.default.header },
            _react2.default.createElement(
                'span',
                { className: _Back2.default.title },
                _constants.LANDING_CLANS_DESCRITION
            ),
            _react2.default.createElement(
                _reactWotBootstrap.Button,
                {
                    type: 'secondary',
                    mixClassName: _Back2.default.clanButton,
                    tooltipId: 'clan_profile_' + clanNumber,
                    onClick: function onClick() {
                        (0, _web_to_client.openClanCard)({ id: clan.id, tag: clan.tag });
                    },
                    buttonClickSoundId: _sounds2.default.CLICK
                },
                _react2.default.createElement('img', { className: _Back2.default.clanButtonImage, src: __webpack_require__(1358), alt: '' })
            ),
            _react2.default.createElement(
                _reactWotBootstrap.Tooltip,
                { id: 'clan_profile_' + clanNumber },
                _constants.LANDING_CLANS_PROFILE_TOOLTIP
            )
        ),
        description ? _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)(_Back2.default.scroll, isShadowVisible && _Back2.default.scroll__shadows), ref: scrollAreaRef },
            _react2.default.createElement(
                _reactWotBootstrap.ScrollArea,
                { scrollableAreaHeight: scrollHeight, onChangeScrollView: onChangeScrollView },
                _react2.default.createElement('div', { className: _Back2.default.description, dangerouslySetInnerHTML: { __html: description } })
            )
        ) : _react2.default.createElement(
            'div',
            { className: _Back2.default.noDescription },
            _constants.LANDING_CLANS_NO_DESCRITION
        ),
        children
    );
};

Back.propTypes = {
    clan: _propTypes3.RecommendedClanPropTypes,
    description: _propTypes2.default.string,
    clanNumber: _propTypes2.default.number
};

exports.default = Back;

/***/ }),
/* 2252 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Back_base--KGDDq","header":"Back_header--1iTDX","scroll":"Back_scroll--QNMhr","scroll__shadows":"Back_scroll__shadows--1kWir","scrollShadows":"Back_scroll__shadows--1kWir","footer":"Back_footer--1VttH","description":"Back_description--2Loc9","noDescription":"Back_noDescription--3g_v7","title":"Back_title--39ocR","clanButton":"Back_clanButton--3LJWq","clanButtonImage":"Back_clanButtonImage--2gJ_t"};

/***/ }),
/* 2253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _Clan = __webpack_require__(2254);

var _Clan2 = _interopRequireDefault(_Clan);

var _Suitability = __webpack_require__(2256);

var _Suitability2 = _interopRequireDefault(_Suitability);

var _Flag = __webpack_require__(1359);

var _Flag2 = _interopRequireDefault(_Flag);

var _Stat = __webpack_require__(2259);

var _Stat2 = _interopRequireDefault(_Stat);

var _constants = __webpack_require__(90);

var _propTypes3 = __webpack_require__(236);

var _Front = __webpack_require__(2261);

var _Front2 = _interopRequireDefault(_Front);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var META_ORDER = [_Stat.STAT_TYPES.victories, _Stat.STAT_TYPES.players, _Stat.STAT_TYPES.battles];
var SIMPLIFIED_META_ORDER = [_Stat.STAT_TYPES.players, _Stat.STAT_TYPES.level, _Stat.STAT_TYPES.victories, _Stat.STAT_TYPES.battles];

var Front = function Front(_ref) {
    var _STAT_TYPES_MAP;

    var clan = _ref.clan,
        isSimple = _ref.isSimple;
    var languages = clan.languages,
        tag = clan.tag,
        name = clan.name,
        color = clan.color,
        emblems = clan.emblems,
        dwhClanReservesScore = clan.dwhClanReservesScore,
        dwhSquadScore = clan.dwhSquadScore,
        dwhStrongholdScore = clan.dwhStrongholdScore,
        dwhGlobalMapScore = clan.dwhGlobalMapScore,
        winRate = clan.winRate,
        battlesCount = clan.battlesCount,
        membersCount = clan.membersCount,
        strongholdLevel = clan.strongholdLevel;


    var STAT_TYPES_MAP = (_STAT_TYPES_MAP = {}, _defineProperty(_STAT_TYPES_MAP, _Stat.STAT_TYPES.players, { number: membersCount, title: _constants.LANDING_CLANS_STAT_PLAYERS }), _defineProperty(_STAT_TYPES_MAP, _Stat.STAT_TYPES.level, { number: strongholdLevel, title: _constants.LANDING_CLANS_STAT_LEVEL }), _defineProperty(_STAT_TYPES_MAP, _Stat.STAT_TYPES.victories, { number: winRate, title: _constants.LANDING_CLANS_STAT_VICTORIES }), _defineProperty(_STAT_TYPES_MAP, _Stat.STAT_TYPES.battles, { number: battlesCount, title: _constants.LANDING_CLANS_STAT_BATTLES }), _STAT_TYPES_MAP);

    var META_BLOCKS = isSimple ? SIMPLIFIED_META_ORDER : META_ORDER;

    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_Front2.default.base, isSimple && _Front2.default.base__simple) },
        _react2.default.createElement(
            'div',
            { className: _Front2.default.corners },
            _react2.default.createElement('div', { className: (0, _classnames2.default)(_Front2.default.corner, _Front2.default.corner__topLeft) }),
            _react2.default.createElement('div', { className: (0, _classnames2.default)(_Front2.default.corner, _Front2.default.corner__topRight) }),
            _react2.default.createElement('div', { className: (0, _classnames2.default)(_Front2.default.corner, _Front2.default.corner__bottomRight) }),
            _react2.default.createElement('div', { className: (0, _classnames2.default)(_Front2.default.corner, _Front2.default.corner__bottomLeft) })
        ),
        _react2.default.createElement(
            'div',
            { className: _Front2.default.languages },
            languages.map(function (lang) {
                return _react2.default.createElement(_Flag2.default, { code: lang, key: lang });
            })
        ),
        _react2.default.createElement(_Clan2.default, {
            tag: tag,
            name: name,
            color: color,
            emblem: emblems['195x195']
        }),
        _react2.default.createElement(
            'div',
            { className: _Front2.default.meta },
            META_BLOCKS.map(function (statType) {
                var _STAT_TYPES_MAP$statT = STAT_TYPES_MAP[statType],
                    number = _STAT_TYPES_MAP$statT.number,
                    title = _STAT_TYPES_MAP$statT.title;


                return _react2.default.createElement(_Stat2.default, {
                    key: statType,
                    className: _Front2.default.metaItem,
                    type: statType,
                    number: number,
                    title: title
                });
            })
        ),
        !isSimple && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_Suitability2.default, { title: _constants.LANDING_CLANS_STAT_PLATOONS, level: dwhSquadScore }),
            _react2.default.createElement(_Suitability2.default, {
                title: _constants.LANDING_CLANS_STAT_STRONGHOLDS,
                level: dwhStrongholdScore,
                strongholdLevel: strongholdLevel
            }),
            _react2.default.createElement(_Suitability2.default, { title: _constants.LANDING_CLANS_STAT_GLOBAL_MAP, level: dwhGlobalMapScore }),
            _react2.default.createElement(_Suitability2.default, { title: _constants.LANDING_CLANS_STAT_RESERVES, level: dwhClanReservesScore })
        )
    );
};

Front.propTypes = {
    clan: _propTypes3.RecommendedClanPropTypes,
    isSimple: _propTypes2.default.bool
};

exports.default = Front;

/***/ }),
/* 2254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _Clan = __webpack_require__(2255);

var _Clan2 = _interopRequireDefault(_Clan);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Clan = function Clan(props) {
    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_Clan2.default.base, props.className) },
        _react2.default.createElement('img', { className: _Clan2.default.emblem, src: props.emblem }),
        _react2.default.createElement(
            'div',
            { className: _Clan2.default.tagName, style: { color: props.color } },
            '[' + props.tag + ']'
        ),
        _react2.default.createElement(
            'div',
            { className: _Clan2.default.clanName },
            props.name
        )
    );
};

Clan.propTypes = {
    tag: _propTypes2.default.string.isRequired,
    name: _propTypes2.default.string.isRequired,
    color: _propTypes2.default.string,
    emblem: _propTypes2.default.string.isRequired,
    className: _propTypes2.default.string
};

exports.default = Clan;

/***/ }),
/* 2255 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Clan_base--34T2l","emblem":"Clan_emblem--NoGNt","tagName":"Clan_tagName--1nrz2","clanName":"Clan_clanName--245Iu"};

/***/ }),
/* 2256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _helpers = __webpack_require__(11);

var _Suitability = __webpack_require__(2257);

var _Suitability2 = _interopRequireDefault(_Suitability);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LEVEL_ARRAY = new Array(5).fill(null);

var Suitability = function Suitability(_ref) {
    var title = _ref.title,
        level = _ref.level,
        strongholdLevel = _ref.strongholdLevel;

    return _react2.default.createElement(
        'div',
        { className: _Suitability2.default.base },
        _react2.default.createElement(
            'div',
            { className: _Suitability2.default.titleContainer },
            title,
            strongholdLevel && _react2.default.createElement(
                'span',
                { className: _Suitability2.default.strongholdLevel },
                (0, _helpers.toRoman)(strongholdLevel)
            )
        ),
        _react2.default.createElement(
            'div',
            { className: _Suitability2.default.levels },
            LEVEL_ARRAY.map(function (_, index) {
                return _react2.default.createElement('div', { className: (0, _classnames2.default)(_Suitability2.default.level, index < level && _Suitability2.default.level__active), key: index });
            })
        )
    );
};

Suitability.propTypes = {
    title: _propTypes2.default.object.isRequired,
    level: _propTypes2.default.number.isRequired,
    strongholdLevel: _propTypes2.default.number
};

exports.default = Suitability;

/***/ }),
/* 2257 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Suitability_base--2htgN","levels":"Suitability_levels--3Q6ek","titleContainer":"Suitability_titleContainer--1I9Pd","strongholdLevel":"Suitability_strongholdLevel--wqPnP","level":"Suitability_level--iWKOe","level__active":"Suitability_level__active--1Q3r3","levelActive":"Suitability_level__active--1Q3r3"};

/***/ }),
/* 2258 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Flag_base--1uCJ9","base__sq":"Flag_base__sq--18Dg-","baseSq":"Flag_base__sq--18Dg-","base__hy":"Flag_base__hy--Tqxh4","baseHy":"Flag_base__hy--Tqxh4","base__az":"Flag_base__az--3m3ht","baseAz":"Flag_base__az--3m3ht","base__be":"Flag_base__be--3bV9f","baseBe":"Flag_base__be--3bV9f","base__bs":"Flag_base__bs--2eGlg","baseBs":"Flag_base__bs--2eGlg","base__bg":"Flag_base__bg--3bqXv","baseBg":"Flag_base__bg--3bqXv","base__zh":"Flag_base__zh--1Dyd1","baseZh":"Flag_base__zh--1Dyd1","base__zh_TW":"Flag_base__zh_TW--QkFT1","baseZhTw":"Flag_base__zh_TW--QkFT1","base__hr":"Flag_base__hr--3IMQD","baseHr":"Flag_base__hr--3IMQD","base__cs":"Flag_base__cs--3L7QU","baseCs":"Flag_base__cs--3L7QU","base__da":"Flag_base__da--bZmgN","baseDa":"Flag_base__da--bZmgN","base__nl":"Flag_base__nl--1Y0hJ","baseNl":"Flag_base__nl--1Y0hJ","base__en":"Flag_base__en--UWkfV","baseEn":"Flag_base__en--UWkfV","base__et":"Flag_base__et--EJXhY","baseEt":"Flag_base__et--EJXhY","base__fi":"Flag_base__fi--_Qg8t","baseFi":"Flag_base__fi--_Qg8t","base__fr":"Flag_base__fr--1Zh1-","baseFr":"Flag_base__fr--1Zh1-","base__ka":"Flag_base__ka--2z_2g","baseKa":"Flag_base__ka--2z_2g","base__de":"Flag_base__de--_dXUP","baseDe":"Flag_base__de--_dXUP","base__el":"Flag_base__el--2E6qa","baseEl":"Flag_base__el--2E6qa","base__hu":"Flag_base__hu--10ZBt","baseHu":"Flag_base__hu--10ZBt","base__it":"Flag_base__it--Rxs7G","baseIt":"Flag_base__it--Rxs7G","base__ja":"Flag_base__ja--1CEvX","baseJa":"Flag_base__ja--1CEvX","base__kk":"Flag_base__kk--ZOhuh","baseKk":"Flag_base__kk--ZOhuh","base__ko":"Flag_base__ko--iFYkv","baseKo":"Flag_base__ko--iFYkv","base__ky":"Flag_base__ky--3OGMx","baseKy":"Flag_base__ky--3OGMx","base__lv":"Flag_base__lv--HGSBE","baseLv":"Flag_base__lv--HGSBE","base__lt":"Flag_base__lt--23Ybv","baseLt":"Flag_base__lt--23Ybv","base__mo":"Flag_base__mo--2Cfbi","baseMo":"Flag_base__mo--2Cfbi","base__no":"Flag_base__no--13vYc","baseNo":"Flag_base__no--13vYc","base__fil":"Flag_base__fil--1gF8S","baseFil":"Flag_base__fil--1gF8S","base__pl":"Flag_base__pl--3Nz_n","basePl":"Flag_base__pl--3Nz_n","base__pt":"Flag_base__pt--1qH1N","basePt":"Flag_base__pt--1qH1N","base__ro":"Flag_base__ro--QN8mL","baseRo":"Flag_base__ro--QN8mL","base__ru":"Flag_base__ru--1NcF1","baseRu":"Flag_base__ru--1NcF1","base__sr":"Flag_base__sr--3OyA8","baseSr":"Flag_base__sr--3OyA8","base__sk":"Flag_base__sk--3CoZV","baseSk":"Flag_base__sk--3CoZV","base__es":"Flag_base__es--Popqq","baseEs":"Flag_base__es--Popqq","base__sv":"Flag_base__sv--1YKR4","baseSv":"Flag_base__sv--1YKR4","base__tg":"Flag_base__tg---NH6z","baseTg":"Flag_base__tg---NH6z","base__th":"Flag_base__th--2iHfh","baseTh":"Flag_base__th--2iHfh","base__tr":"Flag_base__tr--10s6X","baseTr":"Flag_base__tr--10s6X","base__tk":"Flag_base__tk--2RxdT","baseTk":"Flag_base__tk--2RxdT","base__uk":"Flag_base__uk--2YvqB","baseUk":"Flag_base__uk--2YvqB","base__us":"Flag_base__us--1cmJU","baseUs":"Flag_base__us--1cmJU","base__uz":"Flag_base__uz--1pkkZ","baseUz":"Flag_base__uz--1pkkZ","base__vi":"Flag_base__vi--1UUHV","baseVi":"Flag_base__vi--1UUHV","base__id":"Flag_base__id--lTI8O","baseId":"Flag_base__id--lTI8O","base__ms":"Flag_base__ms--3piRk","baseMs":"Flag_base__ms--3piRk","base__zh_CN":"Flag_base__zh_CN--1UMEy","baseZhCn":"Flag_base__zh_CN--1UMEy"};

/***/ }),
/* 2259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.STAT_TYPES = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Stat = __webpack_require__(2260);

var _Stat2 = _interopRequireDefault(_Stat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var STAT_TYPES = exports.STAT_TYPES = {
    battles: 'battles',
    level: 'level',
    players: 'players',
    victories: 'victories'
};
var getValue = function getValue(type, number) {
    if (!number) return _react2.default.createElement(
        'span',
        null,
        '\u2014'
    );

    return type === STAT_TYPES.victories ? number + '%' : number;
};

var Stat = function Stat(_ref) {
    var title = _ref.title,
        number = _ref.number,
        type = _ref.type,
        className = _ref.className;
    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_Stat2.default.base, className) },
        _react2.default.createElement('div', { className: (0, _classnames2.default)(_Stat2.default.icon, _Stat2.default['icon__' + type]) }),
        _react2.default.createElement(
            'span',
            { className: _Stat2.default.value },
            getValue(type, number)
        ),
        _react2.default.createElement(
            'span',
            { className: _Stat2.default.title },
            title
        )
    );
};

Stat.propTypes = {
    title: _propTypes2.default.object.isRequired,
    type: _propTypes2.default.string.isRequired,
    number: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    className: _propTypes2.default.string
};

exports.default = Stat;

/***/ }),
/* 2260 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Stat_base--2p5kD","icon":"Stat_icon--2k5Jy","icon__battles":"Stat_icon__battles--2BUn3","iconBattles":"Stat_icon__battles--2BUn3","icon__level":"Stat_icon__level--141hy","iconLevel":"Stat_icon__level--141hy","icon__players":"Stat_icon__players--jzanx","iconPlayers":"Stat_icon__players--jzanx","icon__victories":"Stat_icon__victories--8QOp7","iconVictories":"Stat_icon__victories--8QOp7","value":"Stat_value--wC4Hn","title":"Stat_title--28uwM"};

/***/ }),
/* 2261 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Front_base--jwRD3","base__simple":"Front_base__simple--1JAhb","baseSimple":"Front_base__simple--1JAhb","corners":"Front_corners--26tjO","corner":"Front_corner--2wYd3","corner__topLeft":"Front_corner__topLeft--1WqWq","cornerTopLeft":"Front_corner__topLeft--1WqWq","corner__topRight":"Front_corner__topRight--3WlSO","cornerTopRight":"Front_corner__topRight--3WlSO","corner__bottomLeft":"Front_corner__bottomLeft--2l6W3","cornerBottomLeft":"Front_corner__bottomLeft--2l6W3","corner__bottomRight":"Front_corner__bottomRight--EHPnq","cornerBottomRight":"Front_corner__bottomRight--EHPnq","languages":"Front_languages--AjNjA","meta":"Front_meta--2vi1y","metaItem":"Front_metaItem--1NwXf"};

/***/ }),
/* 2262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EnterClan = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactWotBootstrap = __webpack_require__(5);

var _reactRedux = __webpack_require__(7);

var _recommended_clans = __webpack_require__(159);

var _constants = __webpack_require__(90);

var _propTypes3 = __webpack_require__(236);

var _EnterClan = __webpack_require__(2263);

var _EnterClan2 = _interopRequireDefault(_EnterClan);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EnterClan = exports.EnterClan = function EnterClan(_ref) {
    var onClickButton = _ref.onClickButton,
        clan = _ref.clan;

    var _useState = (0, _react.useState)(false),
        _useState2 = _slicedToArray(_useState, 2),
        isButtonClicked = _useState2[0],
        setIsButtonClicked = _useState2[1];

    var inviteId = clan.inviteId,
        isClanAcceptableForAutoJoining = clan.isClanAcceptableForAutoJoining,
        id = clan.id;

    var dispatch = (0, _reactRedux.useDispatch)();

    var _useSelector = (0, _reactRedux.useSelector)(function (state) {
        return state.recommendedClans.joinResult;
    }),
        loading = _useSelector.loading,
        errors = _useSelector.errors,
        applied = _useSelector.applied,
        cooldownTill = _useSelector.cooldownTill;

    var cooldownError = Object.values(errors).includes(43);

    var tooltipError = _constants.TOOLTIP_BY_ERROR_CODE[errors[id]];
    if (cooldownError) {
        tooltipError = (0, _recommended_clans.formatCooldownError)(cooldownTill);
    }

    var isDisabled = loading || tooltipError !== undefined || cooldownError;
    var isApplied = applied.includes(id);

    (0, _react.useEffect)(function () {
        if (isButtonClicked && !loading) {
            setIsButtonClicked(false);
        }
    }, [isButtonClicked, loading]);

    var handleButtonClick = function handleButtonClick() {
        if (isDisabled) {
            return;
        }

        dispatch((0, _recommended_clans.enterClan)(clan));
        setIsButtonClicked(true);
        onClickButton();
    };

    return _react2.default.createElement(
        'div',
        { className: _EnterClan2.default.base },
        isApplied ? _react2.default.createElement(
            'span',
            { className: _EnterClan2.default.applied },
            _constants.LANDING_CLANS_APPLIED
        ) : _react2.default.createElement(
            _reactWotBootstrap.Button,
            {
                type: 'primary',
                isDisabled: isDisabled && !isButtonClicked,
                onClick: handleButtonClick,
                tooltipId: 'button-card-tooltip-' + id
            },
            _react2.default.createElement(
                'span',
                { className: (0, _classnames2.default)(_EnterClan2.default.button, loading && isButtonClicked && _EnterClan2.default.isLoading) },
                inviteId !== null || isClanAcceptableForAutoJoining ? _constants.JOIN_CLAN_BUTTON_TITLE : _constants.SEND_APPLY_BUTTON_TITLE
            )
        ),
        isDisabled && _react2.default.createElement(
            _reactWotBootstrap.Tooltip,
            { id: 'button-card-tooltip-' + id },
            tooltipError || _constants.LANDING_CLANS_WAITING
        )
    );
};

EnterClan.propTypes = {
    onClickButton: _propTypes2.default.func,
    clan: _propTypes3.RecommendedClanPropTypes
};

exports.default = EnterClan;

/***/ }),
/* 2263 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"EnterClan_base--1uHBM","applied":"EnterClan_applied--3_njB","button":"EnterClan_button--3DlI1","spin":"EnterClan_spin--2TL8J","isLoading":"EnterClan_isLoading--JAhQf"};

/***/ }),
/* 2264 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Card_base--3GwCH","flipWrapper":"Card_flipWrapper--3HhI4","flipBack":"Card_flipBack--ZHsDd","flip":"Card_flip--8TCYF","front":"Card_front--25Kj4","back":"Card_back--rtep8"};

/***/ }),
/* 2265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _locale = __webpack_require__(21);

var _hooks = __webpack_require__(164);

var _reactWotBootstrap = __webpack_require__(5);

var _constants = __webpack_require__(4);

var _constants2 = __webpack_require__(90);

var _logConstants = __webpack_require__(165);

var _translations = __webpack_require__(2266);

var _TextPlate = __webpack_require__(2267);

var _TextPlate2 = _interopRequireDefault(_TextPlate);

var _SearchControl = __webpack_require__(2269);

var _SearchControl2 = _interopRequireDefault(_SearchControl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var SearchControl = function SearchControl(_ref) {
    var setSearchTerm = _ref.setSearchTerm,
        partnerID = _ref.partnerID,
        searchTerm = _ref.searchTerm;

    var log = (0, _hooks.useMetricsLog)(_logConstants.FEATURE);
    var logSearch = (0, _react.useCallback)(function (item) {
        var info = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        log({
            action: _logConstants.Actions.Click,
            item: item,
            parentScreen: _logConstants.Items.LandingClans,
            partnerID: partnerID,
            info: info
        });
    }, [log]);

    var _useState = (0, _react.useState)(''),
        _useState2 = _slicedToArray(_useState, 2),
        inputValue = _useState2[0],
        setInputValue = _useState2[1];

    var _useState3 = (0, _react.useState)(false),
        _useState4 = _slicedToArray(_useState3, 2),
        isFocused = _useState4[0],
        setFocused = _useState4[1];

    var _useState5 = (0, _react.useState)(false),
        _useState6 = _slicedToArray(_useState5, 2),
        isEnterPressed = _useState6[0],
        setEnterPressed = _useState6[1];

    var hasInput = inputValue !== '';

    var valueWithoutSpaces = inputValue ? inputValue.trim() : '';

    var isEnoughLetters = [].concat(_toConsumableArray(valueWithoutSpaces)).length >= _constants2.SEARCH_INPUT_MIN_LENGTH;

    var handleChange = function handleChange(event) {
        setInputValue([].concat(_toConsumableArray(event.target.value)).slice(0, _constants2.SEARCH_INPUT_MAX_LENGTH).join(''));
        setEnterPressed(false);
    };

    var handleClearClick = function handleClearClick() {
        if (!hasInput && searchTerm === null) return;
        setInputValue('');
        setSearchTerm(null);
        logSearch(_logConstants.Items.ClearSearchTextField);
        (0, _reactWotBootstrap.sendCancelClickSoundCommand)();
    };

    var handleFocus = function handleFocus() {
        setFocused(true);
        logSearch(_logConstants.Items.FocusSearchTextField);
    };

    var handleBlur = function handleBlur() {
        setFocused(false);
    };

    var handleKeyUp = function handleKeyUp(e) {
        if (e.keyCode === _constants.KEY_CODES.ENTER && isEnoughLetters && !isEnterPressed) {
            setSearchTerm(inputValue);
            document.activeElement.blur();
            setEnterPressed(true);

            var info = JSON.stringify({
                type: 'search'
            });
            logSearch(_logConstants.Items.SubmitSearchTextField, info);
        }
    };

    return _react2.default.createElement(
        'div',
        { className: _SearchControl2.default.search },
        _react2.default.createElement(
            'div',
            { className: _SearchControl2.default.inputContainer },
            _react2.default.createElement('input', {
                type: 'text',
                className: _SearchControl2.default.input,
                value: inputValue,
                placeholder: isFocused ? undefined : (0, _locale.formatMessage)(_translations.SEARCH_CONTROL.placeholder),
                onChange: handleChange,
                onFocus: handleFocus,
                onBlur: handleBlur,
                onKeyUp: handleKeyUp
            }),
            _react2.default.createElement('div', { className: _SearchControl2.default.searchIcon }),
            _react2.default.createElement('button', {
                className: (0, _classnames2.default)(_SearchControl2.default.clear, hasInput && _SearchControl2.default.clear__visible),
                onClick: hasInput ? handleClearClick : undefined,
                onMouseEnter: hasInput ? _reactWotBootstrap.sendHoverSoundCommand : undefined
            }),
            isFocused && _react2.default.createElement(
                _TextPlate2.default,
                null,
                _react2.default.createElement(
                    _react.Fragment,
                    null,
                    [].concat(_toConsumableArray(valueWithoutSpaces)).length === 0 && _translations.SEARCH_CONTROL_EMPTY,
                    [].concat(_toConsumableArray(valueWithoutSpaces)).length === 1 && _translations.SEARCH_CONTROL_SINGLE_LETTER,
                    isEnoughLetters && _translations.SEARCH_CONTROL_ENTER
                )
            )
        )
    );
};

SearchControl.propTypes = {
    setSearchTerm: _propTypes2.default.func.isRequired,
    partnerID: _propTypes2.default.string.isRequired,
    searchTerm: _propTypes2.default.string
};

exports.default = SearchControl;

/***/ }),
/* 2266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SEARCH_CONTROL = exports.SEARCH_CONTROL_ENTER = exports.SEARCH_CONTROL_SINGLE_LETTER = exports.SEARCH_CONTROL_EMPTY = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SEARCH_CONTROL_EMPTY = exports.SEARCH_CONTROL_EMPTY = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'clan_landing.search_control.empty', defaultMessage: '\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u0438\u043B\u0438 \u0442\u0435\u0433 \u043A\u043B\u0430\u043D\u0430' });

var SEARCH_CONTROL_SINGLE_LETTER = exports.SEARCH_CONTROL_SINGLE_LETTER = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_landing.search_control.single_letter',
    defaultMessage: '\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u0435 \u043C\u0435\u043D\u0435\u0435 2 \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432 \u0434\u043B\u044F \u043F\u043E\u0438\u0441\u043A\u0430 \u043A\u043B\u0430\u043D\u0430'
});

var SEARCH_CONTROL_ENTER = exports.SEARCH_CONTROL_ENTER = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'clan_landing.search_control.enter', defaultMessage: '\u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u0415nter \u0434\u043B\u044F \u043F\u043E\u0438\u0441\u043A\u0430 \u043A\u043B\u0430\u043D\u0430' });

var SEARCH_CONTROL = exports.SEARCH_CONTROL = (0, _reactIntl.defineMessages)({
    placeholder: {
        'id': 'clan_landing.search_control.placeholder',
        'defaultMessage': '\u041F\u043E\u0438\u0441\u043A \u043A\u043B\u0430\u043D\u0430'
    }
});

/***/ }),
/* 2267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TextPlate = __webpack_require__(2268);

var _TextPlate2 = _interopRequireDefault(_TextPlate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextPlate = function TextPlate(_ref) {
    var children = _ref.children;

    return _react2.default.createElement(
        'div',
        { className: _TextPlate2.default.base },
        children
    );
};
TextPlate.propTypes = {
    children: _propTypes2.default.element
};

exports.default = TextPlate;

/***/ }),
/* 2268 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"TextPlate_base--2EsYi"};

/***/ }),
/* 2269 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"search":"SearchControl_search--2qAAV","inputContainer":"SearchControl_inputContainer--3E9VQ","label":"SearchControl_label--3jfUm","buttonSearch":"SearchControl_buttonSearch--1Xwlh","input":"SearchControl_input--eK6EC","searchIcon":"SearchControl_searchIcon--kGmtq","clear":"SearchControl_clear--3gox_","clear__visible":"SearchControl_clear__visible--1rrHg","clearVisible":"SearchControl_clear__visible--1rrHg"};

/***/ }),
/* 2270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Paginator = __webpack_require__(2271);

var _Paginator2 = _interopRequireDefault(_Paginator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Pagination = function Pagination(_ref) {
    var paging = _ref.paging,
        selectNextPage = _ref.selectNextPage,
        selectPrevPage = _ref.selectPrevPage,
        className = _ref.className;
    var current = paging.current,
        total = paging.total;


    return _react2.default.createElement(_Paginator2.default, {
        className: className,
        total: total,
        current: current + 1,
        onNextClick: selectNextPage,
        onPrevClick: selectPrevPage
    });
};

Pagination.propTypes = {
    paging: _propTypes2.default.shape({
        current: _propTypes2.default.number.isRequired,
        total: _propTypes2.default.number.isRequired
    }).isRequired,
    selectPrevPage: _propTypes2.default.func.isRequired,
    selectNextPage: _propTypes2.default.func.isRequired,
    className: _propTypes2.default.string
};

exports.default = Pagination;

/***/ }),
/* 2271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactWotBootstrap = __webpack_require__(5);

var _Paginator = __webpack_require__(2272);

var _Paginator2 = _interopRequireDefault(_Paginator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Paginator = function (_React$PureComponent) {
    _inherits(Paginator, _React$PureComponent);

    function Paginator(props) {
        _classCallCheck(this, Paginator);

        var _this = _possibleConstructorReturn(this, (Paginator.__proto__ || Object.getPrototypeOf(Paginator)).call(this, props));

        _this.handlePrevClick = _this.handlePrevClick.bind(_this);
        _this.handleNextClick = _this.handleNextClick.bind(_this);
        return _this;
    }

    _createClass(Paginator, [{
        key: 'handlePrevClick',
        value: function handlePrevClick() {
            this.props.onPrevClick();
        }
    }, {
        key: 'handleNextClick',
        value: function handleNextClick() {
            this.props.onNextClick();
        }
    }, {
        key: 'render',
        value: function render() {
            var classNamePrev = (0, _classnames2.default)(_Paginator2.default.control, _Paginator2.default['control__prev'], _defineProperty({}, _Paginator2.default.isDisabled, this.props.current <= 1));

            var classNameNext = (0, _classnames2.default)(_Paginator2.default.control, _Paginator2.default['control__next'], _defineProperty({}, _Paginator2.default.isDisabled, this.props.current >= this.props.total));

            var prevDataAttrs = this.props.prevTooltipId ? {
                'data-tip': true,
                'data-for': this.props.prevTooltipId
            } : {};

            var nextDataAttrs = this.props.nextTooltipId ? {
                'data-tip': true,
                'data-for': this.props.nextTooltipId
            } : {};

            var isPrevEnabled = this.props.current > 1;
            var isNextEnabled = this.props.current < this.props.total;
            return _react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)(_Paginator2.default.base, this.props.className) },
                _react2.default.createElement('span', _extends({}, prevDataAttrs, {
                    className: classNamePrev,
                    onClick: isPrevEnabled ? this.handlePrevClick : null,
                    onMouseDown: isPrevEnabled ? _reactWotBootstrap.sendSelectClickSoundCommand : null,
                    onMouseEnter: isPrevEnabled ? _reactWotBootstrap.sendHoverSoundCommand : null,
                    tabIndex: '-1'
                })),
                _react2.default.createElement(
                    'span',
                    { className: _Paginator2.default.current },
                    this.props.current
                ),
                _react2.default.createElement(
                    'span',
                    { className: _Paginator2.default.divider },
                    '/'
                ),
                _react2.default.createElement(
                    'span',
                    { className: _Paginator2.default.total },
                    this.props.total
                ),
                _react2.default.createElement('span', _extends({}, nextDataAttrs, {
                    className: classNameNext,
                    onClick: isNextEnabled ? this.handleNextClick : null,
                    onMouseDown: isNextEnabled ? _reactWotBootstrap.sendSelectClickSoundCommand : null,
                    onMouseEnter: isNextEnabled ? _reactWotBootstrap.sendHoverSoundCommand : null,
                    tabIndex: '-1'
                }))
            );
        }
    }]);

    return Paginator;
}(_react2.default.PureComponent);

Paginator.propTypes = {
    total: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
    current: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
    onPrevClick: _propTypes2.default.func.isRequired,
    onNextClick: _propTypes2.default.func.isRequired,
    prevTooltipId: _propTypes2.default.string,
    nextTooltipId: _propTypes2.default.string,
    className: _propTypes2.default.string
};

exports.default = Paginator;

/***/ }),
/* 2272 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Paginator_base--3JdXf","control":"Paginator_control--206Oo","isDisabled":"Paginator_isDisabled--KyXcL","control__prev":"Paginator_control__prev--jsk7_","controlPrev":"Paginator_control__prev--jsk7_","control__next":"Paginator_control__next--1SWEU","controlNext":"Paginator_control__next--1SWEU","current":"Paginator_current--3Xut3","divider":"Paginator_divider--36nXv","total":"Paginator_total--nOshA"};

/***/ }),
/* 2273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactWotBootstrap = __webpack_require__(5);

var _constants = __webpack_require__(90);

var _FiltersButton = __webpack_require__(2274);

var _FiltersButton2 = _interopRequireDefault(_FiltersButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FiltersButton = function FiltersButton(_ref) {
    var onClick = _ref.onClick;

    var handleClick = function handleClick() {
        (0, _reactWotBootstrap.sendClickSoundCommand)();
        onClick();
    };

    return _react2.default.createElement(
        'div',
        { className: _FiltersButton2.default.base, onClick: handleClick, onMouseEnter: _reactWotBootstrap.sendHoverSoundCommand },
        _react2.default.createElement('span', { className: _FiltersButton2.default.icon }),
        _constants.FILTERS_BUTTON
    );
};

FiltersButton.propTypes = {
    onClick: _propTypes2.default.func
};

exports.default = FiltersButton;

/***/ }),
/* 2274 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"FiltersButton_base--2Uibl","icon":"FiltersButton_icon--1weZp"};

/***/ }),
/* 2275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _constants = __webpack_require__(90);

var _SearchResult = __webpack_require__(2276);

var _SearchResult2 = _interopRequireDefault(_SearchResult);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchResult = function SearchResult(_ref) {
    var result = _ref.result;

    if (!result) {
        return null;
    }

    return _react2.default.createElement(
        'div',
        { className: _SearchResult2.default.base },
        _react2.default.createElement(
            'span',
            { className: _SearchResult2.default.description },
            _constants.SEARCH_CONTROL_RESULT
        ),
        _react2.default.createElement(
            'span',
            { className: _SearchResult2.default.name },
            result.trim()
        )
    );
};

SearchResult.propTypes = {
    result: _propTypes2.default.string
};

exports.default = SearchResult;

/***/ }),
/* 2276 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"SearchResult_base--2F11-","description":"SearchResult_description--2jgGt","name":"SearchResult_name--1v8kf"};

/***/ }),
/* 2277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = __webpack_require__(7);

var _reactWotBootstrap = __webpack_require__(5);

var _sounds = __webpack_require__(177);

var _sounds2 = _interopRequireDefault(_sounds);

var _Back = __webpack_require__(70);

var _useCallbackOnEsc = __webpack_require__(1352);

var _Language = __webpack_require__(2278);

var _Language2 = _interopRequireDefault(_Language);

var _Levels = __webpack_require__(2280);

var _Levels2 = _interopRequireDefault(_Levels);

var _hooks = __webpack_require__(164);

var _logConstants = __webpack_require__(165);

var _recommended_clans = __webpack_require__(983);

var _recommended_clans2 = __webpack_require__(159);

var _constants = __webpack_require__(279);

var _Filters = __webpack_require__(2282);

var _Filters2 = _interopRequireDefault(_Filters);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var Filters = function Filters(_ref) {
    var isFull = _ref.isFull,
        isOpened = _ref.isOpened,
        onClose = _ref.onClose,
        partnerID = _ref.partnerID;

    var log = (0, _hooks.useMetricsLog)(_logConstants.FEATURE);
    var dispatch = (0, _reactRedux.useDispatch)();

    var _useSelector = (0, _reactRedux.useSelector)(function (state) {
        return state.settings;
    }),
        realm = _useSelector.realm;

    var _useSelector2 = (0, _reactRedux.useSelector)(function (state) {
        return state.recommendedClans;
    }),
        languages = _useSelector2.languages,
        membersCount = _useSelector2.membersCount,
        listType = _useSelector2.listType,
        dwhType = _useSelector2.dwhType,
        total = _useSelector2.total;

    var _useState = (0, _react.useState)(languages),
        _useState2 = _slicedToArray(_useState, 2),
        langugesFilter = _useState2[0],
        setLangugesFilter = _useState2[1];

    var _useState3 = (0, _react.useState)(membersCount),
        _useState4 = _slicedToArray(_useState3, 2),
        membersFilter = _useState4[0],
        setMembersFilter = _useState4[1];

    var _useState5 = (0, _react.useState)(listType),
        _useState6 = _slicedToArray(_useState5, 2),
        listFilter = _useState6[0],
        setListFilter = _useState6[1];

    var _useState7 = (0, _react.useState)(false),
        _useState8 = _slicedToArray(_useState7, 2),
        hasChanges = _useState8[0],
        setHasChanges = _useState8[1];

    (0, _react.useEffect)(function () {
        if (!membersCount) {
            dispatch((0, _recommended_clans2.setMembersCount)(1));
        }
    }, []);

    var handleButtonClick = (0, _react.useCallback)(function () {
        log({
            action: _logConstants.Actions.Click,
            item: _logConstants.Items.SaveButton,
            parentScreen: _logConstants.Items.LandingClans,
            partnerID: partnerID,
            info: JSON.stringify({
                type: dwhType,
                total: total,
                membersCount: membersCount,
                gameLevel: listType,
                languages: languages
            })
        });
    }, [log]);

    (0, _react.useEffect)(function () {
        if (!hasChanges) {
            setLangugesFilter(languages);
            setMembersFilter(membersCount);
            setListFilter(listType);
        }
    }, [hasChanges, languages, membersCount, listFilter]);

    var selectLanguage = (0, _react.useCallback)(function (lang) {
        setHasChanges(true);
        if (languages.includes(lang)) {
            dispatch((0, _recommended_clans2.setLanguageCode)(languages.filter(function (item) {
                return item !== lang;
            })));
        } else {
            dispatch((0, _recommended_clans2.setLanguageCode)([].concat(_toConsumableArray(languages), [lang])));
        }
    }, [languages]);

    var selectListType = (0, _react.useCallback)(function (listType) {
        setHasChanges(true);
        dispatch((0, _recommended_clans2.setListType)(listType));
    }, []);

    var handleSetPLayers = (0, _react.useCallback)(function (membersCount) {
        setHasChanges(true);
        dispatch((0, _recommended_clans2.setMembersCount)(membersCount));
    }, []);

    var handleSave = (0, _react.useCallback)(function () {
        handleButtonClick();
        if (hasChanges) {
            dispatch((0, _recommended_clans2.sendFilterSettings)());
            dispatch((0, _recommended_clans2.fetchRecommendedClans)());
        }
        onClose(true);
        setHasChanges(false);
    }, [membersCount, listType, languages, onClose, hasChanges, langugesFilter]);

    var handleClose = (0, _react.useCallback)(function () {
        dispatch((0, _recommended_clans2.setLanguageCode)(langugesFilter));
        dispatch((0, _recommended_clans2.setMembersCount)(membersFilter));
        dispatch((0, _recommended_clans2.setListType)(listFilter));
        onClose(false);
        setHasChanges(false);
    }, [onClose]);

    var selectedMembersCountItem = _constants.MEMBERS_COUNT_ITEMS.find(function (item) {
        return item.value === membersCount;
    });
    var shouldHideLanguageSection = realm === 'cn360' && _constants.REALM_LANGUAGE_CODES[realm].length === 1;

    (0, _useCallbackOnEsc.useCallbackOnEsc)(function (e, nextEscCallback) {
        if (isOpened) {
            handleClose();
            return;
        }

        nextEscCallback && nextEscCallback();
    });

    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_Filters2.default.base, isOpened && _Filters2.default.base__opened) },
        _react2.default.createElement('div', { className: _Filters2.default.background }),
        _react2.default.createElement(
            'div',
            { className: _Filters2.default.back },
            _react2.default.createElement(_Back.Back, {
                caption: _Back.Back.CAPTIONS.close,
                type: _Back.Back.TYPES.close,
                side: _Back.Back.SIDES.right,
                handleClick: handleClose,
                playHoverSound: _reactWotBootstrap.sendHoverSoundCommand,
                playClickSound: _reactWotBootstrap.sendClickSoundCommand
            })
        ),
        _react2.default.createElement(
            'div',
            { className: _Filters2.default.container },
            _react2.default.createElement(
                'div',
                { className: _Filters2.default.title },
                _constants.FILTERS_TITLE
            ),
            isFull && _react2.default.createElement(
                'div',
                { className: _Filters2.default.section },
                _react2.default.createElement(
                    'div',
                    { className: _Filters2.default.subtitle },
                    _constants.FILTERS_ACTIVITY
                ),
                _react2.default.createElement(_Levels2.default, { level: listType, onClick: selectListType })
            ),
            _react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)(_Filters2.default.section, isFull && _Filters2.default.section__bordered) },
                _react2.default.createElement(
                    'div',
                    { className: _Filters2.default.subtitle },
                    _constants.FILTERS_PLAYERS
                ),
                _react2.default.createElement(_reactWotBootstrap.Filter, {
                    items: _constants.MEMBERS_COUNT_ITEMS,
                    checkedItem: selectedMembersCountItem && selectedMembersCountItem.value || _constants.MEMBERS_COUNT_ITEMS[0].value,
                    onItemChange: handleSetPLayers
                })
            ),
            !shouldHideLanguageSection && _react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)(_Filters2.default.section, _Filters2.default.section__bordered) },
                _react2.default.createElement(
                    'div',
                    { className: _Filters2.default.subtitle },
                    _constants.FILTERS_LANGUAGE
                ),
                _react2.default.createElement(
                    'div',
                    { className: _Filters2.default.languages },
                    _constants.REALM_LANGUAGE_CODES[realm] && _constants.REALM_LANGUAGE_CODES[realm].map(function (lang) {
                        var stateLangCode = (0, _recommended_clans.normalizeBackCnLangForServer)(lang, realm);
                        return _react2.default.createElement(_Language2.default, {
                            key: lang,
                            code: (0, _recommended_clans.normalizeLanguageCodeForClient)(lang, realm),
                            title: (0, _recommended_clans.getLocalizedLanguageTitle)(lang, realm),
                            onClick: function onClick() {
                                return selectLanguage(stateLangCode);
                            },
                            isChecked: languages.includes(stateLangCode)
                        });
                    })
                )
            ),
            _react2.default.createElement(
                'div',
                { className: _Filters2.default.buttons },
                _react2.default.createElement(
                    _reactWotBootstrap.ButtonGroup,
                    null,
                    _react2.default.createElement(
                        _reactWotBootstrap.Button,
                        {
                            mixClassName: _Filters2.default.button,
                            isJustified: true,
                            onClick: handleSave
                        },
                        _constants.FILTERS_SAVE
                    ),
                    _react2.default.createElement(
                        _reactWotBootstrap.Button,
                        {
                            mixClassName: _Filters2.default.button,
                            isJustified: true,
                            onClick: handleClose,
                            type: 'secondary',
                            buttonClickSoundId: _sounds2.default.CLICK
                        },
                        _constants.FILTERS_CLOSE
                    )
                )
            )
        )
    );
};

Filters.propTypes = {
    isOpened: _propTypes2.default.bool.isRequired,
    isFull: _propTypes2.default.bool.isRequired,
    onClose: _propTypes2.default.func.isRequired,
    partnerID: _propTypes2.default.string.isRequired
};

exports.default = Filters;

/***/ }),
/* 2278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactWotBootstrap = __webpack_require__(5);

var _Flag = __webpack_require__(1359);

var _Flag2 = _interopRequireDefault(_Flag);

var _Language = __webpack_require__(2279);

var _Language2 = _interopRequireDefault(_Language);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Language = function Language(_ref) {
    var code = _ref.code,
        title = _ref.title,
        isChecked = _ref.isChecked,
        onClick = _ref.onClick;

    var handleClick = function handleClick() {
        (0, _reactWotBootstrap.sendTabClickSoundCommand)();
        onClick(code);
    };

    return _react2.default.createElement(
        'div',
        {
            className: (0, _classnames2.default)(_Language2.default.base, isChecked && _Language2.default.base__checked),
            onClick: handleClick,
            onMouseEnter: _reactWotBootstrap.sendHoverSoundCommand
        },
        _react2.default.createElement(_Flag2.default, { code: code }),
        _react2.default.createElement(
            'div',
            { className: _Language2.default.title },
            title
        )
    );
};

Language.propTypes = {
    code: _propTypes2.default.string.isRequired,
    title: _propTypes2.default.string.isRequired,
    isChecked: _propTypes2.default.bool.isRequired,
    onClick: _propTypes2.default.func.isRequired
};

exports.default = Language;

/***/ }),
/* 2279 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Language_base--RAwKW","base__checked":"Language_base__checked--2brG8","baseChecked":"Language_base__checked--2brG8","title":"Language_title--1KMsh"};

/***/ }),
/* 2280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactWotBootstrap = __webpack_require__(5);

var _constants = __webpack_require__(279);

var _Levels = __webpack_require__(2281);

var _Levels2 = _interopRequireDefault(_Levels);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LEVELS = [{
    listType: _constants.LIST_TYPES.CHOICE_1,
    title: _constants.FILTERS_ACTIVITY_PLATOON_TITLE,
    description: _constants.FILTERS_ACTIVITY_PLATOON_DESCRIPTION
}, {
    listType: _constants.LIST_TYPES.CHOICE_2,
    title: _constants.FILTERS_ACTIVITY_STRONGHOLD_TITLE,
    description: _constants.FILTERS_ACTIVITY_STRONGHOLD_DESCRIPTION
}, {
    listType: _constants.LIST_TYPES.CHOICE_3,
    title: _constants.FILTERS_ACTIVITY_GLOBAL_MAP_TITLE,
    description: _constants.FILTERS_ACTIVITY_GLOBAL_MAP_DESCRIPTION
}];

var Levels = function Levels(_ref) {
    var level = _ref.level,
        onClick = _ref.onClick;

    var createHandleClick = (0, _react.useCallback)(function (listType) {
        return function () {
            onClick(listType);
            (0, _reactWotBootstrap.sendTabClickSoundCommand)();
        };
    }, [onClick]);

    return _react2.default.createElement(
        'div',
        { className: _Levels2.default.base },
        LEVELS.map(function (_ref2) {
            var listType = _ref2.listType,
                title = _ref2.title,
                description = _ref2.description;

            var isSelected = listType === level;

            return _react2.default.createElement(
                'div',
                {
                    key: listType,
                    onMouseEnter: isSelected ? undefined : _reactWotBootstrap.sendHoverSoundCommand,
                    onClick: isSelected ? undefined : createHandleClick(listType),
                    className: (0, _classnames2.default)(_Levels2.default.item, isSelected && _Levels2.default.item__active)
                },
                _react2.default.createElement(
                    'div',
                    { className: _Levels2.default.title },
                    title
                ),
                _react2.default.createElement(
                    'div',
                    { className: _Levels2.default.description },
                    description
                )
            );
        })
    );
};

Levels.propTypes = {
    level: _propTypes2.default.string,
    onClick: _propTypes2.default.func.isRequired
};

exports.default = Levels;

/***/ }),
/* 2281 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Levels_base--2A6Lg","item":"Levels_item--1iyBC","item__active":"Levels_item__active--eIqfr","itemActive":"Levels_item__active--eIqfr","title":"Levels_title--3kY51","description":"Levels_description--2uLxL"};

/***/ }),
/* 2282 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Filters_base--BjxKv","base__opened":"Filters_base__opened--3Pu5n","baseOpened":"Filters_base__opened--3Pu5n","background":"Filters_background--E_VWb","back":"Filters_back--1LGMG","container":"Filters_container--3DJYC","section":"Filters_section--2PYYU","section__bordered":"Filters_section__bordered--3ly6a","sectionBordered":"Filters_section__bordered--3ly6a","buttons":"Filters_buttons--uL_KM","button":"Filters_button--gICuk","title":"Filters_title--1YwXX","subtitle":"Filters_subtitle--1fxaI","languages":"Filters_languages--14od6"};

/***/ }),
/* 2283 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"LandingClans_base--3BB3Y","header":"LandingClans_header--1qWbS","title":"LandingClans_title--3jhfN","subtitle":"LandingClans_subtitle--1CpR6","filters":"LandingClans_filters--1CoIy","button":"LandingClans_button--2VTSr","filtersItem":"LandingClans_filtersItem--35D2V","content":"LandingClans_content--34VBH","clans":"LandingClans_clans--2QvnT","clans__blured":"LandingClans_clans__blured--soE2M","clansBlured":"LandingClans_clans__blured--soE2M","message":"LandingClans_message--1Hmmt","pagination":"LandingClans_pagination--ivb3G","pagination__invisible":"LandingClans_pagination__invisible--2V08n","paginationInvisible":"LandingClans_pagination__invisible--2V08n","back":"LandingClans_back--3GdfJ","backTitle":"LandingClans_backTitle--2GdjV"};

/***/ }),
/* 2284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _translations = __webpack_require__(2285);

var _LandingPromo = __webpack_require__(2286);

var _LandingPromo2 = _interopRequireDefault(_LandingPromo);

var _reactWotBootstrap = __webpack_require__(5);

var _translations2 = __webpack_require__(567);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LandingPromo = function LandingPromo(_ref) {
    var onGoToRecommendedClansButtonClick = _ref.onGoToRecommendedClansButtonClick;

    return _react2.default.createElement(
        'div',
        { className: _LandingPromo2.default.base },
        _react2.default.createElement(
            'div',
            { className: _LandingPromo2.default.header },
            _translations.LANDING_PROMO_HEADER
        ),
        _react2.default.createElement(
            'div',
            { className: _LandingPromo2.default.message },
            _react2.default.createElement(
                'div',
                { className: _LandingPromo2.default.text },
                _translations.LANDING_PROMO_MESSAGE
            )
        ),
        _react2.default.createElement(
            'div',
            { className: _LandingPromo2.default.buttonWrapper },
            _react2.default.createElement('div', { className: _LandingPromo2.default.glowing }),
            _react2.default.createElement(
                _reactWotBootstrap.Button,
                {
                    type: 'primary',
                    tooltipId: 'goto_selection_clan_tooltip',
                    onClick: onGoToRecommendedClansButtonClick
                },
                _react2.default.createElement(
                    'span',
                    null,
                    _translations2.LANDING_GOTO_SELECTION_CLAN
                )
            ),
            _react2.default.createElement(
                _reactWotBootstrap.Tooltip,
                { id: 'goto_selection_clan_tooltip' },
                _translations2.LANDING_GOTO_SELECTION_CLAN_TOOLTIP
            )
        )
    );
};

LandingPromo.propTypes = {
    onGoToRecommendedClansButtonClick: _propTypes2.default.func.isRequired
};

exports.default = LandingPromo;

/***/ }),
/* 2285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LANDING_PROMO_REWARD = exports.LANDING_PROMO_MESSAGE = exports.LANDING_PROMO_HEADER = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LANDING_PROMO_HEADER = exports.LANDING_PROMO_HEADER = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'landing_promo.header',
    defaultMessage: '\u041A\u041B\u0410\u041D\u042B \u0412 WORLD OF TANKS'
});

var LANDING_PROMO_MESSAGE = exports.LANDING_PROMO_MESSAGE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'landing_promo.message'
    // eslint-disable-next-line max-len
    , defaultMessage: 'Вступайте в клан, играйте вместе с другими танкистами, достигайте общих целей и получайте технику, золото, боны и клановые резервы для ускорения развития в игре!'
});

var LANDING_PROMO_REWARD = exports.LANDING_PROMO_REWARD = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'landing_promo.reward',
    defaultMessage: 'Награда за вступление:{brTag} Стиль для клановых игроков',
    values: {
        brTag: _react2.default.createElement('br', null)
    }
});

/***/ }),
/* 2286 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"LandingPromo_base--2PyWa","header":"LandingPromo_header--1JxrW","message":"LandingPromo_message--skw0z","text":"LandingPromo_text--2AFmW","tooltipContainer":"LandingPromo_tooltipContainer--RtpxU","awardMessage":"LandingPromo_awardMessage--1oYyb","buttonWrapper":"LandingPromo_buttonWrapper--2RQwA","glowing":"LandingPromo_glowing--1tW3W"};

/***/ }),
/* 2287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(7);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactWotBootstrap = __webpack_require__(5);

var _web_to_client = __webpack_require__(12);

var _Clan = __webpack_require__(81);

var _Clan2 = _interopRequireDefault(_Clan);

var _sounds = __webpack_require__(22);

var _translations = __webpack_require__(2288);

var _greeting_landing = __webpack_require__(1002);

var _translations2 = __webpack_require__(237);

var _LandingResult = __webpack_require__(2289);

var _LandingResult2 = _interopRequireDefault(_LandingResult);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LandingResult = function LandingResult(_ref) {
    var isWaiting = _ref.isWaiting,
        onClick = _ref.onClick;

    var tooltipTimeoutRef = (0, _react.useRef)(0);
    var dispatch = (0, _reactRedux.useDispatch)();

    var _useSelector = (0, _reactRedux.useSelector)(function (state) {
        return state;
    }),
        greetingLanding = _useSelector.greetingLanding;

    (0, _react.useEffect)(function () {
        (0, _sounds.playCongratulationClanJoiningSound)();
        dispatch((0, _greeting_landing.requestGreetingLandingInfo)());
    }, []);

    var handleMouseEnter = function handleMouseEnter() {
        tooltipTimeoutRef.current = window.setTimeout(function () {
            (0, _web_to_client.showItemTooltip)(_web_to_client.REWARD_PACK_TYPE.STYLE_ALL, 1, parseInt(199, 10) || '');
            tooltipTimeoutRef.current = undefined;
        }, 200);
    };

    var handleMouseLeave = function handleMouseLeave() {
        window.clearTimeout(tooltipTimeoutRef.current);
        if (tooltipTimeoutRef.current === undefined) {
            (0, _web_to_client.hideTooltip)();
        }
    };

    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_LandingResult2.default.base, isWaiting && _LandingResult2.default.base__waiting) },
        _react2.default.createElement(
            'div',
            { className: _LandingResult2.default.greeting },
            _translations.SUCCESS_SCREEN_GREETING
        ),
        _react2.default.createElement(
            'div',
            { className: _LandingResult2.default.message },
            isWaiting ? _translations.WAITING_SCREEN_MESSAGE : _translations.SUCCESS_SCREEN_MESSAGE
        ),
        _react2.default.createElement(_Clan2.default, _extends({}, greetingLanding, { className: _LandingResult2.default.clan, nameColor: '#fefeec' })),
        _react2.default.createElement(
            'div',
            { className: _LandingResult2.default.awardContainer },
            _react2.default.createElement('div', { className: _LandingResult2.default.awardImage, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave })
        ),
        _react2.default.createElement(
            'div',
            { className: _LandingResult2.default.awardMessage },
            _translations.SUCCESS_SCREEN_AWARD_MESSAGE
        ),
        _react2.default.createElement(
            'div',
            { className: _LandingResult2.default.info },
            _react2.default.createElement(
                'span',
                { className: _LandingResult2.default.warningIcon },
                _react2.default.createElement(_reactWotBootstrap.Icon, { glyph: 'warning' })
            ),
            _translations.WAITING_SCREEN_INFO
        ),
        _react2.default.createElement(
            _reactWotBootstrap.Button,
            { isExternal: true, onClick: onClick, tooltipId: 'style_tooltip', mixClassName: _LandingResult2.default.button },
            isWaiting ? _translations.BUTTON_BACK_TO_HANGAR : _translations2.AFFIRMATIVE
        )
    );
};

LandingResult.propTypes = {
    isWaiting: _propTypes2.default.bool,
    onClick: _propTypes2.default.func.isRequired,
    playCongratulationClanJoiningSound: _propTypes2.default.func
};

exports.default = LandingResult;

/***/ }),
/* 2288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SUCCESS_SCREEN_AWARD_MESSAGE = exports.BUTTON_BACK_TO_HANGAR = exports.WAITING_SCREEN_INFO = exports.WAITING_SCREEN_MESSAGE = exports.SUCCESS_SCREEN_MESSAGE = exports.SUCCESS_SCREEN_GREETING = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SUCCESS_SCREEN_GREETING = exports.SUCCESS_SCREEN_GREETING = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'success_screen.greeting', defaultMessage: '\u041F\u041E\u0417\u0414\u0420\u0410\u0412\u041B\u042F\u0415\u041C!' });

var SUCCESS_SCREEN_MESSAGE = exports.SUCCESS_SCREEN_MESSAGE = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'success_screen.message', defaultMessage: '\u0412\u042B \u0412\u0421\u0422\u0423\u041F\u0418\u041B\u0418 \u0412 \u041A\u041B\u0410\u041D' });

var WAITING_SCREEN_MESSAGE = exports.WAITING_SCREEN_MESSAGE = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'waiting_screen.message', defaultMessage: '\u0412\u0410\u0428\u0415 \u0412\u0421\u0422\u0423\u041F\u041B\u0415\u041D\u0418\u0415 \u0412 \u041A\u041B\u0410\u041D \u041E\u0414\u041E\u0411\u0420\u0415\u041D\u041E' });

var WAITING_SCREEN_INFO = exports.WAITING_SCREEN_INFO = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'waiting_screen.info', defaultMessage: '\u0412\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u0435 \u0432 \u043A\u043B\u0430\u043D \u043C\u043E\u0436\u0435\u0442 \u0437\u0430\u043D\u044F\u0442\u044C \u043D\u0435\u043A\u043E\u0442\u043E\u0440\u043E\u0435 \u0432\u0440\u0435\u043C\u044F' });

var BUTTON_BACK_TO_HANGAR = exports.BUTTON_BACK_TO_HANGAR = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'success_screen.button.to_hangar', defaultMessage: '\u0412\u0435\u0440\u043D\u0443\u0442\u044C\u0441\u044F \u0432 \u0410\u043D\u0433\u0430\u0440' });

var SUCCESS_SCREEN_AWARD_MESSAGE = exports.SUCCESS_SCREEN_AWARD_MESSAGE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'success_screen.award_message',
    defaultMessage: '\u041D\u0430\u0433\u0440\u0430\u0434\u0430 \u0437\u0430 \u0432\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u0435 \u0432 \u043A\u043B\u0430\u043D \u2014 \u043E\u0441\u043E\u0431\u044B\u0439 \u0441\u0442\u0438\u043B\u044C \xAB\u041A\u043B\u0430\u043D\u043E\u0432\u044B\u0439 \u043F\u043E\u0432\u0441\u0435\u0434\u043D\u0435\u0432\u043D\u044B\u0439\xBB'
});

/***/ }),
/* 2289 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"LandingResult_base--1uBX2","greeting":"LandingResult_greeting--1UyjL","message":"LandingResult_message--2aWm5","clan":"LandingResult_clan--3xWPY","base__waiting":"LandingResult_base__waiting--EHbZl","baseWaiting":"LandingResult_base__waiting--EHbZl","awardContainer":"LandingResult_awardContainer--1XLA_","awardImage":"LandingResult_awardImage--24tYC","awardMessage":"LandingResult_awardMessage--35Wdq","warningIcon":"LandingResult_warningIcon--12x6C","info":"LandingResult_info--3KaMU","button":"LandingResult_button--1yOB4"};

/***/ }),
/* 2290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SlideInner = __webpack_require__(568);

var _SlideInner2 = _interopRequireDefault(_SlideInner);

var _LandingToursOfDuty = __webpack_require__(2292);

var _LandingToursOfDuty2 = _interopRequireDefault(_LandingToursOfDuty);

var _translations = __webpack_require__(2293);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LandingToursOfDuty = function LandingToursOfDuty() {
    return _react2.default.createElement(
        _SlideInner2.default,
        {
            title: _translations.LANDING_TOURS_OF_DUTY_HEADER,
            description: [_translations.LANDING_TOURS_OF_DUTY_MESSAGE1, _translations.LANDING_TOURS_OF_DUTY_MESSAGE2]
        },
        _react2.default.createElement('div', { className: _LandingToursOfDuty2.default.imageContainer })
    );
};

exports.default = LandingToursOfDuty;

/***/ }),
/* 2291 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"SlideInner_base--3o4tI","slideContainer":"SlideInner_slideContainer--3cJMz","slideHeader":"SlideInner_slideHeader--3Lbue","description":"SlideInner_description--GNaqo","slideMessage":"SlideInner_slideMessage--Mb8rS"};

/***/ }),
/* 2292 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"imageContainer":"LandingToursOfDuty_imageContainer--3Xjio"};

/***/ }),
/* 2293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LANDING_TOURS_OF_DUTY_MESSAGE2 = exports.LANDING_TOURS_OF_DUTY_MESSAGE1 = exports.LANDING_TOURS_OF_DUTY_HEADER = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LANDING_TOURS_OF_DUTY_HEADER = exports.LANDING_TOURS_OF_DUTY_HEADER = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'landing_tours_of_duty.header',
    defaultMessage: '\u0411\u043E\u0435\u0432\u044B\u0435 \u043F\u043E\u0445\u043E\u0434\u044B'
});

var LANDING_TOURS_OF_DUTY_MESSAGE1 = exports.LANDING_TOURS_OF_DUTY_MESSAGE1 = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'landing_tours_of_duty_header.message1'
    // eslint-disable-next-line max-len
    , defaultMessage: 'Когда вы вступите в клан, вам станут доступны регулярные игровые события{nbsp}— Боевые походы.',
    values: {
        nbsp: _react2.default.createElement(
            'span',
            null,
            '\xA0'
        )
    }
});

var LANDING_TOURS_OF_DUTY_MESSAGE2 = exports.LANDING_TOURS_OF_DUTY_MESSAGE2 = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'landing_tours_of_duty_header_message2'
    // eslint-disable-next-line max-len
    , defaultMessage: 'Играя в своём обычном режиме, вы сможете выполнять специальные задачи, продвигаться в Боевом походе, получать ценные награды, а также помогать в этом всем игрокам клана.'
});

/***/ }),
/* 2294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactWotBootstrap = __webpack_require__(5);

var _NextSliderButton = __webpack_require__(2295);

var _NextSliderButton2 = _interopRequireDefault(_NextSliderButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NextSliderButton = function (_React$PureComponent) {
    _inherits(NextSliderButton, _React$PureComponent);

    function NextSliderButton() {
        _classCallCheck(this, NextSliderButton);

        return _possibleConstructorReturn(this, (NextSliderButton.__proto__ || Object.getPrototypeOf(NextSliderButton)).apply(this, arguments));
    }

    _createClass(NextSliderButton, [{
        key: 'render',
        value: function render() {
            var isDisabled = this.props.currentSlide === this.props.slideCount - 1;
            var classNameBase = (0, _classnames2.default)(this.props.className, _NextSliderButton2.default.next, _defineProperty({}, _NextSliderButton2.default.isDisabled, isDisabled));
            return _react2.default.createElement('div', {
                className: classNameBase,
                style: this.props.style,
                onClick: this.props.onClick,
                onMouseDown: isDisabled ? null : _reactWotBootstrap.sendSelectClickSoundCommand,
                onMouseEnter: isDisabled ? null : _reactWotBootstrap.sendHoverSoundCommand
            });
        }
    }]);

    return NextSliderButton;
}(_react2.default.PureComponent);

NextSliderButton.propTypes = {
    className: _propTypes2.default.string,
    currentSlide: _propTypes2.default.number,
    slideCount: _propTypes2.default.number,
    style: _propTypes2.default.object,
    onClick: _propTypes2.default.func
};
exports.default = NextSliderButton;

/***/ }),
/* 2295 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"next":"NextSliderButton_next--3JLkw","isDisabled":"NextSliderButton_isDisabled--2YaJT"};

/***/ }),
/* 2296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactWotBootstrap = __webpack_require__(5);

var _PrevSliderButton = __webpack_require__(2297);

var _PrevSliderButton2 = _interopRequireDefault(_PrevSliderButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PrevSliderButton = function (_React$PureComponent) {
    _inherits(PrevSliderButton, _React$PureComponent);

    function PrevSliderButton() {
        _classCallCheck(this, PrevSliderButton);

        return _possibleConstructorReturn(this, (PrevSliderButton.__proto__ || Object.getPrototypeOf(PrevSliderButton)).apply(this, arguments));
    }

    _createClass(PrevSliderButton, [{
        key: 'render',
        value: function render() {
            var isDisabled = this.props.currentSlide === 0;

            var classNameBase = (0, _classnames2.default)(this.props.className, _PrevSliderButton2.default.prev, _defineProperty({}, _PrevSliderButton2.default.isDisabled, isDisabled));
            return _react2.default.createElement('div', {
                className: classNameBase,
                style: this.props.style,
                onClick: this.props.onClick,
                onMouseDown: isDisabled ? null : _reactWotBootstrap.sendSelectClickSoundCommand,
                onMouseEnter: isDisabled ? null : _reactWotBootstrap.sendHoverSoundCommand
            });
        }
    }]);

    return PrevSliderButton;
}(_react2.default.PureComponent);

PrevSliderButton.propTypes = {
    className: _propTypes2.default.string,
    currentSlide: _propTypes2.default.number,
    style: _propTypes2.default.object,
    onClick: _propTypes2.default.func
};
exports.default = PrevSliderButton;

/***/ }),
/* 2297 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"prev":"PrevSliderButton_prev--bGjpC","isDisabled":"PrevSliderButton_isDisabled--1dk9t"};

/***/ }),
/* 2298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SlideInner = __webpack_require__(568);

var _SlideInner2 = _interopRequireDefault(_SlideInner);

var _LandingStronghold = __webpack_require__(2299);

var _LandingStronghold2 = _interopRequireDefault(_LandingStronghold);

var _translations = __webpack_require__(2300);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LandingStronghold = function LandingStronghold() {
    return _react2.default.createElement(
        _SlideInner2.default,
        {
            title: _translations.LANDING_STRONGHOLD_HEADER,
            description: [_translations.LANDING_STRONGHOLD_MESSAGE1, _translations.LANDING_STRONGHOLD_MESSAGE2]
        },
        _react2.default.createElement('div', { className: _LandingStronghold2.default.imageContainer })
    );
};

exports.default = LandingStronghold;

/***/ }),
/* 2299 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"imageContainer":"LandingStronghold_imageContainer--3XjDX"};

/***/ }),
/* 2300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LANDING_STRONGHOLD_MESSAGE2 = exports.LANDING_STRONGHOLD_MESSAGE1 = exports.LANDING_STRONGHOLD_HEADER = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var nbsp = _react2.default.createElement(
    'span',
    null,
    '\xA0'
);

var LANDING_STRONGHOLD_HEADER = exports.LANDING_STRONGHOLD_HEADER = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'landing_stronghold.header',
    defaultMessage: '\u0423\u043A\u0440\u0435\u043F\u0440\u0430\u0439\u043E\u043D'
});

var LANDING_STRONGHOLD_MESSAGE1 = exports.LANDING_STRONGHOLD_MESSAGE1 = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'landing_stronghold.message1'
    // eslint-disable-next-line max-len
    , defaultMessage: 'В Укрепрайонах кланы сражаются друг с другом. Результат противостояний во многом зависит от тактики и командной игры, а главная цель в этом режиме{nbsp}— подготовка клановых резервов, дающих бонус к опыту и кредитам.',
    values: {
        nbsp: nbsp
    }
});

var LANDING_STRONGHOLD_MESSAGE2 = exports.LANDING_STRONGHOLD_MESSAGE2 = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'landing_stronghold_message2'
    // eslint-disable-next-line max-len
    , defaultMessage: 'Также в Укрепрайонах регулярно проводятся Военные игры{nbsp}— соревнования, в которых можно выиграть золото и клановые резервы высоких уровней.',
    values: {
        nbsp: nbsp
    }
});

/***/ }),
/* 2301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SlideInner = __webpack_require__(568);

var _SlideInner2 = _interopRequireDefault(_SlideInner);

var _LandingGlobalMap = __webpack_require__(2302);

var _LandingGlobalMap2 = _interopRequireDefault(_LandingGlobalMap);

var _translations = __webpack_require__(2303);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LandingGlobalMap = function LandingGlobalMap() {
    return _react2.default.createElement(
        _SlideInner2.default,
        {
            title: _translations.LANDING_GLOBAL_MAP_HEADER,
            description: [_translations.LANDING_GLOBAL_MAP_MESSAGE1, _translations.LANDING_GLOBAL_MAP_MESSAGE2]
        },
        _react2.default.createElement('div', { className: _LandingGlobalMap2.default.imageContainer })
    );
};

exports.default = LandingGlobalMap;

/***/ }),
/* 2302 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"imageContainer":"LandingGlobalMap_imageContainer--1wYub"};

/***/ }),
/* 2303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LANDING_GLOBAL_MAP_MESSAGE2 = exports.LANDING_GLOBAL_MAP_MESSAGE1 = exports.LANDING_GLOBAL_MAP_HEADER = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LANDING_GLOBAL_MAP_HEADER = exports.LANDING_GLOBAL_MAP_HEADER = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'landing_global_map.header',
    defaultMessage: '\u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u0430\u044F \u043A\u0430\u0440\u0442\u0430'
});

var LANDING_GLOBAL_MAP_MESSAGE1 = exports.LANDING_GLOBAL_MAP_MESSAGE1 = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'landing_global_map.message1'
    // eslint-disable-next-line max-len
    , defaultMessage: 'Кланы ведут ожесточённую борьбу за территории на игровом поле{nbsp}— Глобальной карте. Выполняя определённые действия, они зарабатывают золото и другие награды.',
    values: {
        nbsp: _react2.default.createElement(
            'span',
            null,
            '\xA0'
        )
    }
});

var LANDING_GLOBAL_MAP_MESSAGE2 = exports.LANDING_GLOBAL_MAP_MESSAGE2 = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'landing_global_map_message2'
    // eslint-disable-next-line max-len
    , defaultMessage: 'Также на Глобальной карте проходят игровые события, в которых можно получить технику, особые 3D-стили и многое другое.'
});

/***/ }),
/* 2304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(93);

var _hooks = __webpack_require__(164);

var _reactRedux = __webpack_require__(7);

var _logConstants = __webpack_require__(165);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LogWrapper = function LogWrapper(_ref) {
    var WrappedComponent = _ref.WrappedComponent,
        isCurrent = _ref.isCurrent,
        partnerID = _ref.partnerID,
        slideName = _ref.slideName,
        isLastSlide = _ref.isLastSlide,
        onLastSlideBackClick = _ref.onLastSlideBackClick,
        onGoToRecommendedClansButtonClick = _ref.onGoToRecommendedClansButtonClick;

    var _useSelector = (0, _reactRedux.useSelector)(function (state) {
        return state.recommendedClans;
    }),
        total = _useSelector.total,
        dwhType = _useSelector.dwhType,
        membersCount = _useSelector.membersCount,
        listType = _useSelector.listType,
        languages = _useSelector.languages,
        loadedBefore = _useSelector.loadedBefore;

    var log = (0, _hooks.useMetricsLog)(_logConstants.FEATURE);

    var _useMetricsLogTimeSpe = (0, _hooks.useMetricsLogTimeSpent)(_logConstants.FEATURE),
        _useMetricsLogTimeSpe2 = _slicedToArray(_useMetricsLogTimeSpe, 2),
        start = _useMetricsLogTimeSpe2[0],
        stop = _useMetricsLogTimeSpe2[1];

    var handleSlideOpen = (0, _react.useCallback)(function () {
        var info = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        start(_logConstants.Actions.Preview);
        log({
            action: _logConstants.Actions.Open,
            item: _logConstants.Items[(0, _lodash.upperFirst)(slideName)],
            parentScreen: _logConstants.Items.Hangar,
            partnerID: partnerID,
            info: info
        });
    }, [log, start]);

    var handleSlideClose = (0, _react.useCallback)(function () {
        stop({
            action: _logConstants.Actions.Preview,
            item: _logConstants.Items[(0, _lodash.upperFirst)(slideName)],
            timeLimit: 1.0,
            partnerID: partnerID
        });
    }, [stop]);

    (0, _react.useEffect)(function () {
        var handleKeyUp = function handleKeyUp(e) {
            e.keyCode === _constants.KEY_CODES.ESCAPE && handleSlideClose();
        };
        window.addEventListener('keydown', handleKeyUp);

        return function () {
            window.removeEventListener('keydown', handleKeyUp);
        };
    });

    (0, _react.useEffect)(function () {
        if (isCurrent && !isLastSlide) {
            handleSlideOpen();
        }
        if (isCurrent && isLastSlide && loadedBefore) {
            var info = JSON.stringify({
                type: dwhType,
                total: total,
                membersCount: membersCount,
                gameLevel: listType,
                languages: languages
            });
            handleSlideOpen(info);
        }
        return function () {
            handleSlideClose();
        };
    }, [isCurrent, loadedBefore]);

    return _react2.default.createElement(WrappedComponent, {
        partnerID: partnerID,
        onLastSlideBackClick: onLastSlideBackClick,
        onGoToRecommendedClansButtonClick: onGoToRecommendedClansButtonClick
    });
};

LogWrapper.propTypes = {
    WrappedComponent: _propTypes2.default.elementType.isRequired,
    isCurrent: _propTypes2.default.bool.isRequired,
    isLastSlide: _propTypes2.default.bool.isRequired,
    partnerID: _propTypes2.default.string.isRequired,
    slideName: _propTypes2.default.string.isRequired,
    onLastSlideBackClick: _propTypes2.default.func.isRequired,
    onGoToRecommendedClansButtonClick: _propTypes2.default.func.isRequired
};

exports.default = LogWrapper;

/***/ }),
/* 2305 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Landing_base--1vNy_","body":"Landing_body--3hD8O","slideBg":"Landing_slideBg--2JSee","landingPromo":"Landing_landingPromo--1MmzQ Landing_slideBg--2JSee","landingBonus":"Landing_landingBonus--2PccI Landing_slideBg--2JSee","landingBattles":"Landing_landingBattles---l3b1 Landing_slideBg--2JSee","isCNRealm":"Landing_isCNRealm--3IcZP","isCnRealm":"Landing_isCNRealm--3IcZP","landingClans":"Landing_landingClans--3H_54 Landing_slideBg--2JSee","landingToursOfDuty":"Landing_landingToursOfDuty--8Ofey Landing_slideBg--2JSee","landingStronghold":"Landing_landingStronghold--2_dz- Landing_slideBg--2JSee","landingGlobalMap":"Landing_landingGlobalMap--2MkvP Landing_slideBg--2JSee","footer":"Landing_footer--3HuSt","footerContainer":"Landing_footerContainer--1k0vK","button":"Landing_button--18SBU","gotoSelectionClan":"Landing_gotoSelectionClan--2KhUy","gotoSelectionClanButton":"Landing_gotoSelectionClanButton--2T9S6","item":"Landing_item--ApkU9","emptyListContainer":"Landing_emptyListContainer--2DyvZ","slick-loading":"Landing_slick-loading--16bvk","slickLoading":"Landing_slick-loading--16bvk","slick-initialized":"Landing_slick-initialized--2WlFZ","slickInitialized":"Landing_slick-initialized--2WlFZ","slick-vertical":"Landing_slick-vertical--1-1CX","slickVertical":"Landing_slick-vertical--1-1CX"};

/***/ }),
/* 2306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(7);

var _ClanLanding = __webpack_require__(2307);

var _ClanLanding2 = _interopRequireDefault(_ClanLanding);

var _useIsTimestampExpired = __webpack_require__(1353);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ClanLandingContainer = function ClanLandingContainer() {
    var _useSelector = (0, _reactRedux.useSelector)(function (state) {
        return state.strongholdManeuvers;
    }),
        visibleStartDate = _useSelector.visibleStartDate,
        visibleEndDate = _useSelector.visibleEndDate;

    var isVisibleStartExpired = (0, _useIsTimestampExpired.useIsTimestampExpired)(visibleStartDate || 0);
    var isVisibleEndExpired = (0, _useIsTimestampExpired.useIsTimestampExpired)(visibleEndDate || 0);
    var isManeuversEventVisible = isVisibleStartExpired && !isVisibleEndExpired;

    return _react2.default.createElement(_ClanLanding2.default, { isManeuversEventVisible: isManeuversEventVisible });
};

exports.default = ClanLandingContainer;

/***/ }),
/* 2307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.dispatchToProps = exports.stateToProps = exports.isClanSupplyProgressionLoading = exports.isClanSupplyProgressionSettingsLoading = exports.isClanSupplyQuestsLoading = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(7);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = __webpack_require__(93);

var _constants = __webpack_require__(4);

var _translations = __webpack_require__(78);

var _clan_landing = __webpack_require__(996);

var _reactWotBootstrap = __webpack_require__(5);

var _Clan = __webpack_require__(81);

var _Clan2 = _interopRequireDefault(_Clan);

var _LoadingScreen = __webpack_require__(29);

var _LoadingScreen2 = _interopRequireDefault(_LoadingScreen);

var _MainCard = __webpack_require__(2308);

var _MainCard2 = _interopRequireDefault(_MainCard);

var _StrongholdCard = __webpack_require__(2312);

var _StrongholdCard2 = _interopRequireDefault(_StrongholdCard);

var _GlobalMapCard = __webpack_require__(2313);

var _GlobalMapCard2 = _interopRequireDefault(_GlobalMapCard);

var _ManeuversCard = __webpack_require__(2315);

var _ManeuversCard2 = _interopRequireDefault(_ManeuversCard);

var _AnnouncementsCard = __webpack_require__(2316);

var _AnnouncementsCard2 = _interopRequireDefault(_AnnouncementsCard);

var _ClanLandingReserves = __webpack_require__(2338);

var _ClanLandingReserves2 = _interopRequireDefault(_ClanLandingReserves);

var _ClanSupplyQuestsCard = __webpack_require__(2340);

var _ClanSupplyQuestsCard2 = _interopRequireDefault(_ClanSupplyQuestsCard);

var _ClanSupplyProgressionCard = __webpack_require__(2351);

var _ClanSupplyProgressionCard2 = _interopRequireDefault(_ClanSupplyProgressionCard);

var _DisabledCard = __webpack_require__(2353);

var _DisabledCard2 = _interopRequireDefault(_DisabledCard);

var _roles = __webpack_require__(49);

var _hermod = __webpack_require__(1369);

var _sounds = __webpack_require__(22);

var _balance = __webpack_require__(275);

var _client2web = __webpack_require__(126);

var _ClanLanding = __webpack_require__(2355);

var _ClanLanding2 = _interopRequireDefault(_ClanLanding);

var _cards = __webpack_require__(94);

var _cards2 = _interopRequireDefault(_cards);

var _announcements = __webpack_require__(158);

var _global_map = __webpack_require__(282);

var _craft_machine = __webpack_require__(281);

var _challenges = __webpack_require__(240);

var _webbrg = __webpack_require__(998);

var _shop = __webpack_require__(242);

var _clan_supply_quests = __webpack_require__(283);

var _client = __webpack_require__(373);

var _client_counters = __webpack_require__(374);

var _stronghold_maneuvers = __webpack_require__(378);

var _playersMatching = __webpack_require__(57);

var _ClanQuestsTutorialConnector = __webpack_require__(2356);

var _ClanQuestsTutorialConnector2 = _interopRequireDefault(_ClanQuestsTutorialConnector);

var _clan_supply_progression_main = __webpack_require__(2369);

var _selectors = __webpack_require__(569);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CLAN_TOOLTIP_ID = 'clan_tooltip';
var HIDE_INDICATOR_TIMEOUT = 5000;

var ClanLanding = function (_React$Component) {
    _inherits(ClanLanding, _React$Component);

    function ClanLanding(props) {
        _classCallCheck(this, ClanLanding);

        var _this = _possibleConstructorReturn(this, (ClanLanding.__proto__ || Object.getPrototypeOf(ClanLanding)).call(this, props));

        _this.isTutorialRequired = function () {
            return _this.props.showClanQuestsCard && !_this.state.hideClanQuestIntro && !(0, _playersMatching.getParsedStorageItem)(_constants.LOCAL_STORAGE_KEYS.CLAN_QUESTS_INTRO_SHOWN);
        };

        _this.onKeyDown = function (e) {
            if (e.keyCode === _constants.KEY_CODES.ESCAPE) {
                (0, _reactWotBootstrap.openHangar)();
            }
        };

        _this.resetGlobalMapTimer = function () {
            if (_this.globalMapTimerId) {
                clearTimeout(_this.globalMapTimerId);
            }
        };

        _this.resetReactiveIndicatorTimer = function () {
            if (_this.reactiveIndicatorTimerId) {
                clearTimeout(_this.reactiveIndicatorTimerId);
            }
        };

        _this.handleReactiveChannelMessage = function (c2wEvent) {
            var data = (0, _hermod.parseHermodJSONData)(c2wEvent);
            var isBattlesUpdated = data && data.type === _constants.REACTIVE_CLAN_MESSAGE_TYPE.BATTLES_UPDATED;
            var isPingEvent = data && data.type === _constants.REACTIVE_CLAN_MESSAGE_TYPE.PING;

            if (isBattlesUpdated) {
                var timeout = (0, _lodash.random)(2000, 6000);

                _this.resetGlobalMapTimer();
                _this.globalMapTimerId = setTimeout(function () {
                    _this.props.requestGlobalMapInfo(true);
                }, timeout);
            }

            if (isPingEvent) {
                _this.resetReactiveIndicatorTimer();
                _this.setState({ showReactiveIndicator: true });
                _this.reactiveIndicatorTimerId = setTimeout(function () {
                    return _this.setState({ showReactiveIndicator: false });
                }, HIDE_INDICATOR_TIMEOUT);
            }
        };

        _this.handleClanQuestIntroClose = function () {
            (0, _playersMatching.saveToStorage)(_constants.LOCAL_STORAGE_KEYS.CLAN_QUESTS_INTRO_SHOWN, true);
            _this.setState({ hideClanQuestIntro: true });
        };

        _this.state = {
            hideClanQuestIntro: true,
            showReactiveIndicator: false
        };
        return _this;
    }

    _createClass(ClanLanding, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.props.onComponentDidMount();
            this.props.loadClanLanding(this.props);
            window.addEventListener('keydown', this.onKeyDown);
            window.onBeforeUnloadHandlers.unsubscribeChannelOnExit = function () {
                _this2.unsubscribeChannel();
            };
            this.props.sendEnterLandingSoundState();

            this.props.requestGlobalMapInfo();
            this.props.requestStrongholdManeuversInfo();
            this.subscribeChannel();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.props.onComponentWillUnmount();
            window.removeEventListener('keydown', this.onKeyDown);
            delete window.onBeforeUnloadHandlers.unsubscribeChannelOnExit;

            this.resetGlobalMapTimer();
            this.resetReactiveIndicatorTimer();
            this.unsubscribeChannel();
        }
    }, {
        key: 'subscribeChannel',
        value: function subscribeChannel() {
            (0, _hermod.subscribeToChannel)(this.props.clanChannelId, this.handleReactiveChannelMessage);
        }
    }, {
        key: 'unsubscribeChannel',
        value: function unsubscribeChannel() {
            (0, _hermod.unsubscribeFromChannel)(this.props.clanChannelId, this.handleReactiveChannelMessage);
        }
    }, {
        key: 'renderHeader',
        value: function renderHeader() {
            var emblem = this.props.clan.emblem.replace('32x32', '100x100_wgsh');

            return _react2.default.createElement(
                'div',
                { className: _ClanLanding2.default.header_wrapper },
                _react2.default.createElement(
                    'header',
                    { className: _ClanLanding2.default.header },
                    _react2.default.createElement('img', {
                        className: _ClanLanding2.default.clan_logo,
                        src: emblem,
                        'data-tip': true, 'data-for': CLAN_TOOLTIP_ID
                    }),
                    _react2.default.createElement(
                        'h1',
                        null,
                        _react2.default.createElement(
                            'span',
                            { 'data-tip': true, 'data-for': CLAN_TOOLTIP_ID },
                            _react2.default.createElement(
                                'span',
                                {
                                    className: _ClanLanding2.default.clan_tag,
                                    style: { color: this.props.clan.color }
                                },
                                '[' + this.props.clan.tag + ']'
                            ),
                            '\xA0',
                            this.props.clan.name
                        )
                    ),
                    this.props.accountRole && _react2.default.createElement(
                        'small',
                        null,
                        _translations.CLAN_LANDING_ROLE_DESCRIPTION,
                        '\xA0',
                        (0, _roles.getLocalizedName)(this.props.accountRole)
                    ),
                    _react2.default.createElement(
                        _reactWotBootstrap.Tooltip,
                        { id: CLAN_TOOLTIP_ID },
                        _react2.default.createElement(_Clan2.default, this.props.clan)
                    )
                ),
                _react2.default.createElement(_ClanLandingReserves2.default, null)
            );
        }
    }, {
        key: 'renderClanQuestsIntro',
        value: function renderClanQuestsIntro() {
            if (!this.isTutorialRequired()) {
                return null;
            }

            return _react2.default.createElement(_ClanQuestsTutorialConnector2.default, { onClose: this.handleClanQuestIntroClose });
        }
    }, {
        key: 'renderMainCard',
        value: function renderMainCard() {
            return _react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)(_ClanLanding2.default.main_card, _ClanLanding2.default.card) },
                _react2.default.createElement(_MainCard2.default, { withQuests: this.props.showClanQuestsCard }),
                _react2.default.createElement('div', { className: _ClanLanding2.default.card__hover_overlay })
            );
        }
    }, {
        key: 'renderAnnouncementsCard',
        value: function renderAnnouncementsCard() {
            if (!this.props.showAnnouncements) {
                return null;
            }

            var announcementsCardClassName = (0, _classnames2.default)(_ClanLanding2.default.announcements_card, _ClanLanding2.default.card);

            return _react2.default.createElement(
                'div',
                { className: announcementsCardClassName },
                _react2.default.createElement(_AnnouncementsCard2.default, { withQuests: this.props.showClanQuestsCard }),
                _react2.default.createElement('div', { className: _ClanLanding2.default.card__hover_overlay })
            );
        }
    }, {
        key: 'renderStrongholdCard',
        value: function renderStrongholdCard() {
            var _props = this.props,
                industrialResourceMultiplier = _props.industrialResourceMultiplier,
                clientCounters = _props.clientCounters,
                showAnnouncements = _props.showAnnouncements,
                showClanQuestsCard = _props.showClanQuestsCard;


            return _react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)(_ClanLanding2.default.card, _ClanLanding2.default.stronghold_card, industrialResourceMultiplier > 1 && _ClanLanding2.default.card__multiplier)
                },
                _react2.default.createElement(_StrongholdCard2.default, {
                    withNews: showAnnouncements,
                    withQuests: showClanQuestsCard,
                    withTutorialArrow: clientCounters.items.clanNews > 0
                }),
                _react2.default.createElement('div', { className: _ClanLanding2.default.card__hover_overlay })
            );
        }
    }, {
        key: 'renderGlobalMapCard',
        value: function renderGlobalMapCard() {
            if (this.props.isManeuversEventVisible) {
                return null;
            }

            var globalMapCardClassName = (0, _classnames2.default)(_ClanLanding2.default.globalmap_card, _ClanLanding2.default.card, this.props.globalMapDisabled && _ClanLanding2.default.card__disabled);

            return _react2.default.createElement(
                'div',
                { className: globalMapCardClassName },
                this.state.showReactiveIndicator && _react2.default.createElement('div', { className: _ClanLanding2.default.reactive_indicator }),
                _react2.default.createElement(_GlobalMapCard2.default, { withNews: this.props.showAnnouncements, withQuests: this.props.showClanQuestsCard }),
                _react2.default.createElement('div', { className: _ClanLanding2.default.card__hover_overlay })
            );
        }
    }, {
        key: 'renderManeuversCard',
        value: function renderManeuversCard() {
            var _props2 = this.props,
                showAnnouncements = _props2.showAnnouncements,
                showClanQuestsCard = _props2.showClanQuestsCard,
                wgshEventsUrl = _props2.wgshEventsUrl;


            var maneuversCardClassName = (0, _classnames2.default)(_ClanLanding2.default.maneuvers_card, _ClanLanding2.default.card);

            return _react2.default.createElement(
                'div',
                { className: maneuversCardClassName },
                _react2.default.createElement(_ManeuversCard2.default, {
                    withNews: showAnnouncements,
                    withQuests: showClanQuestsCard,
                    wgshEventsUrl: wgshEventsUrl
                }),
                _react2.default.createElement('div', { className: _ClanLanding2.default.card__hover_overlay })
            );
        }
    }, {
        key: 'renderClanSupply',
        value: function renderClanSupply() {
            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)(_ClanLanding2.default.clanSupplyQuests_card, _ClanLanding2.default.card, !this.props.areQuestsEnabled && _ClanLanding2.default.card__disabled)
                    },
                    _react2.default.createElement(
                        'div',
                        { className: (0, _classnames2.default)(_cards2.default.clanSupplyCard, _cards2.default.clanSupplyCard__quests) },
                        this.props.areQuestsEnabled ? _react2.default.createElement(_ClanSupplyQuestsCard2.default, null) : _react2.default.createElement(_DisabledCard2.default, {
                            title: _translations.CLAN_SUPPLY_QUESTS_TITLE,
                            text: _translations.CLAN_SUPPLY_QUESTS_DISABLED_TEXT
                        }),
                        _react2.default.createElement('div', { className: _ClanLanding2.default.card__hover_overlay })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)(_ClanLanding2.default.clanSupplyProgression_card, _ClanLanding2.default.card, !this.props.isMapSettingsEnabled && _ClanLanding2.default.card__disabled)
                    },
                    _react2.default.createElement(
                        'div',
                        { className: (0, _classnames2.default)(_cards2.default.clanSupplyCard, _cards2.default.clanSupplyCard__progression) },
                        this.props.isMapSettingsEnabled ? _react2.default.createElement(_ClanSupplyProgressionCard2.default, { tourCoin: this.props.balance.tourcoin }) : _react2.default.createElement(_DisabledCard2.default, {
                            title: _translations.CLAN_SUPPLY_PROGRESSION_TITLE,
                            text: _translations.CLAN_SUPPLY_PROGRESSION_DISABLED_TEXT
                        })
                    ),
                    _react2.default.createElement('div', { className: _ClanLanding2.default.card__hover_overlay })
                )
            );
        }
    }, {
        key: 'getGridModifier',
        value: function getGridModifier() {
            var _props3 = this.props,
                showAnnouncements = _props3.showAnnouncements,
                showClanQuestsCard = _props3.showClanQuestsCard,
                isManeuversEventVisible = _props3.isManeuversEventVisible;


            return showAnnouncements ? showClanQuestsCard ? isManeuversEventVisible ? _ClanLanding2.default.grid__with_announcements_and_clansupply_and_maneuvers : _ClanLanding2.default.grid__with_announcements_and_clansupply : isManeuversEventVisible ? _ClanLanding2.default.grid__with_announcements_and_maneuvers : _ClanLanding2.default.grid__with_announcements : showClanQuestsCard ? isManeuversEventVisible ? _ClanLanding2.default.grid__with_clansupply_and_maneuvers : _ClanLanding2.default.grid__with_clansupply : isManeuversEventVisible ? _ClanLanding2.default.grid__with_maneuvers : null;
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.props.loading) {
                return _react2.default.createElement(_LoadingScreen2.default, { type: 'fullscreen' });
            }

            var gridClassName = (0, _classnames2.default)(_ClanLanding2.default.grid, this.getGridModifier());

            return _react2.default.createElement(
                'div',
                { className: _ClanLanding2.default.base },
                _react2.default.createElement(
                    'div',
                    {
                        className: (0, _classnames2.default)(_ClanLanding2.default.wrapper, _defineProperty({}, _ClanLanding2.default.wrapper__blurred, this.isTutorialRequired()))
                    },
                    this.renderHeader(),
                    _react2.default.createElement(
                        'div',
                        { className: gridClassName },
                        this.renderMainCard(),
                        this.renderAnnouncementsCard(),
                        this.renderStrongholdCard(),
                        this.renderGlobalMapCard(),
                        this.renderManeuversCard(),
                        this.props.showClanQuestsCard && this.renderClanSupply()
                    )
                ),
                this.renderClanQuestsIntro()
            );
        }
    }]);

    return ClanLanding;
}(_react2.default.Component);

ClanLanding.propTypes = {
    accountRole: _propTypes2.default.string,
    clan: _propTypes2.default.object.isRequired,
    clanChannelId: _propTypes2.default.string.isRequired,
    client: _propTypes2.default.object.isRequired,
    clientCounters: _propTypes2.default.object.isRequired,
    showAnnouncements: _propTypes2.default.bool,
    globalMapDisabled: _propTypes2.default.bool,
    showClanQuestsCard: _propTypes2.default.bool,
    loading: _propTypes2.default.bool,
    industrialResourceMultiplier: _propTypes2.default.number.isRequired,

    loadClanLanding: _propTypes2.default.func.isRequired,
    requestGlobalMapInfo: _propTypes2.default.func.isRequired,
    sendEnterLandingSoundState: _propTypes2.default.func.isRequired,
    isManeuversEventVisible: _propTypes2.default.bool.isRequired,
    requestStrongholdManeuversInfo: _propTypes2.default.func.isRequired,
    wgshEventsUrl: _propTypes2.default.string.isRequired,
    areQuestsEnabled: _propTypes2.default.bool,
    isMapSettingsEnabled: _propTypes2.default.bool,
    onComponentDidMount: _propTypes2.default.func.isRequired,
    onComponentWillUnmount: _propTypes2.default.func.isRequired,
    balance: _propTypes2.default.shape({
        tourcoin: _propTypes2.default.number.isRequired
    })
};
var isClanSupplyQuestsLoading = exports.isClanSupplyQuestsLoading = function isClanSupplyQuestsLoading(_ref) {
    var clanSupplyQuests = _ref.clanSupplyQuests,
        client = _ref.client;

    var clanSupplyQuestsDataLoadingFirstTime = clanSupplyQuests.loading && !(clanSupplyQuests.loaded || clanSupplyQuests.errorMessage);
    var clientProductsLoading = client.loading;

    return clanSupplyQuestsDataLoadingFirstTime || clientProductsLoading;
};

var isClanSupplyProgressionSettingsLoading = exports.isClanSupplyProgressionSettingsLoading = function isClanSupplyProgressionSettingsLoading(_ref2) {
    var clanSupplyProgressionSettings = _ref2.clanSupplyProgressionSettings,
        client = _ref2.client;

    var dataLoadingFirstTime = clanSupplyProgressionSettings.loading && !(clanSupplyProgressionSettings.loaded || clanSupplyProgressionSettings.errorMessage);

    var clientProductsLoading = client.loading;

    return dataLoadingFirstTime || clientProductsLoading;
};

var isClanSupplyProgressionLoading = exports.isClanSupplyProgressionLoading = function isClanSupplyProgressionLoading(_ref3) {
    var clanSupplyProgression = _ref3.clanSupplyProgression,
        client = _ref3.client;

    var dataLoadingFirstTime = clanSupplyProgression.loading && !(clanSupplyProgression.loaded || clanSupplyProgression.errorMessage);

    var clientProductsLoading = client.loading;

    return dataLoadingFirstTime || clientProductsLoading;
};

/* eslint-disable complexity  */
var stateToProps = exports.stateToProps = function stateToProps(state) {
    return {
        clan: state.clan,
        clanChannelId: 'gm_clan_' + state.clan.id,
        client: state.client,
        clientCounters: state.clientCounters,
        accountRole: state.account.role,
        globalMapDisabled: !state.globalMap.context_id || !state.settings.globalMapUrl,
        showClanQuestsCard: state.settings.showClanQuestsCard,
        wgshEventsUrl: state.settings.wgshEventsUrl,
        industrialResourceMultiplier: state.settings.industrialResourceMultiplier,
        showAnnouncements: state.announcements.list.length > 0 || state.webbrg.clanNews.length > 0 || state.announcements.settings.can_create_messages,
        loading: state.announcements.isLoading || !state.stronghold.level ||
        // we have reactive updates from a server for the global map object
        // so loading screen should be shown only on initial loading
        !state.globalMap.loaded && state.globalMap.loading || state.webbrg.loading || !state.shop.statusLoaded && !state.shop.errorMessage || !state.clientCounters.loaded && state.clientCounters.loading || isClanSupplyQuestsLoading(state) || isClanSupplyProgressionSettingsLoading(state) || isClanSupplyProgressionLoading(state),
        areQuestsEnabled: state.clanSupplyQuests && state.clanSupplyQuests.enabled ? (0, _selectors.selectQuests)(state).enabled : false,
        isMapSettingsEnabled: state.clanSupplyProgressionSettings && state.clanSupplyProgression ? state.clanSupplyProgressionSettings.enabled && !state.clanSupplyProgression.errorMessage : false,
        balance: state.balance
    };
};

var dispatchToProps = exports.dispatchToProps = function dispatchToProps(dispatch) {
    return {
        onComponentDidMount: function onComponentDidMount() {
            dispatch((0, _balance.requestBalance)());
            (0, _client2web.addWOTClientListener)(_client2web.C2W_EVENT_TYPES.UPDATE_BALANCE, dispatch);
            (0, _client2web.addWOTClientListener)(_client2web.C2W_EVENT_TYPES.WALLET_UPDATE, dispatch);
        },
        onComponentWillUnmount: function onComponentWillUnmount() {
            (0, _client2web.removeWOTClientListener)(_client2web.C2W_EVENT_TYPES.UPDATE_BALANCE, dispatch);
            (0, _client2web.removeWOTClientListener)(_client2web.C2W_EVENT_TYPES.WALLET_UPDATE, dispatch);
        },
        loadClanLanding: function loadClanLanding(_ref4) {
            var showClanQuestsCard = _ref4.showClanQuestsCard;

            dispatch((0, _announcements.requestAnnouncements)());
            dispatch((0, _craft_machine.requestCraftMachineInfo)());
            dispatch((0, _challenges.requestNextChallengeInfo)());
            dispatch((0, _clan_landing.requestClanLanding)());
            dispatch((0, _webbrg.requestNews)());
            dispatch((0, _shop.requestShopStatus)());
            dispatch((0, _client_counters.requestClientCounters)());
            dispatch((0, _client.requestServerTimestamp)());
            if (showClanQuestsCard) {
                dispatch((0, _clan_supply_quests.requestClanSupplyQuestsInfo)());
                dispatch((0, _clan_supply_progression_main.requestClanSupplyProgressionMainInfo)());
            }
        },
        requestGlobalMapInfo: function requestGlobalMapInfo(notResetState) {
            return dispatch((0, _global_map.requestGlobalMapInfo)(notResetState));
        },
        sendEnterLandingSoundState: function sendEnterLandingSoundState() {
            return dispatch((0, _sounds.sendEnterLandingSoundState)());
        },
        requestStrongholdManeuversInfo: function requestStrongholdManeuversInfo() {
            return dispatch((0, _stronghold_maneuvers.requestStrongholdManeuversInfo)());
        }
    };
};

exports.default = (0, _reactRedux.connect)(stateToProps, dispatchToProps)(ClanLanding);

/***/ }),
/* 2308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MainCard = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(7);

var _reactRouterRedux = __webpack_require__(15);

var _reactIntl = __webpack_require__(3);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _urls = __webpack_require__(19);

var _reactWotBootstrap = __webpack_require__(5);

var _roles = __webpack_require__(49);

var _web_to_client = __webpack_require__(12);

var _propTypes3 = __webpack_require__(298);

var _app = __webpack_require__(566);

var _clan_members_online = __webpack_require__(369);

var _clan_members_online2 = _interopRequireDefault(_clan_members_online);

var _ClanManagement = __webpack_require__(102);

var _sounds = __webpack_require__(22);

var _constants = __webpack_require__(549);

var _translations = __webpack_require__(78);

var _CurrencyTooltip = __webpack_require__(1360);

var _CurrencyTooltip2 = _interopRequireDefault(_CurrencyTooltip);

var _ButtonInbox = __webpack_require__(1361);

var _ButtonInbox2 = _interopRequireDefault(_ButtonInbox);

var _cards = __webpack_require__(94);

var _cards2 = _interopRequireDefault(_cards);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CLAN_MANAGEMENT_TOOLTIP_ID = 'clan_panel_management_tooltip';

var MainCard = exports.MainCard = function (_React$Component) {
    _inherits(MainCard, _React$Component);

    function MainCard() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, MainCard);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MainCard.__proto__ || Object.getPrototypeOf(MainCard)).call.apply(_ref, [this].concat(args))), _this), _this.openInvites = function (event) {
            event.preventDefault();
            event.stopPropagation();

            _this.props.openInvites();
        }, _this.openClanSearch = function (event) {
            event.preventDefault();
            event.stopPropagation();

            _this.props.openClanSearch();
        }, _this.openClanCard = function (event) {
            event.preventDefault();
            event.stopPropagation();

            (0, _web_to_client.openClanCard)({
                id: _this.props.clan.id,
                tag: _this.props.clan.tag
            });
        }, _this.handleOpenClanManagement = function () {
            _this.props.openClanManagement();
            _this.props.sendEnterMainCardSoundState();
            _this.props.playEnterMainCardSound();
        }, _this.renderTreasury = function () {
            if (!_this.props.canSeeTreasury) return null;

            var _this$props$treasury = _this.props.treasury,
                crystal = _this$props$treasury.crystal,
                gold = _this$props$treasury.gold;


            return _react2.default.createElement(
                'div',
                { className: _cards2.default.treasury },
                _react2.default.createElement(
                    'h2',
                    null,
                    _translations.CLAN_TREASURY
                ),
                _react2.default.createElement(
                    'div',
                    { className: _cards2.default.currency },
                    crystal !== undefined && _react2.default.createElement(
                        'span',
                        {
                            className: (0, _classnames2.default)(_cards2.default.crystal, crystal === 0 && _cards2.default.crystal__empty),
                            'data-tip': true, 'data-for': 'clan_panel_currency_tooltip_crystal'
                        },
                        _react2.default.createElement(_reactIntl.FormattedNumber, { value: crystal }),
                        _react2.default.createElement(_CurrencyTooltip2.default, { amount: crystal, type: 'crystal' })
                    ),
                    gold !== undefined && _react2.default.createElement(
                        'span',
                        {
                            className: (0, _classnames2.default)(_cards2.default.gold, gold === 0 && _cards2.default.gold__empty),
                            'data-tip': true, 'data-for': 'clan_panel_currency_tooltip_gold'
                        },
                        _react2.default.createElement(_reactIntl.FormattedNumber, { value: gold }),
                        _react2.default.createElement(_CurrencyTooltip2.default, { amount: gold, type: 'gold' })
                    )
                )
            );
        }, _this.renderEntryPoints = function () {
            var inbox = void 0;
            if (_this.props.canHandleInvites) {
                var messages = _this.props.clan.applications_count > 99 ? '99+' : _this.props.clan.applications_count;

                inbox = _react2.default.createElement(_ButtonInbox2.default, {
                    type: 'miniSecondary',
                    messages: messages,
                    onClick: _this.openInvites,
                    muteClick: true
                });
            }

            return _react2.default.createElement(
                'div',
                { className: _cards2.default.buttons_wrapper },
                _react2.default.createElement(
                    _reactWotBootstrap.ButtonSmall,
                    {
                        type: 'miniSecondary',
                        tooltipId: 'entrypoint_tooltip_search',
                        onClick: _this.openClanCard,
                        muteClick: true
                    },
                    _react2.default.createElement('div', { className: _cards2.default.icon_clan }),
                    _react2.default.createElement(
                        _reactWotBootstrap.Tooltip,
                        { id: 'entrypoint_tooltip_search' },
                        _translations.ENTRYPOINT_CLAN
                    )
                ),
                inbox,
                _react2.default.createElement(
                    _reactWotBootstrap.ButtonSmall,
                    {
                        type: 'miniSecondary',
                        tooltipId: 'entrypoint_tooltip_clan',
                        onClick: _this.openClanSearch,
                        muteClick: true
                    },
                    _react2.default.createElement('div', { className: _cards2.default.icon_search }),
                    _react2.default.createElement(
                        _reactWotBootstrap.Tooltip,
                        { id: 'entrypoint_tooltip_clan' },
                        _translations.ENTRYPOINT_SEARCH
                    )
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(MainCard, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.requestMembersStatus();
            this.requestMembersTimeout = setInterval(this.props.requestMembersStatus, 3000);

            if (this.props.canHandleInvites) {
                this.props.requestClanExtendedInfo();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            clearInterval(this.requestMembersTimeout);
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames;

            var mainCardClassNames = (0, _classnames2.default)(_cards2.default.main, _cards2.default.card, (_classNames = {}, _defineProperty(_classNames, _cards2.default.main__cn, !this.props.withQuests && this.props.isCNRealm), _defineProperty(_classNames, _cards2.default.main__with_quests, this.props.withQuests), _defineProperty(_classNames, _cards2.default.main__with_quests_cn, this.props.withQuests && this.props.isCNRealm), _classNames));

            return _react2.default.createElement(
                'div',
                {
                    className: mainCardClassNames,
                    onClick: this.handleOpenClanManagement,
                    onMouseDown: _reactWotBootstrap.sendClickSoundCommand,
                    onMouseEnter: _reactWotBootstrap.sendHoverSoundCommand
                },
                _react2.default.createElement(
                    'h2',
                    null,
                    _constants.CLAN_MANAGEMENT_TITLE
                ),
                _react2.default.createElement(
                    'span',
                    {
                        className: _cards2.default.members_online,
                        'data-tip': true,
                        'data-for': CLAN_MANAGEMENT_TOOLTIP_ID
                    },
                    _react2.default.createElement(
                        'span',
                        { className: _cards2.default.count_online },
                        this.props.membersOnline
                    ),
                    '\xA0',
                    _react2.default.createElement(
                        'span',
                        { className: _cards2.default.count_delimiter },
                        '/'
                    ),
                    '\xA0',
                    this.props.membersTotal
                ),
                this.renderTreasury(),
                this.renderEntryPoints(),
                _react2.default.createElement(
                    _reactWotBootstrap.Tooltip,
                    { id: CLAN_MANAGEMENT_TOOLTIP_ID },
                    _react2.default.createElement(
                        'div',
                        { className: _cards2.default.tooltipContent },
                        _react2.default.createElement(
                            'p',
                            { className: _cards2.default.tooltipSubtitle },
                            _constants.CLAN_MANAGEMENT_TITLE
                        ),
                        _react2.default.createElement(
                            'p',
                            { className: _cards2.default.tooltipMessage },
                            (0, _constants.MEMBERS_ONLINE_TOOLTIP)(this.props.membersOnline, this.props.membersTotal)
                        ),
                        _react2.default.createElement(
                            'p',
                            { className: _cards2.default.tooltipMessage },
                            _constants.CLAN_MANAGEMENT_TOOLTIP_FOOTER
                        )
                    )
                )
            );
        }
    }]);

    return MainCard;
}(_react2.default.Component);

MainCard.propTypes = {
    clan: _propTypes2.default.object.isRequired,
    membersOnline: _propTypes2.default.number,
    membersTotal: _propTypes2.default.number,
    canSeeTreasury: _propTypes2.default.bool,
    canHandleInvites: _propTypes2.default.bool,
    treasury: _propTypes3.treasuryPropTypes,
    withQuests: _propTypes2.default.bool,
    isCNRealm: _propTypes2.default.bool,

    openInvites: _propTypes2.default.func.isRequired,
    openClanManagement: _propTypes2.default.func.isRequired,
    openClanSearch: _propTypes2.default.func.isRequired,
    requestMembersStatus: _propTypes2.default.func.isRequired,
    requestClanExtendedInfo: _propTypes2.default.func.isRequired,
    sendEnterMainCardSoundState: _propTypes2.default.func.isRequired,
    playEnterMainCardSound: _propTypes2.default.func.isRequired
};


var stateToProps = function stateToProps(state) {
    var _state$clanMembersOnl = state.clanMembersOnline,
        membersOnline = _state$clanMembersOnl.membersOnline,
        membersTotal = _state$clanMembersOnl.membersTotal;

    return {
        clan: state.clan,
        membersOnline: membersOnline,
        membersTotal: membersTotal,
        canSeeTreasury: state.account.permissions.see_treasury,
        canHandleInvites: (0, _roles.hasPermission)(state.account.role, _roles.permissions.HANDLE_INVITES),
        treasury: state.clan.treasury,
        isCNRealm: state.settings.isCNRealm
    };
};

var dispatchToProps = {
    openInvites: _ClanManagement.openInvitesApplicationsWindow,
    openClanSearch: _app.openClanSearch,
    openClanManagement: function openClanManagement() {
        return (0, _reactRouterRedux.push)(_urls.CLAN_MANAGEMENT);
    },
    requestMembersStatus: _clan_members_online2.default,
    requestClanExtendedInfo: _ClanManagement.requestClanExtendedInfo,
    sendEnterMainCardSoundState: _sounds.sendEnterMainCardSoundState,
    playEnterMainCardSound: _sounds.playEnterMainCardSound
};

exports.default = (0, _reactRedux.connect)(stateToProps, dispatchToProps)(MainCard);

/***/ }),
/* 2309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EARN_RESOURCES_ON_GLOBAL_MAP = exports.NOW_IN_TREASURY = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-multi-comp */

var NOW_IN_TREASURY = exports.NOW_IN_TREASURY = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_panel.item.now_in_treasury',
    defaultMessage: '\u0421\u0435\u0439\u0447\u0430\u0441 \u0432 \u043A\u0430\u0437\u043D\u0435:'
});

var EARN_RESOURCES_ON_GLOBAL_MAP = exports.EARN_RESOURCES_ON_GLOBAL_MAP = {
    gold: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'clan_panel.item.currency.earn_resources.gold',
        defaultMessage: '\u0417\u0430\u0440\u0430\u0431\u043E\u0442\u0430\u0442\u044C \u0437\u043E\u043B\u043E\u0442\u043E \u0432 \u043A\u0430\u0437\u043D\u0443 \u043A\u043B\u0430\u043D\u0430 \u043C\u043E\u0436\u043D\u043E \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435.'
    }),
    crystal: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'clan_panel.item.currency.earn_resources.crystal',
        defaultMessage: '\u0417\u0430\u0440\u0430\u0431\u043E\u0442\u0430\u0442\u044C \u0431\u043E\u043D\u044B \u0432 \u043A\u0430\u0437\u043D\u0443 \u043A\u043B\u0430\u043D\u0430 \u043C\u043E\u0436\u043D\u043E \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435.'
    }),
    credits: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'clan_panel.item.currency.earn_resources.silver',
        defaultMessage: '\u0417\u0430\u0440\u0430\u0431\u043E\u0442\u0430\u0442\u044C \u043A\u0440\u0435\u0434\u0438\u0442\u044B \u0432 \u043A\u0430\u0437\u043D\u0443 \u043A\u043B\u0430\u043D\u0430 \u043C\u043E\u0436\u043D\u043E \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435.'
    })
};

/***/ }),
/* 2310 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"root":"CurrencyTooltip_root--3sk3o","root__show":"CurrencyTooltip_root__show--JZC1v","rootShow":"CurrencyTooltip_root__show--JZC1v","body":"CurrencyTooltip_body--1fzL9","wrapper":"CurrencyTooltip_wrapper--3iMe8","content":"CurrencyTooltip_content--3STT9","title":"CurrencyTooltip_title--1CiuJ","subtitle":"CurrencyTooltip_subtitle--1AF7-","message":"CurrencyTooltip_message--330B5","warning":"CurrencyTooltip_warning--3B7iw","divider":"CurrencyTooltip_divider--24lNu","highlight":"CurrencyTooltip_highlight--Ws1EU","ribbon":"CurrencyTooltip_ribbon--2slbn","statusMessage":"CurrencyTooltip_statusMessage--HXbyo","statusMessage__positive":"CurrencyTooltip_statusMessage__positive--3A_zq","statusMessagePositive":"CurrencyTooltip_statusMessage__positive--3A_zq","status":"CurrencyTooltip_status--2hNpa","statusMessage__negative":"CurrencyTooltip_statusMessage__negative--3_Lwr","statusMessageNegative":"CurrencyTooltip_statusMessage__negative--3_Lwr","statusMessage__noPermission":"CurrencyTooltip_statusMessage__noPermission--34kFa","statusMessageNoPermission":"CurrencyTooltip_statusMessage__noPermission--34kFa","status__positive":"CurrencyTooltip_status__positive--1pWz9","statusPositive":"CurrencyTooltip_status__positive--1pWz9","status__negative":"CurrencyTooltip_status__negative--xjqdm","statusNegative":"CurrencyTooltip_status__negative--xjqdm","statusText":"CurrencyTooltip_statusText--3aBjd"};

/***/ }),
/* 2311 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"icon":"ButtonInbox_icon--1ioSP","base__new-message":"ButtonInbox_base__new-message---ieDJ","baseNewMessage":"ButtonInbox_base__new-message---ieDJ","messages":"ButtonInbox_messages--18o6d"};

/***/ }),
/* 2312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StrongholdCard = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(7);

var _reactRouterRedux = __webpack_require__(15);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactWotBootstrap = __webpack_require__(5);

var _helpers = __webpack_require__(11);

var _datetime = __webpack_require__(13);

var _i18n = __webpack_require__(10);

var _challenges = __webpack_require__(240);

var _sounds = __webpack_require__(22);

var _urls = __webpack_require__(19);

var _constants = __webpack_require__(4);

var _IndustrialResourceCoefTooltip = __webpack_require__(163);

var _IndustrialResourceCoefTooltip2 = _interopRequireDefault(_IndustrialResourceCoefTooltip);

var _IndustrialResource = __webpack_require__(35);

var _IndustrialResource2 = _interopRequireDefault(_IndustrialResource);

var _Timer = __webpack_require__(51);

var _Timer2 = _interopRequireDefault(_Timer);

var _StorageTooltip = __webpack_require__(1344);

var _StorageTooltip2 = _interopRequireDefault(_StorageTooltip);

var _TutorialArrow = __webpack_require__(1334);

var _constants2 = __webpack_require__(1335);

var _translations = __webpack_require__(78);

var _cards = __webpack_require__(94);

var _cards2 = _interopRequireDefault(_cards);

var _IndustrialBuyinTooltip = __webpack_require__(1346);

var _IndustrialBuyinTooltip2 = _interopRequireDefault(_IndustrialBuyinTooltip);

var _googleAnalytic = __webpack_require__(581);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StrongholdCard = exports.StrongholdCard = function (_React$Component) {
    _inherits(StrongholdCard, _React$Component);

    function StrongholdCard() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, StrongholdCard);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = StrongholdCard.__proto__ || Object.getPrototypeOf(StrongholdCard)).call.apply(_ref, [this].concat(args))), _this), _this.handleOpenShop = function (event) {
            event.preventDefault();
            event.stopPropagation();

            (0, _googleAnalytic.trackEvent)(_googleAnalytic.GA_ACTIONS.TO_STOREFRONT, _googleAnalytic.GA_LABEL.FROM_CLAN_LANDING_SCREEN);
            _this.props.openShop();
        }, _this.handleIndustrialResourceBuyin = function (event) {
            event.preventDefault();
            event.stopPropagation();

            (0, _reactWotBootstrap.sendButtonClickSoundCommand)();
        }, _this.handleOpenStronghold = function () {
            _this.props.openStronghold();
            _this.props.sendEnterStrongholdSoundState();
            _this.props.playEnterStrongholdSound();
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(StrongholdCard, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate(oldProps) {
            if (this.props.challenge.start_datetime !== oldProps.challenge.start_datetime) {
                var timeToStart = this.props.challenge.start_datetime - Date.now();
                if (timeToStart > 0) {
                    clearTimeout(this.timeToChallengeTimeoutId);
                    this.timeToChallengeTimeoutId = setTimeout(this.props.requestNextChallengeInfo, Math.min(timeToStart + 1000, _constants.MAX_SET_TIMEOUT_VALUE));
                }
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            clearTimeout(this.timeToChallengeTimeoutId);
        }
    }, {
        key: 'renderChallengesStatus',
        value: function renderChallengesStatus() {
            var now = Date.now();
            var _props$challenge = this.props.challenge,
                start_datetime = _props$challenge.start_datetime,
                end_datetime = _props$challenge.end_datetime;


            if (!start_datetime && !end_datetime) {
                return _translations.CHALLENGES_OFF;
            }
            if (now > start_datetime && now < end_datetime) {
                var timer = _react2.default.createElement(_Timer2.default, {
                    endTime: (0, _moment2.default)(end_datetime),
                    onExpire: this.props.requestNextChallengeInfo,
                    onExpireDelay: 1000
                });
                return _react2.default.createElement(
                    'span',
                    null,
                    _translations.CHALLENGES,
                    '\xA0',
                    (0, _translations.CHALLENGES_TIMER)(_react2.default.createElement(
                        'span',
                        { className: _cards2.default.timer },
                        timer
                    ))
                );
            }

            var momentDate = (0, _moment2.default)(start_datetime);
            return _react2.default.createElement(
                'span',
                null,
                _translations.CHALLENGES,
                '\xA0',
                (0, _datetime.getEndDateMessage)(momentDate)
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames;

            var _props = this.props,
                industrialResourceMultiplier = _props.industrialResourceMultiplier,
                strongholdLevel = _props.strongholdLevel,
                industrialResourceBuyinAvailable = _props.industrialResourceBuyinAvailable,
                industrialResource = _props.industrialResource,
                withQuests = _props.withQuests,
                withNews = _props.withNews,
                withTutorialArrow = _props.withTutorialArrow;


            var className = (0, _classnames2.default)(_cards2.default.card, _cards2.default.stronghold, (_classNames = {}, _defineProperty(_classNames, _cards2.default.stronghold__with_news, withNews && !withQuests), _defineProperty(_classNames, _cards2.default.stronghold__with_quests, withQuests && !withNews), _defineProperty(_classNames, _cards2.default.stronghold__with_news_with_quests, withNews && withQuests), _classNames));
            var balanceClassName = (0, _classnames2.default)(_cards2.default.balance, industrialResource < 0 && _cards2.default.balance_notEnough);

            var arrowHintClassName = !withNews && !withQuests && _cards2.default.tutorialArrow;

            return _react2.default.createElement(
                'div',
                {
                    className: className,
                    onClick: this.handleOpenStronghold,
                    onMouseDown: _reactWotBootstrap.sendClickSoundCommand,
                    onMouseEnter: _reactWotBootstrap.sendHoverSoundCommand
                },
                withTutorialArrow && _react2.default.createElement(_TutorialArrow.TutorialArrow, {
                    classNames: {
                        hint: arrowHintClassName
                    },
                    showBorder: false,
                    arrowPosition: _constants2.ArrowPosition.Left,
                    text: _translations.STRONGHOLD_UPDATED
                }),
                industrialResourceMultiplier > 1 && _react2.default.createElement(
                    'span',
                    {
                        className: _cards2.default.multiplier,
                        'data-tip': true, 'data-for': _IndustrialResourceCoefTooltip2.default.id
                    },
                    (0, _i18n.INDUSTRIAL_RESOURCE_MULTIPLIER)(industrialResourceMultiplier)
                ),
                industrialResourceMultiplier > 1 && _react2.default.createElement(_IndustrialResourceCoefTooltip2.default, { multiplier: industrialResourceMultiplier }),
                _react2.default.createElement(
                    'h2',
                    null,
                    _i18n.STRONGHOLD,
                    _react2.default.createElement(
                        'span',
                        { className: _cards2.default.stronghold_level },
                        strongholdLevel
                    )
                ),
                _react2.default.createElement(
                    'h3',
                    null,
                    this.renderChallengesStatus()
                ),
                _react2.default.createElement(
                    'div',
                    { className: balanceClassName },
                    _react2.default.createElement(_IndustrialResource2.default, {
                        value: industrialResource,
                        custom: true,
                        iconAtLeft: true,
                        notEnough: industrialResource < 0,
                        popoverId: _StorageTooltip2.default.id
                    }),
                    industrialResourceBuyinAvailable && _react2.default.createElement('div', {
                        className: _cards2.default.industrialResourceBuyin,
                        onMouseDown: this.handleIndustrialResourceBuyin,
                        onMouseEnter: _reactWotBootstrap.sendHoverSoundCommand,
                        onClick: this.handleOpenShop,
                        'data-tip': true,
                        'data-for': _IndustrialBuyinTooltip2.default.id
                    }),
                    industrialResourceBuyinAvailable && _react2.default.createElement(_IndustrialBuyinTooltip2.default, null),
                    _react2.default.createElement(_StorageTooltip2.default, {
                        industrialResource: industrialResource,
                        showFooter: false
                    })
                )
            );
        }
    }]);

    return StrongholdCard;
}(_react2.default.Component);

StrongholdCard.propTypes = {
    requestNextChallengeInfo: _propTypes2.default.func.isRequired,
    openStronghold: _propTypes2.default.func.isRequired,
    openShop: _propTypes2.default.func.isRequired,

    challenge: _propTypes2.default.object.isRequired,
    strongholdLevel: _propTypes2.default.string,
    industrialResource: _propTypes2.default.number,
    industrialResourceMultiplier: _propTypes2.default.number.isRequired,
    industrialResourceBuyinAvailable: _propTypes2.default.bool.isRequired,

    withNews: _propTypes2.default.bool,
    withQuests: _propTypes2.default.bool,
    withTutorialArrow: _propTypes2.default.bool,

    sendEnterStrongholdSoundState: _propTypes2.default.func.isRequired,
    playEnterStrongholdSound: _propTypes2.default.func.isRequired
};


var stateToProps = function stateToProps(state) {
    return {
        industrialResourceMultiplier: state.settings.industrialResourceMultiplier,
        industrialResource: state.clan.industrial_resource,
        industrialResourceBuyinAvailable: !!state.shop.status && state.shop.status.enabled,
        challenge: state.challenges.nextChallenge,
        strongholdLevel: (0, _helpers.toRoman)(state.stronghold.level)
    };
};

var dispatchToProps = {
    openStronghold: function openStronghold() {
        return (0, _reactRouterRedux.push)(_urls.STRONGHOLD);
    },
    openShop: function openShop() {
        return (0, _reactRouterRedux.push)(_urls.SHOP_STOREFRONT);
    },
    requestNextChallengeInfo: _challenges.requestNextChallengeInfo,
    sendEnterStrongholdSoundState: _sounds.sendEnterStrongholdSoundState,
    playEnterStrongholdSound: _sounds.playEnterStrongholdSound
};

exports.default = (0, _reactRedux.connect)(stateToProps, dispatchToProps)(StrongholdCard);

/***/ }),
/* 2313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.GlobalMapCard = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(7);

var _reactRouterRedux = __webpack_require__(15);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

var _datetime = __webpack_require__(13);

var _isEmpty = __webpack_require__(157);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _reactWotBootstrap = __webpack_require__(5);

var _web_to_client = __webpack_require__(12);

var _sounds = __webpack_require__(22);

var _FamePoints = __webpack_require__(143);

var _FamePoints2 = _interopRequireDefault(_FamePoints);

var _translations = __webpack_require__(78);

var _urls = __webpack_require__(19);

var _cards = __webpack_require__(94);

var _cards2 = _interopRequireDefault(_cards);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GlobalMapCard = exports.GlobalMapCard = function (_React$Component) {
    _inherits(GlobalMapCard, _React$Component);

    function GlobalMapCard(props) {
        _classCallCheck(this, GlobalMapCard);

        var _this = _possibleConstructorReturn(this, (GlobalMapCard.__proto__ || Object.getPrototypeOf(GlobalMapCard)).call(this, props));

        _this.handleClick = function () {
            var _this$props = _this.props,
                isSomeServiceEnabled = _this$props.isSomeServiceEnabled,
                isCraftServiceEnabled = _this$props.isCraftServiceEnabled,
                personalBonusesEnabled = _this$props.personalBonusesEnabled,
                eventRewardsEnabled = _this$props.eventRewardsEnabled,
                leaderboardsEnabled = _this$props.leaderboardsEnabled,
                battleScheduleEnabled = _this$props.battleScheduleEnabled,
                openPersonalShop = _this$props.openPersonalShop,
                openEventRewards = _this$props.openEventRewards,
                openBattleSchedule = _this$props.openBattleSchedule,
                openLeaderboards = _this$props.openLeaderboards,
                sendEnterGlobalMapSoundState = _this$props.sendEnterGlobalMapSoundState,
                playEnterGlobalMapSound = _this$props.playEnterGlobalMapSound,
                craftMachineUrl = _this$props.craftMachineUrl,
                signInTokenUrl = _this$props.signInTokenUrl,
                externalUrl = _this$props.externalUrl;


            switch (true) {
                case !isSomeServiceEnabled:
                    return (0, _web_to_client.openExternalBrowserWithAuth)(signInTokenUrl, externalUrl);
                case leaderboardsEnabled:
                    openLeaderboards();
                    break;
                case isCraftServiceEnabled:
                    window.location.href = craftMachineUrl;
                    return sendEnterGlobalMapSoundState();
                case eventRewardsEnabled:
                    openEventRewards();
                    break;
                case personalBonusesEnabled:
                    openPersonalShop();
                    break;
                case battleScheduleEnabled:
                    openBattleSchedule();
                    break;
            }

            sendEnterGlobalMapSoundState();
            playEnterGlobalMapSound();
        };

        _this.state = {
            time: (0, _moment2.default)().unix()
        };
        return _this;
    }

    _createClass(GlobalMapCard, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.interval = setInterval(function () {
                return _this2.setState({ time: (0, _moment2.default)().unix() });
            }, 10000);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            clearInterval(this.interval);
        }
    }, {
        key: 'getStartDateMessage',
        value: function getStartDateMessage(startDate, isPlanned) {
            if ((0, _datetime.isTodayDay)(startDate)) {
                return (0, _translations.TODAY_TIME)(startDate, isPlanned);
            } else if ((0, _datetime.isTomorrowDay)(startDate)) {
                return (0, _translations.TOMMOROW_TIME)(startDate, isPlanned);
            }

            return (0, _translations.CUSTOM_DATE_TIME)(startDate, isPlanned);
        }
    }, {
        key: 'renderBattleSchedule',
        value: function renderBattleSchedule() {
            var nowTimestamp = this.state.time;
            var _props$nearestBattle = this.props.nearestBattle,
                battleDate = _props$nearestBattle.starts_at,
                isPlanned = _props$nearestBattle.is_planned;

            var momentBattleDate = _moment2.default.unix(battleDate);

            if (!battleDate) return;
            if (nowTimestamp > battleDate) {
                return _react2.default.createElement(
                    'div',
                    { className: _cards2.default.battleBox },
                    _react2.default.createElement(
                        'div',
                        { className: _cards2.default.battleDate },
                        _react2.default.createElement(
                            'span',
                            { className: _cards2.default.battleText },
                            _translations.BATTLES_NOW
                        )
                    )
                );
            }
            return _react2.default.createElement(
                'div',
                { className: _cards2.default.battleBox,
                    'data-tip': true,
                    'data-for': 'global_map_card_battle_date'
                },
                _react2.default.createElement(
                    'div',
                    { className: _cards2.default.battleDate },
                    this.getStartDateMessage(momentBattleDate, isPlanned)
                ),
                _react2.default.createElement(
                    _reactWotBootstrap.Tooltip,
                    { id: 'global_map_card_battle_date' },
                    _react2.default.createElement(
                        'p',
                        { className: _cards2.default['tooltip-message'] },
                        _translations.GLOBAL_MAP_NEAREST_BATTLE_TIME
                    )
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                isSomeServiceEnabled = _props.isSomeServiceEnabled,
                isGlobalMapEnabled = _props.isGlobalMapEnabled,
                battleScheduleEnabled = _props.battleScheduleEnabled,
                eventName = _props.eventName,
                nearestBattle = _props.nearestBattle,
                famePoints = _props.famePoints;


            if (!eventName || !isGlobalMapEnabled) {
                var lockedGlobalCardClassNames = this.getGlobalCardClassNames(_cards2.default.global_map__locked);

                return _react2.default.createElement(
                    'div',
                    { className: lockedGlobalCardClassNames },
                    _react2.default.createElement(
                        'div',
                        { className: _cards2.default.locked_description },
                        _react2.default.createElement(
                            'h2',
                            null,
                            _translations.GLOBAL_MAP
                        ),
                        _react2.default.createElement(
                            'h3',
                            null,
                            _translations.GLOBAL_MAP_DISABLED
                        )
                    )
                );
            }

            var globalCardClassNames = this.getGlobalCardClassNames();

            var title = isSomeServiceEnabled ? eventName : _translations.GLOBAL_MAP;

            var subtitle = isSomeServiceEnabled ? _translations.GLOBAL_MAP : eventName;

            var renderBattleSchedule = battleScheduleEnabled && nearestBattle && !(0, _isEmpty2.default)(nearestBattle);

            return _react2.default.createElement(
                'div',
                {
                    className: globalCardClassNames,
                    onClick: this.handleClick,
                    onMouseDown: _reactWotBootstrap.sendClickSoundCommand,
                    onMouseEnter: _reactWotBootstrap.sendHoverSoundCommand
                },
                renderBattleSchedule && _react2.default.createElement(
                    'div',
                    { className: _cards2.default.battleHolder },
                    this.renderBattleSchedule()
                ),
                _react2.default.createElement(
                    'h2',
                    null,
                    title
                ),
                _react2.default.createElement(
                    'h3',
                    null,
                    subtitle
                ),
                _react2.default.createElement(
                    'div',
                    {
                        className: _cards2.default.famePoints,
                        'data-tip': true,
                        'data-for': 'fame_points'
                    },
                    famePoints !== undefined && _react2.default.createElement(
                        'reactFragment',
                        null,
                        _react2.default.createElement(_FamePoints2.default, {
                            value: famePoints,
                            iconPosition: 'before',
                            mixClassName: _cards2.default.pfp
                        }),
                        _react2.default.createElement(
                            _reactWotBootstrap.Tooltip,
                            { id: 'fame_points' },
                            _react2.default.createElement(
                                'p',
                                { className: _cards2.default['tooltip-subtitle'] },
                                _translations.PERSONAL_FAME_POINTS
                            ),
                            _react2.default.createElement(
                                'p',
                                { className: _cards2.default['tooltip-message'] },
                                (0, _translations.PERSONAL_FAME_POINTS_BALANCE)(_react2.default.createElement(_FamePoints2.default, {
                                    value: famePoints,
                                    iconPosition: 'before',
                                    mixClassName: _cards2.default.pfp
                                }))
                            ),
                            _react2.default.createElement('div', { className: _cards2.default['tooltip-divider'] }),
                            _react2.default.createElement(
                                'p',
                                { className: _cards2.default['tooltip-message'] },
                                _translations.PERSONAL_FAME_POINTS_EARN
                            )
                        )
                    )
                ),
                !isSomeServiceEnabled && _react2.default.createElement('div', { className: _cards2.default.externalUrl })
            );
        }
    }, {
        key: 'getGlobalCardClassNames',
        value: function getGlobalCardClassNames() {
            var _ref;

            var withOnlyNews = this.props.withNews && !this.props.withQuests;
            var withOnlyQuests = !this.props.withNews && this.props.withQuests;
            var withNewsWithQuests = this.props.withNews && this.props.withQuests;

            for (var _len = arguments.length, cardModifiers = Array(_len), _key = 0; _key < _len; _key++) {
                cardModifiers[_key] = arguments[_key];
            }

            var commonGlobalCardClassNames = [_cards2.default.card, _cards2.default.global_map].concat(cardModifiers, [(_ref = {}, _defineProperty(_ref, _cards2.default.global_map__with_news, withOnlyNews), _defineProperty(_ref, _cards2.default.global_map__with_quests, withOnlyQuests), _defineProperty(_ref, _cards2.default.global_map__with_news_with_quests, withNewsWithQuests), _ref)]);

            if (this.props.isCNRealm) {
                var _ref2;

                return _classnames2.default.apply(undefined, _toConsumableArray(commonGlobalCardClassNames).concat([(_ref2 = {}, _defineProperty(_ref2, _cards2.default.global_map__cn, !this.props.withNews && !this.props.withQuests), _defineProperty(_ref2, _cards2.default.global_map__with_news_cn, withOnlyNews), _defineProperty(_ref2, _cards2.default.global_map__with_quests_cn, withOnlyQuests), _defineProperty(_ref2, _cards2.default.global_map__with_news_with_quests_cn, withNewsWithQuests), _ref2)]));
            }

            return (0, _classnames2.default)(commonGlobalCardClassNames);
        }
    }]);

    return GlobalMapCard;
}(_react2.default.Component);

GlobalMapCard.propTypes = {
    craftMachineUrl: _propTypes2.default.string,
    isSomeServiceEnabled: _propTypes2.default.bool,
    isCraftServiceEnabled: _propTypes2.default.bool,
    leaderboardsEnabled: _propTypes2.default.bool,
    // eslint-disable-next-line react/no-unused-prop-types
    personalShopEnabled: _propTypes2.default.bool,
    personalBonusesEnabled: _propTypes2.default.bool,
    eventRewardsEnabled: _propTypes2.default.bool,
    battleScheduleEnabled: _propTypes2.default.bool,
    eventName: _propTypes2.default.string,
    famePoints: _propTypes2.default.number,
    nearestBattle: _propTypes2.default.object,
    externalUrl: _propTypes2.default.string,
    signInTokenUrl: _propTypes2.default.string,

    withNews: _propTypes2.default.bool,
    withQuests: _propTypes2.default.bool,

    openPersonalShop: _propTypes2.default.func.isRequired,
    openEventRewards: _propTypes2.default.func.isRequired,
    openBattleSchedule: _propTypes2.default.func.isRequired,
    openLeaderboards: _propTypes2.default.func.isRequired,
    sendEnterGlobalMapSoundState: _propTypes2.default.func.isRequired,
    playEnterGlobalMapSound: _propTypes2.default.func.isRequired,

    isGlobalMapEnabled: _propTypes2.default.bool,
    isCNRealm: _propTypes2.default.bool
};


var stateToProps = function stateToProps(_ref3) {
    var craftMachine = _ref3.craftMachine,
        globalMap = _ref3.globalMap,
        settings = _ref3.settings,
        clan = _ref3.clan;

    var hasClan = clan.id !== null;
    var personalShopEnabled = globalMap.personal_bonuses_enabled || globalMap.event_rewards_enabled;
    var battleScheduleEnabled = globalMap.battle_schedule_enabled && hasClan;
    var leaderboardsEnabled = globalMap.leaderboards_enabled && hasClan;
    var isCraftServiceEnabled = craftMachine.is_craft_service_enabled;

    var isSomeServiceEnabled = leaderboardsEnabled || personalShopEnabled || battleScheduleEnabled || isCraftServiceEnabled;

    return {
        craftMachineUrl: settings.craftMachineUrl,
        personalShopEnabled: personalShopEnabled,
        personalBonusesEnabled: globalMap.personal_bonuses_enabled,
        eventRewardsEnabled: globalMap.event_rewards_enabled,
        battleScheduleEnabled: battleScheduleEnabled,
        leaderboardsEnabled: leaderboardsEnabled,
        isCraftServiceEnabled: isCraftServiceEnabled,
        isSomeServiceEnabled: isSomeServiceEnabled,
        eventName: globalMap.context_id, // season or event name
        famePoints: globalMap.fame_points,
        nearestBattle: globalMap.nearest_battle,
        externalUrl: settings.globalMapUrl,
        signInTokenUrl: settings.signInTokenUrl,
        isGlobalMapEnabled: !!settings.globalMapUrl,
        isCNRealm: settings.isCNRealm
    };
};

var dispatchToProps = {
    openPersonalShop: function openPersonalShop() {
        return (0, _reactRouterRedux.push)(_urls.WGCWX_SHOP);
    },
    openEventRewards: function openEventRewards() {
        return (0, _reactRouterRedux.push)(_urls.WGCWX_SHOP_REWARDS);
    },
    openBattleSchedule: function openBattleSchedule() {
        return (0, _reactRouterRedux.push)(_urls.WGCWX_BATTLE_SCHEDULE);
    },
    openLeaderboards: function openLeaderboards() {
        return (0, _reactRouterRedux.push)(_urls.WGCWX_LEADERBOARDS);
    },
    sendEnterGlobalMapSoundState: _sounds.sendEnterGlobalMapSoundState,
    playEnterGlobalMapSound: _sounds.playEnterGlobalMapSound
};

exports.default = (0, _reactRedux.connect)(stateToProps, dispatchToProps)(GlobalMapCard);

/***/ }),
/* 2314 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"FamePoints_base--3UXl0","base__small":"FamePoints_base__small--37IEN","baseSmall":"FamePoints_base__small--37IEN","base__medium":"FamePoints_base__medium--37F7c","baseMedium":"FamePoints_base__medium--37F7c","base__regular":"FamePoints_base__regular--dZt8W","baseRegular":"FamePoints_base__regular--dZt8W","base__large":"FamePoints_base__large--1FHLI","baseLarge":"FamePoints_base__large--1FHLI","base__before":"FamePoints_base__before--rbECW","baseBefore":"FamePoints_base__before--rbECW","base__after":"FamePoints_base__after--210f5","baseAfter":"FamePoints_base__after--210f5","base__not-available":"FamePoints_base__not-available--1HaIL","baseNotAvailable":"FamePoints_base__not-available--1HaIL","base__white":"FamePoints_base__white--2Zzj-","baseWhite":"FamePoints_base__white--2Zzj-","base__inactive":"FamePoints_base__inactive--12i9-","baseInactive":"FamePoints_base__inactive--12i9-"};

/***/ }),
/* 2315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _cards = __webpack_require__(94);

var _cards2 = _interopRequireDefault(_cards);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactWotBootstrap = __webpack_require__(5);

var _translations = __webpack_require__(78);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ManeuversCard = (0, _react.memo)(function (_ref) {
    var withNews = _ref.withNews,
        withQuests = _ref.withQuests,
        wgshEventsUrl = _ref.wgshEventsUrl;

    var withOnlyNews = withNews && !withQuests;
    var withOnlyQuests = !withNews && withQuests;
    var withNewsWithQuests = withNews && withQuests;

    var classes = (0, _classnames2.default)(_cards2.default.card, _cards2.default.maneuvers, withOnlyNews && _cards2.default.maneuvers__with_news, withOnlyQuests && _cards2.default.maneuvers__with_quests, withNewsWithQuests && _cards2.default.maneuvers__with_news_with_quests);

    var handleClick = function handleClick() {
        window.location = wgshEventsUrl;
    };

    return _react2.default.createElement(
        'div',
        {
            onClick: handleClick,
            onMouseDown: _reactWotBootstrap.sendClickSoundCommand,
            onMouseEnter: _reactWotBootstrap.sendHoverSoundCommand,
            className: classes
        },
        _react2.default.createElement(
            'h2',
            null,
            _translations.MANEUVERS_TITLE
        ),
        _react2.default.createElement(
            'h3',
            null,
            _translations.MANEUVERS_DESCRIPTION
        )
    );
});

ManeuversCard.propTypes = {
    withNews: _propTypes2.default.bool.isRequired,
    withQuests: _propTypes2.default.bool.isRequired,
    wgshEventsUrl: _propTypes2.default.string.isRequired
};

exports.default = ManeuversCard;

/***/ }),
/* 2316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(7);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactSlick = __webpack_require__(565);

var _reactSlick2 = _interopRequireDefault(_reactSlick);

var _reactWotBootstrap = __webpack_require__(5);

var _web_to_client = __webpack_require__(17);

var _helpers = __webpack_require__(11);

var _i18n = __webpack_require__(10);

var _announcements = __webpack_require__(158);

var _ButtonSimple = __webpack_require__(235);

var _ButtonSimple2 = _interopRequireDefault(_ButtonSimple);

var _constants = __webpack_require__(131);

var _translations = __webpack_require__(166);

var _Paginator = __webpack_require__(2317);

var _Paginator2 = _interopRequireDefault(_Paginator);

var _Navigation = __webpack_require__(1362);

var _CopyrightInfo = __webpack_require__(1363);

var _AnnouncementOverlay = __webpack_require__(2321);

var _constants2 = __webpack_require__(43);

var _helpers2 = __webpack_require__(2335);

var _AnnouncementsStatusModel = __webpack_require__(2336);

var _AnnouncementsCard = __webpack_require__(2337);

var _AnnouncementsCard2 = _interopRequireDefault(_AnnouncementsCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var announcementsStatus = new _AnnouncementsStatusModel.AnnouncementsStatusModel();

var AnnouncementsCard = function (_React$Component) {
    _inherits(AnnouncementsCard, _React$Component);

    function AnnouncementsCard() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, AnnouncementsCard);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AnnouncementsCard.__proto__ || Object.getPrototypeOf(AnnouncementsCard)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            selectedItem: 0
        }, _this.sliderRef = function (c) {
            return _this.slider = c;
        }, _this.stopAutoplay = function () {
            clearInterval(_this.autoplayIntervalId);
        }, _this.startAutoplay = function () {
            _this.stopAutoplay();

            if (_this.props.items.length < 2) {
                return;
            }

            if (!_this.slider) {
                return;
            }

            _this.autoplayIntervalId = setInterval(_this.slider.slickNext, _constants2.AUTOPLAY_SPEED);
        }, _this.handleNavigation = function (e, direction) {
            e.stopPropagation();

            switch (direction) {
                case _constants2.NAVIGATION_DIRECTION.LEFT:
                    _this.slider.slickPrev();
                    break;
                case _constants2.NAVIGATION_DIRECTION.RIGHT:
                    _this.slider.slickNext();
                    break;
                default:
                    break;
            }
        }, _this.handleSliderBeforeChange = function (oldItem, newSelectedItem) {
            var item = _this.props.items[newSelectedItem];
            announcementsStatus.markAsDisplayed(item);

            _this.setState({
                selectedItem: newSelectedItem
            });
        }, _this.saveReadAnnouncements = function () {
            announcementsStatus.markAllDisplayedAsRead();
            announcementsStatus.saveReadAnnouncements();
        }, _this.handleChangingMode = function (mode, messageId) {
            var _this$props = _this.props,
                changeOpenedAnnouncement = _this$props.changeOpenedAnnouncement,
                changeAnnouncementMode = _this$props.changeAnnouncementMode;


            changeOpenedAnnouncement(messageId);
            changeAnnouncementMode(mode);
            _this.saveReadAnnouncements();
        }, _this.closeAnnouncement = function () {
            _this.handleChangingMode(_constants2.ANNOUNCEMENT_MODE.CARD);
        }, _this.handleCreateNewAnnouncementClick = function (e) {
            e.stopPropagation();
            _this.handleChangingMode(_constants2.ANNOUNCEMENT_MODE.CREATE);
        }, _this.handleOpenAnnouncement = function (announcementId) {
            _this.handleChangingMode(_constants2.ANNOUNCEMENT_MODE.VIEW, announcementId);
        }, _this.handleOpenNews = function (_ref2) {
            var url = _ref2.url,
                external_link = _ref2.external_link;

            _this.saveReadAnnouncements();

            if (external_link) {
                (0, _reactWotBootstrap.openExternalBrowser)(url);
            } else {
                (0, _web_to_client.openWindow)('clan_ads_overlay', { url: url });
            }
        }, _this.renderContent = function () {
            return _react2.default.createElement(
                _reactSlick2.default,
                {
                    draggable: false,
                    initialSlide: _this.state.selectedItem,
                    beforeChange: _this.handleSliderBeforeChange,
                    arrows: false,
                    speed: _constants2.SLIDE_SPEED,
                    ref: _this.sliderRef,
                    className: _AnnouncementsCard2.default.cardSlider
                },
                _this.props.items.map(function (item, index) {
                    return _react2.default.createElement(
                        'div',
                        {
                            key: 'slide_' + index,
                            className: _AnnouncementsCard2.default.slideWrapper
                        },
                        _this.renderSlide(item, index)
                    );
                })
            );
        }, _this.renderSlide = function (item) {
            switch (item.type) {
                case _constants2.CARD_TYPES.ANNOUNCEMENTS:
                    return _this.renderAnnouncement(item);
                case _constants2.CARD_TYPES.NEWS:
                    return _this.renderNews(item);
                case _constants2.CARD_TYPES.CREATE_NEW_ANNOUNCEMENT:
                    return _this.renderCreateNewAnnouncement();
                default:
                    return null;
            }
        }, _this.renderNews = function (news) {
            return _react2.default.createElement(
                'div',
                {
                    className: _AnnouncementsCard2.default.news,
                    onMouseDown: _reactWotBootstrap.sendClickSoundCommand,
                    onMouseEnter: _reactWotBootstrap.sendHoverSoundCommand,
                    onClick: function onClick() {
                        return _this.handleOpenNews(news);
                    }
                },
                _react2.default.createElement(
                    'h2',
                    { className: _AnnouncementsCard2.default.newsTitle },
                    news.title
                )
            );
        }, _this.renderAnnouncement = function (announcement) {
            return _react2.default.createElement(
                'div',
                {
                    className: _AnnouncementsCard2.default.announcement,
                    onMouseDown: _reactWotBootstrap.sendClickSoundCommand,
                    onMouseEnter: _reactWotBootstrap.sendHoverSoundCommand,
                    onClick: function onClick() {
                        return _this.handleOpenAnnouncement(announcement.message_id);
                    }
                },
                _react2.default.createElement(
                    'div',
                    { className: _AnnouncementsCard2.default.announcementContent },
                    _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: (0, _helpers.formatter)(announcement.body) } })
                ),
                _react2.default.createElement('div', { className: _AnnouncementsCard2.default.announcementDivider }),
                _react2.default.createElement(_CopyrightInfo.CopyrightInfo, _extends({}, announcement, {
                    accountId: _this.props.accountId
                }))
            );
        }, _this.renderCreateNewAnnouncement = function () {
            var announcementContentClassNames = (0, _classnames2.default)(_AnnouncementsCard2.default.announcementContent, _AnnouncementsCard2.default.announcementContent__new);

            return _react2.default.createElement(
                'div',
                {
                    className: _AnnouncementsCard2.default.announcement,
                    onMouseEnter: _reactWotBootstrap.sendHoverSoundCommand
                },
                _react2.default.createElement(
                    'div',
                    { className: announcementContentClassNames },
                    _translations.CREATE_NEW_ANNOUNCEMENT_TEXT,
                    _react2.default.createElement(
                        'div',
                        { className: _AnnouncementsCard2.default.announcementButton },
                        _react2.default.createElement(
                            _ButtonSimple2.default,
                            {
                                isGlow: true,
                                tooltipId: _constants2.TOOLTIP_IDS.CREATE_NEW_ANNOUNCEMENT_BUTTON,
                                onClick: _this.handleCreateNewAnnouncementClick
                            },
                            _translations.CREATE_NEW_ANNOUNCEMENT_BUTTON
                        )
                    )
                )
            );
        }, _this.renderCreateNewAnnouncementIcon = function () {
            var _this$props2 = _this.props,
                items = _this$props2.items,
                hasPermissions = _this$props2.hasPermissions,
                isAnnouncementsLimitReached = _this$props2.isAnnouncementsLimitReached;


            if (!_this.props.hasPermissions) {
                return null;
            }

            var activeSlide = items[_this.state.selectedItem];
            var isAnnouncementSlideActive = activeSlide && activeSlide.type === _constants2.CARD_TYPES.ANNOUNCEMENTS;

            if (!isAnnouncementSlideActive || !hasPermissions) {
                return null;
            }

            var tooltipId = isAnnouncementsLimitReached ? _constants2.TOOLTIP_IDS.CREATE_NEW_ANNOUNCEMENT_DISABLED_ICON : _constants2.TOOLTIP_IDS.CREATE_NEW_ANNOUNCEMENT_ICON;

            var announcementIconClassNames = (0, _classnames2.default)(_AnnouncementsCard2.default.announcementIcon, isAnnouncementsLimitReached && _AnnouncementsCard2.default.announcementIcon__disabled);

            return _react2.default.createElement('div', {
                className: announcementIconClassNames,
                'data-tip': true, 'data-for': tooltipId,
                onClick: function onClick(e) {
                    return !isAnnouncementsLimitReached && _this.handleCreateNewAnnouncementClick(e);
                }
            });
        }, _this.renderNewsExternalUrlIcon = function () {
            var activeSlide = _this.props.items[_this.state.selectedItem];
            var isNewsSlideActive = activeSlide && activeSlide.type === _constants2.CARD_TYPES.NEWS;

            if (!isNewsSlideActive || !activeSlide.external_link) {
                return null;
            }

            return _react2.default.createElement('div', {
                className: _AnnouncementsCard2.default.newsExternalUrlIcon,
                'data-tip': true, 'data-for': _constants2.TOOLTIP_IDS.EXTERNAL_URL_ICON,
                onClick: function onClick() {
                    return _this.handleOpenNews(activeSlide);
                }
            });
        }, _this.renderNavigation = function () {
            var _this$props3 = _this.props,
                items = _this$props3.items,
                withQuests = _this$props3.withQuests;


            if (items.length < 2) {
                return null;
            }

            return _react2.default.createElement(
                'div',
                { className: _AnnouncementsCard2.default.navigation },
                _react2.default.createElement(_Navigation.Navigation, {
                    disabledLeft: false,
                    disabledRight: false,
                    size: withQuests ? _constants.ARROW_SIZES.small : _constants.ARROW_SIZES.big,
                    onClick: _this.handleNavigation,
                    onMouseEnter: _this.slider ? _this.slider.slickPause : null,
                    onMouseLeave: _this.slider ? _this.slider.slickPlay : null
                }),
                items.length > 1 && _react2.default.createElement(
                    'div',
                    { className: _AnnouncementsCard2.default.paginator },
                    _react2.default.createElement(_Paginator2.default, {
                        pagesCount: _this.props.items.length,
                        currentPage: _this.state.selectedItem
                    })
                )
            );
        }, _this.renderAnnouncementOverlay = function () {
            var _this$props4 = _this.props,
                items = _this$props4.items,
                accountId = _this$props4.accountId,
                openedAnnouncement = _this$props4.openedAnnouncement;


            var announcements = items.filter(function (item) {
                return item.type === _constants2.CARD_TYPES.ANNOUNCEMENTS;
            });

            var selectedAnnouncement = openedAnnouncement ? announcements.findIndex(function (a) {
                return a.message_id === openedAnnouncement;
            }) : -1;

            return _react2.default.createElement(
                'div',
                { className: _AnnouncementsCard2.default.announcementOverlay },
                _react2.default.createElement(_AnnouncementOverlay.AnnouncementOverlay, {
                    items: announcements,
                    currentSlide: selectedAnnouncement,
                    accountId: accountId,
                    onClose: _this.closeAnnouncement
                }),
                _this.renderTooltips()
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(AnnouncementsCard, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.addEventListener('unload', this.saveReadAnnouncements);
            this.handleSliderBeforeChange(null, this.state.selectedItem);
            this.startAutoplay();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.props.announcementMode === _constants2.ANNOUNCEMENT_MODE.CARD) {
                this.startAutoplay();
            } else {
                this.stopAutoplay();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('unload', this.saveReadAnnouncements);
            this.saveReadAnnouncements();
            this.stopAutoplay();
        }
    }, {
        key: 'renderTooltips',


        /**
         * slick-slider inserts slides several times and browser throws errors about duplicate tooltips
         */
        value: function renderTooltips() {
            var announcements = this.props.items.filter(function (i) {
                return i.type === _constants2.CARD_TYPES.ANNOUNCEMENTS;
            });
            var authorRoleTooltips = announcements.map(function (item) {
                return _react2.default.createElement(
                    _reactWotBootstrap.Tooltip,
                    { id: '' + _constants2.TOOLTIP_IDS.AUTHOR_ROLE + item.message_id, key: item.message_id },
                    _i18n.USER_ROLES[item.author_role]
                );
            });

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    _reactWotBootstrap.Tooltip,
                    { id: _constants2.TOOLTIP_IDS.LOCKED_ANNOUNCEMENT },
                    _translations.LOCKED_ANNOUNCEMENT_TOOLTIP
                ),
                _react2.default.createElement(
                    _reactWotBootstrap.Tooltip,
                    { id: _constants2.TOOLTIP_IDS.OUT_OF_CLAN },
                    _translations.OUT_OF_CLAN
                ),
                _react2.default.createElement(
                    _reactWotBootstrap.Tooltip,
                    { id: _constants2.TOOLTIP_IDS.CREATE_NEW_ANNOUNCEMENT_BUTTON },
                    _translations.CREATE_NEW_ANNOUNCEMENT_BUTTON_TOOLTIP
                ),
                _react2.default.createElement(
                    _reactWotBootstrap.Tooltip,
                    { id: _constants2.TOOLTIP_IDS.CREATE_NEW_ANNOUNCEMENT_ICON },
                    _translations.CREATE_NEW_ANNOUNCEMENT_ICON_TOOLTIP
                ),
                _react2.default.createElement(
                    _reactWotBootstrap.Tooltip,
                    { id: _constants2.TOOLTIP_IDS.CREATE_NEW_ANNOUNCEMENT_DISABLED_ICON },
                    _translations.ANNOUNCEMENT_VIEW_BUTTON_CREATE_DISABLED_TOOLTIP
                ),
                _react2.default.createElement(
                    _reactWotBootstrap.Tooltip,
                    { id: _constants2.TOOLTIP_IDS.EXTERNAL_URL_ICON },
                    _translations.EXTERNAL_URL_ICON_TOOLTIP
                ),
                authorRoleTooltips
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                items = _props.items,
                withQuests = _props.withQuests,
                announcementMode = _props.announcementMode;
            var selectedItem = this.state.selectedItem;


            if (!items.length) {
                return null;
            }

            if (announcementMode !== _constants2.ANNOUNCEMENT_MODE.CARD) {
                return this.renderAnnouncementOverlay();
            }

            var item = items[selectedItem];

            var isNewMarker = !announcementsStatus.isRead(item);

            var baseClassNames = (0, _classnames2.default)(_AnnouncementsCard2.default.base, withQuests && _AnnouncementsCard2.default.base__withQuests);

            var customNewsBackgrounds = items.filter(function (item) {
                return item.type === _constants2.CARD_TYPES.NEWS && item.image_url !== null;
            }).map(function (item) {
                return _react2.default.createElement('div', {
                    className: (0, _classnames2.default)(_AnnouncementsCard2.default.newsBackground, item.index === selectedItem && _AnnouncementsCard2.default.newsBackground__active),
                    key: item.news_id,
                    style: { backgroundImage: 'url(' + item.image_url + ')' }
                });
            });

            var defaultNewsBackgroundClassNames = (0, _classnames2.default)(_AnnouncementsCard2.default.defaultNewsBackground, item.type === _constants2.CARD_TYPES.NEWS && _AnnouncementsCard2.default.defaultNewsBackground__active);

            return _react2.default.createElement(
                'div',
                { className: baseClassNames, onMouseEnter: this.stopAutoplay, onMouseLeave: this.startAutoplay },
                _react2.default.createElement('div', { className: defaultNewsBackgroundClassNames }),
                customNewsBackgrounds,
                this.renderContent(),
                this.renderNavigation(),
                this.renderCreateNewAnnouncementIcon(),
                this.renderNewsExternalUrlIcon(),
                isNewMarker && _react2.default.createElement('div', { className: _AnnouncementsCard2.default.newMarker }),
                this.renderTooltips()
            );
        }
    }]);

    return AnnouncementsCard;
}(_react2.default.Component);

AnnouncementsCard.propTypes = {
    withQuests: _propTypes2.default.bool,

    signInTokenUrl: _propTypes2.default.string.isRequired,
    accountId: _propTypes2.default.number.isRequired,

    items: _propTypes2.default.array.isRequired,
    announcementMode: _propTypes2.default.oneOf(Object.values(_constants2.ANNOUNCEMENT_MODE)).isRequired,
    openedAnnouncement: _propTypes2.default.number,
    hasPermissions: _propTypes2.default.bool.isRequired,
    isAnnouncementsLimitReached: _propTypes2.default.bool.isRequired,

    changeAnnouncementMode: _propTypes2.default.func.isRequired,
    changeOpenedAnnouncement: _propTypes2.default.func.isRequired
};


var stateToProps = function stateToProps(state) {
    var announcements = state.announcements.list.map(function (item) {
        return _extends({
            type: _constants2.CARD_TYPES.ANNOUNCEMENTS
        }, item);
    });

    var news = state.webbrg.clanNews.map(function (item) {
        return _extends({
            type: _constants2.CARD_TYPES.NEWS
        }, item);
    });

    announcements.forEach(function (item) {
        if (item.is_read) {
            announcementsStatus.markAsRead(item);
        }
    });

    var items = (0, _helpers2.sortAnnouncementCards)([].concat(_toConsumableArray(announcements), _toConsumableArray(news)), announcementsStatus);

    var hasPermissions = state.announcements.settings.can_create_messages;

    if (announcements.length === 0 && hasPermissions) {
        items.push({ type: _constants2.CARD_TYPES.CREATE_NEW_ANNOUNCEMENT });
    }

    items.forEach(function (item, index) {
        return item.index = index;
    });

    return {
        signInTokenUrl: state.settings.signInTokenUrl,
        accountId: state.account.id,
        items: items,
        announcementMode: state.announcements.mode,
        openedAnnouncement: state.announcements.openedAnnouncement,
        hasPermissions: state.announcements.settings.can_create_messages,
        isAnnouncementsLimitReached: state.announcements.settings.is_limit_reached
    };
};

var dispatchToProps = function dispatchToProps(dispatch) {
    return {
        changeAnnouncementMode: function changeAnnouncementMode(mode) {
            return dispatch((0, _announcements.changeMode)(mode));
        },
        changeOpenedAnnouncement: function changeOpenedAnnouncement(announcementId) {
            return dispatch((0, _announcements.changeOpenedAnnouncement)(announcementId));
        }
    };
};

exports.default = (0, _reactRedux.connect)(stateToProps, dispatchToProps)(AnnouncementsCard);

/***/ }),
/* 2317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _Paginator = __webpack_require__(2318);

var _Paginator2 = _interopRequireDefault(_Paginator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Paginator = function Paginator(_ref) {
    var pagesCount = _ref.pagesCount,
        currentPage = _ref.currentPage;

    var pages = Array.from({ length: pagesCount }, function (_, i) {
        return _react2.default.createElement('div', {
            className: (0, _classnames2.default)(_Paginator2.default.page, i === currentPage && _Paginator2.default.page_active),
            key: i
        });
    });

    return _react2.default.createElement(
        'div',
        { className: _Paginator2.default.base },
        pages
    );
};

Paginator.propTypes = {
    pagesCount: _propTypes2.default.number.isRequired,
    currentPage: _propTypes2.default.number.isRequired
};

exports.default = Paginator;

/***/ }),
/* 2318 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Paginator_base--1-saa","page":"Paginator_page--2csI0","page_active":"Paginator_page_active--3ZG4O","pageActive":"Paginator_page_active--3ZG4O"};

/***/ }),
/* 2319 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Navigation_base--YBl3P","arrow":"Navigation_arrow--1AbTj"};

/***/ }),
/* 2320 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"CopyrightInfo_base--3smlc","memberStatus":"CopyrightInfo_memberStatus--1FUXI","memberStatus__online":"CopyrightInfo_memberStatus__online--3RSky","memberStatusOnline":"CopyrightInfo_memberStatus__online--3RSky","memberStatus__busy":"CopyrightInfo_memberStatus__busy--3vVfj","memberStatusBusy":"CopyrightInfo_memberStatus__busy--3vVfj","memberStatus__isFriend":"CopyrightInfo_memberStatus__isFriend--YYfWL","memberStatusIsFriend":"CopyrightInfo_memberStatus__isFriend--YYfWL","memberStatus__offline":"CopyrightInfo_memberStatus__offline--3VckM","memberStatusOffline":"CopyrightInfo_memberStatus__offline--3VckM","time":"CopyrightInfo_time--1qrv0","lock":"CopyrightInfo_lock--1B_4R"};

/***/ }),
/* 2321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AnnouncementOverlay = exports.dispatchToProps = exports.AnnouncementOverlayComponent = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(7);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactSlick = __webpack_require__(565);

var _reactSlick2 = _interopRequireDefault(_reactSlick);

var _sounds = __webpack_require__(22);

var _announcements = __webpack_require__(158);

var _Back = __webpack_require__(70);

var _Back2 = _interopRequireDefault(_Back);

var _constants = __webpack_require__(4);

var _constants2 = __webpack_require__(43);

var _Header = __webpack_require__(2322);

var _Body = __webpack_require__(2324);

var _FooterViewControls = __webpack_require__(2326);

var _Navigation = __webpack_require__(1362);

var _AnnouncementEditor = __webpack_require__(2327);

var _ConfirmationScreen = __webpack_require__(2332);

var _AnnouncementOverlay = __webpack_require__(2334);

var _AnnouncementOverlay2 = _interopRequireDefault(_AnnouncementOverlay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AnnouncementOverlayComponent = exports.AnnouncementOverlayComponent = function (_React$Component) {
    _inherits(AnnouncementOverlayComponent, _React$Component);

    function AnnouncementOverlayComponent() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, AnnouncementOverlayComponent);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AnnouncementOverlayComponent.__proto__ || Object.getPrototypeOf(AnnouncementOverlayComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            currentSlide: _this.props.currentSlide,
            isDisabledEdit: false,
            isDisabledArchive: false,
            isDisabledDelete: false,
            isDisabledCreate: false
        }, _this.handleSliderAfterChange = function (currentSlide) {
            _this.setState({ currentSlide: currentSlide });
        }, _this.handleKeydown = function (e) {
            e.stopPropagation();

            if (e.keyCode === _constants.KEY_CODES.ESCAPE) {
                _this.handleClosing();
            }
        }, _this.handleClosing = function () {
            var _this$props = _this.props,
                announcementMode = _this$props.announcementMode,
                items = _this$props.items;
            var currentSlide = _this.state.currentSlide;


            var currentItem = items[currentSlide];

            if (!currentItem || announcementMode === _constants2.ANNOUNCEMENT_MODE.VIEW) {
                _this.props.onClose();
            } else {
                _this.handleChangingMode(_constants2.ANNOUNCEMENT_MODE.VIEW);
            }
        }, _this.handleChangingMode = function (mode) {
            var _this$props2 = _this.props,
                items = _this$props2.items,
                changeOpenedAnnouncement = _this$props2.changeOpenedAnnouncement,
                changeAnnouncementMode = _this$props2.changeAnnouncementMode;
            var currentSlide = _this.state.currentSlide;

            var _ref2 = items[currentSlide] || {},
                message_id = _ref2.message_id;

            changeOpenedAnnouncement(message_id);
            changeAnnouncementMode(mode);
        }, _this.handleNavigation = function (e, direction) {
            e.stopPropagation();

            switch (direction) {
                case _constants2.NAVIGATION_DIRECTION.LEFT:
                    _this.slider.slickPrev();
                    break;
                case _constants2.NAVIGATION_DIRECTION.RIGHT:
                    _this.slider.slickNext();
                    break;
                default:
                    break;
            }
        }, _this.handleRemoving = function () {
            var _this$props3 = _this.props,
                announcementMode = _this$props3.announcementMode,
                items = _this$props3.items,
                archiveAnnouncement = _this$props3.archiveAnnouncement,
                deleteAnnouncement = _this$props3.deleteAnnouncement;
            var currentSlide = _this.state.currentSlide;


            var currentItem = items[currentSlide];

            if (announcementMode === _constants2.ANNOUNCEMENT_MODE.ARCHIVE) {
                archiveAnnouncement(currentItem.message_id);
            } else if (announcementMode === _constants2.ANNOUNCEMENT_MODE.DELETE) {
                deleteAnnouncement(currentItem.message_id);
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(AnnouncementOverlayComponent, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            document.addEventListener('keydown', this.handleKeydown);
            this.handleError();

            this.props.sendEnterAnnouncementsSoundState();
            this.props.playEnterAnnouncementSound();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            var currentSlide = this.props.currentSlide;


            if (currentSlide !== prevProps.currentSlide) {
                this.slider.slickGoTo(currentSlide);
                this.handleSliderAfterChange(currentSlide);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.removeEventListener('keydown', this.handleKeydown);
            clearTimeout(this.timerId);

            this.props.sendEnterLandingSoundState();
            this.props.playExitAnnouncementSound();
        }
    }, {
        key: 'handleError',
        value: function handleError() {
            var _this2 = this;

            var announcementError = this.props.announcementError;


            clearTimeout(this.timerId);

            var isDisabledEdit = announcementError === _constants2.ANNOUNCEMENT_ERROR.EDIT;
            var isDisabledArchive = announcementError === _constants2.ANNOUNCEMENT_ERROR.ARCHIVE;
            var isDisabledDelete = announcementError === _constants2.ANNOUNCEMENT_ERROR.DELETE;
            var isDisabledCreate = announcementError === _constants2.ANNOUNCEMENT_ERROR.CREATE;

            this.setState({
                isDisabledEdit: isDisabledEdit,
                isDisabledArchive: isDisabledArchive,
                isDisabledDelete: isDisabledDelete,
                isDisabledCreate: isDisabledCreate
            });

            this.timerId = setTimeout(function () {
                _this2.setState({
                    isDisabledEdit: false,
                    isDisabledArchive: false,
                    isDisabledDelete: false,
                    isDisabledCreate: false
                });
            }, _constants2.DISABLING_DURATION);
        }
    }, {
        key: 'isViewScreen',
        value: function isViewScreen() {
            var announcementMode = this.props.announcementMode;


            var isCreating = announcementMode === _constants2.ANNOUNCEMENT_MODE.CREATE;
            var isEditing = announcementMode === _constants2.ANNOUNCEMENT_MODE.EDIT;

            return !(isCreating || isEditing);
        }
    }, {
        key: 'isConfirmationScreen',
        value: function isConfirmationScreen() {
            var announcementMode = this.props.announcementMode;


            var isArchiving = announcementMode === _constants2.ANNOUNCEMENT_MODE.ARCHIVE;
            var isDeleting = announcementMode === _constants2.ANNOUNCEMENT_MODE.DELETE;

            return isArchiving || isDeleting;
        }
    }, {
        key: 'renderAnnouncementView',
        value: function renderAnnouncementView() {
            var _this3 = this;

            var _props = this.props,
                items = _props.items,
                hasPermissions = _props.hasPermissions,
                isAnnouncementsLimitReached = _props.isAnnouncementsLimitReached;
            var _state = this.state,
                currentSlide = _state.currentSlide,
                isDisabledEdit = _state.isDisabledEdit,
                isDisabledArchive = _state.isDisabledArchive,
                isDisabledDelete = _state.isDisabledDelete,
                isDisabledCreate = _state.isDisabledCreate;


            if (!this.isViewScreen()) {
                return null;
            }

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    _reactSlick2.default,
                    {
                        draggable: false,
                        infinite: false,
                        initialSlide: currentSlide,
                        afterChange: this.handleSliderAfterChange,
                        arrows: false,
                        speed: _constants2.SLIDE_SPEED,
                        ref: function ref(slider) {
                            return _this3.slider = slider;
                        }
                    },
                    items.map(function (item, index) {
                        return _react2.default.createElement(_Body.Body, _extends({}, item, {
                            key: item.message_id + '_' + index,
                            accountId: _this3.props.accountId
                        }));
                    })
                ),
                hasPermissions && _react2.default.createElement(
                    'div',
                    { className: _AnnouncementOverlay2.default.footer },
                    _react2.default.createElement(_FooterViewControls.FooterViewControls, {
                        disabledEdit: isDisabledEdit,
                        disabledArchive: isDisabledArchive,
                        disabledDelete: isDisabledDelete,
                        disabledCreate: isDisabledCreate,
                        isAnnouncementsLimitReached: isAnnouncementsLimitReached,
                        onChangeMode: this.handleChangingMode
                    })
                )
            );
        }
    }, {
        key: 'renderAnnouncementEditor',
        value: function renderAnnouncementEditor() {
            var _props2 = this.props,
                items = _props2.items,
                announcementMode = _props2.announcementMode;
            var currentSlide = this.state.currentSlide;


            var isEditing = announcementMode === _constants2.ANNOUNCEMENT_MODE.EDIT;

            if (this.isViewScreen()) {
                return null;
            }

            var currentItem = isEditing ? items[currentSlide] : null;

            return _react2.default.createElement(_AnnouncementEditor.AnnouncementEditor, {
                item: currentItem,
                announcementMode: announcementMode,
                onChangeMode: this.handleChangingMode
            });
        }
    }, {
        key: 'renderConfirmationScreen',
        value: function renderConfirmationScreen() {
            var _this4 = this;

            var announcementMode = this.props.announcementMode;
            var _state2 = this.state,
                isDisabledArchive = _state2.isDisabledArchive,
                isDisabledDelete = _state2.isDisabledDelete;


            if (!this.isConfirmationScreen()) {
                return null;
            }

            var isArchiving = announcementMode === _constants2.ANNOUNCEMENT_MODE.ARCHIVE;
            var isDisabled = isArchiving ? isDisabledArchive : isDisabledDelete;

            return _react2.default.createElement(
                'div',
                { className: _AnnouncementOverlay2.default.confirmationScreen },
                _react2.default.createElement(_ConfirmationScreen.ConfirmationScreen, {
                    announcementMode: announcementMode,
                    isDisabled: isDisabled,
                    onApply: this.handleRemoving,
                    onCancel: function onCancel() {
                        return _this4.handleChangingMode(_constants2.ANNOUNCEMENT_MODE.VIEW);
                    }
                })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _props3 = this.props,
                items = _props3.items,
                announcementMode = _props3.announcementMode;
            var currentSlide = this.state.currentSlide;


            var itemsLength = items.length;
            var lastItem = itemsLength - 1;

            var withNavigation = itemsLength > 1 && this.isViewScreen();

            var contentWrapperClassNames = (0, _classnames2.default)(_AnnouncementOverlay2.default.contentWrapper, this.isConfirmationScreen() && _AnnouncementOverlay2.default.contentWrapper__blur);

            return _react2.default.createElement(
                'div',
                { className: _AnnouncementOverlay2.default.base },
                _react2.default.createElement(
                    'div',
                    { className: _AnnouncementOverlay2.default.back },
                    _react2.default.createElement(_Back2.default, {
                        caption: _Back2.default.CAPTIONS.close,
                        type: _Back2.default.TYPES.close,
                        side: _Back2.default.SIDES.right,
                        handleClick: this.handleClosing
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: contentWrapperClassNames },
                    _react2.default.createElement(
                        'div',
                        { className: _AnnouncementOverlay2.default.header },
                        _react2.default.createElement(_Header.Header, {
                            currentItem: currentSlide + 1,
                            itemsLength: itemsLength,
                            announcementMode: announcementMode,
                            withPaginationInfo: withNavigation
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _AnnouncementOverlay2.default.main },
                        this.renderAnnouncementView(),
                        this.renderAnnouncementEditor()
                    ),
                    withNavigation && _react2.default.createElement(_Navigation.Navigation, {
                        disabledLeft: currentSlide === 0,
                        disabledRight: currentSlide === lastItem,
                        onClick: this.handleNavigation
                    })
                ),
                this.renderConfirmationScreen()
            );
        }
    }]);

    return AnnouncementOverlayComponent;
}(_react2.default.Component);

AnnouncementOverlayComponent.propTypes = {
    announcementMode: _propTypes2.default.oneOf(Object.values(_constants2.ANNOUNCEMENT_MODE)).isRequired,
    announcementError: _propTypes2.default.oneOf(Object.values(_constants2.ANNOUNCEMENT_ERROR)),
    hasPermissions: _propTypes2.default.bool.isRequired,
    isAnnouncementsLimitReached: _propTypes2.default.bool.isRequired,
    sendEnterAnnouncementsSoundState: _propTypes2.default.func.isRequired,
    sendEnterLandingSoundState: _propTypes2.default.func.isRequired,
    playEnterAnnouncementSound: _propTypes2.default.func.isRequired,
    playExitAnnouncementSound: _propTypes2.default.func.isRequired,
    changeAnnouncementMode: _propTypes2.default.func.isRequired,
    changeOpenedAnnouncement: _propTypes2.default.func.isRequired,
    archiveAnnouncement: _propTypes2.default.func.isRequired,
    deleteAnnouncement: _propTypes2.default.func.isRequired,

    items: _propTypes2.default.array.isRequired,
    currentSlide: _propTypes2.default.number.isRequired,
    accountId: _propTypes2.default.number.isRequired,
    onClose: _propTypes2.default.func.isRequired
};


var stateToProps = function stateToProps(state) {
    return {
        announcementMode: state.announcements.mode,
        announcementError: state.announcements.error,
        hasPermissions: state.announcements.settings.can_create_messages,
        isAnnouncementsLimitReached: state.announcements.settings.is_limit_reached
    };
};

var dispatchToProps = exports.dispatchToProps = function dispatchToProps(dispatch) {
    return {
        sendEnterAnnouncementsSoundState: function sendEnterAnnouncementsSoundState() {
            return dispatch((0, _sounds.sendEnterAnnouncementsSoundState)());
        },
        sendEnterLandingSoundState: function sendEnterLandingSoundState() {
            return dispatch((0, _sounds.sendEnterLandingSoundState)());
        },
        playEnterAnnouncementSound: function playEnterAnnouncementSound() {
            return dispatch((0, _sounds.playEnterAnnouncementSound)());
        },
        playExitAnnouncementSound: function playExitAnnouncementSound() {
            return dispatch((0, _sounds.playExitAnnouncementSound)());
        },
        changeAnnouncementMode: function changeAnnouncementMode(mode) {
            return dispatch((0, _announcements.changeMode)(mode));
        },
        archiveAnnouncement: function archiveAnnouncement(data) {
            return dispatch((0, _announcements.archiveAnnouncement)(data));
        },
        deleteAnnouncement: function deleteAnnouncement(data) {
            return dispatch((0, _announcements.deleteAnnouncement)(data));
        },
        changeOpenedAnnouncement: function changeOpenedAnnouncement(announcementId) {
            return dispatch((0, _announcements.changeOpenedAnnouncement)(announcementId));
        }
    };
};

var AnnouncementOverlay = exports.AnnouncementOverlay = (0, _reactRedux.connect)(stateToProps, dispatchToProps)(AnnouncementOverlayComponent);

/***/ }),
/* 2322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Header = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(43);

var _translations = __webpack_require__(166);

var _Header = __webpack_require__(2323);

var _Header2 = _interopRequireDefault(_Header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getTitle = function getTitle(mode) {
    switch (mode) {
        case _constants.ANNOUNCEMENT_MODE.CREATE:
            return _translations.ANNOUNCEMENT_CREATE_TITLE;
        case _constants.ANNOUNCEMENT_MODE.EDIT:
            return _translations.ANNOUNCEMENT_EDIT_TITLE;
        default:
            return _translations.ANNOUNCEMENT_VIEW_TITLE;
    }
};

var Header = exports.Header = function Header(props) {
    var withPaginationInfo = props.withPaginationInfo,
        itemsLength = props.itemsLength,
        announcementMode = props.announcementMode,
        currentItem = props.currentItem;


    var paginatorClassNames = (0, _classnames2.default)(_Header2.default.paginator, !withPaginationInfo && _Header2.default.paginator__hidden);

    return _react2.default.createElement(
        'div',
        { className: _Header2.default.base },
        _react2.default.createElement(
            'div',
            { className: paginatorClassNames },
            currentItem + ' / ' + itemsLength
        ),
        _react2.default.createElement(
            'h1',
            { className: _Header2.default.title },
            getTitle(announcementMode)
        )
    );
};

Header.propTypes = {
    withPaginationInfo: _propTypes2.default.bool.isRequired,
    itemsLength: _propTypes2.default.number.isRequired,
    announcementMode: _propTypes2.default.oneOf(Object.values(_constants.ANNOUNCEMENT_MODE)).isRequired,
    currentItem: _propTypes2.default.number.isRequired
};

/***/ }),
/* 2323 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Header_base--29x8-","title":"Header_title--2Prl4","paginator":"Header_paginator--3BpRN","paginator__hidden":"Header_paginator__hidden--3GFSi","paginatorHidden":"Header_paginator__hidden--3GFSi"};

/***/ }),
/* 2324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Body = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactWotBootstrap = __webpack_require__(5);

var _constants = __webpack_require__(4);

var _helpers = __webpack_require__(11);

var _CopyrightInfo = __webpack_require__(1363);

var _Body = __webpack_require__(2325);

var _Body2 = _interopRequireDefault(_Body);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SCROLLABLE_AREA_HEIGHT_SMALL = 250;
var SCROLLABLE_AREA_HEIGHT_BIG = 300;

var Body = exports.Body = function (_React$Component) {
    _inherits(Body, _React$Component);

    function Body() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Body);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Body.__proto__ || Object.getPrototypeOf(Body)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            scrollableAreaHeight: 0,
            isBodyScrollable: false
        }, _this.updateScrollableAreaHeight = function () {
            var scrollableAreaHeight = (0, _helpers.mq)(_constants.MQ_BREAKPOINTS.M) ? SCROLLABLE_AREA_HEIGHT_BIG : SCROLLABLE_AREA_HEIGHT_SMALL;

            var contentHeight = _this._content ? _this._content.clientHeight : 0;

            _this.setState({
                scrollableAreaHeight: scrollableAreaHeight,
                isBodyScrollable: scrollableAreaHeight < contentHeight
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Body, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.updateScrollableAreaHeight();
            window.addEventListener('resize', this.updateScrollableAreaHeight);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('resize', this.updateScrollableAreaHeight);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                scrollableAreaHeight = _state.scrollableAreaHeight,
                isBodyScrollable = _state.isBodyScrollable;

            var body = (0, _helpers.formatter)(this.props.body);

            var contentClassNames = (0, _classnames2.default)(_Body2.default.content, isBodyScrollable && _Body2.default.content__scrollable);

            var announcementInfoClassNames = (0, _classnames2.default)(_Body2.default.announcementInfo, !isBodyScrollable && _Body2.default.announcementInfo__dots);

            return _react2.default.createElement(
                'div',
                { className: _Body2.default.base },
                _react2.default.createElement(
                    'div',
                    { className: contentClassNames },
                    _react2.default.createElement(
                        _reactWotBootstrap.ScrollArea,
                        { scrollableAreaHeight: scrollableAreaHeight },
                        _react2.default.createElement('p', {
                            className: _Body2.default.message,
                            dangerouslySetInnerHTML: { __html: body },
                            ref: function ref(c) {
                                return _this2._content = c;
                            }
                        })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: announcementInfoClassNames },
                    _react2.default.createElement(_CopyrightInfo.CopyrightInfo, _extends({}, this.props, {
                        timeClassName: _Body2.default.announcementTime
                    }))
                )
            );
        }
    }]);

    return Body;
}(_react2.default.Component);

Body.propTypes = {
    body: _propTypes2.default.string.isRequired,
    accountId: _propTypes2.default.number.isRequired
};

/***/ }),
/* 2325 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Body_base--irita","content":"Body_content--klbb0","content__scrollable":"Body_content__scrollable--1bnwQ","contentScrollable":"Body_content__scrollable--1bnwQ","message":"Body_message--1hrw8","announcementInfo":"Body_announcementInfo--24xQ1","announcementInfo__dots":"Body_announcementInfo__dots--2mxRH","announcementInfoDots":"Body_announcementInfo__dots--2mxRH","announcementTime":"Body_announcementTime--6k49N"};

/***/ }),
/* 2326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FooterViewControls = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactWotBootstrap = __webpack_require__(5);

var _ButtonSimple = __webpack_require__(235);

var _ButtonSimple2 = _interopRequireDefault(_ButtonSimple);

var _translations = __webpack_require__(166);

var _constants = __webpack_require__(43);

var _Footer = __webpack_require__(1364);

var _Footer2 = _interopRequireDefault(_Footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FooterViewControls = exports.FooterViewControls = function FooterViewControls(props) {
    var onChangeMode = props.onChangeMode,
        isAnnouncementsLimitReached = props.isAnnouncementsLimitReached,
        disabledEdit = props.disabledEdit,
        disabledArchive = props.disabledArchive,
        disabledDelete = props.disabledDelete,
        disabledCreate = props.disabledCreate;


    var creationButtonTooltip = isAnnouncementsLimitReached ? _translations.ANNOUNCEMENT_VIEW_BUTTON_CREATE_DISABLED_TOOLTIP : _translations.ANNOUNCEMENT_VIEW_BUTTON_CREATE_TOOLTIP;

    var baseClassNames = (0, _classnames2.default)(_Footer2.default.base, _Footer2.default.base__view);

    var buttonClassNames = (0, _classnames2.default)(_Footer2.default.button, _Footer2.default.button__right);

    return _react2.default.createElement(
        'div',
        { className: baseClassNames },
        _react2.default.createElement(
            'div',
            { className: _Footer2.default.button },
            _react2.default.createElement(
                _ButtonSimple2.default,
                {
                    isDisabled: disabledEdit,
                    tooltipId: _constants.TOOLTIP_IDS.BUTTON_EDIT,
                    onClick: function onClick() {
                        return onChangeMode(_constants.ANNOUNCEMENT_MODE.EDIT);
                    }
                },
                _react2.default.createElement(
                    'span',
                    { className: _Footer2.default.buttonText },
                    _translations.ANNOUNCEMENT_VIEW_BUTTON_EDIT
                )
            ),
            _react2.default.createElement(
                _reactWotBootstrap.Tooltip,
                { id: _constants.TOOLTIP_IDS.BUTTON_EDIT },
                _translations.ANNOUNCEMENT_VIEW_BUTTON_EDIT_TOOLTIP
            )
        ),
        _react2.default.createElement(
            'div',
            { className: _Footer2.default.button },
            _react2.default.createElement(
                _ButtonSimple2.default,
                {
                    isDisabled: disabledArchive,
                    tooltipId: _constants.TOOLTIP_IDS.BUTTON_ARCHIVE,
                    onClick: function onClick() {
                        return onChangeMode(_constants.ANNOUNCEMENT_MODE.ARCHIVE);
                    }
                },
                _react2.default.createElement(
                    'span',
                    { className: _Footer2.default.buttonText },
                    _translations.ANNOUNCEMENT_VIEW_BUTTON_ARCHIVE
                )
            ),
            _react2.default.createElement(
                _reactWotBootstrap.Tooltip,
                { id: _constants.TOOLTIP_IDS.BUTTON_ARCHIVE },
                _translations.ANNOUNCEMENT_VIEW_BUTTON_ARCHIVE_TOOLTIP
            )
        ),
        _react2.default.createElement(
            'div',
            { className: _Footer2.default.button },
            _react2.default.createElement(
                _ButtonSimple2.default,
                {
                    isDisabled: disabledDelete,
                    tooltipId: _constants.TOOLTIP_IDS.BUTTON_DELETE,
                    onClick: function onClick() {
                        return onChangeMode(_constants.ANNOUNCEMENT_MODE.DELETE);
                    }
                },
                _react2.default.createElement(
                    'span',
                    { className: _Footer2.default.buttonText },
                    _translations.ANNOUNCEMENT_VIEW_BUTTON_DELETE
                )
            ),
            _react2.default.createElement(
                _reactWotBootstrap.Tooltip,
                { id: _constants.TOOLTIP_IDS.BUTTON_DELETE },
                _translations.ANNOUNCEMENT_VIEW_BUTTON_DELETE_TOOLTIP
            )
        ),
        _react2.default.createElement(
            'div',
            { className: buttonClassNames },
            _react2.default.createElement(
                _reactWotBootstrap.Button,
                {
                    isDisabled: disabledCreate || isAnnouncementsLimitReached,
                    tooltipId: _constants.TOOLTIP_IDS.BUTTON_CREATE,
                    onClick: function onClick() {
                        return onChangeMode(_constants.ANNOUNCEMENT_MODE.CREATE);
                    }
                },
                _react2.default.createElement(
                    'span',
                    { className: _Footer2.default.buttonText },
                    _translations.ANNOUNCEMENT_VIEW_BUTTON_CREATE
                )
            ),
            _react2.default.createElement(
                _reactWotBootstrap.Tooltip,
                { id: _constants.TOOLTIP_IDS.BUTTON_CREATE },
                creationButtonTooltip
            )
        )
    );
};

FooterViewControls.propTypes = {
    onChangeMode: _propTypes2.default.func.isRequired,
    isAnnouncementsLimitReached: _propTypes2.default.bool.isRequired,
    disabledEdit: _propTypes2.default.bool,
    disabledArchive: _propTypes2.default.bool,
    disabledDelete: _propTypes2.default.bool,
    disabledCreate: _propTypes2.default.bool
};

FooterViewControls.defaultProps = {
    disabledEdit: false,
    disabledArchive: false,
    disabledDelete: false,
    disabledCreate: false
};

/***/ }),
/* 2327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AnnouncementEditor = exports.dispatchToProps = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(7);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

var _reactWotBootstrap = __webpack_require__(5);

var _constants = __webpack_require__(4);

var _helpers = __webpack_require__(11);

var _announcements = __webpack_require__(158);

var _TextArea = __webpack_require__(2328);

var _translations = __webpack_require__(166);

var _FooterEditControls = __webpack_require__(2330);

var _constants2 = __webpack_require__(43);

var _AnnouncementEditor = __webpack_require__(2331);

var _AnnouncementEditor2 = _interopRequireDefault(_AnnouncementEditor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TEXT_AREA_HEIGHT_SMALL = 220;
var TEXT_AREA_HEIGHT_BIG = 270;

var getItemsForSelect = function getItemsForSelect(groupList) {
    return groupList.map(function (type) {
        return {
            caption: _translations.ANNOUNCEMENT_EDIT_GROUP_TYPE_ITEMS[type],
            value: type,
            tooltipId: _constants2.TOOLTIP_IDS.EDITOR_GROUP_TYPE_ITEMS[type]
        };
    });
};

var AnnouncementEditorComponent = function (_React$Component) {
    _inherits(AnnouncementEditorComponent, _React$Component);

    function AnnouncementEditorComponent() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, AnnouncementEditorComponent);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AnnouncementEditorComponent.__proto__ || Object.getPrototypeOf(AnnouncementEditorComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            editedText: _this.props.item ? _this.props.item.body : '',
            groupType: _this.props.item ? _this.props.item.group_type : _this.props.groupList[0],
            textAreaHeight: TEXT_AREA_HEIGHT_SMALL,
            savingButtonState: _constants2.FOOTER_EDIT_CONTROLS_STATE.WITHOUT_RESTRICTION,
            expiredAt: (Date.now() + _this.props.defaultMessageLifetime * _constants.ONE_SECOND) / _constants.ONE_SECOND
        }, _this.setTextAreaRef = function (c) {
            _this.textareaRef = c;
        }, _this.checkSavingButtonState = function () {
            var maxMessageLength = _this.props.maxMessageLength;
            var editedText = _this.state.editedText;


            var savingButtonState = editedText.length > maxMessageLength ? _constants2.FOOTER_EDIT_CONTROLS_STATE.MAX_CHARS : _constants2.FOOTER_EDIT_CONTROLS_STATE.WITHOUT_RESTRICTION;

            _this.setState({
                savingButtonState: savingButtonState
            });
        }, _this.updateTextAreaHeight = function () {
            var textAreaHeight = (0, _helpers.mq)(_constants.MQ_BREAKPOINTS.M) ? TEXT_AREA_HEIGHT_BIG : TEXT_AREA_HEIGHT_SMALL;

            _this.setState({ textAreaHeight: textAreaHeight });
        }, _this.handleSaving = function () {
            var _this$props = _this.props,
                item = _this$props.item,
                announcementMode = _this$props.announcementMode,
                createAnnouncement = _this$props.createAnnouncement,
                updateAnnouncement = _this$props.updateAnnouncement;
            var _this$state = _this.state,
                editedText = _this$state.editedText,
                groupType = _this$state.groupType,
                expiredAt = _this$state.expiredAt;


            var data = {
                message: editedText,
                groupType: groupType,
                expiredAt: expiredAt
            };

            if (announcementMode === _constants2.ANNOUNCEMENT_MODE.CREATE) {
                createAnnouncement(data);
            } else if (announcementMode === _constants2.ANNOUNCEMENT_MODE.EDIT) {
                updateAnnouncement(_extends({}, data, {
                    messageId: item.message_id
                }));
            }
        }, _this.handleCancel = function () {
            var _this$props2 = _this.props,
                openedAnnouncement = _this$props2.openedAnnouncement,
                onChangeMode = _this$props2.onChangeMode;

            onChangeMode(openedAnnouncement ? _constants2.ANNOUNCEMENT_MODE.VIEW : _constants2.ANNOUNCEMENT_MODE.CARD);
        }, _this.updateEditedText = function (e) {
            var editedText = e.target.value;
            _this.setState({ editedText: editedText });
        }, _this.changeAccessLevel = function (value) {
            _this.setState({ groupType: value });
        }, _this.handlePrivacyLinkOpening = function (e) {
            var privacyPolicyLink = _this.props.privacyPolicyLink;


            e.preventDefault();
            (0, _reactWotBootstrap.openExternalBrowser)(privacyPolicyLink);
        }, _this.renderTooltips = function () {
            var groupTypeItems = Object.keys(_constants2.GROUP_LIST).map(function (key) {
                return _react2.default.createElement(
                    _reactWotBootstrap.Tooltip,
                    {
                        key: _constants2.TOOLTIP_IDS.EDITOR_GROUP_TYPE_ITEMS[key],
                        id: _constants2.TOOLTIP_IDS.EDITOR_GROUP_TYPE_ITEMS[key]
                    },
                    _translations.ANNOUNCEMENT_EDIT_GROUP_TYPE_ITEMS_TOOLTIP[key]
                );
            });

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    _reactWotBootstrap.Tooltip,
                    { id: _constants2.TOOLTIP_IDS.EDITOR_HINT_BOLD },
                    _react2.default.createElement(
                        _reactWotBootstrap.TooltipHeader,
                        null,
                        _translations.ANNOUNCEMENT_EDIT_TEXTAREA_HINT_BOLD_TITLE_TOOLTIP
                    ),
                    _translations.ANNOUNCEMENT_EDIT_TEXTAREA_HINT_BOLD_BODY_TOOLTIP
                ),
                _react2.default.createElement(
                    _reactWotBootstrap.Tooltip,
                    { id: _constants2.TOOLTIP_IDS.EDITOR_GROUP_TYPE },
                    _translations.ANNOUNCEMENT_EDIT_GROUP_TYPE_TOOLTIP
                ),
                _react2.default.createElement(
                    _reactWotBootstrap.Tooltip,
                    { id: _constants2.TOOLTIP_IDS.EDITOR_INFO },
                    _translations.ANNOUNCEMENT_EDIT_INFO_TOOLTIP
                ),
                groupTypeItems
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(AnnouncementEditorComponent, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.updateTextAreaHeight();
            window.addEventListener('resize', this.updateTextAreaHeight);
            this.handleError();

            this.textareaRef.focus();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (prevState.editedText !== this.state.editedText) {
                this.checkSavingButtonState();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('resize', this.updateTextAreaHeight);
            clearTimeout(this.timerId);
        }
    }, {
        key: 'handleError',
        value: function handleError() {
            var announcementError = this.props.announcementError;


            clearTimeout(this.timerId);

            var isForbiddenError = announcementError === _constants2.ANNOUNCEMENT_ERROR.FORBIDDEN_WORDS;
            var isCreateError = announcementError === _constants2.ANNOUNCEMENT_ERROR.EDIT;
            var isEditError = announcementError === _constants2.ANNOUNCEMENT_ERROR.CREATE;

            if (isForbiddenError) {
                this.setState({
                    savingButtonState: _constants2.FOOTER_EDIT_CONTROLS_STATE.FORBIDDEN_WORDS
                });
            } else if (isCreateError || isEditError) {
                this.setState({
                    savingButtonState: _constants2.FOOTER_EDIT_CONTROLS_STATE.DISABLED
                });

                this.timerId = setTimeout(this.checkSavingButtonState, _constants2.DISABLING_DURATION);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                announcementMode = _props.announcementMode,
                maxMessageLength = _props.maxMessageLength,
                groupList = _props.groupList;
            var _state = this.state,
                editedText = _state.editedText,
                groupType = _state.groupType,
                expiredAt = _state.expiredAt,
                textAreaHeight = _state.textAreaHeight,
                savingButtonState = _state.savingButtonState;


            var charLength = editedText.length;
            var time = (0, _moment2.default)(expiredAt * _constants.ONE_SECOND).format('DD.MM.YYYY');

            var highlightedTextClassNames = (0, _classnames2.default)(_AnnouncementEditor2.default.highlightedText, charLength > maxMessageLength && _AnnouncementEditor2.default.highlightedText__exceeded);

            return _react2.default.createElement(
                'div',
                { className: _AnnouncementEditor2.default.base },
                _react2.default.createElement(
                    'div',
                    { className: _AnnouncementEditor2.default.content },
                    _react2.default.createElement(_TextArea.TextArea, {
                        ref: this.setTextAreaRef,
                        height: textAreaHeight,
                        value: editedText,
                        className: _AnnouncementEditor2.default.textarea,
                        onChange: this.updateEditedText
                    }),
                    _react2.default.createElement(
                        'div',
                        { className: _AnnouncementEditor2.default.textareaHint },
                        _react2.default.createElement(
                            'span',
                            null,
                            (0, _translations.ANNOUNCEMENT_EDIT_TEXTAREA_HINT_CHARS)(_react2.default.createElement(
                                'span',
                                { className: highlightedTextClassNames },
                                charLength
                            ), maxMessageLength)
                        ),
                        _react2.default.createElement(
                            'span',
                            {
                                'data-tip': true, 'data-for': _constants2.TOOLTIP_IDS.EDITOR_HINT_BOLD,
                                className: _AnnouncementEditor2.default.boldHint
                            },
                            (0, _translations.ANNOUNCEMENT_EDIT_TEXTAREA_HINT_BOLD)(_react2.default.createElement(
                                'span',
                                { className: _AnnouncementEditor2.default.highlightedText },
                                _translations.ANNOUNCEMENT_EDIT_TEXTAREA_HINT_BOLD_EXAMPLE
                            ))
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _AnnouncementEditor2.default.groupType },
                        _react2.default.createElement(_reactWotBootstrap.Select, {
                            items: getItemsForSelect(groupList),
                            selectedItem: groupType,
                            onItemChange: this.changeAccessLevel,
                            caption: _translations.ANNOUNCEMENT_EDIT_GROUP_TYPE_CAPTION,
                            captionPosition: 'top',
                            tooltipId: _constants2.TOOLTIP_IDS.EDITOR_GROUP_TYPE
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        {
                            'data-tip': true, 'data-for': _constants2.TOOLTIP_IDS.EDITOR_INFO,
                            className: _AnnouncementEditor2.default.announcementInfo
                        },
                        (0, _translations.ANNOUNCEMENT_EDIT_INFO)(time),
                        _react2.default.createElement(
                            'div',
                            { className: _AnnouncementEditor2.default.infoIcon },
                            _react2.default.createElement(_reactWotBootstrap.Info, null)
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _AnnouncementEditor2.default.privacyCaption },
                        (0, _translations.ANNOUNCEMENT_EDIT_PRIVACY_CAPTION)(_react2.default.createElement(
                            'a',
                            {
                                className: _AnnouncementEditor2.default.externalLink,
                                onClick: this.handlePrivacyLinkOpening
                            },
                            _translations.ANNOUNCEMENT_EDIT_PRIVACY_LINK
                        ))
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _AnnouncementEditor2.default.footer },
                    _react2.default.createElement(_FooterEditControls.FooterEditControls, {
                        announcementMode: announcementMode,
                        state: savingButtonState,
                        onSave: this.handleSaving,
                        onCancel: this.handleCancel
                    })
                ),
                this.renderTooltips()
            );
        }
    }]);

    return AnnouncementEditorComponent;
}(_react2.default.Component);

AnnouncementEditorComponent.propTypes = {
    openedAnnouncement: _propTypes2.default.number,
    announcementError: _propTypes2.default.oneOf(Object.values(_constants2.ANNOUNCEMENT_ERROR)),
    privacyPolicyLink: _propTypes2.default.string.isRequired,
    maxMessageLength: _propTypes2.default.number.isRequired,
    defaultMessageLifetime: _propTypes2.default.number.isRequired,
    groupList: _propTypes2.default.array.isRequired,
    createAnnouncement: _propTypes2.default.func.isRequired,
    updateAnnouncement: _propTypes2.default.func.isRequired,

    item: _propTypes2.default.object,
    announcementMode: _propTypes2.default.oneOf(Object.values(_constants2.ANNOUNCEMENT_MODE)).isRequired,
    onChangeMode: _propTypes2.default.func.isRequired
};


var stateToProps = function stateToProps(state) {
    return {
        openedAnnouncement: state.announcements.openedAnnouncement,
        announcementError: state.announcements.error,
        privacyPolicyLink: state.announcements.settings.privacy_policy_link,
        maxMessageLength: state.announcements.settings.max_message_length,
        defaultMessageLifetime: state.announcements.settings.default_message_lifetime,
        groupList: state.announcements.settings.group_list
    };
};

var dispatchToProps = exports.dispatchToProps = function dispatchToProps(dispatch) {
    return {
        createAnnouncement: function createAnnouncement(data) {
            return dispatch((0, _announcements.createAnnouncement)(data));
        },
        updateAnnouncement: function updateAnnouncement(data) {
            return dispatch((0, _announcements.updateAnnouncement)(data));
        }
    };
};

var AnnouncementEditor = exports.AnnouncementEditor = (0, _reactRedux.connect)(stateToProps, dispatchToProps)(AnnouncementEditorComponent);

/***/ }),
/* 2328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TextArea = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactWotBootstrap = __webpack_require__(5);

var _TextArea = __webpack_require__(2329);

var _TextArea2 = _interopRequireDefault(_TextArea);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextArea = exports.TextArea = function (_React$Component) {
    _inherits(TextArea, _React$Component);

    function TextArea() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, TextArea);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TextArea.__proto__ || Object.getPrototypeOf(TextArea)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            isFocused: false,
            placeholder: _this.props.placeholder || '',
            value: _this.props.value || '',
            scrollOffset: 0
        }, _this.setTextAreaRef = function (element) {
            _this.textAreaRef = element;
        }, _this.focus = function () {
            if (_this.textAreaRef) {
                _this.textAreaRef.focus();
                _this.moveCaretAtTheEnd(_this.textAreaRef);
                _this.scrollAtTheEnd(_this.textAreaRef);
            }
        }, _this.blur = function () {
            _this.textAreaRef && _this.textAreaRef.blur();
        }, _this.handleFocus = function (e) {
            _this.setState({ isFocused: true });

            if (_this.props.onFocus) {
                _this.props.onFocus(_this.getEventWithValue(e));
            }
        }, _this.handleBlur = function (e) {
            _this.setState({ isFocused: false });
            _this.updateValue(e.target.innerText);

            if (_this.props.onBlur) {
                _this.props.onBlur(_this.getEventWithValue(e));
            }
        }, _this.handleInput = function (e) {
            if (_this.props.onChange) {
                _this.props.onChange(_this.getEventWithValue(e));
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(TextArea, [{
        key: 'updateValue',
        value: function updateValue(value) {
            this.setState({ value: value });
        }
    }, {
        key: 'moveCaretAtTheEnd',
        value: function moveCaretAtTheEnd(textArea) {
            var range = document.createRange();
            range.selectNodeContents(textArea);
            range.collapse(false);
            var selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
        }
    }, {
        key: 'scrollAtTheEnd',
        value: function scrollAtTheEnd(textArea) {
            var height = textArea.offsetHeight;
            this.setState({ scrollOffset: height });
        }
    }, {
        key: 'getEventWithValue',
        value: function getEventWithValue(e) {
            e.target.value = e.target.innerText;
            return e;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                disabled = _props.disabled,
                maxHeight = _props.maxHeight,
                width = _props.width,
                height = _props.height;
            var _state = this.state,
                isFocused = _state.isFocused,
                placeholder = _state.placeholder,
                value = _state.value,
                scrollOffset = _state.scrollOffset;


            var scrollableAreaHeight = Math.max(maxHeight, height);

            var isPlaceholderVisible = !(isFocused || value);

            var baseClassNames = (0, _classnames2.default)(_TextArea2.default.base, isFocused && _TextArea2.default.base__focused, isPlaceholderVisible && _TextArea2.default.base__placeholder, disabled && _TextArea2.default.base__disabled, this.props.className);

            return _react2.default.createElement(
                'div',
                {
                    className: baseClassNames,
                    style: { width: width }
                },
                _react2.default.createElement(
                    'div',
                    { className: _TextArea2.default.wrapper },
                    _react2.default.createElement(
                        _reactWotBootstrap.ScrollArea,
                        {
                            scrollableAreaHeight: scrollableAreaHeight,
                            scrollTopOffset: scrollOffset
                        },
                        _react2.default.createElement(
                            'div',
                            {
                                ref: this.setTextAreaRef,
                                contentEditable: !disabled && 'plaintext-only',
                                className: _TextArea2.default.textarea,
                                style: { minHeight: height },
                                onFocus: this.handleFocus,
                                onBlur: this.handleBlur,
                                onInput: this.handleInput,
                                suppressContentEditableWarning: true
                            },
                            isPlaceholderVisible ? placeholder : value
                        )
                    )
                ),
                disabled && _react2.default.createElement('div', { className: _TextArea2.default.disabledStateOverlay })
            );
        }
    }]);

    return TextArea;
}(_react2.default.Component);

TextArea.propTypes = {
    width: _propTypes2.default.number,
    height: _propTypes2.default.number,
    maxHeight: _propTypes2.default.number,
    value: _propTypes2.default.string,
    placeholder: _propTypes2.default.string,
    className: _propTypes2.default.string,
    disabled: _propTypes2.default.bool,
    onFocus: _propTypes2.default.func,
    onBlur: _propTypes2.default.func,
    onChange: _propTypes2.default.func
};
TextArea.defaultProps = {
    maxHeight: 200,
    disabled: false
};

/***/ }),
/* 2329 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"TextArea_base--25-gm","base__focused":"TextArea_base__focused--2dYyh","baseFocused":"TextArea_base__focused--2dYyh","base__placeholder":"TextArea_base__placeholder--jZwEW","basePlaceholder":"TextArea_base__placeholder--jZwEW","base__disabled":"TextArea_base__disabled--197CJ","baseDisabled":"TextArea_base__disabled--197CJ","wrapper":"TextArea_wrapper--1tvFA","textarea":"TextArea_textarea--tEZja","disabledStateOverlay":"TextArea_disabledStateOverlay--3ONb1"};

/***/ }),
/* 2330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FooterEditControls = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactWotBootstrap = __webpack_require__(5);

var _translations = __webpack_require__(166);

var _constants = __webpack_require__(43);

var _Footer = __webpack_require__(1364);

var _Footer2 = _interopRequireDefault(_Footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getSavingButtonTooltip = function getSavingButtonTooltip(state) {
    switch (state) {
        case _constants.FOOTER_EDIT_CONTROLS_STATE.MAX_CHARS:
            return _translations.ANNOUNCEMENT_EDIT_BUTTON_SAVE_TOOLTIP_LIMIT;
        case _constants.FOOTER_EDIT_CONTROLS_STATE.FORBIDDEN_WORDS:
            return _translations.ANNOUNCEMENT_EDIT_BUTTON_SAVE_TOOLTIP_FORBIDDEN;
        default:
            return '';
    }
};

var FooterEditControls = exports.FooterEditControls = function FooterEditControls(props) {
    var announcementMode = props.announcementMode,
        state = props.state,
        onSave = props.onSave,
        onCancel = props.onCancel;


    var isCreating = announcementMode === _constants.ANNOUNCEMENT_MODE.CREATE;
    var isDisabledSaving = state !== _constants.FOOTER_EDIT_CONTROLS_STATE.WITHOUT_RESTRICTION;

    var savingButtonTooltip = getSavingButtonTooltip(state);

    var savingButtonText = isCreating ? _translations.ANNOUNCEMENT_CREATE_BUTTON_SAVE : _translations.ANNOUNCEMENT_EDIT_BUTTON_SAVE;

    var baseClassNames = (0, _classnames2.default)(_Footer2.default.base, _Footer2.default.base__edit);

    return _react2.default.createElement(
        'div',
        { className: baseClassNames },
        _react2.default.createElement(
            'div',
            { className: _Footer2.default.button },
            _react2.default.createElement(
                _reactWotBootstrap.Button,
                {
                    isDisabled: isDisabledSaving,
                    tooltipId: _constants.TOOLTIP_IDS.BUTTON_SAVE,
                    onClick: function onClick() {
                        return onSave(_constants.ANNOUNCEMENT_MODE.CREATE);
                    }
                },
                _react2.default.createElement(
                    'span',
                    { className: _Footer2.default.buttonText },
                    savingButtonText
                )
            ),
            savingButtonTooltip && _react2.default.createElement(
                _reactWotBootstrap.Tooltip,
                { id: _constants.TOOLTIP_IDS.BUTTON_SAVE },
                savingButtonTooltip
            )
        ),
        _react2.default.createElement(
            'div',
            { className: _Footer2.default.button },
            _react2.default.createElement(
                _reactWotBootstrap.Button,
                {
                    type: 'secondary',
                    onClick: onCancel
                },
                _react2.default.createElement(
                    'span',
                    { className: _Footer2.default.buttonText },
                    _translations.ANNOUNCEMENT_EDIT_BUTTON_CANCEL
                )
            )
        )
    );
};

FooterEditControls.propTypes = {
    announcementMode: _propTypes2.default.oneOf(Object.values(_constants.ANNOUNCEMENT_MODE)).isRequired,
    state: _propTypes2.default.oneOf(Object.values(_constants.FOOTER_EDIT_CONTROLS_STATE)).isRequired,
    onSave: _propTypes2.default.func.isRequired,
    onCancel: _propTypes2.default.func.isRequired
};

/***/ }),
/* 2331 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"AnnouncementEditor_base--kbPdQ","content":"AnnouncementEditor_content--3D3cc","textarea":"AnnouncementEditor_textarea--3Bm2c","textareaHint":"AnnouncementEditor_textareaHint--2LUSA","boldHint":"AnnouncementEditor_boldHint--3X9K5","highlightedText":"AnnouncementEditor_highlightedText--3AA9F","highlightedText__exceeded":"AnnouncementEditor_highlightedText__exceeded--1QETK","highlightedTextExceeded":"AnnouncementEditor_highlightedText__exceeded--1QETK","groupType":"AnnouncementEditor_groupType--23BaO","announcementInfo":"AnnouncementEditor_announcementInfo--2FXEm","infoIcon":"AnnouncementEditor_infoIcon--2oKLx","privacyCaption":"AnnouncementEditor_privacyCaption--1knk3","externalLink":"AnnouncementEditor_externalLink--10iFQ","footer":"AnnouncementEditor_footer--3AODt"};

/***/ }),
/* 2332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ConfirmationScreen = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactWotBootstrap = __webpack_require__(5);

var _constants = __webpack_require__(43);

var _translations = __webpack_require__(166);

var _ConfirmationScreen = __webpack_require__(2333);

var _ConfirmationScreen2 = _interopRequireDefault(_ConfirmationScreen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConfirmationScreen = exports.ConfirmationScreen = function ConfirmationScreen(props) {
    var announcementMode = props.announcementMode,
        onApply = props.onApply,
        onCancel = props.onCancel,
        isDisabled = props.isDisabled;


    var isArchive = announcementMode === _constants.ANNOUNCEMENT_MODE.ARCHIVE;

    var title = isArchive ? _translations.ANNOUNCEMENT_CONFIRMATION_TITLE_ARCHIVE : _translations.ANNOUNCEMENT_CONFIRMATION_TITLE_DELETE;

    var description = isArchive ? _translations.ANNOUNCEMENT_CONFIRMATION_DESCRIPTION_ARCHIVE : _translations.ANNOUNCEMENT_CONFIRMATION_DESCRIPTION_DELETE;

    var applyButtonCaption = isArchive ? _translations.ANNOUNCEMENT_CONFIRMATION_BUTTON_APPLY_ARCHIVE : _translations.ANNOUNCEMENT_CONFIRMATION_BUTTON_APPLY_DELETE;

    return _react2.default.createElement(
        'div',
        { className: _ConfirmationScreen2.default.base },
        _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement('div', { className: _ConfirmationScreen2.default.warningIcon }),
            _react2.default.createElement(
                'div',
                { className: _ConfirmationScreen2.default.contentWrapper },
                _react2.default.createElement(
                    'h1',
                    { className: _ConfirmationScreen2.default.title },
                    title
                ),
                _react2.default.createElement(
                    'div',
                    { className: _ConfirmationScreen2.default.description },
                    description
                )
            ),
            _react2.default.createElement(
                'div',
                { className: _ConfirmationScreen2.default.controls },
                _react2.default.createElement(
                    _reactWotBootstrap.Button,
                    {
                        isDisabled: isDisabled,
                        onClick: onApply,
                        mixClassName: _ConfirmationScreen2.default.button
                    },
                    _react2.default.createElement(
                        'span',
                        { className: _ConfirmationScreen2.default.buttonText },
                        applyButtonCaption
                    )
                ),
                _react2.default.createElement(
                    _reactWotBootstrap.Button,
                    {
                        type: 'secondary',
                        onClick: onCancel,
                        mixClassName: _ConfirmationScreen2.default.button
                    },
                    _react2.default.createElement(
                        'span',
                        { className: _ConfirmationScreen2.default.buttonText },
                        _translations.ANNOUNCEMENT_CONFIRMATION_BUTTON_CANCEL
                    )
                )
            )
        )
    );
};

ConfirmationScreen.propTypes = {
    announcementMode: _propTypes2.default.oneOf(Object.values(_constants.ANNOUNCEMENT_MODE)).isRequired,
    onApply: _propTypes2.default.func.isRequired,
    onCancel: _propTypes2.default.func.isRequired,
    isDisabled: _propTypes2.default.bool
};

ConfirmationScreen.defaultProps = {
    isDisabled: false
};

/***/ }),
/* 2333 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"ConfirmationScreen_base--3HPGM","warningIcon":"ConfirmationScreen_warningIcon--LQoNz","contentWrapper":"ConfirmationScreen_contentWrapper--Aigwo","title":"ConfirmationScreen_title--uinrv","description":"ConfirmationScreen_description--3uM41","controls":"ConfirmationScreen_controls--IdLl7","button":"ConfirmationScreen_button--24A5m","buttonText":"ConfirmationScreen_buttonText--P7tq2"};

/***/ }),
/* 2334 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"AnnouncementOverlay_base--ksJ8e","contentWrapper":"AnnouncementOverlay_contentWrapper--395m_","contentWrapper__blur":"AnnouncementOverlay_contentWrapper__blur--1x2hx","contentWrapperBlur":"AnnouncementOverlay_contentWrapper__blur--1x2hx","back":"AnnouncementOverlay_back--kHbWR","header":"AnnouncementOverlay_header--3BT4q","main":"AnnouncementOverlay_main--uMzVG","footer":"AnnouncementOverlay_footer--tWezs","confirmationScreen":"AnnouncementOverlay_confirmationScreen--xwaLc"};

/***/ }),
/* 2335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sortAnnouncementCards = undefined;

var _constants = __webpack_require__(43);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var compareByType = function compareByType(a, b) {
    if (a.type === _constants.CARD_TYPES.ANNOUNCEMENTS) {
        if (b.type === _constants.CARD_TYPES.NEWS) {
            return -1;
        }

        return b.position - a.position;
    }

    if (b.type === _constants.CARD_TYPES.ANNOUNCEMENTS) {
        return 1;
    }

    return b.publication_start - a.publication_start;
};

/**
 * sort announcements and news mixed array:
 * first unread announcements ordered by date
 * then unread news ordered by publication date
 * then read announcements ordered by date
 * then read news ordered by publication date
 */
var sortAnnouncementCards = exports.sortAnnouncementCards = function sortAnnouncementCards(items, announcementsStatus) {
    return [].concat(_toConsumableArray(items)).sort(function (a, b) {
        if (announcementsStatus.isRead(a)) {
            if (announcementsStatus.isRead(b)) {
                return compareByType(a, b);
            }

            return 1;
        }

        if (announcementsStatus.isRead(b)) {
            return -1;
        }

        return compareByType(a, b);
    });
};

/***/ }),
/* 2336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AnnouncementsStatusModel = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _playersMatching = __webpack_require__(57);

var _constants = __webpack_require__(43);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AnnouncementsStatusModel = exports.AnnouncementsStatusModel = function () {
    function AnnouncementsStatusModel() {
        _classCallCheck(this, AnnouncementsStatusModel);

        this.readAnnouncements = {};
        this.readNews = {};
        this.displayedAnnouncements = {};
        this.displayedNews = {};

        this.readAnnouncements = (0, _playersMatching.getParsedStorageItem)(_constants.STORAGE_KEYS.READ_ANNOUNCEMENTS) || {};
        this.readNews = (0, _playersMatching.getParsedStorageItem)(_constants.STORAGE_KEYS.READ_NEWS) || {};
    }

    _createClass(AnnouncementsStatusModel, [{
        key: 'getAnnouncementKey',
        value: function getAnnouncementKey(item) {
            return item.type === _constants.CARD_TYPES.ANNOUNCEMENTS && item.message_id + '_' + item.created_at || item.type === _constants.CARD_TYPES.NEWS && item.news_id;
        }
    }, {
        key: 'getReadItems',
        value: function getReadItems(item) {
            return item.type === _constants.CARD_TYPES.ANNOUNCEMENTS ? this.readAnnouncements : this.readNews;
        }
    }, {
        key: 'getDisplayedItems',
        value: function getDisplayedItems(item) {
            return item.type === _constants.CARD_TYPES.ANNOUNCEMENTS ? this.displayedAnnouncements : this.displayedNews;
        }
    }, {
        key: 'saveReadAnnouncements',
        value: function saveReadAnnouncements() {
            (0, _playersMatching.saveToStorage)(_constants.STORAGE_KEYS.READ_ANNOUNCEMENTS, this.readAnnouncements);
            (0, _playersMatching.saveToStorage)(_constants.STORAGE_KEYS.READ_NEWS, this.readNews);
        }
    }, {
        key: 'markAllDisplayedAsRead',
        value: function markAllDisplayedAsRead() {
            this.readAnnouncements = Object.assign({}, this.readAnnouncements, this.displayedAnnouncements);
            this.readNews = Object.assign({}, this.readNews, this.displayedNews);
        }
    }, {
        key: 'markAsRead',
        value: function markAsRead(item) {
            this.getReadItems(item)[this.getAnnouncementKey(item)] = true;
        }
    }, {
        key: 'markAsDisplayed',
        value: function markAsDisplayed(item) {
            this.getDisplayedItems(item)[this.getAnnouncementKey(item)] = true;
        }
    }, {
        key: 'isRead',
        value: function isRead(item) {
            return item.type === _constants.CARD_TYPES.CREATE_NEW_ANNOUNCEMENT || this.getReadItems(item)[this.getAnnouncementKey(item)];
        }
    }]);

    return AnnouncementsStatusModel;
}();

/***/ }),
/* 2337 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tooltip-root":"AnnouncementsCard_tooltip-root--3HoBf","tooltipRoot":"AnnouncementsCard_tooltip-root--3HoBf","tooltip-root__show":"AnnouncementsCard_tooltip-root__show--1mmWJ","tooltipRootShow":"AnnouncementsCard_tooltip-root__show--1mmWJ","tooltip-body":"AnnouncementsCard_tooltip-body--1gDHF","tooltipBody":"AnnouncementsCard_tooltip-body--1gDHF","tooltip-wrapper":"AnnouncementsCard_tooltip-wrapper--1VQi8","tooltipWrapper":"AnnouncementsCard_tooltip-wrapper--1VQi8","tooltip-content":"AnnouncementsCard_tooltip-content--135WE","tooltipContent":"AnnouncementsCard_tooltip-content--135WE","tooltip-title":"AnnouncementsCard_tooltip-title--3akyV","tooltipTitle":"AnnouncementsCard_tooltip-title--3akyV","tooltip-subtitle":"AnnouncementsCard_tooltip-subtitle--qfImB","tooltipSubtitle":"AnnouncementsCard_tooltip-subtitle--qfImB","tooltip-message":"AnnouncementsCard_tooltip-message--2gB4w","tooltipMessage":"AnnouncementsCard_tooltip-message--2gB4w","tooltip-warning":"AnnouncementsCard_tooltip-warning--1KBr1","tooltipWarning":"AnnouncementsCard_tooltip-warning--1KBr1","tooltip-divider":"AnnouncementsCard_tooltip-divider--3aRTh","tooltipDivider":"AnnouncementsCard_tooltip-divider--3aRTh","tooltip-highlight":"AnnouncementsCard_tooltip-highlight--1KGJ3","tooltipHighlight":"AnnouncementsCard_tooltip-highlight--1KGJ3","tooltip-ribbon":"AnnouncementsCard_tooltip-ribbon--3o0oT","tooltipRibbon":"AnnouncementsCard_tooltip-ribbon--3o0oT","tooltip-statusMessage":"AnnouncementsCard_tooltip-statusMessage--30po4","tooltipStatusMessage":"AnnouncementsCard_tooltip-statusMessage--30po4","tooltip-statusMessage__positive":"AnnouncementsCard_tooltip-statusMessage__positive--okPRU","tooltipStatusMessagePositive":"AnnouncementsCard_tooltip-statusMessage__positive--okPRU","tooltip-status":"AnnouncementsCard_tooltip-status--2MvP2","tooltipStatus":"AnnouncementsCard_tooltip-status--2MvP2","tooltip-statusMessage__negative":"AnnouncementsCard_tooltip-statusMessage__negative--227hg","tooltipStatusMessageNegative":"AnnouncementsCard_tooltip-statusMessage__negative--227hg","tooltip-statusMessage__noPermission":"AnnouncementsCard_tooltip-statusMessage__noPermission--6Ak7w","tooltipStatusMessageNoPermission":"AnnouncementsCard_tooltip-statusMessage__noPermission--6Ak7w","tooltip-status__positive":"AnnouncementsCard_tooltip-status__positive--99M-I","tooltipStatusPositive":"AnnouncementsCard_tooltip-status__positive--99M-I","tooltip-status__negative":"AnnouncementsCard_tooltip-status__negative--2YK3O","tooltipStatusNegative":"AnnouncementsCard_tooltip-status__negative--2YK3O","tooltip-statusText":"AnnouncementsCard_tooltip-statusText--2vZhd","tooltipStatusText":"AnnouncementsCard_tooltip-statusText--2vZhd","base":"AnnouncementsCard_base--3qgpn","base__withQuests":"AnnouncementsCard_base__withQuests--6CQEg","baseWithQuests":"AnnouncementsCard_base__withQuests--6CQEg","newMarker":"AnnouncementsCard_newMarker--1GVJP","slideWrapper":"AnnouncementsCard_slideWrapper--2Rc1C","announcement":"AnnouncementsCard_announcement--10cU4","news":"AnnouncementsCard_news--p5x_B","newsTitle":"AnnouncementsCard_newsTitle--2jL7V","newsBackground":"AnnouncementsCard_newsBackground--tJLO3","defaultNewsBackground":"AnnouncementsCard_defaultNewsBackground--3VnIk","newsBackground__active":"AnnouncementsCard_newsBackground__active--3NEQ9","newsBackgroundActive":"AnnouncementsCard_newsBackground__active--3NEQ9","defaultNewsBackground__active":"AnnouncementsCard_defaultNewsBackground__active---AWwN","defaultNewsBackgroundActive":"AnnouncementsCard_defaultNewsBackground__active---AWwN","announcementContent":"AnnouncementsCard_announcementContent--2C_LT","announcementContent__new":"AnnouncementsCard_announcementContent__new--3h5wb","announcementContentNew":"AnnouncementsCard_announcementContent__new--3h5wb","announcementDivider":"AnnouncementsCard_announcementDivider--3lJIj","announcementButton":"AnnouncementsCard_announcementButton--3KwFa","newsExternalUrlIcon":"AnnouncementsCard_newsExternalUrlIcon--3qtoS","announcementIcon":"AnnouncementsCard_announcementIcon--3Po_I","announcementIcon__disabled":"AnnouncementsCard_announcementIcon__disabled--gTJGA","announcementIconDisabled":"AnnouncementsCard_announcementIcon__disabled--gTJGA","navigation":"AnnouncementsCard_navigation--MKpiz","navigationArrow":"AnnouncementsCard_navigationArrow--34giQ","paginator":"AnnouncementsCard_paginator--2lPt6","announcementOverlay":"AnnouncementsCard_announcementOverlay--P8UxO","cardSlider":"AnnouncementsCard_cardSlider--2vB7B"};

/***/ }),
/* 2338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapStateToProps = exports.ClanLandingReserves = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(7);

var _reactRouterRedux = __webpack_require__(15);

var _reactWotBootstrap = __webpack_require__(5);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _urls = __webpack_require__(19);

var _accounts = __webpack_require__(33);

var _ReserveBlock = __webpack_require__(2339);

var _ReserveBlock2 = _interopRequireDefault(_ReserveBlock);

var _sounds = __webpack_require__(22);

var _constants = __webpack_require__(391);

var _ClanLandingReserves = __webpack_require__(1365);

var _ClanLandingReserves2 = _interopRequireDefault(_ClanLandingReserves);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ClanLandingReserves = exports.ClanLandingReserves = function (_React$Component) {
    _inherits(ClanLandingReserves, _React$Component);

    function ClanLandingReserves() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ClanLandingReserves);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ClanLandingReserves.__proto__ || Object.getPrototypeOf(ClanLandingReserves)).call.apply(_ref, [this].concat(args))), _this), _this.state = { reserves: [] }, _this.handleOpenStronghold = function () {
            _this.props.openStronghold();
            _this.props.playClickSound();
            _this.props.sendEnterStrongholdSoundState();
            _this.props.playEnterStrongholdSound();
        }, _this.update = function () {
            _this.clearTimeouts();

            var now = Date.now();
            var isEffectActive = function isEffectActive(reserves) {
                return reserves.some(function (reserve) {
                    return reserve.effectEnds > now;
                });
            };
            var reserves = _this.props.reserves.filter(isEffectActive);

            _this.setState({ reserves: reserves });
            if (reserves.length) _this.timeoutId = setTimeout(_this.update, 1000);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ClanLandingReserves, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.update();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.props.reserves.length && !this.timeoutId) this.update();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.clearTimeouts();
        }
    }, {
        key: 'clearTimeouts',
        value: function clearTimeouts() {
            if (this.timeoutId) clearTimeout(this.timeoutId);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                canActivate = _props.canActivate,
                reserveGroups = _props.reserveGroups,
                reserveSettings = _props.reserveSettings;


            var reserves = this.state.reserves;

            if (!canActivate && !reserves.length) return null;

            var emptyBoxes = [];
            if (reserves.length < _constants.BOXES_COUNT && canActivate) emptyBoxes = Array.from({ length: _constants.BOXES_COUNT - reserves.length }, function () {
                return null;
            });

            var classNamesHeader = (0, _classnames2.default)(_ClanLandingReserves2.default.header, _defineProperty({}, _ClanLandingReserves2.default.header__fullSize, reserves.length === 2));
            var getTooltipId = function getTooltipId(index) {
                return _constants.NEW_RESERVE_TOOLTIP_ID + '_' + index;
            };
            return _react2.default.createElement(
                'div',
                { className: _ClanLandingReserves2.default.base },
                _react2.default.createElement(
                    'div',
                    { className: classNamesHeader },
                    _constants.HEADER_MESSAGE
                ),
                _react2.default.createElement(
                    'div',
                    { className: _ClanLandingReserves2.default.reservesWrapper },
                    reserves.map(function (reserveList) {
                        return _react2.default.createElement(_ReserveBlock2.default, {
                            key: reserveList[0].type,
                            reserveType: reserveList[0].type,
                            reserveList: reserveList,
                            reserveSettings: reserveSettings,
                            reserveGroups: reserveGroups,
                            openStronghold: _this2.handleOpenStronghold,
                            playHoverSound: _this2.props.playHoverSound
                        });
                    }),
                    emptyBoxes.map(function (_, index) {
                        return _react2.default.createElement(
                            'figure',
                            {
                                className: _ClanLandingReserves2.default.reserveContainer,
                                key: index,
                                onClick: _this2.handleOpenStronghold,
                                onMouseEnter: _this2.props.playHoverSound
                            },
                            _react2.default.createElement('div', {
                                className: _ClanLandingReserves2.default.blankImage,
                                'data-tip': true,
                                'data-for': getTooltipId(index)
                            }),
                            _react2.default.createElement(
                                _reactWotBootstrap.Tooltip,
                                { id: getTooltipId(index) },
                                _constants.COMMANDER_TOOLTIP_TEXT
                            )
                        );
                    })
                )
            );
        }
    }]);

    return ClanLandingReserves;
}(_react2.default.Component);

ClanLandingReserves.propTypes = {
    canActivate: _propTypes2.default.bool.isRequired,
    reserves: _propTypes2.default.array.isRequired,
    reserveGroups: _propTypes2.default.object.isRequired,
    reserveSettings: _propTypes2.default.object.isRequired,

    openStronghold: _propTypes2.default.func.isRequired,
    sendEnterStrongholdSoundState: _propTypes2.default.func.isRequired,
    playEnterStrongholdSound: _propTypes2.default.func.isRequired,
    playClickSound: _propTypes2.default.func.isRequired,
    playHoverSound: _propTypes2.default.func.isRequired
};
var mapStateToProps = exports.mapStateToProps = function mapStateToProps(_ref2) {
    var account = _ref2.account,
        clanReserves = _ref2.clanReserves,
        settings = _ref2.settings;
    var reserveSettings = settings.reserves,
        reserveGroups = settings.reserve_groups;

    var canActivate = (0, _accounts.canActivateReserves)(account);

    var effective = function effective(reserve) {
        return reserve.is_effective;
    };
    var compareActivity = function compareActivity(reserveList1, reserveList2) {
        return reserveList1.find(effective).effectEnds - reserveList2.find(effective).effectEnds;
    };
    var shouldShow = function shouldShow(reserveList) {
        return reserveList.length && _constants.RESERVES_TO_SHOW.includes(reserveList[0].type) && reserveList.some(effective);
    };

    var reserves = Object.values(clanReserves).filter(shouldShow).sort(compareActivity);

    return {
        canActivate: canActivate,
        reserves: reserves,
        reserveGroups: reserveGroups,
        reserveSettings: reserveSettings
    };
};
var mapDispatchToProps = {
    openStronghold: function openStronghold() {
        return (0, _reactRouterRedux.push)(_urls.STRONGHOLD);
    },
    sendEnterStrongholdSoundState: _sounds.sendEnterStrongholdSoundState,
    playEnterStrongholdSound: _sounds.playEnterStrongholdSound,
    playHoverSound: _sounds.playHoverSound,
    playClickSound: _sounds.playClickSound
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ClanLandingReserves);

/***/ }),
/* 2339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

var _reserves = __webpack_require__(28);

var _ReserveTooltip = __webpack_require__(1350);

var _ReserveTooltip2 = _interopRequireDefault(_ReserveTooltip);

var _Reserve = __webpack_require__(289);

var _Reserve2 = _interopRequireDefault(_Reserve);

var _ReserveProgress = __webpack_require__(1349);

var _ReserveProgress2 = _interopRequireDefault(_ReserveProgress);

var _Timer = __webpack_require__(51);

var _Timer2 = _interopRequireDefault(_Timer);

var _constants = __webpack_require__(391);

var _ClanLandingReserves = __webpack_require__(1365);

var _ClanLandingReserves2 = _interopRequireDefault(_ClanLandingReserves);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReserveBlock = function (_React$Component) {
    _inherits(ReserveBlock, _React$Component);

    function ReserveBlock() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ReserveBlock);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ReserveBlock.__proto__ || Object.getPrototypeOf(ReserveBlock)).call.apply(_ref, [this].concat(args))), _this), _this.getGroup = function (reserveType) {
            return Object.entries(_this.props.reserveGroups).find(function (_ref2) {
                var _ref3 = _slicedToArray(_ref2, 2),
                    groupName = _ref3[0],
                    reserves = _ref3[1];

                return reserves.includes(reserveType);
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ReserveBlock, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                reserveType = _props.reserveType,
                reserveList = _props.reserveList,
                reserveSettings = _props.reserveSettings,
                openStronghold = _props.openStronghold;

            var reserveBonus = (0, _reserves.getReserveBonus)(reserveSettings, reserveType);
            var effectiveReserve = reserveList.find(function (reserve) {
                return reserve.is_effective;
            });
            var endTime = (0, _moment2.default)(effectiveReserve.effectEnds);
            var level = effectiveReserve.level;

            var group = this.getGroup(reserveType);
            var bonusValues = (0, _reserves.getBonusValues)(reserveBonus, level);
            var popoverType = (0, _reserves.getTargetType)(group, bonusValues);

            var tooltipId = _constants.RESERVE_TOOLTIP_ID + '.' + reserveType;
            return _react2.default.createElement(
                'figure',
                { className: _ClanLandingReserves2.default.reserveContainer },
                _react2.default.createElement(
                    'div',
                    {
                        className: _ClanLandingReserves2.default.reserveImage,
                        onClick: openStronghold,
                        onMouseEnter: this.props.playHoverSound,
                        'data-popover-offset': '{ "bottom": 3 }',
                        'data-popover-type': popoverType,
                        'data-tip': true,
                        'data-for': tooltipId
                    },
                    _react2.default.createElement(
                        'div',
                        { className: _ClanLandingReserves2.default.progressContainer },
                        _react2.default.createElement(_ReserveProgress2.default, {
                            endTime: endTime,
                            totalDuration: reserveBonus.values[level - 1].duration
                        })
                    ),
                    _react2.default.createElement(_Reserve2.default, {
                        level: level,
                        type: reserveType,
                        modifier: _constants.MODIFIER_CLAN_LANDING,
                        reserves: reserveList
                    })
                ),
                _react2.default.createElement(
                    'figcaption',
                    { className: _ClanLandingReserves2.default.reserveCaption },
                    _react2.default.createElement(_Timer2.default, { endTime: endTime, hideSeconds: true })
                ),
                _react2.default.createElement(_ReserveTooltip2.default, {
                    id: tooltipId,
                    reserveType: reserveType,
                    reserves: _defineProperty({}, level, reserveList)
                })
            );
        }
    }]);

    return ReserveBlock;
}(_react2.default.Component);

ReserveBlock.propTypes = {
    openStronghold: _propTypes2.default.func.isRequired,
    reserveGroups: _propTypes2.default.object.isRequired,
    reserveList: _propTypes2.default.array.isRequired,
    reserveSettings: _propTypes2.default.object.isRequired,
    reserveType: _propTypes2.default.string.isRequired,
    playHoverSound: _propTypes2.default.func.isRequired
};
exports.default = ReserveBlock;

/***/ }),
/* 2340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _translations = __webpack_require__(78);

var _cards = __webpack_require__(94);

var _cards2 = _interopRequireDefault(_cards);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _ArcProgressbarQuest = __webpack_require__(2341);

var _ArcProgressbarQuest2 = _interopRequireDefault(_ArcProgressbarQuest);

var _ProgressbarTooltip = __webpack_require__(2343);

var _ProgressbarTooltip2 = _interopRequireDefault(_ProgressbarTooltip);

var _ClanSupplyFooterQuests = __webpack_require__(2344);

var _ClanSupplyFooterQuests2 = _interopRequireDefault(_ClanSupplyFooterQuests);

var _ClanSupplyQuestsTimer = __webpack_require__(2345);

var _ClanSupplyQuestsTimer2 = _interopRequireDefault(_ClanSupplyQuestsTimer);

var _selectors = __webpack_require__(569);

var _reactRedux = __webpack_require__(7);

var _clan_quests_constants = __webpack_require__(76);

var _web_to_client = __webpack_require__(17);

var _web_to_client2 = __webpack_require__(12);

var _QuestStatusTooltip = __webpack_require__(2350);

var _QuestStatusTooltip2 = _interopRequireDefault(_QuestStatusTooltip);

var _formatters = __webpack_require__(262);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var tooltipQuestId = 'tooltipId-clan-supply-quest-card-';

var ClanSupplyQuestsCard = (0, _react.memo)(function () {
    var quests = (0, _reactRedux.useSelector)(_selectors.selectQuests);
    var previousRewardsSum = quests.previousRewards.tourCoin + quests.previousRewards.industrialResource;
    var availableQuestIndex = quests.questsList.findIndex(function (quest) {
        return quest.status === _clan_quests_constants.QUEST_STATUSES.INCOMPLETE;
    });
    var isLockedByPreviousCycle = availableQuestIndex === 0 && previousRewardsSum > 0;

    var handleCardClick = function handleCardClick(event) {
        event.stopPropagation();

        (0, _web_to_client2.openClanSupplyQuests)();
    };

    var availableRewards = quests.questsList.reduce(function (acc, quest) {
        if (quest.status === _clan_quests_constants.QUEST_STATUSES.REWARD_AVAILABLE) {
            acc.tourCoin += quest.rewards.tourCoin;
            acc.industrialResource += quest.rewards.industrialResource;
        }

        return acc;
    }, {
        tourCoin: 0,
        industrialResource: 0
    });

    return _react2.default.createElement(
        'div',
        {
            className: (0, _classnames2.default)(_cards2.default.card, _cards2.default.clanSupplyQuestsCard),
            onClick: handleCardClick,
            onMouseDown: _web_to_client.sendClickSoundCommand,
            onMouseEnter: _web_to_client.sendHoverSoundCommand
        },
        _react2.default.createElement(
            'h2',
            null,
            _translations.CLAN_SUPPLY_QUESTS_TITLE
        ),
        _react2.default.createElement(
            'div',
            { className: _cards2.default.timer },
            _react2.default.createElement(_ClanSupplyQuestsTimer2.default, {
                cycleEnd: quests.cycleEnd
            })
        ),
        _react2.default.createElement(
            'div',
            { className: _cards2.default.quests },
            quests.questsList.map(function (item, index) {
                var tooltipQuestProgressBarId = tooltipQuestId + 'progressbar-' + index;
                var tooltipQuestStatusId = tooltipQuestId + 'status-' + index;
                var isAvailable = index === availableQuestIndex && !isLockedByPreviousCycle;

                return _react2.default.createElement(
                    'div',
                    {
                        className: _cards2.default.quest,
                        key: item.name
                    },
                    _react2.default.createElement(
                        'div',
                        {
                            'data-tip': true,
                            'data-for': tooltipQuestProgressBarId
                        },
                        _react2.default.createElement(_ArcProgressbarQuest2.default, {
                            level: item.level,
                            currentProgress: item.currentProgress,
                            requiredProgress: item.requiredProgress,
                            status: item.status,
                            isAvailable: isAvailable
                        }),
                        _react2.default.createElement(_ProgressbarTooltip2.default, {
                            id: tooltipQuestProgressBarId,
                            rule: item.conditions.main.rule.type,
                            value: item.conditions.main.rule.value,
                            squadStates: item.conditions.main.squadStates,
                            isClanSquad: item.conditions.main.isClanSquad,
                            levelFrom: item.conditions.common.levelFrom,
                            levelTo: item.conditions.common.levelTo,
                            status: item.status,
                            industrialResource: item.rewards.industrialResource,
                            tourCoin: item.rewards.tourCoin
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        {
                            className: _cards2.default.status,
                            'data-tip': true,
                            'data-for': tooltipQuestStatusId
                        },
                        isAvailable ? _react2.default.createElement(
                            'div',
                            { className: _cards2.default.progress },
                            (0, _translations.CLAN_SUPPLY_ARC_PROGRESSBAR_STATISTICS)(_react2.default.createElement(
                                'span',
                                { className: (0, _classnames2.default)(_cards2.default.current, item.currentProgress > 0 && _cards2.default.current__started)
                                },
                                item.currentProgress
                            ), _react2.default.createElement(
                                'span',
                                { className: _cards2.default.required },
                                item.requiredProgress
                            ))
                        ) : _react2.default.createElement('div', {
                            className: (0, _classnames2.default)(_cards2.default['icon-status'], item.status === _clan_quests_constants.QUEST_STATUSES.REWARD_PENDING && _cards2.default['icon-status__pending'], item.status === _clan_quests_constants.QUEST_STATUSES.REWARD_AVAILABLE && _cards2.default['icon-status__reward-available'], item.status === _clan_quests_constants.QUEST_STATUSES.COMPLETE && _cards2.default['icon-status__complete'])
                        }),
                        _react2.default.createElement(_QuestStatusTooltip2.default, {
                            id: tooltipQuestStatusId,
                            isAvailable: isAvailable,
                            previousRewardsSum: previousRewardsSum,
                            isLockedByPreviousCycle: isLockedByPreviousCycle,
                            status: item.status
                        })
                    )
                );
            })
        ),
        _react2.default.createElement(
            'p',
            { className: _cards2.default.rewards },
            (quests.previousRewards.tourCoin > 0 || availableRewards.tourCoin > 0) && _react2.default.createElement(
                'span',
                { className: (0, _classnames2.default)(_cards2.default.currencies, _cards2.default['currencies__tourCoin']) },
                (0, _formatters.thousands)(quests.previousRewards.tourCoin + availableRewards.tourCoin)
            ),
            (quests.previousRewards.industrialResource > 0 || availableRewards.industrialResource > 0) && _react2.default.createElement(
                'span',
                { className: (0, _classnames2.default)(_cards2.default.currencies, _cards2.default['currencies__industrialResource']) },
                (0, _formatters.thousands)(quests.previousRewards.industrialResource + availableRewards.industrialResource)
            )
        ),
        _react2.default.createElement(_ClanSupplyFooterQuests2.default, {
            questsList: quests.questsList,
            previousRewardsSum: previousRewardsSum
        })
    );
});

exports.default = ClanSupplyQuestsCard;

/***/ }),
/* 2341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _clan_quests_constants = __webpack_require__(76);

var _ArcProgressbarQuest = __webpack_require__(2342);

var _ArcProgressbarQuest2 = _interopRequireDefault(_ArcProgressbarQuest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ArcProgressbarQuest = (0, _react.memo)(function (_ref) {
    var isAvailable = _ref.isAvailable,
        currentProgress = _ref.currentProgress,
        requiredProgress = _ref.requiredProgress,
        status = _ref.status,
        level = _ref.level;

    var progress = 75 * (currentProgress / requiredProgress);
    var sparkLocation = 45 + currentProgress / requiredProgress * 270;
    var isInProgress = status === _clan_quests_constants.QUEST_STATUSES.INCOMPLETE && isAvailable;

    return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)(_ArcProgressbarQuest2.default.arc, _ArcProgressbarQuest2.default['arc__level-' + level]) },
            _react2.default.createElement('div', {
                style: { '--progress': progress + '%' },
                className: (0, _classnames2.default)(_ArcProgressbarQuest2.default.progressbar, isInProgress && _ArcProgressbarQuest2.default['progressbar__in-progress'], status !== _clan_quests_constants.QUEST_STATUSES.INCOMPLETE && _ArcProgressbarQuest2.default['progressbar__completed'])
            }),
            isAvailable && _react2.default.createElement(
                'div',
                {
                    style: { transform: 'rotate(' + sparkLocation + 'deg)' },
                    className: _ArcProgressbarQuest2.default['spark-wrapper']
                },
                _react2.default.createElement('div', { className: _ArcProgressbarQuest2.default.spark })
            )
        )
    );
});

ArcProgressbarQuest.propTypes = {
    isAvailable: _propTypes2.default.bool.isRequired,
    level: _propTypes2.default.oneOf([1, 2, 3]).isRequired,
    currentProgress: _propTypes2.default.number.isRequired,
    requiredProgress: _propTypes2.default.number.isRequired,
    status: _propTypes2.default.oneOf(Object.values(_clan_quests_constants.QUEST_STATUSES)).isRequired
};

exports.default = ArcProgressbarQuest;

/***/ }),
/* 2342 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tooltip-root":"ArcProgressbarQuest_tooltip-root--1jsuj","tooltipRoot":"ArcProgressbarQuest_tooltip-root--1jsuj","tooltip-root__show":"ArcProgressbarQuest_tooltip-root__show--1shJd","tooltipRootShow":"ArcProgressbarQuest_tooltip-root__show--1shJd","tooltip-body":"ArcProgressbarQuest_tooltip-body--_TNpP","tooltipBody":"ArcProgressbarQuest_tooltip-body--_TNpP","tooltip-wrapper":"ArcProgressbarQuest_tooltip-wrapper--3Odap","tooltipWrapper":"ArcProgressbarQuest_tooltip-wrapper--3Odap","tooltip-content":"ArcProgressbarQuest_tooltip-content--2zn58","tooltipContent":"ArcProgressbarQuest_tooltip-content--2zn58","tooltip-title":"ArcProgressbarQuest_tooltip-title--1MGK1","tooltipTitle":"ArcProgressbarQuest_tooltip-title--1MGK1","tooltip-subtitle":"ArcProgressbarQuest_tooltip-subtitle--3bz5g","tooltipSubtitle":"ArcProgressbarQuest_tooltip-subtitle--3bz5g","tooltip-message":"ArcProgressbarQuest_tooltip-message--16JtY","tooltipMessage":"ArcProgressbarQuest_tooltip-message--16JtY","tooltip-warning":"ArcProgressbarQuest_tooltip-warning--ZshJi","tooltipWarning":"ArcProgressbarQuest_tooltip-warning--ZshJi","tooltip-divider":"ArcProgressbarQuest_tooltip-divider--A3Cdh","tooltipDivider":"ArcProgressbarQuest_tooltip-divider--A3Cdh","tooltip-highlight":"ArcProgressbarQuest_tooltip-highlight--2VWem","tooltipHighlight":"ArcProgressbarQuest_tooltip-highlight--2VWem","tooltip-ribbon":"ArcProgressbarQuest_tooltip-ribbon--CV3_j","tooltipRibbon":"ArcProgressbarQuest_tooltip-ribbon--CV3_j","tooltip-statusMessage":"ArcProgressbarQuest_tooltip-statusMessage--zXdNm","tooltipStatusMessage":"ArcProgressbarQuest_tooltip-statusMessage--zXdNm","tooltip-statusMessage__positive":"ArcProgressbarQuest_tooltip-statusMessage__positive--MIMbK","tooltipStatusMessagePositive":"ArcProgressbarQuest_tooltip-statusMessage__positive--MIMbK","tooltip-status":"ArcProgressbarQuest_tooltip-status--3MoHX","tooltipStatus":"ArcProgressbarQuest_tooltip-status--3MoHX","tooltip-statusMessage__negative":"ArcProgressbarQuest_tooltip-statusMessage__negative--36Fn0","tooltipStatusMessageNegative":"ArcProgressbarQuest_tooltip-statusMessage__negative--36Fn0","tooltip-statusMessage__noPermission":"ArcProgressbarQuest_tooltip-statusMessage__noPermission--2Om8c","tooltipStatusMessageNoPermission":"ArcProgressbarQuest_tooltip-statusMessage__noPermission--2Om8c","tooltip-status__positive":"ArcProgressbarQuest_tooltip-status__positive--1rNC2","tooltipStatusPositive":"ArcProgressbarQuest_tooltip-status__positive--1rNC2","tooltip-status__negative":"ArcProgressbarQuest_tooltip-status__negative--Agilr","tooltipStatusNegative":"ArcProgressbarQuest_tooltip-status__negative--Agilr","tooltip-statusText":"ArcProgressbarQuest_tooltip-statusText--3KAQ3","tooltipStatusText":"ArcProgressbarQuest_tooltip-statusText--3KAQ3","arc":"ArcProgressbarQuest_arc--2YphT","arc__level-1":"ArcProgressbarQuest_arc__level-1--3VVxx","arcLevel1":"ArcProgressbarQuest_arc__level-1--3VVxx","arc__level-2":"ArcProgressbarQuest_arc__level-2--2A-TN","arcLevel2":"ArcProgressbarQuest_arc__level-2--2A-TN","arc__level-3":"ArcProgressbarQuest_arc__level-3--1LCpR","arcLevel3":"ArcProgressbarQuest_arc__level-3--1LCpR","progressbar":"ArcProgressbarQuest_progressbar--HvI3z","progressbar__in-progress":"ArcProgressbarQuest_progressbar__in-progress--14jHM","progressbarInProgress":"ArcProgressbarQuest_progressbar__in-progress--14jHM","progressbar__completed":"ArcProgressbarQuest_progressbar__completed--1O5xN","progressbarCompleted":"ArcProgressbarQuest_progressbar__completed--1O5xN","spark-wrapper":"ArcProgressbarQuest_spark-wrapper--3lBc9","sparkWrapper":"ArcProgressbarQuest_spark-wrapper--3lBc9","spark":"ArcProgressbarQuest_spark--14VwL"};

/***/ }),
/* 2343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Tooltip = __webpack_require__(155);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _translations = __webpack_require__(1366);

var _ClanSupplyTooltips = __webpack_require__(1367);

var _ClanSupplyTooltips2 = _interopRequireDefault(_ClanSupplyTooltips);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _clan_quests_constants = __webpack_require__(76);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getTaskDescription(value, rule, isSoloIncluded) {
    if (rule === _clan_quests_constants.QUEST_RULES.FULL_DAMAGE) {
        return (0, _translations.RULE_FULL_DAMAGE)(value, isSoloIncluded);
    }

    if (rule === _clan_quests_constants.QUEST_RULES.EXP) {
        return (0, _translations.RULE_EXP)(value, isSoloIncluded);
    }

    if (rule === _clan_quests_constants.QUEST_RULES.FRAGS) {
        return (0, _translations.RULE_FRAGS)(value, isSoloIncluded);
    }
}

var ProgressbarTooltip = (0, _react.memo)(function (_ref) {
    var id = _ref.id,
        rule = _ref.rule,
        squadStates = _ref.squadStates,
        isClanSquad = _ref.isClanSquad,
        value = _ref.value,
        levelFrom = _ref.levelFrom,
        levelTo = _ref.levelTo,
        status = _ref.status,
        industrialResource = _ref.industrialResource,
        tourCoin = _ref.tourCoin;

    return _react2.default.createElement(
        _Tooltip2.default,
        {
            id: id,
            isWide: true
        },
        _react2.default.createElement(
            'div',
            { className: _ClanSupplyTooltips2.default.wrapper },
            _react2.default.createElement(
                'p',
                { className: (0, _classnames2.default)(_ClanSupplyTooltips2.default['tooltip-title'], _ClanSupplyTooltips2.default.title) },
                _translations.TASK
            ),
            _react2.default.createElement(
                'p',
                { className: (0, _classnames2.default)(_ClanSupplyTooltips2.default['tooltip-message'], _ClanSupplyTooltips2.default.description) },
                getTaskDescription(value, rule, squadStates.includes(_clan_quests_constants.QUEST_SQUAD.SOLO))
            ),
            _react2.default.createElement(
                'p',
                { className: (0, _classnames2.default)(_ClanSupplyTooltips2.default['tooltip-subtitle'], _ClanSupplyTooltips2.default.restrictions) },
                _react2.default.createElement('span', { className: _ClanSupplyTooltips2.default.infoIcon }),
                _translations.LIMITS
            ),
            _react2.default.createElement(
                'p',
                { className: (0, _classnames2.default)(_ClanSupplyTooltips2.default['tooltip-message'], _ClanSupplyTooltips2.default.vehicleTier) },
                (0, _translations.LIMITS_DESCRIPTION)(levelFrom, levelTo, isClanSquad)
            ),
            _react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)(_ClanSupplyTooltips2.default['tooltip-subtitle'], _ClanSupplyTooltips2.default.reward) },
                _translations.REWARD,
                _react2.default.createElement('div', { className: _ClanSupplyTooltips2.default.divider }),
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)(_ClanSupplyTooltips2.default.currency, _ClanSupplyTooltips2.default.currency__tourCoin) },
                    tourCoin
                ),
                _react2.default.createElement('div', { className: _ClanSupplyTooltips2.default.iconPlus }),
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)(_ClanSupplyTooltips2.default.currency, _ClanSupplyTooltips2.default.currency__industrialResource) },
                    industrialResource
                )
            ),
            status !== _clan_quests_constants.QUEST_STATUSES.INCOMPLETE && _react2.default.createElement(
                'p',
                { className: _ClanSupplyTooltips2.default.done },
                status === _clan_quests_constants.QUEST_STATUSES.COMPLETE ? _translations.REWARD_TAKEN : _translations.DONE
            )
        )
    );
});

ProgressbarTooltip.propTypes = {
    id: _propTypes2.default.string.isRequired,
    rule: _propTypes2.default.oneOf(Object.values(_clan_quests_constants.QUEST_RULES)).isRequired,
    squadStates: _propTypes2.default.arrayOf(_propTypes2.default.oneOf(Object.values(_clan_quests_constants.QUEST_SQUAD))).isRequired,
    isClanSquad: _propTypes2.default.bool.isRequired,
    value: _propTypes2.default.number.isRequired,
    levelFrom: _propTypes2.default.number.isRequired,
    levelTo: _propTypes2.default.number.isRequired,
    status: _propTypes2.default.oneOf(Object.values(_clan_quests_constants.QUEST_STATUSES)).isRequired,
    industrialResource: _propTypes2.default.number.isRequired,
    tourCoin: _propTypes2.default.number.isRequired
};

exports.default = ProgressbarTooltip;

/***/ }),
/* 2344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _clan_quests_constants = __webpack_require__(76);

var _translations = __webpack_require__(78);

var _ClanSupplyFooter = __webpack_require__(1368);

var _ClanSupplyFooter2 = _interopRequireDefault(_ClanSupplyFooter);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactWotBootstrap = __webpack_require__(5);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _clan_supply_quests = __webpack_require__(283);

var _reactRedux = __webpack_require__(7);

var _web_to_client = __webpack_require__(12);

var _constants = __webpack_require__(4);

var _delay = __webpack_require__(974);

var _delay2 = _interopRequireDefault(_delay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var expectedStatuses = [_clan_quests_constants.QUEST_STATUSES.COMPLETE, _clan_quests_constants.QUEST_STATUSES.COMPLETE, _clan_quests_constants.QUEST_STATUSES.COMPLETE];

var ClanSupplyFooterQuests = (0, _react.memo)(function (_ref) {
    var previousRewardsSum = _ref.previousRewardsSum,
        questsList = _ref.questsList;

    var dispatch = (0, _reactRedux.useDispatch)();

    var _useState = (0, _react.useState)(true),
        _useState2 = _slicedToArray(_useState, 2),
        isButtonClickEnabled = _useState2[0],
        setIsButtonClickEnabled = _useState2[1];

    var store = (0, _reactRedux.useStore)();

    var handleClick = (0, _react.useCallback)(function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(event) {
            var state, requestNotPossibleByTimeout;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            event.stopPropagation();
                            setIsButtonClickEnabled(false);

                            _context.next = 4;
                            return dispatch((0, _clan_supply_quests.requestToTakeRewards)());

                        case 4:
                            state = store.getState();
                            requestNotPossibleByTimeout = state.clanSupplyQuests.lastRequestTimestamp && Date.now() - state.clanSupplyQuests.lastRequestTimestamp < _clan_supply_quests.REQUEST_INTERVAL;

                            if (!(state.clanSupplyQuests.loading || requestNotPossibleByTimeout)) {
                                _context.next = 9;
                                break;
                            }

                            _context.next = 9;
                            return (0, _delay2.default)(_clan_supply_quests.REQUEST_INTERVAL);

                        case 9:
                            _context.next = 11;
                            return dispatch((0, _clan_supply_quests.requestClanSupplyQuestsInfo)());

                        case 11:

                            (0, _web_to_client.setNewsCounter)(_constants.CLAN_SUPPLY_HANGAR_BUBBLE_KEY, 0);
                            setIsButtonClickEnabled(true);

                        case 13:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined);
        }));

        return function (_x) {
            return _ref2.apply(this, arguments);
        };
    }(), [dispatch, _clan_supply_quests.requestToTakeRewards, _clan_supply_quests.requestClanSupplyQuestsInfo]);

    var text = _translations.CLAN_SUPPLY_QUESTS_PLAY_WITH_TEAMMATES;
    var status = _clan_quests_constants.CLAN_SUPPLY_FOOTER_STATUSES.DEFAULT;
    var statuses = Object.values(questsList).map(function (item) {
        return item.status;
    });
    if (previousRewardsSum > 0 || statuses.includes(_clan_quests_constants.QUEST_STATUSES.REWARD_AVAILABLE)) {
        status = _clan_quests_constants.CLAN_SUPPLY_FOOTER_STATUSES.TAKE_PRIZE;
    } else if (statuses.includes(_clan_quests_constants.QUEST_STATUSES.REWARD_PENDING)) {
        text = _translations.CLAN_SUPPLY_IN_PROGRESS;
    } else if (statuses.every(function (element, index) {
        return element === expectedStatuses[index];
    })) {
        status = _clan_quests_constants.CLAN_SUPPLY_FOOTER_STATUSES.SUCCESS;
        text = _translations.CLAN_SUPPLY_QUESTS_ALL_DONE;
    }

    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_ClanSupplyFooter2.default.base, _ClanSupplyFooter2.default['base__status-' + status]) },
        status === _clan_quests_constants.CLAN_SUPPLY_FOOTER_STATUSES.TAKE_PRIZE ? _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
                _reactWotBootstrap.Button,
                { type: 'primary', onClick: handleClick, isDisabled: !isButtonClickEnabled },
                _translations.CLAN_SUPPLY_QUESTS_TAKE_REWARD
            )
        ) : _react2.default.createElement(
            _react2.default.Fragment,
            null,
            status === _clan_quests_constants.CLAN_SUPPLY_FOOTER_STATUSES.SUCCESS && _react2.default.createElement('div', { className: _ClanSupplyFooter2.default.iconStatus }),
            _react2.default.createElement(
                'p',
                { className: (0, _classnames2.default)(_ClanSupplyFooter2.default.text, status === _clan_quests_constants.CLAN_SUPPLY_FOOTER_STATUSES.SUCCESS && _ClanSupplyFooter2.default.text__success)
                },
                text
            )
        )
    );
});

ClanSupplyFooterQuests.propTypes = {
    previousRewardsSum: _propTypes2.default.number.isRequired,
    questsList: _propTypes2.default.array.isRequired
};

exports.default = ClanSupplyFooterQuests;

/***/ }),
/* 2345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _OrangeTimer = __webpack_require__(2346);

var _OrangeTimer2 = _interopRequireDefault(_OrangeTimer);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ClanSupplyQuestsTimer = __webpack_require__(2348);

var _ClanSupplyQuestsTimer2 = _interopRequireDefault(_ClanSupplyQuestsTimer);

var _reactRedux = __webpack_require__(7);

var _Tooltip = __webpack_require__(155);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _constants = __webpack_require__(4);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _translations = __webpack_require__(78);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var tooltipId = 'tooltipId-ClanSupplyQuests';

var ClanSupplyQuestsTimer = (0, _react.memo)(function (_ref) {
    var cycleEnd = _ref.cycleEnd;

    var _useSelector = (0, _reactRedux.useSelector)(function (state) {
        return state.client;
    }),
        deltaTime = _useSelector.deltaTime;

    return _react2.default.createElement(
        'div',
        {
            className: _ClanSupplyQuestsTimer2.default.base,
            'data-tip': true,
            'data-for': tooltipId
        },
        _react2.default.createElement(
            'div',
            { className: _ClanSupplyQuestsTimer2.default.effect },
            _react2.default.createElement('div', { className: _ClanSupplyQuestsTimer2.default.line })
        ),
        _react2.default.createElement(_OrangeTimer2.default, {
            endDate: cycleEnd,
            serverDelta: deltaTime,
            className: _ClanSupplyQuestsTimer2.default.timer,
            glowAt: 2 * _constants.ONE_HOUR,
            isSmall: true,
            showDays: true
        }),
        _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)(_ClanSupplyQuestsTimer2.default.effect, _ClanSupplyQuestsTimer2.default.effect__rotated) },
            _react2.default.createElement('div', { className: _ClanSupplyQuestsTimer2.default.line })
        ),
        _react2.default.createElement(
            _Tooltip2.default,
            { id: tooltipId },
            _react2.default.createElement(
                'p',
                { className: _ClanSupplyQuestsTimer2.default['tooltip-message'] },
                _translations.CLAN_SUPPLY_QUESTS_TIME_BEFORE_END
            )
        )
    );
});

ClanSupplyQuestsTimer.propTypes = {
    cycleEnd: _propTypes2.default.number.isRequired
};

exports.default = ClanSupplyQuestsTimer;

/***/ }),
/* 2346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _OrangeTimer = __webpack_require__(2347);

var _OrangeTimer2 = _interopRequireDefault(_OrangeTimer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OrangeTimer = function (_React$PureComponent) {
    _inherits(OrangeTimer, _React$PureComponent);

    function OrangeTimer(props) {
        _classCallCheck(this, OrangeTimer);

        var _this = _possibleConstructorReturn(this, (OrangeTimer.__proto__ || Object.getPrototypeOf(OrangeTimer)).call(this, props));

        _this.MILLISECONDS_IN_DAY = 24 * 60 * 60 * 1000;
        return _this;
    }

    _createClass(OrangeTimer, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.update(true);
        }
    }, {
        key: 'update',
        value: function update(isFirstTime) {
            var _this2 = this;

            var milliseconds = Math.max(_moment2.default.utc(this.props.endDate).diff((0, _moment2.default)().add(this.props.serverDelta)), 0);
            if (milliseconds === 0 && !!this.props.onExpired) {
                this.props.onExpired();
            }

            this.timeoutId = setTimeout(this.update.bind(this), 1000);

            if (isFirstTime && this.props.glowAt) {
                this.timeoutGlowId = setTimeout(function () {
                    _this2.setState({
                        showGlow: true
                    });
                }, milliseconds - this.props.glowAt);
            }

            this.setState({
                milliseconds: milliseconds
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.timeoutId) {
                clearTimeout(this.timeoutId);
            }
            if (this.timeoutGlowId) {
                clearTimeout(this.timeoutGlowId);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classNames;

            var baseClassName = (0, _classnames2.default)(_OrangeTimer2.default.base, this.props.className, (_classNames = {}, _defineProperty(_classNames, _OrangeTimer2.default.base__isSmall, this.props.isSmall), _defineProperty(_classNames, _OrangeTimer2.default.base__isBig, !this.props.isSmall), _classNames));
            var timeLeft = _moment2.default.utc(this.state.milliseconds);
            var days = Math.floor(this.state.milliseconds / this.MILLISECONDS_IN_DAY);
            if (days === 0 || !this.props.showDays) {
                var hours = days * 24 + timeLeft.hours();
                return _react2.default.createElement(
                    'div',
                    { className: baseClassName },
                    this.state.showGlow && _react2.default.createElement('div', { className: _OrangeTimer2.default.showGlow }),
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'shop.countdown.no.days',
                        defaultMessage: '{hours} : {minutes} : {seconds}',
                        values: {
                            hours: hours < 100 ? ('0' + (days * 24 + timeLeft.hours())).slice(-2) : hours,
                            minutes: ('0' + timeLeft.minutes()).slice(-2),
                            seconds: ('0' + timeLeft.seconds()).slice(-2)
                        }
                    })
                );
            }

            return _react2.default.createElement(
                'div',
                { className: baseClassName },
                this.state.showGlow && _react2.default.createElement('div', { className: _OrangeTimer2.default.showGlow }),
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'shop.countdown',
                    defaultMessage: '{days}\u0434 : {hours} : {minutes} : {seconds}',
                    values: {
                        days: days,
                        hours: ('0' + timeLeft.hours()).slice(-2),
                        minutes: ('0' + timeLeft.minutes()).slice(-2),
                        seconds: ('0' + timeLeft.seconds()).slice(-2)
                    }
                })
            );
        }
    }]);

    return OrangeTimer;
}(_react2.default.PureComponent);

OrangeTimer.propTypes = {
    className: _propTypes2.default.string,
    serverDelta: _propTypes2.default.number.isRequired,
    isSmall: _propTypes2.default.bool,
    endDate: _propTypes2.default.number.isRequired,
    showDays: _propTypes2.default.bool,
    onExpired: _propTypes2.default.func,
    glowAt: _propTypes2.default.number
};
exports.default = OrangeTimer;

/***/ }),
/* 2347 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"OrangeTimer_base--1qaWO","base__isSmall":"OrangeTimer_base__isSmall--Ry5EO","baseIsSmall":"OrangeTimer_base__isSmall--Ry5EO","base__isBig":"OrangeTimer_base__isBig--3K852","baseIsBig":"OrangeTimer_base__isBig--3K852","showGlow":"OrangeTimer_showGlow--3T8ix"};

/***/ }),
/* 2348 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tooltip-root":"ClanSupplyQuestsTimer_tooltip-root--2_zj-","tooltipRoot":"ClanSupplyQuestsTimer_tooltip-root--2_zj-","tooltip-root__show":"ClanSupplyQuestsTimer_tooltip-root__show--2CpBc","tooltipRootShow":"ClanSupplyQuestsTimer_tooltip-root__show--2CpBc","tooltip-body":"ClanSupplyQuestsTimer_tooltip-body--2qDHt","tooltipBody":"ClanSupplyQuestsTimer_tooltip-body--2qDHt","tooltip-wrapper":"ClanSupplyQuestsTimer_tooltip-wrapper--ReRL6","tooltipWrapper":"ClanSupplyQuestsTimer_tooltip-wrapper--ReRL6","tooltip-content":"ClanSupplyQuestsTimer_tooltip-content--2UefK","tooltipContent":"ClanSupplyQuestsTimer_tooltip-content--2UefK","tooltip-title":"ClanSupplyQuestsTimer_tooltip-title--3qIoF","tooltipTitle":"ClanSupplyQuestsTimer_tooltip-title--3qIoF","tooltip-subtitle":"ClanSupplyQuestsTimer_tooltip-subtitle--1IF5m","tooltipSubtitle":"ClanSupplyQuestsTimer_tooltip-subtitle--1IF5m","tooltip-message":"ClanSupplyQuestsTimer_tooltip-message--O0wp_","tooltipMessage":"ClanSupplyQuestsTimer_tooltip-message--O0wp_","tooltip-warning":"ClanSupplyQuestsTimer_tooltip-warning--3VX51","tooltipWarning":"ClanSupplyQuestsTimer_tooltip-warning--3VX51","tooltip-divider":"ClanSupplyQuestsTimer_tooltip-divider--1xpyo","tooltipDivider":"ClanSupplyQuestsTimer_tooltip-divider--1xpyo","tooltip-highlight":"ClanSupplyQuestsTimer_tooltip-highlight--3q-M3","tooltipHighlight":"ClanSupplyQuestsTimer_tooltip-highlight--3q-M3","tooltip-ribbon":"ClanSupplyQuestsTimer_tooltip-ribbon--Br_gA","tooltipRibbon":"ClanSupplyQuestsTimer_tooltip-ribbon--Br_gA","tooltip-statusMessage":"ClanSupplyQuestsTimer_tooltip-statusMessage--3kXa_","tooltipStatusMessage":"ClanSupplyQuestsTimer_tooltip-statusMessage--3kXa_","tooltip-statusMessage__positive":"ClanSupplyQuestsTimer_tooltip-statusMessage__positive--2-O_E","tooltipStatusMessagePositive":"ClanSupplyQuestsTimer_tooltip-statusMessage__positive--2-O_E","tooltip-status":"ClanSupplyQuestsTimer_tooltip-status--3kvS3","tooltipStatus":"ClanSupplyQuestsTimer_tooltip-status--3kvS3","tooltip-statusMessage__negative":"ClanSupplyQuestsTimer_tooltip-statusMessage__negative--3LC8x","tooltipStatusMessageNegative":"ClanSupplyQuestsTimer_tooltip-statusMessage__negative--3LC8x","tooltip-statusMessage__noPermission":"ClanSupplyQuestsTimer_tooltip-statusMessage__noPermission--2a2Uf","tooltipStatusMessageNoPermission":"ClanSupplyQuestsTimer_tooltip-statusMessage__noPermission--2a2Uf","tooltip-status__positive":"ClanSupplyQuestsTimer_tooltip-status__positive--1oowP","tooltipStatusPositive":"ClanSupplyQuestsTimer_tooltip-status__positive--1oowP","tooltip-status__negative":"ClanSupplyQuestsTimer_tooltip-status__negative--g_xdP","tooltipStatusNegative":"ClanSupplyQuestsTimer_tooltip-status__negative--g_xdP","tooltip-statusText":"ClanSupplyQuestsTimer_tooltip-statusText--KE4X9","tooltipStatusText":"ClanSupplyQuestsTimer_tooltip-statusText--KE4X9","base":"ClanSupplyQuestsTimer_base--1tF2s","timer":"ClanSupplyQuestsTimer_timer--2zrA6","effect":"ClanSupplyQuestsTimer_effect--WRyw-","effect__rotated":"ClanSupplyQuestsTimer_effect__rotated--Q7sqt","effectRotated":"ClanSupplyQuestsTimer_effect__rotated--Q7sqt","line":"ClanSupplyQuestsTimer_line--2fJRY"};

/***/ }),
/* 2349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.questsDataModel = questsDataModel;
exports.mapSettingsDataModel = mapSettingsDataModel;
exports.mapProgressDataModel = mapProgressDataModel;

var _get = __webpack_require__(156);

var _get2 = _interopRequireDefault(_get);

var _time = __webpack_require__(372);

var _clan_quests_constants = __webpack_require__(76);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */
function getQuestsList(data) {
    var questsList = [];

    if (data.quest_info && data.quest_info.length === 0) return questsList;

    for (var i = 0; i <= 2; i++) {
        var keyName = void 0;
        var rule = data.quest_info[i].conditions.main.rule;

        Object.keys(rule).filter(function (key) {
            return key !== 'type';
        }).forEach(function (key) {
            keyName = key;
        });

        questsList.push({
            level: (0, _get2.default)(data, 'quest_info.' + i + '.level', 1),
            name: (0, _get2.default)(data, 'quest_info.' + i + '.name', ''),
            currentProgress: (0, _get2.default)(data, 'quest_info.' + i + '.current_progress', 0),
            requiredProgress: (0, _get2.default)(data, 'quest_info.' + i + '.required_progress', 0),
            status: (0, _get2.default)(data, 'quest_info.' + i + '.status', _clan_quests_constants.QUEST_STATUSES.INCOMPLETE),
            rewards: {
                tourCoin: (0, _get2.default)(data, 'quest_info.' + i + '.rewards.tourcoin', 0),
                industrialResource: (0, _get2.default)(data, 'quest_info.' + i + '.rewards.industrial_resource', 0)
            },
            conditions: {
                main: {
                    rule: {
                        type: (0, _get2.default)(data, 'quest_info.' + i + '.conditions.main.rule.type', _clan_quests_constants.QUEST_RULES.FULL_DAMAGE),
                        value: (0, _get2.default)(data, 'quest_info.' + i + '.conditions.main.rule.' + keyName, 0)
                    },
                    squadStates: (0, _get2.default)(data, 'quest_info.' + i + '.conditions.main.squad_states', [_clan_quests_constants.QUEST_SQUAD.SOLO]),
                    isClanSquad: (0, _get2.default)(data, 'quest_info.' + i + '.conditions.main.is_clan_squad', false)
                },
                alternative: {
                    rule: {
                        type: (0, _get2.default)(data, 'quest_info.' + i + '.conditions.alternative.rule.type', _clan_quests_constants.QUEST_RULES.WIN)
                    },
                    squadStates: (0, _get2.default)(data, 'quest_info.' + i + '.conditions.alternative.rule.squad_states', [_clan_quests_constants.QUEST_SQUAD.SOLO]),
                    isClanSquad: (0, _get2.default)(data, 'quest_info.' + i + '.conditions.alternative.is_clan_squad', false)
                },
                common: {
                    levelFrom: (0, _get2.default)(data, 'quest_info.' + i + '.conditions.common.level_from', 0),
                    levelTo: (0, _get2.default)(data, 'quest_info.' + i + '.conditions.common.level_to', 0)
                }
            }
        });
    }

    return questsList;
}

function questsDataModel(data) {
    var questsList = getQuestsList(data);
    var enabled = questsList.length === 0 ? false : (0, _get2.default)(data, 'enabled', false);

    return {
        enabled: enabled,
        cycleDuration: (0, _get2.default)(data, 'cycle_duration', 0),
        cycleEnd: (0, _time.fromPythonTS)((0, _get2.default)(data, 'cycle_end', 0)),
        previousRewards: {
            tourCoin: (0, _get2.default)(data, 'previous_rewards.tourcoin', 0),
            industrialResource: (0, _get2.default)(data, 'previous_rewards.industrial_resource', 0)
        },
        questsList: questsList
    };
}

function mapSettingsDataModel(data) {
    return {
        enabled: (0, _get2.default)(data, 'enabled', false),
        regionsCount: (0, _get2.default)(data, 'regions_count', 0),
        prize: {
            availableImage: (0, _get2.default)(data, 'prize.available_image', ''),
            notAvailableImage: (0, _get2.default)(data, 'prize.not_available_image', ''),
            type: (0, _get2.default)(data, 'prize.type', _constants.VEHICLE_TYPES[0]),
            level: (0, _get2.default)(data, 'prize.level', 1),
            title: (0, _get2.default)(data, 'prize.title', '')
        }
    };
}

function mapProgressDataModel(data) {
    return {
        regionsUnlocked: (0, _get2.default)(data, 'regions_unlocked', 0),
        finalRegion: {
            status: (0, _get2.default)(data, 'final_region.status', _clan_quests_constants.TANK_STATUSES.UNAVAILABLE),
            price: (0, _get2.default)(data, 'final_region.price', 0)
        },
        cheapestRegionPrice: (0, _get2.default)(data, 'cheapest_region', 0)
    };
}

/***/ }),
/* 2350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Tooltip = __webpack_require__(155);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _translations = __webpack_require__(1366);

var _clan_quests_constants = __webpack_require__(76);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ClanSupplyTooltips = __webpack_require__(1367);

var _ClanSupplyTooltips2 = _interopRequireDefault(_ClanSupplyTooltips);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuestStatusTooltip = (0, _react.memo)(function (_ref) {
    var id = _ref.id,
        isAvailable = _ref.isAvailable,
        previousRewardsSum = _ref.previousRewardsSum,
        isLockedByPreviousCycle = _ref.isLockedByPreviousCycle,
        status = _ref.status;


    if (status === _clan_quests_constants.QUEST_STATUSES.COMPLETE) return null;

    if (status === _clan_quests_constants.QUEST_STATUSES.REWARD_AVAILABLE) return _react2.default.createElement(
        _Tooltip2.default,
        {
            id: id
        },
        _react2.default.createElement(
            'p',
            { className: _ClanSupplyTooltips2.default['tooltip-subtitle'] },
            _translations.DONE
        ),
        _react2.default.createElement(
            'p',
            { className: _ClanSupplyTooltips2.default['tooltip-message'] },
            _translations.DONE_DESCRIPTION
        )
    );

    if (status === _clan_quests_constants.QUEST_STATUSES.REWARD_PENDING) return _react2.default.createElement(
        _Tooltip2.default,
        {
            id: id
        },
        _react2.default.createElement(
            'p',
            { className: _ClanSupplyTooltips2.default['tooltip-message'] },
            _translations.PENDING
        )
    );

    if (!isAvailable) return _react2.default.createElement(
        _Tooltip2.default,
        {
            id: id
        },
        _react2.default.createElement(
            'p',
            { className: _ClanSupplyTooltips2.default['tooltip-subtitle'] },
            _translations.TASK_NOT_AVAILABLE
        ),
        _react2.default.createElement(
            'p',
            { className: _ClanSupplyTooltips2.default['tooltip-message'] },
            isLockedByPreviousCycle ? _translations.TASK_TAKE_PREV_REWARD : _translations.TASK_COMPLETE_PREVIOUS
        )
    );
});

QuestStatusTooltip.propTypes = {
    id: _propTypes2.default.string.isRequired,
    isAvailable: _propTypes2.default.bool.isRequired,
    previousRewardsSum: _propTypes2.default.number.isRequired,
    isLockedByPreviousCycle: _propTypes2.default.bool.isRequired,
    status: _propTypes2.default.oneOf(Object.values(_clan_quests_constants.QUEST_STATUSES)).isRequired
};

exports.default = QuestStatusTooltip;

/***/ }),
/* 2351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _cards = __webpack_require__(94);

var _cards2 = _interopRequireDefault(_cards);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _translations = __webpack_require__(78);

var _reactRedux = __webpack_require__(7);

var _ClanSupplyFooterProgression = __webpack_require__(2352);

var _ClanSupplyFooterProgression2 = _interopRequireDefault(_ClanSupplyFooterProgression);

var _selectors = __webpack_require__(569);

var _clan_quests_constants = __webpack_require__(76);

var _web_to_client = __webpack_require__(17);

var _web_to_client2 = __webpack_require__(12);

var _Tooltip = __webpack_require__(155);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _formatters = __webpack_require__(262);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var tooltipId = 'tooltipId-ClanSupplyProgression';

var ClanSupplyProgressionCard = (0, _react.memo)(function (_ref) {
    var tourCoin = _ref.tourCoin;

    var mapSettings = (0, _reactRedux.useSelector)(_selectors.selectMapSettings);
    var mapProgress = (0, _reactRedux.useSelector)(_selectors.selectMapProgress);
    var isTankAvailable = mapProgress.finalRegion.status === _clan_quests_constants.TANK_STATUSES.AVAILABLE;
    var explodedValue = (0, _formatters.thousands)(mapProgress.regionsUnlocked);
    var countValue = (0, _formatters.thousands)(mapSettings.regionsCount);

    return _react2.default.createElement(
        'div',
        {
            className: (0, _classnames2.default)(_cards2.default.card, _cards2.default.clanSupplyProgressionCard),
            onClick: _web_to_client2.openClanSupplyProgression,
            onMouseDown: _web_to_client.sendClickSoundCommand,
            onMouseEnter: _web_to_client.sendHoverSoundCommand
        },
        _react2.default.createElement('div', {
            className: _cards2.default.tankImage,
            style: { '--tank-image': 'url(' + (isTankAvailable ? mapSettings.prize.availableImage : mapSettings.prize.notAvailableImage) + ')' }
        }),
        _react2.default.createElement(
            'h2',
            null,
            _translations.CLAN_SUPPLY_PROGRESSION_TITLE
        ),
        _react2.default.createElement(
            'div',
            { className: _cards2.default.explored },
            _react2.default.createElement(
                'div',
                { className: _cards2.default.effect },
                _react2.default.createElement('div', { className: _cards2.default.line })
            ),
            _react2.default.createElement(
                'p',
                {
                    className: _cards2.default.exploredText,
                    'data-tip': true,
                    'data-for': tooltipId
                },
                mapProgress.regionsUnlocked === mapSettings.regionsCount ? _translations.CLAN_SUPPLY_PROGRESSION_ALL_REGIONS_EXPLORED : (0, _translations.CLAN_SUPPLY_PROGRESSION_REGIONS_EXPLORED)(_react2.default.createElement(
                    'span',
                    { className: _cards2.default.exploredCurrent },
                    explodedValue
                ), _react2.default.createElement(
                    'span',
                    { className: _cards2.default.exploredCount },
                    countValue
                ), _react2.default.createElement(
                    'span',
                    { className: _cards2.default.exploredDivider },
                    _translations.CLAN_SUPPLY_SLASH
                ))
            ),
            _react2.default.createElement(
                _Tooltip2.default,
                { id: tooltipId },
                _react2.default.createElement(
                    'p',
                    { className: _cards2.default['tooltip-message'] },
                    _translations.CLAN_SUPPLY_PROGRESSION_PROGRESS_TOOLTIP
                )
            ),
            _react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)(_cards2.default.effect, _cards2.default.effect__rotated) },
                _react2.default.createElement('div', { className: _cards2.default.line })
            )
        ),
        _react2.default.createElement(_ClanSupplyFooterProgression2.default, {
            tankStatus: mapProgress.finalRegion.status,
            type: mapSettings.prize.type,
            level: mapSettings.prize.level,
            title: mapSettings.prize.title,
            isNewStageAvailable: tourCoin >= mapProgress.cheapestRegionPrice
        })
    );
});

ClanSupplyProgressionCard.propTypes = {
    tourCoin: _propTypes2.default.number.isRequired
};

exports.default = ClanSupplyProgressionCard;

/***/ }),
/* 2352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ClanSupplyFooter = __webpack_require__(1368);

var _ClanSupplyFooter2 = _interopRequireDefault(_ClanSupplyFooter);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _clan_quests_constants = __webpack_require__(76);

var _translations = __webpack_require__(78);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _constants = __webpack_require__(4);

var _helpers = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getStatus = function getStatus(isNewStageAvailable, isTankAcquired) {
    if (isTankAcquired) {
        return _clan_quests_constants.CLAN_SUPPLY_FOOTER_STATUSES.SUCCESS;
    }
    if (isNewStageAvailable) {
        return _clan_quests_constants.CLAN_SUPPLY_FOOTER_STATUSES.CAN_EXAMINE;
    }

    return _clan_quests_constants.CLAN_SUPPLY_FOOTER_STATUSES.DEFAULT;
};

var ClanSupplyFooterProgression = (0, _react.memo)(function (_ref) {
    var tankStatus = _ref.tankStatus,
        type = _ref.type,
        level = _ref.level,
        title = _ref.title,
        isNewStageAvailable = _ref.isNewStageAvailable;

    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_ClanSupplyFooter2.default.base, _ClanSupplyFooter2.default['base__status-' + getStatus(isNewStageAvailable, tankStatus === _clan_quests_constants.TANK_STATUSES.ACQUIRED)])
        },
        isNewStageAvailable && tankStatus !== _clan_quests_constants.TANK_STATUSES.ACQUIRED && _react2.default.createElement('div', { className: _ClanSupplyFooter2.default.canExamineEffect }),
        (tankStatus === _clan_quests_constants.TANK_STATUSES.ACQUIRED || isNewStageAvailable) && _react2.default.createElement('div', { className: (0, _classnames2.default)(_ClanSupplyFooter2.default.iconStatus) }),
        _react2.default.createElement(
            'p',
            { className: _ClanSupplyFooter2.default.text },
            function () {
                switch (true) {
                    case tankStatus === _clan_quests_constants.TANK_STATUSES.AVAILABLE:
                        return _translations.CLAN_SUPPLY_PROGRESSION_EXPLORE_WITH_NEW_TANK;
                    case tankStatus === _clan_quests_constants.TANK_STATUSES.ACQUIRED:
                        return (0, _translations.CLAN_SUPPLY_PROGRESSION_TANK_RECEIVED)(_react2.default.createElement(
                            'span',
                            { className: _ClanSupplyFooter2.default.vehicleLevel },
                            (0, _helpers.toRoman)(level)
                        ), _react2.default.createElement('div', { className: (0, _classnames2.default)(_ClanSupplyFooter2.default.typeIcon, _ClanSupplyFooter2.default['typeIcon__' + type]) }), _react2.default.createElement(
                            'span',
                            { className: _ClanSupplyFooter2.default.vehicleTitle },
                            title
                        ));
                    case isNewStageAvailable:
                        return _translations.CLAN_SUPPLY_PROGRESSION_CAN_OPEN_NEW_REGION;
                    default:
                        return _translations.CLAN_SUPPLY_PROGRESSION_EXPLORE_NEW_REGIONS;
                }
            }()
        )
    );
});

ClanSupplyFooterProgression.propTypes = {
    tankStatus: _propTypes2.default.oneOf(Object.values(_clan_quests_constants.TANK_STATUSES)).isRequired,
    type: _propTypes2.default.oneOf(Object.values(_constants.VEHICLE_TYPES)).isRequired,
    level: _propTypes2.default.number.isRequired,
    title: _propTypes2.default.string.isRequired,
    isNewStageAvailable: _propTypes2.default.bool.isRequired
};

exports.default = ClanSupplyFooterProgression;

/***/ }),
/* 2353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _cards = __webpack_require__(94);

var _cards2 = _interopRequireDefault(_cards);

var _DisabledCard = __webpack_require__(2354);

var _DisabledCard2 = _interopRequireDefault(_DisabledCard);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DisabledCard = (0, _react.memo)(function (_ref) {
    var title = _ref.title,
        text = _ref.text;

    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_cards2.default.card, _DisabledCard2.default.base) },
        _react2.default.createElement(
            'h2',
            null,
            title
        ),
        _react2.default.createElement(
            'p',
            null,
            text
        )
    );
});

DisabledCard.propTypes = {
    title: _propTypes2.default.string.isRequired,
    text: _propTypes2.default.string.isRequired
};

exports.default = DisabledCard;

/***/ }),
/* 2354 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"DisabledCard_base--V3GX4"};

/***/ }),
/* 2355 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"ClanLanding_base--1zRd7","wrapper":"ClanLanding_wrapper--9A0p4","wrapper__blurred":"ClanLanding_wrapper__blurred--3fXis","wrapperBlurred":"ClanLanding_wrapper__blurred--3fXis","header":"ClanLanding_header--2-uTi","clan_tag":"ClanLanding_clan_tag--1kTkK","clanTag":"ClanLanding_clan_tag--1kTkK","clan_logo":"ClanLanding_clan_logo--2Qigi","clanLogo":"ClanLanding_clan_logo--2Qigi","card":"ClanLanding_card--1fnDl","card__multiplier":"ClanLanding_card__multiplier--2C5Bo","cardMultiplier":"ClanLanding_card__multiplier--2C5Bo","card__hover_overlay":"ClanLanding_card__hover_overlay--mBtht","cardHoverOverlay":"ClanLanding_card__hover_overlay--mBtht","card__disabled":"ClanLanding_card__disabled--3eBIK","cardDisabled":"ClanLanding_card__disabled--3eBIK","reactive_indicator":"ClanLanding_reactive_indicator--gWo8r","reactiveIndicator":"ClanLanding_reactive_indicator--gWo8r","header_wrapper":"ClanLanding_header_wrapper--3xnvt","headerWrapper":"ClanLanding_header_wrapper--3xnvt","main_card":"ClanLanding_main_card--1vM92","mainCard":"ClanLanding_main_card--1vM92","announcements_card":"ClanLanding_announcements_card--2NHJy","announcementsCard":"ClanLanding_announcements_card--2NHJy","stronghold_card":"ClanLanding_stronghold_card--2iz90","strongholdCard":"ClanLanding_stronghold_card--2iz90","globalmap_card":"ClanLanding_globalmap_card--387RX","globalmapCard":"ClanLanding_globalmap_card--387RX","maneuvers_card":"ClanLanding_maneuvers_card--1VzA-","maneuversCard":"ClanLanding_maneuvers_card--1VzA-","clanquests_card":"ClanLanding_clanquests_card--1aUIF","clanquestsCard":"ClanLanding_clanquests_card--1aUIF","clanSupplyQuests_card":"ClanLanding_clanSupplyQuests_card--1BNu8","clanSupplyQuestsCard":"ClanLanding_clanSupplyQuests_card--1BNu8","clanSupplyProgression_card":"ClanLanding_clanSupplyProgression_card--1ywop","clanSupplyProgressionCard":"ClanLanding_clanSupplyProgression_card--1ywop","grid":"ClanLanding_grid--3kF6u","grid__with_maneuvers":"ClanLanding_grid__with_maneuvers--fhh8x","gridWithManeuvers":"ClanLanding_grid__with_maneuvers--fhh8x","grid__with_announcements":"ClanLanding_grid__with_announcements--XExmg","gridWithAnnouncements":"ClanLanding_grid__with_announcements--XExmg","grid__with_clanquests":"ClanLanding_grid__with_clanquests--2clGd","gridWithClanquests":"ClanLanding_grid__with_clanquests--2clGd","grid__with_announcements_and_clanquests":"ClanLanding_grid__with_announcements_and_clanquests--3_lWw","gridWithAnnouncementsAndClanquests":"ClanLanding_grid__with_announcements_and_clanquests--3_lWw","grid__with_announcements_and_maneuvers":"ClanLanding_grid__with_announcements_and_maneuvers--3AjnG","gridWithAnnouncementsAndManeuvers":"ClanLanding_grid__with_announcements_and_maneuvers--3AjnG","grid__with_clanquests_and_maneuvers":"ClanLanding_grid__with_clanquests_and_maneuvers--21MF5","gridWithClanquestsAndManeuvers":"ClanLanding_grid__with_clanquests_and_maneuvers--21MF5","grid__with_announcements_and_clanquests_and_maneuvers":"ClanLanding_grid__with_announcements_and_clanquests_and_maneuvers--ILp4H","gridWithAnnouncementsAndClanquestsAndManeuvers":"ClanLanding_grid__with_announcements_and_clanquests_and_maneuvers--ILp4H","grid__with_clansupply":"ClanLanding_grid__with_clansupply--Ep3g4","gridWithClansupply":"ClanLanding_grid__with_clansupply--Ep3g4","grid__with_announcements_and_clansupply":"ClanLanding_grid__with_announcements_and_clansupply--igqX7","gridWithAnnouncementsAndClansupply":"ClanLanding_grid__with_announcements_and_clansupply--igqX7","grid__with_clansupply_and_maneuvers":"ClanLanding_grid__with_clansupply_and_maneuvers--33-zN","gridWithClansupplyAndManeuvers":"ClanLanding_grid__with_clansupply_and_maneuvers--33-zN","grid__with_announcements_and_clansupply_and_maneuvers":"ClanLanding_grid__with_announcements_and_clansupply_and_maneuvers--2pV2K","gridWithAnnouncementsAndClansupplyAndManeuvers":"ClanLanding_grid__with_announcements_and_clansupply_and_maneuvers--2pV2K"};

/***/ }),
/* 2356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.stateToProps = undefined;

var _reactRedux = __webpack_require__(7);

var _ClanQuestsTutorialView = __webpack_require__(2357);

var stateToProps = exports.stateToProps = function stateToProps(state) {
    return {
        language: state.locale.language,
        videoId: state.clanQuests.tutorial_video_id,
        isCNRealm: state.settings.isCNRealm
    };
};

exports.default = (0, _reactRedux.connect)(stateToProps)(_ClanQuestsTutorialView.ClanQuestsTutorialView);

/***/ }),
/* 2357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ClanQuestsTutorialView = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(4);

var _ClanQuestsTutorialView = __webpack_require__(2358);

var _ClanQuestsTutorialView2 = _interopRequireDefault(_ClanQuestsTutorialView);

var _Back = __webpack_require__(70);

var _Back2 = _interopRequireDefault(_Back);

var _Pagination = __webpack_require__(2359);

var _YoutubeVideo = __webpack_require__(2367);

var _translations = __webpack_require__(2368);

var _reactWotBootstrap = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var maxPagesCount = 4;

var ClanQuestsTutorialView = exports.ClanQuestsTutorialView = function (_React$PureComponent) {
    _inherits(ClanQuestsTutorialView, _React$PureComponent);

    function ClanQuestsTutorialView(props) {
        _classCallCheck(this, ClanQuestsTutorialView);

        var _this = _possibleConstructorReturn(this, (ClanQuestsTutorialView.__proto__ || Object.getPrototypeOf(ClanQuestsTutorialView)).call(this, props));

        _this.onKeyDown = function (e) {
            if (e.keyCode !== _constants.KEY_CODES.ESCAPE) {
                return;
            }
            _this.props.onClose();
        };

        _this.handleClanQuestIntroPageUpdate = function (pageIndex) {
            _this.setState({ pageIndex: pageIndex });
        };

        _this.renderPage = function () {
            switch (_this.state.pageIndex) {
                case 0:
                    {
                        return _this.props.isCNRealm ? _react2.default.createElement(
                            'video',
                            {
                                controls: true,
                                className: _ClanQuestsTutorialView2.default.video,
                                disablePictureInPicture: true,
                                controlsList: 'nodownload noremoteplayback'
                            },
                            _react2.default.createElement('source', { src: _this.props.videoId, type: 'video/webm' })
                        ) : _react2.default.createElement('iframe', {
                            className: _ClanQuestsTutorialView2.default.video,
                            id: 'youtube-video',
                            sandbox: 'allow-forms allow-scripts allow-pointer-lock allow-same-origin allow-top-navigation',
                            src: (0, _YoutubeVideo.generateYouTubeLink)(_this.props.videoId, _this.props.language),
                            allowFullScreen: true
                        });
                    }
                case 1:
                    {
                        return _react2.default.createElement(
                            'div',
                            { className: (0, _classnames2.default)(_ClanQuestsTutorialView2.default.page, _ClanQuestsTutorialView2.default.page2) },
                            _react2.default.createElement('div', { className: _ClanQuestsTutorialView2.default.img }),
                            _react2.default.createElement(
                                'div',
                                { className: _ClanQuestsTutorialView2.default.content },
                                _react2.default.createElement(
                                    'div',
                                    { className: _ClanQuestsTutorialView2.default.contentTitle },
                                    _translations.PAGE_2_TITLE
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: _ClanQuestsTutorialView2.default.contentDescription },
                                    _translations.PAGE_2_DESCRIPTION
                                )
                            )
                        );
                    }
                case 2:
                    {
                        return _react2.default.createElement(
                            'div',
                            { className: (0, _classnames2.default)(_ClanQuestsTutorialView2.default.page, _ClanQuestsTutorialView2.default.page3) },
                            _react2.default.createElement('div', { className: _ClanQuestsTutorialView2.default.img }),
                            _react2.default.createElement(
                                'div',
                                { className: _ClanQuestsTutorialView2.default.content },
                                _react2.default.createElement(
                                    'div',
                                    { className: _ClanQuestsTutorialView2.default.contentTitle },
                                    _translations.PAGE_3_TITLE
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: _ClanQuestsTutorialView2.default.contentDescription },
                                    _translations.PAGE_3_DESCRIPTION
                                )
                            )
                        );
                    }
                case 3:
                    {
                        return _react2.default.createElement(
                            'div',
                            { className: (0, _classnames2.default)(_ClanQuestsTutorialView2.default.page, _ClanQuestsTutorialView2.default.page4) },
                            _react2.default.createElement('div', { className: _ClanQuestsTutorialView2.default.img }),
                            _react2.default.createElement(
                                'div',
                                { className: _ClanQuestsTutorialView2.default.content },
                                _react2.default.createElement(
                                    'div',
                                    { className: _ClanQuestsTutorialView2.default.contentTitle },
                                    _translations.PAGE_4_TITLE
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: _ClanQuestsTutorialView2.default.contentDescription },
                                    _translations.PAGE_4_DESCRIPTION
                                )
                            )
                        );
                    }
                default:
                    {
                        return null;
                    }
            }
        };

        _this.state = {
            pageIndex: 0
        };
        _this.videoAPI = _YoutubeVideo.video.loadAPI();
        return _this;
    }

    _createClass(ClanQuestsTutorialView, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.addEventListener('keydown', this.onKeyDown);

            this.videoAPI.then(function () {
                _YoutubeVideo.video.createPlayer('youtube-video', false);
            });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('keydown', this.onKeyDown);

            this.videoAPI.then(function () {
                _YoutubeVideo.video.destroyPlayer('youtube-video');
            });
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: _ClanQuestsTutorialView2.default.base },
                _react2.default.createElement(
                    'div',
                    { className: _ClanQuestsTutorialView2.default.closeButton },
                    _react2.default.createElement(_Back2.default, {
                        type: _Back2.default.TYPES.close,
                        side: _Back2.default.SIDES.right,
                        caption: _Back2.default.CAPTIONS.close,
                        handleClick: this.props.onClose
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: _ClanQuestsTutorialView2.default.wrapper },
                    _react2.default.createElement(
                        'div',
                        { className: _ClanQuestsTutorialView2.default.paginationCounter },
                        this.state.pageIndex + 1 + ' / ' + maxPagesCount
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _ClanQuestsTutorialView2.default.title },
                        _translations.CLAN_QUEST_TUTORIAL_TITLE
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _ClanQuestsTutorialView2.default.description },
                        _translations.CLAN_QUEST_TUTORIAL_DESCRIPTION
                    ),
                    _react2.default.createElement(
                        _Pagination.Pagination,
                        {
                            className: _ClanQuestsTutorialView2.default.pagination,
                            onChange: this.handleClanQuestIntroPageUpdate,
                            pagesCount: maxPagesCount,
                            hasPageButtons: false,
                            hasArrow: true
                        },
                        this.renderPage()
                    ),
                    _react2.default.createElement('div', { className: _ClanQuestsTutorialView2.default.divider }),
                    _react2.default.createElement(
                        _reactWotBootstrap.Button,
                        { mixClassName: _ClanQuestsTutorialView2.default.affirmativeButton, onClick: this.props.onClose },
                        _translations.AFFIRMATIVE_BUTTON
                    )
                )
            );
        }
    }]);

    return ClanQuestsTutorialView;
}(_react2.default.PureComponent);

ClanQuestsTutorialView.propTypes = {
    videoId: _propTypes2.default.string.isRequired,
    language: _propTypes2.default.string.isRequired,
    isCNRealm: _propTypes2.default.bool.isRequired,
    onClose: _propTypes2.default.func.isRequired
};

/***/ }),
/* 2358 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"ClanQuestsTutorialView_base--jPEZe","closeButton":"ClanQuestsTutorialView_closeButton--1-9Kq","wrapper":"ClanQuestsTutorialView_wrapper--1DRJg","paginationCounter":"ClanQuestsTutorialView_paginationCounter--3CaZs","title":"ClanQuestsTutorialView_title--Dwh7M","description":"ClanQuestsTutorialView_description--29iJc","page":"ClanQuestsTutorialView_page--2Frjm","video":"ClanQuestsTutorialView_video--EIaMq","img":"ClanQuestsTutorialView_img--2d5fo","page2":"ClanQuestsTutorialView_page2--2XPqG","page3":"ClanQuestsTutorialView_page3--2UShU","page4":"ClanQuestsTutorialView_page4--2Fr1j","content":"ClanQuestsTutorialView_content--3oT7i","contentTitle":"ClanQuestsTutorialView_contentTitle--39G3c","contentDescription":"ClanQuestsTutorialView_contentDescription--2RtpQ","divider":"ClanQuestsTutorialView_divider--1IaO0","affirmativeButton":"ClanQuestsTutorialView_affirmativeButton--TKLDp"};

/***/ }),
/* 2359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Pagination = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _PaginationList = __webpack_require__(2360);

var _PaginationArrowButton = __webpack_require__(2364);

var _PaginationArrowButton2 = _interopRequireDefault(_PaginationArrowButton);

var _contants = __webpack_require__(1370);

var _Pagination = __webpack_require__(2366);

var _Pagination2 = _interopRequireDefault(_Pagination);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Pagination = exports.Pagination = function (_React$PureComponent) {
    _inherits(Pagination, _React$PureComponent);

    function Pagination() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Pagination);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Pagination.__proto__ || Object.getPrototypeOf(Pagination)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            currentSelected: _this.props.selectedPage || 0
        }, _this.handleRenderClick = function (value) {
            _this.setState({ currentSelected: value });
        }, _this.handleLeftArrowClick = function () {
            _this.setState({ currentSelected: _this.state.currentSelected - 1 });
        }, _this.handleRightArrowClick = function () {
            _this.setState({ currentSelected: _this.state.currentSelected + 1 });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Pagination, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (prevState.currentSelected !== this.state.currentSelected) {
                this.props.onChange(this.state.currentSelected);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                pagesCount = _props.pagesCount,
                children = _props.children,
                className = _props.className,
                hasArrow = _props.hasArrow,
                hasPageButtons = _props.hasPageButtons;

            var baseClassName = (0, _classnames2.default)(_Pagination2.default.base, className);

            return _react2.default.createElement(
                'div',
                { className: baseClassName },
                _react2.default.createElement(
                    'div',
                    { className: _Pagination2.default.content },
                    hasArrow && _react2.default.createElement(_PaginationArrowButton2.default, {
                        onClick: this.handleLeftArrowClick,
                        direction: _contants.ArrowDirection.Back,
                        isLocked: this.state.currentSelected === 0
                    }),
                    _react2.default.createElement(
                        'div',
                        { className: _Pagination2.default.children },
                        children
                    ),
                    hasArrow && _react2.default.createElement(_PaginationArrowButton2.default, {
                        onClick: this.handleRightArrowClick,
                        direction: _contants.ArrowDirection.Forward,
                        isLocked: this.state.currentSelected === pagesCount - 1
                    })
                ),
                hasPageButtons && _react2.default.createElement(_PaginationList.PaginationList, {
                    className: _Pagination2.default.list,
                    selectedPage: this.state.currentSelected,
                    pagesCount: pagesCount,
                    onChange: this.handleRenderClick
                })
            );
        }
    }]);

    return Pagination;
}(_react2.default.PureComponent);

Pagination.propTypes = {
    pagesCount: _propTypes2.default.number.isRequired,
    className: _propTypes2.default.string,
    selectedPage: _propTypes2.default.number,
    hasArrow: _propTypes2.default.bool,
    hasPageButtons: _propTypes2.default.bool,
    onChange: _propTypes2.default.func.isRequired
};
Pagination.defaultProps = {
    hasPageButtons: true
};

/***/ }),
/* 2360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PaginationList = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _PaginationRender = __webpack_require__(2361);

var _PaginationRender2 = _interopRequireDefault(_PaginationRender);

var _PaginationList = __webpack_require__(2363);

var _PaginationList2 = _interopRequireDefault(_PaginationList);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PaginationList = exports.PaginationList = function (_React$PureComponent) {
    _inherits(PaginationList, _React$PureComponent);

    function PaginationList() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, PaginationList);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PaginationList.__proto__ || Object.getPrototypeOf(PaginationList)).call.apply(_ref, [this].concat(args))), _this), _this.renderButtons = function () {
            var maxIndex = _this.props.pagesCount - 1;
            var buttons = [];
            for (var i = 0; i < _this.props.pagesCount; i++) {
                buttons.push(_react2.default.createElement(_PaginationRender2.default, {
                    onClick: _this.props.onChange,
                    index: i,
                    isLast: i === maxIndex,
                    isSelected: _this.props.selectedPage === i,
                    key: i
                }));
            }
            return buttons;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(PaginationList, [{
        key: 'render',
        value: function render() {
            var baseClassName = (0, _classnames2.default)(_PaginationList2.default.base, this.props.className);

            return _react2.default.createElement(
                'div',
                { className: baseClassName },
                this.renderButtons()
            );
        }
    }]);

    return PaginationList;
}(_react2.default.PureComponent);

PaginationList.propTypes = {
    pagesCount: _propTypes2.default.number.isRequired,
    className: _propTypes2.default.string,
    selectedPage: _propTypes2.default.number.isRequired,
    onChange: _propTypes2.default.func.isRequired
};

/***/ }),
/* 2361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PaginationRender = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _PaginationRender = __webpack_require__(2362);

var _PaginationRender2 = _interopRequireDefault(_PaginationRender);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _sounds = __webpack_require__(22);

var _reactRedux = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PaginationRender = exports.PaginationRender = function (_React$PureComponent) {
    _inherits(PaginationRender, _React$PureComponent);

    function PaginationRender() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, PaginationRender);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PaginationRender.__proto__ || Object.getPrototypeOf(PaginationRender)).call.apply(_ref, [this].concat(args))), _this), _this.handleMouseClick = function () {
            _this.props.onClick(_this.props.index);
            _this.props.playButtonClickSound();
        }, _this.handleMouseEnter = function () {
            _this.props.playHoverSound();
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(PaginationRender, [{
        key: 'render',
        value: function render() {
            var _classNames;

            var _props = this.props,
                isSelected = _props.isSelected,
                isLast = _props.isLast,
                index = _props.index,
                className = _props.className;

            var baseClassName = (0, _classnames2.default)(_PaginationRender2.default.base, (_classNames = {}, _defineProperty(_classNames, _PaginationRender2.default.base__isLast, isLast), _defineProperty(_classNames, _PaginationRender2.default.base__selected, isSelected), _classNames), className);

            return _react2.default.createElement(
                'div',
                {
                    className: baseClassName,
                    onClick: this.handleMouseClick,
                    onMouseEnter: this.handleMouseEnter
                },
                isSelected && _react2.default.createElement('span', { className: _PaginationRender2.default.selectedImage }),
                index + 1
            );
        }
    }]);

    return PaginationRender;
}(_react2.default.PureComponent);

PaginationRender.propTypes = {
    index: _propTypes2.default.number.isRequired,
    className: _propTypes2.default.string,
    isSelected: _propTypes2.default.bool,
    isLast: _propTypes2.default.bool,
    onClick: _propTypes2.default.func.isRequired,
    playHoverSound: _propTypes2.default.func.isRequired,
    playButtonClickSound: _propTypes2.default.func.isRequired
};


var mapDispatchToProps = { playHoverSound: _sounds.playHoverSound, playButtonClickSound: _sounds.playButtonClickSound };

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(PaginationRender);

/***/ }),
/* 2362 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"PaginationRender_base--1AgBL","base__isLast":"PaginationRender_base__isLast--3UUV5","baseIsLast":"PaginationRender_base__isLast--3UUV5","base__selected":"PaginationRender_base__selected--1NYMu","baseSelected":"PaginationRender_base__selected--1NYMu","selectedImage":"PaginationRender_selectedImage--27EwD"};

/***/ }),
/* 2363 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"PaginationList_base--21QZ1"};

/***/ }),
/* 2364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PaginationArrowButton = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _contants = __webpack_require__(1370);

var _PaginationArrowButton = __webpack_require__(2365);

var _PaginationArrowButton2 = _interopRequireDefault(_PaginationArrowButton);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _sounds = __webpack_require__(22);

var _reactRedux = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PaginationArrowButton = exports.PaginationArrowButton = function (_React$PureComponent) {
    _inherits(PaginationArrowButton, _React$PureComponent);

    function PaginationArrowButton() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, PaginationArrowButton);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PaginationArrowButton.__proto__ || Object.getPrototypeOf(PaginationArrowButton)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function () {
            if (!_this.props.isLocked) {
                _this.props.onClick();
                _this.props.playClickSound();
            }
        }, _this.handleMouseEnter = function () {
            if (!_this.props.isLocked) {
                _this.props.playHoverSound();
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(PaginationArrowButton, [{
        key: 'render',
        value: function render() {
            var baseClassName = (0, _classnames2.default)(_PaginationArrowButton2.default.base, this.props.isLocked && _PaginationArrowButton2.default.base__locked, this.props.className);

            var iconClassName = (0, _classnames2.default)(_PaginationArrowButton2.default.icon, _PaginationArrowButton2.default['icon__' + this.props.direction]);

            return _react2.default.createElement(
                'div',
                { className: baseClassName },
                _react2.default.createElement('div', {
                    className: iconClassName,
                    onClick: this.handleClick,
                    onMouseEnter: this.handleMouseEnter
                })
            );
        }
    }]);

    return PaginationArrowButton;
}(_react2.default.PureComponent);

PaginationArrowButton.propTypes = {
    className: _propTypes2.default.string,
    direction: _propTypes2.default.oneOf(Object.values(_contants.ArrowDirection)).isRequired,
    isLocked: _propTypes2.default.bool,
    onClick: _propTypes2.default.func.isRequired,
    playHoverSound: _propTypes2.default.func.isRequired,
    playClickSound: _propTypes2.default.func.isRequired
};


var mapDispatchToProps = { playHoverSound: _sounds.playHoverSound, playClickSound: _sounds.playClickSound };

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(PaginationArrowButton);

/***/ }),
/* 2365 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"PaginationArrowButton_base--xHf0R","base__locked":"PaginationArrowButton_base__locked--v0PHw","baseLocked":"PaginationArrowButton_base__locked--v0PHw","icon":"PaginationArrowButton_icon--3N1Tz","icon__back":"PaginationArrowButton_icon__back--3fJzW","iconBack":"PaginationArrowButton_icon__back--3fJzW","icon__forward":"PaginationArrowButton_icon__forward--MpAuz","iconForward":"PaginationArrowButton_icon__forward--MpAuz"};

/***/ }),
/* 2366 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Pagination_base--16i5I","content":"Pagination_content--1Yu3f","list":"Pagination_list--3ygQE","children":"Pagination_children--v2Hu4"};

/***/ }),
/* 2367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.generateYouTubeLink = exports.video = exports.YoutubeVideo = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _forOwn = __webpack_require__(935);

var _forOwn2 = _interopRequireDefault(_forOwn);

var _isFunction = __webpack_require__(123);

var _isFunction2 = _interopRequireDefault(_isFunction);

var _web_to_client = __webpack_require__(12);

var _helpers = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var YOUTUBE_IFRAME_API_ENDPOINT = 'https://www.youtube.com/iframe_api';
var API_LOAD_TIMEOUT = 5 * 1000; // 5 sec

var YoutubeVideo = exports.YoutubeVideo = function () {
    function YoutubeVideo(global) {
        _classCallCheck(this, YoutubeVideo);

        this._global = global;

        this._videoPlayers = {};
        this._isSoundMuted = false;
        this._YT = null;
        this._isLoaded = false;
    }

    _createClass(YoutubeVideo, [{
        key: 'muteSound',
        value: function muteSound() {
            (0, _web_to_client.musicOnOff)(true);
        }
    }, {
        key: 'unmuteSound',
        value: function unmuteSound() {
            (0, _web_to_client.musicOnOff)(false);
        }
    }, {
        key: 'isLoaded',
        value: function isLoaded() {
            return this._isLoaded;
        }
    }, {
        key: 'loadAPI',
        value: function loadAPI() {
            var _this = this;

            if (this._isLoaded) {
                return Promise.resolve();
            }

            var loadingPromise = new Promise(function (resolve) {
                var apiLoadingTimer = void 0;

                apiLoadingTimer = setTimeout(function () {
                    _this._isLoaded = true;
                    resolve();
                }, API_LOAD_TIMEOUT);

                _this._global.onYouTubeIframeAPIReady = function () {
                    _this._YT = _this._global.YT;
                    _this._isLoaded = true;
                    clearTimeout(apiLoadingTimer);

                    _this._global.addEventListener('beforeunload', function () {
                        if (_this._isSoundMuted) {
                            _this.unmuteSound();
                        }
                    });

                    resolve();
                };
            });

            var youtubeApiScript = this._global.document.createElement('script');
            var firstScriptTag = this._global.document.getElementsByTagName('script')[0];
            youtubeApiScript.src = YOUTUBE_IFRAME_API_ENDPOINT;
            firstScriptTag.parentNode.insertBefore(youtubeApiScript, firstScriptTag);

            return loadingPromise;
        }

        /**
         * @param {string} id
         * @param {boolean} isPlayingForced
         */

    }, {
        key: 'createPlayer',
        value: function createPlayer(id, isPlayingForced) {
            var _this2 = this;

            var player = this._videoPlayers[id];
            var YT = this._YT;

            if (player || !YT) {
                return;
            }

            player = new YT.Player(id, {
                playerVars: {
                    autoplay: isPlayingForced ? 1 : 0
                },
                events: {
                    onReady: function onReady() {
                        if (isPlayingForced) {
                            player.playVideo();
                        }
                    },
                    onStateChange: function onStateChange(data) {
                        var isAnythingPlaying = void 0;

                        switch (data.data) {
                            case YT.PlayerState.PLAYING:
                                (0, _forOwn2.default)(_this2._videoPlayers, function (videoPlayer, videoPlayerId) {
                                    if ((0, _isFunction2.default)(videoPlayer.pauseVideo) && videoPlayerId !== id) {
                                        videoPlayer.pauseVideo();
                                    }
                                });

                                if (!_this2._isSoundMuted) {
                                    _this2.muteSound();
                                    _this2._isSoundMuted = true;
                                }
                                break;
                            case YT.PlayerState.ENDED:
                            case YT.PlayerState.PAUSED:
                                isAnythingPlaying = false;
                                (0, _forOwn2.default)(_this2._videoPlayers, function (videoPlayer) {
                                    if (videoPlayer.getPlayerState() === YT.PlayerState.PLAYING) {
                                        isAnythingPlaying = true;
                                    }
                                });
                                if (!isAnythingPlaying && _this2._isSoundMuted) {
                                    _this2.unmuteSound();
                                    _this2._isSoundMuted = false;
                                }
                                break;
                        }
                    }
                }
            });
            this._videoPlayers[id] = player;
        }

        /**
         * @param {string} id
         */

    }, {
        key: 'destroyPlayer',
        value: function destroyPlayer(id) {
            var player = this._videoPlayers[id];

            if (!player || !this._YT) {
                return;
            }

            if (this._isSoundMuted) {
                this.unmuteSound();
                this._isSoundMuted = false;
            }

            this._videoPlayers[id] = null;
        }
    }]);

    return YoutubeVideo;
}();

var video = exports.video = new YoutubeVideo(window);

/**
 * @param {string} youTubeId
 * @param {string} langCode
 * @param {boolean} show_subtitles
 * @param {boolean} autoplay
 * @returns {string}
 */
var generateYouTubeLink = exports.generateYouTubeLink = function generateYouTubeLink(youTubeId, langCode) {
    var show_subtitles = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var autoplay = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    var params = {
        modestbranding: 1,
        rel: 0,
        showinfo: 0,
        iv_load_policy: 3,
        disablekb: 1,
        hl: langCode,
        controls: 1,
        enablejsapi: 1,
        autoplay: autoplay ? 1 : 0,
        cc_load_policy: 0
    };
    if (show_subtitles) {
        params.cc_lang_pref = langCode;
        params.cc_load_policy = 1;
    }
    return '' + youTubeId + (0, _helpers.serialize)(params);
};

/***/ }),
/* 2368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PAGE_4_DESCRIPTION = exports.PAGE_4_TITLE = exports.PAGE_3_DESCRIPTION = exports.PAGE_3_TITLE = exports.PAGE_2_DESCRIPTION = exports.PAGE_2_TITLE = exports.AFFIRMATIVE_BUTTON = exports.CLAN_QUEST_TUTORIAL_DESCRIPTION = exports.CLAN_QUEST_TUTORIAL_TITLE = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */
var CLAN_QUEST_TUTORIAL_TITLE = exports.CLAN_QUEST_TUTORIAL_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_quests.tutorial.title',
    defaultMessage: '\u0411\u041E\u0415\u0412\u042B\u0415 \u041F\u041E\u0425\u041E\u0414\u042B'
});

var CLAN_QUEST_TUTORIAL_DESCRIPTION = exports.CLAN_QUEST_TUTORIAL_DESCRIPTION = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_quests.tutorial.description',
    defaultMessage: '\u0411\u043E\u0435\u0432\u044B\u0435 \u043F\u043E\u0445\u043E\u0434\u044B \u2014 \u0440\u0435\u0433\u0443\u043B\u044F\u0440\u043D\u044B\u0435 \u0438\u0433\u0440\u043E\u0432\u044B\u0435 \u0441\u043E\u0431\u044B\u0442\u0438\u044F, \u0432 \u043A\u043E\u0442\u043E\u0440\u044B\u0445 \u0438\u0433\u0440\u043E\u043A\u0438 \u043E\u0434\u043D\u043E\u0433\u043E \u043A\u043B\u0430\u043D\u0430 \u0441\u043E\u0432\u043C\u0435\u0441\u0442\u043D\u044B\u043C\u0438 \u0443\u0441\u0438\u043B\u0438\u044F\u043C\u0438 \u0437\u0430\u043F\u043E\u043B\u043D\u044F\u044E\u0442 \u0448\u043A\u0430\u043B\u0443 \u043F\u0440\u043E\u0434\u0432\u0438\u0436\u0435\u043D\u0438\u044F. \u0417\u0430 \u0434\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u0435 \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0445 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0439 \u043F\u0440\u043E\u0433\u0440\u0435\u0441\u0441\u0430 \u0438\u0433\u0440\u043E\u043A\u0438 \u043A\u043B\u0430\u043D\u0430 \u043F\u043E\u043B\u0443\u0447\u0430\u044E\u0442 \u0446\u0435\u043D\u043D\u044B\u0435 \u043D\u0430\u0433\u0440\u0430\u0434\u044B.'
});

var AFFIRMATIVE_BUTTON = exports.AFFIRMATIVE_BUTTON = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_quests.tutorial.affirmative.button',
    defaultMessage: '\u0422\u0430\u043A \u0442\u043E\u0447\u043D\u043E!'
});

var PAGE_2_TITLE = exports.PAGE_2_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_quests.tutorial.page2.title',
    defaultMessage: '\u0417\u0430\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0439\u0442\u0435 \u043E\u0447\u043A\u0438'
});

var PAGE_2_DESCRIPTION = exports.PAGE_2_DESCRIPTION = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_quests.tutorial.page2.description',
    defaultMessage: '\u0412\u044B\u043F\u043E\u043B\u043D\u044F\u0439\u0442\u0435 \u043F\u043E\u0440\u0443\u0447\u0435\u043D\u0438\u044F, \u0447\u0442\u043E\u0431\u044B \u0437\u0430\u0440\u0430\u0431\u043E\u0442\u0430\u0442\u044C \u043E\u0447\u043A\u0438 \u043B\u0438\u0447\u043D\u043E\u0433\u043E \u0432\u043A\u043B\u0430\u0434\u0430 \u0438 \u043E\u0447\u043A\u0438 \u043F\u043E\u0445\u043E\u0434\u0430.{brTag}{brTag}\u0414\u043E\u0441\u0442\u0438\u0433\u0430\u0439\u0442\u0435 \u043A\u043B\u0430\u043D\u043E\u043C \u0446\u0435\u043B\u0438 \u043F\u043E\u0445\u043E\u0434\u0430, \u0447\u0442\u043E\u0431\u044B \u0437\u0430\u0440\u0430\u0431\u043E\u0442\u0430\u0442\u044C \u0435\u0449\u0451 \u0431\u043E\u043B\u044C\u0448\u0435 \u043E\u0447\u043A\u043E\u0432.',
    values: {
        brTag: _react2.default.createElement('br', null)
    }
});

var PAGE_3_TITLE = exports.PAGE_3_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_quests.tutorial.page3.title',
    defaultMessage: '\u041F\u0440\u043E\u0434\u0432\u0438\u0433\u0430\u0439\u0442\u0435\u0441\u044C \u0432\u043F\u0435\u0440\u0451\u0434'
});

var PAGE_3_DESCRIPTION = exports.PAGE_3_DESCRIPTION = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_quests.tutorial.page3.description',
    defaultMessage: '\u0417\u0430\u0440\u0430\u0431\u043E\u0442\u0430\u043D\u043D\u044B\u0435 \u043E\u0447\u043A\u0438 \u0443\u0432\u0435\u043B\u0438\u0447\u0438\u0432\u0430\u044E\u0442 \u0432\u0430\u0448 \u043B\u0438\u0447\u043D\u044B\u0439 \u0432\u043A\u043B\u0430\u0434 \u0438 \u043F\u0440\u043E\u0434\u0432\u0438\u0433\u0430\u044E\u0442 \u043F\u043E\u0445\u043E\u0434.'
});

var PAGE_4_TITLE = exports.PAGE_4_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_quests.tutorial.page4.title',
    defaultMessage: '\u041F\u043E\u043B\u0443\u0447\u0430\u0439\u0442\u0435 \u043D\u0430\u0433\u0440\u0430\u0434\u044B'
});

var PAGE_4_DESCRIPTION = exports.PAGE_4_DESCRIPTION = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_quests.tutorial.page4.description',
    defaultMessage: '\u0417\u0430 \u043B\u0438\u0447\u043D\u044B\u0439 \u0432\u043A\u043B\u0430\u0434 \u0432\u044B \u043F\u043E\u043B\u0443\u0447\u0430\u0435\u0442\u0435 \u043D\u0430\u0433\u0440\u0430\u0434\u044B, \u0430 \u0437\u0430 \u043F\u0440\u043E\u0434\u0432\u0438\u0436\u0435\u043D\u0438\u0435 \u043F\u043E\u0445\u043E\u0434\u0430 \u2014 \u0442\u0440\u043E\u0444\u0435\u0438. \u042D\u0442\u043E \u0431\u043E\u043B\u0435\u0435 \u0446\u0435\u043D\u043D\u044B\u0435 \u043F\u0440\u0438\u0437\u044B.'
});

/***/ }),
/* 2369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.requestClanSupplyProgressionMainInfo = requestClanSupplyProgressionMainInfo;

var _clan_supply_progression_settings = __webpack_require__(362);

var _clan_supply_progression = __webpack_require__(971);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function requestClanSupplyProgressionMainInfo() {
    var _this = this;

    return function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
            var state;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return dispatch((0, _clan_supply_progression_settings.requestClanSupplyProgressionSettingsInfo)());

                        case 2:
                            state = getState();

                            if (!state.clanSupplyProgressionSettings.enabled) {
                                _context.next = 6;
                                break;
                            }

                            _context.next = 6;
                            return dispatch((0, _clan_supply_progression.requestClanSupplyProgressionInfo)());

                        case 6:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }));

        return function (_x, _x2) {
            return _ref.apply(this, arguments);
        };
    }();
}

/***/ }),
/* 2370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapDispatchToProps = exports.mapStateToProps = exports.ClanManagement = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(7);

var _reactRouterRedux = __webpack_require__(15);

var _urls = __webpack_require__(19);

var _ClanManagement = __webpack_require__(2371);

var _ClanManagement2 = _interopRequireDefault(_ClanManagement);

var _reactWotBootstrap = __webpack_require__(5);

var _Dialogs = __webpack_require__(2404);

var _Dialogs2 = _interopRequireDefault(_Dialogs);

var _UpdateMembersStatusesManager = __webpack_require__(2405);

var _UpdateMembersStatusesManager2 = _interopRequireDefault(_UpdateMembersStatusesManager);

var _sounds = __webpack_require__(22);

var _ClanManagement3 = __webpack_require__(2406);

var _ClanManagement4 = _interopRequireDefault(_ClanManagement3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BACKSPACE_KEYCODE = 8;
var TAB_KEYCODE = 9;

var ClanManagement = exports.ClanManagement = function (_React$Component) {
    _inherits(ClanManagement, _React$Component);

    function ClanManagement() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ClanManagement);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ClanManagement.__proto__ || Object.getPrototypeOf(ClanManagement)).call.apply(_ref, [this].concat(args))), _this), _this.handleBackClick = function () {
            _this.props.openClanLanding();
            _this.props.playExitMainCardSound();
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ClanManagement, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            document.addEventListener('keydown', this.onKeyDown, true);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.removeEventListener('keydown', this.onKeyDown, true);
        }
    }, {
        key: 'onKeyDown',
        value: function onKeyDown(e) {
            if (e.keyCode === TAB_KEYCODE || e.target.tagName !== 'INPUT' && e.keyCode === BACKSPACE_KEYCODE) e.preventDefault();
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: _ClanManagement4.default.base },
                _react2.default.createElement(_ClanManagement2.default, { onBackClick: this.handleBackClick }),
                _react2.default.createElement(_reactWotBootstrap.Processing, { type: 'window', caption: this.props.fetchingText, isVisible: this.props.fetchingVisible }),
                _react2.default.createElement(_Dialogs2.default, { dialog: this.props.dialog }),
                _react2.default.createElement(_UpdateMembersStatusesManager2.default, null)
            );
        }
    }]);

    return ClanManagement;
}(_react2.default.Component);

ClanManagement.propTypes = {
    dialog: _propTypes2.default.node,
    fetchingText: _propTypes2.default.string,
    fetchingVisible: _propTypes2.default.bool,

    openClanLanding: _propTypes2.default.func.isRequired,
    playExitMainCardSound: _propTypes2.default.func.isRequired
};
var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
    var fetching = state.fetching,
        dialog = state.dialog;


    return {
        fetchingText: fetching.text,
        fetchingVisible: fetching.counter > 0,
        dialog: dialog.dialog
    };
};

var mapDispatchToProps = exports.mapDispatchToProps = {
    openClanLanding: function openClanLanding() {
        return (0, _reactRouterRedux.push)(_urls.CLAN_LANDING);
    },
    playExitMainCardSound: _sounds.playExitMainCardSound
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ClanManagement);

/***/ }),
/* 2371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(7);

var _ClanManagement = __webpack_require__(102);

var actions = _interopRequireWildcard(_ClanManagement);

var _MembersOperation = __webpack_require__(128);

var membersOperationActions = _interopRequireWildcard(_MembersOperation);

var _Dialog = __webpack_require__(284);

var _clan_members_online = __webpack_require__(369);

var _clan_members_online2 = _interopRequireDefault(_clan_members_online);

var _ClanManagement2 = __webpack_require__(2372);

var _ClanManagement3 = _interopRequireDefault(_ClanManagement2);

var _ChangeCommander = __webpack_require__(2396);

var _ChangeCommander2 = _interopRequireDefault(_ChangeCommander);

var _RemoveMembers = __webpack_require__(2397);

var _RemoveMembers2 = _interopRequireDefault(_RemoveMembers);

var _AllocatingResources = __webpack_require__(2399);

var _AllocatingResources2 = _interopRequireDefault(_AllocatingResources);

var _ChangeRole = __webpack_require__(2401);

var _ChangeRole2 = _interopRequireDefault(_ChangeRole);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
    var members = state.members.members;
    var currentMember = members.find(function (member) {
        return member.id === state.account.id;
    });
    var _state$clanMembersOnl = state.clanMembersOnline,
        membersOnline = _state$clanMembersOnl.membersOnline,
        membersTotal = _state$clanMembersOnl.membersTotal;


    return {
        currentMemberId: state.account.id,
        currentMemberRole: currentMember && currentMember.role,
        isError: state.clanManagement.isError,
        isFetching: state.clanManagement.fetchingCounter > 0,
        clanTransactionInProcessing: state.clanManagement.transactionInProcessing,
        blockType: state.clanManagement.blockType,
        statisticsType: state.members.statisticsType,
        statistics: state.members.statistics,
        blockState: state.clanManagement[state.clanManagement.blockType],
        clan: state.clan,
        members: members,
        membersOnline: membersOnline,
        membersTotal: membersTotal,
        tableHeadersSorting: state.members.sorting,
        membersOperation: state.membersOperation,
        canSeeTreasury: state.account.permissions.see_treasury,
        showClanQuestsCard: state.settings.showClanQuestsCard,
        isCNRealm: state.settings.isCNRealm,
        isGlobalMapEnabled: !!state.settings.globalMapUrl
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        fetchData: function fetchData(withGlobalSpinner) {
            return dispatch(actions.fetchClanInfo(withGlobalSpinner));
        },
        openInvitesApplicationsWindow: function openInvitesApplicationsWindow() {
            return dispatch(actions.openInvitesApplicationsWindow());
        },
        showChangeCommanderDialog: function showChangeCommanderDialog(selectedMember) {
            var dialog = _react2.default.createElement(_ChangeCommander2.default, {
                isOpened: true,
                selectedMemberName: selectedMember.name,
                onSubmit: function onSubmit() {
                    dispatch(membersOperationActions.changeCommander(selectedMember.id));
                    dispatch((0, _Dialog.hideDialog)());
                },
                onClose: function onClose() {
                    return dispatch((0, _Dialog.hideDialog)());
                }
            });
            dispatch((0, _Dialog.showDialog)(dialog));
        },
        showRemoveMembersDialog: function showRemoveMembersDialog(selectedMembers, memberId) {
            var dialog = _react2.default.createElement(_RemoveMembers2.default, {
                isOpened: true,
                selectedMembers: selectedMembers,
                onSubmit: function onSubmit() {
                    dispatch(membersOperationActions.removeMembers(memberId));
                    dispatch((0, _Dialog.hideDialog)());
                },
                onClose: function onClose() {
                    return dispatch((0, _Dialog.hideDialog)());
                }
            });
            dispatch((0, _Dialog.showDialog)(dialog));
        },
        showAllocatingResourcesDialog: function showAllocatingResourcesDialog(member) {
            var dialog = _react2.default.createElement(_AllocatingResources2.default, {
                isOpened: true,
                selectedMembers: member && [member],
                onSubmit: function onSubmit(amountToEach, currency) {
                    dispatch(membersOperationActions.allocateResources(amountToEach, currency, member && member.id));
                    dispatch((0, _Dialog.hideDialog)());
                }
            });
            dispatch((0, _Dialog.showDialog)(dialog));
        },
        showChangeRoleDialog: function showChangeRoleDialog(member) {
            var dialog = _react2.default.createElement(_ChangeRole2.default, {
                isOpened: true,
                selectedMembers: member && [member],
                onSubmit: function onSubmit() {
                    dispatch(membersOperationActions.changeRole(member && member.id));
                    dispatch((0, _Dialog.hideDialog)());
                }
            });
            dispatch((0, _Dialog.showDialog)(dialog));
        },
        onChangeBlockType: function onChangeBlockType(clanTransactionInProcessing, blockType) {
            dispatch(actions.changeBlockType(blockType));
            if (!clanTransactionInProcessing) {
                dispatch(actions.fetchClanInfo());
            }
        },
        onChangePeriod: function onChangePeriod(clanTransactionInProcessing, period) {
            dispatch(actions.changePeriod(period));
            if (!clanTransactionInProcessing) {
                dispatch(actions.fetchClanInfo());
            }
        },
        onChangeBattleType: function onChangeBattleType(clanTransactionInProcessing, battleType) {
            dispatch(actions.changeBattleType(battleType));
            if (!clanTransactionInProcessing) {
                dispatch(actions.fetchClanInfo());
            }
        },
        onChangeRandomBattleType: function onChangeRandomBattleType(clanTransactionInProcessing, randomBattleType) {
            dispatch(actions.changeRandomBattleType(randomBattleType));
            if (!clanTransactionInProcessing) {
                dispatch(actions.fetchClanInfo());
            }
        },
        onToggleMemberTick: function onToggleMemberTick(memberId) {
            return dispatch(membersOperationActions.toggleMemberTick(memberId));
        },
        onResetSelectedMembers: function onResetSelectedMembers() {
            return dispatch(membersOperationActions.resetSelectedMembers());
        },
        onTableHeaderClick: function onTableHeaderClick(header) {
            return dispatch(membersOperationActions.sortMembers(header));
        },
        onTickAllMembers: function onTickAllMembers(membersIds) {
            return dispatch(membersOperationActions.toggleAllMembersTick(membersIds));
        },
        requestMembersStatus: function requestMembersStatus() {
            return dispatch((0, _clan_members_online2.default)());
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_ClanManagement3.default);

/***/ }),
/* 2372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactWotBootstrap = __webpack_require__(5);

var _MembersTable = __webpack_require__(2373);

var _MembersTable2 = _interopRequireDefault(_MembersTable);

var _MembersControlBlock = __webpack_require__(2387);

var _MembersControlBlock2 = _interopRequireDefault(_MembersControlBlock);

var _Inbox = __webpack_require__(2391);

var _Inbox2 = _interopRequireDefault(_Inbox);

var _CurrencyTooltip = __webpack_require__(1360);

var _CurrencyTooltip2 = _interopRequireDefault(_CurrencyTooltip);

var _roles = __webpack_require__(49);

var _propTypes3 = __webpack_require__(298);

var _constants = __webpack_require__(160);

var _battles = __webpack_require__(199);

var _periods = __webpack_require__(280);

var _constants2 = __webpack_require__(2394);

var _tooltips = __webpack_require__(144);

var _tooltips2 = __webpack_require__(571);

var _constants3 = __webpack_require__(1341);

var _constants4 = __webpack_require__(549);

var _translations = __webpack_require__(570);

var _constants5 = __webpack_require__(4);

var _ClanManagement = __webpack_require__(2395);

var _ClanManagement2 = _interopRequireDefault(_ClanManagement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ClanManagement = function (_React$Component) {
    _inherits(ClanManagement, _React$Component);

    function ClanManagement(props) {
        _classCallCheck(this, ClanManagement);

        var _this = _possibleConstructorReturn(this, (ClanManagement.__proto__ || Object.getPrototypeOf(ClanManagement)).call(this, props));

        _this.renderSubtitle = function () {
            var treasury = void 0;
            if (_this.props.canSeeTreasury) {
                treasury = _react2.default.createElement(
                    'span',
                    null,
                    _translations.TREASURY,
                    _this.props.clan.treasury.crystal !== undefined && _react2.default.createElement(
                        'span',
                        {
                            className: _ClanManagement2.default.treasuryCurrency,
                            'data-tip': true, 'data-for': 'clan_panel_currency_tooltip_crystal'
                        },
                        _react2.default.createElement(_reactWotBootstrap.Bons, { value: _this.props.clan.treasury.crystal, iconPosition: 'before' }),
                        _react2.default.createElement(_CurrencyTooltip2.default, { amount: _this.props.clan.treasury.crystal, type: 'crystal' })
                    ),
                    _this.props.clan.treasury.gold !== undefined && _react2.default.createElement(
                        'span',
                        {
                            className: _ClanManagement2.default.treasuryCurrency,
                            'data-tip': true, 'data-for': 'clan_panel_currency_tooltip_gold'
                        },
                        _react2.default.createElement(_reactWotBootstrap.Gold, { value: _this.props.clan.treasury.gold, iconPosition: 'before' }),
                        _react2.default.createElement(_CurrencyTooltip2.default, { amount: _this.props.clan.treasury.gold, type: 'gold' })
                    ),
                    _this.props.clan.treasury.credits !== undefined && _react2.default.createElement(
                        'span',
                        {
                            className: _ClanManagement2.default.treasuryCurrency,
                            'data-tip': true, 'data-for': 'clan_panel_currency_tooltip_credits'
                        },
                        _react2.default.createElement(_reactWotBootstrap.Silver, { value: _this.props.clan.treasury.credits, iconPosition: 'before' }),
                        _react2.default.createElement(_CurrencyTooltip2.default, { amount: _this.props.clan.treasury.credits, type: 'credits' })
                    )
                );
            }

            return _react2.default.createElement(
                'div',
                { className: _ClanManagement2.default.subtitle },
                _react2.default.createElement(
                    'span',
                    {
                        className: _ClanManagement2.default.membersOnline,
                        'data-tip': true, 'data-for': 'members_online'
                    },
                    (0, _translations.MEMBERS_ONLINE)(_this.props.membersOnline, _this.props.membersTotal),
                    _react2.default.createElement(
                        _reactWotBootstrap.Tooltip,
                        { id: 'members_online' },
                        (0, _constants4.MEMBERS_ONLINE_TOOLTIP)(_this.props.membersOnline, _this.props.membersTotal)
                    )
                ),
                treasury
            );
        };

        _this.state = {
            heightAfterTable: 0
        };

        _this.onKeyDown = _this.onKeyDown.bind(_this);
        _this.onActionBarRef = _this.onActionBarRef.bind(_this);
        _this.onMemberContextMenuItemSelected = _this.onMemberContextMenuItemSelected.bind(_this);
        _this.onRemoveMembersClick = _this.onRemoveMembersClick.bind(_this);
        _this.onAllocateTreasuryClick = _this.onAllocateTreasuryClick.bind(_this);
        _this.onChangeRoleClick = _this.onChangeRoleClick.bind(_this);
        _this.onChangeBlockType = _this.onChangeBlockType.bind(_this);
        _this.onChangePeriod = _this.onChangePeriod.bind(_this);
        _this.onChangeBattleType = _this.onChangeBattleType.bind(_this);
        _this.onChangeRandomBattleType = _this.onChangeRandomBattleType.bind(_this);
        return _this;
    }

    _createClass(ClanManagement, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.props.fetchData(true);
            window.addEventListener('keydown', this.onKeyDown);

            this.props.requestMembersStatus();
            this.requestMembersTimeout = setInterval(this.props.requestMembersStatus, 3000);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('keydown', this.onKeyDown);
            clearInterval(this.requestMembersTimeout);
        }
    }, {
        key: 'onKeyDown',
        value: function onKeyDown(e) {
            if (e.keyCode === _constants5.KEY_CODES.ESCAPE) this.props.onBackClick();
        }
    }, {
        key: 'onActionBarRef',
        value: function onActionBarRef(actionBar) {
            if (actionBar) {
                var offsetHeight = actionBar.offsetHeight;
                if (offsetHeight !== this.state.heightAfterTable) {
                    this.setState({ heightAfterTable: offsetHeight });
                }
            }
        }
    }, {
        key: 'onMemberContextMenuItemSelected',
        value: function onMemberContextMenuItemSelected(_ref) {
            var member = _ref.member,
                action = _ref.action;

            switch (action) {
                case 'CHANGE_COMMANDER':
                    this.props.showChangeCommanderDialog(member);
                    break;
                case 'REMOVE_MEMBER':
                    this.props.showRemoveMembersDialog([member], member.id);
                    break;
                case 'DIVIDE_PROFITS':
                    this.props.showAllocatingResourcesDialog(member);
                    break;
                case 'CHANGE_ROLE':
                    this.props.showChangeRoleDialog(member);
                    break;
            }
        }
    }, {
        key: 'onChangeBlockType',
        value: function onChangeBlockType(blockType) {
            this.props.onChangeBlockType(this.props.clanTransactionInProcessing, blockType);
        }
    }, {
        key: 'onChangePeriod',
        value: function onChangePeriod(period) {
            this.props.onChangePeriod(this.props.clanTransactionInProcessing, period);
        }
    }, {
        key: 'onChangeBattleType',
        value: function onChangeBattleType(battleType) {
            this.props.onChangeBattleType(this.props.clanTransactionInProcessing, battleType);
        }
    }, {
        key: 'onChangeRandomBattleType',
        value: function onChangeRandomBattleType(randomBattleType) {
            this.props.onChangeRandomBattleType(this.props.clanTransactionInProcessing, randomBattleType);
        }
    }, {
        key: 'onRemoveMembersClick',
        value: function onRemoveMembersClick() {
            var _this2 = this;

            if (!(0, _roles.hasPermission)(this.props.currentMemberRole, _roles.permissions.REMOVE_MEMBER)) return;

            var selectedMembers = this.props.members.filter(function (member) {
                return _this2.props.membersOperation.selectedIds.includes(member.id);
            });
            this.props.showRemoveMembersDialog(selectedMembers);
        }
    }, {
        key: 'onAllocateTreasuryClick',
        value: function onAllocateTreasuryClick() {
            if (!(0, _roles.hasPermission)(this.props.currentMemberRole, _roles.permissions.DIVIDE_PROFITS)) return;

            this.props.showAllocatingResourcesDialog();
        }
    }, {
        key: 'onChangeRoleClick',
        value: function onChangeRoleClick() {
            if (!(0, _roles.hasPermission)(this.props.currentMemberRole, _roles.permissions.CHANGE_ROLE)) return;

            this.props.showChangeRoleDialog();
        }
    }, {
        key: 'renderPeriodsFilter',
        value: function renderPeriodsFilter() {
            var blockType = this.props.blockType;
            var blockState = this.props.blockState;
            var battleType = blockState.battleType;
            var randomBattleType = blockState.randomBattleType;
            var period = blockState.period;
            var items = _constants2.PERIODS_BY_BLOCK_TYPE[blockType];
            var isBattleTypeOnlyWithAll = battleType === _battles.BATTLE_TYPES.RANKED || battleType === _battles.BATTLE_TYPES.RANDOM && randomBattleType === _battles.RANDOM_BATTLE_TYPES.EPIC;
            if (blockType === _constants.BLOCK_TYPES.STATISTICS && isBattleTypeOnlyWithAll) {
                items = items.map(function (item) {
                    var isDisabled = item.value !== _periods.PERIOD_TYPES.ALL;
                    return _extends({}, item, {
                        isDisabled: isDisabled,
                        tooltipId: isDisabled ? _tooltips.StatisticsDisabledPeriodTooltip.id : item.tooltipId
                    });
                });
            }

            return _react2.default.createElement(
                'div',
                { className: _ClanManagement2.default.filterItem },
                _react2.default.createElement(_reactWotBootstrap.Filter, {
                    caption: _translations.PERIOD_FILTER_CAPTION,
                    items: items,
                    checkedItem: period,
                    onItemChange: this.onChangePeriod
                })
            );
        }
    }, {
        key: 'renderBattleTypeSelect',
        value: function renderBattleTypeSelect() {
            if (this.props.blockType !== _constants.BLOCK_TYPES.STATISTICS) return null;
            var items = this.props.isGlobalMapEnabled ? _constants2.STATISTICS_BATTLE_TYPES : _constants2.COMMON_STATISTICS_BATTLE_TYPES;

            return _react2.default.createElement(
                'div',
                { className: _ClanManagement2.default.filterItem },
                _react2.default.createElement(_reactWotBootstrap.Select, {
                    width: 170,
                    caption: _translations.STATISTICS_BATTLE_TYPE_SELECT_CAPTION,
                    items: items,
                    tooltipId: _tooltips2.BattleTypeTooltip.id,
                    selectedItem: this.props.blockState.battleType,
                    onItemChange: this.onChangeBattleType
                }),
                _react2.default.createElement(_tooltips2.BattleTypeTooltip, null)
            );
        }
    }, {
        key: 'renderRandomTypesFilter',
        value: function renderRandomTypesFilter() {
            if (this.props.blockType !== _constants.BLOCK_TYPES.STATISTICS || this.props.blockState.battleType !== _battles.BATTLE_TYPES.RANDOM) {
                return null;
            }

            return _react2.default.createElement(
                'div',
                { className: _ClanManagement2.default.filterItem },
                _react2.default.createElement(_reactWotBootstrap.Filter, {
                    items: _constants2.RANDOM_BATTLE_TYPES_FILTER_ITEMS,
                    checkedItem: this.props.blockState.randomBattleType,
                    onItemChange: this.onChangeRandomBattleType
                }),
                _react2.default.createElement(_tooltips.StatisticsRandomDefaultBattleTypeTooltip, null),
                _react2.default.createElement(_tooltips.StatisticsRandomEpicBattleTypeTooltip, null)
            );
        }
    }, {
        key: 'renderMembersControlBlock',
        value: function renderMembersControlBlock() {
            var currentMemberRole = this.props.currentMemberRole;
            var hasPermissions = (0, _roles.hasAnyPermission)(currentMemberRole, _constants.NEED_PERMISSIONS_FOR_MEMBER_CONTROL_BLOCK);
            if (!currentMemberRole || !hasPermissions) return null;

            var _props = this.props,
                members = _props.members,
                membersOperation = _props.membersOperation;


            var selectedMembers = members;
            if (members.length !== membersOperation.selectedIds.length) {
                selectedMembers = members.filter(function (member) {
                    return membersOperation.selectedIds.includes(member.id);
                });
            }

            var counter = null;
            if (selectedMembers.length > 0) {
                counter = _react2.default.createElement(
                    'div',
                    { className: _ClanManagement2.default.counter, key: 'members-counter' },
                    _react2.default.createElement(_reactWotBootstrap.Counter, {
                        total: members.length,
                        current: selectedMembers.length,
                        onClick: this.props.onResetSelectedMembers,
                        tooltipId: _tooltips.SelectedMembersTooltip.id,
                        buttonTooltipId: _tooltips.ClearSelectedMembersTooltip.id
                    }),
                    _react2.default.createElement(_tooltips.SelectedMembersTooltip, {
                        count: selectedMembers.length,
                        total: members.length
                    }),
                    _react2.default.createElement(_tooltips.ClearSelectedMembersTooltip, null)
                );
            }

            var currentMemberRank = (0, _roles.getRank)(this.props.currentMemberRole);
            var isSelectedMembersWithSameOrHighRole = selectedMembers.some(function (member) {
                return (0, _roles.getRank)(member.role) >= currentMemberRank;
            });

            var classNamePanel = (0, _classnames2.default)(_ClanManagement2.default.panel, _defineProperty({}, _ClanManagement2.default.isProcessing, this.props.isFetching));

            return _react2.default.createElement(
                'div',
                { className: classNamePanel, ref: this.onActionBarRef },
                counter,
                _react2.default.createElement(_MembersControlBlock2.default, {
                    currentMemberRole: currentMemberRole,
                    selectedMembersCount: selectedMembers.length,
                    isSelectedMembersWithSameOrHighRole: isSelectedMembersWithSameOrHighRole,
                    clanTreasure: this.props.clan.treasury,
                    onAllocateTreasuryClick: this.onAllocateTreasuryClick,
                    onChangeRoleClick: this.onChangeRoleClick,
                    onRemoveMembersClick: this.onRemoveMembersClick
                })
            );
        }
    }, {
        key: 'renderAboutIndicator',
        value: function renderAboutIndicator() {
            if (this.props.blockType !== _constants.BLOCK_TYPES.CLAN_MODES) return null;

            return _react2.default.createElement(
                'div',
                {
                    className: _ClanManagement2.default.info,
                    'data-tip': true, 'data-for': _tooltips.AboutIndicatorsClanModesTooltip.id
                },
                _react2.default.createElement(_reactWotBootstrap.Info, null),
                _translations.CAPTION_ABOUT_INDICATORS,
                _react2.default.createElement(_tooltips.AboutIndicatorsClanModesTooltip, null)
            );
        }
    }, {
        key: 'renderMembersTable',
        value: function renderMembersTable() {
            if (this.props.members.length === 0 && !this.props.isError) return null;

            var membersControlBlock = this.props.isError ? null : this.renderMembersControlBlock();
            return _react2.default.createElement(
                'div',
                { className: _ClanManagement2.default.wrapper },
                _react2.default.createElement(
                    'div',
                    { className: _ClanManagement2.default.table },
                    _react2.default.createElement(_MembersTable2.default, {
                        currentMemberId: this.props.currentMemberId,
                        currentMemberRole: this.props.currentMemberRole,
                        members: this.props.members,
                        headersSorting: this.props.tableHeadersSorting,
                        isError: this.props.isError,
                        isProcessing: this.props.isFetching,
                        statisticsType: this.props.isError ? this.props.blockType : this.props.statisticsType,
                        statistics: this.props.statistics,
                        selectedMembersIds: this.props.membersOperation.selectedIds,
                        heightAfterTable: this.state.heightAfterTable,
                        onReloadClick: this.props.fetchData,
                        onToggleMemberTick: this.props.onToggleMemberTick,
                        onHeaderClick: this.props.onTableHeaderClick,
                        onTickAllMembers: this.props.onTickAllMembers,
                        onMemberContextMenuItemSelected: this.onMemberContextMenuItemSelected,
                        selectedPeriod: this.props.blockType === _constants.BLOCK_TYPES.CLAN_MODES ? this.props.blockState.period : null,
                        showClanQuestsCard: this.props.showClanQuestsCard
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: _ClanManagement2.default.memberBlock },
                    membersControlBlock
                )
            );
        }
    }, {
        key: 'renderInbox',
        value: function renderInbox() {
            if (!(0, _roles.hasPermission)(this.props.currentMemberRole, _roles.permissions.HANDLE_INVITES)) return null;

            return _react2.default.createElement(_Inbox2.default, {
                messages: this.props.clan.applications_count,
                onClick: this.props.openInvitesApplicationsWindow
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var baseClassNames = (0, _classnames2.default)(_ClanManagement2.default.base, _defineProperty({}, _ClanManagement2.default.base__cn, this.props.isCNRealm));

            return _react2.default.createElement(
                'div',
                { className: baseClassNames },
                _react2.default.createElement(
                    'div',
                    { className: _ClanManagement2.default.header },
                    _react2.default.createElement(
                        'div',
                        { className: _ClanManagement2.default.headerInner },
                        _react2.default.createElement(
                            'div',
                            { className: _ClanManagement2.default.back },
                            _react2.default.createElement(_reactWotBootstrap.Back, {
                                caption: _constants3.BACK_TO_CLAN_INFO,
                                side: 'left',
                                type: 'back',
                                onClick: this.props.onBackClick
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _ClanManagement2.default.title },
                            _react2.default.createElement(
                                _reactWotBootstrap.PageTitle,
                                null,
                                _translations.TITLE_STAFF
                            ),
                            this.renderSubtitle()
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _ClanManagement2.default.tabs },
                            _react2.default.createElement(_reactWotBootstrap.Tabs, {
                                items: _constants2.TABS_BLOCK_TYPES,
                                checkedItem: this.props.blockType,
                                onItemChange: this.onChangeBlockType
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _ClanManagement2.default.filter },
                            this.renderPeriodsFilter(),
                            this.renderBattleTypeSelect(),
                            this.renderRandomTypesFilter(),
                            this.renderAboutIndicator(),
                            _react2.default.createElement(_tooltips.StatisticsOverallTooltip, null),
                            _react2.default.createElement(_tooltips.Statistics28DaysTooltip, null),
                            _react2.default.createElement(_tooltips.Statistics7DaysTooltip, null),
                            _react2.default.createElement(_tooltips.Statistics1DayTooltip, null),
                            _react2.default.createElement(_tooltips.StatisticsDisabledPeriodTooltip, null),
                            _react2.default.createElement(_tooltips.LeavingClanTooltip, null)
                        ),
                        this.renderInbox()
                    )
                ),
                this.renderMembersTable()
            );
        }
    }]);

    return ClanManagement;
}(_react2.default.Component);

ClanManagement.propTypes = {
    currentMemberId: _propTypes2.default.number.isRequired,
    canSeeTreasury: _propTypes2.default.bool.isRequired,
    showClanQuestsCard: _propTypes2.default.bool.isRequired,
    isError: _propTypes2.default.bool.isRequired,
    isFetching: _propTypes2.default.bool.isRequired,
    clanTransactionInProcessing: _propTypes2.default.bool.isRequired,
    blockType: _propTypes2.default.oneOf(Object.values(_constants.BLOCK_TYPES)).isRequired,
    statisticsType: _propTypes2.default.oneOf(Object.values(_constants.BLOCK_TYPES)).isRequired,
    statistics: _propTypes2.default.object.isRequired,
    blockState: _propTypes2.default.shape({
        period: _propTypes2.default.oneOf(Object.values(_periods.PERIOD_TYPES)).isRequired,
        battleType: _propTypes2.default.oneOf(Object.values(_battles.BATTLE_TYPES)),
        randomBattleType: _propTypes2.default.oneOf(Object.values(_battles.RANDOM_BATTLE_TYPES))
    }).isRequired,
    clan: _propTypes2.default.shape({
        applications_count: _propTypes2.default.number,
        treasury: _propTypes3.treasuryPropTypes
    }).isRequired,
    members: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        id: _propTypes2.default.number.isRequired,
        name: _propTypes2.default.string.isRequired,
        role: _propTypes2.default.oneOf(_roles.roleNames).isRequired,
        daysInClan: _propTypes2.default.number.isRequired,
        status: _propTypes2.default.string,
        logoutAt: _propTypes2.default.number
    }).isRequired).isRequired,
    membersOnline: _propTypes2.default.number,
    membersTotal: _propTypes2.default.number,
    tableHeadersSorting: _propTypes2.default.object.isRequired,
    membersOperation: _propTypes2.default.shape({
        selectedIds: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired
    }).isRequired,

    currentMemberRole: _propTypes2.default.string,

    fetchData: _propTypes2.default.func.isRequired,
    onToggleMemberTick: _propTypes2.default.func.isRequired,
    onResetSelectedMembers: _propTypes2.default.func.isRequired,
    onTableHeaderClick: _propTypes2.default.func.isRequired,
    onTickAllMembers: _propTypes2.default.func.isRequired,
    onBackClick: _propTypes2.default.func.isRequired,
    onChangeBlockType: _propTypes2.default.func.isRequired,
    onChangePeriod: _propTypes2.default.func.isRequired,
    onChangeBattleType: _propTypes2.default.func.isRequired,
    onChangeRandomBattleType: _propTypes2.default.func.isRequired,
    openInvitesApplicationsWindow: _propTypes2.default.func.isRequired,

    requestMembersStatus: _propTypes2.default.func.isRequired,
    showChangeCommanderDialog: _propTypes2.default.func.isRequired,
    showRemoveMembersDialog: _propTypes2.default.func.isRequired,
    showAllocatingResourcesDialog: _propTypes2.default.func.isRequired,
    showChangeRoleDialog: _propTypes2.default.func.isRequired,

    isGlobalMapEnabled: _propTypes2.default.bool,
    isCNRealm: _propTypes2.default.bool
};
exports.default = ClanManagement;

/***/ }),
/* 2373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _MembersTable$columns;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactWotBootstrap = __webpack_require__(5);

var _translations = __webpack_require__(984);

var _roles = __webpack_require__(49);

var _constants = __webpack_require__(160);

var _MembersTableHead = __webpack_require__(2374);

var _MembersTableHead2 = _interopRequireDefault(_MembersTableHead);

var _ClanModesMembersTableItem = __webpack_require__(2375);

var _ClanModesMembersTableItem2 = _interopRequireDefault(_ClanModesMembersTableItem);

var _StatisticsMembersTableItem = __webpack_require__(2384);

var _StatisticsMembersTableItem2 = _interopRequireDefault(_StatisticsMembersTableItem);

var _StatisticsHeaders = __webpack_require__(2385);

var _StatisticsHeaders2 = _interopRequireDefault(_StatisticsHeaders);

var _ClanModesHeaders = __webpack_require__(2386);

var _ClanModesHeaders2 = _interopRequireDefault(_ClanModesHeaders);

var _tooltips = __webpack_require__(144);

var _EarnedResourceTooltip = __webpack_require__(1371);

var _tooltips2 = __webpack_require__(571);

var _i18n = __webpack_require__(10);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MembersTable = function (_React$Component) {
    _inherits(MembersTable, _React$Component);

    function MembersTable(props) {
        _classCallCheck(this, MembersTable);

        var _this = _possibleConstructorReturn(this, (MembersTable.__proto__ || Object.getPrototypeOf(MembersTable)).call(this, props));

        _this.state = {
            isCMDisplayedOnMember: null,
            scrollAreaHeight: 0
        };

        _this.onResize = _this.onResize.bind(_this);
        _this.onTickAllMembers = _this.onTickAllMembers.bind(_this);
        _this.getMembersTableColumnTooltipContent = _this.getMembersTableColumnTooltipContent.bind(_this);
        _this.getNameTooltipContent = _this.getNameTooltipContent.bind(_this);
        _this.getBattlesInClanTooltipContent = _this.getBattlesInClanTooltipContent.bind(_this);
        _this.getRoleTooltipContent = _this.getRoleTooltipContent.bind(_this);
        _this.getResourceEarnedTooltipContent = _this.getResourceEarnedTooltipContent.bind(_this);
        _this.onContextMenuStateChanged = _this.onContextMenuStateChanged.bind(_this);
        return _this;
    }

    _createClass(MembersTable, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (nextProps.members.length !== this.props.members.length || nextProps.heightAfterTable !== this.props.heightAfterTable || nextProps.currentMemberRole !== this.props.currentMemberRole) {
                this.setScrollAreaHeight(nextProps.heightAfterTable);
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.addEventListener('resize', this.onResize);
            this.setScrollAreaHeight(this.props.heightAfterTable);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('resize', this.onResize);
        }
    }, {
        key: 'onResize',
        value: function onResize() {
            this.setScrollAreaHeight(this.props.heightAfterTable);
        }
    }, {
        key: 'onTickAllMembers',
        value: function onTickAllMembers() {
            var _props = this.props,
                members = _props.members,
                selectedMembersIds = _props.selectedMembersIds;

            if (members.length === selectedMembersIds.length) {
                this.props.onTickAllMembers([]);
            } else {
                this.props.onTickAllMembers(members.map(function (member) {
                    return member.id;
                }));
            }
        }
    }, {
        key: 'onContextMenuStateChanged',
        value: function onContextMenuStateChanged(memberId, isCMDisplayed) {
            this.setState({
                isCMDisplayedOnMember: isCMDisplayed ? memberId : null
            });
        }
    }, {
        key: 'setScrollAreaHeight',
        value: function setScrollAreaHeight(heightAfterTable) {
            var coords = this._table.getBoundingClientRect();
            var scrollAreaHeight = window.innerHeight - coords.top - this._tableHead.offsetHeight - heightAfterTable;
            if (this.state.scrollAreaHeight !== scrollAreaHeight) {
                this.setState({ scrollAreaHeight: scrollAreaHeight });
            }
        }
    }, {
        key: 'isDisplayCheckboxes',
        value: function isDisplayCheckboxes() {
            var currentMemberRole = this.props.currentMemberRole;

            return currentMemberRole && (0, _roles.hasAnyPermission)(currentMemberRole, _constants.NEED_PERMISSIONS_FOR_MEMBER_CONTROL_BLOCK);
        }
    }, {
        key: 'renderTableItemInstance',
        value: function renderTableItemInstance(props) {
            var statistics = this.props.statistics[props.memberId];

            return this.props.statisticsType === _constants.BLOCK_TYPES.CLAN_MODES ? _react2.default.createElement(_ClanModesMembersTableItem2.default, _extends({}, props, statistics)) : _react2.default.createElement(_StatisticsMembersTableItem2.default, _extends({}, props, statistics));
        }
    }, {
        key: 'renderMembers',
        value: function renderMembers(shouldShowLegendaryColumn) {
            var _this2 = this;

            var displayCheckbox = this.isDisplayCheckboxes();
            var selectedMembersIdsSet = new Set(this.props.selectedMembersIds);
            return this.props.members.map(function (member) {
                var isActive = selectedMembersIdsSet.has(member.id);
                var itemProps = {
                    key: '' + _this2.props.statisticsType + member.id,
                    memberId: member.id,
                    memberDaysInClan: member.daysInClan,
                    memberRole: member.role,
                    memberName: member.name,
                    memberStatus: member.status,
                    memberLogoutAt: member.logoutAt,

                    shouldShowLegendaryColumn: shouldShowLegendaryColumn,
                    displayCheckbox: displayCheckbox,
                    isActive: isActive,
                    isOwn: member.id === _this2.props.currentMemberId,
                    isFriend: member.isFriend,
                    isChecked: isActive,
                    isCMDisplayed: _this2.state.isCMDisplayedOnMember === member.id,
                    onTickMember: displayCheckbox ? _this2.props.onToggleMemberTick : null,
                    onContextMenuItemSelected: _this2.props.onMemberContextMenuItemSelected,
                    onContextMenuStateChanged: _this2.onContextMenuStateChanged
                };

                return _this2.renderTableItemInstance(itemProps);
            });
        }
    }, {
        key: 'getMembersTableColumnTooltipContent',
        value: function getMembersTableColumnTooltipContent(tooltipTip) {
            return tooltipTip && MembersTable.columnsTooltipContentByTip[tooltipTip];
        }
    }, {
        key: 'getNameTooltipContent',
        value: function getNameTooltipContent(tooltipTip) {
            if (!tooltipTip) return null;

            var memberId = Number(tooltipTip);
            var member = this.props.members.find(function (member) {
                return member.id === memberId;
            });
            return _react2.default.createElement(_tooltips.NameTooltipContent, { name: member.name });
        }
    }, {
        key: 'getBattlesInClanTooltipContent',
        value: function getBattlesInClanTooltipContent(tooltipTip) {
            if (!tooltipTip) return null;

            var tips = tooltipTip.split('-');
            var field = tips[0];
            var memberId = tips[1];

            var statistics = this.props.statistics[memberId];

            var fieldValue = _reactWotBootstrap.helpers.thousands(statistics[field]);
            var fieldWinsPercent = _reactWotBootstrap.helpers.percent(statistics[field + 'WinsPercent']);
            return _react2.default.createElement(_tooltips.BattlesInClanTooltipContent, {
                battles: fieldValue,
                winrate: fieldWinsPercent
            });
        }
    }, {
        key: 'getRoleTooltipContent',
        value: function getRoleTooltipContent(tooltipTip) {
            return tooltipTip ? _react2.default.createElement(_tooltips.RoleTooltipContent, { role: tooltipTip }) : null;
        }
    }, {
        key: 'getResourceEarnedTooltipContent',
        value: function getResourceEarnedTooltipContent(memberId) {
            if (!memberId) return null;

            var statistics = this.props.statistics[memberId];

            return _react2.default.createElement(_EarnedResourceTooltip.EarnedResourceTooltipContent, {
                selectedPeriod: this.props.selectedPeriod,
                statistics: statistics,
                showClanQuestsCard: this.props.showClanQuestsCard
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var isClanModes = this.props.statisticsType === _constants.BLOCK_TYPES.CLAN_MODES;
            var showLegendaryColumn = isClanModes ? Object.values(this.props.statistics).some(function (item) {
                return item.sortiesLegendary;
            }) : false;
            var headers = isClanModes ? (0, _ClanModesHeaders2.default)(showLegendaryColumn) : _StatisticsHeaders2.default;

            var tableContent = this.props.isError ? _react2.default.createElement(_reactWotBootstrap.EmptyList, {
                title: _i18n.LOADING_ERROR.title,
                message: _i18n.LOADING_ERROR.message,
                buttonCaption: _i18n.LOADING_ERROR.refresh_button_caption,
                height: this.state.scrollAreaHeight,
                onButtonClick: this.props.onReloadClick
            }) : _react2.default.createElement(
                'div',
                { style: { height: this.state.scrollAreaHeight } },
                _react2.default.createElement(
                    _reactWotBootstrap.ScrollArea,
                    {
                        modifier: 'table',
                        stepHeight: MembersTable.SCROLL_AREA_STEP_HEIGHT,
                        scrollableAreaHeight: this.state.scrollAreaHeight
                    },
                    _react2.default.createElement(
                        _reactWotBootstrap.TableBody,
                        null,
                        this.renderMembers(showLegendaryColumn)
                    )
                )
            );

            var isDisplayCheckbox = this.isDisplayCheckboxes();
            var isAllMembersSelected = isDisplayCheckbox && this.props.members.length > 0 && this.props.selectedMembersIds.length === this.props.members.length;

            var nameTooltip = this.state.isCMDisplayedOnMember ? null : _react2.default.createElement(_reactWotBootstrap.Tooltip, {
                id: 'member-name-tooltip',
                getContent: this.getNameTooltipContent
            });

            return _react2.default.createElement(
                'div',
                { ref: function ref(c) {
                        return _this3._table = c;
                    } },
                _react2.default.createElement(
                    _reactWotBootstrap.Table,
                    {
                        isScrollable: true,
                        processingCaption: _translations.LOADING_DATA,
                        isProcessing: this.props.isProcessing
                    },
                    _react2.default.createElement(
                        'div',
                        { ref: function ref(c) {
                                return _this3._tableHead = c;
                            } },
                        _react2.default.createElement(_MembersTableHead2.default, {
                            headers: headers,
                            headersSorting: this.props.headersSorting,
                            isChecked: isAllMembersSelected,
                            displayCheckbox: isDisplayCheckbox,
                            onHeaderClick: this.props.onHeaderClick,
                            onTickAllMembers: isDisplayCheckbox ? this.onTickAllMembers : null
                        })
                    ),
                    tableContent
                ),
                _react2.default.createElement(_tooltips.NotPlayedInClanModesTooltip, null),
                _react2.default.createElement(_EarnedResourceTooltip.NotEarnedResourceTooltip, null),
                _react2.default.createElement(_tooltips.NotLoggedInEverTooltip, null),
                nameTooltip,
                _react2.default.createElement(_reactWotBootstrap.Tooltip, {
                    id: 'members-table-column-tooltip',
                    getContent: this.getMembersTableColumnTooltipContent
                }),
                _react2.default.createElement(_reactWotBootstrap.Tooltip, {
                    id: 'battles-in-clan-tooltip',
                    getContent: this.getBattlesInClanTooltipContent
                }),
                _react2.default.createElement(_reactWotBootstrap.Tooltip, {
                    id: 'member-role-tooltip',
                    getContent: this.getRoleTooltipContent
                }),
                _react2.default.createElement(_reactWotBootstrap.Tooltip, {
                    id: 'resource-earned-tooltip',
                    isWide: true,
                    getContent: this.getResourceEarnedTooltipContent
                })
            );
        }
    }]);

    return MembersTable;
}(_react2.default.Component);

MembersTable.propTypes = {
    currentMemberId: _propTypes2.default.number.isRequired,
    members: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        id: _propTypes2.default.number.isRequired,
        role: _propTypes2.default.oneOf(_roles.roleNames).isRequired
    }).isRequired).isRequired,
    headersSorting: _propTypes2.default.object.isRequired,
    isError: _propTypes2.default.bool.isRequired,
    isProcessing: _propTypes2.default.bool.isRequired,
    statisticsType: _propTypes2.default.oneOf(Object.values(_constants.BLOCK_TYPES)).isRequired,
    statistics: _propTypes2.default.object.isRequired,
    selectedMembersIds: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired,
    heightAfterTable: _propTypes2.default.number.isRequired,
    selectedPeriod: _propTypes2.default.oneOf([1, 7, 28]),
    showClanQuestsCard: _propTypes2.default.bool.isRequired,

    currentMemberRole: _propTypes2.default.string,

    onHeaderClick: _propTypes2.default.func.isRequired,
    onToggleMemberTick: _propTypes2.default.func.isRequired,
    onReloadClick: _propTypes2.default.func.isRequired,
    onTickAllMembers: _propTypes2.default.func.isRequired,
    onMemberContextMenuItemSelected: _propTypes2.default.func.isRequired
};
MembersTable.SCROLL_AREA_STEP_HEIGHT = 20;
MembersTable.columnsTooltipContentByTip = (_MembersTable$columns = {}, _defineProperty(_MembersTable$columns, _tooltips.PlayerColumnTooltipContent.tip, _react2.default.createElement(_tooltips.PlayerColumnTooltipContent, null)), _defineProperty(_MembersTable$columns, _tooltips.PlayerStatusColumnTooltipContent.tip, _react2.default.createElement(_tooltips.PlayerStatusColumnTooltipContent, null)), _defineProperty(_MembersTable$columns, _tooltips.RoleColumnTooltipContent.tip, _react2.default.createElement(_tooltips.RoleColumnTooltipContent, null)), _defineProperty(_MembersTable$columns, _tooltips.Attack6ColumnTooltipContent.tip, _react2.default.createElement(_tooltips.Attack6ColumnTooltipContent, null)), _defineProperty(_MembersTable$columns, _tooltips.Attack8ColumnTooltipContent.tip, _react2.default.createElement(_tooltips.Attack8ColumnTooltipContent, null)), _defineProperty(_MembersTable$columns, _tooltips.Attack10ColumnTooltipContent.tip, _react2.default.createElement(_tooltips.Attack10ColumnTooltipContent, null)), _defineProperty(_MembersTable$columns, _tooltips.Attack11ColumnTooltipContent.tip, _react2.default.createElement(_tooltips.Attack11ColumnTooltipContent, null)), _defineProperty(_MembersTable$columns, _tooltips.FortBattlesColumnTooltipContent.tip, _react2.default.createElement(_tooltips.FortBattlesColumnTooltipContent, null)), _defineProperty(_MembersTable$columns, _tooltips.ResourceColumnTooltipContent.tip, _react2.default.createElement(_tooltips.ResourceColumnTooltipContent, null)), _defineProperty(_MembersTable$columns, _tooltips2.BattlesCountColumnTooltipContent.tip, _react2.default.createElement(_tooltips2.BattlesCountColumnTooltipContent, null)), _defineProperty(_MembersTable$columns, _tooltips2.DamageColumnTooltipContent.tip, _react2.default.createElement(_tooltips2.DamageColumnTooltipContent, null)), _defineProperty(_MembersTable$columns, _tooltips2.DaysInClanColumnTooltipContent.tip, _react2.default.createElement(_tooltips2.DaysInClanColumnTooltipContent, null)), _defineProperty(_MembersTable$columns, _tooltips2.ExperienceColumnTooltipContent.tip, _react2.default.createElement(_tooltips2.ExperienceColumnTooltipContent, null)), _defineProperty(_MembersTable$columns, _tooltips2.PersonalRatingColumnTooltipContent.tip, _react2.default.createElement(_tooltips2.PersonalRatingColumnTooltipContent, null)), _defineProperty(_MembersTable$columns, _tooltips2.WinRateColumnTooltipContent.tip, _react2.default.createElement(_tooltips2.WinRateColumnTooltipContent, null)), _MembersTable$columns);
exports.default = MembersTable;

/***/ }),
/* 2374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactWotBootstrap = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultProps = {
    isChecked: false,
    displayCheckbox: false,
    onTickAllMembers: function onTickAllMembers() {}
};

var toSortOrder = function toSortOrder(isAsc) {
    return isAsc ? 'asc' : 'desc';
};

var MembersTableHead = function MembersTableHead(props) {
    var allCheckboxCell = props.displayCheckbox ? _react2.default.createElement(
        _reactWotBootstrap.TableHeadCell,
        { type: 'check', isFirst: true },
        _react2.default.createElement(_reactWotBootstrap.Checkbox, {
            isChecked: props.isChecked,
            onChange: props.onTickAllMembers
        })
    ) : null;

    var headers = props.headers.map(function (header, index) {
        var content = header.icon ? _react2.default.createElement(_reactWotBootstrap.IconTable, { glyph: header.icon }) : header.text;

        var clickHandler = function clickHandler() {
            return props.onHeaderClick(header.key);
        };

        return _react2.default.createElement(
            _reactWotBootstrap.TableHeadCell,
            {
                key: header.key,
                type: header.type,
                isFirst: !props.displayCheckbox && index === 0,
                tooltipId: header.tooltipId || null,
                tooltipTip: header.tooltipTip || null,
                isSortable: header.isSortable,
                sortOrder: props.headersSorting.column === header.key ? toSortOrder(props.headersSorting.isAsc) : null,
                onClick: clickHandler
            },
            content
        );
    });

    return _react2.default.createElement(
        _reactWotBootstrap.TableHead,
        null,
        allCheckboxCell,
        headers
    );
};

MembersTableHead.propTypes = {
    headers: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        type: _propTypes2.default.string,
        isSortable: _propTypes2.default.bool.isRequired,
        key: _propTypes2.default.string.isRequired,

        icon: _propTypes2.default.string,
        text: _propTypes2.default.any
    })),
    headersSorting: _propTypes2.default.object.isRequired,

    isChecked: _propTypes2.default.bool,
    displayCheckbox: _propTypes2.default.bool,
    onHeaderClick: _propTypes2.default.func, // eslint-disable-line react/no-unused-prop-types
    onTickAllMembers: _propTypes2.default.func
};
MembersTableHead.defaultProps = defaultProps;

exports.default = MembersTableHead;

/***/ }),
/* 2375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactWotBootstrap = __webpack_require__(5);

var _ButtonLeavingClan = __webpack_require__(2376);

var _ButtonLeavingClan2 = _interopRequireDefault(_ButtonLeavingClan);

var _tooltips = __webpack_require__(144);

var _EarnedResourceTooltip = __webpack_require__(1371);

var _BaseMembersTableItem2 = __webpack_require__(1372);

var _BaseMembersTableItem3 = _interopRequireDefault(_BaseMembersTableItem2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ClanModesMembersTableItem = function (_BaseMembersTableItem) {
    _inherits(ClanModesMembersTableItem, _BaseMembersTableItem);

    function ClanModesMembersTableItem() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ClanModesMembersTableItem);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ClanModesMembersTableItem.__proto__ || Object.getPrototypeOf(ClanModesMembersTableItem)).call.apply(_ref, [this].concat(args))), _this), _this.renderBattleModeTableCell = function (battleModeName) {
            var battlesCount = _this.props[battleModeName];
            return _react2.default.createElement(
                _reactWotBootstrap.TableBodyCell,
                {
                    valueType: battlesCount ? undefined : 'null',
                    valueWidth: '45',
                    isValue: true,
                    key: battleModeName,
                    tooltipId: battlesCount ? 'battles-in-clan-tooltip' : _tooltips.NotPlayedInClanModesTooltip.id,
                    tooltipTip: battlesCount ? battleModeName + '-' + _this.props.memberId : undefined
                },
                _reactWotBootstrap.helpers.thousands(battlesCount)
            );
        }, _this.renderExitFromClanButton = function () {
            if (_this.props.isOwn === false || _this.props.memberRole === 'commander') {
                return null;
            }
            return _react2.default.createElement(_ButtonLeavingClan2.default, {
                tooltipId: _tooltips.LeavingClanTooltip.id
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ClanModesMembersTableItem, [{
        key: 'render',
        value: function render() {
            var ir = this.props.industrialResourceEarnedAsClanmate + this.props.industrialResourceEarnedAsLegionary + this.props.industrialResourceEarnedInRandomInClanmatePlatoon + this.props.industrialResourceEarnedInRandom + this.props.industrialResourceForClanPurchaseProduct + this.props.industrialResourceClansupply;

            var irTotal = this.props.industrialResourceWhole;

            var formattedIndustrial = _reactWotBootstrap.helpers.thousands(ir);
            var showLegendaryColumn = this.props.shouldShowLegendaryColumn ? ['sortiesLegendary'] : [];
            var battleModes = ['sortiesMiddle', 'sortiesChampion', 'sortiesAbsolute'].concat(showLegendaryColumn, ['battles']);
            var battleModesCells = battleModes.map(this.renderBattleModeTableCell);

            return _react2.default.createElement(
                _reactWotBootstrap.TableRow,
                {
                    isHoverable: true,
                    isActive: this.isRowActive(),
                    needPlayHoverSound: this.needPlayHoverSound(),
                    onClick: this.props.displayCheckbox ? this.onRowClick : null
                },
                this.renderTableCellCheckbox(),
                this.renderTableCellRole(),
                this.renderTableCellMember(this.renderExitFromClanButton()),
                battleModesCells,
                _react2.default.createElement(
                    _reactWotBootstrap.TableBodyCell,
                    {
                        valueType: ir ? 'resource' : 'null',
                        valueWidth: '69',
                        isValue: true,
                        tooltipId: irTotal ? 'resource-earned-tooltip' : _EarnedResourceTooltip.NotEarnedResourceTooltip.id,
                        tooltipTip: irTotal ? this.props.memberId.toString() : undefined
                    },
                    formattedIndustrial
                ),
                this.renderTableCellMemberStatus()
            );
        }
    }]);

    return ClanModesMembersTableItem;
}(_BaseMembersTableItem3.default);

ClanModesMembersTableItem.propTypes = _extends({}, ClanModesMembersTableItem.propTypes, {
    sortiesMiddle: _propTypes2.default.number,
    sortiesMiddleWinsPercent: _propTypes2.default.number,
    sortiesChampion: _propTypes2.default.number,
    sortiesChampionWinsPercent: _propTypes2.default.number,
    sortiesAbsolute: _propTypes2.default.number,
    sortiesAbsoluteWinsPercent: _propTypes2.default.number,
    battles: _propTypes2.default.number,
    battlesWinsPercent: _propTypes2.default.number,

    industrialResourceEarnedAsClanmate: _propTypes2.default.number,
    industrialResourceEarnedAsLegionary: _propTypes2.default.number,
    industrialResourceEarnedInRandomInClanmatePlatoon: _propTypes2.default.number,
    industrialResourceEarnedInRandom: _propTypes2.default.number,
    industrialResourceForClanPurchaseProduct: _propTypes2.default.number,
    industrialResourceClansupply: _propTypes2.default.number,

    industrialResourceWhole: _propTypes2.default.number,

    shouldShowLegendaryColumn: _propTypes2.default.bool
});

exports.default = ClanModesMembersTableItem;

/***/ }),
/* 2376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactWotBootstrap = __webpack_require__(5);

var _reactRouterRedux = __webpack_require__(15);

var _reactRedux = __webpack_require__(7);

var _urls = __webpack_require__(19);

var _ButtonLeavingClan = __webpack_require__(2377);

var _ButtonLeavingClan2 = _interopRequireDefault(_ButtonLeavingClan);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonLeavingClan = function ButtonLeavingClan(_ref) {
    var tooltipId = _ref.tooltipId;

    var dispatch = (0, _reactRedux.useDispatch)();

    var dataAttrs = tooltipId ? { 'data-tip': true, 'data-for': tooltipId } : {};

    return _react2.default.createElement('button', _extends({
        className: _ButtonLeavingClan2.default.base,
        onClick: function onClick(e) {
            e.stopPropagation();
            dispatch((0, _reactRouterRedux.push)(_urls.CLAN_LEAVING));
        },
        onMouseDown: _reactWotBootstrap.sendClickSoundCommand,
        onMouseEnter: _reactWotBootstrap.sendHoverSoundCommand
    }, dataAttrs));
};

ButtonLeavingClan.propTypes = {
    tooltipId: _propTypes2.default.string
};

exports.default = ButtonLeavingClan;

/***/ }),
/* 2377 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"ButtonLeavingClan_base--1-dCn"};

/***/ }),
/* 2378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactWotBootstrap = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var propTypes = _extends({}, _reactWotBootstrap.IndustrialResource.propTypes, {
    amount: _propTypes2.default.number
});

var FormattedIndustrialResource = function FormattedIndustrialResource(_ref) {
    var amount = _ref.amount,
        props = _objectWithoutProperties(_ref, ['amount']);

    return _react2.default.createElement(
        _reactWotBootstrap.IndustrialResource,
        props,
        _reactWotBootstrap.helpers.thousands(amount)
    );
};
FormattedIndustrialResource.propTypes = propTypes;

exports.default = FormattedIndustrialResource;

/***/ }),
/* 2379 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"EarnedResourceTooltip_base--3rN-H","period":"EarnedResourceTooltip_period--1SgpQ","block":"EarnedResourceTooltip_block--1Cn7d","icon":"EarnedResourceTooltip_icon--Y9FfE","icon__strongholds":"EarnedResourceTooltip_icon__strongholds--oF-FH","iconStrongholds":"EarnedResourceTooltip_icon__strongholds--oF-FH","icon__random":"EarnedResourceTooltip_icon__random--2Tf_R","iconRandom":"EarnedResourceTooltip_icon__random--2Tf_R","icon__purchase":"EarnedResourceTooltip_icon__purchase--2C8Bv","iconPurchase":"EarnedResourceTooltip_icon__purchase--2C8Bv","icon__quests":"EarnedResourceTooltip_icon__quests--4btIH","iconQuests":"EarnedResourceTooltip_icon__quests--4btIH","content":"EarnedResourceTooltip_content--3iv-_","caption":"EarnedResourceTooltip_caption--1ziVk","item":"EarnedResourceTooltip_item--v0_9S","key":"EarnedResourceTooltip_key--1ooUs","keyInner":"EarnedResourceTooltip_keyInner--gbstZ","value":"EarnedResourceTooltip_value--OXpGC"};

/***/ }),
/* 2380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = __webpack_require__(7);

var _reactWotBootstrap = __webpack_require__(5);

var _ContextMenu = __webpack_require__(2381);

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
    return {
        onContextMenu: function onContextMenu() {
            if (ownProps.onContextMenu) ownProps.onContextMenu();
            dispatch((0, _ContextMenu.userContextMenu)(ownProps.id)).then(ownProps.onContextMenuItemSelected);
        }
    };
};

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(_reactWotBootstrap.TableBodyCell);

/***/ }),
/* 2381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.userContextMenu = undefined;

var _reactIntl = __webpack_require__(3);

var _locale = __webpack_require__(21);

var _web_to_client = __webpack_require__(12);

var _roles = __webpack_require__(49);

/**
 * @see https://confluence.wargaming.net/pages/viewpage.action?spaceKey=WGCGK&title=Web+to+client+API
 * @see https://confluence.wargaming.net/display/WEBDEV/CMT+improvements
 */

var localizedActionNames = (0, _reactIntl.defineMessages)({
    divide_profits: {
        'id': 'clanmanagement.context_menu.divide_profits',
        'defaultMessage': '\u0420\u0430\u0441\u043F\u0440\u0435\u0434\u0435\u043B\u0438\u0442\u044C \u043A\u0430\u0437\u043D\u0443'
    },
    change_role: {
        'id': 'clanmanagement.context_menu.change_role',
        'defaultMessage': '\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0434\u043E\u043B\u0436\u043D\u043E\u0441\u0442\u044C'
    },
    change_commander: {
        'id': 'clanmanagement.context_menu.change_commander',
        'defaultMessage': '\u041F\u0435\u0440\u0435\u0434\u0430\u0442\u044C \u043A\u043E\u043C\u0430\u043D\u0434\u043E\u0432\u0430\u043D\u0438\u0435'
    },
    remove_member: {
        'id': 'clanmanagement.context_menu.remove_member',
        'defaultMessage': '\u0418\u0441\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0438\u0437 \u043A\u043B\u0430\u043D\u0430'
    }
});

/**
 * customItems array format:
 * [customItemId, customItemLocalizedString, isEnabled]
 */
var userContextMenu = exports.userContextMenu = function userContextMenu(memberId) {
    return function (dispatch, getState) {
        var state = getState();

        var member = state.members.members.find(function (member) {
            return member.id === memberId;
        });
        if (member.isAnonymized) return;

        var author = state.members.members.find(function (member) {
            return member.id === state.account.id;
        });
        var canManageMember = (0, _roles.canManage)(author.role, member.role);

        var customItems = [];

        if ((0, _roles.hasPermission)(author.role, _roles.permissions.DIVIDE_PROFITS)) {
            var message = (0, _locale.formatMessage)(localizedActionNames.divide_profits);
            var enabled = Object.values(state.clan.treasury).some(function (amount) {
                return amount !== 0;
            }) && !member.isSuspended;

            customItems.push(['DIVIDE_PROFITS', message, enabled]);
        }
        if ((0, _roles.hasPermission)(author.role, _roles.permissions.CHANGE_COMMANDER)) {
            var _message = (0, _locale.formatMessage)(localizedActionNames.change_commander);
            var _enabled = canManageMember && !member.isSuspended;

            customItems.push(['CHANGE_COMMANDER', _message, _enabled]);
        }
        if ((0, _roles.hasPermission)(author.role, _roles.permissions.CHANGE_ROLE)) {
            var _message2 = (0, _locale.formatMessage)(localizedActionNames.change_role);
            var _enabled2 = canManageMember;

            customItems.push(['CHANGE_ROLE', _message2, _enabled2]);
        }

        if ((0, _roles.hasPermission)(author.role, _roles.permissions.REMOVE_MEMBER)) {
            var _message3 = (0, _locale.formatMessage)(localizedActionNames.remove_member);
            var _enabled3 = canManageMember;

            customItems.push(['REMOVE_MEMBER', _message3, _enabled3]);
        }

        return (0, _web_to_client.userContextMenu)(memberId, member.name, customItems).then(function (action) {
            return { member: member, action: action };
        });
    };
};

/***/ }),
/* 2382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _translations = __webpack_require__(2383);

var _reactWotBootstrap = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultLocalizations = {
    seconds: _translations.TIME_SINCE_TIMESTAMP_SECONDS,
    minutes: _translations.TIME_SINCE_TIMESTAMP_MINUTES,
    hours: _translations.TIME_SINCE_TIMESTAMP_HOURS,
    days: _translations.TIME_SINCE_TIMESTAMP_DAYS,
    months: _translations.TIME_SINCE_TIMESTAMP_MONTHS,
    years: _translations.TIME_SINCE_TIMESTAMP_YEARS
};

var propTypes = {
    timestamp: _propTypes2.default.number,
    localizations: _propTypes2.default.shape({
        seconds: _propTypes2.default.func,
        minutes: _propTypes2.default.func,
        hours: _propTypes2.default.func,
        days: _propTypes2.default.func,
        months: _propTypes2.default.func,
        years: _propTypes2.default.func
    })
};

var defaultProps = {
    localizations: defaultLocalizations
};

var FormattedTimeSince = function (_React$PureComponent) {
    _inherits(FormattedTimeSince, _React$PureComponent);

    function FormattedTimeSince() {
        _classCallCheck(this, FormattedTimeSince);

        return _possibleConstructorReturn(this, (FormattedTimeSince.__proto__ || Object.getPrototypeOf(FormattedTimeSince)).apply(this, arguments));
    }

    _createClass(FormattedTimeSince, [{
        key: 'render',
        value: function render() {
            if (!this.props.timestamp) {
                return _react2.default.createElement(
                    'span',
                    null,
                    _reactWotBootstrap.helpers.DEFAULT_ERROR
                );
            }
            return _reactWotBootstrap.helpers.getTimeSinceTimestamp(this.props.timestamp, this.props.localizations);
        }
    }]);

    return FormattedTimeSince;
}(_react2.default.PureComponent);

FormattedTimeSince.propTypes = propTypes;
FormattedTimeSince.defaultProps = defaultProps;

exports.default = FormattedTimeSince;

/***/ }),
/* 2383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TIME_SINCE_TIMESTAMP_YEARS = exports.TIME_SINCE_TIMESTAMP_MONTHS = exports.TIME_SINCE_TIMESTAMP_DAYS = exports.TIME_SINCE_TIMESTAMP_HOURS = exports.TIME_SINCE_TIMESTAMP_MINUTES = exports.TIME_SINCE_TIMESTAMP_SECONDS = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-multi-comp */
var TIME_SINCE_TIMESTAMP_SECONDS = exports.TIME_SINCE_TIMESTAMP_SECONDS = function TIME_SINCE_TIMESTAMP_SECONDS() {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'clanmanagement.memberstable.player.offline.seconds',
        defaultMessage: '1 \u043C\u0438\u043D\u0443\u0442\u0430'
    });
};

var TIME_SINCE_TIMESTAMP_MINUTES = exports.TIME_SINCE_TIMESTAMP_MINUTES = function TIME_SINCE_TIMESTAMP_MINUTES(value) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'clanmanagement.memberstable.player.status.offline.minutes',
        defaultMessage: '{value} \u043C\u0438\u043D.',
        values: { value: value }
    });
};

var TIME_SINCE_TIMESTAMP_HOURS = exports.TIME_SINCE_TIMESTAMP_HOURS = function TIME_SINCE_TIMESTAMP_HOURS(value) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'clanmanagement.memberstable.player.status.offline.hours',
        defaultMessage: '{value} \u0447.',
        values: { value: value }
    });
};

var TIME_SINCE_TIMESTAMP_DAYS = exports.TIME_SINCE_TIMESTAMP_DAYS = function TIME_SINCE_TIMESTAMP_DAYS(value) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'clanmanagement.memberstable.player.status.offline.days',
        defaultMessage: '{value} \u0434.',
        values: { value: value }
    });
};

var TIME_SINCE_TIMESTAMP_MONTHS = exports.TIME_SINCE_TIMESTAMP_MONTHS = function TIME_SINCE_TIMESTAMP_MONTHS(value) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'clanmanagement.memberstable.player.status.offline.months',
        defaultMessage: '{value} \u043C\u0435\u0441.',
        values: { value: value }
    });
};

var TIME_SINCE_TIMESTAMP_YEARS = exports.TIME_SINCE_TIMESTAMP_YEARS = function TIME_SINCE_TIMESTAMP_YEARS(value) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'clanmanagement.memberstable.player.status.offline.years',
        defaultMessage: '{value} \u0433.',
        values: { value: value }
    });
};

/***/ }),
/* 2384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactWotBootstrap = __webpack_require__(5);

var _BaseMembersTableItem2 = __webpack_require__(1372);

var _BaseMembersTableItem3 = _interopRequireDefault(_BaseMembersTableItem2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MembersTableItem = function (_BaseMembersTableItem) {
    _inherits(MembersTableItem, _BaseMembersTableItem);

    function MembersTableItem() {
        _classCallCheck(this, MembersTableItem);

        return _possibleConstructorReturn(this, (MembersTableItem.__proto__ || Object.getPrototypeOf(MembersTableItem)).apply(this, arguments));
    }

    _createClass(MembersTableItem, [{
        key: 'render',
        value: function render() {
            var getValueType = function getValueType(value) {
                return value ? undefined : 'null';
            };

            var formattedValue = function formattedValue(value) {
                var roundDown = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

                return _reactWotBootstrap.helpers.thousands(value || 0, roundDown);
            };

            return _react2.default.createElement(
                _reactWotBootstrap.TableRow,
                {
                    isHoverable: true,
                    isActive: this.isRowActive(),
                    needPlayHoverSound: this.needPlayHoverSound(),
                    onClick: this.props.displayCheckbox ? this.onRowClick : null
                },
                this.renderTableCellCheckbox(),
                this.renderTableCellRole(),
                this.renderTableCellMember(),
                _react2.default.createElement(
                    _reactWotBootstrap.TableBodyCell,
                    {
                        type: 'center',
                        valueType: getValueType(this.props.personalRating),
                        valueWidth: '38px',
                        isValue: true
                    },
                    _reactWotBootstrap.helpers.thousands(this.props.personalRating)
                ),
                _react2.default.createElement(
                    _reactWotBootstrap.TableBodyCell,
                    {
                        type: 'center',
                        valueType: getValueType(this.props.battlesCount),
                        valueWidth: '45',
                        isValue: true
                    },
                    formattedValue(this.props.battlesCount)
                ),
                _react2.default.createElement(
                    _reactWotBootstrap.TableBodyCell,
                    {
                        type: 'center',
                        valueType: getValueType(this.props.winsPercentage),
                        valueWidth: '48',
                        isValue: true
                    },
                    _reactWotBootstrap.helpers.percent(this.props.winsPercentage || 0)
                ),
                _react2.default.createElement(
                    _reactWotBootstrap.TableBodyCell,
                    {
                        type: 'center',
                        valueType: getValueType(this.props.expPerBattle),
                        valueWidth: '31',
                        isValue: true
                    },
                    formattedValue(this.props.expPerBattle, true)
                ),
                _react2.default.createElement(
                    _reactWotBootstrap.TableBodyCell,
                    {
                        type: 'center',
                        valueType: getValueType(this.props.damagePerBattle),
                        valueWidth: '31',
                        isValue: true
                    },
                    formattedValue(this.props.damagePerBattle, true)
                ),
                _react2.default.createElement(
                    _reactWotBootstrap.TableBodyCell,
                    {
                        type: 'center',
                        valueType: getValueType(this.props.memberDaysInClan),
                        valueWidth: '31',
                        isValue: true
                    },
                    _reactWotBootstrap.helpers.thousands(this.props.memberDaysInClan)
                ),
                this.renderTableCellMemberStatus()
            );
        }
    }]);

    return MembersTableItem;
}(_BaseMembersTableItem3.default);

MembersTableItem.propTypes = _extends({}, MembersTableItem.propTypes, {
    battlesCount: _propTypes2.default.number,
    damagePerBattle: _propTypes2.default.number,
    expPerBattle: _propTypes2.default.number,
    winsPercentage: _propTypes2.default.number,
    winsCount: _propTypes2.default.number,
    personalRating: _propTypes2.default.number,
    logoutAt: _propTypes2.default.number
});

exports.default = MembersTableItem;

/***/ }),
/* 2385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _CommonHeadersSettings = __webpack_require__(1374);

var _tooltips = __webpack_require__(571);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.default = [].concat(_toConsumableArray(_CommonHeadersSettings.FirstCommonHeaders), [{
    isSortable: true,
    icon: 'rating',
    key: 'personal_rating',
    tooltipId: 'members-table-column-tooltip',
    tooltipTip: _tooltips.PersonalRatingColumnTooltipContent.tip
}, {
    isSortable: true,
    icon: 'battles',
    key: 'battles_count',
    tooltipId: 'members-table-column-tooltip',
    tooltipTip: _tooltips.BattlesCountColumnTooltipContent.tip
}, {
    isSortable: true,
    icon: 'wins',
    key: 'wins_percentage',
    tooltipId: 'members-table-column-tooltip',
    tooltipTip: _tooltips.WinRateColumnTooltipContent.tip
}, {
    isSortable: true,
    icon: 'avg-exp',
    key: 'experience_per_battle',
    tooltipId: 'members-table-column-tooltip',
    tooltipTip: _tooltips.ExperienceColumnTooltipContent.tip
}, {
    isSortable: true,
    icon: 'avg-damage',
    key: 'damage_per_battle',
    tooltipId: 'members-table-column-tooltip',
    tooltipTip: _tooltips.DamageColumnTooltipContent.tip
}, {
    isSortable: true,
    icon: 'days',
    key: 'days_in_clan',
    tooltipId: 'members-table-column-tooltip',
    tooltipTip: _tooltips.DaysInClanColumnTooltipContent.tip
}], _toConsumableArray(_CommonHeadersSettings.LastCommonHeaders));

/***/ }),
/* 2386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (shouldShowLegendary) {
    var additionalColumn = shouldShowLegendary ? [{
        isSortable: true,
        icon: 'sorties-legendary',
        key: 'sorties_legendary',
        tooltipId: 'members-table-column-tooltip',
        tooltipTip: _tooltips.Attack11ColumnTooltipContent.tip
    }] : [];

    return [].concat(_toConsumableArray(_CommonHeadersSettings.FirstCommonHeaders), [{
        isSortable: true,
        icon: 'sorties-middle',
        key: 'sorties_middle',
        tooltipId: 'members-table-column-tooltip',
        tooltipTip: _tooltips.Attack6ColumnTooltipContent.tip
    }, {
        isSortable: true,
        icon: 'sorties-champion',
        key: 'sorties_champion',
        tooltipId: 'members-table-column-tooltip',
        tooltipTip: _tooltips.Attack8ColumnTooltipContent.tip
    }, {
        isSortable: true,
        icon: 'sorties-absolute',
        key: 'sorties_absolute',
        tooltipId: 'members-table-column-tooltip',
        tooltipTip: _tooltips.Attack10ColumnTooltipContent.tip
    }], additionalColumn, [{
        isSortable: true,
        icon: 'battles-attack',
        key: 'battles-attack',
        tooltipId: 'members-table-column-tooltip',
        tooltipTip: _tooltips.FortBattlesColumnTooltipContent.tip
    }, {
        isSortable: true,
        icon: 'industrial',
        key: 'industrial',
        tooltipId: 'members-table-column-tooltip',
        tooltipTip: _tooltips.ResourceColumnTooltipContent.tip
    }], _toConsumableArray(_CommonHeadersSettings.LastCommonHeaders));
};

var _CommonHeadersSettings = __webpack_require__(1374);

var _tooltips = __webpack_require__(144);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/***/ }),
/* 2387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactWotBootstrap = __webpack_require__(5);

var _roles = __webpack_require__(49);

var _propTypes3 = __webpack_require__(298);

var _tooltips = __webpack_require__(2388);

var _translations = __webpack_require__(2389);

var _MembersControlBlock = __webpack_require__(2390);

var _MembersControlBlock2 = _interopRequireDefault(_MembersControlBlock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MembersControlBlock = function (_React$PureComponent) {
    _inherits(MembersControlBlock, _React$PureComponent);

    function MembersControlBlock() {
        _classCallCheck(this, MembersControlBlock);

        return _possibleConstructorReturn(this, (MembersControlBlock.__proto__ || Object.getPrototypeOf(MembersControlBlock)).apply(this, arguments));
    }

    _createClass(MembersControlBlock, [{
        key: 'renderRemoveMembers',
        value: function renderRemoveMembers(cannotControlQuartermaster) {
            if (!(0, _roles.hasPermission)(this.props.currentMemberRole, _roles.permissions.REMOVE_MEMBER)) return null;

            var noSelectedMembers = this.props.selectedMembersCount === 0;

            var tooltip = null;
            var tooltipId = null;
            if (noSelectedMembers) {
                tooltip = _react2.default.createElement(_tooltips.RemoveMembersZeroPlayersSelectedTooltip, null);
                tooltipId = _tooltips.RemoveMembersZeroPlayersSelectedTooltip.id;
            } else if (this.props.isSelectedMembersWithSameOrHighRole) {
                if (cannotControlQuartermaster) {
                    tooltip = _react2.default.createElement(_tooltips.RemoveMembersCannotRemoveMembersExceptTreasurersTooltip, null);
                    tooltipId = _tooltips.RemoveMembersCannotRemoveMembersExceptTreasurersTooltip.id;
                } else {
                    tooltip = _react2.default.createElement(_tooltips.RemoveMembersCannotRemoveMembersTooltip, null);
                    tooltipId = _tooltips.RemoveMembersCannotRemoveMembersTooltip.id;
                }
            }

            var classNameIcon = (0, _classnames2.default)(_MembersControlBlock2.default.icon, _MembersControlBlock2.default['icon__removeMembers'], _defineProperty({}, _MembersControlBlock2.default.isDisabled, this.props.isSelectedMembersWithSameOrHighRole || noSelectedMembers));

            return _react2.default.createElement(
                _reactWotBootstrap.ButtonSmall,
                {
                    isDisabled: this.props.isSelectedMembersWithSameOrHighRole || noSelectedMembers,
                    onClick: this.props.onRemoveMembersClick,
                    tooltipId: tooltipId,
                    isJustified: true
                },
                _react2.default.createElement('div', { className: classNameIcon }),
                _translations.BUTTON_REMOVE_MEMBERS,
                tooltip
            );
        }
    }, {
        key: 'renderAllocateTreasury',
        value: function renderAllocateTreasury() {
            if (!(0, _roles.hasPermission)(this.props.currentMemberRole, _roles.permissions.DIVIDE_PROFITS)) return null;

            var noSelectedMembers = this.props.selectedMembersCount === 0;
            var notEnoughTreasure = Object.values(this.props.clanTreasure).every(function (amount) {
                return amount === 0;
            });

            var tooltip = void 0;
            var tooltipId = void 0;
            if (noSelectedMembers) {
                tooltip = _react2.default.createElement(_tooltips.AllocateTreasuryZeroPlayersSelectedTooltip, null);
                tooltipId = _tooltips.AllocateTreasuryZeroPlayersSelectedTooltip.id;
            } else if (notEnoughTreasure) {
                tooltip = _react2.default.createElement(_tooltips.AllocateTreasuryNoResourceTooltip, null);
                tooltipId = _tooltips.AllocateTreasuryNoResourceTooltip.id;
            }

            var classNameIcon = (0, _classnames2.default)(_MembersControlBlock2.default.icon, _MembersControlBlock2.default['icon__allocateTreasury'], _defineProperty({}, _MembersControlBlock2.default.isDisabled, noSelectedMembers || notEnoughTreasure));

            return _react2.default.createElement(
                _reactWotBootstrap.ButtonSmall,
                {
                    isDisabled: noSelectedMembers || notEnoughTreasure,
                    onClick: this.props.onAllocateTreasuryClick,
                    tooltipId: tooltipId,
                    isJustified: true
                },
                _react2.default.createElement('div', { className: classNameIcon }),
                _translations.BUTTON_DIVIDE_PROFITS,
                tooltip
            );
        }
    }, {
        key: 'renderChangeRole',
        value: function renderChangeRole(cannotControlQuartermaster) {
            if (!(0, _roles.hasPermission)(this.props.currentMemberRole, _roles.permissions.CHANGE_ROLE)) return null;

            var noSelectedMembers = this.props.selectedMembersCount === 0;

            var tooltip = null;
            var tooltipId = null;
            if (noSelectedMembers) {
                tooltip = _react2.default.createElement(_tooltips.ChangeRoleZeroPlayersSelectedTooltip, null);
                tooltipId = _tooltips.ChangeRoleZeroPlayersSelectedTooltip.id;
            } else if (this.props.isSelectedMembersWithSameOrHighRole) {
                if (cannotControlQuartermaster) {
                    tooltip = _react2.default.createElement(_tooltips.ChangeRoleCannotChangeRoleExceptTreasurersTooltip, null);
                    tooltipId = _tooltips.ChangeRoleCannotChangeRoleExceptTreasurersTooltip.id;
                } else {
                    tooltip = _react2.default.createElement(_tooltips.ChangeRoleCannotChangeRoleTooltip, null);
                    tooltipId = _tooltips.ChangeRoleCannotChangeRoleTooltip.id;
                }
            }

            var classNameIcon = (0, _classnames2.default)(_MembersControlBlock2.default.icon, _MembersControlBlock2.default['icon__changeRole'], _defineProperty({}, _MembersControlBlock2.default.isDisabled, this.props.isSelectedMembersWithSameOrHighRole || noSelectedMembers));

            return _react2.default.createElement(
                _reactWotBootstrap.ButtonSmall,
                {
                    isDisabled: this.props.isSelectedMembersWithSameOrHighRole || noSelectedMembers,
                    onClick: this.props.onChangeRoleClick,
                    tooltipId: tooltipId,
                    isJustified: true
                },
                _react2.default.createElement('div', { className: classNameIcon }),
                _translations.BUTTON_CHANGE_ROLE,
                tooltip
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var currentMemberRank = (0, _roles.getRank)(this.props.currentMemberRole);

            var cannotControlQuartermaster = currentMemberRank < 9;

            var allocateTreasury = this.renderAllocateTreasury();
            var changeRole = this.renderChangeRole(cannotControlQuartermaster);
            var removeMembers = this.renderRemoveMembers(cannotControlQuartermaster);

            return _react2.default.createElement(
                _reactWotBootstrap.Panel,
                null,
                _react2.default.createElement(
                    'div',
                    { className: _MembersControlBlock2.default.base },
                    _react2.default.createElement(
                        _reactWotBootstrap.ButtonGroup,
                        null,
                        allocateTreasury,
                        changeRole,
                        removeMembers
                    )
                )
            );
        }
    }]);

    return MembersControlBlock;
}(_react2.default.PureComponent);

MembersControlBlock.propTypes = {
    currentMemberRole: _propTypes2.default.oneOf(_roles.roleNames).isRequired,
    selectedMembersCount: _propTypes2.default.number.isRequired,
    isSelectedMembersWithSameOrHighRole: _propTypes2.default.bool.isRequired,

    clanTreasure: _propTypes3.treasuryPropTypes,

    onAllocateTreasuryClick: _propTypes2.default.func.isRequired,
    onChangeRoleClick: _propTypes2.default.func.isRequired,
    onRemoveMembersClick: _propTypes2.default.func.isRequired
};
exports.default = MembersControlBlock;

/***/ }),
/* 2388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RemoveMembersCannotRemoveMembersTooltip = exports.RemoveMembersCannotRemoveMembersExceptTreasurersTooltip = exports.RemoveMembersZeroPlayersSelectedTooltip = exports.ChangeRoleCannotChangeRoleTooltip = exports.ChangeRoleCannotChangeRoleExceptTreasurersTooltip = exports.ChangeRoleZeroPlayersSelectedTooltip = exports.AllocateTreasuryNoResourceTooltip = exports.AllocateTreasuryZeroPlayersSelectedTooltip = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _reactWotBootstrap = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AllocateTreasuryZeroPlayersSelectedTooltip = exports.AllocateTreasuryZeroPlayersSelectedTooltip = function AllocateTreasuryZeroPlayersSelectedTooltip() {
    return _react2.default.createElement(
        _reactWotBootstrap.Tooltip,
        { id: AllocateTreasuryZeroPlayersSelectedTooltip.id },
        _react2.default.createElement(
            _reactWotBootstrap.TooltipBody,
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'clanmanagement.tooltips.allocate_treasury_zero_players_selected_body',
                defaultMessage: '\u0427\u0442\u043E\u0431\u044B \u0440\u0430\u0441\u043F\u0440\u0435\u0434\u0435\u043B\u0438\u0442\u044C \u043A\u0430\u0437\u043D\u0443, \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043E\u0434\u043D\u043E\u0433\u043E \u0438\u043B\u0438 \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u0438\u0445 \u0438\u0433\u0440\u043E\u043A\u043E\u0432.'
            })
        )
    );
}; /* eslint-disable react/no-multi-comp, max-len */

AllocateTreasuryZeroPlayersSelectedTooltip.id = 'separate-treasury-zero-players-selected-tooltip';

var AllocateTreasuryNoResourceTooltip = exports.AllocateTreasuryNoResourceTooltip = function AllocateTreasuryNoResourceTooltip() {
    return _react2.default.createElement(
        _reactWotBootstrap.Tooltip,
        { id: AllocateTreasuryNoResourceTooltip.id },
        _react2.default.createElement(
            _reactWotBootstrap.TooltipBody,
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'clanmanagement.tooltips.allocate_treasury_no_resource_body',
                defaultMessage: '\u0412 \u043A\u0430\u0437\u043D\u0435 \u043A\u043B\u0430\u043D\u0430 \u043D\u0435\u0442 \u0440\u0435\u0441\u0443\u0440\u0441\u043E\u0432'
            })
        )
    );
};
AllocateTreasuryNoResourceTooltip.id = 'separate-treasury-no-gold-tooltip';

var ChangeRoleZeroPlayersSelectedTooltip = exports.ChangeRoleZeroPlayersSelectedTooltip = function ChangeRoleZeroPlayersSelectedTooltip() {
    return _react2.default.createElement(
        _reactWotBootstrap.Tooltip,
        { id: ChangeRoleZeroPlayersSelectedTooltip.id },
        _react2.default.createElement(
            _reactWotBootstrap.TooltipBody,
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'clanmanagement.tooltips.change_role_zero_players_selected_body',
                defaultMessage: '\u0427\u0442\u043E\u0431\u044B \u0438\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0434\u043E\u043B\u0436\u043D\u043E\u0441\u0442\u044C, \u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043E\u0434\u043D\u043E\u0433\u043E \u0438\u043B\u0438 \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u0438\u0445 \u0438\u0433\u0440\u043E\u043A\u043E\u0432.'
            })
        )
    );
};
ChangeRoleZeroPlayersSelectedTooltip.id = 'change-role-zero-players-selected-tooltip';

var ChangeRoleCannotChangeRoleExceptTreasurersTooltip = exports.ChangeRoleCannotChangeRoleExceptTreasurersTooltip = function ChangeRoleCannotChangeRoleExceptTreasurersTooltip() {
    return _react2.default.createElement(
        _reactWotBootstrap.Tooltip,
        { id: ChangeRoleCannotChangeRoleExceptTreasurersTooltip.id },
        _react2.default.createElement(
            _reactWotBootstrap.TooltipBody,
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'clanmanagement.tooltips.change_role_cannot_change_role_except_treasurers_body',
                defaultMessage: '\u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0438\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0434\u043E\u043B\u0436\u043D\u043E\u0441\u0442\u044C \u0442\u043E\u043B\u044C\u043A\u043E \u0438\u0433\u0440\u043E\u043A\u043E\u0432 \u0432 \u0434\u043E\u043B\u0436\u043D\u043E\u0441\u0442\u0438 \u043D\u0438\u0436\u0435 \u0432\u0430\u0448\u0435\u0439 (\u043A\u0440\u043E\u043C\u0435 \u043E\u0444\u0438\u0446\u0435\u0440\u0430 \u0441\u043D\u0430\u0431\u0436\u0435\u043D\u0438\u044F).'
            })
        )
    );
};
ChangeRoleCannotChangeRoleExceptTreasurersTooltip.id = 'change-role-cannot-change-role-except-treasurers-body';

var ChangeRoleCannotChangeRoleTooltip = exports.ChangeRoleCannotChangeRoleTooltip = function ChangeRoleCannotChangeRoleTooltip() {
    return _react2.default.createElement(
        _reactWotBootstrap.Tooltip,
        { id: ChangeRoleCannotChangeRoleTooltip.id },
        _react2.default.createElement(
            _reactWotBootstrap.TooltipBody,
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'clanmanagement.tooltips.change_role_cannot_change_role_body',
                defaultMessage: '\u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0438\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0434\u043E\u043B\u0436\u043D\u043E\u0441\u0442\u044C \u0442\u043E\u043B\u044C\u043A\u043E \u0438\u0433\u0440\u043E\u043A\u043E\u0432 \u0432 \u0434\u043E\u043B\u0436\u043D\u043E\u0441\u0442\u0438 \u043D\u0438\u0436\u0435 \u0432\u0430\u0448\u0435\u0439.'
            })
        )
    );
};
ChangeRoleCannotChangeRoleTooltip.id = 'change-role-cannot-change-role-body';

var RemoveMembersZeroPlayersSelectedTooltip = exports.RemoveMembersZeroPlayersSelectedTooltip = function RemoveMembersZeroPlayersSelectedTooltip() {
    return _react2.default.createElement(
        _reactWotBootstrap.Tooltip,
        { id: RemoveMembersZeroPlayersSelectedTooltip.id },
        _react2.default.createElement(
            _reactWotBootstrap.TooltipBody,
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'clanmanagement.tooltips.remove_members_zero_players_selected_body',
                defaultMessage: '\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043E\u0434\u043D\u043E\u0433\u043E \u0438\u043B\u0438 \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u0438\u0445 \u0438\u0433\u0440\u043E\u043A\u043E\u0432, \u0447\u0442\u043E\u0431\u044B \u0438\u0441\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0438\u0437 \u043A\u043B\u0430\u043D\u0430.'
            })
        )
    );
};
RemoveMembersZeroPlayersSelectedTooltip.id = 'remove-members-zero-players-selected-tooltip';

var RemoveMembersCannotRemoveMembersExceptTreasurersTooltip = exports.RemoveMembersCannotRemoveMembersExceptTreasurersTooltip = function RemoveMembersCannotRemoveMembersExceptTreasurersTooltip() {
    return _react2.default.createElement(
        _reactWotBootstrap.Tooltip,
        { id: RemoveMembersCannotRemoveMembersExceptTreasurersTooltip.id },
        _react2.default.createElement(
            _reactWotBootstrap.TooltipBody,
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'clanmanagement.tooltips.remove_members_cannot_remove_members_except_treasurers_body',
                defaultMessage: '\u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0438\u0441\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0438\u0437 \u043A\u043B\u0430\u043D\u0430 \u0442\u043E\u043B\u044C\u043A\u043E \u0438\u0433\u0440\u043E\u043A\u043E\u0432 \u0432 \u0434\u043E\u043B\u0436\u043D\u043E\u0441\u0442\u0438 \u043D\u0438\u0436\u0435 \u0432\u0430\u0448\u0435\u0439 (\u043A\u0440\u043E\u043C\u0435 \u043E\u0444\u0438\u0446\u0435\u0440\u0430 \u0441\u043D\u0430\u0431\u0436\u0435\u043D\u0438\u044F).'
            })
        )
    );
};
RemoveMembersCannotRemoveMembersExceptTreasurersTooltip.id = 'remove-members-cannot-remove-members-except-treasurers-body';

var RemoveMembersCannotRemoveMembersTooltip = exports.RemoveMembersCannotRemoveMembersTooltip = function RemoveMembersCannotRemoveMembersTooltip() {
    return _react2.default.createElement(
        _reactWotBootstrap.Tooltip,
        { id: RemoveMembersCannotRemoveMembersTooltip.id },
        _react2.default.createElement(
            _reactWotBootstrap.TooltipBody,
            null,
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'clanmanagement.tooltips.remove_members_cannot_remove_members_body',
                defaultMessage: '\u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0438\u0441\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0438\u0437 \u043A\u043B\u0430\u043D\u0430 \u0442\u043E\u043B\u044C\u043A\u043E \u0438\u0433\u0440\u043E\u043A\u043E\u0432 \u0432 \u0434\u043E\u043B\u0436\u043D\u043E\u0441\u0442\u0438 \u043D\u0438\u0436\u0435 \u0432\u0430\u0448\u0435\u0439.'
            })
        )
    );
};
RemoveMembersCannotRemoveMembersTooltip.id = 'remove-members-cannot-remove-members-body';

/***/ }),
/* 2389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BUTTON_REMOVE_MEMBERS = exports.BUTTON_CHANGE_ROLE = exports.BUTTON_DIVIDE_PROFITS = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BUTTON_DIVIDE_PROFITS = exports.BUTTON_DIVIDE_PROFITS = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'members_control_block.button.divide_profits',
    defaultMessage: '\u0420\u0430\u0441\u043F\u0440\u0435\u0434\u0435\u043B\u0438\u0442\u044C \u043A\u0430\u0437\u043D\u0443'
});

var BUTTON_CHANGE_ROLE = exports.BUTTON_CHANGE_ROLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'members_control_block.button.change_role',
    defaultMessage: '\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0434\u043E\u043B\u0436\u043D\u043E\u0441\u0442\u044C'
});

var BUTTON_REMOVE_MEMBERS = exports.BUTTON_REMOVE_MEMBERS = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'members_control_block.button.remove_members',
    defaultMessage: '\u0418\u0441\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0438\u0437 \u043A\u043B\u0430\u043D\u0430'
});

/***/ }),
/* 2390 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"MembersControlBlock_base--Ci7di","icon":"MembersControlBlock_icon--mLCog","icon__changeRole":"MembersControlBlock_icon__changeRole--2_fOb","iconChangeRole":"MembersControlBlock_icon__changeRole--2_fOb","icon__allocateTreasury":"MembersControlBlock_icon__allocateTreasury--Nnhax","iconAllocateTreasury":"MembersControlBlock_icon__allocateTreasury--Nnhax","icon__removeMembers":"MembersControlBlock_icon__removeMembers--3Gr55","iconRemoveMembers":"MembersControlBlock_icon__removeMembers--3Gr55","isDisabled":"MembersControlBlock_isDisabled--1ObZX"};

/***/ }),
/* 2391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ButtonInbox = __webpack_require__(1361);

var _ButtonInbox2 = _interopRequireDefault(_ButtonInbox);

var _translations = __webpack_require__(2392);

var _Inbox = __webpack_require__(2393);

var _Inbox2 = _interopRequireDefault(_Inbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Inbox = function (_React$PureComponent) {
    _inherits(Inbox, _React$PureComponent);

    function Inbox() {
        _classCallCheck(this, Inbox);

        return _possibleConstructorReturn(this, (Inbox.__proto__ || Object.getPrototypeOf(Inbox)).apply(this, arguments));
    }

    _createClass(Inbox, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: _Inbox2.default.inbox },
                _react2.default.createElement(
                    'div',
                    { className: _Inbox2.default.inboxCaption },
                    _translations.APPLICATIONS_AND_INVITES
                ),
                _react2.default.createElement(
                    'div',
                    { className: _Inbox2.default.inboxButton },
                    _react2.default.createElement(_ButtonInbox2.default, {
                        messages: this.props.messages,
                        onClick: this.props.onClick,
                        type: 'miniSecondary'
                    })
                )
            );
        }
    }]);

    return Inbox;
}(_react2.default.PureComponent);

Inbox.propTypes = {
    messages: _propTypes2.default.number,
    onClick: _propTypes2.default.func.isRequired
};
exports.default = Inbox;

/***/ }),
/* 2392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.APPLICATIONS_AND_INVITES = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var APPLICATIONS_AND_INVITES = exports.APPLICATIONS_AND_INVITES = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clanmanagement.caption.applications_and_invites',
    defaultMessage: '\u0417\u0430\u044F\u0432\u043A\u0438 \u0438 \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F:'
});

/***/ }),
/* 2393 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"inbox":"Inbox_inbox--3hxam","inboxCaption":"Inbox_inboxCaption--3aUTD","inboxButton":"Inbox_inboxButton--2dwNk"};

/***/ }),
/* 2394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RANDOM_BATTLE_TYPES_FILTER_ITEMS = exports.STATISTICS_BATTLE_TYPES = exports.COMMON_STATISTICS_BATTLE_TYPES = exports.TABS_BLOCK_TYPES = exports.PERIODS_BY_BLOCK_TYPE = undefined;

var _PERIODS_BY_BLOCK_TYP;

var _constants = __webpack_require__(160);

var _battles = __webpack_require__(199);

var _periods = __webpack_require__(280);

var _translations = __webpack_require__(570);

var _tooltips = __webpack_require__(144);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PERIODS_BY_BLOCK_TYPE = exports.PERIODS_BY_BLOCK_TYPE = (_PERIODS_BY_BLOCK_TYP = {}, _defineProperty(_PERIODS_BY_BLOCK_TYP, _constants.BLOCK_TYPES.CLAN_MODES, [{
    name: 'periods',
    value: _periods.PERIOD_TYPES.MONTH,
    caption: _translations.PERIOD_28_DAYS,
    tooltipId: _tooltips.Statistics28DaysTooltip.id
}, {
    name: 'periods',
    value: _periods.PERIOD_TYPES.WEEK,
    caption: _translations.PERIOD_7_DAYS,
    tooltipId: _tooltips.Statistics7DaysTooltip.id
}, {
    name: 'periods',
    value: _periods.PERIOD_TYPES.DAY,
    caption: _translations.PERIOD_1_DAY,
    tooltipId: _tooltips.Statistics1DayTooltip.id
}]), _defineProperty(_PERIODS_BY_BLOCK_TYP, _constants.BLOCK_TYPES.STATISTICS, [{
    name: 'periods',
    value: _periods.PERIOD_TYPES.ALL,
    caption: _translations.PERIOD_ALL_TIME,
    tooltipId: _tooltips.StatisticsOverallTooltip.id
}, {
    name: 'periods',
    value: _periods.PERIOD_TYPES.MONTH,
    caption: _translations.PERIOD_28_DAYS,
    tooltipId: _tooltips.Statistics28DaysTooltip.id
}, {
    name: 'periods',
    value: _periods.PERIOD_TYPES.WEEK,
    caption: _translations.PERIOD_7_DAYS,
    tooltipId: _tooltips.Statistics7DaysTooltip.id
}, {
    name: 'periods',
    value: _periods.PERIOD_TYPES.DAY,
    caption: _translations.PERIOD_1_DAY,
    tooltipId: _tooltips.Statistics1DayTooltip.id
}]), _PERIODS_BY_BLOCK_TYP);

var TABS_BLOCK_TYPES = exports.TABS_BLOCK_TYPES = [{
    value: _constants.BLOCK_TYPES.CLAN_MODES,
    caption: _translations.BLOCK_TYPES_CLAN_MODES
}, {
    value: _constants.BLOCK_TYPES.STATISTICS,
    caption: _translations.BLOCK_TYPES_STATISTICS
}];

var COMMON_STATISTICS_BATTLE_TYPES = exports.COMMON_STATISTICS_BATTLE_TYPES = [{
    value: _battles.BATTLE_TYPES.RANDOM,
    caption: _translations.STATISTICS_BATTLE_TYPES_RANDOM
}, {
    value: _battles.BATTLE_TYPES.RANKED,
    caption: _translations.STATISTICS_BATTLE_TYPES_RANKED
}, {
    value: _battles.BATTLE_TYPES.TEAM,
    caption: _translations.STATISTICS_BATTLE_TYPES_TEAM
}, {
    value: _battles.BATTLE_TYPES.SKIRMISHES,
    caption: _translations.STATISTICS_BATTLE_TYPES_SKIRMISHES
}, {
    value: _battles.BATTLE_TYPES.ATTACKS,
    caption: _translations.STATISTICS_BATTLE_TYPES_FORT
}];

var STATISTICS_BATTLE_TYPES = exports.STATISTICS_BATTLE_TYPES = [].concat(COMMON_STATISTICS_BATTLE_TYPES, [{
    value: _battles.BATTLE_TYPES.GLOBAL_MAP,
    caption: _translations.STATISTICS_BATTLE_GLOBAL_MAP
}]);

var RANDOM_BATTLE_TYPES_FILTER_ITEMS = exports.RANDOM_BATTLE_TYPES_FILTER_ITEMS = [{
    name: 'periods',
    value: _battles.RANDOM_BATTLE_TYPES.DEFAULT,
    caption: '15x15',
    tooltipId: _tooltips.StatisticsRandomDefaultBattleTypeTooltip.id
}, {
    name: 'periods',
    value: _battles.RANDOM_BATTLE_TYPES.EPIC,
    caption: '30x30',
    tooltipId: _tooltips.StatisticsRandomEpicBattleTypeTooltip.id
}];

/***/ }),
/* 2395 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"ClanManagement_base--2kRJv","base__cn":"ClanManagement_base__cn--1Qz35","baseCn":"ClanManagement_base__cn--1Qz35","header":"ClanManagement_header--27OCh","headerInner":"ClanManagement_headerInner--cpCoe","back":"ClanManagement_back--3b54a","title":"ClanManagement_title--1WsHP","tabs":"ClanManagement_tabs--2toDz","filter":"ClanManagement_filter--12PhB","filterItem":"ClanManagement_filterItem--2WoD7","info":"ClanManagement_info--1kkpu","wrapper":"ClanManagement_wrapper--2HCLO","table":"ClanManagement_table--2eryB","memberBlock":"ClanManagement_memberBlock--26QbN","panel":"ClanManagement_panel--3bF6g","isProcessing":"ClanManagement_isProcessing--3M_dk","counter":"ClanManagement_counter--1UL5C","subtitle":"ClanManagement_subtitle--1FTZf","membersOnline":"ClanManagement_membersOnline--3yiEp","treasuryCurrency":"ClanManagement_treasuryCurrency--1R-UW"};

/***/ }),
/* 2396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactWotBootstrap = __webpack_require__(5);

var _translations = __webpack_require__(299);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
    selectedMemberName: _propTypes2.default.string.isRequired,

    isOpened: _propTypes2.default.bool,

    onSubmit: _propTypes2.default.func.isRequired,
    onClose: _propTypes2.default.func.isRequired
};

var ChangeCommanderDialog = function ChangeCommanderDialog(props) {
    var member = _react2.default.createElement(_reactWotBootstrap.MemberName, { name: props.selectedMemberName });
    var dialogContent = _react2.default.createElement(
        'div',
        null,
        _translations.DIALOG_CHANGE_COMMANDER_CONTENT,
        '\u2002',
        member
    );
    return _react2.default.createElement(
        _reactWotBootstrap.Dialog,
        {
            title: _translations.DIALOG_CHANGE_COMMANDER_TITLE,
            submitCaption: _translations.DIALOG_CHANGE_COMMANDER_SUBMIT_BUTTON_CAPTION,
            closeCaption: _translations.DIALOG_BUTTON_CANCEL_CAPTION,
            isOpened: props.isOpened,
            isFocusOnSubmitBtn: true,
            onSubmit: props.onSubmit,
            onClose: props.onClose
        },
        dialogContent
    );
};

ChangeCommanderDialog.propTypes = propTypes;

exports.default = ChangeCommanderDialog;

/***/ }),
/* 2397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactWotBootstrap = __webpack_require__(5);

var _tooltips = __webpack_require__(2398);

var _translations = __webpack_require__(299);

var _Dialogs = __webpack_require__(573);

var _Dialogs2 = _interopRequireDefault(_Dialogs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
    selectedMembers: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        id: _propTypes2.default.number.isRequired,
        name: _propTypes2.default.string.isRequired
    })).isRequired,

    isOpened: _propTypes2.default.bool,

    onSubmit: _propTypes2.default.func.isRequired,
    onClose: _propTypes2.default.func.isRequired
};

var RemoveMembersDialog = function RemoveMembersDialog(props) {
    var dialogContent = null;
    var selectedMembersCount = props.selectedMembers.length;
    if (selectedMembersCount === 1) {
        var member = _react2.default.createElement(_reactWotBootstrap.MemberName, { name: props.selectedMembers[0].name });
        dialogContent = _react2.default.createElement(
            'div',
            null,
            _translations.DIALOG_REMOVE_MEMBERS_CONTENT_1_PLAYER,
            '\u2002',
            member
        );
    } else if (selectedMembersCount > 0) {
        var members = props.selectedMembers.map(function (member) {
            return _react2.default.createElement(_reactWotBootstrap.MemberName, { key: member.id, name: member.name });
        });

        var isNeedTooltip = selectedMembersCount > 10;
        var tooltip = isNeedTooltip ? _react2.default.createElement(
            _tooltips.DialogRemoveMembersPlayersTooltip,
            null,
            members
        ) : null;

        dialogContent = _react2.default.createElement(
            'div',
            {
                'data-tip': isNeedTooltip,
                'data-for': isNeedTooltip ? _tooltips.DialogRemoveMembersPlayersTooltip.id : null
            },
            _translations.DIALOG_REMOVE_MEMBERS_CONTENT_PLAYERS,
            '\u2002',
            isNeedTooltip ? _react2.default.createElement(
                'span',
                { className: _Dialogs2.default.membersCount },
                selectedMembersCount
            ) : members,
            tooltip
        );
    }

    return _react2.default.createElement(
        _reactWotBootstrap.Dialog,
        {
            title: _translations.DIALOG_REMOVE_MEMBERS_TITLE,
            submitCaption: _translations.DIALOG_REMOVE_MEMBERS_SUBMIT_BUTTON_CAPTION,
            closeCaption: _translations.DIALOG_BUTTON_CANCEL_CAPTION,
            isOpened: props.isOpened,
            isFocusOnSubmitBtn: true,
            onSubmit: props.onSubmit,
            onClose: props.onClose
        },
        dialogContent
    );
};

RemoveMembersDialog.propTypes = propTypes;

exports.default = RemoveMembersDialog;

/***/ }),
/* 2398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DialogRemoveMembersPlayersTooltip = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _reactWotBootstrap = __webpack_require__(5);

var _constants = __webpack_require__(572);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DialogRemoveMembersPlayersTooltip = exports.DialogRemoveMembersPlayersTooltip = function DialogRemoveMembersPlayersTooltip(_ref) {
    var children = _ref.children;
    return _react2.default.createElement(
        _reactWotBootstrap.Tooltip,
        { id: DialogRemoveMembersPlayersTooltip.id },
        _react2.default.createElement(
            _reactWotBootstrap.TooltipBody,
            null,
            _react2.default.createElement(
                _reactWotBootstrap.TooltipSubtitle,
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'clanmanagement.tooltips.dialog_remove_members_players_header',
                    defaultMessage: '\u0418\u0441\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0438\u0437 \u043A\u043B\u0430\u043D\u0430 \u0438\u0433\u0440\u043E\u043A\u043E\u0432:'
                })
            ),
            _react2.default.createElement(
                _reactWotBootstrap.LineClamp,
                { lines: _constants.LINE_CLAMP_LINES },
                children
            )
        )
    );
};
DialogRemoveMembersPlayersTooltip.id = 'dialog-remove-members-players-body';
DialogRemoveMembersPlayersTooltip.propTypes = {
    children: _propTypes2.default.node.isRequired
};

/***/ }),
/* 2399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AllocatingResourcesDialog = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = __webpack_require__(7);

var _reactWotBootstrap = __webpack_require__(5);

var _Dialog = __webpack_require__(284);

var dialogActions = _interopRequireWildcard(_Dialog);

var _propTypes3 = __webpack_require__(298);

var _constants = __webpack_require__(4);

var _i18n = __webpack_require__(10);

var _translations = __webpack_require__(299);

var _translations2 = __webpack_require__(1375);

var _tooltips = __webpack_require__(2400);

var _Dialogs = __webpack_require__(573);

var _Dialogs2 = _interopRequireDefault(_Dialogs);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
    selectedMembers: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        id: _propTypes2.default.number.isRequired,
        name: _propTypes2.default.string.isRequired
    })).isRequired,
    treasury: _propTypes3.treasuryPropTypes.isRequired,
    isOpened: _propTypes2.default.bool,

    onSubmit: _propTypes2.default.func.isRequired,
    onClose: _propTypes2.default.func.isRequired
};

var AllocatingResourcesDialog = exports.AllocatingResourcesDialog = function (_React$Component) {
    _inherits(AllocatingResourcesDialog, _React$Component);

    function AllocatingResourcesDialog(props) {
        _classCallCheck(this, AllocatingResourcesDialog);

        var _this = _possibleConstructorReturn(this, (AllocatingResourcesDialog.__proto__ || Object.getPrototypeOf(AllocatingResourcesDialog)).call(this, props));

        _this.onChangeAmountToEach = function (toEach) {
            return _this.setState({ toEach: toEach });
        };

        _this.onSubmit = function () {
            return _this.props.onSubmit(_this.state.toEach, _this.state.currency);
        };

        _this.onCurrencyChange = function (newCurrency) {
            return _this.setState({ currency: newCurrency, toEach: 0 });
        };

        var currency = void 0;

        if (_constants.MONEY_TYPES.gold in props.treasury) currency = _constants.MONEY_TYPES.gold;else if (_constants.MONEY_TYPES.credits in props.treasury) currency = _constants.MONEY_TYPES.credits;else if (_constants.MONEY_TYPES.crystal in props.treasury) currency = _constants.MONEY_TYPES.crystal;

        _this.state = {
            toEach: 0,
            currency: currency
        };
        return _this;
    }

    _createClass(AllocatingResourcesDialog, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var members = null;
            var tooltip = null;

            var currency = this.state.currency;
            var totalAmount = this.props.treasury[currency];

            var selectedMembersCount = this.props.selectedMembers.length;
            var isNeedTooltip = selectedMembersCount > 10;
            if (selectedMembersCount === 1) {
                members = _react2.default.createElement(_reactWotBootstrap.MemberName, { name: this.props.selectedMembers[0].name });
            } else if (selectedMembersCount > 1) {
                members = this.props.selectedMembers.map(function (member) {
                    return _react2.default.createElement(_reactWotBootstrap.MemberName, { key: member.id, name: member.name });
                });
                tooltip = isNeedTooltip ? _react2.default.createElement(_tooltips.DialogAllocatingResourcesPlayersTooltip, { children: members }) : null;

                members = isNeedTooltip ? _react2.default.createElement(
                    'span',
                    { className: _Dialogs2.default.membersCount },
                    selectedMembersCount
                ) : _react2.default.createElement(
                    'div',
                    { className: _Dialogs2.default.members },
                    members
                );
            }

            var maxAmountToEach = selectedMembersCount ? Math.floor(totalAmount / selectedMembersCount) : 0;

            var dropDownItems = [_constants.MONEY_TYPES.gold, _constants.MONEY_TYPES.credits, _constants.MONEY_TYPES.crystal].filter(function (currency) {
                return currency in _this2.props.treasury;
            }).map(function (currency) {
                return { caption: _i18n.CURRENCIES[currency], value: currency };
            });

            var amountToCharge = this.state.toEach * selectedMembersCount;
            var treasuryCaptionClassName = (0, _classnames2.default)(_Dialogs2.default.caption, _Dialogs2.default['caption__treasury']);
            return _react2.default.createElement(
                _reactWotBootstrap.Dialog,
                {
                    title: _translations2.DIALOG_ALLOCATING_RESOURCES_TITLE,
                    submitCaption: _translations2.DIALOG_ALLOCATING_RESOURCES_SUBMIT_BUTTON_CAPTION,
                    closeCaption: _translations.DIALOG_BUTTON_CANCEL_CAPTION,
                    isOpened: this.props.isOpened,
                    isDisabledSubmit: amountToCharge === 0,
                    onSubmit: this.onSubmit,
                    onClose: this.props.onClose
                },
                _react2.default.createElement(
                    'div',
                    { className: _Dialogs2.default.base },
                    _react2.default.createElement(
                        'div',
                        {
                            className: _Dialogs2.default.header,
                            'data-tip': isNeedTooltip,
                            'data-for': isNeedTooltip ? _tooltips.DialogAllocatingResourcesPlayersTooltip.id : null
                        },
                        selectedMembersCount > 1 ? _translations2.DIALOG_ALLOCATING_RESOURCES_DIVIDE_TO_MEMBERS_TITLE : _translations2.DIALOG_ALLOCATING_RESOURCES_DIVIDE_TO_MEMBER_TITLE,
                        '\u2002',
                        members,
                        tooltip
                    ),
                    _react2.default.createElement('div', { className: _Dialogs2.default.divider }),
                    _react2.default.createElement(
                        'div',
                        { className: _Dialogs2.default.body },
                        _react2.default.createElement(
                            'div',
                            { className: _Dialogs2.default.row },
                            _react2.default.createElement(
                                'div',
                                { className: treasuryCaptionClassName },
                                _translations2.DIALOG_ALLOCATING_RESOURCES_SELECT_CURRENCY
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: (0, _classnames2.default)(_Dialogs2.default.value, _Dialogs2.default.value__currency) },
                                _react2.default.createElement(_reactWotBootstrap.Select, {
                                    items: dropDownItems,
                                    selectedItem: currency,
                                    onItemChange: this.onCurrencyChange,
                                    width: 113
                                })
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _Dialogs2.default.row },
                            _react2.default.createElement(
                                'div',
                                { className: treasuryCaptionClassName },
                                _translations2.DIALOG_ALLOCATING_RESOURCES_BEFORE_DIVIDE_TITLE
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _Dialogs2.default.value },
                                _react2.default.createElement(_reactWotBootstrap.Currency, { type: currency, value: totalAmount })
                            )
                        )
                    ),
                    _react2.default.createElement('div', { className: _Dialogs2.default.dividerArrow }),
                    _react2.default.createElement(
                        'div',
                        { className: _Dialogs2.default.body },
                        _react2.default.createElement(
                            'div',
                            { className: _Dialogs2.default.row },
                            _react2.default.createElement(
                                'div',
                                { className: treasuryCaptionClassName },
                                selectedMembersCount > 1 ? _translations2.DIALOG_ALLOCATING_RESOURCES_DIVIDE_EACH_TITLE : _translations2.DIALOG_ALLOCATING_RESOURCES_DIVIDE_TO_ONE_TITLE
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _Dialogs2.default.value },
                                _react2.default.createElement(_reactWotBootstrap.Currency, { type: currency }),
                                _react2.default.createElement(
                                    'div',
                                    { className: _Dialogs2.default.input },
                                    _react2.default.createElement(_reactWotBootstrap.InputNumber, {
                                        value: this.state.toEach,
                                        valueMax: maxAmountToEach,
                                        type: currency === _constants.MONEY_TYPES.gold ? 'gold' : 'regular',
                                        isFocusOn: true,
                                        onChange: this.onChangeAmountToEach
                                    })
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _Dialogs2.default.row },
                            _react2.default.createElement(
                                'div',
                                { className: treasuryCaptionClassName },
                                _translations2.DIALOG_ALLOCATING_RESOURCES_AMOUNT_OF_CHARGES_TITLE
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _Dialogs2.default.value },
                                _react2.default.createElement(_reactWotBootstrap.Currency, { type: currency, value: amountToCharge })
                            )
                        )
                    ),
                    _react2.default.createElement('div', { className: _Dialogs2.default.dividerArrow }),
                    _react2.default.createElement(
                        'div',
                        { className: _Dialogs2.default.body },
                        _react2.default.createElement(
                            'div',
                            { className: _Dialogs2.default.row },
                            _react2.default.createElement(
                                'div',
                                { className: treasuryCaptionClassName },
                                _translations2.DIALOG_ALLOCATING_RESOURCES_AFTER_DIVIDE_TITLE
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _Dialogs2.default.value },
                                _react2.default.createElement(_reactWotBootstrap.Currency, { type: currency, value: totalAmount - amountToCharge })
                            )
                        )
                    )
                )
            );
        }
    }]);

    return AllocatingResourcesDialog;
}(_react2.default.Component);

AllocatingResourcesDialog.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state, ownProps) {
    var members = state.members.members;
    var selectedMembers = ownProps.selectedMembers || members.filter(function (member) {
        return state.membersOperation.selectedIds.includes(member.id);
    });
    return {
        selectedMembers: selectedMembers,
        treasury: state.clan.treasury
    };
};

var mapDispatchToProps = {
    onClose: dialogActions.hideDialog
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AllocatingResourcesDialog);

/***/ }),
/* 2400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DialogAllocatingResourcesPlayersTooltip = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactWotBootstrap = __webpack_require__(5);

var _translations = __webpack_require__(1375);

var _constants = __webpack_require__(572);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DialogAllocatingResourcesPlayersTooltip = exports.DialogAllocatingResourcesPlayersTooltip = function DialogAllocatingResourcesPlayersTooltip(_ref) {
    var children = _ref.children;
    return _react2.default.createElement(
        _reactWotBootstrap.Tooltip,
        { id: DialogAllocatingResourcesPlayersTooltip.id },
        _react2.default.createElement(
            _reactWotBootstrap.TooltipBody,
            null,
            _react2.default.createElement(
                _reactWotBootstrap.TooltipSubtitle,
                null,
                _translations.DIALOG_ALLOCATING_RESOURCES_DIVIDE_TO_MEMBERS_TITLE
            ),
            _react2.default.createElement(
                _reactWotBootstrap.LineClamp,
                { lines: _constants.LINE_CLAMP_LINES },
                children
            )
        )
    );
};
DialogAllocatingResourcesPlayersTooltip.id = 'dialog-allocating-resources-players-body';
DialogAllocatingResourcesPlayersTooltip.propTypes = {
    children: _propTypes2.default.node.isRequired
};

/***/ }),
/* 2401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ChangeRoleDialog = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRedux = __webpack_require__(7);

var _reactWotBootstrap = __webpack_require__(5);

var _Dialog = __webpack_require__(284);

var dialogActions = _interopRequireWildcard(_Dialog);

var _MembersOperation = __webpack_require__(128);

var membersOperationActions = _interopRequireWildcard(_MembersOperation);

var _roles = __webpack_require__(49);

var _translations = __webpack_require__(299);

var _translations2 = __webpack_require__(2402);

var _tooltips = __webpack_require__(2403);

var _Dialogs = __webpack_require__(573);

var _Dialogs2 = _interopRequireDefault(_Dialogs);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
    currentMemberRole: _propTypes2.default.string.isRequired,
    selectedMembers: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        id: _propTypes2.default.number.isRequired,
        name: _propTypes2.default.string.isRequired
    })).isRequired,

    selectedRole: _propTypes2.default.string,
    isOpened: _propTypes2.default.bool,

    onSubmit: _propTypes2.default.func.isRequired,
    onClose: _propTypes2.default.func.isRequired,
    onRoleChange: _propTypes2.default.func.isRequired
};

var ChangeRoleDialog = exports.ChangeRoleDialog = function (_React$Component) {
    _inherits(ChangeRoleDialog, _React$Component);

    function ChangeRoleDialog() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ChangeRoleDialog);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ChangeRoleDialog.__proto__ || Object.getPrototypeOf(ChangeRoleDialog)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            isSelectActive: false
        }, _this.onSelectToggled = function (isSelectActive) {
            _this.setState({ isSelectActive: isSelectActive });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ChangeRoleDialog, [{
        key: 'render',
        value: function render() {
            var selectedRole = (0, _roles.getAssignableRole)(this.props.currentMemberRole, this.props.selectedRole);
            var suitableRoleNames = (0, _roles.getAssignableRoles)(this.props.currentMemberRole);

            var selectItems = suitableRoleNames.map(function (roleName) {
                return {
                    value: roleName,
                    caption: (0, _roles.getLocalizedName)(roleName),
                    tooltipId: 'role-tooltip-' + roleName
                };
            });

            var rolesTooltips = suitableRoleNames.map(function (roleName) {
                return _react2.default.createElement(
                    _reactWotBootstrap.Tooltip,
                    { id: 'role-tooltip-' + roleName, key: roleName },
                    _react2.default.createElement(
                        'div',
                        { className: _Dialogs2.default.tooltipContent },
                        _react2.default.createElement(
                            'h3',
                            { className: _Dialogs2.default.tooltipSubtitle },
                            (0, _roles.getLocalizedName)(roleName)
                        ),
                        _react2.default.createElement(
                            'p',
                            { className: _Dialogs2.default.tooltipMessage },
                            _translations2.USER_ROLES_DESCRIPTIONS[roleName]
                        )
                    )
                );
            });

            var members = null;
            var tooltip = null;
            var selectedMembersCount = this.props.selectedMembers.length;
            var isNeedTooltip = selectedMembersCount > 10;
            if (selectedMembersCount === 1) {
                members = _react2.default.createElement(_reactWotBootstrap.MemberName, { name: this.props.selectedMembers[0].name });
            } else if (selectedMembersCount > 1) {
                members = this.props.selectedMembers.map(function (member) {
                    return _react2.default.createElement(_reactWotBootstrap.MemberName, { key: member.id, name: member.name });
                });
                tooltip = isNeedTooltip ? _react2.default.createElement(
                    _tooltips.DialogChangeRolePlayersTooltip,
                    null,
                    members
                ) : null;

                members = isNeedTooltip ? _react2.default.createElement(
                    'span',
                    { className: _Dialogs2.default.membersCount },
                    selectedMembersCount
                ) : _react2.default.createElement(
                    'div',
                    { className: _Dialogs2.default.members },
                    members
                );
            }

            var selectTooltip = this.state.isSelectActive ? null : _react2.default.createElement(_tooltips.DialogChangeRoleSelectTooltip, null);

            return _react2.default.createElement(
                _reactWotBootstrap.Dialog,
                {
                    title: _translations2.DIALOG_CHANGE_ROLE_TITLE,
                    submitCaption: _translations2.DIALOG_CHANGE_ROLE_SUBMIT_BUTTON_CAPTION,
                    closeCaption: _translations.DIALOG_BUTTON_CANCEL_CAPTION,
                    isOpened: this.props.isOpened,
                    isFocusOnSubmitBtn: true,
                    onSubmit: this.props.onSubmit,
                    onClose: this.props.onClose
                },
                _react2.default.createElement(
                    'div',
                    { className: _Dialogs2.default.base },
                    _react2.default.createElement(
                        'div',
                        {
                            className: _Dialogs2.default.header,
                            'data-tip': isNeedTooltip,
                            'data-for': isNeedTooltip ? _tooltips.DialogChangeRolePlayersTooltip.id : null
                        },
                        selectedMembersCount > 1 ? _translations2.DIALOG_CHANGE_ROLE_MEMBERS_TITLE : _translations2.DIALOG_CHANGE_ROLE_MEMBER_TITLE,
                        '\u2002',
                        members,
                        tooltip
                    ),
                    _react2.default.createElement('div', { className: _Dialogs2.default.divider }),
                    _react2.default.createElement(
                        'div',
                        { className: _Dialogs2.default.body },
                        _react2.default.createElement(
                            'div',
                            { className: _Dialogs2.default.row },
                            _react2.default.createElement(
                                'div',
                                { className: (0, _classnames2.default)(_Dialogs2.default.caption, _Dialogs2.default['caption__changeRole']) },
                                _translations2.DIALOG_CHANGE_ROLE_NEW_ROLE_TITLE
                            ),
                            _react2.default.createElement(_reactWotBootstrap.Select, {
                                width: 190,
                                items: selectItems,
                                selectedItem: selectedRole,
                                tooltipId: this.state.isSelectActive ? null : _tooltips.DialogChangeRoleSelectTooltip.id,
                                onItemChange: this.props.onRoleChange,
                                onToggled: this.onSelectToggled
                            }),
                            selectTooltip,
                            rolesTooltips
                        )
                    )
                )
            );
        }
    }]);

    return ChangeRoleDialog;
}(_react2.default.Component);

ChangeRoleDialog.propTypes = propTypes;

var mapStateToProps = function mapStateToProps(state, ownProps) {
    var members = state.members.members;
    var currentMember = members.find(function (member) {
        return member.id === state.account.id;
    });
    var selectedMembers = ownProps.selectedMembers || members.filter(function (member) {
        return state.membersOperation.selectedIds.includes(member.id);
    });
    return {
        currentMemberRole: currentMember.role,
        selectedMembers: selectedMembers,
        selectedRole: state.membersOperation.selectedRole
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
    return {
        onSubmit: ownProps.onSubmit,
        onClose: function onClose() {
            return dispatch(dialogActions.hideDialog());
        },
        onRoleChange: function onRoleChange(roleName) {
            return dispatch(membersOperationActions.selectRoleMembersOperation(roleName));
        }
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ChangeRoleDialog);

/***/ }),
/* 2402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.USER_ROLES_DESCRIPTIONS = exports.DIALOG_CHANGE_ROLE_NEW_ROLE_TITLE = exports.DIALOG_CHANGE_ROLE_MEMBERS_TITLE = exports.DIALOG_CHANGE_ROLE_MEMBER_TITLE = exports.DIALOG_CHANGE_ROLE_SUBMIT_BUTTON_CAPTION = exports.DIALOG_CHANGE_ROLE_TITLE = undefined;

var _USER_ROLES_DESCRIPTI;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _constants = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint-disable max-len */


var DIALOG_CHANGE_ROLE_TITLE = exports.DIALOG_CHANGE_ROLE_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'members_control_block.dialog.change_role.title',
    defaultMessage: '\u0418\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0435 \u0434\u043E\u043B\u0436\u043D\u043E\u0441\u0442\u0438'
});

var DIALOG_CHANGE_ROLE_SUBMIT_BUTTON_CAPTION = exports.DIALOG_CHANGE_ROLE_SUBMIT_BUTTON_CAPTION = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'members_control_block.dialog.change_role.submit_button.caption',
    defaultMessage: '\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C'
});

var DIALOG_CHANGE_ROLE_MEMBER_TITLE = exports.DIALOG_CHANGE_ROLE_MEMBER_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'members_control_block.dialog.change_role.member.title',
    defaultMessage: '\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0434\u043E\u043B\u0436\u043D\u043E\u0441\u0442\u044C \u0438\u0433\u0440\u043E\u043A\u0443:'
});

var DIALOG_CHANGE_ROLE_MEMBERS_TITLE = exports.DIALOG_CHANGE_ROLE_MEMBERS_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'members_control_block.dialog.change_role.members.title',
    defaultMessage: '\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0434\u043E\u043B\u0436\u043D\u043E\u0441\u0442\u044C \u0438\u0433\u0440\u043E\u043A\u043E\u0432:'
});

var DIALOG_CHANGE_ROLE_NEW_ROLE_TITLE = exports.DIALOG_CHANGE_ROLE_NEW_ROLE_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'members_control_block.dialog.change_role.new_role.title',
    defaultMessage: '\u041D\u043E\u0432\u0430\u044F \u0434\u043E\u043B\u0436\u043D\u043E\u0441\u0442\u044C:'
});

var CONTROL_LOWER_ROLES = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'roles_permissions.control_lower_roles',
    defaultMessage: '\u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u043B\u0438\u0447\u043D\u044B\u043C \u0441\u043E\u0441\u0442\u0430\u0432\u043E\u043C \u043D\u0438\u0436\u0435 \u043F\u043E \u0440\u0430\u043D\u0433\u0443 (\u043A\u0440\u043E\u043C\u0435 \u041E\u0444\u0438\u0446\u0435\u0440\u0430 \u0441\u043D\u0430\u0431\u0436\u0435\u043D\u0438\u044F);'
});
var ADD_NEW_PLAYERS = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'roles_permissions.add_new_players',
    defaultMessage: '\u043D\u0430\u0431\u043E\u0440 \u0438\u0433\u0440\u043E\u043A\u043E\u0432 \u0432 \u043A\u043B\u0430\u043D;'
});
var ACTIVATE_RESERVES = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'roles_permissions.activate_reserves',
    defaultMessage: '\u0430\u043A\u0442\u0438\u0432\u0430\u0446\u0438\u044F \u0440\u0435\u0437\u0435\u0440\u0432\u043E\u0432;'
});
var PREPARE_RESERVES = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'roles_permissions.prepare_reserves',
    defaultMessage: '\u043F\u043E\u0434\u0433\u043E\u0442\u043E\u0432\u043A\u0430 \u0440\u0435\u0437\u0435\u0440\u0432\u043E\u0432;'
});
var GLOBAL_MAP = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'roles_permissions.global_map',
    defaultMessage: '\u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u043A\u043B\u0430\u043D\u043E\u043C \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435.'
});
var VIEW_GLOBAL_MAP = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'roles_permissions.view_global_map',
    defaultMessage: '\u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440 \u0442\u0430\u043A\u0442\u0438\u0447\u0435\u0441\u043A\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u043E \u043A\u043B\u0430\u043D\u0435 \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435.'
});
var VIEW_TREASURY = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'roles_permissions.view_treasury',
    defaultMessage: '\u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440 \u043A\u0430\u0437\u043D\u044B \u043A\u043B\u0430\u043D\u0430;'
});
var RECIEVE_RESERVE_BONUS = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'roles_permissions.recieve_reserve_bonus',
    defaultMessage: '\u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435 \u043D\u0430\u0434\u0431\u0430\u0432\u043A\u0438 \u043E\u0442 \u043A\u043B\u0430\u043D\u043E\u0432\u044B\u0445 \u0440\u0435\u0437\u0435\u0440\u0432\u043E\u0432;'
});

var USER_ROLES_DESCRIPTIONS = exports.USER_ROLES_DESCRIPTIONS = (_USER_ROLES_DESCRIPTI = {}, _defineProperty(_USER_ROLES_DESCRIPTI, _constants.USER_ROLES.COMMANDER, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'roles_descriptions.commander',
    defaultMessage: '\u0413\u043B\u0430\u0432\u0430 \u043A\u043B\u0430\u043D\u0430. \u041E\u0431\u043B\u0430\u0434\u0430\u0435\u0442 \u0432\u0441\u0435\u043C\u0438 \u043F\u0440\u0430\u0432\u0430\u043C\u0438 \u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u043A\u043B\u0430\u043D\u043E\u043C \u0438 \u0432\u0441\u0435\u043C \u0435\u0433\u043E \u0438\u043C\u0443\u0449\u0435\u0441\u0442\u0432\u043E\u043C, \u0430 \u0442\u0430\u043A\u0436\u0435 \u043B\u0438\u0447\u043D\u044B\u043C \u0441\u043E\u0441\u0442\u0430\u0432\u043E\u043C.'
})), _defineProperty(_USER_ROLES_DESCRIPTI, _constants.USER_ROLES.EXECUTIVE_OFFICER, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'roles_descriptions.executive_officer',
    defaultMessage: '\u041F\u0435\u0440\u0432\u044B\u0439 \u043F\u043E\u043C\u043E\u0449\u043D\u0438\u043A \u043A\u043E\u043C\u0430\u043D\u0434\u0443\u044E\u0449\u0435\u0433\u043E. \u041E\u0431\u043B\u0430\u0434\u0430\u0435\u0442 \u043E\u0441\u043D\u043E\u0432\u043D\u044B\u043C\u0438 \u043F\u043E\u043B\u043D\u043E\u043C\u043E\u0447\u0438\u044F\u043C\u0438 \u043A\u043E\u043C\u0430\u043D\u0434\u0443\u044E\u0449\u0435\u0433\u043E, \u0443\u043F\u0440\u0430\u0432\u043B\u044F\u0435\u0442 \u043B\u0438\u0447\u043D\u044B\u043C \u0441\u043E\u0441\u0442\u0430\u0432\u043E\u043C \u043D\u0438\u0436\u0435 \u043F\u043E \u0440\u0430\u043D\u0433\u0443.'
})), _defineProperty(_USER_ROLES_DESCRIPTI, _constants.USER_ROLES.PERSONNEL_OFFICER, _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
        'p',
        null,
        _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'roles_descriptions.personnel_officer',
            defaultMessage: '\u041F\u043E\u043C\u043E\u0449\u043D\u0438\u043A \u043A\u043E\u043C\u0430\u043D\u0434\u0443\u044E\u0449\u0435\u0433\u043E \u0441\u043E \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u043C\u0438 \u043F\u043E\u043B\u043D\u043E\u043C\u043E\u0447\u0438\u044F\u043C\u0438:'
        })
    ),
    _react2.default.createElement(
        'ul',
        null,
        _react2.default.createElement(
            'li',
            null,
            CONTROL_LOWER_ROLES
        ),
        _react2.default.createElement(
            'li',
            null,
            ADD_NEW_PLAYERS
        ),
        _react2.default.createElement(
            'li',
            null,
            PREPARE_RESERVES
        ),
        _react2.default.createElement(
            'li',
            null,
            ACTIVATE_RESERVES
        ),
        _react2.default.createElement(
            'li',
            null,
            GLOBAL_MAP
        )
    )
)), _defineProperty(_USER_ROLES_DESCRIPTI, _constants.USER_ROLES.COMBAT_OFFICER, _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
        'p',
        null,
        _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'roles_descriptions.combat_officer',
            defaultMessage: '\u041A\u043E\u043C\u0430\u043D\u0434\u0438\u0440 \u043D\u0430 \u043F\u043E\u043B\u0435 \u0431\u043E\u044F. \u041E\u0431\u043B\u0430\u0434\u0430\u0435\u0442 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u043C\u0438 \u043F\u043E\u043B\u043D\u043E\u043C\u043E\u0447\u0438\u044F\u043C\u0438:'
        })
    ),
    _react2.default.createElement(
        'ul',
        null,
        _react2.default.createElement(
            'li',
            null,
            CONTROL_LOWER_ROLES
        ),
        _react2.default.createElement(
            'li',
            null,
            ACTIVATE_RESERVES
        ),
        _react2.default.createElement(
            'li',
            null,
            GLOBAL_MAP
        )
    )
)), _defineProperty(_USER_ROLES_DESCRIPTI, _constants.USER_ROLES.INTELLIGENCE_OFFICER, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'roles_descriptions.intelligence_officer',
    defaultMessage: '\u0411\u043E\u0435\u0446, \u0437\u0430\u0441\u043B\u0443\u0436\u0438\u0432\u0448\u0438\u0439 \u043F\u0440\u0438\u0437\u043D\u0430\u043D\u0438\u044F \u043A\u043B\u0430\u043D\u0430 \u0438 \u0443\u0434\u043E\u0441\u0442\u043E\u0435\u043D\u043D\u044B\u0439 \u043E\u0444\u0438\u0446\u0435\u0440\u0441\u043A\u043E\u0433\u043E \u0437\u0432\u0430\u043D\u0438\u044F.'
})), _defineProperty(_USER_ROLES_DESCRIPTI, _constants.USER_ROLES.QUARTERMASTER, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'roles_descriptions.quartermaster',
    defaultMessage: '\u041E\u0444\u0438\u0446\u0435\u0440 \u043A\u043B\u0430\u043D\u0430 \u0441 \u043F\u043E\u043B\u043D\u043E\u043C\u043E\u0447\u0438\u044F\u043C\u0438 \u0440\u0430\u0441\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u044F \u043A\u0430\u0437\u043D\u044B \u043A\u043B\u0430\u043D\u0430.'
})), _defineProperty(_USER_ROLES_DESCRIPTI, _constants.USER_ROLES.RECRUITMENT_OFFICER, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'roles_descriptions.recruitment_officer',
    defaultMessage: '\u041E\u0444\u0438\u0446\u0435\u0440 \u043A\u043B\u0430\u043D\u0430, \u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0439 \u0437\u0430 \u043D\u0430\u0431\u043E\u0440 \u0438\u0433\u0440\u043E\u043A\u043E\u0432 \u0432 \u043A\u043B\u0430\u043D.'
})), _defineProperty(_USER_ROLES_DESCRIPTI, _constants.USER_ROLES.JUNIOR_OFFICER, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'roles_descriptions.junior_officer',
    defaultMessage: '\u0411\u043E\u0435\u0446, \u0437\u0430\u0441\u043B\u0443\u0436\u0438\u0432\u0448\u0438\u0439 \u043F\u043E\u0447\u0442\u0435\u043D\u0438\u0435 \u0441\u043E\u043A\u043B\u0430\u043D\u043E\u0432\u0446\u0435\u0432.'
})), _defineProperty(_USER_ROLES_DESCRIPTI, _constants.USER_ROLES.PRIVATE, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'roles_descriptions.private',
    defaultMessage: '\u0418\u0433\u0440\u043E\u043A \u043A\u043B\u0430\u043D\u0430 \u0431\u0435\u0437 \u043E\u0441\u043E\u0431\u044B\u0445 \u043F\u043E\u043B\u043D\u043E\u043C\u043E\u0447\u0438\u0439, \u043D\u043E \u0438 \u0431\u0435\u0437 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u0439.'
})), _defineProperty(_USER_ROLES_DESCRIPTI, _constants.USER_ROLES.RECRUIT, _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
        'p',
        null,
        _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'roles_descriptions.recruit',
            defaultMessage: '\u0418\u0433\u0440\u043E\u043A \u043A\u043B\u0430\u043D\u0430 \u0431\u0435\u0437 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0445 \u043F\u0440\u0430\u0432:'
        })
    ),
    _react2.default.createElement(
        'ul',
        null,
        _react2.default.createElement(
            'li',
            null,
            VIEW_TREASURY
        ),
        _react2.default.createElement(
            'li',
            null,
            VIEW_GLOBAL_MAP
        )
    )
)), _defineProperty(_USER_ROLES_DESCRIPTI, _constants.USER_ROLES.RESERVIST, _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
        'p',
        null,
        _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'roles_descriptions.reservist',
            defaultMessage: '\u0418\u0433\u0440\u043E\u043A \u043A\u043B\u0430\u043D\u0430 \u0431\u0435\u0437 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0445 \u043F\u0440\u0430\u0432:'
        })
    ),
    _react2.default.createElement(
        'ul',
        null,
        _react2.default.createElement(
            'li',
            null,
            RECIEVE_RESERVE_BONUS
        ),
        _react2.default.createElement(
            'li',
            null,
            VIEW_TREASURY
        ),
        _react2.default.createElement(
            'li',
            null,
            VIEW_GLOBAL_MAP
        )
    )
)), _USER_ROLES_DESCRIPTI);

/***/ }),
/* 2403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DialogChangeRoleSelectTooltip = exports.DialogChangeRolePlayersTooltip = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _reactWotBootstrap = __webpack_require__(5);

var _constants = __webpack_require__(572);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DialogChangeRolePlayersTooltip = exports.DialogChangeRolePlayersTooltip = function DialogChangeRolePlayersTooltip(_ref) {
    var children = _ref.children;
    return _react2.default.createElement(
        _reactWotBootstrap.Tooltip,
        { id: DialogChangeRolePlayersTooltip.id },
        _react2.default.createElement(
            _reactWotBootstrap.TooltipBody,
            null,
            _react2.default.createElement(
                _reactWotBootstrap.TooltipSubtitle,
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'clanmanagement.tooltips.dialog_change_roles_players_header',
                    defaultMessage: '\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0434\u043E\u043B\u0436\u043D\u043E\u0441\u0442\u0438 \u0438\u0433\u0440\u043E\u043A\u0430\u043C:'
                })
            ),
            _react2.default.createElement(
                _reactWotBootstrap.LineClamp,
                { lines: _constants.LINE_CLAMP_LINES },
                children
            )
        )
    );
}; /* eslint-disable react/no-multi-comp */

DialogChangeRolePlayersTooltip.id = 'dialog-change-role-players-body';
DialogChangeRolePlayersTooltip.propTypes = {
    children: _propTypes2.default.node.isRequired
};

var DialogChangeRoleSelectTooltip = exports.DialogChangeRoleSelectTooltip = function DialogChangeRoleSelectTooltip() {
    return _react2.default.createElement(
        _reactWotBootstrap.Tooltip,
        { id: DialogChangeRoleSelectTooltip.id },
        _react2.default.createElement(
            _reactWotBootstrap.TooltipBody,
            null,
            _react2.default.createElement(
                _reactWotBootstrap.TooltipSubtitle,
                null,
                _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: 'clanmanagement.tooltips.dialog_change_role_select_header',
                    defaultMessage: '\u041D\u043E\u0432\u0430\u044F \u0434\u043E\u043B\u0436\u043D\u043E\u0441\u0442\u044C'
                })
            ),
            _react2.default.createElement(_reactIntl.FormattedMessage, {
                id: 'clanmanagement.tooltips.dialog_change_role_select_body',
                defaultMessage: '\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0434\u043E\u043B\u0436\u043D\u043E\u0441\u0442\u044C, \u043D\u0430 \u043A\u043E\u0442\u043E\u0440\u0443\u044E \u0431\u0443\u0434\u0443\u0442 \u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u044B \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0435 \u0438\u0433\u0440\u043E\u043A\u0438.'
            })
        )
    );
};
DialogChangeRoleSelectTooltip.id = 'dialog-change-role-select-tooltip';

/***/ }),
/* 2404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
    dialog: _propTypes2.default.node
};

var DialogWrapper = function DialogWrapper(_ref) {
    var dialog = _ref.dialog;
    return _react2.default.createElement(
        'div',
        null,
        dialog
    );
};

DialogWrapper.propTypes = propTypes;

exports.default = DialogWrapper;

/***/ }),
/* 2405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(7);

var _debounce = __webpack_require__(304);

var _debounce2 = _interopRequireDefault(_debounce);

var _ClanManagement = __webpack_require__(102);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UpdateMembersStatusesManager = function (_React$Component) {
    _inherits(UpdateMembersStatusesManager, _React$Component);

    function UpdateMembersStatusesManager(props) {
        _classCallCheck(this, UpdateMembersStatusesManager);

        var _this = _possibleConstructorReturn(this, (UpdateMembersStatusesManager.__proto__ || Object.getPrototypeOf(UpdateMembersStatusesManager)).call(this, props));

        _this.currentDebounceWait = null;
        _this.updateMembersStatuses = _this.updateMembersStatuses.bind(_this);
        _this.updateMembersStatusesDebounce = _this.createUpdateMembersStatusesDebounce();
        return _this;
    }

    _createClass(UpdateMembersStatusesManager, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.updateMembersStatusesDebounce();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.updateMembersStatusesDebounce.cancel();
        }
    }, {
        key: 'createUpdateMembersStatusesDebounce',
        value: function createUpdateMembersStatusesDebounce(wait) {
            wait = wait || UpdateMembersStatusesManager.updateTimeout;
            if (this.currentDebounceWait === wait && this.updateMembersStatusesDebounce) {
                return this.updateMembersStatusesDebounce;
            }

            this.currentDebounceWait = wait;
            return (0, _debounce2.default)(this.updateMembersStatuses, wait);
        }
    }, {
        key: 'updateMembersStatuses',
        value: function updateMembersStatuses() {
            if (!this.props.updateMembersAt) return;

            var now = new Date();
            var timeFromLastUpdate = now.getTime() - this.props.updateMembersAt.getTime();
            var wait = UpdateMembersStatusesManager.updateTimeout - timeFromLastUpdate;
            this.updateMembersStatusesDebounce = this.createUpdateMembersStatusesDebounce(wait > 0 ? wait : void 0);

            if (wait > 0 || this.props.isFetching || this.props.isError || this.props.membersCount === 0) {
                this.updateMembersStatusesDebounce();
                return;
            }

            this.props.fetchMembersStatuses().then(this.updateMembersStatusesDebounce).catch(this.updateMembersStatusesDebounce);
        }
    }, {
        key: 'render',
        value: function render() {
            return null;
        }
    }]);

    return UpdateMembersStatusesManager;
}(_react2.default.Component);

UpdateMembersStatusesManager.updateTimeout = 30 * 1000;
UpdateMembersStatusesManager.propTypes = {
    isError: _propTypes2.default.bool.isRequired,
    isFetching: _propTypes2.default.bool.isRequired,
    membersCount: _propTypes2.default.number.isRequired,
    updateMembersAt: _propTypes2.default.instanceOf(Date),

    fetchMembersStatuses: _propTypes2.default.func.isRequired
};


var mapStateToProps = function mapStateToProps(state) {
    return {
        isError: state.clanManagement.isError,
        isFetching: state.clanManagement.fetchingCounter > 0 || state.fetching.counter > 0,
        membersCount: state.members.members.length,
        updateMembersAt: state.members.updateMembersAt
    };
};

var mapDispatchToProps = {
    fetchMembersStatuses: _ClanManagement.fetchMembersStatuses
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UpdateMembersStatusesManager);

/***/ }),
/* 2406 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"ClanManagement_base--1wZLx"};

/***/ }),
/* 2407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(7);

var _reactRouterRedux = __webpack_require__(15);

var _reactWotBootstrap = __webpack_require__(5);

var _constants = __webpack_require__(4);

var _urls = __webpack_require__(19);

var _MembersOperation = __webpack_require__(128);

var _constants2 = __webpack_require__(2408);

var _ClanLeavingLayout = __webpack_require__(2409);

var _ClanLeavingLayout2 = _interopRequireDefault(_ClanLeavingLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ClanLeaving = function ClanLeaving() {
    var dispatch = (0, _reactRedux.useDispatch)();

    var _useSelector = (0, _reactRedux.useSelector)(function (state) {
        return state;
    }),
        clan = _useSelector.clan,
        clanManagement = _useSelector.clanManagement;

    var _useSelector2 = (0, _reactRedux.useSelector)(function (state) {
        return {
            clanEntranceCooldown: state.settings.clanEntranceCooldown
        };
    }),
        clanEntranceCooldown = _useSelector2.clanEntranceCooldown;

    var isFetchingVisible = clanManagement.fetchingCounter > 0;

    var handleLeaveClan = (0, _react.useCallback)(function (reasons) {
        dispatch((0, _MembersOperation.leaveClan)(reasons));
    }, []);

    var openClanManagement = (0, _react.useCallback)(function () {
        dispatch((0, _reactRouterRedux.push)(_urls.CLAN_MANAGEMENT));
    }, []);

    (0, _react.useEffect)(function () {
        var onKeyDown = function onKeyDown(e) {
            if (e.keyCode === _constants.KEY_CODES.ESCAPE) {
                e.stopPropagation();
                openClanManagement();
            }
        };

        document.documentElement.addEventListener('keydown', onKeyDown, false);

        return function () {
            document.documentElement.removeEventListener('keydown', onKeyDown, false);
        };
    }, [openClanManagement]);

    return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(_ClanLeavingLayout2.default, {
            clan: clan,
            leaveClan: handleLeaveClan,
            openClanManagement: openClanManagement,
            clanEntranceCooldown: clanEntranceCooldown
        }),
        _react2.default.createElement(_reactWotBootstrap.Processing, { type: 'window', caption: _constants2.LEAVING_CLAN_LOADER, isVisible: isFetchingVisible })
    );
};

ClanLeaving.propTypes = {
    clan: _propTypes2.default.shape({
        color: _propTypes2.default.string,
        emblem: _propTypes2.default.string.isRequired,
        id: _propTypes2.default.number.isRequired,
        isClanAcceptableForAutoJoining: _propTypes2.default.bool.isRequired,
        isRecruitingOpened: _propTypes2.default.bool.isRequired,
        languages: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
        membersCount: _propTypes2.default.number.isRequired,
        name: _propTypes2.default.string.isRequired,
        strongholdLevel: _propTypes2.default.number.isRequired,
        tag: _propTypes2.default.string.isRequired,
        clanEntranceCooldown: _propTypes2.default.number.isRequired
    })
};

exports.default = ClanLeaving;

/***/ }),
/* 2408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LEAVING_CLAN_LOADER = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-multi-comp */

var LEAVING_CLAN_LOADER = exports.LEAVING_CLAN_LOADER = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'clan_leaving.layout.leaving_clan_loader', defaultMessage: '\u0412\u044B\u0445\u043E\u0434 \u0438\u0437 \u043A\u043B\u0430\u043D\u0430...' });

/***/ }),
/* 2409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactWotBootstrap = __webpack_require__(5);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _sounds = __webpack_require__(177);

var _sounds2 = _interopRequireDefault(_sounds);

var _Reasons = __webpack_require__(2410);

var _Reasons2 = _interopRequireDefault(_Reasons);

var _constants = __webpack_require__(2415);

var _ClanLeavingLayout = __webpack_require__(2416);

var _ClanLeavingLayout2 = _interopRequireDefault(_ClanLeavingLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ClanLeavingLayout = function ClanLeavingLayout(_ref) {
    var clan = _ref.clan,
        leaveClan = _ref.leaveClan,
        openClanManagement = _ref.openClanManagement,
        clanEntranceCooldown = _ref.clanEntranceCooldown;

    var _useState = (0, _react.useState)([]),
        _useState2 = _slicedToArray(_useState, 2),
        reasons = _useState2[0],
        setReasons = _useState2[1];

    var handleChangeReasons = (0, _react.useCallback)(function (value) {
        setReasons(value);
    }, []);

    return _react2.default.createElement(
        'div',
        { className: _ClanLeavingLayout2.default.base },
        _react2.default.createElement(
            'header',
            { className: _ClanLeavingLayout2.default.closeButton },
            _react2.default.createElement(_reactWotBootstrap.Back, { caption: _constants.CLOSE_BUTTON, type: 'close', side: 'right', onClick: openClanManagement })
        ),
        _react2.default.createElement(
            'main',
            { className: _ClanLeavingLayout2.default.main },
            _react2.default.createElement(
                'div',
                { className: _ClanLeavingLayout2.default.title },
                _constants.LEAVING_CLAN,
                _react2.default.createElement(
                    'span',
                    { style: { color: clan.color } },
                    ' [' + clan.tag + ']'
                )
            ),
            _react2.default.createElement(_Reasons2.default, { onChange: handleChangeReasons }),
            _react2.default.createElement(
                'div',
                { className: _ClanLeavingLayout2.default.warning },
                _react2.default.createElement(_reactWotBootstrap.Icon, { glyph: 'warning' }),
                _react2.default.createElement(
                    'div',
                    { className: _ClanLeavingLayout2.default.warningText },
                    (0, _constants.COOLDOWN)(Math.floor(clanEntranceCooldown / 3600))
                )
            ),
            _react2.default.createElement(
                'div',
                { className: _ClanLeavingLayout2.default.buttons },
                _react2.default.createElement(
                    _reactWotBootstrap.Button,
                    { mixClassName: (0, _classnames2.default)(_ClanLeavingLayout2.default.button, _ClanLeavingLayout2.default.button__leaving), onClick: function onClick() {
                            leaveClan(reasons);
                        }
                    },
                    _constants.LEAVING_BUTTON
                ),
                _react2.default.createElement(
                    _reactWotBootstrap.Button,
                    {
                        mixClassName: _ClanLeavingLayout2.default.button,
                        type: 'secondary',
                        onClick: openClanManagement,
                        buttonClickSoundId: _sounds2.default.CLICK
                    },
                    _constants.CANCEL_BUTTON
                )
            )
        )
    );
};

ClanLeavingLayout.propTypes = {
    clan: _propTypes2.default.shape({
        color: _propTypes2.default.string,
        emblem: _propTypes2.default.string.isRequired,
        id: _propTypes2.default.number.isRequired,
        isClanAcceptableForAutoJoining: _propTypes2.default.bool.isRequired,
        isRecruitingOpened: _propTypes2.default.bool.isRequired,
        languages: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
        membersCount: _propTypes2.default.number.isRequired,
        name: _propTypes2.default.string.isRequired,
        strongholdLevel: _propTypes2.default.number.isRequired,
        tag: _propTypes2.default.string.isRequired
    }),
    leaveClan: _propTypes2.default.func.isRequired,
    openClanManagement: _propTypes2.default.func.isRequired,
    clanEntranceCooldown: _propTypes2.default.number.isRequired
};

exports.default = ClanLeavingLayout;

/***/ }),
/* 2410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ReasonItem = __webpack_require__(2411);

var _ReasonItem2 = _interopRequireDefault(_ReasonItem);

var _constants = __webpack_require__(2413);

var _Reasons = __webpack_require__(2414);

var _Reasons2 = _interopRequireDefault(_Reasons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Reasons = function Reasons(_ref) {
    var _ref$onChange = _ref.onChange,
        onChange = _ref$onChange === undefined ? function () {} : _ref$onChange;

    var numberOfReasons = Object.keys(_constants.REASONS).length - 1;

    var _useState = (0, _react.useState)([]),
        _useState2 = _slicedToArray(_useState, 2),
        checked = _useState2[0],
        setChecked = _useState2[1];

    var _useState3 = (0, _react.useState)(Array(numberOfReasons).fill(null).map(function () {
        return Math.random() * numberOfReasons;
    }).concat(numberOfReasons + 1)),
        _useState4 = _slicedToArray(_useState3, 1),
        orders = _useState4[0];

    (0, _react.useEffect)(function () {
        onChange(checked);
    }, [checked]);

    var generateReasons = function generateReasons() {
        return Object.keys(_constants.REASONS).map(function (reason, index) {
            return { order: orders[index], value: _constants.REASONS[reason], text: _constants.REASONS_TEXT[reason] };
        }).sort(function (a, b) {
            return a.order - b.order;
        });
    };

    return _react2.default.createElement(
        'div',
        { className: _Reasons2.default.base },
        _react2.default.createElement(
            'p',
            { className: _Reasons2.default.question },
            _constants.REASON_QUESTION
        ),
        generateReasons().map(function (reason) {
            function changeReasonCheck() {
                var value = reason.value;
                if (checked.includes(value)) {
                    setChecked(checked.filter(function (reason) {
                        return reason !== value;
                    }));
                } else {
                    setChecked(checked.concat(value));
                }
            }

            return _react2.default.createElement(_ReasonItem2.default, {
                key: reason.value,
                isChecked: checked.includes(reason.value),
                reason: reason.text,
                onChange: changeReasonCheck
            });
        })
    );
};

Reasons.propTypes = {
    onChange: _propTypes2.default.func
};

exports.default = Reasons;

/***/ }),
/* 2411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _ReasonItem = __webpack_require__(2412);

var _ReasonItem2 = _interopRequireDefault(_ReasonItem);

var _reactWotBootstrap = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ReasonItem = function ReasonItem(_ref) {
    var isChecked = _ref.isChecked,
        onChange = _ref.onChange,
        _ref$reason = _ref.reason,
        reason = _ref$reason === undefined ? '' : _ref$reason;
    return _react2.default.createElement(
        'label',
        {
            className: (0, _classnames2.default)(_ReasonItem2.default.base, isChecked && _ReasonItem2.default.isChecked),
            onMouseDown: _reactWotBootstrap.sendTabClickSoundCommand,
            onMouseEnter: _reactWotBootstrap.sendHoverSoundCommand
        },
        _react2.default.createElement('input', { type: 'checkbox', className: _ReasonItem2.default.input, checked: isChecked, onChange: onChange }),
        _react2.default.createElement('span', { className: _ReasonItem2.default.check }),
        _react2.default.createElement(
            'span',
            { className: _ReasonItem2.default.caption },
            reason
        )
    );
};

ReasonItem.propTypes = {
    reason: _propTypes2.default.node,
    isChecked: _propTypes2.default.bool,
    onChange: _propTypes2.default.func.isRequired
};

exports.default = ReasonItem;

/***/ }),
/* 2412 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"ReasonItem_base--1JYrY","input":"ReasonItem_input--2R71q","check":"ReasonItem_check--rWx0s","isChecked":"ReasonItem_isChecked--3_S8c","caption":"ReasonItem_caption--3Obyt"};

/***/ }),
/* 2413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.REASON_QUESTION = exports.REASONS_TEXT = exports.REASONS = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-multi-comp */
var REASONS = exports.REASONS = {
    INACTIVE_CLAN: 'inactive_clan',
    DEMANDING_CLAN: 'demanding_clan',
    TOO_SKILLED_CLAN: 'too_skilled_clan',
    TOO_UNSKILLED_CLAN: 'too_unskilled_clan',
    QUARRELED_WITH_THE_PLAYERS: 'quarreled_with_the_players',
    DONT_PLAN_TO_PLAY_IN_CLAN: 'dont_plan_to_play_in_clan',
    OTHER: 'other'
};

var REASONS_TEXT = exports.REASONS_TEXT = {
    INACTIVE_CLAN: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'clan_leaving.reasons.inactive_clan', defaultMessage: '\u041A\u043B\u0430\u043D \u043D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E \u0430\u043A\u0442\u0438\u0432\u043D\u044B\u0439' }),
    DEMANDING_CLAN: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'clan_leaving.reasons.demanding_clan',
        defaultMessage: '\u041D\u0435 \u043C\u043E\u0433\u0443 \u0443\u0434\u0435\u043B\u044F\u0442\u044C \u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E \u0432\u0440\u0435\u043C\u0435\u043D\u0438 \u044D\u0442\u043E\u043C\u0443 \u043A\u043B\u0430\u043D\u0443'
    }),
    TOO_SKILLED_CLAN: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'clan_leaving.reasons.too_skilled_clan',
        defaultMessage: '\u0412 \u043A\u043B\u0430\u043D\u0435 \u0441\u043B\u0438\u0448\u043A\u043E\u043C \u0432\u044B\u0441\u043E\u043A\u0438\u0439 \u0443\u0440\u043E\u0432\u0435\u043D\u044C \u043C\u0430\u0441\u0442\u0435\u0440\u0441\u0442\u0432\u0430'
    }),
    TOO_UNSKILLED_CLAN: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'clan_leaving.reasons.too_unskilled_clan',
        defaultMessage: '\u0412 \u043A\u043B\u0430\u043D\u0435 \u0441\u043B\u0438\u0448\u043A\u043E\u043C \u043D\u0438\u0437\u043A\u0438\u0439 \u0443\u0440\u043E\u0432\u0435\u043D\u044C \u043C\u0430\u0441\u0442\u0435\u0440\u0441\u0442\u0432\u0430'
    }),
    QUARRELED_WITH_THE_PLAYERS: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'clan_leaving.reasons.quarreled_with_the_players',
        defaultMessage: '\u041D\u0435 \u0441\u043B\u043E\u0436\u0438\u043B\u0438\u0441\u044C \u043E\u0442\u043D\u043E\u0448\u0435\u043D\u0438\u044F \u0432 \u043A\u043B\u0430\u043D\u0435'
    }),
    DONT_PLAN_TO_PLAY_IN_CLAN: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'clan_leaving.reasons.dont_plan_to_play_in_clan',
        defaultMessage: '\u041D\u0435 \u043F\u043B\u0430\u043D\u0438\u0440\u0443\u044E \u0431\u043E\u043B\u044C\u0448\u0435 \u0441\u043E\u0441\u0442\u043E\u044F\u0442\u044C \u0432 \u043A\u0430\u043A\u043E\u043C-\u043B\u0438\u0431\u043E \u043A\u043B\u0430\u043D\u0435'
    }),
    OTHER: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'clan_leaving.reasons.other', defaultMessage: '\u041D\u0435\u0442 \u043F\u043E\u0434\u0445\u043E\u0434\u044F\u0449\u0435\u0433\u043E \u043E\u0442\u0432\u0435\u0442\u0430' })
};

var REASON_QUESTION = exports.REASON_QUESTION = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'clan_leaving.reasons.question', defaultMessage: '\u041F\u043E\u0447\u0435\u043C\u0443 \u0432\u044B \u0440\u0435\u0448\u0438\u043B\u0438 \u043F\u043E\u043A\u0438\u043D\u0443\u0442\u044C \u043A\u043B\u0430\u043D?' });

/***/ }),
/* 2414 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Reasons_base--3yxkL","question":"Reasons_question--3MTMP"};

/***/ }),
/* 2415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CLOSE_BUTTON = exports.CANCEL_BUTTON = exports.LEAVING_BUTTON = exports.JOURNAL_TOOLTIP = exports.COOLDOWN = exports.LEAVING_CLAN = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/no-multi-comp */

var LEAVING_CLAN = exports.LEAVING_CLAN = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'clan_leaving.layout.leaving_clan', defaultMessage: '\u041F\u043E\u043A\u0438\u043D\u0443\u0442\u044C \u043A\u043B\u0430\u043D ' });
var COOLDOWN = exports.COOLDOWN = function COOLDOWN(time) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'clan_leaving.layout.cooldown',
        defaultMessage: '\u041F\u043E\u0441\u043B\u0435 \u0432\u044B\u0445\u043E\u0434\u0430 \u0438\u0437 \u043A\u043B\u0430\u043D\u0430 \u0432\u044B \u0441\u043C\u043E\u0436\u0435\u0442\u0435 \u0432\u0441\u0442\u0443\u043F\u0438\u0442\u044C \u0432 \u043A\u043B\u0430\u043D \u0447\u0435\u0440\u0435\u0437 {time}{nbsp}\u0447.',
        values: {
            time: time,
            nbsp: _react2.default.createElement(
                'span',
                null,
                '\xA0'
            )
        }
    });
};

var JOURNAL_TOOLTIP = exports.JOURNAL_TOOLTIP = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'clan_leaving.layout.journal_tooltip',
    defaultMessage: '\u041D\u0430\u0436\u043C\u0438\u0442\u0435, \u0447\u0442\u043E\u0431\u044B \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u043F\u0440\u043E\u0448\u0435\u0434\u0448\u0438\u0435 \u0441\u043E\u0431\u044B\u0442\u0438\u044F \u0432 \u0423\u043A\u0440\u0435\u043F\u0440\u0430\u0439\u043E\u043D\u0435.'
});

var LEAVING_BUTTON = exports.LEAVING_BUTTON = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'clan_leaving.layout.leaving_button', defaultMessage: '\u041F\u043E\u043A\u0438\u043D\u0443\u0442\u044C \u043A\u043B\u0430\u043D' });

var CANCEL_BUTTON = exports.CANCEL_BUTTON = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'clan_leaving.layout.cancel_button', defaultMessage: '\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C' });

var CLOSE_BUTTON = exports.CLOSE_BUTTON = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'clan_leaving.layout.close_button', defaultMessage: '\u0417\u0410\u041A\u0420\u042B\u0422\u042C' });

/***/ }),
/* 2416 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"ClanLeavingLayout_base--19_zI","closeButton":"ClanLeavingLayout_closeButton--1BrZx","main":"ClanLeavingLayout_main--35C6D","title":"ClanLeavingLayout_title--3GQGX","warning":"ClanLeavingLayout_warning--2UAjQ","warningText":"ClanLeavingLayout_warningText--20NNN","buttons":"ClanLeavingLayout_buttons--3GZQP","button":"ClanLeavingLayout_button--XFI7D","button__leaving":"ClanLeavingLayout_button__leaving--3vXP8","buttonLeaving":"ClanLeavingLayout_button__leaving--3vXP8"};

/***/ }),
/* 2417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.stateToProps = exports.WGCWXWrapper = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(7);

var _reactRouterRedux = __webpack_require__(15);

var _web_to_client = __webpack_require__(12);

var _urls = __webpack_require__(19);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(4);

var _reactWotBootstrap = __webpack_require__(5);

var _constants2 = __webpack_require__(241);

var _InfoButton = __webpack_require__(2418);

var _InfoButton2 = _interopRequireDefault(_InfoButton);

var _MainMenu = __webpack_require__(2420);

var _MainMenu2 = _interopRequireDefault(_MainMenu);

var _craft_machine = __webpack_require__(281);

var _global_map = __webpack_require__(282);

var _wgcwx_shop = __webpack_require__(106);

var _sounds = __webpack_require__(22);

var _WGCWXConfirmation = __webpack_require__(238);

var _WGCWXConfirmation2 = _interopRequireDefault(_WGCWXConfirmation);

var _translations = __webpack_require__(2423);

var _translations2 = __webpack_require__(237);

var _errors = __webpack_require__(2424);

var _errors2 = _interopRequireDefault(_errors);

var _WGCWXWrapper = __webpack_require__(2425);

var _WGCWXWrapper2 = _interopRequireDefault(_WGCWXWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WGCWXWrapper = exports.WGCWXWrapper = function (_React$Component) {
    _inherits(WGCWXWrapper, _React$Component);

    function WGCWXWrapper() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, WGCWXWrapper);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WGCWXWrapper.__proto__ || Object.getPrototypeOf(WGCWXWrapper)).call.apply(_ref, [this].concat(args))), _this), _this.openContentPage = function () {
            if (_this.props.contentUrl) {
                (0, _web_to_client.openOverlayPage)(_this.props.contentUrl);
            }
        }, _this.onKeyDown = function (event) {
            var _this$props = _this.props,
                close = _this$props.close,
                isEscHandlerDisabled = _this$props.isEscHandlerDisabled;

            if (!isEscHandlerDisabled && event.keyCode === _constants.KEY_CODES.ESCAPE) {
                close();
            }
        }, _this.renderError = function () {
            var _this$props2 = _this.props,
                close = _this$props2.close,
                location = _this$props2.location;


            var errorData = function () {
                switch (location) {
                    case _urls.WGCWX_SHOP:
                        return _errors2.default[_errors.ERROR_CODES.PRODUCTS_UNKNOWN_ERROR];
                    case _urls.WGCWX_SHOP_REWARDS:
                        return _errors2.default[_errors.ERROR_CODES.REWARDS_UNKNOWN_ERROR];
                    case _urls.WGCWX_BATTLE_SCHEDULE:
                        return _errors2.default[_errors.ERROR_CODES.BATTLES_UNKNOWN_ERROR];
                    case _urls.WGCWX_LEADERBOARDS:
                        return _errors2.default[_errors.ERROR_CODES.LEADERBOARDS_UNKNOWN_ERROR];
                }
            }();

            var title = errorData.title,
                description = errorData.description;

            var errorClassNames = (0, _classnames2.default)(_WGCWXWrapper2.default.base, _WGCWXWrapper2.default.base__overlayOpened);

            return _react2.default.createElement(
                'div',
                { className: errorClassNames },
                _react2.default.createElement('div', { className: _WGCWXWrapper2.default.background }),
                _react2.default.createElement(_WGCWXConfirmation2.default, {
                    messageType: 'error',
                    title: title,
                    description: description,
                    buttonsOptions: [{
                        caption: _translations2.AFFIRMATIVE,
                        callback: function callback() {
                            return close();
                        }
                    }],
                    onClose: function onClose() {
                        return close();
                    }
                })
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(WGCWXWrapper, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            window.addEventListener('keydown', this.onKeyDown);
            this.props.onComponentDidMount(this.props);
            window.onBeforeUnloadHandlers.playGlobalMapSoundsOnExit = function () {
                _this2.props.playExitGlobalMapSound();
            };
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('keydown', this.onKeyDown);
            this.props.playExitGlobalMapSound();
            delete window.onBeforeUnloadHandlers.playGlobalMapSoundsOnExit;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                loaded = _props.loaded,
                isMenuAvailable = _props.isMenuAvailable,
                contentUrl = _props.contentUrl,
                close = _props.close,
                children = _props.children,
                error = _props.error;


            if (error) {
                return this.renderError();
            }

            if (!loaded) return _react2.default.createElement(_reactWotBootstrap.Processing, { type: 'fullscreen', isVisible: true });

            return _react2.default.createElement(
                'div',
                null,
                contentUrl && _react2.default.createElement(
                    'div',
                    { className: _WGCWXWrapper2.default.about },
                    _react2.default.createElement(_InfoButton2.default, {
                        caption: _translations.ABOUT,
                        onClick: this.openContentPage
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: _WGCWXWrapper2.default.close },
                    _react2.default.createElement(_reactWotBootstrap.Back, {
                        side: 'right',
                        type: 'close',
                        caption: _constants2.BACK_CAPTIONS.close,
                        onClick: close
                    })
                ),
                isMenuAvailable && _react2.default.createElement(_MainMenu2.default, null),
                children
            );
        }
    }]);

    return WGCWXWrapper;
}(_react2.default.Component);

WGCWXWrapper.propTypes = {
    loaded: _propTypes2.default.bool.isRequired,
    // eslint-disable-next-line react/no-unused-prop-types
    isGlobalMapInfoLoaded: _propTypes2.default.bool.isRequired,
    contentUrl: _propTypes2.default.string,
    isMenuAvailable: _propTypes2.default.bool.isRequired,
    isEscHandlerDisabled: _propTypes2.default.bool.isRequired,

    onComponentDidMount: _propTypes2.default.func.isRequired,
    close: _propTypes2.default.func.isRequired,
    playExitGlobalMapSound: _propTypes2.default.func.isRequired,
    location: _propTypes2.default.string,
    error: _propTypes2.default.bool
};
var stateToProps = exports.stateToProps = function stateToProps(state) {
    return function (_ref2) {
        var craftMachine = _ref2.craftMachine,
            globalMap = _ref2.globalMap,
            wgcwxShop = _ref2.wgcwxShop,
            wgcwxClanInfo = _ref2.wgcwxClanInfo;

        var loaded = globalMap.loaded && craftMachine.loaded && wgcwxClanInfo.loaded;

        var menuItemsArr = [craftMachine.is_craft_machine_enabled, craftMachine.is_enhancements_enabled, globalMap.personal_bonuses_enabled, globalMap.event_rewards_enabled, globalMap.battle_schedule_enabled, globalMap.leaderboards_enabled];
        var isMenuAvailable = menuItemsArr.filter(function (item) {
            return item;
        }).length > 1;

        var isEscHandlerDisabled = wgcwxShop.innerPageOpened;

        return {
            loaded: loaded,
            isGlobalMapInfoLoaded: globalMap.loaded,
            contentUrl: craftMachine.webbrg_content_url,
            isMenuAvailable: isMenuAvailable,
            isEscHandlerDisabled: isEscHandlerDisabled,
            error: globalMap.error,
            location: state.routing.locationBeforeTransitions.pathname
        };
    };
};

var dispatchToProps = function dispatchToProps(dispatch) {
    return {
        onComponentDidMount: function onComponentDidMount(props) {
            if (!props.isGlobalMapInfoLoaded) {
                dispatch((0, _global_map.requestGlobalMapInfo)());
            }

            dispatch((0, _craft_machine.requestCraftMachineInfo)());
            dispatch((0, _wgcwx_shop.fetchClanInfo)());
        },
        close: function close() {
            return dispatch((0, _reactRouterRedux.push)(_urls.CLAN_LANDING));
        },
        playExitGlobalMapSound: function playExitGlobalMapSound() {
            return dispatch((0, _sounds.playExitGlobalMapSound)());
        }
    };
};

exports.default = (0, _reactRedux.connect)(stateToProps, dispatchToProps)(WGCWXWrapper);

/***/ }),
/* 2418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _web_to_client = __webpack_require__(17);

var _InfoButton = __webpack_require__(2419);

var _InfoButton2 = _interopRequireDefault(_InfoButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InfoButton = function (_PureComponent) {
    _inherits(InfoButton, _PureComponent);

    function InfoButton() {
        _classCallCheck(this, InfoButton);

        return _possibleConstructorReturn(this, (InfoButton.__proto__ || Object.getPrototypeOf(InfoButton)).apply(this, arguments));
    }

    _createClass(InfoButton, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'button',
                {
                    className: _InfoButton2.default.base,
                    onClick: this.props.onClick,
                    onMouseDown: _web_to_client.sendClickSoundCommand,
                    onMouseEnter: _web_to_client.sendHoverSoundCommand
                },
                _react2.default.createElement('span', { className: _InfoButton2.default.icon }),
                _react2.default.createElement(
                    'span',
                    { className: _InfoButton2.default.caption },
                    this.props.caption
                )
            );
        }
    }]);

    return InfoButton;
}(_react.PureComponent);

InfoButton.propTypes = {
    onClick: _propTypes2.default.func.isRequired,
    caption: _propTypes2.default.element.isRequired
};

exports.default = InfoButton;

/***/ }),
/* 2419 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"InfoButton_base--3cNqo","icon":"InfoButton_icon--2YFuG","caption":"InfoButton_caption--3y4uF"};

/***/ }),
/* 2420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MainMenu = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _uniqueId = __webpack_require__(574);

var _uniqueId2 = _interopRequireDefault(_uniqueId);

var _reactRedux = __webpack_require__(7);

var _Tooltip = __webpack_require__(155);

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _web_to_client = __webpack_require__(17);

var _constants = __webpack_require__(4);

var _constants2 = __webpack_require__(2421);

var _MainMenu = __webpack_require__(2422);

var _MainMenu2 = _interopRequireDefault(_MainMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MainMenu = exports.MainMenu = function (_React$Component) {
    _inherits(MainMenu, _React$Component);

    function MainMenu(props) {
        _classCallCheck(this, MainMenu);

        var _this = _possibleConstructorReturn(this, (MainMenu.__proto__ || Object.getPrototypeOf(MainMenu)).call(this, props));

        _this.handleMouseEnter = function () {
            (0, _web_to_client.sendHoverSoundCommand)();
        };

        _this.handleMouseDown = function (event) {
            event.preventDefault();
            (0, _web_to_client.sendClickSoundCommand)();
        };

        _this.handleClick = function (page) {
            return function (event) {
                event.preventDefault();
                _this.changePage(page);
            };
        };

        _this.handleKeyPress = function (page) {
            return function (event) {
                var code = event.keyCode || event.which;

                event.preventDefault();

                if (code === _constants.KEY_CODES.ENTER) {
                    _this.changePage(page);
                }
            };
        };

        _this.changePage = function (page) {
            switch (page) {
                case _constants2.PAGES.craft:
                    {
                        return window.location.assign(_this.props.craftMachineUrl + '/#' + _constants2.MENU_URLS[page].url);
                    }
                case _constants2.PAGES.boost:
                    {
                        return window.location.assign(_this.props.craftMachineUrl + '/#' + _constants2.MENU_URLS[page].url);
                    }
                default:
                    {
                        _this.setState({
                            activePage: page
                        });

                        return window.location.assign('/#' + _constants2.MENU_URLS[page].url);
                    }
            }
        };

        _this.getTooltipContent = function (page) {
            return _react2.default.createElement(
                'p',
                { className: _MainMenu2.default.tooltipMessage },
                _constants2.SECTION_TOOLTIPS[page].title
            );
        };

        _this.filterPages = function (page) {
            var _enabledPagesConfig;

            var enabledPagesConfig = (_enabledPagesConfig = {}, _defineProperty(_enabledPagesConfig, _constants2.PAGES.leaderboards, _this.props.leaderboardsEnabled), _defineProperty(_enabledPagesConfig, _constants2.PAGES.craft, _this.props.craftMachineEnabled), _defineProperty(_enabledPagesConfig, _constants2.PAGES.boost, _this.props.enhancementsEnabled), _defineProperty(_enabledPagesConfig, _constants2.PAGES.rewards, _this.props.eventRewardsEnabled), _defineProperty(_enabledPagesConfig, _constants2.PAGES.bonuses, _this.props.personalBonusesEnabled), _defineProperty(_enabledPagesConfig, _constants2.PAGES.battleSchedule, _this.props.battleScheduleEnabled), _enabledPagesConfig);

            return enabledPagesConfig[page];
        };

        _this.state = {
            isFirstAppear: true,
            activePage: null,
            pages: []
        };

        _this.tooltipId = (0, _uniqueId2.default)('main-menu-tooltip-id-');
        return _this;
    }

    _createClass(MainMenu, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var pages = Object.values(_constants2.PAGES).filter(this.filterPages);
            var activePage = pages.find(function (page) {
                return _this2.props.location === _constants2.MENU_URLS[page].url;
            });

            // eslint-disable-next-line react/no-did-mount-set-state
            this.setState({
                pages: pages,
                activePage: activePage
            });
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (prevState.activePage && prevState.activePage !== this.state.activePage) {
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFirstAppear: false
                });
            }
        }
    }, {
        key: 'renderItems',
        value: function renderItems(items) {
            var _this3 = this;

            var activePage = this.state.activePage;


            return items.map(function (page) {
                var isActivePage = page === activePage;

                var itemClassName = (0, _classnames2.default)(_MainMenu2.default.item, _MainMenu2.default['item__' + (isActivePage ? 'active' : 'default')]);

                return _react2.default.createElement(
                    'div',
                    {
                        tabIndex: isActivePage ? -1 : 0,
                        className: itemClassName,
                        onMouseDown: _this3.handleMouseDown,
                        onMouseEnter: _this3.handleMouseEnter,
                        onClick: _this3.handleClick(page),
                        onKeyPress: _this3.handleKeyPress(page),
                        key: 'main-menu-' + page,
                        'data-tip': page,
                        'data-for': _this3.tooltipId
                    },
                    _react2.default.createElement('span', { className: (0, _classnames2.default)(_MainMenu2.default.icon, _MainMenu2.default[page]) }),
                    _react2.default.createElement('span', { className: (0, _classnames2.default)(_MainMenu2.default.iconActive, _MainMenu2.default[page]) }),
                    _react2.default.createElement('span', { className: _MainMenu2.default.condition })
                );
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                pages = _state.pages,
                isFirstAppear = _state.isFirstAppear;

            var baseClassName = (0, _classnames2.default)(_MainMenu2.default.base, isFirstAppear && _MainMenu2.default.base__firstAppear);

            return _react2.default.createElement(
                'div',
                { className: baseClassName, style: { '--count': pages.length } },
                _react2.default.createElement(
                    'div',
                    { className: _MainMenu2.default.wrapper },
                    _react2.default.createElement('span', { className: _MainMenu2.default.back }),
                    _react2.default.createElement(
                        'div',
                        { className: _MainMenu2.default.holder },
                        _react2.default.createElement(
                            'div',
                            { className: _MainMenu2.default.inner },
                            this.renderItems(pages),
                            _react2.default.createElement(
                                'span',
                                { className: _MainMenu2.default.caret },
                                _react2.default.createElement('span', { className: _MainMenu2.default.effects })
                            )
                        )
                    )
                ),
                _react2.default.createElement(_Tooltip2.default, { id: this.tooltipId, getContent: this.getTooltipContent })
            );
        }
    }]);

    return MainMenu;
}(_react2.default.Component);

MainMenu.propTypes = {
    craftMachineUrl: _propTypes2.default.string,
    craftMachineEnabled: _propTypes2.default.bool,
    enhancementsEnabled: _propTypes2.default.bool,
    eventRewardsEnabled: _propTypes2.default.bool,
    personalBonusesEnabled: _propTypes2.default.bool,
    battleScheduleEnabled: _propTypes2.default.bool,
    leaderboardsEnabled: _propTypes2.default.bool,
    location: _propTypes2.default.string
};


var stateToProps = function stateToProps(state) {
    return {
        craftMachineUrl: state.settings.craftMachineUrl,
        craftMachineEnabled: state.craftMachine.is_craft_machine_enabled,
        enhancementsEnabled: state.craftMachine.is_enhancements_enabled,
        eventRewardsEnabled: state.globalMap.event_rewards_enabled,
        personalBonusesEnabled: state.globalMap.personal_bonuses_enabled,
        battleScheduleEnabled: state.globalMap.battle_schedule_enabled && !!state.wgcwxClanInfo.clan_info.joined_at,
        leaderboardsEnabled: state.globalMap.leaderboards_enabled && !!state.wgcwxClanInfo.clan_info.joined_at,
        location: state.routing.locationBeforeTransitions.pathname
    };
};

exports.default = (0, _reactRedux.connect)(stateToProps, {})(MainMenu);

/***/ }),
/* 2421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SECTION_TOOLTIPS = exports.MENU_URLS = exports.PAGES = undefined;

var _MENU_URLS, _SECTION_TOOLTIPS;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PAGES = exports.PAGES = {
    leaderboards: 'leaderboards',
    craft: 'craft',
    boost: 'boost',
    rewards: 'rewards',
    bonuses: 'bonuses',
    battleSchedule: 'battleSchedule'
};

var MENU_URLS = exports.MENU_URLS = (_MENU_URLS = {}, _defineProperty(_MENU_URLS, PAGES.leaderboards, {
    url: '/leaderboards'
}), _defineProperty(_MENU_URLS, PAGES.craft, {
    url: '/craft/vehicles'
}), _defineProperty(_MENU_URLS, PAGES.boost, {
    url: '/boost'
}), _defineProperty(_MENU_URLS, PAGES.bonuses, {
    url: '/personal_shop/products'
}), _defineProperty(_MENU_URLS, PAGES.rewards, {
    url: '/personal_shop/rewards'
}), _defineProperty(_MENU_URLS, PAGES.battleSchedule, {
    url: '/battle_schedule'
}), _MENU_URLS);

var CRAFT_TOOLTIP_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'main_menu.tooltips.craft.title',
    defaultMessage: '\u041C\u0430\u0441\u0442\u0435\u0440\u0441\u043A\u0430\u044F'
});

var BOOST_TOOLTIP_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'main_menu.tooltips.boost.title',
    defaultMessage: '\u041C\u043E\u0434\u0435\u0440\u043D\u0438\u0437\u0430\u0446\u0438\u044F \u0442\u0435\u0445\u043D\u0438\u043A\u0438'
});

var SHOP_TOOLTIP_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'main_menu.tooltips.shop.title',
    defaultMessage: '\u041F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0431\u043E\u043D\u0443\u0441\u044B'
});

var REWARD_TOOLTIP_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'main_menu.tooltips.reward.title',
    defaultMessage: '\u041D\u0430\u0433\u0440\u0430\u0436\u0434\u0435\u043D\u0438\u0435 \u043F\u043E\u0431\u0435\u0434\u0438\u0442\u0435\u043B\u0435\u0439'
});

var BATTLE_SCHEDULE_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'main_menu.tooltips.battle_schedule.title',
    defaultMessage: '\u0411\u043E\u0438 \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435'
});

var LEADERBOARDS_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'main_menu.tooltips.leaderboards.title',
    defaultMessage: '\u0414\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u044F \u0432 \u0441\u043E\u0431\u044B\u0442\u0438\u0438'
});

var SECTION_TOOLTIPS = exports.SECTION_TOOLTIPS = (_SECTION_TOOLTIPS = {}, _defineProperty(_SECTION_TOOLTIPS, PAGES.craft, {
    title: CRAFT_TOOLTIP_TITLE
}), _defineProperty(_SECTION_TOOLTIPS, PAGES.boost, {
    title: BOOST_TOOLTIP_TITLE
}), _defineProperty(_SECTION_TOOLTIPS, PAGES.rewards, {
    title: REWARD_TOOLTIP_TITLE
}), _defineProperty(_SECTION_TOOLTIPS, PAGES.bonuses, {
    title: SHOP_TOOLTIP_TITLE
}), _defineProperty(_SECTION_TOOLTIPS, PAGES.battleSchedule, {
    title: BATTLE_SCHEDULE_TITLE
}), _defineProperty(_SECTION_TOOLTIPS, PAGES.leaderboards, {
    title: LEADERBOARDS_TITLE
}), _SECTION_TOOLTIPS);

/***/ }),
/* 2422 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"MainMenu_base--3Xjfm","wrapper":"MainMenu_wrapper--nVDd6","back":"MainMenu_back--1VvUG","holder":"MainMenu_holder--1A7v4","inner":"MainMenu_inner--1Cst8","caret":"MainMenu_caret--2XhpK","item":"MainMenu_item--lReqH","item__active":"MainMenu_item__active--3h1h6","itemActive":"MainMenu_item__active--3h1h6","switch-arrow":"MainMenu_switch-arrow--3L3AW","switchArrow":"MainMenu_switch-arrow--3L3AW","base__firstAppear":"MainMenu_base__firstAppear--1tcPa","baseFirstAppear":"MainMenu_base__firstAppear--1tcPa","switch-arrow-appear":"MainMenu_switch-arrow-appear--2NnFI","switchArrowAppear":"MainMenu_switch-arrow-appear--2NnFI","effects":"MainMenu_effects--3CwGQ","menu-switch-effects":"MainMenu_menu-switch-effects--3G9O5","menuSwitchEffects":"MainMenu_menu-switch-effects--3G9O5","menu-switch-effects-appear":"MainMenu_menu-switch-effects-appear--3nlz6","menuSwitchEffectsAppear":"MainMenu_menu-switch-effects-appear--3nlz6","icon":"MainMenu_icon--14vXZ","craft":"MainMenu_craft--3QtVC","boost":"MainMenu_boost--3j6QU","rewards":"MainMenu_rewards--3uKL5","bonuses":"MainMenu_bonuses--zWYzq","battle-schedule":"MainMenu_battle-schedule--3PM40","battleSchedule":"MainMenu_battle-schedule--3PM40","leaderboards":"MainMenu_leaderboards--1wRcb","iconActive":"MainMenu_iconActive--3WlcQ","condition":"MainMenu_condition--2TY1v","item__default":"MainMenu_item__default--35g7l","itemDefault":"MainMenu_item__default--35g7l"};

/***/ }),
/* 2423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ABOUT = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ABOUT = exports.ABOUT = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'about',
    defaultMessage: '\u041E \u0441\u043E\u0431\u044B\u0442\u0438\u0438'
});

/***/ }),
/* 2424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ERROR_CODES = undefined;

var _ERROR_CODES$BATTLES_;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint-disable react/no-multi-comp, max-len */


var ERROR_CODES = exports.ERROR_CODES = {
    BATTLES_UNKNOWN_ERROR: 'UNKNOWN_ERROR',
    PRODUCTS_UNKNOWN_ERROR: 'PRODUCTS_UNKNOWN_ERROR',
    REWARDS_UNKNOWN_ERROR: 'REWARDS_UNKNOWN_ERROR',
    LEADERBOARDS_UNKNOWN_ERROR: 'LEADERBOARDS_UNKNOWN_ERROR'
};

exports.default = (_ERROR_CODES$BATTLES_ = {}, _defineProperty(_ERROR_CODES$BATTLES_, ERROR_CODES.BATTLES_UNKNOWN_ERROR, {
    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_battle_schedule.battle_schedule_data_loading_error.title',
        defaultMessage: '\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043E\u0442\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u044C \u0441\u043F\u0438\u0441\u043E\u043A \u0431\u043E\u0451\u0432'
    }),
    description: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_battle_schedule.battle_schedule_data_loading_error.description',
        defaultMessage: '\u0421\u043F\u0438\u0441\u043E\u043A \u0431\u043E\u0451\u0432 \u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u0435\u043D. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u043E\u0437\u0436\u0435.'
    })
}), _defineProperty(_ERROR_CODES$BATTLES_, ERROR_CODES.LEADERBOARDS_UNKNOWN_ERROR, {
    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_leaderboards.leaderboards_data_loading_error.title',
        defaultMessage: '\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043E\u0442\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u044C \u0434\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u044F \u0432 \u0441\u043E\u0431\u044B\u0442\u0438\u0438'
    }),
    description: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_leaderboards.leaderboards_data_loading_error.description',
        defaultMessage: '\u0414\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u044F \u0432 \u0441\u043E\u0431\u044B\u0442\u0438\u0438 \u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0437\u0430\u0439\u0442\u0438 \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u043F\u043E\u0437\u0436\u0435.'
    })
}), _defineProperty(_ERROR_CODES$BATTLES_, ERROR_CODES.REWARDS_UNKNOWN_ERROR, {
    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop_errors.titles.rewards_is_not_showed',
        defaultMessage: '\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043E\u0442\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u044C \u0441\u043F\u0438\u0441\u043E\u043A \u043D\u0430\u0433\u0440\u0430\u0434'
    }),
    description: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop_errors.rewards_purchase_is_not_available',
        defaultMessage: '\u041F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435 \u043D\u0430\u0433\u0440\u0430\u0434 \u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u043E\u0437\u0436\u0435.'
    })
}), _defineProperty(_ERROR_CODES$BATTLES_, ERROR_CODES.PRODUCTS_UNKNOWN_ERROR, {
    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop_errors.titles.products_is_not_showed',
        defaultMessage: '\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043E\u0442\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u044C \u0441\u043F\u0438\u0441\u043E\u043A \u0431\u043E\u043D\u0443\u0441\u043E\u0432'
    }),
    description: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop_errors.products_purchase_is_not_available',
        defaultMessage: '\u041F\u0440\u0438\u043E\u0431\u0440\u0435\u0442\u0435\u043D\u0438\u0435 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0431\u043E\u043D\u0443\u0441\u043E\u0432 \u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u043E\u0437\u0436\u0435.'
    })
}), _ERROR_CODES$BATTLES_);

/***/ }),
/* 2425 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"WGCWXWrapper_base--1RGQa","base__overlayOpened":"WGCWXWrapper_base__overlayOpened--mx9zj","baseOverlayOpened":"WGCWXWrapper_base__overlayOpened--mx9zj","about":"WGCWXWrapper_about--vXKPx","close":"WGCWXWrapper_close--_AjW-"};

/***/ }),
/* 2426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.stateToProps = exports.WGCWXShop = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(7);

var _reactRouterRedux = __webpack_require__(15);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _wgcwx_shop = __webpack_require__(106);

var _comparison_basket = __webpack_require__(1001);

var _balance = __webpack_require__(275);

var _reactWotBootstrap = __webpack_require__(5);

var _WGCWXConfirmation = __webpack_require__(238);

var _WGCWXConfirmation2 = _interopRequireDefault(_WGCWXConfirmation);

var _WGCWXShopProducts = __webpack_require__(2427);

var _WGCWXShopProducts2 = _interopRequireDefault(_WGCWXShopProducts);

var _WGCWXShopDetailedProduct = __webpack_require__(2431);

var _WGCWXShopDetailedProduct2 = _interopRequireDefault(_WGCWXShopDetailedProduct);

var _WGCWXRewads = __webpack_require__(2434);

var _WGCWXRewads2 = _interopRequireDefault(_WGCWXRewads);

var _WGCWXRewardsTank = __webpack_require__(2440);

var _WGCWXRewardsTank2 = _interopRequireDefault(_WGCWXRewardsTank);

var _urls = __webpack_require__(19);

var _constants = __webpack_require__(92);

var _errors = __webpack_require__(1321);

var _errors2 = _interopRequireDefault(_errors);

var _translations = __webpack_require__(237);

var _propTypes3 = __webpack_require__(79);

var _sounds = __webpack_require__(22);

var _client2web = __webpack_require__(126);

var _WGCWXShop = __webpack_require__(2451);

var _WGCWXShop2 = _interopRequireDefault(_WGCWXShop);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WGCWXShop = exports.WGCWXShop = function (_React$Component) {
    _inherits(WGCWXShop, _React$Component);

    function WGCWXShop(props) {
        _classCallCheck(this, WGCWXShop);

        var _this = _possibleConstructorReturn(this, (WGCWXShop.__proto__ || Object.getPrototypeOf(WGCWXShop)).call(this, props));

        _this.scrollToCurrentBox = function (id) {
            var productElement = document.getElementById(id);
            productElement && productElement.scrollIntoView();
        };

        _this.onErrorClose = function (isUnknownError, isWGMoneyError) {
            var _this$state = _this.state,
                selectedProduct = _this$state.selectedProduct,
                selectedRewardId = _this$state.selectedRewardId;
            var _this$props = _this.props,
                error = _this$props.error,
                productsErrorActionType = _this$props.productsErrorActionType,
                rewardsErrorActionType = _this$props.rewardsErrorActionType,
                requestShopGoods = _this$props.requestShopGoods,
                requestRewards = _this$props.requestRewards,
                close = _this$props.close;


            var errorActionType = productsErrorActionType || rewardsErrorActionType;
            var isRequestAction = errorActionType === _errors.ERROR_ACTION_TYPES.REQUEST_ITEMS;
            var isPurchaseAction = errorActionType === _errors.ERROR_ACTION_TYPES.PURCHASE_ITEM;

            var closingShopErrors = new Set([_errors.ERROR_CODES.REWARDING_IS_FINISHED, _errors.ERROR_CODES.AUCTION_IS_DISABLED]);
            var closingInfoErrors = new Set([_errors.ERROR_CODES.ITEM_IS_NOT_AVAILABLE, _errors.ERROR_CODES.TURN_CALCULATION_IN_PROGRESS]);
            // redirect to clan landing for unhandled errors while loading page and if shop is disabled
            if (closingShopErrors.has(error) || isRequestAction && isUnknownError) {
                close();
                return;
            }

            // open main page if selected product or reward is no longer available or wg Money is unavailable
            if (closingInfoErrors.has(error) || isPurchaseAction && isUnknownError || isWGMoneyError) {
                _this.openMain();
            }

            if (selectedProduct) {
                requestShopGoods();
            }

            if (selectedRewardId) {
                requestRewards();
            }
        };

        _this.selectProduct = function (productType) {
            _this.props.setShopInnerPageState(true);
            _this.setState({
                currentProduct: productType,
                selectedProduct: productType
            });
        };

        _this.selectReward = function (rewardId) {
            _this.props.setShopInnerPageState(true);
            _this.setState({
                currentRewardId: 'reward-pack-' + rewardId,
                selectedRewardId: rewardId
            });
        };

        _this.backToRewardsScreen = function () {
            _this.props.setShopInnerPageState(false);
            _this.setState({ selectedRewardId: null });
        };

        _this.openMain = function () {
            var partitionType = _this.props.partitionType;

            var isProductsPartition = partitionType === _constants.PARTITION_TYPES.products;

            if (isProductsPartition) {
                _this.props.setShopInnerPageState(false);
                _this.setState({ selectedProduct: null });
            } else {
                _this.backToRewardsScreen();
            }
        };

        _this.renderProductsPartition = function () {
            var _this$props2 = _this.props,
                products = _this$props2.products,
                rewards = _this$props2.rewards;


            var containerClassNames = (0, _classnames2.default)(_WGCWXShop2.default.base, _this.state.selectedProduct && _WGCWXShop2.default.base__overlayOpened);

            return _react2.default.createElement(
                'div',
                { className: containerClassNames },
                _this.state.selectedProduct === null && _react2.default.createElement(_WGCWXShopProducts2.default, {
                    products: products,
                    accountInfo: _this.props.accountInfo,
                    accountBalance: _this.props.accountBalance,
                    rewards: rewards,
                    rewardsMeta: _this.props.rewardsMeta,
                    eventName: _this.props.eventName,
                    globalMapUrl: _this.props.globalMapUrl,
                    signInTokenUrl: _this.props.signInTokenUrl,
                    selectProduct: _this.selectProduct
                }),
                _this.state.selectedProduct !== null && _react2.default.createElement(_WGCWXShopDetailedProduct2.default, {
                    realm: _this.props.realm,
                    product: products[_this.state.selectedProduct],
                    tankProduct: rewards,
                    productType: _this.state.selectedProduct,
                    accountFamePoints: _this.props.accountInfo.fame_points,
                    purchaseItem: _this.props.purchaseItem,
                    close: _this.openMain,
                    globalMapStylesInInventory: _this.props.globalMapStylesInInventory
                })
            );
        };

        _this.renderRewardsPartition = function () {
            var _this$props3 = _this.props,
                rewards = _this$props3.rewards,
                rewardsMeta = _this$props3.rewardsMeta,
                isAddToComparisonAvailable = _this$props3.isAddToComparisonAvailable,
                purchaseItem = _this$props3.purchaseItem,
                makeRewardAuctionBet = _this$props3.makeRewardAuctionBet,
                cancelRewardAuctionBet = _this$props3.cancelRewardAuctionBet,
                accountBalance = _this$props3.accountBalance;
            var selectedRewardId = _this.state.selectedRewardId;

            var selectedTank = rewards.filter(function (reward) {
                return reward.id === selectedRewardId && reward.type === _constants.REWARDS_TYPES.TANK;
            });
            var anyTankSelected = rewards.filter(function (item) {
                return item.type === _constants.REWARDS_TYPES.TANK;
            }).some(function (item) {
                return item.isSelected;
            });

            return _react2.default.createElement(
                'div',
                { className: _WGCWXShop2.default.base },
                selectedRewardId === null && rewards && _react2.default.createElement(_WGCWXRewads2.default, {
                    rewards: rewards,
                    rewardsMeta: rewardsMeta,
                    accountBalance: accountBalance,
                    selectReward: _this.selectReward,
                    isAddToComparisonAvailable: isAddToComparisonAvailable
                }),
                selectedRewardId && _react2.default.createElement(_WGCWXRewardsTank2.default, {
                    wgMoneyServiceError: !accountBalance.isWGMoneyAvailable,
                    accountBalance: accountBalance,
                    selectedTank: selectedTank,
                    rewardsMeta: rewardsMeta,
                    backToRewardsHandler: _this.backToRewardsScreen,
                    purchaseItem: purchaseItem,
                    makeRewardAuctionBet: makeRewardAuctionBet,
                    cancelRewardAuctionBet: cancelRewardAuctionBet,
                    isAddToComparisonAvailable: isAddToComparisonAvailable,
                    anyTankSelected: anyTankSelected
                })
            );
        };

        _this.state = {
            selectedProduct: null,
            currentProduct: null,
            selectedRewardId: null,
            currentRewardId: null
        };
        return _this;
    }

    _createClass(WGCWXShop, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.props.playEnterClansWinnerRewardSound();
            window.onBeforeUnloadHandlers.playShopSoundsOnExit = function () {
                _this2.props.playExitClansWinnerRewardSound();
            };
            this.props.onComponentDidMount();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (prevProps.partitionType !== this.props.partitionType) {
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    selectedProduct: null,
                    currentProduct: null,
                    selectedRewardId: null,
                    currentRewardId: null
                });
            }
            if (this.state.currentProduct) {
                this.scrollToCurrentBox(this.state.currentProduct);
            }
            if (this.state.currentRewardId) {
                this.scrollToCurrentBox(this.state.currentRewardId);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.props.playExitClansWinnerRewardSound();
            delete window.onBeforeUnloadHandlers.playShopSoundsOnExit;
            this.props.onComponentWillUnmount();
        }
    }, {
        key: 'renderShopError',
        value: function renderShopError(errorActionType, isWGMoneyError) {
            var _this3 = this;

            var _props = this.props,
                error = _props.error,
                partitionType = _props.partitionType;


            var erroredPartition = partitionType.toUpperCase();

            var isRewardsPartition = partitionType === _constants.PARTITION_TYPES.rewards;
            var isRequestAction = errorActionType === _errors.ERROR_ACTION_TYPES.REQUEST_ITEMS;
            var isPurchaseAction = errorActionType === _errors.ERROR_ACTION_TYPES.PURCHASE_ITEM;

            var title = _errors.ERROR_TITLES[errorActionType];
            var description = _errors2.default[error];
            var isUnknownError = false;

            if (error === _errors.ERROR_CODES.ITEM_IS_NOT_AVAILABLE) {
                description = _errors2.default[error][erroredPartition];
            }

            if (isRewardsPartition && error === _errors.ERROR_CODES.USER_ALREADY_BOUGHT_THIS_PRODUCT) {
                error = _errors.ERROR_CODES.TANK_IS_ALREADY_SELECTED;
                description = _errors2.default[error];
            }

            if (!description || isWGMoneyError) {
                error = erroredPartition + '_' + _errors.ERROR_CODES.UNKNOWN_ERROR;
                description = _errors2.default[error];
                isUnknownError = true;
            }

            if (isRequestAction || isPurchaseAction) {
                var errorAction = erroredPartition + '_' + errorActionType;
                title = isRequestAction ? _errors.ERROR_TITLES[errorAction][error] : _errors.ERROR_TITLES[errorAction];
            }

            var errorClassNames = (0, _classnames2.default)(_WGCWXShop2.default.base, _WGCWXShop2.default.base__overlayOpened);

            return _react2.default.createElement(
                'div',
                { className: errorClassNames },
                _react2.default.createElement(_WGCWXConfirmation2.default, {
                    messageType: 'error',
                    title: title,
                    description: description,
                    buttonsOptions: [{
                        caption: _translations.AFFIRMATIVE,
                        callback: function callback() {
                            return _this3.onErrorClose(isUnknownError, isWGMoneyError);
                        }
                    }],
                    onClose: function onClose() {
                        return _this3.onErrorClose(isUnknownError, isWGMoneyError);
                    }
                })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                loading = _props2.loading,
                error = _props2.error,
                productsErrorActionType = _props2.productsErrorActionType,
                rewardsErrorActionType = _props2.rewardsErrorActionType,
                partitionType = _props2.partitionType,
                isWGMoneyAvailable = _props2.accountBalance.isWGMoneyAvailable;


            if (loading && !error) return _react2.default.createElement(
                'div',
                { className: _WGCWXShop2.default.processing },
                _react2.default.createElement(_reactWotBootstrap.Processing, { type: 'local', isVisible: true })
            );

            var errorActionType = void 0;
            if (partitionType === _constants.PARTITION_TYPES.products || productsErrorActionType === _errors.ERROR_ACTION_TYPES.PURCHASE_ITEM) {
                errorActionType = productsErrorActionType;
            } else {
                errorActionType = rewardsErrorActionType;
            }

            var isRewardsPartition = partitionType === _constants.PARTITION_TYPES.rewards;
            var wgMoneyErrorActions = new Set([_errors.ERROR_ACTION_TYPES.PURCHASE_ITEM, _errors.ERROR_ACTION_TYPES.MAKE_TANK_BET, _errors.ERROR_ACTION_TYPES.CANCEL_TANK_BET]);

            var isWGMoneyError = isRewardsPartition && wgMoneyErrorActions.has(errorActionType) && !isWGMoneyAvailable || error === _errors.ERROR_CODES.WG_MONEY_UNAVAILABILE;

            if (error && errorActionType || isWGMoneyError) {
                return this.renderShopError(errorActionType, isWGMoneyError);
            }

            return _react2.default.createElement(
                'div',
                null,
                partitionType === _constants.PARTITION_TYPES.products && this.renderProductsPartition(),
                partitionType === _constants.PARTITION_TYPES.rewards && this.renderRewardsPartition()
            );
        }
    }]);

    return WGCWXShop;
}(_react2.default.Component);

WGCWXShop.propTypes = {
    partitionType: _propTypes2.default.string.isRequired,
    loading: _propTypes2.default.bool.isRequired,
    error: _propTypes2.default.string,
    productsErrorActionType: _propTypes2.default.oneOf(Object.values(_errors.ERROR_ACTION_TYPES)),
    rewardsErrorActionType: _propTypes2.default.oneOf(Object.values(_errors.ERROR_ACTION_TYPES)),
    products: _propTypes2.default.objectOf(_propTypes3.ProductPropTypes),
    accountInfo: _propTypes2.default.shape({
        fame_points: _propTypes2.default.number,
        fame_points_bonus: _propTypes2.default.number
    }).isRequired,
    accountBalance: _propTypes3.BalancePropTypes,
    rewards: _propTypes2.default.arrayOf(_propTypes3.RewardPropTypes),
    rewardsMeta: _propTypes3.RewardsMetaPropTypes,
    eventName: _propTypes2.default.string.isRequired,
    globalMapUrl: _propTypes2.default.string.isRequired,
    signInTokenUrl: _propTypes2.default.string.isRequired,
    realm: _propTypes2.default.string.isRequired,
    globalMapStylesInInventory: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired,

    close: _propTypes2.default.func.isRequired,
    setShopInnerPageState: _propTypes2.default.func.isRequired,
    onComponentDidMount: _propTypes2.default.func.isRequired,
    onComponentWillUnmount: _propTypes2.default.func.isRequired,
    requestShopGoods: _propTypes2.default.func.isRequired,
    requestRewards: _propTypes2.default.func.isRequired,
    purchaseItem: _propTypes2.default.func.isRequired,
    makeRewardAuctionBet: _propTypes2.default.func.isRequired,
    cancelRewardAuctionBet: _propTypes2.default.func.isRequired,
    playExitClansWinnerRewardSound: _propTypes2.default.func.isRequired,
    playEnterClansWinnerRewardSound: _propTypes2.default.func.isRequired,
    isAddToComparisonAvailable: _propTypes2.default.bool.isRequired
};
var stateToProps = exports.stateToProps = function stateToProps(_ref, ownProps) {
    var globalMap = _ref.globalMap,
        settings = _ref.settings,
        wgcwxShopProducts = _ref.wgcwxShopProducts,
        wgcwxShopRewards = _ref.wgcwxShopRewards,
        wgcwxInventoryStyles = _ref.wgcwxInventoryStyles,
        wgcwxPreloadImages = _ref.wgcwxPreloadImages,
        comparisonBasket = _ref.comparisonBasket,
        balance = _ref.balance;
    var partitionType = ownProps.params.partitionType;


    var productsLoading = wgcwxShopProducts.loading || wgcwxShopProducts.goods === null;
    var rewardsLoading = wgcwxShopRewards.loading || wgcwxShopRewards.data === null;
    var imagesLoading = !wgcwxPreloadImages.imagesLoaded;

    var loading = productsLoading || rewardsLoading || wgcwxShopProducts.processing || wgcwxShopRewards.processing || imagesLoading;

    var globalMapStylesInInventory = wgcwxInventoryStyles.styles ? Array.from(wgcwxInventoryStyles.styles, function (style) {
        return style.id;
    }) : [];

    return {
        partitionType: partitionType,
        loading: loading,
        error: wgcwxShopProducts.errorMessage || wgcwxShopRewards.errorMessage,
        productsErrorActionType: wgcwxShopProducts.errorActionType,
        rewardsErrorActionType: wgcwxShopRewards.errorActionType,
        products: wgcwxShopProducts.goods,
        accountInfo: wgcwxShopProducts.accountInfo,
        accountBalance: balance,
        rewards: wgcwxShopRewards.goods,
        rewardsMeta: wgcwxShopRewards.accountInfo,
        isAddToComparisonAvailable: !comparisonBasket.isFull,
        eventName: globalMap.context_id,
        globalMapUrl: settings.globalMapUrl,
        signInTokenUrl: settings.signInTokenUrl,
        realm: settings.realm,
        globalMapStylesInInventory: globalMapStylesInInventory
    };
};

var dispatchToProps = function dispatchToProps(dispatch) {
    return {
        onComponentDidMount: function onComponentDidMount() {
            dispatch((0, _wgcwx_shop.requestShopGoods)());
            dispatch((0, _wgcwx_shop.requestRewards)());
            dispatch((0, _comparison_basket.requestComparisonStatus)());
            dispatch((0, _balance.requestBalance)());
            dispatch((0, _wgcwx_shop.requestPreloadImages)());

            (0, _client2web.addWOTClientListener)(_client2web.C2W_EVENT_TYPES.UPDATE_VEHICLE_STATE, dispatch);
            (0, _client2web.addWOTClientListener)(_client2web.C2W_EVENT_TYPES.UPDATE_COMPARISON_BASKET, dispatch);
            (0, _client2web.addWOTClientListener)(_client2web.C2W_EVENT_TYPES.UPDATE_BALANCE, dispatch);
            (0, _client2web.addWOTClientListener)(_client2web.C2W_EVENT_TYPES.WALLET_UPDATE, dispatch);
        },
        onComponentWillUnmount: function onComponentWillUnmount() {
            (0, _client2web.removeWOTClientListener)(_client2web.C2W_EVENT_TYPES.UPDATE_VEHICLE_STATE, dispatch);
            (0, _client2web.removeWOTClientListener)(_client2web.C2W_EVENT_TYPES.UPDATE_COMPARISON_BASKET, dispatch);
            (0, _client2web.removeWOTClientListener)(_client2web.C2W_EVENT_TYPES.UPDATE_BALANCE, dispatch);
            (0, _client2web.removeWOTClientListener)(_client2web.C2W_EVENT_TYPES.WALLET_UPDATE, dispatch);
        },
        close: function close() {
            return dispatch((0, _reactRouterRedux.push)(_urls.CLAN_LANDING));
        },
        setShopInnerPageState: function setShopInnerPageState(isInnerPageOpened) {
            return dispatch((0, _wgcwx_shop.setShopInnerPageState)(isInnerPageOpened));
        },
        requestShopGoods: function requestShopGoods() {
            return dispatch((0, _wgcwx_shop.requestShopGoods)());
        },
        requestRewards: function requestRewards() {
            return dispatch((0, _wgcwx_shop.requestRewards)());
        },
        requestComparisonStatus: function requestComparisonStatus() {
            return dispatch((0, _comparison_basket.requestComparisonStatus)());
        },
        purchaseItem: function purchaseItem(productId) {
            return dispatch((0, _wgcwx_shop.purchaseItem)(productId));
        },
        makeRewardAuctionBet: function makeRewardAuctionBet(bet, productId) {
            return dispatch((0, _wgcwx_shop.makeRewardAuctionBet)(bet, productId));
        },
        cancelRewardAuctionBet: function cancelRewardAuctionBet() {
            return dispatch((0, _wgcwx_shop.cancelRewardAuctionBet)());
        },
        playExitClansWinnerRewardSound: function playExitClansWinnerRewardSound() {
            return dispatch((0, _sounds.playExitClansWinnerRewardSound)());
        },
        playEnterClansWinnerRewardSound: function playEnterClansWinnerRewardSound() {
            return dispatch((0, _sounds.playEnterClansWinnerRewardSound)());
        }
    };
};

exports.default = (0, _reactRedux.connect)(stateToProps, dispatchToProps)(WGCWXShop);

/***/ }),
/* 2427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

var _web_to_client = __webpack_require__(12);

var _reactWotBootstrap = __webpack_require__(5);

var _FamePoints = __webpack_require__(143);

var _FamePoints2 = _interopRequireDefault(_FamePoints);

var _WGCWXShopHeaderCard = __webpack_require__(2428);

var _WGCWXShopHeaderCard2 = _interopRequireDefault(_WGCWXShopHeaderCard);

var _WGCWXShopProductGrid = __webpack_require__(2429);

var _WGCWXShopProductGrid2 = _interopRequireDefault(_WGCWXShopProductGrid);

var _translations = __webpack_require__(575);

var _propTypes3 = __webpack_require__(79);

var _WGCWXShopProducts = __webpack_require__(1378);

var _WGCWXShopProducts2 = _interopRequireDefault(_WGCWXShopProducts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WGCWXShopProducts = function (_React$Component) {
    _inherits(WGCWXShopProducts, _React$Component);

    function WGCWXShopProducts(props) {
        _classCallCheck(this, WGCWXShopProducts);

        var _this = _possibleConstructorReturn(this, (WGCWXShopProducts.__proto__ || Object.getPrototypeOf(WGCWXShopProducts)).call(this, props));

        _this.handleResize = function () {
            _this.setScrollAreaHeight();
        };

        _this.openGlobalMap = function (e) {
            e.preventDefault();
            (0, _web_to_client.openExternalBrowserWithAuth)(_this.props.signInTokenUrl, _this.props.globalMapUrl);
        };

        _this.state = {
            scrollableAreaHeight: 0
        };

        _this.BOTTOM_SCROLL_OFFSET = 10;
        _this.SCROLL_STEP = 50;
        return _this;
    }

    _createClass(WGCWXShopProducts, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.addEventListener('resize', this.handleResize);

            this.setScrollAreaHeight();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('resize', this.handleResize);
        }
    }, {
        key: 'setScrollAreaHeight',
        value: function setScrollAreaHeight() {
            if (!this._body) return;
            var coords = this._body.getBoundingClientRect();
            var height = window.innerHeight - coords.top - this.BOTTOM_SCROLL_OFFSET;
            this.setState({ scrollableAreaHeight: height });
        }
    }, {
        key: 'renderHeader',
        value: function renderHeader(rewardsAvailableToBuy) {
            var _props$accountInfo = this.props.accountInfo,
                fame_points_bonus = _props$accountInfo.fame_points_bonus,
                fame_points = _props$accountInfo.fame_points;


            if (fame_points === undefined) return null;

            var userPfpValue = _react2.default.createElement(
                'span',
                { className: _WGCWXShopProducts2.default.subtitle_value },
                _react2.default.createElement(_FamePoints2.default, {
                    value: fame_points,
                    iconPosition: 'before',
                    mixClassName: _WGCWXShopProducts2.default.subtitle_value
                })
            );

            return _react2.default.createElement(
                _WGCWXShopHeaderCard2.default,
                null,
                _react2.default.createElement(
                    'span',
                    { className: _WGCWXShopProducts2.default.subtitle },
                    (0, _translations.PERSONAL_FAME_POINTS)(userPfpValue)
                ),
                !rewardsAvailableToBuy && fame_points_bonus !== undefined && _react2.default.createElement(
                    'span',
                    { className: _WGCWXShopProducts2.default.subtitle },
                    (0, _translations.PERSONAL_FAME_POINTS_BONUS)(_react2.default.createElement(
                        'span',
                        { className: _WGCWXShopProducts2.default.subtitle_value },
                        '+' + fame_points_bonus + '%'
                    ))
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var rewardsAvailableToBuy = this.props.rewards && this.props.rewards.every(function (reward) {
                return reward.price > 0;
            });
            var datetimeEnd = _moment2.default.utc(this.props.rewardsMeta.purchaseDatetimeEnd).local();

            return _react2.default.createElement(
                'div',
                { className: _WGCWXShopProducts2.default.base },
                _react2.default.createElement(
                    'div',
                    { className: _WGCWXShopProducts2.default.content },
                    _react2.default.createElement(
                        'h1',
                        { className: _WGCWXShopProducts2.default.title },
                        _translations.PERSONAL_BONUSES
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: _WGCWXShopProducts2.default.eventInfo },
                        (0, _translations.GLOBAL_MAP_EVENT_NAME)(this.props.eventName),
                        '\xA0',
                        _react2.default.createElement(
                            'a',
                            { href: '', className: _WGCWXShopProducts2.default.wgcwxLink, onClick: this.openGlobalMap },
                            _translations.GO_TO_GLOBAL_MAP
                        )
                    ),
                    rewardsAvailableToBuy && _react2.default.createElement(
                        'div',
                        { className: (0, _classnames2.default)(_WGCWXShopProducts2.default.info, _WGCWXShopProducts2.default.info__center) },
                        _react2.default.createElement(_reactWotBootstrap.Info, null),
                        '\xA0',
                        (0, _translations.PURCHASE_DATETIME_END)(datetimeEnd)
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _WGCWXShopProducts2.default.header },
                        this.renderHeader(rewardsAvailableToBuy)
                    ),
                    _react2.default.createElement('div', { className: _WGCWXShopProducts2.default.separator }),
                    _react2.default.createElement(
                        'div',
                        { ref: function ref(c) {
                                return _this2._body = c;
                            }, className: _WGCWXShopProducts2.default.body },
                        _react2.default.createElement(
                            _reactWotBootstrap.ScrollArea,
                            {
                                stepHeight: this.SCROLL_STEP,
                                scrollableAreaHeight: this.state.scrollableAreaHeight
                            },
                            _react2.default.createElement(_WGCWXShopProductGrid2.default, {
                                products: this.props.products,
                                accountFamePoints: this.props.accountInfo.fame_points,
                                selectProduct: this.props.selectProduct
                            })
                        )
                    )
                )
            );
        }
    }]);

    return WGCWXShopProducts;
}(_react2.default.Component);

WGCWXShopProducts.propTypes = {
    products: _propTypes2.default.objectOf(_propTypes3.ProductPropTypes),
    accountInfo: _propTypes2.default.shape({
        fame_points: _propTypes2.default.number,
        fame_points_bonus: _propTypes2.default.number
    }).isRequired,
    rewards: _propTypes2.default.arrayOf(_propTypes3.RewardPropTypes),
    rewardsMeta: _propTypes3.RewardsMetaPropTypes,
    eventName: _propTypes2.default.string.isRequired,
    globalMapUrl: _propTypes2.default.string.isRequired,
    signInTokenUrl: _propTypes2.default.string.isRequired,

    selectProduct: _propTypes2.default.func.isRequired
};
exports.default = WGCWXShopProducts;

/***/ }),
/* 2428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _WGCWXShopCard = __webpack_require__(297);

var _WGCWXShopCard2 = _interopRequireDefault(_WGCWXShopCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WGCWXShopHeaderCard = function WGCWXShopHeaderCard(props) {
    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_WGCWXShopCard2.default.card, _WGCWXShopCard2.default.card__large, _WGCWXShopCard2.default.card__header) },
        _react2.default.createElement(
            'div',
            { className: _WGCWXShopCard2.default.inner },
            props.children
        )
    );
};

exports.default = WGCWXShopHeaderCard;

/***/ }),
/* 2429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WGCWXShopProductGrid = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(93);

var _reactRedux = __webpack_require__(7);

var _reactWotBootstrap = __webpack_require__(5);

var _WGCWXShopProductCard = __webpack_require__(2430);

var _WGCWXShopProductCard2 = _interopRequireDefault(_WGCWXShopProductCard);

var _FamePoints = __webpack_require__(143);

var _FamePoints2 = _interopRequireDefault(_FamePoints);

var _helpers = __webpack_require__(130);

var _translations = __webpack_require__(237);

var _translations2 = __webpack_require__(575);

var _products = __webpack_require__(576);

var _constants = __webpack_require__(92);

var _propTypes3 = __webpack_require__(79);

var _WGCWXShopProducts = __webpack_require__(1378);

var _WGCWXShopProducts2 = _interopRequireDefault(_WGCWXShopProducts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WGCWXShopProductGrid = exports.WGCWXShopProductGrid = function (_React$Component) {
    _inherits(WGCWXShopProductGrid, _React$Component);

    function WGCWXShopProductGrid() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, WGCWXShopProductGrid);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WGCWXShopProductGrid.__proto__ || Object.getPrototypeOf(WGCWXShopProductGrid)).call.apply(_ref, [this].concat(args))), _this), _this.selectProduct = function (type) {
            return function (e) {
                return _this.props.selectProduct(type);
            };
        }, _this.translateGroup = function (group) {
            if (group) {
                return _react2.default.createElement(
                    'span',
                    null,
                    ': ',
                    _translations.GROUP_CAPTIONS[group]
                );
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(WGCWXShopProductGrid, [{
        key: 'getGroups',
        value: function getGroups(product) {
            return Object.entries(product.groups);
        }
    }, {
        key: 'getCurrentGroup',
        value: function getCurrentGroup(product) {
            var groupKeys = Object.keys(product.groups);
            return groupKeys[0].split(':')[1];
        }
    }, {
        key: 'getLastIndex',
        value: function getLastIndex(item) {
            return (0, _lodash.findLastIndex)(item[1], function (i) {
                return i.is_bought;
            }) + 1;
        }
    }, {
        key: 'renderGrid',
        value: function renderGrid() {
            var _this2 = this;

            var realm = this.props.realm;

            var gridConfig = (0, _helpers.isCnRealm)(realm) ? _products.PRODUCTS_GRID_CONFIG_CN : _products.PRODUCTS_GRID_CONFIG;
            return gridConfig.map(function (row, index) {
                return _react2.default.createElement(
                    'div',
                    {
                        key: 'row-' + index,
                        className: _WGCWXShopProducts2.default.grid_row
                    },
                    row.map(function (item) {
                        return _this2.renderCard(_constants.PRODUCT_TYPES[item], _products.PRODUCTS_SIZE_CONFIG[row.length - 1]);
                    })
                );
            });
        }
    }, {
        key: 'renderCard',
        value: function renderCard(productType, size) {
            var _this3 = this;

            var product = this.props.products[productType];
            if (!product) return null;
            var groups = this.getGroups(product);
            var groupsType = (0, _helpers.getGroupsType)(product);
            var currentGroup = this.getCurrentGroup(product);
            var hasOneGroup = groups.length === 1 && groupsType !== _constants.GROUP_TYPES.root;

            var firstGroup = Object.entries(product.groups)[0];

            var availableAmount = groups.map(function (item) {
                return item[1].length;
            }).reduce(function (sum, current) {
                return sum + current;
            });

            var items = firstGroup[1];
            var boughtItemsNumber = groups.map(function (item) {
                return _this3.getLastIndex(item);
            }).reduce(function (sum, current) {
                return sum + current;
            });

            var currentItem = items.find(function (item) {
                return !item.is_bought;
            });
            var titleItem = currentItem || items[items.length - 1];

            var itemConfig = _products.PRODUCTS_CONFIG[productType](titleItem);

            var minPriceItemsArr = groups.map(function (item) {
                return item[1][_this3.getLastIndex(item)];
            }).filter(function (item) {
                return item !== undefined;
            });

            var minBoughtItemsPrice = null;

            if (minPriceItemsArr.length !== 0) {
                minBoughtItemsPrice = minPriceItemsArr.reduce(function (min, item) {
                    return min < item.price ? min : item.price;
                }, minPriceItemsArr[0].price);
            }

            var accountFamePoints = this.props.accountFamePoints;


            var priceNotAvailable = minBoughtItemsPrice && accountFamePoints !== null && accountFamePoints < minBoughtItemsPrice;

            var price = null;
            if (minBoughtItemsPrice !== null && boughtItemsNumber !== availableAmount) {
                var isLastItemLeft = boughtItemsNumber === availableAmount - 1;
                price = isLastItemLeft ? _react2.default.createElement(_FamePoints2.default, { size: 'medium', value: minBoughtItemsPrice, notAvailable: priceNotAvailable }) : (0, _translations2.PRICE_STARTS_FROM)(_react2.default.createElement(_FamePoints2.default, { size: 'medium', value: minBoughtItemsPrice, notAvailable: priceNotAvailable }));
            }

            var isAvailable = product.is_available_to_buy && boughtItemsNumber !== availableAmount;
            return _react2.default.createElement(_WGCWXShopProductCard2.default, {
                key: productType,
                title: itemConfig.title,
                groupName: hasOneGroup ? this.translateGroup(currentGroup) : undefined,
                description: itemConfig.description,
                price: price,
                boughtAmount: boughtItemsNumber,
                availableAmount: availableAmount,
                productType: productType,
                value: currentItem ? currentItem.value : titleItem.value,
                size: size,
                isAvailable: isAvailable,
                realm: this.props.realm,
                onClick: this.selectProduct(productType)
            });
        }
    }, {
        key: 'renderPfpBonuses',
        value: function renderPfpBonuses() {
            if (!this.props.products.PFP_BATTLES) return null;
            return _react2.default.createElement(
                'section',
                null,
                _react2.default.createElement(
                    'h2',
                    { className: _WGCWXShopProducts2.default.subtitle },
                    _translations2.PFP_BATTLES_BONUS_SECTION
                ),
                _react2.default.createElement(
                    'div',
                    { className: _WGCWXShopProducts2.default.grid_row },
                    this.renderCard(_constants.PRODUCT_TYPES.PFP_BATTLES, 'large')
                )
            );
        }
    }, {
        key: 'renderPremiumBonuses',
        value: function renderPremiumBonuses() {
            var availableProducts = Object.keys(this.props.products);
            if (availableProducts.length === 0 || availableProducts.length === 1 && availableProducts[0] === _constants.PRODUCT_TYPES.PFP_BATTLES) return null;

            return _react2.default.createElement(
                'section',
                null,
                this.props.products.PFP_BATTLES && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'h2',
                        { className: _WGCWXShopProducts2.default.subtitle },
                        _translations2.PREMIUM_BONUSES_SECTION
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _WGCWXShopProducts2.default.info },
                        _react2.default.createElement(_reactWotBootstrap.Info, null),
                        '\xA0',
                        _translations.PREMIUM_BONUSES_NOT_AVAILABLE_YET
                    )
                ),
                this.renderGrid()
            );
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: _WGCWXShopProducts2.default.grid },
                this.renderPfpBonuses(),
                this.renderPremiumBonuses()
            );
        }
    }]);

    return WGCWXShopProductGrid;
}(_react2.default.Component);

WGCWXShopProductGrid.propTypes = {
    products: _propTypes2.default.objectOf(_propTypes3.ProductPropTypes).isRequired,
    accountFamePoints: _propTypes2.default.number,
    realm: _propTypes2.default.string.isRequired,

    selectProduct: _propTypes2.default.func.isRequired
};


var mapStateToProps = function mapStateToProps(state) {
    return {
        realm: state.settings.realm
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(WGCWXShopProductGrid);

/***/ }),
/* 2430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _camelCase = __webpack_require__(781);

var _camelCase2 = _interopRequireDefault(_camelCase);

var _reactWotBootstrap = __webpack_require__(5);

var _translations = __webpack_require__(575);

var _helpers = __webpack_require__(130);

var _constants = __webpack_require__(92);

var _WGCWXShopCard = __webpack_require__(297);

var _WGCWXShopCard2 = _interopRequireDefault(_WGCWXShopCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WGCWXShopProductCard = function (_React$Component) {
    _inherits(WGCWXShopProductCard, _React$Component);

    function WGCWXShopProductCard() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, WGCWXShopProductCard);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WGCWXShopProductCard.__proto__ || Object.getPrototypeOf(WGCWXShopProductCard)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            isHover: false
        }, _this.handleMouseEnter = function () {
            (0, _reactWotBootstrap.sendHoverSoundCommand)();
            _this.setState({
                isHover: true
            });
        }, _this.handleMouseLeave = function () {
            _this.setState({
                isHover: false
            });
        }, _this.handleMouseDown = function () {
            (0, _reactWotBootstrap.sendClickSoundCommand)();
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(WGCWXShopProductCard, [{
        key: 'render',
        value: function render() {
            var cardClassNames = (0, _classnames2.default)(_WGCWXShopCard2.default.card, _WGCWXShopCard2.default['card__' + this.props.size], this.state.isHover && _WGCWXShopCard2.default.card__hover, this.props.isAvailable && _WGCWXShopCard2.default.card__green_corner, this.props.main && _WGCWXShopCard2.default.card__main);

            var imageClassNames = (0, _classnames2.default)(_WGCWXShopCard2.default.image, _WGCWXShopCard2.default['image__' + this.props.productType], (0, _helpers.isCnRealm)(this.props.realm) && _WGCWXShopCard2.default.isCnRealm, this.props.productType === _constants.PRODUCT_TYPES.PREMIUM_PLUS && _WGCWXShopCard2.default['image__' + this.props.productType + '_' + this.props.value]);

            return _react2.default.createElement(
                'div',
                {
                    className: cardClassNames,
                    onMouseEnter: this.handleMouseEnter,
                    onMouseLeave: this.handleMouseLeave,
                    onMouseDown: this.handleMouseDown,
                    onClick: this.props.onClick,
                    id: this.props.productType
                },
                _react2.default.createElement(
                    'div',
                    { className: _WGCWXShopCard2.default.placeholder },
                    _react2.default.createElement('div', { className: imageClassNames })
                ),
                _react2.default.createElement(
                    'div',
                    { className: _WGCWXShopCard2.default.inner },
                    !this.props.hideCount && _react2.default.createElement(
                        'div',
                        { className: _WGCWXShopCard2.default.items_count },
                        this.state.isHover && _react2.default.createElement(
                            'span',
                            { className: _WGCWXShopCard2.default.items_count_description },
                            _translations.PRODUCT_ITEMS_RECEIVED
                        ),
                        ' ' + this.props.boughtAmount + ' / ' + this.props.availableAmount
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _WGCWXShopCard2.default.content },
                        _react2.default.createElement(
                            'h5',
                            { className: (0, _classnames2.default)(_WGCWXShopCard2.default.title, _WGCWXShopCard2.default['title__' + (0, _camelCase2.default)(this.props.productType)]) },
                            this.props.title,
                            this.props.groupName
                        ),
                        this.props.size === 'large' && _react2.default.createElement(
                            'div',
                            { className: _WGCWXShopCard2.default.description },
                            this.props.description
                        )
                    ),
                    _react2.default.createElement(
                        'footer',
                        { className: _WGCWXShopCard2.default.price },
                        this.props.price
                    )
                )
            );
        }
    }]);

    return WGCWXShopProductCard;
}(_react2.default.Component);

WGCWXShopProductCard.propTypes = {
    title: _propTypes2.default.node.isRequired,
    description: _propTypes2.default.node,
    price: _propTypes2.default.node,
    boughtAmount: _propTypes2.default.number.isRequired,
    availableAmount: _propTypes2.default.number.isRequired,
    productType: _propTypes2.default.string.isRequired,
    groupName: _propTypes2.default.node,
    value: _propTypes2.default.number,
    size: _propTypes2.default.oneOf(['small', 'medium', 'large']).isRequired,
    main: _propTypes2.default.bool,
    isAvailable: _propTypes2.default.bool,
    hideCount: _propTypes2.default.bool,
    realm: _propTypes2.default.string.isRequired,

    onClick: _propTypes2.default.func.isRequired
};
exports.default = WGCWXShopProductCard;

/***/ }),
/* 2431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _uniqueId = __webpack_require__(574);

var _uniqueId2 = _interopRequireDefault(_uniqueId);

var _reactWotBootstrap = __webpack_require__(5);

var _FamePoints = __webpack_require__(143);

var _FamePoints2 = _interopRequireDefault(_FamePoints);

var _Back = __webpack_require__(70);

var _Back2 = _interopRequireDefault(_Back);

var _WGCWXConfirmation = __webpack_require__(238);

var _WGCWXConfirmation2 = _interopRequireDefault(_WGCWXConfirmation);

var _helpers = __webpack_require__(130);

var _constants = __webpack_require__(4);

var _products = __webpack_require__(576);

var _constants2 = __webpack_require__(92);

var _translations = __webpack_require__(237);

var _translations2 = __webpack_require__(2432);

var _propTypes3 = __webpack_require__(79);

var _WGCWXShopDetailedProduct = __webpack_require__(1377);

var _WGCWXShopDetailedProduct2 = _interopRequireDefault(_WGCWXShopDetailedProduct);

var _WGCWXConfirmation3 = __webpack_require__(1376);

var _WGCWXConfirmation4 = _interopRequireDefault(_WGCWXConfirmation3);

var _FilterSelectButton = __webpack_require__(2433);

var _FilterSelectButton2 = _interopRequireDefault(_FilterSelectButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WGCWXShopDetailedProduct = function (_React$Component) {
    _inherits(WGCWXShopDetailedProduct, _React$Component);

    _createClass(WGCWXShopDetailedProduct, null, [{
        key: 'getTooltipGroupContent',
        value: function getTooltipGroupContent(group) {
            return _react2.default.createElement(
                'p',
                { className: _WGCWXShopDetailedProduct2.default.tooltipSubtitle },
                (0, _translations.getTooltipTitleForGroup)(group)
            );
        }
    }]);

    function WGCWXShopDetailedProduct(props) {
        _classCallCheck(this, WGCWXShopDetailedProduct);

        var _this = _possibleConstructorReturn(this, (WGCWXShopDetailedProduct.__proto__ || Object.getPrototypeOf(WGCWXShopDetailedProduct)).call(this, props));

        _this.selectFirstAvailableGroup = function () {
            var groupsType = (0, _helpers.getGroupsType)(_this.props.product);
            if (groupsType !== _constants2.GROUP_TYPES.root) {
                var groupKeys = groupsType === _constants2.GROUP_TYPES.nation ? _this.sortNationsByRealm() : _this.getGroupKeys();
                return groupKeys.find(function (item) {
                    return !_this.groupIsBought(item);
                }) || groupKeys[0];
            }
        };

        _this.selectGroup = function (selectedGroup) {
            _this.setState({ selectedGroup: selectedGroup });
        };

        _this.isStyleAlreadyPurchased = function (product) {
            if (!product.is_one_time_purchase) return;
            var productToken = product.groups.root[0].token;

            return _this.props.globalMapStylesInInventory.includes(productToken);
        };

        _this.translateGroup = function (group) {
            if (group) {
                return _react2.default.createElement(
                    'span',
                    null,
                    ': ',
                    _translations.GROUP_CAPTIONS[group]
                );
            }
        };

        _this.handleKeyPress = function (e) {
            if (e.keyCode !== _constants.KEY_CODES.ESCAPE) return;

            if (_this.state.confirmationOpened) return;

            _this.props.close();
        };

        _this.openConfirmation = function () {
            _this.setState({ confirmationOpened: true });
        };

        _this.closeConfirmation = function () {
            _this.setState({ confirmationOpened: false });
        };

        _this.purchase = function () {
            var currentItem = _this.getCurrentItem();
            _this.props.purchaseItem(currentItem.id);
        };

        _this.showTankWarning = function (currentItem) {
            var tankItem = _this.props.tankProduct && _this.props.tankProduct[0];
            return tankItem && tankItem.price !== null && tankItem.price <= _this.props.accountFamePoints && _this.props.accountFamePoints - currentItem.price < tankItem.price && !_this.props.tankProduct.some(function (tankItem) {
                return tankItem.isSelected;
            });
        };

        _this.productConfig = _products.PRODUCTS_CONFIG[props.productType];

        _this.state = {
            confirmationOpened: false,
            selectedGroup: _this.selectFirstAvailableGroup()
        };
        _this.tooltipGroupId = (0, _uniqueId2.default)('group-tooltip-id-');
        return _this;
    }

    _createClass(WGCWXShopDetailedProduct, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.addEventListener('keydown', this.handleKeyPress);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('keydown', this.handleKeyPress);
        }
    }, {
        key: 'getGroups',
        value: function getGroups() {
            return Object.entries(this.props.product.groups);
        }
    }, {
        key: 'getGroupKeys',
        value: function getGroupKeys() {
            var groupKeys = Object.keys(this.props.product.groups);
            return groupKeys.map(function (item) {
                return item.split(':')[1];
            });
        }
    }, {
        key: 'getCurrentGroup',
        value: function getCurrentGroup() {
            var _this2 = this;

            var groups = this.getGroups();
            var currentGroup = groups.find(function (item) {
                return item[0].includes(_this2.state.selectedGroup);
            }) || groups[0];
            return currentGroup[1];
        }
    }, {
        key: 'getCurrentItem',
        value: function getCurrentItem() {
            var currentGroup = this.getCurrentGroup();
            return currentGroup.find(function (item) {
                return !item.is_bought;
            });
        }
    }, {
        key: 'groupIsBought',
        value: function groupIsBought(groupName) {
            var groups = this.getGroups();
            var group = groups.find(function (item) {
                return item[0].includes(groupName);
            });
            var groupValues = group[1];

            return !groupValues.find(function (item) {
                return !item.is_bought;
            });
        }
    }, {
        key: 'sortNationsByRealm',
        value: function sortNationsByRealm() {
            var _this3 = this;

            var realmNations = _constants.NATIONS_BY_REALM[this.props.realm];
            return realmNations.filter(function (item) {
                return _this3.getGroupKeys().includes(item);
            });
        }
    }, {
        key: 'renderFooterWithNotification',
        value: function renderFooterWithNotification(message) {
            return _react2.default.createElement(
                'div',
                { className: _WGCWXShopDetailedProduct2.default.footer },
                _react2.default.createElement(
                    'footer',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: _WGCWXShopDetailedProduct2.default.status },
                        _react2.default.createElement(_reactWotBootstrap.Icon, { glyph: 'info' }),
                        message
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _WGCWXShopDetailedProduct2.default.action },
                        _react2.default.createElement(
                            _reactWotBootstrap.Button,
                            { onClick: this.props.close },
                            _translations.AFFIRMATIVE
                        )
                    )
                )
            );
        }
    }, {
        key: 'renderFooterWithPrice',
        value: function renderFooterWithPrice(isAllPurchased, currentItem) {
            var lackOfFP = !isAllPurchased && currentItem.price > this.props.accountFamePoints;

            return _react2.default.createElement(
                'div',
                { className: _WGCWXShopDetailedProduct2.default.footer },
                _react2.default.createElement(
                    'footer',
                    null,
                    _react2.default.createElement('div', { className: _WGCWXShopDetailedProduct2.default.status }),
                    _react2.default.createElement(
                        'div',
                        { className: _WGCWXShopDetailedProduct2.default.action },
                        _react2.default.createElement(
                            'span',
                            { className: _WGCWXShopDetailedProduct2.default.price },
                            _react2.default.createElement(_FamePoints2.default, { value: currentItem.price, notAvailable: lackOfFP })
                        ),
                        _react2.default.createElement(
                            _reactWotBootstrap.Button,
                            {
                                isDisabled: lackOfFP,
                                tooltipId: lackOfFP ? this.props.productType : null,
                                onClick: this.openConfirmation
                            },
                            _translations2.PURCHASE_PRODUCT
                        ),
                        _react2.default.createElement(
                            _reactWotBootstrap.Tooltip,
                            { id: this.props.productType },
                            _translations2.NOT_ENOUGH_PFP
                        )
                    )
                )
            );
        }
    }, {
        key: 'renderFooter',
        value: function renderFooter(currentItem) {
            var isAllPurchased = this.props.accountFamePoints !== null && currentItem === undefined;
            var isPurchaseDisabled = isAllPurchased || !this.props.product.is_available_to_buy;

            if (isPurchaseDisabled) {
                var allBonusesPurchasedText = this.isAllGroupsAreBought ? _translations2.ALL_BONUSES_PURCHASED[_constants2.GROUP_TYPES.root] : _translations2.ALL_BONUSES_PURCHASED[(0, _helpers.getGroupsType)(this.props.product)];
                var allPurchasedText = isAllPurchased ? allBonusesPurchasedText : _translations2.PURCHASE_IS_NOT_AVAILABLE_YET;

                return this.renderFooterWithNotification(allPurchasedText);
            }

            if (this.isStyleAlreadyPurchased(this.props.product)) {
                return this.renderFooterWithNotification(_translations.STYLE_IS_IN_INVENTORY_ALREADY);
            }

            return this.renderFooterWithPrice(isAllPurchased, currentItem);
        }
    }, {
        key: 'renderItem',
        value: function renderItem(item, isCurrent) {
            var itemClassNames = (0, _classnames2.default)(_WGCWXShopDetailedProduct2.default.list_item, item.is_bought && _WGCWXShopDetailedProduct2.default.list_item__bought, isCurrent && _WGCWXShopDetailedProduct2.default.list_item__current);
            return _react2.default.createElement(
                'li',
                { key: item.id, className: itemClassNames },
                _react2.default.createElement(
                    'span',
                    { className: _WGCWXShopDetailedProduct2.default.list_item_title },
                    this.productConfig(item).shortDetailedTitle || this.productConfig(item).title,
                    this.getGroups().length > 1 && this.translateGroup(this.state.selectedGroup)
                ),
                !item.is_bought && _react2.default.createElement(
                    'span',
                    { className: _WGCWXShopDetailedProduct2.default.pfp },
                    _react2.default.createElement(_FamePoints2.default, { size: 'small', value: item.price, inactive: !isCurrent })
                )
            );
        }
    }, {
        key: 'renderGroupsButtons',
        value: function renderGroupsButtons() {
            var _this4 = this;

            var groupKeys = this.getGroupKeys();

            if ((0, _helpers.getGroupsType)(this.props.product) === _constants2.GROUP_TYPES.nation) {
                groupKeys = this.sortNationsByRealm();
            }

            return groupKeys.map(function (groupName) {
                var isChecked = _this4.state.selectedGroup === groupName;
                var classNameGroup = (0, _classnames2.default)(_WGCWXShopDetailedProduct2.default.group, _WGCWXShopDetailedProduct2.default['group__' + groupName], isChecked && _WGCWXShopDetailedProduct2.default.isActive, (0, _helpers.isCnRealm)(_this4.props.realm) && _WGCWXShopDetailedProduct2.default.isCnRealm);
                var classNameButton = (0, _classnames2.default)(_WGCWXShopDetailedProduct2.default.button, _defineProperty({}, _WGCWXShopDetailedProduct2.default.button__isBought, _this4.groupIsBought(groupName)));
                return _react2.default.createElement(_FilterSelectButton2.default, {
                    key: 'product-group-' + groupName,
                    isChecked: isChecked,
                    caption: _react2.default.createElement('span', { className: classNameGroup }),
                    value: groupName,
                    onChange: _this4.selectGroup,
                    tooltipId: _this4.tooltipGroupId,
                    cssClassName: classNameButton
                });
            });
        }
    }, {
        key: 'renderGroupsBlock',
        value: function renderGroupsBlock() {
            return _react2.default.createElement(
                'div',
                { className: _WGCWXShopDetailedProduct2.default.itemContent },
                _react2.default.createElement(
                    'span',
                    { className: _WGCWXShopDetailedProduct2.default.itemContent_title },
                    _translations2.NATIONS_TITLE
                ),
                _react2.default.createElement(
                    'div',
                    { className: _WGCWXShopDetailedProduct2.default.buttons },
                    this.renderGroupsButtons()
                )
            );
        }
    }, {
        key: 'renderPriceList',
        value: function renderPriceList(currentGroup, currentItem) {
            var _this5 = this;

            return _react2.default.createElement(
                'ul',
                { className: _WGCWXShopDetailedProduct2.default.list },
                currentGroup.map(function (item) {
                    return _this5.renderItem(item, item === currentItem);
                })
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var groups = this.getGroups();
            var currentGroup = this.getCurrentGroup();
            var currentItem = this.getCurrentItem();
            var groupsType = (0, _helpers.getGroupsType)(this.props.product);
            var hasOneGroup = groups.length === 1 && groupsType !== _constants2.GROUP_TYPES.root;
            var isNationalItem = groupsType === _constants2.GROUP_TYPES.nation;

            if (this.state.confirmationOpened) {
                var showTankWarning = this.showTankWarning(currentItem);
                var productTitle = this.productConfig(currentItem).title;
                var groupName = this.translateGroup(this.state.selectedGroup);

                return _react2.default.createElement(
                    _WGCWXConfirmation2.default,
                    {
                        messageType: showTankWarning ? 'alert' : undefined,
                        title: (0, _translations2.PURCHASE_PRODUCT_CONFIRMATION)(productTitle, groupName),
                        buttonsOptions: [{
                            caption: _translations.PURCHASE,
                            callback: this.purchase
                        }, {
                            caption: _translations.NO,
                            callback: this.closeConfirmation
                        }],
                        description: showTankWarning ? _translations2.NOT_ENOUGH_PFP_FOR_TANK_WARNING : undefined,
                        onClose: this.closeConfirmation
                    },
                    _react2.default.createElement(
                        'p',
                        { className: _WGCWXConfirmation4.default.price },
                        (0, _translations.CURRENCY_TO_SPEND)(_react2.default.createElement(_FamePoints2.default, { size: 'large', value: currentItem.price })),
                        _react2.default.createElement('span', { className: _WGCWXConfirmation4.default.price_divider }),
                        (0, _translations.CURRENCY_LEFT)(_react2.default.createElement(_FamePoints2.default, { size: 'large', value: this.props.accountFamePoints - currentItem.price }))
                    )
                );
            }

            var titleItem = currentItem || currentGroup[currentGroup.length - 1];

            var imageClassName = (0, _classnames2.default)(_WGCWXShopDetailedProduct2.default.image, _WGCWXShopDetailedProduct2.default['image__' + this.props.productType], (0, _helpers.isCnRealm)(this.props.realm) && _WGCWXShopDetailedProduct2.default.isCnRealm, this.props.productType === _constants2.PRODUCT_TYPES.PREMIUM_PLUS && _WGCWXShopDetailedProduct2.default['image__' + this.props.productType + '_' + titleItem.value], groupsType !== _constants2.GROUP_TYPES.root && _WGCWXShopDetailedProduct2.default['image__' + this.props.productType + '_' + this.state.selectedGroup]);

            var flagClassName = (0, _classnames2.default)(_WGCWXShopDetailedProduct2.default.flag, _WGCWXShopDetailedProduct2.default['flag__' + this.state.selectedGroup], (0, _helpers.isCnRealm)(this.props.realm) && _WGCWXShopDetailedProduct2.default.isCnRealm);

            var _productConfig = this.productConfig(titleItem),
                title = _productConfig.title,
                shortDetailedTitle = _productConfig.shortDetailedTitle,
                description = _productConfig.description,
                content = _productConfig.content;

            return _react2.default.createElement(
                'div',
                { className: _WGCWXShopDetailedProduct2.default.base },
                _react2.default.createElement(
                    'div',
                    { className: _WGCWXShopDetailedProduct2.default.holder },
                    _react2.default.createElement(
                        'div',
                        { className: _WGCWXShopDetailedProduct2.default.back },
                        _react2.default.createElement(
                            _Back2.default,
                            { handleClick: this.props.close },
                            _react2.default.createElement(
                                'span',
                                { className: _WGCWXShopDetailedProduct2.default.backTitle },
                                _translations.BACK_TO_MAIN
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'h1',
                        { className: _WGCWXShopDetailedProduct2.default.header },
                        shortDetailedTitle || title,
                        hasOneGroup && this.translateGroup(this.state.selectedGroup)
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _WGCWXShopDetailedProduct2.default.content },
                        _react2.default.createElement(
                            'div',
                            { className: _WGCWXShopDetailedProduct2.default.info },
                            _react2.default.createElement(
                                'p',
                                { className: _WGCWXShopDetailedProduct2.default.description },
                                description
                            ),
                            content && _react2.default.createElement(
                                'div',
                                { className: _WGCWXShopDetailedProduct2.default.itemContent },
                                _react2.default.createElement(
                                    'span',
                                    { className: _WGCWXShopDetailedProduct2.default.itemContent_title },
                                    _translations2.PRODUCT_CONTENT
                                ),
                                content
                            ),
                            isNationalItem && this.renderGroupsBlock(),
                            currentGroup.length > 1 && this.renderPriceList(currentGroup, currentItem)
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _WGCWXShopDetailedProduct2.default.imageContainer },
                            isNationalItem && _react2.default.createElement('div', { className: flagClassName }),
                            _react2.default.createElement('div', { className: imageClassName })
                        )
                    ),
                    this.renderFooter(currentItem)
                ),
                _react2.default.createElement(_reactWotBootstrap.Tooltip, { id: this.tooltipGroupId, getContent: WGCWXShopDetailedProduct.getTooltipGroupContent })
            );
        }
    }, {
        key: 'isAllGroupsAreBought',
        get: function get() {
            var _this6 = this;

            if ((0, _helpers.getGroupsType)(this.props.product) !== _constants2.GROUP_TYPES.root) {
                var groupKeys = this.getGroupKeys();
                return groupKeys.every(function (group) {
                    return _this6.groupIsBought(group);
                });
            }
            return false;
        }
    }]);

    return WGCWXShopDetailedProduct;
}(_react2.default.Component);

WGCWXShopDetailedProduct.propTypes = {
    accountFamePoints: _propTypes2.default.number.isRequired,
    product: _propTypes3.ProductPropTypes,
    tankProduct: _propTypes2.default.arrayOf(_propTypes3.RewardPropTypes),
    productType: _propTypes2.default.string.isRequired,
    realm: _propTypes2.default.string.isRequired,
    globalMapStylesInInventory: _propTypes2.default.arrayOf(_propTypes2.default.number).isRequired,

    purchaseItem: _propTypes2.default.func.isRequired,
    close: _propTypes2.default.func.isRequired
};
exports.default = WGCWXShopDetailedProduct;

/***/ }),
/* 2432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NATIONS_TITLE = exports.PRODUCT_CONTENT = exports.NOT_ENOUGH_PFP_FOR_TANK_WARNING = exports.PURCHASE_IS_NOT_AVAILABLE_YET = exports.ALL_BONUSES_PURCHASED = exports.PREMIUM_BONUSES_NOTICE = exports.PURCHASE_PRODUCT_CONFIRMATION = exports.PURCHASE_PRODUCT = exports.NOT_ENOUGH_PFP = undefined;

var _ALL_BONUSES_PURCHASE;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _constants = __webpack_require__(92);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint-disable react/no-multi-comp, max-len */


var NOT_ENOUGH_PFP = exports.NOT_ENOUGH_PFP = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.detailed_product.not_enough_pfp',
    defaultMessage: '\u041D\u0430 \u0432\u0430\u0448\u0435\u043C \u0441\u0447\u0435\u0442\u0443 \u043D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E \u041E\u0447\u043A\u043E\u0432 \u0441\u043B\u0430\u0432\u044B'
});

var PURCHASE_PRODUCT = exports.PURCHASE_PRODUCT = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.detailed_product.purchase_product',
    defaultMessage: '\u041A\u0443\u043F\u0438\u0442\u044C'
});

var PURCHASE_PRODUCT_CONFIRMATION = exports.PURCHASE_PRODUCT_CONFIRMATION = function PURCHASE_PRODUCT_CONFIRMATION(product, group) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop.detailed_product.purchase_product.confirmation',
        defaultMessage: '\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0431\u043E\u043D\u0443\u0441 \xAB{product}{group}\xBB?',
        values: { product: product, group: group }
    });
};

var PREMIUM_BONUSES_NOTICE = exports.PREMIUM_BONUSES_NOTICE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.detailed_product.premium_bonuses_notice',
    defaultMessage: '\u041F\u0440\u0438\u0437\u043E\u0432\u044B\u0435 \u0431\u043E\u043D\u0443\u0441\u044B \u0431\u0443\u0434\u0443\u0442 \u043D\u0430\u0447\u0438\u0441\u043B\u0435\u043D\u044B \u043D\u0430 \u0432\u0430\u0448 \u0430\u043A\u043A\u0430\u0443\u043D\u0442 \u043F\u043E\u0441\u043B\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u044D\u0442\u0430\u043F\u0430 \u043D\u0430\u0433\u0440\u0430\u0436\u0434\u0435\u043D\u0438\u044F.'
});

var ALL_BONUSES_PURCHASED = exports.ALL_BONUSES_PURCHASED = (_ALL_BONUSES_PURCHASE = {}, _defineProperty(_ALL_BONUSES_PURCHASE, _constants.GROUP_TYPES.root, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.detailed_product.all_bonuses_purchased',
    defaultMessage: '\u0412\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u043B\u0438 \u0432\u0441\u0435 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0431\u043E\u043D\u0443\u0441\u044B \u0432 \u0434\u0430\u043D\u043D\u043E\u0439 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u0438.'
})), _defineProperty(_ALL_BONUSES_PURCHASE, _constants.GROUP_TYPES.nation, _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.detailed_product.all_nation_bonuses_purchased',
    defaultMessage: '\u0412\u044B \u043F\u043E\u043B\u0443\u0447\u0438\u043B\u0438 \u0432\u0441\u0435 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0431\u043E\u043D\u0443\u0441\u044B \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u0439 \u043D\u0430\u0446\u0438\u0438.'
})), _ALL_BONUSES_PURCHASE);

var PURCHASE_IS_NOT_AVAILABLE_YET = exports.PURCHASE_IS_NOT_AVAILABLE_YET = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.detailed_product.purchase_is_not_available_yet',
    defaultMessage: '\u041F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435 \u043F\u0440\u0438\u0437\u043E\u0432 \u0441\u0442\u0430\u043D\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E \u0447\u0435\u0440\u0435\u0437 \u043D\u0435\u043A\u043E\u0442\u043E\u0440\u043E\u0435 \u0432\u0440\u0435\u043C\u044F \u043F\u043E\u0441\u043B\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0441\u043E\u0431\u044B\u0442\u0438\u044F.'
});

var NOT_ENOUGH_PFP_FOR_TANK_WARNING = exports.NOT_ENOUGH_PFP_FOR_TANK_WARNING = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.detailed_product.not_enough_pfp_for_tank_warning',
    defaultMessage: '\u0412 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u0435 \u0434\u0430\u043D\u043D\u043E\u0439 \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u0438 \u043D\u0430 \u0432\u0430\u0448\u0435\u043C \u0441\u0447\u0435\u0442\u0443 \u043E\u0441\u0442\u0430\u043D\u0435\u0442\u0441\u044F \u043C\u0435\u043D\u044C\u0448\u0435 \u041E\u0447\u043A\u043E\u0432 \u0441\u043B\u0430\u0432\u044B, \u0447\u0435\u043C \u0442\u0440\u0435\u0431\u0443\u0435\u0442\u0441\u044F \u0434\u043B\u044F \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u043F\u0440\u0438\u0437\u043E\u0432\u043E\u0439 \u043C\u0430\u0448\u0438\u043D\u044B.'
});

var PRODUCT_CONTENT = exports.PRODUCT_CONTENT = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.detailed_product.content',
    defaultMessage: '\u0421\u043E\u0441\u0442\u0430\u0432 \u043D\u0430\u0431\u043E\u0440\u0430'
});

var NATIONS_TITLE = exports.NATIONS_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.detailed_product.nations_title',
    defaultMessage: '\u0412\u044B\u0431\u043E\u0440 \u043D\u0430\u0446\u0438\u0438'
});

/***/ }),
/* 2433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ButtonToggleSmall = __webpack_require__(790);

var _ButtonToggleSmall2 = _interopRequireDefault(_ButtonToggleSmall);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable @typescript-eslint/no-explicit-any */


var FilterSelectButton = function (_React$Component) {
    _inherits(FilterSelectButton, _React$Component);

    function FilterSelectButton() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, FilterSelectButton);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FilterSelectButton.__proto__ || Object.getPrototypeOf(FilterSelectButton)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function () {
            _this.props.onChange(_this.props.value);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(FilterSelectButton, [{
        key: 'render',
        value: function render() {
            var tooltipProps = this.props.tooltipId ? {
                'data-tip': this.props.value,
                'data-for': this.props.tooltipId
            } : {};

            return _react2.default.createElement(
                'div',
                _extends({}, tooltipProps, { className: this.props.cssClassName }),
                _react2.default.createElement(_ButtonToggleSmall2.default, {
                    caption: this.props.caption,
                    isChecked: this.props.isChecked,
                    tabIndex: 0,
                    onClick: this.handleClick
                })
            );
        }
    }]);

    return FilterSelectButton;
}(_react2.default.Component);

FilterSelectButton.propTypes = {
    value: _propTypes2.default.any,
    isChecked: _propTypes2.default.bool,
    caption: _propTypes2.default.element,
    onChange: _propTypes2.default.func.isRequired,
    tooltipId: _propTypes2.default.string,
    cssClassName: _propTypes2.default.string
};
exports.default = FilterSelectButton;

/***/ }),
/* 2434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _propTypes3 = __webpack_require__(79);

var _WGCWXRewardsGrid = __webpack_require__(2435);

var _WGCWXRewardsGrid2 = _interopRequireDefault(_WGCWXRewardsGrid);

var _translations = __webpack_require__(577);

var _WGCWXRewards = __webpack_require__(578);

var _WGCWXRewards2 = _interopRequireDefault(_WGCWXRewards);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WGCWXRewards = function (_React$Component) {
    _inherits(WGCWXRewards, _React$Component);

    function WGCWXRewards() {
        _classCallCheck(this, WGCWXRewards);

        return _possibleConstructorReturn(this, (WGCWXRewards.__proto__ || Object.getPrototypeOf(WGCWXRewards)).apply(this, arguments));
    }

    _createClass(WGCWXRewards, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                rewards = _props.rewards,
                rewardsMeta = _props.rewardsMeta,
                accountBalance = _props.accountBalance,
                selectReward = _props.selectReward,
                isAddToComparisonAvailable = _props.isAddToComparisonAvailable;


            return _react2.default.createElement(
                'div',
                { className: _WGCWXRewards2.default.base },
                _react2.default.createElement('div', { className: _WGCWXRewards2.default.hangar }),
                _react2.default.createElement(
                    'div',
                    { className: _WGCWXRewards2.default.container },
                    _react2.default.createElement(
                        'div',
                        { className: _WGCWXRewards2.default.content },
                        _react2.default.createElement(
                            'h1',
                            { className: _WGCWXRewards2.default.title },
                            _translations.EVENT_REWARDS
                        ),
                        _react2.default.createElement(_WGCWXRewardsGrid2.default, {
                            rewards: rewards,
                            rewardsMeta: rewardsMeta,
                            accountBalance: accountBalance,
                            selectReward: selectReward,
                            isAddToComparisonAvailable: isAddToComparisonAvailable
                        })
                    )
                )
            );
        }
    }]);

    return WGCWXRewards;
}(_react2.default.Component);

WGCWXRewards.propTypes = {
    rewards: _propTypes2.default.arrayOf(_propTypes3.RewardPropTypes),
    rewardsMeta: _propTypes3.RewardsMetaPropTypes,
    accountBalance: _propTypes3.BalancePropTypes,
    selectReward: _propTypes2.default.func.isRequired,
    isAddToComparisonAvailable: _propTypes2.default.bool.isRequired
};
exports.default = WGCWXRewards;

/***/ }),
/* 2435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

var _propTypes3 = __webpack_require__(79);

var _WGCWXRewardsTankCard = __webpack_require__(2436);

var _WGCWXRewardsTankCard2 = _interopRequireDefault(_WGCWXRewardsTankCard);

var _reactWotBootstrap = __webpack_require__(5);

var _constants = __webpack_require__(92);

var _constants2 = __webpack_require__(579);

var _translations = __webpack_require__(577);

var _WGCWXRewards = __webpack_require__(578);

var _WGCWXRewards2 = _interopRequireDefault(_WGCWXRewards);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WGCWXRewardsGrid = function (_React$Component) {
    _inherits(WGCWXRewardsGrid, _React$Component);

    function WGCWXRewardsGrid(props) {
        _classCallCheck(this, WGCWXRewardsGrid);

        var _this = _possibleConstructorReturn(this, (WGCWXRewardsGrid.__proto__ || Object.getPrototypeOf(WGCWXRewardsGrid)).call(this, props));

        _this.handleResize = function () {
            _this.setScrollAreaHeight();
        };

        _this.state = {
            scrollableAreaHeight: 0
        };

        _this.BOTTOM_SCROLL_OFFSET = 10;
        _this.SCROLL_STEP = 50;
        return _this;
    }

    _createClass(WGCWXRewardsGrid, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.addEventListener('resize', this.handleResize);

            this.setScrollAreaHeight();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('resize', this.handleResize);
        }
    }, {
        key: 'setScrollAreaHeight',
        value: function setScrollAreaHeight() {
            if (!this._body) return;
            var coords = this._body.getBoundingClientRect();
            var height = window.innerHeight - coords.top - this.BOTTOM_SCROLL_OFFSET;
            this.setState({ scrollableAreaHeight: height });
        }
    }, {
        key: 'renderRewardsConditions',
        value: function renderRewardsConditions() {
            var _props$rewardsMeta = this.props.rewardsMeta,
                places = _props$rewardsMeta.places,
                purchaseDatetimeEnd = _props$rewardsMeta.purchaseDatetimeEnd,
                famePoints = _props$rewardsMeta.famePoints,
                hasAuctionTicket = _props$rewardsMeta.hasAuctionTicket,
                currentBet = _props$rewardsMeta.currentBet;


            var rewardsPrices = this.props.rewards.map(function (reward) {
                return reward.price;
            });
            var minRewardPrice = Math.min.apply(Math, _toConsumableArray(rewardsPrices));

            var isEnoughPfp = famePoints >= minRewardPrice;
            var datetimeEnd = _moment2.default.utc(purchaseDatetimeEnd).local();

            switch (true) {
                case !minRewardPrice && !hasAuctionTicket:
                    return _react2.default.createElement(
                        'p',
                        { className: _WGCWXRewards2.default.requirements },
                        (0, _translations.REWARDS_TANK_HAS_NO_AUCTION_TICKET)(places)
                    );
                case !minRewardPrice && hasAuctionTicket:
                    return _react2.default.createElement(
                        'p',
                        { className: _WGCWXRewards2.default.requirements },
                        (0, _translations.REWARDS_TANK_HAS_AUCTION_TICKET)(places)
                    );
                case minRewardPrice && isEnoughPfp:
                    return _react2.default.createElement(
                        'p',
                        { className: _WGCWXRewards2.default.requirements },
                        (0, _translations.ENOUGH_PFP_FOR_TANK_RECEIVING)(datetimeEnd, places)
                    );
                case minRewardPrice && !hasAuctionTicket && !currentBet:
                    return _react2.default.createElement(
                        'p',
                        { className: _WGCWXRewards2.default.requirements },
                        _translations.EVENT_FINISHED_HAS_NO_AUCTION_TICKET
                    );
                default:
                    return _react2.default.createElement(
                        'p',
                        { className: _WGCWXRewards2.default.requirements },
                        (0, _translations.NOT_ENOUGH_PFP_FOR_TANK_RECEIVING)(datetimeEnd)
                    );
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var tanksRewards = this.props.rewards.filter(function (reward) {
                return reward.type === _constants.REWARDS_TYPES.TANK && reward.vehicleParams;
            });

            return _react2.default.createElement(
                'div',
                { className: _WGCWXRewards2.default.content },
                _react2.default.createElement(
                    'h2',
                    { className: _WGCWXRewards2.default.category },
                    _translations.REWARDS_TANKS_SECTION
                ),
                this.renderRewardsConditions(),
                _react2.default.createElement(
                    'div',
                    { ref: function ref(c) {
                            return _this2._body = c;
                        }, className: _WGCWXRewards2.default.body },
                    _react2.default.createElement(
                        _reactWotBootstrap.ScrollArea,
                        {
                            stepHeight: this.SCROLL_STEP,
                            scrollableAreaHeight: this.state.scrollableAreaHeight
                        },
                        _react2.default.createElement(
                            'div',
                            { className: _WGCWXRewards2.default.grid },
                            tanksRewards.map(function (tank) {
                                return _react2.default.createElement(_WGCWXRewardsTankCard2.default, {
                                    key: tank.id,
                                    tank: tank,
                                    tanks: tanksRewards,
                                    rewardsMeta: _this2.props.rewardsMeta,
                                    accountBalance: _this2.props.accountBalance,
                                    selectReward: _this2.props.selectReward,
                                    isAddToComparisonAvailable: _this2.props.isAddToComparisonAvailable
                                });
                            })
                        )
                    )
                ),
                this.props.isAddToComparisonAvailable && _react2.default.createElement(
                    _reactWotBootstrap.Tooltip,
                    { id: _constants2.VEHICLE_TO_COMPARE_TOOLTIP.id },
                    _constants2.VEHICLE_TO_COMPARE_TOOLTIP.message
                )
            );
        }
    }]);

    return WGCWXRewardsGrid;
}(_react2.default.Component);

WGCWXRewardsGrid.propTypes = {
    rewards: _propTypes2.default.arrayOf(_propTypes3.RewardPropTypes),
    rewardsMeta: _propTypes3.RewardsMetaPropTypes,
    accountBalance: _propTypes3.BalancePropTypes,
    selectReward: _propTypes2.default.func.isRequired,
    isAddToComparisonAvailable: _propTypes2.default.bool.isRequired
};
exports.default = WGCWXRewardsGrid;

/***/ }),
/* 2436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WGCWXRewardsTankCard = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _helpers = __webpack_require__(11);

var _reactRedux = __webpack_require__(7);

var _translations = __webpack_require__(577);

var _reactWotBootstrap = __webpack_require__(5);

var _helpers2 = __webpack_require__(130);

var _constants = __webpack_require__(2437);

var _propTypes3 = __webpack_require__(79);

var _VehicleAddToComparison = __webpack_require__(1379);

var _VehicleAddToComparison2 = _interopRequireDefault(_VehicleAddToComparison);

var _VehicleType = __webpack_require__(68);

var _VehicleType2 = _interopRequireDefault(_VehicleType);

var _FamePoints = __webpack_require__(143);

var _FamePoints2 = _interopRequireDefault(_FamePoints);

var _WGCWXRewardsTankCard = __webpack_require__(2439);

var _WGCWXRewardsTankCard2 = _interopRequireDefault(_WGCWXRewardsTankCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WGCWXRewardsTankCard = exports.WGCWXRewardsTankCard = function (_React$Component) {
    _inherits(WGCWXRewardsTankCard, _React$Component);

    function WGCWXRewardsTankCard(props) {
        _classCallCheck(this, WGCWXRewardsTankCard);

        var _this = _possibleConstructorReturn(this, (WGCWXRewardsTankCard.__proto__ || Object.getPrototypeOf(WGCWXRewardsTankCard)).call(this, props));

        _this.handleMouseEnter = function () {
            (0, _reactWotBootstrap.sendHoverSoundCommand)();
        };

        _this.handleMouseDown = function () {
            (0, _reactWotBootstrap.sendClickSoundCommand)();
        };

        _this.handleClick = function (rewardId) {
            return function (event) {
                event.preventDefault();
                _this.props.selectReward(rewardId);
            };
        };

        _this.renderCompareComponent = function (vehicleId) {
            if (!_this.props.isAddToComparisonAvailable) return null;

            return _react2.default.createElement(_VehicleAddToComparison2.default, {
                vehicleCd: vehicleId,
                mixClassName: _WGCWXRewardsTankCard2.default.addToCompare
            });
        };

        _this.islackOfBonds = function () {
            var _this$props$rewardsMe = _this.props.rewardsMeta,
                minBet = _this$props$rewardsMe.minBet,
                famePoints = _this$props$rewardsMe.famePoints,
                hasAuctionTicket = _this$props$rewardsMe.hasAuctionTicket;
            var _this$props$tank = _this.props.tank,
                price = _this$props$tank.price,
                secondPrice = _this$props$tank.secondPrice;
            var bonds = _this.props.accountBalance.crystal;

            var isEnoughPfp = famePoints >= price;

            if (hasAuctionTicket) {
                return isEnoughPfp ? bonds < secondPrice : bonds < minBet;
            } else {
                return bonds < secondPrice;
            }
        };

        _this.defineCardStatus = function () {
            var _this$props$rewardsMe2 = _this.props.rewardsMeta,
                famePoints = _this$props$rewardsMe2.famePoints,
                currentBet = _this$props$rewardsMe2.currentBet,
                hasAuctionTicket = _this$props$rewardsMe2.hasAuctionTicket;
            var _this$props$tank2 = _this.props.tank,
                inHangar = _this$props$tank2.inHangar,
                token = _this$props$tank2.token,
                price = _this$props$tank2.price;


            var isRewardingStarted = _this.props.tanks.every(function (tank) {
                return tank.price > 0;
            });

            var selectedTankInfo = _this.props.tanks.find(function (tank) {
                return tank.isSelected;
            });
            var isCurrentTankSelected = selectedTankInfo && selectedTankInfo.token === token;

            var isEnoughPfp = famePoints >= price;

            switch (true) {
                case inHangar && !isCurrentTankSelected:
                    return _constants.CARD_STATUS_TYPES.TANK_IN_HANGAR;

                case isCurrentTankSelected && !currentBet:
                    return _constants.CARD_STATUS_TYPES.REWARD_RECEIVED;

                case selectedTankInfo && !isCurrentTankSelected:
                    return _constants.CARD_STATUS_TYPES.OTHER_REWARD_SELECTED;

                case !isRewardingStarted:
                    return _constants.CARD_STATUS_TYPES.REWARDING_NOT_STARTED;

                case !selectedTankInfo && isEnoughPfp || !hasAuctionTicket && !currentBet:
                    return _constants.CARD_STATUS_TYPES.REWARDING_STARTED;

                case !isEnoughPfp && !currentBet:
                    return _constants.CARD_STATUS_TYPES.AUCTION_AVAILABLE;

                default:
                    return _constants.CARD_STATUS_TYPES.AUCTION_BET_APPLIED;
            }
        };

        _this.renderTankStatus = function () {
            var cardStatus = _this.state.cardStatus;
            var _this$props$rewardsMe3 = _this.props.rewardsMeta,
                currentBet = _this$props$rewardsMe3.currentBet,
                minBet = _this$props$rewardsMe3.minBet;
            var _this$props$tank3 = _this.props.tank,
                price = _this$props$tank3.price,
                secondPrice = _this$props$tank3.secondPrice;
            var isWGMoneyAvailable = _this.props.accountBalance.isWGMoneyAvailable;


            var lackOfBonds = false;

            if (isWGMoneyAvailable) {
                lackOfBonds = _this.islackOfBonds();
            }

            var okIconClassNames = (0, _classnames2.default)(_WGCWXRewardsTankCard2.default.statusIcon, _WGCWXRewardsTankCard2.default.statusIcon__ok);
            var hangarIconClassNames = (0, _classnames2.default)(_WGCWXRewardsTankCard2.default.statusIcon, _WGCWXRewardsTankCard2.default.statusIcon__inHangar);
            var lockedIconClassNames = (0, _classnames2.default)(_WGCWXRewardsTankCard2.default.statusIcon, _WGCWXRewardsTankCard2.default.statusIcon__locked);
            var bondsClassNames = (0, _classnames2.default)(_WGCWXRewardsTankCard2.default.bonds, _defineProperty({}, _WGCWXRewardsTankCard2.default.bonds__notEnough, lackOfBonds));

            switch (cardStatus) {
                case _constants.CARD_STATUS_TYPES.TANK_IN_HANGAR:
                    return _react2.default.createElement(
                        'div',
                        { className: _WGCWXRewardsTankCard2.default.status },
                        _react2.default.createElement('span', { className: hangarIconClassNames }),
                        _translations.TANK_IS_IN_HANGAR
                    );

                case _constants.CARD_STATUS_TYPES.REWARD_RECEIVED:
                    return _react2.default.createElement(
                        'div',
                        { className: _WGCWXRewardsTankCard2.default.status },
                        _react2.default.createElement('span', { className: okIconClassNames }),
                        _translations.REWARD_RECEIVED
                    );

                case _constants.CARD_STATUS_TYPES.OTHER_REWARD_SELECTED:
                    return _react2.default.createElement(
                        'div',
                        { className: _WGCWXRewardsTankCard2.default.status },
                        _react2.default.createElement('span', { className: lockedIconClassNames }),
                        _translations.OTHER_REWARD_SELECTED
                    );

                case _constants.CARD_STATUS_TYPES.REWARDING_NOT_STARTED:
                    return _react2.default.createElement(
                        'div',
                        { className: _WGCWXRewardsTankCard2.default.status },
                        _react2.default.createElement(_reactWotBootstrap.Bons, {
                            size: 'large',
                            iconPosition: 'after',
                            value: secondPrice,
                            mixClassName: _WGCWXRewardsTankCard2.default.bonds
                        }),
                        _react2.default.createElement('span', { className: _WGCWXRewardsTankCard2.default.plus }),
                        _translations.PFP_NAME
                    );

                case _constants.CARD_STATUS_TYPES.REWARDING_STARTED:
                    return _react2.default.createElement(
                        'div',
                        { className: _WGCWXRewardsTankCard2.default.status },
                        _react2.default.createElement(_reactWotBootstrap.Bons, {
                            size: 'large',
                            iconPosition: 'after',
                            value: secondPrice,
                            mixClassName: bondsClassNames
                        }),
                        _react2.default.createElement('span', { className: _WGCWXRewardsTankCard2.default.plus }),
                        _react2.default.createElement(_FamePoints2.default, {
                            value: price,
                            size: 'medium'
                        })
                    );

                case _constants.CARD_STATUS_TYPES.AUCTION_AVAILABLE:
                    return _react2.default.createElement(
                        'div',
                        { className: _WGCWXRewardsTankCard2.default.status },
                        _translations.AUCTION_START_FROM,
                        _react2.default.createElement(_reactWotBootstrap.Bons, {
                            size: 'large',
                            iconPosition: 'after',
                            value: minBet,
                            mixClassName: (0, _classnames2.default)(bondsClassNames, _WGCWXRewardsTankCard2.default.bonds__afterText)
                        })
                    );
                case _constants.CARD_STATUS_TYPES.AUCTION_BET_APPLIED:
                    return _react2.default.createElement(
                        'div',
                        { className: _WGCWXRewardsTankCard2.default.status },
                        _react2.default.createElement('span', { className: okIconClassNames }),
                        _translations.AUCTION_BET_APPLIED,
                        isWGMoneyAvailable && _react2.default.createElement(_reactWotBootstrap.Bons, {
                            size: 'large',
                            iconPosition: 'after',
                            value: currentBet,
                            mixClassName: (0, _classnames2.default)(_WGCWXRewardsTankCard2.default.bonds, _WGCWXRewardsTankCard2.default.bonds__afterText)
                        })
                    );
            }
        };

        _this.state = {
            cardStatus: _this.defineCardStatus()
        };
        return _this;
    }

    _createClass(WGCWXRewardsTankCard, [{
        key: 'render',
        value: function render() {
            var id = this.props.tank.id;
            var _props$tank$vehiclePa = this.props.tank.vehicleParams,
                level = _props$tank$vehiclePa.level,
                type = _props$tank$vehiclePa.type,
                userName = _props$tank$vehiclePa.userName,
                vehicleId = _props$tank$vehiclePa.vehicleId,
                isPremium = _props$tank$vehiclePa.isPremium;


            var isSuccessCard = this.state.cardStatus === _constants.CARD_STATUS_TYPES.REWARD_RECEIVED || this.state.cardStatus === _constants.CARD_STATUS_TYPES.AUCTION_BET_APPLIED;

            var tankImageClassNames = (0, _classnames2.default)(_WGCWXRewardsTankCard2.default.tank, _WGCWXRewardsTankCard2.default['tank__' + vehicleId], (0, _helpers2.isCnRealm)(this.props.realm) && _WGCWXRewardsTankCard2.default.isCnRealm);
            var cardClassNames = (0, _classnames2.default)(_WGCWXRewardsTankCard2.default.base, _defineProperty({}, _WGCWXRewardsTankCard2.default.base__success, isSuccessCard));

            var tankLevel = (0, _helpers.toRoman)(level);

            return _react2.default.createElement(
                'div',
                {
                    className: cardClassNames,
                    onMouseEnter: this.handleMouseEnter,
                    onMouseDown: this.handleMouseDown,
                    onClick: this.handleClick(id),
                    id: 'reward-pack-' + id
                },
                this.renderCompareComponent(vehicleId),
                _react2.default.createElement(
                    'div',
                    { className: _WGCWXRewardsTankCard2.default.holder },
                    _react2.default.createElement('span', { className: tankImageClassNames }),
                    _react2.default.createElement(
                        'p',
                        { className: _WGCWXRewardsTankCard2.default.info },
                        _react2.default.createElement(
                            'span',
                            { className: _WGCWXRewardsTankCard2.default.level },
                            tankLevel
                        ),
                        _react2.default.createElement(_VehicleType2.default, { type: type, premium: isPremium }),
                        _react2.default.createElement(
                            'span',
                            { className: _WGCWXRewardsTankCard2.default.name },
                            userName
                        )
                    ),
                    this.renderTankStatus()
                )
            );
        }
    }]);

    return WGCWXRewardsTankCard;
}(_react2.default.Component);

WGCWXRewardsTankCard.propTypes = {
    tank: _propTypes3.RewardPropTypes,
    tanks: _propTypes2.default.arrayOf(_propTypes3.RewardPropTypes),
    rewardsMeta: _propTypes3.RewardsMetaPropTypes,
    accountBalance: _propTypes3.BalancePropTypes,
    selectReward: _propTypes2.default.func.isRequired,
    isAddToComparisonAvailable: _propTypes2.default.bool.isRequired,
    realm: _propTypes2.default.string.isRequired
};


var mapStateToProps = function mapStateToProps(state) {
    return {
        realm: state.settings.realm
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(WGCWXRewardsTankCard);

/***/ }),
/* 2437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var CARD_STATUS_TYPES = exports.CARD_STATUS_TYPES = {
    TANK_IN_HANGAR: 'TANK_IN_HANGAR',
    REWARD_RECEIVED: 'REWARD_RECEIVED',
    OTHER_REWARD_SELECTED: 'OTHER_REWARD_SELECTED',
    REWARDING_NOT_STARTED: 'REWARDING_NOT_STARTED',
    REWARDING_STARTED: 'REWARDING_STARTED',
    AUCTION_AVAILABLE: 'AUCTION_AVAILABLE',
    AUCTION_BET_APPLIED: 'AUCTION_BET_APPLIED'
};

/***/ }),
/* 2438 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"VehicleAddToComparison_base--MGxOE"};

/***/ }),
/* 2439 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"WGCWXRewardsTankCard_base--1bq7f","addToCompare":"WGCWXRewardsTankCard_addToCompare--3aMNm","holder":"WGCWXRewardsTankCard_holder--2KOsx","base__success":"WGCWXRewardsTankCard_base__success--2Ex9D","baseSuccess":"WGCWXRewardsTankCard_base__success--2Ex9D","tank":"WGCWXRewardsTankCard_tank--vG0Ce","tank__50849":"WGCWXRewardsTankCard_tank__50849--3wjNI","tank50849":"WGCWXRewardsTankCard_tank__50849--3wjNI","isCnRealm":"WGCWXRewardsTankCard_isCnRealm--9x9nQ","tank__55841":"WGCWXRewardsTankCard_tank__55841--6D99n","tank55841":"WGCWXRewardsTankCard_tank__55841--6D99n","tank__15617":"WGCWXRewardsTankCard_tank__15617--3jDWb","tank15617":"WGCWXRewardsTankCard_tank__15617--3jDWb","tank__63537":"WGCWXRewardsTankCard_tank__63537--1bpHe","tank63537":"WGCWXRewardsTankCard_tank__63537--1bpHe","tank__15905":"WGCWXRewardsTankCard_tank__15905--2ixz2","tank15905":"WGCWXRewardsTankCard_tank__15905--2ixz2","tank__58641":"WGCWXRewardsTankCard_tank__58641--27SJ8","tank58641":"WGCWXRewardsTankCard_tank__58641--27SJ8","tank__57937":"WGCWXRewardsTankCard_tank__57937--1w6gF","tank57937":"WGCWXRewardsTankCard_tank__57937--1w6gF","tank__59441":"WGCWXRewardsTankCard_tank__59441--3GJRC","tank59441":"WGCWXRewardsTankCard_tank__59441--3GJRC","info":"WGCWXRewardsTankCard_info--1UDCl","level":"WGCWXRewardsTankCard_level--31O5-","name":"WGCWXRewardsTankCard_name--TeXAL","status":"WGCWXRewardsTankCard_status--rOlAV","statusIcon":"WGCWXRewardsTankCard_statusIcon--1nF4U","statusIcon__inHangar":"WGCWXRewardsTankCard_statusIcon__inHangar--1XKT8","statusIconInHangar":"WGCWXRewardsTankCard_statusIcon__inHangar--1XKT8","statusIcon__locked":"WGCWXRewardsTankCard_statusIcon__locked--1pcOv","statusIconLocked":"WGCWXRewardsTankCard_statusIcon__locked--1pcOv","statusIcon__ok":"WGCWXRewardsTankCard_statusIcon__ok--3DqrZ","statusIconOk":"WGCWXRewardsTankCard_statusIcon__ok--3DqrZ","bonds":"WGCWXRewardsTankCard_bonds--3aRzi","bonds__notEnough":"WGCWXRewardsTankCard_bonds__notEnough--yrEw2","bondsNotEnough":"WGCWXRewardsTankCard_bonds__notEnough--yrEw2","bonds__afterText":"WGCWXRewardsTankCard_bonds__afterText--Rj3SL","bondsAfterText":"WGCWXRewardsTankCard_bonds__afterText--Rj3SL","plus":"WGCWXRewardsTankCard_plus--3c-LP"};

/***/ }),
/* 2440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WGCWXRewardsTank = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(7);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactWotBootstrap = __webpack_require__(5);

var _FamePoints = __webpack_require__(143);

var _FamePoints2 = _interopRequireDefault(_FamePoints);

var _VehicleType = __webpack_require__(68);

var _VehicleType2 = _interopRequireDefault(_VehicleType);

var _VehicleAddToComparison = __webpack_require__(1379);

var _VehicleAddToComparison2 = _interopRequireDefault(_VehicleAddToComparison);

var _constants = __webpack_require__(579);

var _products = __webpack_require__(576);

var _Back = __webpack_require__(70);

var _Back2 = _interopRequireDefault(_Back);

var _TankInfo = __webpack_require__(2441);

var _TankInfo2 = _interopRequireDefault(_TankInfo);

var _Footer = __webpack_require__(2443);

var _Footer2 = _interopRequireDefault(_Footer);

var _WGCWXRewardsTankConfirmation = __webpack_require__(2449);

var _WGCWXRewardsTankConfirmation2 = _interopRequireDefault(_WGCWXRewardsTankConfirmation);

var _propTypes3 = __webpack_require__(79);

var _helpers = __webpack_require__(11);

var _helpers2 = __webpack_require__(130);

var _constants2 = __webpack_require__(4);

var _WGCWXRewardsTank = __webpack_require__(2450);

var _WGCWXRewardsTank2 = _interopRequireDefault(_WGCWXRewardsTank);

var _WGCWXRewardsTankConfirmation3 = __webpack_require__(1382);

var _WGCWXRewardsTankConfirmation4 = _interopRequireDefault(_WGCWXRewardsTankConfirmation3);

var _translations = __webpack_require__(1380);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WGCWXRewardsTank = exports.WGCWXRewardsTank = function (_Component) {
    _inherits(WGCWXRewardsTank, _Component);

    function WGCWXRewardsTank(props) {
        _classCallCheck(this, WGCWXRewardsTank);

        var _this = _possibleConstructorReturn(this, (WGCWXRewardsTank.__proto__ || Object.getPrototypeOf(WGCWXRewardsTank)).call(this, props));

        _this.handleBackButtonClick = function () {
            _this.props.backToRewardsHandler();
        };

        _this.onClose = function () {
            _this.props.backToRewardsHandler();
        };

        _this.handleKeyPress = function (e) {
            if (e.keyCode !== _constants2.KEY_CODES.ESCAPE) return;
            if (_this.state.tankPurchaseConfirmationOpened || _this.state.cancelBetConfirmationOpened) return;
            _this.props.backToRewardsHandler();
        };

        _this.openTankPurchaseConfirmation = function () {
            _this.setState({ tankPurchaseConfirmationOpened: true });
        };

        _this.closeTankPurchaseConfirmation = function () {
            _this.setState({ tankPurchaseConfirmationOpened: false });
        };

        _this.purchaseTank = function () {
            _this.props.purchaseItem(_this.state.selectedTank.id);
        };

        _this.openCancelBetConfirmation = function () {
            _this.setState({ cancelBetConfirmationOpened: true });
        };

        _this.closeCancelBetConfirmation = function () {
            _this.setState({ cancelBetConfirmationOpened: false });
        };

        _this.handleBetChange = function (bet) {
            _this.setState({ bet: bet });
        };

        _this.makeBet = function () {
            _this.props.makeRewardAuctionBet(_this.state.bet, _this.state.selectedTank.id);
        };

        _this.cancelBet = function () {
            _this.props.cancelRewardAuctionBet();
        };

        _this.renderCompareComponent = function () {
            if (!_this.props.isAddToComparisonAvailable) return null;

            return _react2.default.createElement(_VehicleAddToComparison2.default, {
                vehicleCd: _this.state.selectedTank.token,
                mixClassName: _WGCWXRewardsTank2.default.buttonCompare
            });
        };

        _this.state = {
            tankPurchaseConfirmationOpened: false,
            cancelBetConfirmationOpened: false,
            bet: props.rewardsMeta.minBet,
            selectedTank: props.selectedTank[0],
            meta: props.rewardsMeta,
            anyTankSelected: props.anyTankSelected,
            oldCrystalBalance: props.accountBalance.crystal
        };
        return _this;
    }

    _createClass(WGCWXRewardsTank, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.addEventListener('keydown', this.handleKeyPress);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (prevProps.accountBalance.crystal !== this.props.accountBalance.crystal) {
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    oldCrystalBalance: prevProps.accountBalance.crystal
                });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('keydown', this.handleKeyPress);
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                bet = _state.bet,
                selectedTank = _state.selectedTank,
                vehicleParams = _state.selectedTank.vehicleParams,
                meta = _state.meta,
                anyTankSelected = _state.anyTankSelected,
                oldCrystalBalance = _state.oldCrystalBalance,
                tankPurchaseConfirmationOpened = _state.tankPurchaseConfirmationOpened,
                cancelBetConfirmationOpened = _state.cancelBetConfirmationOpened;
            var inHangar = selectedTank.inHangar,
                isSelected = selectedTank.isSelected,
                price = selectedTank.price,
                secondPrice = selectedTank.secondPrice;
            var level = vehicleParams.level,
                userName = vehicleParams.userName,
                type = vehicleParams.type,
                nation = vehicleParams.nation,
                vehicleId = vehicleParams.vehicleId;
            var famePoints = meta.famePoints;
            var _props = this.props,
                wgMoneyServiceError = _props.wgMoneyServiceError,
                accountBalance = _props.accountBalance;

            var tankLevel = (0, _helpers.toRoman)(level);

            var baseClassName = (0, _classnames2.default)(_WGCWXRewardsTank2.default.base, (tankPurchaseConfirmationOpened || cancelBetConfirmationOpened) && _WGCWXRewardsTank2.default.base__blur);

            var nationalityClassName = (0, _classnames2.default)(_WGCWXRewardsTank2.default.nationality, _WGCWXRewardsTank2.default['nationality__' + nation], (0, _helpers2.isCnRealm)(this.props.realm) && _WGCWXRewardsTank2.default.isCnRealm);
            var tankBgClassName = (0, _classnames2.default)(_WGCWXRewardsTank2.default.tankBg, _WGCWXRewardsTank2.default['tankBg__' + vehicleId], (0, _helpers2.isCnRealm)(this.props.realm) && _WGCWXRewardsTank2.default.isCnRealm);

            return _react2.default.createElement(
                'div',
                { className: _WGCWXRewardsTank2.default.baseWrapper },
                _react2.default.createElement(
                    'div',
                    { className: baseClassName },
                    _react2.default.createElement(
                        'div',
                        { className: _WGCWXRewardsTank2.default.back },
                        _react2.default.createElement(
                            _Back2.default,
                            { handleClick: this.handleBackButtonClick },
                            _react2.default.createElement(
                                'span',
                                { className: _WGCWXRewardsTank2.default.backTitle },
                                _translations.AFFIRMATIVE_BUTTON
                            )
                        )
                    ),
                    _react2.default.createElement('div', { className: _WGCWXRewardsTank2.default.hangarBg }),
                    _react2.default.createElement('div', { className: tankBgClassName }),
                    _react2.default.createElement(
                        'div',
                        { className: _WGCWXRewardsTank2.default.main },
                        _react2.default.createElement(
                            'div',
                            { className: _WGCWXRewardsTank2.default.wrapper },
                            _react2.default.createElement(
                                'div',
                                { className: _WGCWXRewardsTank2.default.header },
                                _react2.default.createElement('div', { className: nationalityClassName }),
                                _react2.default.createElement(
                                    'div',
                                    { className: _WGCWXRewardsTank2.default.level },
                                    tankLevel
                                ),
                                _react2.default.createElement(_VehicleType2.default, {
                                    type: type,
                                    premium: true,
                                    mini: false
                                }),
                                _react2.default.createElement(
                                    'div',
                                    { className: _WGCWXRewardsTank2.default.name },
                                    userName
                                ),
                                _react2.default.createElement(
                                    'div',
                                    { className: _WGCWXRewardsTank2.default.compare },
                                    this.renderCompareComponent(),
                                    this.props.isAddToComparisonAvailable && _react2.default.createElement(
                                        _reactWotBootstrap.Tooltip,
                                        { id: _constants.VEHICLE_TO_COMPARE_TOOLTIP.id },
                                        _constants.VEHICLE_TO_COMPARE_TOOLTIP.message
                                    )
                                )
                            ),
                            !_products.NO_DESCRIPTION_VEHICLES.includes(this.state.selectedTank.token) && _react2.default.createElement(
                                'div',
                                { className: _WGCWXRewardsTank2.default.info },
                                _react2.default.createElement('div', { className: _WGCWXRewardsTank2.default.infoIcon }),
                                _react2.default.createElement(
                                    'div',
                                    { className: _WGCWXRewardsTank2.default.infoText },
                                    (0, _translations.INFO_TEXT_STYLE)(_translations.STYLE_VETERAN)
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _WGCWXRewardsTank2.default.tankContainer },
                                _react2.default.createElement(_TankInfo2.default, {
                                    selectedTank: selectedTank
                                })
                            )
                        )
                    ),
                    _react2.default.createElement(_Footer2.default, {
                        onCloseHandler: this.handleBackButtonClick,
                        openTankPurchaseConfirmationHandler: this.openTankPurchaseConfirmation,
                        openCancelBetConfirmationHandler: this.openCancelBetConfirmation,
                        makeBetHandler: this.makeBet,
                        handleBetChangeHandler: this.handleBetChange,
                        meta: meta,
                        bet: bet,
                        inHangar: inHangar,
                        isSelected: isSelected,
                        price: secondPrice,
                        pfpPrice: price,
                        accountBalance: accountBalance,
                        wgMoneyServiceError: wgMoneyServiceError,
                        anyTankSelected: anyTankSelected
                    })
                ),
                this.state.tankPurchaseConfirmationOpened && _react2.default.createElement(
                    'div',
                    { className: _WGCWXRewardsTank2.default.confirmWindow },
                    _react2.default.createElement(
                        _WGCWXRewardsTankConfirmation2.default,
                        {
                            title: (0, _translations.PURCHASE_TANK)(userName),
                            buttonsOptions: [{
                                caption: _translations.PURCHASE,
                                callback: this.purchaseTank
                            }, {
                                caption: _translations.NO,
                                callback: this.closeTankPurchaseConfirmation
                            }],
                            onClose: this.closeTankPurchaseConfirmation
                        },
                        _react2.default.createElement(
                            'p',
                            { className: _WGCWXRewardsTankConfirmation4.default.price },
                            (0, _translations.CURRENCY_TO_SPEND)(_react2.default.createElement(
                                'span',
                                null,
                                _react2.default.createElement(
                                    'span',
                                    { className: _WGCWXRewardsTank2.default.bons },
                                    _react2.default.createElement(_reactWotBootstrap.Bons, {
                                        size: 'large',
                                        iconPosition: 'after',
                                        mixClassName: _WGCWXRewardsTank2.default.bonds,
                                        value: secondPrice
                                    })
                                ),
                                _react2.default.createElement('span', { className: _WGCWXRewardsTankConfirmation4.default.plus }),
                                _react2.default.createElement(_FamePoints2.default, { size: 'large', value: price })
                            )),
                            _react2.default.createElement('span', { className: _WGCWXRewardsTankConfirmation4.default.price_divider }),
                            (0, _translations.CURRENCY_LEFT)(_react2.default.createElement(
                                'span',
                                null,
                                _react2.default.createElement(
                                    'span',
                                    { className: _WGCWXRewardsTank2.default.bons },
                                    _react2.default.createElement(_reactWotBootstrap.Bons, {
                                        size: 'large',
                                        iconPosition: 'after',
                                        mixClassName: _WGCWXRewardsTank2.default.bonds,
                                        value: oldCrystalBalance - secondPrice
                                    })
                                ),
                                _react2.default.createElement('span', { className: _WGCWXRewardsTankConfirmation4.default.plus }),
                                _react2.default.createElement(_FamePoints2.default, { size: 'large', value: famePoints - price })
                            ))
                        )
                    )
                ),
                this.state.cancelBetConfirmationOpened && _react2.default.createElement(
                    'div',
                    { className: _WGCWXRewardsTank2.default.confirmWindow },
                    _react2.default.createElement(_WGCWXRewardsTankConfirmation2.default, {
                        buttonsOptions: [{
                            caption: _translations.CANCEL_BET,
                            callback: this.cancelBet
                        }, {
                            caption: _translations.NO,
                            callback: this.closeCancelBetConfirmation
                        }],
                        messageType: 'alert',
                        title: _translations.CANCEL_BET_TITLE,
                        description: _translations.CANCEL_BET_DESCRIPTION,
                        onClose: this.closeCancelBetConfirmation
                    })
                )
            );
        }
    }]);

    return WGCWXRewardsTank;
}(_react.Component);

WGCWXRewardsTank.propTypes = {
    rewardsMeta: _propTypes3.RewardsMetaPropTypes,
    backToRewardsHandler: _propTypes2.default.func.isRequired,
    purchaseItem: _propTypes2.default.func.isRequired,
    makeRewardAuctionBet: _propTypes2.default.func.isRequired,
    cancelRewardAuctionBet: _propTypes2.default.func.isRequired,
    selectedTank: _propTypes2.default.arrayOf(_propTypes3.RewardPropTypes),
    wgMoneyServiceError: _propTypes2.default.bool.isRequired,
    isAddToComparisonAvailable: _propTypes2.default.bool.isRequired,
    accountBalance: _propTypes3.BalancePropTypes,
    anyTankSelected: _propTypes2.default.bool.isRequired,
    realm: _propTypes2.default.string.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
    return {
        realm: state.settings.realm
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(WGCWXRewardsTank);

/***/ }),
/* 2441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactWotBootstrap = __webpack_require__(5);

var _format_number = __webpack_require__(109);

var _propTypes = __webpack_require__(79);

var _translations = __webpack_require__(1380);

var _TankInfo = __webpack_require__(2442);

var _TankInfo2 = _interopRequireDefault(_TankInfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TankInfo = function (_Component) {
    _inherits(TankInfo, _Component);

    function TankInfo(props) {
        _classCallCheck(this, TankInfo);

        var _this = _possibleConstructorReturn(this, (TankInfo.__proto__ || Object.getPrototypeOf(TankInfo)).call(this, props));

        _this.createOpenTankopediaHandler = function (infoUrl) {
            return function (event) {
                event.preventDefault();
                (0, _reactWotBootstrap.openExternalBrowser)(infoUrl);
            };
        };

        _this.renderTTCvalue = function (properties) {
            if (Array.isArray(properties)) {
                return _react2.default.createElement(
                    'div',
                    { className: _TankInfo2.default.valueTTC },
                    properties.map(function (property, index) {
                        var showSeparator = index !== 0;
                        return _react2.default.createElement(
                            'span',
                            { key: index },
                            showSeparator && _react2.default.createElement(
                                'span',
                                null,
                                ' / '
                            ),
                            _react2.default.createElement(
                                'span',
                                { className: _TankInfo2.default.value },
                                (0, _format_number.floats)(property, 2)
                            )
                        );
                    })
                );
            }
            return _react2.default.createElement(
                'div',
                { className: _TankInfo2.default.valueTTC },
                _react2.default.createElement(
                    'span',
                    { className: _TankInfo2.default.value },
                    (0, _format_number.floats)(properties, 2)
                )
            );
        };

        return _this;
    }

    _createClass(TankInfo, [{
        key: 'render',
        value: function render() {
            if (!this.props.selectedTank) {
                return null;
            }

            var _props = this.props,
                infoUrl = _props.selectedTank.infoUrl,
                _props$selectedTank$v = _props.selectedTank.vehicleParams,
                health = _props$selectedTank$v.health,
                hullArmor = _props$selectedTank$v.hullArmor,
                avgDamage = _props$selectedTank$v.avgDamage,
                piercingPower = _props$selectedTank$v.piercingPower,
                clipFireRate = _props$selectedTank$v.clipFireRate,
                reloadTime = _props$selectedTank$v.reloadTime,
                turretArmor = _props$selectedTank$v.turretArmor;

            return _react2.default.createElement(
                'div',
                { className: _TankInfo2.default.tankTTC },
                _react2.default.createElement(
                    'div',
                    { className: _TankInfo2.default.titleTTC },
                    _translations.TTC_TITLE
                ),
                _react2.default.createElement(
                    'div',
                    { className: _TankInfo2.default.containerTTC },
                    health && _react2.default.createElement(
                        'div',
                        { className: _TankInfo2.default.itemTTC },
                        _react2.default.createElement(
                            'div',
                            { className: _TankInfo2.default.nameTTC },
                            _translations.TANK_TECH_STATS.MAX_HEALTH
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _TankInfo2.default.valueTTC },
                            _react2.default.createElement(
                                'span',
                                { className: _TankInfo2.default.value },
                                this.renderTTCvalue(health)
                            )
                        )
                    ),
                    hullArmor && _react2.default.createElement(
                        'div',
                        { className: _TankInfo2.default.itemTTC },
                        _react2.default.createElement(
                            'div',
                            { className: _TankInfo2.default.nameTTC },
                            _translations.TANK_TECH_STATS.HULL_ARMORS
                        ),
                        this.renderTTCvalue(hullArmor)
                    ),
                    turretArmor && _react2.default.createElement(
                        'div',
                        { className: _TankInfo2.default.itemTTC },
                        _react2.default.createElement(
                            'div',
                            { className: _TankInfo2.default.nameTTC },
                            _translations.TANK_TECH_STATS.TURRET_ARMORS
                        ),
                        this.renderTTCvalue(turretArmor)
                    ),
                    avgDamage && _react2.default.createElement(
                        'div',
                        { className: _TankInfo2.default.itemTTC },
                        _react2.default.createElement(
                            'div',
                            { className: _TankInfo2.default.nameTTC },
                            _translations.TANK_TECH_STATS.DAMAGE
                        ),
                        this.renderTTCvalue(avgDamage)
                    ),
                    piercingPower && _react2.default.createElement(
                        'div',
                        { className: _TankInfo2.default.itemTTC },
                        _react2.default.createElement(
                            'div',
                            { className: _TankInfo2.default.nameTTC },
                            _translations.TANK_TECH_STATS.PIERCING
                        ),
                        this.renderTTCvalue(piercingPower)
                    ),
                    reloadTime && _react2.default.createElement(
                        'div',
                        { className: _TankInfo2.default.itemTTC },
                        _react2.default.createElement(
                            'div',
                            { className: _TankInfo2.default.nameTTC },
                            _translations.TANK_TECH_STATS.GUN_RATE_CYCLE
                        ),
                        _react2.default.createElement(
                            'span',
                            { className: _TankInfo2.default.value },
                            this.renderTTCvalue(reloadTime)
                        )
                    ),
                    clipFireRate && _react2.default.createElement(
                        'div',
                        { className: _TankInfo2.default.itemTTC },
                        _react2.default.createElement(
                            'div',
                            { className: _TankInfo2.default.nameTTC },
                            _translations.TANK_TECH_STATS.GUN_RATE
                        ),
                        _react2.default.createElement(
                            'span',
                            { className: _TankInfo2.default.value },
                            this.renderTTCvalue(clipFireRate)
                        )
                    )
                ),
                infoUrl && _react2.default.createElement(
                    'a',
                    {
                        href: '',
                        onClick: this.createOpenTankopediaHandler(infoUrl),
                        className: _TankInfo2.default.tankopediaLink
                    },
                    _translations.MORE_ABOUT_TANK
                )
            );
        }
    }]);

    return TankInfo;
}(_react.Component);

TankInfo.propTypes = {
    selectedTank: _propTypes.RewardPropTypes
};

exports.default = TankInfo;

/***/ }),
/* 2442 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tankTTC":"TankInfo_tankTTC--130Zb","tankTtc":"TankInfo_tankTTC--130Zb","titleTTC":"TankInfo_titleTTC--2zdEK","titleTtc":"TankInfo_titleTTC--2zdEK","containerTTC":"TankInfo_containerTTC--2en_u","containerTtc":"TankInfo_containerTTC--2en_u","itemTTC":"TankInfo_itemTTC--vxIEb","itemTtc":"TankInfo_itemTTC--vxIEb","nameTTC":"TankInfo_nameTTC--3kBsx","nameTtc":"TankInfo_nameTTC--3kBsx","valueTTC":"TankInfo_valueTTC--ySyqS","valueTtc":"TankInfo_valueTTC--ySyqS","value":"TankInfo_value--8FG8L","tankopediaLink":"TankInfo_tankopediaLink--1BlXL"};

/***/ }),
/* 2443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mapDispatchToProps = exports.Footer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(7);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _moment = __webpack_require__(6);

var _moment2 = _interopRequireDefault(_moment);

var _reactWotBootstrap = __webpack_require__(5);

var _sounds = __webpack_require__(22);

var _ButtonGhost = __webpack_require__(2444);

var _ButtonGhost2 = _interopRequireDefault(_ButtonGhost);

var _FamePoints = __webpack_require__(143);

var _FamePoints2 = _interopRequireDefault(_FamePoints);

var _TankAuctionSlider = __webpack_require__(2446);

var _TankAuctionSlider2 = _interopRequireDefault(_TankAuctionSlider);

var _propTypes3 = __webpack_require__(79);

var _translations = __webpack_require__(2448);

var _Footer = __webpack_require__(1381);

var _Footer2 = _interopRequireDefault(_Footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable complexity */


var Footer = exports.Footer = function (_Component) {
    _inherits(Footer, _Component);

    function Footer(props) {
        _classCallCheck(this, Footer);

        var _this = _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).call(this, props));

        _initialiseProps.call(_this);

        _this.state = {
            footerState: _this.defineFooterState(props)
        };
        return _this;
    }

    _createClass(Footer, [{
        key: 'render',
        value: function render() {
            var footerState = this.state.footerState;
            var _props = this.props,
                onCloseHandler = _props.onCloseHandler,
                openTankPurchaseConfirmationHandler = _props.openTankPurchaseConfirmationHandler,
                openCancelBetConfirmationHandler = _props.openCancelBetConfirmationHandler,
                handleBetChangeHandler = _props.handleBetChangeHandler,
                price = _props.price,
                bet = _props.bet,
                meta = _props.meta,
                pfpPrice = _props.pfpPrice,
                crystal = _props.accountBalance.crystal;
            var places = meta.places,
                minBet = meta.minBet,
                currentBet = meta.currentBet,
                purchaseDatetimeEnd = meta.purchaseDatetimeEnd;


            var datetimeEnd = _moment2.default.utc(purchaseDatetimeEnd).local();
            var footerClassName = (0, _classnames2.default)(_Footer2.default.footer, _Footer2.default['footer__' + footerState]);

            var footerIconClassName = (0, _classnames2.default)(_Footer2.default.footerIcon, _Footer2.default['footerIcon__' + footerState]);

            if (footerState === 'rewardInHangar') {
                return _react2.default.createElement(
                    'div',
                    { className: footerClassName },
                    _react2.default.createElement(
                        'div',
                        { className: _Footer2.default.wrapperContainer },
                        _react2.default.createElement(
                            'div',
                            { className: _Footer2.default.textBlock },
                            _react2.default.createElement('div', { className: footerIconClassName }),
                            _react2.default.createElement(
                                'div',
                                { className: _Footer2.default.text },
                                _translations.TANK_IS_ALREADY_IN_HANGAR
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _Footer2.default.action },
                            _react2.default.createElement(
                                _reactWotBootstrap.Button,
                                {
                                    onClick: onCloseHandler,
                                    mixClassName: _Footer2.default.buttonAfirmative
                                },
                                _translations.AFFIRMATIVE
                            )
                        )
                    )
                );
            }

            if (footerState === 'rewardSelected') {
                return _react2.default.createElement(
                    'div',
                    { className: footerClassName },
                    _react2.default.createElement(
                        'div',
                        { className: _Footer2.default.wrapperContainer },
                        _react2.default.createElement(
                            'div',
                            { className: _Footer2.default.textBlock },
                            _react2.default.createElement('div', { className: footerIconClassName }),
                            _react2.default.createElement(
                                'div',
                                { className: _Footer2.default.text },
                                _translations.TANK_IS_ALREADY_SELECTED
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _Footer2.default.action },
                            _react2.default.createElement(
                                _reactWotBootstrap.Button,
                                {
                                    onClick: onCloseHandler,
                                    mixClassName: _Footer2.default.buttonAfirmative
                                },
                                _translations.AFFIRMATIVE
                            )
                        )
                    )
                );
            }

            if (footerState === 'rewardPurchased') {
                return _react2.default.createElement(
                    'div',
                    { className: footerClassName },
                    _react2.default.createElement(
                        'div',
                        { className: _Footer2.default.wrapperContainer },
                        _react2.default.createElement(
                            'div',
                            { className: _Footer2.default.textBlock },
                            _react2.default.createElement(
                                'div',
                                { className: _Footer2.default.text },
                                _translations.TANK_IS_ALREADY_PURCHASED
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _Footer2.default.action },
                            _react2.default.createElement(
                                _reactWotBootstrap.Button,
                                {
                                    onClick: onCloseHandler,
                                    mixClassName: _Footer2.default.buttonAfirmative
                                },
                                _translations.AFFIRMATIVE
                            )
                        )
                    )
                );
            }

            if (footerState === 'wgMoneyUnavailable') {
                return _react2.default.createElement(
                    'div',
                    { className: footerClassName },
                    _react2.default.createElement(
                        'div',
                        { className: _Footer2.default.wrapperContainer },
                        _react2.default.createElement(
                            'div',
                            { className: _Footer2.default.textBlock },
                            _react2.default.createElement('div', { className: footerIconClassName }),
                            _react2.default.createElement(
                                'div',
                                { className: _Footer2.default.text },
                                _translations.WG_MONEY_UNAVAILABILE
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _Footer2.default.action },
                            _react2.default.createElement(
                                _reactWotBootstrap.Button,
                                {
                                    onClick: onCloseHandler,
                                    mixClassName: _Footer2.default.buttonAfirmative
                                },
                                _translations.AFFIRMATIVE
                            )
                        )
                    )
                );
            }

            if (footerState === 'enoughPfpEnoughBonds') {
                return _react2.default.createElement(
                    'div',
                    { className: footerClassName },
                    _react2.default.createElement(
                        'div',
                        { className: _Footer2.default.wrapperContainer },
                        _react2.default.createElement(
                            'div',
                            { className: _Footer2.default.textBlock },
                            _react2.default.createElement(
                                'div',
                                { className: _Footer2.default.text },
                                (0, _translations.ENOUGH_PFP)(_react2.default.createElement(
                                    'span',
                                    { className: _Footer2.default.top_count },
                                    (0, _translations.TOP_BEST_COUNT)(places)
                                ))
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _Footer2.default.action },
                            _react2.default.createElement(
                                'div',
                                { className: _Footer2.default.toChangeText },
                                _translations.TO_CHANGE
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _Footer2.default.footerBons },
                                _react2.default.createElement(_reactWotBootstrap.Bons, {
                                    size: 'large',
                                    iconPosition: 'after',
                                    value: price
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _Footer2.default.footerFamePoints },
                                _react2.default.createElement(_FamePoints2.default, { value: pfpPrice })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _Footer2.default.buttonAction },
                                _react2.default.createElement(
                                    _reactWotBootstrap.Button,
                                    {
                                        type: 'primary',
                                        onClick: openTankPurchaseConfirmationHandler,
                                        mixClassName: _Footer2.default.buttonPurchase
                                    },
                                    _translations.PURCHASE_REWARD
                                )
                            )
                        )
                    )
                );
            }

            if (footerState === 'enoughPfpNotEnoughBonds') {
                return _react2.default.createElement(
                    'div',
                    { className: footerClassName },
                    _react2.default.createElement(
                        'div',
                        { className: _Footer2.default.wrapperContainer },
                        _react2.default.createElement(
                            'div',
                            { className: _Footer2.default.textBlock },
                            _react2.default.createElement(
                                'div',
                                { className: _Footer2.default.text },
                                (0, _translations.ENOUGH_PFP)(_react2.default.createElement(
                                    'span',
                                    { className: _Footer2.default.top_count },
                                    (0, _translations.TOP_BEST_COUNT)(places)
                                ))
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _Footer2.default.action },
                            _react2.default.createElement(
                                'div',
                                { className: _Footer2.default.warningMessage },
                                _translations.WARNING_MESSAGE_NOT_ENOUGH_BONS_FOR_PURCHASE
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _Footer2.default.toChangeText },
                                _translations.TO_CHANGE
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _Footer2.default.footerBons },
                                _react2.default.createElement(_reactWotBootstrap.Bons, {
                                    size: 'large',
                                    iconPosition: 'after',
                                    value: price,
                                    isNotEnough: true
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _Footer2.default.footerFamePoints },
                                _react2.default.createElement(_FamePoints2.default, { value: pfpPrice })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _Footer2.default.buttonAction },
                                _react2.default.createElement(
                                    _reactWotBootstrap.Button,
                                    {
                                        onClick: onCloseHandler,
                                        mixClassName: _Footer2.default.buttonAfirmative
                                    },
                                    _translations.AFFIRMATIVE
                                )
                            )
                        )
                    )
                );
            }

            if (footerState === 'notEnoughPfpNotEnoughBonds') {
                return _react2.default.createElement(
                    'div',
                    { className: footerClassName },
                    _react2.default.createElement(
                        'div',
                        { className: _Footer2.default.wrapperContainer },
                        _react2.default.createElement(
                            'div',
                            { className: _Footer2.default.textBlock },
                            _react2.default.createElement(
                                'div',
                                { className: _Footer2.default.text },
                                _translations.NOT_ENOUGH_PFP
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _Footer2.default.action },
                            _react2.default.createElement(
                                'div',
                                { className: _Footer2.default.warningMessage },
                                _react2.default.createElement(
                                    'span',
                                    { className: _Footer2.default.text },
                                    _translations.WARNING_MESSAGE_NOT_ENOUGH_BONS
                                ),
                                _react2.default.createElement(
                                    'span',
                                    null,
                                    _translations.MINIMAL_RATE
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _Footer2.default.footerBons },
                                _react2.default.createElement(_reactWotBootstrap.Bons, {
                                    size: 'large',
                                    iconPosition: 'after',
                                    value: minBet,
                                    isNotEnough: true
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _Footer2.default.action },
                                _react2.default.createElement(
                                    _reactWotBootstrap.Button,
                                    {
                                        onClick: onCloseHandler,
                                        mixClassName: _Footer2.default.buttonAfirmative
                                    },
                                    _translations.AFFIRMATIVE
                                )
                            )
                        )
                    )
                );
            }
            if (footerState === 'eventNotFinishedNoAuctionTicket') {
                return _react2.default.createElement(
                    'div',
                    { className: footerClassName },
                    _react2.default.createElement(
                        'div',
                        { className: _Footer2.default.wrapperContainer },
                        _react2.default.createElement(
                            'div',
                            { className: _Footer2.default.textBlock },
                            _react2.default.createElement(
                                'div',
                                { className: _Footer2.default.text },
                                (0, _translations.EVENT_NOT_FINISHED_NO_AUCTION_TICKET)(_react2.default.createElement(
                                    'span',
                                    { className: _Footer2.default.top_count },
                                    (0, _translations.TOP_BEST_COUNT)(places)
                                ))
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _Footer2.default.action },
                            _react2.default.createElement(
                                _reactWotBootstrap.Button,
                                {
                                    onClick: onCloseHandler,
                                    mixClassName: _Footer2.default.buttonAfirmative
                                },
                                _translations.AFFIRMATIVE
                            )
                        )
                    )
                );
            }

            if (footerState === 'eventFinishedNoAuctionTicket') {
                return _react2.default.createElement(
                    'div',
                    { className: footerClassName },
                    _react2.default.createElement(
                        'div',
                        { className: _Footer2.default.wrapperContainer },
                        _react2.default.createElement(
                            'div',
                            { className: _Footer2.default.textBlock },
                            _react2.default.createElement(
                                'div',
                                { className: _Footer2.default.text },
                                _translations.EVENT_FINISHED_NO_AUCTION_TICKET
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _Footer2.default.action },
                            _react2.default.createElement(
                                _reactWotBootstrap.Button,
                                {
                                    onClick: onCloseHandler,
                                    mixClassName: _Footer2.default.buttonAfirmative
                                },
                                _translations.AFFIRMATIVE
                            )
                        )
                    )
                );
            }

            if (footerState === 'eventNotFinishedHasAuctionTicket') {
                return _react2.default.createElement(
                    'div',
                    { className: footerClassName },
                    _react2.default.createElement(
                        'div',
                        { className: _Footer2.default.wrapperContainer },
                        _react2.default.createElement(
                            'div',
                            { className: _Footer2.default.textBlock },
                            _react2.default.createElement(
                                'div',
                                { className: _Footer2.default.text },
                                _translations.EVENT_NOT_FINISHED_HAS_AUCTION_TICKET
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _Footer2.default.action },
                            _react2.default.createElement(
                                _reactWotBootstrap.Button,
                                {
                                    onClick: onCloseHandler,
                                    mixClassName: _Footer2.default.buttonAfirmative
                                },
                                _translations.AFFIRMATIVE
                            )
                        )
                    )
                );
            }

            if (footerState === 'betAccepted') {
                return _react2.default.createElement(
                    'div',
                    { className: footerClassName },
                    _react2.default.createElement(
                        'div',
                        { className: _Footer2.default.wrapperContainer },
                        _react2.default.createElement(
                            'div',
                            { className: _Footer2.default.textBlock },
                            _react2.default.createElement(
                                'div',
                                { className: _Footer2.default.text },
                                (0, _translations.BET_ACCEPTED)(datetimeEnd),
                                _translations.BET_LOST
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _Footer2.default.action },
                            _react2.default.createElement(
                                'div',
                                { className: _Footer2.default.yourBetText },
                                _translations.YOUR_BET
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _Footer2.default.footerBons },
                                _react2.default.createElement(_reactWotBootstrap.Bons, {
                                    size: 'large',
                                    iconPosition: 'after',
                                    value: currentBet
                                })
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _Footer2.default.cancelBetWrapper },
                                _react2.default.createElement(
                                    _ButtonGhost2.default,
                                    {
                                        onClick: openCancelBetConfirmationHandler,
                                        mixClassName: _Footer2.default.buttonCancelBet
                                    },
                                    _translations.CANCEL_BET
                                )
                            ),
                            _react2.default.createElement(
                                _reactWotBootstrap.Button,
                                {
                                    onClick: onCloseHandler,
                                    mixClassName: _Footer2.default.buttonAfirmative
                                },
                                _translations.AFFIRMATIVE
                            )
                        )
                    )
                );
            }

            if (footerState === 'makeBet') {
                return _react2.default.createElement(
                    'div',
                    { className: footerClassName },
                    _react2.default.createElement(
                        'div',
                        { className: _Footer2.default.wrapperContainer },
                        _react2.default.createElement(
                            'div',
                            { className: _Footer2.default.textBlock },
                            _react2.default.createElement(
                                'div',
                                { className: _Footer2.default.text },
                                _translations.MAKE_BET
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _Footer2.default.action },
                            _react2.default.createElement(
                                'div',
                                { className: _Footer2.default.yourBetText },
                                _translations.YOUR_BET
                            ),
                            _react2.default.createElement(_TankAuctionSlider2.default, {
                                currentValue: bet,
                                minValue: minBet,
                                maxValue: crystal,
                                handleChange: handleBetChangeHandler
                            }),
                            _react2.default.createElement(
                                _reactWotBootstrap.Button,
                                {
                                    mixClassName: _Footer2.default.buttonMakeBet,
                                    isPending: this.props.actionInProgress,
                                    type: 'primary',
                                    onClick: this.handleMakeBet
                                },
                                _translations.MAKE_BET_TEXT
                            )
                        )
                    )
                );
            }
            return null;
        }
    }]);

    return Footer;
}(_react.Component);

/* eslint-disable react/no-unused-prop-types */


var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.handleMakeBet = function () {
        _this2.props.playClansWinnerRewardMakeBet();
        _this2.props.makeBetHandler();
    };

    this.defineFooterState = function (props) {
        var inHangar = props.inHangar,
            isSelected = props.isSelected,
            meta = props.meta,
            price = props.price,
            wgMoneyServiceError = props.wgMoneyServiceError,
            anyTankSelected = props.anyTankSelected,
            pfpPrice = props.pfpPrice,
            crystal = props.accountBalance.crystal;
        var famePoints = meta.famePoints,
            minBet = meta.minBet,
            currentBet = meta.currentBet,
            hasAuctionTicket = meta.hasAuctionTicket;


        switch (true) {
            case inHangar && !isSelected:
                return 'rewardInHangar'; // reward was in hangar before event

            case inHangar && isSelected || !inHangar && isSelected && !currentBet:
                /* purchasing reward:
                    reward selected and given
                    reward selected but not given yet and it isn't bet
                */
                return 'rewardPurchased';
            case !inHangar && !isSelected && anyTankSelected:
                return 'rewardSelected'; // open reward can't be selected because another reward selected

            case !pfpPrice && !hasAuctionTicket:
                return 'eventNotFinishedNoAuctionTicket';

            case !pfpPrice && hasAuctionTicket:
                return 'eventNotFinishedHasAuctionTicket';

            case pfpPrice && wgMoneyServiceError:
                return 'wgMoneyUnavailable'; // event finished and wgm error

            case pfpPrice && famePoints >= pfpPrice && crystal >= price:
                return 'enoughPfpEnoughBonds'; // player has enough pfp and bons to purchase this reward

            case pfpPrice && famePoints >= pfpPrice && crystal < price && !currentBet:
                // player has enough pfp but few bons to purchase this reward and bet not accepted

                return 'enoughPfpNotEnoughBonds';

            case pfpPrice && !hasAuctionTicket && !currentBet:
                return 'eventFinishedNoAuctionTicket';

            case pfpPrice && famePoints < pfpPrice && crystal < minBet && !currentBet:
                // player hasn't enough bons to make bet and bet not accepted
                return 'notEnoughPfpNotEnoughBonds';

            case Boolean(currentBet):
                return 'betAccepted';

            default:
                return 'makeBet';
        }
    };
};

Footer.propTypes = {
    onCloseHandler: _propTypes2.default.func.isRequired,
    openTankPurchaseConfirmationHandler: _propTypes2.default.func.isRequired,
    openCancelBetConfirmationHandler: _propTypes2.default.func.isRequired,
    makeBetHandler: _propTypes2.default.func.isRequired,
    handleBetChangeHandler: _propTypes2.default.func.isRequired,
    bet: _propTypes2.default.number.isRequired,
    meta: _propTypes3.RewardsMetaPropTypes,
    inHangar: _propTypes2.default.bool.isRequired,
    isSelected: _propTypes2.default.bool.isRequired,
    price: _propTypes2.default.number.isRequired,
    pfpPrice: _propTypes2.default.number.isRequired,
    wgMoneyServiceError: _propTypes2.default.bool.isRequired,
    actionInProgress: _propTypes2.default.bool.isRequired,
    accountBalance: _propTypes3.BalancePropTypes,
    anyTankSelected: _propTypes2.default.bool.isRequired,
    playClansWinnerRewardMakeBet: _propTypes2.default.func.isRequired
    /* eslint-enable */

};var mapStateToProps = function mapStateToProps(state) {
    return {
        actionInProgress: state.wgcwxShopRewards.processing
    };
};

var mapDispatchToProps = exports.mapDispatchToProps = {
    playClansWinnerRewardMakeBet: _sounds.playClansWinnerRewardMakeBet
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Footer);

/***/ }),
/* 2444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ButtonGhost = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactWotBootstrap = __webpack_require__(5);

var _ButtonGhost = __webpack_require__(2445);

var _ButtonGhost2 = _interopRequireDefault(_ButtonGhost);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ButtonGhost = exports.ButtonGhost = function ButtonGhost(props) {
    return _react2.default.createElement(
        'button',
        {
            className: _ButtonGhost2.default.base,
            onClick: props.onClick,
            onMouseDown: _reactWotBootstrap.sendClickSoundCommand,
            onMouseEnter: _reactWotBootstrap.sendHoverSoundCommand
        },
        _react2.default.createElement(
            'span',
            { className: _ButtonGhost2.default.caption },
            props.children
        )
    );
};

ButtonGhost.propTypes = {
    children: _propTypes2.default.node.isRequired,
    onClick: _propTypes2.default.func.isRequired
};

exports.default = ButtonGhost;

/***/ }),
/* 2445 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"ButtonGhost_base--HIJK0","caption":"ButtonGhost_caption--2SRvz"};

/***/ }),
/* 2446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _reactWotBootstrap = __webpack_require__(5);

var _helpers = __webpack_require__(130);

var _constants = __webpack_require__(4);

var _TankAuctionSlider = __webpack_require__(2447);

var _TankAuctionSlider2 = _interopRequireDefault(_TankAuctionSlider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TankAuctionSlider = function (_React$Component) {
    _inherits(TankAuctionSlider, _React$Component);

    function TankAuctionSlider(props) {
        _classCallCheck(this, TankAuctionSlider);

        var _this = _possibleConstructorReturn(this, (TankAuctionSlider.__proto__ || Object.getPrototypeOf(TankAuctionSlider)).call(this, props));

        _this.handleSliderChange = function (event) {
            _this.props.handleChange(parseInt(event.target.value));
        };

        _this.updateInput = function () {
            return _this.setState({ value: _this.props.currentValue });
        };

        _this.handleInputChange = function (event) {
            var value = event.target.value;
            if (value.split('').every(function (char) {
                return !isNaN(parseInt(char));
            })) _this.setState({ value: value });
        };

        _this.handleBlur = function () {
            var newValue = Math.max(Math.min(_this.state.value, _this.props.maxValue), _this.props.minValue);
            _this.props.handleChange(newValue);

            _this.updateInput();
        };

        _this.handleKeyDown = function (event) {
            if (event.keyCode === _constants.KEY_CODES.ENTER || event.keyCode === _constants.KEY_CODES.ESCAPE) {
                _this.input.blur();
                return;
            }

            (0, _helpers.digitsOnlyKeyDownValidation)(event);
        };

        _this.state = {
            value: props.currentValue
        };
        return _this;
    }

    _createClass(TankAuctionSlider, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate(oldProps) {
            if (oldProps.currentValue !== this.props.currentValue) this.updateInput();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                minValue = _props.minValue,
                currentValue = _props.currentValue,
                maxValue = _props.maxValue;

            var selectionWidth = (currentValue - minValue) / (maxValue - minValue);

            return _react2.default.createElement(
                'div',
                { className: _TankAuctionSlider2.default.base },
                _react2.default.createElement(
                    'div',
                    { className: _TankAuctionSlider2.default.slider },
                    _react2.default.createElement(
                        'div',
                        { className: _TankAuctionSlider2.default.range },
                        _react2.default.createElement(
                            'div',
                            { className: _TankAuctionSlider2.default.holder },
                            _react2.default.createElement('div', { className: _TankAuctionSlider2.default.selected, style: { width: selectionWidth * 100 + '%' } }),
                            _react2.default.createElement(
                                'div',
                                { className: _TankAuctionSlider2.default.wrapper },
                                _react2.default.createElement('input', {
                                    className: _TankAuctionSlider2.default.input,
                                    type: 'range',
                                    min: minValue,
                                    value: currentValue,
                                    max: maxValue,
                                    onChange: this.handleSliderChange,
                                    onMouseEnter: _reactWotBootstrap.sendHoverSoundCommand,
                                    onMouseDown: _reactWotBootstrap.sendSelectClickSoundCommand
                                })
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _TankAuctionSlider2.default.limits },
                        _react2.default.createElement(
                            'span',
                            { className: _TankAuctionSlider2.default.limits_min },
                            _react2.default.createElement(_reactIntl.FormattedNumber, { value: minValue })
                        ),
                        _react2.default.createElement(
                            'span',
                            { className: _TankAuctionSlider2.default.limits_max },
                            _react2.default.createElement(_reactIntl.FormattedNumber, { value: maxValue })
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _TankAuctionSlider2.default.bet },
                    _react2.default.createElement('input', {
                        ref: function ref(c) {
                            return _this2.input = c;
                        },
                        onChange: this.handleInputChange,
                        onBlur: this.handleBlur,
                        onFocus: this.handleFocus,
                        onKeyDown: this.handleKeyDown,
                        className: _TankAuctionSlider2.default.bet_input,
                        type: 'text',
                        inputMode: 'numeric',
                        pattern: '[0-9]',
                        value: this.state.value
                    })
                )
            );
        }
    }]);

    return TankAuctionSlider;
}(_react2.default.Component);

TankAuctionSlider.propTypes = {
    minValue: _propTypes2.default.number.isRequired,
    maxValue: _propTypes2.default.number.isRequired,
    currentValue: _propTypes2.default.number.isRequired,
    handleChange: _propTypes2.default.func.isRequired
};
exports.default = TankAuctionSlider;

/***/ }),
/* 2447 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"range":"TankAuctionSlider_range--DV9-S","holder":"TankAuctionSlider_holder--6EB2I","selected":"TankAuctionSlider_selected--27iqb","available":"TankAuctionSlider_available--DYZPi","wrapper":"TankAuctionSlider_wrapper--2JzWo","input":"TankAuctionSlider_input--3LWSL","base":"TankAuctionSlider_base--2gLfW","slider":"TankAuctionSlider_slider--3-DWP","limits":"TankAuctionSlider_limits--1YN9W","limits_min":"TankAuctionSlider_limits_min--3kY2w","limitsMin":"TankAuctionSlider_limits_min--3kY2w","limits_max":"TankAuctionSlider_limits_max--qXP7p","limitsMax":"TankAuctionSlider_limits_max--qXP7p","label":"TankAuctionSlider_label--2Ig7b","bet":"TankAuctionSlider_bet--2-3lP","bet_input":"TankAuctionSlider_bet_input--3gaKa","betInput":"TankAuctionSlider_bet_input--3gaKa"};

/***/ }),
/* 2448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EVENT_FINISHED_NO_AUCTION_TICKET = exports.PURCHASE_REWARD = exports.CANCEL_BET = exports.MAKE_BET_TEXT = exports.MAKE_BET = exports.YOUR_BET = exports.BET_LOST = exports.BET_ACCEPTED = exports.MINIMAL_RATE = exports.WARNING_MESSAGE_NOT_ENOUGH_BONS_FOR_PURCHASE = exports.WARNING_MESSAGE_NOT_ENOUGH_BONS = exports.TO_CHANGE = exports.TOP_BEST_COUNT = exports.EVENT_NOT_FINISHED_HAS_AUCTION_TICKET = exports.EVENT_NOT_FINISHED_NO_AUCTION_TICKET = exports.NOT_ENOUGH_PFP = exports.ENOUGH_PFP = exports.WG_MONEY_UNAVAILABILE = exports.TANK_IS_ALREADY_PURCHASED = exports.TANK_IS_ALREADY_SELECTED = exports.TANK_IS_ALREADY_IN_HANGAR = exports.AFFIRMATIVE = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _Footer = __webpack_require__(1381);

var _Footer2 = _interopRequireDefault(_Footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AFFIRMATIVE = exports.AFFIRMATIVE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.rewards.tank.footer.affirmative',
    defaultMessage: '\u0422\u0430\u043A \u0442\u043E\u0447\u043D\u043E!'
}); /* eslint-disable react/no-multi-comp, max-len */
var TANK_IS_ALREADY_IN_HANGAR = exports.TANK_IS_ALREADY_IN_HANGAR = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.rewards.tank.footer.tank_is_already_in_hangar',
    defaultMessage: '\u042D\u0442\u0430 \u043C\u0430\u0448\u0438\u043D\u0430 \u0443\u0436\u0435 \u0435\u0441\u0442\u044C \u0432 \u0432\u0430\u0448\u0435\u043C \u0410\u043D\u0433\u0430\u0440\u0435.'
});

var TANK_IS_ALREADY_SELECTED = exports.TANK_IS_ALREADY_SELECTED = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.rewards.tank.footer.tank_is_already_selected',
    defaultMessage: '\u0412\u044B \u0443\u0436\u0435 \u0432\u044B\u0431\u0440\u0430\u043B\u0438 \u0434\u0440\u0443\u0433\u0443\u044E \u043D\u0430\u0433\u0440\u0430\u0434\u0443 \u0432 \u0434\u0430\u043D\u043D\u043E\u0439 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u0438.'
});

var TANK_IS_ALREADY_PURCHASED = exports.TANK_IS_ALREADY_PURCHASED = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.rewards.tank.footer.tank_is_already_purchased',
    defaultMessage: '\u041D\u0430\u0433\u0440\u0430\u0434\u0430 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0430 \u0438 \u0431\u0443\u0434\u0435\u0442 \u043D\u0430\u0447\u0438\u0441\u043B\u0435\u043D\u0430 \u043D\u0430 \u0432\u0430\u0448 \u0430\u043A\u043A\u0430\u0443\u043D\u0442 \u0432 \u0431\u043B\u0438\u0436\u0430\u0439\u0448\u0435\u0435 \u0432\u0440\u0435\u043C\u044F.'
});

var WG_MONEY_UNAVAILABILE = exports.WG_MONEY_UNAVAILABILE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.rewards.tank.footer.wg_money_unavailable',
    defaultMessage: '\u041F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435 \u043D\u0430\u0433\u0440\u0430\u0434 \u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u043E\u0437\u0436\u0435.'
});

var ENOUGH_PFP = exports.ENOUGH_PFP = function ENOUGH_PFP(topBestCount) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop.rewards.tank.footer.enough_pfp',
        defaultMessage: '\u041F\u043E\u0437\u0434\u0440\u0430\u0432\u043B\u044F\u0435\u043C! \u0412\u044B \u0432\u043E\u0448\u043B\u0438 \u0432 {topBestCount} \u0438\u0433\u0440\u043E\u043A\u043E\u0432 \u043F\u043E \u0438\u0442\u043E\u0433\u0430\u043C \u0441\u043E\u0431\u044B\u0442\u0438\u044F \u0438 \u043F\u043E\u043B\u0443\u0447\u0438\u043B\u0438 \u043F\u0440\u0430\u0432\u043E \u043D\u0430 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435 \u043D\u0430\u0433\u0440\u0430\u0434\u044B.',
        values: { topBestCount: topBestCount }
    });
};

var NOT_ENOUGH_PFP = exports.NOT_ENOUGH_PFP = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.rewards.tank.footer.not_enough_pfp',
    defaultMessage: '\u041A \u0441\u043E\u0436\u0430\u043B\u0435\u043D\u0438\u044E, \u0432\u044B \u043D\u0430\u0431\u0440\u0430\u043B\u0438 \u043D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E\u0435 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u041E\u0447\u043A\u043E\u0432 \u0441\u043B\u0430\u0432\u044B \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 \u0441\u043E\u0431\u044B\u0442\u0438\u044F, \u043D\u043E \u0432\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0431\u043E\u043D\u044B \u0434\u043B\u044F \u0443\u0447\u0430\u0441\u0442\u0438\u044F \u0432 \u0430\u0443\u043A\u0446\u0438\u043E\u043D\u0435 \u0437\u0430 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435 \u043D\u0430\u0433\u0440\u0430\u0434.'
});

var EVENT_NOT_FINISHED_NO_AUCTION_TICKET = exports.EVENT_NOT_FINISHED_NO_AUCTION_TICKET = function EVENT_NOT_FINISHED_NO_AUCTION_TICKET(topBestCount) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop.rewards.tank.footer.event_not_finished_no_auction_ticket',
        defaultMessage: '\u0422\u0435\u0445\u043D\u0438\u043A\u0443 \u0437\u0430 \u0444\u0438\u043A\u0441\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0435 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0431\u043E\u043D \u0441\u043C\u043E\u0433\u0443\u0442 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0438\u0433\u0440\u043E\u043A\u0438, \u0432\u043E\u0448\u0435\u0434\u0448\u0438\u0435 \u0432 {topBestCount} \u043F\u043E \u0438\u0442\u043E\u0433\u0430\u043C \u0441\u043E\u0431\u044B\u0442\u0438\u044F. \u041E\u0441\u0442\u0430\u043B\u044C\u043D\u044B\u043C \u0438\u0433\u0440\u043E\u043A\u0430\u043C \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0441\u043E\u0431\u0440\u0430\u0442\u044C \u0432 \u041C\u0430\u0441\u0442\u0435\u0440\u0441\u043A\u043E\u0439 \u0434\u043E\u043F\u0443\u0441\u043A \u043D\u0430 \u0430\u0443\u043A\u0446\u0438\u043E\u043D \u0442\u0435\u0445\u043D\u0438\u043A\u0438 \u0434\u043B\u044F \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u0438 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043F\u0440\u0438\u0437\u043E\u0432\u044B\u0435 \u043C\u0430\u0448\u0438\u043D\u044B, \u0434\u0435\u043B\u0430\u044F \u0441\u0442\u0430\u0432\u043A\u0438 \u0432 \u0431\u043E\u043D\u043E\u0432\u043E\u043C \u0430\u0443\u043A\u0446\u0438\u043E\u043D\u0435. \u041D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E\u0435 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043B\u0438\u0447\u043D\u044B\u0445 \u041E\u0447\u043A\u043E\u0432 \u0441\u043B\u0430\u0432\u044B \u0434\u043B\u044F \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u0442\u0435\u0445\u043D\u0438\u043A\u0438 \u0441\u0442\u0430\u043D\u0435\u0442 \u0438\u0437\u0432\u0435\u0441\u0442\u043D\u043E \u043F\u043E\u0441\u043B\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0441\u043E\u0431\u044B\u0442\u0438\u044F.',
        values: { topBestCount: topBestCount }
    });
};

var EVENT_NOT_FINISHED_HAS_AUCTION_TICKET = exports.EVENT_NOT_FINISHED_HAS_AUCTION_TICKET = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.rewards.tank.footer.event_not_finished_has_auction_ticket',
    defaultMessage: '\u041F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435 \u043D\u0430\u0433\u0440\u0430\u0434 \u0441\u0442\u0430\u043D\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E \u043F\u043E\u0441\u043B\u0435 \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u044F \u0441\u043E\u0431\u044B\u0442\u0438\u044F.'
});

var TOP_BEST_COUNT = exports.TOP_BEST_COUNT = function TOP_BEST_COUNT(number) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop.rewards.tank.footer.top_best_count',
        defaultMessage: '\u0442\u043E\u043F-{top}',
        values: { top: _react2.default.createElement(_reactIntl.FormattedNumber, { value: number }) }
    });
};

var TO_CHANGE = exports.TO_CHANGE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.rewards.tank.footer.to_change',
    defaultMessage: '\u043A \u043E\u0431\u043C\u0435\u043D\u0443:'
});

var WARNING_MESSAGE_NOT_ENOUGH_BONS = exports.WARNING_MESSAGE_NOT_ENOUGH_BONS = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.rewards.tank.footer.warning_message_no_enough_bons',
    defaultMessage: '\u0423 \u0432\u0430\u0441 \u043D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E \u0431\u043E\u043D \u0434\u043B\u044F \u0443\u0447\u0430\u0441\u0442\u0438\u044F \u0432 \u0430\u0443\u043A\u0446\u0438\u043E\u043D\u0435.'
});

var WARNING_MESSAGE_NOT_ENOUGH_BONS_FOR_PURCHASE = exports.WARNING_MESSAGE_NOT_ENOUGH_BONS_FOR_PURCHASE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.rewards.tank.footer.warning_message_no_enough_bons_to_purchase',
    defaultMessage: '\u0423 \u0432\u0430\u0441 \u043D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E \u0431\u043E\u043D \u0434\u043B\u044F \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u043D\u0430\u0433\u0440\u0430\u0434\u044B.'
});

var MINIMAL_RATE = exports.MINIMAL_RATE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.rewards.tank.footer.minimal_rate',
    defaultMessage: '\u041C\u0438\u043D\u0438\u043C\u0430\u043B\u044C\u043D\u0430\u044F \u0441\u0442\u0430\u0432\u043A\u0430:'
});

var BET_ACCEPTED = exports.BET_ACCEPTED = function BET_ACCEPTED(datetimeEnd) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_shop.rewards.tank.footer.bet_accepted',
        defaultMessage: '\u041F\u0440\u0438\u043D\u044F\u0442\u0430 \u0441\u0442\u0430\u0432\u043A\u0430 \u0432 \u0430\u0443\u043A\u0446\u0438\u043E\u043D\u0435 \u043D\u0430 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435 \u043F\u0440\u0438\u0437\u0430. \u041E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u0435 \u043F\u043E\u0431\u0435\u0434\u0438\u0442\u0435\u043B\u0435\u0439 \u0441\u043E\u0441\u0442\u043E\u0438\u0442\u0441\u044F {datetimeEnd}.',
        values: {
            datetimeEnd: _react2.default.createElement(
                'span',
                { className: _Footer2.default.finishedDate },
                datetimeEnd.format('L, LT')
            )
        }
    });
};

var BET_LOST = exports.BET_LOST = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.rewards.tank.footer.lost_bet',
    defaultMessage: '\u041F\u0440\u0438 \u043F\u0440\u043E\u0438\u0433\u0440\u044B\u0448\u0435 \u0431\u043E\u043D\u044B \u0431\u0443\u0434\u0443\u0442 \u0432\u043E\u0437\u0432\u0440\u0430\u0449\u0435\u043D\u044B \u043D\u0430 \u0432\u0430\u0448 \u0441\u0447\u0451\u0442.'
});

var YOUR_BET = exports.YOUR_BET = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.rewards.tank.foter.your_bet',
    defaultMessage: '\u0412\u0430\u0448\u0430 \u0441\u0442\u0430\u0432\u043A\u0430:'
});

var MAKE_BET = exports.MAKE_BET = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.rewards.tank.footer.make_bet',
    defaultMessage: '\u041A \u0441\u043E\u0436\u0430\u043B\u0435\u043D\u0438\u044E, \u0432\u044B \u043D\u0430\u0431\u0440\u0430\u043B\u0438 \u043D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E\u0435 \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u041E\u0447\u043A\u043E\u0432 \u0441\u043B\u0430\u0432\u044B \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 \u0441\u043E\u0431\u044B\u0442\u0438\u044F, \u043D\u043E \u0432\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C \u0431\u043E\u043D\u044B \u0434\u043B\u044F \u0443\u0447\u0430\u0441\u0442\u0438\u044F \u0432 \u0430\u0443\u043A\u0446\u0438\u043E\u043D\u0435 \u0437\u0430 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u0435 \u043D\u0430\u0433\u0440\u0430\u0434.'
});

var MAKE_BET_TEXT = exports.MAKE_BET_TEXT = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.rewards.tank.footer.make_bet_text',
    defaultMessage: '\u0421\u0434\u0435\u043B\u0430\u0442\u044C \u0441\u0442\u0430\u0432\u043A\u0443'
});

var CANCEL_BET = exports.CANCEL_BET = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.rewards.tank.footer.cancel_bet',
    defaultMessage: '\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C \u0441\u0442\u0430\u0432\u043A\u0443'
});

var PURCHASE_REWARD = exports.PURCHASE_REWARD = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.rewards.tank.footer.purchase_reward',
    defaultMessage: '\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043D\u0430\u0433\u0440\u0430\u0434\u0443'
});

var EVENT_FINISHED_NO_AUCTION_TICKET = exports.EVENT_FINISHED_NO_AUCTION_TICKET = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_shop.rewards.tank.footer.event_finished_has_no_auction_ticket',
    defaultMessage: '\u0412\u044B \u043D\u0435 \u0441\u043E\u0431\u0440\u0430\u043B\u0438 \u0432 \u041C\u0430\u0441\u0442\u0435\u0440\u0441\u043A\u043E\u0439 \u0434\u043E\u043F\u0443\u0441\u043A \u043D\u0430 \u0430\u0443\u043A\u0446\u0438\u043E\u043D \u0442\u0435\u0445\u043D\u0438\u043A\u0438 \u0434\u043B\u044F \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u043D\u0430\u0433\u0440\u0430\u0434\u043D\u044B\u0445 \u043C\u0430\u0448\u0438\u043D \u0437\u0430 \u0431\u043E\u043D\u044B.'
});

/***/ }),
/* 2449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactWotBootstrap = __webpack_require__(5);

var _constants = __webpack_require__(241);

var _constants2 = __webpack_require__(4);

var _WGCWXRewardsTankConfirmation = __webpack_require__(1382);

var _WGCWXRewardsTankConfirmation2 = _interopRequireDefault(_WGCWXRewardsTankConfirmation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WGCWXRewardsTankConfirmation = function (_React$Component) {
    _inherits(WGCWXRewardsTankConfirmation, _React$Component);

    function WGCWXRewardsTankConfirmation() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, WGCWXRewardsTankConfirmation);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WGCWXRewardsTankConfirmation.__proto__ || Object.getPrototypeOf(WGCWXRewardsTankConfirmation)).call.apply(_ref, [this].concat(args))), _this), _this.handleKeyPress = function (e) {
            if (e.keyCode !== _constants2.KEY_CODES.ESCAPE) return;

            _this.props.onClose();
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(WGCWXRewardsTankConfirmation, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.addEventListener('keydown', this.handleKeyPress);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('keydown', this.handleKeyPress);
        }
    }, {
        key: 'render',
        value: function render() {
            var imageClassNames = (0, _classnames2.default)(_WGCWXRewardsTankConfirmation2.default.image, this.props.messageType && _WGCWXRewardsTankConfirmation2.default['image__' + this.props.messageType]);
            return _react2.default.createElement(
                'div',
                { className: _WGCWXRewardsTankConfirmation2.default.base },
                _react2.default.createElement(
                    'div',
                    { className: _WGCWXRewardsTankConfirmation2.default.back },
                    _react2.default.createElement(_reactWotBootstrap.Back, {
                        side: 'right',
                        type: 'close',
                        caption: _constants.BACK_CAPTIONS.close,
                        onClick: this.props.onClose
                    })
                ),
                _react2.default.createElement(
                    'div',
                    { className: _WGCWXRewardsTankConfirmation2.default.content },
                    _react2.default.createElement('div', { className: imageClassNames }),
                    _react2.default.createElement(
                        'h1',
                        { className: _WGCWXRewardsTankConfirmation2.default.header },
                        this.props.title
                    ),
                    this.props.description && _react2.default.createElement(
                        'p',
                        { className: _WGCWXRewardsTankConfirmation2.default.description },
                        this.props.description
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _WGCWXRewardsTankConfirmation2.default.separator },
                        _react2.default.createElement('span', { className: _WGCWXRewardsTankConfirmation2.default.separator_image })
                    ),
                    this.props.children,
                    _react2.default.createElement(
                        'div',
                        { className: _WGCWXRewardsTankConfirmation2.default.buttons },
                        this.props.buttonsOptions.map(function (button, index) {
                            return _react2.default.createElement(
                                _reactWotBootstrap.Button,
                                {
                                    key: index === 0 ? 'default' : 'secondary',
                                    type: index === 0 ? 'default' : 'secondary',
                                    onClick: button.callback,
                                    mixClassName: _WGCWXRewardsTankConfirmation2.default.button
                                },
                                button.caption
                            );
                        })
                    )
                )
            );
        }
    }]);

    return WGCWXRewardsTankConfirmation;
}(_react2.default.Component);

WGCWXRewardsTankConfirmation.propTypes = {
    buttonsOptions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        caption: _propTypes2.default.element.isRequired,
        callback: _propTypes2.default.func.isRequired
    })).isRequired,
    description: _propTypes2.default.node,
    title: _propTypes2.default.element.isRequired,
    messageType: _propTypes2.default.oneOf(['error', 'alert']),

    children: _propTypes2.default.element,

    onClose: _propTypes2.default.func.isRequired
};
exports.default = WGCWXRewardsTankConfirmation;

/***/ }),
/* 2450 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"baseWrapper":"WGCWXRewardsTank_baseWrapper--2tu-p","base":"WGCWXRewardsTank_base--3augZ","base__blur":"WGCWXRewardsTank_base__blur--RNLoe","baseBlur":"WGCWXRewardsTank_base__blur--RNLoe","back":"WGCWXRewardsTank_back--17YBz","backTitle":"WGCWXRewardsTank_backTitle--3BxLO","hangarBg":"WGCWXRewardsTank_hangarBg--3BnjH","tankBg":"WGCWXRewardsTank_tankBg--1gf50","tankBg__50849":"WGCWXRewardsTank_tankBg__50849--3tYKp","tankBg50849":"WGCWXRewardsTank_tankBg__50849--3tYKp","tankBg__15617":"WGCWXRewardsTank_tankBg__15617--3txmK","tankBg15617":"WGCWXRewardsTank_tankBg__15617--3txmK","tankBg__58641":"WGCWXRewardsTank_tankBg__58641--JH8L4","tankBg58641":"WGCWXRewardsTank_tankBg__58641--JH8L4","tankBg__15905":"WGCWXRewardsTank_tankBg__15905--QUBZ6","tankBg15905":"WGCWXRewardsTank_tankBg__15905--QUBZ6","tankBg__63537":"WGCWXRewardsTank_tankBg__63537--2_ViT","tankBg63537":"WGCWXRewardsTank_tankBg__63537--2_ViT","tankBg__55841":"WGCWXRewardsTank_tankBg__55841--1VNbk","tankBg55841":"WGCWXRewardsTank_tankBg__55841--1VNbk","tankBg__57937":"WGCWXRewardsTank_tankBg__57937--2z5dJ","tankBg57937":"WGCWXRewardsTank_tankBg__57937--2z5dJ","tankBg__59441":"WGCWXRewardsTank_tankBg__59441---ns2G","tankBg59441":"WGCWXRewardsTank_tankBg__59441---ns2G","isCnRealm":"WGCWXRewardsTank_isCnRealm--Uxea9","main":"WGCWXRewardsTank_main--CvuSr","wrapper":"WGCWXRewardsTank_wrapper--3l9za","header":"WGCWXRewardsTank_header--3LGOy","nationality":"WGCWXRewardsTank_nationality--38EX1","nationality__ussr":"WGCWXRewardsTank_nationality__ussr--qlHyG","nationalityUssr":"WGCWXRewardsTank_nationality__ussr--qlHyG","nationality__germany":"WGCWXRewardsTank_nationality__germany--_Tk5f","nationalityGermany":"WGCWXRewardsTank_nationality__germany--_Tk5f","nationality__usa":"WGCWXRewardsTank_nationality__usa--2lj8v","nationalityUsa":"WGCWXRewardsTank_nationality__usa--2lj8v","nationality__china":"WGCWXRewardsTank_nationality__china--3h08L","nationalityChina":"WGCWXRewardsTank_nationality__china--3h08L","nationality__france":"WGCWXRewardsTank_nationality__france--36nnQ","nationalityFrance":"WGCWXRewardsTank_nationality__france--36nnQ","nationality__uk":"WGCWXRewardsTank_nationality__uk--d8OBE","nationalityUk":"WGCWXRewardsTank_nationality__uk--d8OBE","nationality__japan":"WGCWXRewardsTank_nationality__japan--1ztQH","nationalityJapan":"WGCWXRewardsTank_nationality__japan--1ztQH","nationality__czech":"WGCWXRewardsTank_nationality__czech--1_L-r","nationalityCzech":"WGCWXRewardsTank_nationality__czech--1_L-r","nationality__sweden":"WGCWXRewardsTank_nationality__sweden--2xi-b","nationalitySweden":"WGCWXRewardsTank_nationality__sweden--2xi-b","nationality__poland":"WGCWXRewardsTank_nationality__poland--_Dp5k","nationalityPoland":"WGCWXRewardsTank_nationality__poland--_Dp5k","nationality__italy":"WGCWXRewardsTank_nationality__italy--PEhK5","nationalityItaly":"WGCWXRewardsTank_nationality__italy--PEhK5","level":"WGCWXRewardsTank_level--5qAMD","name":"WGCWXRewardsTank_name--TVqms","compare":"WGCWXRewardsTank_compare--1gagA","buttonCompare":"WGCWXRewardsTank_buttonCompare--3sgeV","info":"WGCWXRewardsTank_info--3DXAT","infoIcon":"WGCWXRewardsTank_infoIcon--QEVho","infoText":"WGCWXRewardsTank_infoText--356eV","tankContainer":"WGCWXRewardsTank_tankContainer--1XOPx","bons":"WGCWXRewardsTank_bons--1qZl3","confirmWindow":"WGCWXRewardsTank_confirmWindow--aRx2w"};

/***/ }),
/* 2451 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"WGCWXShop_base--1D5zE","base__overlayOpened":"WGCWXShop_base__overlayOpened--1Lm8x","baseOverlayOpened":"WGCWXShop_base__overlayOpened--1Lm8x","processing":"WGCWXShop_processing--_h-Nz"};

/***/ }),
/* 2452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.stateToProps = exports.WGCWXBattleSchedule = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(7);

var _reactRouterRedux = __webpack_require__(15);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = __webpack_require__(93);

var _constants = __webpack_require__(4);

var _urls = __webpack_require__(19);

var _web_to_client = __webpack_require__(12);

var _hermod = __webpack_require__(1369);

var _wgcwx_battle_schedule = __webpack_require__(999);

var _reactWotBootstrap = __webpack_require__(5);

var _ButtonSimple = __webpack_require__(235);

var _ButtonSimple2 = _interopRequireDefault(_ButtonSimple);

var _WGCWXConfirmation = __webpack_require__(238);

var _WGCWXConfirmation2 = _interopRequireDefault(_WGCWXConfirmation);

var _BattleLog = __webpack_require__(2453);

var _BattleLog2 = _interopRequireDefault(_BattleLog);

var _errors = __webpack_require__(2458);

var _errors2 = _interopRequireDefault(_errors);

var _propTypes3 = __webpack_require__(1383);

var _translations = __webpack_require__(2459);

var _sounds = __webpack_require__(22);

var _WGCWXBattleSchedule = __webpack_require__(2460);

var _WGCWXBattleSchedule2 = _interopRequireDefault(_WGCWXBattleSchedule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WGCWXBattleSchedule = exports.WGCWXBattleSchedule = function (_React$Component) {
    _inherits(WGCWXBattleSchedule, _React$Component);

    function WGCWXBattleSchedule(props) {
        _classCallCheck(this, WGCWXBattleSchedule);

        var _this = _possibleConstructorReturn(this, (WGCWXBattleSchedule.__proto__ || Object.getPrototypeOf(WGCWXBattleSchedule)).call(this, props));

        _this.resetBattleScheduleTimer = function () {
            if (_this.battleScheduleTimerId) {
                clearTimeout(_this.battleScheduleTimerId);
            }
        };

        _this.handleReactiveChannelMessage = function (c2wEvent) {
            var data = (0, _hermod.parseHermodJSONData)(c2wEvent);
            var isBattlesUpdated = data && data.type === _constants.REACTIVE_CLAN_MESSAGE_TYPE.BATTLES_UPDATED;

            if (isBattlesUpdated) {
                var timeout = (0, _lodash.random)(2000, 6000);

                _this.resetBattleScheduleTimer();
                _this.battleScheduleTimerId = setTimeout(function () {
                    _this.props.requestBattleSchedule();
                }, timeout);
            }
        };

        _this.openGlobalMap = function (e) {
            e.preventDefault();
            var _this$props = _this.props,
                signInTokenUrl = _this$props.signInTokenUrl,
                globalMapUrl = _this$props.globalMapUrl;

            (0, _web_to_client.openExternalBrowserWithAuth)(signInTokenUrl, globalMapUrl);
        };

        _this.renderError = function () {
            var _this$props2 = _this.props,
                close = _this$props2.close,
                error = _this$props2.error;

            var errorData = _errors2.default[error] ? _errors2.default[error] : _errors2.default[_errors.ERROR_CODES.UNKNOWN_ERROR];

            var title = errorData.title,
                description = errorData.description;

            var errorClassNames = (0, _classnames2.default)(_WGCWXBattleSchedule2.default.base, _WGCWXBattleSchedule2.default.base__overlayOpened);

            return _react2.default.createElement(
                'div',
                { className: errorClassNames },
                _react2.default.createElement('div', { className: _WGCWXBattleSchedule2.default.background }),
                _react2.default.createElement(_WGCWXConfirmation2.default, {
                    messageType: 'error',
                    title: title,
                    description: description,
                    buttonsOptions: [{
                        caption: _translations.AFFIRMATIVE,
                        callback: function callback() {
                            return close();
                        }
                    }],
                    onClose: function onClose() {
                        return close();
                    }
                })
            );
        };

        _this.state = {
            isInitialLoading: true,
            battleSchedule: []
        };
        return _this;
    }

    _createClass(WGCWXBattleSchedule, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.props.playEnterClansBattlesGlobalMapSound();
            window.onBeforeUnloadHandlers.playShopSoundsOnExit = function () {
                _this2.props.playExitClansBattlesGlobalMapSound();
            };
            window.onBeforeUnloadHandlers.unsubscribeChannelOnExit = function () {
                _this2.unsubscribeChannel();
            };

            this.props.requestBattleSchedule();
            this.subscribeChannel();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.props.playExitClansBattlesGlobalMapSound();
            delete window.onBeforeUnloadHandlers.playShopSoundsOnExit;
            delete window.onBeforeUnloadHandlers.unsubscribeChannelOnExit;

            this.resetBattleScheduleTimer();
            this.unsubscribeChannel();
        }
    }, {
        key: 'subscribeChannel',
        value: function subscribeChannel() {
            if (this.props.clanChannelId) {
                (0, _hermod.subscribeToChannel)(this.props.clanChannelId, this.handleReactiveChannelMessage);
            }
        }
    }, {
        key: 'unsubscribeChannel',
        value: function unsubscribeChannel() {
            if (this.props.clanChannelId) {
                (0, _hermod.unsubscribeFromChannel)(this.props.clanChannelId, this.handleReactiveChannelMessage);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                isInitialLoading = _props.isInitialLoading,
                error = _props.error,
                battleSchedule = _props.battleSchedule;


            if (error) {
                return this.renderError();
            }

            return _react2.default.createElement(
                'div',
                { className: _WGCWXBattleSchedule2.default.base },
                _react2.default.createElement('div', { className: _WGCWXBattleSchedule2.default.background }),
                _react2.default.createElement(
                    'div',
                    { className: _WGCWXBattleSchedule2.default.container },
                    _react2.default.createElement(
                        'h1',
                        { className: _WGCWXBattleSchedule2.default.title },
                        _translations.GLOBAL_MAPS_BATTLES
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _WGCWXBattleSchedule2.default.infoContainer },
                        _react2.default.createElement(
                            'div',
                            { className: _WGCWXBattleSchedule2.default.infoIcon },
                            _react2.default.createElement(_reactWotBootstrap.Info, null)
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _WGCWXBattleSchedule2.default.info },
                            _translations.BATTLE_SCHEDULE_INFO
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _WGCWXBattleSchedule2.default.mapButton },
                            _react2.default.createElement(
                                _ButtonSimple2.default,
                                {
                                    onClick: this.openGlobalMap,
                                    isExternal: true
                                },
                                _translations.GO_TO_GLOBAL_MAP
                            )
                        )
                    ),
                    _react2.default.createElement(_BattleLog2.default, {
                        isInitialLoading: isInitialLoading,
                        battleSchedule: battleSchedule
                    })
                )
            );
        }
    }]);

    return WGCWXBattleSchedule;
}(_react2.default.Component);

WGCWXBattleSchedule.propTypes = {
    clanChannelId: _propTypes2.default.string.isRequired,
    globalMapUrl: _propTypes2.default.string.isRequired,
    signInTokenUrl: _propTypes2.default.string.isRequired,
    isInitialLoading: _propTypes2.default.bool.isRequired,
    error: _propTypes2.default.string,
    battleSchedule: _propTypes2.default.arrayOf(_propTypes3.battleInfoPropTypes),
    requestBattleSchedule: _propTypes2.default.func.isRequired,
    close: _propTypes2.default.func.isRequired,
    playEnterClansBattlesGlobalMapSound: _propTypes2.default.func.isRequired,
    playExitClansBattlesGlobalMapSound: _propTypes2.default.func.isRequired
};
var stateToProps = exports.stateToProps = function stateToProps(_ref) {
    var settings = _ref.settings,
        wgcwxBattleSchedule = _ref.wgcwxBattleSchedule,
        wgcwxClanInfo = _ref.wgcwxClanInfo;

    var clanId = wgcwxClanInfo.clan_info && wgcwxClanInfo.clan_info.id;
    return {
        clanChannelId: clanId && 'gm_clan_' + clanId,
        globalMapUrl: settings.globalMapUrl,
        signInTokenUrl: settings.signInTokenUrl,
        isInitialLoading: wgcwxBattleSchedule.isInitialLoading,
        error: wgcwxBattleSchedule.errorMessage,
        battleSchedule: wgcwxBattleSchedule.battleSchedule
    };
};

var dispatchToProps = function dispatchToProps(dispatch) {
    return {
        requestBattleSchedule: function requestBattleSchedule() {
            return dispatch((0, _wgcwx_battle_schedule.requestBattleSchedule)());
        },
        close: function close() {
            return dispatch((0, _reactRouterRedux.push)(_urls.CLAN_LANDING));
        },
        playEnterClansBattlesGlobalMapSound: function playEnterClansBattlesGlobalMapSound() {
            return dispatch((0, _sounds.playEnterClansBattlesGlobalMapSound)());
        },
        playExitClansBattlesGlobalMapSound: function playExitClansBattlesGlobalMapSound() {
            return dispatch((0, _sounds.playExitClansBattlesGlobalMapSound)());
        }
    };
};

exports.default = (0, _reactRedux.connect)(stateToProps, dispatchToProps)(WGCWXBattleSchedule);

/***/ }),
/* 2453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BattleLog = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _constants = __webpack_require__(4);

var _datetime = __webpack_require__(786);

var _reactWotBootstrap = __webpack_require__(5);

var _TextOverflow = __webpack_require__(2454);

var _TextOverflow2 = _interopRequireDefault(_TextOverflow);

var _propTypes3 = __webpack_require__(1383);

var _translations = __webpack_require__(2456);

var _BattleLog = __webpack_require__(2457);

var _BattleLog2 = _interopRequireDefault(_BattleLog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BattleLog = exports.BattleLog = function (_React$Component) {
    _inherits(BattleLog, _React$Component);

    function BattleLog(props) {
        _classCallCheck(this, BattleLog);

        var _this = _possibleConstructorReturn(this, (BattleLog.__proto__ || Object.getPrototypeOf(BattleLog)).call(this, props));

        _this.setScrollAreaHeight = function () {
            if (!_this._table || !_this._tableHead) return;

            var tableHeadHeight = _this._tableHead.clientHeight;
            var coords = _this._table.getBoundingClientRect();
            var scrollAreaHeight = window.innerHeight - coords.top - tableHeadHeight - _this.BOTTOM_SCROLL_OFFSET;
            if (_this.state.scrollAreaHeight !== scrollAreaHeight) {
                _this.setState({
                    scrollAreaHeight: scrollAreaHeight
                });
            }
        };

        _this.handleMediaQueryChange = function (event) {
            var isSmallMqActive = event.matches;

            if (_this.state.isSmallMqActive !== isSmallMqActive) {
                _this.setState({ isSmallMqActive: isSmallMqActive });
            }
        };

        _this.renderBattleInfoItem = function (battleInfo) {
            var provinceName = battleInfo.provinceName,
                arenaName = battleInfo.arenaName,
                peripheryName = battleInfo.peripheryName,
                respawnName = battleInfo.respawnName,
                isPlanned = battleInfo.isPlanned,
                enemyClan = battleInfo.enemyClan,
                startsAt = battleInfo.startsAt,
                provinceId = battleInfo.provinceId;
            var isSmallMqActive = _this.state.isSmallMqActive;


            var clanNameTooltipId = 'tooltip-clan-name-' + startsAt;
            var clanNameTooltipContent = enemyClan && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_reactWotBootstrap.ClanTag, {
                    size: 'medium',
                    tag: enemyClan.tag,
                    color: enemyClan.color
                }),
                _react2.default.createElement(
                    'span',
                    { className: _BattleLog2.default.clanName },
                    enemyClan.name
                )
            );

            var planedClassNames = (0, _classnames2.default)(_BattleLog2.default.planned, _defineProperty({}, _BattleLog2.default.planned__visible, isPlanned));

            return _react2.default.createElement(
                _reactWotBootstrap.TableRow,
                { key: startsAt + ' + ' + provinceId },
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)(_BattleLog2.default.td, _BattleLog2.default.td__begin) },
                    _react2.default.createElement(
                        'div',
                        { className: _BattleLog2.default.dateContainer },
                        _react2.default.createElement(
                            'div',
                            { className: _BattleLog2.default.time },
                            (0, _datetime.unixToFormattedLocalTime)(startsAt),
                            _react2.default.createElement(
                                'span',
                                { className: planedClassNames },
                                '\u2009',
                                '+'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _BattleLog2.default.date },
                            (0, _datetime.unixToFormattedLocalDate)(startsAt)
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)(_BattleLog2.default.td, _BattleLog2.default.td__server) },
                    _react2.default.createElement(
                        _TextOverflow2.default,
                        { tooltipId: 'tooltip-periphery-name-' + startsAt },
                        peripheryName
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)(_BattleLog2.default.td, _BattleLog2.default.td__province) },
                    _react2.default.createElement(
                        _TextOverflow2.default,
                        { tooltipId: 'tooltip-province-name-' + startsAt },
                        provinceName
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)(_BattleLog2.default.td, _BattleLog2.default.td__map) },
                    _react2.default.createElement(
                        _TextOverflow2.default,
                        { tooltipId: 'tooltip-arena-name-' + startsAt },
                        arenaName
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)(_BattleLog2.default.td, _BattleLog2.default.td__base) },
                    respawnName ? _react2.default.createElement(
                        _TextOverflow2.default,
                        { tooltipId: 'tooltip-respawn-name-' + startsAt },
                        respawnName
                    ) : _react2.default.createElement(
                        'div',
                        { className: _BattleLog2.default.dashes },
                        '– –'
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)(_BattleLog2.default.td, _BattleLog2.default.td__enemy) },
                    enemyClan ? _react2.default.createElement(
                        'div',
                        {
                            className: _BattleLog2.default.clan,
                            'data-tip': clanNameTooltipId,
                            'data-for': clanNameTooltipId
                        },
                        _react2.default.createElement(
                            'div',
                            { className: _BattleLog2.default.clanTag },
                            _react2.default.createElement(_reactWotBootstrap.ClanTag, {
                                size: 'medium',
                                tag: enemyClan.tag,
                                color: enemyClan.color,
                                emblem: enemyClan.emblemUrl
                            })
                        ),
                        isSmallMqActive ? _react2.default.createElement(
                            _TextOverflow2.default,
                            {
                                tooltipId: clanNameTooltipId,
                                tooltipContent: clanNameTooltipContent
                            },
                            enemyClan.name
                        ) : _react2.default.createElement(_reactWotBootstrap.Tooltip, {
                            id: clanNameTooltipId,
                            getContent: function getContent() {
                                return clanNameTooltipContent;
                            }
                        })
                    ) : _react2.default.createElement(
                        _TextOverflow2.default,
                        {
                            classMix: _BattleLog2.default.enemyNotDefined,
                            tooltipId: 'tooltip-clan-not-defined-' + startsAt
                        },
                        _translations.ENEMY_NOT_DEFINED
                    )
                )
            );
        };

        _this.state = {
            scrollAreaHeight: 0,
            isSmallMqActive: window.matchMedia(_constants.MEDIA_QUERIES.EXTRA_SMALL_WIDTH).matches
        };

        _this.BOTTOM_SCROLL_OFFSET = 10;
        _this.SCROLL_STEP = 40;
        return _this;
    }

    _createClass(BattleLog, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.matchMedia(_constants.MEDIA_QUERIES.EXTRA_SMALL_WIDTH).addEventListener('change', this.handleMediaQueryChange);
            window.addEventListener('resize', this.setScrollAreaHeight);
            this.setScrollAreaHeight();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.matchMedia(_constants.MEDIA_QUERIES.EXTRA_SMALL_WIDTH).removeEventListener('change', this.handleMediaQueryChange);
            window.removeEventListener('resize', this.setScrollAreaHeight);
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (this.props.battleSchedule && prevProps.battleSchedule.length !== this.props.battleSchedule.length) {
                this.setScrollAreaHeight();
            }
        }
    }, {
        key: 'renderContent',
        value: function renderContent() {
            var _props = this.props,
                battleSchedule = _props.battleSchedule,
                isInitialLoading = _props.isInitialLoading;

            if (isInitialLoading) return _react2.default.createElement(
                'div',
                { style: { height: this.state.scrollAreaHeight } },
                _react2.default.createElement(_reactWotBootstrap.Processing, {
                    type: 'local',
                    isVisible: true
                })
            );

            if (!battleSchedule.length) return _react2.default.createElement(
                'div',
                {
                    className: _BattleLog2.default.tableInfo,
                    style: { height: this.state.scrollAreaHeight }
                },
                _translations.NO_CLAN_BATTLES
            );

            return _react2.default.createElement(
                _reactWotBootstrap.ScrollArea,
                {
                    modifier: 'table',
                    stepHeight: this.SCROLL_STEP,
                    scrollableAreaHeight: this.state.scrollAreaHeight
                },
                battleSchedule.map(this.renderBattleInfoItem)
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { ref: function ref(el) {
                        return _this2._table = el;
                    } },
                _react2.default.createElement(
                    _reactWotBootstrap.Table,
                    { isScrollable: true },
                    _react2.default.createElement(
                        'div',
                        { ref: function ref(el) {
                                return _this2._tableHead = el;
                            } },
                        _react2.default.createElement(
                            _reactWotBootstrap.TableHead,
                            null,
                            _react2.default.createElement(
                                'div',
                                { className: (0, _classnames2.default)(_BattleLog2.default.th, _BattleLog2.default.th__begin) },
                                _translations.BEGIN
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: (0, _classnames2.default)(_BattleLog2.default.th, _BattleLog2.default.th__server) },
                                _translations.SERVER
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: (0, _classnames2.default)(_BattleLog2.default.th, _BattleLog2.default.th__province) },
                                _translations.PROVINCE
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: (0, _classnames2.default)(_BattleLog2.default.th, _BattleLog2.default.th__map) },
                                _translations.MAP
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: (0, _classnames2.default)(_BattleLog2.default.th, _BattleLog2.default.th__base) },
                                _translations.BASE
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: (0, _classnames2.default)(_BattleLog2.default.th, _BattleLog2.default.th__enemy) },
                                _translations.ENEMY
                            )
                        )
                    ),
                    this.renderContent()
                )
            );
        }
    }]);

    return BattleLog;
}(_react2.default.Component);

BattleLog.propTypes = {
    isInitialLoading: _propTypes2.default.bool.isRequired,
    battleSchedule: _propTypes2.default.arrayOf(_propTypes3.battleInfoPropTypes)
};
exports.default = BattleLog;

/***/ }),
/* 2454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _reactWotBootstrap = __webpack_require__(5);

var _TextOverflow = __webpack_require__(2455);

var _TextOverflow2 = _interopRequireDefault(_TextOverflow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextOverflow = function (_React$Component) {
    _inherits(TextOverflow, _React$Component);

    function TextOverflow(props) {
        _classCallCheck(this, TextOverflow);

        var _this = _possibleConstructorReturn(this, (TextOverflow.__proto__ || Object.getPrototypeOf(TextOverflow)).call(this, props));

        _this.checkOverflow = function () {
            if (!_this._base) return;

            var isTooltipEnabled = _this._base.offsetWidth < _this._base.scrollWidth;

            if (_this.state.isTooltipEnabled !== isTooltipEnabled) {
                _this.setState({
                    isTooltipEnabled: isTooltipEnabled
                });
            }
        };

        _this.getTooltipContent = function () {
            var _this$props = _this.props,
                tooltipContent = _this$props.tooltipContent,
                children = _this$props.children;

            return tooltipContent ? tooltipContent : children;
        };

        _this.state = {
            isTooltipEnabled: false
        };
        return _this;
    }

    _createClass(TextOverflow, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.addEventListener('resize', this.checkOverflow);
            this.checkOverflow();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('resize', this.checkOverflow);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                children = _props.children,
                classMix = _props.classMix,
                withTooltip = _props.withTooltip,
                tooltipId = _props.tooltipId;
            var isTooltipEnabled = this.state.isTooltipEnabled;


            var baseClassName = (0, _classnames2.default)(_TextOverflow2.default.base, classMix);

            return _react2.default.createElement(
                'div',
                {
                    ref: function ref(c) {
                        return _this2._base = c;
                    },
                    className: baseClassName,
                    'data-tip': tooltipId,
                    'data-for': tooltipId
                },
                children,
                withTooltip && isTooltipEnabled && _react2.default.createElement(_reactWotBootstrap.Tooltip, {
                    id: tooltipId,
                    getContent: this.getTooltipContent
                })
            );
        }
    }]);

    return TextOverflow;
}(_react2.default.Component);

TextOverflow.propTypes = {
    children: _propTypes2.default.node.isRequired,
    classMix: _propTypes2.default.string,
    withTooltip: _propTypes2.default.bool,
    tooltipId: _propTypes2.default.string,
    tooltipContent: _propTypes2.default.node
};


TextOverflow.defaultProps = {
    withTooltip: true
};

exports.default = TextOverflow;

/***/ }),
/* 2455 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"TextOverflow_base--1L7dU"};

/***/ }),
/* 2456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NO_CLAN_BATTLES = exports.ENEMY_NOT_DEFINED = exports.ENEMY = exports.BASE = exports.MAP = exports.PROVINCE = exports.SERVER = exports.BEGIN = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BEGIN = exports.BEGIN = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_log.battle_begin',
    defaultMessage: '\u041D\u0430\u0447\u0430\u043B\u043E'
});

var SERVER = exports.SERVER = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_log.battle_server',
    defaultMessage: '\u0421\u0435\u0440\u0432\u0435\u0440'
});

var PROVINCE = exports.PROVINCE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_log.battle_province',
    defaultMessage: '\u041F\u0440\u043E\u0432\u0438\u043D\u0446\u0438\u044F'
});

var MAP = exports.MAP = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_log.battle_map',
    defaultMessage: '\u041A\u0430\u0440\u0442\u0430'
});

var BASE = exports.BASE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_log.base',
    defaultMessage: '\u041C\u0435\u0441\u0442\u043E \u0432\u044B\u0441\u0430\u0434\u043A\u0438'
});

var ENEMY = exports.ENEMY = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_log.battle_enemy',
    defaultMessage: '\u041F\u0440\u043E\u0442\u0438\u0432\u043D\u0438\u043A'
});

var ENEMY_NOT_DEFINED = exports.ENEMY_NOT_DEFINED = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_log.battle_enemy_not_defined',
    defaultMessage: '\u041F\u0440\u043E\u0442\u0438\u0432\u043D\u0438\u043A \u043D\u0435 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0451\u043D'
});

var NO_CLAN_BATTLES = exports.NO_CLAN_BATTLES = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'battle_log.no_clan_battles',
    defaultMessage: '\u0423 \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043B\u0430\u043D\u0430 \u043D\u0435\u0442 \u0431\u043E\u0451\u0432'
});

/***/ }),
/* 2457 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tableInfo":"BattleLog_tableInfo--1TyjX","th":"BattleLog_th--2qX-P","th__begin":"BattleLog_th__begin--2tSNJ","thBegin":"BattleLog_th__begin--2tSNJ","th__server":"BattleLog_th__server--3n-Pe","thServer":"BattleLog_th__server--3n-Pe","th__province":"BattleLog_th__province--1PVcU","thProvince":"BattleLog_th__province--1PVcU","th__map":"BattleLog_th__map--27cYp","thMap":"BattleLog_th__map--27cYp","th__base":"BattleLog_th__base--3ZQcm","thBase":"BattleLog_th__base--3ZQcm","th__enemy":"BattleLog_th__enemy--2bFru","thEnemy":"BattleLog_th__enemy--2bFru","td":"BattleLog_td--3b05R","td__begin":"BattleLog_td__begin--3eP_B","tdBegin":"BattleLog_td__begin--3eP_B","td__server":"BattleLog_td__server--Xgii_","tdServer":"BattleLog_td__server--Xgii_","td__province":"BattleLog_td__province--3CclY","tdProvince":"BattleLog_td__province--3CclY","td__map":"BattleLog_td__map--3fnk_","tdMap":"BattleLog_td__map--3fnk_","td__base":"BattleLog_td__base--3w41B","tdBase":"BattleLog_td__base--3w41B","td__enemy":"BattleLog_td__enemy--_AaeB","tdEnemy":"BattleLog_td__enemy--_AaeB","dateContainer":"BattleLog_dateContainer--JrvK8","time":"BattleLog_time--1WOgz","planned":"BattleLog_planned--9x5-z","planned__visible":"BattleLog_planned__visible--1E6Ap","plannedVisible":"BattleLog_planned__visible--1E6Ap","date":"BattleLog_date--1qBgG","dashes":"BattleLog_dashes--doSyT","enemyNotDefined":"BattleLog_enemyNotDefined--UBbW1","clan":"BattleLog_clan--uSkzJ","clanTag":"BattleLog_clanTag--s-mbb","clanName":"BattleLog_clanName--1c8HH"};

/***/ }),
/* 2458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ERROR_CODES = undefined;

var _ERROR_CODES$SCHEDULE;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint-disable react/no-multi-comp, max-len */


var ERROR_CODES = exports.ERROR_CODES = {
    SCHEDULE_IS_NOT_AVAILABLE: 'battle_schedule_is_not_available',
    UNKNOWN_ERROR: 'UNKNOWN_ERROR'
};

exports.default = (_ERROR_CODES$SCHEDULE = {}, _defineProperty(_ERROR_CODES$SCHEDULE, ERROR_CODES.SCHEDULE_IS_NOT_AVAILABLE, {
    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_battle_schedule.battle_schedule_is_not_available.title',
        defaultMessage: '\u0421\u043F\u0438\u0441\u043E\u043A \u0431\u043E\u0435\u0432 \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u0435\u043D'
    }),
    description: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_battle_schedule.battle_schedule_is_not_available.description',
        defaultMessage: '\u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0437\u0430\u0439\u0442\u0438 \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u043F\u043E\u0437\u0436\u0435'
    })
}), _defineProperty(_ERROR_CODES$SCHEDULE, ERROR_CODES.UNKNOWN_ERROR, {
    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_battle_schedule.battle_schedule_data_loading_error.title',
        defaultMessage: '\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043E\u0442\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u044C \u0441\u043F\u0438\u0441\u043E\u043A \u0431\u043E\u0451\u0432'
    }),
    description: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_battle_schedule.battle_schedule_data_loading_error.description',
        defaultMessage: '\u0421\u043F\u0438\u0441\u043E\u043A \u0431\u043E\u0451\u0432 \u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u0435\u043D. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u043E\u0437\u0436\u0435.'
    })
}), _ERROR_CODES$SCHEDULE);

/***/ }),
/* 2459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AFFIRMATIVE = exports.GO_TO_GLOBAL_MAP = exports.BATTLE_SCHEDULE_INFO = exports.GLOBAL_MAPS_BATTLES = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */
var GLOBAL_MAPS_BATTLES = exports.GLOBAL_MAPS_BATTLES = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_battle_schedule.title',
    defaultMessage: '\u0411\u043E\u0438 \u043D\u0430 \u0433\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435'
});

var BATTLE_SCHEDULE_INFO = exports.BATTLE_SCHEDULE_INFO = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_battle_schedule.info',
    defaultMessage: '\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043F\u0440\u0435\u0434\u0441\u0442\u043E\u044F\u0449\u0438\u0445 \u0431\u043E\u0451\u0432 \u043C\u043E\u0436\u0435\u0442 \u0438\u0437\u043C\u0435\u043D\u044F\u0442\u044C\u0441\u044F \u0432 \u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0441\u0442\u0438 \u043E\u0442 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0439 \u043A\u043E\u043C\u0430\u043D\u0434\u043D\u043E\u0433\u043E \u0441\u043E\u0441\u0442\u0430\u0432\u0430 \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043B\u0430\u043D\u0430 \u0438 \u043A\u043B\u0430\u043D\u043E\u0432-\u0441\u043E\u043F\u0435\u0440\u043D\u0438\u043A\u043E\u0432 \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435.'
});

var GO_TO_GLOBAL_MAP = exports.GO_TO_GLOBAL_MAP = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_battle_schedule.go_to_global_map',
    defaultMessage: '\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043A \u043A\u0430\u0440\u0442\u0435'
});

var AFFIRMATIVE = exports.AFFIRMATIVE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_battle_schedule.affirmative',
    defaultMessage: '\u0422\u0430\u043A \u0442\u043E\u0447\u043D\u043E!'
});

/***/ }),
/* 2460 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"WGCWXBattleSchedule_base--3EWt5","base__overlayOpened":"WGCWXBattleSchedule_base__overlayOpened--kunwD","baseOverlayOpened":"WGCWXBattleSchedule_base__overlayOpened--kunwD","background":"WGCWXBattleSchedule_background--2boXO","container":"WGCWXBattleSchedule_container--10EMs","title":"WGCWXBattleSchedule_title--1YTXo","infoContainer":"WGCWXBattleSchedule_infoContainer--XvugP","infoIcon":"WGCWXBattleSchedule_infoIcon--cJH7X","info":"WGCWXBattleSchedule_info--1FHDs","mapButton":"WGCWXBattleSchedule_mapButton--92Il4"};

/***/ }),
/* 2461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.stateToProps = exports.WGCWXLeaderboards = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(7);

var _reactRouterRedux = __webpack_require__(15);

var _reactWotBootstrap = __webpack_require__(5);

var _urls = __webpack_require__(19);

var _wgcwx_leaderboards = __webpack_require__(1000);

var _web_to_client = __webpack_require__(12);

var _datetime = __webpack_require__(13);

var _constants = __webpack_require__(104);

var _RatingCard = __webpack_require__(2462);

var _RatingCard2 = _interopRequireDefault(_RatingCard);

var _Header = __webpack_require__(2474);

var _Header2 = _interopRequireDefault(_Header);

var _Error = __webpack_require__(2476);

var _Error2 = _interopRequireDefault(_Error);

var _Footer = __webpack_require__(2479);

var _Footer2 = _interopRequireDefault(_Footer);

var _translations = __webpack_require__(2482);

var _sounds = __webpack_require__(22);

var _WGCWXLeaderboards = __webpack_require__(2483);

var _WGCWXLeaderboards2 = _interopRequireDefault(_WGCWXLeaderboards);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WGCWXLeaderboards = exports.WGCWXLeaderboards = function (_React$Component) {
    _inherits(WGCWXLeaderboards, _React$Component);

    function WGCWXLeaderboards(props) {
        _classCallCheck(this, WGCWXLeaderboards);

        var _this = _possibleConstructorReturn(this, (WGCWXLeaderboards.__proto__ || Object.getPrototypeOf(WGCWXLeaderboards)).call(this, props));

        _this.openRatingLink = function (e) {
            e.preventDefault();
            var _this$props = _this.props,
                signInTokenUrl = _this$props.signInTokenUrl,
                globalMapUrl = _this$props.globalMapUrl;

            var url = new URL(globalMapUrl);
            (0, _web_to_client.openExternalBrowserWithAuth)(signInTokenUrl, url.origin + url.pathname + _constants.LEADERBOARDS_HASH, true);
        };

        _this.openAboutRewardingLink = function (e) {
            e.preventDefault();
            var _this$props2 = _this.props,
                signInTokenUrl = _this$props2.signInTokenUrl,
                leaderboards = _this$props2.leaderboards;

            (0, _web_to_client.openExternalBrowserWithAuth)(signInTokenUrl, leaderboards.event.aboutRewardingLink, true);
        };

        return _this;
    }

    _createClass(WGCWXLeaderboards, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            this.props.playEnterClansBattlesGlobalMapSound();
            window.onBeforeUnloadHandlers.playShopSoundsOnExit = function () {
                _this2.props.playExitClansBattlesGlobalMapSound();
            };

            this.props.requestLeaderboards();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.props.playExitClansBattlesGlobalMapSound();
            delete window.onBeforeUnloadHandlers.playShopSoundsOnExit;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                leaderboards = _props.leaderboards,
                isLoading = _props.isLoading,
                error = _props.error,
                errorActionType = _props.errorActionType,
                _onClose = _props.onClose,
                getRewards = _props.getRewards,
                isRewardsTaken = _props.isRewardsTaken,
                isRewardsProcessing = _props.isRewardsProcessing;


            if (error) {
                return _react2.default.createElement(_Error2.default, {
                    error: error,
                    errorActionType: errorActionType,
                    caption: _translations.LEADERBOARDS_AFFIRMATIVE,
                    onClose: function onClose() {
                        return _onClose();
                    }
                });
            }

            if (isLoading) return _react2.default.createElement(_reactWotBootstrap.Processing, {
                type: 'local',
                isVisible: true
            });

            return _react2.default.createElement(
                'div',
                { className: _WGCWXLeaderboards2.default.base },
                _react2.default.createElement(
                    'div',
                    { className: _WGCWXLeaderboards2.default.container },
                    _react2.default.createElement(_Header2.default, {
                        title: _translations.LEADERBOARDS_TITLE,
                        eventName: leaderboards.event.name,
                        date: (0, _datetime.getDatePeriod)(leaderboards.event.startDate, leaderboards.event.endDate)
                    }),
                    _react2.default.createElement(
                        'div',
                        { className: _WGCWXLeaderboards2.default.infoContainer },
                        _react2.default.createElement(
                            'div',
                            { className: _WGCWXLeaderboards2.default.info },
                            _translations.LEADERBOARDS_INFO
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _WGCWXLeaderboards2.default.linksBlock },
                            _react2.default.createElement(
                                'div',
                                { className: _WGCWXLeaderboards2.default.externalLink, onClick: this.openRatingLink },
                                _translations.GO_TO_GLOBAL_MAP_RATINGS
                            ),
                            _react2.default.createElement(
                                'div',
                                { className: _WGCWXLeaderboards2.default.externalLink, onClick: this.openAboutRewardingLink },
                                _translations.GO_TO_GLOBAL_MAP_REWARDS
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _WGCWXLeaderboards2.default.boardsHolder },
                        _react2.default.createElement(
                            'div',
                            { className: _WGCWXLeaderboards2.default.boards },
                            leaderboards.leaderboards.map(function (item) {
                                return _react2.default.createElement(
                                    'div',
                                    { className: _WGCWXLeaderboards2.default.boardItem, key: item.type },
                                    _react2.default.createElement(_RatingCard2.default, _extends({}, item, {
                                        event: leaderboards.event
                                    }))
                                );
                            })
                        )
                    )
                ),
                _react2.default.createElement(_Footer2.default, {
                    reward: leaderboards.rewards,
                    getRewards: getRewards,
                    isRewardsTaken: isRewardsTaken,
                    isRewardsProcessing: isRewardsProcessing
                })
            );
        }
    }]);

    return WGCWXLeaderboards;
}(_react2.default.Component);

WGCWXLeaderboards.propTypes = {
    isLoading: _propTypes2.default.bool.isRequired,
    isRewardsProcessing: _propTypes2.default.bool.isRequired,
    isRewardsTaken: _propTypes2.default.bool.isRequired,
    leaderboards: _propTypes2.default.object,
    requestLeaderboards: _propTypes2.default.func.isRequired,
    getRewards: _propTypes2.default.func.isRequired,
    globalMapUrl: _propTypes2.default.string.isRequired,
    signInTokenUrl: _propTypes2.default.string.isRequired,
    error: _propTypes2.default.string,
    errorActionType: _propTypes2.default.string,
    onClose: _propTypes2.default.func.isRequired,
    playEnterClansBattlesGlobalMapSound: _propTypes2.default.func.isRequired,
    playExitClansBattlesGlobalMapSound: _propTypes2.default.func.isRequired
};
var stateToProps = exports.stateToProps = function stateToProps(_ref) {
    var settings = _ref.settings,
        wgcwxLeaderboards = _ref.wgcwxLeaderboards,
        wgcwxClanInfo = _ref.wgcwxClanInfo;

    var clanId = wgcwxClanInfo.clan_info && wgcwxClanInfo.clan_info.id;
    return {
        clanChannelId: clanId && 'gm_clan_' + clanId,
        globalMapUrl: settings.globalMapUrl,
        signInTokenUrl: settings.signInTokenUrl,
        isLoading: wgcwxLeaderboards.isLoading,
        isRewardsProcessing: wgcwxLeaderboards.isRewardsProcessing,
        isRewardsTaken: wgcwxLeaderboards.isRewardsTaken,
        error: wgcwxLeaderboards.errorMessage,
        errorActionType: wgcwxLeaderboards.errorActionType,
        leaderboards: wgcwxLeaderboards.leaderboards
    };
};

var dispatchToProps = function dispatchToProps(dispatch) {
    return {
        requestLeaderboards: function requestLeaderboards() {
            return dispatch((0, _wgcwx_leaderboards.requestLeaderboards)());
        },
        getRewards: function getRewards() {
            return dispatch((0, _wgcwx_leaderboards.getRewards)());
        },
        onClose: function onClose() {
            return dispatch((0, _reactRouterRedux.push)(_urls.CLAN_LANDING));
        },
        playEnterClansBattlesGlobalMapSound: function playEnterClansBattlesGlobalMapSound() {
            return dispatch((0, _sounds.playEnterClansBattlesGlobalMapSound)());
        },
        playExitClansBattlesGlobalMapSound: function playExitClansBattlesGlobalMapSound() {
            return dispatch((0, _sounds.playExitClansBattlesGlobalMapSound)());
        }
    };
};

exports.default = (0, _reactRedux.connect)(stateToProps, dispatchToProps)(WGCWXLeaderboards);

/***/ }),
/* 2462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _sortBy = __webpack_require__(300);

var _sortBy2 = _interopRequireDefault(_sortBy);

var _translations = __webpack_require__(2463);

var _reactIntl = __webpack_require__(3);

var _constants = __webpack_require__(104);

var _datetime = __webpack_require__(13);

var _Reward = __webpack_require__(2464);

var _RewardBox = __webpack_require__(2470);

var _RatingCard = __webpack_require__(1384);

var _RatingCard2 = _interopRequireDefault(_RatingCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getPositionClanText = function getPositionClanText(qualificationFp, qualificationBattles) {
    switch (true) {
        case Boolean(qualificationFp && qualificationBattles):
            return (0, _translations.RATING_CARD_POSITION_CLAN)(qualificationFp, qualificationBattles);
        case Boolean(qualificationBattles):
            return (0, _translations.RATING_CARD_POSITION_CLAN_BATTLES)(qualificationBattles);
        case Boolean(qualificationFp):
            return _translations.RATING_CARD_POSITION_CLAN_PFP;
        default:
            return null;
    }
};

var getPeriod = function getPeriod(type, startTs, endTs, event) {
    switch (type) {
        case _constants.LEADERBOARDS_TYPE.PERSONAL_PERIODIC:
            return (0, _datetime.getDateTimePeriod)(startTs, endTs);
        case _constants.LEADERBOARDS_TYPE.CLAN_PERIODIC:
            return (0, _datetime.getDateTimePeriod)(startTs, endTs);
        case _constants.LEADERBOARDS_TYPE.CLAN:
            return (0, _translations.LEADERBOARDS_ALL_THE_TIME)((0, _datetime.getDatePeriod)(event.startDate, event.endDate));
    }
};

var getDescriptionText = function getDescriptionText(type, hasRewards, prizePlaces, endTs) {
    if (hasRewards) {
        switch (type) {
            case _constants.LEADERBOARDS_TYPE.PERSONAL_PERIODIC:
                return _translations.LEADERBOARDS_RATING_DESCRIPTION_PERSONAL;
            case _constants.LEADERBOARDS_TYPE.CLAN_PERIODIC:
                return (0, _translations.LEADERBOARDS_DESCRIPTION_CLAN_PERIODIC)((0, _datetime.getDateTime)(endTs));
            case _constants.LEADERBOARDS_TYPE.CLAN:
                return _translations.LEADERBOARDS_RATING_DESCRIPTION_CLAN;
        }
    }

    if (prizePlaces) {
        switch (type) {
            case _constants.LEADERBOARDS_TYPE.PERSONAL_PERIODIC:
                return (0, _translations.LEADERBOARDS_DESCRIPTION_TOP_PERSONAL)(_react2.default.createElement(_reactIntl.FormattedNumber, { value: prizePlaces }));
            case _constants.LEADERBOARDS_TYPE.CLAN:
                return (0, _translations.LEADERBOARDS_DESCRIPTION_TOP_CLAN)(_react2.default.createElement(_reactIntl.FormattedNumber, { value: prizePlaces }));
            case _constants.LEADERBOARDS_TYPE.CLAN_PERIODIC:
                return _translations.LEADERBOARDS_DESCRIPTION_CLAN_PERIODIC_NOT_DEFINED;
        }
    }

    return _translations.LEADERBOARDS_RATING_DESCRIPTION_NOT_DEFINED;
};

var getTitleText = function getTitleText(type) {
    switch (type) {
        case _constants.LEADERBOARDS_TYPE.PERSONAL_PERIODIC:
            return _translations.LEADERBOARDS_PERSONAL_PERIODIC;
        case _constants.LEADERBOARDS_TYPE.CLAN_PERIODIC:
            return _translations.LEADERBOARDS_CLAN_PERIODIC;
        case _constants.LEADERBOARDS_TYPE.CLAN:
            return _translations.LEADERBOARDS_CLAN;
    }
};

var getPositionText = function getPositionText(place, type, qualificationFp, qualificationBattles) {
    if (place) {
        return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'div',
                { className: _RatingCard2.default.positionNumber },
                _react2.default.createElement(_reactIntl.FormattedNumber, { value: place })
            ),
            _react2.default.createElement(
                'div',
                { className: _RatingCard2.default.positionText },
                type === _constants.LEADERBOARDS_TYPE.PERSONAL_PERIODIC ? _translations.LEADERBOARDS_RATING_POSITION_PERSONAL : _translations.LEADERBOARDS_RATING_POSITION_CLAN
            )
        );
    }

    switch (type) {
        case _constants.LEADERBOARDS_TYPE.PERSONAL_PERIODIC:
            return _react2.default.createElement(
                'div',
                { className: _RatingCard2.default.positionDescription },
                (0, _translations.RATING_CARD_POSITION_PERSONAL)(qualificationFp)
            );
        case _constants.LEADERBOARDS_TYPE.CLAN_PERIODIC:
            return _react2.default.createElement(
                'div',
                { className: _RatingCard2.default.positionDescription },
                _translations.RATING_CARD_POSITION_CLAN_PERIODIC
            );
        case _constants.LEADERBOARDS_TYPE.CLAN:
            return _react2.default.createElement(
                'div',
                { className: _RatingCard2.default.positionDescription },
                getPositionClanText(qualificationFp, qualificationBattles)
            );
    }
};

var RatingCard = function RatingCard(props) {
    var place = props.place,
        type = props.type,
        _props$rewards = props.rewards,
        rewards = _props$rewards === undefined ? [] : _props$rewards,
        prizePlaces = props.prizePlaces,
        startTs = props.startTs,
        endTs = props.endTs,
        qualificationFp = props.qualificationFp,
        qualificationBattles = props.qualificationBattles,
        event = props.event;


    var hasRewards = rewards && rewards.length > 0;
    var hasRewardsInBox = hasRewards && rewards.length > _constants.MAX_VISIBLE_REWARD_COUNT;

    var sortedRewards = (0, _sortBy2.default)(rewards, ['priority']);
    var visibleRewards = hasRewardsInBox ? sortedRewards.slice(0, _constants.MAX_VISIBLE_REWARD_COUNT - 1) : sortedRewards;
    var rewardsInBox = hasRewardsInBox ? sortedRewards.slice(_constants.MAX_VISIBLE_REWARD_COUNT - sortedRewards.length - 1).map(function (item) {
        return {
            id: item.id,
            type: _constants.CLIENT_REWARD_TYPE[item.type],
            value: item.amount
        };
    }) : [];

    return _react2.default.createElement(
        'div',
        { className: _RatingCard2.default.base },
        _react2.default.createElement(
            'div',
            { className: _RatingCard2.default.ratingHeader },
            _react2.default.createElement(
                'div',
                { className: _RatingCard2.default.title },
                getTitleText(type)
            ),
            _react2.default.createElement(
                'div',
                { className: _RatingCard2.default.date },
                getPeriod(type, startTs, endTs, event)
            )
        ),
        _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)(_RatingCard2.default.positionBlock, !place && _RatingCard2.default.positionBlock__noPosition) },
            getPositionText(place, type, qualificationFp, qualificationBattles)
        ),
        _react2.default.createElement(
            'div',
            { className: _RatingCard2.default.footer },
            _react2.default.createElement(
                'div',
                { className: (0, _classnames2.default)(_RatingCard2.default.rewards, hasRewards && _RatingCard2.default.rewards__granted) },
                visibleRewards.map(function (item, i) {
                    return _react2.default.createElement(_Reward.Reward, { key: i, reward: item });
                }),
                hasRewardsInBox && _react2.default.createElement(_RewardBox.RewardBox, {
                    className: _RatingCard2.default.rewardBox,
                    rewards: rewardsInBox
                })
            ),
            _react2.default.createElement(
                'div',
                { className: _RatingCard2.default.description },
                getDescriptionText(type, hasRewards, prizePlaces, endTs)
            )
        )
    );
};

RatingCard.propTypes = {
    type: _propTypes2.default.string.isRequired,
    place: _propTypes2.default.number,
    rewards: _propTypes2.default.array,
    prizePlaces: _propTypes2.default.number,
    startTs: _propTypes2.default.number,
    endTs: _propTypes2.default.number,
    qualificationFp: _propTypes2.default.number,
    qualificationBattles: _propTypes2.default.number,
    event: _propTypes2.default.object
};

exports.default = RatingCard;

/***/ }),
/* 2463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LEADERBOARDS_RATING_DESCRIPTION_NOT_DEFINED = exports.LEADERBOARDS_RATING_DESCRIPTION_CLAN = exports.LEADERBOARDS_DESCRIPTION_TOP_CLAN = exports.LEADERBOARDS_DESCRIPTION_TOP_PERSONAL = exports.LEADERBOARDS_DESCRIPTION_CLAN_PERIODIC_NOT_DEFINED = exports.LEADERBOARDS_DESCRIPTION_CLAN_PERIODIC = exports.LEADERBOARDS_RATING_DESCRIPTION_PERSONAL = exports.LEADERBOARDS_RATING_POSITION_CLAN = exports.LEADERBOARDS_RATING_POSITION_PERSONAL = exports.LEADERBOARDS_ALL_THE_TIME = exports.LEADERBOARDS_CLAN = exports.LEADERBOARDS_CLAN_PERIODIC = exports.LEADERBOARDS_PERSONAL_PERIODIC = exports.RATING_CARD_POSITION_CLAN = exports.RATING_CARD_POSITION_CLAN_BATTLES = exports.RATING_CARD_POSITION_CLAN_PFP = exports.RATING_CARD_POSITION_CLAN_PERIODIC = exports.RATING_CARD_POSITION_PERSONAL = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _RatingCard = __webpack_require__(1384);

var _RatingCard2 = _interopRequireDefault(_RatingCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RATING_CARD_POSITION_PERSONAL = exports.RATING_CARD_POSITION_PERSONAL = function RATING_CARD_POSITION_PERSONAL(qualificationFp) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'rating.card.position.personal',
        defaultMessage: '\u0414\u043B\u044F \u0443\u0447\u0430\u0441\u0442\u0438\u044F \u0432 \u0440\u0435\u0439\u0442\u0438\u043D\u0433\u0435 \u0432\u0430\u043C \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u043D\u0430\u0431\u0440\u0430\u0442\u044C \u041E\u0447\u043A\u043E\u0432 \u0441\u043B\u0430\u0432\u044B: {qualificationFp}',
        values: {
            qualificationFp: _react2.default.createElement(
                'span',
                { className: _RatingCard2.default.important },
                qualificationFp
            )
        }
    });
}; /* eslint-disable max-len */
/* eslint-disable react/no-multi-comp */
var RATING_CARD_POSITION_CLAN_PERIODIC = exports.RATING_CARD_POSITION_CLAN_PERIODIC = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'rating.card.position.clan.periodic',
    defaultMessage: '\u0414\u043B\u044F \u0443\u0447\u0430\u0441\u0442\u0438\u044F \u0432 \u0440\u0435\u0439\u0442\u0438\u043D\u0433\u0435 \u0437\u0430 \u043D\u0435\u0434\u0435\u043B\u044E \u043D\u0430 \u0441\u0447\u0435\u0442\u0443 \u0432\u0430\u0448\u0435\u0433\u043E \u043A\u043B\u0430\u043D\u0430 \u0434\u043E\u043B\u0436\u043D\u044B \u0431\u044B\u0442\u044C \u0437\u0430\u0440\u0430\u0431\u043E\u0442\u0430\u043D\u043D\u044B\u0435 \u041E\u0447\u043A\u0438 \u0441\u043B\u0430\u0432\u044B'
});

var RATING_CARD_POSITION_CLAN_PFP = exports.RATING_CARD_POSITION_CLAN_PFP = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'rating.card.position.clan.PFP',
    defaultMessage: '\u0414\u043B\u044F \u0443\u0447\u0430\u0441\u0442\u0438\u044F \u0432 \u043E\u0431\u0449\u0435\u043C \u0440\u0435\u0439\u0442\u0438\u043D\u0433\u0435 \u0432\u0430\u0448\u0435\u043C\u0443 \u043A\u043B\u0430\u043D\u0443 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u043D\u0430\u0431\u0440\u0430\u0442\u044C \u041E\u0447\u043A\u0438 \u0441\u043B\u0430\u0432\u044B'
});

var RATING_CARD_POSITION_CLAN_BATTLES = exports.RATING_CARD_POSITION_CLAN_BATTLES = function RATING_CARD_POSITION_CLAN_BATTLES(qualificationBattles) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'rating.card.position.clan.ballles',
        defaultMessage: '\u0414\u043B\u044F \u0443\u0447\u0430\u0441\u0442\u0438\u044F \u0432 \u043E\u0431\u0449\u0435\u043C \u0440\u0435\u0439\u0442\u0438\u043D\u0433\u0435 \u0432\u0430\u0448\u0435\u043C\u0443 \u043A\u043B\u0430\u043D\u0443 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u043F\u0440\u043E\u0432\u0435\u0441\u0442\u0438 \u0431\u043E\u0451\u0432: {qualificationBattles}',
        values: {
            qualificationBattles: _react2.default.createElement(
                'span',
                { className: _RatingCard2.default.important },
                qualificationBattles
            )
        }
    });
};

var RATING_CARD_POSITION_CLAN = exports.RATING_CARD_POSITION_CLAN = function RATING_CARD_POSITION_CLAN(qualificationFp, qualificationBattles) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'rating.card.position.clan',
        defaultMessage: '\u0414\u043B\u044F \u0443\u0447\u0430\u0441\u0442\u0438\u044F \u0432 \u043E\u0431\u0449\u0435\u043C \u0440\u0435\u0439\u0442\u0438\u043D\u0433\u0435 \u0432\u0430\u0448\u0435\u043C\u0443 \u043A\u043B\u0430\u043D\u0443 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u043D\u0430\u0431\u0440\u0430\u0442\u044C \u041E\u0447\u043A\u0438 \u0441\u043B\u0430\u0432\u044B \u0438 \u043F\u0440\u043E\u0432\u0435\u0441\u0442\u0438 \u0431\u043E\u0451\u0432: {qualificationBattles}',
        values: {
            qualificationBattles: _react2.default.createElement(
                'span',
                { className: _RatingCard2.default.important },
                qualificationBattles
            )
        }
    });
};

var LEADERBOARDS_PERSONAL_PERIODIC = exports.LEADERBOARDS_PERSONAL_PERIODIC = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'leaderboards.personal.periodic',
    defaultMessage: '\u041B\u0438\u0447\u043D\u044B\u0439 \u0440\u0435\u0439\u0442\u0438\u043D\u0433 \u0437\u0430 \u0434\u0435\u043D\u044C'
});

var LEADERBOARDS_CLAN_PERIODIC = exports.LEADERBOARDS_CLAN_PERIODIC = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'leaderboards.clan.periodic',
    defaultMessage: '\u041A\u043B\u0430\u043D\u043E\u0432\u044B\u0439 \u0440\u0435\u0439\u0442\u0438\u043D\u0433 \u0437\u0430 \u043D\u0435\u0434\u0435\u043B\u044E'
});

var LEADERBOARDS_CLAN = exports.LEADERBOARDS_CLAN = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'leaderboards.clan',
    defaultMessage: '\u041A\u043B\u0430\u043D\u043E\u0432\u044B\u0439 \u043E\u0431\u0449\u0438\u0439 \u0440\u0435\u0439\u0442\u0438\u043D\u0433'
});

var LEADERBOARDS_ALL_THE_TIME = exports.LEADERBOARDS_ALL_THE_TIME = function LEADERBOARDS_ALL_THE_TIME(DatePeriod) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'leaderboards.all.the.time',
        defaultMessage: '\u0417\u0430 \u0432\u0441\u0451 \u0441\u043E\u0431\u044B\u0442\u0438\u0435: {DatePeriod}',
        values: {
            DatePeriod: DatePeriod
        }
    });
};

var LEADERBOARDS_RATING_POSITION_PERSONAL = exports.LEADERBOARDS_RATING_POSITION_PERSONAL = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'leaderboards.rating.position.personal',
    defaultMessage: '\u043C\u043E\u044F \u043F\u043E\u0437\u0438\u0446\u0438\u044F \u0432 \u0440\u0435\u0439\u0442\u0438\u043D\u0433\u0435'
});

var LEADERBOARDS_RATING_POSITION_CLAN = exports.LEADERBOARDS_RATING_POSITION_CLAN = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'leaderboards.rating.position.clan',
    defaultMessage: '\u043F\u043E\u0437\u0438\u0446\u0438\u044F \u043A\u043B\u0430\u043D\u0430 \u0432 \u0440\u0435\u0439\u0442\u0438\u043D\u0433\u0435'
});

var LEADERBOARDS_RATING_DESCRIPTION_PERSONAL = exports.LEADERBOARDS_RATING_DESCRIPTION_PERSONAL = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'leaderboards.rating.description.personal',
    defaultMessage: '\u041D\u0430\u0433\u0440\u0430\u0434\u044B \u043C\u043E\u0436\u043D\u043E \u0431\u0443\u0434\u0435\u0442 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043F\u043E\u0441\u043B\u0435 \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u044F \u0438\u0433\u0440\u043E\u0432\u043E\u0433\u043E \u0434\u043D\u044F'
});

var LEADERBOARDS_DESCRIPTION_CLAN_PERIODIC = exports.LEADERBOARDS_DESCRIPTION_CLAN_PERIODIC = function LEADERBOARDS_DESCRIPTION_CLAN_PERIODIC(date) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'leaderboards.description.clan.periodic',
        defaultMessage: '\u041D\u0430\u0433\u0440\u0430\u0434\u044B \u0431\u0443\u0434\u0443\u0442 \u043F\u0435\u0440\u0435\u0447\u0438\u0441\u043B\u0435\u043D\u044B \u0432 \u043A\u0430\u0437\u043D\u0443 \u043A\u043B\u0430\u043D\u0430 {date}',
        values: {
            date: date
        }
    });
};

var LEADERBOARDS_DESCRIPTION_CLAN_PERIODIC_NOT_DEFINED = exports.LEADERBOARDS_DESCRIPTION_CLAN_PERIODIC_NOT_DEFINED = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'leaderboards.description.clan.periodic.not.defined',
    defaultMessage: '\u041D\u0430\u0433\u0440\u0430\u0434\u044B \u0431\u0443\u0434\u0443\u0442 \u0440\u0430\u0441\u0441\u0447\u0438\u0442\u0430\u043D\u044B \u043F\u043E\u0441\u043B\u0435 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u044F \u043B\u0438\u0434\u0435\u0440\u043E\u0432 \u043F\u043E \u041B\u0438\u0447\u043D\u043E\u043C\u0443 \u0440\u0435\u0439\u0442\u0438\u043D\u0433\u0443'
});

var LEADERBOARDS_DESCRIPTION_TOP_PERSONAL = exports.LEADERBOARDS_DESCRIPTION_TOP_PERSONAL = function LEADERBOARDS_DESCRIPTION_TOP_PERSONAL(top) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'leaderboards.description.top.personal',
        defaultMessage: '\u0412\u044B \u043D\u0435 \u043F\u043E\u043F\u0430\u043B\u0438 \u0432 \u0442\u043E\u043F-{top} \u043D\u0430\u0433\u0440\u0430\u0436\u0434\u0430\u0435\u043C\u044B\u0445 \u043F\u043E\u0437\u0438\u0446\u0438\u0439 \u0440\u0435\u0439\u0442\u0438\u043D\u0433\u0430',
        values: {
            top: _react2.default.createElement(
                'span',
                { className: _RatingCard2.default.important },
                top
            )
        }
    });
};

var LEADERBOARDS_DESCRIPTION_TOP_CLAN = exports.LEADERBOARDS_DESCRIPTION_TOP_CLAN = function LEADERBOARDS_DESCRIPTION_TOP_CLAN(top) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'leaderboards.description.top.clan',
        defaultMessage: '\u0412\u0430\u0448 \u043A\u043B\u0430\u043D \u043D\u0435 \u043F\u043E\u043F\u0430\u043B \u0432 \u0442\u043E\u043F-{top} \u043D\u0430\u0433\u0440\u0430\u0436\u0434\u0430\u0435\u043C\u044B\u0445 \u043F\u043E\u0437\u0438\u0446\u0438\u0439 \u0440\u0435\u0439\u0442\u0438\u043D\u0433\u0430',
        values: {
            top: _react2.default.createElement(
                'span',
                { className: _RatingCard2.default.important },
                top
            )
        }
    });
};

var LEADERBOARDS_RATING_DESCRIPTION_CLAN = exports.LEADERBOARDS_RATING_DESCRIPTION_CLAN = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'leaderboards.rating.description.clan',
    defaultMessage: '\u041D\u0430\u0433\u0440\u0430\u0434\u044B \u0431\u0443\u0434\u0443\u0442 \u043F\u0435\u0440\u0435\u0447\u0438\u0441\u043B\u0435\u043D\u044B \u0438\u0433\u0440\u043E\u043A\u0430\u043C \u043A\u043B\u0430\u043D\u0430 \u043F\u043E\u0441\u043B\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0441\u043E\u0431\u044B\u0442\u0438\u044F'
});

var LEADERBOARDS_RATING_DESCRIPTION_NOT_DEFINED = exports.LEADERBOARDS_RATING_DESCRIPTION_NOT_DEFINED = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'leaderboards.rating.description.personal.not.defined',
    defaultMessage: '\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043D\u0430\u0433\u0440\u0430\u0436\u0434\u0430\u0435\u043C\u044B\u0445 \u043F\u043E\u0437\u0438\u0446\u0438\u0439 \u0440\u0435\u0439\u0442\u0438\u043D\u0433\u0430 \u0431\u0443\u0434\u0435\u0442 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043E \u043F\u043E\u0441\u043B\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0431\u043B\u0438\u0436\u0430\u0439\u0448\u0438\u0445 \u0431\u043E\u0451\u0432'
});

/***/ }),
/* 2464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Reward = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _uniqueId = __webpack_require__(574);

var _uniqueId2 = _interopRequireDefault(_uniqueId);

var _constants = __webpack_require__(104);

var _web_to_client = __webpack_require__(12);

var _reactWotBootstrap = __webpack_require__(5);

var _format_number = __webpack_require__(109);

var _RewardTooltip = __webpack_require__(2465);

var _RewardTooltip2 = _interopRequireDefault(_RewardTooltip);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _Reward = __webpack_require__(2469);

var _Reward2 = _interopRequireDefault(_Reward);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Reward = exports.Reward = function (_PureComponent) {
    _inherits(Reward, _PureComponent);

    function Reward() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Reward);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Reward.__proto__ || Object.getPrototypeOf(Reward)).call.apply(_ref, [this].concat(args))), _this), _this._tooltipTimeoutId = 0, _this._tooltipMedal = (0, _uniqueId2.default)('tooltip_medal_'), _this.handleMouseEnter = function () {
            if (_this.isMedalReward) {
                return;
            }

            _this._tooltipTimeoutId = window.setTimeout(function () {
                var _this$props$reward = _this.props.reward,
                    type = _this$props$reward.type,
                    amount = _this$props$reward.amount,
                    id = _this$props$reward.id;

                (0, _web_to_client.showItemTooltip)(_constants.CLIENT_REWARD_TYPE[type], amount, parseInt(id, 10) || '');
                _this._tooltipTimeoutId = undefined;
            }, 200);
        }, _this.handleMouseLeave = function () {
            if (_this.isMedalReward) {
                return;
            }

            window.clearTimeout(_this._tooltipTimeoutId);
            if (_this._tooltipTimeoutId === undefined) {
                (0, _web_to_client.hideTooltip)();
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Reward, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            clearTimeout(this._tooltipTimeoutId);
        }
    }, {
        key: 'render',
        value: function render() {
            var reward = this.props.reward;

            var tooltipProps = this.isMedalReward ? {
                'data-tip': true,
                'data-for': this.medalTooltipId
            } : {};
            var rewardClassNames = (0, _classnames2.default)(_Reward2.default.base, _Reward2.default['base__' + reward.type]);

            switch (reward.type) {
                case _constants.REWARD_TYPE.GOLD:
                    return _react2.default.createElement(_reactWotBootstrap.Gold, {
                        value: reward.amount,
                        size: 'large',
                        iconPosition: 'after',
                        mixClassName: _Reward2.default.gold
                    });
                case _constants.REWARD_TYPE.BONDS:
                case _constants.REWARD_TYPE.CLAN_BONDS:
                    return _react2.default.createElement(_reactWotBootstrap.Bons, {
                        size: 'large',
                        iconPosition: 'after',
                        value: reward.amount,
                        mixClassName: _Reward2.default.bonds
                    });
                default:
                    return _react2.default.createElement(
                        'div',
                        _extends({
                            className: rewardClassNames,
                            onMouseEnter: this.handleMouseEnter,
                            onMouseLeave: this.handleMouseLeave
                        }, tooltipProps),
                        reward.amount > 1 && _react2.default.createElement(
                            'span',
                            { className: _Reward2.default.counter },
                            (0, _format_number.thousands)(reward.amount, false)
                        ),
                        this.isMedalReward && _react2.default.createElement(_RewardTooltip2.default, {
                            type: reward.type,
                            id: this.medalTooltipId
                        })
                    );
            }
        }
    }, {
        key: 'medalTooltipId',
        get: function get() {
            var _props$reward = this.props.reward,
                type = _props$reward.type,
                id = _props$reward.id;

            return '' + this._tooltipMedal + type + '_' + id;
        }
    }, {
        key: 'isMedalReward',
        get: function get() {
            return this.props.reward.type.includes('medal');
        }
    }]);

    return Reward;
}(_react.PureComponent);

Reward.propTypes = {
    reward: _propTypes2.default.object.isRequired
};

/***/ }),
/* 2465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RewardTooltip = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactWotBootstrap = __webpack_require__(5);

var _constants = __webpack_require__(104);

var _translations = __webpack_require__(2466);

var _RewardTooltip = __webpack_require__(2467);

var _RewardTooltip2 = _interopRequireDefault(_RewardTooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RewardTooltip = exports.RewardTooltip = function RewardTooltip(props) {
    return _react2.default.createElement(
        _reactWotBootstrap.Tooltip,
        { id: props.id },
        _react2.default.createElement(
            'p',
            { className: _RewardTooltip2.default.tooltipTitle },
            _translations.REWARD_MEDAL_TOOLTIPS[props.type].title
        ),
        _react2.default.createElement('img', {
            className: _RewardTooltip2.default.icon,
            src: __webpack_require__(2468)("./" + props.type + '.png')
        }),
        _react2.default.createElement('span', { className: _RewardTooltip2.default.tooltipDivider }),
        _react2.default.createElement(
            'p',
            { className: _RewardTooltip2.default.tooltipMessage },
            _translations.REWARD_MEDAL_TOOLTIPS[props.type].message
        )
    );
};

RewardTooltip.TYPES = _constants.REWARD_TYPE;

RewardTooltip.propTypes = {
    type: _propTypes2.default.oneOf(Object.values(_constants.REWARD_TYPE)).isRequired,
    id: _propTypes2.default.string.isRequired
};

exports.default = RewardTooltip;

/***/ }),
/* 2466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.REWARD_MEDAL_TOOLTIPS = undefined;

var _REWARD_MEDAL_TOOLTIP;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

var _constants = __webpack_require__(104);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint-disable max-len */


var REWARD_MEDAL_TOOLTIPS = exports.REWARD_MEDAL_TOOLTIPS = (_REWARD_MEDAL_TOOLTIP = {}, _defineProperty(_REWARD_MEDAL_TOOLTIP, _constants.REWARD_TYPE.MEDAL_FIRST, {
    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'reward.tooltips.medal.first.title',
        defaultMessage: '\u041C\u0435\u0434\u0430\u043B\u044C \xAB\u041F\u043E\u0431\u0435\u0434\u0438\u0442\u0435\u043B\u044C I \u0441\u0442\u0435\u043F\u0435\u043D\u0438\xBB'
    }),
    message: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'reward.tooltips.medal.first.body',
        defaultMessage: '\u0417\u0430\u043D\u044F\u0442\u044C \u043F\u0435\u0440\u0432\u043E\u0435 \u043C\u0435\u0441\u0442\u043E \u043F\u043E \u0438\u0442\u043E\u0433\u0430\u043C \u0441\u0435\u0437\u043E\u043D\u0430 \u043D\u0430 \u0443\u0440\u043E\u0432\u043D\u0435 \u0442\u0435\u0445\u043D\u0438\u043A\u0438 X \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435.'
    })
}), _defineProperty(_REWARD_MEDAL_TOOLTIP, _constants.REWARD_TYPE.MEDAL_SECOND, {
    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'reward.tooltips.medal.second.title',
        defaultMessage: '\u041C\u0435\u0434\u0430\u043B\u044C \xAB\u041F\u043E\u0431\u0435\u0434\u0438\u0442\u0435\u043B\u044C II \u0441\u0442\u0435\u043F\u0435\u043D\u0438\xBB'
    }),
    message: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'reward.tooltips.medal.second.body',
        defaultMessage: '\u0417\u0430\u043D\u044F\u0442\u044C \u0432\u0442\u043E\u0440\u043E\u0435 \u043C\u0435\u0441\u0442\u043E \u043F\u043E \u0438\u0442\u043E\u0433\u0430\u043C \u0441\u0435\u0437\u043E\u043D\u0430 \u043D\u0430 \u0443\u0440\u043E\u0432\u043D\u0435 \u0442\u0435\u0445\u043D\u0438\u043A\u0438 X \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435.'
    })
}), _defineProperty(_REWARD_MEDAL_TOOLTIP, _constants.REWARD_TYPE.MEDAL_THIRD, {
    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'reward.tooltips.medal.third.title',
        defaultMessage: '\u041C\u0435\u0434\u0430\u043B\u044C \xAB\u041F\u043E\u0431\u0435\u0434\u0438\u0442\u0435\u043B\u044C III \u0441\u0442\u0435\u043F\u0435\u043D\u0438\xBB'
    }),
    message: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'reward.tooltips.medal.third.body',
        defaultMessage: '\u0417\u0430\u043D\u044F\u0442\u044C \u0442\u0440\u0435\u0442\u044C\u0435 \u043C\u0435\u0441\u0442\u043E \u043F\u043E \u0438\u0442\u043E\u0433\u0430\u043C \u0441\u0435\u0437\u043E\u043D\u0430 \u043D\u0430 \u0443\u0440\u043E\u0432\u043D\u0435 \u0442\u0435\u0445\u043D\u0438\u043A\u0438 X \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435.'
    })
}), _defineProperty(_REWARD_MEDAL_TOOLTIP, _constants.REWARD_TYPE.MEDAL_ELITE, {
    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'reward.tooltips.medal.elite.title',
        defaultMessage: '\u041C\u0435\u0434\u0430\u043B\u044C \xAB\u042D\u043B\u0438\u0442\u0430\xBB'
    }),
    message: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'reward.tooltips.medal.elite.body',
        defaultMessage: '\u0412\u043E\u0439\u0442\u0438 \u0432 10% \u043B\u0443\u0447\u0448\u0438\u0445 \u043A\u043B\u0430\u043D\u043E\u0432 \u043F\u043E \u0438\u0442\u043E\u0433\u0430\u043C \u0441\u0435\u0437\u043E\u043D\u0430 \u043D\u0430 \u0443\u0440\u043E\u0432\u043D\u0435 \u0442\u0435\u0445\u043D\u0438\u043A\u0438 X \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435.'
    })
}), _defineProperty(_REWARD_MEDAL_TOOLTIP, _constants.REWARD_TYPE.MEDAL_VETERAN, {
    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'reward.tooltips.medal.veteran.title',
        defaultMessage: '\u041C\u0435\u0434\u0430\u043B\u044C \xAB\u0412\u0435\u0442\u0435\u0440\u0430\u043D\xBB'
    }),
    message: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'reward.tooltips.medal.veteran.body',
        defaultMessage: '\u0412\u043E\u0439\u0442\u0438 \u0432 50% \u043B\u0443\u0447\u0448\u0438\u0445 \u043A\u043B\u0430\u043D\u043E\u0432 \u043F\u043E \u0438\u0442\u043E\u0433\u0430\u043C \u0441\u0435\u0437\u043E\u043D\u0430 \u043D\u0430 \u0443\u0440\u043E\u0432\u043D\u0435 \u0442\u0435\u0445\u043D\u0438\u043A\u0438 X \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435.'
    })
}), _REWARD_MEDAL_TOOLTIP);

/***/ }),
/* 2467 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tooltip-root":"RewardTooltip_tooltip-root--5Ckv_","tooltipRoot":"RewardTooltip_tooltip-root--5Ckv_","tooltip-root__show":"RewardTooltip_tooltip-root__show--1pYs-","tooltipRootShow":"RewardTooltip_tooltip-root__show--1pYs-","tooltip-body":"RewardTooltip_tooltip-body--Il2hd","tooltipBody":"RewardTooltip_tooltip-body--Il2hd","tooltip-wrapper":"RewardTooltip_tooltip-wrapper--2r1RW","tooltipWrapper":"RewardTooltip_tooltip-wrapper--2r1RW","tooltip-content":"RewardTooltip_tooltip-content--2Um7S","tooltipContent":"RewardTooltip_tooltip-content--2Um7S","tooltip-title":"RewardTooltip_tooltip-title--5DQQo","tooltipTitle":"RewardTooltip_tooltip-title--5DQQo","tooltip-subtitle":"RewardTooltip_tooltip-subtitle--1FDiL","tooltipSubtitle":"RewardTooltip_tooltip-subtitle--1FDiL","tooltip-message":"RewardTooltip_tooltip-message--1pq3p","tooltipMessage":"RewardTooltip_tooltip-message--1pq3p","tooltip-warning":"RewardTooltip_tooltip-warning--1-CcC","tooltipWarning":"RewardTooltip_tooltip-warning--1-CcC","tooltip-divider":"RewardTooltip_tooltip-divider--3Ac8o","tooltipDivider":"RewardTooltip_tooltip-divider--3Ac8o","tooltip-highlight":"RewardTooltip_tooltip-highlight--Eh5Bg","tooltipHighlight":"RewardTooltip_tooltip-highlight--Eh5Bg","tooltip-ribbon":"RewardTooltip_tooltip-ribbon--1EedO","tooltipRibbon":"RewardTooltip_tooltip-ribbon--1EedO","tooltip-statusMessage":"RewardTooltip_tooltip-statusMessage--h7vgU","tooltipStatusMessage":"RewardTooltip_tooltip-statusMessage--h7vgU","tooltip-statusMessage__positive":"RewardTooltip_tooltip-statusMessage__positive--1mpC-","tooltipStatusMessagePositive":"RewardTooltip_tooltip-statusMessage__positive--1mpC-","tooltip-status":"RewardTooltip_tooltip-status--2SZuV","tooltipStatus":"RewardTooltip_tooltip-status--2SZuV","tooltip-statusMessage__negative":"RewardTooltip_tooltip-statusMessage__negative--wn7qb","tooltipStatusMessageNegative":"RewardTooltip_tooltip-statusMessage__negative--wn7qb","tooltip-statusMessage__noPermission":"RewardTooltip_tooltip-statusMessage__noPermission--3ZJEz","tooltipStatusMessageNoPermission":"RewardTooltip_tooltip-statusMessage__noPermission--3ZJEz","tooltip-status__positive":"RewardTooltip_tooltip-status__positive--O8O4i","tooltipStatusPositive":"RewardTooltip_tooltip-status__positive--O8O4i","tooltip-status__negative":"RewardTooltip_tooltip-status__negative--1FtrI","tooltipStatusNegative":"RewardTooltip_tooltip-status__negative--1FtrI","tooltip-statusText":"RewardTooltip_tooltip-statusText--Q5gUd","tooltipStatusText":"RewardTooltip_tooltip-statusText--Q5gUd","icon":"RewardTooltip_icon--2Aeoa"};

/***/ }),
/* 2468 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./medal_elite.png": 1385,
	"./medal_first.png": 1386,
	"./medal_second.png": 1387,
	"./medal_third.png": 1388,
	"./medal_veteran.png": 1389
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2468;

/***/ }),
/* 2469 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"tooltip-root":"Reward_tooltip-root--o04F-","tooltipRoot":"Reward_tooltip-root--o04F-","tooltip-root__show":"Reward_tooltip-root__show--13NH0","tooltipRootShow":"Reward_tooltip-root__show--13NH0","tooltip-body":"Reward_tooltip-body--2gBGL","tooltipBody":"Reward_tooltip-body--2gBGL","tooltip-wrapper":"Reward_tooltip-wrapper--oh-m0","tooltipWrapper":"Reward_tooltip-wrapper--oh-m0","tooltip-content":"Reward_tooltip-content--300Dk","tooltipContent":"Reward_tooltip-content--300Dk","tooltip-title":"Reward_tooltip-title--isDDr","tooltipTitle":"Reward_tooltip-title--isDDr","tooltip-subtitle":"Reward_tooltip-subtitle--bRzT4","tooltipSubtitle":"Reward_tooltip-subtitle--bRzT4","tooltip-message":"Reward_tooltip-message--1aApk","tooltipMessage":"Reward_tooltip-message--1aApk","tooltip-warning":"Reward_tooltip-warning--2nW42","tooltipWarning":"Reward_tooltip-warning--2nW42","tooltip-divider":"Reward_tooltip-divider--1JFJ9","tooltipDivider":"Reward_tooltip-divider--1JFJ9","tooltip-highlight":"Reward_tooltip-highlight--Vgts2","tooltipHighlight":"Reward_tooltip-highlight--Vgts2","tooltip-ribbon":"Reward_tooltip-ribbon--3zAaA","tooltipRibbon":"Reward_tooltip-ribbon--3zAaA","tooltip-statusMessage":"Reward_tooltip-statusMessage--2ofk6","tooltipStatusMessage":"Reward_tooltip-statusMessage--2ofk6","tooltip-statusMessage__positive":"Reward_tooltip-statusMessage__positive--1sm2e","tooltipStatusMessagePositive":"Reward_tooltip-statusMessage__positive--1sm2e","tooltip-status":"Reward_tooltip-status--b65f-","tooltipStatus":"Reward_tooltip-status--b65f-","tooltip-statusMessage__negative":"Reward_tooltip-statusMessage__negative--zJMAN","tooltipStatusMessageNegative":"Reward_tooltip-statusMessage__negative--zJMAN","tooltip-statusMessage__noPermission":"Reward_tooltip-statusMessage__noPermission--1DNnB","tooltipStatusMessageNoPermission":"Reward_tooltip-statusMessage__noPermission--1DNnB","tooltip-status__positive":"Reward_tooltip-status__positive--3jWMD","tooltipStatusPositive":"Reward_tooltip-status__positive--3jWMD","tooltip-status__negative":"Reward_tooltip-status__negative--2CT8b","tooltipStatusNegative":"Reward_tooltip-status__negative--2CT8b","tooltip-statusText":"Reward_tooltip-statusText--3xJMt","tooltipStatusText":"Reward_tooltip-statusText--3xJMt","base":"Reward_base--3aRTb","base__emblem":"Reward_base__emblem--1NWvI","baseEmblem":"Reward_base__emblem--1NWvI","base__decal":"Reward_base__decal--3ziYh","baseDecal":"Reward_base__decal--3ziYh","base__style":"Reward_base__style--2RKF1","baseStyle":"Reward_base__style--2RKF1","base__medal_elite":"Reward_base__medal_elite--2q5ok","baseMedalElite":"Reward_base__medal_elite--2q5ok","base__medal_first":"Reward_base__medal_first--2HkBN","baseMedalFirst":"Reward_base__medal_first--2HkBN","base__medal_second":"Reward_base__medal_second--2Xgm2","baseMedalSecond":"Reward_base__medal_second--2Xgm2","base__medal_third":"Reward_base__medal_third--1CSZu","baseMedalThird":"Reward_base__medal_third--1CSZu","base__medal_veteran":"Reward_base__medal_veteran--3pDqz","baseMedalVeteran":"Reward_base__medal_veteran--3pDqz","gold":"Reward_gold--3Qd4T","bonds":"Reward_bonds--1LUNy","counter":"Reward_counter--2UqzS"};

/***/ }),
/* 2470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RewardBox = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _translations = __webpack_require__(2471);

var _web_to_client = __webpack_require__(12);

var _rewards = __webpack_require__(2472);

var _constants = __webpack_require__(4);

var _RewardBox = __webpack_require__(2473);

var _RewardBox2 = _interopRequireDefault(_RewardBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RewardBox = exports.RewardBox = function (_PureComponent) {
    _inherits(RewardBox, _PureComponent);

    function RewardBox() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, RewardBox);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RewardBox.__proto__ || Object.getPrototypeOf(RewardBox)).call.apply(_ref, [this].concat(args))), _this), _this._tooltipTimeoutId = 0, _this._clientCursorPosition = {}, _this.handleMouseLeave = function () {
            window.clearTimeout(_this._tooltipTimeoutId);
            if (_this._tooltipTimeoutId === undefined) {
                (0, _web_to_client.hideGamefaceTooltip)();
                document.removeEventListener('mousemove', _this.handleMouseMove);
            }
        }, _this.handleMouseMove = function (e) {
            _this._clientCursorPosition = {
                x: e.pageX,
                y: e.pageY + _constants.CLIENT_HEADER_HEIGHT
            };
        }, _this.handleMouseEnter = function () {
            document.addEventListener('mousemove', _this.handleMouseMove);

            var tooltipRewards = _this.props.rewards.reduce(function (config, item) {

                // client bug need to be fixed: type for EMBLEM is not 'decal/1' for single tooltip
                var type = item.type === _web_to_client.REWARD_PACK_TYPE.DECAL_1 ? _web_to_client.REWARD_PACK_TYPE.EMBLEM : item.type;

                var category = (0, _rewards.getRewardCategory)(type);
                if (!category) {
                    return config;
                }
                if (!config.hasOwnProperty(category)) {
                    config[category] = [];
                }

                if (category === _web_to_client.REWARD_CATEGORY.CUSTOMIZATIONS) {
                    config[category].push(_extends({}, item, {
                        custType: type.split('/')[0]
                    }));
                }

                return config;
            }, {});

            _this._tooltipTimeoutId = window.setTimeout(function () {
                var _this$_clientCursorPo = _this._clientCursorPosition,
                    x = _this$_clientCursorPo.x,
                    y = _this$_clientCursorPo.y;

                (0, _web_to_client.showRewardBoxTooltip)(x, y, tooltipRewards);
                _this._tooltipTimeoutId = undefined;
            }, 200);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(RewardBox, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            clearTimeout(this._tooltipTimeoutId);
            document.removeEventListener('mousemove', this.handleMouseMove);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                label = _props.label,
                className = _props.className,
                rewards = _props.rewards;


            return _react2.default.createElement(
                'div',
                {
                    className: (0, _classnames2.default)(_RewardBox2.default.base, className),
                    onMouseEnter: this.handleMouseEnter,
                    onMouseLeave: this.handleMouseLeave
                },
                _react2.default.createElement(
                    'div',
                    { className: _RewardBox2.default.label },
                    label ? label : (0, _translations.REWARD_BOX_LABEL)(rewards.length)
                )
            );
        }
    }]);

    return RewardBox;
}(_react.PureComponent);

RewardBox.propTypes = {
    rewards: _propTypes2.default.array.isRequired,
    label: _propTypes2.default.string,
    className: _propTypes2.default.string
};

/***/ }),
/* 2471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.REWARD_BOX_LABEL = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REWARD_BOX_LABEL = exports.REWARD_BOX_LABEL = function REWARD_BOX_LABEL(rewardCount) {
    return _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'reward_box.label',
        defaultMessage: '\u0418 \u0435\u0449\u0451: {rewardCount}',
        values: {
            rewardCount: rewardCount
        }
    });
};

/***/ }),
/* 2472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getRewardCategory = undefined;

var _web_to_client = __webpack_require__(12);

var getRewardCategory = exports.getRewardCategory = function getRewardCategory(rewardType) {
    switch (rewardType) {
        case _web_to_client.REWARD_PACK_TYPE.STYLE_ALL:
        case _web_to_client.REWARD_PACK_TYPE.PROJECTION_DECAL_ALL:
        case _web_to_client.REWARD_PACK_TYPE.EMBLEM:
            return _web_to_client.REWARD_CATEGORY.CUSTOMIZATIONS;
        default:
            return null;
    }
};

/***/ }),
/* 2473 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"RewardBox_base--3qOac","label":"RewardBox_label--2cUiM"};

/***/ }),
/* 2474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Header = __webpack_require__(2475);

var _Header2 = _interopRequireDefault(_Header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = function Header(props) {
    var title = props.title,
        eventName = props.eventName,
        date = props.date;

    return _react2.default.createElement(
        'reactFragment',
        null,
        _react2.default.createElement(
            'h1',
            { className: _Header2.default.title },
            title
        ),
        _react2.default.createElement(
            'div',
            { className: _Header2.default.eventName },
            eventName,
            ': ',
            date
        )
    );
};

Header.propTypes = {
    title: _propTypes2.default.string.isRequired,
    eventName: _propTypes2.default.string.isRequired,
    date: _propTypes2.default.string.isRequired
};

exports.default = Header;

/***/ }),
/* 2475 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"title":"Header_title--25Y5l","eventName":"Header_eventName--6on4m"};

/***/ }),
/* 2476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _errors = __webpack_require__(2477);

var _errors2 = _interopRequireDefault(_errors);

var _constants = __webpack_require__(104);

var _WGCWXConfirmation = __webpack_require__(238);

var _WGCWXConfirmation2 = _interopRequireDefault(_WGCWXConfirmation);

var _Error = __webpack_require__(2478);

var _Error2 = _interopRequireDefault(_Error);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Error = function Error(props) {
    var onClose = props.onClose,
        error = props.error,
        errorActionType = props.errorActionType,
        caption = props.caption;

    var errorData = function errorData() {
        switch (errorActionType) {
            case _constants.ERROR_ACTION_TYPE.LEADERBOARDS_ERROR:
                return _errors2.default[error] ? _errors2.default[error] : _errors2.default[_errors.ERROR_CODES.UNKNOWN_ERROR];
            case _constants.ERROR_ACTION_TYPE.GET_REWARDS_ERROR:
                return _errors2.default[_errors.ERROR_CODES.GET_REWARD_ERROR];
        }
    };

    var _errorData = errorData(),
        title = _errorData.title,
        description = _errorData.description;

    var errorClassNames = (0, _classnames2.default)(_Error2.default.base, _Error2.default.base__overlayOpened);

    return _react2.default.createElement(
        'div',
        { className: errorClassNames },
        _react2.default.createElement('div', { className: _Error2.default.background }),
        _react2.default.createElement(_WGCWXConfirmation2.default, {
            messageType: 'error',
            title: title,
            description: description,
            buttonsOptions: [{
                caption: caption,
                callback: function callback() {
                    return onClose();
                }
            }],
            onClose: onClose
        })
    );
};

Error.propTypes = {
    error: _propTypes2.default.string,
    errorActionType: _propTypes2.default.string,
    caption: _propTypes2.default.string,
    onClose: _propTypes2.default.func.isRequired
};

exports.default = Error;

/***/ }),
/* 2477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ERROR_CODES = undefined;

var _ERROR_CODES$GET_REWA;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint-disable react/no-multi-comp, max-len */


var ERROR_CODES = exports.ERROR_CODES = {
    LEADERBOARDS_NOT_AVAILABLE: 'leaderboards_not_available',
    UNKNOWN_ERROR: 'UNKNOWN_ERROR',
    GET_REWARD_ERROR: 'GET_REWARD_ERROR'
};

exports.default = (_ERROR_CODES$GET_REWA = {}, _defineProperty(_ERROR_CODES$GET_REWA, ERROR_CODES.GET_REWARD_ERROR, {
    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_leaderboards.get_reward_error.title',
        defaultMessage: '\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u043F\u0435\u0440\u0435\u0447\u0438\u0441\u043B\u0435\u043D\u0438\u0438 \u0441\u0440\u0435\u0434\u0441\u0442\u0432 \u043D\u0430 \u0441\u0447\u0451\u0442'
    }),
    description: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_leaderboards.get_reward_error.description',
        defaultMessage: '\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043D\u0430\u0447\u0438\u0441\u043B\u0438\u0442\u044C \u043D\u0430\u0433\u0440\u0430\u0434\u0443. \u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u0435 \u043F\u043E\u043F\u044B\u0442\u043A\u0443 \u043F\u043E\u0437\u0436\u0435.'
    })
}), _defineProperty(_ERROR_CODES$GET_REWA, ERROR_CODES.LEADERBOARDS_NOT_AVAILABLE, {
    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_leaderboards.leaderboards_are_not_available.title',
        defaultMessage: '\u0414\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u044F \u0432 \u0441\u043E\u0431\u044B\u0442\u0438\u0438 \u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B'
    }),
    description: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_leaderboards.leaderboards_are_not_available.description',
        defaultMessage: '\u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0437\u0430\u0439\u0442\u0438 \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u043F\u043E\u0437\u0436\u0435.'
    })
}), _defineProperty(_ERROR_CODES$GET_REWA, ERROR_CODES.UNKNOWN_ERROR, {
    title: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_leaderboards.leaderboards_data_loading_error.title',
        defaultMessage: '\u041D\u0435 \u0443\u0434\u0430\u043B\u043E\u0441\u044C \u043E\u0442\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u044C \u0434\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u044F \u0432 \u0441\u043E\u0431\u044B\u0442\u0438\u0438'
    }),
    description: _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'wgcwx_leaderboards.leaderboards_data_loading_error.description',
        defaultMessage: '\u0414\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u044F \u0432 \u0441\u043E\u0431\u044B\u0442\u0438\u0438 \u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0437\u0430\u0439\u0442\u0438 \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443 \u043F\u043E\u0437\u0436\u0435.'
    })
}), _ERROR_CODES$GET_REWA);

/***/ }),
/* 2478 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Error_base--3X-zd","base__overlayOpened":"Error_base__overlayOpened--nilEc","baseOverlayOpened":"Error_base__overlayOpened--nilEc","background":"Error_background--3xshU"};

/***/ }),
/* 2479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Footer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(2);

var _classnames2 = _interopRequireDefault(_classnames);

var _isEmpty = __webpack_require__(157);

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _constants = __webpack_require__(104);

var _reactWotBootstrap = __webpack_require__(5);

var _translations = __webpack_require__(2480);

var _Footer = __webpack_require__(2481);

var _Footer2 = _interopRequireDefault(_Footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Footer = exports.Footer = function (_React$Component) {
    _inherits(Footer, _React$Component);

    function Footer() {
        _classCallCheck(this, Footer);

        return _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).apply(this, arguments));
    }

    _createClass(Footer, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                reward = _props.reward,
                isRewardsTaken = _props.isRewardsTaken,
                isRewardsProcessing = _props.isRewardsProcessing,
                getRewards = _props.getRewards;

            var baseClassNames = (0, _classnames2.default)(_Footer2.default.base, !(0, _isEmpty2.default)(reward) && _Footer2.default.base__haveReward, isRewardsTaken && _Footer2.default.base__gotReawrd);
            var buttonLightClassNames = (0, _classnames2.default)(_Footer2.default.buttonLight, isRewardsProcessing && _Footer2.default.buttonLight__fade);

            return _react2.default.createElement(
                'div',
                { className: baseClassNames },
                _react2.default.createElement(
                    'div',
                    { className: _Footer2.default.content },
                    isRewardsTaken ? _react2.default.createElement(
                        'div',
                        { className: _Footer2.default.rewardHolder },
                        _react2.default.createElement(
                            'div',
                            { className: _Footer2.default.receivedTitle },
                            _translations.GET_REWARD_REWARD_RECEIVED_TITLE
                        ),
                        _translations.GET_REWARD_REWARD_RECEIVED
                    ) : !(0, _isEmpty2.default)(reward) ? _react2.default.createElement(
                        'div',
                        { className: _Footer2.default.rewardHolder },
                        _react2.default.createElement(
                            'div',
                            { className: _Footer2.default.title },
                            _translations.GET_REWARD_TITLE
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _Footer2.default.reward },
                            reward[_constants.REWARD_TYPE.BONDS] && _react2.default.createElement(_reactWotBootstrap.Bons, {
                                size: 'large',
                                iconPosition: 'after',
                                value: reward[_constants.REWARD_TYPE.BONDS],
                                mixClassName: _Footer2.default.bonds
                            }),
                            reward[_constants.REWARD_TYPE.GOLD] && _react2.default.createElement(_reactWotBootstrap.Gold, {
                                size: 'large',
                                value: reward[_constants.REWARD_TYPE.GOLD],
                                iconPosition: 'after',
                                mixClassName: _Footer2.default.gold
                            })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: buttonLightClassNames },
                            _react2.default.createElement(
                                _reactWotBootstrap.Button,
                                {
                                    onClick: function onClick() {
                                        return getRewards();
                                    },
                                    mixClassName: _Footer2.default.buttonGetReward,
                                    isPending: isRewardsProcessing,
                                    type: 'primary'
                                },
                                _translations.GET_REWARD_TEXT
                            )
                        )
                    ) : _react2.default.createElement(
                        'span',
                        { className: _Footer2.default.text },
                        _translations.GET_REWARD_NOT_AVAILABLE
                    )
                )
            );
        }
    }]);

    return Footer;
}(_react2.default.Component);

Footer.propTypes = {
    reward: _propTypes2.default.object,
    isRewardsProcessing: _propTypes2.default.bool.isRequired,
    isRewardsTaken: _propTypes2.default.bool.isRequired,
    getRewards: _propTypes2.default.func.isRequired
};
exports.default = Footer;

/***/ }),
/* 2480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.GET_REWARD_REWARD_RECEIVED_TITLE = exports.GET_REWARD_REWARD_RECEIVED = exports.GET_REWARD_NOT_AVAILABLE = exports.GET_REWARD_TITLE = exports.GET_REWARD_TEXT = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */
var GET_REWARD_TEXT = exports.GET_REWARD_TEXT = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'get_reward.text',
    defaultMessage: '\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043D\u0430\u0433\u0440\u0430\u0434\u0443'
});

var GET_REWARD_TITLE = exports.GET_REWARD_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'get_reward.title',
    defaultMessage: '\u041D\u0430\u0433\u0440\u0430\u0434\u0430 \u0437\u0430 \u0434\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u044F \u0432 \u043B\u0438\u0447\u043D\u043E\u043C \u0440\u0435\u0439\u0442\u0438\u043D\u0433\u0435'
});

var GET_REWARD_NOT_AVAILABLE = exports.GET_REWARD_NOT_AVAILABLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'get_reward.not.available',
    defaultMessage: '\u0423 \u0432\u0430\u0441 \u043D\u0435\u0442 \u043D\u0430\u0447\u0438\u0441\u043B\u0435\u043D\u043D\u044B\u0445 \u0438 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0445 \u0434\u043B\u044F \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u043D\u0430\u0433\u0440\u0430\u0434'
});

var GET_REWARD_REWARD_RECEIVED = exports.GET_REWARD_REWARD_RECEIVED = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'get_reward.reward.received',
    defaultMessage: '\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0435 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u0435 \u043F\u043E\u0437\u0438\u0446\u0438\u0438 \u0432 \u0440\u0435\u0439\u0442\u0438\u043D\u0433\u0435 \u0438 \u0440\u0430\u0437\u043C\u0435\u0440\u0430 \u043D\u0430\u0433\u0440\u0430\u0434\u044B \u043F\u0440\u043E\u0438\u0437\u043E\u0439\u0434\u0435\u0442 \u043F\u043E\u0441\u043B\u0435 \u0440\u0430\u0441\u0447\u0451\u0442\u0430 \u0445\u043E\u0434\u0430 \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435'
});

var GET_REWARD_REWARD_RECEIVED_TITLE = exports.GET_REWARD_REWARD_RECEIVED_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'get_reward.reward.received.title',
    defaultMessage: '\u041D\u0430\u0433\u0440\u0430\u0434\u0430 \u043D\u0430\u0447\u0438\u0441\u043B\u0435\u043D\u0430 \u043D\u0430 \u0432\u0430\u0448 \u0430\u043A\u043A\u0430\u0443\u043D\u0442'
});

/***/ }),
/* 2481 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"Footer_base--2e6a-","base__haveReward":"Footer_base__haveReward--1U8IF","baseHaveReward":"Footer_base__haveReward--1U8IF","base__gotReawrd":"Footer_base__gotReawrd--o37rH","baseGotReawrd":"Footer_base__gotReawrd--o37rH","content":"Footer_content--22_r-","rewardHolder":"Footer_rewardHolder--2Z9nm","title":"Footer_title--SzBBe","reward":"Footer_reward--YUzDw","gold":"Footer_gold--YZrKT","bonds":"Footer_bonds---bofg","buttonLight":"Footer_buttonLight--2Gu65","buttonLight__fade":"Footer_buttonLight__fade--3i-9h","buttonLightFade":"Footer_buttonLight__fade--3i-9h","buttonGetReward":"Footer_buttonGetReward--1eDRF","text":"Footer_text--2Yroa","receivedTitle":"Footer_receivedTitle--27X1P"};

/***/ }),
/* 2482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LEADERBOARDS_AFFIRMATIVE = exports.GO_TO_GLOBAL_MAP_REWARDS = exports.GO_TO_GLOBAL_MAP_RATINGS = exports.LEADERBOARDS_INFO = exports.LEADERBOARDS_TITLE = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIntl = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */
var LEADERBOARDS_TITLE = exports.LEADERBOARDS_TITLE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'leaderboards.title',
    defaultMessage: '\u0414\u043E\u0441\u0442\u0438\u0436\u0435\u043D\u0438\u044F \u0432 \u0441\u043E\u0431\u044B\u0442\u0438\u0438'
});

var LEADERBOARDS_INFO = exports.LEADERBOARDS_INFO = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'wgcwx_leaderboards.info',
    defaultMessage: '\u0412 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 \u0441\u043E\u0431\u044B\u0442\u0438\u044F \u0438\u0433\u0440\u043E\u043A\u0438 \u0438 \u043A\u043B\u0430\u043D\u044B \u0437\u0430\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u044E\u0442 \u041E\u0447\u043A\u0438 \u0441\u043B\u0430\u0432\u044B, \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043A\u043E\u0442\u043E\u0440\u044B\u0445 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u044F\u0435\u0442 \u043F\u043E\u0437\u0438\u0446\u0438\u044E \u0432 \u0440\u0435\u0439\u0442\u0438\u043D\u0433\u0430\u0445 \u0438 \u043D\u0430\u0433\u0440\u0430\u0434\u0443.{newLine}\u0420\u0435\u0439\u0442\u0438\u043D\u0433\u0438 \u043E\u0431\u043D\u043E\u0432\u043B\u044F\u044E\u0442\u0441\u044F \u043A\u0430\u0436\u0434\u044B\u0439 \u0447\u0430\u0441 \u043F\u0440\u0438 \u043F\u0435\u0440\u0435\u0441\u0447\u0451\u0442\u0435 \u0445\u043E\u0434\u0430 \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435.',
    values: {
        newLine: _react2.default.createElement(
            'span',
            null,
            '\xA0'
        )
    }
});

var GO_TO_GLOBAL_MAP_RATINGS = exports.GO_TO_GLOBAL_MAP_RATINGS = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'leaderboards.go_to_global_map_ratings',
    defaultMessage: '\u041A \u0440\u0435\u0439\u0442\u0438\u043D\u0433\u0430\u043C \u043D\u0430 \u0413\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u043A\u0430\u0440\u0442\u0435'
});

var GO_TO_GLOBAL_MAP_REWARDS = exports.GO_TO_GLOBAL_MAP_REWARDS = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'leaderboards.go_to_global_map_rewards',
    defaultMessage: '\u041F\u043E\u0434\u0440\u043E\u0431\u043D\u0435\u0435 \u043E \u043D\u0430\u0447\u0438\u0441\u043B\u0435\u043D\u0438\u0438 \u043D\u0430\u0433\u0440\u0430\u0434'
});

var LEADERBOARDS_AFFIRMATIVE = exports.LEADERBOARDS_AFFIRMATIVE = _react2.default.createElement(_reactIntl.FormattedMessage, {
    id: 'leaderboards.affirmative',
    defaultMessage: '\u0422\u0430\u043A \u0442\u043E\u0447\u043D\u043E!'
});

/***/ }),
/* 2483 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"WGCWXLeaderboards_base--3x7vl","container":"WGCWXLeaderboards_container--2PJIw","infoContainer":"WGCWXLeaderboards_infoContainer--1Kr9L","info":"WGCWXLeaderboards_info--jv8aP","externalLink":"WGCWXLeaderboards_externalLink--1I3-m","mapButton":"WGCWXLeaderboards_mapButton--3KtBn","linksBlock":"WGCWXLeaderboards_linksBlock--37nQ4","boardsHolder":"WGCWXLeaderboards_boardsHolder--r4q1M","boards":"WGCWXLeaderboards_boards--2ClHN","boardItem":"WGCWXLeaderboards_boardItem--1NNuf"};

/***/ }),
/* 2484 */,
/* 2485 */,
/* 2486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.stateToProps = exports.ShopView = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(7);

var _reactWotBootstrap = __webpack_require__(5);

var _Stronghold = __webpack_require__(1340);

var _Stronghold2 = _interopRequireDefault(_Stronghold);

var _shop = __webpack_require__(242);

var _balance = __webpack_require__(275);

var _client2web = __webpack_require__(126);

var _ShopView = __webpack_require__(2487);

var _ShopView2 = _interopRequireDefault(_ShopView);

var _reactRouterRedux = __webpack_require__(15);

var _urls = __webpack_require__(19);

var _constants = __webpack_require__(301);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ShopView = exports.ShopView = function (_React$Component) {
    _inherits(ShopView, _React$Component);

    function ShopView() {
        _classCallCheck(this, ShopView);

        return _possibleConstructorReturn(this, (ShopView.__proto__ || Object.getPrototypeOf(ShopView)).apply(this, arguments));
    }

    _createClass(ShopView, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.errorStatus === 403) {
                this.props.showError(_constants.ErrorIds.NOT_CLAN_MEMBER);
            } else {
                this.props.onComponentDidMount();
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            if (prevProps.errorStatus !== this.props.errorStatus && this.props.errorStatus === 403) {
                this.props.showError(_constants.ErrorIds.NOT_CLAN_MEMBER);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.props.onComponentWillUnmount();
        }
    }, {
        key: 'render',
        value: function render() {
            if (!this.props.loaded && !this.props.error) {
                return _react2.default.createElement(_reactWotBootstrap.Processing, { type: 'fullscreen', isVisible: true });
            }

            return _react2.default.createElement(
                'div',
                { className: _ShopView2.default.base },
                _react2.default.createElement(
                    'div',
                    { className: _ShopView2.default.strongholdBackground },
                    _react2.default.createElement(_Stronghold2.default, { ignoreEscape: true })
                ),
                this.props.children
            );
        }
    }]);

    return ShopView;
}(_react2.default.Component);

ShopView.propTypes = {
    loaded: _propTypes2.default.bool.isRequired,
    error: _propTypes2.default.bool,
    errorStatus: _propTypes2.default.number,

    onComponentDidMount: _propTypes2.default.func.isRequired,
    onComponentWillUnmount: _propTypes2.default.func.isRequired,
    showError: _propTypes2.default.func.isRequired
};
var stateToProps = exports.stateToProps = function stateToProps(_ref) {
    var shop = _ref.shop,
        balance = _ref.balance;

    return {
        loaded: shop.productsLoaded,
        error: !!shop.errorMessage,
        errorStatus: shop.errorStatus,
        balance: balance
    };
};

var dispatchToProps = function dispatchToProps(dispatch) {
    return {
        onComponentDidMount: function onComponentDidMount() {
            dispatch((0, _shop.requestShopProducts)());
            dispatch((0, _balance.requestBalance)());

            (0, _client2web.addWOTClientListener)(_client2web.C2W_EVENT_TYPES.UPDATE_BALANCE, dispatch);
            (0, _client2web.addWOTClientListener)(_client2web.C2W_EVENT_TYPES.WALLET_UPDATE, dispatch);
        },
        onComponentWillUnmount: function onComponentWillUnmount() {
            (0, _client2web.removeWOTClientListener)(_client2web.C2W_EVENT_TYPES.UPDATE_BALANCE, dispatch);
            (0, _client2web.removeWOTClientListener)(_client2web.C2W_EVENT_TYPES.WALLET_UPDATE, dispatch);
        },
        showError: function showError(errorId) {
            return dispatch((0, _reactRouterRedux.push)((0, _urls.SHOP_ERROR)(errorId)));
        }
    };
};

exports.default = (0, _reactRedux.connect)(stateToProps, dispatchToProps)(ShopView);

/***/ }),
/* 2487 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"base":"ShopView_base--IkWS-","strongholdBackground":"ShopView_strongholdBackground--3dldM"};

/***/ }),
/* 2488 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./components/ArenaTooltip/images/map-placeholder.png": 2489,
	"./components/Back/images/back-hover.png": 2490,
	"./components/Back/images/back.png": 2491,
	"./components/Back/images/close-hover.png": 2492,
	"./components/Back/images/close.png": 2493,
	"./components/Back/images/info-hover.png": 2494,
	"./components/Back/images/info.png": 2495,
	"./components/Back/images/shine-to-left.png": 2496,
	"./components/Back/images/shine-to-right.png": 2497,
	"./components/Back/images/shine.png": 2498,
	"./components/BaseBonusInfoTable/images/dots.png": 2499,
	"./components/BattleWizard/components/Arenas/images/command-center.png": 2500,
	"./components/BattleWizard/components/Arenas/images/flag.png": 2501,
	"./components/BattleWizard/components/Battle/images/bg-fort-battle.png": 2502,
	"./components/BattleWizard/components/Battle/images/bg-sortie.png": 2503,
	"./components/BattleWizard/components/Battle/images/divider.png": 2504,
	"./components/BattleWizard/components/BattleTitleTooltip/images/reward-bg.png": 2505,
	"./components/BattleWizard/components/BattleTitleTooltip/images/reward-icon.png": 2506,
	"./components/BattleWizard/components/Direction/images/battle.png": 2507,
	"./components/BattleWizard/components/Direction/images/direction-bg-bonus.png": 2508,
	"./components/BattleWizard/components/Direction/images/direction-bg.png": 2509,
	"./components/BattleWizard/components/Direction/images/direction-icon-A-doubled.png": 2510,
	"./components/BattleWizard/components/Direction/images/direction-icon-A.png": 2511,
	"./components/BattleWizard/components/Direction/images/direction-icon-B-doubled.png": 2512,
	"./components/BattleWizard/components/Direction/images/direction-icon-B.png": 2513,
	"./components/BattleWizard/components/Direction/images/direction-icon-C-doubled.png": 2514,
	"./components/BattleWizard/components/Direction/images/direction-icon-C.png": 2515,
	"./components/BattleWizard/components/Direction/images/direction-icon-D-doubled.png": 2516,
	"./components/BattleWizard/components/Direction/images/direction-icon-D.png": 2517,
	"./components/BattleWizard/components/Level/images/level-bg.png": 2518,
	"./components/BattleWizard/components/Option/images/duration.png": 2519,
	"./components/BattleWizard/components/Option/images/legionaries.png": 2520,
	"./components/BattleWizard/components/Option/images/level.png": 2521,
	"./components/BattleWizard/components/Option/images/players.png": 2522,
	"./components/BattleWizard/components/Schedule/images/background.png": 2523,
	"./components/BattleWizard/components/Schedule/images/divider.png": 2524,
	"./components/BattleWizard/components/Status/images/background.png": 2525,
	"./components/BattleWizard/components/UnavailableBattle/images/alert-bg.png": 2526,
	"./components/BattleWizard/components/UnavailableBattle/images/bg-content.png": 2527,
	"./components/BattleWizard/components/UnavailableBattle/images/bg-fort-battle.png": 2528,
	"./components/BattleWizard/components/UnavailableBattle/images/bg-sortie.png": 2529,
	"./components/BattleWizard/components/UnavailableBattle/images/divider-content.png": 2530,
	"./components/BattleWizard/components/WizardButton/images/body-texture-bonus.png": 2531,
	"./components/BattleWizard/components/WizardButton/images/body-texture-selected.png": 2532,
	"./components/BattleWizard/components/WizardButton/images/body-texture.png": 2533,
	"./components/BattleWizard/components/WizardButton/images/border-battle.png": 2534,
	"./components/BattleWizard/components/WizardButton/images/border-bonus-hover.png": 2535,
	"./components/BattleWizard/components/WizardButton/images/border-bonus.png": 2536,
	"./components/BattleWizard/components/WizardButton/images/border-hover.png": 2537,
	"./components/BattleWizard/components/WizardButton/images/border-normal.png": 2538,
	"./components/BattleWizard/components/WizardButton/images/border-selected.png": 2539,
	"./components/BattleWizard/components/WizardButton/images/disabled-pattern.png": 2540,
	"./components/BattleWizard/components/WizardButton/images/overlay.png": 2541,
	"./components/BattleWizard/components/WizardButton/images/ribbon.png": 2542,
	"./components/BattleWizard/images/background.jpg": 2543,
	"./components/BattleWizard/images/divider.png": 2544,
	"./components/BattleWizard/images/pattern.png": 2545,
	"./components/BattleWizard/images/sparks.png": 2546,
	"./components/BuildingCardImage/images/arrow/arrow-0-100.png": 2547,
	"./components/BuildingCardImage/images/arrow/arrow-0-50.png": 2548,
	"./components/BuildingCardImage/images/arrow/arrow-0-75.png": 2549,
	"./components/BuildingCardImage/images/arrow/arrow-1-100.png": 2550,
	"./components/BuildingCardImage/images/arrow/arrow-1-50.png": 2551,
	"./components/BuildingCardImage/images/arrow/arrow-1-75.png": 2552,
	"./components/BuildingCardImage/images/arrow/arrow-2-100.png": 2553,
	"./components/BuildingCardImage/images/arrow/arrow-2-50.png": 2554,
	"./components/BuildingCardImage/images/arrow/arrow-2-75.png": 2555,
	"./components/BuildingCardImage/images/arrow/arrow-3-100.png": 2556,
	"./components/BuildingCardImage/images/arrow/arrow-3-50.png": 2557,
	"./components/BuildingCardImage/images/arrow/arrow-3-75.png": 2558,
	"./components/BuildingCardImage/images/arrow/arrow-4-100.png": 2559,
	"./components/BuildingCardImage/images/arrow/arrow-4-50.png": 2560,
	"./components/BuildingCardImage/images/arrow/arrow-4-75.png": 2561,
	"./components/BuildingCardImage/images/arrow/arrow-base-100.png": 2562,
	"./components/BuildingCardImage/images/arrow/arrow-base-50.png": 2563,
	"./components/BuildingCardImage/images/arrow/arrow-base-75.png": 2564,
	"./components/BuildingCardImage/images/cost-bg-disabled.png": 2565,
	"./components/BuildingCardImage/images/cost-bg.png": 2566,
	"./components/BuildingCardImage/images/max-level-100.png": 2567,
	"./components/BuildingCardImage/images/max-level-50.png": 2568,
	"./components/ButtonInbox/images/button-inbox-new-message.png": 2569,
	"./components/ButtonInbox/images/button-inbox.png": 2570,
	"./components/ButtonLeavingClan/images/button-exit-clan.png": 2571,
	"./components/ButtonSimple/images/button-simple-external-icon.png": 2572,
	"./components/ButtonTiny/images/default-borders-active.png": 2573,
	"./components/ButtonTiny/images/default-borders-hover.png": 2574,
	"./components/ButtonTiny/images/default-borders.png": 2575,
	"./components/ButtonTiny/images/default-tile-active.png": 2576,
	"./components/ButtonTiny/images/default-tile-hover.png": 2577,
	"./components/ButtonTiny/images/default-tile.png": 2578,
	"./components/ButtonTiny/images/disabled-borders.png": 2579,
	"./components/ButtonTiny/images/disabled-tile-pattern.png": 2580,
	"./components/ButtonTiny/images/disabled-tile.png": 2581,
	"./components/ButtonTiny/images/secondary-borders-active.png": 2582,
	"./components/ButtonTiny/images/secondary-borders-hover.png": 2583,
	"./components/ButtonTiny/images/secondary-borders.png": 2584,
	"./components/ButtonTiny/images/secondary-tile-active.png": 2585,
	"./components/ButtonTiny/images/secondary-tile-hover.png": 2586,
	"./components/ButtonTiny/images/secondary-tile.png": 2587,
	"./components/ChallengeContent/components/Label/images/label-results.png": 2588,
	"./components/ChallengeContent/components/Label/images/label.png": 2589,
	"./components/ChallengeContent/components/Label/images/rhomb.png": 2590,
	"./components/ChallengeContent/components/Label/images/wing-left.png": 2591,
	"./components/ChallengeContent/components/Label/images/wing-right.png": 2592,
	"./components/ChallengeContent/components/Message/images/glow-position.png": 2593,
	"./components/Confirmation/images/background.png": 2594,
	"./components/Confirmation/images/close.png": 2595,
	"./components/FamePoints/images/icon-fame-points.png": 2596,
	"./components/Gamefield/images/gamefield-100.jpg": 2597,
	"./components/Gamefield/images/gamefield-50.jpg": 2598,
	"./components/Gamefield/images/gamefield-75.jpg": 2599,
	"./components/Gamefield/images/gamefield-external-100.jpg": 2600,
	"./components/Gamefield/images/gamefield-external-50.jpg": 2601,
	"./components/Gamefield/images/gamefield-external-75.jpg": 2602,
	"./components/InfoButton/images/info-hover.png": 2603,
	"./components/InfoButton/images/info.png": 2604,
	"./components/LoadingScreen/images/fullscreen-bg.jpg": 2605,
	"./components/LoadingScreen/images/spinner.RU.png": 2606,
	"./components/LoadingScreen/images/spinner.png": 2607,
	"./components/LoadingScreen/images/window-bg.jpg": 2608,
	"./components/ModernizationOverlay/images/modernization-bg-100.jpg": 2609,
	"./components/ModernizationOverlay/images/modernization-bg-50.jpg": 2610,
	"./components/ModernizationOverlay/images/modernization-bg-75.jpg": 2611,
	"./components/Nation/images/flag-all-china.png": 2612,
	"./components/Nation/images/flag-all-czech.png": 2613,
	"./components/Nation/images/flag-all-france.png": 2614,
	"./components/Nation/images/flag-all-germany.png": 2615,
	"./components/Nation/images/flag-all-italy.png": 2616,
	"./components/Nation/images/flag-all-japan.png": 2617,
	"./components/Nation/images/flag-all-poland.png": 2618,
	"./components/Nation/images/flag-all-sweden.png": 2619,
	"./components/Nation/images/flag-all-uk.png": 2620,
	"./components/Nation/images/flag-all-usa.png": 2621,
	"./components/Nation/images/flag-all-ussr.png": 2622,
	"./components/Nation/images/flag-all.png": 2623,
	"./components/Nation/images/flag-cn-china.png": 2624,
	"./components/Nation/images/flag-cn-czech.png": 2625,
	"./components/Nation/images/flag-cn-france.png": 2626,
	"./components/Nation/images/flag-cn-germany.png": 2627,
	"./components/Nation/images/flag-cn-italy.png": 2628,
	"./components/Nation/images/flag-cn-japan.png": 2629,
	"./components/Nation/images/flag-cn-poland.png": 2630,
	"./components/Nation/images/flag-cn-sweden.png": 2631,
	"./components/Nation/images/flag-cn-uk.png": 2632,
	"./components/Nation/images/flag-cn-usa.png": 2633,
	"./components/Nation/images/flag-cn-ussr.png": 2634,
	"./components/NavigationArrow/images/arrow-left-disabled-big.png": 2635,
	"./components/NavigationArrow/images/arrow-left-disabled-small.png": 2636,
	"./components/NavigationArrow/images/arrow-left-disabled-tiny.png": 2637,
	"./components/NavigationArrow/images/arrow-left-hover-big.png": 2638,
	"./components/NavigationArrow/images/arrow-left-hover-small.png": 2639,
	"./components/NavigationArrow/images/arrow-left-hover-tiny.png": 2640,
	"./components/NavigationArrow/images/arrow-left-normal-big.png": 2641,
	"./components/NavigationArrow/images/arrow-left-normal-small.png": 2642,
	"./components/NavigationArrow/images/arrow-left-normal-tiny.png": 2643,
	"./components/NavigationArrow/images/arrow-right-disabled-big.png": 2644,
	"./components/NavigationArrow/images/arrow-right-disabled-small.png": 2645,
	"./components/NavigationArrow/images/arrow-right-disabled-tiny.png": 2646,
	"./components/NavigationArrow/images/arrow-right-hover-big.png": 2647,
	"./components/NavigationArrow/images/arrow-right-hover-small.png": 2648,
	"./components/NavigationArrow/images/arrow-right-hover-tiny.png": 2649,
	"./components/NavigationArrow/images/arrow-right-normal-big.png": 2650,
	"./components/NavigationArrow/images/arrow-right-normal-small.png": 2651,
	"./components/NavigationArrow/images/arrow-right-normal-tiny.png": 2652,
	"./components/Pagination/PaginationArrowButton/images/pagination-arrow.png": 2653,
	"./components/Pagination/PaginationArrowButton/images/pagination-arrow_disable.png": 2654,
	"./components/Pagination/PaginationList/PaginationRender/images/item_select.png": 2655,
	"./components/Popover/images/arrow-aside.png": 2656,
	"./components/Popover/images/arrow-top.png": 2657,
	"./components/ProductionProgress/images/cancel-button-active.png": 2658,
	"./components/ProductionProgress/images/cancel-button-default.png": 2659,
	"./components/ProductionProgress/images/cancel-button-hover.png": 2660,
	"./components/Reserve/images/bg.png": 2661,
	"./components/ReserveProgress/images/gradient.png": 2662,
	"./components/ReserveProgress/images/pattern.png": 2663,
	"./components/RewardBox/images/rewardBox.png": 2664,
	"./components/RewardBox/images/small/rewardBox.png": 2665,
	"./components/RewardMoney/images/bonds-large.RU.png": 2666,
	"./components/RewardMoney/images/bonds-large.png": 2667,
	"./components/RewardMoney/images/bonds-small.RU.png": 2668,
	"./components/RewardMoney/images/bonds-small.png": 2669,
	"./components/RewardMoney/images/credits-large.png": 2670,
	"./components/RewardMoney/images/credits-small.png": 2671,
	"./components/RewardMoney/images/gold-large.png": 2672,
	"./components/RewardMoney/images/gold-small.png": 2673,
	"./components/RewardMoney/images/industrial_resources-large.png": 2674,
	"./components/RewardMoney/images/industrial_resources-small.png": 2675,
	"./components/TutorialArrow/images/back.png": 2676,
	"./components/TutorialArrow/images/border.png": 2677,
	"./components/TutorialArrow/images/tutorial-arrow.png": 2678,
	"./components/UpdateButton/images/update-icon.png": 2679,
	"./components/UpgradeConfirmationView/images/bg.jpg": 2680,
	"./components/UpgradeConfirmationView/images/divider.png": 2681,
	"./components/UpgradeConfirmationView/images/radiance/radiance-0.png": 2682,
	"./components/UpgradeConfirmationView/images/radiance/radiance-1.png": 2683,
	"./components/UpgradeConfirmationView/images/radiance/radiance-10.png": 2684,
	"./components/UpgradeConfirmationView/images/radiance/radiance-2.png": 2685,
	"./components/UpgradeConfirmationView/images/radiance/radiance-3.png": 2686,
	"./components/UpgradeConfirmationView/images/radiance/radiance-4.png": 2687,
	"./components/UpgradeConfirmationView/images/radiance/radiance-5.png": 2688,
	"./components/UpgradeConfirmationView/images/radiance/radiance-6.png": 2689,
	"./components/UpgradeConfirmationView/images/radiance/radiance-7.png": 2690,
	"./components/UpgradeConfirmationView/images/radiance/radiance-8.png": 2691,
	"./components/UpgradeConfirmationView/images/radiance/radiance-9.png": 2692,
	"./components/UpgradeEffect/images/hover-borders.png": 2693,
	"./components/UpgradeEffect/images/hover-tile.png": 2694,
	"./components/UpgradeIcon/images/arrow-0.png": 2695,
	"./components/UpgradeIcon/images/arrow-1.png": 2696,
	"./components/UpgradeIcon/images/arrow-2.png": 2697,
	"./components/UpgradeIcon/images/arrow-3.png": 2698,
	"./components/UpgradeIcon/images/arrow-4.png": 2699,
	"./components/UpgradeIcon/images/arrow-base.png": 2700,
	"./components/VehicleAddToComparison/images/icon-vehicle-add-to-comp.png": 2701,
	"./components/VehicleFilter/images/favourite_vehicles.png": 2702,
	"./components/VehicleFilter/images/filter_button_overlay.png": 2703,
	"./components/VehicleFilter/images/gear_icon.png": 2704,
	"./components/VehicleFilterCheckbox/images/vehicle-filter-checkbox-bg.png": 2705,
	"./components/VehicleFilterCheckbox/images/vehicle-filter-checkbox-check.png": 2706,
	"./components/VehicleFilterSelect/images/select-bg.png": 2707,
	"./components/VehicleFilterSelect/images/select-triangle.png": 2708,
	"./components/VehicleType/images/AT-SPG-prem-tiny.png": 2709,
	"./components/VehicleType/images/AT-SPG-prem.png": 2710,
	"./components/VehicleType/images/AT-SPG-tiny.png": 2711,
	"./components/VehicleType/images/AT-SPG.png": 2712,
	"./components/VehicleType/images/SPG-prem-tiny.png": 2713,
	"./components/VehicleType/images/SPG-prem.png": 2714,
	"./components/VehicleType/images/SPG-tiny.png": 2715,
	"./components/VehicleType/images/SPG.png": 2716,
	"./components/VehicleType/images/heavyTank-prem-tiny.png": 2717,
	"./components/VehicleType/images/heavyTank-prem.png": 2718,
	"./components/VehicleType/images/heavyTank-tiny.png": 2719,
	"./components/VehicleType/images/heavyTank.png": 2720,
	"./components/VehicleType/images/lightTank-prem-tiny.png": 2721,
	"./components/VehicleType/images/lightTank-prem.png": 2722,
	"./components/VehicleType/images/lightTank-tiny.png": 2723,
	"./components/VehicleType/images/lightTank.png": 2724,
	"./components/VehicleType/images/mediumTank-prem-tiny.png": 2725,
	"./components/VehicleType/images/mediumTank-prem.png": 2726,
	"./components/VehicleType/images/mediumTank-tiny.png": 2727,
	"./components/VehicleType/images/mediumTank.png": 2728,
	"./components/WGCWXConfirmation/images/alert.png": 2729,
	"./components/WGCWXConfirmation/images/alert_light.png": 2730,
	"./components/WGCWXConfirmation/images/error.png": 2731,
	"./components/WGCWXConfirmation/images/error_light.png": 2732,
	"./components/Warning/images/alert.png": 2733,
	"./components/Warning/images/warning.png": 2734,
	"./containers/BattleRooms/components/BattleRoomsWrapper/images/header-cn.jpg": 2735,
	"./containers/BattleRooms/components/BattleRoomsWrapper/images/header-sparks.png": 2736,
	"./containers/BattleRooms/components/BattleRoomsWrapper/images/header.jpg": 2737,
	"./containers/BattleRooms/components/FullSchedule/images/background.jpg": 2738,
	"./containers/BattleRooms/components/Squad/components/Vehicle/images/vehicle-slot.png": 2739,
	"./containers/BattleRooms/components/Squad/images/border-bottom.png": 2740,
	"./containers/BattleRooms/components/Squad/images/border-top.png": 2741,
	"./containers/BattleRooms/components/Squad/images/locked-slot.png": 2742,
	"./containers/BattleRooms/components/Squad/images/tr-background.png": 2743,
	"./containers/BattleRooms/components/Squad/images/tr-disabled-pattern.png": 2744,
	"./containers/BattleRooms/components/Tabs/images/background.png": 2745,
	"./containers/BattleRooms/components/Tabs/images/border-left.png": 2746,
	"./containers/BattleRooms/components/Tabs/images/border-right.png": 2747,
	"./containers/BattleRooms/components/Tabs/images/border-top.png": 2748,
	"./containers/BattleRooms/components/Tabs/images/border.png": 2749,
	"./containers/BattleRooms/components/Tabs/images/highlight.png": 2750,
	"./containers/BattleRooms/components/Tabs/images/overlay-active.png": 2751,
	"./containers/BattleRooms/components/Tabs/images/overlay-left-active.png": 2752,
	"./containers/BattleRooms/components/Tabs/images/overlay-right-active.png": 2753,
	"./containers/BattleRooms/components/Tabs/images/overlay.png": 2754,
	"./containers/BattleRooms/components/Title/images/calendar-icon.png": 2755,
	"./containers/BattleRooms/components/UnitPreview/images/unitPreviewBackground.jpg": 2756,
	"./containers/BattleRooms/components/UnitsList/images/fort-battle-10.png": 2757,
	"./containers/BattleRooms/components/UnitsList/images/sortie-10.png": 2758,
	"./containers/BattleRooms/components/UnitsList/images/sortie-6.png": 2759,
	"./containers/BattleRooms/components/UnitsList/images/sortie-8.png": 2760,
	"./containers/BattleRooms/components/UnitsList/images/th-divider.png": 2761,
	"./containers/BattleRooms/components/UnitsList/images/thead-border.png": 2762,
	"./containers/BattleRooms/components/UnitsList/images/tr-background.png": 2763,
	"./containers/BattleRooms/components/UnitsList/images/tr-hover.png": 2764,
	"./containers/BattleRooms/components/UnitsList/images/tr-select.png": 2765,
	"./containers/BattleRooms/components/UnitsList/images/tr-subtitle.png": 2766,
	"./containers/BattleRooms/containers/PlayersMatchingView/components/PlayersMatchingButton/images/button_bg.png": 2767,
	"./containers/BattleRooms/containers/PlayersMatchingView/components/Unit/images/squad.png": 2768,
	"./containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/bonuses/bonus_x2.png": 2769,
	"./containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/bonuses/bonus_x3.png": 2770,
	"./containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/bonuses/bonus_x4.png": 2771,
	"./containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/bonuses/bonus_x5.png": 2772,
	"./containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/closeButton.png": 2773,
	"./containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags/china.png": 2774,
	"./containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags/czech.png": 2775,
	"./containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags/france.png": 2776,
	"./containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags/germany.png": 2777,
	"./containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags/italy.png": 2778,
	"./containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags/japan.png": 2779,
	"./containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags/poland.png": 2780,
	"./containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags/sweden.png": 2781,
	"./containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags/uk.png": 2782,
	"./containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags/usa.png": 2783,
	"./containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags/ussr.png": 2784,
	"./containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags_CN/china.png": 2785,
	"./containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags_CN/czech.png": 2786,
	"./containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags_CN/france.png": 2787,
	"./containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags_CN/germany.png": 2788,
	"./containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags_CN/italy.png": 2789,
	"./containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags_CN/japan.png": 2790,
	"./containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags_CN/poland.png": 2791,
	"./containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags_CN/sweden.png": 2792,
	"./containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags_CN/uk.png": 2793,
	"./containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags_CN/usa.png": 2794,
	"./containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags_CN/ussr.png": 2795,
	"./containers/BattleRooms/containers/PlayersMatchingView/components/WaitingPopover/images/footer_bg.png": 2796,
	"./containers/BattleRooms/containers/PlayersMatchingView/images/clanUnitsFooter.png": 2797,
	"./containers/BattleRooms/containers/PlayersMatchingView/images/resetSelectedVehiclesButton.png": 2798,
	"./containers/BattleRooms/containers/PlayersMatchingView/images/resetSelectedVehiclesButton_hover.png": 2799,
	"./containers/BattleRooms/containers/UnitsView/images/vertical-divider.png": 2800,
	"./containers/BattleRooms/containers/UnitsView/images/view-bg.png": 2801,
	"./containers/BattleRooms/images/cap.png": 2802,
	"./containers/BuildingCard/components/ReserveProduce/images/divider-shadowed-mask.png": 2803,
	"./containers/BuildingCard/components/ReserveProduce/images/divider-shadowed.png": 2804,
	"./containers/BuildingCard/components/ReserveSelect/images/arrow-hover.png": 2805,
	"./containers/BuildingCard/components/ReserveSelect/images/arrow.png": 2806,
	"./containers/BuildingCard/components/ReserveSelect/images/bg-pattern.png": 2807,
	"./containers/BuildingsCarousel/images/bg-hover.png": 2808,
	"./containers/BuildingsCarousel/images/bg.png": 2809,
	"./containers/BuildingsCarousel/images/carousel-mask.png": 2810,
	"./containers/BuildingsCarousel/images/pattern.png": 2811,
	"./containers/ChallengeView/components/Leaderboard/images/clan-divider.png": 2812,
	"./containers/ChallengeView/components/Leaderboard/images/footer-divider.png": 2813,
	"./containers/ChallengeView/components/Leaderboard/images/prize-background.png": 2814,
	"./containers/ChallengeView/components/Leaderboard/images/sparkles.png": 2815,
	"./containers/ChallengeView/components/RulesPoints/images/header-divider.png": 2816,
	"./containers/ChallengeView/images/background-conscription.jpg": 2817,
	"./containers/ChallengeView/images/background-onslaught.jpg": 2818,
	"./containers/ChallengeView/images/background-shooting-cn.jpg": 2819,
	"./containers/ChallengeView/images/background-shooting.jpg": 2820,
	"./containers/ChallengeView/images/background-superiority-cn.jpg": 2821,
	"./containers/ChallengeView/images/background-superiority.jpg": 2822,
	"./containers/ChallengeView/images/background.jpg": 2823,
	"./containers/Challenges/components/Challenge/images/background-conscription.png": 2824,
	"./containers/Challenges/components/Challenge/images/background-onslaught.png": 2825,
	"./containers/Challenges/components/Challenge/images/background-pattern.png": 2826,
	"./containers/Challenges/components/Challenge/images/background-shooting-cn.png": 2827,
	"./containers/Challenges/components/Challenge/images/background-shooting.png": 2828,
	"./containers/Challenges/components/Challenge/images/background-superiority-cn.png": 2829,
	"./containers/Challenges/components/Challenge/images/background-superiority.png": 2830,
	"./containers/Challenges/components/Challenge/images/borders-default.png": 2831,
	"./containers/Challenges/components/Challenge/images/borders-selection-history.png": 2832,
	"./containers/Challenges/components/Challenge/images/borders-selection-prize.png": 2833,
	"./containers/Challenges/components/Challenge/images/borders-selection.png": 2834,
	"./containers/Challenges/components/Challenge/images/disabled-pattern.png": 2835,
	"./containers/Challenges/components/Challenge/images/glow-bottom.png": 2836,
	"./containers/Challenges/components/Challenge/images/glow-top.png": 2837,
	"./containers/Challenges/components/Challenge/images/history-item-divider.png": 2838,
	"./containers/Challenges/components/Challenge/images/icon-conscription.png": 2839,
	"./containers/Challenges/components/Challenge/images/icon-onslaught.png": 2840,
	"./containers/Challenges/components/Challenge/images/icon-shooting.png": 2841,
	"./containers/Challenges/components/Challenge/images/icon-superiority.png": 2842,
	"./containers/Challenges/components/Challenge/images/label.png": 2843,
	"./containers/Challenges/components/Challenge/images/sparkles-bottom-conscription.png": 2844,
	"./containers/Challenges/components/Challenge/images/sparkles-bottom-onslaught.png": 2845,
	"./containers/Challenges/components/Challenge/images/sparkles-bottom-shooting.png": 2846,
	"./containers/Challenges/components/Challenge/images/sparkles-bottom-superiority.png": 2847,
	"./containers/Challenges/components/Challenge/images/sparkles-top-conscription.png": 2848,
	"./containers/Challenges/components/Challenge/images/sparkles-top-onslaught.png": 2849,
	"./containers/Challenges/components/Challenge/images/sparkles-top-shooting.png": 2850,
	"./containers/Challenges/components/Challenge/images/sparkles-top-superiority.png": 2851,
	"./containers/Challenges/components/Status/images/button.png": 2852,
	"./containers/Challenges/components/Status/images/button_disabled.png": 2853,
	"./containers/Challenges/components/Status/images/button_hover.png": 2854,
	"./containers/Challenges/components/Status/images/future_bg.png": 2855,
	"./containers/Challenges/components/Status/images/future_right_1.png": 2856,
	"./containers/Challenges/components/Status/images/future_right_2.png": 2857,
	"./containers/Challenges/components/Status/images/gold_bg.png": 2858,
	"./containers/Challenges/components/Status/images/gold_left_1.png": 2859,
	"./containers/Challenges/components/Status/images/gold_left_2.png": 2860,
	"./containers/Challenges/components/Status/images/gold_light.png": 2861,
	"./containers/Challenges/components/Status/images/gold_right_1.png": 2862,
	"./containers/Challenges/components/Status/images/gold_right_2.png": 2863,
	"./containers/Challenges/components/Status/images/line_light.png": 2864,
	"./containers/Challenges/components/Status/images/line_light_wrapped.png": 2865,
	"./containers/Challenges/components/Status/images/past_bg.png": 2866,
	"./containers/Challenges/components/Status/images/past_left_1.png": 2867,
	"./containers/Challenges/components/Status/images/past_left_2.png": 2868,
	"./containers/Challenges/components/Status/images/past_light.png": 2869,
	"./containers/Challenges/components/Status/images/shadows-tile.png": 2870,
	"./containers/Challenges/components/Status/images/small_gold_light.png": 2871,
	"./containers/Challenges/images/glow-message.png": 2872,
	"./containers/Challenges/images/header-background.png": 2873,
	"./containers/Challenges/images/top-shadows-tile.png": 2874,
	"./containers/ChallengesPromo/images/places.RU.png": 2875,
	"./containers/ChallengesPromo/images/places.png": 2876,
	"./containers/ChallengesPromo/images/points.png": 2877,
	"./containers/ChallengesPromo/images/rewards.png": 2878,
	"./containers/ChallengesResults/images/challenges-rewarding-bg.jpg": 2879,
	"./containers/ChallengesResults/images/item-divider.png": 2880,
	"./containers/ChallengesResults/images/ribbon.png": 2881,
	"./containers/ClanLanding/components/AnnouncementsCard/images/announcement_create_icon.png": 2882,
	"./containers/ClanLanding/components/AnnouncementsCard/images/announcement_create_icon_disabled.png": 2883,
	"./containers/ClanLanding/components/AnnouncementsCard/images/announcement_footer.png": 2884,
	"./containers/ClanLanding/components/AnnouncementsCard/images/announcement_shadow.png": 2885,
	"./containers/ClanLanding/components/AnnouncementsCard/images/announcement_view_bg.jpg": 2886,
	"./containers/ClanLanding/components/AnnouncementsCard/images/announcements_bg.jpg": 2887,
	"./containers/ClanLanding/components/AnnouncementsCard/images/announcements_bg_big.jpg": 2888,
	"./containers/ClanLanding/components/AnnouncementsCard/images/announcements_bg_with_quests.jpg": 2889,
	"./containers/ClanLanding/components/AnnouncementsCard/images/announcements_bg_with_quests_big.jpg": 2890,
	"./containers/ClanLanding/components/AnnouncementsCard/images/default_news_bg.jpg": 2891,
	"./containers/ClanLanding/components/AnnouncementsCard/images/default_news_bg_big.jpg": 2892,
	"./containers/ClanLanding/components/AnnouncementsCard/images/default_news_bg_with_quests.jpg": 2893,
	"./containers/ClanLanding/components/AnnouncementsCard/images/default_news_bg_with_quests_big.jpg": 2894,
	"./containers/ClanLanding/components/AnnouncementsCard/images/external_url_icon.png": 2895,
	"./containers/ClanLanding/components/AnnouncementsCard/images/external_url_icon_dark.png": 2896,
	"./containers/ClanLanding/components/AnnouncementsCard/images/icon_lock.png": 2897,
	"./containers/ClanLanding/components/AnnouncementsCard/images/warning_icon.png": 2898,
	"./containers/ClanLanding/components/ArcProgressbar/images/arc-progressbar-clan-bg.png": 2899,
	"./containers/ClanLanding/components/ArcProgressbar/images/arc-progressbar-clan-crawl.png": 2900,
	"./containers/ClanLanding/components/ArcProgressbar/images/arc-progressbar-clan-full.png": 2901,
	"./containers/ClanLanding/components/ArcProgressbar/images/arc-progressbar-clan-global-map.png": 2902,
	"./containers/ClanLanding/components/ArcProgressbar/images/arc-progressbar-clan-light.png": 2903,
	"./containers/ClanLanding/components/ArcProgressbar/images/arc-progressbar-clan-squad.png": 2904,
	"./containers/ClanLanding/components/ArcProgressbar/images/arc-progressbar-clan-stronghold.png": 2905,
	"./containers/ClanLanding/components/ArcProgressbar/images/arc-progressbar-personal-achievement.png": 2906,
	"./containers/ClanLanding/components/ArcProgressbar/images/arc-progressbar-personal-bg.png": 2907,
	"./containers/ClanLanding/components/ArcProgressbar/images/arc-progressbar-personal-damage.png": 2908,
	"./containers/ClanLanding/components/ArcProgressbar/images/arc-progressbar-personal-delta.png": 2909,
	"./containers/ClanLanding/components/ArcProgressbar/images/arc-progressbar-personal-experience.png": 2910,
	"./containers/ClanLanding/components/ArcProgressbar/images/arc-progressbar-personal-full.png": 2911,
	"./containers/ClanLanding/components/ArcProgressbar/images/arc-progressbar-personal-kill.png": 2912,
	"./containers/ClanLanding/components/ArcProgressbar/images/arc-progressbar-personal-light.png": 2913,
	"./containers/ClanLanding/components/ArcProgressbar/images/arc-progressbar-personal-top.png": 2914,
	"./containers/ClanLanding/components/ArcProgressbar/images/arc-progressbar-personal-win.png": 2915,
	"./containers/ClanLanding/components/ArcProgressbar/images/arc-progressbar-quest-first.png": 2916,
	"./containers/ClanLanding/components/ArcProgressbar/images/arc-progressbar-quest-progress-done.png": 2917,
	"./containers/ClanLanding/components/ArcProgressbar/images/arc-progressbar-quest-progressbar-bg.png": 2918,
	"./containers/ClanLanding/components/ArcProgressbar/images/arc-progressbar-quest-progressbar.png": 2919,
	"./containers/ClanLanding/components/ArcProgressbar/images/arc-progressbar-quest-second.png": 2920,
	"./containers/ClanLanding/components/ArcProgressbar/images/arc-progressbar-quest-spark.png": 2921,
	"./containers/ClanLanding/components/ArcProgressbar/images/arc-progressbar-quest-third.png": 2922,
	"./containers/ClanLanding/components/ArcProgressbar/images/icon-complete.png": 2923,
	"./containers/ClanLanding/components/ArcProgressbar/images/icon-info.png": 2924,
	"./containers/ClanLanding/components/ArcProgressbar/images/icon-locked.png": 2925,
	"./containers/ClanLanding/components/ArcProgressbar/images/icon-pending.png": 2926,
	"./containers/ClanLanding/components/ClanLandingReserves/images/background-big.png": 2927,
	"./containers/ClanLanding/components/ClanLandingReserves/images/background-sm.png": 2928,
	"./containers/ClanLanding/components/ClanLandingReserves/images/new-reserve-big.png": 2929,
	"./containers/ClanLanding/components/ClanLandingReserves/images/new-reserve-hover-big.png": 2930,
	"./containers/ClanLanding/components/ClanLandingReserves/images/new-reserve-hover-sm.png": 2931,
	"./containers/ClanLanding/components/ClanLandingReserves/images/new-reserve-sm.png": 2932,
	"./containers/ClanLanding/components/ClanQuestsTutorial/images/devider.png": 2933,
	"./containers/ClanLanding/components/ClanQuestsTutorial/images/slide-2-image.png": 2934,
	"./containers/ClanLanding/components/ClanQuestsTutorial/images/slide-3-image.png": 2935,
	"./containers/ClanLanding/components/ClanQuestsTutorial/images/slide-4-image.png": 2936,
	"./containers/ClanLanding/components/ClanSupplyFooter/images/footer_bg_get_rewards.png": 2937,
	"./containers/ClanLanding/components/ClanSupplyFooter/images/footer_bg_get_rewards_large.png": 2938,
	"./containers/ClanLanding/components/DisabledCard/images/icon_timer.png": 2939,
	"./containers/ClanLanding/components/OrangeTimer/images/countdown-less-than-hour.png": 2940,
	"./containers/ClanLanding/components/OrangeTimer/images/expiration-time-icon.png": 2941,
	"./containers/ClanLanding/components/OrangeTimer/images/timer-glow-big.png": 2942,
	"./containers/ClanLanding/components/OrangeTimer/images/timer-glow-small.png": 2943,
	"./containers/ClanLanding/components/RewardItem/images/industrial_resource_small.png": 2944,
	"./containers/ClanLanding/components/RewardItem/images/stubs/stub-default.png": 2945,
	"./containers/ClanLanding/components/TaskItemTooltip/images/icon-attention.png": 2946,
	"./containers/ClanLanding/components/TaskItemTooltip/images/icon-info.png": 2947,
	"./containers/ClanLanding/components/TaskItemTooltip/images/tooltip-background.png": 2948,
	"./containers/ClanLanding/components/TextArea/images/disabled_state_pattern.png": 2949,
	"./containers/ClanLanding/images/account-points-icon.png": 2950,
	"./containers/ClanLanding/images/all-rewards-recieved.png": 2951,
	"./containers/ClanLanding/images/battle.png": 2952,
	"./containers/ClanLanding/images/battle_date_bg.png": 2953,
	"./containers/ClanLanding/images/card_corner_xN.png": 2954,
	"./containers/ClanLanding/images/clan-points-icon.png": 2955,
	"./containers/ClanLanding/images/clan-quests-not-available.png": 2956,
	"./containers/ClanLanding/images/clan-quests-reload.png": 2957,
	"./containers/ClanLanding/images/clan_quests_background.jpg": 2958,
	"./containers/ClanLanding/images/clan_quests_background_big.jpg": 2959,
	"./containers/ClanLanding/images/clan_quests_top.png": 2960,
	"./containers/ClanLanding/images/clan_quests_top_big.png": 2961,
	"./containers/ClanLanding/images/clan_supply_progression_background.png": 2962,
	"./containers/ClanLanding/images/clan_supply_progression_background_large.png": 2963,
	"./containers/ClanLanding/images/clan_supply_quests_background.png": 2964,
	"./containers/ClanLanding/images/clan_supply_quests_background_large.png": 2965,
	"./containers/ClanLanding/images/clock.png": 2966,
	"./containers/ClanLanding/images/disable_pattern.png": 2967,
	"./containers/ClanLanding/images/divider.png": 2968,
	"./containers/ClanLanding/images/divider_big.png": 2969,
	"./containers/ClanLanding/images/divider_dotty.png": 2970,
	"./containers/ClanLanding/images/exclamation.png": 2971,
	"./containers/ClanLanding/images/expiration-time-icon.png": 2972,
	"./containers/ClanLanding/images/external_url_icon.png": 2973,
	"./containers/ClanLanding/images/global_map_bg.jpg": 2974,
	"./containers/ClanLanding/images/global_map_bg_big.jpg": 2975,
	"./containers/ClanLanding/images/global_map_bg_big_cn.jpg": 2976,
	"./containers/ClanLanding/images/global_map_bg_cn.jpg": 2977,
	"./containers/ClanLanding/images/global_map_bg_with_news.jpg": 2978,
	"./containers/ClanLanding/images/global_map_bg_with_news_big.jpg": 2979,
	"./containers/ClanLanding/images/global_map_bg_with_news_big_cn.jpg": 2980,
	"./containers/ClanLanding/images/global_map_bg_with_news_cn.jpg": 2981,
	"./containers/ClanLanding/images/global_map_bg_with_news_with_quests.jpg": 2982,
	"./containers/ClanLanding/images/global_map_bg_with_news_with_quests_big.jpg": 2983,
	"./containers/ClanLanding/images/global_map_bg_with_news_with_quests_big_cn.jpg": 2984,
	"./containers/ClanLanding/images/global_map_bg_with_news_with_quests_cn.jpg": 2985,
	"./containers/ClanLanding/images/global_map_bg_with_quests.jpg": 2986,
	"./containers/ClanLanding/images/global_map_bg_with_quests_big.jpg": 2987,
	"./containers/ClanLanding/images/global_map_bg_with_quests_big_cn.jpg": 2988,
	"./containers/ClanLanding/images/global_map_bg_with_quests_cn.jpg": 2989,
	"./containers/ClanLanding/images/gold-buyin-button-hover.png": 2990,
	"./containers/ClanLanding/images/gold-buyin-button.png": 2991,
	"./containers/ClanLanding/images/icon-progress-done.png": 2992,
	"./containers/ClanLanding/images/icon-progress-locked.png": 2993,
	"./containers/ClanLanding/images/icon-progress-progress.png": 2994,
	"./containers/ClanLanding/images/icon_button_clan.png": 2995,
	"./containers/ClanLanding/images/icon_button_search.png": 2996,
	"./containers/ClanLanding/images/icon_crystal.RU.png": 2997,
	"./containers/ClanLanding/images/icon_crystal.png": 2998,
	"./containers/ClanLanding/images/icon_crystal_small.RU.png": 2999,
	"./containers/ClanLanding/images/icon_crystal_small.png": 3000,
	"./containers/ClanLanding/images/icon_gold.png": 3001,
	"./containers/ClanLanding/images/icon_gold_small.png": 3002,
	"./containers/ClanLanding/images/icon_industrial_resource.png": 3003,
	"./containers/ClanLanding/images/icon_info.png": 3004,
	"./containers/ClanLanding/images/icon_online.png": 3005,
	"./containers/ClanLanding/images/icon_online_small.png": 3006,
	"./containers/ClanLanding/images/icon_plus.png": 3007,
	"./containers/ClanLanding/images/icon_progress_done_new.png": 3008,
	"./containers/ClanLanding/images/icon_tourcoin.png": 3009,
	"./containers/ClanLanding/images/lock.png": 3010,
	"./containers/ClanLanding/images/main_card_background.jpg": 3011,
	"./containers/ClanLanding/images/main_card_background_big.jpg": 3012,
	"./containers/ClanLanding/images/main_card_background_big_cn.jpg": 3013,
	"./containers/ClanLanding/images/main_card_background_cn.jpg": 3014,
	"./containers/ClanLanding/images/main_card_background_with_quests.jpg": 3015,
	"./containers/ClanLanding/images/main_card_background_with_quests_big.jpg": 3016,
	"./containers/ClanLanding/images/main_card_background_with_quests_big_cn.jpg": 3017,
	"./containers/ClanLanding/images/main_card_background_with_quests_cn.jpg": 3018,
	"./containers/ClanLanding/images/maneuvers_bg.png": 3019,
	"./containers/ClanLanding/images/maneuvers_bg_big.png": 3020,
	"./containers/ClanLanding/images/maneuvers_bg_with_news.png": 3021,
	"./containers/ClanLanding/images/maneuvers_bg_with_news_big.png": 3022,
	"./containers/ClanLanding/images/maneuvers_bg_with_news_with_quests.png": 3023,
	"./containers/ClanLanding/images/maneuvers_bg_with_news_with_quests_big.png": 3024,
	"./containers/ClanLanding/images/maneuvers_bg_with_quests.png": 3025,
	"./containers/ClanLanding/images/maneuvers_bg_with_quests_big.png": 3026,
	"./containers/ClanLanding/images/new_marker.png": 3027,
	"./containers/ClanLanding/images/page_marker_active.png": 3028,
	"./containers/ClanLanding/images/quests_reload.png": 3029,
	"./containers/ClanLanding/images/sparks.png": 3030,
	"./containers/ClanLanding/images/stopped.png": 3031,
	"./containers/ClanLanding/images/stronghold_bg.jpg": 3032,
	"./containers/ClanLanding/images/stronghold_bg_big.jpg": 3033,
	"./containers/ClanLanding/images/stronghold_bg_with_news.jpg": 3034,
	"./containers/ClanLanding/images/stronghold_bg_with_news_big.jpg": 3035,
	"./containers/ClanLanding/images/stronghold_bg_with_news_with_quests.jpg": 3036,
	"./containers/ClanLanding/images/stronghold_bg_with_news_with_quests_big.jpg": 3037,
	"./containers/ClanLanding/images/stronghold_bg_with_quests.jpg": 3038,
	"./containers/ClanLanding/images/stronghold_bg_with_quests_big.jpg": 3039,
	"./containers/ClanLanding/images/success-icon.png": 3040,
	"./containers/ClanLanding/images/tank-available-CN.png": 3041,
	"./containers/ClanLanding/images/tank-available.png": 969,
	"./containers/ClanLanding/images/tank-not-available-CN.png": 3042,
	"./containers/ClanLanding/images/tank-not-available.png": 970,
	"./containers/ClanLanding/images/tooltip-bg.png": 3043,
	"./containers/ClanLanding/images/tooltip_bg.png": 3044,
	"./containers/ClanLanding/images/treasury_separator.png": 3045,
	"./containers/ClanLeaving/components/ClanLeavingLayout/images/cl-background.jpg": 3046,
	"./containers/ClanManagement/components/ClanManagement/images/cm-background-cn.jpg": 3047,
	"./containers/ClanManagement/components/ClanManagement/images/cm-background.jpg": 3048,
	"./containers/ClanManagement/components/ClanManagement/images/cm-earned-resource-tooltip-bg.jpg": 3049,
	"./containers/ClanManagement/components/ClanManagement/images/cm-earned-resource-tooltip-divider.jpg": 3050,
	"./containers/ClanManagement/components/ClanManagement/images/cm-earned-resource-tooltip-dot.jpg": 3051,
	"./containers/ClanManagement/components/ClanManagement/images/cm-earned-resource-tooltip-icons.png": 3052,
	"./containers/ClanManagement/components/Dialogs/images/dialog-divider-arrow.png": 3053,
	"./containers/ClanManagement/components/Dialogs/images/dialog-divider.png": 3054,
	"./containers/ClanManagement/components/MembersControlBlock/images/allocate_treasury.png": 3055,
	"./containers/ClanManagement/components/MembersControlBlock/images/change_role.png": 3056,
	"./containers/ClanManagement/components/MembersControlBlock/images/remove_members.png": 3057,
	"./containers/ClanPanel/components/BattlesButton/images/active.png": 3058,
	"./containers/ClanPanel/components/BattlesButton/images/glow-bottom.png": 3059,
	"./containers/ClanPanel/components/BattlesButton/images/glow-top.png": 3060,
	"./containers/ClanPanel/components/BattlesButton/images/hover.png": 3061,
	"./containers/ClanPanel/components/BattlesButton/images/light.png": 3062,
	"./containers/ClanPanel/components/BattlesButton/images/normal.png": 3063,
	"./containers/ClanPanel/components/BattlesButton/images/primary-active.png": 3064,
	"./containers/ClanPanel/components/BattlesButton/images/primary-hover.png": 3065,
	"./containers/ClanPanel/components/BattlesButton/images/primary-normal.png": 3066,
	"./containers/ClanPanel/components/BattlesButton/images/schedule.png": 3067,
	"./containers/ClanPanel/components/Item/images/active.png": 3068,
	"./containers/ClanPanel/components/Item/images/hover.png": 3069,
	"./containers/ClanPanel/components/Item/images/icon-challenges.png": 3070,
	"./containers/ClanPanel/components/Item/images/icon-crystal.RU.png": 3071,
	"./containers/ClanPanel/components/Item/images/icon-crystal.png": 3072,
	"./containers/ClanPanel/components/Item/images/icon-gold.png": 3073,
	"./containers/ClanPanel/components/Item/images/icon-industrial.png": 3074,
	"./containers/ClanPanel/components/Item/images/icon-journal.png": 3075,
	"./containers/ClanPanel/components/Item/images/selected-small.png": 3076,
	"./containers/ClanPanel/components/Item/images/selected.png": 3077,
	"./containers/ClanPanel/components/Item/images/tokens.png": 3078,
	"./containers/ClanPanel/images/bg-active.png": 3079,
	"./containers/ClanPanel/images/bg-pattern-active.png": 3080,
	"./containers/ClanPanel/images/bg-pattern-sparks.png": 3081,
	"./containers/ClanPanel/images/bg-pattern.png": 3082,
	"./containers/ClanPanel/images/bg.png": 3083,
	"./containers/CommandCenterCard/images/ribbon-mask.png": 3084,
	"./containers/CommandCenterCard/images/ribbon.png": 3085,
	"./containers/Construct/images/construct-bg-100.jpg": 3086,
	"./containers/Construct/images/construct-bg-50.jpg": 3087,
	"./containers/Construct/images/construct-bg-75.jpg": 3088,
	"./containers/EloLeaderboard/components/LeaderboardTable/images/battles_28.png": 3089,
	"./containers/EloLeaderboard/components/LeaderboardTable/images/bottom-panel.png": 3090,
	"./containers/EloLeaderboard/components/LeaderboardTable/images/divider-pattern.png": 3091,
	"./containers/EloLeaderboard/components/LeaderboardTable/images/elo-icon_10.png": 3092,
	"./containers/EloLeaderboard/components/LeaderboardTable/images/elo-icon_6.png": 3093,
	"./containers/EloLeaderboard/components/LeaderboardTable/images/elo-icon_8.png": 3094,
	"./containers/EloLeaderboard/components/LeaderboardTable/images/leaderboard-position1.png": 3095,
	"./containers/EloLeaderboard/components/LeaderboardTable/images/leaderboard-position2.png": 3096,
	"./containers/EloLeaderboard/components/LeaderboardTable/images/leaderboard-position3.png": 3097,
	"./containers/EloLeaderboard/components/LeaderboardTable/images/winrate_28.png": 3098,
	"./containers/EloLeaderboard/images/leaderboard-leaders-button.png": 3099,
	"./containers/EloLeaderboard/images/leaderboard_bg.jpg": 3100,
	"./containers/EloLeaderboard/images/tab-bg.png": 3101,
	"./containers/EloLeaderboard/images/tab-bg_disabled.png": 3102,
	"./containers/EloLeaderboard/images/tab-bg_hover.png": 3103,
	"./containers/EloLeaderboard/images/tab-border_active.png": 3104,
	"./containers/EloLeaderboard/images/tab-border_disabled.png": 3105,
	"./containers/Journal/components/ReservesHistory/images/reserve_active.png": 3106,
	"./containers/Journal/components/ReservesHistory/images/timer.png": 3107,
	"./containers/Journal/images/background-cn.jpg": 3108,
	"./containers/Journal/images/background.jpg": 3109,
	"./containers/Journal/images/update-icon.png": 3110,
	"./containers/Landing/components/LandingBonus/images/landing-bonus-ico-gold-large.RU.png": 3111,
	"./containers/Landing/components/LandingBonus/images/landing-bonus-ico-gold-large.png": 3112,
	"./containers/Landing/components/LandingBonus/images/landing-bonus-ico-gold-small.RU.png": 3113,
	"./containers/Landing/components/LandingBonus/images/landing-bonus-ico-gold-small.png": 3114,
	"./containers/Landing/components/LandingBonus/images/landing-bonus-ico-reserve-large.png": 3115,
	"./containers/Landing/components/LandingBonus/images/landing-bonus-ico-reserve-small.png": 3116,
	"./containers/Landing/components/LandingBonus/images/landing-bonus-ico-vehicle-large.png": 3117,
	"./containers/Landing/components/LandingBonus/images/landing-bonus-ico-vehicle-small.png": 3118,
	"./containers/Landing/components/LandingClans/components/Card/components/Back/images/banner.png": 1358,
	"./containers/Landing/components/LandingClans/components/Card/components/Back/images/check.png": 3119,
	"./containers/Landing/components/LandingClans/components/Card/components/Back/images/shadow.png": 3120,
	"./containers/Landing/components/LandingClans/components/Card/components/EnterClan/images/check.png": 3121,
	"./containers/Landing/components/LandingClans/components/Card/components/EnterClan/images/spinner.png": 3122,
	"./containers/Landing/components/LandingClans/components/Card/components/Front/images/corner.png": 3123,
	"./containers/Landing/components/LandingClans/components/Card/components/Stat/images/battles.png": 3124,
	"./containers/Landing/components/LandingClans/components/Card/components/Stat/images/level.png": 3125,
	"./containers/Landing/components/LandingClans/components/Card/components/Stat/images/players.png": 3126,
	"./containers/Landing/components/LandingClans/components/Card/components/Stat/images/victories.png": 3127,
	"./containers/Landing/components/LandingClans/components/Card/images/sample-emblem.png": 3128,
	"./containers/Landing/components/LandingClans/components/Filters/components/Language/images/check.png": 3129,
	"./containers/Landing/components/LandingClans/components/FiltersButton/images/filters.png": 3130,
	"./containers/Landing/components/LandingClans/components/Flag/images/landing-clans-languages.png": 3131,
	"./containers/Landing/components/LandingClans/components/Paginator/images/paginator-controls.png": 3132,
	"./containers/Landing/components/LandingClans/components/SearchControl/images/clear-icon.png": 3133,
	"./containers/Landing/components/LandingClans/components/SearchControl/images/pattern.png": 3134,
	"./containers/Landing/components/LandingClans/components/SearchControl/images/search-icon.png": 3135,
	"./containers/Landing/components/LandingClans/components/TextPlate/images/pattern.png": 3136,
	"./containers/Landing/components/LandingGlobalMap/images/landing-global-map-small.png": 3137,
	"./containers/Landing/components/LandingGlobalMap/images/landing-global-map.png": 3138,
	"./containers/Landing/components/LandingPromo/images/glowing.png": 3139,
	"./containers/Landing/components/LandingResult/images/landing-result-award.RU.png": 3140,
	"./containers/Landing/components/LandingResult/images/landing-result-award.png": 3141,
	"./containers/Landing/components/LandingResult/images/landing-result-award_small.RU.png": 3142,
	"./containers/Landing/components/LandingResult/images/landing-result-award_small.png": 3143,
	"./containers/Landing/components/LandingResult/images/landing-result-bg-image.jpg": 3144,
	"./containers/Landing/components/LandingResult/images/landing-result-light.png": 3145,
	"./containers/Landing/components/LandingResult/images/landing-result-ribbon.png": 3146,
	"./containers/Landing/components/LandingStronghold/images/landing-stronghold-small.png": 3147,
	"./containers/Landing/components/LandingStronghold/images/landing-stronghold.png": 3148,
	"./containers/Landing/components/LandingToursOfDuty/images/landing-tours-of-duty-small.png": 3149,
	"./containers/Landing/components/LandingToursOfDuty/images/landing-tours-of-duty.png": 3150,
	"./containers/Landing/components/NextSliderButton/images/next-nav-disabled.png": 3151,
	"./containers/Landing/components/NextSliderButton/images/next-nav-small-disabled.png": 3152,
	"./containers/Landing/components/NextSliderButton/images/next-nav-small.png": 3153,
	"./containers/Landing/components/NextSliderButton/images/next-nav.png": 3154,
	"./containers/Landing/components/PrevSliderButton/images/prev-nav-disabled.png": 3155,
	"./containers/Landing/components/PrevSliderButton/images/prev-nav-small-disabled.png": 3156,
	"./containers/Landing/components/PrevSliderButton/images/prev-nav-small.png": 3157,
	"./containers/Landing/components/PrevSliderButton/images/prev-nav.png": 3158,
	"./containers/Landing/images/landing-battles-bg-cn.jpg": 3159,
	"./containers/Landing/images/landing-battles-bg.jpg": 3160,
	"./containers/Landing/images/landing-bonus-bg.jpg": 3161,
	"./containers/Landing/images/landing-clans-bg.jpg": 3162,
	"./containers/Landing/images/landing-footer-img.png": 3163,
	"./containers/Landing/images/landing-footer-top.png": 3164,
	"./containers/Landing/images/landing-global-map.jpg": 3165,
	"./containers/Landing/images/landing-promo-bg.jpg": 3166,
	"./containers/Landing/images/landing-promo-ribbon.png": 3167,
	"./containers/Landing/images/landing-slide-bg-pattern.png": 3168,
	"./containers/Landing/images/landing-stronghold.jpg": 3169,
	"./containers/Landing/images/landing-tours-of-duty.jpg": 3170,
	"./containers/Landing/images/page_marker_active.png": 3171,
	"./containers/MainMenu/images/mainmenu-item-active-32.png": 3172,
	"./containers/MainMenu/images/mainmenu-item-active-arrow-32.png": 3173,
	"./containers/MainMenu/images/mainmenu-item-active-arrow.png": 3174,
	"./containers/MainMenu/images/mainmenu-item-active-highlight-32.png": 3175,
	"./containers/MainMenu/images/mainmenu-item-active-highlight.png": 3176,
	"./containers/MainMenu/images/mainmenu-item-active-shine-32.png": 3177,
	"./containers/MainMenu/images/mainmenu-item-active-shine.png": 3178,
	"./containers/MainMenu/images/mainmenu-item-active.png": 3179,
	"./containers/MainMenu/images/mainmenu-item-battle-schedule-32-active.png": 3180,
	"./containers/MainMenu/images/mainmenu-item-battle-schedule-32.png": 3181,
	"./containers/MainMenu/images/mainmenu-item-battle-schedule-64-active.png": 3182,
	"./containers/MainMenu/images/mainmenu-item-battle-schedule-64.png": 3183,
	"./containers/MainMenu/images/mainmenu-item-bonuses-32-active.png": 3184,
	"./containers/MainMenu/images/mainmenu-item-bonuses-32.png": 3185,
	"./containers/MainMenu/images/mainmenu-item-bonuses-64-active.png": 3186,
	"./containers/MainMenu/images/mainmenu-item-bonuses-64.png": 3187,
	"./containers/MainMenu/images/mainmenu-item-boost-32-active.png": 3188,
	"./containers/MainMenu/images/mainmenu-item-boost-32.png": 3189,
	"./containers/MainMenu/images/mainmenu-item-boost-64-active.png": 3190,
	"./containers/MainMenu/images/mainmenu-item-boost-64.png": 3191,
	"./containers/MainMenu/images/mainmenu-item-craft-32-active.png": 3192,
	"./containers/MainMenu/images/mainmenu-item-craft-32.png": 3193,
	"./containers/MainMenu/images/mainmenu-item-craft-64-active.png": 3194,
	"./containers/MainMenu/images/mainmenu-item-craft-64.png": 3195,
	"./containers/MainMenu/images/mainmenu-item-leaderboards-32-active.png": 3196,
	"./containers/MainMenu/images/mainmenu-item-leaderboards-32.png": 3197,
	"./containers/MainMenu/images/mainmenu-item-leaderboards-64-active.png": 3198,
	"./containers/MainMenu/images/mainmenu-item-leaderboards-64.png": 3199,
	"./containers/MainMenu/images/mainmenu-item-rewards-32-active.png": 3200,
	"./containers/MainMenu/images/mainmenu-item-rewards-32.png": 3201,
	"./containers/MainMenu/images/mainmenu-item-rewards-64-active.png": 3202,
	"./containers/MainMenu/images/mainmenu-item-rewards-64.png": 3203,
	"./containers/MigrationScreen/images/migration.png": 3204,
	"./containers/MigrationScreen/images/slide_1.png": 3205,
	"./containers/MigrationScreen/images/slide_2.png": 3206,
	"./containers/MigrationScreen/images/slide_3.png": 3207,
	"./containers/PostbattleScreen/components/BattleList/images/background-defeat.png": 3208,
	"./containers/PostbattleScreen/components/BattleList/images/divider-column.png": 3209,
	"./containers/PostbattleScreen/components/BattleList/images/divider-header.png": 3210,
	"./containers/PostbattleScreen/components/BattleList/images/divider-row.png": 3211,
	"./containers/PostbattleScreen/components/BattleList/images/divider-shadow.png": 3212,
	"./containers/PostbattleScreen/components/Details/images/dots.png": 3213,
	"./containers/PostbattleScreen/components/FortBattleSeries/images/arrow-attack-long-highlight.png": 3214,
	"./containers/PostbattleScreen/components/FortBattleSeries/images/arrow-attack-long.png": 3215,
	"./containers/PostbattleScreen/components/FortBattleSeries/images/arrow-attack-short.png": 3216,
	"./containers/PostbattleScreen/components/FortBattleSeries/images/arrow-defense-long-highlight.png": 3217,
	"./containers/PostbattleScreen/components/FortBattleSeries/images/arrow-defense-long.png": 3218,
	"./containers/PostbattleScreen/components/FortBattleSeries/images/arrow-defense-short.png": 3219,
	"./containers/PostbattleScreen/components/FortBattleSeries/images/flag-green-current.png": 3220,
	"./containers/PostbattleScreen/components/FortBattleSeries/images/flag-green.png": 3221,
	"./containers/PostbattleScreen/components/FortBattleSeries/images/flag-red-current.png": 3222,
	"./containers/PostbattleScreen/components/FortBattleSeries/images/flag-red.png": 3223,
	"./containers/PostbattleScreen/components/FortBattleSeries/images/line-green-long.png": 3224,
	"./containers/PostbattleScreen/components/FortBattleSeries/images/line-green-short.png": 3225,
	"./containers/PostbattleScreen/components/FortBattleSeries/images/line-red-long.png": 3226,
	"./containers/PostbattleScreen/components/FortBattleSeries/images/line-red-short.png": 3227,
	"./containers/PostbattleScreen/components/FortBattleSeries/images/stronghold-green-current.png": 3228,
	"./containers/PostbattleScreen/components/FortBattleSeries/images/stronghold-green.png": 3229,
	"./containers/PostbattleScreen/components/FortBattleSeries/images/stronghold-red-current.png": 3230,
	"./containers/PostbattleScreen/components/FortBattleSeries/images/stronghold-red.png": 3231,
	"./containers/PostbattleScreen/components/Header/images/defeat-background.jpg": 3232,
	"./containers/PostbattleScreen/components/Header/images/defeat-ribbon.png": 3233,
	"./containers/PostbattleScreen/components/Header/images/draw-background.jpg": 3234,
	"./containers/PostbattleScreen/components/Header/images/draw-ribbon.png": 3235,
	"./containers/PostbattleScreen/components/Header/images/victory-background.jpg": 3236,
	"./containers/PostbattleScreen/components/Header/images/victory-ribbon.png": 3237,
	"./containers/PostbattleScreen/components/Subtitle/images/background.png": 3238,
	"./containers/PostbattleScreen/components/Tabs/images/postbattle-tabs-background.png": 3239,
	"./containers/PostbattleScreen/components/Tabs/images/tab-hover.png": 3240,
	"./containers/PostbattleScreen/components/Tabs/images/tab-left.png": 3241,
	"./containers/PostbattleScreen/components/Tabs/images/tab-right.png": 3242,
	"./containers/PostbattleScreen/components/Tabs/images/tab-selected-left.png": 3243,
	"./containers/PostbattleScreen/components/Tabs/images/tab-selected-right.png": 3244,
	"./containers/PostbattleScreen/images/background.png": 3245,
	"./containers/Schedule/images/background.jpg": 3246,
	"./containers/Schedule/images/calendar_button-hover.png": 3247,
	"./containers/Schedule/images/calendar_button_background.png": 3248,
	"./containers/Schedule/images/calendar_item_selected_shadow.png": 3249,
	"./containers/Schedule/images/challenges_icon.png": 3250,
	"./containers/Schedule/images/halo_bottom.png": 3251,
	"./containers/Schedule/images/halo_top.png": 3252,
	"./containers/Schedule/images/schedule_table-shadow.png": 3253,
	"./containers/Schedule/images/schedule_table_bar-dark_gray_translucent.png": 3254,
	"./containers/Schedule/images/schedule_table_bar-dark_green.png": 3255,
	"./containers/Schedule/images/schedule_table_bar-light_green.png": 3256,
	"./containers/Schedule/images/schedule_table_bar-orange.png": 3257,
	"./containers/Schedule/images/time_line.png": 3258,
	"./containers/ShopView/containers/ShopCongratulationScreen/images/highlight.png": 3259,
	"./containers/ShopView/containers/ShopErrorScreen/images/error-icon.png": 3260,
	"./containers/ShopView/containers/ShopErrorScreen/images/icon-highlight.png": 3261,
	"./containers/ShopView/images/big/package_l.png": 992,
	"./containers/ShopView/images/big/package_m.png": 990,
	"./containers/ShopView/images/big/package_s.png": 988,
	"./containers/ShopView/images/big/package_xl.png": 994,
	"./containers/ShopView/images/small/package_l.png": 993,
	"./containers/ShopView/images/small/package_m.png": 991,
	"./containers/ShopView/images/small/package_s.png": 989,
	"./containers/ShopView/images/small/package_xl.png": 995,
	"./containers/Stronghold/components/ClanInfoPanel/images/bg.jpg": 3262,
	"./containers/Stronghold/components/ClanInfoPanel/images/divider.png": 3263,
	"./containers/Stronghold/components/ClanInfoPanel/images/elo-icon-10.png": 3264,
	"./containers/Stronghold/components/ClanInfoPanel/images/elo-icon-6.png": 3265,
	"./containers/Stronghold/components/ClanInfoPanel/images/elo-icon-8.png": 3266,
	"./containers/Stronghold/components/ClanInfoPanel/images/pattern-left.jpg": 3267,
	"./containers/Stronghold/components/ClanInfoPanel/images/pattern-right.jpg": 3268,
	"./containers/Stronghold/components/ClanInfoPanel/images/shadow.png": 3269,
	"./containers/Stronghold/components/CommandCenter/images/command-center-lvl1-100.png": 3270,
	"./containers/Stronghold/components/CommandCenter/images/command-center-lvl1-50.png": 3271,
	"./containers/Stronghold/components/CommandCenter/images/command-center-lvl1-75.png": 3272,
	"./containers/Stronghold/components/CommandCenter/images/command-center-lvl2-100.png": 3273,
	"./containers/Stronghold/components/CommandCenter/images/command-center-lvl2-50.png": 3274,
	"./containers/Stronghold/components/CommandCenter/images/command-center-lvl2-75.png": 3275,
	"./containers/Stronghold/components/CommandCenter/images/command-center-lvl3-100.png": 3276,
	"./containers/Stronghold/components/CommandCenter/images/command-center-lvl3-50.png": 3277,
	"./containers/Stronghold/components/CommandCenter/images/command-center-lvl3-75.png": 3278,
	"./containers/Stronghold/components/Direction/components/Building/images/artillery-battalion-lvl1-100.png": 3279,
	"./containers/Stronghold/components/Direction/components/Building/images/artillery-battalion-lvl1-50.png": 3280,
	"./containers/Stronghold/components/Direction/components/Building/images/artillery-battalion-lvl1-75.png": 3281,
	"./containers/Stronghold/components/Direction/components/Building/images/artillery-battalion-lvl2-100.png": 3282,
	"./containers/Stronghold/components/Direction/components/Building/images/artillery-battalion-lvl2-50.png": 3283,
	"./containers/Stronghold/components/Direction/components/Building/images/artillery-battalion-lvl2-75.png": 3284,
	"./containers/Stronghold/components/Direction/components/Building/images/artillery-battalion-lvl3-100.png": 3285,
	"./containers/Stronghold/components/Direction/components/Building/images/artillery-battalion-lvl3-50.png": 3286,
	"./containers/Stronghold/components/Direction/components/Building/images/artillery-battalion-lvl3-75.png": 3287,
	"./containers/Stronghold/components/Direction/components/Building/images/attack-bomber-squadrons-lvl1-100.png": 3288,
	"./containers/Stronghold/components/Direction/components/Building/images/attack-bomber-squadrons-lvl1-50.png": 3289,
	"./containers/Stronghold/components/Direction/components/Building/images/attack-bomber-squadrons-lvl1-75.png": 3290,
	"./containers/Stronghold/components/Direction/components/Building/images/attack-bomber-squadrons-lvl2-100.png": 3291,
	"./containers/Stronghold/components/Direction/components/Building/images/attack-bomber-squadrons-lvl2-50.png": 3292,
	"./containers/Stronghold/components/Direction/components/Building/images/attack-bomber-squadrons-lvl2-75.png": 3293,
	"./containers/Stronghold/components/Direction/components/Building/images/attack-bomber-squadrons-lvl3-100.png": 3294,
	"./containers/Stronghold/components/Direction/components/Building/images/attack-bomber-squadrons-lvl3-50.png": 3295,
	"./containers/Stronghold/components/Direction/components/Building/images/attack-bomber-squadrons-lvl3-75.png": 3296,
	"./containers/Stronghold/components/Direction/components/Building/images/financial-unit-lvl1-100.png": 3297,
	"./containers/Stronghold/components/Direction/components/Building/images/financial-unit-lvl1-50.png": 3298,
	"./containers/Stronghold/components/Direction/components/Building/images/financial-unit-lvl1-75.png": 3299,
	"./containers/Stronghold/components/Direction/components/Building/images/financial-unit-lvl2-100.png": 3300,
	"./containers/Stronghold/components/Direction/components/Building/images/financial-unit-lvl2-50.png": 3301,
	"./containers/Stronghold/components/Direction/components/Building/images/financial-unit-lvl2-75.png": 3302,
	"./containers/Stronghold/components/Direction/components/Building/images/financial-unit-lvl3-100.png": 3303,
	"./containers/Stronghold/components/Direction/components/Building/images/financial-unit-lvl3-50.png": 3304,
	"./containers/Stronghold/components/Direction/components/Building/images/financial-unit-lvl3-75.png": 3305,
	"./containers/Stronghold/components/Direction/components/Building/images/gears-shadow.png": 3306,
	"./containers/Stronghold/components/Direction/components/Building/images/gears-static.png": 3307,
	"./containers/Stronghold/components/Direction/components/Building/images/home-front-service-lvl1-100.png": 3308,
	"./containers/Stronghold/components/Direction/components/Building/images/home-front-service-lvl1-50.png": 3309,
	"./containers/Stronghold/components/Direction/components/Building/images/home-front-service-lvl1-75.png": 3310,
	"./containers/Stronghold/components/Direction/components/Building/images/home-front-service-lvl2-100.png": 3311,
	"./containers/Stronghold/components/Direction/components/Building/images/home-front-service-lvl2-50.png": 3312,
	"./containers/Stronghold/components/Direction/components/Building/images/home-front-service-lvl2-75.png": 3313,
	"./containers/Stronghold/components/Direction/components/Building/images/home-front-service-lvl3-100.png": 3314,
	"./containers/Stronghold/components/Direction/components/Building/images/home-front-service-lvl3-50.png": 3315,
	"./containers/Stronghold/components/Direction/components/Building/images/home-front-service-lvl3-75.png": 3316,
	"./containers/Stronghold/components/Direction/components/Building/images/military-school-lvl1-100.png": 3317,
	"./containers/Stronghold/components/Direction/components/Building/images/military-school-lvl1-50.png": 3318,
	"./containers/Stronghold/components/Direction/components/Building/images/military-school-lvl1-75.png": 3319,
	"./containers/Stronghold/components/Direction/components/Building/images/military-school-lvl2-100.png": 3320,
	"./containers/Stronghold/components/Direction/components/Building/images/military-school-lvl2-50.png": 3321,
	"./containers/Stronghold/components/Direction/components/Building/images/military-school-lvl2-75.png": 3322,
	"./containers/Stronghold/components/Direction/components/Building/images/military-school-lvl3-100.png": 3323,
	"./containers/Stronghold/components/Direction/components/Building/images/military-school-lvl3-50.png": 3324,
	"./containers/Stronghold/components/Direction/components/Building/images/military-school-lvl3-75.png": 3325,
	"./containers/Stronghold/components/Direction/components/Building/images/smoke.png": 3326,
	"./containers/Stronghold/components/Direction/components/Building/images/tankodrome-lvl1-100.png": 3327,
	"./containers/Stronghold/components/Direction/components/Building/images/tankodrome-lvl1-50.png": 3328,
	"./containers/Stronghold/components/Direction/components/Building/images/tankodrome-lvl1-75.png": 3329,
	"./containers/Stronghold/components/Direction/components/Building/images/tankodrome-lvl2-100.png": 3330,
	"./containers/Stronghold/components/Direction/components/Building/images/tankodrome-lvl2-50.png": 3331,
	"./containers/Stronghold/components/Direction/components/Building/images/tankodrome-lvl2-75.png": 3332,
	"./containers/Stronghold/components/Direction/components/Building/images/tankodrome-lvl3-100.png": 3333,
	"./containers/Stronghold/components/Direction/components/Building/images/tankodrome-lvl3-50.png": 3334,
	"./containers/Stronghold/components/Direction/components/Building/images/tankodrome-lvl3-75.png": 3335,
	"./containers/Stronghold/components/Direction/components/Building/images/training-unit-lvl1-100.png": 3336,
	"./containers/Stronghold/components/Direction/components/Building/images/training-unit-lvl1-50.png": 3337,
	"./containers/Stronghold/components/Direction/components/Building/images/training-unit-lvl1-75.png": 3338,
	"./containers/Stronghold/components/Direction/components/Building/images/training-unit-lvl2-100.png": 3339,
	"./containers/Stronghold/components/Direction/components/Building/images/training-unit-lvl2-50.png": 3340,
	"./containers/Stronghold/components/Direction/components/Building/images/training-unit-lvl2-75.png": 3341,
	"./containers/Stronghold/components/Direction/components/Building/images/training-unit-lvl3-100.png": 3342,
	"./containers/Stronghold/components/Direction/components/Building/images/training-unit-lvl3-50.png": 3343,
	"./containers/Stronghold/components/Direction/components/Building/images/training-unit-lvl3-75.png": 3344,
	"./containers/Stronghold/components/Direction/components/Building/images/transportation-unit-lvl1-100.png": 3345,
	"./containers/Stronghold/components/Direction/components/Building/images/transportation-unit-lvl1-50.png": 3346,
	"./containers/Stronghold/components/Direction/components/Building/images/transportation-unit-lvl1-75.png": 3347,
	"./containers/Stronghold/components/Direction/components/Building/images/transportation-unit-lvl2-100.png": 3348,
	"./containers/Stronghold/components/Direction/components/Building/images/transportation-unit-lvl2-50.png": 3349,
	"./containers/Stronghold/components/Direction/components/Building/images/transportation-unit-lvl2-75.png": 3350,
	"./containers/Stronghold/components/Direction/components/Building/images/transportation-unit-lvl3-100.png": 3351,
	"./containers/Stronghold/components/Direction/components/Building/images/transportation-unit-lvl3-50.png": 3352,
	"./containers/Stronghold/components/Direction/components/Building/images/transportation-unit-lvl3-75.png": 3353,
	"./containers/Stronghold/components/Direction/components/Building/images/trophy-brigade-lvl1-100.png": 3354,
	"./containers/Stronghold/components/Direction/components/Building/images/trophy-brigade-lvl1-50.png": 3355,
	"./containers/Stronghold/components/Direction/components/Building/images/trophy-brigade-lvl1-75.png": 3356,
	"./containers/Stronghold/components/Direction/components/Building/images/trophy-brigade-lvl2-100.png": 3357,
	"./containers/Stronghold/components/Direction/components/Building/images/trophy-brigade-lvl2-50.png": 3358,
	"./containers/Stronghold/components/Direction/components/Building/images/trophy-brigade-lvl2-75.png": 3359,
	"./containers/Stronghold/components/Direction/components/Building/images/trophy-brigade-lvl3-100.png": 3360,
	"./containers/Stronghold/components/Direction/components/Building/images/trophy-brigade-lvl3-50.png": 3361,
	"./containers/Stronghold/components/Direction/components/Building/images/trophy-brigade-lvl3-75.png": 3362,
	"./containers/Stronghold/components/Direction/components/Slot/images/slot-100.png": 3363,
	"./containers/Stronghold/components/Direction/components/Slot/images/slot-50.png": 3364,
	"./containers/Stronghold/components/Direction/components/Slot/images/slot-75.png": 3365,
	"./containers/Stronghold/components/Direction/components/Slot/images/slot-icon-100.png": 3366,
	"./containers/Stronghold/components/Direction/components/Slot/images/slot-icon-75.png": 3367,
	"./containers/Stronghold/components/Direction/images/direction-A-lvl1-100.png": 3368,
	"./containers/Stronghold/components/Direction/images/direction-A-lvl1-50.png": 3369,
	"./containers/Stronghold/components/Direction/images/direction-A-lvl1-75.png": 3370,
	"./containers/Stronghold/components/Direction/images/direction-A-lvl2-100.png": 3371,
	"./containers/Stronghold/components/Direction/images/direction-A-lvl2-50.png": 3372,
	"./containers/Stronghold/components/Direction/images/direction-A-lvl2-75.png": 3373,
	"./containers/Stronghold/components/Direction/images/direction-A-lvl3-100.png": 3374,
	"./containers/Stronghold/components/Direction/images/direction-A-lvl3-50.png": 3375,
	"./containers/Stronghold/components/Direction/images/direction-A-lvl3-75.png": 3376,
	"./containers/Stronghold/components/Direction/images/direction-B-lvl1-100.png": 3377,
	"./containers/Stronghold/components/Direction/images/direction-B-lvl1-50.png": 3378,
	"./containers/Stronghold/components/Direction/images/direction-B-lvl1-75.png": 3379,
	"./containers/Stronghold/components/Direction/images/direction-B-lvl2-100.png": 3380,
	"./containers/Stronghold/components/Direction/images/direction-B-lvl2-50.png": 3381,
	"./containers/Stronghold/components/Direction/images/direction-B-lvl2-75.png": 3382,
	"./containers/Stronghold/components/Direction/images/direction-B-lvl3-100.png": 3383,
	"./containers/Stronghold/components/Direction/images/direction-B-lvl3-50.png": 3384,
	"./containers/Stronghold/components/Direction/images/direction-B-lvl3-75.png": 3385,
	"./containers/Stronghold/components/Direction/images/direction-C-lvl1-100.png": 3386,
	"./containers/Stronghold/components/Direction/images/direction-C-lvl1-50.png": 3387,
	"./containers/Stronghold/components/Direction/images/direction-C-lvl1-75.png": 3388,
	"./containers/Stronghold/components/Direction/images/direction-C-lvl2-100.png": 3389,
	"./containers/Stronghold/components/Direction/images/direction-C-lvl2-50.png": 3390,
	"./containers/Stronghold/components/Direction/images/direction-C-lvl2-75.png": 3391,
	"./containers/Stronghold/components/Direction/images/direction-C-lvl3-100.png": 3392,
	"./containers/Stronghold/components/Direction/images/direction-C-lvl3-50.png": 3393,
	"./containers/Stronghold/components/Direction/images/direction-C-lvl3-75.png": 3394,
	"./containers/Stronghold/components/Direction/images/direction-D-lvl1-100.png": 3395,
	"./containers/Stronghold/components/Direction/images/direction-D-lvl1-50.png": 3396,
	"./containers/Stronghold/components/Direction/images/direction-D-lvl1-75.png": 3397,
	"./containers/Stronghold/components/Direction/images/direction-D-lvl2-100.png": 3398,
	"./containers/Stronghold/components/Direction/images/direction-D-lvl2-50.png": 3399,
	"./containers/Stronghold/components/Direction/images/direction-D-lvl2-75.png": 3400,
	"./containers/Stronghold/components/Direction/images/direction-D-lvl3-100.png": 3401,
	"./containers/Stronghold/components/Direction/images/direction-D-lvl3-50.png": 3402,
	"./containers/Stronghold/components/Direction/images/direction-D-lvl3-75.png": 3403,
	"./containers/Stronghold/components/RatingLabel/images/stronghold_rating_label_bg-disabled.png": 3404,
	"./containers/Stronghold/components/RatingLabel/images/stronghold_rating_label_bg-hover.png": 3405,
	"./containers/Stronghold/components/RatingLabel/images/stronghold_rating_label_bg.png": 3406,
	"./containers/Stronghold/components/ReserveActivationPopover/images/active-background.png": 3407,
	"./containers/Stronghold/components/ReserveActivationPopover/images/disabled-pattern.png": 3408,
	"./containers/Stronghold/components/ReserveActivationPopover/images/divider-bottom.png": 3409,
	"./containers/Stronghold/components/ReserveActivationPopover/images/divider.png": 3410,
	"./containers/Stronghold/components/ReserveActivationTimer/images/timer.png": 3411,
	"./containers/Stronghold/components/ReserveButton/images/battle-disabled-hover-50.png": 3412,
	"./containers/Stronghold/components/ReserveButton/images/battle-disabled-hover.png": 3413,
	"./containers/Stronghold/components/ReserveButton/images/battle-disabled-normal-50.png": 3414,
	"./containers/Stronghold/components/ReserveButton/images/battle-disabled-normal.png": 3415,
	"./containers/Stronghold/components/ReserveButton/images/battle-hover-50.png": 3416,
	"./containers/Stronghold/components/ReserveButton/images/battle-hover.png": 3417,
	"./containers/Stronghold/components/ReserveButton/images/battle-normal-50.png": 3418,
	"./containers/Stronghold/components/ReserveButton/images/battle-normal.png": 3419,
	"./containers/Stronghold/components/ReserveButton/images/battle-selected-50.png": 3420,
	"./containers/Stronghold/components/ReserveButton/images/battle-selected.png": 3421,
	"./containers/Stronghold/components/ReserveButton/images/battle-stack-50.png": 3422,
	"./containers/Stronghold/components/ReserveButton/images/battle-stack.png": 3423,
	"./containers/Stronghold/components/ReserveButton/images/battle-unique-disabled-hover.png": 3424,
	"./containers/Stronghold/components/ReserveButton/images/battle-unique-disabled-normal.png": 3425,
	"./containers/Stronghold/components/ReserveButton/images/battle-unique-hover.png": 3426,
	"./containers/Stronghold/components/ReserveButton/images/battle-unique-normal.png": 3427,
	"./containers/Stronghold/components/ReserveButton/images/economics-active-hover-50.png": 3428,
	"./containers/Stronghold/components/ReserveButton/images/economics-active-hover.png": 3429,
	"./containers/Stronghold/components/ReserveButton/images/economics-active-normal-50.png": 3430,
	"./containers/Stronghold/components/ReserveButton/images/economics-active-normal.png": 3431,
	"./containers/Stronghold/components/ReserveButton/images/economics-disabled-hover-50.png": 3432,
	"./containers/Stronghold/components/ReserveButton/images/economics-disabled-hover.png": 3433,
	"./containers/Stronghold/components/ReserveButton/images/economics-disabled-normal-50.png": 3434,
	"./containers/Stronghold/components/ReserveButton/images/economics-disabled-normal.png": 3435,
	"./containers/Stronghold/components/ReserveButton/images/economics-hover-50.png": 3436,
	"./containers/Stronghold/components/ReserveButton/images/economics-hover.png": 3437,
	"./containers/Stronghold/components/ReserveButton/images/economics-normal-50.png": 3438,
	"./containers/Stronghold/components/ReserveButton/images/economics-normal.png": 3439,
	"./containers/Stronghold/components/ReserveButton/images/economics-selected-50.png": 3440,
	"./containers/Stronghold/components/ReserveButton/images/economics-selected.png": 3441,
	"./containers/Stronghold/components/ReserveButton/images/economics-stack-50.png": 3442,
	"./containers/Stronghold/components/ReserveButton/images/economics-stack.png": 3443,
	"./containers/Stronghold/components/ReserveButton/images/gold-disabled-hover-50.png": 3444,
	"./containers/Stronghold/components/ReserveButton/images/gold-disabled-normal-50.png": 3445,
	"./containers/Stronghold/components/ReserveButton/images/gold-hover-50.png": 3446,
	"./containers/Stronghold/components/ReserveButton/images/gold-normal-50.png": 3447,
	"./containers/StrongholdExternal/components/Statistics/images/elo-icon-10.png": 3448,
	"./containers/StrongholdExternal/components/Statistics/images/elo-icon-6.png": 3449,
	"./containers/StrongholdExternal/components/Statistics/images/elo-icon-8.png": 3450,
	"./containers/WGCWXBattleSchedule/images/background_vehicles_dark.jpg": 3451,
	"./containers/WGCWXLeaderboards/components/Footer/images/button_bg.png": 3452,
	"./containers/WGCWXLeaderboards/components/Footer/images/button_top.png": 3453,
	"./containers/WGCWXLeaderboards/components/Footer/images/ok.png": 3454,
	"./containers/WGCWXLeaderboards/components/Footer/images/ribbon.png": 3455,
	"./containers/WGCWXLeaderboards/components/Footer/images/ribbon_bg.png": 3456,
	"./containers/WGCWXLeaderboards/components/RatingCard/images/divider_dotty.png": 3457,
	"./containers/WGCWXLeaderboards/components/RatingCard/images/light.png": 3458,
	"./containers/WGCWXLeaderboards/components/RatingCard/images/union.png": 3459,
	"./containers/WGCWXLeaderboards/components/RatingCard/images/union_no_position.png": 3460,
	"./containers/WGCWXLeaderboards/components/Reward/images/rewards/decal.png": 3461,
	"./containers/WGCWXLeaderboards/components/Reward/images/rewards/emblem.png": 3462,
	"./containers/WGCWXLeaderboards/components/Reward/images/rewards/medal_elite.png": 3463,
	"./containers/WGCWXLeaderboards/components/Reward/images/rewards/medal_first.png": 3464,
	"./containers/WGCWXLeaderboards/components/Reward/images/rewards/medal_second.png": 3465,
	"./containers/WGCWXLeaderboards/components/Reward/images/rewards/medal_third.png": 3466,
	"./containers/WGCWXLeaderboards/components/Reward/images/rewards/medal_veteran.png": 3467,
	"./containers/WGCWXLeaderboards/components/Reward/images/rewards/small/decal.png": 3468,
	"./containers/WGCWXLeaderboards/components/Reward/images/rewards/small/emblem.png": 3469,
	"./containers/WGCWXLeaderboards/components/Reward/images/rewards/small/medal_elite.png": 3470,
	"./containers/WGCWXLeaderboards/components/Reward/images/rewards/small/medal_first.png": 3471,
	"./containers/WGCWXLeaderboards/components/Reward/images/rewards/small/medal_second.png": 3472,
	"./containers/WGCWXLeaderboards/components/Reward/images/rewards/small/medal_third.png": 3473,
	"./containers/WGCWXLeaderboards/components/Reward/images/rewards/small/medal_veteran.png": 3474,
	"./containers/WGCWXLeaderboards/components/Reward/images/rewards/small/style.png": 3475,
	"./containers/WGCWXLeaderboards/components/Reward/images/rewards/style.png": 3476,
	"./containers/WGCWXLeaderboards/components/RewardTooltip/images/medal_elite.png": 1385,
	"./containers/WGCWXLeaderboards/components/RewardTooltip/images/medal_first.png": 1386,
	"./containers/WGCWXLeaderboards/components/RewardTooltip/images/medal_second.png": 1387,
	"./containers/WGCWXLeaderboards/components/RewardTooltip/images/medal_third.png": 1388,
	"./containers/WGCWXLeaderboards/components/RewardTooltip/images/medal_veteran.png": 1389,
	"./containers/WGCWXLeaderboards/images/background_vehicles_dark.jpg": 3477,
	"./containers/WGCWXLeaderboards/images/external_url_icon.png": 3478,
	"./containers/WGCWXLeaderboards/images/light_left.png": 3479,
	"./containers/WGCWXLeaderboards/images/light_right.png": 3480,
	"./containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/icon_in_hangar.png": 1004,
	"./containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/icon_locked.png": 1005,
	"./containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/icon_ok.png": 1006,
	"./containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/icon_plus.png": 1007,
	"./containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/icon_vehicle_add_to_comp.png": 1008,
	"./containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/icon_vehicle_add_to_comp_hover.png": 1009,
	"./containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/ok_card_status.png": 1010,
	"./containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/tanks/116-f3.png": 1011,
	"./containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/tanks/116-f3_small.png": 1012,
	"./containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/tanks/121b.png": 1013,
	"./containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/tanks/121b_small.png": 1014,
	"./containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/tanks/carro_45t.png": 1015,
	"./containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/tanks/carro_45t_small.png": 1016,
	"./containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/tanks/chieftain.png": 1017,
	"./containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/tanks/chieftain_small.png": 1018,
	"./containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/tanks/cn/116-f3.png": 1019,
	"./containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/tanks/cn/116-f3_small.png": 1020,
	"./containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/tanks/cn/121b.png": 1021,
	"./containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/tanks/cn/121b_small.png": 1022,
	"./containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/tanks/cn/carro_45t.png": 1023,
	"./containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/tanks/cn/carro_45t_small.png": 1024,
	"./containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/tanks/cn/chieftain.png": 1025,
	"./containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/tanks/cn/chieftain_small.png": 1026,
	"./containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/tanks/cn/m60.png": 1027,
	"./containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/tanks/cn/m60_small.png": 1028,
	"./containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/tanks/cn/object_907.png": 1029,
	"./containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/tanks/cn/object_907_small.png": 1030,
	"./containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/tanks/cn/t95e6.png": 1031,
	"./containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/tanks/cn/t95e6_small.png": 1032,
	"./containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/tanks/cn/vk_72_01.png": 1033,
	"./containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/tanks/cn/vk_72_01_small.png": 1034,
	"./containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/tanks/m60.png": 1035,
	"./containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/tanks/m60_small.png": 1036,
	"./containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/tanks/object_907.png": 1037,
	"./containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/tanks/object_907_small.png": 1038,
	"./containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/tanks/t95e6.png": 1039,
	"./containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/tanks/t95e6_small.png": 1040,
	"./containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/tanks/vk_72_01.png": 1041,
	"./containers/WGCWXShop/containers/WGCWXRewards/components/WGCWXRewardsTankCard/images/tanks/vk_72_01_small.png": 1042,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/components/Footer/images/footer_bg.png": 1043,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/components/Footer/images/icon_alert.png": 1044,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/components/Footer/images/icon_locked.png": 1045,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/components/Footer/images/icon_ok.png": 1046,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/components/Footer/images/inhangar.png": 1047,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/components/TankAuctionSlider/images/bonds.RU.png": 1048,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/components/TankAuctionSlider/images/bonds.png": 1049,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/components/TankAuctionSlider/images/slider-scale.png": 1050,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/components/WGCWXRewardsTankConfirmation/images/alert.png": 1051,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/components/WGCWXRewardsTankConfirmation/images/alert_light.png": 1052,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/components/WGCWXRewardsTankConfirmation/images/error.png": 1053,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/components/WGCWXRewardsTankConfirmation/images/error_light.png": 1054,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/images/background_vehicle_enhancements.png": 1055,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/images/cards/cards_116-f3.png": 1056,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/images/cards/cards_121b.png": 1057,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/images/cards/cards_carro_45t.png": 1058,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/images/cards/cards_chieftain.png": 1059,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/images/cards/cards_m60.png": 1060,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/images/cards/cards_ob907.png": 1061,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/images/cards/cards_t95e6.png": 1062,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/images/cards/cards_vk_72_01.png": 1063,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/images/cards/cn/cards_116-f3.png": 1064,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/images/cards/cn/cards_carro_45t.png": 1065,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/images/event_rewards_bg.jpg": 1066,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/images/flags/china.png": 1067,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/images/flags/china_cn.png": 1068,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/images/flags/czech.png": 1069,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/images/flags/czech_cn.png": 1070,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/images/flags/france.png": 1071,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/images/flags/france_cn.png": 1072,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/images/flags/germany.png": 1073,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/images/flags/germany_cn.png": 1074,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/images/flags/italy.png": 1075,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/images/flags/italy_cn.png": 1076,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/images/flags/japan.png": 1077,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/images/flags/japan_cn.png": 1078,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/images/flags/poland.png": 1079,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/images/flags/poland_cn.png": 1080,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/images/flags/sweden.png": 1081,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/images/flags/sweden_cn.png": 1082,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/images/flags/uk.png": 1083,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/images/flags/uk_cn.png": 1084,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/images/flags/usa.png": 1085,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/images/flags/usa_cn.png": 1086,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/images/flags/ussr.png": 1087,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/images/flags/ussr_cn.png": 1088,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/images/icon_notifications_info.png": 1089,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/images/link.png": 1090,
	"./containers/WGCWXShop/containers/WGCWXRewardsTank/images/pattern_disabled.png": 1091,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/bought-group-icon.png": 1092,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/bought-product-icon.png": 1093,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/flags/cn/flags_china_cn.png": 1094,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/flags/cn/flags_czech_cn.png": 1095,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/flags/cn/flags_france_cn.png": 1096,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/flags/cn/flags_germany_cn.png": 1097,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/flags/cn/flags_italy_cn.png": 1098,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/flags/cn/flags_japan_cn.png": 1099,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/flags/cn/flags_poland_cn.png": 1100,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/flags/cn/flags_sweden_cn.png": 1101,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/flags/cn/flags_uk_cn.png": 1102,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/flags/cn/flags_usa_cn.png": 1103,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/flags/cn/flags_ussr_cn.png": 1104,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/flags/flags_china.png": 1105,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/flags/flags_czech.png": 1106,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/flags/flags_france.png": 1107,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/flags/flags_germany.png": 1108,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/flags/flags_italy.png": 1109,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/flags/flags_japan.png": 1110,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/flags/flags_poland.png": 1111,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/flags/flags_sweden.png": 1112,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/flags/flags_uk.png": 1113,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/flags/flags_usa.png": 1114,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/flags/flags_ussr.png": 1115,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/nation/nation-china.png": 1116,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/nation/nation-cn-china.png": 1117,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/nation/nation-cn-czech.png": 1118,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/nation/nation-cn-france.png": 1119,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/nation/nation-cn-germany.png": 1120,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/nation/nation-cn-italy.png": 1121,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/nation/nation-cn-japan.png": 1122,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/nation/nation-cn-poland.png": 1123,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/nation/nation-cn-sweden.png": 1124,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/nation/nation-cn-uk.png": 1125,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/nation/nation-cn-usa.png": 1126,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/nation/nation-cn-ussr.png": 1127,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/nation/nation-czech.png": 1128,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/nation/nation-france.png": 1129,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/nation/nation-germany.png": 1130,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/nation/nation-italy.png": 1131,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/nation/nation-japan.png": 1132,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/nation/nation-poland.png": 1133,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/nation/nation-sweden.png": 1134,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/nation/nation-uk.png": 1135,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/nation/nation-usa.png": 1136,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/nation/nation-ussr.png": 1137,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/AIR_ELEMENTAL_STYLE.png": 1138,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/BASALT_STYLE.png": 1139,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/BONDS.RU.png": 1140,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/BONDS.png": 1141,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/BROKEN_STONE_STYLE.png": 1142,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/CLAN_URBAN_STYLE.png": 1143,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/CONQUEROR_STYLE.png": 1144,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/CREW_EXPERIENCE.png": 1145,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/CREW_WOMAN.png": 1146,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/DIGITAL_ADAPTED_STYLE.png": 1147,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/DIGITAL_STYLE.png": 1148,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/DIRECTIVES_PACK.png": 1149,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/DIRECTIVES_PACK_30.png": 1150,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/EARTH_ELEMENTAL_STYLE.png": 1151,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/EMBLEM.png": 1152,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/EXPERIENCE.png": 1153,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/FIRE_ELEMENTAL_STYLE.png": 1154,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/FIRE_STYLE.png": 1155,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/FREE_EXPERIENCE.png": 1156,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/FREE_XP_AND_CREW_XP.png": 1157,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/GOLD.RU.png": 1158,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/GOLD.png": 1159,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/GRAPHITE_STYLE.png": 1160,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/GUARDIAN_OF_CROWN_STYLE.png": 1161,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/HELLRAISER_STYLE.png": 1162,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/JUDGEMENT_STYLE.png": 1163,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/KRAIT_STYLE.png": 1164,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/NAMENLOS_STYLE.png": 1165,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/NIGHTFALL_STYLE.png": 1166,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/PERSONAL_RESERVE.png": 1167,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/PFP_BATTLES.png": 1168,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/PREMIUM_PLUS_1.png": 1169,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/PREMIUM_PLUS_3.png": 1170,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/PROPHESY_STYLE.png": 1171,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/PROSERPINA_STYLE.png": 1172,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/REAPER_STYLE.png": 1173,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/SILVER.RU.png": 1174,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/SILVER.png": 1175,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/VANQUISHER_STYLE.png": 1176,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/VETERAN_STYLE.png": 1177,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/WARRIOR_OF_THE_EAST_STYLE.png": 1178,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/WARRIOR_OF_THE_NORTH_STYLE.png": 1179,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/WARRIOR_OF_THE_SOUTH_STYLE.png": 1180,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/WARRIOR_OF_THE_WEST_STYLE.png": 1181,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/WATER_ELEMENTAL_STYLE.png": 1182,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/XP_RESERVE.png": 1183,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/CREW_BOOK_NATIONAL_china.RU.png": 1184,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/CREW_BOOK_NATIONAL_china.png": 1185,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/CREW_BOOK_NATIONAL_czech.RU.png": 1186,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/CREW_BOOK_NATIONAL_czech.png": 1187,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/CREW_BOOK_NATIONAL_france.RU.png": 1188,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/CREW_BOOK_NATIONAL_france.png": 1189,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/CREW_BOOK_NATIONAL_germany.RU.png": 1190,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/CREW_BOOK_NATIONAL_germany.png": 1191,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/CREW_BOOK_NATIONAL_italy.RU.png": 1192,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/CREW_BOOK_NATIONAL_italy.png": 1193,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/CREW_BOOK_NATIONAL_japan.RU.png": 1194,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/CREW_BOOK_NATIONAL_japan.png": 1195,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/CREW_BOOK_NATIONAL_poland.RU.png": 1196,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/CREW_BOOK_NATIONAL_poland.png": 1197,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/CREW_BOOK_NATIONAL_sweden.RU.png": 1198,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/CREW_BOOK_NATIONAL_sweden.png": 1199,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/CREW_BOOK_NATIONAL_uk.RU.png": 1200,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/CREW_BOOK_NATIONAL_uk.png": 1201,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/CREW_BOOK_NATIONAL_usa.RU.png": 1202,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/CREW_BOOK_NATIONAL_usa.png": 1203,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/CREW_BOOK_NATIONAL_ussr.RU.png": 1204,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/CREW_BOOK_NATIONAL_ussr.png": 1205,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/cn/CREW_BOOK_NATIONAL_china_cn.png": 1206,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/cn/CREW_BOOK_NATIONAL_czech_cn.png": 1207,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/cn/CREW_BOOK_NATIONAL_france_cn.png": 1208,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/cn/CREW_BOOK_NATIONAL_germany_cn.png": 1209,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/cn/CREW_BOOK_NATIONAL_italy_cn.png": 1210,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/cn/CREW_BOOK_NATIONAL_japan_cn.png": 1211,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/cn/CREW_BOOK_NATIONAL_poland_cn.png": 1212,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/cn/CREW_BOOK_NATIONAL_sweden_cn.png": 1213,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/cn/CREW_BOOK_NATIONAL_uk_cn.png": 1214,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/cn/CREW_BOOK_NATIONAL_usa_cn.png": 1215,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/cn/CREW_BOOK_NATIONAL_ussr_cn.png": 1216,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageDesert/DIGITAL_CAMOUFLAGE_DESERT_china.png": 1217,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageDesert/DIGITAL_CAMOUFLAGE_DESERT_czech.png": 1218,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageDesert/DIGITAL_CAMOUFLAGE_DESERT_france.png": 1219,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageDesert/DIGITAL_CAMOUFLAGE_DESERT_germany.png": 1220,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageDesert/DIGITAL_CAMOUFLAGE_DESERT_italy.png": 1221,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageDesert/DIGITAL_CAMOUFLAGE_DESERT_japan.png": 1222,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageDesert/DIGITAL_CAMOUFLAGE_DESERT_poland.png": 1223,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageDesert/DIGITAL_CAMOUFLAGE_DESERT_sweden.png": 1224,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageDesert/DIGITAL_CAMOUFLAGE_DESERT_uk.png": 1225,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageDesert/DIGITAL_CAMOUFLAGE_DESERT_usa.png": 1226,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageDesert/DIGITAL_CAMOUFLAGE_DESERT_ussr.png": 1227,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageSummer/DIGITAL_CAMOUFLAGE_SUMMER_china.png": 1228,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageSummer/DIGITAL_CAMOUFLAGE_SUMMER_czech.png": 1229,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageSummer/DIGITAL_CAMOUFLAGE_SUMMER_france.png": 1230,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageSummer/DIGITAL_CAMOUFLAGE_SUMMER_germany.png": 1231,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageSummer/DIGITAL_CAMOUFLAGE_SUMMER_italy.png": 1232,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageSummer/DIGITAL_CAMOUFLAGE_SUMMER_japan.png": 1233,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageSummer/DIGITAL_CAMOUFLAGE_SUMMER_poland.png": 1234,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageSummer/DIGITAL_CAMOUFLAGE_SUMMER_sweden.png": 1235,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageSummer/DIGITAL_CAMOUFLAGE_SUMMER_uk.png": 1236,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageSummer/DIGITAL_CAMOUFLAGE_SUMMER_usa.png": 1237,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageSummer/DIGITAL_CAMOUFLAGE_SUMMER_ussr.png": 1238,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageWinter/DIGITAL_CAMOUFLAGE_WINTER_china.png": 1239,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageWinter/DIGITAL_CAMOUFLAGE_WINTER_czech.png": 1240,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageWinter/DIGITAL_CAMOUFLAGE_WINTER_france.png": 1241,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageWinter/DIGITAL_CAMOUFLAGE_WINTER_germany.png": 1242,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageWinter/DIGITAL_CAMOUFLAGE_WINTER_italy.png": 1243,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageWinter/DIGITAL_CAMOUFLAGE_WINTER_japan.png": 1244,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageWinter/DIGITAL_CAMOUFLAGE_WINTER_poland.png": 1245,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageWinter/DIGITAL_CAMOUFLAGE_WINTER_sweden.png": 1246,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageWinter/DIGITAL_CAMOUFLAGE_WINTER_uk.png": 1247,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageWinter/DIGITAL_CAMOUFLAGE_WINTER_usa.png": 1248,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageWinter/DIGITAL_CAMOUFLAGE_WINTER_ussr.png": 1249,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/lightningStyle/LIGHTNING_STYLE_china.png": 1250,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/lightningStyle/LIGHTNING_STYLE_czech.png": 1251,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/lightningStyle/LIGHTNING_STYLE_france.png": 1252,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/lightningStyle/LIGHTNING_STYLE_germany.png": 1253,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/lightningStyle/LIGHTNING_STYLE_italy.png": 1254,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/lightningStyle/LIGHTNING_STYLE_japan.png": 1255,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/lightningStyle/LIGHTNING_STYLE_poland.png": 1256,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/lightningStyle/LIGHTNING_STYLE_sweden.png": 1257,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/lightningStyle/LIGHTNING_STYLE_uk.png": 1258,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/lightningStyle/LIGHTNING_STYLE_usa.png": 1259,
	"./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/lightningStyle/LIGHTNING_STYLE_ussr.png": 1260,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/green-corner.png": 1261,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/AIR_ELEMENTAL_STYLE.png": 1262,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/BASALT_STYLE.png": 1263,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/BONDS.RU.png": 1264,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/BONDS.png": 1265,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/BROKEN_STONE_STYLE.png": 1266,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/CLAN_URBAN_STYLE.png": 1267,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/CONQUEROR_STYLE.png": 1268,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/CREW_BOOK_NATIONAL.RU.png": 1269,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/CREW_BOOK_NATIONAL.png": 1270,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/CREW_EXPERIENCE.png": 1271,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/CREW_WOMAN.png": 1272,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/DIGITAL_ADAPTED_STYLE.png": 1273,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/DIGITAL_CAMOUFLAGE_DESERT.png": 1274,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/DIGITAL_CAMOUFLAGE_SUMMER.png": 1275,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/DIGITAL_CAMOUFLAGE_WINTER.png": 1276,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/DIGITAL_STYLE.png": 1277,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/DIRECTIVES_PACK.png": 1278,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/DIRECTIVES_PACK_30.png": 1279,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/EARTH_ELEMENTAL_STYLE.png": 1280,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/EMBLEM.png": 1281,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/EXPERIENCE.png": 1282,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/FIRE_ELEMENTAL_STYLE.png": 1283,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/FIRE_STYLE.png": 1284,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/FREE_EXPERIENCE.png": 1285,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/FREE_XP_AND_CREW_XP.png": 1286,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/GOLD.RU.png": 1287,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/GOLD.png": 1288,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/GRAPHITE_STYLE.png": 1289,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/GUARDIAN_OF_CROWN_STYLE.png": 1290,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/HELLRAISER_STYLE.png": 1291,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/JUDGEMENT_STYLE.png": 1292,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/KRAIT_STYLE.png": 1293,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/LIGHTNING_STYLE.png": 1294,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/NAMENLOS_STYLE.png": 1295,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/NIGHTFALL_STYLE.png": 1296,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/PERSONAL_RESERVE.png": 1297,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/PFP_BATTLES.png": 1298,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/PREMIUM_PLUS_1.png": 1299,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/PREMIUM_PLUS_3.png": 1300,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/PROPHESY_STYLE.png": 1301,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/PROSERPINA_STYLE.png": 1302,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/REAPER_STYLE.png": 1303,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/SILVER.RU.png": 1304,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/SILVER.png": 1305,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/TANK.png": 1306,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/VANQUISHER_STYLE.png": 1307,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/VETERAN_STYLE.png": 1308,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/WARRIOR_OF_THE_EAST_STYLE.png": 1309,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/WARRIOR_OF_THE_NORTH_STYLE.png": 1310,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/WARRIOR_OF_THE_SOUTH_STYLE.png": 1311,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/WARRIOR_OF_THE_WEST_STYLE.png": 1312,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/WATER_ELEMENTAL_STYLE.png": 1313,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/XP_RESERVE.png": 1314,
	"./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopCard/images/products/cn/CREW_BOOK_NATIONAL.png": 1315,
	"./containers/WGCWXShop/images/background_vehicles_dark.jpg": 1316,
	"./containers/WGCWXShop/images/link.png": 1317,
	"./containers/WGCWXShop/images/shape_pattern.png": 1318,
	"./containers/WGCWXShop/images/shop_iron_age_bg.jpg": 1319,
	"./containers/WGCWXShop/images/wargods_shop_bg.jpg": 1320,
	"./styles/core/components/button/images/default-active-bg-left.png": 3481,
	"./styles/core/components/button/images/default-active-bg-right.png": 3482,
	"./styles/core/components/button/images/default-active-bg.png": 3483,
	"./styles/core/components/button/images/default-bg-left.png": 3484,
	"./styles/core/components/button/images/default-bg-right.png": 3485,
	"./styles/core/components/button/images/default-bg.png": 3486,
	"./styles/core/components/button/images/default-hover-bg-left.png": 3487,
	"./styles/core/components/button/images/default-hover-bg-right.png": 3488,
	"./styles/core/components/button/images/default-hover-bg.png": 3489,
	"./styles/core/components/button/images/disabled-pattern.png": 3490,
	"./styles/core/components/button/images/shadow.png": 3491,
	"./styles/images/battlerooms_bg.jpg": 3492,
	"./styles/images/building-card/building-card-bg-100.jpg": 3493,
	"./styles/images/building-card/building-card-bg-50.jpg": 3494,
	"./styles/images/building-card/building-card-bg-75.jpg": 3495,
	"./styles/images/buildings/artillery-battalion-lvl1-100.png": 3496,
	"./styles/images/buildings/artillery-battalion-lvl1-50.png": 3497,
	"./styles/images/buildings/artillery-battalion-lvl1-75.png": 3498,
	"./styles/images/buildings/artillery-battalion-lvl2-100.png": 3499,
	"./styles/images/buildings/artillery-battalion-lvl2-50.png": 3500,
	"./styles/images/buildings/artillery-battalion-lvl2-75.png": 3501,
	"./styles/images/buildings/artillery-battalion-lvl3-100.png": 3502,
	"./styles/images/buildings/artillery-battalion-lvl3-50.png": 3503,
	"./styles/images/buildings/artillery-battalion-lvl3-75.png": 3504,
	"./styles/images/buildings/attack-bomber-squadrons-lvl1-100.png": 3505,
	"./styles/images/buildings/attack-bomber-squadrons-lvl1-50.png": 3506,
	"./styles/images/buildings/attack-bomber-squadrons-lvl1-75.png": 3507,
	"./styles/images/buildings/attack-bomber-squadrons-lvl2-100.png": 3508,
	"./styles/images/buildings/attack-bomber-squadrons-lvl2-50.png": 3509,
	"./styles/images/buildings/attack-bomber-squadrons-lvl2-75.png": 3510,
	"./styles/images/buildings/attack-bomber-squadrons-lvl3-100.png": 3511,
	"./styles/images/buildings/attack-bomber-squadrons-lvl3-50.png": 3512,
	"./styles/images/buildings/attack-bomber-squadrons-lvl3-75.png": 3513,
	"./styles/images/buildings/command-center-lvl1-100.png": 3514,
	"./styles/images/buildings/command-center-lvl1-50.png": 3515,
	"./styles/images/buildings/command-center-lvl1-75.png": 3516,
	"./styles/images/buildings/command-center-lvl2-100.png": 3517,
	"./styles/images/buildings/command-center-lvl2-50.png": 3518,
	"./styles/images/buildings/command-center-lvl2-75.png": 3519,
	"./styles/images/buildings/command-center-lvl3-100.png": 3520,
	"./styles/images/buildings/command-center-lvl3-50.png": 3521,
	"./styles/images/buildings/command-center-lvl3-75.png": 3522,
	"./styles/images/buildings/command-center-maxlvl-100.png": 3523,
	"./styles/images/buildings/command-center-maxlvl-50.png": 3524,
	"./styles/images/buildings/financial-unit-lvl1-100.png": 3525,
	"./styles/images/buildings/financial-unit-lvl1-50.png": 3526,
	"./styles/images/buildings/financial-unit-lvl1-75.png": 3527,
	"./styles/images/buildings/financial-unit-lvl2-100.png": 3528,
	"./styles/images/buildings/financial-unit-lvl2-50.png": 3529,
	"./styles/images/buildings/financial-unit-lvl2-75.png": 3530,
	"./styles/images/buildings/financial-unit-lvl3-100.png": 3531,
	"./styles/images/buildings/financial-unit-lvl3-50.png": 3532,
	"./styles/images/buildings/financial-unit-lvl3-75.png": 3533,
	"./styles/images/buildings/home-front-service-lvl1-100.png": 3534,
	"./styles/images/buildings/home-front-service-lvl1-50.png": 3535,
	"./styles/images/buildings/home-front-service-lvl1-75.png": 3536,
	"./styles/images/buildings/home-front-service-lvl2-100.png": 3537,
	"./styles/images/buildings/home-front-service-lvl2-50.png": 3538,
	"./styles/images/buildings/home-front-service-lvl2-75.png": 3539,
	"./styles/images/buildings/home-front-service-lvl3-100.png": 3540,
	"./styles/images/buildings/home-front-service-lvl3-50.png": 3541,
	"./styles/images/buildings/home-front-service-lvl3-75.png": 3542,
	"./styles/images/buildings/military-school-lvl1-100.png": 3543,
	"./styles/images/buildings/military-school-lvl1-50.png": 3544,
	"./styles/images/buildings/military-school-lvl1-75.png": 3545,
	"./styles/images/buildings/military-school-lvl2-100.png": 3546,
	"./styles/images/buildings/military-school-lvl2-50.png": 3547,
	"./styles/images/buildings/military-school-lvl2-75.png": 3548,
	"./styles/images/buildings/military-school-lvl3-100.png": 3549,
	"./styles/images/buildings/military-school-lvl3-50.png": 3550,
	"./styles/images/buildings/military-school-lvl3-75.png": 3551,
	"./styles/images/buildings/tankodrome-lvl1-100.png": 3552,
	"./styles/images/buildings/tankodrome-lvl1-50.png": 3553,
	"./styles/images/buildings/tankodrome-lvl1-75.png": 3554,
	"./styles/images/buildings/tankodrome-lvl2-100.png": 3555,
	"./styles/images/buildings/tankodrome-lvl2-50.png": 3556,
	"./styles/images/buildings/tankodrome-lvl2-75.png": 3557,
	"./styles/images/buildings/tankodrome-lvl3-100.png": 3558,
	"./styles/images/buildings/tankodrome-lvl3-50.png": 3559,
	"./styles/images/buildings/tankodrome-lvl3-75.png": 3560,
	"./styles/images/buildings/training-unit-lvl1-100.png": 3561,
	"./styles/images/buildings/training-unit-lvl1-50.png": 3562,
	"./styles/images/buildings/training-unit-lvl1-75.png": 3563,
	"./styles/images/buildings/training-unit-lvl2-100.png": 3564,
	"./styles/images/buildings/training-unit-lvl2-50.png": 3565,
	"./styles/images/buildings/training-unit-lvl2-75.png": 3566,
	"./styles/images/buildings/training-unit-lvl3-100.png": 3567,
	"./styles/images/buildings/training-unit-lvl3-50.png": 3568,
	"./styles/images/buildings/training-unit-lvl3-75.png": 3569,
	"./styles/images/buildings/transportation-unit-lvl1-100.png": 3570,
	"./styles/images/buildings/transportation-unit-lvl1-50.png": 3571,
	"./styles/images/buildings/transportation-unit-lvl1-75.png": 3572,
	"./styles/images/buildings/transportation-unit-lvl2-100.png": 3573,
	"./styles/images/buildings/transportation-unit-lvl2-50.png": 3574,
	"./styles/images/buildings/transportation-unit-lvl2-75.png": 3575,
	"./styles/images/buildings/transportation-unit-lvl3-100.png": 3576,
	"./styles/images/buildings/transportation-unit-lvl3-50.png": 3577,
	"./styles/images/buildings/transportation-unit-lvl3-75.png": 3578,
	"./styles/images/buildings/trophy-brigade-lvl1-100.png": 3579,
	"./styles/images/buildings/trophy-brigade-lvl1-50.png": 3580,
	"./styles/images/buildings/trophy-brigade-lvl1-75.png": 3581,
	"./styles/images/buildings/trophy-brigade-lvl2-100.png": 3582,
	"./styles/images/buildings/trophy-brigade-lvl2-50.png": 3583,
	"./styles/images/buildings/trophy-brigade-lvl2-75.png": 3584,
	"./styles/images/buildings/trophy-brigade-lvl3-100.png": 3585,
	"./styles/images/buildings/trophy-brigade-lvl3-50.png": 3586,
	"./styles/images/buildings/trophy-brigade-lvl3-75.png": 3587,
	"./styles/images/button-small/bsm-default-active-bg-left.png": 3588,
	"./styles/images/button-small/bsm-default-active-bg-right.png": 3589,
	"./styles/images/button-small/bsm-default-active-bg.png": 3590,
	"./styles/images/button-small/bsm-default-bg-left.png": 3591,
	"./styles/images/button-small/bsm-default-bg-right.png": 3592,
	"./styles/images/button-small/bsm-default-bg.png": 3593,
	"./styles/images/button-small/bsm-default-hover-bg-left.png": 3594,
	"./styles/images/button-small/bsm-default-hover-bg-right.png": 3595,
	"./styles/images/button-small/bsm-default-hover-bg.png": 3596,
	"./styles/images/button-small/bsm-disabled-bg-left.png": 3597,
	"./styles/images/button-small/bsm-disabled-bg-right.png": 3598,
	"./styles/images/button-small/bsm-disabled-bg.png": 3599,
	"./styles/images/button-small/bsm-disabled-pattern.png": 3600,
	"./styles/images/button-small/bsm-secondary-active-bg-left.png": 3601,
	"./styles/images/button-small/bsm-secondary-active-bg-right.png": 3602,
	"./styles/images/button-small/bsm-secondary-active-bg.png": 3603,
	"./styles/images/button-small/bsm-secondary-bg-left.png": 3604,
	"./styles/images/button-small/bsm-secondary-bg-right.png": 3605,
	"./styles/images/button-small/bsm-secondary-bg.png": 3606,
	"./styles/images/button-small/bsm-secondary-hover-bg-left.png": 3607,
	"./styles/images/button-small/bsm-secondary-hover-bg-right.png": 3608,
	"./styles/images/button-small/bsm-secondary-hover-bg.png": 3609,
	"./styles/images/cancel.png": 3610,
	"./styles/images/challenges-bg.jpg": 3611,
	"./styles/images/challenges/icon-conscription.png": 3612,
	"./styles/images/challenges/icon-onslaught.png": 3613,
	"./styles/images/challenges/icon-shooting.png": 3614,
	"./styles/images/challenges/icon-superiority.png": 3615,
	"./styles/images/chess-pattern-white.png": 3616,
	"./styles/images/chess-pattern.png": 3617,
	"./styles/images/divider-dots-horizontal.png": 3618,
	"./styles/images/divider-shadowed-mask.png": 3619,
	"./styles/images/divider-shadowed-small.png": 3620,
	"./styles/images/divider-shadowed.png": 3621,
	"./styles/images/dots-pattern-x.png": 3622,
	"./styles/images/dots-pattern-y.png": 3623,
	"./styles/images/events/event-building.png": 3624,
	"./styles/images/events/event-challenge.png": 3625,
	"./styles/images/events/event-upgrade.png": 3626,
	"./styles/images/footer-divider.png": 3627,
	"./styles/images/handle.png": 3628,
	"./styles/images/horizontal-dots-divider.png": 3629,
	"./styles/images/icons/average-rating.RU.png": 3630,
	"./styles/images/icons/average-rating.png": 3631,
	"./styles/images/icons/fort-battle-active.png": 3632,
	"./styles/images/icons/fort-battle.png": 3633,
	"./styles/images/icons/icon-error.png": 3634,
	"./styles/images/icons/icon-levels.png": 3635,
	"./styles/images/icons/icon-success.png": 3636,
	"./styles/images/icons/icon-vehicle-types.png": 3637,
	"./styles/images/icons/industrial-resource-small.png": 3638,
	"./styles/images/icons/industrial-resource.png": 3639,
	"./styles/images/icons/info-big.png": 3640,
	"./styles/images/icons/info.png": 3641,
	"./styles/images/icons/settings.png": 3642,
	"./styles/images/icons/sortie-active.png": 3643,
	"./styles/images/icons/sortie.png": 3644,
	"./styles/images/icons/warning.png": 3645,
	"./styles/images/icons/warning_small.png": 3646,
	"./styles/images/in-battle-icon.png": 3647,
	"./styles/images/landing-bg.jpg": 3648,
	"./styles/images/landing/landing-award-large.RU.png": 3649,
	"./styles/images/landing/landing-award-large.png": 3650,
	"./styles/images/landing/landing-award-small.RU.png": 3651,
	"./styles/images/landing/landing-award-small.png": 3652,
	"./styles/images/landing/landing-slider-arrows.png": 3653,
	"./styles/images/leaderboards/battle_mode_10.png": 3654,
	"./styles/images/leaderboards/battle_mode_6.png": 3655,
	"./styles/images/leaderboards/battle_mode_8.png": 3656,
	"./styles/images/nations/china-cn.png": 3657,
	"./styles/images/nations/china.png": 3658,
	"./styles/images/nations/czech-cn.png": 3659,
	"./styles/images/nations/czech.png": 3660,
	"./styles/images/nations/france-cn.png": 3661,
	"./styles/images/nations/france.png": 3662,
	"./styles/images/nations/germany-cn.png": 3663,
	"./styles/images/nations/germany.png": 3664,
	"./styles/images/nations/italy-cn.png": 3665,
	"./styles/images/nations/italy.png": 3666,
	"./styles/images/nations/japan-cn.png": 3667,
	"./styles/images/nations/japan.png": 3668,
	"./styles/images/nations/poland-cn.png": 3669,
	"./styles/images/nations/poland.png": 3670,
	"./styles/images/nations/sweden-cn.png": 3671,
	"./styles/images/nations/sweden.png": 3672,
	"./styles/images/nations/uk-cn.png": 3673,
	"./styles/images/nations/uk.png": 3674,
	"./styles/images/nations/usa-cn.png": 3675,
	"./styles/images/nations/usa.png": 3676,
	"./styles/images/nations/ussr-cn.png": 3677,
	"./styles/images/nations/ussr.png": 3678,
	"./styles/images/plus-icon.png": 3679,
	"./styles/images/popover-footer-divider.png": 3680,
	"./styles/images/pure-table/pattern.png": 3681,
	"./styles/images/pure-table/shine-left.png": 3682,
	"./styles/images/pure-table/shine-right.png": 3683,
	"./styles/images/pure-table/shine.png": 3684,
	"./styles/images/reserves/additional-briefing-50.png": 3685,
	"./styles/images/reserves/additional-briefing-clan-landing-big.png": 3686,
	"./styles/images/reserves/additional-briefing-clan-landing-elite-big.png": 3687,
	"./styles/images/reserves/additional-briefing-clan-landing-elite-sm.png": 3688,
	"./styles/images/reserves/additional-briefing-clan-landing-sm.png": 3689,
	"./styles/images/reserves/additional-briefing-elite-50.png": 3690,
	"./styles/images/reserves/additional-briefing-elite.png": 3691,
	"./styles/images/reserves/additional-briefing.png": 3692,
	"./styles/images/reserves/airstrike-elite-toolbar-50.png": 3693,
	"./styles/images/reserves/airstrike-elite-toolbar.png": 3694,
	"./styles/images/reserves/airstrike-elite.png": 3695,
	"./styles/images/reserves/airstrike-toolbar-50.png": 3696,
	"./styles/images/reserves/airstrike-toolbar.png": 3697,
	"./styles/images/reserves/airstrike.png": 3698,
	"./styles/images/reserves/artillery-strike-elite-toolbar-50.png": 3699,
	"./styles/images/reserves/artillery-strike-elite-toolbar.png": 3700,
	"./styles/images/reserves/artillery-strike-elite.png": 3701,
	"./styles/images/reserves/artillery-strike-toolbar-50.png": 3702,
	"./styles/images/reserves/artillery-strike-toolbar.png": 3703,
	"./styles/images/reserves/artillery-strike.png": 3704,
	"./styles/images/reserves/battle-payments-50.png": 3705,
	"./styles/images/reserves/battle-payments-clan-landing-big.png": 3706,
	"./styles/images/reserves/battle-payments-clan-landing-elite-big.png": 3707,
	"./styles/images/reserves/battle-payments-clan-landing-elite-sm.png": 3708,
	"./styles/images/reserves/battle-payments-clan-landing-sm.png": 3709,
	"./styles/images/reserves/battle-payments-elite-50.png": 3710,
	"./styles/images/reserves/battle-payments-elite.png": 3711,
	"./styles/images/reserves/battle-payments.png": 3712,
	"./styles/images/reserves/high-capacity-transport-elite-toolbar-50.png": 3713,
	"./styles/images/reserves/high-capacity-transport-elite-toolbar.png": 3714,
	"./styles/images/reserves/high-capacity-transport-elite.png": 3715,
	"./styles/images/reserves/high-capacity-transport-toolbar-50.png": 3716,
	"./styles/images/reserves/high-capacity-transport-toolbar.png": 3717,
	"./styles/images/reserves/high-capacity-transport.png": 3718,
	"./styles/images/reserves/inspiration-elite-toolbar-50.png": 3719,
	"./styles/images/reserves/inspiration-elite-toolbar.png": 3720,
	"./styles/images/reserves/inspiration-elite.png": 3721,
	"./styles/images/reserves/inspiration-toolbar-50.png": 3722,
	"./styles/images/reserves/inspiration-toolbar.png": 3723,
	"./styles/images/reserves/inspiration.png": 3724,
	"./styles/images/reserves/journal/additional-briefing-cancel.png": 3725,
	"./styles/images/reserves/journal/additional-briefing-elite.png": 3726,
	"./styles/images/reserves/journal/additional-briefing.png": 3727,
	"./styles/images/reserves/journal/airstrike-cancel.png": 3728,
	"./styles/images/reserves/journal/airstrike-elite.png": 3729,
	"./styles/images/reserves/journal/airstrike.png": 3730,
	"./styles/images/reserves/journal/artillery-strike-cancel.png": 3731,
	"./styles/images/reserves/journal/artillery-strike-elite.png": 3732,
	"./styles/images/reserves/journal/artillery-strike.png": 3733,
	"./styles/images/reserves/journal/battle-payments-cancel.png": 3734,
	"./styles/images/reserves/journal/battle-payments-elite.png": 3735,
	"./styles/images/reserves/journal/battle-payments.png": 3736,
	"./styles/images/reserves/journal/high-capacity-transport-cancel.png": 3737,
	"./styles/images/reserves/journal/high-capacity-transport-elite.png": 3738,
	"./styles/images/reserves/journal/high-capacity-transport.png": 3739,
	"./styles/images/reserves/journal/inspiration-cancel.png": 3740,
	"./styles/images/reserves/journal/inspiration-elite.png": 3741,
	"./styles/images/reserves/journal/inspiration.png": 3742,
	"./styles/images/reserves/journal/military-maneuvers-cancel.png": 3743,
	"./styles/images/reserves/journal/military-maneuvers-elite.png": 3744,
	"./styles/images/reserves/journal/military-maneuvers.png": 3745,
	"./styles/images/reserves/journal/requisition-cancel.png": 3746,
	"./styles/images/reserves/journal/requisition-elite.png": 3747,
	"./styles/images/reserves/journal/requisition.png": 3748,
	"./styles/images/reserves/journal/tactical-training-cancel.png": 3749,
	"./styles/images/reserves/journal/tactical-training-elite.png": 3750,
	"./styles/images/reserves/journal/tactical-training.png": 3751,
	"./styles/images/reserves/military-maneuvers-50.png": 3752,
	"./styles/images/reserves/military-maneuvers-clan-landing-big.png": 3753,
	"./styles/images/reserves/military-maneuvers-clan-landing-elite-big.png": 3754,
	"./styles/images/reserves/military-maneuvers-clan-landing-elite-sm.png": 3755,
	"./styles/images/reserves/military-maneuvers-clan-landing-sm.png": 3756,
	"./styles/images/reserves/military-maneuvers-elite-50.png": 3757,
	"./styles/images/reserves/military-maneuvers-elite.png": 3758,
	"./styles/images/reserves/military-maneuvers.png": 3759,
	"./styles/images/reserves/requisition-elite-toolbar-50.png": 3760,
	"./styles/images/reserves/requisition-elite-toolbar.png": 3761,
	"./styles/images/reserves/requisition-elite.png": 3762,
	"./styles/images/reserves/requisition-toolbar-50.png": 3763,
	"./styles/images/reserves/requisition-toolbar.png": 3764,
	"./styles/images/reserves/requisition.png": 3765,
	"./styles/images/reserves/rewards/additional-briefing-elite-reward-100.png": 3766,
	"./styles/images/reserves/rewards/additional-briefing-elite-reward-50.png": 3767,
	"./styles/images/reserves/rewards/additional-briefing-reward-100.png": 3768,
	"./styles/images/reserves/rewards/additional-briefing-reward-50.png": 3769,
	"./styles/images/reserves/rewards/airstrike-elite-reward-100.png": 3770,
	"./styles/images/reserves/rewards/airstrike-elite-reward-50.png": 3771,
	"./styles/images/reserves/rewards/airstrike-reward-100.png": 3772,
	"./styles/images/reserves/rewards/airstrike-reward-50.png": 3773,
	"./styles/images/reserves/rewards/artillery-strike-elite-reward-100.png": 3774,
	"./styles/images/reserves/rewards/artillery-strike-elite-reward-50.png": 3775,
	"./styles/images/reserves/rewards/artillery-strike-reward-100.png": 3776,
	"./styles/images/reserves/rewards/artillery-strike-reward-50.png": 3777,
	"./styles/images/reserves/rewards/battle-payments-elite-reward-100.png": 3778,
	"./styles/images/reserves/rewards/battle-payments-elite-reward-50.png": 3779,
	"./styles/images/reserves/rewards/battle-payments-reward-100.png": 3780,
	"./styles/images/reserves/rewards/battle-payments-reward-50.png": 3781,
	"./styles/images/reserves/rewards/high-capacity-transport-elite-reward-100.png": 3782,
	"./styles/images/reserves/rewards/high-capacity-transport-elite-reward-50.png": 3783,
	"./styles/images/reserves/rewards/high-capacity-transport-reward-100.png": 3784,
	"./styles/images/reserves/rewards/high-capacity-transport-reward-50.png": 3785,
	"./styles/images/reserves/rewards/inspiration-elite-reward-100.png": 3786,
	"./styles/images/reserves/rewards/inspiration-elite-reward-50.png": 3787,
	"./styles/images/reserves/rewards/inspiration-reward-100.png": 3788,
	"./styles/images/reserves/rewards/inspiration-reward-50.png": 3789,
	"./styles/images/reserves/rewards/military-maneuvers-elite-reward-100.png": 3790,
	"./styles/images/reserves/rewards/military-maneuvers-elite-reward-50.png": 3791,
	"./styles/images/reserves/rewards/military-maneuvers-reward-100.png": 3792,
	"./styles/images/reserves/rewards/military-maneuvers-reward-50.png": 3793,
	"./styles/images/reserves/rewards/requisition-elite-reward-100.png": 3794,
	"./styles/images/reserves/rewards/requisition-elite-reward-50.png": 3795,
	"./styles/images/reserves/rewards/requisition-reward-100.png": 3796,
	"./styles/images/reserves/rewards/requisition-reward-50.png": 3797,
	"./styles/images/reserves/rewards/tactical-training-elite-reward-100.png": 3798,
	"./styles/images/reserves/rewards/tactical-training-elite-reward-50.png": 3799,
	"./styles/images/reserves/rewards/tactical-training-reward-100.png": 3800,
	"./styles/images/reserves/rewards/tactical-training-reward-50.png": 3801,
	"./styles/images/reserves/tactical-training-50.png": 3802,
	"./styles/images/reserves/tactical-training-clan-landing-big.png": 3803,
	"./styles/images/reserves/tactical-training-clan-landing-elite-big.png": 3804,
	"./styles/images/reserves/tactical-training-clan-landing-elite-sm.png": 3805,
	"./styles/images/reserves/tactical-training-clan-landing-sm.png": 3806,
	"./styles/images/reserves/tactical-training-elite-50.png": 3807,
	"./styles/images/reserves/tactical-training-elite.png": 3808,
	"./styles/images/reserves/tactical-training.png": 3809,
	"./styles/images/sortable_header/th-active-left.png": 3810,
	"./styles/images/sortable_header/th-active-right.png": 3811,
	"./styles/images/sortable_header/th-divider.png": 3812,
	"./styles/images/sortable_header/th-hover-left.png": 3813,
	"./styles/images/sortable_header/th-hover-right.png": 3814,
	"./styles/images/sortable_header/th-sort-down.png": 3815,
	"./styles/images/sortable_header/th-sort-up.png": 3816,
	"./styles/images/sortable_header/th-sort.png": 3817,
	"./styles/images/table/table-expand-shadow-bottom.png": 3818,
	"./styles/images/table/table-expand-shadow-top.png": 3819,
	"./styles/images/table/table-head-cell-active-left.png": 3820,
	"./styles/images/table/table-head-cell-active-right.png": 3821,
	"./styles/images/table/table-head-cell-divider.png": 3822,
	"./styles/images/table/table-head-cell-hover-left.png": 3823,
	"./styles/images/table/table-head-cell-hover-right.png": 3824,
	"./styles/images/table/table-head-cell-sort-down.png": 3825,
	"./styles/images/table/table-head-cell-sort-up.png": 3826,
	"./styles/images/table/table-head-divider.png": 3827,
	"./styles/images/table/table-head-shadow.png": 3828,
	"./styles/images/table/table-row-50-expandable-active.png": 3829,
	"./styles/images/table/table-row-50-expandable-hover.png": 3830,
	"./styles/images/table/table-row-divider-expandable-bottom.png": 3831,
	"./styles/images/table/table-row-divider-expandable-top.png": 3832,
	"./styles/images/table/table-row-divider.png": 3833,
	"./styles/images/table/table-row-expandable-active.png": 3834,
	"./styles/images/table/table-row-expandable-arrow.png": 3835,
	"./styles/images/table/table-row-expandable-glow.png": 3836,
	"./styles/images/table/table-row-expandable-hover.png": 3837,
	"./styles/images/table/table-row-expandable-own-left.png": 3838,
	"./styles/images/table/table-row-expandable-own-right.png": 3839,
	"./styles/images/table/table-row-expandable-own.png": 3840,
	"./styles/images/table/table-row-expandable-sparks.png": 3841,
	"./styles/images/table/table-row-own-left.png": 3842,
	"./styles/images/table/table-row-own-right.png": 3843,
	"./styles/images/table/table-row-own.png": 3844,
	"./styles/images/timer/timer_light.png": 3845,
	"./styles/images/tooltip/bg-borders.png": 3846,
	"./styles/images/tooltip/bg-pattern.png": 3847,
	"./styles/images/tooltip/disable-background.png": 3848,
	"./styles/images/tooltip/shadow.png": 3849,
	"./styles/images/vehicles/R146_STG_Tday.png": 3850,
	"./styles/images/vertical-divider.png": 3851
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2488;

/***/ }),
/* 2489 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/ArenaTooltip/images/map-placeholder.158636f3.png";

/***/ }),
/* 2490 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/Back/images/back-hover.04fd723e.png";

/***/ }),
/* 2491 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/Back/images/back.719dda72.png";

/***/ }),
/* 2492 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/Back/images/close-hover.b9d1585b.png";

/***/ }),
/* 2493 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/Back/images/close.92971416.png";

/***/ }),
/* 2494 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/Back/images/info-hover.a0dee0d1.png";

/***/ }),
/* 2495 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/Back/images/info.7e69f346.png";

/***/ }),
/* 2496 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/Back/images/shine-to-left.503ab52a.png";

/***/ }),
/* 2497 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/Back/images/shine-to-right.efd3c166.png";

/***/ }),
/* 2498 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/Back/images/shine.f818f6ce.png";

/***/ }),
/* 2499 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BaseBonusInfoTable/images/dots.d3f86a3b.png";

/***/ }),
/* 2500 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BattleWizard/components/Arenas/images/command-center.09cdeda0.png";

/***/ }),
/* 2501 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BattleWizard/components/Arenas/images/flag.b892cdae.png";

/***/ }),
/* 2502 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BattleWizard/components/Battle/images/bg-fort-battle.25093e9f.png";

/***/ }),
/* 2503 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BattleWizard/components/Battle/images/bg-sortie.93b9e6c2.png";

/***/ }),
/* 2504 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BattleWizard/components/Battle/images/divider.3e512c06.png";

/***/ }),
/* 2505 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BattleWizard/components/BattleTitleTooltip/images/reward-bg.bf95f65f.png";

/***/ }),
/* 2506 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BattleWizard/components/BattleTitleTooltip/images/reward-icon.8a0149fe.png";

/***/ }),
/* 2507 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BattleWizard/components/Direction/images/battle.da7b855f.png";

/***/ }),
/* 2508 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BattleWizard/components/Direction/images/direction-bg-bonus.a820ca31.png";

/***/ }),
/* 2509 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BattleWizard/components/Direction/images/direction-bg.c529ab79.png";

/***/ }),
/* 2510 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BattleWizard/components/Direction/images/direction-icon-A-doubled.13d09d7f.png";

/***/ }),
/* 2511 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BattleWizard/components/Direction/images/direction-icon-A.ed41d27b.png";

/***/ }),
/* 2512 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BattleWizard/components/Direction/images/direction-icon-B-doubled.0191d003.png";

/***/ }),
/* 2513 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BattleWizard/components/Direction/images/direction-icon-B.85994fc8.png";

/***/ }),
/* 2514 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BattleWizard/components/Direction/images/direction-icon-C-doubled.b770bbbd.png";

/***/ }),
/* 2515 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BattleWizard/components/Direction/images/direction-icon-C.46d323aa.png";

/***/ }),
/* 2516 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BattleWizard/components/Direction/images/direction-icon-D-doubled.7e2c7657.png";

/***/ }),
/* 2517 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BattleWizard/components/Direction/images/direction-icon-D.ebc5f587.png";

/***/ }),
/* 2518 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BattleWizard/components/Level/images/level-bg.5b58c8fc.png";

/***/ }),
/* 2519 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BattleWizard/components/Option/images/duration.ed3d7ef9.png";

/***/ }),
/* 2520 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BattleWizard/components/Option/images/legionaries.6d038b6f.png";

/***/ }),
/* 2521 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BattleWizard/components/Option/images/level.311088a4.png";

/***/ }),
/* 2522 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BattleWizard/components/Option/images/players.0116e941.png";

/***/ }),
/* 2523 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BattleWizard/components/Schedule/images/background.ad967184.png";

/***/ }),
/* 2524 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BattleWizard/components/Schedule/images/divider.789452cc.png";

/***/ }),
/* 2525 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BattleWizard/components/Status/images/background.f16e7569.png";

/***/ }),
/* 2526 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BattleWizard/components/UnavailableBattle/images/alert-bg.921f5037.png";

/***/ }),
/* 2527 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BattleWizard/components/UnavailableBattle/images/bg-content.4832e784.png";

/***/ }),
/* 2528 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BattleWizard/components/UnavailableBattle/images/bg-fort-battle.6bcdde16.png";

/***/ }),
/* 2529 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BattleWizard/components/UnavailableBattle/images/bg-sortie.8e8ce6fa.png";

/***/ }),
/* 2530 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BattleWizard/components/UnavailableBattle/images/divider-content.e632c9b4.png";

/***/ }),
/* 2531 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BattleWizard/components/WizardButton/images/body-texture-bonus.0a55ee09.png";

/***/ }),
/* 2532 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BattleWizard/components/WizardButton/images/body-texture-selected.ec0719a5.png";

/***/ }),
/* 2533 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BattleWizard/components/WizardButton/images/body-texture.e87d6317.png";

/***/ }),
/* 2534 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BattleWizard/components/WizardButton/images/border-battle.ad7344ea.png";

/***/ }),
/* 2535 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BattleWizard/components/WizardButton/images/border-bonus-hover.2c2ba265.png";

/***/ }),
/* 2536 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BattleWizard/components/WizardButton/images/border-bonus.814a5e77.png";

/***/ }),
/* 2537 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BattleWizard/components/WizardButton/images/border-hover.d11d7498.png";

/***/ }),
/* 2538 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BattleWizard/components/WizardButton/images/border-normal.9063f468.png";

/***/ }),
/* 2539 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BattleWizard/components/WizardButton/images/border-selected.13870e23.png";

/***/ }),
/* 2540 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BattleWizard/components/WizardButton/images/disabled-pattern.5cf7a388.png";

/***/ }),
/* 2541 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BattleWizard/components/WizardButton/images/overlay.cde4ff60.png";

/***/ }),
/* 2542 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BattleWizard/components/WizardButton/images/ribbon.d347e819.png";

/***/ }),
/* 2543 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BattleWizard/images/background.7d3f33bf.jpg";

/***/ }),
/* 2544 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BattleWizard/images/divider.acd2b194.png";

/***/ }),
/* 2545 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BattleWizard/images/pattern.a72becb8.png";

/***/ }),
/* 2546 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BattleWizard/images/sparks.1906f32e.png";

/***/ }),
/* 2547 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BuildingCardImage/images/arrow/arrow-0-100.a65db5ab.png";

/***/ }),
/* 2548 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BuildingCardImage/images/arrow/arrow-0-50.2f380295.png";

/***/ }),
/* 2549 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BuildingCardImage/images/arrow/arrow-0-75.a5b114a3.png";

/***/ }),
/* 2550 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BuildingCardImage/images/arrow/arrow-1-100.466f283a.png";

/***/ }),
/* 2551 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BuildingCardImage/images/arrow/arrow-1-50.785b4e75.png";

/***/ }),
/* 2552 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BuildingCardImage/images/arrow/arrow-1-75.d10a55a6.png";

/***/ }),
/* 2553 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BuildingCardImage/images/arrow/arrow-2-100.bd037ad9.png";

/***/ }),
/* 2554 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BuildingCardImage/images/arrow/arrow-2-50.fd29fdc2.png";

/***/ }),
/* 2555 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BuildingCardImage/images/arrow/arrow-2-75.6ed57559.png";

/***/ }),
/* 2556 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BuildingCardImage/images/arrow/arrow-3-100.83396274.png";

/***/ }),
/* 2557 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BuildingCardImage/images/arrow/arrow-3-50.80249ed0.png";

/***/ }),
/* 2558 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BuildingCardImage/images/arrow/arrow-3-75.b2cf64c2.png";

/***/ }),
/* 2559 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BuildingCardImage/images/arrow/arrow-4-100.ff70031d.png";

/***/ }),
/* 2560 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BuildingCardImage/images/arrow/arrow-4-50.c156f541.png";

/***/ }),
/* 2561 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BuildingCardImage/images/arrow/arrow-4-75.0510f6ef.png";

/***/ }),
/* 2562 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BuildingCardImage/images/arrow/arrow-base-100.a4e020f8.png";

/***/ }),
/* 2563 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BuildingCardImage/images/arrow/arrow-base-50.82356c3e.png";

/***/ }),
/* 2564 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BuildingCardImage/images/arrow/arrow-base-75.7ee1e66f.png";

/***/ }),
/* 2565 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BuildingCardImage/images/cost-bg-disabled.9f90a21e.png";

/***/ }),
/* 2566 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BuildingCardImage/images/cost-bg.8fb960e2.png";

/***/ }),
/* 2567 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BuildingCardImage/images/max-level-100.fbe7e62e.png";

/***/ }),
/* 2568 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/BuildingCardImage/images/max-level-50.3d8957d8.png";

/***/ }),
/* 2569 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/ButtonInbox/images/button-inbox-new-message.e7be4ed2.png";

/***/ }),
/* 2570 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/ButtonInbox/images/button-inbox.f9965ea5.png";

/***/ }),
/* 2571 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/ButtonLeavingClan/images/button-exit-clan.dba9d05d.png";

/***/ }),
/* 2572 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/ButtonSimple/images/button-simple-external-icon.02c15e55.png";

/***/ }),
/* 2573 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/ButtonTiny/images/default-borders-active.7db2358f.png";

/***/ }),
/* 2574 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/ButtonTiny/images/default-borders-hover.bf638910.png";

/***/ }),
/* 2575 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/ButtonTiny/images/default-borders.2efaeea3.png";

/***/ }),
/* 2576 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/ButtonTiny/images/default-tile-active.6526642a.png";

/***/ }),
/* 2577 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/ButtonTiny/images/default-tile-hover.c022d638.png";

/***/ }),
/* 2578 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/ButtonTiny/images/default-tile.53bd7f2b.png";

/***/ }),
/* 2579 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/ButtonTiny/images/disabled-borders.f27b20fb.png";

/***/ }),
/* 2580 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/ButtonTiny/images/disabled-tile-pattern.8158fe27.png";

/***/ }),
/* 2581 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/ButtonTiny/images/disabled-tile.785bfc3e.png";

/***/ }),
/* 2582 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/ButtonTiny/images/secondary-borders-active.a9b3f618.png";

/***/ }),
/* 2583 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/ButtonTiny/images/secondary-borders-hover.9ec5f568.png";

/***/ }),
/* 2584 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/ButtonTiny/images/secondary-borders.6b8b351e.png";

/***/ }),
/* 2585 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/ButtonTiny/images/secondary-tile-active.f9a9e4d5.png";

/***/ }),
/* 2586 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/ButtonTiny/images/secondary-tile-hover.2fe8101a.png";

/***/ }),
/* 2587 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/ButtonTiny/images/secondary-tile.de05f7ac.png";

/***/ }),
/* 2588 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/ChallengeContent/components/Label/images/label-results.064e7f86.png";

/***/ }),
/* 2589 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/ChallengeContent/components/Label/images/label.d31bdcaa.png";

/***/ }),
/* 2590 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/ChallengeContent/components/Label/images/rhomb.a189106f.png";

/***/ }),
/* 2591 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/ChallengeContent/components/Label/images/wing-left.8a577cc2.png";

/***/ }),
/* 2592 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/ChallengeContent/components/Label/images/wing-right.bbe8813e.png";

/***/ }),
/* 2593 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/ChallengeContent/components/Message/images/glow-position.b3807082.png";

/***/ }),
/* 2594 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/Confirmation/images/background.4716733e.png";

/***/ }),
/* 2595 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/Confirmation/images/close.2100b800.png";

/***/ }),
/* 2596 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/FamePoints/images/icon-fame-points.9a0c9d31.png";

/***/ }),
/* 2597 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/Gamefield/images/gamefield-100.38c93d1c.jpg";

/***/ }),
/* 2598 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/Gamefield/images/gamefield-50.d23908e5.jpg";

/***/ }),
/* 2599 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/Gamefield/images/gamefield-75.33c268b8.jpg";

/***/ }),
/* 2600 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/Gamefield/images/gamefield-external-100.41a23eab.jpg";

/***/ }),
/* 2601 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/Gamefield/images/gamefield-external-50.e4fd7c6b.jpg";

/***/ }),
/* 2602 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/Gamefield/images/gamefield-external-75.6ab48fb6.jpg";

/***/ }),
/* 2603 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/InfoButton/images/info-hover.b7f0bd7e.png";

/***/ }),
/* 2604 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/InfoButton/images/info.ffe123e1.png";

/***/ }),
/* 2605 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/LoadingScreen/images/fullscreen-bg.7ae51fd2.jpg";

/***/ }),
/* 2606 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/LoadingScreen/images/spinner.RU.efe16efc.png";

/***/ }),
/* 2607 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/LoadingScreen/images/spinner.efe16efc.png";

/***/ }),
/* 2608 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/LoadingScreen/images/window-bg.d5357bbb.jpg";

/***/ }),
/* 2609 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/ModernizationOverlay/images/modernization-bg-100.b2573a7e.jpg";

/***/ }),
/* 2610 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/ModernizationOverlay/images/modernization-bg-50.3d74b55d.jpg";

/***/ }),
/* 2611 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/ModernizationOverlay/images/modernization-bg-75.29f63e7d.jpg";

/***/ }),
/* 2612 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/Nation/images/flag-all-china.45f7e865.png";

/***/ }),
/* 2613 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/Nation/images/flag-all-czech.67ac6af3.png";

/***/ }),
/* 2614 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/Nation/images/flag-all-france.65f6681c.png";

/***/ }),
/* 2615 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/Nation/images/flag-all-germany.0ec18359.png";

/***/ }),
/* 2616 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/Nation/images/flag-all-italy.7a15f572.png";

/***/ }),
/* 2617 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/Nation/images/flag-all-japan.9d2758aa.png";

/***/ }),
/* 2618 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/Nation/images/flag-all-poland.20cde1b0.png";

/***/ }),
/* 2619 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/Nation/images/flag-all-sweden.96412065.png";

/***/ }),
/* 2620 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/Nation/images/flag-all-uk.d0ea7ae0.png";

/***/ }),
/* 2621 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/Nation/images/flag-all-usa.e0e4cebb.png";

/***/ }),
/* 2622 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/Nation/images/flag-all-ussr.fb1c1e9c.png";

/***/ }),
/* 2623 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/Nation/images/flag-all.64fe0d30.png";

/***/ }),
/* 2624 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/Nation/images/flag-cn-china.c638cfcb.png";

/***/ }),
/* 2625 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/Nation/images/flag-cn-czech.02004a07.png";

/***/ }),
/* 2626 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/Nation/images/flag-cn-france.a915061b.png";

/***/ }),
/* 2627 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/Nation/images/flag-cn-germany.27302329.png";

/***/ }),
/* 2628 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/Nation/images/flag-cn-italy.acc90fe9.png";

/***/ }),
/* 2629 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/Nation/images/flag-cn-japan.11a5e061.png";

/***/ }),
/* 2630 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/Nation/images/flag-cn-poland.ab82209b.png";

/***/ }),
/* 2631 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/Nation/images/flag-cn-sweden.8375df97.png";

/***/ }),
/* 2632 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/Nation/images/flag-cn-uk.adf7461b.png";

/***/ }),
/* 2633 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/Nation/images/flag-cn-usa.1450446d.png";

/***/ }),
/* 2634 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/Nation/images/flag-cn-ussr.6cc3308e.png";

/***/ }),
/* 2635 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/NavigationArrow/images/arrow-left-disabled-big.66efba67.png";

/***/ }),
/* 2636 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/NavigationArrow/images/arrow-left-disabled-small.574bd947.png";

/***/ }),
/* 2637 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/NavigationArrow/images/arrow-left-disabled-tiny.34cbaa24.png";

/***/ }),
/* 2638 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/NavigationArrow/images/arrow-left-hover-big.05b3acd6.png";

/***/ }),
/* 2639 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/NavigationArrow/images/arrow-left-hover-small.eef29f69.png";

/***/ }),
/* 2640 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/NavigationArrow/images/arrow-left-hover-tiny.3338a231.png";

/***/ }),
/* 2641 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/NavigationArrow/images/arrow-left-normal-big.55a31245.png";

/***/ }),
/* 2642 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/NavigationArrow/images/arrow-left-normal-small.06431dce.png";

/***/ }),
/* 2643 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/NavigationArrow/images/arrow-left-normal-tiny.902b222b.png";

/***/ }),
/* 2644 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/NavigationArrow/images/arrow-right-disabled-big.2be6d748.png";

/***/ }),
/* 2645 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/NavigationArrow/images/arrow-right-disabled-small.cd001a26.png";

/***/ }),
/* 2646 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/NavigationArrow/images/arrow-right-disabled-tiny.5b76fa25.png";

/***/ }),
/* 2647 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/NavigationArrow/images/arrow-right-hover-big.f87bf190.png";

/***/ }),
/* 2648 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/NavigationArrow/images/arrow-right-hover-small.7a9b5dbc.png";

/***/ }),
/* 2649 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/NavigationArrow/images/arrow-right-hover-tiny.ff940b92.png";

/***/ }),
/* 2650 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/NavigationArrow/images/arrow-right-normal-big.76410311.png";

/***/ }),
/* 2651 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/NavigationArrow/images/arrow-right-normal-small.130a5ff4.png";

/***/ }),
/* 2652 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/NavigationArrow/images/arrow-right-normal-tiny.ed22f473.png";

/***/ }),
/* 2653 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/Pagination/PaginationArrowButton/images/pagination-arrow.addab66b.png";

/***/ }),
/* 2654 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/Pagination/PaginationArrowButton/images/pagination-arrow_disable.07a13211.png";

/***/ }),
/* 2655 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/Pagination/PaginationList/PaginationRender/images/item_select.7e09c3c7.png";

/***/ }),
/* 2656 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/Popover/images/arrow-aside.5d9d1601.png";

/***/ }),
/* 2657 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/Popover/images/arrow-top.4c420dd0.png";

/***/ }),
/* 2658 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/ProductionProgress/images/cancel-button-active.6849ded9.png";

/***/ }),
/* 2659 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/ProductionProgress/images/cancel-button-default.f9542de8.png";

/***/ }),
/* 2660 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/ProductionProgress/images/cancel-button-hover.def97a1b.png";

/***/ }),
/* 2661 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/Reserve/images/bg.8f1a287d.png";

/***/ }),
/* 2662 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/ReserveProgress/images/gradient.b123f157.png";

/***/ }),
/* 2663 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/ReserveProgress/images/pattern.499a1591.png";

/***/ }),
/* 2664 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/RewardBox/images/rewardBox.da5b2787.png";

/***/ }),
/* 2665 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/RewardBox/images/small/rewardBox.524e2c86.png";

/***/ }),
/* 2666 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/RewardMoney/images/bonds-large.RU.262438e3.png";

/***/ }),
/* 2667 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/RewardMoney/images/bonds-large.262438e3.png";

/***/ }),
/* 2668 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/RewardMoney/images/bonds-small.RU.b9467749.png";

/***/ }),
/* 2669 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/RewardMoney/images/bonds-small.b9467749.png";

/***/ }),
/* 2670 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/RewardMoney/images/credits-large.9db50770.png";

/***/ }),
/* 2671 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/RewardMoney/images/credits-small.b264a67a.png";

/***/ }),
/* 2672 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/RewardMoney/images/gold-large.3e903b49.png";

/***/ }),
/* 2673 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/RewardMoney/images/gold-small.0f92870d.png";

/***/ }),
/* 2674 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/RewardMoney/images/industrial_resources-large.d636d698.png";

/***/ }),
/* 2675 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/RewardMoney/images/industrial_resources-small.9d3b65d8.png";

/***/ }),
/* 2676 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/TutorialArrow/images/back.b8297e87.png";

/***/ }),
/* 2677 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/TutorialArrow/images/border.2dab0e1f.png";

/***/ }),
/* 2678 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/TutorialArrow/images/tutorial-arrow.fbb1e9b9.png";

/***/ }),
/* 2679 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/UpdateButton/images/update-icon.5276b5be.png";

/***/ }),
/* 2680 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/UpgradeConfirmationView/images/bg.82bedeed.jpg";

/***/ }),
/* 2681 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/UpgradeConfirmationView/images/divider.abe38824.png";

/***/ }),
/* 2682 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/UpgradeConfirmationView/images/radiance/radiance-0.acb29388.png";

/***/ }),
/* 2683 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/UpgradeConfirmationView/images/radiance/radiance-1.40be4897.png";

/***/ }),
/* 2684 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/UpgradeConfirmationView/images/radiance/radiance-10.2ff4cff3.png";

/***/ }),
/* 2685 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/UpgradeConfirmationView/images/radiance/radiance-2.71de4c94.png";

/***/ }),
/* 2686 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/UpgradeConfirmationView/images/radiance/radiance-3.8168591f.png";

/***/ }),
/* 2687 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/UpgradeConfirmationView/images/radiance/radiance-4.e7e647c0.png";

/***/ }),
/* 2688 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/UpgradeConfirmationView/images/radiance/radiance-5.958b1bea.png";

/***/ }),
/* 2689 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/UpgradeConfirmationView/images/radiance/radiance-6.f2fd07f5.png";

/***/ }),
/* 2690 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/UpgradeConfirmationView/images/radiance/radiance-7.bbc5066c.png";

/***/ }),
/* 2691 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/UpgradeConfirmationView/images/radiance/radiance-8.b5b02e4a.png";

/***/ }),
/* 2692 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/UpgradeConfirmationView/images/radiance/radiance-9.bf700e49.png";

/***/ }),
/* 2693 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/UpgradeEffect/images/hover-borders.0d34aba1.png";

/***/ }),
/* 2694 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/UpgradeEffect/images/hover-tile.e4da9181.png";

/***/ }),
/* 2695 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/UpgradeIcon/images/arrow-0.2f95a547.png";

/***/ }),
/* 2696 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/UpgradeIcon/images/arrow-1.0cf7e126.png";

/***/ }),
/* 2697 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/UpgradeIcon/images/arrow-2.1d4992c0.png";

/***/ }),
/* 2698 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/UpgradeIcon/images/arrow-3.625327e7.png";

/***/ }),
/* 2699 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/UpgradeIcon/images/arrow-4.9ae8de99.png";

/***/ }),
/* 2700 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/UpgradeIcon/images/arrow-base.20811f74.png";

/***/ }),
/* 2701 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/VehicleAddToComparison/images/icon-vehicle-add-to-comp.6496ca32.png";

/***/ }),
/* 2702 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/VehicleFilter/images/favourite_vehicles.aca43318.png";

/***/ }),
/* 2703 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/VehicleFilter/images/filter_button_overlay.503e813f.png";

/***/ }),
/* 2704 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/VehicleFilter/images/gear_icon.44b9cb68.png";

/***/ }),
/* 2705 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/VehicleFilterCheckbox/images/vehicle-filter-checkbox-bg.83aa30fb.png";

/***/ }),
/* 2706 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/VehicleFilterCheckbox/images/vehicle-filter-checkbox-check.420eefdb.png";

/***/ }),
/* 2707 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/VehicleFilterSelect/images/select-bg.6095d963.png";

/***/ }),
/* 2708 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/VehicleFilterSelect/images/select-triangle.df16e1bc.png";

/***/ }),
/* 2709 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/VehicleType/images/AT-SPG-prem-tiny.d51601c5.png";

/***/ }),
/* 2710 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/VehicleType/images/AT-SPG-prem.43902b2c.png";

/***/ }),
/* 2711 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/VehicleType/images/AT-SPG-tiny.f13a2bd0.png";

/***/ }),
/* 2712 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/VehicleType/images/AT-SPG.78edf1c9.png";

/***/ }),
/* 2713 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/VehicleType/images/SPG-prem-tiny.430c66d4.png";

/***/ }),
/* 2714 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/VehicleType/images/SPG-prem.f855fa38.png";

/***/ }),
/* 2715 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/VehicleType/images/SPG-tiny.84beaddc.png";

/***/ }),
/* 2716 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/VehicleType/images/SPG.93d23cc1.png";

/***/ }),
/* 2717 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/VehicleType/images/heavyTank-prem-tiny.b457d4d8.png";

/***/ }),
/* 2718 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/VehicleType/images/heavyTank-prem.07e9422b.png";

/***/ }),
/* 2719 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/VehicleType/images/heavyTank-tiny.cdf80a26.png";

/***/ }),
/* 2720 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/VehicleType/images/heavyTank.b6228f13.png";

/***/ }),
/* 2721 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/VehicleType/images/lightTank-prem-tiny.f51e39d7.png";

/***/ }),
/* 2722 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/VehicleType/images/lightTank-prem.0b5d94c6.png";

/***/ }),
/* 2723 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/VehicleType/images/lightTank-tiny.081524e0.png";

/***/ }),
/* 2724 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/VehicleType/images/lightTank.6be7b229.png";

/***/ }),
/* 2725 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/VehicleType/images/mediumTank-prem-tiny.1f34060a.png";

/***/ }),
/* 2726 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/VehicleType/images/mediumTank-prem.a4c30253.png";

/***/ }),
/* 2727 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/VehicleType/images/mediumTank-tiny.a87f9ef4.png";

/***/ }),
/* 2728 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/VehicleType/images/mediumTank.732f9327.png";

/***/ }),
/* 2729 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/WGCWXConfirmation/images/alert.cf2e803a.png";

/***/ }),
/* 2730 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/WGCWXConfirmation/images/alert_light.fdac27de.png";

/***/ }),
/* 2731 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/WGCWXConfirmation/images/error.7fa92cf5.png";

/***/ }),
/* 2732 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/WGCWXConfirmation/images/error_light.5bb90c53.png";

/***/ }),
/* 2733 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/Warning/images/alert.e22d880b.png";

/***/ }),
/* 2734 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/components/Warning/images/warning.6582758b.png";

/***/ }),
/* 2735 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/components/BattleRoomsWrapper/images/header-cn.df72666c.jpg";

/***/ }),
/* 2736 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/components/BattleRoomsWrapper/images/header-sparks.9423f500.png";

/***/ }),
/* 2737 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/components/BattleRoomsWrapper/images/header.15207bbe.jpg";

/***/ }),
/* 2738 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/components/FullSchedule/images/background.710bc7bb.jpg";

/***/ }),
/* 2739 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/components/Squad/components/Vehicle/images/vehicle-slot.59a4769e.png";

/***/ }),
/* 2740 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/components/Squad/images/border-bottom.14af8bd4.png";

/***/ }),
/* 2741 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/components/Squad/images/border-top.285bd122.png";

/***/ }),
/* 2742 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/components/Squad/images/locked-slot.caf70554.png";

/***/ }),
/* 2743 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/components/Squad/images/tr-background.51d94c8e.png";

/***/ }),
/* 2744 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/components/Squad/images/tr-disabled-pattern.5dad720b.png";

/***/ }),
/* 2745 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/components/Tabs/images/background.1be71328.png";

/***/ }),
/* 2746 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/components/Tabs/images/border-left.7f3687d7.png";

/***/ }),
/* 2747 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/components/Tabs/images/border-right.a1c7a9b8.png";

/***/ }),
/* 2748 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/components/Tabs/images/border-top.8cfbd0f9.png";

/***/ }),
/* 2749 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/components/Tabs/images/border.1471238c.png";

/***/ }),
/* 2750 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/components/Tabs/images/highlight.093b4540.png";

/***/ }),
/* 2751 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/components/Tabs/images/overlay-active.0669b98c.png";

/***/ }),
/* 2752 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/components/Tabs/images/overlay-left-active.bd833743.png";

/***/ }),
/* 2753 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/components/Tabs/images/overlay-right-active.d060cc52.png";

/***/ }),
/* 2754 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/components/Tabs/images/overlay.9e7d0603.png";

/***/ }),
/* 2755 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/components/Title/images/calendar-icon.3fe0a5a2.png";

/***/ }),
/* 2756 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/components/UnitPreview/images/unitPreviewBackground.4e73083b.jpg";

/***/ }),
/* 2757 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/components/UnitsList/images/fort-battle-10.282e7938.png";

/***/ }),
/* 2758 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/components/UnitsList/images/sortie-10.cc7114c6.png";

/***/ }),
/* 2759 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/components/UnitsList/images/sortie-6.8e48c671.png";

/***/ }),
/* 2760 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/components/UnitsList/images/sortie-8.524db365.png";

/***/ }),
/* 2761 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/components/UnitsList/images/th-divider.d62acd2a.png";

/***/ }),
/* 2762 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/components/UnitsList/images/thead-border.554b4011.png";

/***/ }),
/* 2763 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/components/UnitsList/images/tr-background.d42a2e15.png";

/***/ }),
/* 2764 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/components/UnitsList/images/tr-hover.b9072325.png";

/***/ }),
/* 2765 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/components/UnitsList/images/tr-select.e9f03180.png";

/***/ }),
/* 2766 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/components/UnitsList/images/tr-subtitle.d58a9b2d.png";

/***/ }),
/* 2767 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/containers/PlayersMatchingView/components/PlayersMatchingButton/images/button_bg.e471313c.png";

/***/ }),
/* 2768 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/containers/PlayersMatchingView/components/Unit/images/squad.9bed90bb.png";

/***/ }),
/* 2769 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/bonuses/bonus_x2.ee16746a.png";

/***/ }),
/* 2770 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/bonuses/bonus_x3.4de7275e.png";

/***/ }),
/* 2771 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/bonuses/bonus_x4.ce14d414.png";

/***/ }),
/* 2772 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/bonuses/bonus_x5.59237f23.png";

/***/ }),
/* 2773 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/closeButton.d094c35b.png";

/***/ }),
/* 2774 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags/china.ebe4df13.png";

/***/ }),
/* 2775 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags/czech.f83e58f1.png";

/***/ }),
/* 2776 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags/france.51a9d872.png";

/***/ }),
/* 2777 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags/germany.f66011fd.png";

/***/ }),
/* 2778 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags/italy.eea42f69.png";

/***/ }),
/* 2779 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags/japan.d8f362c8.png";

/***/ }),
/* 2780 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags/poland.eb749a9d.png";

/***/ }),
/* 2781 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags/sweden.fec24b72.png";

/***/ }),
/* 2782 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags/uk.9006d825.png";

/***/ }),
/* 2783 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags/usa.e110196f.png";

/***/ }),
/* 2784 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags/ussr.409e7468.png";

/***/ }),
/* 2785 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags_CN/china.6cff4119.png";

/***/ }),
/* 2786 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags_CN/czech.862e0438.png";

/***/ }),
/* 2787 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags_CN/france.abed2fa5.png";

/***/ }),
/* 2788 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags_CN/germany.d1d45671.png";

/***/ }),
/* 2789 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags_CN/italy.f26a0678.png";

/***/ }),
/* 2790 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags_CN/japan.6990e7c5.png";

/***/ }),
/* 2791 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags_CN/poland.5c3f7df2.png";

/***/ }),
/* 2792 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags_CN/sweden.23c94cb9.png";

/***/ }),
/* 2793 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags_CN/uk.86d64249.png";

/***/ }),
/* 2794 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags_CN/usa.005934e2.png";

/***/ }),
/* 2795 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/containers/PlayersMatchingView/components/Vehicle/images/flags_CN/ussr.755c5618.png";

/***/ }),
/* 2796 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/containers/PlayersMatchingView/components/WaitingPopover/images/footer_bg.bca3b941.png";

/***/ }),
/* 2797 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/containers/PlayersMatchingView/images/clanUnitsFooter.95eaef97.png";

/***/ }),
/* 2798 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/containers/PlayersMatchingView/images/resetSelectedVehiclesButton.c550d136.png";

/***/ }),
/* 2799 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/containers/PlayersMatchingView/images/resetSelectedVehiclesButton_hover.aa18fe9f.png";

/***/ }),
/* 2800 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/containers/UnitsView/images/vertical-divider.5124223e.png";

/***/ }),
/* 2801 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/containers/UnitsView/images/view-bg.f2bb6110.png";

/***/ }),
/* 2802 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BattleRooms/images/cap.32d3a047.png";

/***/ }),
/* 2803 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BuildingCard/components/ReserveProduce/images/divider-shadowed-mask.74f71462.png";

/***/ }),
/* 2804 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BuildingCard/components/ReserveProduce/images/divider-shadowed.b03075a5.png";

/***/ }),
/* 2805 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BuildingCard/components/ReserveSelect/images/arrow-hover.1341d816.png";

/***/ }),
/* 2806 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BuildingCard/components/ReserveSelect/images/arrow.8eca0d52.png";

/***/ }),
/* 2807 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BuildingCard/components/ReserveSelect/images/bg-pattern.ad0b7beb.png";

/***/ }),
/* 2808 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BuildingsCarousel/images/bg-hover.b7a49d5f.png";

/***/ }),
/* 2809 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BuildingsCarousel/images/bg.7bafe8ef.png";

/***/ }),
/* 2810 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BuildingsCarousel/images/carousel-mask.1ce61256.png";

/***/ }),
/* 2811 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/BuildingsCarousel/images/pattern.d886abc3.png";

/***/ }),
/* 2812 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ChallengeView/components/Leaderboard/images/clan-divider.ed652697.png";

/***/ }),
/* 2813 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ChallengeView/components/Leaderboard/images/footer-divider.58b96321.png";

/***/ }),
/* 2814 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ChallengeView/components/Leaderboard/images/prize-background.deb2605f.png";

/***/ }),
/* 2815 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ChallengeView/components/Leaderboard/images/sparkles.c64cd10c.png";

/***/ }),
/* 2816 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ChallengeView/components/RulesPoints/images/header-divider.71b3523a.png";

/***/ }),
/* 2817 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ChallengeView/images/background-conscription.4badd20d.jpg";

/***/ }),
/* 2818 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ChallengeView/images/background-onslaught.383e5c18.jpg";

/***/ }),
/* 2819 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ChallengeView/images/background-shooting-cn.a9f99b16.jpg";

/***/ }),
/* 2820 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ChallengeView/images/background-shooting.64aef6c7.jpg";

/***/ }),
/* 2821 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ChallengeView/images/background-superiority-cn.bfe72101.jpg";

/***/ }),
/* 2822 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ChallengeView/images/background-superiority.06df19d4.jpg";

/***/ }),
/* 2823 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ChallengeView/images/background.b458456b.jpg";

/***/ }),
/* 2824 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/components/Challenge/images/background-conscription.feed753f.png";

/***/ }),
/* 2825 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/components/Challenge/images/background-onslaught.5c429bfc.png";

/***/ }),
/* 2826 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/components/Challenge/images/background-pattern.c5885081.png";

/***/ }),
/* 2827 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/components/Challenge/images/background-shooting-cn.f39fb804.png";

/***/ }),
/* 2828 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/components/Challenge/images/background-shooting.ad1f7934.png";

/***/ }),
/* 2829 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/components/Challenge/images/background-superiority-cn.946a12f4.png";

/***/ }),
/* 2830 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/components/Challenge/images/background-superiority.5a357819.png";

/***/ }),
/* 2831 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/components/Challenge/images/borders-default.bdaf4b7e.png";

/***/ }),
/* 2832 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/components/Challenge/images/borders-selection-history.f7e9c5f2.png";

/***/ }),
/* 2833 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/components/Challenge/images/borders-selection-prize.71515ddd.png";

/***/ }),
/* 2834 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/components/Challenge/images/borders-selection.94c476df.png";

/***/ }),
/* 2835 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/components/Challenge/images/disabled-pattern.6100355c.png";

/***/ }),
/* 2836 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/components/Challenge/images/glow-bottom.97355d3f.png";

/***/ }),
/* 2837 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/components/Challenge/images/glow-top.816616bd.png";

/***/ }),
/* 2838 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/components/Challenge/images/history-item-divider.8737d7d1.png";

/***/ }),
/* 2839 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/components/Challenge/images/icon-conscription.5b209abf.png";

/***/ }),
/* 2840 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/components/Challenge/images/icon-onslaught.cf0ebd67.png";

/***/ }),
/* 2841 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/components/Challenge/images/icon-shooting.0ec1c65f.png";

/***/ }),
/* 2842 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/components/Challenge/images/icon-superiority.a9a049dd.png";

/***/ }),
/* 2843 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/components/Challenge/images/label.d31bdcaa.png";

/***/ }),
/* 2844 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/components/Challenge/images/sparkles-bottom-conscription.bf283b86.png";

/***/ }),
/* 2845 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/components/Challenge/images/sparkles-bottom-onslaught.d03686d6.png";

/***/ }),
/* 2846 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/components/Challenge/images/sparkles-bottom-shooting.89621d7f.png";

/***/ }),
/* 2847 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/components/Challenge/images/sparkles-bottom-superiority.011a200d.png";

/***/ }),
/* 2848 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/components/Challenge/images/sparkles-top-conscription.76172f4f.png";

/***/ }),
/* 2849 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/components/Challenge/images/sparkles-top-onslaught.4fd472fe.png";

/***/ }),
/* 2850 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/components/Challenge/images/sparkles-top-shooting.f9a27df8.png";

/***/ }),
/* 2851 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/components/Challenge/images/sparkles-top-superiority.f0f7f9f6.png";

/***/ }),
/* 2852 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/components/Status/images/button.ac037659.png";

/***/ }),
/* 2853 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/components/Status/images/button_disabled.3646ca00.png";

/***/ }),
/* 2854 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/components/Status/images/button_hover.df11d3e6.png";

/***/ }),
/* 2855 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/components/Status/images/future_bg.032919ff.png";

/***/ }),
/* 2856 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/components/Status/images/future_right_1.b1a2746b.png";

/***/ }),
/* 2857 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/components/Status/images/future_right_2.0dbb0cee.png";

/***/ }),
/* 2858 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/components/Status/images/gold_bg.2b23ea20.png";

/***/ }),
/* 2859 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/components/Status/images/gold_left_1.8a2dbe3c.png";

/***/ }),
/* 2860 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/components/Status/images/gold_left_2.0eabde1b.png";

/***/ }),
/* 2861 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/components/Status/images/gold_light.7517dea0.png";

/***/ }),
/* 2862 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/components/Status/images/gold_right_1.f2c7c435.png";

/***/ }),
/* 2863 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/components/Status/images/gold_right_2.ebb303ae.png";

/***/ }),
/* 2864 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/components/Status/images/line_light.bb1b0b06.png";

/***/ }),
/* 2865 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/components/Status/images/line_light_wrapped.536c9520.png";

/***/ }),
/* 2866 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/components/Status/images/past_bg.93416fd5.png";

/***/ }),
/* 2867 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/components/Status/images/past_left_1.258e24df.png";

/***/ }),
/* 2868 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/components/Status/images/past_left_2.645c1c98.png";

/***/ }),
/* 2869 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/components/Status/images/past_light.bdfe4c3d.png";

/***/ }),
/* 2870 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/components/Status/images/shadows-tile.8f0110f3.png";

/***/ }),
/* 2871 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/components/Status/images/small_gold_light.7517dea0.png";

/***/ }),
/* 2872 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/images/glow-message.ccceca39.png";

/***/ }),
/* 2873 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/images/header-background.aeac7133.png";

/***/ }),
/* 2874 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Challenges/images/top-shadows-tile.8f0110f3.png";

/***/ }),
/* 2875 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ChallengesPromo/images/places.RU.719a3fcf.png";

/***/ }),
/* 2876 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ChallengesPromo/images/places.719a3fcf.png";

/***/ }),
/* 2877 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ChallengesPromo/images/points.bf4f133b.png";

/***/ }),
/* 2878 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ChallengesPromo/images/rewards.f63dd021.png";

/***/ }),
/* 2879 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ChallengesResults/images/challenges-rewarding-bg.dc929822.jpg";

/***/ }),
/* 2880 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ChallengesResults/images/item-divider.8737d7d1.png";

/***/ }),
/* 2881 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ChallengesResults/images/ribbon.229d73be.png";

/***/ }),
/* 2882 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/AnnouncementsCard/images/announcement_create_icon.521d1d1e.png";

/***/ }),
/* 2883 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/AnnouncementsCard/images/announcement_create_icon_disabled.532abd8f.png";

/***/ }),
/* 2884 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/AnnouncementsCard/images/announcement_footer.8acdbdee.png";

/***/ }),
/* 2885 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/AnnouncementsCard/images/announcement_shadow.f9f6abf0.png";

/***/ }),
/* 2886 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/AnnouncementsCard/images/announcement_view_bg.90b25240.jpg";

/***/ }),
/* 2887 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/AnnouncementsCard/images/announcements_bg.5da8a6ea.jpg";

/***/ }),
/* 2888 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/AnnouncementsCard/images/announcements_bg_big.207394a6.jpg";

/***/ }),
/* 2889 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/AnnouncementsCard/images/announcements_bg_with_quests.77004b8e.jpg";

/***/ }),
/* 2890 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/AnnouncementsCard/images/announcements_bg_with_quests_big.0d40b15f.jpg";

/***/ }),
/* 2891 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/AnnouncementsCard/images/default_news_bg.fddd84e6.jpg";

/***/ }),
/* 2892 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/AnnouncementsCard/images/default_news_bg_big.a46ac225.jpg";

/***/ }),
/* 2893 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/AnnouncementsCard/images/default_news_bg_with_quests.98fcf39a.jpg";

/***/ }),
/* 2894 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/AnnouncementsCard/images/default_news_bg_with_quests_big.00b8bd77.jpg";

/***/ }),
/* 2895 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/AnnouncementsCard/images/external_url_icon.e5fafcb9.png";

/***/ }),
/* 2896 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/AnnouncementsCard/images/external_url_icon_dark.02c15e55.png";

/***/ }),
/* 2897 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/AnnouncementsCard/images/icon_lock.2cea50ab.png";

/***/ }),
/* 2898 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/AnnouncementsCard/images/warning_icon.b6a90e1a.png";

/***/ }),
/* 2899 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/ArcProgressbar/images/arc-progressbar-clan-bg.9e5e9486.png";

/***/ }),
/* 2900 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/ArcProgressbar/images/arc-progressbar-clan-crawl.124cfd7c.png";

/***/ }),
/* 2901 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/ArcProgressbar/images/arc-progressbar-clan-full.c5f61c99.png";

/***/ }),
/* 2902 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/ArcProgressbar/images/arc-progressbar-clan-global-map.e39315ef.png";

/***/ }),
/* 2903 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/ArcProgressbar/images/arc-progressbar-clan-light.ab93a7ee.png";

/***/ }),
/* 2904 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/ArcProgressbar/images/arc-progressbar-clan-squad.7bcfc3ef.png";

/***/ }),
/* 2905 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/ArcProgressbar/images/arc-progressbar-clan-stronghold.751de2cb.png";

/***/ }),
/* 2906 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/ArcProgressbar/images/arc-progressbar-personal-achievement.134dd680.png";

/***/ }),
/* 2907 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/ArcProgressbar/images/arc-progressbar-personal-bg.b84ef042.png";

/***/ }),
/* 2908 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/ArcProgressbar/images/arc-progressbar-personal-damage.80801efd.png";

/***/ }),
/* 2909 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/ArcProgressbar/images/arc-progressbar-personal-delta.4c260d0f.png";

/***/ }),
/* 2910 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/ArcProgressbar/images/arc-progressbar-personal-experience.f3c2b283.png";

/***/ }),
/* 2911 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/ArcProgressbar/images/arc-progressbar-personal-full.5382f7fb.png";

/***/ }),
/* 2912 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/ArcProgressbar/images/arc-progressbar-personal-kill.e6b38dd5.png";

/***/ }),
/* 2913 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/ArcProgressbar/images/arc-progressbar-personal-light.a154471b.png";

/***/ }),
/* 2914 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/ArcProgressbar/images/arc-progressbar-personal-top.859e6c00.png";

/***/ }),
/* 2915 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/ArcProgressbar/images/arc-progressbar-personal-win.30ca8c8f.png";

/***/ }),
/* 2916 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/ArcProgressbar/images/arc-progressbar-quest-first.02db500c.png";

/***/ }),
/* 2917 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/ArcProgressbar/images/arc-progressbar-quest-progress-done.82740762.png";

/***/ }),
/* 2918 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/ArcProgressbar/images/arc-progressbar-quest-progressbar-bg.aa348688.png";

/***/ }),
/* 2919 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/ArcProgressbar/images/arc-progressbar-quest-progressbar.d00d0242.png";

/***/ }),
/* 2920 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/ArcProgressbar/images/arc-progressbar-quest-second.d54f2eda.png";

/***/ }),
/* 2921 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/ArcProgressbar/images/arc-progressbar-quest-spark.32007d60.png";

/***/ }),
/* 2922 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/ArcProgressbar/images/arc-progressbar-quest-third.34d30463.png";

/***/ }),
/* 2923 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/ArcProgressbar/images/icon-complete.4fbacb9f.png";

/***/ }),
/* 2924 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/ArcProgressbar/images/icon-info.f6aa78c1.png";

/***/ }),
/* 2925 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/ArcProgressbar/images/icon-locked.57cf2670.png";

/***/ }),
/* 2926 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/ArcProgressbar/images/icon-pending.8ab67166.png";

/***/ }),
/* 2927 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/ClanLandingReserves/images/background-big.101bb0b8.png";

/***/ }),
/* 2928 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/ClanLandingReserves/images/background-sm.26cb4408.png";

/***/ }),
/* 2929 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/ClanLandingReserves/images/new-reserve-big.9f814420.png";

/***/ }),
/* 2930 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/ClanLandingReserves/images/new-reserve-hover-big.821fdd4d.png";

/***/ }),
/* 2931 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/ClanLandingReserves/images/new-reserve-hover-sm.42ac3291.png";

/***/ }),
/* 2932 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/ClanLandingReserves/images/new-reserve-sm.0a58e080.png";

/***/ }),
/* 2933 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/ClanQuestsTutorial/images/devider.c382870d.png";

/***/ }),
/* 2934 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/ClanQuestsTutorial/images/slide-2-image.f680684d.png";

/***/ }),
/* 2935 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/ClanQuestsTutorial/images/slide-3-image.96c05c96.png";

/***/ }),
/* 2936 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/ClanQuestsTutorial/images/slide-4-image.45fb7d4f.png";

/***/ }),
/* 2937 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/ClanSupplyFooter/images/footer_bg_get_rewards.e53632c4.png";

/***/ }),
/* 2938 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/ClanSupplyFooter/images/footer_bg_get_rewards_large.47a7addf.png";

/***/ }),
/* 2939 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/DisabledCard/images/icon_timer.fd39fa1b.png";

/***/ }),
/* 2940 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/OrangeTimer/images/countdown-less-than-hour.a5fdf339.png";

/***/ }),
/* 2941 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/OrangeTimer/images/expiration-time-icon.3bd8febf.png";

/***/ }),
/* 2942 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/OrangeTimer/images/timer-glow-big.24229aba.png";

/***/ }),
/* 2943 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/OrangeTimer/images/timer-glow-small.2647c539.png";

/***/ }),
/* 2944 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/RewardItem/images/industrial_resource_small.94391564.png";

/***/ }),
/* 2945 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/RewardItem/images/stubs/stub-default.7575e918.png";

/***/ }),
/* 2946 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/TaskItemTooltip/images/icon-attention.82e939b3.png";

/***/ }),
/* 2947 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/TaskItemTooltip/images/icon-info.202460a1.png";

/***/ }),
/* 2948 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/TaskItemTooltip/images/tooltip-background.9322dc0d.png";

/***/ }),
/* 2949 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/components/TextArea/images/disabled_state_pattern.2ab96fca.png";

/***/ }),
/* 2950 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/account-points-icon.7b2ee446.png";

/***/ }),
/* 2951 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/all-rewards-recieved.4fa35642.png";

/***/ }),
/* 2952 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/battle.c94d5146.png";

/***/ }),
/* 2953 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/battle_date_bg.b3ec01c0.png";

/***/ }),
/* 2954 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/card_corner_xN.8828c7bd.png";

/***/ }),
/* 2955 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/clan-points-icon.f1b105fa.png";

/***/ }),
/* 2956 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/clan-quests-not-available.7a960531.png";

/***/ }),
/* 2957 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/clan-quests-reload.87c5611b.png";

/***/ }),
/* 2958 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/clan_quests_background.269a16a1.jpg";

/***/ }),
/* 2959 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/clan_quests_background_big.966d0bca.jpg";

/***/ }),
/* 2960 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/clan_quests_top.72839b68.png";

/***/ }),
/* 2961 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/clan_quests_top_big.5d598a32.png";

/***/ }),
/* 2962 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/clan_supply_progression_background.770a8f1e.png";

/***/ }),
/* 2963 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/clan_supply_progression_background_large.633c1344.png";

/***/ }),
/* 2964 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/clan_supply_quests_background.f0ad462c.png";

/***/ }),
/* 2965 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/clan_supply_quests_background_large.458c063e.png";

/***/ }),
/* 2966 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/clock.14a1b59f.png";

/***/ }),
/* 2967 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/disable_pattern.743e4bdd.png";

/***/ }),
/* 2968 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/divider.6f23aa6b.png";

/***/ }),
/* 2969 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/divider_big.99937f0c.png";

/***/ }),
/* 2970 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/divider_dotty.e019cd99.png";

/***/ }),
/* 2971 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/exclamation.f2642e7a.png";

/***/ }),
/* 2972 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/expiration-time-icon.3bd8febf.png";

/***/ }),
/* 2973 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/external_url_icon.6a7698cf.png";

/***/ }),
/* 2974 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/global_map_bg.eabf93ff.jpg";

/***/ }),
/* 2975 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/global_map_bg_big.29fbbd64.jpg";

/***/ }),
/* 2976 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/global_map_bg_big_cn.f5b233b4.jpg";

/***/ }),
/* 2977 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/global_map_bg_cn.6f81606f.jpg";

/***/ }),
/* 2978 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/global_map_bg_with_news.d7af790a.jpg";

/***/ }),
/* 2979 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/global_map_bg_with_news_big.5ea12434.jpg";

/***/ }),
/* 2980 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/global_map_bg_with_news_big_cn.128c9549.jpg";

/***/ }),
/* 2981 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/global_map_bg_with_news_cn.43c7e429.jpg";

/***/ }),
/* 2982 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/global_map_bg_with_news_with_quests.b6135937.jpg";

/***/ }),
/* 2983 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/global_map_bg_with_news_with_quests_big.ab726e4f.jpg";

/***/ }),
/* 2984 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/global_map_bg_with_news_with_quests_big_cn.0976ea59.jpg";

/***/ }),
/* 2985 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/global_map_bg_with_news_with_quests_cn.adb72080.jpg";

/***/ }),
/* 2986 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/global_map_bg_with_quests.22696479.jpg";

/***/ }),
/* 2987 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/global_map_bg_with_quests_big.5b12ea47.jpg";

/***/ }),
/* 2988 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/global_map_bg_with_quests_big_cn.28f8da47.jpg";

/***/ }),
/* 2989 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/global_map_bg_with_quests_cn.11577d33.jpg";

/***/ }),
/* 2990 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/gold-buyin-button-hover.06748034.png";

/***/ }),
/* 2991 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/gold-buyin-button.3f254a94.png";

/***/ }),
/* 2992 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/icon-progress-done.4fbacb9f.png";

/***/ }),
/* 2993 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/icon-progress-locked.57cf2670.png";

/***/ }),
/* 2994 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/icon-progress-progress.8ab67166.png";

/***/ }),
/* 2995 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/icon_button_clan.587f20bd.png";

/***/ }),
/* 2996 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/icon_button_search.e71f1006.png";

/***/ }),
/* 2997 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/icon_crystal.RU.2fb655b1.png";

/***/ }),
/* 2998 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/icon_crystal.2fb655b1.png";

/***/ }),
/* 2999 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/icon_crystal_small.RU.aaa10536.png";

/***/ }),
/* 3000 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/icon_crystal_small.aaa10536.png";

/***/ }),
/* 3001 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/icon_gold.8fe3bdb4.png";

/***/ }),
/* 3002 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/icon_gold_small.d3f6a683.png";

/***/ }),
/* 3003 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/icon_industrial_resource.6e540fb7.png";

/***/ }),
/* 3004 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/icon_info.42d85ca9.png";

/***/ }),
/* 3005 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/icon_online.6349c09d.png";

/***/ }),
/* 3006 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/icon_online_small.83226d60.png";

/***/ }),
/* 3007 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/icon_plus.b26c49d0.png";

/***/ }),
/* 3008 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/icon_progress_done_new.7858bec7.png";

/***/ }),
/* 3009 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/icon_tourcoin.6fc9d57d.png";

/***/ }),
/* 3010 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/lock.5019d958.png";

/***/ }),
/* 3011 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/main_card_background.0d18962d.jpg";

/***/ }),
/* 3012 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/main_card_background_big.3303a123.jpg";

/***/ }),
/* 3013 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/main_card_background_big_cn.25c417bc.jpg";

/***/ }),
/* 3014 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/main_card_background_cn.dd44a9b9.jpg";

/***/ }),
/* 3015 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/main_card_background_with_quests.35363bdd.jpg";

/***/ }),
/* 3016 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/main_card_background_with_quests_big.81fb2180.jpg";

/***/ }),
/* 3017 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/main_card_background_with_quests_big_cn.821a5431.jpg";

/***/ }),
/* 3018 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/main_card_background_with_quests_cn.84b7653d.jpg";

/***/ }),
/* 3019 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/maneuvers_bg.c49fa6f0.png";

/***/ }),
/* 3020 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/maneuvers_bg_big.22aedefc.png";

/***/ }),
/* 3021 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/maneuvers_bg_with_news.44f9df45.png";

/***/ }),
/* 3022 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/maneuvers_bg_with_news_big.9c682b77.png";

/***/ }),
/* 3023 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/maneuvers_bg_with_news_with_quests.83df0992.png";

/***/ }),
/* 3024 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/maneuvers_bg_with_news_with_quests_big.c178736e.png";

/***/ }),
/* 3025 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/maneuvers_bg_with_quests.c3194cf3.png";

/***/ }),
/* 3026 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/maneuvers_bg_with_quests_big.e2e82935.png";

/***/ }),
/* 3027 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/new_marker.56f6473f.png";

/***/ }),
/* 3028 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/page_marker_active.1ae95189.png";

/***/ }),
/* 3029 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/quests_reload.f8a92659.png";

/***/ }),
/* 3030 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/sparks.23ee42d8.png";

/***/ }),
/* 3031 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/stopped.7e03ffd2.png";

/***/ }),
/* 3032 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/stronghold_bg.9b4bbcbe.jpg";

/***/ }),
/* 3033 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/stronghold_bg_big.08c60506.jpg";

/***/ }),
/* 3034 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/stronghold_bg_with_news.0399d851.jpg";

/***/ }),
/* 3035 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/stronghold_bg_with_news_big.c82430ff.jpg";

/***/ }),
/* 3036 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/stronghold_bg_with_news_with_quests.bc7d4336.jpg";

/***/ }),
/* 3037 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/stronghold_bg_with_news_with_quests_big.4e12a0f0.jpg";

/***/ }),
/* 3038 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/stronghold_bg_with_quests.d1a8e7c9.jpg";

/***/ }),
/* 3039 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/stronghold_bg_with_quests_big.785facf9.jpg";

/***/ }),
/* 3040 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/success-icon.3894b7b7.png";

/***/ }),
/* 3041 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/tank-available-CN.6d74d2ef.png";

/***/ }),
/* 3042 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/tank-not-available-CN.6b3b2802.png";

/***/ }),
/* 3043 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/tooltip-bg.0af9db80.png";

/***/ }),
/* 3044 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/tooltip_bg.d70fa519.png";

/***/ }),
/* 3045 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLanding/images/treasury_separator.c0d3ae8b.png";

/***/ }),
/* 3046 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanLeaving/components/ClanLeavingLayout/images/cl-background.fe900053.jpg";

/***/ }),
/* 3047 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanManagement/components/ClanManagement/images/cm-background-cn.6e1afdf4.jpg";

/***/ }),
/* 3048 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanManagement/components/ClanManagement/images/cm-background.43993f38.jpg";

/***/ }),
/* 3049 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanManagement/components/ClanManagement/images/cm-earned-resource-tooltip-bg.3b50d364.jpg";

/***/ }),
/* 3050 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanManagement/components/ClanManagement/images/cm-earned-resource-tooltip-divider.4ecb688c.jpg";

/***/ }),
/* 3051 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanManagement/components/ClanManagement/images/cm-earned-resource-tooltip-dot.61d058dc.jpg";

/***/ }),
/* 3052 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanManagement/components/ClanManagement/images/cm-earned-resource-tooltip-icons.442f46a9.png";

/***/ }),
/* 3053 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanManagement/components/Dialogs/images/dialog-divider-arrow.39da9c87.png";

/***/ }),
/* 3054 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanManagement/components/Dialogs/images/dialog-divider.09eb7347.png";

/***/ }),
/* 3055 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanManagement/components/MembersControlBlock/images/allocate_treasury.9d2218bb.png";

/***/ }),
/* 3056 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanManagement/components/MembersControlBlock/images/change_role.e41c1d91.png";

/***/ }),
/* 3057 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanManagement/components/MembersControlBlock/images/remove_members.7508563a.png";

/***/ }),
/* 3058 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanPanel/components/BattlesButton/images/active.7d5471ce.png";

/***/ }),
/* 3059 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanPanel/components/BattlesButton/images/glow-bottom.d4656426.png";

/***/ }),
/* 3060 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanPanel/components/BattlesButton/images/glow-top.da715f81.png";

/***/ }),
/* 3061 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanPanel/components/BattlesButton/images/hover.f77e332e.png";

/***/ }),
/* 3062 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanPanel/components/BattlesButton/images/light.094030d1.png";

/***/ }),
/* 3063 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanPanel/components/BattlesButton/images/normal.6fdfe789.png";

/***/ }),
/* 3064 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanPanel/components/BattlesButton/images/primary-active.2efe1095.png";

/***/ }),
/* 3065 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanPanel/components/BattlesButton/images/primary-hover.98508b47.png";

/***/ }),
/* 3066 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanPanel/components/BattlesButton/images/primary-normal.0f35f9bb.png";

/***/ }),
/* 3067 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanPanel/components/BattlesButton/images/schedule.162b23e4.png";

/***/ }),
/* 3068 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanPanel/components/Item/images/active.5234db99.png";

/***/ }),
/* 3069 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanPanel/components/Item/images/hover.23aa01f3.png";

/***/ }),
/* 3070 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanPanel/components/Item/images/icon-challenges.c7d0ec3d.png";

/***/ }),
/* 3071 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanPanel/components/Item/images/icon-crystal.RU.e0f321ad.png";

/***/ }),
/* 3072 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanPanel/components/Item/images/icon-crystal.e0f321ad.png";

/***/ }),
/* 3073 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanPanel/components/Item/images/icon-gold.0a63b9d3.png";

/***/ }),
/* 3074 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanPanel/components/Item/images/icon-industrial.ebd5ae2c.png";

/***/ }),
/* 3075 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanPanel/components/Item/images/icon-journal.c57b4736.png";

/***/ }),
/* 3076 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanPanel/components/Item/images/selected-small.92022356.png";

/***/ }),
/* 3077 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanPanel/components/Item/images/selected.fbbd7188.png";

/***/ }),
/* 3078 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanPanel/components/Item/images/tokens.cd2d0b54.png";

/***/ }),
/* 3079 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanPanel/images/bg-active.d3c14892.png";

/***/ }),
/* 3080 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanPanel/images/bg-pattern-active.6d5f1114.png";

/***/ }),
/* 3081 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanPanel/images/bg-pattern-sparks.ec847266.png";

/***/ }),
/* 3082 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanPanel/images/bg-pattern.774109b4.png";

/***/ }),
/* 3083 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ClanPanel/images/bg.b55204b3.png";

/***/ }),
/* 3084 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/CommandCenterCard/images/ribbon-mask.4982da8a.png";

/***/ }),
/* 3085 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/CommandCenterCard/images/ribbon.675a6521.png";

/***/ }),
/* 3086 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Construct/images/construct-bg-100.d3cf0217.jpg";

/***/ }),
/* 3087 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Construct/images/construct-bg-50.0e317bf0.jpg";

/***/ }),
/* 3088 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Construct/images/construct-bg-75.95a2e04e.jpg";

/***/ }),
/* 3089 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/EloLeaderboard/components/LeaderboardTable/images/battles_28.e022760f.png";

/***/ }),
/* 3090 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/EloLeaderboard/components/LeaderboardTable/images/bottom-panel.0255dced.png";

/***/ }),
/* 3091 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/EloLeaderboard/components/LeaderboardTable/images/divider-pattern.5b7babc2.png";

/***/ }),
/* 3092 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/EloLeaderboard/components/LeaderboardTable/images/elo-icon_10.10f56bd9.png";

/***/ }),
/* 3093 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/EloLeaderboard/components/LeaderboardTable/images/elo-icon_6.c9e22e26.png";

/***/ }),
/* 3094 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/EloLeaderboard/components/LeaderboardTable/images/elo-icon_8.2e5c0efb.png";

/***/ }),
/* 3095 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/EloLeaderboard/components/LeaderboardTable/images/leaderboard-position1.39512c73.png";

/***/ }),
/* 3096 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/EloLeaderboard/components/LeaderboardTable/images/leaderboard-position2.d540189f.png";

/***/ }),
/* 3097 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/EloLeaderboard/components/LeaderboardTable/images/leaderboard-position3.fe54b5df.png";

/***/ }),
/* 3098 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/EloLeaderboard/components/LeaderboardTable/images/winrate_28.bf4b770c.png";

/***/ }),
/* 3099 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/EloLeaderboard/images/leaderboard-leaders-button.d74c9e6f.png";

/***/ }),
/* 3100 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/EloLeaderboard/images/leaderboard_bg.05fb6520.jpg";

/***/ }),
/* 3101 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/EloLeaderboard/images/tab-bg.df50953d.png";

/***/ }),
/* 3102 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/EloLeaderboard/images/tab-bg_disabled.fcb8b539.png";

/***/ }),
/* 3103 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/EloLeaderboard/images/tab-bg_hover.59268b70.png";

/***/ }),
/* 3104 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/EloLeaderboard/images/tab-border_active.bbd33980.png";

/***/ }),
/* 3105 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/EloLeaderboard/images/tab-border_disabled.6685b021.png";

/***/ }),
/* 3106 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Journal/components/ReservesHistory/images/reserve_active.48871730.png";

/***/ }),
/* 3107 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Journal/components/ReservesHistory/images/timer.fc607974.png";

/***/ }),
/* 3108 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Journal/images/background-cn.a2bb2154.jpg";

/***/ }),
/* 3109 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Journal/images/background.70e71406.jpg";

/***/ }),
/* 3110 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Journal/images/update-icon.5276b5be.png";

/***/ }),
/* 3111 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/LandingBonus/images/landing-bonus-ico-gold-large.RU.596d171e.png";

/***/ }),
/* 3112 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/LandingBonus/images/landing-bonus-ico-gold-large.596d171e.png";

/***/ }),
/* 3113 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/LandingBonus/images/landing-bonus-ico-gold-small.RU.cb81706e.png";

/***/ }),
/* 3114 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/LandingBonus/images/landing-bonus-ico-gold-small.cb81706e.png";

/***/ }),
/* 3115 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/LandingBonus/images/landing-bonus-ico-reserve-large.e89ae63d.png";

/***/ }),
/* 3116 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/LandingBonus/images/landing-bonus-ico-reserve-small.9dd6f1e3.png";

/***/ }),
/* 3117 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/LandingBonus/images/landing-bonus-ico-vehicle-large.6febee49.png";

/***/ }),
/* 3118 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/LandingBonus/images/landing-bonus-ico-vehicle-small.38c35ef7.png";

/***/ }),
/* 3119 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/LandingClans/components/Card/components/Back/images/check.c1ab5baf.png";

/***/ }),
/* 3120 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/LandingClans/components/Card/components/Back/images/shadow.775a3a2c.png";

/***/ }),
/* 3121 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/LandingClans/components/Card/components/EnterClan/images/check.c1ab5baf.png";

/***/ }),
/* 3122 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/LandingClans/components/Card/components/EnterClan/images/spinner.0ac30d14.png";

/***/ }),
/* 3123 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/LandingClans/components/Card/components/Front/images/corner.5f857dda.png";

/***/ }),
/* 3124 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/LandingClans/components/Card/components/Stat/images/battles.e51ebfee.png";

/***/ }),
/* 3125 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/LandingClans/components/Card/components/Stat/images/level.84c04f47.png";

/***/ }),
/* 3126 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/LandingClans/components/Card/components/Stat/images/players.569c1e24.png";

/***/ }),
/* 3127 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/LandingClans/components/Card/components/Stat/images/victories.f2e0176f.png";

/***/ }),
/* 3128 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/LandingClans/components/Card/images/sample-emblem.0d5bb16e.png";

/***/ }),
/* 3129 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/LandingClans/components/Filters/components/Language/images/check.872618f3.png";

/***/ }),
/* 3130 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/LandingClans/components/FiltersButton/images/filters.d659dc55.png";

/***/ }),
/* 3131 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/LandingClans/components/Flag/images/landing-clans-languages.f2e64bac.png";

/***/ }),
/* 3132 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/LandingClans/components/Paginator/images/paginator-controls.31476b38.png";

/***/ }),
/* 3133 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/LandingClans/components/SearchControl/images/clear-icon.0adbb37c.png";

/***/ }),
/* 3134 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/LandingClans/components/SearchControl/images/pattern.4a86a5e4.png";

/***/ }),
/* 3135 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/LandingClans/components/SearchControl/images/search-icon.8ab6c047.png";

/***/ }),
/* 3136 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/LandingClans/components/TextPlate/images/pattern.f8225d3d.png";

/***/ }),
/* 3137 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/LandingGlobalMap/images/landing-global-map-small.8be447e9.png";

/***/ }),
/* 3138 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/LandingGlobalMap/images/landing-global-map.f0a28fce.png";

/***/ }),
/* 3139 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/LandingPromo/images/glowing.1636a64a.png";

/***/ }),
/* 3140 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/LandingResult/images/landing-result-award.RU.0061d88a.png";

/***/ }),
/* 3141 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/LandingResult/images/landing-result-award.0061d88a.png";

/***/ }),
/* 3142 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/LandingResult/images/landing-result-award_small.RU.1a8fc158.png";

/***/ }),
/* 3143 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/LandingResult/images/landing-result-award_small.1a8fc158.png";

/***/ }),
/* 3144 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/LandingResult/images/landing-result-bg-image.3e4e591d.jpg";

/***/ }),
/* 3145 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/LandingResult/images/landing-result-light.579c073e.png";

/***/ }),
/* 3146 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/LandingResult/images/landing-result-ribbon.903d452d.png";

/***/ }),
/* 3147 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/LandingStronghold/images/landing-stronghold-small.f03d0b33.png";

/***/ }),
/* 3148 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/LandingStronghold/images/landing-stronghold.bb71667e.png";

/***/ }),
/* 3149 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/LandingToursOfDuty/images/landing-tours-of-duty-small.ecb8f6fe.png";

/***/ }),
/* 3150 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/LandingToursOfDuty/images/landing-tours-of-duty.8beedc92.png";

/***/ }),
/* 3151 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/NextSliderButton/images/next-nav-disabled.7a4594ac.png";

/***/ }),
/* 3152 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/NextSliderButton/images/next-nav-small-disabled.d103166a.png";

/***/ }),
/* 3153 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/NextSliderButton/images/next-nav-small.17ba23d1.png";

/***/ }),
/* 3154 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/NextSliderButton/images/next-nav.53f0c13c.png";

/***/ }),
/* 3155 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/PrevSliderButton/images/prev-nav-disabled.1d98fef6.png";

/***/ }),
/* 3156 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/PrevSliderButton/images/prev-nav-small-disabled.09913e89.png";

/***/ }),
/* 3157 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/PrevSliderButton/images/prev-nav-small.1747f553.png";

/***/ }),
/* 3158 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/components/PrevSliderButton/images/prev-nav.9f290afe.png";

/***/ }),
/* 3159 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/images/landing-battles-bg-cn.ec5066bf.jpg";

/***/ }),
/* 3160 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/images/landing-battles-bg.46fce3f7.jpg";

/***/ }),
/* 3161 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/images/landing-bonus-bg.83af7eba.jpg";

/***/ }),
/* 3162 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/images/landing-clans-bg.83af7eba.jpg";

/***/ }),
/* 3163 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/images/landing-footer-img.5970a0f2.png";

/***/ }),
/* 3164 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/images/landing-footer-top.8457c790.png";

/***/ }),
/* 3165 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/images/landing-global-map.2f3238e4.jpg";

/***/ }),
/* 3166 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/images/landing-promo-bg.53464313.jpg";

/***/ }),
/* 3167 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/images/landing-promo-ribbon.5eb239dc.png";

/***/ }),
/* 3168 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/images/landing-slide-bg-pattern.722bb99e.png";

/***/ }),
/* 3169 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/images/landing-stronghold.d9511697.jpg";

/***/ }),
/* 3170 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/images/landing-tours-of-duty.ec19f3ac.jpg";

/***/ }),
/* 3171 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Landing/images/page_marker_active.0fc3875b.png";

/***/ }),
/* 3172 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/MainMenu/images/mainmenu-item-active-32.0cd46e21.png";

/***/ }),
/* 3173 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/MainMenu/images/mainmenu-item-active-arrow-32.1a65a2aa.png";

/***/ }),
/* 3174 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/MainMenu/images/mainmenu-item-active-arrow.dd7fa117.png";

/***/ }),
/* 3175 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/MainMenu/images/mainmenu-item-active-highlight-32.1eec3c53.png";

/***/ }),
/* 3176 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/MainMenu/images/mainmenu-item-active-highlight.a25a874e.png";

/***/ }),
/* 3177 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/MainMenu/images/mainmenu-item-active-shine-32.cbed9779.png";

/***/ }),
/* 3178 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/MainMenu/images/mainmenu-item-active-shine.07f39054.png";

/***/ }),
/* 3179 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/MainMenu/images/mainmenu-item-active.a07f1ad1.png";

/***/ }),
/* 3180 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/MainMenu/images/mainmenu-item-battle-schedule-32-active.65004319.png";

/***/ }),
/* 3181 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/MainMenu/images/mainmenu-item-battle-schedule-32.3f879cb8.png";

/***/ }),
/* 3182 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/MainMenu/images/mainmenu-item-battle-schedule-64-active.a2730e0b.png";

/***/ }),
/* 3183 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/MainMenu/images/mainmenu-item-battle-schedule-64.fe51d07f.png";

/***/ }),
/* 3184 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/MainMenu/images/mainmenu-item-bonuses-32-active.9aacbc83.png";

/***/ }),
/* 3185 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/MainMenu/images/mainmenu-item-bonuses-32.7b0e5461.png";

/***/ }),
/* 3186 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/MainMenu/images/mainmenu-item-bonuses-64-active.7369748e.png";

/***/ }),
/* 3187 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/MainMenu/images/mainmenu-item-bonuses-64.55ad84cd.png";

/***/ }),
/* 3188 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/MainMenu/images/mainmenu-item-boost-32-active.37ba1ced.png";

/***/ }),
/* 3189 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/MainMenu/images/mainmenu-item-boost-32.9bcab028.png";

/***/ }),
/* 3190 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/MainMenu/images/mainmenu-item-boost-64-active.3a1f36dd.png";

/***/ }),
/* 3191 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/MainMenu/images/mainmenu-item-boost-64.499ae8e3.png";

/***/ }),
/* 3192 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/MainMenu/images/mainmenu-item-craft-32-active.8c61b999.png";

/***/ }),
/* 3193 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/MainMenu/images/mainmenu-item-craft-32.54b26c17.png";

/***/ }),
/* 3194 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/MainMenu/images/mainmenu-item-craft-64-active.ff638dc3.png";

/***/ }),
/* 3195 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/MainMenu/images/mainmenu-item-craft-64.15f68c5b.png";

/***/ }),
/* 3196 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/MainMenu/images/mainmenu-item-leaderboards-32-active.873e679b.png";

/***/ }),
/* 3197 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/MainMenu/images/mainmenu-item-leaderboards-32.a969cef3.png";

/***/ }),
/* 3198 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/MainMenu/images/mainmenu-item-leaderboards-64-active.01abce3b.png";

/***/ }),
/* 3199 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/MainMenu/images/mainmenu-item-leaderboards-64.bd40daab.png";

/***/ }),
/* 3200 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/MainMenu/images/mainmenu-item-rewards-32-active.ed927493.png";

/***/ }),
/* 3201 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/MainMenu/images/mainmenu-item-rewards-32.543c448b.png";

/***/ }),
/* 3202 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/MainMenu/images/mainmenu-item-rewards-64-active.bd17031c.png";

/***/ }),
/* 3203 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/MainMenu/images/mainmenu-item-rewards-64.2de97cc3.png";

/***/ }),
/* 3204 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/MigrationScreen/images/migration.8114efa2.png";

/***/ }),
/* 3205 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/MigrationScreen/images/slide_1.f23f497e.png";

/***/ }),
/* 3206 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/MigrationScreen/images/slide_2.03d0c5c1.png";

/***/ }),
/* 3207 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/MigrationScreen/images/slide_3.5aa8728a.png";

/***/ }),
/* 3208 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/PostbattleScreen/components/BattleList/images/background-defeat.c7dfae66.png";

/***/ }),
/* 3209 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/PostbattleScreen/components/BattleList/images/divider-column.3913c99f.png";

/***/ }),
/* 3210 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/PostbattleScreen/components/BattleList/images/divider-header.96416248.png";

/***/ }),
/* 3211 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/PostbattleScreen/components/BattleList/images/divider-row.76fa4659.png";

/***/ }),
/* 3212 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/PostbattleScreen/components/BattleList/images/divider-shadow.9603bf73.png";

/***/ }),
/* 3213 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/PostbattleScreen/components/Details/images/dots.dcd1575e.png";

/***/ }),
/* 3214 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/PostbattleScreen/components/FortBattleSeries/images/arrow-attack-long-highlight.67748873.png";

/***/ }),
/* 3215 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/PostbattleScreen/components/FortBattleSeries/images/arrow-attack-long.2c309f31.png";

/***/ }),
/* 3216 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/PostbattleScreen/components/FortBattleSeries/images/arrow-attack-short.ecbcc89f.png";

/***/ }),
/* 3217 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/PostbattleScreen/components/FortBattleSeries/images/arrow-defense-long-highlight.9b4fb742.png";

/***/ }),
/* 3218 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/PostbattleScreen/components/FortBattleSeries/images/arrow-defense-long.a58dab37.png";

/***/ }),
/* 3219 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/PostbattleScreen/components/FortBattleSeries/images/arrow-defense-short.cd10da68.png";

/***/ }),
/* 3220 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/PostbattleScreen/components/FortBattleSeries/images/flag-green-current.c64f7624.png";

/***/ }),
/* 3221 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/PostbattleScreen/components/FortBattleSeries/images/flag-green.ef18f07e.png";

/***/ }),
/* 3222 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/PostbattleScreen/components/FortBattleSeries/images/flag-red-current.1c73feb2.png";

/***/ }),
/* 3223 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/PostbattleScreen/components/FortBattleSeries/images/flag-red.50b40208.png";

/***/ }),
/* 3224 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/PostbattleScreen/components/FortBattleSeries/images/line-green-long.b84df943.png";

/***/ }),
/* 3225 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/PostbattleScreen/components/FortBattleSeries/images/line-green-short.d72d664a.png";

/***/ }),
/* 3226 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/PostbattleScreen/components/FortBattleSeries/images/line-red-long.9a502548.png";

/***/ }),
/* 3227 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/PostbattleScreen/components/FortBattleSeries/images/line-red-short.bfe0af69.png";

/***/ }),
/* 3228 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/PostbattleScreen/components/FortBattleSeries/images/stronghold-green-current.c2630967.png";

/***/ }),
/* 3229 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/PostbattleScreen/components/FortBattleSeries/images/stronghold-green.8509b1ad.png";

/***/ }),
/* 3230 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/PostbattleScreen/components/FortBattleSeries/images/stronghold-red-current.3dc21f92.png";

/***/ }),
/* 3231 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/PostbattleScreen/components/FortBattleSeries/images/stronghold-red.ce37c62c.png";

/***/ }),
/* 3232 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/PostbattleScreen/components/Header/images/defeat-background.9d9e90a4.jpg";

/***/ }),
/* 3233 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/PostbattleScreen/components/Header/images/defeat-ribbon.4b0d144d.png";

/***/ }),
/* 3234 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/PostbattleScreen/components/Header/images/draw-background.b0b17466.jpg";

/***/ }),
/* 3235 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/PostbattleScreen/components/Header/images/draw-ribbon.19b18ab5.png";

/***/ }),
/* 3236 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/PostbattleScreen/components/Header/images/victory-background.44bb1d94.jpg";

/***/ }),
/* 3237 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/PostbattleScreen/components/Header/images/victory-ribbon.987f742b.png";

/***/ }),
/* 3238 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/PostbattleScreen/components/Subtitle/images/background.268246f2.png";

/***/ }),
/* 3239 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/PostbattleScreen/components/Tabs/images/postbattle-tabs-background.c7ac4be0.png";

/***/ }),
/* 3240 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/PostbattleScreen/components/Tabs/images/tab-hover.70a37fc1.png";

/***/ }),
/* 3241 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/PostbattleScreen/components/Tabs/images/tab-left.c5290081.png";

/***/ }),
/* 3242 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/PostbattleScreen/components/Tabs/images/tab-right.c67f1d5e.png";

/***/ }),
/* 3243 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/PostbattleScreen/components/Tabs/images/tab-selected-left.61385203.png";

/***/ }),
/* 3244 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/PostbattleScreen/components/Tabs/images/tab-selected-right.c93165f8.png";

/***/ }),
/* 3245 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/PostbattleScreen/images/background.ab2b830b.png";

/***/ }),
/* 3246 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Schedule/images/background.5a75d115.jpg";

/***/ }),
/* 3247 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Schedule/images/calendar_button-hover.36c76892.png";

/***/ }),
/* 3248 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Schedule/images/calendar_button_background.a18b3784.png";

/***/ }),
/* 3249 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Schedule/images/calendar_item_selected_shadow.3e7cb7c0.png";

/***/ }),
/* 3250 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Schedule/images/challenges_icon.14987551.png";

/***/ }),
/* 3251 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Schedule/images/halo_bottom.6027fecc.png";

/***/ }),
/* 3252 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Schedule/images/halo_top.819b8d9f.png";

/***/ }),
/* 3253 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Schedule/images/schedule_table-shadow.3e9bd7fc.png";

/***/ }),
/* 3254 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Schedule/images/schedule_table_bar-dark_gray_translucent.75dff453.png";

/***/ }),
/* 3255 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Schedule/images/schedule_table_bar-dark_green.6da63bd0.png";

/***/ }),
/* 3256 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Schedule/images/schedule_table_bar-light_green.f68a93b5.png";

/***/ }),
/* 3257 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Schedule/images/schedule_table_bar-orange.0c6c3afe.png";

/***/ }),
/* 3258 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Schedule/images/time_line.ed4c68fb.png";

/***/ }),
/* 3259 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ShopView/containers/ShopCongratulationScreen/images/highlight.b733d0dc.png";

/***/ }),
/* 3260 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ShopView/containers/ShopErrorScreen/images/error-icon.bef74211.png";

/***/ }),
/* 3261 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/ShopView/containers/ShopErrorScreen/images/icon-highlight.32acf482.png";

/***/ }),
/* 3262 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ClanInfoPanel/images/bg.89c9b2ef.jpg";

/***/ }),
/* 3263 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ClanInfoPanel/images/divider.d5811861.png";

/***/ }),
/* 3264 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ClanInfoPanel/images/elo-icon-10.a4eee692.png";

/***/ }),
/* 3265 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ClanInfoPanel/images/elo-icon-6.e712f727.png";

/***/ }),
/* 3266 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ClanInfoPanel/images/elo-icon-8.a1c48724.png";

/***/ }),
/* 3267 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ClanInfoPanel/images/pattern-left.5e767129.jpg";

/***/ }),
/* 3268 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ClanInfoPanel/images/pattern-right.214deea4.jpg";

/***/ }),
/* 3269 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ClanInfoPanel/images/shadow.6273dfb0.png";

/***/ }),
/* 3270 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/CommandCenter/images/command-center-lvl1-100.dab69f7f.png";

/***/ }),
/* 3271 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/CommandCenter/images/command-center-lvl1-50.423c0bd8.png";

/***/ }),
/* 3272 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/CommandCenter/images/command-center-lvl1-75.da537138.png";

/***/ }),
/* 3273 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/CommandCenter/images/command-center-lvl2-100.a39ef10b.png";

/***/ }),
/* 3274 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/CommandCenter/images/command-center-lvl2-50.6f81227c.png";

/***/ }),
/* 3275 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/CommandCenter/images/command-center-lvl2-75.8ddff834.png";

/***/ }),
/* 3276 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/CommandCenter/images/command-center-lvl3-100.576406ad.png";

/***/ }),
/* 3277 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/CommandCenter/images/command-center-lvl3-50.1b2dae7b.png";

/***/ }),
/* 3278 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/CommandCenter/images/command-center-lvl3-75.a83c1114.png";

/***/ }),
/* 3279 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/artillery-battalion-lvl1-100.5812d27a.png";

/***/ }),
/* 3280 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/artillery-battalion-lvl1-50.90f3fdc3.png";

/***/ }),
/* 3281 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/artillery-battalion-lvl1-75.dc23d177.png";

/***/ }),
/* 3282 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/artillery-battalion-lvl2-100.e3cf87e4.png";

/***/ }),
/* 3283 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/artillery-battalion-lvl2-50.7d3b0476.png";

/***/ }),
/* 3284 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/artillery-battalion-lvl2-75.01ef6ce6.png";

/***/ }),
/* 3285 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/artillery-battalion-lvl3-100.34a6c424.png";

/***/ }),
/* 3286 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/artillery-battalion-lvl3-50.9c87c3bb.png";

/***/ }),
/* 3287 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/artillery-battalion-lvl3-75.25d754f3.png";

/***/ }),
/* 3288 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/attack-bomber-squadrons-lvl1-100.e21623fa.png";

/***/ }),
/* 3289 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/attack-bomber-squadrons-lvl1-50.b99b910b.png";

/***/ }),
/* 3290 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/attack-bomber-squadrons-lvl1-75.abcc4c52.png";

/***/ }),
/* 3291 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/attack-bomber-squadrons-lvl2-100.3f09764c.png";

/***/ }),
/* 3292 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/attack-bomber-squadrons-lvl2-50.057e5170.png";

/***/ }),
/* 3293 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/attack-bomber-squadrons-lvl2-75.f8d904f7.png";

/***/ }),
/* 3294 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/attack-bomber-squadrons-lvl3-100.27356fbe.png";

/***/ }),
/* 3295 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/attack-bomber-squadrons-lvl3-50.914470e3.png";

/***/ }),
/* 3296 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/attack-bomber-squadrons-lvl3-75.f9033d32.png";

/***/ }),
/* 3297 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/financial-unit-lvl1-100.758413b4.png";

/***/ }),
/* 3298 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/financial-unit-lvl1-50.ab3caf0b.png";

/***/ }),
/* 3299 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/financial-unit-lvl1-75.de053f7d.png";

/***/ }),
/* 3300 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/financial-unit-lvl2-100.2b773014.png";

/***/ }),
/* 3301 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/financial-unit-lvl2-50.a4dcbcc3.png";

/***/ }),
/* 3302 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/financial-unit-lvl2-75.165e4172.png";

/***/ }),
/* 3303 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/financial-unit-lvl3-100.57d01cfa.png";

/***/ }),
/* 3304 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/financial-unit-lvl3-50.6ce18337.png";

/***/ }),
/* 3305 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/financial-unit-lvl3-75.3a08252e.png";

/***/ }),
/* 3306 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/gears-shadow.be46d250.png";

/***/ }),
/* 3307 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/gears-static.f965050a.png";

/***/ }),
/* 3308 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/home-front-service-lvl1-100.b4b9de58.png";

/***/ }),
/* 3309 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/home-front-service-lvl1-50.3b078afa.png";

/***/ }),
/* 3310 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/home-front-service-lvl1-75.11049270.png";

/***/ }),
/* 3311 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/home-front-service-lvl2-100.c35f8e5b.png";

/***/ }),
/* 3312 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/home-front-service-lvl2-50.d3b8cb20.png";

/***/ }),
/* 3313 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/home-front-service-lvl2-75.f162f9b6.png";

/***/ }),
/* 3314 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/home-front-service-lvl3-100.7f7e8c7a.png";

/***/ }),
/* 3315 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/home-front-service-lvl3-50.3e0654ea.png";

/***/ }),
/* 3316 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/home-front-service-lvl3-75.1234c055.png";

/***/ }),
/* 3317 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/military-school-lvl1-100.acd94b0f.png";

/***/ }),
/* 3318 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/military-school-lvl1-50.cb1425ad.png";

/***/ }),
/* 3319 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/military-school-lvl1-75.37acf197.png";

/***/ }),
/* 3320 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/military-school-lvl2-100.3bb81c89.png";

/***/ }),
/* 3321 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/military-school-lvl2-50.4e954ce2.png";

/***/ }),
/* 3322 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/military-school-lvl2-75.32bab6a3.png";

/***/ }),
/* 3323 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/military-school-lvl3-100.8a7bd785.png";

/***/ }),
/* 3324 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/military-school-lvl3-50.e5ede137.png";

/***/ }),
/* 3325 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/military-school-lvl3-75.95cbe8d7.png";

/***/ }),
/* 3326 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/smoke.6786efb1.png";

/***/ }),
/* 3327 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/tankodrome-lvl1-100.8bf1fce6.png";

/***/ }),
/* 3328 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/tankodrome-lvl1-50.5216b6b2.png";

/***/ }),
/* 3329 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/tankodrome-lvl1-75.a0dacf52.png";

/***/ }),
/* 3330 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/tankodrome-lvl2-100.1643ff84.png";

/***/ }),
/* 3331 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/tankodrome-lvl2-50.a6b97b43.png";

/***/ }),
/* 3332 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/tankodrome-lvl2-75.ccea1d7a.png";

/***/ }),
/* 3333 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/tankodrome-lvl3-100.2fd18b5d.png";

/***/ }),
/* 3334 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/tankodrome-lvl3-50.94b14ef7.png";

/***/ }),
/* 3335 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/tankodrome-lvl3-75.62c282c1.png";

/***/ }),
/* 3336 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/training-unit-lvl1-100.f237f3c3.png";

/***/ }),
/* 3337 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/training-unit-lvl1-50.14e81e5c.png";

/***/ }),
/* 3338 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/training-unit-lvl1-75.11d54303.png";

/***/ }),
/* 3339 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/training-unit-lvl2-100.93bb28c7.png";

/***/ }),
/* 3340 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/training-unit-lvl2-50.edd665b9.png";

/***/ }),
/* 3341 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/training-unit-lvl2-75.c91c0c2a.png";

/***/ }),
/* 3342 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/training-unit-lvl3-100.269b6d9a.png";

/***/ }),
/* 3343 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/training-unit-lvl3-50.fd47c9b1.png";

/***/ }),
/* 3344 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/training-unit-lvl3-75.44504b8e.png";

/***/ }),
/* 3345 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/transportation-unit-lvl1-100.122d2cfb.png";

/***/ }),
/* 3346 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/transportation-unit-lvl1-50.a7209284.png";

/***/ }),
/* 3347 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/transportation-unit-lvl1-75.53b9b1a1.png";

/***/ }),
/* 3348 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/transportation-unit-lvl2-100.74eb33c3.png";

/***/ }),
/* 3349 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/transportation-unit-lvl2-50.525d650e.png";

/***/ }),
/* 3350 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/transportation-unit-lvl2-75.359f41d2.png";

/***/ }),
/* 3351 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/transportation-unit-lvl3-100.51ee39a6.png";

/***/ }),
/* 3352 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/transportation-unit-lvl3-50.d15aaec0.png";

/***/ }),
/* 3353 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/transportation-unit-lvl3-75.fac54217.png";

/***/ }),
/* 3354 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/trophy-brigade-lvl1-100.ab49e26e.png";

/***/ }),
/* 3355 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/trophy-brigade-lvl1-50.51f96b28.png";

/***/ }),
/* 3356 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/trophy-brigade-lvl1-75.65ef1c34.png";

/***/ }),
/* 3357 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/trophy-brigade-lvl2-100.d5949e42.png";

/***/ }),
/* 3358 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/trophy-brigade-lvl2-50.e27478c1.png";

/***/ }),
/* 3359 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/trophy-brigade-lvl2-75.48293850.png";

/***/ }),
/* 3360 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/trophy-brigade-lvl3-100.f28da35a.png";

/***/ }),
/* 3361 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/trophy-brigade-lvl3-50.cc59fb9c.png";

/***/ }),
/* 3362 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Building/images/trophy-brigade-lvl3-75.46719d9e.png";

/***/ }),
/* 3363 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Slot/images/slot-100.cdc3efd5.png";

/***/ }),
/* 3364 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Slot/images/slot-50.a332f80d.png";

/***/ }),
/* 3365 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Slot/images/slot-75.de628ecb.png";

/***/ }),
/* 3366 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Slot/images/slot-icon-100.5a73364f.png";

/***/ }),
/* 3367 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/components/Slot/images/slot-icon-75.1e95017b.png";

/***/ }),
/* 3368 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/images/direction-A-lvl1-100.7cbe338b.png";

/***/ }),
/* 3369 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/images/direction-A-lvl1-50.8e0ef50c.png";

/***/ }),
/* 3370 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/images/direction-A-lvl1-75.9138d05c.png";

/***/ }),
/* 3371 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/images/direction-A-lvl2-100.bcbb24d7.png";

/***/ }),
/* 3372 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/images/direction-A-lvl2-50.dd5c461c.png";

/***/ }),
/* 3373 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/images/direction-A-lvl2-75.a3983b93.png";

/***/ }),
/* 3374 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/images/direction-A-lvl3-100.ea645d08.png";

/***/ }),
/* 3375 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/images/direction-A-lvl3-50.fac04f87.png";

/***/ }),
/* 3376 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/images/direction-A-lvl3-75.cd1f4c49.png";

/***/ }),
/* 3377 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/images/direction-B-lvl1-100.18243d8f.png";

/***/ }),
/* 3378 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/images/direction-B-lvl1-50.f5fbba13.png";

/***/ }),
/* 3379 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/images/direction-B-lvl1-75.f69de2d5.png";

/***/ }),
/* 3380 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/images/direction-B-lvl2-100.649addef.png";

/***/ }),
/* 3381 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/images/direction-B-lvl2-50.d7de4717.png";

/***/ }),
/* 3382 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/images/direction-B-lvl2-75.511f0a73.png";

/***/ }),
/* 3383 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/images/direction-B-lvl3-100.2a57b2c0.png";

/***/ }),
/* 3384 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/images/direction-B-lvl3-50.80129260.png";

/***/ }),
/* 3385 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/images/direction-B-lvl3-75.1b1a98d9.png";

/***/ }),
/* 3386 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/images/direction-C-lvl1-100.fb7490ad.png";

/***/ }),
/* 3387 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/images/direction-C-lvl1-50.e580e43e.png";

/***/ }),
/* 3388 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/images/direction-C-lvl1-75.908c181a.png";

/***/ }),
/* 3389 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/images/direction-C-lvl2-100.3f5b51df.png";

/***/ }),
/* 3390 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/images/direction-C-lvl2-50.7c9a9368.png";

/***/ }),
/* 3391 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/images/direction-C-lvl2-75.23879022.png";

/***/ }),
/* 3392 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/images/direction-C-lvl3-100.875a68c9.png";

/***/ }),
/* 3393 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/images/direction-C-lvl3-50.87ba6068.png";

/***/ }),
/* 3394 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/images/direction-C-lvl3-75.9886698a.png";

/***/ }),
/* 3395 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/images/direction-D-lvl1-100.742cdc71.png";

/***/ }),
/* 3396 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/images/direction-D-lvl1-50.070a194d.png";

/***/ }),
/* 3397 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/images/direction-D-lvl1-75.929b65f6.png";

/***/ }),
/* 3398 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/images/direction-D-lvl2-100.b5b3d1d1.png";

/***/ }),
/* 3399 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/images/direction-D-lvl2-50.0e371191.png";

/***/ }),
/* 3400 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/images/direction-D-lvl2-75.6c24348c.png";

/***/ }),
/* 3401 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/images/direction-D-lvl3-100.124b26cc.png";

/***/ }),
/* 3402 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/images/direction-D-lvl3-50.e170784a.png";

/***/ }),
/* 3403 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/Direction/images/direction-D-lvl3-75.0d10982c.png";

/***/ }),
/* 3404 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/RatingLabel/images/stronghold_rating_label_bg-disabled.65e83507.png";

/***/ }),
/* 3405 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/RatingLabel/images/stronghold_rating_label_bg-hover.6c2c8836.png";

/***/ }),
/* 3406 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/RatingLabel/images/stronghold_rating_label_bg.3ca30542.png";

/***/ }),
/* 3407 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ReserveActivationPopover/images/active-background.a89c869d.png";

/***/ }),
/* 3408 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ReserveActivationPopover/images/disabled-pattern.c5ff23b4.png";

/***/ }),
/* 3409 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ReserveActivationPopover/images/divider-bottom.655e8ee4.png";

/***/ }),
/* 3410 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ReserveActivationPopover/images/divider.eb028e92.png";

/***/ }),
/* 3411 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ReserveActivationTimer/images/timer.c0b9fab8.png";

/***/ }),
/* 3412 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ReserveButton/images/battle-disabled-hover-50.0b54b0da.png";

/***/ }),
/* 3413 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ReserveButton/images/battle-disabled-hover.572f4df4.png";

/***/ }),
/* 3414 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ReserveButton/images/battle-disabled-normal-50.60f03366.png";

/***/ }),
/* 3415 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ReserveButton/images/battle-disabled-normal.de626c2e.png";

/***/ }),
/* 3416 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ReserveButton/images/battle-hover-50.d1a2e213.png";

/***/ }),
/* 3417 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ReserveButton/images/battle-hover.041c9953.png";

/***/ }),
/* 3418 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ReserveButton/images/battle-normal-50.5763cf24.png";

/***/ }),
/* 3419 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ReserveButton/images/battle-normal.5f89c8f3.png";

/***/ }),
/* 3420 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ReserveButton/images/battle-selected-50.a88d818e.png";

/***/ }),
/* 3421 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ReserveButton/images/battle-selected.6291a386.png";

/***/ }),
/* 3422 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ReserveButton/images/battle-stack-50.7fb8b85d.png";

/***/ }),
/* 3423 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ReserveButton/images/battle-stack.f5e5caa1.png";

/***/ }),
/* 3424 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ReserveButton/images/battle-unique-disabled-hover.95289dce.png";

/***/ }),
/* 3425 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ReserveButton/images/battle-unique-disabled-normal.0d21c42e.png";

/***/ }),
/* 3426 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ReserveButton/images/battle-unique-hover.92305545.png";

/***/ }),
/* 3427 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ReserveButton/images/battle-unique-normal.b67a968c.png";

/***/ }),
/* 3428 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ReserveButton/images/economics-active-hover-50.12aaef01.png";

/***/ }),
/* 3429 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ReserveButton/images/economics-active-hover.26890f79.png";

/***/ }),
/* 3430 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ReserveButton/images/economics-active-normal-50.e892a0de.png";

/***/ }),
/* 3431 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ReserveButton/images/economics-active-normal.97a7505d.png";

/***/ }),
/* 3432 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ReserveButton/images/economics-disabled-hover-50.3931c8ed.png";

/***/ }),
/* 3433 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ReserveButton/images/economics-disabled-hover.ce901a41.png";

/***/ }),
/* 3434 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ReserveButton/images/economics-disabled-normal-50.447ef69f.png";

/***/ }),
/* 3435 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ReserveButton/images/economics-disabled-normal.274f3a33.png";

/***/ }),
/* 3436 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ReserveButton/images/economics-hover-50.1fd9b96d.png";

/***/ }),
/* 3437 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ReserveButton/images/economics-hover.c373f852.png";

/***/ }),
/* 3438 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ReserveButton/images/economics-normal-50.0610f664.png";

/***/ }),
/* 3439 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ReserveButton/images/economics-normal.70667a1e.png";

/***/ }),
/* 3440 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ReserveButton/images/economics-selected-50.1e736a0c.png";

/***/ }),
/* 3441 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ReserveButton/images/economics-selected.5adcd02e.png";

/***/ }),
/* 3442 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ReserveButton/images/economics-stack-50.3a32b490.png";

/***/ }),
/* 3443 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ReserveButton/images/economics-stack.fa3926b1.png";

/***/ }),
/* 3444 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ReserveButton/images/gold-disabled-hover-50.09609bf7.png";

/***/ }),
/* 3445 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ReserveButton/images/gold-disabled-normal-50.fe6e46da.png";

/***/ }),
/* 3446 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ReserveButton/images/gold-hover-50.003f2356.png";

/***/ }),
/* 3447 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/Stronghold/components/ReserveButton/images/gold-normal-50.04b10b98.png";

/***/ }),
/* 3448 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/StrongholdExternal/components/Statistics/images/elo-icon-10.c1f78890.png";

/***/ }),
/* 3449 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/StrongholdExternal/components/Statistics/images/elo-icon-6.bf5b62b6.png";

/***/ }),
/* 3450 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/StrongholdExternal/components/Statistics/images/elo-icon-8.96d11c2c.png";

/***/ }),
/* 3451 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/WGCWXBattleSchedule/images/background_vehicles_dark.926914bb.jpg";

/***/ }),
/* 3452 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/WGCWXLeaderboards/components/Footer/images/button_bg.de545059.png";

/***/ }),
/* 3453 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/WGCWXLeaderboards/components/Footer/images/button_top.ce8d15a5.png";

/***/ }),
/* 3454 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/WGCWXLeaderboards/components/Footer/images/ok.6bc1362f.png";

/***/ }),
/* 3455 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/WGCWXLeaderboards/components/Footer/images/ribbon.0b53ecf8.png";

/***/ }),
/* 3456 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/WGCWXLeaderboards/components/Footer/images/ribbon_bg.3e496bc7.png";

/***/ }),
/* 3457 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/WGCWXLeaderboards/components/RatingCard/images/divider_dotty.9ffa50bb.png";

/***/ }),
/* 3458 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/WGCWXLeaderboards/components/RatingCard/images/light.8e36288c.png";

/***/ }),
/* 3459 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/WGCWXLeaderboards/components/RatingCard/images/union.6f1ac3a0.png";

/***/ }),
/* 3460 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/WGCWXLeaderboards/components/RatingCard/images/union_no_position.fb4e07bd.png";

/***/ }),
/* 3461 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/WGCWXLeaderboards/components/Reward/images/rewards/decal.a0d1e675.png";

/***/ }),
/* 3462 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/WGCWXLeaderboards/components/Reward/images/rewards/emblem.e9bc22d5.png";

/***/ }),
/* 3463 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/WGCWXLeaderboards/components/Reward/images/rewards/medal_elite.d7f27a2a.png";

/***/ }),
/* 3464 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/WGCWXLeaderboards/components/Reward/images/rewards/medal_first.c1ef8637.png";

/***/ }),
/* 3465 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/WGCWXLeaderboards/components/Reward/images/rewards/medal_second.f7781570.png";

/***/ }),
/* 3466 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/WGCWXLeaderboards/components/Reward/images/rewards/medal_third.255e8ccf.png";

/***/ }),
/* 3467 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/WGCWXLeaderboards/components/Reward/images/rewards/medal_veteran.780a0e9b.png";

/***/ }),
/* 3468 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/WGCWXLeaderboards/components/Reward/images/rewards/small/decal.528a12a2.png";

/***/ }),
/* 3469 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/WGCWXLeaderboards/components/Reward/images/rewards/small/emblem.6239111e.png";

/***/ }),
/* 3470 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/WGCWXLeaderboards/components/Reward/images/rewards/small/medal_elite.1f672672.png";

/***/ }),
/* 3471 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/WGCWXLeaderboards/components/Reward/images/rewards/small/medal_first.1487221e.png";

/***/ }),
/* 3472 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/WGCWXLeaderboards/components/Reward/images/rewards/small/medal_second.40f195de.png";

/***/ }),
/* 3473 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/WGCWXLeaderboards/components/Reward/images/rewards/small/medal_third.a4e5e18e.png";

/***/ }),
/* 3474 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/WGCWXLeaderboards/components/Reward/images/rewards/small/medal_veteran.f590f330.png";

/***/ }),
/* 3475 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/WGCWXLeaderboards/components/Reward/images/rewards/small/style.0c5e00dc.png";

/***/ }),
/* 3476 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/WGCWXLeaderboards/components/Reward/images/rewards/style.9e237f2e.png";

/***/ }),
/* 3477 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/WGCWXLeaderboards/images/background_vehicles_dark.290d1499.jpg";

/***/ }),
/* 3478 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/WGCWXLeaderboards/images/external_url_icon.9c099781.png";

/***/ }),
/* 3479 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/WGCWXLeaderboards/images/light_left.9a812f4f.png";

/***/ }),
/* 3480 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/containers/WGCWXLeaderboards/images/light_right.0435424e.png";

/***/ }),
/* 3481 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/core/components/button/images/default-active-bg-left.c5a8c277.png";

/***/ }),
/* 3482 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/core/components/button/images/default-active-bg-right.eb8ab708.png";

/***/ }),
/* 3483 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/core/components/button/images/default-active-bg.3b972020.png";

/***/ }),
/* 3484 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/core/components/button/images/default-bg-left.b96cb06a.png";

/***/ }),
/* 3485 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/core/components/button/images/default-bg-right.5417dabc.png";

/***/ }),
/* 3486 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/core/components/button/images/default-bg.519d1247.png";

/***/ }),
/* 3487 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/core/components/button/images/default-hover-bg-left.c0b03bde.png";

/***/ }),
/* 3488 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/core/components/button/images/default-hover-bg-right.89bea18a.png";

/***/ }),
/* 3489 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/core/components/button/images/default-hover-bg.c2a047e2.png";

/***/ }),
/* 3490 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/core/components/button/images/disabled-pattern.489bad11.png";

/***/ }),
/* 3491 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/core/components/button/images/shadow.9781fccd.png";

/***/ }),
/* 3492 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/battlerooms_bg.6694bade.jpg";

/***/ }),
/* 3493 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/building-card/building-card-bg-100.2cc8db88.jpg";

/***/ }),
/* 3494 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/building-card/building-card-bg-50.153b9c5f.jpg";

/***/ }),
/* 3495 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/building-card/building-card-bg-75.a2917ce1.jpg";

/***/ }),
/* 3496 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/artillery-battalion-lvl1-100.ec9d12bd.png";

/***/ }),
/* 3497 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/artillery-battalion-lvl1-50.555c26f0.png";

/***/ }),
/* 3498 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/artillery-battalion-lvl1-75.8c428335.png";

/***/ }),
/* 3499 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/artillery-battalion-lvl2-100.cd1dc052.png";

/***/ }),
/* 3500 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/artillery-battalion-lvl2-50.c8462dda.png";

/***/ }),
/* 3501 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/artillery-battalion-lvl2-75.b78cf0fe.png";

/***/ }),
/* 3502 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/artillery-battalion-lvl3-100.22505380.png";

/***/ }),
/* 3503 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/artillery-battalion-lvl3-50.202610c8.png";

/***/ }),
/* 3504 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/artillery-battalion-lvl3-75.d84fd06f.png";

/***/ }),
/* 3505 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/attack-bomber-squadrons-lvl1-100.49f7c873.png";

/***/ }),
/* 3506 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/attack-bomber-squadrons-lvl1-50.fb26bfb4.png";

/***/ }),
/* 3507 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/attack-bomber-squadrons-lvl1-75.9bf3b05d.png";

/***/ }),
/* 3508 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/attack-bomber-squadrons-lvl2-100.5d0f5f9a.png";

/***/ }),
/* 3509 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/attack-bomber-squadrons-lvl2-50.859ca5d4.png";

/***/ }),
/* 3510 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/attack-bomber-squadrons-lvl2-75.fbda58f4.png";

/***/ }),
/* 3511 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/attack-bomber-squadrons-lvl3-100.a8a74976.png";

/***/ }),
/* 3512 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/attack-bomber-squadrons-lvl3-50.8be0d2d1.png";

/***/ }),
/* 3513 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/attack-bomber-squadrons-lvl3-75.270f88a0.png";

/***/ }),
/* 3514 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/command-center-lvl1-100.ac4a948d.png";

/***/ }),
/* 3515 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/command-center-lvl1-50.7a25525b.png";

/***/ }),
/* 3516 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/command-center-lvl1-75.4c4d3d0e.png";

/***/ }),
/* 3517 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/command-center-lvl2-100.a9d5f787.png";

/***/ }),
/* 3518 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/command-center-lvl2-50.ba6b799e.png";

/***/ }),
/* 3519 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/command-center-lvl2-75.aeb0df20.png";

/***/ }),
/* 3520 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/command-center-lvl3-100.9086fa03.png";

/***/ }),
/* 3521 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/command-center-lvl3-50.adea14a5.png";

/***/ }),
/* 3522 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/command-center-lvl3-75.9f66beb3.png";

/***/ }),
/* 3523 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/command-center-maxlvl-100.42551912.png";

/***/ }),
/* 3524 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/command-center-maxlvl-50.3fd4271d.png";

/***/ }),
/* 3525 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/financial-unit-lvl1-100.e08ef929.png";

/***/ }),
/* 3526 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/financial-unit-lvl1-50.d664b364.png";

/***/ }),
/* 3527 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/financial-unit-lvl1-75.97838763.png";

/***/ }),
/* 3528 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/financial-unit-lvl2-100.6d968d81.png";

/***/ }),
/* 3529 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/financial-unit-lvl2-50.e89c42dd.png";

/***/ }),
/* 3530 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/financial-unit-lvl2-75.965cac9c.png";

/***/ }),
/* 3531 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/financial-unit-lvl3-100.16de3605.png";

/***/ }),
/* 3532 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/financial-unit-lvl3-50.b7c2a964.png";

/***/ }),
/* 3533 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/financial-unit-lvl3-75.033f4b20.png";

/***/ }),
/* 3534 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/home-front-service-lvl1-100.6e5526ea.png";

/***/ }),
/* 3535 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/home-front-service-lvl1-50.7243f6f2.png";

/***/ }),
/* 3536 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/home-front-service-lvl1-75.3fba704f.png";

/***/ }),
/* 3537 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/home-front-service-lvl2-100.1a24b97f.png";

/***/ }),
/* 3538 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/home-front-service-lvl2-50.be47a84d.png";

/***/ }),
/* 3539 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/home-front-service-lvl2-75.0d27c0a6.png";

/***/ }),
/* 3540 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/home-front-service-lvl3-100.4dfab0d8.png";

/***/ }),
/* 3541 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/home-front-service-lvl3-50.4704c7d8.png";

/***/ }),
/* 3542 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/home-front-service-lvl3-75.cf64b1ae.png";

/***/ }),
/* 3543 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/military-school-lvl1-100.039d871f.png";

/***/ }),
/* 3544 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/military-school-lvl1-50.2c00d20a.png";

/***/ }),
/* 3545 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/military-school-lvl1-75.22f23f66.png";

/***/ }),
/* 3546 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/military-school-lvl2-100.adc2622a.png";

/***/ }),
/* 3547 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/military-school-lvl2-50.78f0501f.png";

/***/ }),
/* 3548 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/military-school-lvl2-75.9844629c.png";

/***/ }),
/* 3549 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/military-school-lvl3-100.6d44d26d.png";

/***/ }),
/* 3550 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/military-school-lvl3-50.bc3451bf.png";

/***/ }),
/* 3551 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/military-school-lvl3-75.45224fca.png";

/***/ }),
/* 3552 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/tankodrome-lvl1-100.0b2760bb.png";

/***/ }),
/* 3553 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/tankodrome-lvl1-50.f9f7be31.png";

/***/ }),
/* 3554 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/tankodrome-lvl1-75.79d52870.png";

/***/ }),
/* 3555 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/tankodrome-lvl2-100.1593c9f2.png";

/***/ }),
/* 3556 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/tankodrome-lvl2-50.a937a4fd.png";

/***/ }),
/* 3557 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/tankodrome-lvl2-75.8a1644a4.png";

/***/ }),
/* 3558 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/tankodrome-lvl3-100.2329cc96.png";

/***/ }),
/* 3559 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/tankodrome-lvl3-50.9ecf8428.png";

/***/ }),
/* 3560 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/tankodrome-lvl3-75.e003c9bf.png";

/***/ }),
/* 3561 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/training-unit-lvl1-100.15ec77fb.png";

/***/ }),
/* 3562 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/training-unit-lvl1-50.4b4199cc.png";

/***/ }),
/* 3563 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/training-unit-lvl1-75.58c23848.png";

/***/ }),
/* 3564 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/training-unit-lvl2-100.9f3c7596.png";

/***/ }),
/* 3565 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/training-unit-lvl2-50.10e57e2f.png";

/***/ }),
/* 3566 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/training-unit-lvl2-75.435db135.png";

/***/ }),
/* 3567 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/training-unit-lvl3-100.deb5fa3b.png";

/***/ }),
/* 3568 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/training-unit-lvl3-50.e9b3d50f.png";

/***/ }),
/* 3569 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/training-unit-lvl3-75.39fa6ae3.png";

/***/ }),
/* 3570 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/transportation-unit-lvl1-100.4a602144.png";

/***/ }),
/* 3571 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/transportation-unit-lvl1-50.eb7ab347.png";

/***/ }),
/* 3572 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/transportation-unit-lvl1-75.cccedd4a.png";

/***/ }),
/* 3573 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/transportation-unit-lvl2-100.e9769951.png";

/***/ }),
/* 3574 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/transportation-unit-lvl2-50.f5e6c5b8.png";

/***/ }),
/* 3575 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/transportation-unit-lvl2-75.9d742ed1.png";

/***/ }),
/* 3576 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/transportation-unit-lvl3-100.f4b9cc98.png";

/***/ }),
/* 3577 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/transportation-unit-lvl3-50.aa7346f3.png";

/***/ }),
/* 3578 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/transportation-unit-lvl3-75.5f451d0d.png";

/***/ }),
/* 3579 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/trophy-brigade-lvl1-100.bee1dac3.png";

/***/ }),
/* 3580 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/trophy-brigade-lvl1-50.83da6a28.png";

/***/ }),
/* 3581 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/trophy-brigade-lvl1-75.ac526d7e.png";

/***/ }),
/* 3582 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/trophy-brigade-lvl2-100.78b96aaf.png";

/***/ }),
/* 3583 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/trophy-brigade-lvl2-50.a037ad72.png";

/***/ }),
/* 3584 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/trophy-brigade-lvl2-75.c346b058.png";

/***/ }),
/* 3585 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/trophy-brigade-lvl3-100.5917b144.png";

/***/ }),
/* 3586 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/trophy-brigade-lvl3-50.bb9ed5f7.png";

/***/ }),
/* 3587 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/buildings/trophy-brigade-lvl3-75.a0073067.png";

/***/ }),
/* 3588 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/button-small/bsm-default-active-bg-left.a5ef0199.png";

/***/ }),
/* 3589 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/button-small/bsm-default-active-bg-right.b2cd45be.png";

/***/ }),
/* 3590 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/button-small/bsm-default-active-bg.3d757993.png";

/***/ }),
/* 3591 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/button-small/bsm-default-bg-left.e3ebaa05.png";

/***/ }),
/* 3592 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/button-small/bsm-default-bg-right.c2100d0f.png";

/***/ }),
/* 3593 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/button-small/bsm-default-bg.5bad9755.png";

/***/ }),
/* 3594 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/button-small/bsm-default-hover-bg-left.cfa76166.png";

/***/ }),
/* 3595 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/button-small/bsm-default-hover-bg-right.4c7af6ed.png";

/***/ }),
/* 3596 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/button-small/bsm-default-hover-bg.99540753.png";

/***/ }),
/* 3597 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/button-small/bsm-disabled-bg-left.577e50eb.png";

/***/ }),
/* 3598 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/button-small/bsm-disabled-bg-right.c63b2f12.png";

/***/ }),
/* 3599 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/button-small/bsm-disabled-bg.f9917af5.png";

/***/ }),
/* 3600 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/button-small/bsm-disabled-pattern.1719cddb.png";

/***/ }),
/* 3601 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/button-small/bsm-secondary-active-bg-left.dcbd6329.png";

/***/ }),
/* 3602 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/button-small/bsm-secondary-active-bg-right.5ff51943.png";

/***/ }),
/* 3603 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/button-small/bsm-secondary-active-bg.0f5acd54.png";

/***/ }),
/* 3604 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/button-small/bsm-secondary-bg-left.287cbd94.png";

/***/ }),
/* 3605 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/button-small/bsm-secondary-bg-right.060c5427.png";

/***/ }),
/* 3606 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/button-small/bsm-secondary-bg.9c2f08e2.png";

/***/ }),
/* 3607 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/button-small/bsm-secondary-hover-bg-left.75abfe72.png";

/***/ }),
/* 3608 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/button-small/bsm-secondary-hover-bg-right.d04077c7.png";

/***/ }),
/* 3609 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/button-small/bsm-secondary-hover-bg.f8004862.png";

/***/ }),
/* 3610 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/cancel.9e7d70d3.png";

/***/ }),
/* 3611 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/challenges-bg.1a221af9.jpg";

/***/ }),
/* 3612 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/challenges/icon-conscription.5b209abf.png";

/***/ }),
/* 3613 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/challenges/icon-onslaught.cf0ebd67.png";

/***/ }),
/* 3614 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/challenges/icon-shooting.0ec1c65f.png";

/***/ }),
/* 3615 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/challenges/icon-superiority.a9a049dd.png";

/***/ }),
/* 3616 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/chess-pattern-white.666be6b1.png";

/***/ }),
/* 3617 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/chess-pattern.ad45b187.png";

/***/ }),
/* 3618 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/divider-dots-horizontal.f6a27a67.png";

/***/ }),
/* 3619 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/divider-shadowed-mask.74f71462.png";

/***/ }),
/* 3620 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/divider-shadowed-small.4b6b4c3f.png";

/***/ }),
/* 3621 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/divider-shadowed.b03075a5.png";

/***/ }),
/* 3622 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/dots-pattern-x.9adf32e9.png";

/***/ }),
/* 3623 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/dots-pattern-y.4fe3cb77.png";

/***/ }),
/* 3624 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/events/event-building.74a27e6f.png";

/***/ }),
/* 3625 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/events/event-challenge.5089199f.png";

/***/ }),
/* 3626 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/events/event-upgrade.164c5a3a.png";

/***/ }),
/* 3627 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/footer-divider.935605cb.png";

/***/ }),
/* 3628 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/handle.38e9927e.png";

/***/ }),
/* 3629 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/horizontal-dots-divider.3e512c06.png";

/***/ }),
/* 3630 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/icons/average-rating.RU.268f4b62.png";

/***/ }),
/* 3631 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/icons/average-rating.268f4b62.png";

/***/ }),
/* 3632 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/icons/fort-battle-active.75a3c05d.png";

/***/ }),
/* 3633 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/icons/fort-battle.dbe41ba0.png";

/***/ }),
/* 3634 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/icons/icon-error.25a12556.png";

/***/ }),
/* 3635 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/icons/icon-levels.54ed0c34.png";

/***/ }),
/* 3636 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/icons/icon-success.17f6a56c.png";

/***/ }),
/* 3637 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/icons/icon-vehicle-types.f8829f4d.png";

/***/ }),
/* 3638 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/icons/industrial-resource-small.c25528f8.png";

/***/ }),
/* 3639 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/icons/industrial-resource.1a3d9576.png";

/***/ }),
/* 3640 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/icons/info-big.2412453f.png";

/***/ }),
/* 3641 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/icons/info.b65b33ab.png";

/***/ }),
/* 3642 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/icons/settings.3fb8e73b.png";

/***/ }),
/* 3643 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/icons/sortie-active.94fe6d3a.png";

/***/ }),
/* 3644 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/icons/sortie.575743a5.png";

/***/ }),
/* 3645 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/icons/warning.08a998e4.png";

/***/ }),
/* 3646 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/icons/warning_small.58dc7a0d.png";

/***/ }),
/* 3647 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/in-battle-icon.c21e2603.png";

/***/ }),
/* 3648 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/landing-bg.ffc378eb.jpg";

/***/ }),
/* 3649 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/landing/landing-award-large.RU.d9d781c3.png";

/***/ }),
/* 3650 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/landing/landing-award-large.d9d781c3.png";

/***/ }),
/* 3651 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/landing/landing-award-small.RU.1a08ae0e.png";

/***/ }),
/* 3652 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/landing/landing-award-small.1a08ae0e.png";

/***/ }),
/* 3653 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/landing/landing-slider-arrows.bbaf148e.png";

/***/ }),
/* 3654 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/leaderboards/battle_mode_10.2650e54d.png";

/***/ }),
/* 3655 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/leaderboards/battle_mode_6.491987dc.png";

/***/ }),
/* 3656 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/leaderboards/battle_mode_8.75b61ac9.png";

/***/ }),
/* 3657 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/nations/china-cn.90d23202.png";

/***/ }),
/* 3658 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/nations/china.fd49babf.png";

/***/ }),
/* 3659 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/nations/czech-cn.7ee14b8a.png";

/***/ }),
/* 3660 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/nations/czech.7083fe81.png";

/***/ }),
/* 3661 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/nations/france-cn.a329d2e7.png";

/***/ }),
/* 3662 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/nations/france.27f0bf1b.png";

/***/ }),
/* 3663 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/nations/germany-cn.9f1d72c4.png";

/***/ }),
/* 3664 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/nations/germany.c6ae38d4.png";

/***/ }),
/* 3665 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/nations/italy-cn.271831f8.png";

/***/ }),
/* 3666 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/nations/italy.27db44c8.png";

/***/ }),
/* 3667 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/nations/japan-cn.b2f4bd9d.png";

/***/ }),
/* 3668 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/nations/japan.782b4330.png";

/***/ }),
/* 3669 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/nations/poland-cn.28da6b9b.png";

/***/ }),
/* 3670 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/nations/poland.b602e625.png";

/***/ }),
/* 3671 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/nations/sweden-cn.b043adf0.png";

/***/ }),
/* 3672 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/nations/sweden.f250f998.png";

/***/ }),
/* 3673 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/nations/uk-cn.9729d2d7.png";

/***/ }),
/* 3674 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/nations/uk.fc2f1331.png";

/***/ }),
/* 3675 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/nations/usa-cn.bbcb360d.png";

/***/ }),
/* 3676 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/nations/usa.182fe821.png";

/***/ }),
/* 3677 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/nations/ussr-cn.e8aed93b.png";

/***/ }),
/* 3678 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/nations/ussr.0fb2f64e.png";

/***/ }),
/* 3679 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/plus-icon.8c2fd9b4.png";

/***/ }),
/* 3680 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/popover-footer-divider.e570c02a.png";

/***/ }),
/* 3681 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/pure-table/pattern.1aced791.png";

/***/ }),
/* 3682 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/pure-table/shine-left.41b50503.png";

/***/ }),
/* 3683 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/pure-table/shine-right.08b8c8fc.png";

/***/ }),
/* 3684 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/pure-table/shine.54131234.png";

/***/ }),
/* 3685 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/additional-briefing-50.75413c26.png";

/***/ }),
/* 3686 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/additional-briefing-clan-landing-big.c2b44039.png";

/***/ }),
/* 3687 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/additional-briefing-clan-landing-elite-big.5f2f7470.png";

/***/ }),
/* 3688 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/additional-briefing-clan-landing-elite-sm.5e3b290a.png";

/***/ }),
/* 3689 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/additional-briefing-clan-landing-sm.78eef1a9.png";

/***/ }),
/* 3690 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/additional-briefing-elite-50.02ec0fcf.png";

/***/ }),
/* 3691 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/additional-briefing-elite.fe543ccb.png";

/***/ }),
/* 3692 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/additional-briefing.1bab5e0a.png";

/***/ }),
/* 3693 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/airstrike-elite-toolbar-50.139c4c20.png";

/***/ }),
/* 3694 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/airstrike-elite-toolbar.577706d3.png";

/***/ }),
/* 3695 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/airstrike-elite.1f851335.png";

/***/ }),
/* 3696 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/airstrike-toolbar-50.66af9258.png";

/***/ }),
/* 3697 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/airstrike-toolbar.851409b2.png";

/***/ }),
/* 3698 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/airstrike.80fffcfe.png";

/***/ }),
/* 3699 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/artillery-strike-elite-toolbar-50.e4ba36fa.png";

/***/ }),
/* 3700 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/artillery-strike-elite-toolbar.556f09ef.png";

/***/ }),
/* 3701 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/artillery-strike-elite.df40dfd8.png";

/***/ }),
/* 3702 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/artillery-strike-toolbar-50.7e51b8f7.png";

/***/ }),
/* 3703 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/artillery-strike-toolbar.f96a7cae.png";

/***/ }),
/* 3704 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/artillery-strike.df6ce6d1.png";

/***/ }),
/* 3705 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/battle-payments-50.b23ad9e8.png";

/***/ }),
/* 3706 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/battle-payments-clan-landing-big.0d3627ef.png";

/***/ }),
/* 3707 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/battle-payments-clan-landing-elite-big.0bbc1aef.png";

/***/ }),
/* 3708 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/battle-payments-clan-landing-elite-sm.f4bc59d7.png";

/***/ }),
/* 3709 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/battle-payments-clan-landing-sm.1768ceb7.png";

/***/ }),
/* 3710 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/battle-payments-elite-50.f9cdb7ed.png";

/***/ }),
/* 3711 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/battle-payments-elite.05d31388.png";

/***/ }),
/* 3712 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/battle-payments.83ba812b.png";

/***/ }),
/* 3713 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/high-capacity-transport-elite-toolbar-50.9eb5608b.png";

/***/ }),
/* 3714 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/high-capacity-transport-elite-toolbar.0f8c7a84.png";

/***/ }),
/* 3715 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/high-capacity-transport-elite.40959d9f.png";

/***/ }),
/* 3716 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/high-capacity-transport-toolbar-50.2d7e98e7.png";

/***/ }),
/* 3717 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/high-capacity-transport-toolbar.e3405e1c.png";

/***/ }),
/* 3718 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/high-capacity-transport.9f62dd78.png";

/***/ }),
/* 3719 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/inspiration-elite-toolbar-50.39c75471.png";

/***/ }),
/* 3720 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/inspiration-elite-toolbar.e6f58048.png";

/***/ }),
/* 3721 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/inspiration-elite.c978a4bf.png";

/***/ }),
/* 3722 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/inspiration-toolbar-50.43957760.png";

/***/ }),
/* 3723 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/inspiration-toolbar.5f7a009a.png";

/***/ }),
/* 3724 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/inspiration.6b0f5bff.png";

/***/ }),
/* 3725 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/journal/additional-briefing-cancel.56ed5f65.png";

/***/ }),
/* 3726 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/journal/additional-briefing-elite.a39b217d.png";

/***/ }),
/* 3727 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/journal/additional-briefing.66f83c28.png";

/***/ }),
/* 3728 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/journal/airstrike-cancel.bcf025ff.png";

/***/ }),
/* 3729 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/journal/airstrike-elite.99d1862a.png";

/***/ }),
/* 3730 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/journal/airstrike.7d34046a.png";

/***/ }),
/* 3731 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/journal/artillery-strike-cancel.efaf3154.png";

/***/ }),
/* 3732 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/journal/artillery-strike-elite.61aec2a2.png";

/***/ }),
/* 3733 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/journal/artillery-strike.6fad6c68.png";

/***/ }),
/* 3734 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/journal/battle-payments-cancel.941930ef.png";

/***/ }),
/* 3735 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/journal/battle-payments-elite.30ba5e40.png";

/***/ }),
/* 3736 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/journal/battle-payments.09553b15.png";

/***/ }),
/* 3737 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/journal/high-capacity-transport-cancel.f1471f03.png";

/***/ }),
/* 3738 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/journal/high-capacity-transport-elite.97ca3eac.png";

/***/ }),
/* 3739 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/journal/high-capacity-transport.1a01a850.png";

/***/ }),
/* 3740 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/journal/inspiration-cancel.52d75365.png";

/***/ }),
/* 3741 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/journal/inspiration-elite.d457654a.png";

/***/ }),
/* 3742 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/journal/inspiration.37b56959.png";

/***/ }),
/* 3743 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/journal/military-maneuvers-cancel.2f4244c4.png";

/***/ }),
/* 3744 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/journal/military-maneuvers-elite.afa8cc43.png";

/***/ }),
/* 3745 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/journal/military-maneuvers.ab33e2ac.png";

/***/ }),
/* 3746 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/journal/requisition-cancel.59281a3d.png";

/***/ }),
/* 3747 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/journal/requisition-elite.a1b6ba97.png";

/***/ }),
/* 3748 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/journal/requisition.b1c9c3f1.png";

/***/ }),
/* 3749 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/journal/tactical-training-cancel.3b214c8f.png";

/***/ }),
/* 3750 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/journal/tactical-training-elite.3f99547f.png";

/***/ }),
/* 3751 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/journal/tactical-training.ab48aadd.png";

/***/ }),
/* 3752 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/military-maneuvers-50.8f2afae4.png";

/***/ }),
/* 3753 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/military-maneuvers-clan-landing-big.eb491124.png";

/***/ }),
/* 3754 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/military-maneuvers-clan-landing-elite-big.991ce3ee.png";

/***/ }),
/* 3755 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/military-maneuvers-clan-landing-elite-sm.f76f6187.png";

/***/ }),
/* 3756 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/military-maneuvers-clan-landing-sm.daf44fa9.png";

/***/ }),
/* 3757 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/military-maneuvers-elite-50.7d25f0d3.png";

/***/ }),
/* 3758 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/military-maneuvers-elite.4ee61d47.png";

/***/ }),
/* 3759 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/military-maneuvers.1a31cc63.png";

/***/ }),
/* 3760 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/requisition-elite-toolbar-50.033791f6.png";

/***/ }),
/* 3761 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/requisition-elite-toolbar.c8d2fbd1.png";

/***/ }),
/* 3762 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/requisition-elite.e2f8f7bf.png";

/***/ }),
/* 3763 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/requisition-toolbar-50.d724cf80.png";

/***/ }),
/* 3764 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/requisition-toolbar.4951a4f1.png";

/***/ }),
/* 3765 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/requisition.36a2ee94.png";

/***/ }),
/* 3766 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/rewards/additional-briefing-elite-reward-100.2015f70a.png";

/***/ }),
/* 3767 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/rewards/additional-briefing-elite-reward-50.f34ad74e.png";

/***/ }),
/* 3768 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/rewards/additional-briefing-reward-100.85b18f36.png";

/***/ }),
/* 3769 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/rewards/additional-briefing-reward-50.73d462e9.png";

/***/ }),
/* 3770 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/rewards/airstrike-elite-reward-100.661a9c75.png";

/***/ }),
/* 3771 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/rewards/airstrike-elite-reward-50.940a4a37.png";

/***/ }),
/* 3772 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/rewards/airstrike-reward-100.61e3bb01.png";

/***/ }),
/* 3773 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/rewards/airstrike-reward-50.8bb35ead.png";

/***/ }),
/* 3774 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/rewards/artillery-strike-elite-reward-100.289b57af.png";

/***/ }),
/* 3775 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/rewards/artillery-strike-elite-reward-50.3a88bef9.png";

/***/ }),
/* 3776 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/rewards/artillery-strike-reward-100.c6c07f2c.png";

/***/ }),
/* 3777 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/rewards/artillery-strike-reward-50.8403d671.png";

/***/ }),
/* 3778 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/rewards/battle-payments-elite-reward-100.ef339126.png";

/***/ }),
/* 3779 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/rewards/battle-payments-elite-reward-50.f20b511a.png";

/***/ }),
/* 3780 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/rewards/battle-payments-reward-100.19fc230b.png";

/***/ }),
/* 3781 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/rewards/battle-payments-reward-50.20d55cf4.png";

/***/ }),
/* 3782 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/rewards/high-capacity-transport-elite-reward-100.316e742a.png";

/***/ }),
/* 3783 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/rewards/high-capacity-transport-elite-reward-50.3fa81fb4.png";

/***/ }),
/* 3784 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/rewards/high-capacity-transport-reward-100.25942c12.png";

/***/ }),
/* 3785 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/rewards/high-capacity-transport-reward-50.e8a910f6.png";

/***/ }),
/* 3786 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/rewards/inspiration-elite-reward-100.53a51e3b.png";

/***/ }),
/* 3787 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/rewards/inspiration-elite-reward-50.a1c976b1.png";

/***/ }),
/* 3788 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/rewards/inspiration-reward-100.0c64f4a8.png";

/***/ }),
/* 3789 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/rewards/inspiration-reward-50.836939d0.png";

/***/ }),
/* 3790 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/rewards/military-maneuvers-elite-reward-100.262d8242.png";

/***/ }),
/* 3791 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/rewards/military-maneuvers-elite-reward-50.0cb647cc.png";

/***/ }),
/* 3792 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/rewards/military-maneuvers-reward-100.050e87c3.png";

/***/ }),
/* 3793 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/rewards/military-maneuvers-reward-50.34946d57.png";

/***/ }),
/* 3794 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/rewards/requisition-elite-reward-100.1ace7b8e.png";

/***/ }),
/* 3795 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/rewards/requisition-elite-reward-50.0c1b5162.png";

/***/ }),
/* 3796 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/rewards/requisition-reward-100.ef41399e.png";

/***/ }),
/* 3797 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/rewards/requisition-reward-50.eb96f8a3.png";

/***/ }),
/* 3798 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/rewards/tactical-training-elite-reward-100.d84ddf3e.png";

/***/ }),
/* 3799 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/rewards/tactical-training-elite-reward-50.263bd908.png";

/***/ }),
/* 3800 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/rewards/tactical-training-reward-100.095e7f39.png";

/***/ }),
/* 3801 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/rewards/tactical-training-reward-50.5fc76db9.png";

/***/ }),
/* 3802 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/tactical-training-50.e0d84634.png";

/***/ }),
/* 3803 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/tactical-training-clan-landing-big.b2fc5178.png";

/***/ }),
/* 3804 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/tactical-training-clan-landing-elite-big.51e04e1f.png";

/***/ }),
/* 3805 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/tactical-training-clan-landing-elite-sm.b0816cb0.png";

/***/ }),
/* 3806 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/tactical-training-clan-landing-sm.9d4e26a3.png";

/***/ }),
/* 3807 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/tactical-training-elite-50.6a3c8602.png";

/***/ }),
/* 3808 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/tactical-training-elite.29386146.png";

/***/ }),
/* 3809 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/reserves/tactical-training.b7c60bba.png";

/***/ }),
/* 3810 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/sortable_header/th-active-left.f644739a.png";

/***/ }),
/* 3811 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/sortable_header/th-active-right.e524f639.png";

/***/ }),
/* 3812 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/sortable_header/th-divider.45241f23.png";

/***/ }),
/* 3813 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/sortable_header/th-hover-left.3b7aed33.png";

/***/ }),
/* 3814 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/sortable_header/th-hover-right.802578d0.png";

/***/ }),
/* 3815 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/sortable_header/th-sort-down.46b3ae6a.png";

/***/ }),
/* 3816 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/sortable_header/th-sort-up.f3f3b74f.png";

/***/ }),
/* 3817 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/sortable_header/th-sort.e54caf18.png";

/***/ }),
/* 3818 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/table/table-expand-shadow-bottom.66890e9b.png";

/***/ }),
/* 3819 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/table/table-expand-shadow-top.5d40ac7b.png";

/***/ }),
/* 3820 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/table/table-head-cell-active-left.f644739a.png";

/***/ }),
/* 3821 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/table/table-head-cell-active-right.e524f639.png";

/***/ }),
/* 3822 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/table/table-head-cell-divider.45241f23.png";

/***/ }),
/* 3823 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/table/table-head-cell-hover-left.3b7aed33.png";

/***/ }),
/* 3824 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/table/table-head-cell-hover-right.802578d0.png";

/***/ }),
/* 3825 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/table/table-head-cell-sort-down.46b3ae6a.png";

/***/ }),
/* 3826 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/table/table-head-cell-sort-up.f3f3b74f.png";

/***/ }),
/* 3827 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/table/table-head-divider.6c04529c.png";

/***/ }),
/* 3828 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/table/table-head-shadow.fb86ec2b.png";

/***/ }),
/* 3829 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/table/table-row-50-expandable-active.91b5752e.png";

/***/ }),
/* 3830 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/table/table-row-50-expandable-hover.78974bd3.png";

/***/ }),
/* 3831 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/table/table-row-divider-expandable-bottom.0bfc8ea4.png";

/***/ }),
/* 3832 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/table/table-row-divider-expandable-top.c50c48c8.png";

/***/ }),
/* 3833 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/table/table-row-divider.bdf4b193.png";

/***/ }),
/* 3834 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/table/table-row-expandable-active.9ef89bc6.png";

/***/ }),
/* 3835 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/table/table-row-expandable-arrow.9be97d60.png";

/***/ }),
/* 3836 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/table/table-row-expandable-glow.1dcbde15.png";

/***/ }),
/* 3837 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/table/table-row-expandable-hover.9f2fdf89.png";

/***/ }),
/* 3838 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/table/table-row-expandable-own-left.e62e7275.png";

/***/ }),
/* 3839 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/table/table-row-expandable-own-right.d42f06e0.png";

/***/ }),
/* 3840 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/table/table-row-expandable-own.c9d5858d.png";

/***/ }),
/* 3841 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/table/table-row-expandable-sparks.35c0dc14.png";

/***/ }),
/* 3842 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/table/table-row-own-left.e62e7275.png";

/***/ }),
/* 3843 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/table/table-row-own-right.d42f06e0.png";

/***/ }),
/* 3844 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/table/table-row-own.c9d5858d.png";

/***/ }),
/* 3845 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/timer/timer_light.1682d0cd.png";

/***/ }),
/* 3846 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/tooltip/bg-borders.9e4925de.png";

/***/ }),
/* 3847 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/tooltip/bg-pattern.c2d87307.png";

/***/ }),
/* 3848 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/tooltip/disable-background.cc8f31f1.png";

/***/ }),
/* 3849 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/tooltip/shadow.9b325e4b.png";

/***/ }),
/* 3850 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/vehicles/R146_STG_Tday.f37ca6c3.png";

/***/ }),
/* 3851 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/images/styles/images/vertical-divider.eb83078e.png";

/***/ })
]),[1401]);


// WEBPACK FOOTER //
// static/bundles/a5bc0b599c74144c19f0.index.js